
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9856"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9856"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
'use strict';
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});

parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dsPLe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("cpmCj")).default);

var $cpmCj = parcelRequire("cpmCj");

});
parcelRegister("cpmCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $90895d1859655b11$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $90895d1859655b11$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});


parcelRegister("lYE9x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("1jJMI")).default);

var $1jJMI = parcelRequire("1jJMI");

});
parcelRegister("1jJMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f5b14b581d98cb8$export$2e2bcd8739ae039);
function $0f5b14b581d98cb8$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $0f5b14b581d98cb8$export$2e2bcd8739ae039 = $0f5b14b581d98cb8$var$clamp;

});


parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bOOlK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $89ab6b9e702438b4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $89ab6b9e702438b4$export$e00380445f2b9e0c);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("jjlaj")).keyframes);
$parcel$export(module.exports, "css", () => (parcelRequire("jjlaj")).css);
$parcel$export(module.exports, "StyledEngineProvider", () => (parcelRequire("2BuCw")).default);
$parcel$export(module.exports, "GlobalStyles", () => (parcelRequire("bBbjn")).default);
/**
 * @mui/styled-engine v5.16.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5rflj = parcelRequire("5rflj");

var $jjlaj = parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $2BuCw = parcelRequire("2BuCw");

var $bBbjn = parcelRequire("bBbjn");
'use client';
function $89ab6b9e702438b4$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $5rflj.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $89ab6b9e702438b4$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("5rflj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f5b60245567d758$export$2e2bcd8739ae039);

var $dAzjV = parcelRequire("dAzjV");
parcelRequire("3p9rK");

parcelRequire("8rteH");
parcelRequire("2lACw");
parcelRequire("8ajhZ");
parcelRequire("acw62");
parcelRequire("gd942");
var $3f5b60245567d758$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $3f5b60245567d758$export$2e2bcd8739ae039 = (0, $dAzjV.default).bind(null);
$3f5b60245567d758$var$tags.forEach(function(tagName) {
    $3f5b60245567d758$export$2e2bcd8739ae039[tagName] = $3f5b60245567d758$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("dAzjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e4a09088fdc2ec0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");

var $8ajhZ = parcelRequire("8ajhZ");

var $acw62 = parcelRequire("acw62");

var $gd942 = parcelRequire("gd942");
var $9e4a09088fdc2ec0$var$isBrowser = typeof document !== 'undefined';
var $9e4a09088fdc2ec0$var$isDevelopment = false;
var $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag = (0, $gd942.default);
var $9e4a09088fdc2ec0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag : $9e4a09088fdc2ec0$var$testOmitPropsOnComponent;
};
var $9e4a09088fdc2ec0$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $9e4a09088fdc2ec0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$9e4a09088fdc2ec0$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9e4a09088fdc2ec0$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $9e4a09088fdc2ec0$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $eP9YU.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $eP9YU.T));
            }
            if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $8rteH.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($9e4a09088fdc2ec0$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $9e4a09088fdc2ec0$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $8nd05.default)({}, options, nextOptions, {
                shouldForwardProp: $9e4a09088fdc2ec0$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jjlaj", function(module, exports) {

$parcel$export(module.exports, "Global", () => $e0f035ab0866fe47$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $e0f035ab0866fe47$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $e0f035ab0866fe47$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("eP9YU")).w);

var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $2lACw = parcelRequire("2lACw");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eP9YU.h).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eP9YU.E);
    createElementArgArray[1] = (0, $eP9YU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $eP9YU.T)));
    if (!(0, $eP9YU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eP9YU.i) && res !== undefined) rules += res;
        }
        if (!(0, $eP9YU.i)) return rules;
    });
    if (!(0, $eP9YU.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $eP9YU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eP9YU", function(module, exports) {

$parcel$export(module.exports, "a", () => $acad92301ef10c3f$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $acad92301ef10c3f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $acad92301ef10c3f$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $acad92301ef10c3f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $acad92301ef10c3f$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $acad92301ef10c3f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $acad92301ef10c3f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $acad92301ef10c3f$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $apDLo = parcelRequire("apDLo");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: 'css'
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDLo.default)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $fm8kz = parcelRequire("fm8kz");

var $iq6RI = parcelRequire("iq6RI");

var $9ffXE = parcelRequire("9ffXE");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($76500f1a9bc57c92$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + 'box-$1$2' + (0, $fm8kz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-item-' + (0, $fm8kz.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-line-pack' + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + 'box-' + (0, $fm8kz.replace)(value, '-grow', '') + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, '$1' + (0, $fm8kz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + '$1'), /(image-set)/, (0, $fm8kz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + 'box-pack:$3' + (0, $fm8kz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fm8kz.WEBKIT) + '$2-$3' + '$1' + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $fm8kz.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ':', ':' + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fm8kz.WEBKIT) + '$2$3' + '$1' + (0, $fm8kz.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, '@', '@' + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $iq6RI.default)(function() {
    return (0, $9ffXE.default)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fm8kz.stringify),
            (0, $fm8kz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fm8kz.stringify)
        ];
        var _serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("apDLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $794b155aeb6b00fd$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dNL7g"));

});



parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2lACw", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $1b59f2f50af460c0$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $1b59f2f50af460c0$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== 'undefined';
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;

});



parcelRegister("gd942", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd4e42ca4163639$export$2e2bcd8739ae039);

var $9ffXE = parcelRequire("9ffXE");
// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("2BuCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e56ca0825dc344f$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $eP9YU = parcelRequire("eP9YU");

var $a9M6v = parcelRequire("a9M6v");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
let $1e56ca0825dc344f$var$cache;
if (typeof document === 'object') $1e56ca0825dc344f$var$cache = (0, $a9M6v.default)({
    key: 'css',
    prepend: true
});
function $1e56ca0825dc344f$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $1e56ca0825dc344f$var$cache ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eP9YU.C), {
        value: $1e56ca0825dc344f$var$cache,
        children: children
    }) : children;
}

});
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1b2ls"));

});


parcelRegister("bBbjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $871beca1e2477cf0$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $jjlaj = parcelRequire("jjlaj");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $871beca1e2477cf0$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $871beca1e2477cf0$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($871beca1e2477cf0$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jjlaj.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("2A1GY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("gxvzd")).default);

var $gxvzd = parcelRequire("gxvzd");

});
parcelRegister("gxvzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a836f2f53d8f74$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");
function $c0a836f2f53d8f74$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $cpmCj.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("eQufN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("eWm0o")).default);

var $eWm0o = parcelRequire("eWm0o");
$parcel$exportWildcard(module.exports, $eWm0o);

});
parcelRegister("eWm0o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", () => $ae078d4716220a63$export$aad197c7121a6651);
$parcel$export(module.exports, "default", () => $ae078d4716220a63$export$2e2bcd8739ae039);

var $4jPKB = parcelRequire("4jPKB");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $ae078d4716220a63$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $ae078d4716220a63$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($ae078d4716220a63$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $ae078d4716220a63$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $ae078d4716220a63$export$aad197c7121a6651(Component) || fallback;
}
function $ae078d4716220a63$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ae078d4716220a63$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ae078d4716220a63$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $ae078d4716220a63$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $4jPKB.ForwardRef:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $4jPKB.Memo:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8ZGCM"));

});
parcelRegister("8ZGCM", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $68c5159438cce3ec$export$a7c73072b1a182ae, (v) => $68c5159438cce3ec$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $68c5159438cce3ec$export$9f27bc3417b4524d, (v) => $68c5159438cce3ec$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $68c5159438cce3ec$export$db77ccec0bb4ccac, (v) => $68c5159438cce3ec$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $68c5159438cce3ec$export$8392c0c9d3dcbd35, (v) => $68c5159438cce3ec$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $68c5159438cce3ec$export$ffb0004e005737fa, (v) => $68c5159438cce3ec$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $68c5159438cce3ec$export$b624eff549462981, (v) => $68c5159438cce3ec$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $68c5159438cce3ec$export$7897aa7841a5380c, (v) => $68c5159438cce3ec$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $68c5159438cce3ec$export$602eac185826482c, (v) => $68c5159438cce3ec$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $68c5159438cce3ec$export$e2c29f18771995cb, (v) => $68c5159438cce3ec$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $68c5159438cce3ec$export$5f8d39834fd61797, (v) => $68c5159438cce3ec$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $68c5159438cce3ec$export$74bf444e3cd11ea5, (v) => $68c5159438cce3ec$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $68c5159438cce3ec$export$998bcd577473dd93, (v) => $68c5159438cce3ec$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $68c5159438cce3ec$export$b706b080d889d2c9, (v) => $68c5159438cce3ec$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $68c5159438cce3ec$export$5be5a87408f70ddc, (v) => $68c5159438cce3ec$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $68c5159438cce3ec$export$45a5e7f76e0caa8d, (v) => $68c5159438cce3ec$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $68c5159438cce3ec$export$455c2e768291efa6, (v) => $68c5159438cce3ec$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $68c5159438cce3ec$export$9522e17588c12572, (v) => $68c5159438cce3ec$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $68c5159438cce3ec$export$2110ac352bb060b9, (v) => $68c5159438cce3ec$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $68c5159438cce3ec$export$56885ab8b9c456ab, (v) => $68c5159438cce3ec$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $68c5159438cce3ec$export$d927fcb6adf8f9de, (v) => $68c5159438cce3ec$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $68c5159438cce3ec$export$b82d16f27459e05a, (v) => $68c5159438cce3ec$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $68c5159438cce3ec$export$522c17b4f5e123e8, (v) => $68c5159438cce3ec$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $68c5159438cce3ec$export$1aabd8a0274ecfd6, (v) => $68c5159438cce3ec$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $68c5159438cce3ec$export$3d6c20d97e46b957, (v) => $68c5159438cce3ec$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $68c5159438cce3ec$export$9b621391a187a31a, (v) => $68c5159438cce3ec$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $68c5159438cce3ec$export$f5bbd400c2f4426f, (v) => $68c5159438cce3ec$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $68c5159438cce3ec$export$a7c73072b1a182ae;
var $68c5159438cce3ec$export$9f27bc3417b4524d;
var $68c5159438cce3ec$export$db77ccec0bb4ccac;
var $68c5159438cce3ec$export$8392c0c9d3dcbd35;
var $68c5159438cce3ec$export$ffb0004e005737fa;
var $68c5159438cce3ec$export$b624eff549462981;
var $68c5159438cce3ec$export$7897aa7841a5380c;
var $68c5159438cce3ec$export$602eac185826482c;
var $68c5159438cce3ec$export$e2c29f18771995cb;
var $68c5159438cce3ec$export$5f8d39834fd61797;
var $68c5159438cce3ec$export$74bf444e3cd11ea5;
var $68c5159438cce3ec$export$998bcd577473dd93;
var $68c5159438cce3ec$export$b706b080d889d2c9;
var $68c5159438cce3ec$export$5be5a87408f70ddc;
var $68c5159438cce3ec$export$45a5e7f76e0caa8d;
var $68c5159438cce3ec$export$455c2e768291efa6;
var $68c5159438cce3ec$export$9522e17588c12572;
var $68c5159438cce3ec$export$2110ac352bb060b9;
var $68c5159438cce3ec$export$56885ab8b9c456ab;
var $68c5159438cce3ec$export$d927fcb6adf8f9de;
var $68c5159438cce3ec$export$b82d16f27459e05a;
var $68c5159438cce3ec$export$522c17b4f5e123e8;
var $68c5159438cce3ec$export$1aabd8a0274ecfd6;
var $68c5159438cce3ec$export$3d6c20d97e46b957;
var $68c5159438cce3ec$export$9b621391a187a31a;
var $68c5159438cce3ec$export$f5bbd400c2f4426f;
"use strict";
var $68c5159438cce3ec$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $68c5159438cce3ec$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $68c5159438cce3ec$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $68c5159438cce3ec$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $68c5159438cce3ec$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $68c5159438cce3ec$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $68c5159438cce3ec$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $68c5159438cce3ec$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $68c5159438cce3ec$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $68c5159438cce3ec$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE:
                    case $68c5159438cce3ec$var$REACT_PROFILER_TYPE:
                    case $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $68c5159438cce3ec$var$REACT_CONTEXT_TYPE:
                            case $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE:
                            case $68c5159438cce3ec$var$REACT_LAZY_TYPE:
                            case $68c5159438cce3ec$var$REACT_MEMO_TYPE:
                                return object;
                            case $68c5159438cce3ec$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $68c5159438cce3ec$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$68c5159438cce3ec$export$a7c73072b1a182ae = $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
$68c5159438cce3ec$export$9f27bc3417b4524d = $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
$68c5159438cce3ec$export$db77ccec0bb4ccac = $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
$68c5159438cce3ec$export$8392c0c9d3dcbd35 = $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
$68c5159438cce3ec$export$ffb0004e005737fa = $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
$68c5159438cce3ec$export$b624eff549462981 = $68c5159438cce3ec$var$REACT_LAZY_TYPE;
$68c5159438cce3ec$export$7897aa7841a5380c = $68c5159438cce3ec$var$REACT_MEMO_TYPE;
$68c5159438cce3ec$export$602eac185826482c = $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
$68c5159438cce3ec$export$e2c29f18771995cb = $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
$68c5159438cce3ec$export$5f8d39834fd61797 = $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
$68c5159438cce3ec$export$74bf444e3cd11ea5 = $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
$68c5159438cce3ec$export$998bcd577473dd93 = $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
$68c5159438cce3ec$export$b706b080d889d2c9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
};
$68c5159438cce3ec$export$5be5a87408f70ddc = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
};
$68c5159438cce3ec$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
};
$68c5159438cce3ec$export$455c2e768291efa6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
};
$68c5159438cce3ec$export$9522e17588c12572 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
};
$68c5159438cce3ec$export$2110ac352bb060b9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_LAZY_TYPE;
};
$68c5159438cce3ec$export$56885ab8b9c456ab = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_MEMO_TYPE;
};
$68c5159438cce3ec$export$d927fcb6adf8f9de = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
};
$68c5159438cce3ec$export$b82d16f27459e05a = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
};
$68c5159438cce3ec$export$522c17b4f5e123e8 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
};
$68c5159438cce3ec$export$1aabd8a0274ecfd6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
};
$68c5159438cce3ec$export$3d6c20d97e46b957 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
};
$68c5159438cce3ec$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE || type === $68c5159438cce3ec$var$REACT_PROFILER_TYPE || type === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE || type === $68c5159438cce3ec$var$REACT_OFFSCREEN_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $68c5159438cce3ec$var$REACT_LAZY_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_MEMO_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$68c5159438cce3ec$export$f5bbd400c2f4426f = $68c5159438cce3ec$var$typeOf;

});




parcelRegister("5QV4f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6o2lr")).default);
$parcel$export(module.exports, "private_createBreakpoints", () => (parcelRequire("dLM8u")).default);
$parcel$export(module.exports, "unstable_applyStyles", () => (parcelRequire("2UDLz")).default);

var $6o2lr = parcelRequire("6o2lr");

var $dLM8u = parcelRequire("dLM8u");

var $2UDLz = parcelRequire("2UDLz");

});
parcelRegister("6o2lr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a66cd95e497efc7$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");

var $dLM8u = parcelRequire("dLM8u");

var $bVuw0 = parcelRequire("bVuw0");

var $2GcsG = parcelRequire("2GcsG");

var $9dZwz = parcelRequire("9dZwz");

var $kOOck = parcelRequire("kOOck");

var $2UDLz = parcelRequire("2UDLz");
const $4a66cd95e497efc7$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $4a66cd95e497efc7$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $1En50.default)(options, $4a66cd95e497efc7$var$_excluded);
    const breakpoints = (0, $dLM8u.default)(breakpointsInput);
    const spacing = (0, $2GcsG.default)(spacingInput);
    let muiTheme = (0, $3z1Ay.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $8nd05.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $8nd05.default)({}, (0, $bVuw0.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $2UDLz.default);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $kOOck.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $4a66cd95e497efc7$export$2e2bcd8739ae039 = $4a66cd95e497efc7$var$createTheme;

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("3z1Ay", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $2985df77ba145d35$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $2985df77ba145d35$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
function $2985df77ba145d35$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $2985df77ba145d35$var$deepClone(source) {
    if (/*#__PURE__*/ $acw62.isValidElement(source) || !$2985df77ba145d35$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $2985df77ba145d35$var$deepClone(source[key]);
    });
    return output;
}
function $2985df77ba145d35$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $8nd05.default)({}, target) : target;
    if ($2985df77ba145d35$export$53b83ca8eaab0383(target) && $2985df77ba145d35$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(source[key])) output[key] = source[key];
        else if ($2985df77ba145d35$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $2985df77ba145d35$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $2985df77ba145d35$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $2985df77ba145d35$export$53b83ca8eaab0383(source[key]) ? $2985df77ba145d35$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("dLM8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06500f70819ed69$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $a06500f70819ed69$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $a06500f70819ed69$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $a06500f70819ed69$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $8nd05.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $a06500f70819ed69$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $1En50.default)(breakpoints, $a06500f70819ed69$var$_excluded);
    const sortedValues = $a06500f70819ed69$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $8nd05.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("bVuw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aecb04a157fa644$export$2e2bcd8739ae039);
const $8aecb04a157fa644$var$shape = {
    borderRadius: 4
};
var $8aecb04a157fa644$export$2e2bcd8739ae039 = $8aecb04a157fa644$var$shape;

});

parcelRegister("2GcsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f392ba2ebd18096$export$2e2bcd8739ae039);

var $cKRCq = parcelRequire("cKRCq");
function $1f392ba2ebd18096$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $cKRCq.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("cKRCq", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $94935f79a2c44a85$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $94935f79a2c44a85$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $94935f79a2c44a85$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $94935f79a2c44a85$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $94935f79a2c44a85$export$6f98e8eaf0be1996);


var $3OJTQ = parcelRequire("3OJTQ");

var $k0igC = parcelRequire("k0igC");

var $aFh0N = parcelRequire("aFh0N");

var $hsAPr = parcelRequire("hsAPr");
const $94935f79a2c44a85$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $94935f79a2c44a85$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $94935f79a2c44a85$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $94935f79a2c44a85$var$getCssProperties = (0, $hsAPr.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($94935f79a2c44a85$var$aliases[prop]) prop = $94935f79a2c44a85$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $94935f79a2c44a85$var$properties[a];
    const direction = $94935f79a2c44a85$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $94935f79a2c44a85$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $94935f79a2c44a85$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $94935f79a2c44a85$var$spacingKeys = [
    ...$94935f79a2c44a85$export$aab52a0dde05ad8a,
    ...$94935f79a2c44a85$export$f8397d44f03ab6ad
];
function $94935f79a2c44a85$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $k0igC.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $94935f79a2c44a85$export$1def6f833384e3d1(theme) {
    return $94935f79a2c44a85$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $94935f79a2c44a85$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $94935f79a2c44a85$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $94935f79a2c44a85$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $94935f79a2c44a85$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $94935f79a2c44a85$var$getCssProperties(prop);
    const styleFromPropValue = $94935f79a2c44a85$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $3OJTQ.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $94935f79a2c44a85$var$style(props, keys) {
    const transformer = $94935f79a2c44a85$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$94935f79a2c44a85$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $aFh0N.default), {});
}
function $94935f79a2c44a85$export$7ede87f9b603dd3c(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$export$aab52a0dde05ad8a);
}
$94935f79a2c44a85$export$7ede87f9b603dd3c.propTypes = {};
$94935f79a2c44a85$export$7ede87f9b603dd3c.filterProps = $94935f79a2c44a85$export$aab52a0dde05ad8a;
function $94935f79a2c44a85$export$6f98e8eaf0be1996(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$export$f8397d44f03ab6ad);
}
$94935f79a2c44a85$export$6f98e8eaf0be1996.propTypes = {};
$94935f79a2c44a85$export$6f98e8eaf0be1996.filterProps = $94935f79a2c44a85$export$f8397d44f03ab6ad;
function $94935f79a2c44a85$var$spacing(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$var$spacingKeys);
}
$94935f79a2c44a85$var$spacing.propTypes = {};
$94935f79a2c44a85$var$spacing.filterProps = $94935f79a2c44a85$var$spacingKeys;
var $94935f79a2c44a85$export$2e2bcd8739ae039 = $94935f79a2c44a85$var$spacing;

});
parcelRegister("3OJTQ", function(module, exports) {

$parcel$export(module.exports, "values", () => $2c79a5510dec9b08$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $2c79a5510dec9b08$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $2c79a5510dec9b08$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $2c79a5510dec9b08$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $2c79a5510dec9b08$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $2c79a5510dec9b08$export$980e6a259d807490);

var $8nd05 = parcelRequire("8nd05");


var $3z1Ay = parcelRequire("3z1Ay");

var $aFh0N = parcelRequire("aFh0N");
const $2c79a5510dec9b08$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $2c79a5510dec9b08$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$2c79a5510dec9b08$export$68c286be0e7e55b7[key]}px)`
};
function $2c79a5510dec9b08$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $2c79a5510dec9b08$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $2c79a5510dec9b08$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $8nd05.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $aFh0N.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $2c79a5510dec9b08$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $2c79a5510dec9b08$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $2c79a5510dec9b08$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $2c79a5510dec9b08$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3z1Ay.default)(prev, next), {});
    return $2c79a5510dec9b08$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $2c79a5510dec9b08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $2c79a5510dec9b08$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $2c79a5510dec9b08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $2c79a5510dec9b08$export$2e2bcd8739ae039 = $2c79a5510dec9b08$var$breakpoints;

});
parcelRegister("aFh0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3aede628aa278f$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");
function $7c3aede628aa278f$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3z1Ay.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $7c3aede628aa278f$export$2e2bcd8739ae039 = $7c3aede628aa278f$var$merge;

});


parcelRegister("k0igC", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $e901fa2f27580273$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $e901fa2f27580273$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $e901fa2f27580273$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");


var $3OJTQ = parcelRequire("3OJTQ");
function $e901fa2f27580273$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $e901fa2f27580273$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $e901fa2f27580273$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $e901fa2f27580273$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $e901fa2f27580273$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $e901fa2f27580273$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $e901fa2f27580273$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $3OJTQ.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $e901fa2f27580273$export$2e2bcd8739ae039 = $e901fa2f27580273$var$style;

});

parcelRegister("hsAPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb619e97db430627$export$2e2bcd8739ae039);
function $cb619e97db430627$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("9dZwz", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => $6b750d631801d296$export$7d53d8bf2911e013);
$parcel$export(module.exports, "default", () => $6b750d631801d296$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");

var $aFh0N = parcelRequire("aFh0N");

var $k0igC = parcelRequire("k0igC");

var $3OJTQ = parcelRequire("3OJTQ");

var $kOOck = parcelRequire("kOOck");
function $6b750d631801d296$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $6b750d631801d296$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $6b750d631801d296$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $k0igC.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $k0igC.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $k0igC.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $3OJTQ.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $kOOck.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $3OJTQ.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $6b750d631801d296$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $aFh0N.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $3OJTQ.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($6b750d631801d296$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $aFh0N.default)(css, breakpointsValues);
                        }
                    } else css = (0, $aFh0N.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $3OJTQ.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $6b750d631801d296$var$styleFunctionSx = $6b750d631801d296$export$7d53d8bf2911e013();
$6b750d631801d296$var$styleFunctionSx.filterProps = [
    'sx'
];
var $6b750d631801d296$export$2e2bcd8739ae039 = $6b750d631801d296$var$styleFunctionSx;

});
parcelRegister("kOOck", function(module, exports) {

$parcel$export(module.exports, "default", () => $f27f6a6c429b3415$export$2e2bcd8739ae039);

var $cKRCq = parcelRequire("cKRCq");

var $jxD4j = parcelRequire("jxD4j");

var $nZvud = parcelRequire("nZvud");

var $8ru1G = parcelRequire("8ru1G");

var $imjyU = parcelRequire("imjyU");
const $f27f6a6c429b3415$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $jxD4j.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $8ru1G.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $8ru1G.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $8ru1G.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $cKRCq.padding)
    },
    pt: {
        style: (0, $cKRCq.padding)
    },
    pr: {
        style: (0, $cKRCq.padding)
    },
    pb: {
        style: (0, $cKRCq.padding)
    },
    pl: {
        style: (0, $cKRCq.padding)
    },
    px: {
        style: (0, $cKRCq.padding)
    },
    py: {
        style: (0, $cKRCq.padding)
    },
    padding: {
        style: (0, $cKRCq.padding)
    },
    paddingTop: {
        style: (0, $cKRCq.padding)
    },
    paddingRight: {
        style: (0, $cKRCq.padding)
    },
    paddingBottom: {
        style: (0, $cKRCq.padding)
    },
    paddingLeft: {
        style: (0, $cKRCq.padding)
    },
    paddingX: {
        style: (0, $cKRCq.padding)
    },
    paddingY: {
        style: (0, $cKRCq.padding)
    },
    paddingInline: {
        style: (0, $cKRCq.padding)
    },
    paddingInlineStart: {
        style: (0, $cKRCq.padding)
    },
    paddingInlineEnd: {
        style: (0, $cKRCq.padding)
    },
    paddingBlock: {
        style: (0, $cKRCq.padding)
    },
    paddingBlockStart: {
        style: (0, $cKRCq.padding)
    },
    paddingBlockEnd: {
        style: (0, $cKRCq.padding)
    },
    m: {
        style: (0, $cKRCq.margin)
    },
    mt: {
        style: (0, $cKRCq.margin)
    },
    mr: {
        style: (0, $cKRCq.margin)
    },
    mb: {
        style: (0, $cKRCq.margin)
    },
    ml: {
        style: (0, $cKRCq.margin)
    },
    mx: {
        style: (0, $cKRCq.margin)
    },
    my: {
        style: (0, $cKRCq.margin)
    },
    margin: {
        style: (0, $cKRCq.margin)
    },
    marginTop: {
        style: (0, $cKRCq.margin)
    },
    marginRight: {
        style: (0, $cKRCq.margin)
    },
    marginBottom: {
        style: (0, $cKRCq.margin)
    },
    marginLeft: {
        style: (0, $cKRCq.margin)
    },
    marginX: {
        style: (0, $cKRCq.margin)
    },
    marginY: {
        style: (0, $cKRCq.margin)
    },
    marginInline: {
        style: (0, $cKRCq.margin)
    },
    marginInlineStart: {
        style: (0, $cKRCq.margin)
    },
    marginInlineEnd: {
        style: (0, $cKRCq.margin)
    },
    marginBlock: {
        style: (0, $cKRCq.margin)
    },
    marginBlockStart: {
        style: (0, $cKRCq.margin)
    },
    marginBlockEnd: {
        style: (0, $cKRCq.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $nZvud.gap)
    },
    rowGap: {
        style: (0, $nZvud.rowGap)
    },
    columnGap: {
        style: (0, $nZvud.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $imjyU.sizingTransform)
    },
    maxWidth: {
        style: (0, $imjyU.maxWidth)
    },
    minWidth: {
        transform: (0, $imjyU.sizingTransform)
    },
    height: {
        transform: (0, $imjyU.sizingTransform)
    },
    maxHeight: {
        transform: (0, $imjyU.sizingTransform)
    },
    minHeight: {
        transform: (0, $imjyU.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $f27f6a6c429b3415$export$2e2bcd8739ae039 = $f27f6a6c429b3415$var$defaultSxConfig;

});
parcelRegister("jxD4j", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $e39f6794db8cf9ac$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $e39f6794db8cf9ac$export$7a57f79000377ca2);


var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");

var $cKRCq = parcelRequire("cKRCq");

var $3OJTQ = parcelRequire("3OJTQ");
function $e39f6794db8cf9ac$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $e39f6794db8cf9ac$var$createBorderStyle(prop, transform) {
    return (0, $k0igC.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $e39f6794db8cf9ac$export$1edee58a52776cd9 = $e39f6794db8cf9ac$var$createBorderStyle('border', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$f9a7b6bd24892946 = $e39f6794db8cf9ac$var$createBorderStyle('borderTop', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$5abca33e6be905d2 = $e39f6794db8cf9ac$var$createBorderStyle('borderRight', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$e2ce9f12a980a822 = $e39f6794db8cf9ac$var$createBorderStyle('borderBottom', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$47658cca1a909427 = $e39f6794db8cf9ac$var$createBorderStyle('borderLeft', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$e7fb0694ba2404fc = $e39f6794db8cf9ac$var$createBorderStyle('borderColor');
const $e39f6794db8cf9ac$export$126a92c968acdb85 = $e39f6794db8cf9ac$var$createBorderStyle('borderTopColor');
const $e39f6794db8cf9ac$export$85cc51cb8fbb8c0e = $e39f6794db8cf9ac$var$createBorderStyle('borderRightColor');
const $e39f6794db8cf9ac$export$340b0327727f6d1a = $e39f6794db8cf9ac$var$createBorderStyle('borderBottomColor');
const $e39f6794db8cf9ac$export$60beef91a985b4bf = $e39f6794db8cf9ac$var$createBorderStyle('borderLeftColor');
const $e39f6794db8cf9ac$export$f9258c55612cbed7 = $e39f6794db8cf9ac$var$createBorderStyle('outline', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$621fe586efeb64b9 = $e39f6794db8cf9ac$var$createBorderStyle('outlineColor');
const $e39f6794db8cf9ac$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$e39f6794db8cf9ac$export$7a57f79000377ca2.propTypes = {};
$e39f6794db8cf9ac$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $e39f6794db8cf9ac$var$borders = (0, $gojsU.default)($e39f6794db8cf9ac$export$1edee58a52776cd9, $e39f6794db8cf9ac$export$f9a7b6bd24892946, $e39f6794db8cf9ac$export$5abca33e6be905d2, $e39f6794db8cf9ac$export$e2ce9f12a980a822, $e39f6794db8cf9ac$export$47658cca1a909427, $e39f6794db8cf9ac$export$e7fb0694ba2404fc, $e39f6794db8cf9ac$export$126a92c968acdb85, $e39f6794db8cf9ac$export$85cc51cb8fbb8c0e, $e39f6794db8cf9ac$export$340b0327727f6d1a, $e39f6794db8cf9ac$export$60beef91a985b4bf, $e39f6794db8cf9ac$export$7a57f79000377ca2, $e39f6794db8cf9ac$export$f9258c55612cbed7, $e39f6794db8cf9ac$export$621fe586efeb64b9);
var $e39f6794db8cf9ac$export$2e2bcd8739ae039 = $e39f6794db8cf9ac$var$borders;

});
parcelRegister("gojsU", function(module, exports) {

$parcel$export(module.exports, "default", () => $beedfc9d7e65f133$export$2e2bcd8739ae039);

var $aFh0N = parcelRequire("aFh0N");
function $beedfc9d7e65f133$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $aFh0N.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $beedfc9d7e65f133$export$2e2bcd8739ae039 = $beedfc9d7e65f133$var$compose;

});


parcelRegister("nZvud", function(module, exports) {

$parcel$export(module.exports, "gap", () => $0481dc1348188242$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $0481dc1348188242$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $0481dc1348188242$export$8a833ffa5f5dbeda);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");

var $cKRCq = parcelRequire("cKRCq");

var $3OJTQ = parcelRequire("3OJTQ");

const $0481dc1348188242$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$5df9adcb0db95e1e.propTypes = {};
$0481dc1348188242$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $0481dc1348188242$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$ec60d70ff941a580.propTypes = {};
$0481dc1348188242$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $0481dc1348188242$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$8a833ffa5f5dbeda.propTypes = {};
$0481dc1348188242$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $0481dc1348188242$export$baf44164ca3a34e8 = (0, $k0igC.default)({
    prop: 'gridColumn'
});
const $0481dc1348188242$export$8f7213a1cd01e832 = (0, $k0igC.default)({
    prop: 'gridRow'
});
const $0481dc1348188242$export$b0e0abbc49ba668 = (0, $k0igC.default)({
    prop: 'gridAutoFlow'
});
const $0481dc1348188242$export$bcd8b929d4b4142 = (0, $k0igC.default)({
    prop: 'gridAutoColumns'
});
const $0481dc1348188242$export$e5039a674e14c828 = (0, $k0igC.default)({
    prop: 'gridAutoRows'
});
const $0481dc1348188242$export$42bd9088661ffb03 = (0, $k0igC.default)({
    prop: 'gridTemplateColumns'
});
const $0481dc1348188242$export$920682ae05b999bc = (0, $k0igC.default)({
    prop: 'gridTemplateRows'
});
const $0481dc1348188242$export$1b88fbdd482fd33a = (0, $k0igC.default)({
    prop: 'gridTemplateAreas'
});
const $0481dc1348188242$export$bdb486e40d52d26f = (0, $k0igC.default)({
    prop: 'gridArea'
});
const $0481dc1348188242$var$grid = (0, $gojsU.default)($0481dc1348188242$export$5df9adcb0db95e1e, $0481dc1348188242$export$ec60d70ff941a580, $0481dc1348188242$export$8a833ffa5f5dbeda, $0481dc1348188242$export$baf44164ca3a34e8, $0481dc1348188242$export$8f7213a1cd01e832, $0481dc1348188242$export$b0e0abbc49ba668, $0481dc1348188242$export$bcd8b929d4b4142, $0481dc1348188242$export$e5039a674e14c828, $0481dc1348188242$export$42bd9088661ffb03, $0481dc1348188242$export$920682ae05b999bc, $0481dc1348188242$export$1b88fbdd482fd33a, $0481dc1348188242$export$bdb486e40d52d26f);
var $0481dc1348188242$export$2e2bcd8739ae039 = $0481dc1348188242$var$grid;

});

parcelRegister("8ru1G", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $625822e5d7cce21a$export$dbaffd4420ea0ac6);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");
function $625822e5d7cce21a$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $625822e5d7cce21a$export$35e9368ef982300f = (0, $k0igC.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $625822e5d7cce21a$export$dbaffd4420ea0ac6
});
const $625822e5d7cce21a$export$2506f56c10355b33 = (0, $k0igC.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $625822e5d7cce21a$export$dbaffd4420ea0ac6
});
const $625822e5d7cce21a$export$8c5a050822fd698c = (0, $k0igC.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $625822e5d7cce21a$export$dbaffd4420ea0ac6
});
const $625822e5d7cce21a$var$palette = (0, $gojsU.default)($625822e5d7cce21a$export$35e9368ef982300f, $625822e5d7cce21a$export$2506f56c10355b33, $625822e5d7cce21a$export$8c5a050822fd698c);
var $625822e5d7cce21a$export$2e2bcd8739ae039 = $625822e5d7cce21a$var$palette;

});

parcelRegister("imjyU", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $d5d974b5976c38ad$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $d5d974b5976c38ad$export$488fda99655ff65a);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");

var $3OJTQ = parcelRequire("3OJTQ");
function $d5d974b5976c38ad$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $d5d974b5976c38ad$export$7e3df82ee760448c = (0, $k0igC.default)({
    prop: 'width',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $3OJTQ.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $d5d974b5976c38ad$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $3OJTQ.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$d5d974b5976c38ad$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $d5d974b5976c38ad$export$ee148fbbe8357dd2 = (0, $k0igC.default)({
    prop: 'minWidth',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$ac607276a8fe9f0a = (0, $k0igC.default)({
    prop: 'height',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$dc0d8bd0b94f8570 = (0, $k0igC.default)({
    prop: 'maxHeight',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$a43cf604e12f3b17 = (0, $k0igC.default)({
    prop: 'minHeight',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$ffed9f14fb65e276 = (0, $k0igC.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$905076ed6620e671 = (0, $k0igC.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$6ccc93f785106a58 = (0, $k0igC.default)({
    prop: 'boxSizing'
});
const $d5d974b5976c38ad$var$sizing = (0, $gojsU.default)($d5d974b5976c38ad$export$7e3df82ee760448c, $d5d974b5976c38ad$export$488fda99655ff65a, $d5d974b5976c38ad$export$ee148fbbe8357dd2, $d5d974b5976c38ad$export$ac607276a8fe9f0a, $d5d974b5976c38ad$export$dc0d8bd0b94f8570, $d5d974b5976c38ad$export$a43cf604e12f3b17, $d5d974b5976c38ad$export$6ccc93f785106a58);
var $d5d974b5976c38ad$export$2e2bcd8739ae039 = $d5d974b5976c38ad$var$sizing;

});



parcelRegister("2UDLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $21efa8802134c535$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $21efa8802134c535$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("2bwhi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("9dZwz")).default);
$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => (parcelRequire("9dZwz")).unstable_createStyleFunctionSx);
$parcel$export(module.exports, "extendSxProp", () => (parcelRequire("hcz0Q")).default);
$parcel$export(module.exports, "unstable_defaultSxConfig", () => (parcelRequire("kOOck")).default);

var $9dZwz = parcelRequire("9dZwz");

var $hcz0Q = parcelRequire("hcz0Q");

var $kOOck = parcelRequire("kOOck");

});
parcelRegister("hcz0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $c85eb76b78f8a14c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");

var $kOOck = parcelRequire("kOOck");
const $c85eb76b78f8a14c$var$_excluded = [
    "sx"
];
const $c85eb76b78f8a14c$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $kOOck.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c85eb76b78f8a14c$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $1En50.default)(props, $c85eb76b78f8a14c$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $c85eb76b78f8a14c$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3z1Ay.isPlainObject)(result)) return systemProps;
        return (0, $8nd05.default)({}, systemProps, result);
    };
    else finalSx = (0, $8nd05.default)({}, systemProps, inSx);
    return (0, $8nd05.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("5uDEp", function(module, exports) {
"use strict";
var $3ffe82e7c0b4721a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3ffe82e7c0b4721a$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3ffe82e7c0b4721a$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3ffe82e7c0b4721a$var$__createBinding(result, mod, k);
    }
    $3ffe82e7c0b4721a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.match = module.exports.foldW = module.exports.matchW = module.exports.isRight = module.exports.isLeft = module.exports.fromOption = module.exports.fromPredicate = module.exports.FromEither = module.exports.MonadThrow = module.exports.throwError = module.exports.ChainRec = module.exports.Extend = module.exports.extend = module.exports.Alt = module.exports.alt = module.exports.altW = module.exports.Bifunctor = module.exports.mapLeft = module.exports.bimap = module.exports.Traversable = module.exports.sequence = module.exports.traverse = module.exports.Foldable = module.exports.reduceRight = module.exports.foldMap = module.exports.reduce = module.exports.Monad = module.exports.Chain = module.exports.Applicative = module.exports.Apply = module.exports.ap = module.exports.apW = module.exports.Pointed = module.exports.of = module.exports.asUnit = module.exports.as = module.exports.Functor = module.exports.map = module.exports.getAltValidation = module.exports.getApplicativeValidation = module.exports.getWitherable = module.exports.getFilterable = module.exports.getCompactable = module.exports.getSemigroup = module.exports.getEq = module.exports.getShow = module.exports.URI = module.exports.flatMap = module.exports.right = module.exports.left = void 0;
module.exports.either = module.exports.stringifyJSON = module.exports.chainFirstW = module.exports.chainFirst = module.exports.chain = module.exports.chainW = module.exports.sequenceArray = module.exports.traverseArray = module.exports.traverseArrayWithIndex = module.exports.traverseReadonlyArrayWithIndex = module.exports.traverseReadonlyNonEmptyArrayWithIndex = module.exports.ApT = module.exports.apSW = module.exports.apS = module.exports.bindW = module.exports.bind = module.exports.let = module.exports.bindTo = module.exports.Do = module.exports.exists = module.exports.toUnion = module.exports.chainNullableK = module.exports.fromNullableK = module.exports.tryCatchK = module.exports.tryCatch = module.exports.fromNullable = module.exports.orElse = module.exports.orElseW = module.exports.swap = module.exports.filterOrElseW = module.exports.filterOrElse = module.exports.flatMapOption = module.exports.flatMapNullable = module.exports.liftOption = module.exports.liftNullable = module.exports.chainOptionKW = module.exports.chainOptionK = module.exports.fromOptionK = module.exports.duplicate = module.exports.flatten = module.exports.flattenW = module.exports.tap = module.exports.apSecondW = module.exports.apSecond = module.exports.apFirstW = module.exports.apFirst = module.exports.flap = module.exports.getOrElse = module.exports.getOrElseW = module.exports.fold = void 0;
module.exports.getValidationMonoid = module.exports.getValidationSemigroup = module.exports.getApplyMonoid = module.exports.getApplySemigroup = void 0;
module.exports.toError = $3ffe82e7c0b4721a$var$toError;
module.exports.elem = $3ffe82e7c0b4721a$var$elem;
module.exports.parseJSON = $3ffe82e7c0b4721a$var$parseJSON;
module.exports.getValidation = $3ffe82e7c0b4721a$var$getValidation;

var $eImHL = parcelRequire("eImHL");

var $4sfjE = parcelRequire("4sfjE");

var $3ffe82e7c0b4721a$var$chainable = $3ffe82e7c0b4721a$var$__importStar((parcelRequire("ERVGH")));

var $ek0ul = parcelRequire("ek0ul");

var $eLQyV = parcelRequire("eLQyV");

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");

var $3ffe82e7c0b4721a$var$_ = $3ffe82e7c0b4721a$var$__importStar((parcelRequire("704qB")));

var $fIQoU = parcelRequire("fIQoU");

var $4p4Yq = parcelRequire("4p4Yq");
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * Constructs a new `Either` holding a `Left` value. This usually represents a failure, due to the right-bias of this
 * structure.
 *
 * @category constructors
 * @since 2.0.0
 */ module.exports.left = $3ffe82e7c0b4721a$var$_.left;
/**
 * Constructs a new `Either` holding a `Right` value. This usually represents a successful value due to the right bias
 * of this structure.
 *
 * @category constructors
 * @since 2.0.0
 */ module.exports.right = $3ffe82e7c0b4721a$var$_.right;
/**
 * @category sequencing
 * @since 2.14.0
 */ module.exports.flatMap = (0, $3abDJ.dual)(2, function(ma, f) {
    return (0, module.exports.isLeft)(ma) ? ma : f(ma.right);
});
var $3ffe82e7c0b4721a$var$_map = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.map)(f));
};
var $3ffe82e7c0b4721a$var$_ap = function(fab, fa) {
    return (0, $3abDJ.pipe)(fab, (0, module.exports.ap)(fa));
};
/* istanbul ignore next */ var $3ffe82e7c0b4721a$var$_reduce = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduce)(b, f));
};
/* istanbul ignore next */ var $3ffe82e7c0b4721a$var$_foldMap = function(M) {
    return function(fa, f) {
        var foldMapM = (0, module.exports.foldMap)(M);
        return (0, $3abDJ.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $3ffe82e7c0b4721a$var$_reduceRight = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduceRight)(b, f));
};
var $3ffe82e7c0b4721a$var$_traverse = function(F) {
    var traverseF = (0, module.exports.traverse)(F);
    return function(ta, f) {
        return (0, $3abDJ.pipe)(ta, traverseF(f));
    };
};
var $3ffe82e7c0b4721a$var$_bimap = function(fa, f, g) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.bimap)(f, g));
};
var $3ffe82e7c0b4721a$var$_mapLeft = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.mapLeft)(f));
};
/* istanbul ignore next */ var $3ffe82e7c0b4721a$var$_alt = function(fa, that) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.alt)(that));
};
/* istanbul ignore next */ var $3ffe82e7c0b4721a$var$_extend = function(wa, f) {
    return (0, $3abDJ.pipe)(wa, (0, module.exports.extend)(f));
};
var $3ffe82e7c0b4721a$var$_chainRec = function(a, f) {
    return (0, $ek0ul.tailRec)(f(a), function(e) {
        return (0, module.exports.isLeft)(e) ? (0, module.exports.right)((0, module.exports.left)(e.left)) : (0, module.exports.isLeft)(e.right) ? (0, module.exports.left)(f(e.right.left)) : (0, module.exports.right)((0, module.exports.right)(e.right.right));
    });
};
/**
 * @category type lambdas
 * @since 2.0.0
 */ module.exports.URI = 'Either';
/**
 * @category instances
 * @since 2.0.0
 */ var $3ffe82e7c0b4721a$var$getShow = function(SE, SA) {
    return {
        show: function(ma) {
            return (0, module.exports.isLeft)(ma) ? "left(".concat(SE.show(ma.left), ")") : "right(".concat(SA.show(ma.right), ")");
        }
    };
};
module.exports.getShow = $3ffe82e7c0b4721a$var$getShow;
/**
 * @category instances
 * @since 2.0.0
 */ var $3ffe82e7c0b4721a$var$getEq = function(EL, EA) {
    return {
        equals: function(x, y) {
            return x === y || ((0, module.exports.isLeft)(x) ? (0, module.exports.isLeft)(y) && EL.equals(x.left, y.left) : (0, module.exports.isRight)(y) && EA.equals(x.right, y.right));
        }
    };
};
module.exports.getEq = $3ffe82e7c0b4721a$var$getEq;
/**
 * Semigroup returning the left-most non-`Left` value. If both operands are `Right`s then the inner values are
 * concatenated using the provided `Semigroup`
 *
 * @example
 * import { getSemigroup, left, right } from 'fp-ts/Either'
 * import { SemigroupSum } from 'fp-ts/number'
 *
 * const S = getSemigroup<string, number>(SemigroupSum)
 * assert.deepStrictEqual(S.concat(left('a'), left('b')), left('a'))
 * assert.deepStrictEqual(S.concat(left('a'), right(2)), right(2))
 * assert.deepStrictEqual(S.concat(right(1), left('b')), right(1))
 * assert.deepStrictEqual(S.concat(right(1), right(2)), right(3))
 *
 * @category instances
 * @since 2.0.0
 */ var $3ffe82e7c0b4721a$var$getSemigroup = function(S) {
    return {
        concat: function(x, y) {
            return (0, module.exports.isLeft)(y) ? x : (0, module.exports.isLeft)(x) ? y : (0, module.exports.right)(S.concat(x.right, y.right));
        }
    };
};
module.exports.getSemigroup = $3ffe82e7c0b4721a$var$getSemigroup;
/**
 * Builds a `Compactable` instance for `Either` given `Monoid` for the left side.
 *
 * @category filtering
 * @since 2.10.0
 */ var $3ffe82e7c0b4721a$var$getCompactable = function(M) {
    var empty = (0, module.exports.left)(M.empty);
    return {
        URI: module.exports.URI,
        _E: undefined,
        compact: function(ma) {
            return (0, module.exports.isLeft)(ma) ? ma : ma.right._tag === 'None' ? empty : (0, module.exports.right)(ma.right.value);
        },
        separate: function(ma) {
            return (0, module.exports.isLeft)(ma) ? (0, $fIQoU.separated)(ma, ma) : (0, module.exports.isLeft)(ma.right) ? (0, $fIQoU.separated)((0, module.exports.right)(ma.right.left), empty) : (0, $fIQoU.separated)(empty, (0, module.exports.right)(ma.right.right));
        }
    };
};
module.exports.getCompactable = $3ffe82e7c0b4721a$var$getCompactable;
/**
 * Builds a `Filterable` instance for `Either` given `Monoid` for the left side
 *
 * @category filtering
 * @since 2.10.0
 */ var $3ffe82e7c0b4721a$var$getFilterable = function(M) {
    var empty = (0, module.exports.left)(M.empty);
    var _a = (0, module.exports.getCompactable)(M), compact = _a.compact, separate = _a.separate;
    var filter = function(ma, predicate) {
        return (0, module.exports.isLeft)(ma) ? ma : predicate(ma.right) ? ma : empty;
    };
    var partition = function(ma, p) {
        return (0, module.exports.isLeft)(ma) ? (0, $fIQoU.separated)(ma, ma) : p(ma.right) ? (0, $fIQoU.separated)(empty, (0, module.exports.right)(ma.right)) : (0, $fIQoU.separated)((0, module.exports.right)(ma.right), empty);
    };
    return {
        URI: module.exports.URI,
        _E: undefined,
        map: $3ffe82e7c0b4721a$var$_map,
        compact: compact,
        separate: separate,
        filter: filter,
        filterMap: function(ma, f) {
            if ((0, module.exports.isLeft)(ma)) return ma;
            var ob = f(ma.right);
            return ob._tag === 'None' ? empty : (0, module.exports.right)(ob.value);
        },
        partition: partition,
        partitionMap: function(ma, f) {
            if ((0, module.exports.isLeft)(ma)) return (0, $fIQoU.separated)(ma, ma);
            var e = f(ma.right);
            return (0, module.exports.isLeft)(e) ? (0, $fIQoU.separated)((0, module.exports.right)(e.left), empty) : (0, $fIQoU.separated)(empty, (0, module.exports.right)(e.right));
        }
    };
};
module.exports.getFilterable = $3ffe82e7c0b4721a$var$getFilterable;
/**
 * Builds `Witherable` instance for `Either` given `Monoid` for the left side
 *
 * @category filtering
 * @since 2.0.0
 */ var $3ffe82e7c0b4721a$var$getWitherable = function(M) {
    var F_ = (0, module.exports.getFilterable)(M);
    var C = (0, module.exports.getCompactable)(M);
    return {
        URI: module.exports.URI,
        _E: undefined,
        map: $3ffe82e7c0b4721a$var$_map,
        compact: F_.compact,
        separate: F_.separate,
        filter: F_.filter,
        filterMap: F_.filterMap,
        partition: F_.partition,
        partitionMap: F_.partitionMap,
        traverse: $3ffe82e7c0b4721a$var$_traverse,
        sequence: module.exports.sequence,
        reduce: $3ffe82e7c0b4721a$var$_reduce,
        foldMap: $3ffe82e7c0b4721a$var$_foldMap,
        reduceRight: $3ffe82e7c0b4721a$var$_reduceRight,
        wither: (0, $4p4Yq.witherDefault)(module.exports.Traversable, C),
        wilt: (0, $4p4Yq.wiltDefault)(module.exports.Traversable, C)
    };
};
module.exports.getWitherable = $3ffe82e7c0b4721a$var$getWitherable;
/**
 * The default [`Applicative`](#applicative) instance returns the first error, if you want to
 * get all errors you need to provide a way to concatenate them via a `Semigroup`.
 *
 * @example
 * import * as A from 'fp-ts/Apply'
 * import * as E from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 * import * as S from 'fp-ts/Semigroup'
 * import * as string from 'fp-ts/string'
 *
 * const parseString = (u: unknown): E.Either<string, string> =>
 *   typeof u === 'string' ? E.right(u) : E.left('not a string')
 *
 * const parseNumber = (u: unknown): E.Either<string, number> =>
 *   typeof u === 'number' ? E.right(u) : E.left('not a number')
 *
 * interface Person {
 *   readonly name: string
 *   readonly age: number
 * }
 *
 * const parsePerson = (
 *   input: Record<string, unknown>
 * ): E.Either<string, Person> =>
 *   pipe(
 *     E.Do,
 *     E.apS('name', parseString(input.name)),
 *     E.apS('age', parseNumber(input.age))
 *   )
 *
 * assert.deepStrictEqual(parsePerson({}), E.left('not a string')) // <= first error
 *
 * const Applicative = E.getApplicativeValidation(
 *   pipe(string.Semigroup, S.intercalate(', '))
 * )
 *
 * const apS = A.apS(Applicative)
 *
 * const parsePersonAll = (
 *   input: Record<string, unknown>
 * ): E.Either<string, Person> =>
 *   pipe(
 *     E.Do,
 *     apS('name', parseString(input.name)),
 *     apS('age', parseNumber(input.age))
 *   )
 *
 * assert.deepStrictEqual(parsePersonAll({}), E.left('not a string, not a number')) // <= all errors
 *
 * @category error handling
 * @since 2.7.0
 */ var $3ffe82e7c0b4721a$var$getApplicativeValidation = function(SE) {
    return {
        URI: module.exports.URI,
        _E: undefined,
        map: $3ffe82e7c0b4721a$var$_map,
        ap: function(fab, fa) {
            return (0, module.exports.isLeft)(fab) ? (0, module.exports.isLeft)(fa) ? (0, module.exports.left)(SE.concat(fab.left, fa.left)) : fab : (0, module.exports.isLeft)(fa) ? fa : (0, module.exports.right)(fab.right(fa.right));
        },
        of: module.exports.of
    };
};
module.exports.getApplicativeValidation = $3ffe82e7c0b4721a$var$getApplicativeValidation;
/**
 * The default [`Alt`](#alt) instance returns the last error, if you want to
 * get all errors you need to provide a way to concatenate them via a `Semigroup`.
 *
 * @example
 * import * as E from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 * import * as S from 'fp-ts/Semigroup'
 * import * as string from 'fp-ts/string'
 *
 * const parseString = (u: unknown): E.Either<string, string> =>
 *   typeof u === 'string' ? E.right(u) : E.left('not a string')
 *
 * const parseNumber = (u: unknown): E.Either<string, number> =>
 *   typeof u === 'number' ? E.right(u) : E.left('not a number')
 *
 * const parse = (u: unknown): E.Either<string, string | number> =>
 *   pipe(
 *     parseString(u),
 *     E.alt<string, string | number>(() => parseNumber(u))
 *   )
 *
 * assert.deepStrictEqual(parse(true), E.left('not a number')) // <= last error
 *
 * const Alt = E.getAltValidation(pipe(string.Semigroup, S.intercalate(', ')))
 *
 * const parseAll = (u: unknown): E.Either<string, string | number> =>
 *   Alt.alt<string | number>(parseString(u), () => parseNumber(u))
 *
 * assert.deepStrictEqual(parseAll(true), E.left('not a string, not a number')) // <= all errors
 *
 * @category error handling
 * @since 2.7.0
 */ var $3ffe82e7c0b4721a$var$getAltValidation = function(SE) {
    return {
        URI: module.exports.URI,
        _E: undefined,
        map: $3ffe82e7c0b4721a$var$_map,
        alt: function(me, that) {
            if ((0, module.exports.isRight)(me)) return me;
            var ea = that();
            return (0, module.exports.isLeft)(ea) ? (0, module.exports.left)(SE.concat(me.left, ea.left)) : ea;
        }
    };
};
module.exports.getAltValidation = $3ffe82e7c0b4721a$var$getAltValidation;
/**
 * @category mapping
 * @since 2.0.0
 */ var $3ffe82e7c0b4721a$var$map = function(f) {
    return function(fa) {
        return (0, module.exports.isLeft)(fa) ? fa : (0, module.exports.right)(f(fa.right));
    };
};
module.exports.map = $3ffe82e7c0b4721a$var$map;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Functor = {
    URI: module.exports.URI,
    map: $3ffe82e7c0b4721a$var$_map
};
/**
 * Maps the `Right` value of this `Either` to the specified constant value.
 *
 * @category mapping
 * @since 2.16.0
 */ module.exports.as = (0, $3abDJ.dual)(2, (0, $emm1u.as)(module.exports.Functor));
/**
 * Maps the `Right` value of this `Either` to the void constant value.
 *
 * @category mapping
 * @since 2.16.0
 */ module.exports.asUnit = (0, $emm1u.asUnit)(module.exports.Functor);
/**
 * @category constructors
 * @since 2.7.0
 */ module.exports.of = module.exports.right;
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Pointed = {
    URI: module.exports.URI,
    of: module.exports.of
};
/**
 * Less strict version of [`ap`](#ap).
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @since 2.8.0
 */ var $3ffe82e7c0b4721a$var$apW = function(fa) {
    return function(fab) {
        return (0, module.exports.isLeft)(fab) ? fab : (0, module.exports.isLeft)(fa) ? fa : (0, module.exports.right)(fab.right(fa.right));
    };
};
module.exports.apW = $3ffe82e7c0b4721a$var$apW;
/**
 * @since 2.0.0
 */ module.exports.ap = module.exports.apW;
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Apply = {
    URI: module.exports.URI,
    map: $3ffe82e7c0b4721a$var$_map,
    ap: $3ffe82e7c0b4721a$var$_ap
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Applicative = {
    URI: module.exports.URI,
    map: $3ffe82e7c0b4721a$var$_map,
    ap: $3ffe82e7c0b4721a$var$_ap,
    of: module.exports.of
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Chain = {
    URI: module.exports.URI,
    map: $3ffe82e7c0b4721a$var$_map,
    ap: $3ffe82e7c0b4721a$var$_ap,
    chain: module.exports.flatMap
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Monad = {
    URI: module.exports.URI,
    map: $3ffe82e7c0b4721a$var$_map,
    ap: $3ffe82e7c0b4721a$var$_ap,
    of: module.exports.of,
    chain: module.exports.flatMap
};
/**
 * Left-associative fold of a structure.
 *
 * @example
 * import { pipe } from 'fp-ts/function'
 * import * as E from 'fp-ts/Either'
 *
 * const startWith = 'prefix'
 * const concat = (a: string, b: string) => `${a}:${b}`
 *
 * assert.deepStrictEqual(
 *   pipe(E.right('a'), E.reduce(startWith, concat)),
 *   'prefix:a'
 * )
 *
 * assert.deepStrictEqual(
 *   pipe(E.left('e'), E.reduce(startWith, concat)),
 *   'prefix'
 * )
 *
 * @category folding
 * @since 2.0.0
 */ var $3ffe82e7c0b4721a$var$reduce = function(b, f) {
    return function(fa) {
        return (0, module.exports.isLeft)(fa) ? b : f(b, fa.right);
    };
};
module.exports.reduce = $3ffe82e7c0b4721a$var$reduce;
/**
 * Map each element of the structure to a monoid, and combine the results.
 *
 * @example
 * import { pipe } from 'fp-ts/function'
 * import * as E from 'fp-ts/Either'
 * import * as S from 'fp-ts/string'
 *
 * const yell = (a: string) => `${a}!`
 *
 * assert.deepStrictEqual(
 *   pipe(E.right('a'), E.foldMap(S.Monoid)(yell)),
 *   'a!'
 * )
 *
 * assert.deepStrictEqual(
 *   pipe(E.left('e'), E.foldMap(S.Monoid)(yell)),
 *   S.Monoid.empty
 * )
 *
 * @category folding
 * @since 2.0.0
 */ var $3ffe82e7c0b4721a$var$foldMap = function(M) {
    return function(f) {
        return function(fa) {
            return (0, module.exports.isLeft)(fa) ? M.empty : f(fa.right);
        };
    };
};
module.exports.foldMap = $3ffe82e7c0b4721a$var$foldMap;
/**
 * Right-associative fold of a structure.
 *
 * @example
 * import { pipe } from 'fp-ts/function'
 * import * as E from 'fp-ts/Either'
 *
 * const startWith = 'postfix'
 * const concat = (a: string, b: string) => `${a}:${b}`
 *
 * assert.deepStrictEqual(
 *   pipe(E.right('a'), E.reduceRight(startWith, concat)),
 *   'a:postfix'
 * )
 *
 * assert.deepStrictEqual(
 *   pipe(E.left('e'), E.reduceRight(startWith, concat)),
 *   'postfix'
 * )
 *
 * @category folding
 * @since 2.0.0
 */ var $3ffe82e7c0b4721a$var$reduceRight = function(b, f) {
    return function(fa) {
        return (0, module.exports.isLeft)(fa) ? b : f(fa.right, b);
    };
};
module.exports.reduceRight = $3ffe82e7c0b4721a$var$reduceRight;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Foldable = {
    URI: module.exports.URI,
    reduce: $3ffe82e7c0b4721a$var$_reduce,
    foldMap: $3ffe82e7c0b4721a$var$_foldMap,
    reduceRight: $3ffe82e7c0b4721a$var$_reduceRight
};
/**
 * Map each element of a structure to an action, evaluate these actions from left to right, and collect the results.
 *
 * @example
 * import { pipe } from 'fp-ts/function'
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import * as E from 'fp-ts/Either'
 * import * as O from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(
 *   pipe(E.right(['a']), E.traverse(O.Applicative)(RA.head)),
 *   O.some(E.right('a'))
 *  )
 *
 * assert.deepStrictEqual(
 *   pipe(E.right([]), E.traverse(O.Applicative)(RA.head)),
 *   O.none
 * )
 *
 * @category traversing
 * @since 2.6.3
 */ var $3ffe82e7c0b4721a$var$traverse = function(F) {
    return function(f) {
        return function(ta) {
            return (0, module.exports.isLeft)(ta) ? F.of((0, module.exports.left)(ta.left)) : F.map(f(ta.right), module.exports.right);
        };
    };
};
module.exports.traverse = $3ffe82e7c0b4721a$var$traverse;
/**
 * Evaluate each monadic action in the structure from left to right, and collect the results.
 *
 * @example
 * import { pipe } from 'fp-ts/function'
 * import * as E from 'fp-ts/Either'
 * import * as O from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(
 *   pipe(E.right(O.some('a')), E.sequence(O.Applicative)),
 *   O.some(E.right('a'))
 *  )
 *
 * assert.deepStrictEqual(
 *   pipe(E.right(O.none), E.sequence(O.Applicative)),
 *   O.none
 * )
 *
 * @category traversing
 * @since 2.6.3
 */ var $3ffe82e7c0b4721a$var$sequence = function(F) {
    return function(ma) {
        return (0, module.exports.isLeft)(ma) ? F.of((0, module.exports.left)(ma.left)) : F.map(ma.right, module.exports.right);
    };
};
module.exports.sequence = $3ffe82e7c0b4721a$var$sequence;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Traversable = {
    URI: module.exports.URI,
    map: $3ffe82e7c0b4721a$var$_map,
    reduce: $3ffe82e7c0b4721a$var$_reduce,
    foldMap: $3ffe82e7c0b4721a$var$_foldMap,
    reduceRight: $3ffe82e7c0b4721a$var$_reduceRight,
    traverse: $3ffe82e7c0b4721a$var$_traverse,
    sequence: module.exports.sequence
};
/**
 * Map a pair of functions over the two type arguments of the bifunctor.
 *
 * @category mapping
 * @since 2.0.0
 */ var $3ffe82e7c0b4721a$var$bimap = function(f, g) {
    return function(fa) {
        return (0, module.exports.isLeft)(fa) ? (0, module.exports.left)(f(fa.left)) : (0, module.exports.right)(g(fa.right));
    };
};
module.exports.bimap = $3ffe82e7c0b4721a$var$bimap;
/**
 * Map a function over the first type argument of a bifunctor.
 *
 * @category error handling
 * @since 2.0.0
 */ var $3ffe82e7c0b4721a$var$mapLeft = function(f) {
    return function(fa) {
        return (0, module.exports.isLeft)(fa) ? (0, module.exports.left)(f(fa.left)) : fa;
    };
};
module.exports.mapLeft = $3ffe82e7c0b4721a$var$mapLeft;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Bifunctor = {
    URI: module.exports.URI,
    bimap: $3ffe82e7c0b4721a$var$_bimap,
    mapLeft: $3ffe82e7c0b4721a$var$_mapLeft
};
/**
 * Less strict version of [`alt`](#alt).
 *
 * The `W` suffix (short for **W**idening) means that the error and the return types will be merged.
 *
 * @category error handling
 * @since 2.9.0
 */ var $3ffe82e7c0b4721a$var$altW = function(that) {
    return function(fa) {
        return (0, module.exports.isLeft)(fa) ? that() : fa;
    };
};
module.exports.altW = $3ffe82e7c0b4721a$var$altW;
/**
 * Identifies an associative operation on a type constructor. It is similar to `Semigroup`, except that it applies to
 * types of kind `* -> *`.
 *
 * In case of `Either` returns the left-most non-`Left` value (or the right-most `Left` value if both values are `Left`).
 *
 * | x        | y        | pipe(x, alt(() => y) |
 * | -------- | -------- | -------------------- |
 * | left(a)  | left(b)  | left(b)              |
 * | left(a)  | right(2) | right(2)             |
 * | right(1) | left(b)  | right(1)             |
 * | right(1) | right(2) | right(1)             |
 *
 * @example
 * import * as E from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     E.left('a'),
 *     E.alt(() => E.left('b'))
 *   ),
 *   E.left('b')
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     E.left('a'),
 *     E.alt(() => E.right(2))
 *   ),
 *   E.right(2)
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     E.right(1),
 *     E.alt(() => E.left('b'))
 *   ),
 *   E.right(1)
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     E.right(1),
 *     E.alt(() => E.right(2))
 *   ),
 *   E.right(1)
 * )
 *
 * @category error handling
 * @since 2.0.0
 */ module.exports.alt = module.exports.altW;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Alt = {
    URI: module.exports.URI,
    map: $3ffe82e7c0b4721a$var$_map,
    alt: $3ffe82e7c0b4721a$var$_alt
};
/**
 * @since 2.0.0
 */ var $3ffe82e7c0b4721a$var$extend = function(f) {
    return function(wa) {
        return (0, module.exports.isLeft)(wa) ? wa : (0, module.exports.right)(f(wa));
    };
};
module.exports.extend = $3ffe82e7c0b4721a$var$extend;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Extend = {
    URI: module.exports.URI,
    map: $3ffe82e7c0b4721a$var$_map,
    extend: $3ffe82e7c0b4721a$var$_extend
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.ChainRec = {
    URI: module.exports.URI,
    map: $3ffe82e7c0b4721a$var$_map,
    ap: $3ffe82e7c0b4721a$var$_ap,
    chain: module.exports.flatMap,
    chainRec: $3ffe82e7c0b4721a$var$_chainRec
};
/**
 * @since 2.6.3
 */ module.exports.throwError = module.exports.left;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.MonadThrow = {
    URI: module.exports.URI,
    map: $3ffe82e7c0b4721a$var$_map,
    ap: $3ffe82e7c0b4721a$var$_ap,
    of: module.exports.of,
    chain: module.exports.flatMap,
    throwError: module.exports.throwError
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.FromEither = {
    URI: module.exports.URI,
    fromEither: $3abDJ.identity
};
/**
 * @example
 * import { fromPredicate, left, right } from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     1,
 *     fromPredicate(
 *       (n) => n > 0,
 *       () => 'error'
 *     )
 *   ),
 *   right(1)
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     -1,
 *     fromPredicate(
 *       (n) => n > 0,
 *       () => 'error'
 *     )
 *   ),
 *   left('error')
 * )
 *
 * @category lifting
 * @since 2.0.0
 */ module.exports.fromPredicate = (0, $eLQyV.fromPredicate)(module.exports.FromEither);
// -------------------------------------------------------------------------------------
// conversions
// -------------------------------------------------------------------------------------
/**
 * @example
 * import * as E from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 * import * as O from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     O.some(1),
 *     E.fromOption(() => 'error')
 *   ),
 *   E.right(1)
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     O.none,
 *     E.fromOption(() => 'error')
 *   ),
 *   E.left('error')
 * )
 *
 * @category conversions
 * @since 2.0.0
 */ module.exports.fromOption = /*#__PURE__*/ (0, $eLQyV.fromOption)(module.exports.FromEither);
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * Returns `true` if the either is an instance of `Left`, `false` otherwise.
 *
 * @category refinements
 * @since 2.0.0
 */ module.exports.isLeft = $3ffe82e7c0b4721a$var$_.isLeft;
/**
 * Returns `true` if the either is an instance of `Right`, `false` otherwise.
 *
 * @category refinements
 * @since 2.0.0
 */ module.exports.isRight = $3ffe82e7c0b4721a$var$_.isRight;
/**
 * Less strict version of [`match`](#match).
 *
 * The `W` suffix (short for **W**idening) means that the handler return types will be merged.
 *
 * @category pattern matching
 * @since 2.10.0
 */ var $3ffe82e7c0b4721a$var$matchW = function(onLeft, onRight) {
    return function(ma) {
        return (0, module.exports.isLeft)(ma) ? onLeft(ma.left) : onRight(ma.right);
    };
};
module.exports.matchW = $3ffe82e7c0b4721a$var$matchW;
/**
 * Alias of [`matchW`](#matchw).
 *
 * @category pattern matching
 * @since 2.10.0
 */ module.exports.foldW = module.exports.matchW;
/**
 * Takes two functions and an `Either` value, if the value is a `Left` the inner value is applied to the first function,
 * if the value is a `Right` the inner value is applied to the second function.
 *
 * @example
 * import { match, left, right } from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 *
 * function onLeft(errors: Array<string>): string {
 *   return `Errors: ${errors.join(', ')}`
 * }
 *
 * function onRight(value: number): string {
 *   return `Ok: ${value}`
 * }
 *
 * assert.strictEqual(
 *   pipe(
 *     right(1),
 *     match(onLeft, onRight)
 *   ),
 *   'Ok: 1'
 * )
 * assert.strictEqual(
 *   pipe(
 *     left(['error 1', 'error 2']),
 *     match(onLeft, onRight)
 *   ),
 *   'Errors: error 1, error 2'
 * )
 *
 * @category pattern matching
 * @since 2.10.0
 */ module.exports.match = module.exports.matchW;
/**
 * Alias of [`match`](#match).
 *
 * @category pattern matching
 * @since 2.0.0
 */ module.exports.fold = module.exports.match;
/**
 * Less strict version of [`getOrElse`](#getorelse).
 *
 * The `W` suffix (short for **W**idening) means that the handler return type will be merged.
 *
 * @category error handling
 * @since 2.6.0
 */ var $3ffe82e7c0b4721a$var$getOrElseW = function(onLeft) {
    return function(ma) {
        return (0, module.exports.isLeft)(ma) ? onLeft(ma.left) : ma.right;
    };
};
module.exports.getOrElseW = $3ffe82e7c0b4721a$var$getOrElseW;
/**
 * Returns the wrapped value if it's a `Right` or a default value if is a `Left`.
 *
 * @example
 * import { getOrElse, left, right } from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     right(1),
 *     getOrElse(() => 0)
 *   ),
 *   1
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     left('error'),
 *     getOrElse(() => 0)
 *   ),
 *   0
 * )
 *
 * @category error handling
 * @since 2.0.0
 */ module.exports.getOrElse = module.exports.getOrElseW;
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @category mapping
 * @since 2.10.0
 */ module.exports.flap = (0, $emm1u.flap)(module.exports.Functor);
/**
 * Combine two effectful actions, keeping only the result of the first.
 *
 * @since 2.0.0
 */ module.exports.apFirst = (0, $4sfjE.apFirst)(module.exports.Apply);
/**
 * Less strict version of [`apFirst`](#apfirst)
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @since 2.12.0
 */ module.exports.apFirstW = module.exports.apFirst;
/**
 * Combine two effectful actions, keeping only the result of the second.
 *
 * @since 2.0.0
 */ module.exports.apSecond = (0, $4sfjE.apSecond)(module.exports.Apply);
/**
 * Less strict version of [`apSecond`](#apsecond)
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @since 2.12.0
 */ module.exports.apSecondW = module.exports.apSecond;
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * @category combinators
 * @since 2.15.0
 */ module.exports.tap = (0, $3abDJ.dual)(2, $3ffe82e7c0b4721a$var$chainable.tap(module.exports.Chain));
/**
 * Less strict version of [`flatten`](#flatten).
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @category sequencing
 * @since 2.11.0
 */ module.exports.flattenW = /*#__PURE__*/ (0, module.exports.flatMap)($3abDJ.identity);
/**
 * The `flatten` function is the conventional monad join operator. It is used to remove one level of monadic structure, projecting its bound argument into the outer level.
 *
 * @example
 * import * as E from 'fp-ts/Either'
 *
 * assert.deepStrictEqual(E.flatten(E.right(E.right('a'))), E.right('a'))
 * assert.deepStrictEqual(E.flatten(E.right(E.left('e'))), E.left('e'))
 * assert.deepStrictEqual(E.flatten(E.left('e')), E.left('e'))
 *
 * @category sequencing
 * @since 2.0.0
 */ module.exports.flatten = module.exports.flattenW;
/**
 * @since 2.0.0
 */ module.exports.duplicate = (0, module.exports.extend)($3abDJ.identity);
/**
 * Use `liftOption`.
 *
 * @category legacy
 * @since 2.10.0
 */ module.exports.fromOptionK = /*#__PURE__*/ (0, $eLQyV.fromOptionK)(module.exports.FromEither);
/**
 * Use `flatMapOption`.
 *
 * @category legacy
 * @since 2.11.0
 */ module.exports.chainOptionK = (0, $eLQyV.chainOptionK)(module.exports.FromEither, module.exports.Chain);
/**
 * Use `flatMapOption`.
 *
 * @category legacy
 * @since 2.13.2
 */ module.exports.chainOptionKW = module.exports.chainOptionK;
/** @internal */ var $3ffe82e7c0b4721a$var$_FromEither = {
    fromEither: module.exports.FromEither.fromEither
};
/**
 * @category lifting
 * @since 2.15.0
 */ module.exports.liftNullable = $3ffe82e7c0b4721a$var$_.liftNullable($3ffe82e7c0b4721a$var$_FromEither);
/**
 * @category lifting
 * @since 2.15.0
 */ module.exports.liftOption = $3ffe82e7c0b4721a$var$_.liftOption($3ffe82e7c0b4721a$var$_FromEither);
/** @internal */ var $3ffe82e7c0b4721a$var$_FlatMap = {
    flatMap: module.exports.flatMap
};
/**
 * @category sequencing
 * @since 2.15.0
 */ module.exports.flatMapNullable = $3ffe82e7c0b4721a$var$_.flatMapNullable($3ffe82e7c0b4721a$var$_FromEither, $3ffe82e7c0b4721a$var$_FlatMap);
/**
 * @category sequencing
 * @since 2.15.0
 */ module.exports.flatMapOption = $3ffe82e7c0b4721a$var$_.flatMapOption($3ffe82e7c0b4721a$var$_FromEither, $3ffe82e7c0b4721a$var$_FlatMap);
/**
 * @example
 * import * as E from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     E.right(1),
 *     E.filterOrElse(
 *       (n) => n > 0,
 *       () => 'error'
 *     )
 *   ),
 *   E.right(1)
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     E.right(-1),
 *     E.filterOrElse(
 *       (n) => n > 0,
 *       () => 'error'
 *     )
 *   ),
 *   E.left('error')
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     E.left('a'),
 *     E.filterOrElse(
 *       (n) => n > 0,
 *       () => 'error'
 *     )
 *   ),
 *   E.left('a')
 * )
 *
 * @category filtering
 * @since 2.0.0
 */ module.exports.filterOrElse = (0, $eLQyV.filterOrElse)(module.exports.FromEither, module.exports.Chain);
/**
 * Less strict version of [`filterOrElse`](#filterorelse).
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @category filtering
 * @since 2.9.0
 */ module.exports.filterOrElseW = module.exports.filterOrElse;
/**
 * Returns a `Right` if is a `Left` (and vice versa).
 *
 * @since 2.0.0
 */ var $3ffe82e7c0b4721a$var$swap = function(ma) {
    return (0, module.exports.isLeft)(ma) ? (0, module.exports.right)(ma.left) : (0, module.exports.left)(ma.right);
};
module.exports.swap = $3ffe82e7c0b4721a$var$swap;
/**
 * Less strict version of [`orElse`](#orelse).
 *
 * The `W` suffix (short for **W**idening) means that the return types will be merged.
 *
 * @category error handling
 * @since 2.10.0
 */ var $3ffe82e7c0b4721a$var$orElseW = function(onLeft) {
    return function(ma) {
        return (0, module.exports.isLeft)(ma) ? onLeft(ma.left) : ma;
    };
};
module.exports.orElseW = $3ffe82e7c0b4721a$var$orElseW;
/**
 * Useful for recovering from errors.
 *
 * @category error handling
 * @since 2.0.0
 */ module.exports.orElse = module.exports.orElseW;
/**
 * Takes a default and a nullable value, if the value is not nully, turn it into a `Right`, if the value is nully use
 * the provided default as a `Left`.
 *
 * @example
 * import { fromNullable, left, right } from 'fp-ts/Either'
 *
 * const parse = fromNullable('nully')
 *
 * assert.deepStrictEqual(parse(1), right(1))
 * assert.deepStrictEqual(parse(null), left('nully'))
 *
 * @category conversions
 * @since 2.0.0
 */ var $3ffe82e7c0b4721a$var$fromNullable = function(e) {
    return function(a) {
        return a == null ? (0, module.exports.left)(e) : (0, module.exports.right)(a);
    };
};
module.exports.fromNullable = $3ffe82e7c0b4721a$var$fromNullable;
/**
 * Constructs a new `Either` from a function that might throw.
 *
 * See also [`tryCatchK`](#trycatchk).
 *
 * @example
 * import * as E from 'fp-ts/Either'
 *
 * const unsafeHead = <A>(as: ReadonlyArray<A>): A => {
 *   if (as.length > 0) {
 *     return as[0]
 *   } else {
 *     throw new Error('empty array')
 *   }
 * }
 *
 * const head = <A>(as: ReadonlyArray<A>): E.Either<Error, A> =>
 *   E.tryCatch(() => unsafeHead(as), e => (e instanceof Error ? e : new Error('unknown error')))
 *
 * assert.deepStrictEqual(head([]), E.left(new Error('empty array')))
 * assert.deepStrictEqual(head([1, 2, 3]), E.right(1))
 *
 * @category interop
 * @since 2.0.0
 */ var $3ffe82e7c0b4721a$var$tryCatch = function(f, onThrow) {
    try {
        return (0, module.exports.right)(f());
    } catch (e) {
        return (0, module.exports.left)(onThrow(e));
    }
};
module.exports.tryCatch = $3ffe82e7c0b4721a$var$tryCatch;
/**
 * Converts a function that may throw to one returning a `Either`.
 *
 * @category interop
 * @since 2.10.0
 */ var $3ffe82e7c0b4721a$var$tryCatchK = function(f, onThrow) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return (0, module.exports.tryCatch)(function() {
            return f.apply(void 0, a);
        }, onThrow);
    };
};
module.exports.tryCatchK = $3ffe82e7c0b4721a$var$tryCatchK;
/**
 * Use `liftNullable`.
 *
 * @category legacy
 * @since 2.9.0
 */ var $3ffe82e7c0b4721a$var$fromNullableK = function(e) {
    var from = (0, module.exports.fromNullable)(e);
    return function(f) {
        return (0, $3abDJ.flow)(f, from);
    };
};
module.exports.fromNullableK = $3ffe82e7c0b4721a$var$fromNullableK;
/**
 * Use `flatMapNullable`.
 *
 * @category legacy
 * @since 2.9.0
 */ var $3ffe82e7c0b4721a$var$chainNullableK = function(e) {
    var from = (0, module.exports.fromNullableK)(e);
    return function(f) {
        return (0, module.exports.flatMap)(from(f));
    };
};
module.exports.chainNullableK = $3ffe82e7c0b4721a$var$chainNullableK;
/**
 * @category conversions
 * @since 2.10.0
 */ module.exports.toUnion = (0, module.exports.foldW)($3abDJ.identity, $3abDJ.identity);
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Default value for the `onError` argument of `tryCatch`
 *
 * @since 2.0.0
 */ function $3ffe82e7c0b4721a$var$toError(e) {
    try {
        return e instanceof Error ? e : new Error(String(e));
    } catch (error) {
        return new Error();
    }
}
function $3ffe82e7c0b4721a$var$elem(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $3ffe82e7c0b4721a$var$elem(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return (0, module.exports.isLeft)(ma) ? false : E.equals(a, ma.right);
    };
}
/**
 * Returns `false` if `Left` or returns the result of the application of the given predicate to the `Right` value.
 *
 * @example
 * import { exists, left, right } from 'fp-ts/Either'
 *
 * const gt2 = exists((n: number) => n > 2)
 *
 * assert.strictEqual(gt2(left('a')), false)
 * assert.strictEqual(gt2(right(1)), false)
 * assert.strictEqual(gt2(right(3)), true)
 *
 * @since 2.0.0
 */ var $3ffe82e7c0b4721a$var$exists = function(predicate) {
    return function(ma) {
        return (0, module.exports.isLeft)(ma) ? false : predicate(ma.right);
    };
};
module.exports.exists = $3ffe82e7c0b4721a$var$exists;
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * @category do notation
 * @since 2.9.0
 */ module.exports.Do = (0, module.exports.of)($3ffe82e7c0b4721a$var$_.emptyRecord);
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.bindTo = (0, $emm1u.bindTo)(module.exports.Functor);
var $3ffe82e7c0b4721a$var$let_ = /*#__PURE__*/ (0, $emm1u.let)(module.exports.Functor);
module.exports.let = $3ffe82e7c0b4721a$var$let_;
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.bind = $3ffe82e7c0b4721a$var$chainable.bind(module.exports.Chain);
/**
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @category do notation
 * @since 2.8.0
 */ module.exports.bindW = module.exports.bind;
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.apS = (0, $4sfjE.apS)(module.exports.Apply);
/**
 * Less strict version of [`apS`](#aps).
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @category do notation
 * @since 2.8.0
 */ module.exports.apSW = module.exports.apS;
/**
 * @since 2.11.0
 */ module.exports.ApT = (0, module.exports.of)($3ffe82e7c0b4721a$var$_.emptyReadonlyArray);
// -------------------------------------------------------------------------------------
// array utils
// -------------------------------------------------------------------------------------
/**
 * Equivalent to `ReadonlyNonEmptyArray#traverseWithIndex(Applicative)`.
 *
 * @category traversing
 * @since 2.11.0
 */ var $3ffe82e7c0b4721a$var$traverseReadonlyNonEmptyArrayWithIndex = function(f) {
    return function(as) {
        var e = f(0, $3ffe82e7c0b4721a$var$_.head(as));
        if ((0, module.exports.isLeft)(e)) return e;
        var out = [
            e.right
        ];
        for(var i = 1; i < as.length; i++){
            var e_1 = f(i, as[i]);
            if ((0, module.exports.isLeft)(e_1)) return e_1;
            out.push(e_1.right);
        }
        return (0, module.exports.right)(out);
    };
};
module.exports.traverseReadonlyNonEmptyArrayWithIndex = $3ffe82e7c0b4721a$var$traverseReadonlyNonEmptyArrayWithIndex;
/**
 * Equivalent to `ReadonlyArray#traverseWithIndex(Applicative)`.
 *
 * @category traversing
 * @since 2.11.0
 */ var $3ffe82e7c0b4721a$var$traverseReadonlyArrayWithIndex = function(f) {
    var g = (0, module.exports.traverseReadonlyNonEmptyArrayWithIndex)(f);
    return function(as) {
        return $3ffe82e7c0b4721a$var$_.isNonEmpty(as) ? g(as) : module.exports.ApT;
    };
};
module.exports.traverseReadonlyArrayWithIndex = $3ffe82e7c0b4721a$var$traverseReadonlyArrayWithIndex;
/**
 * Equivalent to `ReadonlyArray#traverseWithIndex(Applicative)`.
 *
 * @category traversing
 * @since 2.9.0
 */ module.exports.traverseArrayWithIndex = module.exports.traverseReadonlyArrayWithIndex;
/**
 * Equivalent to `ReadonlyArray#traverse(Applicative)`.
 *
 * @category traversing
 * @since 2.9.0
 */ var $3ffe82e7c0b4721a$var$traverseArray = function(f) {
    return (0, module.exports.traverseReadonlyArrayWithIndex)(function(_, a) {
        return f(a);
    });
};
module.exports.traverseArray = $3ffe82e7c0b4721a$var$traverseArray;
/**
 * Equivalent to `ReadonlyArray#sequence(Applicative)`.
 *
 * @category traversing
 * @since 2.9.0
 */ module.exports.sequenceArray = /*#__PURE__*/ (0, module.exports.traverseArray)($3abDJ.identity);
// -------------------------------------------------------------------------------------
// legacy
// -------------------------------------------------------------------------------------
/**
 * Alias of `flatMap`.
 *
 * @category legacy
 * @since 2.6.0
 */ module.exports.chainW = module.exports.flatMap;
/**
 * Alias of `flatMap`.
 *
 * @category legacy
 * @since 2.0.0
 */ module.exports.chain = module.exports.flatMap;
/**
 * Alias of `tap`.
 *
 * @category legacy
 * @since 2.0.0
 */ module.exports.chainFirst = module.exports.tap;
/**
 * Alias of `tap`.
 *
 * @category legacy
 * @since 2.8.0
 */ module.exports.chainFirstW = module.exports.tap;
/**
 * Use [`parse`](./Json.ts.html#parse) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ function $3ffe82e7c0b4721a$var$parseJSON(s, onError) {
    return (0, module.exports.tryCatch)(function() {
        return JSON.parse(s);
    }, onError);
}
/**
 * Use [`stringify`](./Json.ts.html#stringify) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ var $3ffe82e7c0b4721a$var$stringifyJSON = function(u, onError) {
    return (0, module.exports.tryCatch)(function() {
        var s = JSON.stringify(u);
        if (typeof s !== 'string') throw new Error('Converting unsupported structure to JSON');
        return s;
    }, onError);
};
module.exports.stringifyJSON = $3ffe82e7c0b4721a$var$stringifyJSON;
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Functor` instance, pass `E.Functor` instead of `E.either`
 * (where `E` is from `import E from 'fp-ts/Either'`)
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.either = {
    URI: module.exports.URI,
    map: $3ffe82e7c0b4721a$var$_map,
    of: module.exports.of,
    ap: $3ffe82e7c0b4721a$var$_ap,
    chain: module.exports.flatMap,
    reduce: $3ffe82e7c0b4721a$var$_reduce,
    foldMap: $3ffe82e7c0b4721a$var$_foldMap,
    reduceRight: $3ffe82e7c0b4721a$var$_reduceRight,
    traverse: $3ffe82e7c0b4721a$var$_traverse,
    sequence: module.exports.sequence,
    bimap: $3ffe82e7c0b4721a$var$_bimap,
    mapLeft: $3ffe82e7c0b4721a$var$_mapLeft,
    alt: $3ffe82e7c0b4721a$var$_alt,
    extend: $3ffe82e7c0b4721a$var$_extend,
    chainRec: $3ffe82e7c0b4721a$var$_chainRec,
    throwError: module.exports.throwError
};
/**
 * Use [`getApplySemigroup`](./Apply.ts.html#getapplysemigroup) instead.
 *
 * Semigroup returning the left-most `Left` value. If both operands are `Right`s then the inner values
 * are concatenated using the provided `Semigroup`
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getApplySemigroup = /*#__PURE__*/ (0, $4sfjE.getApplySemigroup)(module.exports.Apply);
/**
 * Use [`getApplicativeMonoid`](./Applicative.ts.html#getapplicativemonoid) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getApplyMonoid = /*#__PURE__*/ (0, $eImHL.getApplicativeMonoid)(module.exports.Applicative);
/**
 * Use [`getApplySemigroup`](./Apply.ts.html#getapplysemigroup) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ var $3ffe82e7c0b4721a$var$getValidationSemigroup = function(SE, SA) {
    return (0, $4sfjE.getApplySemigroup)((0, module.exports.getApplicativeValidation)(SE))(SA);
};
module.exports.getValidationSemigroup = $3ffe82e7c0b4721a$var$getValidationSemigroup;
/**
 * Use [`getApplicativeMonoid`](./Applicative.ts.html#getapplicativemonoid) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ var $3ffe82e7c0b4721a$var$getValidationMonoid = function(SE, MA) {
    return (0, $eImHL.getApplicativeMonoid)((0, module.exports.getApplicativeValidation)(SE))(MA);
};
module.exports.getValidationMonoid = $3ffe82e7c0b4721a$var$getValidationMonoid;
/**
 * Use [`getApplicativeValidation`](#getapplicativevalidation) and [`getAltValidation`](#getaltvalidation) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ function $3ffe82e7c0b4721a$var$getValidation(SE) {
    var ap = (0, module.exports.getApplicativeValidation)(SE).ap;
    var alt = (0, module.exports.getAltValidation)(SE).alt;
    return {
        URI: module.exports.URI,
        _E: undefined,
        map: $3ffe82e7c0b4721a$var$_map,
        of: module.exports.of,
        chain: module.exports.flatMap,
        bimap: $3ffe82e7c0b4721a$var$_bimap,
        mapLeft: $3ffe82e7c0b4721a$var$_mapLeft,
        reduce: $3ffe82e7c0b4721a$var$_reduce,
        foldMap: $3ffe82e7c0b4721a$var$_foldMap,
        reduceRight: $3ffe82e7c0b4721a$var$_reduceRight,
        extend: $3ffe82e7c0b4721a$var$_extend,
        traverse: $3ffe82e7c0b4721a$var$_traverse,
        sequence: module.exports.sequence,
        chainRec: $3ffe82e7c0b4721a$var$_chainRec,
        throwError: module.exports.throwError,
        ap: ap,
        alt: alt
    };
}

});
parcelRegister("eImHL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getApplicativeMonoid = $ab66c97d2b1dbac2$var$getApplicativeMonoid;
module.exports.getApplicativeComposition = $ab66c97d2b1dbac2$var$getApplicativeComposition;

var $4sfjE = parcelRequire("4sfjE");

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");
function $ab66c97d2b1dbac2$var$getApplicativeMonoid(F) {
    var f = (0, $4sfjE.getApplySemigroup)(F);
    return function(M) {
        return {
            concat: f(M).concat,
            empty: F.of(M.empty)
        };
    };
}
/** @deprecated */ function $ab66c97d2b1dbac2$var$getApplicativeComposition(F, G) {
    var map = (0, $emm1u.getFunctorComposition)(F, G).map;
    var _ap = (0, $4sfjE.ap)(F, G);
    return {
        map: map,
        of: function(a) {
            return F.of(G.of(a));
        },
        ap: function(fgab, fga) {
            return (0, $3abDJ.pipe)(fgab, _ap(fga));
        }
    };
}

});
parcelRegister("4sfjE", function(module, exports) {
"use strict";
var $33e5a8652eb55ea9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $33e5a8652eb55ea9$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $33e5a8652eb55ea9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $33e5a8652eb55ea9$var$__createBinding(result, mod, k);
    }
    $33e5a8652eb55ea9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ap = $33e5a8652eb55ea9$var$ap;
module.exports.apFirst = $33e5a8652eb55ea9$var$apFirst;
module.exports.apSecond = $33e5a8652eb55ea9$var$apSecond;
module.exports.apS = $33e5a8652eb55ea9$var$apS;
module.exports.getApplySemigroup = $33e5a8652eb55ea9$var$getApplySemigroup;
module.exports.sequenceT = $33e5a8652eb55ea9$var$sequenceT;
module.exports.sequenceS = $33e5a8652eb55ea9$var$sequenceS;

var $3abDJ = parcelRequire("3abDJ");

var $33e5a8652eb55ea9$var$_ = $33e5a8652eb55ea9$var$__importStar((parcelRequire("704qB")));
function $33e5a8652eb55ea9$var$ap(F, G) {
    return function(fa) {
        return function(fab) {
            return F.ap(F.map(fab, function(gab) {
                return function(ga) {
                    return G.ap(gab, ga);
                };
            }), fa);
        };
    };
}
function $33e5a8652eb55ea9$var$apFirst(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function(a) {
                return function() {
                    return a;
                };
            }), second);
        };
    };
}
function $33e5a8652eb55ea9$var$apSecond(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function() {
                return function(b) {
                    return b;
                };
            }), second);
        };
    };
}
function $33e5a8652eb55ea9$var$apS(F) {
    return function(name, fb) {
        return function(fa) {
            return F.ap(F.map(fa, function(a) {
                return function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                };
            }), fb);
        };
    };
}
function $33e5a8652eb55ea9$var$getApplySemigroup(F) {
    return function(S) {
        return {
            concat: function(first, second) {
                return F.ap(F.map(first, function(x) {
                    return function(y) {
                        return S.concat(x, y);
                    };
                }), second);
            }
        };
    };
}
function $33e5a8652eb55ea9$var$curried(f, n, acc) {
    return function(x) {
        var combined = Array(acc.length + 1);
        for(var i = 0; i < acc.length; i++)combined[i] = acc[i];
        combined[acc.length] = x;
        return n === 0 ? f.apply(null, combined) : $33e5a8652eb55ea9$var$curried(f, n - 1, combined);
    };
}
var $33e5a8652eb55ea9$var$tupleConstructors = {
    1: function(a) {
        return [
            a
        ];
    },
    2: function(a) {
        return function(b) {
            return [
                a,
                b
            ];
        };
    },
    3: function(a) {
        return function(b) {
            return function(c) {
                return [
                    a,
                    b,
                    c
                ];
            };
        };
    },
    4: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return [
                        a,
                        b,
                        c,
                        d
                    ];
                };
            };
        };
    },
    5: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return [
                            a,
                            b,
                            c,
                            d,
                            e
                        ];
                    };
                };
            };
        };
    }
};
function $33e5a8652eb55ea9$var$getTupleConstructor(len) {
    if (!$33e5a8652eb55ea9$var$_.has.call($33e5a8652eb55ea9$var$tupleConstructors, len)) $33e5a8652eb55ea9$var$tupleConstructors[len] = $33e5a8652eb55ea9$var$curried($3abDJ.tuple, len - 1, []);
    return $33e5a8652eb55ea9$var$tupleConstructors[len];
}
function $33e5a8652eb55ea9$var$sequenceT(F) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var len = args.length;
        var f = $33e5a8652eb55ea9$var$getTupleConstructor(len);
        var fas = F.map(args[0], f);
        for(var i = 1; i < len; i++)fas = F.ap(fas, args[i]);
        return fas;
    };
}
function $33e5a8652eb55ea9$var$getRecordConstructor(keys) {
    var len = keys.length;
    switch(len){
        case 1:
            return function(a) {
                var _a;
                return _a = {}, _a[keys[0]] = a, _a;
            };
        case 2:
            return function(a) {
                return function(b) {
                    var _a;
                    return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a;
                };
            };
        case 3:
            return function(a) {
                return function(b) {
                    return function(c) {
                        var _a;
                        return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a;
                    };
                };
            };
        case 4:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            var _a;
                            return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a;
                        };
                    };
                };
            };
        case 5:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            return function(e) {
                                var _a;
                                return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a[keys[4]] = e, _a;
                            };
                        };
                    };
                };
            };
        default:
            return $33e5a8652eb55ea9$var$curried(function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var r = {};
                for(var i = 0; i < len; i++)r[keys[i]] = args[i];
                return r;
            }, len - 1, []);
    }
}
function $33e5a8652eb55ea9$var$sequenceS(F) {
    return function(r) {
        var keys = Object.keys(r);
        var len = keys.length;
        var f = $33e5a8652eb55ea9$var$getRecordConstructor(keys);
        var fr = F.map(r[keys[0]], f);
        for(var i = 1; i < len; i++)fr = F.ap(fr, r[keys[i]]);
        return fr;
    };
}

});
parcelRegister("3abDJ", function(module, exports) {
"use strict";
var $24db55ae2b244623$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dual = module.exports.getEndomorphismMonoid = module.exports.SK = module.exports.hole = module.exports.constVoid = module.exports.constUndefined = module.exports.constNull = module.exports.constFalse = module.exports.constTrue = module.exports.unsafeCoerce = module.exports.apply = module.exports.getRing = module.exports.getSemiring = module.exports.getMonoid = module.exports.getSemigroup = module.exports.getBooleanAlgebra = void 0;
module.exports.identity = $24db55ae2b244623$var$identity;
module.exports.constant = $24db55ae2b244623$var$constant;
module.exports.flip = $24db55ae2b244623$var$flip;
module.exports.flow = $24db55ae2b244623$var$flow;
module.exports.tuple = $24db55ae2b244623$var$tuple;
module.exports.increment = $24db55ae2b244623$var$increment;
module.exports.decrement = $24db55ae2b244623$var$decrement;
module.exports.absurd = $24db55ae2b244623$var$absurd;
module.exports.tupled = $24db55ae2b244623$var$tupled;
module.exports.untupled = $24db55ae2b244623$var$untupled;
module.exports.pipe = $24db55ae2b244623$var$pipe;
module.exports.not = $24db55ae2b244623$var$not;
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.10.0
 */ var $24db55ae2b244623$var$getBooleanAlgebra = function(B) {
    return function() {
        return {
            meet: function(x, y) {
                return function(a) {
                    return B.meet(x(a), y(a));
                };
            },
            join: function(x, y) {
                return function(a) {
                    return B.join(x(a), y(a));
                };
            },
            zero: function() {
                return B.zero;
            },
            one: function() {
                return B.one;
            },
            implies: function(x, y) {
                return function(a) {
                    return B.implies(x(a), y(a));
                };
            },
            not: function(x) {
                return function(a) {
                    return B.not(x(a));
                };
            }
        };
    };
};
module.exports.getBooleanAlgebra = $24db55ae2b244623$var$getBooleanAlgebra;
/**
 * Unary functions form a semigroup as long as you can provide a semigroup for the codomain.
 *
 * @example
 * import { Predicate, getSemigroup } from 'fp-ts/function'
 * import * as B from 'fp-ts/boolean'
 *
 * const f: Predicate<number> = (n) => n <= 2
 * const g: Predicate<number> = (n) => n >= 0
 *
 * const S1 = getSemigroup(B.SemigroupAll)<number>()
 *
 * assert.deepStrictEqual(S1.concat(f, g)(1), true)
 * assert.deepStrictEqual(S1.concat(f, g)(3), false)
 *
 * const S2 = getSemigroup(B.SemigroupAny)<number>()
 *
 * assert.deepStrictEqual(S2.concat(f, g)(1), true)
 * assert.deepStrictEqual(S2.concat(f, g)(3), true)
 *
 * @category instances
 * @since 2.10.0
 */ var $24db55ae2b244623$var$getSemigroup = function(S) {
    return function() {
        return {
            concat: function(f, g) {
                return function(a) {
                    return S.concat(f(a), g(a));
                };
            }
        };
    };
};
module.exports.getSemigroup = $24db55ae2b244623$var$getSemigroup;
/**
 * Unary functions form a monoid as long as you can provide a monoid for the codomain.
 *
 * @example
 * import { Predicate } from 'fp-ts/Predicate'
 * import { getMonoid } from 'fp-ts/function'
 * import * as B from 'fp-ts/boolean'
 *
 * const f: Predicate<number> = (n) => n <= 2
 * const g: Predicate<number> = (n) => n >= 0
 *
 * const M1 = getMonoid(B.MonoidAll)<number>()
 *
 * assert.deepStrictEqual(M1.concat(f, g)(1), true)
 * assert.deepStrictEqual(M1.concat(f, g)(3), false)
 *
 * const M2 = getMonoid(B.MonoidAny)<number>()
 *
 * assert.deepStrictEqual(M2.concat(f, g)(1), true)
 * assert.deepStrictEqual(M2.concat(f, g)(3), true)
 *
 * @category instances
 * @since 2.10.0
 */ var $24db55ae2b244623$var$getMonoid = function(M) {
    var getSemigroupM = (0, module.exports.getSemigroup)(M);
    return function() {
        return {
            concat: getSemigroupM().concat,
            empty: function() {
                return M.empty;
            }
        };
    };
};
module.exports.getMonoid = $24db55ae2b244623$var$getMonoid;
/**
 * @category instances
 * @since 2.10.0
 */ var $24db55ae2b244623$var$getSemiring = function(S) {
    return {
        add: function(f, g) {
            return function(x) {
                return S.add(f(x), g(x));
            };
        },
        zero: function() {
            return S.zero;
        },
        mul: function(f, g) {
            return function(x) {
                return S.mul(f(x), g(x));
            };
        },
        one: function() {
            return S.one;
        }
    };
};
module.exports.getSemiring = $24db55ae2b244623$var$getSemiring;
/**
 * @category instances
 * @since 2.10.0
 */ var $24db55ae2b244623$var$getRing = function(R) {
    var S = (0, module.exports.getSemiring)(R);
    return {
        add: S.add,
        mul: S.mul,
        one: S.one,
        zero: S.zero,
        sub: function(f, g) {
            return function(x) {
                return R.sub(f(x), g(x));
            };
        }
    };
};
module.exports.getRing = $24db55ae2b244623$var$getRing;
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * @since 2.11.0
 */ var $24db55ae2b244623$var$apply = function(a) {
    return function(f) {
        return f(a);
    };
};
module.exports.apply = $24db55ae2b244623$var$apply;
/**
 * @since 2.0.0
 */ function $24db55ae2b244623$var$identity(a) {
    return a;
}
/**
 * @since 2.0.0
 */ module.exports.unsafeCoerce = $24db55ae2b244623$var$identity;
/**
 * @since 2.0.0
 */ function $24db55ae2b244623$var$constant(a) {
    return function() {
        return a;
    };
}
/**
 * A thunk that returns always `true`.
 *
 * @since 2.0.0
 */ module.exports.constTrue = $24db55ae2b244623$var$constant(true);
/**
 * A thunk that returns always `false`.
 *
 * @since 2.0.0
 */ module.exports.constFalse = $24db55ae2b244623$var$constant(false);
/**
 * A thunk that returns always `null`.
 *
 * @since 2.0.0
 */ module.exports.constNull = $24db55ae2b244623$var$constant(null);
/**
 * A thunk that returns always `undefined`.
 *
 * @since 2.0.0
 */ module.exports.constUndefined = $24db55ae2b244623$var$constant(undefined);
/**
 * A thunk that returns always `void`.
 *
 * @since 2.0.0
 */ module.exports.constVoid = module.exports.constUndefined;
function $24db55ae2b244623$var$flip(f) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (args.length > 1) return f(args[1], args[0]);
        return function(a) {
            return f(a)(args[0]);
        };
    };
}
function $24db55ae2b244623$var$flow(ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch(arguments.length){
        case 1:
            return ab;
        case 2:
            return function() {
                return bc(ab.apply(this, arguments));
            };
        case 3:
            return function() {
                return cd(bc(ab.apply(this, arguments)));
            };
        case 4:
            return function() {
                return de(cd(bc(ab.apply(this, arguments))));
            };
        case 5:
            return function() {
                return ef(de(cd(bc(ab.apply(this, arguments)))));
            };
        case 6:
            return function() {
                return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
            };
        case 7:
            return function() {
                return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
            };
        case 8:
            return function() {
                return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
            };
        case 9:
            return function() {
                return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
            };
    }
    return;
}
/**
 * @since 2.0.0
 */ function $24db55ae2b244623$var$tuple() {
    var t = [];
    for(var _i = 0; _i < arguments.length; _i++)t[_i] = arguments[_i];
    return t;
}
/**
 * @since 2.0.0
 */ function $24db55ae2b244623$var$increment(n) {
    return n + 1;
}
/**
 * @since 2.0.0
 */ function $24db55ae2b244623$var$decrement(n) {
    return n - 1;
}
/**
 * @since 2.0.0
 */ function $24db55ae2b244623$var$absurd(_) {
    throw new Error('Called `absurd` function which should be uncallable');
}
/**
 * Creates a tupled version of this function: instead of `n` arguments, it accepts a single tuple argument.
 *
 * @example
 * import { tupled } from 'fp-ts/function'
 *
 * const add = tupled((x: number, y: number): number => x + y)
 *
 * assert.strictEqual(add([1, 2]), 3)
 *
 * @since 2.4.0
 */ function $24db55ae2b244623$var$tupled(f) {
    return function(a) {
        return f.apply(void 0, a);
    };
}
/**
 * Inverse function of `tupled`
 *
 * @since 2.4.0
 */ function $24db55ae2b244623$var$untupled(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return f(a);
    };
}
function $24db55ae2b244623$var$pipe(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch(arguments.length){
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        default:
            var ret = arguments[0];
            for(var i = 1; i < arguments.length; i++)ret = arguments[i](ret);
            return ret;
    }
}
/**
 * Type hole simulation
 *
 * @since 2.7.0
 */ module.exports.hole = $24db55ae2b244623$var$absurd;
/**
 * @since 2.11.0
 */ var $24db55ae2b244623$var$SK = function(_, b) {
    return b;
};
module.exports.SK = $24db55ae2b244623$var$SK;
/**
 * Use `Predicate` module instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ function $24db55ae2b244623$var$not(predicate) {
    return function(a) {
        return !predicate(a);
    };
}
/**
 * Use `Endomorphism` module instead.
 *
 * @category zone of death
 * @since 2.10.0
 * @deprecated
 */ var $24db55ae2b244623$var$getEndomorphismMonoid = function() {
    return {
        concat: function(first, second) {
            return $24db55ae2b244623$var$flow(first, second);
        },
        empty: $24db55ae2b244623$var$identity
    };
};
module.exports.getEndomorphismMonoid = $24db55ae2b244623$var$getEndomorphismMonoid;
/** @internal */ var $24db55ae2b244623$var$dual = function(arity, body) {
    var isDataFirst = typeof arity === 'number' ? function(args) {
        return args.length >= arity;
    } : arity;
    return function() {
        var args = Array.from(arguments);
        if (isDataFirst(arguments)) return body.apply(this, args);
        return function(self) {
            return body.apply(void 0, $24db55ae2b244623$var$__spreadArray([
                self
            ], args, false));
        };
    };
};
module.exports.dual = $24db55ae2b244623$var$dual;

});

parcelRegister("704qB", function(module, exports) {
"use strict";
var $518bf7cd1a9f1e8a$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.flatMapReader = module.exports.flatMapTask = module.exports.flatMapIO = module.exports.flatMapEither = module.exports.flatMapOption = module.exports.flatMapNullable = module.exports.liftOption = module.exports.liftNullable = module.exports.fromReadonlyNonEmptyArray = module.exports.has = module.exports.emptyRecord = module.exports.emptyReadonlyArray = module.exports.tail = module.exports.head = module.exports.isNonEmpty = module.exports.singleton = module.exports.right = module.exports.left = module.exports.isRight = module.exports.isLeft = module.exports.some = module.exports.none = module.exports.isSome = module.exports.isNone = void 0;

var $3abDJ = parcelRequire("3abDJ");
// -------------------------------------------------------------------------------------
// Option
// -------------------------------------------------------------------------------------
/** @internal */ var $518bf7cd1a9f1e8a$var$isNone = function(fa) {
    return fa._tag === 'None';
};
module.exports.isNone = $518bf7cd1a9f1e8a$var$isNone;
/** @internal */ var $518bf7cd1a9f1e8a$var$isSome = function(fa) {
    return fa._tag === 'Some';
};
module.exports.isSome = $518bf7cd1a9f1e8a$var$isSome;
/** @internal */ module.exports.none = {
    _tag: 'None'
};
/** @internal */ var $518bf7cd1a9f1e8a$var$some = function(a) {
    return {
        _tag: 'Some',
        value: a
    };
};
module.exports.some = $518bf7cd1a9f1e8a$var$some;
// -------------------------------------------------------------------------------------
// Either
// -------------------------------------------------------------------------------------
/** @internal */ var $518bf7cd1a9f1e8a$var$isLeft = function(ma) {
    return ma._tag === 'Left';
};
module.exports.isLeft = $518bf7cd1a9f1e8a$var$isLeft;
/** @internal */ var $518bf7cd1a9f1e8a$var$isRight = function(ma) {
    return ma._tag === 'Right';
};
module.exports.isRight = $518bf7cd1a9f1e8a$var$isRight;
/** @internal */ var $518bf7cd1a9f1e8a$var$left = function(e) {
    return {
        _tag: 'Left',
        left: e
    };
};
module.exports.left = $518bf7cd1a9f1e8a$var$left;
/** @internal */ var $518bf7cd1a9f1e8a$var$right = function(a) {
    return {
        _tag: 'Right',
        right: a
    };
};
module.exports.right = $518bf7cd1a9f1e8a$var$right;
// -------------------------------------------------------------------------------------
// ReadonlyNonEmptyArray
// -------------------------------------------------------------------------------------
/** @internal */ var $518bf7cd1a9f1e8a$var$singleton = function(a) {
    return [
        a
    ];
};
module.exports.singleton = $518bf7cd1a9f1e8a$var$singleton;
/** @internal */ var $518bf7cd1a9f1e8a$var$isNonEmpty = function(as) {
    return as.length > 0;
};
module.exports.isNonEmpty = $518bf7cd1a9f1e8a$var$isNonEmpty;
/** @internal */ var $518bf7cd1a9f1e8a$var$head = function(as) {
    return as[0];
};
module.exports.head = $518bf7cd1a9f1e8a$var$head;
/** @internal */ var $518bf7cd1a9f1e8a$var$tail = function(as) {
    return as.slice(1);
};
module.exports.tail = $518bf7cd1a9f1e8a$var$tail;
// -------------------------------------------------------------------------------------
// empty
// -------------------------------------------------------------------------------------
/** @internal */ module.exports.emptyReadonlyArray = [];
/** @internal */ module.exports.emptyRecord = {};
// -------------------------------------------------------------------------------------
// Record
// -------------------------------------------------------------------------------------
/** @internal */ module.exports.has = Object.prototype.hasOwnProperty;
// -------------------------------------------------------------------------------------
// NonEmptyArray
// -------------------------------------------------------------------------------------
/** @internal */ var $518bf7cd1a9f1e8a$var$fromReadonlyNonEmptyArray = function(as) {
    return $518bf7cd1a9f1e8a$var$__spreadArray([
        as[0]
    ], as.slice(1), true);
};
module.exports.fromReadonlyNonEmptyArray = $518bf7cd1a9f1e8a$var$fromReadonlyNonEmptyArray;
/** @internal */ var $518bf7cd1a9f1e8a$var$liftNullable = function(F) {
    return function(f, onNullable) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither(o == null ? (0, module.exports.left)(onNullable.apply(void 0, a)) : (0, module.exports.right)(o));
        };
    };
};
module.exports.liftNullable = $518bf7cd1a9f1e8a$var$liftNullable;
/** @internal */ var $518bf7cd1a9f1e8a$var$liftOption = function(F) {
    return function(f, onNone) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither((0, module.exports.isNone)(o) ? (0, module.exports.left)(onNone.apply(void 0, a)) : (0, module.exports.right)(o.value));
        };
    };
};
module.exports.liftOption = $518bf7cd1a9f1e8a$var$liftOption;
/** @internal */ var $518bf7cd1a9f1e8a$var$flatMapNullable = function(F, M) {
    return /*#__PURE__*/ (0, $3abDJ.dual)(3, function(self, f, onNullable) {
        return M.flatMap(self, (0, module.exports.liftNullable)(F)(f, onNullable));
    });
};
module.exports.flatMapNullable = $518bf7cd1a9f1e8a$var$flatMapNullable;
/** @internal */ var $518bf7cd1a9f1e8a$var$flatMapOption = function(F, M) {
    return /*#__PURE__*/ (0, $3abDJ.dual)(3, function(self, f, onNone) {
        return M.flatMap(self, (0, module.exports.liftOption)(F)(f, onNone));
    });
};
module.exports.flatMapOption = $518bf7cd1a9f1e8a$var$flatMapOption;
/** @internal */ var $518bf7cd1a9f1e8a$var$flatMapEither = function(F, M) {
    return /*#__PURE__*/ (0, $3abDJ.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromEither(f(a));
        });
    });
};
module.exports.flatMapEither = $518bf7cd1a9f1e8a$var$flatMapEither;
/** @internal */ var $518bf7cd1a9f1e8a$var$flatMapIO = function(F, M) {
    return /*#__PURE__*/ (0, $3abDJ.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromIO(f(a));
        });
    });
};
module.exports.flatMapIO = $518bf7cd1a9f1e8a$var$flatMapIO;
/** @internal */ var $518bf7cd1a9f1e8a$var$flatMapTask = function(F, M) {
    return /*#__PURE__*/ (0, $3abDJ.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromTask(f(a));
        });
    });
};
module.exports.flatMapTask = $518bf7cd1a9f1e8a$var$flatMapTask;
/** @internal */ var $518bf7cd1a9f1e8a$var$flatMapReader = function(F, M) {
    return /*#__PURE__*/ (0, $3abDJ.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromReader(f(a));
        });
    });
};
module.exports.flatMapReader = $518bf7cd1a9f1e8a$var$flatMapReader;

});


parcelRegister("emm1u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.map = $a7443418a73c36f3$var$map;
module.exports.flap = $a7443418a73c36f3$var$flap;
module.exports.bindTo = $a7443418a73c36f3$var$bindTo;
module.exports.let = $a7443418a73c36f3$var$let_;
module.exports.getFunctorComposition = $a7443418a73c36f3$var$getFunctorComposition;
module.exports.as = $a7443418a73c36f3$var$as;
module.exports.asUnit = $a7443418a73c36f3$var$asUnit;

var $3abDJ = parcelRequire("3abDJ");
function $a7443418a73c36f3$var$map(F, G) {
    return function(f) {
        return function(fa) {
            return F.map(fa, function(ga) {
                return G.map(ga, f);
            });
        };
    };
}
function $a7443418a73c36f3$var$flap(F) {
    return function(a) {
        return function(fab) {
            return F.map(fab, function(f) {
                return f(a);
            });
        };
    };
}
function $a7443418a73c36f3$var$bindTo(F) {
    return function(name) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return _a = {}, _a[name] = a, _a;
            });
        };
    };
}
function $a7443418a73c36f3$var$let_(F) {
    return function(name, f) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return Object.assign({}, a, (_a = {}, _a[name] = f(a), _a));
            });
        };
    };
}
/** @deprecated */ function $a7443418a73c36f3$var$getFunctorComposition(F, G) {
    var _map = $a7443418a73c36f3$var$map(F, G);
    return {
        map: function(fga, f) {
            return (0, $3abDJ.pipe)(fga, _map(f));
        }
    };
}
/** @internal */ function $a7443418a73c36f3$var$as(F) {
    return function(self, b) {
        return F.map(self, function() {
            return b;
        });
    };
}
/** @internal */ function $a7443418a73c36f3$var$asUnit(F) {
    var asM = $a7443418a73c36f3$var$as(F);
    return function(self) {
        return asM(self, undefined);
    };
}

});


parcelRegister("ERVGH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chainFirst = $07ad91ce4db57912$var$chainFirst;
module.exports.tap = $07ad91ce4db57912$var$tap;
module.exports.bind = $07ad91ce4db57912$var$bind;
function $07ad91ce4db57912$var$chainFirst(M) {
    var tapM = $07ad91ce4db57912$var$tap(M);
    return function(f) {
        return function(first) {
            return tapM(first, f);
        };
    };
}
/** @internal */ function $07ad91ce4db57912$var$tap(M) {
    return function(first, f) {
        return M.chain(first, function(a) {
            return M.map(f(a), function() {
                return a;
            });
        });
    };
}
function $07ad91ce4db57912$var$bind(M) {
    return function(name, f) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return M.map(f(a), function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                });
            });
        };
    };
}

});

parcelRegister("ek0ul", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tailRec = void 0;
/**
 * @since 2.0.0
 */ var $a6d34ff3c6e93d25$var$tailRec = function(startWith, f) {
    var ab = f(startWith);
    while(ab._tag === 'Left')ab = f(ab.left);
    return ab.right;
};
module.exports.tailRec = $a6d34ff3c6e93d25$var$tailRec;

});

parcelRegister("eLQyV", function(module, exports) {
"use strict";
/**
 * The `FromEither` type class represents those data types which support errors.
 *
 * @since 2.10.0
 */ var $ac0e3a3ecbc50709$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ac0e3a3ecbc50709$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ac0e3a3ecbc50709$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ac0e3a3ecbc50709$var$__createBinding(result, mod, k);
    }
    $ac0e3a3ecbc50709$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromOption = $ac0e3a3ecbc50709$var$fromOption;
module.exports.fromPredicate = $ac0e3a3ecbc50709$var$fromPredicate;
module.exports.fromOptionK = $ac0e3a3ecbc50709$var$fromOptionK;
module.exports.chainOptionK = $ac0e3a3ecbc50709$var$chainOptionK;
module.exports.fromEitherK = $ac0e3a3ecbc50709$var$fromEitherK;
module.exports.chainEitherK = $ac0e3a3ecbc50709$var$chainEitherK;
module.exports.chainFirstEitherK = $ac0e3a3ecbc50709$var$chainFirstEitherK;
module.exports.filterOrElse = $ac0e3a3ecbc50709$var$filterOrElse;
module.exports.tapEither = $ac0e3a3ecbc50709$var$tapEither;

var $ERVGH = parcelRequire("ERVGH");

var $3abDJ = parcelRequire("3abDJ");

var $ac0e3a3ecbc50709$var$_ = $ac0e3a3ecbc50709$var$__importStar((parcelRequire("704qB")));
function $ac0e3a3ecbc50709$var$fromOption(F) {
    return function(onNone) {
        return function(ma) {
            return F.fromEither($ac0e3a3ecbc50709$var$_.isNone(ma) ? $ac0e3a3ecbc50709$var$_.left(onNone()) : $ac0e3a3ecbc50709$var$_.right(ma.value));
        };
    };
}
function $ac0e3a3ecbc50709$var$fromPredicate(F) {
    return function(predicate, onFalse) {
        return function(a) {
            return F.fromEither(predicate(a) ? $ac0e3a3ecbc50709$var$_.right(a) : $ac0e3a3ecbc50709$var$_.left(onFalse(a)));
        };
    };
}
function $ac0e3a3ecbc50709$var$fromOptionK(F) {
    var fromOptionF = $ac0e3a3ecbc50709$var$fromOption(F);
    return function(onNone) {
        var from = fromOptionF(onNone);
        return function(f) {
            return (0, $3abDJ.flow)(f, from);
        };
    };
}
function $ac0e3a3ecbc50709$var$chainOptionK(F, M) {
    var fromOptionKF = $ac0e3a3ecbc50709$var$fromOptionK(F);
    return function(onNone) {
        var from = fromOptionKF(onNone);
        return function(f) {
            return function(ma) {
                return M.chain(ma, from(f));
            };
        };
    };
}
function $ac0e3a3ecbc50709$var$fromEitherK(F) {
    return function(f) {
        return (0, $3abDJ.flow)(f, F.fromEither);
    };
}
function $ac0e3a3ecbc50709$var$chainEitherK(F, M) {
    var fromEitherKF = $ac0e3a3ecbc50709$var$fromEitherK(F);
    return function(f) {
        return function(ma) {
            return M.chain(ma, fromEitherKF(f));
        };
    };
}
function $ac0e3a3ecbc50709$var$chainFirstEitherK(F, M) {
    var tapEitherM = $ac0e3a3ecbc50709$var$tapEither(F, M);
    return function(f) {
        return function(ma) {
            return tapEitherM(ma, f);
        };
    };
}
function $ac0e3a3ecbc50709$var$filterOrElse(F, M) {
    return function(predicate, onFalse) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return F.fromEither(predicate(a) ? $ac0e3a3ecbc50709$var$_.right(a) : $ac0e3a3ecbc50709$var$_.left(onFalse(a)));
            });
        };
    };
}
/** @internal */ function $ac0e3a3ecbc50709$var$tapEither(F, M) {
    var fromEither = $ac0e3a3ecbc50709$var$fromEitherK(F);
    var tapM = (0, $ERVGH.tap)(M);
    return function(self, f) {
        return tapM(self, fromEither(f));
    };
}

});

parcelRegister("fIQoU", function(module, exports) {
"use strict";
/**
 * ```ts
 * interface Separated<E, A> {
 *    readonly left: E
 *    readonly right: A
 * }
 * ```
 *
 * Represents a result of separating a whole into two parts.
 *
 * @since 2.10.0
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.right = module.exports.left = module.exports.flap = module.exports.Functor = module.exports.Bifunctor = module.exports.URI = module.exports.bimap = module.exports.mapLeft = module.exports.map = module.exports.separated = void 0;

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.10.0
 */ var $b7239cc2776104dd$var$separated = function(left, right) {
    return {
        left: left,
        right: right
    };
};
module.exports.separated = $b7239cc2776104dd$var$separated;
var $b7239cc2776104dd$var$_map = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.map)(f));
};
var $b7239cc2776104dd$var$_mapLeft = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.mapLeft)(f));
};
var $b7239cc2776104dd$var$_bimap = function(fa, g, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.bimap)(g, f));
};
/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
 * use the type constructor `F` to represent some computational context.
 *
 * @category mapping
 * @since 2.10.0
 */ var $b7239cc2776104dd$var$map = function(f) {
    return function(fa) {
        return (0, module.exports.separated)((0, module.exports.left)(fa), f((0, module.exports.right)(fa)));
    };
};
module.exports.map = $b7239cc2776104dd$var$map;
/**
 * Map a function over the first type argument of a bifunctor.
 *
 * @category error handling
 * @since 2.10.0
 */ var $b7239cc2776104dd$var$mapLeft = function(f) {
    return function(fa) {
        return (0, module.exports.separated)(f((0, module.exports.left)(fa)), (0, module.exports.right)(fa));
    };
};
module.exports.mapLeft = $b7239cc2776104dd$var$mapLeft;
/**
 * Map a pair of functions over the two type arguments of the bifunctor.
 *
 * @category mapping
 * @since 2.10.0
 */ var $b7239cc2776104dd$var$bimap = function(f, g) {
    return function(fa) {
        return (0, module.exports.separated)(f((0, module.exports.left)(fa)), g((0, module.exports.right)(fa)));
    };
};
module.exports.bimap = $b7239cc2776104dd$var$bimap;
/**
 * @category type lambdas
 * @since 2.10.0
 */ module.exports.URI = 'Separated';
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Bifunctor = {
    URI: module.exports.URI,
    mapLeft: $b7239cc2776104dd$var$_mapLeft,
    bimap: $b7239cc2776104dd$var$_bimap
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Functor = {
    URI: module.exports.URI,
    map: $b7239cc2776104dd$var$_map
};
/**
 * @category mapping
 * @since 2.10.0
 */ module.exports.flap = (0, $emm1u.flap)(module.exports.Functor);
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * @since 2.10.0
 */ var $b7239cc2776104dd$var$left = function(s) {
    return s.left;
};
module.exports.left = $b7239cc2776104dd$var$left;
/**
 * @since 2.10.0
 */ var $b7239cc2776104dd$var$right = function(s) {
    return s.right;
};
module.exports.right = $b7239cc2776104dd$var$right;

});

parcelRegister("4p4Yq", function(module, exports) {
"use strict";
var $334d5ae4bc2d03d3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $334d5ae4bc2d03d3$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $334d5ae4bc2d03d3$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $334d5ae4bc2d03d3$var$__createBinding(result, mod, k);
    }
    $334d5ae4bc2d03d3$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wiltDefault = $334d5ae4bc2d03d3$var$wiltDefault;
module.exports.witherDefault = $334d5ae4bc2d03d3$var$witherDefault;
module.exports.filterE = $334d5ae4bc2d03d3$var$filterE;

var $334d5ae4bc2d03d3$var$_ = $334d5ae4bc2d03d3$var$__importStar((parcelRequire("704qB")));
function $334d5ae4bc2d03d3$var$wiltDefault(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.separate);
        };
    };
}
function $334d5ae4bc2d03d3$var$witherDefault(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.compact);
        };
    };
}
function $334d5ae4bc2d03d3$var$filterE(W) {
    return function(F) {
        var witherF = W.wither(F);
        return function(predicate) {
            return function(ga) {
                return witherF(ga, function(a) {
                    return F.map(predicate(a), function(b) {
                        return b ? $334d5ae4bc2d03d3$var$_.some(a) : $334d5ae4bc2d03d3$var$_.none;
                    });
                });
            };
        };
    };
}

});


parcelRegister("9I22g", function(module, exports) {
"use strict";
var $7119cd4fb128d574$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7119cd4fb128d574$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7119cd4fb128d574$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7119cd4fb128d574$var$__createBinding(result, mod, k);
    }
    $7119cd4fb128d574$var$__setModuleDefault(result, mod);
    return result;
};
var $7119cd4fb128d574$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reduceRightWithIndex = module.exports.reduceRight = module.exports.reduceWithIndex = module.exports.reduce = module.exports.mapWithIndex = module.exports.map = module.exports.flatten = module.exports.duplicate = module.exports.extend = module.exports.flatMap = module.exports.ap = module.exports.alt = module.exports.altW = module.exports.chunksOf = module.exports.splitAt = module.exports.chop = module.exports.chainWithIndex = module.exports.foldMap = module.exports.foldMapWithIndex = module.exports.intersperse = module.exports.prependAll = module.exports.unzip = module.exports.zipWith = module.exports.of = module.exports.copy = module.exports.modifyAt = module.exports.updateAt = module.exports.insertAt = module.exports.sort = module.exports.groupBy = module.exports.reverse = module.exports.unappend = module.exports.unprepend = module.exports.range = module.exports.replicate = module.exports.makeBy = module.exports.fromArray = module.exports.fromReadonlyNonEmptyArray = module.exports.rotate = module.exports.union = module.exports.sortBy = module.exports.uniq = module.exports.unsafeUpdateAt = module.exports.unsafeInsertAt = module.exports.append = module.exports.appendW = module.exports.prepend = module.exports.prependW = module.exports.isOutOfBound = module.exports.isNonEmpty = void 0;
module.exports.snoc = module.exports.unsnoc = module.exports.uncons = module.exports.filterWithIndex = module.exports.chain = module.exports.intercalate = module.exports.updateLast = module.exports.modifyLast = module.exports.updateHead = module.exports.modifyHead = module.exports.matchRight = module.exports.matchLeft = module.exports.concatAll = module.exports.max = module.exports.min = module.exports.init = module.exports.last = module.exports.tail = module.exports.head = module.exports.apS = module.exports.bind = module.exports.let = module.exports.bindTo = module.exports.Do = module.exports.Comonad = module.exports.Alt = module.exports.TraversableWithIndex = module.exports.Traversable = module.exports.FoldableWithIndex = module.exports.Foldable = module.exports.Monad = module.exports.chainFirst = module.exports.Chain = module.exports.Applicative = module.exports.apSecond = module.exports.apFirst = module.exports.Apply = module.exports.FunctorWithIndex = module.exports.Pointed = module.exports.flap = module.exports.Functor = module.exports.getUnionSemigroup = module.exports.getEq = module.exports.getSemigroup = module.exports.getShow = module.exports.URI = module.exports.extract = module.exports.traverseWithIndex = module.exports.sequence = module.exports.traverse = void 0;
module.exports.nonEmptyArray = module.exports.fold = module.exports.prependToAll = void 0;
module.exports.concatW = $7119cd4fb128d574$var$concatW;
module.exports.concat = $7119cd4fb128d574$var$concat;
module.exports.group = $7119cd4fb128d574$var$group;
module.exports.zip = $7119cd4fb128d574$var$zip;
module.exports.groupSort = $7119cd4fb128d574$var$groupSort;
module.exports.filter = $7119cd4fb128d574$var$filter;
module.exports.cons = $7119cd4fb128d574$var$cons;

var $4sfjE = parcelRequire("4sfjE");

var $ERVGH = parcelRequire("ERVGH");

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");

var $7119cd4fb128d574$var$_ = $7119cd4fb128d574$var$__importStar((parcelRequire("704qB")));

var $e51aV = parcelRequire("e51aV");

var $7119cd4fb128d574$var$RNEA = $7119cd4fb128d574$var$__importStar((parcelRequire("bKKbt")));
// -------------------------------------------------------------------------------------
// internal
// -------------------------------------------------------------------------------------
/**
 * @internal
 */ var $7119cd4fb128d574$var$isNonEmpty = function(as) {
    return as.length > 0;
};
module.exports.isNonEmpty = $7119cd4fb128d574$var$isNonEmpty;
/**
 * @internal
 */ var $7119cd4fb128d574$var$isOutOfBound = function(i, as) {
    return i < 0 || i >= as.length;
};
module.exports.isOutOfBound = $7119cd4fb128d574$var$isOutOfBound;
/**
 * @internal
 */ var $7119cd4fb128d574$var$prependW = function(head) {
    return function(tail) {
        return $7119cd4fb128d574$var$__spreadArray([
            head
        ], tail, true);
    };
};
module.exports.prependW = $7119cd4fb128d574$var$prependW;
/**
 * @internal
 */ module.exports.prepend = module.exports.prependW;
/**
 * @internal
 */ var $7119cd4fb128d574$var$appendW = function(end) {
    return function(init) {
        return $7119cd4fb128d574$var$__spreadArray($7119cd4fb128d574$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
module.exports.appendW = $7119cd4fb128d574$var$appendW;
/**
 * @internal
 */ module.exports.append = module.exports.appendW;
/**
 * @internal
 */ var $7119cd4fb128d574$var$unsafeInsertAt = function(i, a, as) {
    if ((0, module.exports.isNonEmpty)(as)) {
        var xs = (0, module.exports.fromReadonlyNonEmptyArray)(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
module.exports.unsafeInsertAt = $7119cd4fb128d574$var$unsafeInsertAt;
/**
 * @internal
 */ var $7119cd4fb128d574$var$unsafeUpdateAt = function(i, a, as) {
    var xs = (0, module.exports.fromReadonlyNonEmptyArray)(as);
    xs[i] = a;
    return xs;
};
module.exports.unsafeUpdateAt = $7119cd4fb128d574$var$unsafeUpdateAt;
/**
 * Remove duplicates from a `NonEmptyArray`, keeping the first occurrence of an element.
 *
 * @example
 * import { uniq } from 'fp-ts/NonEmptyArray'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(uniq(N.Eq)([1, 2, 1]), [1, 2])
 *
 * @since 2.11.0
 */ var $7119cd4fb128d574$var$uniq = function(E) {
    return function(as) {
        if (as.length === 1) return (0, module.exports.copy)(as);
        var out = [
            (0, module.exports.head)(as)
        ];
        var rest = (0, module.exports.tail)(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
module.exports.uniq = $7119cd4fb128d574$var$uniq;
/**
 * Sort the elements of a `NonEmptyArray` in increasing order, where elements are compared using first `ords[0]`, then `ords[1]`,
 * etc...
 *
 * @example
 * import * as NEA from 'fp-ts/NonEmptyArray'
 * import { contramap } from 'fp-ts/Ord'
 * import * as S from 'fp-ts/string'
 * import * as N from 'fp-ts/number'
 * import { pipe } from 'fp-ts/function'
 *
 * interface Person {
 *   name: string
 *   age: number
 * }
 *
 * const byName = pipe(S.Ord, contramap((p: Person) => p.name))
 *
 * const byAge = pipe(N.Ord, contramap((p: Person) => p.age))
 *
 * const sortByNameByAge = NEA.sortBy([byName, byAge])
 *
 * const persons: NEA.NonEmptyArray<Person> = [
 *   { name: 'a', age: 1 },
 *   { name: 'b', age: 3 },
 *   { name: 'c', age: 2 },
 *   { name: 'b', age: 2 }
 * ]
 *
 * assert.deepStrictEqual(sortByNameByAge(persons), [
 *   { name: 'a', age: 1 },
 *   { name: 'b', age: 2 },
 *   { name: 'b', age: 3 },
 *   { name: 'c', age: 2 }
 * ])
 *
 * @since 2.11.0
 */ var $7119cd4fb128d574$var$sortBy = function(ords) {
    if ((0, module.exports.isNonEmpty)(ords)) {
        var M = (0, $e51aV.getMonoid)();
        return (0, module.exports.sort)(ords.reduce(M.concat, M.empty));
    }
    return module.exports.copy;
};
module.exports.sortBy = $7119cd4fb128d574$var$sortBy;
/**
 * @since 2.11.0
 */ var $7119cd4fb128d574$var$union = function(E) {
    var uniqE = (0, module.exports.uniq)(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $3abDJ.pipe)(first, $7119cd4fb128d574$var$concat(second)));
        };
    };
};
module.exports.union = $7119cd4fb128d574$var$union;
/**
 * Rotate a `NonEmptyArray` by `n` steps.
 *
 * @example
 * import { rotate } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(rotate(2)([1, 2, 3, 4, 5]), [4, 5, 1, 2, 3])
 * assert.deepStrictEqual(rotate(-2)([1, 2, 3, 4, 5]), [3, 4, 5, 1, 2])
 *
 * @since 2.11.0
 */ var $7119cd4fb128d574$var$rotate = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ((0, module.exports.isOutOfBound)(Math.abs(m), as) || m === 0) return (0, module.exports.copy)(as);
        if (m < 0) {
            var _a = (0, module.exports.splitAt)(-m)(as), f = _a[0], s = _a[1];
            return (0, $3abDJ.pipe)(s, $7119cd4fb128d574$var$concat(f));
        } else return (0, module.exports.rotate)(m - len)(as);
    };
};
module.exports.rotate = $7119cd4fb128d574$var$rotate;
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category conversions
 * @since 2.10.0
 */ module.exports.fromReadonlyNonEmptyArray = $7119cd4fb128d574$var$_.fromReadonlyNonEmptyArray;
/**
 * Builds a `NonEmptyArray` from an `Array` returning `none` if `as` is an empty array
 *
 * @category conversions
 * @since 2.0.0
 */ var $7119cd4fb128d574$var$fromArray = function(as) {
    return (0, module.exports.isNonEmpty)(as) ? $7119cd4fb128d574$var$_.some(as) : $7119cd4fb128d574$var$_.none;
};
module.exports.fromArray = $7119cd4fb128d574$var$fromArray;
/**
 * Return a `NonEmptyArray` of length `n` with element `i` initialized with `f(i)`.
 *
 * **Note**. `n` is normalized to a natural number.
 *
 * @example
 * import { makeBy } from 'fp-ts/NonEmptyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * const double = (n: number): number => n * 2
 * assert.deepStrictEqual(pipe(5, makeBy(double)), [0, 2, 4, 6, 8])
 *
 * @category constructors
 * @since 2.11.0
 */ var $7119cd4fb128d574$var$makeBy = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
module.exports.makeBy = $7119cd4fb128d574$var$makeBy;
/**
 * Create a `NonEmptyArray` containing a value repeated the specified number of times.
 *
 * **Note**. `n` is normalized to a natural number.
 *
 * @example
 * import { replicate } from 'fp-ts/NonEmptyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe(3, replicate('a')), ['a', 'a', 'a'])
 *
 * @category constructors
 * @since 2.11.0
 */ var $7119cd4fb128d574$var$replicate = function(a) {
    return (0, module.exports.makeBy)(function() {
        return a;
    });
};
module.exports.replicate = $7119cd4fb128d574$var$replicate;
/**
 * Create a `NonEmptyArray` containing a range of integers, including both endpoints.
 *
 * @example
 * import { range } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(range(1, 5), [1, 2, 3, 4, 5])
 *
 * @category constructors
 * @since 2.11.0
 */ var $7119cd4fb128d574$var$range = function(start, end) {
    return start <= end ? (0, module.exports.makeBy)(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
module.exports.range = $7119cd4fb128d574$var$range;
/**
 * Return the tuple of the `head` and the `tail`.
 *
 * @example
 * import { unprepend } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(unprepend([1, 2, 3]), [1, [2, 3]])
 *
 * @since 2.9.0
 */ var $7119cd4fb128d574$var$unprepend = function(as) {
    return [
        (0, module.exports.head)(as),
        (0, module.exports.tail)(as)
    ];
};
module.exports.unprepend = $7119cd4fb128d574$var$unprepend;
/**
 * Return the tuple of the `init` and the `last`.
 *
 * @example
 * import { unappend } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(unappend([1, 2, 3, 4]), [[1, 2, 3], 4])
 *
 * @since 2.9.0
 */ var $7119cd4fb128d574$var$unappend = function(as) {
    return [
        (0, module.exports.init)(as),
        (0, module.exports.last)(as)
    ];
};
module.exports.unappend = $7119cd4fb128d574$var$unappend;
function $7119cd4fb128d574$var$concatW(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $7119cd4fb128d574$var$concat(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
/**
 * @since 2.0.0
 */ var $7119cd4fb128d574$var$reverse = function(as) {
    return $7119cd4fb128d574$var$__spreadArray([
        (0, module.exports.last)(as)
    ], as.slice(0, -1).reverse(), true);
};
module.exports.reverse = $7119cd4fb128d574$var$reverse;
function $7119cd4fb128d574$var$group(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return [];
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
/**
 * Splits an array into sub-non-empty-arrays stored in an object, based on the result of calling a `string`-returning
 * function on each element, and grouping the results according to values returned
 *
 * @example
 * import { groupBy } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(groupBy((s: string) => String(s.length))(['a', 'b', 'ab']), {
 *   '1': ['a', 'b'],
 *   '2': ['ab']
 * })
 *
 * @since 2.0.0
 */ var $7119cd4fb128d574$var$groupBy = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($7119cd4fb128d574$var$_.has.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
module.exports.groupBy = $7119cd4fb128d574$var$groupBy;
/**
 * @since 2.0.0
 */ var $7119cd4fb128d574$var$sort = function(O) {
    return function(as) {
        return as.slice().sort(O.compare);
    };
};
module.exports.sort = $7119cd4fb128d574$var$sort;
/**
 * @since 2.0.0
 */ var $7119cd4fb128d574$var$insertAt = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $7119cd4fb128d574$var$_.none : $7119cd4fb128d574$var$_.some((0, module.exports.unsafeInsertAt)(i, a, as));
    };
};
module.exports.insertAt = $7119cd4fb128d574$var$insertAt;
/**
 * @since 2.0.0
 */ var $7119cd4fb128d574$var$updateAt = function(i, a) {
    return (0, module.exports.modifyAt)(i, function() {
        return a;
    });
};
module.exports.updateAt = $7119cd4fb128d574$var$updateAt;
/**
 * @since 2.0.0
 */ var $7119cd4fb128d574$var$modifyAt = function(i, f) {
    return function(as) {
        return (0, module.exports.isOutOfBound)(i, as) ? $7119cd4fb128d574$var$_.none : $7119cd4fb128d574$var$_.some((0, module.exports.unsafeUpdateAt)(i, f(as[i]), as));
    };
};
module.exports.modifyAt = $7119cd4fb128d574$var$modifyAt;
/**
 * @since 2.0.0
 */ module.exports.copy = module.exports.fromReadonlyNonEmptyArray;
/**
 * @category constructors
 * @since 2.0.0
 */ var $7119cd4fb128d574$var$of = function(a) {
    return [
        a
    ];
};
module.exports.of = $7119cd4fb128d574$var$of;
/**
 * @since 2.5.1
 */ var $7119cd4fb128d574$var$zipWith = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
module.exports.zipWith = $7119cd4fb128d574$var$zipWith;
function $7119cd4fb128d574$var$zip(as, bs) {
    if (bs === undefined) return function(bs) {
        return $7119cd4fb128d574$var$zip(bs, as);
    };
    return (0, module.exports.zipWith)(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
/**
 * @since 2.5.1
 */ var $7119cd4fb128d574$var$unzip = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
module.exports.unzip = $7119cd4fb128d574$var$unzip;
/**
 * Prepend an element to every member of an array
 *
 * @example
 * import { prependAll } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(prependAll(9)([1, 2, 3, 4]), [9, 1, 9, 2, 9, 3, 9, 4])
 *
 * @since 2.10.0
 */ var $7119cd4fb128d574$var$prependAll = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
module.exports.prependAll = $7119cd4fb128d574$var$prependAll;
/**
 * Places an element in between members of an array
 *
 * @example
 * import { intersperse } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(intersperse(9)([1, 2, 3, 4]), [1, 9, 2, 9, 3, 9, 4])
 *
 * @since 2.9.0
 */ var $7119cd4fb128d574$var$intersperse = function(middle) {
    return function(as) {
        var rest = (0, module.exports.tail)(as);
        return (0, module.exports.isNonEmpty)(rest) ? (0, $3abDJ.pipe)(rest, (0, module.exports.prependAll)(middle), (0, module.exports.prepend)((0, module.exports.head)(as))) : (0, module.exports.copy)(as);
    };
};
module.exports.intersperse = $7119cd4fb128d574$var$intersperse;
/**
 * @category folding
 * @since 2.0.0
 */ module.exports.foldMapWithIndex = $7119cd4fb128d574$var$RNEA.foldMapWithIndex;
/**
 * @category folding
 * @since 2.0.0
 */ module.exports.foldMap = $7119cd4fb128d574$var$RNEA.foldMap;
/**
 * @category sequencing
 * @since 2.10.0
 */ var $7119cd4fb128d574$var$chainWithIndex = function(f) {
    return function(as) {
        var out = (0, module.exports.fromReadonlyNonEmptyArray)(f(0, (0, module.exports.head)(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
module.exports.chainWithIndex = $7119cd4fb128d574$var$chainWithIndex;
/**
 * @since 2.10.0
 */ var $7119cd4fb128d574$var$chop = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while((0, module.exports.isNonEmpty)(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
module.exports.chop = $7119cd4fb128d574$var$chop;
/**
 * Splits a `NonEmptyArray` into two pieces, the first piece has max `n` elements.
 *
 * @since 2.10.0
 */ var $7119cd4fb128d574$var$splitAt = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            (0, module.exports.copy)(as),
            []
        ] : [
            (0, $3abDJ.pipe)(as.slice(1, m), (0, module.exports.prepend)((0, module.exports.head)(as))),
            as.slice(m)
        ];
    };
};
module.exports.splitAt = $7119cd4fb128d574$var$splitAt;
/**
 * @since 2.10.0
 */ var $7119cd4fb128d574$var$chunksOf = function(n) {
    return (0, module.exports.chop)((0, module.exports.splitAt)(n));
};
module.exports.chunksOf = $7119cd4fb128d574$var$chunksOf;
/* istanbul ignore next */ var $7119cd4fb128d574$var$_map = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.map)(f));
};
/* istanbul ignore next */ var $7119cd4fb128d574$var$_mapWithIndex = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.mapWithIndex)(f));
};
/* istanbul ignore next */ var $7119cd4fb128d574$var$_ap = function(fab, fa) {
    return (0, $3abDJ.pipe)(fab, (0, module.exports.ap)(fa));
};
/* istanbul ignore next */ var $7119cd4fb128d574$var$_extend = function(wa, f) {
    return (0, $3abDJ.pipe)(wa, (0, module.exports.extend)(f));
};
/* istanbul ignore next */ var $7119cd4fb128d574$var$_reduce = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduce)(b, f));
};
/* istanbul ignore next */ var $7119cd4fb128d574$var$_foldMap = function(M) {
    var foldMapM = (0, module.exports.foldMap)(M);
    return function(fa, f) {
        return (0, $3abDJ.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $7119cd4fb128d574$var$_reduceRight = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduceRight)(b, f));
};
/* istanbul ignore next */ var $7119cd4fb128d574$var$_traverse = function(F) {
    var traverseF = (0, module.exports.traverse)(F);
    return function(ta, f) {
        return (0, $3abDJ.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $7119cd4fb128d574$var$_alt = function(fa, that) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.alt)(that));
};
/* istanbul ignore next */ var $7119cd4fb128d574$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduceWithIndex)(b, f));
};
/* istanbul ignore next */ var $7119cd4fb128d574$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = (0, module.exports.foldMapWithIndex)(M);
    return function(fa, f) {
        return (0, $3abDJ.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $7119cd4fb128d574$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduceRightWithIndex)(b, f));
};
/* istanbul ignore next */ var $7119cd4fb128d574$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = (0, module.exports.traverseWithIndex)(F);
    return function(ta, f) {
        return (0, $3abDJ.pipe)(ta, traverseWithIndexF(f));
    };
};
/**
 * Less strict version of [`alt`](#alt).
 *
 * The `W` suffix (short for **W**idening) means that the return types will be merged.
 *
 * @example
 * import * as NEA from 'fp-ts/NonEmptyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3] as NEA.NonEmptyArray<number>,
 *     NEA.altW(() => ['a', 'b'])
 *   ),
 *   [1, 2, 3, 'a', 'b']
 * )
 *
 * @category error handling
 * @since 2.9.0
 */ var $7119cd4fb128d574$var$altW = function(that) {
    return function(as) {
        return (0, $3abDJ.pipe)(as, $7119cd4fb128d574$var$concatW(that()));
    };
};
module.exports.altW = $7119cd4fb128d574$var$altW;
/**
 * Identifies an associative operation on a type constructor. It is similar to `Semigroup`, except that it applies to
 * types of kind `* -> *`.
 *
 * In case of `NonEmptyArray` concatenates the inputs into a single array.
 *
 * @example
 * import * as NEA from 'fp-ts/NonEmptyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3],
 *     NEA.alt(() => [4, 5])
 *   ),
 *   [1, 2, 3, 4, 5]
 * )
 *
 * @category error handling
 * @since 2.6.2
 */ module.exports.alt = module.exports.altW;
/**
 * Apply a function to an argument under a type constructor.
 *
 * @since 2.0.0
 */ var $7119cd4fb128d574$var$ap = function(as) {
    return (0, module.exports.flatMap)(function(f) {
        return (0, $3abDJ.pipe)(as, (0, module.exports.map)(f));
    });
};
module.exports.ap = $7119cd4fb128d574$var$ap;
/**
 * @example
 * import * as NEA from 'fp-ts/NonEmptyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3],
 *     NEA.flatMap((n) => [`a${n}`, `b${n}`])
 *   ),
 *   ['a1', 'b1', 'a2', 'b2', 'a3', 'b3']
 * )
 *
 * @category sequencing
 * @since 2.14.0
 */ module.exports.flatMap = (0, $3abDJ.dual)(2, function(ma, f) {
    return (0, $3abDJ.pipe)(ma, (0, module.exports.chainWithIndex)(function(i, a) {
        return f(a, i);
    }));
});
/**
 * @since 2.0.0
 */ var $7119cd4fb128d574$var$extend = function(f) {
    return function(as) {
        var next = (0, module.exports.tail)(as);
        var out = [
            f(as)
        ];
        while((0, module.exports.isNonEmpty)(next)){
            out.push(f(next));
            next = (0, module.exports.tail)(next);
        }
        return out;
    };
};
module.exports.extend = $7119cd4fb128d574$var$extend;
/**
 * @since 2.5.0
 */ module.exports.duplicate = (0, module.exports.extend)($3abDJ.identity);
/**
 * @category sequencing
 * @since 2.5.0
 */ module.exports.flatten = (0, module.exports.flatMap)($3abDJ.identity);
/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
 * use the type constructor `F` to represent some computational context.
 *
 * @category mapping
 * @since 2.0.0
 */ var $7119cd4fb128d574$var$map = function(f) {
    return (0, module.exports.mapWithIndex)(function(_, a) {
        return f(a);
    });
};
module.exports.map = $7119cd4fb128d574$var$map;
/**
 * @category mapping
 * @since 2.0.0
 */ var $7119cd4fb128d574$var$mapWithIndex = function(f) {
    return function(as) {
        var out = [
            f(0, (0, module.exports.head)(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
module.exports.mapWithIndex = $7119cd4fb128d574$var$mapWithIndex;
/**
 * @category folding
 * @since 2.0.0
 */ module.exports.reduce = $7119cd4fb128d574$var$RNEA.reduce;
/**
 * @category folding
 * @since 2.0.0
 */ module.exports.reduceWithIndex = $7119cd4fb128d574$var$RNEA.reduceWithIndex;
/**
 * @category folding
 * @since 2.0.0
 */ module.exports.reduceRight = $7119cd4fb128d574$var$RNEA.reduceRight;
/**
 * @category folding
 * @since 2.0.0
 */ module.exports.reduceRightWithIndex = $7119cd4fb128d574$var$RNEA.reduceRightWithIndex;
/**
 * @category traversing
 * @since 2.6.3
 */ var $7119cd4fb128d574$var$traverse = function(F) {
    var traverseWithIndexF = (0, module.exports.traverseWithIndex)(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
module.exports.traverse = $7119cd4fb128d574$var$traverse;
/**
 * @category traversing
 * @since 2.6.3
 */ var $7119cd4fb128d574$var$sequence = function(F) {
    return (0, module.exports.traverseWithIndex)(F)(function(_, a) {
        return a;
    });
};
module.exports.sequence = $7119cd4fb128d574$var$sequence;
/**
 * @category sequencing
 * @since 2.6.3
 */ var $7119cd4fb128d574$var$traverseWithIndex = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, (0, module.exports.head)(as)), module.exports.of);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $3abDJ.pipe)(bs, (0, module.exports.append)(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
module.exports.traverseWithIndex = $7119cd4fb128d574$var$traverseWithIndex;
/**
 * @since 2.7.0
 */ module.exports.extract = $7119cd4fb128d574$var$RNEA.head;
/**
 * @category type lambdas
 * @since 2.0.0
 */ module.exports.URI = 'NonEmptyArray';
/**
 * @category instances
 * @since 2.0.0
 */ module.exports.getShow = $7119cd4fb128d574$var$RNEA.getShow;
/**
 * Builds a `Semigroup` instance for `NonEmptyArray`
 *
 * @category instances
 * @since 2.0.0
 */ var $7119cd4fb128d574$var$getSemigroup = function() {
    return {
        concat: $7119cd4fb128d574$var$concat
    };
};
module.exports.getSemigroup = $7119cd4fb128d574$var$getSemigroup;
/**
 * @example
 * import { getEq } from 'fp-ts/NonEmptyArray'
 * import * as N from 'fp-ts/number'
 *
 * const E = getEq(N.Eq)
 * assert.strictEqual(E.equals([1, 2], [1, 2]), true)
 * assert.strictEqual(E.equals([1, 2], [1, 3]), false)
 *
 * @category instances
 * @since 2.0.0
 */ module.exports.getEq = $7119cd4fb128d574$var$RNEA.getEq;
/**
 * @since 2.11.0
 */ var $7119cd4fb128d574$var$getUnionSemigroup = function(E) {
    var unionE = (0, module.exports.union)(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
module.exports.getUnionSemigroup = $7119cd4fb128d574$var$getUnionSemigroup;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Functor = {
    URI: module.exports.URI,
    map: $7119cd4fb128d574$var$_map
};
/**
 * @category mapping
 * @since 2.10.0
 */ module.exports.flap = (0, $emm1u.flap)(module.exports.Functor);
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Pointed = {
    URI: module.exports.URI,
    of: module.exports.of
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.FunctorWithIndex = {
    URI: module.exports.URI,
    map: $7119cd4fb128d574$var$_map,
    mapWithIndex: $7119cd4fb128d574$var$_mapWithIndex
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Apply = {
    URI: module.exports.URI,
    map: $7119cd4fb128d574$var$_map,
    ap: $7119cd4fb128d574$var$_ap
};
/**
 * Combine two effectful actions, keeping only the result of the first.
 *
 * @since 2.5.0
 */ module.exports.apFirst = (0, $4sfjE.apFirst)(module.exports.Apply);
/**
 * Combine two effectful actions, keeping only the result of the second.
 *
 * @since 2.5.0
 */ module.exports.apSecond = (0, $4sfjE.apSecond)(module.exports.Apply);
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Applicative = {
    URI: module.exports.URI,
    map: $7119cd4fb128d574$var$_map,
    ap: $7119cd4fb128d574$var$_ap,
    of: module.exports.of
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Chain = {
    URI: module.exports.URI,
    map: $7119cd4fb128d574$var$_map,
    ap: $7119cd4fb128d574$var$_ap,
    chain: module.exports.flatMap
};
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * @category sequencing
 * @since 2.5.0
 */ module.exports.chainFirst = /*#__PURE__*/ (0, $ERVGH.chainFirst)(module.exports.Chain);
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Monad = {
    URI: module.exports.URI,
    map: $7119cd4fb128d574$var$_map,
    ap: $7119cd4fb128d574$var$_ap,
    of: module.exports.of,
    chain: module.exports.flatMap
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Foldable = {
    URI: module.exports.URI,
    reduce: $7119cd4fb128d574$var$_reduce,
    foldMap: $7119cd4fb128d574$var$_foldMap,
    reduceRight: $7119cd4fb128d574$var$_reduceRight
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.FoldableWithIndex = {
    URI: module.exports.URI,
    reduce: $7119cd4fb128d574$var$_reduce,
    foldMap: $7119cd4fb128d574$var$_foldMap,
    reduceRight: $7119cd4fb128d574$var$_reduceRight,
    reduceWithIndex: $7119cd4fb128d574$var$_reduceWithIndex,
    foldMapWithIndex: $7119cd4fb128d574$var$_foldMapWithIndex,
    reduceRightWithIndex: $7119cd4fb128d574$var$_reduceRightWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Traversable = {
    URI: module.exports.URI,
    map: $7119cd4fb128d574$var$_map,
    reduce: $7119cd4fb128d574$var$_reduce,
    foldMap: $7119cd4fb128d574$var$_foldMap,
    reduceRight: $7119cd4fb128d574$var$_reduceRight,
    traverse: $7119cd4fb128d574$var$_traverse,
    sequence: module.exports.sequence
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.TraversableWithIndex = {
    URI: module.exports.URI,
    map: $7119cd4fb128d574$var$_map,
    mapWithIndex: $7119cd4fb128d574$var$_mapWithIndex,
    reduce: $7119cd4fb128d574$var$_reduce,
    foldMap: $7119cd4fb128d574$var$_foldMap,
    reduceRight: $7119cd4fb128d574$var$_reduceRight,
    traverse: $7119cd4fb128d574$var$_traverse,
    sequence: module.exports.sequence,
    reduceWithIndex: $7119cd4fb128d574$var$_reduceWithIndex,
    foldMapWithIndex: $7119cd4fb128d574$var$_foldMapWithIndex,
    reduceRightWithIndex: $7119cd4fb128d574$var$_reduceRightWithIndex,
    traverseWithIndex: $7119cd4fb128d574$var$_traverseWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Alt = {
    URI: module.exports.URI,
    map: $7119cd4fb128d574$var$_map,
    alt: $7119cd4fb128d574$var$_alt
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Comonad = {
    URI: module.exports.URI,
    map: $7119cd4fb128d574$var$_map,
    extend: $7119cd4fb128d574$var$_extend,
    extract: module.exports.extract
};
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * @category do notation
 * @since 2.9.0
 */ module.exports.Do = (0, module.exports.of)($7119cd4fb128d574$var$_.emptyRecord);
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.bindTo = (0, $emm1u.bindTo)(module.exports.Functor);
var $7119cd4fb128d574$var$let_ = /*#__PURE__*/ (0, $emm1u.let)(module.exports.Functor);
module.exports.let = $7119cd4fb128d574$var$let_;
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.bind = (0, $ERVGH.bind)(module.exports.Chain);
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.apS = (0, $4sfjE.apS)(module.exports.Apply);
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * @since 2.0.0
 */ module.exports.head = $7119cd4fb128d574$var$RNEA.head;
/**
 * @since 2.0.0
 */ var $7119cd4fb128d574$var$tail = function(as) {
    return as.slice(1);
};
module.exports.tail = $7119cd4fb128d574$var$tail;
/**
 * @since 2.0.0
 */ module.exports.last = $7119cd4fb128d574$var$RNEA.last;
/**
 * Get all but the last element of a non empty array, creating a new array.
 *
 * @example
 * import { init } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(init([1, 2, 3]), [1, 2])
 * assert.deepStrictEqual(init([1]), [])
 *
 * @since 2.2.0
 */ var $7119cd4fb128d574$var$init = function(as) {
    return as.slice(0, -1);
};
module.exports.init = $7119cd4fb128d574$var$init;
/**
 * @since 2.0.0
 */ module.exports.min = $7119cd4fb128d574$var$RNEA.min;
/**
 * @since 2.0.0
 */ module.exports.max = $7119cd4fb128d574$var$RNEA.max;
/**
 * @since 2.10.0
 */ var $7119cd4fb128d574$var$concatAll = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
module.exports.concatAll = $7119cd4fb128d574$var$concatAll;
/**
 * Break an `Array` into its first element and remaining elements.
 *
 * @category pattern matching
 * @since 2.11.0
 */ var $7119cd4fb128d574$var$matchLeft = function(f) {
    return function(as) {
        return f((0, module.exports.head)(as), (0, module.exports.tail)(as));
    };
};
module.exports.matchLeft = $7119cd4fb128d574$var$matchLeft;
/**
 * Break an `Array` into its initial elements and the last element.
 *
 * @category pattern matching
 * @since 2.11.0
 */ var $7119cd4fb128d574$var$matchRight = function(f) {
    return function(as) {
        return f((0, module.exports.init)(as), (0, module.exports.last)(as));
    };
};
module.exports.matchRight = $7119cd4fb128d574$var$matchRight;
/**
 * Apply a function to the head, creating a new `NonEmptyArray`.
 *
 * @since 2.11.0
 */ var $7119cd4fb128d574$var$modifyHead = function(f) {
    return function(as) {
        return $7119cd4fb128d574$var$__spreadArray([
            f((0, module.exports.head)(as))
        ], (0, module.exports.tail)(as), true);
    };
};
module.exports.modifyHead = $7119cd4fb128d574$var$modifyHead;
/**
 * Change the head, creating a new `NonEmptyArray`.
 *
 * @since 2.11.0
 */ var $7119cd4fb128d574$var$updateHead = function(a) {
    return (0, module.exports.modifyHead)(function() {
        return a;
    });
};
module.exports.updateHead = $7119cd4fb128d574$var$updateHead;
/**
 * Apply a function to the last element, creating a new `NonEmptyArray`.
 *
 * @since 2.11.0
 */ var $7119cd4fb128d574$var$modifyLast = function(f) {
    return function(as) {
        return (0, $3abDJ.pipe)((0, module.exports.init)(as), (0, module.exports.append)(f((0, module.exports.last)(as))));
    };
};
module.exports.modifyLast = $7119cd4fb128d574$var$modifyLast;
/**
 * Change the last element, creating a new `NonEmptyArray`.
 *
 * @since 2.11.0
 */ var $7119cd4fb128d574$var$updateLast = function(a) {
    return (0, module.exports.modifyLast)(function() {
        return a;
    });
};
module.exports.updateLast = $7119cd4fb128d574$var$updateLast;
/**
 * Places an element in between members of a `NonEmptyArray`, then folds the results using the provided `Semigroup`.
 *
 * @example
 * import * as S from 'fp-ts/string'
 * import { intercalate } from 'fp-ts/NonEmptyArray'
 *
 * assert.deepStrictEqual(intercalate(S.Semigroup)('-')(['a', 'b', 'c']), 'a-b-c')
 *
 * @since 2.12.0
 */ module.exports.intercalate = $7119cd4fb128d574$var$RNEA.intercalate;
// -------------------------------------------------------------------------------------
// legacy
// -------------------------------------------------------------------------------------
/**
 * Alias of `flatMap`.
 *
 * @category legacy
 * @since 2.0.0
 */ module.exports.chain = module.exports.flatMap;
function $7119cd4fb128d574$var$groupSort(O) {
    var sortO = (0, module.exports.sort)(O);
    var groupO = $7119cd4fb128d574$var$group(O);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? groupO(sortO(as)) : [];
    };
}
function $7119cd4fb128d574$var$filter(predicate) {
    return (0, module.exports.filterWithIndex)(function(_, a) {
        return predicate(a);
    });
}
/**
 * Use [`filterWithIndex`](./Array.ts.html#filterwithindex) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ var $7119cd4fb128d574$var$filterWithIndex = function(predicate) {
    return function(as) {
        return (0, module.exports.fromArray)(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
module.exports.filterWithIndex = $7119cd4fb128d574$var$filterWithIndex;
/**
 * Use [`unprepend`](#unprepend) instead.
 *
 * @category zone of death
 * @since 2.9.0
 * @deprecated
 */ module.exports.uncons = module.exports.unprepend;
/**
 * Use [`unappend`](#unappend) instead.
 *
 * @category zone of death
 * @since 2.9.0
 * @deprecated
 */ module.exports.unsnoc = module.exports.unappend;
function $7119cd4fb128d574$var$cons(head, tail) {
    return tail === undefined ? (0, module.exports.prepend)(head) : (0, $3abDJ.pipe)(tail, (0, module.exports.prepend)(head));
}
/**
 * Use [`append`](./Array.ts.html#append) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ var $7119cd4fb128d574$var$snoc = function(init, end) {
    return (0, $3abDJ.pipe)(init, (0, module.exports.append)(end));
};
module.exports.snoc = $7119cd4fb128d574$var$snoc;
/**
 * Use [`prependAll`](#prependall) instead.
 *
 * @category zone of death
 * @since 2.9.0
 * @deprecated
 */ module.exports.prependToAll = module.exports.prependAll;
/**
 * Use [`concatAll`](#concatall) instead.
 *
 * @category zone of death
 * @since 2.5.0
 * @deprecated
 */ module.exports.fold = $7119cd4fb128d574$var$RNEA.concatAll;
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Functor` instance, pass `NEA.Functor` instead of `NEA.nonEmptyArray`
 * (where `NEA` is from `import NEA from 'fp-ts/NonEmptyArray'`)
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.nonEmptyArray = {
    URI: module.exports.URI,
    of: module.exports.of,
    map: $7119cd4fb128d574$var$_map,
    mapWithIndex: $7119cd4fb128d574$var$_mapWithIndex,
    ap: $7119cd4fb128d574$var$_ap,
    chain: module.exports.flatMap,
    extend: $7119cd4fb128d574$var$_extend,
    extract: module.exports.extract,
    reduce: $7119cd4fb128d574$var$_reduce,
    foldMap: $7119cd4fb128d574$var$_foldMap,
    reduceRight: $7119cd4fb128d574$var$_reduceRight,
    traverse: $7119cd4fb128d574$var$_traverse,
    sequence: module.exports.sequence,
    reduceWithIndex: $7119cd4fb128d574$var$_reduceWithIndex,
    foldMapWithIndex: $7119cd4fb128d574$var$_foldMapWithIndex,
    reduceRightWithIndex: $7119cd4fb128d574$var$_reduceRightWithIndex,
    traverseWithIndex: $7119cd4fb128d574$var$_traverseWithIndex,
    alt: $7119cd4fb128d574$var$_alt
};

});
parcelRegister("e51aV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ordDate = module.exports.ordNumber = module.exports.ordString = module.exports.ordBoolean = module.exports.ord = module.exports.getDualOrd = module.exports.getTupleOrd = module.exports.between = module.exports.clamp = module.exports.max = module.exports.min = module.exports.geq = module.exports.leq = module.exports.gt = module.exports.lt = module.exports.equals = module.exports.trivial = module.exports.Contravariant = module.exports.getMonoid = module.exports.getSemigroup = module.exports.URI = module.exports.contramap = module.exports.reverse = module.exports.tuple = module.exports.fromCompare = module.exports.equalsDefault = void 0;

var $5Ikl1 = parcelRequire("5Ikl1");

var $3abDJ = parcelRequire("3abDJ");
// -------------------------------------------------------------------------------------
// defaults
// -------------------------------------------------------------------------------------
/**
 * @category defaults
 * @since 2.10.0
 */ var $a40271b21a72ea64$var$equalsDefault = function(compare) {
    return function(first, second) {
        return first === second || compare(first, second) === 0;
    };
};
module.exports.equalsDefault = $a40271b21a72ea64$var$equalsDefault;
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.0.0
 */ var $a40271b21a72ea64$var$fromCompare = function(compare) {
    return {
        equals: (0, module.exports.equalsDefault)(compare),
        compare: function(first, second) {
            return first === second ? 0 : compare(first, second);
        }
    };
};
module.exports.fromCompare = $a40271b21a72ea64$var$fromCompare;
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * Given a tuple of `Ord`s returns an `Ord` for the tuple.
 *
 * @example
 * import { tuple } from 'fp-ts/Ord'
 * import * as B from 'fp-ts/boolean'
 * import * as S from 'fp-ts/string'
 * import * as N from 'fp-ts/number'
 *
 * const O = tuple(S.Ord, N.Ord, B.Ord)
 * assert.strictEqual(O.compare(['a', 1, true], ['b', 2, true]), -1)
 * assert.strictEqual(O.compare(['a', 1, true], ['a', 2, true]), -1)
 * assert.strictEqual(O.compare(['a', 1, true], ['a', 1, false]), 1)
 *
 * @since 2.10.0
 */ var $a40271b21a72ea64$var$tuple = function() {
    var ords = [];
    for(var _i = 0; _i < arguments.length; _i++)ords[_i] = arguments[_i];
    return (0, module.exports.fromCompare)(function(first, second) {
        var i = 0;
        for(; i < ords.length - 1; i++){
            var r = ords[i].compare(first[i], second[i]);
            if (r !== 0) return r;
        }
        return ords[i].compare(first[i], second[i]);
    });
};
module.exports.tuple = $a40271b21a72ea64$var$tuple;
/**
 * @since 2.10.0
 */ var $a40271b21a72ea64$var$reverse = function(O) {
    return (0, module.exports.fromCompare)(function(first, second) {
        return O.compare(second, first);
    });
};
module.exports.reverse = $a40271b21a72ea64$var$reverse;
/* istanbul ignore next */ var $a40271b21a72ea64$var$contramap_ = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.contramap)(f));
};
/**
 * A typical use case for `contramap` would be like, given some `User` type, to construct an `Ord<User>`.
 *
 * We can do so with a function from `User -> X` where `X` is some value that we know how to compare
 * for ordering (meaning we have an `Ord<X>`)
 *
 * For example, given the following `User` type, there are lots of possible choices for `X`,
 * but let's say we want to sort a list of users by `lastName`.
 *
 * If we have a way of comparing `lastName`s for ordering (`ordLastName: Ord<string>`) and we know how to go from `User -> string`,
 * using `contramap` we can do this
 *
 * @example
 * import { pipe } from 'fp-ts/function'
 * import { contramap, Ord } from 'fp-ts/Ord'
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import * as S from 'fp-ts/string'
 *
 * interface User {
 *   readonly firstName: string
 *   readonly lastName: string
 * }
 *
 * const ordLastName: Ord<string> = S.Ord
 *
 * const ordByLastName: Ord<User> = pipe(
 *   ordLastName,
 *   contramap((user) => user.lastName)
 * )
 *
 * assert.deepStrictEqual(
 *   RA.sort(ordByLastName)([
 *     { firstName: 'a', lastName: 'd' },
 *     { firstName: 'c', lastName: 'b' }
 *   ]),
 *   [
 *     { firstName: 'c', lastName: 'b' },
 *     { firstName: 'a', lastName: 'd' }
 *   ]
 * )
 *
 * @since 2.0.0
 */ var $a40271b21a72ea64$var$contramap = function(f) {
    return function(fa) {
        return (0, module.exports.fromCompare)(function(first, second) {
            return fa.compare(f(first), f(second));
        });
    };
};
module.exports.contramap = $a40271b21a72ea64$var$contramap;
/**
 * @category type lambdas
 * @since 2.0.0
 */ module.exports.URI = 'Ord';
/**
 * A typical use case for the `Semigroup` instance of `Ord` is merging two or more orderings.
 *
 * For example the following snippet builds an `Ord` for a type `User` which
 * sorts by `created` date descending, and **then** `lastName`
 *
 * @example
 * import * as D from 'fp-ts/Date'
 * import { pipe } from 'fp-ts/function'
 * import { contramap, getSemigroup, Ord, reverse } from 'fp-ts/Ord'
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import * as S from 'fp-ts/string'
 *
 * interface User {
 *   readonly id: string
 *   readonly lastName: string
 *   readonly created: Date
 * }
 *
 * const ordByLastName: Ord<User> = pipe(
 *   S.Ord,
 *   contramap((user) => user.lastName)
 * )
 *
 * const ordByCreated: Ord<User> = pipe(
 *   D.Ord,
 *   contramap((user) => user.created)
 * )
 *
 * const ordUserByCreatedDescThenLastName = getSemigroup<User>().concat(
 *   reverse(ordByCreated),
 *   ordByLastName
 * )
 *
 * assert.deepStrictEqual(
 *   RA.sort(ordUserByCreatedDescThenLastName)([
 *     { id: 'c', lastName: 'd', created: new Date(1973, 10, 30) },
 *     { id: 'a', lastName: 'b', created: new Date(1973, 10, 30) },
 *     { id: 'e', lastName: 'f', created: new Date(1980, 10, 30) }
 *   ]),
 *   [
 *     { id: 'e', lastName: 'f', created: new Date(1980, 10, 30) },
 *     { id: 'a', lastName: 'b', created: new Date(1973, 10, 30) },
 *     { id: 'c', lastName: 'd', created: new Date(1973, 10, 30) }
 *   ]
 * )
 *
 * @category instances
 * @since 2.0.0
 */ var $a40271b21a72ea64$var$getSemigroup = function() {
    return {
        concat: function(first, second) {
            return (0, module.exports.fromCompare)(function(a, b) {
                var ox = first.compare(a, b);
                return ox !== 0 ? ox : second.compare(a, b);
            });
        }
    };
};
module.exports.getSemigroup = $a40271b21a72ea64$var$getSemigroup;
/**
 * Returns a `Monoid` such that:
 *
 * - its `concat(ord1, ord2)` operation will order first by `ord1`, and then by `ord2`
 * - its `empty` value is an `Ord` that always considers compared elements equal
 *
 * @example
 * import { sort } from 'fp-ts/Array'
 * import { contramap, reverse, getMonoid } from 'fp-ts/Ord'
 * import * as S from 'fp-ts/string'
 * import * as B from 'fp-ts/boolean'
 * import { pipe } from 'fp-ts/function'
 * import { concatAll } from 'fp-ts/Monoid'
 * import * as N from 'fp-ts/number'
 *
 * interface User {
 *   readonly id: number
 *   readonly name: string
 *   readonly age: number
 *   readonly rememberMe: boolean
 * }
 *
 * const byName = pipe(
 *   S.Ord,
 *   contramap((p: User) => p.name)
 * )
 *
 * const byAge = pipe(
 *   N.Ord,
 *   contramap((p: User) => p.age)
 * )
 *
 * const byRememberMe = pipe(
 *   B.Ord,
 *   contramap((p: User) => p.rememberMe)
 * )
 *
 * const M = getMonoid<User>()
 *
 * const users: Array<User> = [
 *   { id: 1, name: 'Guido', age: 47, rememberMe: false },
 *   { id: 2, name: 'Guido', age: 46, rememberMe: true },
 *   { id: 3, name: 'Giulio', age: 44, rememberMe: false },
 *   { id: 4, name: 'Giulio', age: 44, rememberMe: true }
 * ]
 *
 * // sort by name, then by age, then by `rememberMe`
 * const O1 = concatAll(M)([byName, byAge, byRememberMe])
 * assert.deepStrictEqual(sort(O1)(users), [
 *   { id: 3, name: 'Giulio', age: 44, rememberMe: false },
 *   { id: 4, name: 'Giulio', age: 44, rememberMe: true },
 *   { id: 2, name: 'Guido', age: 46, rememberMe: true },
 *   { id: 1, name: 'Guido', age: 47, rememberMe: false }
 * ])
 *
 * // now `rememberMe = true` first, then by name, then by age
 * const O2 = concatAll(M)([reverse(byRememberMe), byName, byAge])
 * assert.deepStrictEqual(sort(O2)(users), [
 *   { id: 4, name: 'Giulio', age: 44, rememberMe: true },
 *   { id: 2, name: 'Guido', age: 46, rememberMe: true },
 *   { id: 3, name: 'Giulio', age: 44, rememberMe: false },
 *   { id: 1, name: 'Guido', age: 47, rememberMe: false }
 * ])
 *
 * @category instances
 * @since 2.4.0
 */ var $a40271b21a72ea64$var$getMonoid = function() {
    return {
        concat: (0, module.exports.getSemigroup)().concat,
        empty: (0, module.exports.fromCompare)(function() {
            return 0;
        })
    };
};
module.exports.getMonoid = $a40271b21a72ea64$var$getMonoid;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Contravariant = {
    URI: module.exports.URI,
    contramap: $a40271b21a72ea64$var$contramap_
};
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * @since 2.11.0
 */ module.exports.trivial = {
    equals: $3abDJ.constTrue,
    compare: /*#__PURE__*/ (0, $3abDJ.constant)(0)
};
/**
 * @since 2.11.0
 */ var $a40271b21a72ea64$var$equals = function(O) {
    return function(second) {
        return function(first) {
            return first === second || O.compare(first, second) === 0;
        };
    };
};
module.exports.equals = $a40271b21a72ea64$var$equals;
// TODO: curry in v3
/**
 * Test whether one value is _strictly less than_ another
 *
 * @since 2.0.0
 */ var $a40271b21a72ea64$var$lt = function(O) {
    return function(first, second) {
        return O.compare(first, second) === -1;
    };
};
module.exports.lt = $a40271b21a72ea64$var$lt;
// TODO: curry in v3
/**
 * Test whether one value is _strictly greater than_ another
 *
 * @since 2.0.0
 */ var $a40271b21a72ea64$var$gt = function(O) {
    return function(first, second) {
        return O.compare(first, second) === 1;
    };
};
module.exports.gt = $a40271b21a72ea64$var$gt;
// TODO: curry in v3
/**
 * Test whether one value is _non-strictly less than_ another
 *
 * @since 2.0.0
 */ var $a40271b21a72ea64$var$leq = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== 1;
    };
};
module.exports.leq = $a40271b21a72ea64$var$leq;
// TODO: curry in v3
/**
 * Test whether one value is _non-strictly greater than_ another
 *
 * @since 2.0.0
 */ var $a40271b21a72ea64$var$geq = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== -1;
    };
};
module.exports.geq = $a40271b21a72ea64$var$geq;
// TODO: curry in v3
/**
 * Take the minimum of two values. If they are considered equal, the first argument is chosen
 *
 * @since 2.0.0
 */ var $a40271b21a72ea64$var$min = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) < 1 ? first : second;
    };
};
module.exports.min = $a40271b21a72ea64$var$min;
// TODO: curry in v3
/**
 * Take the maximum of two values. If they are considered equal, the first argument is chosen
 *
 * @since 2.0.0
 */ var $a40271b21a72ea64$var$max = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) > -1 ? first : second;
    };
};
module.exports.max = $a40271b21a72ea64$var$max;
/**
 * Clamp a value between a minimum and a maximum
 *
 * @since 2.0.0
 */ var $a40271b21a72ea64$var$clamp = function(O) {
    var minO = (0, module.exports.min)(O);
    var maxO = (0, module.exports.max)(O);
    return function(low, hi) {
        return function(a) {
            return maxO(minO(a, hi), low);
        };
    };
};
module.exports.clamp = $a40271b21a72ea64$var$clamp;
/**
 * Test whether a value is between a minimum and a maximum (inclusive)
 *
 * @since 2.0.0
 */ var $a40271b21a72ea64$var$between = function(O) {
    var ltO = (0, module.exports.lt)(O);
    var gtO = (0, module.exports.gt)(O);
    return function(low, hi) {
        return function(a) {
            return ltO(a, low) || gtO(a, hi) ? false : true;
        };
    };
};
module.exports.between = $a40271b21a72ea64$var$between;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * Use [`tuple`](#tuple) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getTupleOrd = module.exports.tuple;
/**
 * Use [`reverse`](#reverse) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getDualOrd = module.exports.reverse;
/**
 * Use [`Contravariant`](#contravariant) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.ord = module.exports.Contravariant;
// default compare for primitive types
function $a40271b21a72ea64$var$compare(first, second) {
    return first < second ? -1 : first > second ? 1 : 0;
}
var $a40271b21a72ea64$var$strictOrd = {
    equals: $5Ikl1.eqStrict.equals,
    compare: $a40271b21a72ea64$var$compare
};
/**
 * Use [`Ord`](./boolean.ts.html#ord) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.ordBoolean = $a40271b21a72ea64$var$strictOrd;
/**
 * Use [`Ord`](./string.ts.html#ord) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.ordString = $a40271b21a72ea64$var$strictOrd;
/**
 * Use [`Ord`](./number.ts.html#ord) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.ordNumber = $a40271b21a72ea64$var$strictOrd;
/**
 * Use [`Ord`](./Date.ts.html#ord) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.ordDate = (0, $3abDJ.pipe)(module.exports.ordNumber, /*#__PURE__*/ (0, module.exports.contramap)(function(date) {
    return date.valueOf();
}));

});
parcelRegister("5Ikl1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.eqDate = module.exports.eqNumber = module.exports.eqString = module.exports.eqBoolean = module.exports.eq = module.exports.strictEqual = module.exports.getStructEq = module.exports.getTupleEq = module.exports.Contravariant = module.exports.getMonoid = module.exports.getSemigroup = module.exports.eqStrict = module.exports.URI = module.exports.contramap = module.exports.tuple = module.exports.struct = module.exports.fromEquals = void 0;

var $3abDJ = parcelRequire("3abDJ");
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.0.0
 */ var $4290d68a0b795162$var$fromEquals = function(equals) {
    return {
        equals: function(x, y) {
            return x === y || equals(x, y);
        }
    };
};
module.exports.fromEquals = $4290d68a0b795162$var$fromEquals;
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @since 2.10.0
 */ var $4290d68a0b795162$var$struct = function(eqs) {
    return (0, module.exports.fromEquals)(function(first, second) {
        for(var key in eqs){
            if (!eqs[key].equals(first[key], second[key])) return false;
        }
        return true;
    });
};
module.exports.struct = $4290d68a0b795162$var$struct;
/**
 * Given a tuple of `Eq`s returns a `Eq` for the tuple
 *
 * @example
 * import { tuple } from 'fp-ts/Eq'
 * import * as S from 'fp-ts/string'
 * import * as N from 'fp-ts/number'
 * import * as B from 'fp-ts/boolean'
 *
 * const E = tuple(S.Eq, N.Eq, B.Eq)
 * assert.strictEqual(E.equals(['a', 1, true], ['a', 1, true]), true)
 * assert.strictEqual(E.equals(['a', 1, true], ['b', 1, true]), false)
 * assert.strictEqual(E.equals(['a', 1, true], ['a', 2, true]), false)
 * assert.strictEqual(E.equals(['a', 1, true], ['a', 1, false]), false)
 *
 * @since 2.10.0
 */ var $4290d68a0b795162$var$tuple = function() {
    var eqs = [];
    for(var _i = 0; _i < arguments.length; _i++)eqs[_i] = arguments[_i];
    return (0, module.exports.fromEquals)(function(first, second) {
        return eqs.every(function(E, i) {
            return E.equals(first[i], second[i]);
        });
    });
};
module.exports.tuple = $4290d68a0b795162$var$tuple;
/* istanbul ignore next */ var $4290d68a0b795162$var$contramap_ = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.contramap)(f));
};
/**
 * A typical use case for `contramap` would be like, given some `User` type, to construct an `Eq<User>`.
 *
 * We can do so with a function from `User -> X` where `X` is some value that we know how to compare
 * for equality (meaning we have an `Eq<X>`)
 *
 * For example, given the following `User` type, we want to construct an `Eq<User>` that just looks at the `key` field
 * for each user (since it's known to be unique).
 *
 * If we have a way of comparing `UUID`s for equality (`eqUUID: Eq<UUID>`) and we know how to go from `User -> UUID`,
 * using `contramap` we can do this
 *
 * @example
 * import { contramap, Eq } from 'fp-ts/Eq'
 * import { pipe } from 'fp-ts/function'
 * import * as S from 'fp-ts/string'
 *
 * type UUID = string
 *
 * interface User {
 *   readonly key: UUID
 *   readonly firstName: string
 *   readonly lastName: string
 * }
 *
 * const eqUUID: Eq<UUID> = S.Eq
 *
 * const eqUserByKey: Eq<User> = pipe(
 *   eqUUID,
 *   contramap((user) => user.key)
 * )
 *
 * assert.deepStrictEqual(
 *   eqUserByKey.equals(
 *     { key: 'k1', firstName: 'a1', lastName: 'b1' },
 *     { key: 'k2', firstName: 'a1', lastName: 'b1' }
 *   ),
 *   false
 * )
 * assert.deepStrictEqual(
 *   eqUserByKey.equals(
 *     { key: 'k1', firstName: 'a1', lastName: 'b1' },
 *     { key: 'k1', firstName: 'a2', lastName: 'b1' }
 *   ),
 *   true
 * )
 *
 * @since 2.0.0
 */ var $4290d68a0b795162$var$contramap = function(f) {
    return function(fa) {
        return (0, module.exports.fromEquals)(function(x, y) {
            return fa.equals(f(x), f(y));
        });
    };
};
module.exports.contramap = $4290d68a0b795162$var$contramap;
/**
 * @category type lambdas
 * @since 2.0.0
 */ module.exports.URI = 'Eq';
/**
 * @category instances
 * @since 2.5.0
 */ module.exports.eqStrict = {
    equals: function(a, b) {
        return a === b;
    }
};
var $4290d68a0b795162$var$empty = {
    equals: function() {
        return true;
    }
};
/**
 * @category instances
 * @since 2.10.0
 */ var $4290d68a0b795162$var$getSemigroup = function() {
    return {
        concat: function(x, y) {
            return (0, module.exports.fromEquals)(function(a, b) {
                return x.equals(a, b) && y.equals(a, b);
            });
        }
    };
};
module.exports.getSemigroup = $4290d68a0b795162$var$getSemigroup;
/**
 * @category instances
 * @since 2.6.0
 */ var $4290d68a0b795162$var$getMonoid = function() {
    return {
        concat: (0, module.exports.getSemigroup)().concat,
        empty: $4290d68a0b795162$var$empty
    };
};
module.exports.getMonoid = $4290d68a0b795162$var$getMonoid;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Contravariant = {
    URI: module.exports.URI,
    contramap: $4290d68a0b795162$var$contramap_
};
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * Use [`tuple`](#tuple) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getTupleEq = module.exports.tuple;
/**
 * Use [`struct`](#struct) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getStructEq = module.exports.struct;
/**
 * Use [`eqStrict`](#eqstrict) instead
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.strictEqual = module.exports.eqStrict.equals;
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Contravariant` instance, pass `E.Contravariant` instead of `E.eq`
 * (where `E` is from `import E from 'fp-ts/Eq'`)
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.eq = module.exports.Contravariant;
/**
 * Use [`Eq`](./boolean.ts.html#eq) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.eqBoolean = module.exports.eqStrict;
/**
 * Use [`Eq`](./string.ts.html#eq) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.eqString = module.exports.eqStrict;
/**
 * Use [`Eq`](./number.ts.html#eq) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.eqNumber = module.exports.eqStrict;
/**
 * Use [`Eq`](./Date.ts.html#eq) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.eqDate = {
    equals: function(first, second) {
        return first.valueOf() === second.valueOf();
    }
};

});


parcelRegister("bKKbt", function(module, exports) {
"use strict";
var $88e7d0c5193e4968$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $88e7d0c5193e4968$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $88e7d0c5193e4968$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $88e7d0c5193e4968$var$__createBinding(result, mod, k);
    }
    $88e7d0c5193e4968$var$__setModuleDefault(result, mod);
    return result;
};
var $88e7d0c5193e4968$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.traverse = module.exports.reduceRightWithIndex = module.exports.foldMapWithIndex = module.exports.reduceWithIndex = module.exports.reduceRight = module.exports.foldMap = module.exports.reduce = module.exports.mapWithIndex = module.exports.map = module.exports.flatten = module.exports.duplicate = module.exports.extend = module.exports.flatMap = module.exports.ap = module.exports.alt = module.exports.altW = module.exports.of = module.exports.chunksOf = module.exports.splitAt = module.exports.chop = module.exports.chainWithIndex = module.exports.intersperse = module.exports.prependAll = module.exports.unzip = module.exports.zipWith = module.exports.modifyAt = module.exports.updateAt = module.exports.sort = module.exports.groupBy = module.exports.reverse = module.exports.fromArray = module.exports.unappend = module.exports.unprepend = module.exports.range = module.exports.replicate = module.exports.makeBy = module.exports.fromReadonlyArray = module.exports.rotate = module.exports.union = module.exports.sortBy = module.exports.uniq = module.exports.unsafeUpdateAt = module.exports.unsafeInsertAt = module.exports.append = module.exports.appendW = module.exports.prepend = module.exports.prependW = module.exports.isOutOfBound = module.exports.isNonEmpty = module.exports.empty = void 0;
module.exports.insertAt = module.exports.snoc = module.exports.unsnoc = module.exports.uncons = module.exports.filterWithIndex = module.exports.chain = module.exports.intercalate = module.exports.updateLast = module.exports.modifyLast = module.exports.updateHead = module.exports.modifyHead = module.exports.matchRight = module.exports.matchLeft = module.exports.concatAll = module.exports.max = module.exports.min = module.exports.init = module.exports.last = module.exports.tail = module.exports.head = module.exports.apS = module.exports.bind = module.exports.let = module.exports.bindTo = module.exports.Do = module.exports.Comonad = module.exports.Alt = module.exports.TraversableWithIndex = module.exports.Traversable = module.exports.FoldableWithIndex = module.exports.Foldable = module.exports.Monad = module.exports.chainFirst = module.exports.Chain = module.exports.Applicative = module.exports.apSecond = module.exports.apFirst = module.exports.Apply = module.exports.FunctorWithIndex = module.exports.Pointed = module.exports.flap = module.exports.Functor = module.exports.getUnionSemigroup = module.exports.getEq = module.exports.getSemigroup = module.exports.getShow = module.exports.URI = module.exports.extract = module.exports.traverseWithIndex = module.exports.sequence = void 0;
module.exports.readonlyNonEmptyArray = module.exports.fold = module.exports.prependToAll = void 0;
module.exports.concatW = $88e7d0c5193e4968$var$concatW;
module.exports.concat = $88e7d0c5193e4968$var$concat;
module.exports.group = $88e7d0c5193e4968$var$group;
module.exports.zip = $88e7d0c5193e4968$var$zip;
module.exports.groupSort = $88e7d0c5193e4968$var$groupSort;
module.exports.filter = $88e7d0c5193e4968$var$filter;
module.exports.cons = $88e7d0c5193e4968$var$cons;

var $4sfjE = parcelRequire("4sfjE");

var $ERVGH = parcelRequire("ERVGH");

var $5Ikl1 = parcelRequire("5Ikl1");

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");

var $88e7d0c5193e4968$var$_ = $88e7d0c5193e4968$var$__importStar((parcelRequire("704qB")));

var $e51aV = parcelRequire("e51aV");

var $88e7d0c5193e4968$var$Se = $88e7d0c5193e4968$var$__importStar((parcelRequire("3OUuJ")));
// -------------------------------------------------------------------------------------
// internal
// -------------------------------------------------------------------------------------
/**
 * @internal
 */ module.exports.empty = $88e7d0c5193e4968$var$_.emptyReadonlyArray;
/**
 * @internal
 */ module.exports.isNonEmpty = $88e7d0c5193e4968$var$_.isNonEmpty;
/**
 * @internal
 */ var $88e7d0c5193e4968$var$isOutOfBound = function(i, as) {
    return i < 0 || i >= as.length;
};
module.exports.isOutOfBound = $88e7d0c5193e4968$var$isOutOfBound;
/**
 * @internal
 */ var $88e7d0c5193e4968$var$prependW = function(head) {
    return function(tail) {
        return $88e7d0c5193e4968$var$__spreadArray([
            head
        ], tail, true);
    };
};
module.exports.prependW = $88e7d0c5193e4968$var$prependW;
/**
 * @internal
 */ module.exports.prepend = module.exports.prependW;
/**
 * @internal
 */ var $88e7d0c5193e4968$var$appendW = function(end) {
    return function(init) {
        return $88e7d0c5193e4968$var$__spreadArray($88e7d0c5193e4968$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
module.exports.appendW = $88e7d0c5193e4968$var$appendW;
/**
 * @internal
 */ module.exports.append = module.exports.appendW;
/**
 * @internal
 */ var $88e7d0c5193e4968$var$unsafeInsertAt = function(i, a, as) {
    if ((0, module.exports.isNonEmpty)(as)) {
        var xs = $88e7d0c5193e4968$var$_.fromReadonlyNonEmptyArray(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
module.exports.unsafeInsertAt = $88e7d0c5193e4968$var$unsafeInsertAt;
/**
 * @internal
 */ var $88e7d0c5193e4968$var$unsafeUpdateAt = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $88e7d0c5193e4968$var$_.fromReadonlyNonEmptyArray(as);
        xs[i] = a;
        return xs;
    }
};
module.exports.unsafeUpdateAt = $88e7d0c5193e4968$var$unsafeUpdateAt;
/**
 * Remove duplicates from a `ReadonlyNonEmptyArray`, keeping the first occurrence of an element.
 *
 * @example
 * import { uniq } from 'fp-ts/ReadonlyNonEmptyArray'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(uniq(N.Eq)([1, 2, 1]), [1, 2])
 *
 * @since 2.11.0
 */ var $88e7d0c5193e4968$var$uniq = function(E) {
    return function(as) {
        if (as.length === 1) return as;
        var out = [
            (0, module.exports.head)(as)
        ];
        var rest = (0, module.exports.tail)(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
module.exports.uniq = $88e7d0c5193e4968$var$uniq;
/**
 * Sort the elements of a `ReadonlyNonEmptyArray` in increasing order, where elements are compared using first `ords[0]`, then `ords[1]`,
 * etc...
 *
 * @example
 * import * as RNEA from 'fp-ts/ReadonlyNonEmptyArray'
 * import { contramap } from 'fp-ts/Ord'
 * import * as S from 'fp-ts/string'
 * import * as N from 'fp-ts/number'
 * import { pipe } from 'fp-ts/function'
 *
 * interface Person {
 *   name: string
 *   age: number
 * }
 *
 * const byName = pipe(S.Ord, contramap((p: Person) => p.name))
 *
 * const byAge = pipe(N.Ord, contramap((p: Person) => p.age))
 *
 * const sortByNameByAge = RNEA.sortBy([byName, byAge])
 *
 * const persons: RNEA.ReadonlyNonEmptyArray<Person> = [
 *   { name: 'a', age: 1 },
 *   { name: 'b', age: 3 },
 *   { name: 'c', age: 2 },
 *   { name: 'b', age: 2 }
 * ]
 *
 * assert.deepStrictEqual(sortByNameByAge(persons), [
 *   { name: 'a', age: 1 },
 *   { name: 'b', age: 2 },
 *   { name: 'b', age: 3 },
 *   { name: 'c', age: 2 }
 * ])
 *
 * @since 2.11.0
 */ var $88e7d0c5193e4968$var$sortBy = function(ords) {
    if ((0, module.exports.isNonEmpty)(ords)) {
        var M = (0, $e51aV.getMonoid)();
        return (0, module.exports.sort)(ords.reduce(M.concat, M.empty));
    }
    return $3abDJ.identity;
};
module.exports.sortBy = $88e7d0c5193e4968$var$sortBy;
/**
 * @since 2.11.0
 */ var $88e7d0c5193e4968$var$union = function(E) {
    var uniqE = (0, module.exports.uniq)(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $3abDJ.pipe)(first, $88e7d0c5193e4968$var$concat(second)));
        };
    };
};
module.exports.union = $88e7d0c5193e4968$var$union;
/**
 * Rotate a `ReadonlyNonEmptyArray` by `n` steps.
 *
 * @example
 * import { rotate } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(rotate(2)([1, 2, 3, 4, 5]), [4, 5, 1, 2, 3])
 * assert.deepStrictEqual(rotate(-2)([1, 2, 3, 4, 5]), [3, 4, 5, 1, 2])
 *
 * @since 2.11.0
 */ var $88e7d0c5193e4968$var$rotate = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ((0, module.exports.isOutOfBound)(Math.abs(m), as) || m === 0) return as;
        if (m < 0) {
            var _a = (0, module.exports.splitAt)(-m)(as), f = _a[0], s = _a[1];
            return (0, $3abDJ.pipe)(s, $88e7d0c5193e4968$var$concat(f));
        } else return (0, module.exports.rotate)(m - len)(as);
    };
};
module.exports.rotate = $88e7d0c5193e4968$var$rotate;
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * Return a `ReadonlyNonEmptyArray` from a `ReadonlyArray` returning `none` if the input is empty.
 *
 * @category conversions
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$fromReadonlyArray = function(as) {
    return (0, module.exports.isNonEmpty)(as) ? $88e7d0c5193e4968$var$_.some(as) : $88e7d0c5193e4968$var$_.none;
};
module.exports.fromReadonlyArray = $88e7d0c5193e4968$var$fromReadonlyArray;
/**
 * Return a `ReadonlyNonEmptyArray` of length `n` with element `i` initialized with `f(i)`.
 *
 * **Note**. `n` is normalized to a natural number.
 *
 * @example
 * import { makeBy } from 'fp-ts/ReadonlyNonEmptyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * const double = (n: number): number => n * 2
 * assert.deepStrictEqual(pipe(5, makeBy(double)), [0, 2, 4, 6, 8])
 *
 * @category constructors
 * @since 2.11.0
 */ var $88e7d0c5193e4968$var$makeBy = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
module.exports.makeBy = $88e7d0c5193e4968$var$makeBy;
/**
 * Create a `ReadonlyNonEmptyArray` containing a value repeated the specified number of times.
 *
 * **Note**. `n` is normalized to a natural number.
 *
 * @example
 * import { replicate } from 'fp-ts/ReadonlyNonEmptyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe(3, replicate('a')), ['a', 'a', 'a'])
 *
 * @category constructors
 * @since 2.11.0
 */ var $88e7d0c5193e4968$var$replicate = function(a) {
    return (0, module.exports.makeBy)(function() {
        return a;
    });
};
module.exports.replicate = $88e7d0c5193e4968$var$replicate;
/**
 * Create a `ReadonlyNonEmptyArray` containing a range of integers, including both endpoints.
 *
 * @example
 * import { range } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(range(1, 5), [1, 2, 3, 4, 5])
 *
 * @category constructors
 * @since 2.11.0
 */ var $88e7d0c5193e4968$var$range = function(start, end) {
    return start <= end ? (0, module.exports.makeBy)(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
module.exports.range = $88e7d0c5193e4968$var$range;
/**
 * Return the tuple of the `head` and the `tail`.
 *
 * @example
 * import { unprepend } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(unprepend([1, 2, 3, 4]), [1, [2, 3, 4]])
 *
 * @since 2.9.0
 */ var $88e7d0c5193e4968$var$unprepend = function(as) {
    return [
        (0, module.exports.head)(as),
        (0, module.exports.tail)(as)
    ];
};
module.exports.unprepend = $88e7d0c5193e4968$var$unprepend;
/**
 * Return the tuple of the `init` and the `last`.
 *
 * @example
 * import { unappend } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(unappend([1, 2, 3, 4]), [[1, 2, 3], 4])
 *
 * @since 2.9.0
 */ var $88e7d0c5193e4968$var$unappend = function(as) {
    return [
        (0, module.exports.init)(as),
        (0, module.exports.last)(as)
    ];
};
module.exports.unappend = $88e7d0c5193e4968$var$unappend;
/**
 * @category conversions
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$fromArray = function(as) {
    return (0, module.exports.fromReadonlyArray)(as.slice());
};
module.exports.fromArray = $88e7d0c5193e4968$var$fromArray;
function $88e7d0c5193e4968$var$concatW(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $88e7d0c5193e4968$var$concat(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
/**
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$reverse = function(as) {
    return as.length === 1 ? as : $88e7d0c5193e4968$var$__spreadArray([
        (0, module.exports.last)(as)
    ], as.slice(0, -1).reverse(), true);
};
module.exports.reverse = $88e7d0c5193e4968$var$reverse;
function $88e7d0c5193e4968$var$group(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return module.exports.empty;
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
/**
 * Splits an array into sub-non-empty-arrays stored in an object, based on the result of calling a `string`-returning
 * function on each element, and grouping the results according to values returned
 *
 * @example
 * import { groupBy } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(groupBy((s: string) => String(s.length))(['a', 'b', 'ab']), {
 *   '1': ['a', 'b'],
 *   '2': ['ab']
 * })
 *
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$groupBy = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($88e7d0c5193e4968$var$_.has.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
module.exports.groupBy = $88e7d0c5193e4968$var$groupBy;
/**
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$sort = function(O) {
    return function(as) {
        return as.length === 1 ? as : as.slice().sort(O.compare);
    };
};
module.exports.sort = $88e7d0c5193e4968$var$sort;
/**
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$updateAt = function(i, a) {
    return (0, module.exports.modifyAt)(i, function() {
        return a;
    });
};
module.exports.updateAt = $88e7d0c5193e4968$var$updateAt;
/**
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$modifyAt = function(i, f) {
    return function(as) {
        return (0, module.exports.isOutOfBound)(i, as) ? $88e7d0c5193e4968$var$_.none : $88e7d0c5193e4968$var$_.some((0, module.exports.unsafeUpdateAt)(i, f(as[i]), as));
    };
};
module.exports.modifyAt = $88e7d0c5193e4968$var$modifyAt;
/**
 * @since 2.5.1
 */ var $88e7d0c5193e4968$var$zipWith = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
module.exports.zipWith = $88e7d0c5193e4968$var$zipWith;
function $88e7d0c5193e4968$var$zip(as, bs) {
    if (bs === undefined) return function(bs) {
        return $88e7d0c5193e4968$var$zip(bs, as);
    };
    return (0, module.exports.zipWith)(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
/**
 * @since 2.5.1
 */ var $88e7d0c5193e4968$var$unzip = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
module.exports.unzip = $88e7d0c5193e4968$var$unzip;
/**
 * Prepend an element to every member of a `ReadonlyNonEmptyArray`.
 *
 * @example
 * import { prependAll } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(prependAll(9)([1, 2, 3, 4]), [9, 1, 9, 2, 9, 3, 9, 4])
 *
 * @since 2.10.0
 */ var $88e7d0c5193e4968$var$prependAll = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
module.exports.prependAll = $88e7d0c5193e4968$var$prependAll;
/**
 * Places an element in between members of a `ReadonlyNonEmptyArray`.
 *
 * @example
 * import { intersperse } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(intersperse(9)([1, 2, 3, 4]), [1, 9, 2, 9, 3, 9, 4])
 *
 * @since 2.9.0
 */ var $88e7d0c5193e4968$var$intersperse = function(middle) {
    return function(as) {
        var rest = (0, module.exports.tail)(as);
        return (0, module.exports.isNonEmpty)(rest) ? (0, $3abDJ.pipe)(rest, (0, module.exports.prependAll)(middle), (0, module.exports.prepend)((0, module.exports.head)(as))) : as;
    };
};
module.exports.intersperse = $88e7d0c5193e4968$var$intersperse;
/**
 * @category sequencing
 * @since 2.10.0
 */ var $88e7d0c5193e4968$var$chainWithIndex = function(f) {
    return function(as) {
        var out = $88e7d0c5193e4968$var$_.fromReadonlyNonEmptyArray(f(0, (0, module.exports.head)(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
module.exports.chainWithIndex = $88e7d0c5193e4968$var$chainWithIndex;
/**
 * A useful recursion pattern for processing a `ReadonlyNonEmptyArray` to produce a new `ReadonlyNonEmptyArray`, often used for "chopping" up the input
 * `ReadonlyNonEmptyArray`. Typically `chop` is called with some function that will consume an initial prefix of the `ReadonlyNonEmptyArray` and produce a
 * value and the tail of the `ReadonlyNonEmptyArray`.
 *
 * @since 2.10.0
 */ var $88e7d0c5193e4968$var$chop = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while((0, module.exports.isNonEmpty)(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
module.exports.chop = $88e7d0c5193e4968$var$chop;
/**
 * Splits a `ReadonlyNonEmptyArray` into two pieces, the first piece has max `n` elements.
 *
 * @since 2.10.0
 */ var $88e7d0c5193e4968$var$splitAt = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            as,
            module.exports.empty
        ] : [
            (0, $3abDJ.pipe)(as.slice(1, m), (0, module.exports.prepend)((0, module.exports.head)(as))),
            as.slice(m)
        ];
    };
};
module.exports.splitAt = $88e7d0c5193e4968$var$splitAt;
/**
 * Splits a `ReadonlyNonEmptyArray` into length-`n` pieces. The last piece will be shorter if `n` does not evenly divide the length of
 * the `ReadonlyNonEmptyArray`.
 *
 * @since 2.10.0
 */ var $88e7d0c5193e4968$var$chunksOf = function(n) {
    return (0, module.exports.chop)((0, module.exports.splitAt)(n));
};
module.exports.chunksOf = $88e7d0c5193e4968$var$chunksOf;
var $88e7d0c5193e4968$var$_map = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.map)(f));
};
/* istanbul ignore next */ var $88e7d0c5193e4968$var$_mapWithIndex = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.mapWithIndex)(f));
};
var $88e7d0c5193e4968$var$_ap = function(fab, fa) {
    return (0, $3abDJ.pipe)(fab, (0, module.exports.ap)(fa));
};
/* istanbul ignore next */ var $88e7d0c5193e4968$var$_extend = function(wa, f) {
    return (0, $3abDJ.pipe)(wa, (0, module.exports.extend)(f));
};
/* istanbul ignore next */ var $88e7d0c5193e4968$var$_reduce = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduce)(b, f));
};
/* istanbul ignore next */ var $88e7d0c5193e4968$var$_foldMap = function(M) {
    var foldMapM = (0, module.exports.foldMap)(M);
    return function(fa, f) {
        return (0, $3abDJ.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $88e7d0c5193e4968$var$_reduceRight = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduceRight)(b, f));
};
/* istanbul ignore next */ var $88e7d0c5193e4968$var$_traverse = function(F) {
    var traverseF = (0, module.exports.traverse)(F);
    return function(ta, f) {
        return (0, $3abDJ.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $88e7d0c5193e4968$var$_alt = function(fa, that) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.alt)(that));
};
/* istanbul ignore next */ var $88e7d0c5193e4968$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduceWithIndex)(b, f));
};
/* istanbul ignore next */ var $88e7d0c5193e4968$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = (0, module.exports.foldMapWithIndex)(M);
    return function(fa, f) {
        return (0, $3abDJ.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $88e7d0c5193e4968$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduceRightWithIndex)(b, f));
};
/* istanbul ignore next */ var $88e7d0c5193e4968$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = (0, module.exports.traverseWithIndex)(F);
    return function(ta, f) {
        return (0, $3abDJ.pipe)(ta, traverseWithIndexF(f));
    };
};
/**
 * @category constructors
 * @since 2.5.0
 */ module.exports.of = $88e7d0c5193e4968$var$_.singleton;
/**
 * Less strict version of [`alt`](#alt).
 *
 * The `W` suffix (short for **W**idening) means that the return types will be merged.
 *
 * @example
 * import * as RNEA from 'fp-ts/ReadonlyNonEmptyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3] as RNEA.ReadonlyNonEmptyArray<number>,
 *     RNEA.altW(() => ['a', 'b'])
 *   ),
 *   [1, 2, 3, 'a', 'b']
 * )
 *
 * @category error handling
 * @since 2.9.0
 */ var $88e7d0c5193e4968$var$altW = function(that) {
    return function(as) {
        return (0, $3abDJ.pipe)(as, $88e7d0c5193e4968$var$concatW(that()));
    };
};
module.exports.altW = $88e7d0c5193e4968$var$altW;
/**
 * Identifies an associative operation on a type constructor. It is similar to `Semigroup`, except that it applies to
 * types of kind `* -> *`.
 *
 * In case of `ReadonlyNonEmptyArray` concatenates the inputs into a single array.
 *
 * @example
 * import * as RNEA from 'fp-ts/ReadonlyNonEmptyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3],
 *     RNEA.alt(() => [4, 5])
 *   ),
 *   [1, 2, 3, 4, 5]
 * )
 *
 * @category error handling
 * @since 2.6.2
 */ module.exports.alt = module.exports.altW;
/**
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$ap = function(as) {
    return (0, module.exports.flatMap)(function(f) {
        return (0, $3abDJ.pipe)(as, (0, module.exports.map)(f));
    });
};
module.exports.ap = $88e7d0c5193e4968$var$ap;
/**
 * @example
 * import * as RNEA from 'fp-ts/ReadonlyNonEmptyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3],
 *     RNEA.flatMap((n) => [`a${n}`, `b${n}`])
 *   ),
 *   ['a1', 'b1', 'a2', 'b2', 'a3', 'b3']
 * )
 *
 * @category sequencing
 * @since 2.14.0
 */ module.exports.flatMap = (0, $3abDJ.dual)(2, function(ma, f) {
    return (0, $3abDJ.pipe)(ma, (0, module.exports.chainWithIndex)(function(i, a) {
        return f(a, i);
    }));
});
/**
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$extend = function(f) {
    return function(as) {
        var next = (0, module.exports.tail)(as);
        var out = [
            f(as)
        ];
        while((0, module.exports.isNonEmpty)(next)){
            out.push(f(next));
            next = (0, module.exports.tail)(next);
        }
        return out;
    };
};
module.exports.extend = $88e7d0c5193e4968$var$extend;
/**
 * @since 2.5.0
 */ module.exports.duplicate = /*#__PURE__*/ (0, module.exports.extend)($3abDJ.identity);
/**
 * @category sequencing
 * @since 2.5.0
 */ module.exports.flatten = /*#__PURE__*/ (0, module.exports.flatMap)($3abDJ.identity);
/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
 * use the type constructor `F` to represent some computational context.
 *
 * @category mapping
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$map = function(f) {
    return (0, module.exports.mapWithIndex)(function(_, a) {
        return f(a);
    });
};
module.exports.map = $88e7d0c5193e4968$var$map;
/**
 * @category mapping
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$mapWithIndex = function(f) {
    return function(as) {
        var out = [
            f(0, (0, module.exports.head)(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
module.exports.mapWithIndex = $88e7d0c5193e4968$var$mapWithIndex;
/**
 * @category folding
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$reduce = function(b, f) {
    return (0, module.exports.reduceWithIndex)(b, function(_, b, a) {
        return f(b, a);
    });
};
module.exports.reduce = $88e7d0c5193e4968$var$reduce;
/**
 * **Note**. The constraint is relaxed: a `Semigroup` instead of a `Monoid`.
 *
 * @category folding
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$foldMap = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a) {
                return S.concat(s, f(a));
            }, f(as[0]));
        };
    };
};
module.exports.foldMap = $88e7d0c5193e4968$var$foldMap;
/**
 * @category folding
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$reduceRight = function(b, f) {
    return (0, module.exports.reduceRightWithIndex)(b, function(_, b, a) {
        return f(b, a);
    });
};
module.exports.reduceRight = $88e7d0c5193e4968$var$reduceRight;
/**
 * @category folding
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$reduceWithIndex = function(b, f) {
    return function(as) {
        return as.reduce(function(b, a, i) {
            return f(i, b, a);
        }, b);
    };
};
module.exports.reduceWithIndex = $88e7d0c5193e4968$var$reduceWithIndex;
/**
 * **Note**. The constraint is relaxed: a `Semigroup` instead of a `Monoid`.
 *
 * @category folding
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$foldMapWithIndex = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a, i) {
                return S.concat(s, f(i + 1, a));
            }, f(0, as[0]));
        };
    };
};
module.exports.foldMapWithIndex = $88e7d0c5193e4968$var$foldMapWithIndex;
/**
 * @category folding
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$reduceRightWithIndex = function(b, f) {
    return function(as) {
        return as.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
module.exports.reduceRightWithIndex = $88e7d0c5193e4968$var$reduceRightWithIndex;
/**
 * @category traversing
 * @since 2.6.3
 */ var $88e7d0c5193e4968$var$traverse = function(F) {
    var traverseWithIndexF = (0, module.exports.traverseWithIndex)(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
module.exports.traverse = $88e7d0c5193e4968$var$traverse;
/**
 * @category traversing
 * @since 2.6.3
 */ var $88e7d0c5193e4968$var$sequence = function(F) {
    return (0, module.exports.traverseWithIndex)(F)($3abDJ.SK);
};
module.exports.sequence = $88e7d0c5193e4968$var$sequence;
/**
 * @category sequencing
 * @since 2.6.3
 */ var $88e7d0c5193e4968$var$traverseWithIndex = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, (0, module.exports.head)(as)), module.exports.of);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $3abDJ.pipe)(bs, (0, module.exports.append)(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
module.exports.traverseWithIndex = $88e7d0c5193e4968$var$traverseWithIndex;
/**
 * @category Comonad
 * @since 2.6.3
 */ module.exports.extract = $88e7d0c5193e4968$var$_.head;
/**
 * @category type lambdas
 * @since 2.5.0
 */ module.exports.URI = 'ReadonlyNonEmptyArray';
/**
 * @category instances
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$getShow = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
module.exports.getShow = $88e7d0c5193e4968$var$getShow;
/**
 * Builds a `Semigroup` instance for `ReadonlyNonEmptyArray`
 *
 * @category instances
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$getSemigroup = function() {
    return {
        concat: $88e7d0c5193e4968$var$concat
    };
};
module.exports.getSemigroup = $88e7d0c5193e4968$var$getSemigroup;
/**
 * @example
 * import { getEq } from 'fp-ts/ReadonlyNonEmptyArray'
 * import * as N from 'fp-ts/number'
 *
 * const E = getEq(N.Eq)
 * assert.strictEqual(E.equals([1, 2], [1, 2]), true)
 * assert.strictEqual(E.equals([1, 2], [1, 3]), false)
 *
 * @category instances
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$getEq = function(E) {
    return (0, $5Ikl1.fromEquals)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
module.exports.getEq = $88e7d0c5193e4968$var$getEq;
/**
 * @since 2.11.0
 */ var $88e7d0c5193e4968$var$getUnionSemigroup = function(E) {
    var unionE = (0, module.exports.union)(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
module.exports.getUnionSemigroup = $88e7d0c5193e4968$var$getUnionSemigroup;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Functor = {
    URI: module.exports.URI,
    map: $88e7d0c5193e4968$var$_map
};
/**
 * @category mapping
 * @since 2.10.0
 */ module.exports.flap = (0, $emm1u.flap)(module.exports.Functor);
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Pointed = {
    URI: module.exports.URI,
    of: module.exports.of
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.FunctorWithIndex = {
    URI: module.exports.URI,
    map: $88e7d0c5193e4968$var$_map,
    mapWithIndex: $88e7d0c5193e4968$var$_mapWithIndex
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Apply = {
    URI: module.exports.URI,
    map: $88e7d0c5193e4968$var$_map,
    ap: $88e7d0c5193e4968$var$_ap
};
/**
 * Combine two effectful actions, keeping only the result of the first.
 *
 * @since 2.5.0
 */ module.exports.apFirst = (0, $4sfjE.apFirst)(module.exports.Apply);
/**
 * Combine two effectful actions, keeping only the result of the second.
 *
 * @since 2.5.0
 */ module.exports.apSecond = (0, $4sfjE.apSecond)(module.exports.Apply);
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Applicative = {
    URI: module.exports.URI,
    map: $88e7d0c5193e4968$var$_map,
    ap: $88e7d0c5193e4968$var$_ap,
    of: module.exports.of
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Chain = {
    URI: module.exports.URI,
    map: $88e7d0c5193e4968$var$_map,
    ap: $88e7d0c5193e4968$var$_ap,
    chain: module.exports.flatMap
};
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * @example
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3],
 *     RA.chainFirst(() => ['a', 'b'])
 *   ),
 *   [1, 1, 2, 2, 3, 3]
 * )
 *
 * @category sequencing
 * @since 2.5.0
 */ module.exports.chainFirst = (0, $ERVGH.chainFirst)(module.exports.Chain);
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Monad = {
    URI: module.exports.URI,
    map: $88e7d0c5193e4968$var$_map,
    ap: $88e7d0c5193e4968$var$_ap,
    of: module.exports.of,
    chain: module.exports.flatMap
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Foldable = {
    URI: module.exports.URI,
    reduce: $88e7d0c5193e4968$var$_reduce,
    foldMap: $88e7d0c5193e4968$var$_foldMap,
    reduceRight: $88e7d0c5193e4968$var$_reduceRight
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.FoldableWithIndex = {
    URI: module.exports.URI,
    reduce: $88e7d0c5193e4968$var$_reduce,
    foldMap: $88e7d0c5193e4968$var$_foldMap,
    reduceRight: $88e7d0c5193e4968$var$_reduceRight,
    reduceWithIndex: $88e7d0c5193e4968$var$_reduceWithIndex,
    foldMapWithIndex: $88e7d0c5193e4968$var$_foldMapWithIndex,
    reduceRightWithIndex: $88e7d0c5193e4968$var$_reduceRightWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Traversable = {
    URI: module.exports.URI,
    map: $88e7d0c5193e4968$var$_map,
    reduce: $88e7d0c5193e4968$var$_reduce,
    foldMap: $88e7d0c5193e4968$var$_foldMap,
    reduceRight: $88e7d0c5193e4968$var$_reduceRight,
    traverse: $88e7d0c5193e4968$var$_traverse,
    sequence: module.exports.sequence
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.TraversableWithIndex = {
    URI: module.exports.URI,
    map: $88e7d0c5193e4968$var$_map,
    mapWithIndex: $88e7d0c5193e4968$var$_mapWithIndex,
    reduce: $88e7d0c5193e4968$var$_reduce,
    foldMap: $88e7d0c5193e4968$var$_foldMap,
    reduceRight: $88e7d0c5193e4968$var$_reduceRight,
    traverse: $88e7d0c5193e4968$var$_traverse,
    sequence: module.exports.sequence,
    reduceWithIndex: $88e7d0c5193e4968$var$_reduceWithIndex,
    foldMapWithIndex: $88e7d0c5193e4968$var$_foldMapWithIndex,
    reduceRightWithIndex: $88e7d0c5193e4968$var$_reduceRightWithIndex,
    traverseWithIndex: $88e7d0c5193e4968$var$_traverseWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Alt = {
    URI: module.exports.URI,
    map: $88e7d0c5193e4968$var$_map,
    alt: $88e7d0c5193e4968$var$_alt
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Comonad = {
    URI: module.exports.URI,
    map: $88e7d0c5193e4968$var$_map,
    extend: $88e7d0c5193e4968$var$_extend,
    extract: module.exports.extract
};
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * @category do notation
 * @since 2.9.0
 */ module.exports.Do = (0, module.exports.of)($88e7d0c5193e4968$var$_.emptyRecord);
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.bindTo = (0, $emm1u.bindTo)(module.exports.Functor);
var $88e7d0c5193e4968$var$let_ = /*#__PURE__*/ (0, $emm1u.let)(module.exports.Functor);
module.exports.let = $88e7d0c5193e4968$var$let_;
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.bind = (0, $ERVGH.bind)(module.exports.Chain);
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.apS = (0, $4sfjE.apS)(module.exports.Apply);
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * @since 2.5.0
 */ module.exports.head = module.exports.extract;
/**
 * @since 2.5.0
 */ module.exports.tail = $88e7d0c5193e4968$var$_.tail;
/**
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$last = function(as) {
    return as[as.length - 1];
};
module.exports.last = $88e7d0c5193e4968$var$last;
/**
 * Get all but the last element of a non empty array, creating a new array.
 *
 * @example
 * import { init } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(init([1, 2, 3]), [1, 2])
 * assert.deepStrictEqual(init([1]), [])
 *
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$init = function(as) {
    return as.slice(0, -1);
};
module.exports.init = $88e7d0c5193e4968$var$init;
/**
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$min = function(O) {
    var S = $88e7d0c5193e4968$var$Se.min(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
module.exports.min = $88e7d0c5193e4968$var$min;
/**
 * @since 2.5.0
 */ var $88e7d0c5193e4968$var$max = function(O) {
    var S = $88e7d0c5193e4968$var$Se.max(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
module.exports.max = $88e7d0c5193e4968$var$max;
/**
 * @since 2.10.0
 */ var $88e7d0c5193e4968$var$concatAll = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
module.exports.concatAll = $88e7d0c5193e4968$var$concatAll;
/**
 * Break a `ReadonlyArray` into its first element and remaining elements.
 *
 * @category pattern matching
 * @since 2.11.0
 */ var $88e7d0c5193e4968$var$matchLeft = function(f) {
    return function(as) {
        return f((0, module.exports.head)(as), (0, module.exports.tail)(as));
    };
};
module.exports.matchLeft = $88e7d0c5193e4968$var$matchLeft;
/**
 * Break a `ReadonlyArray` into its initial elements and the last element.
 *
 * @category pattern matching
 * @since 2.11.0
 */ var $88e7d0c5193e4968$var$matchRight = function(f) {
    return function(as) {
        return f((0, module.exports.init)(as), (0, module.exports.last)(as));
    };
};
module.exports.matchRight = $88e7d0c5193e4968$var$matchRight;
/**
 * Apply a function to the head, creating a new `ReadonlyNonEmptyArray`.
 *
 * @since 2.11.0
 */ var $88e7d0c5193e4968$var$modifyHead = function(f) {
    return function(as) {
        return $88e7d0c5193e4968$var$__spreadArray([
            f((0, module.exports.head)(as))
        ], (0, module.exports.tail)(as), true);
    };
};
module.exports.modifyHead = $88e7d0c5193e4968$var$modifyHead;
/**
 * Change the head, creating a new `ReadonlyNonEmptyArray`.
 *
 * @since 2.11.0
 */ var $88e7d0c5193e4968$var$updateHead = function(a) {
    return (0, module.exports.modifyHead)(function() {
        return a;
    });
};
module.exports.updateHead = $88e7d0c5193e4968$var$updateHead;
/**
 * Apply a function to the last element, creating a new `ReadonlyNonEmptyArray`.
 *
 * @since 2.11.0
 */ var $88e7d0c5193e4968$var$modifyLast = function(f) {
    return function(as) {
        return (0, $3abDJ.pipe)((0, module.exports.init)(as), (0, module.exports.append)(f((0, module.exports.last)(as))));
    };
};
module.exports.modifyLast = $88e7d0c5193e4968$var$modifyLast;
/**
 * Change the last element, creating a new `ReadonlyNonEmptyArray`.
 *
 * @since 2.11.0
 */ var $88e7d0c5193e4968$var$updateLast = function(a) {
    return (0, module.exports.modifyLast)(function() {
        return a;
    });
};
module.exports.updateLast = $88e7d0c5193e4968$var$updateLast;
/**
 * Places an element in between members of a `ReadonlyNonEmptyArray`, then folds the results using the provided `Semigroup`.
 *
 * @example
 * import * as S from 'fp-ts/string'
 * import { intercalate } from 'fp-ts/ReadonlyNonEmptyArray'
 *
 * assert.deepStrictEqual(intercalate(S.Semigroup)('-')(['a', 'b', 'c']), 'a-b-c')
 *
 * @since 2.12.0
 */ var $88e7d0c5193e4968$var$intercalate = function(S) {
    var concatAllS = (0, module.exports.concatAll)(S);
    return function(middle) {
        return (0, $3abDJ.flow)((0, module.exports.intersperse)(middle), concatAllS);
    };
};
module.exports.intercalate = $88e7d0c5193e4968$var$intercalate;
// -------------------------------------------------------------------------------------
// legacy
// -------------------------------------------------------------------------------------
/**
 * Alias of `flatMap`.
 *
 * @category legacy
 * @since 2.5.0
 */ module.exports.chain = module.exports.flatMap;
function $88e7d0c5193e4968$var$groupSort(O) {
    var sortO = (0, module.exports.sort)(O);
    var groupO = $88e7d0c5193e4968$var$group(O);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? groupO(sortO(as)) : module.exports.empty;
    };
}
function $88e7d0c5193e4968$var$filter(predicate) {
    return (0, module.exports.filterWithIndex)(function(_, a) {
        return predicate(a);
    });
}
/**
 * Use [`filterWithIndex`](./ReadonlyArray.ts.html#filterwithindex) instead.
 *
 * @category zone of death
 * @since 2.5.0
 * @deprecated
 */ var $88e7d0c5193e4968$var$filterWithIndex = function(predicate) {
    return function(as) {
        return (0, module.exports.fromReadonlyArray)(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
module.exports.filterWithIndex = $88e7d0c5193e4968$var$filterWithIndex;
/**
 * Use [`unprepend`](#unprepend) instead.
 *
 * @category zone of death
 * @since 2.10.0
 * @deprecated
 */ module.exports.uncons = module.exports.unprepend;
/**
 * Use [`unappend`](#unappend) instead.
 *
 * @category zone of death
 * @since 2.10.0
 * @deprecated
 */ module.exports.unsnoc = module.exports.unappend;
function $88e7d0c5193e4968$var$cons(head, tail) {
    return tail === undefined ? (0, module.exports.prepend)(head) : (0, $3abDJ.pipe)(tail, (0, module.exports.prepend)(head));
}
/**
 * Use [`append`](./ReadonlyArray.ts.html#append) instead.
 *
 * @category zone of death
 * @since 2.5.0
 * @deprecated
 */ var $88e7d0c5193e4968$var$snoc = function(init, end) {
    return (0, $3abDJ.pipe)(init, $88e7d0c5193e4968$var$concat([
        end
    ]));
};
module.exports.snoc = $88e7d0c5193e4968$var$snoc;
/**
 * Use [`insertAt`](./ReadonlyArray.ts.html#insertat) instead.
 *
 * @category zone of death
 * @since 2.5.0
 * @deprecated
 */ var $88e7d0c5193e4968$var$insertAt = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $88e7d0c5193e4968$var$_.none : $88e7d0c5193e4968$var$_.some((0, module.exports.unsafeInsertAt)(i, a, as));
    };
};
module.exports.insertAt = $88e7d0c5193e4968$var$insertAt;
/**
 * Use [`prependAll`](#prependall) instead.
 *
 * @category zone of death
 * @since 2.9.0
 * @deprecated
 */ module.exports.prependToAll = module.exports.prependAll;
/**
 * Use [`concatAll`](#concatall) instead.
 *
 * @category zone of death
 * @since 2.5.0
 * @deprecated
 */ module.exports.fold = module.exports.concatAll;
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Functor` instance, pass `RNEA.Functor` instead of `RNEA.readonlyNonEmptyArray`
 * (where `RNEA` is from `import RNEA from 'fp-ts/ReadonlyNonEmptyArray'`)
 *
 * @category zone of death
 * @since 2.5.0
 * @deprecated
 */ module.exports.readonlyNonEmptyArray = {
    URI: module.exports.URI,
    of: module.exports.of,
    map: $88e7d0c5193e4968$var$_map,
    mapWithIndex: $88e7d0c5193e4968$var$_mapWithIndex,
    ap: $88e7d0c5193e4968$var$_ap,
    chain: module.exports.flatMap,
    extend: $88e7d0c5193e4968$var$_extend,
    extract: module.exports.extract,
    reduce: $88e7d0c5193e4968$var$_reduce,
    foldMap: $88e7d0c5193e4968$var$_foldMap,
    reduceRight: $88e7d0c5193e4968$var$_reduceRight,
    traverse: $88e7d0c5193e4968$var$_traverse,
    sequence: module.exports.sequence,
    reduceWithIndex: $88e7d0c5193e4968$var$_reduceWithIndex,
    foldMapWithIndex: $88e7d0c5193e4968$var$_foldMapWithIndex,
    reduceRightWithIndex: $88e7d0c5193e4968$var$_reduceRightWithIndex,
    traverseWithIndex: $88e7d0c5193e4968$var$_traverseWithIndex,
    alt: $88e7d0c5193e4968$var$_alt
};

});
parcelRegister("3OUuJ", function(module, exports) {
"use strict";
var $2c81dd470e2f52f7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2c81dd470e2f52f7$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2c81dd470e2f52f7$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2c81dd470e2f52f7$var$__createBinding(result, mod, k);
    }
    $2c81dd470e2f52f7$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.semigroupProduct = module.exports.semigroupSum = module.exports.semigroupString = module.exports.getFunctionSemigroup = module.exports.semigroupAny = module.exports.semigroupAll = module.exports.getIntercalateSemigroup = module.exports.getMeetSemigroup = module.exports.getJoinSemigroup = module.exports.getDualSemigroup = module.exports.getStructSemigroup = module.exports.getTupleSemigroup = module.exports.getFirstSemigroup = module.exports.getLastSemigroup = module.exports.getObjectSemigroup = module.exports.semigroupVoid = module.exports.concatAll = module.exports.last = module.exports.first = module.exports.intercalate = module.exports.tuple = module.exports.struct = module.exports.reverse = module.exports.constant = module.exports.max = module.exports.min = void 0;
module.exports.fold = $2c81dd470e2f52f7$var$fold;

var $3abDJ = parcelRequire("3abDJ");

var $2c81dd470e2f52f7$var$_ = $2c81dd470e2f52f7$var$__importStar((parcelRequire("704qB")));

var $2c81dd470e2f52f7$var$M = $2c81dd470e2f52f7$var$__importStar((parcelRequire("jqhlu")));

var $2c81dd470e2f52f7$var$Or = $2c81dd470e2f52f7$var$__importStar((parcelRequire("e51aV")));
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * Get a semigroup where `concat` will return the minimum, based on the provided order.
 *
 * @example
 * import * as N from 'fp-ts/number'
 * import * as S from 'fp-ts/Semigroup'
 *
 * const S1 = S.min(N.Ord)
 *
 * assert.deepStrictEqual(S1.concat(1, 2), 1)
 *
 * @category constructors
 * @since 2.10.0
 */ var $2c81dd470e2f52f7$var$min = function(O) {
    return {
        concat: $2c81dd470e2f52f7$var$Or.min(O)
    };
};
module.exports.min = $2c81dd470e2f52f7$var$min;
/**
 * Get a semigroup where `concat` will return the maximum, based on the provided order.
 *
 * @example
 * import * as N from 'fp-ts/number'
 * import * as S from 'fp-ts/Semigroup'
 *
 * const S1 = S.max(N.Ord)
 *
 * assert.deepStrictEqual(S1.concat(1, 2), 2)
 *
 * @category constructors
 * @since 2.10.0
 */ var $2c81dd470e2f52f7$var$max = function(O) {
    return {
        concat: $2c81dd470e2f52f7$var$Or.max(O)
    };
};
module.exports.max = $2c81dd470e2f52f7$var$max;
/**
 * @category constructors
 * @since 2.10.0
 */ var $2c81dd470e2f52f7$var$constant = function(a) {
    return {
        concat: function() {
            return a;
        }
    };
};
module.exports.constant = $2c81dd470e2f52f7$var$constant;
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Semigroup`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse } from 'fp-ts/Semigroup'
 * import * as S from 'fp-ts/string'
 *
 * assert.deepStrictEqual(reverse(S.Semigroup).concat('a', 'b'), 'ba')
 *
 * @since 2.10.0
 */ module.exports.reverse = $2c81dd470e2f52f7$var$M.reverse;
/**
 * Given a struct of semigroups returns a semigroup for the struct.
 *
 * @example
 * import { struct } from 'fp-ts/Semigroup'
 * import * as N from 'fp-ts/number'
 *
 * interface Point {
 *   readonly x: number
 *   readonly y: number
 * }
 *
 * const S = struct<Point>({
 *   x: N.SemigroupSum,
 *   y: N.SemigroupSum
 * })
 *
 * assert.deepStrictEqual(S.concat({ x: 1, y: 2 }, { x: 3, y: 4 }), { x: 4, y: 6 })
 *
 * @since 2.10.0
 */ var $2c81dd470e2f52f7$var$struct = function(semigroups) {
    return {
        concat: function(first, second) {
            var r = {};
            for(var k in semigroups)if ($2c81dd470e2f52f7$var$_.has.call(semigroups, k)) r[k] = semigroups[k].concat(first[k], second[k]);
            return r;
        }
    };
};
module.exports.struct = $2c81dd470e2f52f7$var$struct;
/**
 * Given a tuple of semigroups returns a semigroup for the tuple.
 *
 * @example
 * import { tuple } from 'fp-ts/Semigroup'
 * import * as B from 'fp-ts/boolean'
 * import * as N from 'fp-ts/number'
 * import * as S from 'fp-ts/string'
 *
 * const S1 = tuple(S.Semigroup, N.SemigroupSum)
 * assert.deepStrictEqual(S1.concat(['a', 1], ['b', 2]), ['ab', 3])
 *
 * const S2 = tuple(S.Semigroup, N.SemigroupSum, B.SemigroupAll)
 * assert.deepStrictEqual(S2.concat(['a', 1, true], ['b', 2, false]), ['ab', 3, false])
 *
 * @since 2.10.0
 */ var $2c81dd470e2f52f7$var$tuple = function() {
    var semigroups = [];
    for(var _i = 0; _i < arguments.length; _i++)semigroups[_i] = arguments[_i];
    return {
        concat: function(first, second) {
            return semigroups.map(function(s, i) {
                return s.concat(first[i], second[i]);
            });
        }
    };
};
module.exports.tuple = $2c81dd470e2f52f7$var$tuple;
/**
 * Between each pair of elements insert `middle`.
 *
 * @example
 * import { intercalate } from 'fp-ts/Semigroup'
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * const S1 = pipe(S.Semigroup, intercalate(' + '))
 *
 * assert.strictEqual(S1.concat('a', 'b'), 'a + b')
 *
 * @since 2.10.0
 */ var $2c81dd470e2f52f7$var$intercalate = function(middle) {
    return function(S) {
        return {
            concat: function(x, y) {
                return S.concat(x, S.concat(middle, y));
            }
        };
    };
};
module.exports.intercalate = $2c81dd470e2f52f7$var$intercalate;
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * Always return the first argument.
 *
 * @example
 * import * as S from 'fp-ts/Semigroup'
 *
 * assert.deepStrictEqual(S.first<number>().concat(1, 2), 1)
 *
 * @category instances
 * @since 2.10.0
 */ var $2c81dd470e2f52f7$var$first = function() {
    return {
        concat: $3abDJ.identity
    };
};
module.exports.first = $2c81dd470e2f52f7$var$first;
/**
 * Always return the last argument.
 *
 * @example
 * import * as S from 'fp-ts/Semigroup'
 *
 * assert.deepStrictEqual(S.last<number>().concat(1, 2), 2)
 *
 * @category instances
 * @since 2.10.0
 */ var $2c81dd470e2f52f7$var$last = function() {
    return {
        concat: function(_, y) {
            return y;
        }
    };
};
module.exports.last = $2c81dd470e2f52f7$var$last;
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Given a sequence of `as`, concat them and return the total.
 *
 * If `as` is empty, return the provided `startWith` value.
 *
 * @example
 * import { concatAll } from 'fp-ts/Semigroup'
 * import * as N from 'fp-ts/number'
 *
 * const sum = concatAll(N.SemigroupSum)(0)
 *
 * assert.deepStrictEqual(sum([1, 2, 3]), 6)
 * assert.deepStrictEqual(sum([]), 0)
 *
 * @since 2.10.0
 */ module.exports.concatAll = $2c81dd470e2f52f7$var$M.concatAll;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * Use `void` module instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.semigroupVoid = (0, module.exports.constant)(undefined);
/**
 * Use [`getAssignSemigroup`](./struct.ts.html#getAssignSemigroup) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ var $2c81dd470e2f52f7$var$getObjectSemigroup = function() {
    return {
        concat: function(first, second) {
            return Object.assign({}, first, second);
        }
    };
};
module.exports.getObjectSemigroup = $2c81dd470e2f52f7$var$getObjectSemigroup;
/**
 * Use [`last`](#last) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getLastSemigroup = module.exports.last;
/**
 * Use [`first`](#first) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getFirstSemigroup = module.exports.first;
/**
 * Use [`tuple`](#tuple) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getTupleSemigroup = module.exports.tuple;
/**
 * Use [`struct`](#struct) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getStructSemigroup = module.exports.struct;
/**
 * Use [`reverse`](#reverse) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getDualSemigroup = module.exports.reverse;
/**
 * Use [`max`](#max) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getJoinSemigroup = module.exports.max;
/**
 * Use [`min`](#min) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getMeetSemigroup = module.exports.min;
/**
 * Use [`intercalate`](#intercalate) instead.
 *
 * @category zone of death
 * @since 2.5.0
 * @deprecated
 */ module.exports.getIntercalateSemigroup = module.exports.intercalate;
function $2c81dd470e2f52f7$var$fold(S) {
    var concatAllS = (0, module.exports.concatAll)(S);
    return function(startWith, as) {
        return as === undefined ? concatAllS(startWith) : concatAllS(startWith)(as);
    };
}
/**
 * Use [`SemigroupAll`](./boolean.ts.html#SemigroupAll) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.semigroupAll = {
    concat: function(x, y) {
        return x && y;
    }
};
/**
 * Use [`SemigroupAny`](./boolean.ts.html#SemigroupAny) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.semigroupAny = {
    concat: function(x, y) {
        return x || y;
    }
};
/**
 * Use [`getSemigroup`](./function.ts.html#getSemigroup) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getFunctionSemigroup = $3abDJ.getSemigroup;
/**
 * Use [`Semigroup`](./string.ts.html#Semigroup) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.semigroupString = {
    concat: function(x, y) {
        return x + y;
    }
};
/**
 * Use [`SemigroupSum`](./number.ts.html#SemigroupSum) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.semigroupSum = {
    concat: function(x, y) {
        return x + y;
    }
};
/**
 * Use [`SemigroupProduct`](./number.ts.html#SemigroupProduct) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.semigroupProduct = {
    concat: function(x, y) {
        return x * y;
    }
};

});
parcelRegister("jqhlu", function(module, exports) {
"use strict";
/**
 * A `Magma` is a pair `(A, concat)` in which `A` is a non-empty set and `concat` is a binary operation on `A`
 *
 * See [Semigroup](https://gcanti.github.io/fp-ts/modules/Semigroup.ts.html) for some instances.
 *
 * @since 2.0.0
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concatAll = module.exports.endo = module.exports.filterSecond = module.exports.filterFirst = module.exports.reverse = void 0;
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Magma`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse, concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(reverse(N.MagmaSub))(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), 2)
 *
 * @since 2.11.0
 */ var $e23de684c84cb90e$var$reverse = function(M) {
    return {
        concat: function(first, second) {
            return M.concat(second, first);
        }
    };
};
module.exports.reverse = $e23de684c84cb90e$var$reverse;
/**
 * @since 2.11.0
 */ var $e23de684c84cb90e$var$filterFirst = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(first) ? M.concat(first, second) : second;
            }
        };
    };
};
module.exports.filterFirst = $e23de684c84cb90e$var$filterFirst;
/**
 * @since 2.11.0
 */ var $e23de684c84cb90e$var$filterSecond = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(second) ? M.concat(first, second) : first;
            }
        };
    };
};
module.exports.filterSecond = $e23de684c84cb90e$var$filterSecond;
/**
 * @since 2.11.0
 */ var $e23de684c84cb90e$var$endo = function(f) {
    return function(M) {
        return {
            concat: function(first, second) {
                return M.concat(f(first), f(second));
            }
        };
    };
};
module.exports.endo = $e23de684c84cb90e$var$endo;
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Given a sequence of `as`, concat them and return the total.
 *
 * If `as` is empty, return the provided `startWith` value.
 *
 * @example
 * import { concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(N.MagmaSub)(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), -6)
 *
 * @since 2.11.0
 */ var $e23de684c84cb90e$var$concatAll = function(M) {
    return function(startWith) {
        return function(as) {
            return as.reduce(function(a, acc) {
                return M.concat(a, acc);
            }, startWith);
        };
    };
};
module.exports.concatAll = $e23de684c84cb90e$var$concatAll;

});




parcelRegister("7Ekty", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bbT5Q.default;
    }
});

var $bbT5Q = parcelRequire("bbT5Q");

});
parcelRegister("bbT5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $825b752ac2a74c27$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $825b752ac2a74c27$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ErGR.default), (0, $8nd05.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $3ErGR.default).muiName;
    return /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(Component));
}

});
parcelRegister("3ErGR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8a963e5702921b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $aiIP4 = parcelRequire("aiIP4");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2a8a963e5702921b$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $2a8a963e5702921b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $jTnBY.default)(color)}`,
            `fontSize${(0, $jTnBY.default)(fontSize)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $aiIP4.getSvgIconUtilityClass), classes);
};
const $2a8a963e5702921b$var$SvgIconRoot = (0, $d8seH.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`fontSize${(0, $jTnBY.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $2a8a963e5702921b$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $1En50.default)(props, $2a8a963e5702921b$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $acw62.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $2a8a963e5702921b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2a8a963e5702921b$var$SvgIconRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$2a8a963e5702921b$var$SvgIcon.muiName = 'SvgIcon';
var $2a8a963e5702921b$export$2e2bcd8739ae039 = $2a8a963e5702921b$var$SvgIcon;

});
parcelRegister("9QePP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});

parcelRegister("8Indx", function(module, exports) {

$parcel$export(module.exports, "default", () => $65847140631d74af$export$2e2bcd8739ae039);
function $65847140631d74af$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("jTnBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b578196486f177$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");
var $e7b578196486f177$export$2e2bcd8739ae039 = (0, $gxvzd.default);

});

parcelRegister("1iOpW", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $0f2e94b8fca67639$export$2440da353cedad43);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $aMyfV = parcelRequire("aMyfV");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $0f2e94b8fca67639$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aMyfV.default), (0, $8nd05.default)({}, props));
}
var $0f2e94b8fca67639$export$2e2bcd8739ae039 = $0f2e94b8fca67639$var$DefaultPropsProvider;
function $0f2e94b8fca67639$export$2440da353cedad43(params) {
    return (0, $aMyfV.useDefaultProps)(params);
}

});
parcelRegister("aMyfV", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $7d98f590ab80e73c$export$2440da353cedad43);
$parcel$export(module.exports, "default", () => $7d98f590ab80e73c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $4FZD0 = parcelRequire("4FZD0");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7d98f590ab80e73c$var$PropsContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $7d98f590ab80e73c$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7d98f590ab80e73c$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $7d98f590ab80e73c$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $4FZD0.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $4FZD0.default)(config, props);
    return props;
}
function $7d98f590ab80e73c$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $acw62.useContext($7d98f590ab80e73c$var$PropsContext);
    return $7d98f590ab80e73c$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $7d98f590ab80e73c$export$2e2bcd8739ae039 = $7d98f590ab80e73c$var$DefaultPropsProvider;

});
parcelRegister("4FZD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $367acbd429e20ec9$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $367acbd429e20ec9$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $8nd05.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $8nd05.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $8nd05.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $367acbd429e20ec9$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("d8seH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0277c5e26ff0d56c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "rootShouldForwardProp", () => (parcelRequire("8Uq77")).default);

var $bpUvK = parcelRequire("bpUvK");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $8Uq77 = parcelRequire("8Uq77");

var $PJRTc = parcelRequire("PJRTc");
'use client';
const $0277c5e26ff0d56c$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($bpUvK)))({
    themeId: (0, $4jPsi.default),
    defaultTheme: $jR9F1.default,
    rootShouldForwardProp: $8Uq77.default
});
var $0277c5e26ff0d56c$export$2e2bcd8739ae039 = $0277c5e26ff0d56c$var$styled;

});
parcelRegister("bpUvK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84fddd6da8624ed6$var$createStyled;
module.exports.shouldForwardProp = $84fddd6da8624ed6$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $84fddd6da8624ed6$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2 = $1jnue((parcelRequire("c05no")));

var $84fddd6da8624ed6$var$_styledEngine = $84fddd6da8624ed6$var$_interopRequireWildcard((parcelRequire("bOOlK")));

var $3z1Ay = parcelRequire("3z1Ay");

var $84fddd6da8624ed6$var$_capitalize = $1jnue((parcelRequire("2A1GY")));

var $84fddd6da8624ed6$var$_getDisplayName = $1jnue((parcelRequire("eQufN")));

var $84fddd6da8624ed6$var$_createTheme = $1jnue((parcelRequire("5QV4f")));

var $84fddd6da8624ed6$var$_styleFunctionSx = $1jnue((parcelRequire("2bwhi")));
const $84fddd6da8624ed6$var$_excluded = [
    "ownerState"
], $84fddd6da8624ed6$var$_excluded2 = [
    "variants"
], $84fddd6da8624ed6$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $84fddd6da8624ed6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($84fddd6da8624ed6$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $84fddd6da8624ed6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $84fddd6da8624ed6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $84fddd6da8624ed6$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $84fddd6da8624ed6$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $84fddd6da8624ed6$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const $84fddd6da8624ed6$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $84fddd6da8624ed6$var$_createTheme.default)();
const $84fddd6da8624ed6$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $84fddd6da8624ed6$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $84fddd6da8624ed6$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $84fddd6da8624ed6$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $84fddd6da8624ed6$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2.default)(_ref, $84fddd6da8624ed6$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $84fddd6da8624ed6$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$84fddd6da8624ed6$var$processStyleArg(resolvedStyle, (0, $84fddd6da8624ed6$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $84fddd6da8624ed6$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $84fddd6da8624ed6$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, $84fddd6da8624ed6$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $84fddd6da8624ed6$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $84fddd6da8624ed6$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $84fddd6da8624ed6$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $84fddd6da8624ed6$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $84fddd6da8624ed6$var$_styleFunctionSx.default)((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
            theme: $84fddd6da8624ed6$var$resolveTheme((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $84fddd6da8624ed6$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $84fddd6da8624ed6$var$defaultOverridesResolver($84fddd6da8624ed6$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $84fddd6da8624ed6$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $84fddd6da8624ed6$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($84fddd6da8624ed6$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $84fddd6da8624ed6$var$_styledEngine.default)(tag, (0, $84fddd6da8624ed6$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $3z1Ay.isPlainObject)(stylesArg)) return (props)=>$84fddd6da8624ed6$var$processStyleArg(stylesArg, (0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    theme: $84fddd6da8624ed6$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $84fddd6da8624ed6$var$resolveTheme((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $84fddd6da8624ed6$var$processStyleArg(slotStyle, (0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $84fddd6da8624ed6$var$resolveTheme((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $84fddd6da8624ed6$var$processStyleArg({
                    variants: themeVariants
                }, (0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jR9F1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e74a75f0176cf8e3$export$2e2bcd8739ae039);

var $ijOKP = parcelRequire("ijOKP");
'use client';
const $e74a75f0176cf8e3$var$defaultTheme = (0, $ijOKP.default)();
var $e74a75f0176cf8e3$export$2e2bcd8739ae039 = $e74a75f0176cf8e3$var$defaultTheme;

});
parcelRegister("ijOKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5615f18e5cd04fc$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $9dZwz = parcelRequire("9dZwz");
var $kOOck = parcelRequire("kOOck");

var $6o2lr = parcelRequire("6o2lr");


var $6plKN = parcelRequire("6plKN");

var $4Gk6P = parcelRequire("4Gk6P");

var $d6q8u = parcelRequire("d6q8u");

var $jtCFx = parcelRequire("jtCFx");

var $bmoVh = parcelRequire("bmoVh");

var $lhXgK = parcelRequire("lhXgK");
const $d5615f18e5cd04fc$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $d5615f18e5cd04fc$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $1En50.default)(options, $d5615f18e5cd04fc$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error((0, $cpmCj.default)(18));
    const palette = (0, $4Gk6P.default)(paletteInput);
    const systemTheme = (0, $6o2lr.default)(options);
    let muiTheme = (0, $3z1Ay.default)(systemTheme, {
        mixins: (0, $6plKN.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $jtCFx.default).slice(),
        typography: (0, $d6q8u.default)(palette, typographyInput),
        transitions: (0, $bmoVh.default)(transitionsInput),
        zIndex: (0, $8nd05.default)({}, (0, $lhXgK.default))
    });
    muiTheme = (0, $3z1Ay.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $kOOck.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $d5615f18e5cd04fc$var$warnedOnce = false;
function $d5615f18e5cd04fc$export$c469355549431d9b(...args) {
    return $d5615f18e5cd04fc$var$createTheme(...args);
}
var $d5615f18e5cd04fc$export$2e2bcd8739ae039 = $d5615f18e5cd04fc$var$createTheme;

});
parcelRegister("6plKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa5f3b4975f3e4c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $4aa5f3b4975f3e4c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $8nd05.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("4Gk6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $368aaef25f6a2997$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $kSnzZ = parcelRequire("kSnzZ");

var $dzxhF = parcelRequire("dzxhF");

var $eU5ou = parcelRequire("eU5ou");

var $kSXRh = parcelRequire("kSXRh");

var $ln9F4 = parcelRequire("ln9F4");

var $dMYym = parcelRequire("dMYym");

var $bKnBV = parcelRequire("bKnBV");

var $iDVue = parcelRequire("iDVue");

var $e4nxq = parcelRequire("e4nxq");
const $368aaef25f6a2997$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $368aaef25f6a2997$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $dzxhF.default).white,
        default: (0, $dzxhF.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $368aaef25f6a2997$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $dzxhF.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $dzxhF.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $368aaef25f6a2997$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $kSnzZ.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $kSnzZ.darken)(intent.main, tonalOffsetDark);
    }
}
function $368aaef25f6a2997$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bKnBV.default)[200],
        light: (0, $bKnBV.default)[50],
        dark: (0, $bKnBV.default)[400]
    };
    return {
        main: (0, $bKnBV.default)[700],
        light: (0, $bKnBV.default)[400],
        dark: (0, $bKnBV.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $kSXRh.default)[200],
        light: (0, $kSXRh.default)[50],
        dark: (0, $kSXRh.default)[400]
    };
    return {
        main: (0, $kSXRh.default)[500],
        light: (0, $kSXRh.default)[300],
        dark: (0, $kSXRh.default)[700]
    };
}
function $368aaef25f6a2997$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ln9F4.default)[500],
        light: (0, $ln9F4.default)[300],
        dark: (0, $ln9F4.default)[700]
    };
    return {
        main: (0, $ln9F4.default)[700],
        light: (0, $ln9F4.default)[400],
        dark: (0, $ln9F4.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $iDVue.default)[400],
        light: (0, $iDVue.default)[300],
        dark: (0, $iDVue.default)[700]
    };
    return {
        main: (0, $iDVue.default)[700],
        light: (0, $iDVue.default)[500],
        dark: (0, $iDVue.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $e4nxq.default)[400],
        light: (0, $e4nxq.default)[300],
        dark: (0, $e4nxq.default)[700]
    };
    return {
        main: (0, $e4nxq.default)[800],
        light: (0, $e4nxq.default)[500],
        dark: (0, $e4nxq.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $dMYym.default)[400],
        light: (0, $dMYym.default)[300],
        dark: (0, $dMYym.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $dMYym.default)[500],
        dark: (0, $dMYym.default)[900]
    };
}
function $368aaef25f6a2997$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $1En50.default)(palette, $368aaef25f6a2997$var$_excluded);
    const primary = palette.primary || $368aaef25f6a2997$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $368aaef25f6a2997$var$getDefaultSecondary(mode);
    const error = palette.error || $368aaef25f6a2997$var$getDefaultError(mode);
    const info = palette.info || $368aaef25f6a2997$var$getDefaultInfo(mode);
    const success = palette.success || $368aaef25f6a2997$var$getDefaultSuccess(mode);
    const warning = palette.warning || $368aaef25f6a2997$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $kSnzZ.getContrastRatio)(background, $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary : $368aaef25f6a2997$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $8nd05.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $cpmCj.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $cpmCj.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $368aaef25f6a2997$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $368aaef25f6a2997$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $368aaef25f6a2997$export$55ce6f3a06c59543,
        light: $368aaef25f6a2997$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $3z1Ay.default)((0, $8nd05.default)({
        // A collection of common colors.
        common: (0, $8nd05.default)({}, (0, $dzxhF.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $eU5ou.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("kSnzZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $f32b24353f12f45a$var$alpha;
module.exports.blend = $f32b24353f12f45a$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $f32b24353f12f45a$var$darken;
module.exports.decomposeColor = $f32b24353f12f45a$var$decomposeColor;
module.exports.emphasize = $f32b24353f12f45a$var$emphasize;
module.exports.getContrastRatio = $f32b24353f12f45a$var$getContrastRatio;
module.exports.getLuminance = $f32b24353f12f45a$var$getLuminance;
module.exports.hexToRgb = $f32b24353f12f45a$var$hexToRgb;
module.exports.hslToRgb = $f32b24353f12f45a$var$hslToRgb;
module.exports.lighten = $f32b24353f12f45a$var$lighten;
module.exports.private_safeAlpha = $f32b24353f12f45a$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $f32b24353f12f45a$var$private_safeDarken;
module.exports.private_safeEmphasize = $f32b24353f12f45a$var$private_safeEmphasize;
module.exports.private_safeLighten = $f32b24353f12f45a$var$private_safeLighten;
module.exports.recomposeColor = $f32b24353f12f45a$var$recomposeColor;
module.exports.rgbToHex = $f32b24353f12f45a$var$rgbToHex;

var $f32b24353f12f45a$var$_formatMuiErrorMessage2 = $1jnue((parcelRequire("dsPLe")));

var $f32b24353f12f45a$var$_clamp = $1jnue((parcelRequire("lYE9x")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $f32b24353f12f45a$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $f32b24353f12f45a$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $f32b24353f12f45a$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $f32b24353f12f45a$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $f32b24353f12f45a$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $f32b24353f12f45a$var$decomposeColor($f32b24353f12f45a$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $f32b24353f12f45a$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $f32b24353f12f45a$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $f32b24353f12f45a$var$colorChannel = (color)=>{
    const decomposedColor = $f32b24353f12f45a$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $f32b24353f12f45a$var$colorChannel;
const $f32b24353f12f45a$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $f32b24353f12f45a$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $f32b24353f12f45a$var$private_safeColorChannel;
function $f32b24353f12f45a$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $f32b24353f12f45a$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $f32b24353f12f45a$var$decomposeColor(color);
    return `#${values.map((n, i)=>$f32b24353f12f45a$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $f32b24353f12f45a$var$hslToRgb(color) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $f32b24353f12f45a$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $f32b24353f12f45a$var$getLuminance(color) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $f32b24353f12f45a$var$decomposeColor($f32b24353f12f45a$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $f32b24353f12f45a$var$getContrastRatio(foreground, background) {
    const lumA = $f32b24353f12f45a$var$getLuminance(foreground);
    const lumB = $f32b24353f12f45a$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$alpha(color, value) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    value = $f32b24353f12f45a$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $f32b24353f12f45a$var$recomposeColor(color);
}
function $f32b24353f12f45a$var$private_safeAlpha(color, value, warning) {
    try {
        return $f32b24353f12f45a$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$darken(color, coefficient) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    coefficient = $f32b24353f12f45a$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $f32b24353f12f45a$var$recomposeColor(color);
}
function $f32b24353f12f45a$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $f32b24353f12f45a$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$lighten(color, coefficient) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    coefficient = $f32b24353f12f45a$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $f32b24353f12f45a$var$recomposeColor(color);
}
function $f32b24353f12f45a$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $f32b24353f12f45a$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$emphasize(color, coefficient = 0.15) {
    return $f32b24353f12f45a$var$getLuminance(color) > 0.5 ? $f32b24353f12f45a$var$darken(color, coefficient) : $f32b24353f12f45a$var$lighten(color, coefficient);
}
function $f32b24353f12f45a$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $f32b24353f12f45a$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $f32b24353f12f45a$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $f32b24353f12f45a$var$decomposeColor(background);
    const overlayColor = $f32b24353f12f45a$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $f32b24353f12f45a$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});

parcelRegister("dzxhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e185cbbdd17e0f7$export$2e2bcd8739ae039);
const $9e185cbbdd17e0f7$var$common = {
    black: '#000',
    white: '#fff'
};
var $9e185cbbdd17e0f7$export$2e2bcd8739ae039 = $9e185cbbdd17e0f7$var$common;

});

parcelRegister("eU5ou", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9a7ac9db04746c$export$2e2bcd8739ae039);
const $ad9a7ac9db04746c$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $ad9a7ac9db04746c$export$2e2bcd8739ae039 = $ad9a7ac9db04746c$var$grey;

});

parcelRegister("kSXRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34748703626d0dc$export$2e2bcd8739ae039);
const $f34748703626d0dc$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $f34748703626d0dc$export$2e2bcd8739ae039 = $f34748703626d0dc$var$purple;

});

parcelRegister("ln9F4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f33d825c71610f$export$2e2bcd8739ae039);
const $f8f33d825c71610f$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $f8f33d825c71610f$export$2e2bcd8739ae039 = $f8f33d825c71610f$var$red;

});

parcelRegister("dMYym", function(module, exports) {

$parcel$export(module.exports, "default", () => $a09ebaae00c386da$export$2e2bcd8739ae039);
const $a09ebaae00c386da$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $a09ebaae00c386da$export$2e2bcd8739ae039 = $a09ebaae00c386da$var$orange;

});

parcelRegister("bKnBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d64e288ac9a70b$export$2e2bcd8739ae039);
const $88d64e288ac9a70b$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $88d64e288ac9a70b$export$2e2bcd8739ae039 = $88d64e288ac9a70b$var$blue;

});

parcelRegister("iDVue", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9287623794ffe70$export$2e2bcd8739ae039);
const $d9287623794ffe70$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $d9287623794ffe70$export$2e2bcd8739ae039 = $d9287623794ffe70$var$lightBlue;

});

parcelRegister("e4nxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e3b29cd31a116f$export$2e2bcd8739ae039);
const $a3e3b29cd31a116f$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $a3e3b29cd31a116f$export$2e2bcd8739ae039 = $a3e3b29cd31a116f$var$green;

});


parcelRegister("d6q8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a01bf22de9dc59$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");
const $98a01bf22de9dc59$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $98a01bf22de9dc59$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $98a01bf22de9dc59$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $98a01bf22de9dc59$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $98a01bf22de9dc59$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $98a01bf22de9dc59$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $1En50.default)(_ref, $98a01bf22de9dc59$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $8nd05.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $98a01bf22de9dc59$var$defaultFontFamily ? {
            letterSpacing: `${$98a01bf22de9dc59$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $98a01bf22de9dc59$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $98a01bf22de9dc59$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $3z1Ay.default)((0, $8nd05.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jtCFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2deb8a0bbe5ea21$export$2e2bcd8739ae039);
const $e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity = 0.2;
const $e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity = 0.14;
const $e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity = 0.12;
function $e2deb8a0bbe5ea21$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e2deb8a0bbe5ea21$var$shadows = [
    'none',
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e2deb8a0bbe5ea21$export$2e2bcd8739ae039 = $e2deb8a0bbe5ea21$var$shadows;

});

parcelRegister("bmoVh", function(module, exports) {

$parcel$export(module.exports, "duration", () => $845514f3678d3888$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $845514f3678d3888$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $845514f3678d3888$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $845514f3678d3888$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $845514f3678d3888$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $845514f3678d3888$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $845514f3678d3888$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $845514f3678d3888$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $8nd05.default)({}, $845514f3678d3888$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $8nd05.default)({}, $845514f3678d3888$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $1En50.default)(options, $845514f3678d3888$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $845514f3678d3888$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $845514f3678d3888$var$formatMs(delay)}`).join(',');
    };
    return (0, $8nd05.default)({
        getAutoHeightDuration: $845514f3678d3888$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("lhXgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f9291b6f07cefb$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f7f9291b6f07cefb$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f7f9291b6f07cefb$export$2e2bcd8739ae039 = $f7f9291b6f07cefb$var$zIndex;

});



parcelRegister("4jPsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3250d9bb994a2d02$export$2e2bcd8739ae039);
var $3250d9bb994a2d02$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("8Uq77", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c7cf568a060c3d$export$2e2bcd8739ae039);

var $PJRTc = parcelRequire("PJRTc");
const $67c7cf568a060c3d$var$rootShouldForwardProp = (prop)=>(0, $PJRTc.default)(prop) && prop !== 'classes';
var $67c7cf568a060c3d$export$2e2bcd8739ae039 = $67c7cf568a060c3d$var$rootShouldForwardProp;

});
parcelRegister("PJRTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b8580029d7f562$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $09b8580029d7f562$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $09b8580029d7f562$export$2e2bcd8739ae039 = $09b8580029d7f562$var$slotShouldForwardProp;

});



parcelRegister("aiIP4", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $77fe5ab326d42cdb$export$c7c50641356bdfa5);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $77fe5ab326d42cdb$export$c7c50641356bdfa5(slot) {
    return (0, $4Cod0.default)('MuiSvgIcon', slot);
}
const $77fe5ab326d42cdb$var$svgIconClasses = (0, $beCSm.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $77fe5ab326d42cdb$export$2e2bcd8739ae039 = $77fe5ab326d42cdb$var$svgIconClasses;

});
parcelRegister("beCSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $82df286c368a2a01$export$2e2bcd8739ae039);

var $4Cod0 = parcelRequire("4Cod0");
function $82df286c368a2a01$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4Cod0.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("4Cod0", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cd7d64717698f7$export$2e2bcd8739ae039);

var $bnost = parcelRequire("bnost");
const $35cd7d64717698f7$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $35cd7d64717698f7$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $35cd7d64717698f7$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $bnost.default).generate(componentName)}-${slot}`;
}
function $35cd7d64717698f7$export$34c0130b1f3e8ae3(slot) {
    return $35cd7d64717698f7$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("bnost", function(module, exports) {

$parcel$export(module.exports, "default", () => $8484d09248d25570$export$2e2bcd8739ae039);
const $8484d09248d25570$var$defaultGenerator = (componentName)=>componentName;
const $8484d09248d25570$var$createClassNameGenerator = ()=>{
    let generate = $8484d09248d25570$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $8484d09248d25570$var$defaultGenerator;
        }
    };
};
const $8484d09248d25570$var$ClassNameGenerator = $8484d09248d25570$var$createClassNameGenerator();
var $8484d09248d25570$export$2e2bcd8739ae039 = $8484d09248d25570$var$ClassNameGenerator;

});







parcelRegister("4ZBbi", function(module, exports) {
"use strict";
var $3a29b35b6ed31f29$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3a29b35b6ed31f29$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3a29b35b6ed31f29$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3a29b35b6ed31f29$var$__createBinding(result, mod, k);
    }
    $3a29b35b6ed31f29$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rotate = module.exports.intersperse = module.exports.prependAll = module.exports.unzip = module.exports.zipWith = module.exports.sort = module.exports.lefts = module.exports.rights = module.exports.reverse = module.exports.modifyAt = module.exports.deleteAt = module.exports.updateAt = module.exports.insertAt = module.exports.copy = module.exports.findLastIndex = module.exports.findLastMap = module.exports.findFirstMap = module.exports.findIndex = module.exports.dropRight = module.exports.dropLeft = module.exports.takeRight = module.exports.takeLeft = module.exports.init = module.exports.tail = module.exports.last = module.exports.head = module.exports.lookup = module.exports.isOutOfBound = module.exports.size = module.exports.scanRight = module.exports.scanLeft = module.exports.chainWithIndex = module.exports.foldRight = module.exports.matchRight = module.exports.matchRightW = module.exports.foldLeft = module.exports.matchLeft = module.exports.matchLeftW = module.exports.match = module.exports.matchW = module.exports.fromEither = module.exports.fromOption = module.exports.replicate = module.exports.makeBy = module.exports.appendW = module.exports.append = module.exports.prependW = module.exports.prepend = module.exports.isNonEmpty = module.exports.isEmpty = void 0;
module.exports.getUnionMonoid = module.exports.getUnionSemigroup = module.exports.getOrd = module.exports.getEq = module.exports.getMonoid = module.exports.getSemigroup = module.exports.getShow = module.exports.URI = module.exports.unfold = module.exports.wilt = module.exports.wither = module.exports.traverseWithIndex = module.exports.sequence = module.exports.traverse = module.exports.reduceRightWithIndex = module.exports.reduceRight = module.exports.reduceWithIndex = module.exports.reduce = module.exports.foldMapWithIndex = module.exports.foldMap = module.exports.duplicate = module.exports.extend = module.exports.filterWithIndex = module.exports.alt = module.exports.altW = module.exports.partitionMapWithIndex = module.exports.partitionMap = module.exports.partitionWithIndex = module.exports.partition = module.exports.filter = module.exports.separate = module.exports.compact = module.exports.filterMap = module.exports.filterMapWithIndex = module.exports.mapWithIndex = module.exports.flatten = module.exports.flatMap = module.exports.ap = module.exports.map = module.exports.zero = module.exports.of = module.exports.concat = module.exports.concatW = module.exports.fromOptionK = module.exports.chunksOf = module.exports.splitAt = module.exports.chop = module.exports.sortBy = module.exports.uniq = module.exports.elem = void 0;
module.exports.cons = module.exports.empty = module.exports.range = module.exports.chain = module.exports.apS = module.exports.bind = module.exports.let = module.exports.bindTo = module.exports.Do = module.exports.intercalate = module.exports.exists = module.exports.some = module.exports.every = module.exports.unsafeDeleteAt = module.exports.unsafeUpdateAt = module.exports.unsafeInsertAt = module.exports.fromEitherK = module.exports.FromEither = module.exports.filterE = module.exports.ChainRecBreadthFirst = module.exports.chainRecBreadthFirst = module.exports.ChainRecDepthFirst = module.exports.chainRecDepthFirst = module.exports.Witherable = module.exports.TraversableWithIndex = module.exports.Traversable = module.exports.FoldableWithIndex = module.exports.Foldable = module.exports.FilterableWithIndex = module.exports.Filterable = module.exports.Compactable = module.exports.Extend = module.exports.Alternative = module.exports.guard = module.exports.Zero = module.exports.Alt = module.exports.Unfoldable = module.exports.Monad = module.exports.chainFirst = module.exports.Chain = module.exports.Applicative = module.exports.apSecond = module.exports.apFirst = module.exports.Apply = module.exports.FunctorWithIndex = module.exports.Pointed = module.exports.flap = module.exports.Functor = module.exports.getDifferenceMagma = module.exports.getIntersectionSemigroup = void 0;
module.exports.array = module.exports.prependToAll = module.exports.snoc = void 0;
module.exports.fromPredicate = $3a29b35b6ed31f29$var$fromPredicate;
module.exports.takeLeftWhile = $3a29b35b6ed31f29$var$takeLeftWhile;
module.exports.spanLeft = $3a29b35b6ed31f29$var$spanLeft;
module.exports.dropLeftWhile = $3a29b35b6ed31f29$var$dropLeftWhile;
module.exports.findFirst = $3a29b35b6ed31f29$var$findFirst;
module.exports.findLast = $3a29b35b6ed31f29$var$findLast;
module.exports.zip = $3a29b35b6ed31f29$var$zip;
module.exports.comprehension = $3a29b35b6ed31f29$var$comprehension;
module.exports.union = $3a29b35b6ed31f29$var$union;
module.exports.intersection = $3a29b35b6ed31f29$var$intersection;
module.exports.difference = $3a29b35b6ed31f29$var$difference;

var $4sfjE = parcelRequire("4sfjE");

var $ERVGH = parcelRequire("ERVGH");

var $eLQyV = parcelRequire("eLQyV");

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");

var $3a29b35b6ed31f29$var$_ = $3a29b35b6ed31f29$var$__importStar((parcelRequire("704qB")));

var $3a29b35b6ed31f29$var$NEA = $3a29b35b6ed31f29$var$__importStar((parcelRequire("9I22g")));

var $3a29b35b6ed31f29$var$RA = $3a29b35b6ed31f29$var$__importStar((parcelRequire("3zj3N")));

var $fIQoU = parcelRequire("fIQoU");

var $4p4Yq = parcelRequire("4p4Yq");

var $iV0VO = parcelRequire("iV0VO");
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * Test whether an array is empty
 *
 * @example
 * import { isEmpty } from 'fp-ts/Array'
 *
 * assert.strictEqual(isEmpty([]), true)
 * assert.strictEqual(isEmpty(['a']), false)
 *
 * @category refinements
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$isEmpty = function(as) {
    return as.length === 0;
};
module.exports.isEmpty = $3a29b35b6ed31f29$var$isEmpty;
/**
 * Test whether an array is non empty narrowing down the type to `NonEmptyArray<A>`
 *
 * @example
 * import { isNonEmpty } from 'fp-ts/Array'
 *
 * assert.strictEqual(isNonEmpty([]), false)
 * assert.strictEqual(isNonEmpty(['a']), true)
 *
 * @category refinements
 * @since 2.0.0
 */ module.exports.isNonEmpty = $3a29b35b6ed31f29$var$NEA.isNonEmpty;
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * Prepend an element to the front of a `Array`, creating a new `NonEmptyArray`.
 *
 * @example
 * import { prepend } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe([2, 3, 4], prepend(1)), [1, 2, 3, 4])
 *
 * @since 2.10.0
 */ module.exports.prepend = $3a29b35b6ed31f29$var$NEA.prepend;
/**
 * Less strict version of [`prepend`](#prepend).
 *
 * @example
 * import { prependW } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe([2, 3, 4], prependW("a")), ["a", 2, 3, 4]);
 *
 * @since 2.11.0
 */ module.exports.prependW = $3a29b35b6ed31f29$var$NEA.prependW;
/**
 * Append an element to the end of a `Array`, creating a new `NonEmptyArray`.
 *
 * @example
 * import { append } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe([1, 2, 3], append(4)), [1, 2, 3, 4])
 *
 * @since 2.10.0
 */ module.exports.append = $3a29b35b6ed31f29$var$NEA.append;
/**
 * Less strict version of [`append`](#append).
 *
 * @example
 * import { appendW } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe([1, 2, 3], appendW("d")), [1, 2, 3, "d"]);
 *
 * @since 2.11.0
 */ module.exports.appendW = $3a29b35b6ed31f29$var$NEA.appendW;
/**
 * Return a `Array` of length `n` with element `i` initialized with `f(i)`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { makeBy } from 'fp-ts/Array'
 *
 * const double = (i: number): number => i * 2
 * assert.deepStrictEqual(makeBy(5, double), [0, 2, 4, 6, 8])
 * assert.deepStrictEqual(makeBy(-3, double), [])
 * assert.deepStrictEqual(makeBy(4.32164, double), [0, 2, 4, 6])
 *
 * @category constructors
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$makeBy = function(n, f) {
    return n <= 0 ? [] : $3a29b35b6ed31f29$var$NEA.makeBy(f)(n);
};
module.exports.makeBy = $3a29b35b6ed31f29$var$makeBy;
/**
 * Create a `Array` containing a value repeated the specified number of times.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { replicate } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(replicate(3, 'a'), ['a', 'a', 'a'])
 * assert.deepStrictEqual(replicate(-3, 'a'), [])
 * assert.deepStrictEqual(replicate(2.985647, 'a'), ['a', 'a'])
 *
 * @category constructors
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$replicate = function(n, a) {
    return (0, module.exports.makeBy)(n, function() {
        return a;
    });
};
module.exports.replicate = $3a29b35b6ed31f29$var$replicate;
function $3a29b35b6ed31f29$var$fromPredicate(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : [];
    };
}
// -------------------------------------------------------------------------------------
// conversions
// -------------------------------------------------------------------------------------
/**
 * Create an array from an `Option`. The resulting array will contain the content of the
 * `Option` if it is `Some` and it will be empty if the `Option` is `None`.
 *
 * @example
 * import { fromOption } from 'fp-ts/Array'
 * import { option } from "fp-ts";
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe(option.some("a"), fromOption),["a"])
 * assert.deepStrictEqual(pipe(option.none, fromOption),[])
 *
 * @category conversions
 * @since 2.11.0
 */ var $3a29b35b6ed31f29$var$fromOption = function(ma) {
    return $3a29b35b6ed31f29$var$_.isNone(ma) ? [] : [
        ma.value
    ];
};
module.exports.fromOption = $3a29b35b6ed31f29$var$fromOption;
/**
 * Create an array from an `Either`. The resulting array will contain the content of the
 * `Either` if it is `Right` and it will be empty if the `Either` is `Left`.
 *
 * @example
 * import { fromEither } from 'fp-ts/Array'
 * import { either } from "fp-ts";
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe(either.right("r"), fromEither), ["r"]);
 * assert.deepStrictEqual(pipe(either.left("l"), fromEither), []);
 *
 * @category conversions
 * @since 2.11.0
 */ var $3a29b35b6ed31f29$var$fromEither = function(e) {
    return $3a29b35b6ed31f29$var$_.isLeft(e) ? [] : [
        e.right
    ];
};
module.exports.fromEither = $3a29b35b6ed31f29$var$fromEither;
/**
 * Less strict version of [`match`](#match).
 *
 * The `W` suffix (short for **W**idening) means that the handler return types will be merged.
 *
 * @example
 * import { matchW } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * const matcherW = matchW(
 *   () => "No elements",
 *   (as) => as.length
 * );
 * assert.deepStrictEqual(pipe([1, 2, 3, 4], matcherW), 4);
 * assert.deepStrictEqual(pipe([], matcherW), "No elements");
 *
 * @category pattern matching
 * @since 2.11.0
 */ var $3a29b35b6ed31f29$var$matchW = function(onEmpty, onNonEmpty) {
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? onNonEmpty(as) : onEmpty();
    };
};
module.exports.matchW = $3a29b35b6ed31f29$var$matchW;
/**
 * Takes an array, if the array is empty it returns the result of `onEmpty`, otherwise
 * it passes the array to `onNonEmpty` and returns the result.
 *
 * @example
 * import { match } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * const matcher = match(
 *   () => "No elements",
 *   (as) => `Found ${as.length} element(s)`
 * );
 * assert.deepStrictEqual(pipe([1, 2, 3, 4], matcher), "Found 4 element(s)");
 * assert.deepStrictEqual(pipe([], matcher), "No elements");
 *
 * @category pattern matching
 * @since 2.11.0
 */ module.exports.match = module.exports.matchW;
/**
 * Less strict version of [`matchLeft`](#matchleft). It will work when `onEmpty` and
 * `onNonEmpty` have different return types.
 *
 * @example
 * import { matchLeftW } from 'fp-ts/Array'
 *
 * const f = matchLeftW(
 *   () => 0,
 *   (head: string, tail: string[]) => `Found "${head}" followed by ${tail.length} elements`
 * );
 * assert.strictEqual(f(["a", "b", "c"]), 'Found "a" followed by 2 elements');
 * assert.strictEqual(f([]), 0);
 *
 * @category pattern matching
 * @since 2.11.0
 */ var $3a29b35b6ed31f29$var$matchLeftW = function(onEmpty, onNonEmpty) {
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? onNonEmpty($3a29b35b6ed31f29$var$NEA.head(as), $3a29b35b6ed31f29$var$NEA.tail(as)) : onEmpty();
    };
};
module.exports.matchLeftW = $3a29b35b6ed31f29$var$matchLeftW;
/**
 * Takes an array, if the array is empty it returns the result of `onEmpty`, otherwise
 * it passes the array to `onNonEmpty` broken into its first element and remaining elements.
 *
 * @example
 * import { matchLeft } from 'fp-ts/Array'
 *
 * const len: <A>(as: Array<A>) => number = matchLeft(() => 0, (_, tail) => 1 + len(tail))
 * assert.strictEqual(len([1, 2, 3]), 3)
 *
 * @category pattern matching
 * @since 2.10.0
 */ module.exports.matchLeft = module.exports.matchLeftW;
/**
 * Alias of [`matchLeft`](#matchleft).
 *
 * @category pattern matching
 * @since 2.0.0
 */ module.exports.foldLeft = module.exports.matchLeft;
/**
 * Less strict version of [`matchRight`](#matchright). It will work when `onEmpty` and
 * `onNonEmpty` have different return types.
 *
 * @example
 * import { matchRightW } from 'fp-ts/Array'
 *
 * const f = matchRightW(
 *   () => 0,
 *   (head: string[], tail: string) => `Found ${head.length} elements folllowed by "${tail}"`
 * );
 * assert.strictEqual(f(["a", "b", "c"]), 'Found 2 elements folllowed by "c"');
 * assert.strictEqual(f([]), 0);
 *
 * @category pattern matching
 * @since 2.11.0
 */ var $3a29b35b6ed31f29$var$matchRightW = function(onEmpty, onNonEmpty) {
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? onNonEmpty($3a29b35b6ed31f29$var$NEA.init(as), $3a29b35b6ed31f29$var$NEA.last(as)) : onEmpty();
    };
};
module.exports.matchRightW = $3a29b35b6ed31f29$var$matchRightW;
/**
 * Takes an array, if the array is empty it returns the result of `onEmpty`, otherwise
 * it passes the array to `onNonEmpty` broken  into its initial elements and the last element.
 *
 * @example
 * import { matchRight } from 'fp-ts/Array'
 *
 * const len: <A>(as: Array<A>) => number = matchRight(
 *   () => 0,
 *   (head, _) => 1 + len(head)
 * );
 * assert.strictEqual(len([1, 2, 3]), 3);
 *
 * @category pattern matching
 * @since 2.10.0
 */ module.exports.matchRight = module.exports.matchRightW;
/**
 * Alias of [`matchRight`](#matchright).
 *
 * @category pattern matching
 * @since 2.0.0
 */ module.exports.foldRight = module.exports.matchRight;
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * Same as [`chain`](#chain), but passing also the index to the iterating function.
 *
 * @example
 * import { chainWithIndex, replicate } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (index: number, x: string) => replicate(2, `${x}${index}`);
 * assert.deepStrictEqual(pipe(["a", "b", "c"], chainWithIndex(f)), ["a0", "a0", "b1", "b1", "c2", "c2"]);
 *
 * @category sequencing
 * @since 2.7.0
 */ var $3a29b35b6ed31f29$var$chainWithIndex = function(f) {
    return function(as) {
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
module.exports.chainWithIndex = $3a29b35b6ed31f29$var$chainWithIndex;
/**
 * Same as `reduce` but it carries over the intermediate steps
 *
 * @example
 * import { scanLeft } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(scanLeft(10, (b, a: number) => b - a)([1, 2, 3]), [10, 9, 7, 4])
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$scanLeft = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
module.exports.scanLeft = $3a29b35b6ed31f29$var$scanLeft;
/**
 * Fold an array from the right, keeping all intermediate results instead of only the final result
 *
 * @example
 * import { scanRight } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(scanRight(10, (a: number, b) => b - a)([1, 2, 3]), [4, 5, 7, 10])
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$scanRight = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
module.exports.scanRight = $3a29b35b6ed31f29$var$scanRight;
/**
 * Calculate the number of elements in a `Array`.
 *
 * @example
 * import { size } from 'fp-ts/Array'
 *
 * assert.strictEqual(size(["a","b","c"]),3)
 *
 * @since 2.10.0
 */ var $3a29b35b6ed31f29$var$size = function(as) {
    return as.length;
};
module.exports.size = $3a29b35b6ed31f29$var$size;
/**
 * Test whether an array contains a particular index
 *
 * @example
 * import { isOutOfBound } from 'fp-ts/Array'
 *
 * assert.strictEqual(isOutOfBound(1,["a","b","c"]),false)
 * assert.strictEqual(isOutOfBound(-1,["a","b","c"]),true)
 * assert.strictEqual(isOutOfBound(3,["a","b","c"]),true)
 *
 * @since 2.0.0
 */ module.exports.isOutOfBound = $3a29b35b6ed31f29$var$NEA.isOutOfBound;
// TODO: remove non-curried overloading in v3
/**
 * This function provides a safe way to read a value at a particular index from an array.
 * It returns a `none` if the index is out of bounds, and a `some` of the element if the
 * index is valid.
 *
 * @example
 * import { lookup } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe([1, 2, 3], lookup(1)), some(2))
 * assert.deepStrictEqual(pipe([1, 2, 3], lookup(3)), none)
 *
 * @since 2.0.0
 */ module.exports.lookup = $3a29b35b6ed31f29$var$RA.lookup;
/**
 * Get the first element in an array, or `None` if the array is empty
 *
 * @example
 * import { head } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(head([1, 2, 3]), some(1))
 * assert.deepStrictEqual(head([]), none)
 *
 * @since 2.0.0
 */ module.exports.head = $3a29b35b6ed31f29$var$RA.head;
/**
 * Get the last element in an array, or `None` if the array is empty
 *
 * @example
 * import { last } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(last([1, 2, 3]), some(3))
 * assert.deepStrictEqual(last([]), none)
 *
 * @since 2.0.0
 */ module.exports.last = $3a29b35b6ed31f29$var$RA.last;
/**
 * Get all but the first element of an array, creating a new array, or `None` if the array is empty
 *
 * @example
 * import { tail } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(tail([1, 2, 3]), some([2, 3]))
 * assert.deepStrictEqual(tail([]), none)
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$tail = function(as) {
    return (0, module.exports.isNonEmpty)(as) ? $3a29b35b6ed31f29$var$_.some($3a29b35b6ed31f29$var$NEA.tail(as)) : $3a29b35b6ed31f29$var$_.none;
};
module.exports.tail = $3a29b35b6ed31f29$var$tail;
/**
 * Get all but the last element of an array, creating a new array, or `None` if the array is empty
 *
 * @example
 * import { init } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(init([1, 2, 3]), some([1, 2]))
 * assert.deepStrictEqual(init([]), none)
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$init = function(as) {
    return (0, module.exports.isNonEmpty)(as) ? $3a29b35b6ed31f29$var$_.some($3a29b35b6ed31f29$var$NEA.init(as)) : $3a29b35b6ed31f29$var$_.none;
};
module.exports.init = $3a29b35b6ed31f29$var$init;
/**
 * Keep only a max number of elements from the start of an `Array`, creating a new `Array`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { takeLeft } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(takeLeft(2)([1, 2, 3, 4, 5]), [1, 2]);
 * assert.deepStrictEqual(takeLeft(7)([1, 2, 3, 4, 5]), [1, 2, 3, 4, 5]);
 * assert.deepStrictEqual(takeLeft(0)([1, 2, 3, 4, 5]), []);
 * assert.deepStrictEqual(takeLeft(-1)([1, 2, 3, 4, 5]), [1, 2, 3, 4, 5]);
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$takeLeft = function(n) {
    return function(as) {
        return (0, module.exports.isOutOfBound)(n, as) ? (0, module.exports.copy)(as) : as.slice(0, n);
    };
};
module.exports.takeLeft = $3a29b35b6ed31f29$var$takeLeft;
/**
 * Keep only a max number of elements from the end of an `Array`, creating a new `Array`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { takeRight } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(takeRight(2)([1, 2, 3, 4, 5]), [4, 5]);
 * assert.deepStrictEqual(takeRight(7)([1, 2, 3, 4, 5]), [1, 2, 3, 4, 5]);
 * assert.deepStrictEqual(takeRight(0)([1, 2, 3, 4, 5]), []);
 * assert.deepStrictEqual(takeRight(-1)([1, 2, 3, 4, 5]), [1, 2, 3, 4, 5]);
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$takeRight = function(n) {
    return function(as) {
        return (0, module.exports.isOutOfBound)(n, as) ? (0, module.exports.copy)(as) : n === 0 ? [] : as.slice(-n);
    };
};
module.exports.takeRight = $3a29b35b6ed31f29$var$takeRight;
function $3a29b35b6ed31f29$var$takeLeftWhile(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        return out;
    };
}
var $3a29b35b6ed31f29$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $3a29b35b6ed31f29$var$spanLeft(predicate) {
    return function(as) {
        var _a = (0, module.exports.splitAt)($3a29b35b6ed31f29$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
/**
 * Creates a new `Array` which is a copy of the input dropping a max number of elements from the start.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { dropLeft } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(dropLeft(2)([1, 2, 3]), [3]);
 * assert.deepStrictEqual(dropLeft(5)([1, 2, 3]), []);
 * assert.deepStrictEqual(dropLeft(0)([1, 2, 3]), [1, 2, 3]);
 * assert.deepStrictEqual(dropLeft(-2)([1, 2, 3]), [1, 2, 3]);
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$dropLeft = function(n) {
    return function(as) {
        return n <= 0 || (0, module.exports.isEmpty)(as) ? (0, module.exports.copy)(as) : n >= as.length ? [] : as.slice(n, as.length);
    };
};
module.exports.dropLeft = $3a29b35b6ed31f29$var$dropLeft;
/**
 * Creates a new `Array` which is a copy of the input dropping a max number of elements from the end.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { dropRight } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(dropRight(2)([1, 2, 3]), [1]);
 * assert.deepStrictEqual(dropRight(5)([1, 2, 3]), []);
 * assert.deepStrictEqual(dropRight(0)([1, 2, 3]), [1, 2, 3]);
 * assert.deepStrictEqual(dropRight(-2)([1, 2, 3]), [1, 2, 3]);
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$dropRight = function(n) {
    return function(as) {
        return n <= 0 || (0, module.exports.isEmpty)(as) ? (0, module.exports.copy)(as) : n >= as.length ? [] : as.slice(0, as.length - n);
    };
};
module.exports.dropRight = $3a29b35b6ed31f29$var$dropRight;
function $3a29b35b6ed31f29$var$dropLeftWhile(predicate) {
    return function(as) {
        return as.slice($3a29b35b6ed31f29$var$spanLeftIndex(as, predicate));
    };
}
/**
 * `findIndex` returns an `Option` containing the first index for which a predicate holds.
 * It returns `None` if no element satisfies the predicate.
 * Similar to [`findFirst`](#findFirst) but returning the index instead of the element.
 *
 * @example
 * import { findIndex } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(findIndex((n: number) => n === 2)([1, 2, 3]), some(1))
 * assert.deepStrictEqual(findIndex((n: number) => n === 2)([]), none)
 *
 * @since 2.0.0
 */ module.exports.findIndex = $3a29b35b6ed31f29$var$RA.findIndex;
function $3a29b35b6ed31f29$var$findFirst(predicate) {
    return $3a29b35b6ed31f29$var$RA.findFirst(predicate);
}
/**
 * Given a selector function which takes an element and returns an option,
 * this function applies the selector to each element of the array and
 * returns the first `Some` result. Otherwise it returns `None`.
 *
 * @example
 * import { findFirstMap } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * interface Person {
 *   readonly name: string;
 *   readonly age: number;
 * }
 *
 * const persons: Array<Person> = [
 *   { name: "John", age: 16 },
 *   { name: "Mary", age: 45 },
 *   { name: "Joey", age: 28 },
 * ];
 *
 * const nameOfPersonAbove18 = (p: Person) => (p.age <= 18 ? none : some(p.name));
 * const nameOfPersonAbove70 = (p: Person) => (p.age <= 70 ? none : some(p.name));
 * assert.deepStrictEqual(findFirstMap(nameOfPersonAbove18)(persons), some("Mary"));
 * assert.deepStrictEqual(findFirstMap(nameOfPersonAbove70)(persons), none);
 *
 * @since 2.0.0
 */ module.exports.findFirstMap = $3a29b35b6ed31f29$var$RA.findFirstMap;
function $3a29b35b6ed31f29$var$findLast(predicate) {
    return $3a29b35b6ed31f29$var$RA.findLast(predicate);
}
/**
 * Given a selector function which takes an element and returns an option,
 * this function applies the selector to each element of the array starting from the
 * end and returns the last `Some` result. Otherwise it returns `None`.
 *
 * @example
 * import { findLastMap } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * interface Person {
 *   readonly name: string;
 *   readonly age: number;
 * }
 *
 * const persons: Array<Person> = [
 *   { name: "John", age: 16 },
 *   { name: "Mary", age: 45 },
 *   { name: "Joey", age: 28 },
 * ];
 *
 * const nameOfPersonAbove18 = (p: Person) => (p.age <= 18 ? none : some(p.name));
 * const nameOfPersonAbove70 = (p: Person) => (p.age <= 70 ? none : some(p.name));
 * assert.deepStrictEqual(findLastMap(nameOfPersonAbove18)(persons), some("Joey"));
 * assert.deepStrictEqual(findLastMap(nameOfPersonAbove70)(persons), none);
 *
 * @since 2.0.0
 */ module.exports.findLastMap = $3a29b35b6ed31f29$var$RA.findLastMap;
/**
 * Returns the index of the last element of the list which matches the predicate.
 * It returns an `Option` containing the index or `None` if not found.
 *
 * @example
 * import { findLastIndex } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * interface X {
 *   readonly a: number
 *   readonly b: number
 * }
 * const xs: Array<X> = [{ a: 1, b: 0 }, { a: 1, b: 1 }]
 * assert.deepStrictEqual(findLastIndex((x: { readonly a: number }) => x.a === 1)(xs), some(1))
 * assert.deepStrictEqual(findLastIndex((x: { readonly a: number }) => x.a === 4)(xs), none)
 *
 * @since 2.0.0
 */ module.exports.findLastIndex = $3a29b35b6ed31f29$var$RA.findLastIndex;
/**
 * This function takes an array and makes a new array containing the same elements.
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$copy = function(as) {
    return as.slice();
};
module.exports.copy = $3a29b35b6ed31f29$var$copy;
/**
 * Insert an element at the specified index, creating a new array,
 * or returning `None` if the index is out of bounds.
 *
 * @example
 * import { insertAt } from 'fp-ts/Array'
 * import { some } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(insertAt(2, 5)([1, 2, 3, 4]), some([1, 2, 5, 3, 4]))
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$insertAt = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $3a29b35b6ed31f29$var$_.none : $3a29b35b6ed31f29$var$_.some((0, module.exports.unsafeInsertAt)(i, a, as));
    };
};
module.exports.insertAt = $3a29b35b6ed31f29$var$insertAt;
/**
 * Change the element at the specified index, creating a new array,
 * or returning `None` if the index is out of bounds.
 *
 * @example
 * import { updateAt } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(updateAt(1, 1)([1, 2, 3]), some([1, 1, 3]))
 * assert.deepStrictEqual(updateAt(1, 1)([]), none)
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$updateAt = function(i, a) {
    return (0, module.exports.modifyAt)(i, function() {
        return a;
    });
};
module.exports.updateAt = $3a29b35b6ed31f29$var$updateAt;
/**
 * Delete the element at the specified index, creating a new array, or returning `None` if the index is out of bounds.
 *
 * @example
 * import { deleteAt } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(deleteAt(0)([1, 2, 3]), some([2, 3]))
 * assert.deepStrictEqual(deleteAt(1)([]), none)
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$deleteAt = function(i) {
    return function(as) {
        return (0, module.exports.isOutOfBound)(i, as) ? $3a29b35b6ed31f29$var$_.none : $3a29b35b6ed31f29$var$_.some((0, module.exports.unsafeDeleteAt)(i, as));
    };
};
module.exports.deleteAt = $3a29b35b6ed31f29$var$deleteAt;
/**
 * Apply a function to the element at the specified index, creating a new array, or returning `None` if the index is out
 * of bounds.
 *
 * @example
 * import { modifyAt } from 'fp-ts/Array'
 * import { some, none } from 'fp-ts/Option'
 *
 * const double = (x: number): number => x * 2
 * assert.deepStrictEqual(modifyAt(1, double)([1, 2, 3]), some([1, 4, 3]))
 * assert.deepStrictEqual(modifyAt(1, double)([]), none)
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$modifyAt = function(i, f) {
    return function(as) {
        return (0, module.exports.isOutOfBound)(i, as) ? $3a29b35b6ed31f29$var$_.none : $3a29b35b6ed31f29$var$_.some((0, module.exports.unsafeUpdateAt)(i, f(as[i]), as));
    };
};
module.exports.modifyAt = $3a29b35b6ed31f29$var$modifyAt;
/**
 * Reverse an array, creating a new array
 *
 * @example
 * import { reverse } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(reverse([1, 2, 3]), [3, 2, 1])
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$reverse = function(as) {
    return (0, module.exports.isEmpty)(as) ? [] : as.slice().reverse();
};
module.exports.reverse = $3a29b35b6ed31f29$var$reverse;
/**
 * Takes an `Array` of `Either` and produces a new `Array` containing
 * the values of all the `Right` elements in the same order.
 *
 * @example
 * import { rights } from 'fp-ts/Array'
 * import { right, left } from 'fp-ts/Either'
 *
 * assert.deepStrictEqual(rights([right(1), left('foo'), right(2)]), [1, 2])
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$rights = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
module.exports.rights = $3a29b35b6ed31f29$var$rights;
/**
 * Takes an `Array` of `Either` and produces a new `Array` containing
 * the values of all the `Left` elements in the same order.
 *
 * @example
 * import { lefts } from 'fp-ts/Array'
 * import { left, right } from 'fp-ts/Either'
 *
 * assert.deepStrictEqual(lefts([right(1), left('foo'), right(2)]), ['foo'])
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$lefts = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
module.exports.lefts = $3a29b35b6ed31f29$var$lefts;
/**
 * Sort the elements of an array in increasing order, creating a new array
 *
 * @example
 * import { sort } from 'fp-ts/Array'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(sort(N.Ord)([3, 2, 1]), [1, 2, 3])
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$sort = function(O) {
    return function(as) {
        return as.length <= 1 ? (0, module.exports.copy)(as) : as.slice().sort(O.compare);
    };
};
module.exports.sort = $3a29b35b6ed31f29$var$sort;
/**
 * Apply a function to pairs of elements at the same index in two arrays, collecting the results in a new array. If one
 * input array is short, excess elements of the longer array are discarded.
 *
 * @example
 * import { zipWith } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(zipWith([1, 2, 3], ['a', 'b', 'c', 'd'], (n, s) => s + n), ['a1', 'b2', 'c3'])
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$zipWith = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
module.exports.zipWith = $3a29b35b6ed31f29$var$zipWith;
function $3a29b35b6ed31f29$var$zip(as, bs) {
    if (bs === undefined) return function(bs) {
        return $3a29b35b6ed31f29$var$zip(bs, as);
    };
    return (0, module.exports.zipWith)(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
/**
 * The function is reverse of `zip`. Takes an array of pairs and return two corresponding arrays
 *
 * @example
 * import { unzip } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(unzip([[1, 'a'], [2, 'b'], [3, 'c']]), [[1, 2, 3], ['a', 'b', 'c']])
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$unzip = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
module.exports.unzip = $3a29b35b6ed31f29$var$unzip;
/**
 * Creates a new `Array`, prepending an element to every member of the input `Array`.
 *
 * @example
 * import { prependAll } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(prependAll(9)([1, 2, 3, 4]), [9, 1, 9, 2, 9, 3, 9, 4])
 *
 * @since 2.10.0
 */ var $3a29b35b6ed31f29$var$prependAll = function(middle) {
    var f = $3a29b35b6ed31f29$var$NEA.prependAll(middle);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? f(as) : [];
    };
};
module.exports.prependAll = $3a29b35b6ed31f29$var$prependAll;
/**
 * Creates a new `Array` placing an element in between members of the input `Array`.
 *
 * @example
 * import { intersperse } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(intersperse(9)([1, 2, 3, 4]), [1, 9, 2, 9, 3, 9, 4])
 *
 * @since 2.9.0
 */ var $3a29b35b6ed31f29$var$intersperse = function(middle) {
    var f = $3a29b35b6ed31f29$var$NEA.intersperse(middle);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? f(as) : (0, module.exports.copy)(as);
    };
};
module.exports.intersperse = $3a29b35b6ed31f29$var$intersperse;
/**
 * Creates a new `Array` rotating the input `Array` by `n` steps.
 *
 * @example
 * import { rotate } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(rotate(2)([1, 2, 3, 4, 5]), [4, 5, 1, 2, 3])
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$rotate = function(n) {
    var f = $3a29b35b6ed31f29$var$NEA.rotate(n);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? f(as) : (0, module.exports.copy)(as);
    };
};
module.exports.rotate = $3a29b35b6ed31f29$var$rotate;
// TODO: remove non-curried overloading in v3
/**
 * Test if a value is a member of an `Array`. Takes a `Eq<A>` as a single
 * argument which returns the function to use to search for a value of type `A` in
 * an `Array<A>`.
 *
 * @example
 * import { elem } from 'fp-ts/Array'
 * import * as N from 'fp-ts/number'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.strictEqual(pipe([1, 2, 3], elem(N.Eq)(2)), true)
 * assert.strictEqual(pipe([1, 2, 3], elem(N.Eq)(0)), false)
 *
 * @since 2.0.0
 */ module.exports.elem = $3a29b35b6ed31f29$var$RA.elem;
/**
 * Creates a new `Array` removing duplicate elements, keeping the first occurrence of an element,
 * based on a `Eq<A>`.
 *
 * @example
 * import { uniq } from 'fp-ts/Array'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(uniq(N.Eq)([1, 2, 1]), [1, 2])
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$uniq = function(E) {
    var f = $3a29b35b6ed31f29$var$NEA.uniq(E);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? f(as) : (0, module.exports.copy)(as);
    };
};
module.exports.uniq = $3a29b35b6ed31f29$var$uniq;
/**
 * Sort the elements of an array in increasing order, where elements are compared using first `ords[0]`, then `ords[1]`,
 * etc...
 *
 * @example
 * import { sortBy } from 'fp-ts/Array'
 * import { contramap } from 'fp-ts/Ord'
 * import * as S from 'fp-ts/string'
 * import * as N from 'fp-ts/number'
 * import { pipe } from 'fp-ts/function'
 *
 * interface Person {
 *   readonly name: string
 *   readonly age: number
 * }
 * const byName = pipe(S.Ord, contramap((p: Person) => p.name))
 * const byAge = pipe(N.Ord, contramap((p: Person) => p.age))
 *
 * const sortByNameByAge = sortBy([byName, byAge])
 *
 * const persons = [{ name: 'a', age: 1 }, { name: 'b', age: 3 }, { name: 'c', age: 2 }, { name: 'b', age: 2 }]
 * assert.deepStrictEqual(sortByNameByAge(persons), [
 *   { name: 'a', age: 1 },
 *   { name: 'b', age: 2 },
 *   { name: 'b', age: 3 },
 *   { name: 'c', age: 2 }
 * ])
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$sortBy = function(ords) {
    var f = $3a29b35b6ed31f29$var$NEA.sortBy(ords);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? f(as) : (0, module.exports.copy)(as);
    };
};
module.exports.sortBy = $3a29b35b6ed31f29$var$sortBy;
/**
 * A useful recursion pattern for processing an array to produce a new array, often used for "chopping" up the input
 * array. Typically chop is called with some function that will consume an initial prefix of the array and produce a
 * value and the rest of the array.
 *
 * @example
 * import { Eq } from 'fp-ts/Eq'
 * import * as A from 'fp-ts/Array'
 * import * as N from 'fp-ts/number'
 * import { pipe } from 'fp-ts/function'
 *
 * const group = <A>(S: Eq<A>): ((as: Array<A>) => Array<Array<A>>) => {
 *   return A.chop(as => {
 *     const { init, rest } = pipe(as, A.spanLeft((a: A) => S.equals(a, as[0])))
 *     return [init, rest]
 *   })
 * }
 * assert.deepStrictEqual(group(N.Eq)([1, 1, 2, 3, 3, 4]), [[1, 1], [2], [3, 3], [4]])
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$chop = function(f) {
    var g = $3a29b35b6ed31f29$var$NEA.chop(f);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? g(as) : [];
    };
};
module.exports.chop = $3a29b35b6ed31f29$var$chop;
/**
 * Splits an `Array` into two pieces, the first piece has max `n` elements.
 *
 * @example
 * import { splitAt } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(splitAt(2)([1, 2, 3, 4, 5]), [[1, 2], [3, 4, 5]])
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$splitAt = function(n) {
    return function(as) {
        return n >= 1 && (0, module.exports.isNonEmpty)(as) ? $3a29b35b6ed31f29$var$NEA.splitAt(n)(as) : (0, module.exports.isEmpty)(as) ? [
            (0, module.exports.copy)(as),
            []
        ] : [
            [],
            (0, module.exports.copy)(as)
        ];
    };
};
module.exports.splitAt = $3a29b35b6ed31f29$var$splitAt;
/**
 * Splits an array into length-`n` pieces. The last piece will be shorter if `n` does not evenly divide the length of
 * the array. Note that `chunksOf(n)([])` is `[]`, not `[[]]`. This is intentional, and is consistent with a recursive
 * definition of `chunksOf`; it satisfies the property that
 *
 * ```ts
 * chunksOf(n)(xs).concat(chunksOf(n)(ys)) == chunksOf(n)(xs.concat(ys)))
 * ```
 *
 * whenever `n` evenly divides the length of `xs`.
 *
 * @example
 * import { chunksOf } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(chunksOf(2)([1, 2, 3, 4, 5]), [[1, 2], [3, 4], [5]])
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$chunksOf = function(n) {
    var f = $3a29b35b6ed31f29$var$NEA.chunksOf(n);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? f(as) : [];
    };
};
module.exports.chunksOf = $3a29b35b6ed31f29$var$chunksOf;
/**
 * @category lifting
 * @since 2.11.0
 */ var $3a29b35b6ed31f29$var$fromOptionK = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return (0, module.exports.fromOption)(f.apply(void 0, a));
    };
};
module.exports.fromOptionK = $3a29b35b6ed31f29$var$fromOptionK;
function $3a29b35b6ed31f29$var$comprehension(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return (0, module.exports.isNonEmpty)(input) ? (0, module.exports.flatMap)($3a29b35b6ed31f29$var$NEA.head(input), function(a) {
            return go((0, $3abDJ.pipe)(scope, (0, module.exports.append)(a)), $3a29b35b6ed31f29$var$NEA.tail(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : [];
    };
    return go([], input);
}
/**
 * @since 2.11.0
 */ var $3a29b35b6ed31f29$var$concatW = function(second) {
    return function(first) {
        return (0, module.exports.isEmpty)(first) ? (0, module.exports.copy)(second) : (0, module.exports.isEmpty)(second) ? (0, module.exports.copy)(first) : first.concat(second);
    };
};
module.exports.concatW = $3a29b35b6ed31f29$var$concatW;
/**
 * @since 2.11.0
 */ module.exports.concat = module.exports.concatW;
function $3a29b35b6ed31f29$var$union(E) {
    var unionE = $3a29b35b6ed31f29$var$NEA.union(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $3a29b35b6ed31f29$var$union(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return (0, module.exports.isNonEmpty)(first) && (0, module.exports.isNonEmpty)(second) ? unionE(second)(first) : (0, module.exports.isNonEmpty)(first) ? (0, module.exports.copy)(first) : (0, module.exports.copy)(second);
    };
}
function $3a29b35b6ed31f29$var$intersection(E) {
    var elemE = (0, module.exports.elem)(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $3a29b35b6ed31f29$var$intersection(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $3a29b35b6ed31f29$var$difference(E) {
    var elemE = (0, module.exports.elem)(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $3a29b35b6ed31f29$var$difference(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $3a29b35b6ed31f29$var$_map = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.map)(f));
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_mapWithIndex = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.mapWithIndex)(f));
};
var $3a29b35b6ed31f29$var$_ap = function(fab, fa) {
    return (0, $3abDJ.pipe)(fab, (0, module.exports.ap)(fa));
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_filter = function(fa, predicate) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.filter)(predicate));
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_filterMap = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.filterMap)(f));
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_partition = function(fa, predicate) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.partition)(predicate));
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_partitionMap = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.partitionMap)(f));
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.partitionWithIndex)(predicateWithIndex));
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.partitionMapWithIndex)(f));
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_alt = function(fa, that) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.alt)(that));
};
var $3a29b35b6ed31f29$var$_reduce = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduce)(b, f));
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_foldMap = function(M) {
    var foldMapM = (0, module.exports.foldMap)(M);
    return function(fa, f) {
        return (0, $3abDJ.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_reduceRight = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduceRight)(b, f));
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduceWithIndex)(b, f));
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = (0, module.exports.foldMapWithIndex)(M);
    return function(fa, f) {
        return (0, $3abDJ.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduceRightWithIndex)(b, f));
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_filterMapWithIndex = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.filterMapWithIndex)(f));
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.filterWithIndex)(predicateWithIndex));
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_extend = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.extend)(f));
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_traverse = function(F) {
    var traverseF = (0, module.exports.traverse)(F);
    return function(ta, f) {
        return (0, $3abDJ.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $3a29b35b6ed31f29$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = (0, module.exports.traverseWithIndex)(F);
    return function(ta, f) {
        return (0, $3abDJ.pipe)(ta, traverseWithIndexF(f));
    };
};
var $3a29b35b6ed31f29$var$_chainRecDepthFirst = $3a29b35b6ed31f29$var$RA._chainRecDepthFirst;
var $3a29b35b6ed31f29$var$_chainRecBreadthFirst = $3a29b35b6ed31f29$var$RA._chainRecBreadthFirst;
/**
 * Given an element of the base type, `of` builds an `Array` containing just that
 * element of the base type (this is useful for building a `Monad`).
 *
 * @example
 * import { of } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(of("a"), ["a"]);
 *
 * @category constructors
 * @since 2.0.0
 */ module.exports.of = $3a29b35b6ed31f29$var$NEA.of;
/**
 * Makes an empty `Array`, useful for building a [`Monoid`](#Monoid)
 *
 * @since 2.7.0
 */ var $3a29b35b6ed31f29$var$zero = function() {
    return [];
};
module.exports.zero = $3a29b35b6ed31f29$var$zero;
/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: Array<A>) => Array<B>`.
 * In practice it applies the base function to each element of the array and collects the
 * results in a new array.
 *
 * @example
 * import { map } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (n: number) => n * 2;
 * assert.deepStrictEqual(pipe([1, 2, 3], map(f)), [2, 4, 6]);
 *
 * @category mapping
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$map = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
module.exports.map = $3a29b35b6ed31f29$var$map;
/**
 * @example
 * import { ap, map, of } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * // a curried function with 3 input parameteres
 * const f = (s1: string) => (n: number) => (s2: string) => s1 + n + s2;
 *
 * // let's use `ap` to iterate `f` over an array for each input parameter
 * assert.deepStrictEqual(pipe(["a", "b"], map(f), ap([1, 2]), ap(["😀", "😫", "😎"])), [
 *   "a1😀", "a1😫", "a1😎",
 *   "a2😀", "a2😫", "a2😎",
 *   "b1😀", "b1😫", "b1😎",
 *   "b2😀", "b2😫", "b2😎",
 * ]);
 *
 * // given Array implements the Applicative interface with the `of` method,
 * // we can write exactly the same thing in a more symmetric way
 * // using `of` on `f` and `ap` on each array in input
 * assert.deepStrictEqual(
 *   pipe(of(f), ap(["a", "b"]), ap([1, 2]), ap(["😀", "😫", "😎"])),
 *   pipe(["a", "b"], map(f), ap([1, 2]), ap(["😀", "😫", "😎"]))
 * );
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$ap = function(fa) {
    return (0, module.exports.flatMap)(function(f) {
        return (0, $3abDJ.pipe)(fa, (0, module.exports.map)(f));
    });
};
module.exports.ap = $3a29b35b6ed31f29$var$ap;
/**
 * Composes computations in sequence, using the return value of one computation to
 * determine the next computation.
 *
 * In other words it takes a function `f` that produces an array from a single element of
 * the base type `A` and returns a new function which applies `f` to each element of the
 * input array (like [`map`](#map)) and, instead of returning an array of arrays, concatenates the
 * results into a single array (like [`flatten`](#flatten)).
 *
 * @example
 * import { flatMap, map, replicate } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (n: number) => replicate(n, `${n}`);
 * assert.deepStrictEqual(pipe([1, 2, 3], map(f)), [["1"], ["2", "2"], ["3", "3", "3"]]);
 * assert.deepStrictEqual(pipe([1, 2, 3], flatMap(f)), ["1", "2", "2", "3", "3", "3"]);
 *
 * @category sequencing
 * @since 2.14.0
 */ module.exports.flatMap = (0, $3abDJ.dual)(2, function(ma, f) {
    return (0, $3abDJ.pipe)(ma, (0, module.exports.chainWithIndex)(function(i, a) {
        return f(a, i);
    }));
});
/**
 * Takes an array of arrays of `A` and flattens them into an array of `A`
 * by concatenating the elements of each array in order.
 *
 * @example
 * import { flatten } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(flatten([["a"], ["b", "c"], ["d", "e", "f"]]), ["a", "b", "c", "d", "e", "f"]);
 *
 * @category sequencing
 * @since 2.5.0
 */ module.exports.flatten = (0, module.exports.flatMap)($3abDJ.identity);
/**
 * Same as [`map`](#map), but the iterating function takes both the index and the value
 * of the element.
 *
 * @example
 * import { mapWithIndex } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (i: number, s: string) => `${s} - ${i}`;
 * assert.deepStrictEqual(pipe(["a", "b", "c"], mapWithIndex(f)), ["a - 0", "b - 1", "c - 2"]);
 *
 * @category mapping
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$mapWithIndex = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
module.exports.mapWithIndex = $3a29b35b6ed31f29$var$mapWithIndex;
/**
 * Maps an array with an iterating function that takes the index and the value of
 * each element and returns an `Option`. It keeps only the `Some` values discarding
 * the `None`s.
 *
 * Same as [`filterMap`](#filterMap), but with an iterating function which takes also
 * the index as input.
 *
 * @example
 * import { filterMapWithIndex } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 * import { option } from "fp-ts";
 *
 * const f = (i: number, s: string) => (i % 2 === 1 ? option.some(s.toUpperCase()) : option.none);
 * assert.deepStrictEqual(pipe(["a", "no", "neither", "b"], filterMapWithIndex(f)), ["NO", "B"]);
 *
 * @category filtering
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$filterMapWithIndex = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($3a29b35b6ed31f29$var$_.isSome(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
module.exports.filterMapWithIndex = $3a29b35b6ed31f29$var$filterMapWithIndex;
/**
 * Maps an array with an iterating function that returns an `Option`
 * and it keeps only the `Some` values discarding the `None`s.
 *
 * @example
 * import { filterMap } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 * import { option } from "fp-ts";
 *
 * const f = (s: string) => s.length === 1 ? option.some(s.toUpperCase()) : option.none;
 * assert.deepStrictEqual(pipe(["a", "no", "neither", "b"], filterMap(f)), ["A", "B"]);
 *
 * @category filtering
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$filterMap = function(f) {
    return (0, module.exports.filterMapWithIndex)(function(_, a) {
        return f(a);
    });
};
module.exports.filterMap = $3a29b35b6ed31f29$var$filterMap;
/**
 * Compact an array of `Option`s discarding the `None` values and
 * keeping the `Some` values. It returns a new array containing the values of
 * the `Some` options.
 *
 * @example
 * import { compact } from 'fp-ts/Array'
 * import { option } from "fp-ts";
 *
 * assert.deepStrictEqual(compact([option.some("a"), option.none, option.some("b")]), ["a", "b"]);
 *
 * @category filtering
 * @since 2.0.0
 */ module.exports.compact = (0, module.exports.filterMap)($3abDJ.identity);
/**
 * Separate an array of `Either`s into `Left`s and `Right`s, creating two new arrays:
 * one containing all the left values and one containing all the right values.
 *
 * @example
 * import { separate } from 'fp-ts/Array'
 * import { either } from "fp-ts";
 *
 * assert.deepStrictEqual(separate([either.right("r1"), either.left("l1"), either.right("r2")]), {
 *   left: ["l1"],
 *   right: ["r1", "r2"],
 * });
 *
 * @category filtering
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$separate = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $fIQoU.separated)(left, right);
};
module.exports.separate = $3a29b35b6ed31f29$var$separate;
/**
 * Given an iterating function that is a `Predicate` or a `Refinement`,
 * `filter` creates a new `Array` containing the elements of the original
 * `Array` for which the iterating function is `true`.
 *
 * @example
 * import { filter } from 'fp-ts/Array'
 * import { isString } from "fp-ts/string";
 *
 * assert.deepStrictEqual(filter(isString)(["a", 1, {}, "b", 5]), ["a", "b"]);
 * assert.deepStrictEqual(filter((x:number) => x > 0)([-3, 1, -2, 5]), [1, 5]);
 *
 * @category filtering
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$filter = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
module.exports.filter = $3a29b35b6ed31f29$var$filter;
/**
 * Given an iterating function that is a `Predicate` or a `Refinement`,
 * `partition` creates two new `Array`s: `right` containing the elements of the original
 * `Array` for which the iterating function is `true`, `left` containing the elements
 * for which it is false.
 *
 * @example
 * import { partition } from 'fp-ts/Array'
 * import { isString } from "fp-ts/string";
 *
 * assert.deepStrictEqual(partition(isString)(["a", 1, {}, "b", 5]), { left: [1, {}, 5], right: ["a", "b"] });
 * assert.deepStrictEqual(partition((x: number) => x > 0)([-3, 1, -2, 5]), { left: [-3, -2], right: [1, 5] });
 *
 * @category filtering
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$partition = function(predicate) {
    return (0, module.exports.partitionWithIndex)(function(_, a) {
        return predicate(a);
    });
};
module.exports.partition = $3a29b35b6ed31f29$var$partition;
/**
 * Same as [`partition`](#partition), but passing also the index to the iterating function.
 *
 * @example
 * import { partitionWithIndex } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(partitionWithIndex((index, x: number) => index < 3 && x > 0)([-2, 5, 6, 7]), {
 *   left: [-2, 7],
 *   right: [5, 6],
 * });
 *
 * @category filtering
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$partitionWithIndex = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var b = as[i];
            if (predicateWithIndex(i, b)) right.push(b);
            else left.push(b);
        }
        return (0, $fIQoU.separated)(left, right);
    };
};
module.exports.partitionWithIndex = $3a29b35b6ed31f29$var$partitionWithIndex;
/**
 * Given an iterating function that returns an `Either`,
 * `partitionMap` applies the iterating function to each element and it creates two `Array`s:
 * `right` containing the values of `Right` results, `left` containing the values of `Left` results.
 *
 * @example
 * import { partitionMap } from 'fp-ts/Array'
 * import { Either, left, right } from "fp-ts/Either";
 *
 * const upperIfString = <B>(x: B): Either<B, string> =>
 *   typeof x === "string" ? right(x.toUpperCase()) : left(x);
 * assert.deepStrictEqual(partitionMap(upperIfString)([-2, "hello", 6, 7, "world"]), {
 *   left: [-2, 6, 7],
 *   right: [ 'HELLO', 'WORLD' ],
 * });
 *
 * @category filtering
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$partitionMap = function(f) {
    return (0, module.exports.partitionMapWithIndex)(function(_, a) {
        return f(a);
    });
};
module.exports.partitionMap = $3a29b35b6ed31f29$var$partitionMap;
/**
 * Same as [`partitionMap`](#partitionMap), but passing also the index to the iterating function.
 *
 * @example
 * import { partitionMapWithIndex } from 'fp-ts/Array'
 * import { Either, left, right } from "fp-ts/Either";
 *
 * const upperIfStringBefore3 = <B>(index: number, x: B): Either<B, string> =>
 *   index < 3 && typeof x === "string" ? right(x.toUpperCase()) : left(x);
 * assert.deepStrictEqual(partitionMapWithIndex(upperIfStringBefore3)([-2, "hello", 6, 7, "world"]), {
 *   left: [-2, 6, 7, "world"],
 *   right: ["HELLO"],
 * });
 *
 * @category filtering
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$partitionMapWithIndex = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $fIQoU.separated)(left, right);
    };
};
module.exports.partitionMapWithIndex = $3a29b35b6ed31f29$var$partitionMapWithIndex;
/**
 * Less strict version of [`alt`](#alt).
 *
 * The `W` suffix (short for **W**idening) means that the return types will be merged.
 *
 * @example
 * import * as A from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3],
 *     A.altW(() => ['a', 'b'])
 *   ),
 *   [1, 2, 3, 'a', 'b']
 * )
 *
 * @category error handling
 * @since 2.9.0
 */ var $3a29b35b6ed31f29$var$altW = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
module.exports.altW = $3a29b35b6ed31f29$var$altW;
/**
 * Identifies an associative operation on a type constructor. It is similar to `Semigroup`, except that it applies to
 * types of kind `* -> *`.
 *
 * In case of `Array` concatenates the inputs into a single array.
 *
 * @example
 * import * as A from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3],
 *     A.alt(() => [4, 5])
 *   ),
 *   [1, 2, 3, 4, 5]
 * )
 *
 * @category error handling
 * @since 2.0.0
 */ module.exports.alt = module.exports.altW;
/**
 * Same as [`filter`](#filter), but passing also the index to the iterating function.
 *
 * @example
 * import { filterWithIndex } from 'fp-ts/Array';
 *
 * const f = (index: number, x: number) => x > 0 && index <= 2;
 * assert.deepStrictEqual(filterWithIndex(f)([-3, 1, -2, 5]), [1]);
 *
 * @category filtering
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$filterWithIndex = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(b, i) {
            return predicateWithIndex(i, b);
        });
    };
};
module.exports.filterWithIndex = $3a29b35b6ed31f29$var$filterWithIndex;
/**
 * Given an iterating function that takes `Array<A>` as input, `extend` returns
 * an array containing the results of the iterating function applied to the whole input
 * `Array`, then to the input `Array` without the first element, then to the input
 * `Array` without the first two elements, etc.
 *
 * @example
 * import { extend } from 'fp-ts/Array'
 *
 * const f = (a: string[]) => a.join(",");
 * assert.deepStrictEqual(extend(f)(["a", "b", "c"]), ["a,b,c", "b,c", "c"]);
 *
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$extend = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
module.exports.extend = $3a29b35b6ed31f29$var$extend;
/**
 * `duplicate` returns an array containing the whole input `Array`,
 * then to the input `Array` dropping the first element, then to the input
 * `Array` dropping the first two elements, etc.
 *
 * @example
 * import { duplicate } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(duplicate(["a", "b", "c"]), [["a", "b", "c"], ["b", "c"], ["c"]]);
 *
 * @since 2.0.0
 */ module.exports.duplicate = (0, module.exports.extend)($3abDJ.identity);
/**
 * Map and fold an `Array`.
 * Map the `Array` passing each value to the iterating function.
 * Then fold the results using the provided `Monoid`.
 *
 * @example
 * import { foldMap } from 'fp-ts/Array'
 *
 * const monoid = { concat: (a: string, b: string) => a + b, empty: "" };
 * const f = (s: string) => s.toUpperCase()
 * assert.deepStrictEqual(foldMap(monoid)(f)(["a", "b", "c"]), "ABC");
 *
 * @category folding
 * @since 2.0.0
 */ module.exports.foldMap = $3a29b35b6ed31f29$var$RA.foldMap;
/**
 * Same as [`foldMap`](#foldMap) but passing also the index to the iterating function.
 *
 * @example
 * import { foldMapWithIndex } from 'fp-ts/Array'
 *
 * const monoid = { concat: (a: string, b: string) => a + b, empty: "" };
 * const f = (index:number, s: string) => `${s.toUpperCase()}(${index})`
 * assert.deepStrictEqual(foldMapWithIndex(monoid)(f)(["a", "b", "c"]), "A(0)B(1)C(2)");
 *
 * @category folding
 * @since 2.0.0
 */ module.exports.foldMapWithIndex = $3a29b35b6ed31f29$var$RA.foldMapWithIndex;
/**
 * Reduces an `Array`.
 *
 * `reduce` executes the supplied iterating function on each element of the array,
 * in order, passing in the element and the return value from the calculation on the preceding element.
 *
 * The first time that the iterating function is called there is no "return value of the
 * previous calculation", the initial value is used in its place.
 *
 * @example
 * import { reduce } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(reduce(5, (acc: number, cur: number) => acc * cur)([2, 3]), 5 * 2 * 3);
 *
 * @category folding
 * @since 2.0.0
 */ module.exports.reduce = $3a29b35b6ed31f29$var$RA.reduce;
/**
 * Same as [`reduce`](#reduce) but passing also the index to the iterating function.
 *
 * @example
 * import { reduceWithIndex } from 'fp-ts/Array'
 *
 * const f = (index: number, acc: string, cur: unknown) =>
 *   acc + (typeof cur === "string" ? cur.toUpperCase() + index : "");
 * assert.deepStrictEqual(reduceWithIndex("", f)([2, "a", "b", null]), "A1B2");
 *
 * @category folding
 * @since 2.0.0
 */ module.exports.reduceWithIndex = $3a29b35b6ed31f29$var$RA.reduceWithIndex;
/**
 * Same as [`reduce`](#reduce) but applied from the end to the start.
 *
 * *Note*: the iterating function in this case takes the accumulator as the last argument.
 *
 * @example
 * import { reduceRight } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(reduceRight("", (cur: string, acc: string) => acc + cur)(["a", "b", "c"]), "cba");
 *
 * @category folding
 * @since 2.0.0
 */ module.exports.reduceRight = $3a29b35b6ed31f29$var$RA.reduceRight;
/**
 * Same as [`reduceRight`](#reduceRight) but passing also the index to the iterating function.
 *
 * @example
 * import { reduceRightWithIndex } from 'fp-ts/Array'
 *
 * const f = (index: number, cur: unknown, acc: string) =>
 *   acc + (typeof cur === "string" ? cur.toUpperCase() + index : "");
 * assert.deepStrictEqual(reduceRightWithIndex("", f)([2, "a", "b", null]), "B2A1");
 *
 * @category folding
 * @since 2.0.0
 */ module.exports.reduceRightWithIndex = $3a29b35b6ed31f29$var$RA.reduceRightWithIndex;
/**
 * Given an iterating function that returns a `HKT` (higher kinded type), `traverse`
 * applies the iterating function to each element of the `Array` and then [`sequence`](#sequence)-s
 * the results using the provided `Applicative`.
 *
 * E.g. suppose you have an `Array` and you want to format each element with a function
 * that returns a result or an error as `f = (a: A) => Either<Error, B>`, using `traverse`
 * you can apply `f` to all elements and directly obtain as a result an `Either<Error,Array<B>>`
 * i.e. an `Array<B>` if all the results are `B`, or an `Error` if some of the results
 * are `Error`s.
 *
 * @example
 * import { traverse } from 'fp-ts/Array'
 * import { Applicative, left, right } from "fp-ts/Either";
 *
 * const f = (x: unknown) =>
 *   typeof x === "string" ? right(x.toUpperCase()) : left(new Error("not a string"));
 * assert.deepStrictEqual(traverse(Applicative)(f)(["a", "b"]), right(["A", "B"]));
 * assert.deepStrictEqual(traverse(Applicative)(f)(["a", 5]), left(new Error("not a string")));
 *
 * @category traversing
 * @since 2.6.3
 */ var $3a29b35b6ed31f29$var$traverse = function(F) {
    var traverseWithIndexF = (0, module.exports.traverseWithIndex)(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
module.exports.traverse = $3a29b35b6ed31f29$var$traverse;
/**
 * `sequence` takes an `Array` where elements are `HKT<A>` (higher kinded type) and,
 * using an applicative of that `HKT`, returns an `HKT` of `Array<A>`.
 * E.g. it can turn an `Array<Either<Error, string>>` into an `Either<Error, Array<string>>`.
 *
 * `sequence` requires an `Applicative` of the `HKT` you are targeting, e.g. to turn an
 * `Array<Either<E, A>>` into an `Either<E, Array<A>>`, it needs an
 * `Applicative` for `Either`, to to turn an `Array<Option<A>>` into an `Option<Array<A>>`,
 * it needs an `Applicative` for `Option`.
 *
 * @example
 * import { sequence } from 'fp-ts/Array'
 * import { Applicative, left, right } from "fp-ts/Either";
 *
 * assert.deepStrictEqual(sequence(Applicative)([right("a"), right("b")]), right(["a", "b"]));
 * assert.deepStrictEqual(
 *   sequence(Applicative)([right("a"), left(new Error("not a string"))]),
 *   left(new Error("not a string"))
 * );
 *
 * @category traversing
 * @since 2.6.3
 */ var $3a29b35b6ed31f29$var$sequence = function(F) {
    return function(ta) {
        return $3a29b35b6ed31f29$var$_reduce(ta, F.of((0, module.exports.zero)()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $3abDJ.pipe)(as, (0, module.exports.append)(a));
                };
            }), fa);
        });
    };
};
module.exports.sequence = $3a29b35b6ed31f29$var$sequence;
/**
 * Same as [`traverse`](#traverse) but passing also the index to the iterating function.
 *
 * @example
 * import { traverseWithIndex } from 'fp-ts/Array'
 * import { Applicative, left, right } from "fp-ts/Either";
 *
 * const f = (index:number, x:unknown) =>
 *   typeof x === "string" ? right(x.toUpperCase() + index) : left(new Error("not a string"));
 * assert.deepStrictEqual(traverseWithIndex(Applicative)(f)(["a", "b"]), right(["A0", "B1"]));
 * assert.deepStrictEqual(traverseWithIndex(Applicative)(f)(["a", 5]), left(new Error("not a string")));
 *
 * @category sequencing
 * @since 2.6.3
 */ var $3a29b35b6ed31f29$var$traverseWithIndex = function(F) {
    return function(f) {
        return (0, module.exports.reduceWithIndex)(F.of((0, module.exports.zero)()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $3abDJ.pipe)(bs, (0, module.exports.append)(b));
                };
            }), f(i, a));
        });
    };
};
module.exports.traverseWithIndex = $3a29b35b6ed31f29$var$traverseWithIndex;
/**
 * @category filtering
 * @since 2.6.5
 */ var $3a29b35b6ed31f29$var$wither = function(F) {
    var _witherF = $3a29b35b6ed31f29$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
module.exports.wither = $3a29b35b6ed31f29$var$wither;
/**
 * @category filtering
 * @since 2.6.5
 */ var $3a29b35b6ed31f29$var$wilt = function(F) {
    var _wiltF = $3a29b35b6ed31f29$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
module.exports.wilt = $3a29b35b6ed31f29$var$wilt;
/**
 * `unfold` takes a function `f` which returns an `Option` of a tuple containing an outcome
 * value and an input for the following iteration.
 * `unfold` applies `f` to the initial value `b` and then recursively to the second
 * element of the tuple contained in the returned `option` of the previous
 * calculation until `f` returns `Option.none`.
 *
 * @example
 * import { unfold } from 'fp-ts/Array'
 * import { option } from 'fp-ts'
 *
 * const f = (n: number) => {
 *   if (n <= 0) return option.none;
 *   const returnValue = n * 2;
 *   const inputForNextRound = n - 1;
 *   return option.some([returnValue, inputForNextRound] as const);
 * };
 * assert.deepStrictEqual(unfold(5, f), [10, 8, 6, 4, 2]);
 *
 * @since 2.6.6
 */ var $3a29b35b6ed31f29$var$unfold = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($3a29b35b6ed31f29$var$_.isSome(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
module.exports.unfold = $3a29b35b6ed31f29$var$unfold;
/**
 * @category type lambdas
 * @since 2.0.0
 */ module.exports.URI = 'Array';
/**
 * `getShow` makes a `Show` for an `Array<A>` from a `Show` for
 * an `A`.
 *
 * @example
 * import { getShow } from 'fp-ts/Array'
 *
 * const numShow = { show: (n: number) => (n >= 0 ? `${n}` : `(${-n})`) };
 * assert.deepStrictEqual(getShow(numShow).show([-2, -1, 0, 1]), "[(2), (1), 0, 1]");
 *
 * @category instances
 * @since 2.0.0
 */ module.exports.getShow = $3a29b35b6ed31f29$var$RA.getShow;
/**
 * Get a `Semigroup` based on the concatenation of `Array`s.
 * See also [`getMonoid`](#getMonoid).
 *
 * @example
 * import { getSemigroup } from 'fp-ts/Array'
 *
 * const S = getSemigroup<number>();
 * assert.deepStrictEqual(S.concat([1, 2], [2, 3]), [1, 2, 2, 3]);
 *
 * @category instances
 * @since 2.10.0
 */ var $3a29b35b6ed31f29$var$getSemigroup = function() {
    return {
        concat: function(first, second) {
            return first.concat(second);
        }
    };
};
module.exports.getSemigroup = $3a29b35b6ed31f29$var$getSemigroup;
/**
 * Returns a `Monoid` for `Array<A>` based on the concatenation of `Array`s.
 *
 * @example
 * import { getMonoid } from 'fp-ts/Array'
 *
 * const M = getMonoid<number>()
 * assert.deepStrictEqual(M.concat([1, 2], [3, 4]), [1, 2, 3, 4])
 *
 * @category instances
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$getMonoid = function() {
    return {
        concat: (0, module.exports.getSemigroup)().concat,
        empty: []
    };
};
module.exports.getMonoid = $3a29b35b6ed31f29$var$getMonoid;
/**
 * Derives an `Eq` over the `Array` of a given element type from the `Eq` of that type. The derived `Eq` defines two
 * arrays as equal if all elements of both arrays are compared equal pairwise with the given `E`. In case of arrays of
 * different lengths, the result is non equality.
 *
 * @example
 * import * as S from 'fp-ts/string'
 * import { getEq } from 'fp-ts/Array'
 *
 * const E = getEq(S.Eq)
 * assert.strictEqual(E.equals(['a', 'b'], ['a', 'b']), true)
 * assert.strictEqual(E.equals(['a'], []), false)
 *
 * @category instances
 * @since 2.0.0
 */ module.exports.getEq = $3a29b35b6ed31f29$var$RA.getEq;
/**
 * Derives an `Ord` over the `Array` of a given element type from the `Ord` of that type. The ordering between two such
 * arrays is equal to: the first non equal comparison of each arrays elements taken pairwise in increasing order, in
 * case of equality over all the pairwise elements; the longest array is considered the greatest, if both arrays have
 * the same length, the result is equality.
 *
 * @example
 * import { getOrd } from 'fp-ts/Array'
 * import * as S from 'fp-ts/string'
 *
 * const O = getOrd(S.Ord)
 * assert.strictEqual(O.compare(['b'], ['a']), 1)
 * assert.strictEqual(O.compare(['a'], ['a']), 0)
 * assert.strictEqual(O.compare(['a'], ['b']), -1)
 *
 * @category instances
 * @since 2.0.0
 */ module.exports.getOrd = $3a29b35b6ed31f29$var$RA.getOrd;
/**
 * Get a `Semigroup` based on the union of the elements of `Array`s.
 * Elements which equal according to the provided `Eq` are included
 * only once in the result.
 * See also [`getUnionMonoid`](#getUnionMonoid).
 *
 * @example
 * import { getUnionSemigroup } from 'fp-ts/Array';
 * import { Eq } from 'fp-ts/number';
 *
 * const S = getUnionSemigroup<number>(Eq);
 * assert.deepStrictEqual(S.concat([1, 2], [2, 3]), [1, 2, 3]);
 *
 * @category instances
 * @since 2.11.0
 */ var $3a29b35b6ed31f29$var$getUnionSemigroup = function(E) {
    var unionE = $3a29b35b6ed31f29$var$union(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
module.exports.getUnionSemigroup = $3a29b35b6ed31f29$var$getUnionSemigroup;
/**
 * Get a `Monoid` based on the union of the elements of `Array`s.
 * Elements which equal according to the provided `Eq` are included
 * only once in the result.
 *
 * @example
 * import { getUnionMonoid } from 'fp-ts/Array'
 * import { Eq } from 'fp-ts/number';
 *
 * const M = getUnionMonoid<number>(Eq);
 * assert.deepStrictEqual(M.concat([1, 2], [2, 3]), [1, 2, 3]);
 * assert.deepStrictEqual(M.empty,[]);
 *
 * @category instances
 * @since 2.11.0
 */ var $3a29b35b6ed31f29$var$getUnionMonoid = function(E) {
    return {
        concat: (0, module.exports.getUnionSemigroup)(E).concat,
        empty: []
    };
};
module.exports.getUnionMonoid = $3a29b35b6ed31f29$var$getUnionMonoid;
/**
 * Get a `Semigroup` based on the intersection of the elements of `Array`s.
 * Only elements present in the two arrays which are equal according to the
 * provided `Eq` are included in the result.
 *
 * @example
 * import { getIntersectionSemigroup } from 'fp-ts/Array'
 * import { Eq } from 'fp-ts/number';
 *
 * const S = getIntersectionSemigroup<number>(Eq);
 * assert.deepStrictEqual(S.concat([1, 2], [2, 3]), [2]);
 *
 * @category instances
 * @since 2.11.0
 */ var $3a29b35b6ed31f29$var$getIntersectionSemigroup = function(E) {
    var intersectionE = $3a29b35b6ed31f29$var$intersection(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
module.exports.getIntersectionSemigroup = $3a29b35b6ed31f29$var$getIntersectionSemigroup;
/**
 * Get a `Magma` for `Array` where the `concat` function is the differnce between
 * the first and the second array, i.e. the result contains all the elements of the
 * first array for which their is no equal element in the second array according
 * to the `Eq` provided.
 *
 *
 * @example
 * import { getDifferenceMagma } from 'fp-ts/Array'
 * import { Eq } from 'fp-ts/number';
 *
 * const S = getDifferenceMagma<number>(Eq);
 * assert.deepStrictEqual(S.concat([1, 2], [2, 3]), [1]);
 *
 * @category instances
 * @since 2.11.0
 */ var $3a29b35b6ed31f29$var$getDifferenceMagma = function(E) {
    var differenceE = $3a29b35b6ed31f29$var$difference(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
module.exports.getDifferenceMagma = $3a29b35b6ed31f29$var$getDifferenceMagma;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Functor = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map
};
/**
 * Given an input an `Array` of functions, `flap` returns an `Array` containing
 * the results of applying each function to the given input.
 *
 * @example
 * import { flap } from 'fp-ts/Array'
 *
 * const funs = [
 *   (n: number) => `Double: ${n * 2}`,
 *   (n: number) => `Triple: ${n * 3}`,
 *   (n: number) => `Square: ${n * n}`,
 * ];
 * assert.deepStrictEqual(flap(4)(funs), ['Double: 8', 'Triple: 12', 'Square: 16']);
 *
 * @category mapping
 * @since 2.10.0
 */ module.exports.flap = (0, $emm1u.flap)(module.exports.Functor);
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Pointed = {
    URI: module.exports.URI,
    of: module.exports.of
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.FunctorWithIndex = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map,
    mapWithIndex: $3a29b35b6ed31f29$var$_mapWithIndex
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Apply = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map,
    ap: $3a29b35b6ed31f29$var$_ap
};
/**
 * Combine two effectful actions, keeping only the result of the first.
 *
 * @since 2.5.0
 */ module.exports.apFirst = (0, $4sfjE.apFirst)(module.exports.Apply);
/**
 * Combine two effectful actions, keeping only the result of the second.
 *
 * @since 2.5.0
 */ module.exports.apSecond = (0, $4sfjE.apSecond)(module.exports.Apply);
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Applicative = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map,
    ap: $3a29b35b6ed31f29$var$_ap,
    of: module.exports.of
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Chain = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map,
    ap: $3a29b35b6ed31f29$var$_ap,
    chain: module.exports.flatMap
};
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * @example
 * import * as A from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3],
 *     A.chainFirst(() => ['a', 'b'])
 *   ),
 *   [1, 1, 2, 2, 3, 3]
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3],
 *     A.chainFirst(() => [])
 *   ),
 *   []
 * )
 *
 * @category sequencing
 * @since 2.0.0
 */ module.exports.chainFirst = /*#__PURE__*/ (0, $ERVGH.chainFirst)(module.exports.Chain);
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Monad = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map,
    ap: $3a29b35b6ed31f29$var$_ap,
    of: module.exports.of,
    chain: module.exports.flatMap
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Unfoldable = {
    URI: module.exports.URI,
    unfold: module.exports.unfold
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Alt = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map,
    alt: $3a29b35b6ed31f29$var$_alt
};
/**
 * @category instances
 * @since 2.11.0
 */ module.exports.Zero = {
    URI: module.exports.URI,
    zero: module.exports.zero
};
/**
 * @category do notation
 * @since 2.11.0
 */ module.exports.guard = (0, $iV0VO.guard)(module.exports.Zero, module.exports.Pointed);
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Alternative = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map,
    ap: $3a29b35b6ed31f29$var$_ap,
    of: module.exports.of,
    alt: $3a29b35b6ed31f29$var$_alt,
    zero: module.exports.zero
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Extend = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map,
    extend: $3a29b35b6ed31f29$var$_extend
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Compactable = {
    URI: module.exports.URI,
    compact: module.exports.compact,
    separate: module.exports.separate
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Filterable = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map,
    compact: module.exports.compact,
    separate: module.exports.separate,
    filter: $3a29b35b6ed31f29$var$_filter,
    filterMap: $3a29b35b6ed31f29$var$_filterMap,
    partition: $3a29b35b6ed31f29$var$_partition,
    partitionMap: $3a29b35b6ed31f29$var$_partitionMap
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.FilterableWithIndex = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map,
    mapWithIndex: $3a29b35b6ed31f29$var$_mapWithIndex,
    compact: module.exports.compact,
    separate: module.exports.separate,
    filter: $3a29b35b6ed31f29$var$_filter,
    filterMap: $3a29b35b6ed31f29$var$_filterMap,
    partition: $3a29b35b6ed31f29$var$_partition,
    partitionMap: $3a29b35b6ed31f29$var$_partitionMap,
    partitionMapWithIndex: $3a29b35b6ed31f29$var$_partitionMapWithIndex,
    partitionWithIndex: $3a29b35b6ed31f29$var$_partitionWithIndex,
    filterMapWithIndex: $3a29b35b6ed31f29$var$_filterMapWithIndex,
    filterWithIndex: $3a29b35b6ed31f29$var$_filterWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Foldable = {
    URI: module.exports.URI,
    reduce: $3a29b35b6ed31f29$var$_reduce,
    foldMap: $3a29b35b6ed31f29$var$_foldMap,
    reduceRight: $3a29b35b6ed31f29$var$_reduceRight
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.FoldableWithIndex = {
    URI: module.exports.URI,
    reduce: $3a29b35b6ed31f29$var$_reduce,
    foldMap: $3a29b35b6ed31f29$var$_foldMap,
    reduceRight: $3a29b35b6ed31f29$var$_reduceRight,
    reduceWithIndex: $3a29b35b6ed31f29$var$_reduceWithIndex,
    foldMapWithIndex: $3a29b35b6ed31f29$var$_foldMapWithIndex,
    reduceRightWithIndex: $3a29b35b6ed31f29$var$_reduceRightWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Traversable = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map,
    reduce: $3a29b35b6ed31f29$var$_reduce,
    foldMap: $3a29b35b6ed31f29$var$_foldMap,
    reduceRight: $3a29b35b6ed31f29$var$_reduceRight,
    traverse: $3a29b35b6ed31f29$var$_traverse,
    sequence: module.exports.sequence
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.TraversableWithIndex = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map,
    mapWithIndex: $3a29b35b6ed31f29$var$_mapWithIndex,
    reduce: $3a29b35b6ed31f29$var$_reduce,
    foldMap: $3a29b35b6ed31f29$var$_foldMap,
    reduceRight: $3a29b35b6ed31f29$var$_reduceRight,
    reduceWithIndex: $3a29b35b6ed31f29$var$_reduceWithIndex,
    foldMapWithIndex: $3a29b35b6ed31f29$var$_foldMapWithIndex,
    reduceRightWithIndex: $3a29b35b6ed31f29$var$_reduceRightWithIndex,
    traverse: $3a29b35b6ed31f29$var$_traverse,
    sequence: module.exports.sequence,
    traverseWithIndex: $3a29b35b6ed31f29$var$_traverseWithIndex
};
var $3a29b35b6ed31f29$var$_wither = /*#__PURE__*/ (0, $4p4Yq.witherDefault)(module.exports.Traversable, module.exports.Compactable);
var $3a29b35b6ed31f29$var$_wilt = /*#__PURE__*/ (0, $4p4Yq.wiltDefault)(module.exports.Traversable, module.exports.Compactable);
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Witherable = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map,
    compact: module.exports.compact,
    separate: module.exports.separate,
    filter: $3a29b35b6ed31f29$var$_filter,
    filterMap: $3a29b35b6ed31f29$var$_filterMap,
    partition: $3a29b35b6ed31f29$var$_partition,
    partitionMap: $3a29b35b6ed31f29$var$_partitionMap,
    reduce: $3a29b35b6ed31f29$var$_reduce,
    foldMap: $3a29b35b6ed31f29$var$_foldMap,
    reduceRight: $3a29b35b6ed31f29$var$_reduceRight,
    traverse: $3a29b35b6ed31f29$var$_traverse,
    sequence: module.exports.sequence,
    wither: $3a29b35b6ed31f29$var$_wither,
    wilt: $3a29b35b6ed31f29$var$_wilt
};
/**
 * @category sequencing
 * @since 2.11.0
 */ module.exports.chainRecDepthFirst = $3a29b35b6ed31f29$var$RA.chainRecDepthFirst;
/**
 * @category instances
 * @since 2.11.0
 */ module.exports.ChainRecDepthFirst = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map,
    ap: $3a29b35b6ed31f29$var$_ap,
    chain: module.exports.flatMap,
    chainRec: $3a29b35b6ed31f29$var$_chainRecDepthFirst
};
/**
 * @category sequencing
 * @since 2.11.0
 */ module.exports.chainRecBreadthFirst = $3a29b35b6ed31f29$var$RA.chainRecBreadthFirst;
/**
 * @category instances
 * @since 2.11.0
 */ module.exports.ChainRecBreadthFirst = {
    URI: module.exports.URI,
    map: $3a29b35b6ed31f29$var$_map,
    ap: $3a29b35b6ed31f29$var$_ap,
    chain: module.exports.flatMap,
    chainRec: $3a29b35b6ed31f29$var$_chainRecBreadthFirst
};
/**
 * Filter values inside a context.
 *
 * @since 2.11.0
 */ module.exports.filterE = (0, $4p4Yq.filterE)(module.exports.Witherable);
/**
 * @category instances
 * @since 2.11.0
 */ module.exports.FromEither = {
    URI: module.exports.URI,
    fromEither: module.exports.fromEither
};
/**
 * @category lifting
 * @since 2.11.0
 */ module.exports.fromEitherK = (0, $eLQyV.fromEitherK)(module.exports.FromEither);
// -------------------------------------------------------------------------------------
// unsafe
// -------------------------------------------------------------------------------------
/**
 * @category unsafe
 * @since 2.0.0
 */ module.exports.unsafeInsertAt = $3a29b35b6ed31f29$var$NEA.unsafeInsertAt;
/**
 * @category unsafe
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$unsafeUpdateAt = function(i, a, as) {
    return (0, module.exports.isNonEmpty)(as) ? $3a29b35b6ed31f29$var$NEA.unsafeUpdateAt(i, a, as) : [];
};
module.exports.unsafeUpdateAt = $3a29b35b6ed31f29$var$unsafeUpdateAt;
/**
 * @category unsafe
 * @since 2.0.0
 */ var $3a29b35b6ed31f29$var$unsafeDeleteAt = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
module.exports.unsafeDeleteAt = $3a29b35b6ed31f29$var$unsafeDeleteAt;
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * `every` tells if the provided predicate holds true for every element in the `Array`.
 *
 * @example
 * import { every } from 'fp-ts/Array'
 *
 * assert.equal(every((x: number) => x >= 0)([1, 2, 3]), true);
 * assert.equal(every((x: number) => x >= 0)([-1, 2, 3]), false);
 *
 * @since 2.9.0
 */ module.exports.every = $3a29b35b6ed31f29$var$RA.every;
/**
 * `some` tells if the provided predicate holds true at least for one element in the `Array`.
 *
 * @example
 * import { some } from 'fp-ts/Array'
 *
 * assert.equal(some((x: number) => x >= 0)([1, 2, 3]), true);
 * assert.equal(some((x: number) => x >= 10)([1, 2, 3]), false);
 *
 * @since 2.9.0
 */ var $3a29b35b6ed31f29$var$some = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
module.exports.some = $3a29b35b6ed31f29$var$some;
/**
 * Alias of [`some`](#some)
 *
 * @since 2.11.0
 */ module.exports.exists = module.exports.some;
/**
 * Places an element in between members of an `Array`, then folds the results using the provided `Monoid`.
 *
 * @example
 * import * as S from 'fp-ts/string'
 * import { intercalate } from 'fp-ts/Array'
 *
 * assert.deepStrictEqual(intercalate(S.Monoid)('-')(['a', 'b', 'c']), 'a-b-c')
 *
 * @since 2.12.0
 */ module.exports.intercalate = $3a29b35b6ed31f29$var$RA.intercalate;
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * @category do notation
 * @since 2.9.0
 */ module.exports.Do = (0, module.exports.of)($3a29b35b6ed31f29$var$_.emptyRecord);
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.bindTo = (0, $emm1u.bindTo)(module.exports.Functor);
var $3a29b35b6ed31f29$var$let_ = /*#__PURE__*/ (0, $emm1u.let)(module.exports.Functor);
module.exports.let = $3a29b35b6ed31f29$var$let_;
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.bind = (0, $ERVGH.bind)(module.exports.Chain);
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.apS = (0, $4sfjE.apS)(module.exports.Apply);
// -------------------------------------------------------------------------------------
// legacy
// -------------------------------------------------------------------------------------
/**
 * Alias of `flatMap`.
 *
 * @category legacy
 * @since 2.0.0
 */ module.exports.chain = module.exports.flatMap;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * Use `NonEmptyArray` module instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.range = $3a29b35b6ed31f29$var$NEA.range;
/**
 * Use a new `[]` instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.empty = [];
/**
 * Use `prepend` instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.cons = $3a29b35b6ed31f29$var$NEA.cons;
/**
 * Use `append` instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.snoc = $3a29b35b6ed31f29$var$NEA.snoc;
/**
 * Use `prependAll` instead
 *
 * @category zone of death
 * @since 2.9.0
 * @deprecated
 */ module.exports.prependToAll = module.exports.prependAll;
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Functor` instance, pass `A.Functor` instead of `A.array`
 * (where `A` is from `import A from 'fp-ts/Array'`)
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.array = {
    URI: module.exports.URI,
    compact: module.exports.compact,
    separate: module.exports.separate,
    map: $3a29b35b6ed31f29$var$_map,
    ap: $3a29b35b6ed31f29$var$_ap,
    of: module.exports.of,
    chain: module.exports.flatMap,
    filter: $3a29b35b6ed31f29$var$_filter,
    filterMap: $3a29b35b6ed31f29$var$_filterMap,
    partition: $3a29b35b6ed31f29$var$_partition,
    partitionMap: $3a29b35b6ed31f29$var$_partitionMap,
    mapWithIndex: $3a29b35b6ed31f29$var$_mapWithIndex,
    partitionMapWithIndex: $3a29b35b6ed31f29$var$_partitionMapWithIndex,
    partitionWithIndex: $3a29b35b6ed31f29$var$_partitionWithIndex,
    filterMapWithIndex: $3a29b35b6ed31f29$var$_filterMapWithIndex,
    filterWithIndex: $3a29b35b6ed31f29$var$_filterWithIndex,
    alt: $3a29b35b6ed31f29$var$_alt,
    zero: module.exports.zero,
    unfold: module.exports.unfold,
    reduce: $3a29b35b6ed31f29$var$_reduce,
    foldMap: $3a29b35b6ed31f29$var$_foldMap,
    reduceRight: $3a29b35b6ed31f29$var$_reduceRight,
    traverse: $3a29b35b6ed31f29$var$_traverse,
    sequence: module.exports.sequence,
    reduceWithIndex: $3a29b35b6ed31f29$var$_reduceWithIndex,
    foldMapWithIndex: $3a29b35b6ed31f29$var$_foldMapWithIndex,
    reduceRightWithIndex: $3a29b35b6ed31f29$var$_reduceRightWithIndex,
    traverseWithIndex: $3a29b35b6ed31f29$var$_traverseWithIndex,
    extend: $3a29b35b6ed31f29$var$_extend,
    wither: $3a29b35b6ed31f29$var$_wither,
    wilt: $3a29b35b6ed31f29$var$_wilt
};

});
parcelRegister("3zj3N", function(module, exports) {
"use strict";
var $29936cf2e0dcbf22$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $29936cf2e0dcbf22$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $29936cf2e0dcbf22$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $29936cf2e0dcbf22$var$__createBinding(result, mod, k);
    }
    $29936cf2e0dcbf22$var$__setModuleDefault(result, mod);
    return result;
};
var $29936cf2e0dcbf22$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sortBy = module.exports.uniq = module.exports.rotate = module.exports.intersperse = module.exports.prependAll = module.exports.unzip = module.exports.zipWith = module.exports.sort = module.exports.lefts = module.exports.rights = module.exports.reverse = module.exports.modifyAt = module.exports.deleteAt = module.exports.updateAt = module.exports.insertAt = module.exports.findLastIndex = module.exports.findLastMap = module.exports.findFirstMap = module.exports.findIndex = module.exports.dropRight = module.exports.dropLeft = module.exports.takeRight = module.exports.takeLeft = module.exports.init = module.exports.tail = module.exports.last = module.exports.head = module.exports.isOutOfBound = module.exports.size = module.exports.scanRight = module.exports.scanLeft = module.exports.chainWithIndex = module.exports.foldRight = module.exports.matchRight = module.exports.matchRightW = module.exports.foldLeft = module.exports.matchLeft = module.exports.matchLeftW = module.exports.match = module.exports.matchW = module.exports.fromEither = module.exports.fromOption = module.exports.replicate = module.exports.makeBy = module.exports.appendW = module.exports.append = module.exports.prependW = module.exports.prepend = module.exports.isNonEmpty = module.exports.isEmpty = void 0;
module.exports.getIntersectionSemigroup = module.exports.getUnionMonoid = module.exports.getUnionSemigroup = module.exports.getOrd = module.exports.getEq = module.exports.getMonoid = module.exports.getSemigroup = module.exports.getShow = module.exports.URI = module.exports.unfold = module.exports.wilt = module.exports.wither = module.exports.traverseWithIndex = module.exports.sequence = module.exports.traverse = module.exports.reduceRightWithIndex = module.exports.reduceRight = module.exports.reduceWithIndex = module.exports.foldMap = module.exports.reduce = module.exports.foldMapWithIndex = module.exports.duplicate = module.exports.extend = module.exports.filterWithIndex = module.exports.partitionMapWithIndex = module.exports.partitionMap = module.exports.partitionWithIndex = module.exports.partition = module.exports.compact = module.exports.filterMap = module.exports.filterMapWithIndex = module.exports.filter = module.exports.separate = module.exports.mapWithIndex = module.exports.map = module.exports.flatten = module.exports.flatMap = module.exports.ap = module.exports.alt = module.exports.altW = module.exports.zero = module.exports.of = module.exports._chainRecBreadthFirst = module.exports._chainRecDepthFirst = module.exports.concat = module.exports.concatW = module.exports.fromOptionK = module.exports.chunksOf = module.exports.splitAt = module.exports.chop = void 0;
module.exports.cons = module.exports.range = module.exports.chain = module.exports.apS = module.exports.bind = module.exports.let = module.exports.bindTo = module.exports.Do = module.exports.intercalate = module.exports.exists = module.exports.some = module.exports.empty = module.exports.fromArray = module.exports.toArray = module.exports.unsafeDeleteAt = module.exports.unsafeUpdateAt = module.exports.unsafeInsertAt = module.exports.fromEitherK = module.exports.FromEither = module.exports.filterE = module.exports.Witherable = module.exports.ChainRecBreadthFirst = module.exports.chainRecBreadthFirst = module.exports.ChainRecDepthFirst = module.exports.chainRecDepthFirst = module.exports.TraversableWithIndex = module.exports.Traversable = module.exports.FoldableWithIndex = module.exports.Foldable = module.exports.FilterableWithIndex = module.exports.Filterable = module.exports.Compactable = module.exports.Extend = module.exports.Alternative = module.exports.guard = module.exports.Zero = module.exports.Alt = module.exports.Unfoldable = module.exports.chainFirst = module.exports.Monad = module.exports.Chain = module.exports.Applicative = module.exports.apSecond = module.exports.apFirst = module.exports.Apply = module.exports.FunctorWithIndex = module.exports.Pointed = module.exports.flap = module.exports.Functor = module.exports.getDifferenceMagma = void 0;
module.exports.readonlyArray = module.exports.prependToAll = module.exports.snoc = void 0;
module.exports.fromPredicate = $29936cf2e0dcbf22$var$fromPredicate;
module.exports.lookup = $29936cf2e0dcbf22$var$lookup;
module.exports.takeLeftWhile = $29936cf2e0dcbf22$var$takeLeftWhile;
module.exports.spanLeft = $29936cf2e0dcbf22$var$spanLeft;
module.exports.dropLeftWhile = $29936cf2e0dcbf22$var$dropLeftWhile;
module.exports.findFirst = $29936cf2e0dcbf22$var$findFirst;
module.exports.findLast = $29936cf2e0dcbf22$var$findLast;
module.exports.zip = $29936cf2e0dcbf22$var$zip;
module.exports.elem = $29936cf2e0dcbf22$var$elem;
module.exports.comprehension = $29936cf2e0dcbf22$var$comprehension;
module.exports.union = $29936cf2e0dcbf22$var$union;
module.exports.intersection = $29936cf2e0dcbf22$var$intersection;
module.exports.difference = $29936cf2e0dcbf22$var$difference;
module.exports.every = $29936cf2e0dcbf22$var$every;

var $4sfjE = parcelRequire("4sfjE");

var $ERVGH = parcelRequire("ERVGH");

var $5Ikl1 = parcelRequire("5Ikl1");

var $eLQyV = parcelRequire("eLQyV");

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");

var $29936cf2e0dcbf22$var$_ = $29936cf2e0dcbf22$var$__importStar((parcelRequire("704qB")));

var $29936cf2e0dcbf22$var$N = $29936cf2e0dcbf22$var$__importStar((parcelRequire("b25hP")));

var $e51aV = parcelRequire("e51aV");

var $29936cf2e0dcbf22$var$RNEA = $29936cf2e0dcbf22$var$__importStar((parcelRequire("bKKbt")));

var $fIQoU = parcelRequire("fIQoU");

var $4p4Yq = parcelRequire("4p4Yq");

var $iV0VO = parcelRequire("iV0VO");
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * Test whether a `ReadonlyArray` is empty.
 *
 * @example
 * import { isEmpty } from 'fp-ts/ReadonlyArray'
 *
 * assert.strictEqual(isEmpty([]), true)
 *
 * @category refinements
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$isEmpty = function(as) {
    return as.length === 0;
};
module.exports.isEmpty = $29936cf2e0dcbf22$var$isEmpty;
/**
 * Test whether a `ReadonlyArray` is non empty.
 *
 * @category refinements
 * @since 2.5.0
 */ module.exports.isNonEmpty = $29936cf2e0dcbf22$var$RNEA.isNonEmpty;
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * Prepend an element to the front of a `ReadonlyArray`, creating a new `ReadonlyNonEmptyArray`.
 *
 * @example
 * import { prepend } from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe([2, 3, 4], prepend(1)), [1, 2, 3, 4])
 *
 * @since 2.10.0
 */ module.exports.prepend = $29936cf2e0dcbf22$var$RNEA.prepend;
/**
 * Less strict version of [`prepend`](#prepend).
 *
 * @since 2.11.0
 */ module.exports.prependW = $29936cf2e0dcbf22$var$RNEA.prependW;
/**
 * Append an element to the end of a `ReadonlyArray`, creating a new `ReadonlyNonEmptyArray`.
 *
 * @example
 * import { append } from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe([1, 2, 3], append(4)), [1, 2, 3, 4])
 *
 * @since 2.10.0
 */ module.exports.append = $29936cf2e0dcbf22$var$RNEA.append;
/**
 * Less strict version of [`append`](#append).
 *
 * @since 2.11.0
 */ module.exports.appendW = $29936cf2e0dcbf22$var$RNEA.appendW;
/**
 * Return a `ReadonlyArray` of length `n` with element `i` initialized with `f(i)`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { makeBy } from 'fp-ts/ReadonlyArray'
 *
 * const double = (n: number): number => n * 2
 * assert.deepStrictEqual(makeBy(5, double), [0, 2, 4, 6, 8])
 *
 * @category constructors
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$makeBy = function(n, f) {
    return n <= 0 ? module.exports.empty : $29936cf2e0dcbf22$var$RNEA.makeBy(f)(n);
};
module.exports.makeBy = $29936cf2e0dcbf22$var$makeBy;
/**
 * Create a `ReadonlyArray` containing a value repeated the specified number of times.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import { replicate } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(replicate(3, 'a'), ['a', 'a', 'a'])
 *
 * @category constructors
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$replicate = function(n, a) {
    return (0, module.exports.makeBy)(n, function() {
        return a;
    });
};
module.exports.replicate = $29936cf2e0dcbf22$var$replicate;
function $29936cf2e0dcbf22$var$fromPredicate(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : module.exports.empty;
    };
}
// -------------------------------------------------------------------------------------
// conversions
// -------------------------------------------------------------------------------------
/**
 * @category conversions
 * @since 2.11.0
 */ var $29936cf2e0dcbf22$var$fromOption = function(ma) {
    return $29936cf2e0dcbf22$var$_.isNone(ma) ? module.exports.empty : [
        ma.value
    ];
};
module.exports.fromOption = $29936cf2e0dcbf22$var$fromOption;
/**
 * Transforms an `Either` to a `ReadonlyArray`.
 *
 * @category conversions
 * @since 2.11.0
 */ var $29936cf2e0dcbf22$var$fromEither = function(e) {
    return $29936cf2e0dcbf22$var$_.isLeft(e) ? module.exports.empty : [
        e.right
    ];
};
module.exports.fromEither = $29936cf2e0dcbf22$var$fromEither;
/**
 * Less strict version of [`match`](#match).
 *
 * The `W` suffix (short for **W**idening) means that the handler return types will be merged.
 *
 * @category pattern matching
 * @since 2.11.0
 */ var $29936cf2e0dcbf22$var$matchW = function(onEmpty, onNonEmpty) {
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? onNonEmpty(as) : onEmpty();
    };
};
module.exports.matchW = $29936cf2e0dcbf22$var$matchW;
/**
 * @category pattern matching
 * @since 2.11.0
 */ module.exports.match = module.exports.matchW;
/**
 * Less strict version of [`matchLeft`](#matchleft).
 *
 * @category pattern matching
 * @since 2.11.0
 */ var $29936cf2e0dcbf22$var$matchLeftW = function(onEmpty, onNonEmpty) {
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? onNonEmpty($29936cf2e0dcbf22$var$RNEA.head(as), $29936cf2e0dcbf22$var$RNEA.tail(as)) : onEmpty();
    };
};
module.exports.matchLeftW = $29936cf2e0dcbf22$var$matchLeftW;
/**
 * Break a `ReadonlyArray` into its first element and remaining elements.
 *
 * @example
 * import { matchLeft } from 'fp-ts/ReadonlyArray'
 *
 * const len: <A>(as: ReadonlyArray<A>) => number = matchLeft(() => 0, (_, tail) => 1 + len(tail))
 * assert.strictEqual(len([1, 2, 3]), 3)
 *
 * @category pattern matching
 * @since 2.10.0
 */ module.exports.matchLeft = module.exports.matchLeftW;
/**
 * Alias of [`matchLeft`](#matchleft).
 *
 * @category pattern matching
 * @since 2.5.0
 */ module.exports.foldLeft = module.exports.matchLeft;
/**
 * Less strict version of [`matchRight`](#matchright).
 *
 * @category pattern matching
 * @since 2.11.0
 */ var $29936cf2e0dcbf22$var$matchRightW = function(onEmpty, onNonEmpty) {
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? onNonEmpty($29936cf2e0dcbf22$var$RNEA.init(as), $29936cf2e0dcbf22$var$RNEA.last(as)) : onEmpty();
    };
};
module.exports.matchRightW = $29936cf2e0dcbf22$var$matchRightW;
/**
 * Break a `ReadonlyArray` into its initial elements and the last element.
 *
 * @category pattern matching
 * @since 2.10.0
 */ module.exports.matchRight = module.exports.matchRightW;
/**
 * Alias of [`matchRight`](#matchright).
 *
 * @category pattern matching
 * @since 2.5.0
 */ module.exports.foldRight = module.exports.matchRight;
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @category sequencing
 * @since 2.7.0
 */ var $29936cf2e0dcbf22$var$chainWithIndex = function(f) {
    return function(as) {
        if ((0, module.exports.isEmpty)(as)) return module.exports.empty;
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
module.exports.chainWithIndex = $29936cf2e0dcbf22$var$chainWithIndex;
/**
 * Same as `reduce` but it carries over the intermediate steps.
 *
 * @example
 * import { scanLeft } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(scanLeft(10, (b, a: number) => b - a)([1, 2, 3]), [10, 9, 7, 4])
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$scanLeft = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
module.exports.scanLeft = $29936cf2e0dcbf22$var$scanLeft;
/**
 * Fold an array from the right, keeping all intermediate results instead of only the final result
 *
 * @example
 * import { scanRight } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(scanRight(10, (a: number, b) => b - a)([1, 2, 3]), [4, 5, 7, 10])
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$scanRight = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
module.exports.scanRight = $29936cf2e0dcbf22$var$scanRight;
/**
 * Calculate the number of elements in a `ReadonlyArray`.
 *
 * @since 2.10.0
 */ var $29936cf2e0dcbf22$var$size = function(as) {
    return as.length;
};
module.exports.size = $29936cf2e0dcbf22$var$size;
/**
 * Test whether an array contains a particular index
 *
 * @since 2.5.0
 */ module.exports.isOutOfBound = $29936cf2e0dcbf22$var$RNEA.isOutOfBound;
function $29936cf2e0dcbf22$var$lookup(i, as) {
    return as === undefined ? function(as) {
        return $29936cf2e0dcbf22$var$lookup(i, as);
    } : (0, module.exports.isOutOfBound)(i, as) ? $29936cf2e0dcbf22$var$_.none : $29936cf2e0dcbf22$var$_.some(as[i]);
}
/**
 * Get the first element in an array, or `None` if the array is empty
 *
 * @example
 * import { head } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(head([1, 2, 3]), some(1))
 * assert.deepStrictEqual(head([]), none)
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$head = function(as) {
    return (0, module.exports.isNonEmpty)(as) ? $29936cf2e0dcbf22$var$_.some($29936cf2e0dcbf22$var$RNEA.head(as)) : $29936cf2e0dcbf22$var$_.none;
};
module.exports.head = $29936cf2e0dcbf22$var$head;
/**
 * Get the last element in an array, or `None` if the array is empty
 *
 * @example
 * import { last } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(last([1, 2, 3]), some(3))
 * assert.deepStrictEqual(last([]), none)
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$last = function(as) {
    return (0, module.exports.isNonEmpty)(as) ? $29936cf2e0dcbf22$var$_.some($29936cf2e0dcbf22$var$RNEA.last(as)) : $29936cf2e0dcbf22$var$_.none;
};
module.exports.last = $29936cf2e0dcbf22$var$last;
/**
 * Get all but the first element of an array, creating a new array, or `None` if the array is empty
 *
 * @example
 * import { tail } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(tail([1, 2, 3]), some([2, 3]))
 * assert.deepStrictEqual(tail([]), none)
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$tail = function(as) {
    return (0, module.exports.isNonEmpty)(as) ? $29936cf2e0dcbf22$var$_.some($29936cf2e0dcbf22$var$RNEA.tail(as)) : $29936cf2e0dcbf22$var$_.none;
};
module.exports.tail = $29936cf2e0dcbf22$var$tail;
/**
 * Get all but the last element of an array, creating a new array, or `None` if the array is empty
 *
 * @example
 * import { init } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(init([1, 2, 3]), some([1, 2]))
 * assert.deepStrictEqual(init([]), none)
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$init = function(as) {
    return (0, module.exports.isNonEmpty)(as) ? $29936cf2e0dcbf22$var$_.some($29936cf2e0dcbf22$var$RNEA.init(as)) : $29936cf2e0dcbf22$var$_.none;
};
module.exports.init = $29936cf2e0dcbf22$var$init;
/**
 * Keep only a max number of elements from the start of an `ReadonlyArray`, creating a new `ReadonlyArray`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * const input: ReadonlyArray<number> = [1, 2, 3]
 * assert.deepStrictEqual(pipe(input, RA.takeLeft(2)), [1, 2])
 *
 * // out of bounds
 * assert.strictEqual(pipe(input, RA.takeLeft(4)), input)
 * assert.strictEqual(pipe(input, RA.takeLeft(-1)), input)
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$takeLeft = function(n) {
    return function(as) {
        return (0, module.exports.isOutOfBound)(n, as) ? as : n === 0 ? module.exports.empty : as.slice(0, n);
    };
};
module.exports.takeLeft = $29936cf2e0dcbf22$var$takeLeft;
/**
 * Keep only a max number of elements from the end of an `ReadonlyArray`, creating a new `ReadonlyArray`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * const input: ReadonlyArray<number> = [1, 2, 3]
 * assert.deepStrictEqual(pipe(input, RA.takeRight(2)), [2, 3])
 *
 * // out of bounds
 * assert.strictEqual(pipe(input, RA.takeRight(4)), input)
 * assert.strictEqual(pipe(input, RA.takeRight(-1)), input)
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$takeRight = function(n) {
    return function(as) {
        return (0, module.exports.isOutOfBound)(n, as) ? as : n === 0 ? module.exports.empty : as.slice(-n);
    };
};
module.exports.takeRight = $29936cf2e0dcbf22$var$takeRight;
function $29936cf2e0dcbf22$var$takeLeftWhile(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        var len = out.length;
        return len === as.length ? as : len === 0 ? module.exports.empty : out;
    };
}
var $29936cf2e0dcbf22$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $29936cf2e0dcbf22$var$spanLeft(predicate) {
    return function(as) {
        var _a = (0, module.exports.splitAt)($29936cf2e0dcbf22$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
/**
 * Drop a max number of elements from the start of an `ReadonlyArray`, creating a new `ReadonlyArray`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * const input: ReadonlyArray<number> = [1, 2, 3]
 * assert.deepStrictEqual(pipe(input, RA.dropLeft(2)), [3])
 * assert.strictEqual(pipe(input, RA.dropLeft(0)), input)
 * assert.strictEqual(pipe(input, RA.dropLeft(-1)), input)
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$dropLeft = function(n) {
    return function(as) {
        return n <= 0 || (0, module.exports.isEmpty)(as) ? as : n >= as.length ? module.exports.empty : as.slice(n, as.length);
    };
};
module.exports.dropLeft = $29936cf2e0dcbf22$var$dropLeft;
/**
 * Drop a max number of elements from the end of an `ReadonlyArray`, creating a new `ReadonlyArray`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @example
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * const input: ReadonlyArray<number> = [1, 2, 3]
 * assert.deepStrictEqual(pipe(input, RA.dropRight(2)), [1])
 * assert.strictEqual(pipe(input, RA.dropRight(0)), input)
 * assert.strictEqual(pipe(input, RA.dropRight(-1)), input)
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$dropRight = function(n) {
    return function(as) {
        return n <= 0 || (0, module.exports.isEmpty)(as) ? as : n >= as.length ? module.exports.empty : as.slice(0, as.length - n);
    };
};
module.exports.dropRight = $29936cf2e0dcbf22$var$dropRight;
function $29936cf2e0dcbf22$var$dropLeftWhile(predicate) {
    return function(as) {
        var i = $29936cf2e0dcbf22$var$spanLeftIndex(as, predicate);
        return i === 0 ? as : i === as.length ? module.exports.empty : as.slice(i);
    };
}
/**
 * Find the first index for which a predicate holds
 *
 * @example
 * import { findIndex } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(findIndex((n: number) => n === 2)([1, 2, 3]), some(1))
 * assert.deepStrictEqual(findIndex((n: number) => n === 2)([]), none)
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$findIndex = function(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $29936cf2e0dcbf22$var$_.some(i);
        }
        return $29936cf2e0dcbf22$var$_.none;
    };
};
module.exports.findIndex = $29936cf2e0dcbf22$var$findIndex;
function $29936cf2e0dcbf22$var$findFirst(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $29936cf2e0dcbf22$var$_.some(as[i]);
        }
        return $29936cf2e0dcbf22$var$_.none;
    };
}
/**
 * Find the first element returned by an option based selector function
 *
 * @example
 * import { findFirstMap } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * interface Person {
 *   readonly name: string
 *   readonly age?: number
 * }
 *
 * const persons: ReadonlyArray<Person> = [{ name: 'John' }, { name: 'Mary', age: 45 }, { name: 'Joey', age: 28 }]
 *
 * // returns the name of the first person that has an age
 * assert.deepStrictEqual(findFirstMap((p: Person) => (p.age === undefined ? none : some(p.name)))(persons), some('Mary'))
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$findFirstMap = function(f) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            var out = f(as[i]);
            if ($29936cf2e0dcbf22$var$_.isSome(out)) return out;
        }
        return $29936cf2e0dcbf22$var$_.none;
    };
};
module.exports.findFirstMap = $29936cf2e0dcbf22$var$findFirstMap;
function $29936cf2e0dcbf22$var$findLast(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $29936cf2e0dcbf22$var$_.some(as[i]);
        }
        return $29936cf2e0dcbf22$var$_.none;
    };
}
/**
 * Find the last element returned by an option based selector function
 *
 * @example
 * import { findLastMap } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * interface Person {
 *   readonly name: string
 *   readonly age?: number
 * }
 *
 * const persons: ReadonlyArray<Person> = [{ name: 'John' }, { name: 'Mary', age: 45 }, { name: 'Joey', age: 28 }]
 *
 * // returns the name of the last person that has an age
 * assert.deepStrictEqual(findLastMap((p: Person) => (p.age === undefined ? none : some(p.name)))(persons), some('Joey'))
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$findLastMap = function(f) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            var out = f(as[i]);
            if ($29936cf2e0dcbf22$var$_.isSome(out)) return out;
        }
        return $29936cf2e0dcbf22$var$_.none;
    };
};
module.exports.findLastMap = $29936cf2e0dcbf22$var$findLastMap;
/**
 * Returns the index of the last element of the list which matches the predicate
 *
 * @example
 * import { findLastIndex } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * interface X {
 *   readonly a: number
 *   readonly b: number
 * }
 * const xs: ReadonlyArray<X> = [{ a: 1, b: 0 }, { a: 1, b: 1 }]
 * assert.deepStrictEqual(findLastIndex((x: { readonly a: number }) => x.a === 1)(xs), some(1))
 * assert.deepStrictEqual(findLastIndex((x: { readonly a: number }) => x.a === 4)(xs), none)
 *
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$findLastIndex = function(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $29936cf2e0dcbf22$var$_.some(i);
        }
        return $29936cf2e0dcbf22$var$_.none;
    };
};
module.exports.findLastIndex = $29936cf2e0dcbf22$var$findLastIndex;
/**
 * Insert an element at the specified index, creating a new array, or returning `None` if the index is out of bounds
 *
 * @example
 * import { insertAt } from 'fp-ts/ReadonlyArray'
 * import { some } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(insertAt(2, 5)([1, 2, 3, 4]), some([1, 2, 5, 3, 4]))
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$insertAt = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $29936cf2e0dcbf22$var$_.none : $29936cf2e0dcbf22$var$_.some($29936cf2e0dcbf22$var$RNEA.unsafeInsertAt(i, a, as));
    };
};
module.exports.insertAt = $29936cf2e0dcbf22$var$insertAt;
/**
 * Change the element at the specified index, creating a new array, or returning `None` if the index is out of bounds
 *
 * @example
 * import { updateAt } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(updateAt(1, 1)([1, 2, 3]), some([1, 1, 3]))
 * assert.deepStrictEqual(updateAt(1, 1)([]), none)
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$updateAt = function(i, a) {
    return (0, module.exports.modifyAt)(i, function() {
        return a;
    });
};
module.exports.updateAt = $29936cf2e0dcbf22$var$updateAt;
/**
 * Delete the element at the specified index, creating a new array, or returning `None` if the index is out of bounds
 *
 * @example
 * import { deleteAt } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(deleteAt(0)([1, 2, 3]), some([2, 3]))
 * assert.deepStrictEqual(deleteAt(1)([]), none)
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$deleteAt = function(i) {
    return function(as) {
        return (0, module.exports.isOutOfBound)(i, as) ? $29936cf2e0dcbf22$var$_.none : $29936cf2e0dcbf22$var$_.some((0, module.exports.unsafeDeleteAt)(i, as));
    };
};
module.exports.deleteAt = $29936cf2e0dcbf22$var$deleteAt;
/**
 * Apply a function to the element at the specified index, creating a new array, or returning `None` if the index is out
 * of bounds
 *
 * @example
 * import { modifyAt } from 'fp-ts/ReadonlyArray'
 * import { some, none } from 'fp-ts/Option'
 *
 * const double = (x: number): number => x * 2
 * assert.deepStrictEqual(modifyAt(1, double)([1, 2, 3]), some([1, 4, 3]))
 * assert.deepStrictEqual(modifyAt(1, double)([]), none)
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$modifyAt = function(i, f) {
    return function(as) {
        return (0, module.exports.isOutOfBound)(i, as) ? $29936cf2e0dcbf22$var$_.none : $29936cf2e0dcbf22$var$_.some((0, module.exports.unsafeUpdateAt)(i, f(as[i]), as));
    };
};
module.exports.modifyAt = $29936cf2e0dcbf22$var$modifyAt;
/**
 * Reverse an array, creating a new array
 *
 * @example
 * import { reverse } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(reverse([1, 2, 3]), [3, 2, 1])
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$reverse = function(as) {
    return as.length <= 1 ? as : as.slice().reverse();
};
module.exports.reverse = $29936cf2e0dcbf22$var$reverse;
/**
 * Extracts from an array of `Either` all the `Right` elements. All the `Right` elements are extracted in order
 *
 * @example
 * import { rights } from 'fp-ts/ReadonlyArray'
 * import { right, left } from 'fp-ts/Either'
 *
 * assert.deepStrictEqual(rights([right(1), left('foo'), right(2)]), [1, 2])
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$rights = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
module.exports.rights = $29936cf2e0dcbf22$var$rights;
/**
 * Extracts from an array of `Either` all the `Left` elements. All the `Left` elements are extracted in order
 *
 * @example
 * import { lefts } from 'fp-ts/ReadonlyArray'
 * import { left, right } from 'fp-ts/Either'
 *
 * assert.deepStrictEqual(lefts([right(1), left('foo'), right(2)]), ['foo'])
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$lefts = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
module.exports.lefts = $29936cf2e0dcbf22$var$lefts;
/**
 * Sort the elements of an array in increasing order, creating a new array
 *
 * @example
 * import { sort } from 'fp-ts/ReadonlyArray'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(sort(N.Ord)([3, 2, 1]), [1, 2, 3])
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$sort = function(O) {
    return function(as) {
        return as.length <= 1 ? as : as.slice().sort(O.compare);
    };
};
module.exports.sort = $29936cf2e0dcbf22$var$sort;
// TODO: curry and make data-last in v3
/**
 * Apply a function to pairs of elements at the same index in two arrays, collecting the results in a new array. If one
 * input array is short, excess elements of the longer array are discarded.
 *
 * @example
 * import { zipWith } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(zipWith([1, 2, 3], ['a', 'b', 'c', 'd'], (n, s) => s + n), ['a1', 'b2', 'c3'])
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$zipWith = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
module.exports.zipWith = $29936cf2e0dcbf22$var$zipWith;
function $29936cf2e0dcbf22$var$zip(as, bs) {
    if (bs === undefined) return function(bs) {
        return $29936cf2e0dcbf22$var$zip(bs, as);
    };
    return (0, module.exports.zipWith)(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
/**
 * The function is reverse of `zip`. Takes an array of pairs and return two corresponding arrays
 *
 * @example
 * import { unzip } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(unzip([[1, 'a'], [2, 'b'], [3, 'c']]), [[1, 2, 3], ['a', 'b', 'c']])
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$unzip = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
module.exports.unzip = $29936cf2e0dcbf22$var$unzip;
/**
 * Prepend an element to every member of an array
 *
 * @example
 * import { prependAll } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(prependAll(9)([1, 2, 3, 4]), [9, 1, 9, 2, 9, 3, 9, 4])
 *
 * @since 2.10.0
 */ var $29936cf2e0dcbf22$var$prependAll = function(middle) {
    var f = $29936cf2e0dcbf22$var$RNEA.prependAll(middle);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? f(as) : as;
    };
};
module.exports.prependAll = $29936cf2e0dcbf22$var$prependAll;
/**
 * Places an element in between members of an array
 *
 * @example
 * import { intersperse } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(intersperse(9)([1, 2, 3, 4]), [1, 9, 2, 9, 3, 9, 4])
 *
 * @since 2.9.0
 */ var $29936cf2e0dcbf22$var$intersperse = function(middle) {
    var f = $29936cf2e0dcbf22$var$RNEA.intersperse(middle);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? f(as) : as;
    };
};
module.exports.intersperse = $29936cf2e0dcbf22$var$intersperse;
/**
 * Rotate a `ReadonlyArray` by `n` steps.
 *
 * @example
 * import { rotate } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(rotate(2)([1, 2, 3, 4, 5]), [4, 5, 1, 2, 3])
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$rotate = function(n) {
    var f = $29936cf2e0dcbf22$var$RNEA.rotate(n);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? f(as) : as;
    };
};
module.exports.rotate = $29936cf2e0dcbf22$var$rotate;
function $29936cf2e0dcbf22$var$elem(E) {
    return function(a, as) {
        if (as === undefined) {
            var elemE_1 = $29936cf2e0dcbf22$var$elem(E);
            return function(as) {
                return elemE_1(a, as);
            };
        }
        var predicate = function(element) {
            return E.equals(element, a);
        };
        var i = 0;
        for(; i < as.length; i++){
            if (predicate(as[i])) return true;
        }
        return false;
    };
}
/**
 * Remove duplicates from an array, keeping the first occurrence of an element.
 *
 * @example
 * import { uniq } from 'fp-ts/ReadonlyArray'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(uniq(N.Eq)([1, 2, 1]), [1, 2])
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$uniq = function(E) {
    var f = $29936cf2e0dcbf22$var$RNEA.uniq(E);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? f(as) : as;
    };
};
module.exports.uniq = $29936cf2e0dcbf22$var$uniq;
/**
 * Sort the elements of an array in increasing order, where elements are compared using first `ords[0]`, then `ords[1]`,
 * etc...
 *
 * @example
 * import { sortBy } from 'fp-ts/ReadonlyArray'
 * import { contramap } from 'fp-ts/Ord'
 * import * as S from 'fp-ts/string'
 * import * as N from 'fp-ts/number'
 * import { pipe } from 'fp-ts/function'
 *
 * interface Person {
 *   readonly name: string
 *   readonly age: number
 * }
 * const byName = pipe(S.Ord, contramap((p: Person) => p.name))
 * const byAge = pipe(N.Ord, contramap((p: Person) => p.age))
 *
 * const sortByNameByAge = sortBy([byName, byAge])
 *
 * const persons = [{ name: 'a', age: 1 }, { name: 'b', age: 3 }, { name: 'c', age: 2 }, { name: 'b', age: 2 }]
 * assert.deepStrictEqual(sortByNameByAge(persons), [
 *   { name: 'a', age: 1 },
 *   { name: 'b', age: 2 },
 *   { name: 'b', age: 3 },
 *   { name: 'c', age: 2 }
 * ])
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$sortBy = function(ords) {
    var f = $29936cf2e0dcbf22$var$RNEA.sortBy(ords);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? f(as) : as;
    };
};
module.exports.sortBy = $29936cf2e0dcbf22$var$sortBy;
/**
 * A useful recursion pattern for processing a `ReadonlyArray` to produce a new `ReadonlyArray`, often used for "chopping" up the input
 * `ReadonlyArray`. Typically `chop` is called with some function that will consume an initial prefix of the `ReadonlyArray` and produce a
 * value and the tail of the `ReadonlyArray`.
 *
 * @example
 * import { Eq } from 'fp-ts/Eq'
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import * as N from 'fp-ts/number'
 * import { pipe } from 'fp-ts/function'
 *
 * const group = <A>(S: Eq<A>): ((as: ReadonlyArray<A>) => ReadonlyArray<ReadonlyArray<A>>) => {
 *   return RA.chop(as => {
 *     const { init, rest } = pipe(as, RA.spanLeft((a: A) => S.equals(a, as[0])))
 *     return [init, rest]
 *   })
 * }
 * assert.deepStrictEqual(group(N.Eq)([1, 1, 2, 3, 3, 4]), [[1, 1], [2], [3, 3], [4]])
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$chop = function(f) {
    var g = $29936cf2e0dcbf22$var$RNEA.chop(f);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? g(as) : module.exports.empty;
    };
};
module.exports.chop = $29936cf2e0dcbf22$var$chop;
/**
 * Splits a `ReadonlyArray` into two pieces, the first piece has max `n` elements.
 *
 * @example
 * import { splitAt } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(splitAt(2)([1, 2, 3, 4, 5]), [[1, 2], [3, 4, 5]])
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$splitAt = function(n) {
    return function(as) {
        return n >= 1 && (0, module.exports.isNonEmpty)(as) ? $29936cf2e0dcbf22$var$RNEA.splitAt(n)(as) : (0, module.exports.isEmpty)(as) ? [
            as,
            module.exports.empty
        ] : [
            module.exports.empty,
            as
        ];
    };
};
module.exports.splitAt = $29936cf2e0dcbf22$var$splitAt;
/**
 * Splits a `ReadonlyArray` into length-`n` pieces. The last piece will be shorter if `n` does not evenly divide the length of
 * the `ReadonlyArray`. Note that `chunksOf(n)([])` is `[]`, not `[[]]`. This is intentional, and is consistent with a recursive
 * definition of `chunksOf`; it satisfies the property that:
 *
 * ```ts
 * chunksOf(n)(xs).concat(chunksOf(n)(ys)) == chunksOf(n)(xs.concat(ys)))
 * ```
 *
 * whenever `n` evenly divides the length of `as`.
 *
 * @example
 * import { chunksOf } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(chunksOf(2)([1, 2, 3, 4, 5]), [[1, 2], [3, 4], [5]])
 *
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$chunksOf = function(n) {
    var f = $29936cf2e0dcbf22$var$RNEA.chunksOf(n);
    return function(as) {
        return (0, module.exports.isNonEmpty)(as) ? f(as) : module.exports.empty;
    };
};
module.exports.chunksOf = $29936cf2e0dcbf22$var$chunksOf;
/**
 * @category lifting
 * @since 2.11.0
 */ var $29936cf2e0dcbf22$var$fromOptionK = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return (0, module.exports.fromOption)(f.apply(void 0, a));
    };
};
module.exports.fromOptionK = $29936cf2e0dcbf22$var$fromOptionK;
function $29936cf2e0dcbf22$var$comprehension(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return (0, module.exports.isNonEmpty)(input) ? (0, module.exports.flatMap)($29936cf2e0dcbf22$var$RNEA.head(input), function(a) {
            return go((0, $3abDJ.pipe)(scope, (0, module.exports.append)(a)), $29936cf2e0dcbf22$var$RNEA.tail(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : module.exports.empty;
    };
    return go(module.exports.empty, input);
}
/**
 * @since 2.11.0
 */ var $29936cf2e0dcbf22$var$concatW = function(second) {
    return function(first) {
        return (0, module.exports.isEmpty)(first) ? second : (0, module.exports.isEmpty)(second) ? first : first.concat(second);
    };
};
module.exports.concatW = $29936cf2e0dcbf22$var$concatW;
/**
 * @since 2.11.0
 */ module.exports.concat = module.exports.concatW;
function $29936cf2e0dcbf22$var$union(E) {
    var unionE = $29936cf2e0dcbf22$var$RNEA.union(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $29936cf2e0dcbf22$var$union(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return (0, module.exports.isNonEmpty)(first) && (0, module.exports.isNonEmpty)(second) ? unionE(second)(first) : (0, module.exports.isNonEmpty)(first) ? first : second;
    };
}
function $29936cf2e0dcbf22$var$intersection(E) {
    var elemE = $29936cf2e0dcbf22$var$elem(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $29936cf2e0dcbf22$var$intersection(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $29936cf2e0dcbf22$var$difference(E) {
    var elemE = $29936cf2e0dcbf22$var$elem(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $29936cf2e0dcbf22$var$difference(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $29936cf2e0dcbf22$var$_map = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.map)(f));
};
var $29936cf2e0dcbf22$var$_mapWithIndex = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.mapWithIndex)(f));
};
var $29936cf2e0dcbf22$var$_ap = function(fab, fa) {
    return (0, $3abDJ.pipe)(fab, (0, module.exports.ap)(fa));
};
var $29936cf2e0dcbf22$var$_filter = function(fa, predicate) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.filter)(predicate));
};
var $29936cf2e0dcbf22$var$_filterMap = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.filterMap)(f));
};
var $29936cf2e0dcbf22$var$_partition = function(fa, predicate) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.partition)(predicate));
};
var $29936cf2e0dcbf22$var$_partitionMap = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.partitionMap)(f));
};
var $29936cf2e0dcbf22$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.partitionWithIndex)(predicateWithIndex));
};
var $29936cf2e0dcbf22$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.partitionMapWithIndex)(f));
};
var $29936cf2e0dcbf22$var$_alt = function(fa, that) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.alt)(that));
};
var $29936cf2e0dcbf22$var$_reduce = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduce)(b, f));
};
var $29936cf2e0dcbf22$var$_foldMap = function(M) {
    var foldMapM = (0, module.exports.foldMap)(M);
    return function(fa, f) {
        return (0, $3abDJ.pipe)(fa, foldMapM(f));
    };
};
var $29936cf2e0dcbf22$var$_reduceRight = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduceRight)(b, f));
};
var $29936cf2e0dcbf22$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduceWithIndex)(b, f));
};
var $29936cf2e0dcbf22$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = (0, module.exports.foldMapWithIndex)(M);
    return function(fa, f) {
        return (0, $3abDJ.pipe)(fa, foldMapWithIndexM(f));
    };
};
var $29936cf2e0dcbf22$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduceRightWithIndex)(b, f));
};
var $29936cf2e0dcbf22$var$_filterMapWithIndex = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.filterMapWithIndex)(f));
};
var $29936cf2e0dcbf22$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.filterWithIndex)(predicateWithIndex));
};
var $29936cf2e0dcbf22$var$_extend = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.extend)(f));
};
var $29936cf2e0dcbf22$var$_traverse = function(F) {
    var traverseF = (0, module.exports.traverse)(F);
    return function(ta, f) {
        return (0, $3abDJ.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $29936cf2e0dcbf22$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = (0, module.exports.traverseWithIndex)(F);
    return function(ta, f) {
        return (0, $3abDJ.pipe)(ta, traverseWithIndexF(f));
    };
};
/** @internal */ var $29936cf2e0dcbf22$var$_chainRecDepthFirst = function(a, f) {
    return (0, $3abDJ.pipe)(a, (0, module.exports.chainRecDepthFirst)(f));
};
module.exports._chainRecDepthFirst = $29936cf2e0dcbf22$var$_chainRecDepthFirst;
/** @internal */ var $29936cf2e0dcbf22$var$_chainRecBreadthFirst = function(a, f) {
    return (0, $3abDJ.pipe)(a, (0, module.exports.chainRecBreadthFirst)(f));
};
module.exports._chainRecBreadthFirst = $29936cf2e0dcbf22$var$_chainRecBreadthFirst;
/**
 * @category constructors
 * @since 2.5.0
 */ module.exports.of = $29936cf2e0dcbf22$var$RNEA.of;
/**
 * @since 2.7.0
 */ var $29936cf2e0dcbf22$var$zero = function() {
    return module.exports.empty;
};
module.exports.zero = $29936cf2e0dcbf22$var$zero;
/**
 * Less strict version of [`alt`](#alt).
 *
 * The `W` suffix (short for **W**idening) means that the return types will be merged.
 *
 * @example
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3],
 *     RA.altW(() => ['a', 'b'])
 *   ),
 *   [1, 2, 3, 'a', 'b']
 * )
 *
 * @category error handling
 * @since 2.9.0
 */ var $29936cf2e0dcbf22$var$altW = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
module.exports.altW = $29936cf2e0dcbf22$var$altW;
/**
 * Identifies an associative operation on a type constructor. It is similar to `Semigroup`, except that it applies to
 * types of kind `* -> *`.
 *
 * In case of `ReadonlyArray` concatenates the inputs into a single array.
 *
 * @example
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3],
 *     RA.alt(() => [4, 5])
 *   ),
 *   [1, 2, 3, 4, 5]
 * )
 *
 * @category error handling
 * @since 2.5.0
 */ module.exports.alt = module.exports.altW;
/**
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$ap = function(fa) {
    return (0, module.exports.flatMap)(function(f) {
        return (0, $3abDJ.pipe)(fa, (0, module.exports.map)(f));
    });
};
module.exports.ap = $29936cf2e0dcbf22$var$ap;
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation.
 *
 * @example
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3],
 *     RA.flatMap((n) => [`a${n}`, `b${n}`])
 *   ),
 *   ['a1', 'b1', 'a2', 'b2', 'a3', 'b3']
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3],
 *     RA.flatMap(() => [])
 *   ),
 *   []
 * )
 *
 * @category sequencing
 * @since 2.14.0
 */ module.exports.flatMap = (0, $3abDJ.dual)(2, function(ma, f) {
    return (0, $3abDJ.pipe)(ma, (0, module.exports.chainWithIndex)(function(i, a) {
        return f(a, i);
    }));
});
/**
 * @category sequencing
 * @since 2.5.0
 */ module.exports.flatten = (0, module.exports.flatMap)($3abDJ.identity);
/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
 * use the type constructor `F` to represent some computational context.
 *
 * @category mapping
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$map = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
module.exports.map = $29936cf2e0dcbf22$var$map;
/**
 * @category mapping
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$mapWithIndex = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
module.exports.mapWithIndex = $29936cf2e0dcbf22$var$mapWithIndex;
/**
 * @category filtering
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$separate = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $fIQoU.separated)(left, right);
};
module.exports.separate = $29936cf2e0dcbf22$var$separate;
/**
 * @category filtering
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$filter = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
module.exports.filter = $29936cf2e0dcbf22$var$filter;
/**
 * @category filtering
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$filterMapWithIndex = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($29936cf2e0dcbf22$var$_.isSome(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
module.exports.filterMapWithIndex = $29936cf2e0dcbf22$var$filterMapWithIndex;
/**
 * @category filtering
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$filterMap = function(f) {
    return (0, module.exports.filterMapWithIndex)(function(_, a) {
        return f(a);
    });
};
module.exports.filterMap = $29936cf2e0dcbf22$var$filterMap;
/**
 * @category filtering
 * @since 2.5.0
 */ module.exports.compact = (0, module.exports.filterMap)($3abDJ.identity);
/**
 * @category filtering
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$partition = function(predicate) {
    return (0, module.exports.partitionWithIndex)(function(_, a) {
        return predicate(a);
    });
};
module.exports.partition = $29936cf2e0dcbf22$var$partition;
/**
 * @category filtering
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$partitionWithIndex = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var a = as[i];
            if (predicateWithIndex(i, a)) right.push(a);
            else left.push(a);
        }
        return (0, $fIQoU.separated)(left, right);
    };
};
module.exports.partitionWithIndex = $29936cf2e0dcbf22$var$partitionWithIndex;
/**
 * @category filtering
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$partitionMap = function(f) {
    return (0, module.exports.partitionMapWithIndex)(function(_, a) {
        return f(a);
    });
};
module.exports.partitionMap = $29936cf2e0dcbf22$var$partitionMap;
/**
 * @category filtering
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$partitionMapWithIndex = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $fIQoU.separated)(left, right);
    };
};
module.exports.partitionMapWithIndex = $29936cf2e0dcbf22$var$partitionMapWithIndex;
/**
 * @category filtering
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$filterWithIndex = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(a, i) {
            return predicateWithIndex(i, a);
        });
    };
};
module.exports.filterWithIndex = $29936cf2e0dcbf22$var$filterWithIndex;
/**
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$extend = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
module.exports.extend = $29936cf2e0dcbf22$var$extend;
/**
 * @since 2.5.0
 */ module.exports.duplicate = (0, module.exports.extend)($3abDJ.identity);
/**
 * @category folding
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$foldMapWithIndex = function(M) {
    return function(f) {
        return function(fa) {
            return fa.reduce(function(b, a, i) {
                return M.concat(b, f(i, a));
            }, M.empty);
        };
    };
};
module.exports.foldMapWithIndex = $29936cf2e0dcbf22$var$foldMapWithIndex;
/**
 * @category folding
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$reduce = function(b, f) {
    return (0, module.exports.reduceWithIndex)(b, function(_, b, a) {
        return f(b, a);
    });
};
module.exports.reduce = $29936cf2e0dcbf22$var$reduce;
/**
 * @category folding
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$foldMap = function(M) {
    var foldMapWithIndexM = (0, module.exports.foldMapWithIndex)(M);
    return function(f) {
        return foldMapWithIndexM(function(_, a) {
            return f(a);
        });
    };
};
module.exports.foldMap = $29936cf2e0dcbf22$var$foldMap;
/**
 * @category folding
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$reduceWithIndex = function(b, f) {
    return function(fa) {
        var len = fa.length;
        var out = b;
        for(var i = 0; i < len; i++)out = f(i, out, fa[i]);
        return out;
    };
};
module.exports.reduceWithIndex = $29936cf2e0dcbf22$var$reduceWithIndex;
/**
 * @category folding
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$reduceRight = function(b, f) {
    return (0, module.exports.reduceRightWithIndex)(b, function(_, a, b) {
        return f(a, b);
    });
};
module.exports.reduceRight = $29936cf2e0dcbf22$var$reduceRight;
/**
 * @category folding
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$reduceRightWithIndex = function(b, f) {
    return function(fa) {
        return fa.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
module.exports.reduceRightWithIndex = $29936cf2e0dcbf22$var$reduceRightWithIndex;
/**
 * @category traversing
 * @since 2.6.3
 */ var $29936cf2e0dcbf22$var$traverse = function(F) {
    var traverseWithIndexF = (0, module.exports.traverseWithIndex)(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
module.exports.traverse = $29936cf2e0dcbf22$var$traverse;
/**
 * @category traversing
 * @since 2.6.3
 */ var $29936cf2e0dcbf22$var$sequence = function(F) {
    return function(ta) {
        return $29936cf2e0dcbf22$var$_reduce(ta, F.of((0, module.exports.zero)()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $3abDJ.pipe)(as, (0, module.exports.append)(a));
                };
            }), fa);
        });
    };
};
module.exports.sequence = $29936cf2e0dcbf22$var$sequence;
/**
 * @category sequencing
 * @since 2.6.3
 */ var $29936cf2e0dcbf22$var$traverseWithIndex = function(F) {
    return function(f) {
        return (0, module.exports.reduceWithIndex)(F.of((0, module.exports.zero)()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $3abDJ.pipe)(bs, (0, module.exports.append)(b));
                };
            }), f(i, a));
        });
    };
};
module.exports.traverseWithIndex = $29936cf2e0dcbf22$var$traverseWithIndex;
/**
 * @category filtering
 * @since 2.6.5
 */ var $29936cf2e0dcbf22$var$wither = function(F) {
    var _witherF = $29936cf2e0dcbf22$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
module.exports.wither = $29936cf2e0dcbf22$var$wither;
/**
 * @category filtering
 * @since 2.6.5
 */ var $29936cf2e0dcbf22$var$wilt = function(F) {
    var _wiltF = $29936cf2e0dcbf22$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
module.exports.wilt = $29936cf2e0dcbf22$var$wilt;
/**
 * @since 2.6.6
 */ var $29936cf2e0dcbf22$var$unfold = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($29936cf2e0dcbf22$var$_.isSome(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
module.exports.unfold = $29936cf2e0dcbf22$var$unfold;
/**
 * @category type lambdas
 * @since 2.5.0
 */ module.exports.URI = 'ReadonlyArray';
/**
 * @category instances
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$getShow = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
module.exports.getShow = $29936cf2e0dcbf22$var$getShow;
/**
 * @category instances
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$getSemigroup = function() {
    return {
        concat: function(first, second) {
            return (0, module.exports.isEmpty)(first) ? second : (0, module.exports.isEmpty)(second) ? first : first.concat(second);
        }
    };
};
module.exports.getSemigroup = $29936cf2e0dcbf22$var$getSemigroup;
/**
 * Returns a `Monoid` for `ReadonlyArray<A>`.
 *
 * @example
 * import { getMonoid } from 'fp-ts/ReadonlyArray'
 *
 * const M = getMonoid<number>()
 * assert.deepStrictEqual(M.concat([1, 2], [3, 4]), [1, 2, 3, 4])
 *
 * @category instances
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$getMonoid = function() {
    return {
        concat: (0, module.exports.getSemigroup)().concat,
        empty: module.exports.empty
    };
};
module.exports.getMonoid = $29936cf2e0dcbf22$var$getMonoid;
/**
 * Derives an `Eq` over the `ReadonlyArray` of a given element type from the `Eq` of that type. The derived `Eq` defines two
 * arrays as equal if all elements of both arrays are compared equal pairwise with the given `E`. In case of arrays of
 * different lengths, the result is non equality.
 *
 * @example
 * import * as S from 'fp-ts/string'
 * import { getEq } from 'fp-ts/ReadonlyArray'
 *
 * const E = getEq(S.Eq)
 * assert.strictEqual(E.equals(['a', 'b'], ['a', 'b']), true)
 * assert.strictEqual(E.equals(['a'], []), false)
 *
 * @category instances
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$getEq = function(E) {
    return (0, $5Ikl1.fromEquals)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
module.exports.getEq = $29936cf2e0dcbf22$var$getEq;
/**
 * Derives an `Ord` over the `ReadonlyArray` of a given element type from the `Ord` of that type. The ordering between two such
 * arrays is equal to: the first non equal comparison of each arrays elements taken pairwise in increasing order, in
 * case of equality over all the pairwise elements; the longest array is considered the greatest, if both arrays have
 * the same length, the result is equality.
 *
 * @example
 * import { getOrd } from 'fp-ts/ReadonlyArray'
 * import * as S from 'fp-ts/string'
 *
 * const O = getOrd(S.Ord)
 * assert.strictEqual(O.compare(['b'], ['a']), 1)
 * assert.strictEqual(O.compare(['a'], ['a']), 0)
 * assert.strictEqual(O.compare(['a'], ['b']), -1)
 *
 *
 * @category instances
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$getOrd = function(O) {
    return (0, $e51aV.fromCompare)(function(a, b) {
        var aLen = a.length;
        var bLen = b.length;
        var len = Math.min(aLen, bLen);
        for(var i = 0; i < len; i++){
            var ordering = O.compare(a[i], b[i]);
            if (ordering !== 0) return ordering;
        }
        return $29936cf2e0dcbf22$var$N.Ord.compare(aLen, bLen);
    });
};
module.exports.getOrd = $29936cf2e0dcbf22$var$getOrd;
/**
 * @category instances
 * @since 2.11.0
 */ var $29936cf2e0dcbf22$var$getUnionSemigroup = function(E) {
    var unionE = $29936cf2e0dcbf22$var$union(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
module.exports.getUnionSemigroup = $29936cf2e0dcbf22$var$getUnionSemigroup;
/**
 * @category instances
 * @since 2.11.0
 */ var $29936cf2e0dcbf22$var$getUnionMonoid = function(E) {
    return {
        concat: (0, module.exports.getUnionSemigroup)(E).concat,
        empty: module.exports.empty
    };
};
module.exports.getUnionMonoid = $29936cf2e0dcbf22$var$getUnionMonoid;
/**
 * @category instances
 * @since 2.11.0
 */ var $29936cf2e0dcbf22$var$getIntersectionSemigroup = function(E) {
    var intersectionE = $29936cf2e0dcbf22$var$intersection(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
module.exports.getIntersectionSemigroup = $29936cf2e0dcbf22$var$getIntersectionSemigroup;
/**
 * @category instances
 * @since 2.11.0
 */ var $29936cf2e0dcbf22$var$getDifferenceMagma = function(E) {
    var differenceE = $29936cf2e0dcbf22$var$difference(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
module.exports.getDifferenceMagma = $29936cf2e0dcbf22$var$getDifferenceMagma;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Functor = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map
};
/**
 * @category mapping
 * @since 2.10.0
 */ module.exports.flap = (0, $emm1u.flap)(module.exports.Functor);
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Pointed = {
    URI: module.exports.URI,
    of: module.exports.of
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.FunctorWithIndex = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map,
    mapWithIndex: $29936cf2e0dcbf22$var$_mapWithIndex
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Apply = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map,
    ap: $29936cf2e0dcbf22$var$_ap
};
/**
 * Combine two effectful actions, keeping only the result of the first.
 *
 * @since 2.5.0
 */ module.exports.apFirst = (0, $4sfjE.apFirst)(module.exports.Apply);
/**
 * Combine two effectful actions, keeping only the result of the second.
 *
 * @since 2.5.0
 */ module.exports.apSecond = (0, $4sfjE.apSecond)(module.exports.Apply);
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Applicative = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map,
    ap: $29936cf2e0dcbf22$var$_ap,
    of: module.exports.of
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Chain = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map,
    ap: $29936cf2e0dcbf22$var$_ap,
    chain: module.exports.flatMap
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Monad = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map,
    ap: $29936cf2e0dcbf22$var$_ap,
    of: module.exports.of,
    chain: module.exports.flatMap
};
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * @example
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3],
 *     RA.chainFirst(() => ['a', 'b'])
 *   ),
 *   [1, 1, 2, 2, 3, 3]
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     [1, 2, 3],
 *     RA.chainFirst(() => [])
 *   ),
 *   []
 * )
 *
 * @category sequencing
 * @since 2.5.0
 */ module.exports.chainFirst = /*#__PURE__*/ (0, $ERVGH.chainFirst)(module.exports.Chain);
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Unfoldable = {
    URI: module.exports.URI,
    unfold: module.exports.unfold
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Alt = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map,
    alt: $29936cf2e0dcbf22$var$_alt
};
/**
 * @category instances
 * @since 2.11.0
 */ module.exports.Zero = {
    URI: module.exports.URI,
    zero: module.exports.zero
};
/**
 * @category do notation
 * @since 2.11.0
 */ module.exports.guard = (0, $iV0VO.guard)(module.exports.Zero, module.exports.Pointed);
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Alternative = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map,
    ap: $29936cf2e0dcbf22$var$_ap,
    of: module.exports.of,
    alt: $29936cf2e0dcbf22$var$_alt,
    zero: module.exports.zero
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Extend = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map,
    extend: $29936cf2e0dcbf22$var$_extend
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Compactable = {
    URI: module.exports.URI,
    compact: module.exports.compact,
    separate: module.exports.separate
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Filterable = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map,
    compact: module.exports.compact,
    separate: module.exports.separate,
    filter: $29936cf2e0dcbf22$var$_filter,
    filterMap: $29936cf2e0dcbf22$var$_filterMap,
    partition: $29936cf2e0dcbf22$var$_partition,
    partitionMap: $29936cf2e0dcbf22$var$_partitionMap
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.FilterableWithIndex = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map,
    mapWithIndex: $29936cf2e0dcbf22$var$_mapWithIndex,
    compact: module.exports.compact,
    separate: module.exports.separate,
    filter: $29936cf2e0dcbf22$var$_filter,
    filterMap: $29936cf2e0dcbf22$var$_filterMap,
    partition: $29936cf2e0dcbf22$var$_partition,
    partitionMap: $29936cf2e0dcbf22$var$_partitionMap,
    partitionMapWithIndex: $29936cf2e0dcbf22$var$_partitionMapWithIndex,
    partitionWithIndex: $29936cf2e0dcbf22$var$_partitionWithIndex,
    filterMapWithIndex: $29936cf2e0dcbf22$var$_filterMapWithIndex,
    filterWithIndex: $29936cf2e0dcbf22$var$_filterWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Foldable = {
    URI: module.exports.URI,
    reduce: $29936cf2e0dcbf22$var$_reduce,
    foldMap: $29936cf2e0dcbf22$var$_foldMap,
    reduceRight: $29936cf2e0dcbf22$var$_reduceRight
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.FoldableWithIndex = {
    URI: module.exports.URI,
    reduce: $29936cf2e0dcbf22$var$_reduce,
    foldMap: $29936cf2e0dcbf22$var$_foldMap,
    reduceRight: $29936cf2e0dcbf22$var$_reduceRight,
    reduceWithIndex: $29936cf2e0dcbf22$var$_reduceWithIndex,
    foldMapWithIndex: $29936cf2e0dcbf22$var$_foldMapWithIndex,
    reduceRightWithIndex: $29936cf2e0dcbf22$var$_reduceRightWithIndex
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Traversable = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map,
    reduce: $29936cf2e0dcbf22$var$_reduce,
    foldMap: $29936cf2e0dcbf22$var$_foldMap,
    reduceRight: $29936cf2e0dcbf22$var$_reduceRight,
    traverse: $29936cf2e0dcbf22$var$_traverse,
    sequence: module.exports.sequence
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.TraversableWithIndex = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map,
    mapWithIndex: $29936cf2e0dcbf22$var$_mapWithIndex,
    reduce: $29936cf2e0dcbf22$var$_reduce,
    foldMap: $29936cf2e0dcbf22$var$_foldMap,
    reduceRight: $29936cf2e0dcbf22$var$_reduceRight,
    reduceWithIndex: $29936cf2e0dcbf22$var$_reduceWithIndex,
    foldMapWithIndex: $29936cf2e0dcbf22$var$_foldMapWithIndex,
    reduceRightWithIndex: $29936cf2e0dcbf22$var$_reduceRightWithIndex,
    traverse: $29936cf2e0dcbf22$var$_traverse,
    sequence: module.exports.sequence,
    traverseWithIndex: $29936cf2e0dcbf22$var$_traverseWithIndex
};
/**
 * @category sequencing
 * @since 2.11.0
 */ var $29936cf2e0dcbf22$var$chainRecDepthFirst = function(f) {
    return function(a) {
        var todo = $29936cf2e0dcbf22$var$__spreadArray([], f(a), true);
        var out = [];
        while(todo.length > 0){
            var e = todo.shift();
            if ($29936cf2e0dcbf22$var$_.isLeft(e)) todo.unshift.apply(todo, f(e.left));
            else out.push(e.right);
        }
        return out;
    };
};
module.exports.chainRecDepthFirst = $29936cf2e0dcbf22$var$chainRecDepthFirst;
/**
 * @category instances
 * @since 2.11.0
 */ module.exports.ChainRecDepthFirst = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map,
    ap: $29936cf2e0dcbf22$var$_ap,
    chain: module.exports.flatMap,
    chainRec: module.exports._chainRecDepthFirst
};
/**
 * @category sequencing
 * @since 2.11.0
 */ var $29936cf2e0dcbf22$var$chainRecBreadthFirst = function(f) {
    return function(a) {
        var initial = f(a);
        var todo = [];
        var out = [];
        function go(e) {
            if ($29936cf2e0dcbf22$var$_.isLeft(e)) f(e.left).forEach(function(v) {
                return todo.push(v);
            });
            else out.push(e.right);
        }
        for(var _i = 0, initial_1 = initial; _i < initial_1.length; _i++){
            var e = initial_1[_i];
            go(e);
        }
        while(todo.length > 0)go(todo.shift());
        return out;
    };
};
module.exports.chainRecBreadthFirst = $29936cf2e0dcbf22$var$chainRecBreadthFirst;
/**
 * @category instances
 * @since 2.11.0
 */ module.exports.ChainRecBreadthFirst = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map,
    ap: $29936cf2e0dcbf22$var$_ap,
    chain: module.exports.flatMap,
    chainRec: module.exports._chainRecBreadthFirst
};
var $29936cf2e0dcbf22$var$_wither = /*#__PURE__*/ (0, $4p4Yq.witherDefault)(module.exports.Traversable, module.exports.Compactable);
var $29936cf2e0dcbf22$var$_wilt = /*#__PURE__*/ (0, $4p4Yq.wiltDefault)(module.exports.Traversable, module.exports.Compactable);
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Witherable = {
    URI: module.exports.URI,
    map: $29936cf2e0dcbf22$var$_map,
    compact: module.exports.compact,
    separate: module.exports.separate,
    filter: $29936cf2e0dcbf22$var$_filter,
    filterMap: $29936cf2e0dcbf22$var$_filterMap,
    partition: $29936cf2e0dcbf22$var$_partition,
    partitionMap: $29936cf2e0dcbf22$var$_partitionMap,
    reduce: $29936cf2e0dcbf22$var$_reduce,
    foldMap: $29936cf2e0dcbf22$var$_foldMap,
    reduceRight: $29936cf2e0dcbf22$var$_reduceRight,
    traverse: $29936cf2e0dcbf22$var$_traverse,
    sequence: module.exports.sequence,
    wither: $29936cf2e0dcbf22$var$_wither,
    wilt: $29936cf2e0dcbf22$var$_wilt
};
/**
 * Filter values inside a context.
 *
 * @example
 * import { pipe } from 'fp-ts/function'
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import * as T from 'fp-ts/Task'
 *
 * const filterE = RA.filterE(T.ApplicativePar)
 * async function test() {
 *   assert.deepStrictEqual(
 *     await pipe(
 *       [-1, 2, 3],
 *       filterE((n) => T.of(n > 0))
 *     )(),
 *     [2, 3]
 *   )
 * }
 * test()
 *
 * @since 2.11.0
 */ module.exports.filterE = (0, $4p4Yq.filterE)(module.exports.Witherable);
/**
 * @category instances
 * @since 2.11.0
 */ module.exports.FromEither = {
    URI: module.exports.URI,
    fromEither: module.exports.fromEither
};
/**
 * @category lifting
 * @since 2.11.0
 */ module.exports.fromEitherK = (0, $eLQyV.fromEitherK)(module.exports.FromEither);
// -------------------------------------------------------------------------------------
// unsafe
// -------------------------------------------------------------------------------------
/**
 * @category unsafe
 * @since 2.5.0
 */ module.exports.unsafeInsertAt = $29936cf2e0dcbf22$var$RNEA.unsafeInsertAt;
/**
 * @category unsafe
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$unsafeUpdateAt = function(i, a, as) {
    return (0, module.exports.isNonEmpty)(as) ? $29936cf2e0dcbf22$var$RNEA.unsafeUpdateAt(i, a, as) : as;
};
module.exports.unsafeUpdateAt = $29936cf2e0dcbf22$var$unsafeUpdateAt;
/**
 * @category unsafe
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$unsafeDeleteAt = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
module.exports.unsafeDeleteAt = $29936cf2e0dcbf22$var$unsafeDeleteAt;
/**
 * @category conversions
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$toArray = function(as) {
    return as.slice();
};
module.exports.toArray = $29936cf2e0dcbf22$var$toArray;
/**
 * @category conversions
 * @since 2.5.0
 */ var $29936cf2e0dcbf22$var$fromArray = function(as) {
    return (0, module.exports.isEmpty)(as) ? module.exports.empty : as.slice();
};
module.exports.fromArray = $29936cf2e0dcbf22$var$fromArray;
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * An empty array
 *
 * @since 2.5.0
 */ module.exports.empty = $29936cf2e0dcbf22$var$RNEA.empty;
function $29936cf2e0dcbf22$var$every(predicate) {
    return function(as) {
        return as.every(predicate);
    };
}
/**
 * Check if a predicate holds true for any array member.
 *
 * @example
 * import { some } from 'fp-ts/ReadonlyArray'
 * import { pipe } from 'fp-ts/function'
 *
 * const isPositive = (n: number): boolean => n > 0
 *
 * assert.deepStrictEqual(pipe([-1, -2, 3], some(isPositive)), true)
 * assert.deepStrictEqual(pipe([-1, -2, -3], some(isPositive)), false)
 *
 * @since 2.9.0
 */ var $29936cf2e0dcbf22$var$some = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
module.exports.some = $29936cf2e0dcbf22$var$some;
/**
 * Alias of [`some`](#some)
 *
 * @since 2.11.0
 */ module.exports.exists = module.exports.some;
/**
 * Places an element in between members of a `ReadonlyArray`, then folds the results using the provided `Monoid`.
 *
 * @example
 * import * as S from 'fp-ts/string'
 * import { intercalate } from 'fp-ts/ReadonlyArray'
 *
 * assert.deepStrictEqual(intercalate(S.Monoid)('-')(['a', 'b', 'c']), 'a-b-c')
 *
 * @since 2.12.0
 */ var $29936cf2e0dcbf22$var$intercalate = function(M) {
    var intercalateM = $29936cf2e0dcbf22$var$RNEA.intercalate(M);
    return function(middle) {
        return (0, module.exports.match)(function() {
            return M.empty;
        }, intercalateM(middle));
    };
};
module.exports.intercalate = $29936cf2e0dcbf22$var$intercalate;
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * @category do notation
 * @since 2.9.0
 */ module.exports.Do = (0, module.exports.of)($29936cf2e0dcbf22$var$_.emptyRecord);
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.bindTo = (0, $emm1u.bindTo)(module.exports.Functor);
var $29936cf2e0dcbf22$var$let_ = /*#__PURE__*/ (0, $emm1u.let)(module.exports.Functor);
module.exports.let = $29936cf2e0dcbf22$var$let_;
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.bind = (0, $ERVGH.bind)(module.exports.Chain);
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.apS = (0, $4sfjE.apS)(module.exports.Apply);
// -------------------------------------------------------------------------------------
// legacy
// -------------------------------------------------------------------------------------
/**
 * Alias of `flatMap`.
 *
 * @category legacy
 * @since 2.5.0
 */ module.exports.chain = module.exports.flatMap;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * Use `ReadonlyNonEmptyArray` module instead.
 *
 * @category zone of death
 * @since 2.5.0
 * @deprecated
 */ module.exports.range = $29936cf2e0dcbf22$var$RNEA.range;
/**
 * Use [`prepend`](#prepend) instead.
 *
 * @category zone of death
 * @since 2.5.0
 * @deprecated
 */ module.exports.cons = $29936cf2e0dcbf22$var$RNEA.cons;
/**
 * Use [`append`](#append) instead.
 *
 * @category zone of death
 * @since 2.5.0
 * @deprecated
 */ module.exports.snoc = $29936cf2e0dcbf22$var$RNEA.snoc;
/**
 * Use [`prependAll`](#prependall) instead.
 *
 * @category zone of death
 * @since 2.9.0
 * @deprecated
 */ module.exports.prependToAll = module.exports.prependAll;
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Functor` instance, pass `RA.Functor` instead of `RA.readonlyArray`
 * (where `RA` is from `import RA from 'fp-ts/ReadonlyArray'`)
 *
 * @category zone of death
 * @since 2.5.0
 * @deprecated
 */ module.exports.readonlyArray = {
    URI: module.exports.URI,
    compact: module.exports.compact,
    separate: module.exports.separate,
    map: $29936cf2e0dcbf22$var$_map,
    ap: $29936cf2e0dcbf22$var$_ap,
    of: module.exports.of,
    chain: module.exports.flatMap,
    filter: $29936cf2e0dcbf22$var$_filter,
    filterMap: $29936cf2e0dcbf22$var$_filterMap,
    partition: $29936cf2e0dcbf22$var$_partition,
    partitionMap: $29936cf2e0dcbf22$var$_partitionMap,
    mapWithIndex: $29936cf2e0dcbf22$var$_mapWithIndex,
    partitionMapWithIndex: $29936cf2e0dcbf22$var$_partitionMapWithIndex,
    partitionWithIndex: $29936cf2e0dcbf22$var$_partitionWithIndex,
    filterMapWithIndex: $29936cf2e0dcbf22$var$_filterMapWithIndex,
    filterWithIndex: $29936cf2e0dcbf22$var$_filterWithIndex,
    alt: $29936cf2e0dcbf22$var$_alt,
    zero: module.exports.zero,
    unfold: module.exports.unfold,
    reduce: $29936cf2e0dcbf22$var$_reduce,
    foldMap: $29936cf2e0dcbf22$var$_foldMap,
    reduceRight: $29936cf2e0dcbf22$var$_reduceRight,
    traverse: $29936cf2e0dcbf22$var$_traverse,
    sequence: module.exports.sequence,
    reduceWithIndex: $29936cf2e0dcbf22$var$_reduceWithIndex,
    foldMapWithIndex: $29936cf2e0dcbf22$var$_foldMapWithIndex,
    reduceRightWithIndex: $29936cf2e0dcbf22$var$_reduceRightWithIndex,
    traverseWithIndex: $29936cf2e0dcbf22$var$_traverseWithIndex,
    extend: $29936cf2e0dcbf22$var$_extend,
    wither: $29936cf2e0dcbf22$var$_wither,
    wilt: $29936cf2e0dcbf22$var$_wilt
};

});
parcelRegister("b25hP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Field = module.exports.MonoidProduct = module.exports.MonoidSum = module.exports.SemigroupProduct = module.exports.SemigroupSum = module.exports.MagmaSub = module.exports.Show = module.exports.Bounded = module.exports.Ord = module.exports.Eq = module.exports.isNumber = void 0;
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * @category refinements
 * @since 2.11.0
 */ var $8083fb69ab437f5d$var$isNumber = function(u) {
    return typeof u === 'number';
};
module.exports.isNumber = $8083fb69ab437f5d$var$isNumber;
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Eq = {
    equals: function(first, second) {
        return first === second;
    }
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Ord = {
    equals: module.exports.Eq.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Bounded = {
    equals: module.exports.Eq.equals,
    compare: module.exports.Ord.compare,
    top: Infinity,
    bottom: -Infinity
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Show = {
    show: function(n) {
        return JSON.stringify(n);
    }
};
/**
 * @category instances
 * @since 2.11.0
 */ module.exports.MagmaSub = {
    concat: function(first, second) {
        return first - second;
    }
};
/**
 * `number` semigroup under addition.
 *
 * @example
 * import { SemigroupSum } from 'fp-ts/number'
 *
 * assert.deepStrictEqual(SemigroupSum.concat(2, 3), 5)
 *
 * @category instances
 * @since 2.10.0
 */ module.exports.SemigroupSum = {
    concat: function(first, second) {
        return first + second;
    }
};
/**
 * `number` semigroup under multiplication.
 *
 * @example
 * import { SemigroupProduct } from 'fp-ts/number'
 *
 * assert.deepStrictEqual(SemigroupProduct.concat(2, 3), 6)
 *
 * @category instances
 * @since 2.10.0
 */ module.exports.SemigroupProduct = {
    concat: function(first, second) {
        return first * second;
    }
};
/**
 * `number` monoid under addition.
 *
 * The `empty` value is `0`.
 *
 * @example
 * import { MonoidSum } from 'fp-ts/number'
 *
 * assert.deepStrictEqual(MonoidSum.concat(2, MonoidSum.empty), 2)
 *
 * @category instances
 * @since 2.10.0
 */ module.exports.MonoidSum = {
    concat: module.exports.SemigroupSum.concat,
    empty: 0
};
/**
 * `number` monoid under multiplication.
 *
 * The `empty` value is `1`.
 *
 * @example
 * import { MonoidProduct } from 'fp-ts/number'
 *
 * assert.deepStrictEqual(MonoidProduct.concat(2, MonoidProduct.empty), 2)
 *
 * @category instances
 * @since 2.10.0
 */ module.exports.MonoidProduct = {
    concat: module.exports.SemigroupProduct.concat,
    empty: 1
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Field = {
    add: module.exports.SemigroupSum.concat,
    zero: 0,
    mul: module.exports.SemigroupProduct.concat,
    one: 1,
    sub: module.exports.MagmaSub.concat,
    degree: function(_) {
        return 1;
    },
    div: function(first, second) {
        return first / second;
    },
    mod: function(first, second) {
        return first % second;
    }
};

});

parcelRegister("iV0VO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.guard = $dc5e45da5735ab2e$var$guard;
function $dc5e45da5735ab2e$var$guard(F, P) {
    return function(b) {
        return b ? P.of(undefined) : F.zero();
    };
}

});



parcelRegister("hBXBN", function(module, exports) {
"use strict";
var $cd24216776b8c70b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cd24216776b8c70b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $cd24216776b8c70b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $cd24216776b8c70b$var$__createBinding(result, mod, k);
    }
    $cd24216776b8c70b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.throwError = module.exports.Witherable = module.exports.wilt = module.exports.wither = module.exports.Traversable = module.exports.sequence = module.exports.traverse = module.exports.Filterable = module.exports.partitionMap = module.exports.partition = module.exports.filterMap = module.exports.filter = module.exports.Compactable = module.exports.separate = module.exports.compact = module.exports.Extend = module.exports.extend = module.exports.Alternative = module.exports.guard = module.exports.Zero = module.exports.zero = module.exports.Alt = module.exports.alt = module.exports.altW = module.exports.orElse = module.exports.Foldable = module.exports.reduceRight = module.exports.foldMap = module.exports.reduce = module.exports.Monad = module.exports.Chain = module.exports.flatMap = module.exports.Applicative = module.exports.Apply = module.exports.ap = module.exports.Pointed = module.exports.of = module.exports.asUnit = module.exports.as = module.exports.Functor = module.exports.map = module.exports.getMonoid = module.exports.getOrd = module.exports.getEq = module.exports.getShow = module.exports.URI = module.exports.getRight = module.exports.getLeft = module.exports.some = module.exports.none = void 0;
module.exports.getLastMonoid = module.exports.getFirstMonoid = module.exports.getApplyMonoid = module.exports.getApplySemigroup = module.exports.option = module.exports.mapNullable = module.exports.chainFirst = module.exports.chain = module.exports.sequenceArray = module.exports.traverseArray = module.exports.traverseArrayWithIndex = module.exports.traverseReadonlyArrayWithIndex = module.exports.traverseReadonlyNonEmptyArrayWithIndex = module.exports.ApT = module.exports.apS = module.exports.bind = module.exports.let = module.exports.bindTo = module.exports.Do = module.exports.exists = module.exports.toUndefined = module.exports.toNullable = module.exports.chainNullableK = module.exports.fromNullableK = module.exports.tryCatchK = module.exports.tryCatch = module.exports.fromNullable = module.exports.chainFirstEitherK = module.exports.chainEitherK = module.exports.fromEitherK = module.exports.duplicate = module.exports.tapEither = module.exports.tap = module.exports.flatten = module.exports.apSecond = module.exports.apFirst = module.exports.flap = module.exports.getOrElse = module.exports.getOrElseW = module.exports.fold = module.exports.match = module.exports.foldW = module.exports.matchW = module.exports.isNone = module.exports.isSome = module.exports.FromEither = module.exports.fromEither = module.exports.MonadThrow = void 0;
module.exports.fromPredicate = $cd24216776b8c70b$var$fromPredicate;
module.exports.elem = $cd24216776b8c70b$var$elem;
module.exports.getRefinement = $cd24216776b8c70b$var$getRefinement;

var $eImHL = parcelRequire("eImHL");

var $4sfjE = parcelRequire("4sfjE");

var $cd24216776b8c70b$var$chainable = $cd24216776b8c70b$var$__importStar((parcelRequire("ERVGH")));

var $eLQyV = parcelRequire("eLQyV");

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");

var $cd24216776b8c70b$var$_ = $cd24216776b8c70b$var$__importStar((parcelRequire("704qB")));

var $6t3HJ = parcelRequire("6t3HJ");

var $3OUuJ = parcelRequire("3OUuJ");

var $fIQoU = parcelRequire("fIQoU");

var $4p4Yq = parcelRequire("4p4Yq");

var $iV0VO = parcelRequire("iV0VO");
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * `None` doesn't have a constructor, instead you can use it directly as a value. Represents a missing value.
 *
 * @category constructors
 * @since 2.0.0
 */ module.exports.none = $cd24216776b8c70b$var$_.none;
/**
 * Constructs a `Some`. Represents an optional value that exists.
 *
 * @category constructors
 * @since 2.0.0
 */ module.exports.some = $cd24216776b8c70b$var$_.some;
function $cd24216776b8c70b$var$fromPredicate(predicate) {
    return function(a) {
        return predicate(a) ? (0, module.exports.some)(a) : module.exports.none;
    };
}
/**
 * Returns the `Left` value of an `Either` if possible.
 *
 * @example
 * import { getLeft, none, some } from 'fp-ts/Option'
 * import { right, left } from 'fp-ts/Either'
 *
 * assert.deepStrictEqual(getLeft(right(1)), none)
 * assert.deepStrictEqual(getLeft(left('a')), some('a'))
 *
 * @category constructors
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$getLeft = function(ma) {
    return ma._tag === 'Right' ? module.exports.none : (0, module.exports.some)(ma.left);
};
module.exports.getLeft = $cd24216776b8c70b$var$getLeft;
/**
 * Returns the `Right` value of an `Either` if possible.
 *
 * @example
 * import { getRight, none, some } from 'fp-ts/Option'
 * import { right, left } from 'fp-ts/Either'
 *
 * assert.deepStrictEqual(getRight(right(1)), some(1))
 * assert.deepStrictEqual(getRight(left('a')), none)
 *
 * @category constructors
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$getRight = function(ma) {
    return ma._tag === 'Left' ? module.exports.none : (0, module.exports.some)(ma.right);
};
module.exports.getRight = $cd24216776b8c70b$var$getRight;
var $cd24216776b8c70b$var$_map = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.map)(f));
};
var $cd24216776b8c70b$var$_ap = function(fab, fa) {
    return (0, $3abDJ.pipe)(fab, (0, module.exports.ap)(fa));
};
var $cd24216776b8c70b$var$_reduce = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduce)(b, f));
};
var $cd24216776b8c70b$var$_foldMap = function(M) {
    var foldMapM = (0, module.exports.foldMap)(M);
    return function(fa, f) {
        return (0, $3abDJ.pipe)(fa, foldMapM(f));
    };
};
var $cd24216776b8c70b$var$_reduceRight = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.reduceRight)(b, f));
};
var $cd24216776b8c70b$var$_traverse = function(F) {
    var traverseF = (0, module.exports.traverse)(F);
    return function(ta, f) {
        return (0, $3abDJ.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $cd24216776b8c70b$var$_alt = function(fa, that) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.alt)(that));
};
var $cd24216776b8c70b$var$_filter = function(fa, predicate) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.filter)(predicate));
};
/* istanbul ignore next */ var $cd24216776b8c70b$var$_filterMap = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.filterMap)(f));
};
/* istanbul ignore next */ var $cd24216776b8c70b$var$_extend = function(wa, f) {
    return (0, $3abDJ.pipe)(wa, (0, module.exports.extend)(f));
};
/* istanbul ignore next */ var $cd24216776b8c70b$var$_partition = function(fa, predicate) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.partition)(predicate));
};
/* istanbul ignore next */ var $cd24216776b8c70b$var$_partitionMap = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.partitionMap)(f));
};
/**
 * @category type lambdas
 * @since 2.0.0
 */ module.exports.URI = 'Option';
/**
 * @category instances
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$getShow = function(S) {
    return {
        show: function(ma) {
            return (0, module.exports.isNone)(ma) ? 'none' : "some(".concat(S.show(ma.value), ")");
        }
    };
};
module.exports.getShow = $cd24216776b8c70b$var$getShow;
/**
 * @example
 * import { none, some, getEq } from 'fp-ts/Option'
 * import * as N from 'fp-ts/number'
 *
 * const E = getEq(N.Eq)
 * assert.strictEqual(E.equals(none, none), true)
 * assert.strictEqual(E.equals(none, some(1)), false)
 * assert.strictEqual(E.equals(some(1), none), false)
 * assert.strictEqual(E.equals(some(1), some(2)), false)
 * assert.strictEqual(E.equals(some(1), some(1)), true)
 *
 * @category instances
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$getEq = function(E) {
    return {
        equals: function(x, y) {
            return x === y || ((0, module.exports.isNone)(x) ? (0, module.exports.isNone)(y) : (0, module.exports.isNone)(y) ? false : E.equals(x.value, y.value));
        }
    };
};
module.exports.getEq = $cd24216776b8c70b$var$getEq;
/**
 * The `Ord` instance allows `Option` values to be compared with
 * `compare`, whenever there is an `Ord` instance for
 * the type the `Option` contains.
 *
 * `None` is considered to be less than any `Some` value.
 *
 *
 * @example
 * import { none, some, getOrd } from 'fp-ts/Option'
 * import * as N from 'fp-ts/number'
 *
 * const O = getOrd(N.Ord)
 * assert.strictEqual(O.compare(none, none), 0)
 * assert.strictEqual(O.compare(none, some(1)), -1)
 * assert.strictEqual(O.compare(some(1), none), 1)
 * assert.strictEqual(O.compare(some(1), some(2)), -1)
 * assert.strictEqual(O.compare(some(1), some(1)), 0)
 *
 * @category instances
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$getOrd = function(O) {
    return {
        equals: (0, module.exports.getEq)(O).equals,
        compare: function(x, y) {
            return x === y ? 0 : (0, module.exports.isSome)(x) ? (0, module.exports.isSome)(y) ? O.compare(x.value, y.value) : 1 : -1;
        }
    };
};
module.exports.getOrd = $cd24216776b8c70b$var$getOrd;
/**
 * Monoid returning the left-most non-`None` value. If both operands are `Some`s then the inner values are
 * concatenated using the provided `Semigroup`
 *
 * | x       | y       | concat(x, y)       |
 * | ------- | ------- | ------------------ |
 * | none    | none    | none               |
 * | some(a) | none    | some(a)            |
 * | none    | some(b) | some(b)            |
 * | some(a) | some(b) | some(concat(a, b)) |
 *
 * @example
 * import { getMonoid, some, none } from 'fp-ts/Option'
 * import { SemigroupSum } from 'fp-ts/number'
 *
 * const M = getMonoid(SemigroupSum)
 * assert.deepStrictEqual(M.concat(none, none), none)
 * assert.deepStrictEqual(M.concat(some(1), none), some(1))
 * assert.deepStrictEqual(M.concat(none, some(1)), some(1))
 * assert.deepStrictEqual(M.concat(some(1), some(2)), some(3))
 *
 * @category instances
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$getMonoid = function(S) {
    return {
        concat: function(x, y) {
            return (0, module.exports.isNone)(x) ? y : (0, module.exports.isNone)(y) ? x : (0, module.exports.some)(S.concat(x.value, y.value));
        },
        empty: module.exports.none
    };
};
module.exports.getMonoid = $cd24216776b8c70b$var$getMonoid;
/**
 * @category mapping
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$map = function(f) {
    return function(fa) {
        return (0, module.exports.isNone)(fa) ? module.exports.none : (0, module.exports.some)(f(fa.value));
    };
};
module.exports.map = $cd24216776b8c70b$var$map;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Functor = {
    URI: module.exports.URI,
    map: $cd24216776b8c70b$var$_map
};
/**
 * Maps the `Some` value of this `Option` to the specified constant value.
 *
 * @category mapping
 * @since 2.16.0
 */ module.exports.as = (0, $3abDJ.dual)(2, (0, $emm1u.as)(module.exports.Functor));
/**
 * Maps the `Some` value of this `Option` to the void constant value.
 *
 * @category mapping
 * @since 2.16.0
 */ module.exports.asUnit = (0, $emm1u.asUnit)(module.exports.Functor);
/**
 * @category constructors
 * @since 2.7.0
 */ module.exports.of = module.exports.some;
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Pointed = {
    URI: module.exports.URI,
    of: module.exports.of
};
/**
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$ap = function(fa) {
    return function(fab) {
        return (0, module.exports.isNone)(fab) ? module.exports.none : (0, module.exports.isNone)(fa) ? module.exports.none : (0, module.exports.some)(fab.value(fa.value));
    };
};
module.exports.ap = $cd24216776b8c70b$var$ap;
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Apply = {
    URI: module.exports.URI,
    map: $cd24216776b8c70b$var$_map,
    ap: $cd24216776b8c70b$var$_ap
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Applicative = {
    URI: module.exports.URI,
    map: $cd24216776b8c70b$var$_map,
    ap: $cd24216776b8c70b$var$_ap,
    of: module.exports.of
};
/**
 * @category sequencing
 * @since 2.14.0
 */ module.exports.flatMap = (0, $3abDJ.dual)(2, function(ma, f) {
    return (0, module.exports.isNone)(ma) ? module.exports.none : f(ma.value);
});
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Chain = {
    URI: module.exports.URI,
    map: $cd24216776b8c70b$var$_map,
    ap: $cd24216776b8c70b$var$_ap,
    chain: module.exports.flatMap
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Monad = {
    URI: module.exports.URI,
    map: $cd24216776b8c70b$var$_map,
    ap: $cd24216776b8c70b$var$_ap,
    of: module.exports.of,
    chain: module.exports.flatMap
};
/**
 * @category folding
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$reduce = function(b, f) {
    return function(fa) {
        return (0, module.exports.isNone)(fa) ? b : f(b, fa.value);
    };
};
module.exports.reduce = $cd24216776b8c70b$var$reduce;
/**
 * @category folding
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$foldMap = function(M) {
    return function(f) {
        return function(fa) {
            return (0, module.exports.isNone)(fa) ? M.empty : f(fa.value);
        };
    };
};
module.exports.foldMap = $cd24216776b8c70b$var$foldMap;
/**
 * @category folding
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$reduceRight = function(b, f) {
    return function(fa) {
        return (0, module.exports.isNone)(fa) ? b : f(fa.value, b);
    };
};
module.exports.reduceRight = $cd24216776b8c70b$var$reduceRight;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Foldable = {
    URI: module.exports.URI,
    reduce: $cd24216776b8c70b$var$_reduce,
    foldMap: $cd24216776b8c70b$var$_foldMap,
    reduceRight: $cd24216776b8c70b$var$_reduceRight
};
/**
 * Returns the provided `Option` `that` if `self` is `None`, otherwise returns `self`.
 *
 * @param self - The first `Option` to be checked.
 * @param that - The `Option` to return if `self` is `None`.
 *
 * @example
 * import * as O from "fp-ts/Option"
 *
 * assert.deepStrictEqual(O.orElse(O.none, () => O.none), O.none)
 * assert.deepStrictEqual(O.orElse(O.some(1), () => O.none), O.some(1))
 * assert.deepStrictEqual(O.orElse(O.none, () => O.some('b')), O.some('b'))
 * assert.deepStrictEqual(O.orElse(O.some(1), () => O.some('b')), O.some(1))
 *
 * @category error handling
 * @since 2.16.0
 */ module.exports.orElse = (0, $3abDJ.dual)(2, function(self, that) {
    return (0, module.exports.isNone)(self) ? that() : self;
});
/**
 * Alias of `orElse`.
 *
 * Less strict version of [`alt`](#alt).
 *
 * The `W` suffix (short for **W**idening) means that the return types will be merged.
 *
 * @category legacy
 * @since 2.9.0
 */ module.exports.altW = module.exports.orElse;
/**
 * Alias of `orElse`.
 *
 * @category legacy
 * @since 2.0.0
 */ module.exports.alt = module.exports.orElse;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Alt = {
    URI: module.exports.URI,
    map: $cd24216776b8c70b$var$_map,
    alt: $cd24216776b8c70b$var$_alt
};
/**
 * @since 2.7.0
 */ var $cd24216776b8c70b$var$zero = function() {
    return module.exports.none;
};
module.exports.zero = $cd24216776b8c70b$var$zero;
/**
 * @category instances
 * @since 2.11.0
 */ module.exports.Zero = {
    URI: module.exports.URI,
    zero: module.exports.zero
};
/**
 * @category do notation
 * @since 2.11.0
 */ module.exports.guard = (0, $iV0VO.guard)(module.exports.Zero, module.exports.Pointed);
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Alternative = {
    URI: module.exports.URI,
    map: $cd24216776b8c70b$var$_map,
    ap: $cd24216776b8c70b$var$_ap,
    of: module.exports.of,
    alt: $cd24216776b8c70b$var$_alt,
    zero: module.exports.zero
};
/**
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$extend = function(f) {
    return function(wa) {
        return (0, module.exports.isNone)(wa) ? module.exports.none : (0, module.exports.some)(f(wa));
    };
};
module.exports.extend = $cd24216776b8c70b$var$extend;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Extend = {
    URI: module.exports.URI,
    map: $cd24216776b8c70b$var$_map,
    extend: $cd24216776b8c70b$var$_extend
};
/**
 * @category filtering
 * @since 2.0.0
 */ module.exports.compact = (0, module.exports.flatMap)($3abDJ.identity);
var $cd24216776b8c70b$var$defaultSeparated = /*#__PURE__*/ (0, $fIQoU.separated)(module.exports.none, module.exports.none);
/**
 * @category filtering
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$separate = function(ma) {
    return (0, module.exports.isNone)(ma) ? $cd24216776b8c70b$var$defaultSeparated : (0, $fIQoU.separated)((0, module.exports.getLeft)(ma.value), (0, module.exports.getRight)(ma.value));
};
module.exports.separate = $cd24216776b8c70b$var$separate;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Compactable = {
    URI: module.exports.URI,
    compact: module.exports.compact,
    separate: module.exports.separate
};
/**
 * @category filtering
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$filter = function(predicate) {
    return function(fa) {
        return (0, module.exports.isNone)(fa) ? module.exports.none : predicate(fa.value) ? fa : module.exports.none;
    };
};
module.exports.filter = $cd24216776b8c70b$var$filter;
/**
 * @category filtering
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$filterMap = function(f) {
    return function(fa) {
        return (0, module.exports.isNone)(fa) ? module.exports.none : f(fa.value);
    };
};
module.exports.filterMap = $cd24216776b8c70b$var$filterMap;
/**
 * @category filtering
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$partition = function(predicate) {
    return function(fa) {
        return (0, $fIQoU.separated)($cd24216776b8c70b$var$_filter(fa, (0, $6t3HJ.not)(predicate)), $cd24216776b8c70b$var$_filter(fa, predicate));
    };
};
module.exports.partition = $cd24216776b8c70b$var$partition;
/**
 * @category filtering
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$partitionMap = function(f) {
    return (0, $3abDJ.flow)((0, module.exports.map)(f), module.exports.separate);
};
module.exports.partitionMap = $cd24216776b8c70b$var$partitionMap;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Filterable = {
    URI: module.exports.URI,
    map: $cd24216776b8c70b$var$_map,
    compact: module.exports.compact,
    separate: module.exports.separate,
    filter: $cd24216776b8c70b$var$_filter,
    filterMap: $cd24216776b8c70b$var$_filterMap,
    partition: $cd24216776b8c70b$var$_partition,
    partitionMap: $cd24216776b8c70b$var$_partitionMap
};
/**
 * @category traversing
 * @since 2.6.3
 */ var $cd24216776b8c70b$var$traverse = function(F) {
    return function(f) {
        return function(ta) {
            return (0, module.exports.isNone)(ta) ? F.of(module.exports.none) : F.map(f(ta.value), module.exports.some);
        };
    };
};
module.exports.traverse = $cd24216776b8c70b$var$traverse;
/**
 * @category traversing
 * @since 2.6.3
 */ var $cd24216776b8c70b$var$sequence = function(F) {
    return function(ta) {
        return (0, module.exports.isNone)(ta) ? F.of(module.exports.none) : F.map(ta.value, module.exports.some);
    };
};
module.exports.sequence = $cd24216776b8c70b$var$sequence;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Traversable = {
    URI: module.exports.URI,
    map: $cd24216776b8c70b$var$_map,
    reduce: $cd24216776b8c70b$var$_reduce,
    foldMap: $cd24216776b8c70b$var$_foldMap,
    reduceRight: $cd24216776b8c70b$var$_reduceRight,
    traverse: $cd24216776b8c70b$var$_traverse,
    sequence: module.exports.sequence
};
var $cd24216776b8c70b$var$_wither = /*#__PURE__*/ (0, $4p4Yq.witherDefault)(module.exports.Traversable, module.exports.Compactable);
var $cd24216776b8c70b$var$_wilt = /*#__PURE__*/ (0, $4p4Yq.wiltDefault)(module.exports.Traversable, module.exports.Compactable);
/**
 * @category filtering
 * @since 2.6.5
 */ var $cd24216776b8c70b$var$wither = function(F) {
    var _witherF = $cd24216776b8c70b$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
module.exports.wither = $cd24216776b8c70b$var$wither;
/**
 * @category filtering
 * @since 2.6.5
 */ var $cd24216776b8c70b$var$wilt = function(F) {
    var _wiltF = $cd24216776b8c70b$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
module.exports.wilt = $cd24216776b8c70b$var$wilt;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Witherable = {
    URI: module.exports.URI,
    map: $cd24216776b8c70b$var$_map,
    reduce: $cd24216776b8c70b$var$_reduce,
    foldMap: $cd24216776b8c70b$var$_foldMap,
    reduceRight: $cd24216776b8c70b$var$_reduceRight,
    traverse: $cd24216776b8c70b$var$_traverse,
    sequence: module.exports.sequence,
    compact: module.exports.compact,
    separate: module.exports.separate,
    filter: $cd24216776b8c70b$var$_filter,
    filterMap: $cd24216776b8c70b$var$_filterMap,
    partition: $cd24216776b8c70b$var$_partition,
    partitionMap: $cd24216776b8c70b$var$_partitionMap,
    wither: $cd24216776b8c70b$var$_wither,
    wilt: $cd24216776b8c70b$var$_wilt
};
/**
 * @since 2.7.0
 */ var $cd24216776b8c70b$var$throwError = function() {
    return module.exports.none;
};
module.exports.throwError = $cd24216776b8c70b$var$throwError;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.MonadThrow = {
    URI: module.exports.URI,
    map: $cd24216776b8c70b$var$_map,
    ap: $cd24216776b8c70b$var$_ap,
    of: module.exports.of,
    chain: module.exports.flatMap,
    throwError: module.exports.throwError
};
/**
 * Transforms an `Either` to an `Option` discarding the error.
 *
 * Alias of [getRight](#getright)
 *
 * @category conversions
 * @since 2.0.0
 */ module.exports.fromEither = module.exports.getRight;
/**
 * @category instances
 * @since 2.11.0
 */ module.exports.FromEither = {
    URI: module.exports.URI,
    fromEither: module.exports.fromEither
};
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * Returns `true` if the option is an instance of `Some`, `false` otherwise.
 *
 * @example
 * import { some, none, isSome } from 'fp-ts/Option'
 *
 * assert.strictEqual(isSome(some(1)), true)
 * assert.strictEqual(isSome(none), false)
 *
 * @category refinements
 * @since 2.0.0
 */ module.exports.isSome = $cd24216776b8c70b$var$_.isSome;
/**
 * Returns `true` if the option is `None`, `false` otherwise.
 *
 * @example
 * import { some, none, isNone } from 'fp-ts/Option'
 *
 * assert.strictEqual(isNone(some(1)), false)
 * assert.strictEqual(isNone(none), true)
 *
 * @category refinements
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$isNone = function(fa) {
    return fa._tag === 'None';
};
module.exports.isNone = $cd24216776b8c70b$var$isNone;
/**
 * Less strict version of [`match`](#match).
 *
 * The `W` suffix (short for **W**idening) means that the handler return types will be merged.
 *
 * @category pattern matching
 * @since 2.10.0
 */ var $cd24216776b8c70b$var$matchW = function(onNone, onSome) {
    return function(ma) {
        return (0, module.exports.isNone)(ma) ? onNone() : onSome(ma.value);
    };
};
module.exports.matchW = $cd24216776b8c70b$var$matchW;
/**
 * Alias of [`matchW`](#matchw).
 *
 * @category pattern matching
 * @since 2.10.0
 */ module.exports.foldW = module.exports.matchW;
/**
 * Takes a (lazy) default value, a function, and an `Option` value, if the `Option` value is `None` the default value is
 * returned, otherwise the function is applied to the value inside the `Some` and the result is returned.
 *
 * @example
 * import { some, none, match } from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.strictEqual(
 *   pipe(
 *     some(1),
 *     match(() => 'a none', a => `a some containing ${a}`)
 *   ),
 *   'a some containing 1'
 * )
 *
 * assert.strictEqual(
 *   pipe(
 *     none,
 *     match(() => 'a none', a => `a some containing ${a}`)
 *   ),
 *   'a none'
 * )
 *
 * @category pattern matching
 * @since 2.10.0
 */ module.exports.match = module.exports.matchW;
/**
 * Alias of [`match`](#match).
 *
 * @category pattern matching
 * @since 2.0.0
 */ module.exports.fold = module.exports.match;
/**
 * Less strict version of [`getOrElse`](#getorelse).
 *
 * The `W` suffix (short for **W**idening) means that the handler return type will be merged.
 *
 * @category error handling
 * @since 2.6.0
 */ var $cd24216776b8c70b$var$getOrElseW = function(onNone) {
    return function(ma) {
        return (0, module.exports.isNone)(ma) ? onNone() : ma.value;
    };
};
module.exports.getOrElseW = $cd24216776b8c70b$var$getOrElseW;
/**
 * Extracts the value out of the structure, if it exists. Otherwise returns the given default value
 *
 * @example
 * import { some, none, getOrElse } from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.strictEqual(
 *   pipe(
 *     some(1),
 *     getOrElse(() => 0)
 *   ),
 *   1
 * )
 * assert.strictEqual(
 *   pipe(
 *     none,
 *     getOrElse(() => 0)
 *   ),
 *   0
 * )
 *
 * @category error handling
 * @since 2.0.0
 */ module.exports.getOrElse = module.exports.getOrElseW;
/**
 * @category mapping
 * @since 2.10.0
 */ module.exports.flap = (0, $emm1u.flap)(module.exports.Functor);
/**
 * Combine two effectful actions, keeping only the result of the first.
 *
 * @since 2.0.0
 */ module.exports.apFirst = (0, $4sfjE.apFirst)(module.exports.Apply);
/**
 * Combine two effectful actions, keeping only the result of the second.
 *
 * @since 2.0.0
 */ module.exports.apSecond = (0, $4sfjE.apSecond)(module.exports.Apply);
/**
 * @category sequencing
 * @since 2.0.0
 */ module.exports.flatten = module.exports.compact;
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * @category combinators
 * @since 2.15.0
 */ module.exports.tap = (0, $3abDJ.dual)(2, $cd24216776b8c70b$var$chainable.tap(module.exports.Chain));
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * @example
 * import { pipe } from 'fp-ts/function'
 * import * as O from 'fp-ts/Option'
 * import * as E from 'fp-ts/Either'
 *
 * const compute = (value: number) => pipe(
 *   O.of(value),
 *   O.tapEither((value) => value > 0 ? E.right('ok') : E.left('error')),
 * )
 *
 * assert.deepStrictEqual(compute(1), O.of(1))
 * assert.deepStrictEqual(compute(-42), O.none)
 *
 * @category combinators
 * @since 2.16.0
 */ module.exports.tapEither = (0, $3abDJ.dual)(2, (0, $eLQyV.tapEither)(module.exports.FromEither, module.exports.Chain));
/**
 * @since 2.0.0
 */ module.exports.duplicate = (0, module.exports.extend)($3abDJ.identity);
/**
 * @category lifting
 * @since 2.11.0
 */ module.exports.fromEitherK = (0, $eLQyV.fromEitherK)(module.exports.FromEither);
/**
 * @category sequencing
 * @since 2.11.0
 */ module.exports.chainEitherK = /*#__PURE__*/ (0, $eLQyV.chainEitherK)(module.exports.FromEither, module.exports.Chain);
/**
 * Alias of `tapEither`.
 *
 * @category legacy
 * @since 2.12.0
 */ module.exports.chainFirstEitherK = module.exports.tapEither;
/**
 * Constructs a new `Option` from a nullable type. If the value is `null` or `undefined`, returns `None`, otherwise
 * returns the value wrapped in a `Some`.
 *
 * @example
 * import { none, some, fromNullable } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(fromNullable(undefined), none)
 * assert.deepStrictEqual(fromNullable(null), none)
 * assert.deepStrictEqual(fromNullable(1), some(1))
 *
 * @category conversions
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$fromNullable = function(a) {
    return a == null ? module.exports.none : (0, module.exports.some)(a);
};
module.exports.fromNullable = $cd24216776b8c70b$var$fromNullable;
/**
 * Transforms an exception into an `Option`. If `f` throws, returns `None`, otherwise returns the output wrapped in a
 * `Some`.
 *
 * See also [`tryCatchK`](#trycatchk).
 *
 * @example
 * import { none, some, tryCatch } from 'fp-ts/Option'
 *
 * assert.deepStrictEqual(
 *   tryCatch(() => {
 *     throw new Error()
 *   }),
 *   none
 * )
 * assert.deepStrictEqual(tryCatch(() => 1), some(1))
 *
 * @category interop
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$tryCatch = function(f) {
    try {
        return (0, module.exports.some)(f());
    } catch (e) {
        return module.exports.none;
    }
};
module.exports.tryCatch = $cd24216776b8c70b$var$tryCatch;
/**
 * Converts a function that may throw to one returning a `Option`.
 *
 * @category interop
 * @since 2.10.0
 */ var $cd24216776b8c70b$var$tryCatchK = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return (0, module.exports.tryCatch)(function() {
            return f.apply(void 0, a);
        });
    };
};
module.exports.tryCatchK = $cd24216776b8c70b$var$tryCatchK;
/**
 * Returns a *smart constructor* from a function that returns a nullable value.
 *
 * @example
 * import { fromNullableK, none, some } from 'fp-ts/Option'
 *
 * const f = (s: string): number | undefined => {
 *   const n = parseFloat(s)
 *   return isNaN(n) ? undefined : n
 * }
 *
 * const g = fromNullableK(f)
 *
 * assert.deepStrictEqual(g('1'), some(1))
 * assert.deepStrictEqual(g('a'), none)
 *
 * @category lifting
 * @since 2.9.0
 */ var $cd24216776b8c70b$var$fromNullableK = function(f) {
    return (0, $3abDJ.flow)(f, module.exports.fromNullable);
};
module.exports.fromNullableK = $cd24216776b8c70b$var$fromNullableK;
/**
 * This is `chain` + `fromNullable`, useful when working with optional values.
 *
 * @example
 * import { some, none, fromNullable, chainNullableK } from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * interface Employee {
 *   readonly company?: {
 *     readonly address?: {
 *       readonly street?: {
 *         readonly name?: string
 *       }
 *     }
 *   }
 * }
 *
 * const employee1: Employee = { company: { address: { street: { name: 'high street' } } } }
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     fromNullable(employee1.company),
 *     chainNullableK(company => company.address),
 *     chainNullableK(address => address.street),
 *     chainNullableK(street => street.name)
 *   ),
 *   some('high street')
 * )
 *
 * const employee2: Employee = { company: { address: { street: {} } } }
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     fromNullable(employee2.company),
 *     chainNullableK(company => company.address),
 *     chainNullableK(address => address.street),
 *     chainNullableK(street => street.name)
 *   ),
 *   none
 * )
 *
 * @category sequencing
 * @since 2.9.0
 */ var $cd24216776b8c70b$var$chainNullableK = function(f) {
    return function(ma) {
        return (0, module.exports.isNone)(ma) ? module.exports.none : (0, module.exports.fromNullable)(f(ma.value));
    };
};
module.exports.chainNullableK = $cd24216776b8c70b$var$chainNullableK;
/**
 * Extracts the value out of the structure, if it exists. Otherwise returns `null`.
 *
 * @example
 * import { some, none, toNullable } from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.strictEqual(
 *   pipe(
 *     some(1),
 *     toNullable
 *   ),
 *   1
 * )
 * assert.strictEqual(
 *   pipe(
 *     none,
 *     toNullable
 *   ),
 *   null
 * )
 *
 * @category conversions
 * @since 2.0.0
 */ module.exports.toNullable = (0, module.exports.match)($3abDJ.constNull, $3abDJ.identity);
/**
 * Extracts the value out of the structure, if it exists. Otherwise returns `undefined`.
 *
 * @example
 * import { some, none, toUndefined } from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.strictEqual(
 *   pipe(
 *     some(1),
 *     toUndefined
 *   ),
 *   1
 * )
 * assert.strictEqual(
 *   pipe(
 *     none,
 *     toUndefined
 *   ),
 *   undefined
 * )
 *
 * @category conversions
 * @since 2.0.0
 */ module.exports.toUndefined = (0, module.exports.match)($3abDJ.constUndefined, $3abDJ.identity);
function $cd24216776b8c70b$var$elem(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $cd24216776b8c70b$var$elem(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return (0, module.exports.isNone)(ma) ? false : E.equals(a, ma.value);
    };
}
/**
 * Returns `true` if the predicate is satisfied by the wrapped value
 *
 * @example
 * import { some, none, exists } from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.strictEqual(
 *   pipe(
 *     some(1),
 *     exists(n => n > 0)
 *   ),
 *   true
 * )
 * assert.strictEqual(
 *   pipe(
 *     some(1),
 *     exists(n => n > 1)
 *   ),
 *   false
 * )
 * assert.strictEqual(
 *   pipe(
 *     none,
 *     exists(n => n > 0)
 *   ),
 *   false
 * )
 *
 * @since 2.0.0
 */ var $cd24216776b8c70b$var$exists = function(predicate) {
    return function(ma) {
        return (0, module.exports.isNone)(ma) ? false : predicate(ma.value);
    };
};
module.exports.exists = $cd24216776b8c70b$var$exists;
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * @category do notation
 * @since 2.9.0
 */ module.exports.Do = (0, module.exports.of)($cd24216776b8c70b$var$_.emptyRecord);
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.bindTo = (0, $emm1u.bindTo)(module.exports.Functor);
var $cd24216776b8c70b$var$let_ = /*#__PURE__*/ (0, $emm1u.let)(module.exports.Functor);
module.exports.let = $cd24216776b8c70b$var$let_;
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.bind = $cd24216776b8c70b$var$chainable.bind(module.exports.Chain);
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.apS = (0, $4sfjE.apS)(module.exports.Apply);
/**
 * @since 2.11.0
 */ module.exports.ApT = (0, module.exports.of)($cd24216776b8c70b$var$_.emptyReadonlyArray);
// -------------------------------------------------------------------------------------
// array utils
// -------------------------------------------------------------------------------------
/**
 * Equivalent to `ReadonlyNonEmptyArray#traverseWithIndex(Applicative)`.
 *
 * @category traversing
 * @since 2.11.0
 */ var $cd24216776b8c70b$var$traverseReadonlyNonEmptyArrayWithIndex = function(f) {
    return function(as) {
        var o = f(0, $cd24216776b8c70b$var$_.head(as));
        if ((0, module.exports.isNone)(o)) return module.exports.none;
        var out = [
            o.value
        ];
        for(var i = 1; i < as.length; i++){
            var o_1 = f(i, as[i]);
            if ((0, module.exports.isNone)(o_1)) return module.exports.none;
            out.push(o_1.value);
        }
        return (0, module.exports.some)(out);
    };
};
module.exports.traverseReadonlyNonEmptyArrayWithIndex = $cd24216776b8c70b$var$traverseReadonlyNonEmptyArrayWithIndex;
/**
 * Equivalent to `ReadonlyArray#traverseWithIndex(Applicative)`.
 *
 * @category traversing
 * @since 2.11.0
 */ var $cd24216776b8c70b$var$traverseReadonlyArrayWithIndex = function(f) {
    var g = (0, module.exports.traverseReadonlyNonEmptyArrayWithIndex)(f);
    return function(as) {
        return $cd24216776b8c70b$var$_.isNonEmpty(as) ? g(as) : module.exports.ApT;
    };
};
module.exports.traverseReadonlyArrayWithIndex = $cd24216776b8c70b$var$traverseReadonlyArrayWithIndex;
/**
 * Equivalent to `ReadonlyArray#traverseWithIndex(Applicative)`.
 *
 * @category traversing
 * @since 2.9.0
 */ module.exports.traverseArrayWithIndex = module.exports.traverseReadonlyArrayWithIndex;
/**
 * Equivalent to `ReadonlyArray#traverse(Applicative)`.
 *
 * @category traversing
 * @since 2.9.0
 */ var $cd24216776b8c70b$var$traverseArray = function(f) {
    return (0, module.exports.traverseReadonlyArrayWithIndex)(function(_, a) {
        return f(a);
    });
};
module.exports.traverseArray = $cd24216776b8c70b$var$traverseArray;
/**
 * Equivalent to `ReadonlyArray#sequence(Applicative)`.
 *
 * @category traversing
 * @since 2.9.0
 */ module.exports.sequenceArray = /*#__PURE__*/ (0, module.exports.traverseArray)($3abDJ.identity);
// -------------------------------------------------------------------------------------
// legacy
// -------------------------------------------------------------------------------------
/**
 * Alias of `flatMap`.
 *
 * @category legacy
 * @since 2.0.0
 */ module.exports.chain = module.exports.flatMap;
/**
 * Alias of `tap`.
 *
 * @category legacy
 * @since 2.0.0
 */ module.exports.chainFirst = module.exports.tap;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * Use `Refinement` module instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ function $cd24216776b8c70b$var$getRefinement(getOption) {
    return function(a) {
        return (0, module.exports.isSome)(getOption(a));
    };
}
/**
 * Use [`chainNullableK`](#chainnullablek) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.mapNullable = module.exports.chainNullableK;
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Functor` instance, pass `O.Functor` instead of `O.option`
 * (where `O` is from `import O from 'fp-ts/Option'`)
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.option = {
    URI: module.exports.URI,
    map: $cd24216776b8c70b$var$_map,
    of: module.exports.of,
    ap: $cd24216776b8c70b$var$_ap,
    chain: module.exports.flatMap,
    reduce: $cd24216776b8c70b$var$_reduce,
    foldMap: $cd24216776b8c70b$var$_foldMap,
    reduceRight: $cd24216776b8c70b$var$_reduceRight,
    traverse: $cd24216776b8c70b$var$_traverse,
    sequence: module.exports.sequence,
    zero: module.exports.zero,
    alt: $cd24216776b8c70b$var$_alt,
    extend: $cd24216776b8c70b$var$_extend,
    compact: module.exports.compact,
    separate: module.exports.separate,
    filter: $cd24216776b8c70b$var$_filter,
    filterMap: $cd24216776b8c70b$var$_filterMap,
    partition: $cd24216776b8c70b$var$_partition,
    partitionMap: $cd24216776b8c70b$var$_partitionMap,
    wither: $cd24216776b8c70b$var$_wither,
    wilt: $cd24216776b8c70b$var$_wilt,
    throwError: module.exports.throwError
};
/**
 * Use [`getApplySemigroup`](./Apply.ts.html#getapplysemigroup) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getApplySemigroup = (0, $4sfjE.getApplySemigroup)(module.exports.Apply);
/**
 * Use [`getApplicativeMonoid`](./Applicative.ts.html#getapplicativemonoid) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getApplyMonoid = (0, $eImHL.getApplicativeMonoid)(module.exports.Applicative);
/**
 * Use
 *
 * ```ts
 * import { first } from 'fp-ts/Semigroup'
 * import { getMonoid } from 'fp-ts/Option'
 *
 * getMonoid(first())
 * ```
 *
 * instead.
 *
 * Monoid returning the left-most non-`None` value
 *
 * | x       | y       | concat(x, y) |
 * | ------- | ------- | ------------ |
 * | none    | none    | none         |
 * | some(a) | none    | some(a)      |
 * | none    | some(b) | some(b)      |
 * | some(a) | some(b) | some(a)      |
 *
 * @example
 * import { getFirstMonoid, some, none } from 'fp-ts/Option'
 *
 * const M = getFirstMonoid<number>()
 * assert.deepStrictEqual(M.concat(none, none), none)
 * assert.deepStrictEqual(M.concat(some(1), none), some(1))
 * assert.deepStrictEqual(M.concat(none, some(2)), some(2))
 * assert.deepStrictEqual(M.concat(some(1), some(2)), some(1))
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ var $cd24216776b8c70b$var$getFirstMonoid = function() {
    return (0, module.exports.getMonoid)((0, $3OUuJ.first)());
};
module.exports.getFirstMonoid = $cd24216776b8c70b$var$getFirstMonoid;
/**
 * Use
 *
 * ```ts
 * import { last } from 'fp-ts/Semigroup'
 * import { getMonoid } from 'fp-ts/Option'
 *
 * getMonoid(last())
 * ```
 *
 * instead.
 *
 * Monoid returning the right-most non-`None` value
 *
 * | x       | y       | concat(x, y) |
 * | ------- | ------- | ------------ |
 * | none    | none    | none         |
 * | some(a) | none    | some(a)      |
 * | none    | some(b) | some(b)      |
 * | some(a) | some(b) | some(b)      |
 *
 * @example
 * import { getLastMonoid, some, none } from 'fp-ts/Option'
 *
 * const M = getLastMonoid<number>()
 * assert.deepStrictEqual(M.concat(none, none), none)
 * assert.deepStrictEqual(M.concat(some(1), none), some(1))
 * assert.deepStrictEqual(M.concat(none, some(2)), some(2))
 * assert.deepStrictEqual(M.concat(some(1), some(2)), some(2))
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ var $cd24216776b8c70b$var$getLastMonoid = function() {
    return (0, module.exports.getMonoid)((0, $3OUuJ.last)());
};
module.exports.getLastMonoid = $cd24216776b8c70b$var$getLastMonoid;

});
parcelRegister("6t3HJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.and = module.exports.or = module.exports.not = module.exports.Contravariant = module.exports.getMonoidAll = module.exports.getSemigroupAll = module.exports.getMonoidAny = module.exports.getSemigroupAny = module.exports.URI = module.exports.contramap = void 0;

var $3abDJ = parcelRequire("3abDJ");
var $4b58531a6a29566c$var$contramap_ = function(predicate, f) {
    return (0, $3abDJ.pipe)(predicate, (0, module.exports.contramap)(f));
};
/**
 * @since 2.11.0
 */ var $4b58531a6a29566c$var$contramap = function(f) {
    return function(predicate) {
        return (0, $3abDJ.flow)(f, predicate);
    };
};
module.exports.contramap = $4b58531a6a29566c$var$contramap;
/**
 * @category type lambdas
 * @since 2.11.0
 */ module.exports.URI = 'Predicate';
/**
 * @category instances
 * @since 2.11.0
 */ var $4b58531a6a29566c$var$getSemigroupAny = function() {
    return {
        concat: function(first, second) {
            return (0, $3abDJ.pipe)(first, (0, module.exports.or)(second));
        }
    };
};
module.exports.getSemigroupAny = $4b58531a6a29566c$var$getSemigroupAny;
/**
 * @category instances
 * @since 2.11.0
 */ var $4b58531a6a29566c$var$getMonoidAny = function() {
    return {
        concat: (0, module.exports.getSemigroupAny)().concat,
        empty: $3abDJ.constFalse
    };
};
module.exports.getMonoidAny = $4b58531a6a29566c$var$getMonoidAny;
/**
 * @category instances
 * @since 2.11.0
 */ var $4b58531a6a29566c$var$getSemigroupAll = function() {
    return {
        concat: function(first, second) {
            return (0, $3abDJ.pipe)(first, (0, module.exports.and)(second));
        }
    };
};
module.exports.getSemigroupAll = $4b58531a6a29566c$var$getSemigroupAll;
/**
 * @category instances
 * @since 2.11.0
 */ var $4b58531a6a29566c$var$getMonoidAll = function() {
    return {
        concat: (0, module.exports.getSemigroupAll)().concat,
        empty: $3abDJ.constTrue
    };
};
module.exports.getMonoidAll = $4b58531a6a29566c$var$getMonoidAll;
/**
 * @category instances
 * @since 2.11.0
 */ module.exports.Contravariant = {
    URI: module.exports.URI,
    contramap: $4b58531a6a29566c$var$contramap_
};
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * @since 2.11.0
 */ var $4b58531a6a29566c$var$not = function(predicate) {
    return function(a) {
        return !predicate(a);
    };
};
module.exports.not = $4b58531a6a29566c$var$not;
/**
 * @since 2.11.0
 */ var $4b58531a6a29566c$var$or = function(second) {
    return function(first) {
        return function(a) {
            return first(a) || second(a);
        };
    };
};
module.exports.or = $4b58531a6a29566c$var$or;
/**
 * @since 2.11.0
 */ var $4b58531a6a29566c$var$and = function(second) {
    return function(first) {
        return function(a) {
            return first(a) && second(a);
        };
    };
};
module.exports.and = $4b58531a6a29566c$var$and;

});


parcelRegister("kisy7", function(module, exports) {

$parcel$export(module.exports, "Lens", () => Lens);
$parcel$export(module.exports, "Prism", () => Prism);
$parcel$export(module.exports, "Optional", () => Optional);
$parcel$export(module.exports, "Index", () => Index);
$parcel$export(module.exports, "fromTraversable", () => fromTraversable);
/**
 * @since 1.0.0
 */ 
var $kLIh4 = parcelRequire("kLIh4");

var $9nKyz = parcelRequire("9nKyz");

var $lWM6H = parcelRequire("lWM6H");

var $jCSd8 = parcelRequire("jCSd8");

var $5OFXS = parcelRequire("5OFXS");

var $aOL40 = parcelRequire("aOL40");

var $7x7NY = parcelRequire("7x7NY");

var $cWuKG = parcelRequire("cWuKG");

var $4CMYJ = parcelRequire("4CMYJ");

var $2pOLl = parcelRequire("2pOLl");

var $7hEeH = parcelRequire("7hEeH");

var $bwWgx = parcelRequire("bwWgx");

var $l4Tkk = parcelRequire("l4Tkk");
//
// compat
//
var fromIso = function(iso) {
    return new Iso(iso.get, iso.reverseGet);
};
var fromLens = function(lens) {
    return new Lens(lens.get, lens.set);
};
var fromPrism = function(prism) {
    return new Prism(prism.getOption, prism.reverseGet);
};
var fromOptional = function(optional) {
    return new Optional(optional.getOption, optional.set);
};
var fromTraversal = function(traversal) {
    return new Traversal(traversal.modifyF);
};
var fromAt = function(at) {
    return new At(function(i) {
        return fromLens(at.at(i));
    });
};
var fromIndex = function(ix) {
    return new Index(function(i) {
        return fromOptional(ix.index(i));
    });
};
//
// old APIs
//
var update = function(o, k, a) {
    var _a;
    return a === o[k] ? o : Object.assign({}, o, (_a = {}, _a[k] = a, _a));
};
/**
 * Laws:
 * 1. `reverseGet(get(s)) = s`
 * 2. `get(reversetGet(a)) = a`
 *
 * @category constructor
 * @since 1.0.0
 */ var Iso = /** @class */ function() {
    function Iso(get, reverseGet) {
        this.get = get;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Iso';
        /**
         * @since 1.0.0
         */ this.unwrap = this.get;
        /**
         * @since 1.0.0
         */ this.to = this.get;
        /**
         * @since 1.0.0
         */ this.wrap = this.reverseGet;
        /**
         * @since 1.0.0
         */ this.from = this.reverseGet;
    }
    /**
     * reverse the `Iso`: the source becomes the target and the target becomes the source
     * @since 1.0.0
     */ Iso.prototype.reverse = function() {
        return fromIso($cWuKG.reverse(this));
    };
    /**
     * @since 1.0.0
     */ Iso.prototype.modify = function(f) {
        return $cWuKG.modify(f)(this);
    };
    /**
     * view an `Iso` as a `Lens`
     *
     * @since 1.0.0
     */ Iso.prototype.asLens = function() {
        return fromLens($cWuKG.asLens(this));
    };
    /**
     * view an `Iso` as a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.asPrism = function() {
        return fromPrism($cWuKG.asPrism(this));
    };
    /**
     * view an `Iso` as a `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.asOptional = function() {
        return fromOptional($cWuKG.asOptional(this));
    };
    /**
     * view an `Iso` as a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.asTraversal = function() {
        return fromTraversal($cWuKG.asTraversal(this));
    };
    /**
     * view an `Iso` as a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * view an `Iso` as a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view an `Iso` as a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose an `Iso` with an `Iso`
     *
     * @since 1.0.0
     */ Iso.prototype.compose = function(ab) {
        return fromIso($cWuKG.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Iso.prototype.composeIso = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Iso` with a `Lens `
     *
     * @since 1.0.0
     */ Iso.prototype.composeLens = function(ab) {
        return fromLens((0, $aOL40.pipe)(this, $cWuKG.asLens, $2pOLl.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.composePrism = function(ab) {
        return fromPrism((0, $aOL40.pipe)(this, $cWuKG.asPrism, $bwWgx.compose(ab)));
    };
    /**
     * compose an `Iso` with an `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.composeOptional = function(ab) {
        return fromOptional((0, $aOL40.pipe)(this, $cWuKG.asOptional, $7hEeH.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $aOL40.pipe)(this, $cWuKG.asTraversal, $l4Tkk.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Iso` with a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose an `Iso` with a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    return Iso;
}();
/**
 * Laws:
 * 1. `get(set(a)(s)) = a`
 * 2. `set(get(s))(s) = s`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Lens = /** @class */ function() {
    function Lens(get, set) {
        this.get = get;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Lens';
    }
    /**
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     *   address: {
     *     city: string
     *   }
     * }
     *
     * const city = Lens.fromPath<Person>()(['address', 'city'])
     *
     * const person: Person = { name: 'Giulio', age: 43, address: { city: 'Milan' } }
     *
     * assert.strictEqual(city.get(person), 'Milan')
     * assert.deepStrictEqual(city.set('London')(person), { name: 'Giulio', age: 43, address: { city: 'London' } })
     *
     * @since 1.0.0
     */ Lens.fromPath = function() {
        var fromProp = Lens.fromProp();
        return function(path) {
            var lens = fromProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromProp(prop));
            }, lens);
        };
    };
    /**
     * Returns a `Lens` from a type and a prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     * }
     *
     * const age = Lens.fromProp<Person>()('age')
     *
     * const person: Person = { name: 'Giulio', age: 43 }
     *
     * assert.strictEqual(age.get(person), 43)
     * assert.deepStrictEqual(age.set(44)(person), { name: 'Giulio', age: 44 })
     *
     * @since 1.0.0
     */ Lens.fromProp = function() {
        return function(prop) {
            return fromLens((0, $aOL40.pipe)($2pOLl.id(), $2pOLl.prop(prop)));
        };
    };
    Lens.fromProps = function() {
        return function(props) {
            return fromLens((0, $aOL40.pipe)($2pOLl.id(), $2pOLl.props.apply($2pOLl, props)));
        };
    };
    /**
     * Returns a `Lens` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * interface Outer {
     *   inner?: Inner
     * }
     *
     * interface Inner {
     *   value: number
     *   foo: string
     * }
     *
     * const inner = Lens.fromNullableProp<Outer>()('inner', { value: 0, foo: 'foo' })
     * const value = Lens.fromProp<Inner>()('value')
     * const lens = inner.compose(value)
     *
     * assert.deepStrictEqual(lens.set(1)({}), { inner: { value: 1, foo: 'foo' } })
     * assert.strictEqual(lens.get({}), 0)
     * assert.deepStrictEqual(lens.set(1)({ inner: { value: 1, foo: 'bar' } }), { inner: { value: 1, foo: 'bar' } })
     * assert.strictEqual(lens.get({ inner: { value: 1, foo: 'bar' } }), 1)
     *
     * @since 1.0.0
     */ Lens.fromNullableProp = function() {
        return function(k, defaultValue) {
            return new Lens(function(s) {
                var osk = (0, $5OFXS.fromNullable)(s[k]);
                if ((0, $5OFXS.isNone)(osk)) return defaultValue;
                else return osk.value;
            }, function(a) {
                return function(s) {
                    return update(s, k, a);
                };
            });
        };
    };
    /**
     * @since 1.0.0
     */ Lens.prototype.modify = function(f) {
        return $2pOLl.modify(f)(this);
    };
    /**
     * view a `Lens` as a Optional
     *
     * @since 1.0.0
     */ Lens.prototype.asOptional = function() {
        return fromOptional($2pOLl.asOptional(this));
    };
    /**
     * view a `Lens` as a `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.asTraversal = function() {
        return fromTraversal($2pOLl.asTraversal(this));
    };
    /**
     * view a `Lens` as a `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Lens` as a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view a `Lens` as a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Lens` with a `Lens`
     *
     * @since 1.0.0
     */ Lens.prototype.compose = function(ab) {
        return fromLens($2pOLl.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Lens.prototype.composeLens = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Lens` with a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose a `Lens` with a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Lens` with an `Optional`
     *
     * @since 1.0.0
     */ Lens.prototype.composeOptional = function(ab) {
        return fromOptional((0, $aOL40.pipe)(this, $2pOLl.asOptional, $7hEeH.compose(ab)));
    };
    /**
     * compose a `Lens` with an `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $aOL40.pipe)(this, $2pOLl.asTraversal, $l4Tkk.compose(ab)));
    };
    /**
     * compose a `Lens` with an `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Lens` with an `Iso`
     *
     * @since 1.0.0
     */ Lens.prototype.composeIso = function(ab) {
        return fromLens((0, $aOL40.pipe)(this, $2pOLl.compose((0, $aOL40.pipe)(ab, $cWuKG.asLens))));
    };
    /**
     * compose a `Lens` with a `Prism`
     *
     * @since 1.0.0
     */ Lens.prototype.composePrism = function(ab) {
        return fromOptional($2pOLl.composePrism(ab)(this));
    };
    return Lens;
}();
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, reverseGet)) = s`
 * 2. `getOption(reverseGet(a)) = some(a)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Prism = /** @class */ function() {
    function Prism(getOption, reverseGet) {
        this.getOption = getOption;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Prism';
    }
    Prism.fromPredicate = function(predicate) {
        return fromPrism($bwWgx.fromPredicate(predicate));
    };
    /**
     * @since 1.0.0
     */ Prism.some = function() {
        return somePrism;
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modify = function(f) {
        var _this = this;
        return function(s) {
            var os = _this.modifyOption(f)(s);
            if ((0, $5OFXS.isNone)(os)) return s;
            else return os.value;
        };
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modifyOption = function(f) {
        var _this = this;
        return function(s) {
            return (0, $5OFXS.option).map(_this.getOption(s), function(v) {
                var n = f(v);
                return n === v ? s : _this.reverseGet(n);
            });
        };
    };
    /**
     * set the target of a `Prism` with a value
     *
     * @since 1.0.0
     */ Prism.prototype.set = function(a) {
        return this.modify(function() {
            return a;
        });
    };
    /**
     * view a `Prism` as a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.asOptional = function() {
        return fromOptional($bwWgx.asOptional(this));
    };
    /**
     * view a `Prism` as a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.asTraversal = function() {
        return fromTraversal($bwWgx.asTraversal(this));
    };
    /**
     * view a `Prism` as a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Prism` as a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $5OFXS.isNone)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * compose a `Prism` with a `Prism`
     *
     * @since 1.0.0
     */ Prism.prototype.compose = function(ab) {
        return fromPrism($bwWgx.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Prism.prototype.composePrism = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Prism` with a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.composeOptional = function(ab) {
        return fromOptional((0, $aOL40.pipe)(this, $bwWgx.asOptional, $7hEeH.compose(ab)));
    };
    /**
     * compose a `Prism` with a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $aOL40.pipe)(this, $bwWgx.asTraversal, $l4Tkk.compose(ab)));
    };
    /**
     * compose a `Prism` with a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Prism` with a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Prism` with a `Iso`
     *
     * @since 1.0.0
     */ Prism.prototype.composeIso = function(ab) {
        return fromPrism((0, $aOL40.pipe)(this, $bwWgx.compose((0, $aOL40.pipe)(ab, $cWuKG.asPrism))));
    };
    /**
     * compose a `Prism` with a `Lens`
     *
     * @since 1.0.0
     */ Prism.prototype.composeLens = function(ab) {
        return fromOptional($bwWgx.composeLens(ab)(this));
    };
    /**
     * compose a `Prism` with a `Getter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Prism;
}();
var somePrism = /*#__PURE__*/ new Prism((0, $lWM6H.identity), (0, $5OFXS.some));
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, a => set(a)(s))) = s`
 * 2. `getOption(set(a)(s)) = pipe(getOption(s), map(_ => a))`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Optional = /** @class */ function() {
    function Optional(getOption, set) {
        this.getOption = getOption;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Optional';
    }
    /**
     * Returns an `Optional` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface Phone {
     *   number: string
     * }
     * interface Employment {
     *   phone?: Phone
     * }
     * interface Info {
     *   employment?: Employment
     * }
     * interface Response {
     *   info?: Info
     * }
     *
     * const numberFromResponse = Optional.fromPath<Response>()(['info', 'employment', 'phone', 'number'])
     *
     * const response1: Response = {
     *   info: {
     *     employment: {
     *       phone: {
     *         number: '555-1234'
     *       }
     *     }
     *   }
     * }
     * const response2: Response = {
     *   info: {
     *     employment: {}
     *   }
     * }
     *
     * numberFromResponse.getOption(response1) // some('555-1234')
     * numberFromResponse.getOption(response2) // none
     *
     * @since 2.1.0
     */ Optional.fromPath = function() {
        var fromNullableProp = Optional.fromNullableProp();
        return function(path) {
            var optional = fromNullableProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromNullableProp(prop));
            }, optional);
        };
    };
    /**
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface S {
     *   a: number | undefined | null
     * }
     *
     * const optional = Optional.fromNullableProp<S>()('a')
     *
     * const s1: S = { a: undefined }
     * const s2: S = { a: null }
     * const s3: S = { a: 1 }
     *
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), s2)
     * assert.deepStrictEqual(optional.set(2)(s3), { a: 2 })
     *
     * @since 1.0.0
     */ Optional.fromNullableProp = function() {
        return function(k) {
            return new Optional(function(s) {
                return (0, $5OFXS.fromNullable)(s[k]);
            }, function(a) {
                return function(s) {
                    return s[k] == null ? s : update(s, k, a);
                };
            });
        };
    };
    /**
     * Returns an `Optional` from an option (`Option<A>`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     * import * as O from 'fp-ts/Option'
     *
     * interface S {
     *   a: O.Option<number>
     * }
     *
     * const optional = Optional.fromOptionProp<S>()('a')
     * const s1: S = { a: O.none }
     * const s2: S = { a: O.some(1) }
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), { a: O.some(2) })
     *
     * @since 1.0.0
     */ Optional.fromOptionProp = function() {
        var formProp = Lens.fromProp();
        return function(prop) {
            return formProp(prop).composePrism(somePrism);
        };
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modify = function(f) {
        return $7hEeH.modify(f)(this);
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modifyOption = function(f) {
        return $7hEeH.modifyOption(f)(this);
    };
    /**
     * view a `Optional` as a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.asTraversal = function() {
        return fromTraversal($7hEeH.asTraversal(this));
    };
    /**
     * view an `Optional` as a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $5OFXS.isNone)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * view an `Optional` as a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Optional` with a `Optional`
     *
     * @since 1.0.0
     */ Optional.prototype.compose = function(ab) {
        return fromOptional($7hEeH.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Optional.prototype.composeOptional = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Optional` with a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $aOL40.pipe)(this, $7hEeH.asTraversal, $l4Tkk.compose(ab)));
    };
    /**
     * compose an `Optional` with a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Optional` with a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose an `Optional` with a `Lens`
     *
     * @since 1.0.0
     */ Optional.prototype.composeLens = function(ab) {
        return fromOptional((0, $aOL40.pipe)(this, $7hEeH.compose((0, $aOL40.pipe)(ab, $2pOLl.asOptional))));
    };
    /**
     * compose an `Optional` with a `Prism`
     *
     * @since 1.0.0
     */ Optional.prototype.composePrism = function(ab) {
        return fromOptional((0, $aOL40.pipe)(this, $7hEeH.compose((0, $aOL40.pipe)(ab, $bwWgx.asOptional))));
    };
    /**
     * compose an `Optional` with a `Iso`
     *
     * @since 1.0.0
     */ Optional.prototype.composeIso = function(ab) {
        return fromOptional((0, $aOL40.pipe)(this, $7hEeH.compose((0, $aOL40.pipe)(ab, $cWuKG.asOptional))));
    };
    /**
     * compose an `Optional` with a `Getter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Optional;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Traversal = /** @class */ function() {
    function Traversal(// Van Laarhoven representation
    modifyF) {
        this.modifyF = modifyF;
        /**
         * @since 1.0.0
         */ this._tag = 'Traversal';
    }
    /**
     * @since 1.0.0
     */ Traversal.prototype.modify = function(f) {
        return $l4Tkk.modify(f)(this);
    };
    /**
     * @since 1.0.0
     */ Traversal.prototype.set = function(a) {
        return $l4Tkk.set(a)(this);
    };
    Traversal.prototype.filter = function(predicate) {
        return fromTraversal($l4Tkk.filter(predicate)(this));
    };
    /**
     * view a `Traversal` as a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.modifyF((0, $9nKyz.getApplicative)(M))(function(a) {
                    return (0, $9nKyz.make)(f(a));
                });
            };
        });
    };
    /**
     * view a `Traversal` as a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Traversal` with a `Traversal`
     *
     * @since 1.0.0
     */ Traversal.prototype.compose = function(ab) {
        return fromTraversal($l4Tkk.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeTraversal = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Traversal` with a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Optional`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeOptional = function(ab) {
        return this.compose(ab.asTraversal());
    };
    /**
     * compose a `Traversal` with a `Lens`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeLens = function(ab) {
        return fromTraversal((0, $aOL40.pipe)(this, $l4Tkk.compose((0, $aOL40.pipe)(ab, $2pOLl.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Prism`
     *
     * @since 1.0.0
     */ Traversal.prototype.composePrism = function(ab) {
        return fromTraversal((0, $aOL40.pipe)(this, $l4Tkk.compose((0, $aOL40.pipe)(ab, $bwWgx.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Iso`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeIso = function(ab) {
        return fromTraversal((0, $aOL40.pipe)(this, $l4Tkk.compose((0, $aOL40.pipe)(ab, $cWuKG.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Getter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Traversal;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var At = /** @class */ function() {
    function At(at) {
        this.at = at;
        /**
         * @since 1.0.0
         */ this._tag = 'At';
    }
    /**
     * lift an instance of `At` using an `Iso`
     *
     * @since 1.2.0
     */ At.prototype.fromIso = function(iso) {
        return fromAt($7x7NY.fromIso(iso)(this));
    };
    return At;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var Index = /** @class */ function() {
    function Index(index) {
        this.index = index;
        /**
         * @since 1.0.0
         */ this._tag = 'Index';
    }
    /**
     * @since 1.2.0
     */ Index.fromAt = function(at) {
        return fromIndex($4CMYJ.fromAt(at));
    };
    /**
     * lift an instance of `Index` using an `Iso`
     *
     * @since 1.2.0
     */ Index.prototype.fromIso = function(iso) {
        return fromIndex($4CMYJ.fromIso(iso)(this));
    };
    return Index;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Getter = /** @class */ function() {
    function Getter(get) {
        this.get = get;
        /**
         * @since 1.0.0
         */ this._tag = 'Getter';
    }
    /**
     * view a `Getter` as a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Getter` with a `Getter`
     *
     * @since 1.0.0
     */ Getter.prototype.compose = function(ab) {
        var _this = this;
        return new Getter(function(s) {
            return ab.get(_this.get(s));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Getter.prototype.composeGetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Getter` with a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Getter` with a `Lens`
     *
     * @since 1.0.0
     */ Getter.prototype.composeLens = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Iso`
     *
     * @since 1.0.0
     */ Getter.prototype.composeIso = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeTraversal = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeOptional = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Prism`
     *
     * @since 1.0.0
     */ Getter.prototype.composePrism = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Getter;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Fold = /** @class */ function() {
    function Fold(foldMap) {
        this.foldMap = foldMap;
        /**
         * @since 1.0.0
         */ this._tag = 'Fold';
        this.getAll = foldMap($kLIh4.getMonoid())($kLIh4.of);
        this.exist = foldMap((0, $jCSd8.monoidAny));
        this.all = foldMap((0, $jCSd8.monoidAll));
        this.foldMapFirst = foldMap((0, $5OFXS.getFirstMonoid)());
    }
    /**
     * compose a `Fold` with a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.compose = function(ab) {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.foldMap(M)(ab.foldMap(M)(f));
            };
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Fold.prototype.composeFold = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Fold` with a `Getter`
     *
     * @since 1.0.0
     */ Fold.prototype.composeGetter = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Traversal`
     *
     * @since 1.0.0
     */ Fold.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Optional`
     *
     * @since 1.0.0
     */ Fold.prototype.composeOptional = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Lens`
     *
     * @since 1.0.0
     */ Fold.prototype.composeLens = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Prism`
     *
     * @since 1.0.0
     */ Fold.prototype.composePrism = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Iso`
     *
     * @since 1.0.0
     */ Fold.prototype.composeIso = function(ab) {
        return this.compose(ab.asFold());
    };
    Fold.prototype.find = function(p) {
        return this.foldMapFirst((0, $5OFXS.fromPredicate)(p));
    };
    /**
     * get the first target of a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.headOption = function(s) {
        return this.find(function() {
            return true;
        })(s);
    };
    return Fold;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Setter = /** @class */ function() {
    function Setter(modify) {
        this.modify = modify;
        /**
         * @since 1.0.0
         */ this._tag = 'Setter';
    }
    /**
     * @since 1.0.0
     */ Setter.prototype.set = function(a) {
        return this.modify((0, $lWM6H.constant)(a));
    };
    /**
     * compose a `Setter` with a `Setter`
     *
     * @since 1.0.0
     */ Setter.prototype.compose = function(ab) {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(ab.modify(f));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Setter.prototype.composeSetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Setter` with a `Traversal`
     *
     * @since 1.0.0
     */ Setter.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Optional`
     *
     * @since 1.0.0
     */ Setter.prototype.composeOptional = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Lens`
     *
     * @since 1.0.0
     */ Setter.prototype.composeLens = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Prism`
     *
     * @since 1.0.0
     */ Setter.prototype.composePrism = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Iso`
     *
     * @since 1.0.0
     */ Setter.prototype.composeIso = function(ab) {
        return this.compose(ab.asSetter());
    };
    return Setter;
}();
function fromTraversable(T) {
    var f = $l4Tkk.fromTraversable(T);
    return function() {
        return fromTraversal(f());
    };
}
function fromFoldable(F) {
    return function() {
        return new Fold(function(M) {
            var foldMapFM = F.foldMap(M);
            return function(f) {
                return function(s) {
                    return foldMapFM(s, f);
                };
            };
        });
    };
}

});
parcelRegister("kLIh4", function(module, exports) {

$parcel$export(module.exports, "append", () => $f1ea8a601d239108$export$10d8903dec122b9d);
$parcel$export(module.exports, "lookup", () => $f1ea8a601d239108$export$dfc7155ac0343b8);
$parcel$export(module.exports, "copy", () => $f1ea8a601d239108$export$784d13d8ee351f07);
$parcel$export(module.exports, "updateAt", () => $f1ea8a601d239108$export$b6d8713d53419d4c);
$parcel$export(module.exports, "filterWithIndex", () => $f1ea8a601d239108$export$36e42aef19fc7171);
$parcel$export(module.exports, "of", () => $f1ea8a601d239108$export$ba255e9e49e00608);
$parcel$export(module.exports, "getMonoid", () => $f1ea8a601d239108$export$c2a7ef2cc9b32b31);

var $4AIBj = parcelRequire("4AIBj");

var $iXLA9 = parcelRequire("iXLA9");

var $coJMz = parcelRequire("coJMz");

var $lWM6H = parcelRequire("lWM6H");

var $gnzaQ = parcelRequire("gnzaQ");

var $9sd2T = parcelRequire("9sd2T");

var $fWUU5 = parcelRequire("fWUU5");

var $iLEkM = parcelRequire("iLEkM");

var $fYAej = parcelRequire("fYAej");

var $loyJ7 = parcelRequire("loyJ7");

var $l7120 = parcelRequire("l7120");
var $f1ea8a601d239108$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $f1ea8a601d239108$export$a978c53b4062a525 = $fWUU5.isNonEmpty;
var $f1ea8a601d239108$export$68159836694e22c1 = $fWUU5.prepend;
var $f1ea8a601d239108$export$c4c4d41eab625797 = $fWUU5.prependW;
var $f1ea8a601d239108$export$10d8903dec122b9d = $fWUU5.append;
var $f1ea8a601d239108$export$19903a1bf1942f6 = $fWUU5.appendW;
var $f1ea8a601d239108$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? [] : $fWUU5.makeBy(f)(n);
};
var $f1ea8a601d239108$export$606959e7ccb797f0 = function(n, a) {
    return $f1ea8a601d239108$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $f1ea8a601d239108$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : [];
    };
}
var $f1ea8a601d239108$export$172ec0a6ebfeb6fa = function(ma) {
    return $9sd2T.isNone(ma) ? [] : [
        ma.value
    ];
};
var $f1ea8a601d239108$export$80c878c9b1d77917 = function(e) {
    return $9sd2T.isLeft(e) ? [] : [
        e.right
    ];
};
var $f1ea8a601d239108$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $f1ea8a601d239108$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $f1ea8a601d239108$export$4659b591c19bdf3d = $f1ea8a601d239108$export$2d55ea551c238330;
var $f1ea8a601d239108$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $f1ea8a601d239108$export$a978c53b4062a525(as) ? onNonEmpty($fWUU5.head(as), $fWUU5.tail(as)) : onEmpty();
    };
};
var $f1ea8a601d239108$export$6280271dfaec4919 = $f1ea8a601d239108$export$ebbe93aa91e3abdc;
var $f1ea8a601d239108$export$f3163a37d0ef5927 = $f1ea8a601d239108$export$6280271dfaec4919;
var $f1ea8a601d239108$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $f1ea8a601d239108$export$a978c53b4062a525(as) ? onNonEmpty($fWUU5.init(as), $fWUU5.last(as)) : onEmpty();
    };
};
var $f1ea8a601d239108$export$b1cacb83a5c6bd02 = $f1ea8a601d239108$export$364f7f2cc8473008;
var $f1ea8a601d239108$export$77fa89c00b331c4c = $f1ea8a601d239108$export$b1cacb83a5c6bd02;
var $f1ea8a601d239108$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $f1ea8a601d239108$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $f1ea8a601d239108$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $f1ea8a601d239108$export$346677f925de839c = function(as) {
    return as.length;
};
var $f1ea8a601d239108$export$2fde0b1c54fc39b9 = $fWUU5.isOutOfBound;
var $f1ea8a601d239108$export$dfc7155ac0343b8 = $iLEkM.lookup;
var $f1ea8a601d239108$export$5fd5031fecdacec3 = $iLEkM.head;
var $f1ea8a601d239108$export$4c7897fafd92b108 = $iLEkM.last;
var $f1ea8a601d239108$export$c01875f616615628 = function(as) {
    return $f1ea8a601d239108$export$a978c53b4062a525(as) ? $9sd2T.some($fWUU5.tail(as)) : $9sd2T.none;
};
var $f1ea8a601d239108$export$2cd8252107eb640b = function(as) {
    return $f1ea8a601d239108$export$a978c53b4062a525(as) ? $9sd2T.some($fWUU5.init(as)) : $9sd2T.none;
};
var $f1ea8a601d239108$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $f1ea8a601d239108$export$2fde0b1c54fc39b9(n, as) ? $f1ea8a601d239108$export$784d13d8ee351f07(as) : as.slice(0, n);
    };
};
var $f1ea8a601d239108$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $f1ea8a601d239108$export$2fde0b1c54fc39b9(n, as) ? $f1ea8a601d239108$export$784d13d8ee351f07(as) : n === 0 ? [] : as.slice(-n);
    };
};
function $f1ea8a601d239108$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        return out;
    };
}
var $f1ea8a601d239108$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $f1ea8a601d239108$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $f1ea8a601d239108$export$b0d75975ac0be0e1($f1ea8a601d239108$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $f1ea8a601d239108$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $f1ea8a601d239108$export$dd1bc94b04021eeb(as) ? $f1ea8a601d239108$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(n, as.length);
    };
};
var $f1ea8a601d239108$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $f1ea8a601d239108$export$dd1bc94b04021eeb(as) ? $f1ea8a601d239108$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(0, as.length - n);
    };
};
function $f1ea8a601d239108$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        return as.slice($f1ea8a601d239108$var$spanLeftIndex(as, predicate));
    };
}
var $f1ea8a601d239108$export$de3a4d4a0d731119 = $iLEkM.findIndex;
function $f1ea8a601d239108$export$9a2f228bed5035c2(predicate) {
    return $iLEkM.findFirst(predicate);
}
var $f1ea8a601d239108$export$a86c11c94d794a95 = $iLEkM.findFirstMap;
function $f1ea8a601d239108$export$296de88ccac4bedb(predicate) {
    return $iLEkM.findLast(predicate);
}
var $f1ea8a601d239108$export$8b5e6d6ad82284fa = $iLEkM.findLastMap;
var $f1ea8a601d239108$export$8855a8be7bd3e9f8 = $iLEkM.findLastIndex;
var $f1ea8a601d239108$export$784d13d8ee351f07 = function(as) {
    return as.slice();
};
var $f1ea8a601d239108$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $9sd2T.none : $9sd2T.some($f1ea8a601d239108$export$f4863e1822a1860c(i, a, as));
    };
};
var $f1ea8a601d239108$export$b6d8713d53419d4c = function(i, a) {
    return $f1ea8a601d239108$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $f1ea8a601d239108$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $f1ea8a601d239108$export$2fde0b1c54fc39b9(i, as) ? $9sd2T.none : $9sd2T.some($f1ea8a601d239108$export$4937fde8dfc38dbd(i, as));
    };
};
var $f1ea8a601d239108$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $f1ea8a601d239108$export$2fde0b1c54fc39b9(i, as) ? $9sd2T.none : $9sd2T.some($f1ea8a601d239108$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $f1ea8a601d239108$export$66c1ae025e96b4bc = function(as) {
    return $f1ea8a601d239108$export$dd1bc94b04021eeb(as) ? [] : as.slice().reverse();
};
var $f1ea8a601d239108$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $f1ea8a601d239108$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $f1ea8a601d239108$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? $f1ea8a601d239108$export$784d13d8ee351f07(as) : as.slice().sort(O.compare);
    };
};
var $f1ea8a601d239108$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $f1ea8a601d239108$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $f1ea8a601d239108$export$8901015135f2fb22(bs, as);
    };
    return $f1ea8a601d239108$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $f1ea8a601d239108$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $f1ea8a601d239108$export$849c7567cbd62acc = function(middle) {
    var f = $fWUU5.prependAll(middle);
    return function(as) {
        return $f1ea8a601d239108$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $f1ea8a601d239108$export$af200dcf8b7cb5de = function(middle) {
    var f = $fWUU5.intersperse(middle);
    return function(as) {
        return $f1ea8a601d239108$export$a978c53b4062a525(as) ? f(as) : $f1ea8a601d239108$export$784d13d8ee351f07(as);
    };
};
var $f1ea8a601d239108$export$bb628a54ab399bc9 = function(n) {
    var f = $fWUU5.rotate(n);
    return function(as) {
        return $f1ea8a601d239108$export$a978c53b4062a525(as) ? f(as) : $f1ea8a601d239108$export$784d13d8ee351f07(as);
    };
};
var $f1ea8a601d239108$export$5bf96401662340b7 = $iLEkM.elem;
var $f1ea8a601d239108$export$f70730c3d1fc524e = function(E) {
    var f = $fWUU5.uniq(E);
    return function(as) {
        return $f1ea8a601d239108$export$a978c53b4062a525(as) ? f(as) : $f1ea8a601d239108$export$784d13d8ee351f07(as);
    };
};
var $f1ea8a601d239108$export$b035e44d7bb4278f = function(ords) {
    var f = $fWUU5.sortBy(ords);
    return function(as) {
        return $f1ea8a601d239108$export$a978c53b4062a525(as) ? f(as) : $f1ea8a601d239108$export$784d13d8ee351f07(as);
    };
};
var $f1ea8a601d239108$export$433fe05b12ba833f = function(f) {
    var g = $fWUU5.chop(f);
    return function(as) {
        return $f1ea8a601d239108$export$a978c53b4062a525(as) ? g(as) : [];
    };
};
var $f1ea8a601d239108$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $f1ea8a601d239108$export$a978c53b4062a525(as) ? $fWUU5.splitAt(n)(as) : $f1ea8a601d239108$export$dd1bc94b04021eeb(as) ? [
            $f1ea8a601d239108$export$784d13d8ee351f07(as),
            []
        ] : [
            [],
            $f1ea8a601d239108$export$784d13d8ee351f07(as)
        ];
    };
};
var $f1ea8a601d239108$export$2f0184d5df52135f = function(n) {
    var f = $fWUU5.chunksOf(n);
    return function(as) {
        return $f1ea8a601d239108$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $f1ea8a601d239108$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $f1ea8a601d239108$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $f1ea8a601d239108$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $f1ea8a601d239108$export$a978c53b4062a525(input) ? $f1ea8a601d239108$export$5b8affa63fc6df16($fWUU5.head(input), function(a) {
            return go((0, $lWM6H.pipe)(scope, $f1ea8a601d239108$export$10d8903dec122b9d(a)), $fWUU5.tail(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : [];
    };
    return go([], input);
}
var $f1ea8a601d239108$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $f1ea8a601d239108$export$dd1bc94b04021eeb(first) ? $f1ea8a601d239108$export$784d13d8ee351f07(second) : $f1ea8a601d239108$export$dd1bc94b04021eeb(second) ? $f1ea8a601d239108$export$784d13d8ee351f07(first) : first.concat(second);
    };
};
var $f1ea8a601d239108$export$ee1b3e54f0441b22 = $f1ea8a601d239108$export$c8c959650bbe80e2;
function $f1ea8a601d239108$export$971dd5b0dfd021b6(E) {
    var unionE = $fWUU5.union(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $f1ea8a601d239108$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $f1ea8a601d239108$export$a978c53b4062a525(first) && $f1ea8a601d239108$export$a978c53b4062a525(second) ? unionE(second)(first) : $f1ea8a601d239108$export$a978c53b4062a525(first) ? $f1ea8a601d239108$export$784d13d8ee351f07(first) : $f1ea8a601d239108$export$784d13d8ee351f07(second);
    };
}
function $f1ea8a601d239108$export$bc86dfbf7795668c(E) {
    var elemE = $f1ea8a601d239108$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $f1ea8a601d239108$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $f1ea8a601d239108$export$acaf96a27438246b(E) {
    var elemE = $f1ea8a601d239108$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $f1ea8a601d239108$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $f1ea8a601d239108$var$_map = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_mapWithIndex = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$8f07ddce13659f50(f));
};
var $f1ea8a601d239108$var$_ap = function(fab, fa) {
    return (0, $lWM6H.pipe)(fab, $f1ea8a601d239108$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_filter = function(fa, predicate) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_filterMap = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_partition = function(fa, predicate) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_partitionMap = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$3117e3f9ececb6bc(f));
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$dad5e500f2bab9bc(predicateWithIndex));
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$bc7c0794b9c6f3ba(f));
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_alt = function(fa, that) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$228be17d80722ab(that));
};
var $f1ea8a601d239108$var$_reduce = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_foldMap = function(M) {
    var foldMapM = $f1ea8a601d239108$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $lWM6H.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_reduceRight = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $f1ea8a601d239108$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $lWM6H.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_filterMapWithIndex = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$30c5cbe848021e97(f));
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$36e42aef19fc7171(predicateWithIndex));
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_extend = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_traverse = function(F) {
    var traverseF = $f1ea8a601d239108$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $lWM6H.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $f1ea8a601d239108$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $f1ea8a601d239108$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $lWM6H.pipe)(ta, traverseWithIndexF(f));
    };
};
var $f1ea8a601d239108$var$_chainRecDepthFirst = $iLEkM._chainRecDepthFirst;
var $f1ea8a601d239108$var$_chainRecBreadthFirst = $iLEkM._chainRecBreadthFirst;
var $f1ea8a601d239108$export$ba255e9e49e00608 = $fWUU5.of;
var $f1ea8a601d239108$export$7f9972325ebfd559 = function() {
    return [];
};
var $f1ea8a601d239108$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $f1ea8a601d239108$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $f1ea8a601d239108$export$5b8affa63fc6df16(function(f) {
        return (0, $lWM6H.pipe)(fa, $f1ea8a601d239108$export$871de8747c9eaa88(f));
    });
};
var $f1ea8a601d239108$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $lWM6H.dual)(2, function(ma, f) {
    return (0, $lWM6H.pipe)(ma, $f1ea8a601d239108$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $f1ea8a601d239108$export$bffa455ba8c619a6 = /*#__PURE__*/ $f1ea8a601d239108$export$5b8affa63fc6df16((0, $lWM6H.identity));
var $f1ea8a601d239108$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $f1ea8a601d239108$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($9sd2T.isSome(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $f1ea8a601d239108$export$a04c6c6965dd4709 = function(f) {
    return $f1ea8a601d239108$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $f1ea8a601d239108$export$8e16b83750b44988 = /*#__PURE__*/ $f1ea8a601d239108$export$a04c6c6965dd4709((0, $lWM6H.identity));
var $f1ea8a601d239108$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $fYAej.separated)(left, right);
};
var $f1ea8a601d239108$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $f1ea8a601d239108$export$b29f828819edca8d = function(predicate) {
    return $f1ea8a601d239108$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $f1ea8a601d239108$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var b = as[i];
            if (predicateWithIndex(i, b)) right.push(b);
            else left.push(b);
        }
        return (0, $fYAej.separated)(left, right);
    };
};
var $f1ea8a601d239108$export$3117e3f9ececb6bc = function(f) {
    return $f1ea8a601d239108$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $f1ea8a601d239108$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $fYAej.separated)(left, right);
    };
};
var $f1ea8a601d239108$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $f1ea8a601d239108$export$228be17d80722ab = $f1ea8a601d239108$export$1517cca7889d6aaa;
var $f1ea8a601d239108$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(b, i) {
            return predicateWithIndex(i, b);
        });
    };
};
var $f1ea8a601d239108$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $f1ea8a601d239108$export$ecd5e8ace626722c = /*#__PURE__*/ $f1ea8a601d239108$export$8b58be045bf06082((0, $lWM6H.identity));
var $f1ea8a601d239108$export$b66cdc0497d8a99a = $iLEkM.foldMap;
var $f1ea8a601d239108$export$18153bb1181268e5 = $iLEkM.foldMapWithIndex;
var $f1ea8a601d239108$export$533b26079ad0b4b = $iLEkM.reduce;
var $f1ea8a601d239108$export$bbd3ef8720e22369 = $iLEkM.reduceWithIndex;
var $f1ea8a601d239108$export$7fef8bcdbb34f435 = $iLEkM.reduceRight;
var $f1ea8a601d239108$export$ce2b2fe0b88ccd0a = $iLEkM.reduceRightWithIndex;
var $f1ea8a601d239108$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $f1ea8a601d239108$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $f1ea8a601d239108$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $f1ea8a601d239108$var$_reduce(ta, F.of($f1ea8a601d239108$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $lWM6H.pipe)(as, $f1ea8a601d239108$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $f1ea8a601d239108$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $f1ea8a601d239108$export$bbd3ef8720e22369(F.of($f1ea8a601d239108$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $lWM6H.pipe)(bs, $f1ea8a601d239108$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $f1ea8a601d239108$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $f1ea8a601d239108$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $f1ea8a601d239108$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $f1ea8a601d239108$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $f1ea8a601d239108$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($9sd2T.isSome(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $f1ea8a601d239108$export$9156e739aa33e19f = 'Array';
var $f1ea8a601d239108$export$3cb5cd7f7776c81 = $iLEkM.getShow;
var $f1ea8a601d239108$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return first.concat(second);
        }
    };
};
var $f1ea8a601d239108$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $f1ea8a601d239108$export$e759a9a7f8d04692().concat,
        empty: []
    };
};
var $f1ea8a601d239108$export$804fed467fde44e4 = $iLEkM.getEq;
var $f1ea8a601d239108$export$1af51209b1b91d07 = $iLEkM.getOrd;
var $f1ea8a601d239108$export$baca17b4aff42f82 = function(E) {
    var unionE = $f1ea8a601d239108$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $f1ea8a601d239108$export$c487aac9f4157837 = function(E) {
    return {
        concat: $f1ea8a601d239108$export$baca17b4aff42f82(E).concat,
        empty: []
    };
};
var $f1ea8a601d239108$export$d379a869a72e4055 = function(E) {
    var intersectionE = $f1ea8a601d239108$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $f1ea8a601d239108$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $f1ea8a601d239108$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $f1ea8a601d239108$export$bd5b6bfc5fa2ee61 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map
};
var $f1ea8a601d239108$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $gnzaQ.flap)($f1ea8a601d239108$export$bd5b6bfc5fa2ee61);
var $f1ea8a601d239108$export$59a71046037e6c20 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    of: $f1ea8a601d239108$export$ba255e9e49e00608
};
var $f1ea8a601d239108$export$9fdffe0fe1e91cad = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map,
    mapWithIndex: $f1ea8a601d239108$var$_mapWithIndex
};
var $f1ea8a601d239108$export$efc21ddc6aeb363d = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map,
    ap: $f1ea8a601d239108$var$_ap
};
var $f1ea8a601d239108$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $4AIBj.apFirst)($f1ea8a601d239108$export$efc21ddc6aeb363d);
var $f1ea8a601d239108$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $4AIBj.apSecond)($f1ea8a601d239108$export$efc21ddc6aeb363d);
var $f1ea8a601d239108$export$1279d2b7807629fd = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map,
    ap: $f1ea8a601d239108$var$_ap,
    of: $f1ea8a601d239108$export$ba255e9e49e00608
};
var $f1ea8a601d239108$export$f18d5acc27d70423 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map,
    ap: $f1ea8a601d239108$var$_ap,
    chain: $f1ea8a601d239108$export$5b8affa63fc6df16
};
var $f1ea8a601d239108$export$e3821ef4970c339c = /*#__PURE__*/ (0, $iXLA9.chainFirst)($f1ea8a601d239108$export$f18d5acc27d70423);
var $f1ea8a601d239108$export$fb641926d034ac7d = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map,
    ap: $f1ea8a601d239108$var$_ap,
    of: $f1ea8a601d239108$export$ba255e9e49e00608,
    chain: $f1ea8a601d239108$export$5b8affa63fc6df16
};
var $f1ea8a601d239108$export$8fa953f00d3b093 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    unfold: $f1ea8a601d239108$export$c48e357c1a89b78d
};
var $f1ea8a601d239108$export$25ba4469a069167 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map,
    alt: $f1ea8a601d239108$var$_alt
};
var $f1ea8a601d239108$export$aaef8a3eae948f03 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    zero: $f1ea8a601d239108$export$7f9972325ebfd559
};
var $f1ea8a601d239108$export$864d727b48066337 = /*#__PURE__*/ (0, $l7120.guard)($f1ea8a601d239108$export$aaef8a3eae948f03, $f1ea8a601d239108$export$59a71046037e6c20);
var $f1ea8a601d239108$export$4acb47accde578d2 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map,
    ap: $f1ea8a601d239108$var$_ap,
    of: $f1ea8a601d239108$export$ba255e9e49e00608,
    alt: $f1ea8a601d239108$var$_alt,
    zero: $f1ea8a601d239108$export$7f9972325ebfd559
};
var $f1ea8a601d239108$export$5b5dd0e212d2a5bc = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map,
    extend: $f1ea8a601d239108$var$_extend
};
var $f1ea8a601d239108$export$4a21ac48141ac3c9 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    compact: $f1ea8a601d239108$export$8e16b83750b44988,
    separate: $f1ea8a601d239108$export$709f6946f4e97408
};
var $f1ea8a601d239108$export$d00e1c48fb621173 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map,
    compact: $f1ea8a601d239108$export$8e16b83750b44988,
    separate: $f1ea8a601d239108$export$709f6946f4e97408,
    filter: $f1ea8a601d239108$var$_filter,
    filterMap: $f1ea8a601d239108$var$_filterMap,
    partition: $f1ea8a601d239108$var$_partition,
    partitionMap: $f1ea8a601d239108$var$_partitionMap
};
var $f1ea8a601d239108$export$c29a647071e542ec = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map,
    mapWithIndex: $f1ea8a601d239108$var$_mapWithIndex,
    compact: $f1ea8a601d239108$export$8e16b83750b44988,
    separate: $f1ea8a601d239108$export$709f6946f4e97408,
    filter: $f1ea8a601d239108$var$_filter,
    filterMap: $f1ea8a601d239108$var$_filterMap,
    partition: $f1ea8a601d239108$var$_partition,
    partitionMap: $f1ea8a601d239108$var$_partitionMap,
    partitionMapWithIndex: $f1ea8a601d239108$var$_partitionMapWithIndex,
    partitionWithIndex: $f1ea8a601d239108$var$_partitionWithIndex,
    filterMapWithIndex: $f1ea8a601d239108$var$_filterMapWithIndex,
    filterWithIndex: $f1ea8a601d239108$var$_filterWithIndex
};
var $f1ea8a601d239108$export$41404b31838667c9 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    reduce: $f1ea8a601d239108$var$_reduce,
    foldMap: $f1ea8a601d239108$var$_foldMap,
    reduceRight: $f1ea8a601d239108$var$_reduceRight
};
var $f1ea8a601d239108$export$e8f7d17aaff345cb = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    reduce: $f1ea8a601d239108$var$_reduce,
    foldMap: $f1ea8a601d239108$var$_foldMap,
    reduceRight: $f1ea8a601d239108$var$_reduceRight,
    reduceWithIndex: $f1ea8a601d239108$var$_reduceWithIndex,
    foldMapWithIndex: $f1ea8a601d239108$var$_foldMapWithIndex,
    reduceRightWithIndex: $f1ea8a601d239108$var$_reduceRightWithIndex
};
var $f1ea8a601d239108$export$a0202666c3bda011 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map,
    reduce: $f1ea8a601d239108$var$_reduce,
    foldMap: $f1ea8a601d239108$var$_foldMap,
    reduceRight: $f1ea8a601d239108$var$_reduceRight,
    traverse: $f1ea8a601d239108$var$_traverse,
    sequence: $f1ea8a601d239108$export$49bb65c2ea163039
};
var $f1ea8a601d239108$export$bd7b528d8c36ec41 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map,
    mapWithIndex: $f1ea8a601d239108$var$_mapWithIndex,
    reduce: $f1ea8a601d239108$var$_reduce,
    foldMap: $f1ea8a601d239108$var$_foldMap,
    reduceRight: $f1ea8a601d239108$var$_reduceRight,
    reduceWithIndex: $f1ea8a601d239108$var$_reduceWithIndex,
    foldMapWithIndex: $f1ea8a601d239108$var$_foldMapWithIndex,
    reduceRightWithIndex: $f1ea8a601d239108$var$_reduceRightWithIndex,
    traverse: $f1ea8a601d239108$var$_traverse,
    sequence: $f1ea8a601d239108$export$49bb65c2ea163039,
    traverseWithIndex: $f1ea8a601d239108$var$_traverseWithIndex
};
var $f1ea8a601d239108$var$_wither = /*#__PURE__*/ (0, $loyJ7.witherDefault)($f1ea8a601d239108$export$a0202666c3bda011, $f1ea8a601d239108$export$4a21ac48141ac3c9);
var $f1ea8a601d239108$var$_wilt = /*#__PURE__*/ (0, $loyJ7.wiltDefault)($f1ea8a601d239108$export$a0202666c3bda011, $f1ea8a601d239108$export$4a21ac48141ac3c9);
var $f1ea8a601d239108$export$748d317b4c426f96 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map,
    compact: $f1ea8a601d239108$export$8e16b83750b44988,
    separate: $f1ea8a601d239108$export$709f6946f4e97408,
    filter: $f1ea8a601d239108$var$_filter,
    filterMap: $f1ea8a601d239108$var$_filterMap,
    partition: $f1ea8a601d239108$var$_partition,
    partitionMap: $f1ea8a601d239108$var$_partitionMap,
    reduce: $f1ea8a601d239108$var$_reduce,
    foldMap: $f1ea8a601d239108$var$_foldMap,
    reduceRight: $f1ea8a601d239108$var$_reduceRight,
    traverse: $f1ea8a601d239108$var$_traverse,
    sequence: $f1ea8a601d239108$export$49bb65c2ea163039,
    wither: $f1ea8a601d239108$var$_wither,
    wilt: $f1ea8a601d239108$var$_wilt
};
var $f1ea8a601d239108$export$f855115a79f70c1a = $iLEkM.chainRecDepthFirst;
var $f1ea8a601d239108$export$7d808dfaa6d54634 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map,
    ap: $f1ea8a601d239108$var$_ap,
    chain: $f1ea8a601d239108$export$5b8affa63fc6df16,
    chainRec: $f1ea8a601d239108$var$_chainRecDepthFirst
};
var $f1ea8a601d239108$export$bffee57bb00a6859 = $iLEkM.chainRecBreadthFirst;
var $f1ea8a601d239108$export$57f3a385c7e59628 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    map: $f1ea8a601d239108$var$_map,
    ap: $f1ea8a601d239108$var$_ap,
    chain: $f1ea8a601d239108$export$5b8affa63fc6df16,
    chainRec: $f1ea8a601d239108$var$_chainRecBreadthFirst
};
var $f1ea8a601d239108$export$c40604f35db61519 = /*#__PURE__*/ (0, $loyJ7.filterE)($f1ea8a601d239108$export$748d317b4c426f96);
var $f1ea8a601d239108$export$825ea6cb6fc48d49 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    fromEither: $f1ea8a601d239108$export$80c878c9b1d77917
};
var $f1ea8a601d239108$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $coJMz.fromEitherK)($f1ea8a601d239108$export$825ea6cb6fc48d49);
var $f1ea8a601d239108$export$f4863e1822a1860c = $fWUU5.unsafeInsertAt;
var $f1ea8a601d239108$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $f1ea8a601d239108$export$a978c53b4062a525(as) ? $fWUU5.unsafeUpdateAt(i, a, as) : [];
};
var $f1ea8a601d239108$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $f1ea8a601d239108$export$7ecc1a3b11b57dab = $iLEkM.every;
var $f1ea8a601d239108$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $f1ea8a601d239108$export$f7e9f41ea797a17 = $f1ea8a601d239108$export$ad14ef4001db2bcd;
var $f1ea8a601d239108$export$739ec22334c44788 = $iLEkM.intercalate;
var $f1ea8a601d239108$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $f1ea8a601d239108$export$ba255e9e49e00608($9sd2T.emptyRecord);
var $f1ea8a601d239108$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $gnzaQ.bindTo)($f1ea8a601d239108$export$bd5b6bfc5fa2ee61);
var $f1ea8a601d239108$export$5d537b797c421217 = /*#__PURE__*/ (0, $gnzaQ.let)($f1ea8a601d239108$export$bd5b6bfc5fa2ee61);
var $f1ea8a601d239108$export$2385a24977818dd0 = /*#__PURE__*/ (0, $iXLA9.bind)($f1ea8a601d239108$export$f18d5acc27d70423);
var $f1ea8a601d239108$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $4AIBj.apS)($f1ea8a601d239108$export$efc21ddc6aeb363d);
var $f1ea8a601d239108$export$e08e3b67e392101e = $f1ea8a601d239108$export$5b8affa63fc6df16;
var $f1ea8a601d239108$export$d02631cccf789723 = $fWUU5.range;
var $f1ea8a601d239108$export$6e22c362a0406a2c = [];
var $f1ea8a601d239108$export$8327ebbef2a0ba76 = $fWUU5.cons;
var $f1ea8a601d239108$export$c40cf5aab899f397 = $fWUU5.snoc;
var $f1ea8a601d239108$export$baeb00bf1e27e233 = $f1ea8a601d239108$export$849c7567cbd62acc;
var $f1ea8a601d239108$export$2f23118c22fb2630 = {
    URI: $f1ea8a601d239108$export$9156e739aa33e19f,
    compact: $f1ea8a601d239108$export$8e16b83750b44988,
    separate: $f1ea8a601d239108$export$709f6946f4e97408,
    map: $f1ea8a601d239108$var$_map,
    ap: $f1ea8a601d239108$var$_ap,
    of: $f1ea8a601d239108$export$ba255e9e49e00608,
    chain: $f1ea8a601d239108$export$5b8affa63fc6df16,
    filter: $f1ea8a601d239108$var$_filter,
    filterMap: $f1ea8a601d239108$var$_filterMap,
    partition: $f1ea8a601d239108$var$_partition,
    partitionMap: $f1ea8a601d239108$var$_partitionMap,
    mapWithIndex: $f1ea8a601d239108$var$_mapWithIndex,
    partitionMapWithIndex: $f1ea8a601d239108$var$_partitionMapWithIndex,
    partitionWithIndex: $f1ea8a601d239108$var$_partitionWithIndex,
    filterMapWithIndex: $f1ea8a601d239108$var$_filterMapWithIndex,
    filterWithIndex: $f1ea8a601d239108$var$_filterWithIndex,
    alt: $f1ea8a601d239108$var$_alt,
    zero: $f1ea8a601d239108$export$7f9972325ebfd559,
    unfold: $f1ea8a601d239108$export$c48e357c1a89b78d,
    reduce: $f1ea8a601d239108$var$_reduce,
    foldMap: $f1ea8a601d239108$var$_foldMap,
    reduceRight: $f1ea8a601d239108$var$_reduceRight,
    traverse: $f1ea8a601d239108$var$_traverse,
    sequence: $f1ea8a601d239108$export$49bb65c2ea163039,
    reduceWithIndex: $f1ea8a601d239108$var$_reduceWithIndex,
    foldMapWithIndex: $f1ea8a601d239108$var$_foldMapWithIndex,
    reduceRightWithIndex: $f1ea8a601d239108$var$_reduceRightWithIndex,
    traverseWithIndex: $f1ea8a601d239108$var$_traverseWithIndex,
    extend: $f1ea8a601d239108$var$_extend,
    wither: $f1ea8a601d239108$var$_wither,
    wilt: $f1ea8a601d239108$var$_wilt
};

});
parcelRegister("4AIBj", function(module, exports) {

$parcel$export(module.exports, "ap", () => $357d1efdbd9828ba$export$2f6ca3d3b1f80bf5);
$parcel$export(module.exports, "apFirst", () => $357d1efdbd9828ba$export$5f28d9feedcfd46e);
$parcel$export(module.exports, "apSecond", () => $357d1efdbd9828ba$export$ed01bc59c3d06bf3);
$parcel$export(module.exports, "apS", () => $357d1efdbd9828ba$export$8cbfc0239f42bb49);
$parcel$export(module.exports, "getApplySemigroup", () => $357d1efdbd9828ba$export$18979a515d2a828e);
/**
 * The `Apply` class provides the `ap` which is used to apply a function to an argument under a type constructor.
 *
 * `Apply` can be used to lift functions of two or more arguments to work on values wrapped with the type constructor
 * `f`.
 *
 * Instances must satisfy the following law in addition to the `Functor` laws:
 *
 * 1. Associative composition: `F.ap(F.ap(F.map(fbc, bc => ab => a => bc(ab(a))), fab), fa) <-> F.ap(fbc, F.ap(fab, fa))`
 *
 * Formally, `Apply` represents a strong lax semi-monoidal endofunctor.
 *
 * @example
 * import * as O from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (a: string) => (b: number) => (c: boolean) => a + String(b) + String(c)
 * const fa: O.Option<string> = O.some('s')
 * const fb: O.Option<number> = O.some(1)
 * const fc: O.Option<boolean> = O.some(true)
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     // lift a function
 *     O.some(f),
 *     // apply the first argument
 *     O.ap(fa),
 *     // apply the second argument
 *     O.ap(fb),
 *     // apply the third argument
 *     O.ap(fc)
 *   ),
 *   O.some('s1true')
 * )
 *
 * @since 2.0.0
 */ 
var $lWM6H = parcelRequire("lWM6H");

var $9sd2T = parcelRequire("9sd2T");
function $357d1efdbd9828ba$export$2f6ca3d3b1f80bf5(F, G) {
    return function(fa) {
        return function(fab) {
            return F.ap(F.map(fab, function(gab) {
                return function(ga) {
                    return G.ap(gab, ga);
                };
            }), fa);
        };
    };
}
function $357d1efdbd9828ba$export$5f28d9feedcfd46e(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function(a) {
                return function() {
                    return a;
                };
            }), second);
        };
    };
}
function $357d1efdbd9828ba$export$ed01bc59c3d06bf3(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function() {
                return function(b) {
                    return b;
                };
            }), second);
        };
    };
}
function $357d1efdbd9828ba$export$8cbfc0239f42bb49(F) {
    return function(name, fb) {
        return function(fa) {
            return F.ap(F.map(fa, function(a) {
                return function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                };
            }), fb);
        };
    };
}
function $357d1efdbd9828ba$export$18979a515d2a828e(F) {
    return function(S) {
        return {
            concat: function(first, second) {
                return F.ap(F.map(first, function(x) {
                    return function(y) {
                        return S.concat(x, y);
                    };
                }), second);
            }
        };
    };
}
function $357d1efdbd9828ba$var$curried(f, n, acc) {
    return function(x) {
        var combined = Array(acc.length + 1);
        for(var i = 0; i < acc.length; i++)combined[i] = acc[i];
        combined[acc.length] = x;
        return n === 0 ? f.apply(null, combined) : $357d1efdbd9828ba$var$curried(f, n - 1, combined);
    };
}
var $357d1efdbd9828ba$var$tupleConstructors = {
    1: function(a) {
        return [
            a
        ];
    },
    2: function(a) {
        return function(b) {
            return [
                a,
                b
            ];
        };
    },
    3: function(a) {
        return function(b) {
            return function(c) {
                return [
                    a,
                    b,
                    c
                ];
            };
        };
    },
    4: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return [
                        a,
                        b,
                        c,
                        d
                    ];
                };
            };
        };
    },
    5: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return [
                            a,
                            b,
                            c,
                            d,
                            e
                        ];
                    };
                };
            };
        };
    }
};
function $357d1efdbd9828ba$var$getTupleConstructor(len) {
    if (!$9sd2T.has.call($357d1efdbd9828ba$var$tupleConstructors, len)) $357d1efdbd9828ba$var$tupleConstructors[len] = $357d1efdbd9828ba$var$curried((0, $lWM6H.tuple), len - 1, []);
    return $357d1efdbd9828ba$var$tupleConstructors[len];
}
function $357d1efdbd9828ba$export$6ec24752b7e97e26(F) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var len = args.length;
        var f = $357d1efdbd9828ba$var$getTupleConstructor(len);
        var fas = F.map(args[0], f);
        for(var i = 1; i < len; i++)fas = F.ap(fas, args[i]);
        return fas;
    };
}
function $357d1efdbd9828ba$var$getRecordConstructor(keys) {
    var len = keys.length;
    switch(len){
        case 1:
            return function(a) {
                var _a;
                return _a = {}, _a[keys[0]] = a, _a;
            };
        case 2:
            return function(a) {
                return function(b) {
                    var _a;
                    return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a;
                };
            };
        case 3:
            return function(a) {
                return function(b) {
                    return function(c) {
                        var _a;
                        return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a;
                    };
                };
            };
        case 4:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            var _a;
                            return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a;
                        };
                    };
                };
            };
        case 5:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            return function(e) {
                                var _a;
                                return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a[keys[4]] = e, _a;
                            };
                        };
                    };
                };
            };
        default:
            return $357d1efdbd9828ba$var$curried(function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var r = {};
                for(var i = 0; i < len; i++)r[keys[i]] = args[i];
                return r;
            }, len - 1, []);
    }
}
function $357d1efdbd9828ba$export$d04bd2c3b28691e(F) {
    return function(r) {
        var keys = Object.keys(r);
        var len = keys.length;
        var f = $357d1efdbd9828ba$var$getRecordConstructor(keys);
        var fr = F.map(r[keys[0]], f);
        for(var i = 1; i < len; i++)fr = F.ap(fr, r[keys[i]]);
        return fr;
    };
}

});
parcelRegister("lWM6H", function(module, exports) {

$parcel$export(module.exports, "getSemigroup", () => $ffa454c9eb9d7d9f$export$e759a9a7f8d04692);
$parcel$export(module.exports, "getMonoid", () => $ffa454c9eb9d7d9f$export$c2a7ef2cc9b32b31);
$parcel$export(module.exports, "identity", () => $ffa454c9eb9d7d9f$export$f0954fd7d5368655);
$parcel$export(module.exports, "unsafeCoerce", () => $ffa454c9eb9d7d9f$export$401372c57776dc);
$parcel$export(module.exports, "constant", () => $ffa454c9eb9d7d9f$export$c983f826f44ff86);
$parcel$export(module.exports, "constTrue", () => $ffa454c9eb9d7d9f$export$a68382d9631f6c53);
$parcel$export(module.exports, "constFalse", () => $ffa454c9eb9d7d9f$export$7349232f2648ca80);
$parcel$export(module.exports, "constNull", () => $ffa454c9eb9d7d9f$export$243c2ee5e7d8b05c);
$parcel$export(module.exports, "constUndefined", () => $ffa454c9eb9d7d9f$export$3d16a43570087548);
$parcel$export(module.exports, "flow", () => $ffa454c9eb9d7d9f$export$ccc7b0636abaffc3);
$parcel$export(module.exports, "tuple", () => $ffa454c9eb9d7d9f$export$65e3907585753458);
$parcel$export(module.exports, "pipe", () => $ffa454c9eb9d7d9f$export$a4627e546088548d);
$parcel$export(module.exports, "SK", () => $ffa454c9eb9d7d9f$export$5f584391ee0d99b4);
$parcel$export(module.exports, "dual", () => $ffa454c9eb9d7d9f$export$d1699a1bbdf17835);
var $ffa454c9eb9d7d9f$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $ffa454c9eb9d7d9f$export$f37f1abb2c955577 = function(B) {
    return function() {
        return {
            meet: function(x, y) {
                return function(a) {
                    return B.meet(x(a), y(a));
                };
            },
            join: function(x, y) {
                return function(a) {
                    return B.join(x(a), y(a));
                };
            },
            zero: function() {
                return B.zero;
            },
            one: function() {
                return B.one;
            },
            implies: function(x, y) {
                return function(a) {
                    return B.implies(x(a), y(a));
                };
            },
            not: function(x) {
                return function(a) {
                    return B.not(x(a));
                };
            }
        };
    };
};
var $ffa454c9eb9d7d9f$export$e759a9a7f8d04692 = function(S) {
    return function() {
        return {
            concat: function(f, g) {
                return function(a) {
                    return S.concat(f(a), g(a));
                };
            }
        };
    };
};
var $ffa454c9eb9d7d9f$export$c2a7ef2cc9b32b31 = function(M) {
    var getSemigroupM = $ffa454c9eb9d7d9f$export$e759a9a7f8d04692(M);
    return function() {
        return {
            concat: getSemigroupM().concat,
            empty: function() {
                return M.empty;
            }
        };
    };
};
var $ffa454c9eb9d7d9f$export$3d48c7fefc7b8ec2 = function(S) {
    return {
        add: function(f, g) {
            return function(x) {
                return S.add(f(x), g(x));
            };
        },
        zero: function() {
            return S.zero;
        },
        mul: function(f, g) {
            return function(x) {
                return S.mul(f(x), g(x));
            };
        },
        one: function() {
            return S.one;
        }
    };
};
var $ffa454c9eb9d7d9f$export$575097c1c561f76f = function(R) {
    var S = $ffa454c9eb9d7d9f$export$3d48c7fefc7b8ec2(R);
    return {
        add: S.add,
        mul: S.mul,
        one: S.one,
        zero: S.zero,
        sub: function(f, g) {
            return function(x) {
                return R.sub(f(x), g(x));
            };
        }
    };
};
var $ffa454c9eb9d7d9f$export$5635d7ef4b8fee1c = function(a) {
    return function(f) {
        return f(a);
    };
};
function $ffa454c9eb9d7d9f$export$f0954fd7d5368655(a) {
    return a;
}
var $ffa454c9eb9d7d9f$export$401372c57776dc = $ffa454c9eb9d7d9f$export$f0954fd7d5368655;
function $ffa454c9eb9d7d9f$export$c983f826f44ff86(a) {
    return function() {
        return a;
    };
}
var $ffa454c9eb9d7d9f$export$a68382d9631f6c53 = /*#__PURE__*/ $ffa454c9eb9d7d9f$export$c983f826f44ff86(true);
var $ffa454c9eb9d7d9f$export$7349232f2648ca80 = /*#__PURE__*/ $ffa454c9eb9d7d9f$export$c983f826f44ff86(false);
var $ffa454c9eb9d7d9f$export$243c2ee5e7d8b05c = /*#__PURE__*/ $ffa454c9eb9d7d9f$export$c983f826f44ff86(null);
var $ffa454c9eb9d7d9f$export$3d16a43570087548 = /*#__PURE__*/ $ffa454c9eb9d7d9f$export$c983f826f44ff86(undefined);
var $ffa454c9eb9d7d9f$export$fe2a8306a887c223 = $ffa454c9eb9d7d9f$export$3d16a43570087548;
function $ffa454c9eb9d7d9f$export$8a83211c878a3f1f(f) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (args.length > 1) return f(args[1], args[0]);
        return function(a) {
            return f(a)(args[0]);
        };
    };
}
function $ffa454c9eb9d7d9f$export$ccc7b0636abaffc3(ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch(arguments.length){
        case 1:
            return ab;
        case 2:
            return function() {
                return bc(ab.apply(this, arguments));
            };
        case 3:
            return function() {
                return cd(bc(ab.apply(this, arguments)));
            };
        case 4:
            return function() {
                return de(cd(bc(ab.apply(this, arguments))));
            };
        case 5:
            return function() {
                return ef(de(cd(bc(ab.apply(this, arguments)))));
            };
        case 6:
            return function() {
                return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
            };
        case 7:
            return function() {
                return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
            };
        case 8:
            return function() {
                return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
            };
        case 9:
            return function() {
                return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
            };
    }
    return;
}
function $ffa454c9eb9d7d9f$export$65e3907585753458() {
    var t = [];
    for(var _i = 0; _i < arguments.length; _i++)t[_i] = arguments[_i];
    return t;
}
function $ffa454c9eb9d7d9f$export$a2647aa13413c947(n) {
    return n + 1;
}
function $ffa454c9eb9d7d9f$export$8f85cc9753f280aa(n) {
    return n - 1;
}
function $ffa454c9eb9d7d9f$export$f172309911142386(_) {
    throw new Error('Called `absurd` function which should be uncallable');
}
function $ffa454c9eb9d7d9f$export$91744c046de1af50(f) {
    return function(a) {
        return f.apply(void 0, a);
    };
}
function $ffa454c9eb9d7d9f$export$db52c4d43c315cb5(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return f(a);
    };
}
function $ffa454c9eb9d7d9f$export$a4627e546088548d(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch(arguments.length){
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        default:
            var ret = arguments[0];
            for(var i = 1; i < arguments.length; i++)ret = arguments[i](ret);
            return ret;
    }
}
var $ffa454c9eb9d7d9f$export$5cc5fd8bb7edf254 = $ffa454c9eb9d7d9f$export$f172309911142386;
var $ffa454c9eb9d7d9f$export$5f584391ee0d99b4 = function(_, b) {
    return b;
};
function $ffa454c9eb9d7d9f$export$6003a5f097c73977(predicate) {
    return function(a) {
        return !predicate(a);
    };
}
var $ffa454c9eb9d7d9f$export$5c6d2e402d334f37 = function() {
    return {
        concat: function(first, second) {
            return $ffa454c9eb9d7d9f$export$ccc7b0636abaffc3(first, second);
        },
        empty: $ffa454c9eb9d7d9f$export$f0954fd7d5368655
    };
};
var $ffa454c9eb9d7d9f$export$d1699a1bbdf17835 = function(arity, body) {
    var isDataFirst = typeof arity === 'number' ? function(args) {
        return args.length >= arity;
    } : arity;
    return function() {
        var args = Array.from(arguments);
        if (isDataFirst(arguments)) return body.apply(this, args);
        return function(self) {
            return body.apply(void 0, $ffa454c9eb9d7d9f$var$__spreadArray([
                self
            ], args, false));
        };
    };
};

});

parcelRegister("9sd2T", function(module, exports) {

$parcel$export(module.exports, "isNone", () => $6e20d93164e6da1b$export$e56af863d5645d5f);
$parcel$export(module.exports, "isSome", () => $6e20d93164e6da1b$export$5d7e502287836e58);
$parcel$export(module.exports, "none", () => $6e20d93164e6da1b$export$f883a24d5edde77c);
$parcel$export(module.exports, "some", () => $6e20d93164e6da1b$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "isLeft", () => $6e20d93164e6da1b$export$d649b6842e09f2b);
$parcel$export(module.exports, "isRight", () => $6e20d93164e6da1b$export$a9d71693f0c1a85d);
$parcel$export(module.exports, "left", () => $6e20d93164e6da1b$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "right", () => $6e20d93164e6da1b$export$79ffe56a765070d2);
$parcel$export(module.exports, "singleton", () => $6e20d93164e6da1b$export$439306a4dcaafbb9);
$parcel$export(module.exports, "isNonEmpty", () => $6e20d93164e6da1b$export$a978c53b4062a525);
$parcel$export(module.exports, "head", () => $6e20d93164e6da1b$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tail", () => $6e20d93164e6da1b$export$c01875f616615628);
$parcel$export(module.exports, "emptyReadonlyArray", () => $6e20d93164e6da1b$export$6ca726a2417e0f3f);
$parcel$export(module.exports, "emptyRecord", () => $6e20d93164e6da1b$export$4de80339753b012b);
$parcel$export(module.exports, "has", () => $6e20d93164e6da1b$export$a4f4bb6b1453fff5);
$parcel$export(module.exports, "fromReadonlyNonEmptyArray", () => $6e20d93164e6da1b$export$7e77326b0f0e268c);
$parcel$export(module.exports, "liftNullable", () => $6e20d93164e6da1b$export$cd139e14432f317b);
$parcel$export(module.exports, "liftOption", () => $6e20d93164e6da1b$export$ea4a22f93200df79);
$parcel$export(module.exports, "flatMapNullable", () => $6e20d93164e6da1b$export$1a0515933c5c84fe);
$parcel$export(module.exports, "flatMapOption", () => $6e20d93164e6da1b$export$b5f02b7beb8ed7d8);

var $lWM6H = parcelRequire("lWM6H");
var $6e20d93164e6da1b$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $6e20d93164e6da1b$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $6e20d93164e6da1b$export$5d7e502287836e58 = function(fa) {
    return fa._tag === 'Some';
};
var $6e20d93164e6da1b$export$f883a24d5edde77c = {
    _tag: 'None'
};
var $6e20d93164e6da1b$export$ad14ef4001db2bcd = function(a) {
    return {
        _tag: 'Some',
        value: a
    };
};
var $6e20d93164e6da1b$export$d649b6842e09f2b = function(ma) {
    return ma._tag === 'Left';
};
var $6e20d93164e6da1b$export$a9d71693f0c1a85d = function(ma) {
    return ma._tag === 'Right';
};
var $6e20d93164e6da1b$export$eabcd2c8791e7bf4 = function(e) {
    return {
        _tag: 'Left',
        left: e
    };
};
var $6e20d93164e6da1b$export$79ffe56a765070d2 = function(a) {
    return {
        _tag: 'Right',
        right: a
    };
};
var $6e20d93164e6da1b$export$439306a4dcaafbb9 = function(a) {
    return [
        a
    ];
};
var $6e20d93164e6da1b$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $6e20d93164e6da1b$export$5fd5031fecdacec3 = function(as) {
    return as[0];
};
var $6e20d93164e6da1b$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $6e20d93164e6da1b$export$6ca726a2417e0f3f = [];
var $6e20d93164e6da1b$export$4de80339753b012b = {};
var $6e20d93164e6da1b$export$a4f4bb6b1453fff5 = Object.prototype.hasOwnProperty;
var $6e20d93164e6da1b$export$7e77326b0f0e268c = function(as) {
    return $6e20d93164e6da1b$var$__spreadArray([
        as[0]
    ], as.slice(1), true);
};
var $6e20d93164e6da1b$export$cd139e14432f317b = function(F) {
    return function(f, onNullable) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither(o == null ? $6e20d93164e6da1b$export$eabcd2c8791e7bf4(onNullable.apply(void 0, a)) : $6e20d93164e6da1b$export$79ffe56a765070d2(o));
        };
    };
};
var $6e20d93164e6da1b$export$ea4a22f93200df79 = function(F) {
    return function(f, onNone) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither($6e20d93164e6da1b$export$e56af863d5645d5f(o) ? $6e20d93164e6da1b$export$eabcd2c8791e7bf4(onNone.apply(void 0, a)) : $6e20d93164e6da1b$export$79ffe56a765070d2(o.value));
        };
    };
};
var $6e20d93164e6da1b$export$1a0515933c5c84fe = function(F, M) {
    return /*#__PURE__*/ (0, $lWM6H.dual)(3, function(self, f, onNullable) {
        return M.flatMap(self, $6e20d93164e6da1b$export$cd139e14432f317b(F)(f, onNullable));
    });
};
var $6e20d93164e6da1b$export$b5f02b7beb8ed7d8 = function(F, M) {
    return /*#__PURE__*/ (0, $lWM6H.dual)(3, function(self, f, onNone) {
        return M.flatMap(self, $6e20d93164e6da1b$export$ea4a22f93200df79(F)(f, onNone));
    });
};
var $6e20d93164e6da1b$export$979f2bb6a976172d = function(F, M) {
    return /*#__PURE__*/ (0, $lWM6H.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromEither(f(a));
        });
    });
};
var $6e20d93164e6da1b$export$8b635ef81222764c = function(F, M) {
    return /*#__PURE__*/ (0, $lWM6H.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromIO(f(a));
        });
    });
};
var $6e20d93164e6da1b$export$43849ff3f7ffa51c = function(F, M) {
    return /*#__PURE__*/ (0, $lWM6H.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromTask(f(a));
        });
    });
};
var $6e20d93164e6da1b$export$6481f4ccd0f47bbd = function(F, M) {
    return /*#__PURE__*/ (0, $lWM6H.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromReader(f(a));
        });
    });
};

});


parcelRegister("iXLA9", function(module, exports) {

$parcel$export(module.exports, "chainFirst", () => $dce2a58415b9b4cb$export$e3821ef4970c339c);
$parcel$export(module.exports, "tap", () => $dce2a58415b9b4cb$export$3f23594af5f37336);
$parcel$export(module.exports, "bind", () => $dce2a58415b9b4cb$export$2385a24977818dd0);
function $dce2a58415b9b4cb$export$e3821ef4970c339c(M) {
    var tapM = $dce2a58415b9b4cb$export$3f23594af5f37336(M);
    return function(f) {
        return function(first) {
            return tapM(first, f);
        };
    };
}
function $dce2a58415b9b4cb$export$3f23594af5f37336(M) {
    return function(first, f) {
        return M.chain(first, function(a) {
            return M.map(f(a), function() {
                return a;
            });
        });
    };
}
function $dce2a58415b9b4cb$export$2385a24977818dd0(M) {
    return function(name, f) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return M.map(f(a), function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                });
            });
        };
    };
}

});

parcelRegister("coJMz", function(module, exports) {

$parcel$export(module.exports, "fromOption", () => $906b3d567e02f527$export$172ec0a6ebfeb6fa);
$parcel$export(module.exports, "fromPredicate", () => $906b3d567e02f527$export$23f31c55d7162b91);
$parcel$export(module.exports, "fromOptionK", () => $906b3d567e02f527$export$a907462f448b49f8);
$parcel$export(module.exports, "chainOptionK", () => $906b3d567e02f527$export$12d26179deb6a68a);
$parcel$export(module.exports, "fromEitherK", () => $906b3d567e02f527$export$8138b0ae92c9b5d8);
$parcel$export(module.exports, "chainEitherK", () => $906b3d567e02f527$export$a3eef2eba9908c3e);
$parcel$export(module.exports, "tapEither", () => $906b3d567e02f527$export$be3ff275bb5a8ac9);
$parcel$export(module.exports, "filterOrElse", () => $906b3d567e02f527$export$30af8ca9498ddf5b);
/**
 * The `FromEither` type class represents those data types which support errors.
 *
 * @since 2.10.0
 */ 
var $iXLA9 = parcelRequire("iXLA9");

var $lWM6H = parcelRequire("lWM6H");

var $9sd2T = parcelRequire("9sd2T");
function $906b3d567e02f527$export$172ec0a6ebfeb6fa(F) {
    return function(onNone) {
        return function(ma) {
            return F.fromEither($9sd2T.isNone(ma) ? $9sd2T.left(onNone()) : $9sd2T.right(ma.value));
        };
    };
}
function $906b3d567e02f527$export$23f31c55d7162b91(F) {
    return function(predicate, onFalse) {
        return function(a) {
            return F.fromEither(predicate(a) ? $9sd2T.right(a) : $9sd2T.left(onFalse(a)));
        };
    };
}
function $906b3d567e02f527$export$a907462f448b49f8(F) {
    var fromOptionF = $906b3d567e02f527$export$172ec0a6ebfeb6fa(F);
    return function(onNone) {
        var from = fromOptionF(onNone);
        return function(f) {
            return (0, $lWM6H.flow)(f, from);
        };
    };
}
function $906b3d567e02f527$export$12d26179deb6a68a(F, M) {
    var fromOptionKF = $906b3d567e02f527$export$a907462f448b49f8(F);
    return function(onNone) {
        var from = fromOptionKF(onNone);
        return function(f) {
            return function(ma) {
                return M.chain(ma, from(f));
            };
        };
    };
}
function $906b3d567e02f527$export$8138b0ae92c9b5d8(F) {
    return function(f) {
        return (0, $lWM6H.flow)(f, F.fromEither);
    };
}
function $906b3d567e02f527$export$a3eef2eba9908c3e(F, M) {
    var fromEitherKF = $906b3d567e02f527$export$8138b0ae92c9b5d8(F);
    return function(f) {
        return function(ma) {
            return M.chain(ma, fromEitherKF(f));
        };
    };
}
function $906b3d567e02f527$export$c5f2bdbf9b43f0c0(F, M) {
    var tapEitherM = $906b3d567e02f527$export$be3ff275bb5a8ac9(F, M);
    return function(f) {
        return function(ma) {
            return tapEitherM(ma, f);
        };
    };
}
function $906b3d567e02f527$export$30af8ca9498ddf5b(F, M) {
    return function(predicate, onFalse) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return F.fromEither(predicate(a) ? $9sd2T.right(a) : $9sd2T.left(onFalse(a)));
            });
        };
    };
}
function $906b3d567e02f527$export$be3ff275bb5a8ac9(F, M) {
    var fromEither = $906b3d567e02f527$export$8138b0ae92c9b5d8(F);
    var tapM = (0, $iXLA9.tap)(M);
    return function(self, f) {
        return tapM(self, fromEither(f));
    };
}

});

parcelRegister("gnzaQ", function(module, exports) {

$parcel$export(module.exports, "flap", () => $beca14271b1c8478$export$18c957606d8bdf09);
$parcel$export(module.exports, "bindTo", () => $beca14271b1c8478$export$7c052ae73f8acff0);
$parcel$export(module.exports, "let", () => $beca14271b1c8478$export$5d537b797c421217);
$parcel$export(module.exports, "getFunctorComposition", () => $beca14271b1c8478$export$7b0f6fce42e2b480);
$parcel$export(module.exports, "as", () => $beca14271b1c8478$export$6554612db691658e);
$parcel$export(module.exports, "asUnit", () => $beca14271b1c8478$export$9284b360ca18a0fd);
/**
 * A `Functor` is a type constructor which supports a mapping operation `map`.
 *
 * `map` can be used to turn functions `a -> b` into functions `f a -> f b` whose argument and return types use the type
 * constructor `f` to represent some computational context.
 *
 * Instances must satisfy the following laws:
 *
 * 1. Identity: `F.map(fa, a => a) <-> fa`
 * 2. Composition: `F.map(fa, a => bc(ab(a))) <-> F.map(F.map(fa, ab), bc)`
 *
 * @since 2.0.0
 */ 
var $lWM6H = parcelRequire("lWM6H");
function $beca14271b1c8478$export$871de8747c9eaa88(F, G) {
    return function(f) {
        return function(fa) {
            return F.map(fa, function(ga) {
                return G.map(ga, f);
            });
        };
    };
}
function $beca14271b1c8478$export$18c957606d8bdf09(F) {
    return function(a) {
        return function(fab) {
            return F.map(fab, function(f) {
                return f(a);
            });
        };
    };
}
function $beca14271b1c8478$export$7c052ae73f8acff0(F) {
    return function(name) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return _a = {}, _a[name] = a, _a;
            });
        };
    };
}
function $beca14271b1c8478$export$5d537b797c421217(F) {
    return function(name, f) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return Object.assign({}, a, (_a = {}, _a[name] = f(a), _a));
            });
        };
    };
}
function $beca14271b1c8478$export$7b0f6fce42e2b480(F, G) {
    var _map = $beca14271b1c8478$export$871de8747c9eaa88(F, G);
    return {
        map: function(fga, f) {
            return (0, $lWM6H.pipe)(fga, _map(f));
        }
    };
}
function $beca14271b1c8478$export$6554612db691658e(F) {
    return function(self, b) {
        return F.map(self, function() {
            return b;
        });
    };
}
function $beca14271b1c8478$export$9284b360ca18a0fd(F) {
    var asM = $beca14271b1c8478$export$6554612db691658e(F);
    return function(self) {
        return asM(self, undefined);
    };
}

});

parcelRegister("fWUU5", function(module, exports) {

$parcel$export(module.exports, "isNonEmpty", () => $b9c869a652fa3485$export$a978c53b4062a525);
$parcel$export(module.exports, "isOutOfBound", () => $b9c869a652fa3485$export$2fde0b1c54fc39b9);
$parcel$export(module.exports, "prependW", () => $b9c869a652fa3485$export$c4c4d41eab625797);
$parcel$export(module.exports, "prepend", () => $b9c869a652fa3485$export$68159836694e22c1);
$parcel$export(module.exports, "appendW", () => $b9c869a652fa3485$export$19903a1bf1942f6);
$parcel$export(module.exports, "append", () => $b9c869a652fa3485$export$10d8903dec122b9d);
$parcel$export(module.exports, "unsafeInsertAt", () => $b9c869a652fa3485$export$f4863e1822a1860c);
$parcel$export(module.exports, "unsafeUpdateAt", () => $b9c869a652fa3485$export$9c0c6889b1fa9bfc);
$parcel$export(module.exports, "uniq", () => $b9c869a652fa3485$export$f70730c3d1fc524e);
$parcel$export(module.exports, "head", () => $b9c869a652fa3485$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tail", () => $b9c869a652fa3485$export$c01875f616615628);
$parcel$export(module.exports, "sortBy", () => $b9c869a652fa3485$export$b035e44d7bb4278f);
$parcel$export(module.exports, "sort", () => $b9c869a652fa3485$export$97db5808d8f88186);
$parcel$export(module.exports, "union", () => $b9c869a652fa3485$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "rotate", () => $b9c869a652fa3485$export$bb628a54ab399bc9);
$parcel$export(module.exports, "splitAt", () => $b9c869a652fa3485$export$b0d75975ac0be0e1);
$parcel$export(module.exports, "makeBy", () => $b9c869a652fa3485$export$849fbdcc2211fcde);
$parcel$export(module.exports, "range", () => $b9c869a652fa3485$export$d02631cccf789723);
$parcel$export(module.exports, "init", () => $b9c869a652fa3485$export$2cd8252107eb640b);
$parcel$export(module.exports, "last", () => $b9c869a652fa3485$export$4c7897fafd92b108);
$parcel$export(module.exports, "of", () => $b9c869a652fa3485$export$ba255e9e49e00608);
$parcel$export(module.exports, "prependAll", () => $b9c869a652fa3485$export$849c7567cbd62acc);
$parcel$export(module.exports, "intersperse", () => $b9c869a652fa3485$export$af200dcf8b7cb5de);
$parcel$export(module.exports, "chop", () => $b9c869a652fa3485$export$433fe05b12ba833f);
$parcel$export(module.exports, "chunksOf", () => $b9c869a652fa3485$export$2f0184d5df52135f);
$parcel$export(module.exports, "cons", () => $b9c869a652fa3485$export$8327ebbef2a0ba76);
$parcel$export(module.exports, "snoc", () => $b9c869a652fa3485$export$c40cf5aab899f397);

var $4AIBj = parcelRequire("4AIBj");

var $iXLA9 = parcelRequire("iXLA9");

var $lWM6H = parcelRequire("lWM6H");

var $gnzaQ = parcelRequire("gnzaQ");

var $9sd2T = parcelRequire("9sd2T");

var $4uWSF = parcelRequire("4uWSF");

var $eAcXw = parcelRequire("eAcXw");
var $b9c869a652fa3485$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $b9c869a652fa3485$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $b9c869a652fa3485$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $b9c869a652fa3485$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $b9c869a652fa3485$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $b9c869a652fa3485$export$68159836694e22c1 = $b9c869a652fa3485$export$c4c4d41eab625797;
var $b9c869a652fa3485$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $b9c869a652fa3485$var$__spreadArray($b9c869a652fa3485$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $b9c869a652fa3485$export$10d8903dec122b9d = $b9c869a652fa3485$export$19903a1bf1942f6;
var $b9c869a652fa3485$export$f4863e1822a1860c = function(i, a, as) {
    if ($b9c869a652fa3485$export$a978c53b4062a525(as)) {
        var xs = $b9c869a652fa3485$export$7e77326b0f0e268c(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $b9c869a652fa3485$export$9c0c6889b1fa9bfc = function(i, a, as) {
    var xs = $b9c869a652fa3485$export$7e77326b0f0e268c(as);
    xs[i] = a;
    return xs;
};
var $b9c869a652fa3485$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return $b9c869a652fa3485$export$784d13d8ee351f07(as);
        var out = [
            $b9c869a652fa3485$export$5fd5031fecdacec3(as)
        ];
        var rest = $b9c869a652fa3485$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $b9c869a652fa3485$export$b035e44d7bb4278f = function(ords) {
    if ($b9c869a652fa3485$export$a978c53b4062a525(ords)) {
        var M = (0, $4uWSF.getMonoid)();
        return $b9c869a652fa3485$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return $b9c869a652fa3485$export$784d13d8ee351f07;
};
var $b9c869a652fa3485$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $b9c869a652fa3485$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $lWM6H.pipe)(first, $b9c869a652fa3485$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $b9c869a652fa3485$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($b9c869a652fa3485$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return $b9c869a652fa3485$export$784d13d8ee351f07(as);
        if (m < 0) {
            var _a = $b9c869a652fa3485$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $lWM6H.pipe)(s, $b9c869a652fa3485$export$ee1b3e54f0441b22(f));
        } else return $b9c869a652fa3485$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $b9c869a652fa3485$export$7e77326b0f0e268c = $9sd2T.fromReadonlyNonEmptyArray;
var $b9c869a652fa3485$export$571d59b505e6bb4e = function(as) {
    return $b9c869a652fa3485$export$a978c53b4062a525(as) ? $9sd2T.some(as) : $9sd2T.none;
};
var $b9c869a652fa3485$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $b9c869a652fa3485$export$606959e7ccb797f0 = function(a) {
    return $b9c869a652fa3485$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $b9c869a652fa3485$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $b9c869a652fa3485$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $b9c869a652fa3485$export$c04edabe9c8d994f = function(as) {
    return [
        $b9c869a652fa3485$export$5fd5031fecdacec3(as),
        $b9c869a652fa3485$export$c01875f616615628(as)
    ];
};
var $b9c869a652fa3485$export$89a97afc72a83708 = function(as) {
    return [
        $b9c869a652fa3485$export$2cd8252107eb640b(as),
        $b9c869a652fa3485$export$4c7897fafd92b108(as)
    ];
};
function $b9c869a652fa3485$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $b9c869a652fa3485$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $b9c869a652fa3485$export$66c1ae025e96b4bc = function(as) {
    return $b9c869a652fa3485$var$__spreadArray([
        $b9c869a652fa3485$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $b9c869a652fa3485$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return [];
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $b9c869a652fa3485$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($9sd2T.has.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $b9c869a652fa3485$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.slice().sort(O.compare);
    };
};
var $b9c869a652fa3485$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $9sd2T.none : $9sd2T.some($b9c869a652fa3485$export$f4863e1822a1860c(i, a, as));
    };
};
var $b9c869a652fa3485$export$b6d8713d53419d4c = function(i, a) {
    return $b9c869a652fa3485$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $b9c869a652fa3485$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $b9c869a652fa3485$export$2fde0b1c54fc39b9(i, as) ? $9sd2T.none : $9sd2T.some($b9c869a652fa3485$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $b9c869a652fa3485$export$784d13d8ee351f07 = $b9c869a652fa3485$export$7e77326b0f0e268c;
var $b9c869a652fa3485$export$ba255e9e49e00608 = function(a) {
    return [
        a
    ];
};
var $b9c869a652fa3485$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $b9c869a652fa3485$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $b9c869a652fa3485$export$8901015135f2fb22(bs, as);
    };
    return $b9c869a652fa3485$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $b9c869a652fa3485$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $b9c869a652fa3485$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $b9c869a652fa3485$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $b9c869a652fa3485$export$c01875f616615628(as);
        return $b9c869a652fa3485$export$a978c53b4062a525(rest) ? (0, $lWM6H.pipe)(rest, $b9c869a652fa3485$export$849c7567cbd62acc(middle), $b9c869a652fa3485$export$68159836694e22c1($b9c869a652fa3485$export$5fd5031fecdacec3(as))) : $b9c869a652fa3485$export$784d13d8ee351f07(as);
    };
};
var $b9c869a652fa3485$export$18153bb1181268e5 = $eAcXw.foldMapWithIndex;
var $b9c869a652fa3485$export$b66cdc0497d8a99a = $eAcXw.foldMap;
var $b9c869a652fa3485$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $b9c869a652fa3485$export$7e77326b0f0e268c(f(0, $b9c869a652fa3485$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $b9c869a652fa3485$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($b9c869a652fa3485$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $b9c869a652fa3485$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            $b9c869a652fa3485$export$784d13d8ee351f07(as),
            []
        ] : [
            (0, $lWM6H.pipe)(as.slice(1, m), $b9c869a652fa3485$export$68159836694e22c1($b9c869a652fa3485$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $b9c869a652fa3485$export$2f0184d5df52135f = function(n) {
    return $b9c869a652fa3485$export$433fe05b12ba833f($b9c869a652fa3485$export$b0d75975ac0be0e1(n));
};
/* istanbul ignore next */ var $b9c869a652fa3485$var$_map = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $b9c869a652fa3485$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $b9c869a652fa3485$var$_mapWithIndex = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $b9c869a652fa3485$export$8f07ddce13659f50(f));
};
/* istanbul ignore next */ var $b9c869a652fa3485$var$_ap = function(fab, fa) {
    return (0, $lWM6H.pipe)(fab, $b9c869a652fa3485$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $b9c869a652fa3485$var$_extend = function(wa, f) {
    return (0, $lWM6H.pipe)(wa, $b9c869a652fa3485$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $b9c869a652fa3485$var$_reduce = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $b9c869a652fa3485$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $b9c869a652fa3485$var$_foldMap = function(M) {
    var foldMapM = $b9c869a652fa3485$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $lWM6H.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $b9c869a652fa3485$var$_reduceRight = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $b9c869a652fa3485$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $b9c869a652fa3485$var$_traverse = function(F) {
    var traverseF = $b9c869a652fa3485$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $lWM6H.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $b9c869a652fa3485$var$_alt = function(fa, that) {
    return (0, $lWM6H.pipe)(fa, $b9c869a652fa3485$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $b9c869a652fa3485$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $b9c869a652fa3485$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $b9c869a652fa3485$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $b9c869a652fa3485$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $lWM6H.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $b9c869a652fa3485$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $b9c869a652fa3485$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $b9c869a652fa3485$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $b9c869a652fa3485$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $lWM6H.pipe)(ta, traverseWithIndexF(f));
    };
};
var $b9c869a652fa3485$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $lWM6H.pipe)(as, $b9c869a652fa3485$export$c8c959650bbe80e2(that()));
    };
};
var $b9c869a652fa3485$export$228be17d80722ab = $b9c869a652fa3485$export$1517cca7889d6aaa;
var $b9c869a652fa3485$export$2f6ca3d3b1f80bf5 = function(as) {
    return $b9c869a652fa3485$export$5b8affa63fc6df16(function(f) {
        return (0, $lWM6H.pipe)(as, $b9c869a652fa3485$export$871de8747c9eaa88(f));
    });
};
var $b9c869a652fa3485$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $lWM6H.dual)(2, function(ma, f) {
    return (0, $lWM6H.pipe)(ma, $b9c869a652fa3485$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $b9c869a652fa3485$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $b9c869a652fa3485$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($b9c869a652fa3485$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $b9c869a652fa3485$export$c01875f616615628(next);
        }
        return out;
    };
};
var $b9c869a652fa3485$export$ecd5e8ace626722c = /*#__PURE__*/ $b9c869a652fa3485$export$8b58be045bf06082((0, $lWM6H.identity));
var $b9c869a652fa3485$export$bffa455ba8c619a6 = /*#__PURE__*/ $b9c869a652fa3485$export$5b8affa63fc6df16((0, $lWM6H.identity));
var $b9c869a652fa3485$export$871de8747c9eaa88 = function(f) {
    return $b9c869a652fa3485$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $b9c869a652fa3485$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $b9c869a652fa3485$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $b9c869a652fa3485$export$533b26079ad0b4b = $eAcXw.reduce;
var $b9c869a652fa3485$export$bbd3ef8720e22369 = $eAcXw.reduceWithIndex;
var $b9c869a652fa3485$export$7fef8bcdbb34f435 = $eAcXw.reduceRight;
var $b9c869a652fa3485$export$ce2b2fe0b88ccd0a = $eAcXw.reduceRightWithIndex;
var $b9c869a652fa3485$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $b9c869a652fa3485$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $b9c869a652fa3485$export$49bb65c2ea163039 = function(F) {
    return $b9c869a652fa3485$export$955fdc0d24efa249(F)(function(_, a) {
        return a;
    });
};
var $b9c869a652fa3485$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $b9c869a652fa3485$export$5fd5031fecdacec3(as)), $b9c869a652fa3485$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $lWM6H.pipe)(bs, $b9c869a652fa3485$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $b9c869a652fa3485$export$f9380c9a627682d3 = $eAcXw.head;
var $b9c869a652fa3485$export$9156e739aa33e19f = 'NonEmptyArray';
var $b9c869a652fa3485$export$3cb5cd7f7776c81 = $eAcXw.getShow;
var $b9c869a652fa3485$export$e759a9a7f8d04692 = function() {
    return {
        concat: $b9c869a652fa3485$export$ee1b3e54f0441b22
    };
};
var $b9c869a652fa3485$export$804fed467fde44e4 = $eAcXw.getEq;
var $b9c869a652fa3485$export$baca17b4aff42f82 = function(E) {
    var unionE = $b9c869a652fa3485$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $b9c869a652fa3485$export$bd5b6bfc5fa2ee61 = {
    URI: $b9c869a652fa3485$export$9156e739aa33e19f,
    map: $b9c869a652fa3485$var$_map
};
var $b9c869a652fa3485$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $gnzaQ.flap)($b9c869a652fa3485$export$bd5b6bfc5fa2ee61);
var $b9c869a652fa3485$export$59a71046037e6c20 = {
    URI: $b9c869a652fa3485$export$9156e739aa33e19f,
    of: $b9c869a652fa3485$export$ba255e9e49e00608
};
var $b9c869a652fa3485$export$9fdffe0fe1e91cad = {
    URI: $b9c869a652fa3485$export$9156e739aa33e19f,
    map: $b9c869a652fa3485$var$_map,
    mapWithIndex: $b9c869a652fa3485$var$_mapWithIndex
};
var $b9c869a652fa3485$export$efc21ddc6aeb363d = {
    URI: $b9c869a652fa3485$export$9156e739aa33e19f,
    map: $b9c869a652fa3485$var$_map,
    ap: $b9c869a652fa3485$var$_ap
};
var $b9c869a652fa3485$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $4AIBj.apFirst)($b9c869a652fa3485$export$efc21ddc6aeb363d);
var $b9c869a652fa3485$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $4AIBj.apSecond)($b9c869a652fa3485$export$efc21ddc6aeb363d);
var $b9c869a652fa3485$export$1279d2b7807629fd = {
    URI: $b9c869a652fa3485$export$9156e739aa33e19f,
    map: $b9c869a652fa3485$var$_map,
    ap: $b9c869a652fa3485$var$_ap,
    of: $b9c869a652fa3485$export$ba255e9e49e00608
};
var $b9c869a652fa3485$export$f18d5acc27d70423 = {
    URI: $b9c869a652fa3485$export$9156e739aa33e19f,
    map: $b9c869a652fa3485$var$_map,
    ap: $b9c869a652fa3485$var$_ap,
    chain: $b9c869a652fa3485$export$5b8affa63fc6df16
};
var $b9c869a652fa3485$export$e3821ef4970c339c = /*#__PURE__*/ (0, $iXLA9.chainFirst)($b9c869a652fa3485$export$f18d5acc27d70423);
var $b9c869a652fa3485$export$fb641926d034ac7d = {
    URI: $b9c869a652fa3485$export$9156e739aa33e19f,
    map: $b9c869a652fa3485$var$_map,
    ap: $b9c869a652fa3485$var$_ap,
    of: $b9c869a652fa3485$export$ba255e9e49e00608,
    chain: $b9c869a652fa3485$export$5b8affa63fc6df16
};
var $b9c869a652fa3485$export$41404b31838667c9 = {
    URI: $b9c869a652fa3485$export$9156e739aa33e19f,
    reduce: $b9c869a652fa3485$var$_reduce,
    foldMap: $b9c869a652fa3485$var$_foldMap,
    reduceRight: $b9c869a652fa3485$var$_reduceRight
};
var $b9c869a652fa3485$export$e8f7d17aaff345cb = {
    URI: $b9c869a652fa3485$export$9156e739aa33e19f,
    reduce: $b9c869a652fa3485$var$_reduce,
    foldMap: $b9c869a652fa3485$var$_foldMap,
    reduceRight: $b9c869a652fa3485$var$_reduceRight,
    reduceWithIndex: $b9c869a652fa3485$var$_reduceWithIndex,
    foldMapWithIndex: $b9c869a652fa3485$var$_foldMapWithIndex,
    reduceRightWithIndex: $b9c869a652fa3485$var$_reduceRightWithIndex
};
var $b9c869a652fa3485$export$a0202666c3bda011 = {
    URI: $b9c869a652fa3485$export$9156e739aa33e19f,
    map: $b9c869a652fa3485$var$_map,
    reduce: $b9c869a652fa3485$var$_reduce,
    foldMap: $b9c869a652fa3485$var$_foldMap,
    reduceRight: $b9c869a652fa3485$var$_reduceRight,
    traverse: $b9c869a652fa3485$var$_traverse,
    sequence: $b9c869a652fa3485$export$49bb65c2ea163039
};
var $b9c869a652fa3485$export$bd7b528d8c36ec41 = {
    URI: $b9c869a652fa3485$export$9156e739aa33e19f,
    map: $b9c869a652fa3485$var$_map,
    mapWithIndex: $b9c869a652fa3485$var$_mapWithIndex,
    reduce: $b9c869a652fa3485$var$_reduce,
    foldMap: $b9c869a652fa3485$var$_foldMap,
    reduceRight: $b9c869a652fa3485$var$_reduceRight,
    traverse: $b9c869a652fa3485$var$_traverse,
    sequence: $b9c869a652fa3485$export$49bb65c2ea163039,
    reduceWithIndex: $b9c869a652fa3485$var$_reduceWithIndex,
    foldMapWithIndex: $b9c869a652fa3485$var$_foldMapWithIndex,
    reduceRightWithIndex: $b9c869a652fa3485$var$_reduceRightWithIndex,
    traverseWithIndex: $b9c869a652fa3485$var$_traverseWithIndex
};
var $b9c869a652fa3485$export$25ba4469a069167 = {
    URI: $b9c869a652fa3485$export$9156e739aa33e19f,
    map: $b9c869a652fa3485$var$_map,
    alt: $b9c869a652fa3485$var$_alt
};
var $b9c869a652fa3485$export$fdd73124b9f1de36 = {
    URI: $b9c869a652fa3485$export$9156e739aa33e19f,
    map: $b9c869a652fa3485$var$_map,
    extend: $b9c869a652fa3485$var$_extend,
    extract: $b9c869a652fa3485$export$f9380c9a627682d3
};
var $b9c869a652fa3485$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $b9c869a652fa3485$export$ba255e9e49e00608($9sd2T.emptyRecord);
var $b9c869a652fa3485$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $gnzaQ.bindTo)($b9c869a652fa3485$export$bd5b6bfc5fa2ee61);
var $b9c869a652fa3485$export$5d537b797c421217 = /*#__PURE__*/ (0, $gnzaQ.let)($b9c869a652fa3485$export$bd5b6bfc5fa2ee61);
var $b9c869a652fa3485$export$2385a24977818dd0 = /*#__PURE__*/ (0, $iXLA9.bind)($b9c869a652fa3485$export$f18d5acc27d70423);
var $b9c869a652fa3485$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $4AIBj.apS)($b9c869a652fa3485$export$efc21ddc6aeb363d);
var $b9c869a652fa3485$export$5fd5031fecdacec3 = $eAcXw.head;
var $b9c869a652fa3485$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $b9c869a652fa3485$export$4c7897fafd92b108 = $eAcXw.last;
var $b9c869a652fa3485$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $b9c869a652fa3485$export$96ec731ed4dcb222 = $eAcXw.min;
var $b9c869a652fa3485$export$8960430cfd85939f = $eAcXw.max;
var $b9c869a652fa3485$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $b9c869a652fa3485$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($b9c869a652fa3485$export$5fd5031fecdacec3(as), $b9c869a652fa3485$export$c01875f616615628(as));
    };
};
var $b9c869a652fa3485$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($b9c869a652fa3485$export$2cd8252107eb640b(as), $b9c869a652fa3485$export$4c7897fafd92b108(as));
    };
};
var $b9c869a652fa3485$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $b9c869a652fa3485$var$__spreadArray([
            f($b9c869a652fa3485$export$5fd5031fecdacec3(as))
        ], $b9c869a652fa3485$export$c01875f616615628(as), true);
    };
};
var $b9c869a652fa3485$export$20ca6ad9f7762931 = function(a) {
    return $b9c869a652fa3485$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $b9c869a652fa3485$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $lWM6H.pipe)($b9c869a652fa3485$export$2cd8252107eb640b(as), $b9c869a652fa3485$export$10d8903dec122b9d(f($b9c869a652fa3485$export$4c7897fafd92b108(as))));
    };
};
var $b9c869a652fa3485$export$d3affa0a0a83d946 = function(a) {
    return $b9c869a652fa3485$export$302ad361c463800a(function() {
        return a;
    });
};
var $b9c869a652fa3485$export$739ec22334c44788 = $eAcXw.intercalate;
var $b9c869a652fa3485$export$e08e3b67e392101e = $b9c869a652fa3485$export$5b8affa63fc6df16;
function $b9c869a652fa3485$export$103ce2c0a67e4e61(O) {
    var sortO = $b9c869a652fa3485$export$97db5808d8f88186(O);
    var groupO = $b9c869a652fa3485$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $b9c869a652fa3485$export$a978c53b4062a525(as) ? groupO(sortO(as)) : [];
    };
}
function $b9c869a652fa3485$export$3dea766d36a8935f(predicate) {
    return $b9c869a652fa3485$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $b9c869a652fa3485$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $b9c869a652fa3485$export$571d59b505e6bb4e(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $b9c869a652fa3485$export$b446f6baa3bb1430 = $b9c869a652fa3485$export$c04edabe9c8d994f;
var $b9c869a652fa3485$export$712962e076096ed4 = $b9c869a652fa3485$export$89a97afc72a83708;
function $b9c869a652fa3485$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $b9c869a652fa3485$export$68159836694e22c1(head) : (0, $lWM6H.pipe)(tail, $b9c869a652fa3485$export$68159836694e22c1(head));
}
var $b9c869a652fa3485$export$c40cf5aab899f397 = function(init, end) {
    return (0, $lWM6H.pipe)(init, $b9c869a652fa3485$export$10d8903dec122b9d(end));
};
var $b9c869a652fa3485$export$baeb00bf1e27e233 = $b9c869a652fa3485$export$849c7567cbd62acc;
var $b9c869a652fa3485$export$93e2b83da34ff82a = $eAcXw.concatAll;
var $b9c869a652fa3485$export$a5383a53b408af94 = {
    URI: $b9c869a652fa3485$export$9156e739aa33e19f,
    of: $b9c869a652fa3485$export$ba255e9e49e00608,
    map: $b9c869a652fa3485$var$_map,
    mapWithIndex: $b9c869a652fa3485$var$_mapWithIndex,
    ap: $b9c869a652fa3485$var$_ap,
    chain: $b9c869a652fa3485$export$5b8affa63fc6df16,
    extend: $b9c869a652fa3485$var$_extend,
    extract: $b9c869a652fa3485$export$f9380c9a627682d3,
    reduce: $b9c869a652fa3485$var$_reduce,
    foldMap: $b9c869a652fa3485$var$_foldMap,
    reduceRight: $b9c869a652fa3485$var$_reduceRight,
    traverse: $b9c869a652fa3485$var$_traverse,
    sequence: $b9c869a652fa3485$export$49bb65c2ea163039,
    reduceWithIndex: $b9c869a652fa3485$var$_reduceWithIndex,
    foldMapWithIndex: $b9c869a652fa3485$var$_foldMapWithIndex,
    reduceRightWithIndex: $b9c869a652fa3485$var$_reduceRightWithIndex,
    traverseWithIndex: $b9c869a652fa3485$var$_traverseWithIndex,
    alt: $b9c869a652fa3485$var$_alt
};

});
parcelRegister("4uWSF", function(module, exports) {

$parcel$export(module.exports, "fromCompare", () => $3467a3471c84921a$export$aa9e0de96ff2f1fd);
$parcel$export(module.exports, "getMonoid", () => $3467a3471c84921a$export$c2a7ef2cc9b32b31);
$parcel$export(module.exports, "min", () => $3467a3471c84921a$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $3467a3471c84921a$export$8960430cfd85939f);

var $bOO3o = parcelRequire("bOO3o");

var $lWM6H = parcelRequire("lWM6H");
var $3467a3471c84921a$export$19fbc5aa8790347c = function(compare) {
    return function(first, second) {
        return first === second || compare(first, second) === 0;
    };
};
var $3467a3471c84921a$export$aa9e0de96ff2f1fd = function(compare) {
    return {
        equals: $3467a3471c84921a$export$19fbc5aa8790347c(compare),
        compare: function(first, second) {
            return first === second ? 0 : compare(first, second);
        }
    };
};
var $3467a3471c84921a$export$65e3907585753458 = function() {
    var ords = [];
    for(var _i = 0; _i < arguments.length; _i++)ords[_i] = arguments[_i];
    return $3467a3471c84921a$export$aa9e0de96ff2f1fd(function(first, second) {
        var i = 0;
        for(; i < ords.length - 1; i++){
            var r = ords[i].compare(first[i], second[i]);
            if (r !== 0) return r;
        }
        return ords[i].compare(first[i], second[i]);
    });
};
var $3467a3471c84921a$export$66c1ae025e96b4bc = function(O) {
    return $3467a3471c84921a$export$aa9e0de96ff2f1fd(function(first, second) {
        return O.compare(second, first);
    });
};
/* istanbul ignore next */ var $3467a3471c84921a$var$contramap_ = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $3467a3471c84921a$export$53b696d27ecb7ba7(f));
};
var $3467a3471c84921a$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $3467a3471c84921a$export$aa9e0de96ff2f1fd(function(first, second) {
            return fa.compare(f(first), f(second));
        });
    };
};
var $3467a3471c84921a$export$9156e739aa33e19f = 'Ord';
var $3467a3471c84921a$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $3467a3471c84921a$export$aa9e0de96ff2f1fd(function(a, b) {
                var ox = first.compare(a, b);
                return ox !== 0 ? ox : second.compare(a, b);
            });
        }
    };
};
var $3467a3471c84921a$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $3467a3471c84921a$export$e759a9a7f8d04692().concat,
        empty: $3467a3471c84921a$export$aa9e0de96ff2f1fd(function() {
            return 0;
        })
    };
};
var $3467a3471c84921a$export$def901a57d5539c3 = {
    URI: $3467a3471c84921a$export$9156e739aa33e19f,
    contramap: $3467a3471c84921a$var$contramap_
};
var $3467a3471c84921a$export$e5bb9f0f2dedbef6 = {
    equals: (0, $lWM6H.constTrue),
    compare: /*#__PURE__*/ (0, $lWM6H.constant)(0)
};
var $3467a3471c84921a$export$e9bab7fafb253603 = function(O) {
    return function(second) {
        return function(first) {
            return first === second || O.compare(first, second) === 0;
        };
    };
};
var $3467a3471c84921a$export$b961576059b7aeb6 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === -1;
    };
};
var $3467a3471c84921a$export$dafeacbfe3530cd9 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === 1;
    };
};
var $3467a3471c84921a$export$8c5f3ec5d3a940d = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== 1;
    };
};
var $3467a3471c84921a$export$61f00a763551642c = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== -1;
    };
};
var $3467a3471c84921a$export$96ec731ed4dcb222 = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) < 1 ? first : second;
    };
};
var $3467a3471c84921a$export$8960430cfd85939f = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) > -1 ? first : second;
    };
};
var $3467a3471c84921a$export$7d15b64cf5a3a4c4 = function(O) {
    var minO = $3467a3471c84921a$export$96ec731ed4dcb222(O);
    var maxO = $3467a3471c84921a$export$8960430cfd85939f(O);
    return function(low, hi) {
        return function(a) {
            return maxO(minO(a, hi), low);
        };
    };
};
var $3467a3471c84921a$export$cf95c51b03f10bae = function(O) {
    var ltO = $3467a3471c84921a$export$b961576059b7aeb6(O);
    var gtO = $3467a3471c84921a$export$dafeacbfe3530cd9(O);
    return function(low, hi) {
        return function(a) {
            return ltO(a, low) || gtO(a, hi) ? false : true;
        };
    };
};
var $3467a3471c84921a$export$c41db498223b95e9 = $3467a3471c84921a$export$65e3907585753458;
var $3467a3471c84921a$export$35315ebcdff1b05c = $3467a3471c84921a$export$66c1ae025e96b4bc;
var $3467a3471c84921a$export$ad12338f1fefb50e = $3467a3471c84921a$export$def901a57d5539c3;
// default compare for primitive types
function $3467a3471c84921a$var$compare(first, second) {
    return first < second ? -1 : first > second ? 1 : 0;
}
var $3467a3471c84921a$var$strictOrd = {
    equals: (0, $bOO3o.eqStrict).equals,
    compare: $3467a3471c84921a$var$compare
};
var $3467a3471c84921a$export$ef759d57a4e44836 = $3467a3471c84921a$var$strictOrd;
var $3467a3471c84921a$export$c5f2758e49b2b86a = $3467a3471c84921a$var$strictOrd;
var $3467a3471c84921a$export$5ed021ff2336715c = $3467a3471c84921a$var$strictOrd;
var $3467a3471c84921a$export$722593c82468f9f4 = /*#__PURE__*/ (0, $lWM6H.pipe)($3467a3471c84921a$export$5ed021ff2336715c, /*#__PURE__*/ $3467a3471c84921a$export$53b696d27ecb7ba7(function(date) {
    return date.valueOf();
}));

});
parcelRegister("bOO3o", function(module, exports) {

$parcel$export(module.exports, "fromEquals", () => $89ab30dbf25641c3$export$fec6acd8d60e8568);
$parcel$export(module.exports, "eqStrict", () => $89ab30dbf25641c3$export$37a88d8211c10fd3);

var $lWM6H = parcelRequire("lWM6H");
var $89ab30dbf25641c3$export$fec6acd8d60e8568 = function(equals) {
    return {
        equals: function(x, y) {
            return x === y || equals(x, y);
        }
    };
};
var $89ab30dbf25641c3$export$8cf3da7c1c9174ea = function(eqs) {
    return $89ab30dbf25641c3$export$fec6acd8d60e8568(function(first, second) {
        for(var key in eqs){
            if (!eqs[key].equals(first[key], second[key])) return false;
        }
        return true;
    });
};
var $89ab30dbf25641c3$export$65e3907585753458 = function() {
    var eqs = [];
    for(var _i = 0; _i < arguments.length; _i++)eqs[_i] = arguments[_i];
    return $89ab30dbf25641c3$export$fec6acd8d60e8568(function(first, second) {
        return eqs.every(function(E, i) {
            return E.equals(first[i], second[i]);
        });
    });
};
/* istanbul ignore next */ var $89ab30dbf25641c3$var$contramap_ = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $89ab30dbf25641c3$export$53b696d27ecb7ba7(f));
};
var $89ab30dbf25641c3$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $89ab30dbf25641c3$export$fec6acd8d60e8568(function(x, y) {
            return fa.equals(f(x), f(y));
        });
    };
};
var $89ab30dbf25641c3$export$9156e739aa33e19f = 'Eq';
var $89ab30dbf25641c3$export$37a88d8211c10fd3 = {
    equals: function(a, b) {
        return a === b;
    }
};
var $89ab30dbf25641c3$var$empty = {
    equals: function() {
        return true;
    }
};
var $89ab30dbf25641c3$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(x, y) {
            return $89ab30dbf25641c3$export$fec6acd8d60e8568(function(a, b) {
                return x.equals(a, b) && y.equals(a, b);
            });
        }
    };
};
var $89ab30dbf25641c3$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $89ab30dbf25641c3$export$e759a9a7f8d04692().concat,
        empty: $89ab30dbf25641c3$var$empty
    };
};
var $89ab30dbf25641c3$export$def901a57d5539c3 = {
    URI: $89ab30dbf25641c3$export$9156e739aa33e19f,
    contramap: $89ab30dbf25641c3$var$contramap_
};
var $89ab30dbf25641c3$export$1a50cb133a346493 = $89ab30dbf25641c3$export$65e3907585753458;
var $89ab30dbf25641c3$export$b35b2bde1875587a = $89ab30dbf25641c3$export$8cf3da7c1c9174ea;
var $89ab30dbf25641c3$export$24d177074f8dc6ef = $89ab30dbf25641c3$export$37a88d8211c10fd3.equals;
var $89ab30dbf25641c3$export$9663ddc1cf085b32 = $89ab30dbf25641c3$export$def901a57d5539c3;
var $89ab30dbf25641c3$export$d7927e8ffc1afb48 = $89ab30dbf25641c3$export$37a88d8211c10fd3;
var $89ab30dbf25641c3$export$fa624555ca2acbc8 = $89ab30dbf25641c3$export$37a88d8211c10fd3;
var $89ab30dbf25641c3$export$e24978670be1e4f3 = $89ab30dbf25641c3$export$37a88d8211c10fd3;
var $89ab30dbf25641c3$export$4eced57d6183c43d = {
    equals: function(first, second) {
        return first.valueOf() === second.valueOf();
    }
};

});


parcelRegister("eAcXw", function(module, exports) {

$parcel$export(module.exports, "empty", () => $a9de7ae1f3585c8e$export$6e22c362a0406a2c);
$parcel$export(module.exports, "isNonEmpty", () => $a9de7ae1f3585c8e$export$a978c53b4062a525);
$parcel$export(module.exports, "isOutOfBound", () => $a9de7ae1f3585c8e$export$2fde0b1c54fc39b9);
$parcel$export(module.exports, "prependW", () => $a9de7ae1f3585c8e$export$c4c4d41eab625797);
$parcel$export(module.exports, "prepend", () => $a9de7ae1f3585c8e$export$68159836694e22c1);
$parcel$export(module.exports, "appendW", () => $a9de7ae1f3585c8e$export$19903a1bf1942f6);
$parcel$export(module.exports, "append", () => $a9de7ae1f3585c8e$export$10d8903dec122b9d);
$parcel$export(module.exports, "unsafeInsertAt", () => $a9de7ae1f3585c8e$export$f4863e1822a1860c);
$parcel$export(module.exports, "unsafeUpdateAt", () => $a9de7ae1f3585c8e$export$9c0c6889b1fa9bfc);
$parcel$export(module.exports, "uniq", () => $a9de7ae1f3585c8e$export$f70730c3d1fc524e);
$parcel$export(module.exports, "head", () => $a9de7ae1f3585c8e$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tail", () => $a9de7ae1f3585c8e$export$c01875f616615628);
$parcel$export(module.exports, "sortBy", () => $a9de7ae1f3585c8e$export$b035e44d7bb4278f);
$parcel$export(module.exports, "union", () => $a9de7ae1f3585c8e$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "rotate", () => $a9de7ae1f3585c8e$export$bb628a54ab399bc9);
$parcel$export(module.exports, "splitAt", () => $a9de7ae1f3585c8e$export$b0d75975ac0be0e1);
$parcel$export(module.exports, "makeBy", () => $a9de7ae1f3585c8e$export$849fbdcc2211fcde);
$parcel$export(module.exports, "range", () => $a9de7ae1f3585c8e$export$d02631cccf789723);
$parcel$export(module.exports, "init", () => $a9de7ae1f3585c8e$export$2cd8252107eb640b);
$parcel$export(module.exports, "last", () => $a9de7ae1f3585c8e$export$4c7897fafd92b108);
$parcel$export(module.exports, "prependAll", () => $a9de7ae1f3585c8e$export$849c7567cbd62acc);
$parcel$export(module.exports, "intersperse", () => $a9de7ae1f3585c8e$export$af200dcf8b7cb5de);
$parcel$export(module.exports, "chop", () => $a9de7ae1f3585c8e$export$433fe05b12ba833f);
$parcel$export(module.exports, "chunksOf", () => $a9de7ae1f3585c8e$export$2f0184d5df52135f);
$parcel$export(module.exports, "reduce", () => $a9de7ae1f3585c8e$export$533b26079ad0b4b);
$parcel$export(module.exports, "foldMap", () => $a9de7ae1f3585c8e$export$b66cdc0497d8a99a);
$parcel$export(module.exports, "reduceRight", () => $a9de7ae1f3585c8e$export$7fef8bcdbb34f435);
$parcel$export(module.exports, "reduceWithIndex", () => $a9de7ae1f3585c8e$export$bbd3ef8720e22369);
$parcel$export(module.exports, "foldMapWithIndex", () => $a9de7ae1f3585c8e$export$18153bb1181268e5);
$parcel$export(module.exports, "reduceRightWithIndex", () => $a9de7ae1f3585c8e$export$ce2b2fe0b88ccd0a);
$parcel$export(module.exports, "of", () => $a9de7ae1f3585c8e$export$ba255e9e49e00608);
$parcel$export(module.exports, "getShow", () => $a9de7ae1f3585c8e$export$3cb5cd7f7776c81);
$parcel$export(module.exports, "getEq", () => $a9de7ae1f3585c8e$export$804fed467fde44e4);
$parcel$export(module.exports, "min", () => $a9de7ae1f3585c8e$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $a9de7ae1f3585c8e$export$8960430cfd85939f);
$parcel$export(module.exports, "concatAll", () => $a9de7ae1f3585c8e$export$b314777ae20abca9);
$parcel$export(module.exports, "intercalate", () => $a9de7ae1f3585c8e$export$739ec22334c44788);
$parcel$export(module.exports, "cons", () => $a9de7ae1f3585c8e$export$8327ebbef2a0ba76);
$parcel$export(module.exports, "snoc", () => $a9de7ae1f3585c8e$export$c40cf5aab899f397);

var $4AIBj = parcelRequire("4AIBj");

var $iXLA9 = parcelRequire("iXLA9");

var $bOO3o = parcelRequire("bOO3o");

var $lWM6H = parcelRequire("lWM6H");

var $gnzaQ = parcelRequire("gnzaQ");

var $9sd2T = parcelRequire("9sd2T");

var $4uWSF = parcelRequire("4uWSF");

var $iIsEa = parcelRequire("iIsEa");
var $a9de7ae1f3585c8e$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $a9de7ae1f3585c8e$export$6e22c362a0406a2c = $9sd2T.emptyReadonlyArray;
var $a9de7ae1f3585c8e$export$a978c53b4062a525 = $9sd2T.isNonEmpty;
var $a9de7ae1f3585c8e$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $a9de7ae1f3585c8e$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $a9de7ae1f3585c8e$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $a9de7ae1f3585c8e$export$68159836694e22c1 = $a9de7ae1f3585c8e$export$c4c4d41eab625797;
var $a9de7ae1f3585c8e$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $a9de7ae1f3585c8e$var$__spreadArray($a9de7ae1f3585c8e$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $a9de7ae1f3585c8e$export$10d8903dec122b9d = $a9de7ae1f3585c8e$export$19903a1bf1942f6;
var $a9de7ae1f3585c8e$export$f4863e1822a1860c = function(i, a, as) {
    if ($a9de7ae1f3585c8e$export$a978c53b4062a525(as)) {
        var xs = $9sd2T.fromReadonlyNonEmptyArray(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $a9de7ae1f3585c8e$export$9c0c6889b1fa9bfc = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $9sd2T.fromReadonlyNonEmptyArray(as);
        xs[i] = a;
        return xs;
    }
};
var $a9de7ae1f3585c8e$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return as;
        var out = [
            $a9de7ae1f3585c8e$export$5fd5031fecdacec3(as)
        ];
        var rest = $a9de7ae1f3585c8e$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $a9de7ae1f3585c8e$export$b035e44d7bb4278f = function(ords) {
    if ($a9de7ae1f3585c8e$export$a978c53b4062a525(ords)) {
        var M = (0, $4uWSF.getMonoid)();
        return $a9de7ae1f3585c8e$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return 0, $lWM6H.identity;
};
var $a9de7ae1f3585c8e$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $a9de7ae1f3585c8e$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $lWM6H.pipe)(first, $a9de7ae1f3585c8e$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $a9de7ae1f3585c8e$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($a9de7ae1f3585c8e$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return as;
        if (m < 0) {
            var _a = $a9de7ae1f3585c8e$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $lWM6H.pipe)(s, $a9de7ae1f3585c8e$export$ee1b3e54f0441b22(f));
        } else return $a9de7ae1f3585c8e$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $a9de7ae1f3585c8e$export$9288e031f1846591 = function(as) {
    return $a9de7ae1f3585c8e$export$a978c53b4062a525(as) ? $9sd2T.some(as) : $9sd2T.none;
};
var $a9de7ae1f3585c8e$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $a9de7ae1f3585c8e$export$606959e7ccb797f0 = function(a) {
    return $a9de7ae1f3585c8e$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $a9de7ae1f3585c8e$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $a9de7ae1f3585c8e$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $a9de7ae1f3585c8e$export$c04edabe9c8d994f = function(as) {
    return [
        $a9de7ae1f3585c8e$export$5fd5031fecdacec3(as),
        $a9de7ae1f3585c8e$export$c01875f616615628(as)
    ];
};
var $a9de7ae1f3585c8e$export$89a97afc72a83708 = function(as) {
    return [
        $a9de7ae1f3585c8e$export$2cd8252107eb640b(as),
        $a9de7ae1f3585c8e$export$4c7897fafd92b108(as)
    ];
};
var $a9de7ae1f3585c8e$export$571d59b505e6bb4e = function(as) {
    return $a9de7ae1f3585c8e$export$9288e031f1846591(as.slice());
};
function $a9de7ae1f3585c8e$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $a9de7ae1f3585c8e$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $a9de7ae1f3585c8e$export$66c1ae025e96b4bc = function(as) {
    return as.length === 1 ? as : $a9de7ae1f3585c8e$var$__spreadArray([
        $a9de7ae1f3585c8e$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $a9de7ae1f3585c8e$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return $a9de7ae1f3585c8e$export$6e22c362a0406a2c;
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $a9de7ae1f3585c8e$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($9sd2T.has.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $a9de7ae1f3585c8e$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length === 1 ? as : as.slice().sort(O.compare);
    };
};
var $a9de7ae1f3585c8e$export$b6d8713d53419d4c = function(i, a) {
    return $a9de7ae1f3585c8e$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $a9de7ae1f3585c8e$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $a9de7ae1f3585c8e$export$2fde0b1c54fc39b9(i, as) ? $9sd2T.none : $9sd2T.some($a9de7ae1f3585c8e$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $a9de7ae1f3585c8e$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $a9de7ae1f3585c8e$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $a9de7ae1f3585c8e$export$8901015135f2fb22(bs, as);
    };
    return $a9de7ae1f3585c8e$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $a9de7ae1f3585c8e$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $a9de7ae1f3585c8e$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $a9de7ae1f3585c8e$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $a9de7ae1f3585c8e$export$c01875f616615628(as);
        return $a9de7ae1f3585c8e$export$a978c53b4062a525(rest) ? (0, $lWM6H.pipe)(rest, $a9de7ae1f3585c8e$export$849c7567cbd62acc(middle), $a9de7ae1f3585c8e$export$68159836694e22c1($a9de7ae1f3585c8e$export$5fd5031fecdacec3(as))) : as;
    };
};
var $a9de7ae1f3585c8e$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $9sd2T.fromReadonlyNonEmptyArray(f(0, $a9de7ae1f3585c8e$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $a9de7ae1f3585c8e$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($a9de7ae1f3585c8e$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $a9de7ae1f3585c8e$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            as,
            $a9de7ae1f3585c8e$export$6e22c362a0406a2c
        ] : [
            (0, $lWM6H.pipe)(as.slice(1, m), $a9de7ae1f3585c8e$export$68159836694e22c1($a9de7ae1f3585c8e$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $a9de7ae1f3585c8e$export$2f0184d5df52135f = function(n) {
    return $a9de7ae1f3585c8e$export$433fe05b12ba833f($a9de7ae1f3585c8e$export$b0d75975ac0be0e1(n));
};
var $a9de7ae1f3585c8e$var$_map = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $a9de7ae1f3585c8e$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $a9de7ae1f3585c8e$var$_mapWithIndex = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $a9de7ae1f3585c8e$export$8f07ddce13659f50(f));
};
var $a9de7ae1f3585c8e$var$_ap = function(fab, fa) {
    return (0, $lWM6H.pipe)(fab, $a9de7ae1f3585c8e$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $a9de7ae1f3585c8e$var$_extend = function(wa, f) {
    return (0, $lWM6H.pipe)(wa, $a9de7ae1f3585c8e$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $a9de7ae1f3585c8e$var$_reduce = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $a9de7ae1f3585c8e$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $a9de7ae1f3585c8e$var$_foldMap = function(M) {
    var foldMapM = $a9de7ae1f3585c8e$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $lWM6H.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $a9de7ae1f3585c8e$var$_reduceRight = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $a9de7ae1f3585c8e$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $a9de7ae1f3585c8e$var$_traverse = function(F) {
    var traverseF = $a9de7ae1f3585c8e$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $lWM6H.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $a9de7ae1f3585c8e$var$_alt = function(fa, that) {
    return (0, $lWM6H.pipe)(fa, $a9de7ae1f3585c8e$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $a9de7ae1f3585c8e$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $a9de7ae1f3585c8e$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $a9de7ae1f3585c8e$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $a9de7ae1f3585c8e$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $lWM6H.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $a9de7ae1f3585c8e$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $a9de7ae1f3585c8e$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $a9de7ae1f3585c8e$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $a9de7ae1f3585c8e$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $lWM6H.pipe)(ta, traverseWithIndexF(f));
    };
};
var $a9de7ae1f3585c8e$export$ba255e9e49e00608 = $9sd2T.singleton;
var $a9de7ae1f3585c8e$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $lWM6H.pipe)(as, $a9de7ae1f3585c8e$export$c8c959650bbe80e2(that()));
    };
};
var $a9de7ae1f3585c8e$export$228be17d80722ab = $a9de7ae1f3585c8e$export$1517cca7889d6aaa;
var $a9de7ae1f3585c8e$export$2f6ca3d3b1f80bf5 = function(as) {
    return $a9de7ae1f3585c8e$export$5b8affa63fc6df16(function(f) {
        return (0, $lWM6H.pipe)(as, $a9de7ae1f3585c8e$export$871de8747c9eaa88(f));
    });
};
var $a9de7ae1f3585c8e$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $lWM6H.dual)(2, function(ma, f) {
    return (0, $lWM6H.pipe)(ma, $a9de7ae1f3585c8e$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $a9de7ae1f3585c8e$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $a9de7ae1f3585c8e$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($a9de7ae1f3585c8e$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $a9de7ae1f3585c8e$export$c01875f616615628(next);
        }
        return out;
    };
};
var $a9de7ae1f3585c8e$export$ecd5e8ace626722c = /*#__PURE__*/ $a9de7ae1f3585c8e$export$8b58be045bf06082((0, $lWM6H.identity));
var $a9de7ae1f3585c8e$export$bffa455ba8c619a6 = /*#__PURE__*/ $a9de7ae1f3585c8e$export$5b8affa63fc6df16((0, $lWM6H.identity));
var $a9de7ae1f3585c8e$export$871de8747c9eaa88 = function(f) {
    return $a9de7ae1f3585c8e$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $a9de7ae1f3585c8e$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $a9de7ae1f3585c8e$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $a9de7ae1f3585c8e$export$533b26079ad0b4b = function(b, f) {
    return $a9de7ae1f3585c8e$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $a9de7ae1f3585c8e$export$b66cdc0497d8a99a = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a) {
                return S.concat(s, f(a));
            }, f(as[0]));
        };
    };
};
var $a9de7ae1f3585c8e$export$7fef8bcdbb34f435 = function(b, f) {
    return $a9de7ae1f3585c8e$export$ce2b2fe0b88ccd0a(b, function(_, b, a) {
        return f(b, a);
    });
};
var $a9de7ae1f3585c8e$export$bbd3ef8720e22369 = function(b, f) {
    return function(as) {
        return as.reduce(function(b, a, i) {
            return f(i, b, a);
        }, b);
    };
};
var $a9de7ae1f3585c8e$export$18153bb1181268e5 = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a, i) {
                return S.concat(s, f(i + 1, a));
            }, f(0, as[0]));
        };
    };
};
var $a9de7ae1f3585c8e$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(as) {
        return as.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $a9de7ae1f3585c8e$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $a9de7ae1f3585c8e$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $a9de7ae1f3585c8e$export$49bb65c2ea163039 = function(F) {
    return $a9de7ae1f3585c8e$export$955fdc0d24efa249(F)((0, $lWM6H.SK));
};
var $a9de7ae1f3585c8e$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $a9de7ae1f3585c8e$export$5fd5031fecdacec3(as)), $a9de7ae1f3585c8e$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $lWM6H.pipe)(bs, $a9de7ae1f3585c8e$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $a9de7ae1f3585c8e$export$f9380c9a627682d3 = $9sd2T.head;
var $a9de7ae1f3585c8e$export$9156e739aa33e19f = 'ReadonlyNonEmptyArray';
var $a9de7ae1f3585c8e$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $a9de7ae1f3585c8e$export$e759a9a7f8d04692 = function() {
    return {
        concat: $a9de7ae1f3585c8e$export$ee1b3e54f0441b22
    };
};
var $a9de7ae1f3585c8e$export$804fed467fde44e4 = function(E) {
    return (0, $bOO3o.fromEquals)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $a9de7ae1f3585c8e$export$baca17b4aff42f82 = function(E) {
    var unionE = $a9de7ae1f3585c8e$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $a9de7ae1f3585c8e$export$bd5b6bfc5fa2ee61 = {
    URI: $a9de7ae1f3585c8e$export$9156e739aa33e19f,
    map: $a9de7ae1f3585c8e$var$_map
};
var $a9de7ae1f3585c8e$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $gnzaQ.flap)($a9de7ae1f3585c8e$export$bd5b6bfc5fa2ee61);
var $a9de7ae1f3585c8e$export$59a71046037e6c20 = {
    URI: $a9de7ae1f3585c8e$export$9156e739aa33e19f,
    of: $a9de7ae1f3585c8e$export$ba255e9e49e00608
};
var $a9de7ae1f3585c8e$export$9fdffe0fe1e91cad = {
    URI: $a9de7ae1f3585c8e$export$9156e739aa33e19f,
    map: $a9de7ae1f3585c8e$var$_map,
    mapWithIndex: $a9de7ae1f3585c8e$var$_mapWithIndex
};
var $a9de7ae1f3585c8e$export$efc21ddc6aeb363d = {
    URI: $a9de7ae1f3585c8e$export$9156e739aa33e19f,
    map: $a9de7ae1f3585c8e$var$_map,
    ap: $a9de7ae1f3585c8e$var$_ap
};
var $a9de7ae1f3585c8e$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $4AIBj.apFirst)($a9de7ae1f3585c8e$export$efc21ddc6aeb363d);
var $a9de7ae1f3585c8e$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $4AIBj.apSecond)($a9de7ae1f3585c8e$export$efc21ddc6aeb363d);
var $a9de7ae1f3585c8e$export$1279d2b7807629fd = {
    URI: $a9de7ae1f3585c8e$export$9156e739aa33e19f,
    map: $a9de7ae1f3585c8e$var$_map,
    ap: $a9de7ae1f3585c8e$var$_ap,
    of: $a9de7ae1f3585c8e$export$ba255e9e49e00608
};
var $a9de7ae1f3585c8e$export$f18d5acc27d70423 = {
    URI: $a9de7ae1f3585c8e$export$9156e739aa33e19f,
    map: $a9de7ae1f3585c8e$var$_map,
    ap: $a9de7ae1f3585c8e$var$_ap,
    chain: $a9de7ae1f3585c8e$export$5b8affa63fc6df16
};
var $a9de7ae1f3585c8e$export$e3821ef4970c339c = /*#__PURE__*/ (0, $iXLA9.chainFirst)($a9de7ae1f3585c8e$export$f18d5acc27d70423);
var $a9de7ae1f3585c8e$export$fb641926d034ac7d = {
    URI: $a9de7ae1f3585c8e$export$9156e739aa33e19f,
    map: $a9de7ae1f3585c8e$var$_map,
    ap: $a9de7ae1f3585c8e$var$_ap,
    of: $a9de7ae1f3585c8e$export$ba255e9e49e00608,
    chain: $a9de7ae1f3585c8e$export$5b8affa63fc6df16
};
var $a9de7ae1f3585c8e$export$41404b31838667c9 = {
    URI: $a9de7ae1f3585c8e$export$9156e739aa33e19f,
    reduce: $a9de7ae1f3585c8e$var$_reduce,
    foldMap: $a9de7ae1f3585c8e$var$_foldMap,
    reduceRight: $a9de7ae1f3585c8e$var$_reduceRight
};
var $a9de7ae1f3585c8e$export$e8f7d17aaff345cb = {
    URI: $a9de7ae1f3585c8e$export$9156e739aa33e19f,
    reduce: $a9de7ae1f3585c8e$var$_reduce,
    foldMap: $a9de7ae1f3585c8e$var$_foldMap,
    reduceRight: $a9de7ae1f3585c8e$var$_reduceRight,
    reduceWithIndex: $a9de7ae1f3585c8e$var$_reduceWithIndex,
    foldMapWithIndex: $a9de7ae1f3585c8e$var$_foldMapWithIndex,
    reduceRightWithIndex: $a9de7ae1f3585c8e$var$_reduceRightWithIndex
};
var $a9de7ae1f3585c8e$export$a0202666c3bda011 = {
    URI: $a9de7ae1f3585c8e$export$9156e739aa33e19f,
    map: $a9de7ae1f3585c8e$var$_map,
    reduce: $a9de7ae1f3585c8e$var$_reduce,
    foldMap: $a9de7ae1f3585c8e$var$_foldMap,
    reduceRight: $a9de7ae1f3585c8e$var$_reduceRight,
    traverse: $a9de7ae1f3585c8e$var$_traverse,
    sequence: $a9de7ae1f3585c8e$export$49bb65c2ea163039
};
var $a9de7ae1f3585c8e$export$bd7b528d8c36ec41 = {
    URI: $a9de7ae1f3585c8e$export$9156e739aa33e19f,
    map: $a9de7ae1f3585c8e$var$_map,
    mapWithIndex: $a9de7ae1f3585c8e$var$_mapWithIndex,
    reduce: $a9de7ae1f3585c8e$var$_reduce,
    foldMap: $a9de7ae1f3585c8e$var$_foldMap,
    reduceRight: $a9de7ae1f3585c8e$var$_reduceRight,
    traverse: $a9de7ae1f3585c8e$var$_traverse,
    sequence: $a9de7ae1f3585c8e$export$49bb65c2ea163039,
    reduceWithIndex: $a9de7ae1f3585c8e$var$_reduceWithIndex,
    foldMapWithIndex: $a9de7ae1f3585c8e$var$_foldMapWithIndex,
    reduceRightWithIndex: $a9de7ae1f3585c8e$var$_reduceRightWithIndex,
    traverseWithIndex: $a9de7ae1f3585c8e$var$_traverseWithIndex
};
var $a9de7ae1f3585c8e$export$25ba4469a069167 = {
    URI: $a9de7ae1f3585c8e$export$9156e739aa33e19f,
    map: $a9de7ae1f3585c8e$var$_map,
    alt: $a9de7ae1f3585c8e$var$_alt
};
var $a9de7ae1f3585c8e$export$fdd73124b9f1de36 = {
    URI: $a9de7ae1f3585c8e$export$9156e739aa33e19f,
    map: $a9de7ae1f3585c8e$var$_map,
    extend: $a9de7ae1f3585c8e$var$_extend,
    extract: $a9de7ae1f3585c8e$export$f9380c9a627682d3
};
var $a9de7ae1f3585c8e$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $a9de7ae1f3585c8e$export$ba255e9e49e00608($9sd2T.emptyRecord);
var $a9de7ae1f3585c8e$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $gnzaQ.bindTo)($a9de7ae1f3585c8e$export$bd5b6bfc5fa2ee61);
var $a9de7ae1f3585c8e$export$5d537b797c421217 = /*#__PURE__*/ (0, $gnzaQ.let)($a9de7ae1f3585c8e$export$bd5b6bfc5fa2ee61);
var $a9de7ae1f3585c8e$export$2385a24977818dd0 = /*#__PURE__*/ (0, $iXLA9.bind)($a9de7ae1f3585c8e$export$f18d5acc27d70423);
var $a9de7ae1f3585c8e$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $4AIBj.apS)($a9de7ae1f3585c8e$export$efc21ddc6aeb363d);
var $a9de7ae1f3585c8e$export$5fd5031fecdacec3 = $a9de7ae1f3585c8e$export$f9380c9a627682d3;
var $a9de7ae1f3585c8e$export$c01875f616615628 = $9sd2T.tail;
var $a9de7ae1f3585c8e$export$4c7897fafd92b108 = function(as) {
    return as[as.length - 1];
};
var $a9de7ae1f3585c8e$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $a9de7ae1f3585c8e$export$96ec731ed4dcb222 = function(O) {
    var S = $iIsEa.min(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $a9de7ae1f3585c8e$export$8960430cfd85939f = function(O) {
    var S = $iIsEa.max(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $a9de7ae1f3585c8e$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $a9de7ae1f3585c8e$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($a9de7ae1f3585c8e$export$5fd5031fecdacec3(as), $a9de7ae1f3585c8e$export$c01875f616615628(as));
    };
};
var $a9de7ae1f3585c8e$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($a9de7ae1f3585c8e$export$2cd8252107eb640b(as), $a9de7ae1f3585c8e$export$4c7897fafd92b108(as));
    };
};
var $a9de7ae1f3585c8e$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $a9de7ae1f3585c8e$var$__spreadArray([
            f($a9de7ae1f3585c8e$export$5fd5031fecdacec3(as))
        ], $a9de7ae1f3585c8e$export$c01875f616615628(as), true);
    };
};
var $a9de7ae1f3585c8e$export$20ca6ad9f7762931 = function(a) {
    return $a9de7ae1f3585c8e$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $a9de7ae1f3585c8e$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $lWM6H.pipe)($a9de7ae1f3585c8e$export$2cd8252107eb640b(as), $a9de7ae1f3585c8e$export$10d8903dec122b9d(f($a9de7ae1f3585c8e$export$4c7897fafd92b108(as))));
    };
};
var $a9de7ae1f3585c8e$export$d3affa0a0a83d946 = function(a) {
    return $a9de7ae1f3585c8e$export$302ad361c463800a(function() {
        return a;
    });
};
var $a9de7ae1f3585c8e$export$739ec22334c44788 = function(S) {
    var concatAllS = $a9de7ae1f3585c8e$export$b314777ae20abca9(S);
    return function(middle) {
        return (0, $lWM6H.flow)($a9de7ae1f3585c8e$export$af200dcf8b7cb5de(middle), concatAllS);
    };
};
var $a9de7ae1f3585c8e$export$e08e3b67e392101e = $a9de7ae1f3585c8e$export$5b8affa63fc6df16;
function $a9de7ae1f3585c8e$export$103ce2c0a67e4e61(O) {
    var sortO = $a9de7ae1f3585c8e$export$97db5808d8f88186(O);
    var groupO = $a9de7ae1f3585c8e$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $a9de7ae1f3585c8e$export$a978c53b4062a525(as) ? groupO(sortO(as)) : $a9de7ae1f3585c8e$export$6e22c362a0406a2c;
    };
}
function $a9de7ae1f3585c8e$export$3dea766d36a8935f(predicate) {
    return $a9de7ae1f3585c8e$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $a9de7ae1f3585c8e$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $a9de7ae1f3585c8e$export$9288e031f1846591(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $a9de7ae1f3585c8e$export$b446f6baa3bb1430 = $a9de7ae1f3585c8e$export$c04edabe9c8d994f;
var $a9de7ae1f3585c8e$export$712962e076096ed4 = $a9de7ae1f3585c8e$export$89a97afc72a83708;
function $a9de7ae1f3585c8e$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $a9de7ae1f3585c8e$export$68159836694e22c1(head) : (0, $lWM6H.pipe)(tail, $a9de7ae1f3585c8e$export$68159836694e22c1(head));
}
var $a9de7ae1f3585c8e$export$c40cf5aab899f397 = function(init, end) {
    return (0, $lWM6H.pipe)(init, $a9de7ae1f3585c8e$export$ee1b3e54f0441b22([
        end
    ]));
};
var $a9de7ae1f3585c8e$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $9sd2T.none : $9sd2T.some($a9de7ae1f3585c8e$export$f4863e1822a1860c(i, a, as));
    };
};
var $a9de7ae1f3585c8e$export$baeb00bf1e27e233 = $a9de7ae1f3585c8e$export$849c7567cbd62acc;
var $a9de7ae1f3585c8e$export$93e2b83da34ff82a = $a9de7ae1f3585c8e$export$b314777ae20abca9;
var $a9de7ae1f3585c8e$export$3c6c57333e3dca24 = {
    URI: $a9de7ae1f3585c8e$export$9156e739aa33e19f,
    of: $a9de7ae1f3585c8e$export$ba255e9e49e00608,
    map: $a9de7ae1f3585c8e$var$_map,
    mapWithIndex: $a9de7ae1f3585c8e$var$_mapWithIndex,
    ap: $a9de7ae1f3585c8e$var$_ap,
    chain: $a9de7ae1f3585c8e$export$5b8affa63fc6df16,
    extend: $a9de7ae1f3585c8e$var$_extend,
    extract: $a9de7ae1f3585c8e$export$f9380c9a627682d3,
    reduce: $a9de7ae1f3585c8e$var$_reduce,
    foldMap: $a9de7ae1f3585c8e$var$_foldMap,
    reduceRight: $a9de7ae1f3585c8e$var$_reduceRight,
    traverse: $a9de7ae1f3585c8e$var$_traverse,
    sequence: $a9de7ae1f3585c8e$export$49bb65c2ea163039,
    reduceWithIndex: $a9de7ae1f3585c8e$var$_reduceWithIndex,
    foldMapWithIndex: $a9de7ae1f3585c8e$var$_foldMapWithIndex,
    reduceRightWithIndex: $a9de7ae1f3585c8e$var$_reduceRightWithIndex,
    traverseWithIndex: $a9de7ae1f3585c8e$var$_traverseWithIndex,
    alt: $a9de7ae1f3585c8e$var$_alt
};

});
parcelRegister("iIsEa", function(module, exports) {

$parcel$export(module.exports, "min", () => $da028eb84c171b30$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $da028eb84c171b30$export$8960430cfd85939f);
$parcel$export(module.exports, "constant", () => $da028eb84c171b30$export$c983f826f44ff86);
$parcel$export(module.exports, "reverse", () => $da028eb84c171b30$export$66c1ae025e96b4bc);
$parcel$export(module.exports, "struct", () => $da028eb84c171b30$export$8cf3da7c1c9174ea);
$parcel$export(module.exports, "tuple", () => $da028eb84c171b30$export$65e3907585753458);
$parcel$export(module.exports, "intercalate", () => $da028eb84c171b30$export$739ec22334c44788);
$parcel$export(module.exports, "first", () => $da028eb84c171b30$export$43128fadae87b74a);
$parcel$export(module.exports, "last", () => $da028eb84c171b30$export$4c7897fafd92b108);
$parcel$export(module.exports, "concatAll", () => $da028eb84c171b30$export$b314777ae20abca9);
$parcel$export(module.exports, "semigroupVoid", () => $da028eb84c171b30$export$36aabcd6b6e45f3b);
$parcel$export(module.exports, "getObjectSemigroup", () => $da028eb84c171b30$export$2f965793fef2fb8a);
$parcel$export(module.exports, "getLastSemigroup", () => $da028eb84c171b30$export$edb0acd3f464ffc5);
$parcel$export(module.exports, "getFirstSemigroup", () => $da028eb84c171b30$export$84a57d7a8bf6c3ea);
$parcel$export(module.exports, "getTupleSemigroup", () => $da028eb84c171b30$export$bd94daf2735ef9c);
$parcel$export(module.exports, "getStructSemigroup", () => $da028eb84c171b30$export$98d1814f8ed74e13);
$parcel$export(module.exports, "getDualSemigroup", () => $da028eb84c171b30$export$e0cea6c43ec66a1);
$parcel$export(module.exports, "getJoinSemigroup", () => $da028eb84c171b30$export$4278e54cd9769e6d);
$parcel$export(module.exports, "getMeetSemigroup", () => $da028eb84c171b30$export$7baccd77d16d1a41);
$parcel$export(module.exports, "getIntercalateSemigroup", () => $da028eb84c171b30$export$fcc2cca196b2daf0);
$parcel$export(module.exports, "fold", () => $da028eb84c171b30$export$93e2b83da34ff82a);
$parcel$export(module.exports, "semigroupAll", () => $da028eb84c171b30$export$e8f9875ab703bdff);
$parcel$export(module.exports, "semigroupAny", () => $da028eb84c171b30$export$9511aba5be5ac81b);
$parcel$export(module.exports, "getFunctionSemigroup", () => $da028eb84c171b30$export$b2ecf5de014857c2);
$parcel$export(module.exports, "semigroupString", () => $da028eb84c171b30$export$d9b7100b101f2c5b);
$parcel$export(module.exports, "semigroupSum", () => $da028eb84c171b30$export$1481126044ad2de0);
$parcel$export(module.exports, "semigroupProduct", () => $da028eb84c171b30$export$a22a2283cc3aa839);
/**
 * If a type `A` can form a `Semigroup` it has an **associative** binary operation.
 *
 * ```ts
 * interface Semigroup<A> {
 *   readonly concat: (x: A, y: A) => A
 * }
 * ```
 *
 * Associativity means the following equality must hold for any choice of `x`, `y`, and `z`.
 *
 * ```ts
 * concat(x, concat(y, z)) = concat(concat(x, y), z)
 * ```
 *
 * A common example of a semigroup is the type `string` with the operation `+`.
 *
 * ```ts
 * import { Semigroup } from 'fp-ts/Semigroup'
 *
 * const semigroupString: Semigroup<string> = {
 *   concat: (x, y) => x + y
 * }
 *
 * const x = 'x'
 * const y = 'y'
 * const z = 'z'
 *
 * semigroupString.concat(x, y) // 'xy'
 *
 * semigroupString.concat(x, semigroupString.concat(y, z)) // 'xyz'
 *
 * semigroupString.concat(semigroupString.concat(x, y), z) // 'xyz'
 * ```
 *
 * *Adapted from https://typelevel.org/cats*
 *
 * @since 2.0.0
 */ 
var $lWM6H = parcelRequire("lWM6H");

var $9sd2T = parcelRequire("9sd2T");

var $kmc7w = parcelRequire("kmc7w");

var $4uWSF = parcelRequire("4uWSF");
var $da028eb84c171b30$export$96ec731ed4dcb222 = function(O) {
    return {
        concat: $4uWSF.min(O)
    };
};
var $da028eb84c171b30$export$8960430cfd85939f = function(O) {
    return {
        concat: $4uWSF.max(O)
    };
};
var $da028eb84c171b30$export$c983f826f44ff86 = function(a) {
    return {
        concat: function() {
            return a;
        }
    };
};
var $da028eb84c171b30$export$66c1ae025e96b4bc = $kmc7w.reverse;
var $da028eb84c171b30$export$8cf3da7c1c9174ea = function(semigroups) {
    return {
        concat: function(first, second) {
            var r = {};
            for(var k in semigroups)if ($9sd2T.has.call(semigroups, k)) r[k] = semigroups[k].concat(first[k], second[k]);
            return r;
        }
    };
};
var $da028eb84c171b30$export$65e3907585753458 = function() {
    var semigroups = [];
    for(var _i = 0; _i < arguments.length; _i++)semigroups[_i] = arguments[_i];
    return {
        concat: function(first, second) {
            return semigroups.map(function(s, i) {
                return s.concat(first[i], second[i]);
            });
        }
    };
};
var $da028eb84c171b30$export$739ec22334c44788 = function(middle) {
    return function(S) {
        return {
            concat: function(x, y) {
                return S.concat(x, S.concat(middle, y));
            }
        };
    };
};
var $da028eb84c171b30$export$43128fadae87b74a = function() {
    return {
        concat: (0, $lWM6H.identity)
    };
};
var $da028eb84c171b30$export$4c7897fafd92b108 = function() {
    return {
        concat: function(_, y) {
            return y;
        }
    };
};
var $da028eb84c171b30$export$b314777ae20abca9 = $kmc7w.concatAll;
var $da028eb84c171b30$export$36aabcd6b6e45f3b = $da028eb84c171b30$export$c983f826f44ff86(undefined);
var $da028eb84c171b30$export$2f965793fef2fb8a = function() {
    return {
        concat: function(first, second) {
            return Object.assign({}, first, second);
        }
    };
};
var $da028eb84c171b30$export$edb0acd3f464ffc5 = $da028eb84c171b30$export$4c7897fafd92b108;
var $da028eb84c171b30$export$84a57d7a8bf6c3ea = $da028eb84c171b30$export$43128fadae87b74a;
var $da028eb84c171b30$export$bd94daf2735ef9c = $da028eb84c171b30$export$65e3907585753458;
var $da028eb84c171b30$export$98d1814f8ed74e13 = $da028eb84c171b30$export$8cf3da7c1c9174ea;
var $da028eb84c171b30$export$e0cea6c43ec66a1 = $da028eb84c171b30$export$66c1ae025e96b4bc;
var $da028eb84c171b30$export$4278e54cd9769e6d = $da028eb84c171b30$export$8960430cfd85939f;
var $da028eb84c171b30$export$7baccd77d16d1a41 = $da028eb84c171b30$export$96ec731ed4dcb222;
var $da028eb84c171b30$export$fcc2cca196b2daf0 = $da028eb84c171b30$export$739ec22334c44788;
function $da028eb84c171b30$export$93e2b83da34ff82a(S) {
    var concatAllS = $da028eb84c171b30$export$b314777ae20abca9(S);
    return function(startWith, as) {
        return as === undefined ? concatAllS(startWith) : concatAllS(startWith)(as);
    };
}
var $da028eb84c171b30$export$e8f9875ab703bdff = {
    concat: function(x, y) {
        return x && y;
    }
};
var $da028eb84c171b30$export$9511aba5be5ac81b = {
    concat: function(x, y) {
        return x || y;
    }
};
var $da028eb84c171b30$export$b2ecf5de014857c2 = (0, $lWM6H.getSemigroup);
var $da028eb84c171b30$export$d9b7100b101f2c5b = {
    concat: function(x, y) {
        return x + y;
    }
};
var $da028eb84c171b30$export$1481126044ad2de0 = {
    concat: function(x, y) {
        return x + y;
    }
};
var $da028eb84c171b30$export$a22a2283cc3aa839 = {
    concat: function(x, y) {
        return x * y;
    }
};

});
parcelRegister("kmc7w", function(module, exports) {

$parcel$export(module.exports, "reverse", () => $ed1f4396f0f34032$export$66c1ae025e96b4bc);
$parcel$export(module.exports, "concatAll", () => $ed1f4396f0f34032$export$b314777ae20abca9);
/**
 * A `Magma` is a pair `(A, concat)` in which `A` is a non-empty set and `concat` is a binary operation on `A`
 *
 * See [Semigroup](https://gcanti.github.io/fp-ts/modules/Semigroup.ts.html) for some instances.
 *
 * @since 2.0.0
 */ // -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Magma`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse, concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(reverse(N.MagmaSub))(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), 2)
 *
 * @since 2.11.0
 */ var $ed1f4396f0f34032$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: function(first, second) {
            return M.concat(second, first);
        }
    };
};
var $ed1f4396f0f34032$export$33379f09626d85d4 = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(first) ? M.concat(first, second) : second;
            }
        };
    };
};
var $ed1f4396f0f34032$export$dfdff08f074d9f6c = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(second) ? M.concat(first, second) : first;
            }
        };
    };
};
var $ed1f4396f0f34032$export$235e42f0cd5f5e93 = function(f) {
    return function(M) {
        return {
            concat: function(first, second) {
                return M.concat(f(first), f(second));
            }
        };
    };
};
var $ed1f4396f0f34032$export$b314777ae20abca9 = function(M) {
    return function(startWith) {
        return function(as) {
            return as.reduce(function(a, acc) {
                return M.concat(a, acc);
            }, startWith);
        };
    };
};

});




parcelRegister("iLEkM", function(module, exports) {

$parcel$export(module.exports, "lookup", () => $da9be747d52ca156$export$dfc7155ac0343b8);
$parcel$export(module.exports, "head", () => $da9be747d52ca156$export$5fd5031fecdacec3);
$parcel$export(module.exports, "last", () => $da9be747d52ca156$export$4c7897fafd92b108);
$parcel$export(module.exports, "findIndex", () => $da9be747d52ca156$export$de3a4d4a0d731119);
$parcel$export(module.exports, "findFirst", () => $da9be747d52ca156$export$9a2f228bed5035c2);
$parcel$export(module.exports, "findFirstMap", () => $da9be747d52ca156$export$a86c11c94d794a95);
$parcel$export(module.exports, "findLast", () => $da9be747d52ca156$export$296de88ccac4bedb);
$parcel$export(module.exports, "findLastMap", () => $da9be747d52ca156$export$8b5e6d6ad82284fa);
$parcel$export(module.exports, "findLastIndex", () => $da9be747d52ca156$export$8855a8be7bd3e9f8);
$parcel$export(module.exports, "unsafeUpdateAt", () => $da9be747d52ca156$export$9c0c6889b1fa9bfc);
$parcel$export(module.exports, "elem", () => $da9be747d52ca156$export$5bf96401662340b7);
$parcel$export(module.exports, "reduce", () => $da9be747d52ca156$export$533b26079ad0b4b);
$parcel$export(module.exports, "foldMap", () => $da9be747d52ca156$export$b66cdc0497d8a99a);
$parcel$export(module.exports, "reduceRight", () => $da9be747d52ca156$export$7fef8bcdbb34f435);
$parcel$export(module.exports, "reduceWithIndex", () => $da9be747d52ca156$export$bbd3ef8720e22369);
$parcel$export(module.exports, "foldMapWithIndex", () => $da9be747d52ca156$export$18153bb1181268e5);
$parcel$export(module.exports, "reduceRightWithIndex", () => $da9be747d52ca156$export$ce2b2fe0b88ccd0a);
$parcel$export(module.exports, "_chainRecDepthFirst", () => $da9be747d52ca156$export$c5c44f872d8af73);
$parcel$export(module.exports, "chainRecDepthFirst", () => $da9be747d52ca156$export$f855115a79f70c1a);
$parcel$export(module.exports, "_chainRecBreadthFirst", () => $da9be747d52ca156$export$b9909b62ceeab991);
$parcel$export(module.exports, "chainRecBreadthFirst", () => $da9be747d52ca156$export$bffee57bb00a6859);
$parcel$export(module.exports, "of", () => $da9be747d52ca156$export$ba255e9e49e00608);
$parcel$export(module.exports, "getShow", () => $da9be747d52ca156$export$3cb5cd7f7776c81);
$parcel$export(module.exports, "getMonoid", () => $da9be747d52ca156$export$c2a7ef2cc9b32b31);
$parcel$export(module.exports, "getEq", () => $da9be747d52ca156$export$804fed467fde44e4);
$parcel$export(module.exports, "getOrd", () => $da9be747d52ca156$export$1af51209b1b91d07);
$parcel$export(module.exports, "every", () => $da9be747d52ca156$export$7ecc1a3b11b57dab);
$parcel$export(module.exports, "intercalate", () => $da9be747d52ca156$export$739ec22334c44788);

var $4AIBj = parcelRequire("4AIBj");

var $iXLA9 = parcelRequire("iXLA9");

var $bOO3o = parcelRequire("bOO3o");

var $coJMz = parcelRequire("coJMz");

var $lWM6H = parcelRequire("lWM6H");

var $gnzaQ = parcelRequire("gnzaQ");

var $9sd2T = parcelRequire("9sd2T");

var $jmbk9 = parcelRequire("jmbk9");

var $4uWSF = parcelRequire("4uWSF");

var $eAcXw = parcelRequire("eAcXw");

var $fYAej = parcelRequire("fYAej");

var $loyJ7 = parcelRequire("loyJ7");

var $l7120 = parcelRequire("l7120");
var $da9be747d52ca156$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $da9be747d52ca156$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $da9be747d52ca156$export$a978c53b4062a525 = $eAcXw.isNonEmpty;
var $da9be747d52ca156$export$68159836694e22c1 = $eAcXw.prepend;
var $da9be747d52ca156$export$c4c4d41eab625797 = $eAcXw.prependW;
var $da9be747d52ca156$export$10d8903dec122b9d = $eAcXw.append;
var $da9be747d52ca156$export$19903a1bf1942f6 = $eAcXw.appendW;
var $da9be747d52ca156$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? $da9be747d52ca156$export$6e22c362a0406a2c : $eAcXw.makeBy(f)(n);
};
var $da9be747d52ca156$export$606959e7ccb797f0 = function(n, a) {
    return $da9be747d52ca156$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $da9be747d52ca156$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : $da9be747d52ca156$export$6e22c362a0406a2c;
    };
}
var $da9be747d52ca156$export$172ec0a6ebfeb6fa = function(ma) {
    return $9sd2T.isNone(ma) ? $da9be747d52ca156$export$6e22c362a0406a2c : [
        ma.value
    ];
};
var $da9be747d52ca156$export$80c878c9b1d77917 = function(e) {
    return $9sd2T.isLeft(e) ? $da9be747d52ca156$export$6e22c362a0406a2c : [
        e.right
    ];
};
var $da9be747d52ca156$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $da9be747d52ca156$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $da9be747d52ca156$export$4659b591c19bdf3d = $da9be747d52ca156$export$2d55ea551c238330;
var $da9be747d52ca156$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $da9be747d52ca156$export$a978c53b4062a525(as) ? onNonEmpty($eAcXw.head(as), $eAcXw.tail(as)) : onEmpty();
    };
};
var $da9be747d52ca156$export$6280271dfaec4919 = $da9be747d52ca156$export$ebbe93aa91e3abdc;
var $da9be747d52ca156$export$f3163a37d0ef5927 = $da9be747d52ca156$export$6280271dfaec4919;
var $da9be747d52ca156$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $da9be747d52ca156$export$a978c53b4062a525(as) ? onNonEmpty($eAcXw.init(as), $eAcXw.last(as)) : onEmpty();
    };
};
var $da9be747d52ca156$export$b1cacb83a5c6bd02 = $da9be747d52ca156$export$364f7f2cc8473008;
var $da9be747d52ca156$export$77fa89c00b331c4c = $da9be747d52ca156$export$b1cacb83a5c6bd02;
var $da9be747d52ca156$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        if ($da9be747d52ca156$export$dd1bc94b04021eeb(as)) return $da9be747d52ca156$export$6e22c362a0406a2c;
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $da9be747d52ca156$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $da9be747d52ca156$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $da9be747d52ca156$export$346677f925de839c = function(as) {
    return as.length;
};
var $da9be747d52ca156$export$2fde0b1c54fc39b9 = $eAcXw.isOutOfBound;
function $da9be747d52ca156$export$dfc7155ac0343b8(i, as) {
    return as === undefined ? function(as) {
        return $da9be747d52ca156$export$dfc7155ac0343b8(i, as);
    } : $da9be747d52ca156$export$2fde0b1c54fc39b9(i, as) ? $9sd2T.none : $9sd2T.some(as[i]);
}
var $da9be747d52ca156$export$5fd5031fecdacec3 = function(as) {
    return $da9be747d52ca156$export$a978c53b4062a525(as) ? $9sd2T.some($eAcXw.head(as)) : $9sd2T.none;
};
var $da9be747d52ca156$export$4c7897fafd92b108 = function(as) {
    return $da9be747d52ca156$export$a978c53b4062a525(as) ? $9sd2T.some($eAcXw.last(as)) : $9sd2T.none;
};
var $da9be747d52ca156$export$c01875f616615628 = function(as) {
    return $da9be747d52ca156$export$a978c53b4062a525(as) ? $9sd2T.some($eAcXw.tail(as)) : $9sd2T.none;
};
var $da9be747d52ca156$export$2cd8252107eb640b = function(as) {
    return $da9be747d52ca156$export$a978c53b4062a525(as) ? $9sd2T.some($eAcXw.init(as)) : $9sd2T.none;
};
var $da9be747d52ca156$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $da9be747d52ca156$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $da9be747d52ca156$export$6e22c362a0406a2c : as.slice(0, n);
    };
};
var $da9be747d52ca156$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $da9be747d52ca156$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $da9be747d52ca156$export$6e22c362a0406a2c : as.slice(-n);
    };
};
function $da9be747d52ca156$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        var len = out.length;
        return len === as.length ? as : len === 0 ? $da9be747d52ca156$export$6e22c362a0406a2c : out;
    };
}
var $da9be747d52ca156$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $da9be747d52ca156$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $da9be747d52ca156$export$b0d75975ac0be0e1($da9be747d52ca156$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $da9be747d52ca156$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $da9be747d52ca156$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $da9be747d52ca156$export$6e22c362a0406a2c : as.slice(n, as.length);
    };
};
var $da9be747d52ca156$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $da9be747d52ca156$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $da9be747d52ca156$export$6e22c362a0406a2c : as.slice(0, as.length - n);
    };
};
function $da9be747d52ca156$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        var i = $da9be747d52ca156$var$spanLeftIndex(as, predicate);
        return i === 0 ? as : i === as.length ? $da9be747d52ca156$export$6e22c362a0406a2c : as.slice(i);
    };
}
var $da9be747d52ca156$export$de3a4d4a0d731119 = function(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $9sd2T.some(i);
        }
        return $9sd2T.none;
    };
};
function $da9be747d52ca156$export$9a2f228bed5035c2(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $9sd2T.some(as[i]);
        }
        return $9sd2T.none;
    };
}
var $da9be747d52ca156$export$a86c11c94d794a95 = function(f) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            var out = f(as[i]);
            if ($9sd2T.isSome(out)) return out;
        }
        return $9sd2T.none;
    };
};
function $da9be747d52ca156$export$296de88ccac4bedb(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $9sd2T.some(as[i]);
        }
        return $9sd2T.none;
    };
}
var $da9be747d52ca156$export$8b5e6d6ad82284fa = function(f) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            var out = f(as[i]);
            if ($9sd2T.isSome(out)) return out;
        }
        return $9sd2T.none;
    };
};
var $da9be747d52ca156$export$8855a8be7bd3e9f8 = function(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $9sd2T.some(i);
        }
        return $9sd2T.none;
    };
};
var $da9be747d52ca156$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $9sd2T.none : $9sd2T.some($eAcXw.unsafeInsertAt(i, a, as));
    };
};
var $da9be747d52ca156$export$b6d8713d53419d4c = function(i, a) {
    return $da9be747d52ca156$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $da9be747d52ca156$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $da9be747d52ca156$export$2fde0b1c54fc39b9(i, as) ? $9sd2T.none : $9sd2T.some($da9be747d52ca156$export$4937fde8dfc38dbd(i, as));
    };
};
var $da9be747d52ca156$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $da9be747d52ca156$export$2fde0b1c54fc39b9(i, as) ? $9sd2T.none : $9sd2T.some($da9be747d52ca156$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $da9be747d52ca156$export$66c1ae025e96b4bc = function(as) {
    return as.length <= 1 ? as : as.slice().reverse();
};
var $da9be747d52ca156$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $da9be747d52ca156$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $da9be747d52ca156$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? as : as.slice().sort(O.compare);
    };
};
var $da9be747d52ca156$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $da9be747d52ca156$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $da9be747d52ca156$export$8901015135f2fb22(bs, as);
    };
    return $da9be747d52ca156$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $da9be747d52ca156$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $da9be747d52ca156$export$849c7567cbd62acc = function(middle) {
    var f = $eAcXw.prependAll(middle);
    return function(as) {
        return $da9be747d52ca156$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $da9be747d52ca156$export$af200dcf8b7cb5de = function(middle) {
    var f = $eAcXw.intersperse(middle);
    return function(as) {
        return $da9be747d52ca156$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $da9be747d52ca156$export$bb628a54ab399bc9 = function(n) {
    var f = $eAcXw.rotate(n);
    return function(as) {
        return $da9be747d52ca156$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
function $da9be747d52ca156$export$5bf96401662340b7(E) {
    return function(a, as) {
        if (as === undefined) {
            var elemE_1 = $da9be747d52ca156$export$5bf96401662340b7(E);
            return function(as) {
                return elemE_1(a, as);
            };
        }
        var predicate = function(element) {
            return E.equals(element, a);
        };
        var i = 0;
        for(; i < as.length; i++){
            if (predicate(as[i])) return true;
        }
        return false;
    };
}
var $da9be747d52ca156$export$f70730c3d1fc524e = function(E) {
    var f = $eAcXw.uniq(E);
    return function(as) {
        return $da9be747d52ca156$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $da9be747d52ca156$export$b035e44d7bb4278f = function(ords) {
    var f = $eAcXw.sortBy(ords);
    return function(as) {
        return $da9be747d52ca156$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $da9be747d52ca156$export$433fe05b12ba833f = function(f) {
    var g = $eAcXw.chop(f);
    return function(as) {
        return $da9be747d52ca156$export$a978c53b4062a525(as) ? g(as) : $da9be747d52ca156$export$6e22c362a0406a2c;
    };
};
var $da9be747d52ca156$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $da9be747d52ca156$export$a978c53b4062a525(as) ? $eAcXw.splitAt(n)(as) : $da9be747d52ca156$export$dd1bc94b04021eeb(as) ? [
            as,
            $da9be747d52ca156$export$6e22c362a0406a2c
        ] : [
            $da9be747d52ca156$export$6e22c362a0406a2c,
            as
        ];
    };
};
var $da9be747d52ca156$export$2f0184d5df52135f = function(n) {
    var f = $eAcXw.chunksOf(n);
    return function(as) {
        return $da9be747d52ca156$export$a978c53b4062a525(as) ? f(as) : $da9be747d52ca156$export$6e22c362a0406a2c;
    };
};
var $da9be747d52ca156$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $da9be747d52ca156$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $da9be747d52ca156$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $da9be747d52ca156$export$a978c53b4062a525(input) ? $da9be747d52ca156$export$5b8affa63fc6df16($eAcXw.head(input), function(a) {
            return go((0, $lWM6H.pipe)(scope, $da9be747d52ca156$export$10d8903dec122b9d(a)), $eAcXw.tail(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : $da9be747d52ca156$export$6e22c362a0406a2c;
    };
    return go($da9be747d52ca156$export$6e22c362a0406a2c, input);
}
var $da9be747d52ca156$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $da9be747d52ca156$export$dd1bc94b04021eeb(first) ? second : $da9be747d52ca156$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
    };
};
var $da9be747d52ca156$export$ee1b3e54f0441b22 = $da9be747d52ca156$export$c8c959650bbe80e2;
function $da9be747d52ca156$export$971dd5b0dfd021b6(E) {
    var unionE = $eAcXw.union(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $da9be747d52ca156$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $da9be747d52ca156$export$a978c53b4062a525(first) && $da9be747d52ca156$export$a978c53b4062a525(second) ? unionE(second)(first) : $da9be747d52ca156$export$a978c53b4062a525(first) ? first : second;
    };
}
function $da9be747d52ca156$export$bc86dfbf7795668c(E) {
    var elemE = $da9be747d52ca156$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $da9be747d52ca156$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $da9be747d52ca156$export$acaf96a27438246b(E) {
    var elemE = $da9be747d52ca156$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $da9be747d52ca156$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $da9be747d52ca156$var$_map = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$871de8747c9eaa88(f));
};
var $da9be747d52ca156$var$_mapWithIndex = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$8f07ddce13659f50(f));
};
var $da9be747d52ca156$var$_ap = function(fab, fa) {
    return (0, $lWM6H.pipe)(fab, $da9be747d52ca156$export$2f6ca3d3b1f80bf5(fa));
};
var $da9be747d52ca156$var$_filter = function(fa, predicate) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$3dea766d36a8935f(predicate));
};
var $da9be747d52ca156$var$_filterMap = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$a04c6c6965dd4709(f));
};
var $da9be747d52ca156$var$_partition = function(fa, predicate) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$b29f828819edca8d(predicate));
};
var $da9be747d52ca156$var$_partitionMap = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$3117e3f9ececb6bc(f));
};
var $da9be747d52ca156$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $da9be747d52ca156$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$bc7c0794b9c6f3ba(f));
};
var $da9be747d52ca156$var$_alt = function(fa, that) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$228be17d80722ab(that));
};
var $da9be747d52ca156$var$_reduce = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$533b26079ad0b4b(b, f));
};
var $da9be747d52ca156$var$_foldMap = function(M) {
    var foldMapM = $da9be747d52ca156$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $lWM6H.pipe)(fa, foldMapM(f));
    };
};
var $da9be747d52ca156$var$_reduceRight = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$7fef8bcdbb34f435(b, f));
};
var $da9be747d52ca156$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$bbd3ef8720e22369(b, f));
};
var $da9be747d52ca156$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $da9be747d52ca156$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $lWM6H.pipe)(fa, foldMapWithIndexM(f));
    };
};
var $da9be747d52ca156$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$ce2b2fe0b88ccd0a(b, f));
};
var $da9be747d52ca156$var$_filterMapWithIndex = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$30c5cbe848021e97(f));
};
var $da9be747d52ca156$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$36e42aef19fc7171(predicateWithIndex));
};
var $da9be747d52ca156$var$_extend = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$8b58be045bf06082(f));
};
var $da9be747d52ca156$var$_traverse = function(F) {
    var traverseF = $da9be747d52ca156$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $lWM6H.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $da9be747d52ca156$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $da9be747d52ca156$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $lWM6H.pipe)(ta, traverseWithIndexF(f));
    };
};
var $da9be747d52ca156$export$c5c44f872d8af73 = function(a, f) {
    return (0, $lWM6H.pipe)(a, $da9be747d52ca156$export$f855115a79f70c1a(f));
};
var $da9be747d52ca156$export$b9909b62ceeab991 = function(a, f) {
    return (0, $lWM6H.pipe)(a, $da9be747d52ca156$export$bffee57bb00a6859(f));
};
var $da9be747d52ca156$export$ba255e9e49e00608 = $eAcXw.of;
var $da9be747d52ca156$export$7f9972325ebfd559 = function() {
    return $da9be747d52ca156$export$6e22c362a0406a2c;
};
var $da9be747d52ca156$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $da9be747d52ca156$export$228be17d80722ab = $da9be747d52ca156$export$1517cca7889d6aaa;
var $da9be747d52ca156$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $da9be747d52ca156$export$5b8affa63fc6df16(function(f) {
        return (0, $lWM6H.pipe)(fa, $da9be747d52ca156$export$871de8747c9eaa88(f));
    });
};
var $da9be747d52ca156$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $lWM6H.dual)(2, function(ma, f) {
    return (0, $lWM6H.pipe)(ma, $da9be747d52ca156$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $da9be747d52ca156$export$bffa455ba8c619a6 = /*#__PURE__*/ $da9be747d52ca156$export$5b8affa63fc6df16((0, $lWM6H.identity));
var $da9be747d52ca156$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $da9be747d52ca156$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $da9be747d52ca156$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $fYAej.separated)(left, right);
};
var $da9be747d52ca156$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $da9be747d52ca156$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($9sd2T.isSome(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $da9be747d52ca156$export$a04c6c6965dd4709 = function(f) {
    return $da9be747d52ca156$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $da9be747d52ca156$export$8e16b83750b44988 = /*#__PURE__*/ $da9be747d52ca156$export$a04c6c6965dd4709((0, $lWM6H.identity));
var $da9be747d52ca156$export$b29f828819edca8d = function(predicate) {
    return $da9be747d52ca156$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $da9be747d52ca156$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var a = as[i];
            if (predicateWithIndex(i, a)) right.push(a);
            else left.push(a);
        }
        return (0, $fYAej.separated)(left, right);
    };
};
var $da9be747d52ca156$export$3117e3f9ececb6bc = function(f) {
    return $da9be747d52ca156$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $da9be747d52ca156$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $fYAej.separated)(left, right);
    };
};
var $da9be747d52ca156$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(a, i) {
            return predicateWithIndex(i, a);
        });
    };
};
var $da9be747d52ca156$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $da9be747d52ca156$export$ecd5e8ace626722c = /*#__PURE__*/ $da9be747d52ca156$export$8b58be045bf06082((0, $lWM6H.identity));
var $da9be747d52ca156$export$18153bb1181268e5 = function(M) {
    return function(f) {
        return function(fa) {
            return fa.reduce(function(b, a, i) {
                return M.concat(b, f(i, a));
            }, M.empty);
        };
    };
};
var $da9be747d52ca156$export$533b26079ad0b4b = function(b, f) {
    return $da9be747d52ca156$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $da9be747d52ca156$export$b66cdc0497d8a99a = function(M) {
    var foldMapWithIndexM = $da9be747d52ca156$export$18153bb1181268e5(M);
    return function(f) {
        return foldMapWithIndexM(function(_, a) {
            return f(a);
        });
    };
};
var $da9be747d52ca156$export$bbd3ef8720e22369 = function(b, f) {
    return function(fa) {
        var len = fa.length;
        var out = b;
        for(var i = 0; i < len; i++)out = f(i, out, fa[i]);
        return out;
    };
};
var $da9be747d52ca156$export$7fef8bcdbb34f435 = function(b, f) {
    return $da9be747d52ca156$export$ce2b2fe0b88ccd0a(b, function(_, a, b) {
        return f(a, b);
    });
};
var $da9be747d52ca156$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(fa) {
        return fa.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $da9be747d52ca156$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $da9be747d52ca156$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $da9be747d52ca156$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $da9be747d52ca156$var$_reduce(ta, F.of($da9be747d52ca156$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $lWM6H.pipe)(as, $da9be747d52ca156$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $da9be747d52ca156$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $da9be747d52ca156$export$bbd3ef8720e22369(F.of($da9be747d52ca156$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $lWM6H.pipe)(bs, $da9be747d52ca156$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $da9be747d52ca156$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $da9be747d52ca156$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $da9be747d52ca156$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $da9be747d52ca156$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $da9be747d52ca156$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($9sd2T.isSome(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $da9be747d52ca156$export$9156e739aa33e19f = 'ReadonlyArray';
var $da9be747d52ca156$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $da9be747d52ca156$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $da9be747d52ca156$export$dd1bc94b04021eeb(first) ? second : $da9be747d52ca156$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
        }
    };
};
var $da9be747d52ca156$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $da9be747d52ca156$export$e759a9a7f8d04692().concat,
        empty: $da9be747d52ca156$export$6e22c362a0406a2c
    };
};
var $da9be747d52ca156$export$804fed467fde44e4 = function(E) {
    return (0, $bOO3o.fromEquals)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $da9be747d52ca156$export$1af51209b1b91d07 = function(O) {
    return (0, $4uWSF.fromCompare)(function(a, b) {
        var aLen = a.length;
        var bLen = b.length;
        var len = Math.min(aLen, bLen);
        for(var i = 0; i < len; i++){
            var ordering = O.compare(a[i], b[i]);
            if (ordering !== 0) return ordering;
        }
        return $jmbk9.Ord.compare(aLen, bLen);
    });
};
var $da9be747d52ca156$export$baca17b4aff42f82 = function(E) {
    var unionE = $da9be747d52ca156$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $da9be747d52ca156$export$c487aac9f4157837 = function(E) {
    return {
        concat: $da9be747d52ca156$export$baca17b4aff42f82(E).concat,
        empty: $da9be747d52ca156$export$6e22c362a0406a2c
    };
};
var $da9be747d52ca156$export$d379a869a72e4055 = function(E) {
    var intersectionE = $da9be747d52ca156$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $da9be747d52ca156$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $da9be747d52ca156$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $da9be747d52ca156$export$bd5b6bfc5fa2ee61 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map
};
var $da9be747d52ca156$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $gnzaQ.flap)($da9be747d52ca156$export$bd5b6bfc5fa2ee61);
var $da9be747d52ca156$export$59a71046037e6c20 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    of: $da9be747d52ca156$export$ba255e9e49e00608
};
var $da9be747d52ca156$export$9fdffe0fe1e91cad = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map,
    mapWithIndex: $da9be747d52ca156$var$_mapWithIndex
};
var $da9be747d52ca156$export$efc21ddc6aeb363d = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map,
    ap: $da9be747d52ca156$var$_ap
};
var $da9be747d52ca156$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $4AIBj.apFirst)($da9be747d52ca156$export$efc21ddc6aeb363d);
var $da9be747d52ca156$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $4AIBj.apSecond)($da9be747d52ca156$export$efc21ddc6aeb363d);
var $da9be747d52ca156$export$1279d2b7807629fd = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map,
    ap: $da9be747d52ca156$var$_ap,
    of: $da9be747d52ca156$export$ba255e9e49e00608
};
var $da9be747d52ca156$export$f18d5acc27d70423 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map,
    ap: $da9be747d52ca156$var$_ap,
    chain: $da9be747d52ca156$export$5b8affa63fc6df16
};
var $da9be747d52ca156$export$fb641926d034ac7d = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map,
    ap: $da9be747d52ca156$var$_ap,
    of: $da9be747d52ca156$export$ba255e9e49e00608,
    chain: $da9be747d52ca156$export$5b8affa63fc6df16
};
var $da9be747d52ca156$export$e3821ef4970c339c = /*#__PURE__*/ (0, $iXLA9.chainFirst)($da9be747d52ca156$export$f18d5acc27d70423);
var $da9be747d52ca156$export$8fa953f00d3b093 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    unfold: $da9be747d52ca156$export$c48e357c1a89b78d
};
var $da9be747d52ca156$export$25ba4469a069167 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map,
    alt: $da9be747d52ca156$var$_alt
};
var $da9be747d52ca156$export$aaef8a3eae948f03 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    zero: $da9be747d52ca156$export$7f9972325ebfd559
};
var $da9be747d52ca156$export$864d727b48066337 = /*#__PURE__*/ (0, $l7120.guard)($da9be747d52ca156$export$aaef8a3eae948f03, $da9be747d52ca156$export$59a71046037e6c20);
var $da9be747d52ca156$export$4acb47accde578d2 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map,
    ap: $da9be747d52ca156$var$_ap,
    of: $da9be747d52ca156$export$ba255e9e49e00608,
    alt: $da9be747d52ca156$var$_alt,
    zero: $da9be747d52ca156$export$7f9972325ebfd559
};
var $da9be747d52ca156$export$5b5dd0e212d2a5bc = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map,
    extend: $da9be747d52ca156$var$_extend
};
var $da9be747d52ca156$export$4a21ac48141ac3c9 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    compact: $da9be747d52ca156$export$8e16b83750b44988,
    separate: $da9be747d52ca156$export$709f6946f4e97408
};
var $da9be747d52ca156$export$d00e1c48fb621173 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map,
    compact: $da9be747d52ca156$export$8e16b83750b44988,
    separate: $da9be747d52ca156$export$709f6946f4e97408,
    filter: $da9be747d52ca156$var$_filter,
    filterMap: $da9be747d52ca156$var$_filterMap,
    partition: $da9be747d52ca156$var$_partition,
    partitionMap: $da9be747d52ca156$var$_partitionMap
};
var $da9be747d52ca156$export$c29a647071e542ec = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map,
    mapWithIndex: $da9be747d52ca156$var$_mapWithIndex,
    compact: $da9be747d52ca156$export$8e16b83750b44988,
    separate: $da9be747d52ca156$export$709f6946f4e97408,
    filter: $da9be747d52ca156$var$_filter,
    filterMap: $da9be747d52ca156$var$_filterMap,
    partition: $da9be747d52ca156$var$_partition,
    partitionMap: $da9be747d52ca156$var$_partitionMap,
    partitionMapWithIndex: $da9be747d52ca156$var$_partitionMapWithIndex,
    partitionWithIndex: $da9be747d52ca156$var$_partitionWithIndex,
    filterMapWithIndex: $da9be747d52ca156$var$_filterMapWithIndex,
    filterWithIndex: $da9be747d52ca156$var$_filterWithIndex
};
var $da9be747d52ca156$export$41404b31838667c9 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    reduce: $da9be747d52ca156$var$_reduce,
    foldMap: $da9be747d52ca156$var$_foldMap,
    reduceRight: $da9be747d52ca156$var$_reduceRight
};
var $da9be747d52ca156$export$e8f7d17aaff345cb = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    reduce: $da9be747d52ca156$var$_reduce,
    foldMap: $da9be747d52ca156$var$_foldMap,
    reduceRight: $da9be747d52ca156$var$_reduceRight,
    reduceWithIndex: $da9be747d52ca156$var$_reduceWithIndex,
    foldMapWithIndex: $da9be747d52ca156$var$_foldMapWithIndex,
    reduceRightWithIndex: $da9be747d52ca156$var$_reduceRightWithIndex
};
var $da9be747d52ca156$export$a0202666c3bda011 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map,
    reduce: $da9be747d52ca156$var$_reduce,
    foldMap: $da9be747d52ca156$var$_foldMap,
    reduceRight: $da9be747d52ca156$var$_reduceRight,
    traverse: $da9be747d52ca156$var$_traverse,
    sequence: $da9be747d52ca156$export$49bb65c2ea163039
};
var $da9be747d52ca156$export$bd7b528d8c36ec41 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map,
    mapWithIndex: $da9be747d52ca156$var$_mapWithIndex,
    reduce: $da9be747d52ca156$var$_reduce,
    foldMap: $da9be747d52ca156$var$_foldMap,
    reduceRight: $da9be747d52ca156$var$_reduceRight,
    reduceWithIndex: $da9be747d52ca156$var$_reduceWithIndex,
    foldMapWithIndex: $da9be747d52ca156$var$_foldMapWithIndex,
    reduceRightWithIndex: $da9be747d52ca156$var$_reduceRightWithIndex,
    traverse: $da9be747d52ca156$var$_traverse,
    sequence: $da9be747d52ca156$export$49bb65c2ea163039,
    traverseWithIndex: $da9be747d52ca156$var$_traverseWithIndex
};
var $da9be747d52ca156$export$f855115a79f70c1a = function(f) {
    return function(a) {
        var todo = $da9be747d52ca156$var$__spreadArray([], f(a), true);
        var out = [];
        while(todo.length > 0){
            var e = todo.shift();
            if ($9sd2T.isLeft(e)) todo.unshift.apply(todo, f(e.left));
            else out.push(e.right);
        }
        return out;
    };
};
var $da9be747d52ca156$export$7d808dfaa6d54634 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map,
    ap: $da9be747d52ca156$var$_ap,
    chain: $da9be747d52ca156$export$5b8affa63fc6df16,
    chainRec: $da9be747d52ca156$export$c5c44f872d8af73
};
var $da9be747d52ca156$export$bffee57bb00a6859 = function(f) {
    return function(a) {
        var initial = f(a);
        var todo = [];
        var out = [];
        function go(e) {
            if ($9sd2T.isLeft(e)) f(e.left).forEach(function(v) {
                return todo.push(v);
            });
            else out.push(e.right);
        }
        for(var _i = 0, initial_1 = initial; _i < initial_1.length; _i++){
            var e = initial_1[_i];
            go(e);
        }
        while(todo.length > 0)go(todo.shift());
        return out;
    };
};
var $da9be747d52ca156$export$57f3a385c7e59628 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map,
    ap: $da9be747d52ca156$var$_ap,
    chain: $da9be747d52ca156$export$5b8affa63fc6df16,
    chainRec: $da9be747d52ca156$export$b9909b62ceeab991
};
var $da9be747d52ca156$var$_wither = /*#__PURE__*/ (0, $loyJ7.witherDefault)($da9be747d52ca156$export$a0202666c3bda011, $da9be747d52ca156$export$4a21ac48141ac3c9);
var $da9be747d52ca156$var$_wilt = /*#__PURE__*/ (0, $loyJ7.wiltDefault)($da9be747d52ca156$export$a0202666c3bda011, $da9be747d52ca156$export$4a21ac48141ac3c9);
var $da9be747d52ca156$export$748d317b4c426f96 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    map: $da9be747d52ca156$var$_map,
    compact: $da9be747d52ca156$export$8e16b83750b44988,
    separate: $da9be747d52ca156$export$709f6946f4e97408,
    filter: $da9be747d52ca156$var$_filter,
    filterMap: $da9be747d52ca156$var$_filterMap,
    partition: $da9be747d52ca156$var$_partition,
    partitionMap: $da9be747d52ca156$var$_partitionMap,
    reduce: $da9be747d52ca156$var$_reduce,
    foldMap: $da9be747d52ca156$var$_foldMap,
    reduceRight: $da9be747d52ca156$var$_reduceRight,
    traverse: $da9be747d52ca156$var$_traverse,
    sequence: $da9be747d52ca156$export$49bb65c2ea163039,
    wither: $da9be747d52ca156$var$_wither,
    wilt: $da9be747d52ca156$var$_wilt
};
var $da9be747d52ca156$export$c40604f35db61519 = /*#__PURE__*/ (0, $loyJ7.filterE)($da9be747d52ca156$export$748d317b4c426f96);
var $da9be747d52ca156$export$825ea6cb6fc48d49 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    fromEither: $da9be747d52ca156$export$80c878c9b1d77917
};
var $da9be747d52ca156$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $coJMz.fromEitherK)($da9be747d52ca156$export$825ea6cb6fc48d49);
var $da9be747d52ca156$export$f4863e1822a1860c = $eAcXw.unsafeInsertAt;
var $da9be747d52ca156$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $da9be747d52ca156$export$a978c53b4062a525(as) ? $eAcXw.unsafeUpdateAt(i, a, as) : as;
};
var $da9be747d52ca156$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $da9be747d52ca156$export$45b10814cc054894 = function(as) {
    return as.slice();
};
var $da9be747d52ca156$export$571d59b505e6bb4e = function(as) {
    return $da9be747d52ca156$export$dd1bc94b04021eeb(as) ? $da9be747d52ca156$export$6e22c362a0406a2c : as.slice();
};
var $da9be747d52ca156$export$6e22c362a0406a2c = $eAcXw.empty;
function $da9be747d52ca156$export$7ecc1a3b11b57dab(predicate) {
    return function(as) {
        return as.every(predicate);
    };
}
var $da9be747d52ca156$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $da9be747d52ca156$export$f7e9f41ea797a17 = $da9be747d52ca156$export$ad14ef4001db2bcd;
var $da9be747d52ca156$export$739ec22334c44788 = function(M) {
    var intercalateM = $eAcXw.intercalate(M);
    return function(middle) {
        return $da9be747d52ca156$export$4659b591c19bdf3d(function() {
            return M.empty;
        }, intercalateM(middle));
    };
};
var $da9be747d52ca156$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $da9be747d52ca156$export$ba255e9e49e00608($9sd2T.emptyRecord);
var $da9be747d52ca156$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $gnzaQ.bindTo)($da9be747d52ca156$export$bd5b6bfc5fa2ee61);
var $da9be747d52ca156$export$5d537b797c421217 = /*#__PURE__*/ (0, $gnzaQ.let)($da9be747d52ca156$export$bd5b6bfc5fa2ee61);
var $da9be747d52ca156$export$2385a24977818dd0 = /*#__PURE__*/ (0, $iXLA9.bind)($da9be747d52ca156$export$f18d5acc27d70423);
var $da9be747d52ca156$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $4AIBj.apS)($da9be747d52ca156$export$efc21ddc6aeb363d);
var $da9be747d52ca156$export$e08e3b67e392101e = $da9be747d52ca156$export$5b8affa63fc6df16;
var $da9be747d52ca156$export$d02631cccf789723 = $eAcXw.range;
var $da9be747d52ca156$export$8327ebbef2a0ba76 = $eAcXw.cons;
var $da9be747d52ca156$export$c40cf5aab899f397 = $eAcXw.snoc;
var $da9be747d52ca156$export$baeb00bf1e27e233 = $da9be747d52ca156$export$849c7567cbd62acc;
var $da9be747d52ca156$export$95ca155af9fd5713 = {
    URI: $da9be747d52ca156$export$9156e739aa33e19f,
    compact: $da9be747d52ca156$export$8e16b83750b44988,
    separate: $da9be747d52ca156$export$709f6946f4e97408,
    map: $da9be747d52ca156$var$_map,
    ap: $da9be747d52ca156$var$_ap,
    of: $da9be747d52ca156$export$ba255e9e49e00608,
    chain: $da9be747d52ca156$export$5b8affa63fc6df16,
    filter: $da9be747d52ca156$var$_filter,
    filterMap: $da9be747d52ca156$var$_filterMap,
    partition: $da9be747d52ca156$var$_partition,
    partitionMap: $da9be747d52ca156$var$_partitionMap,
    mapWithIndex: $da9be747d52ca156$var$_mapWithIndex,
    partitionMapWithIndex: $da9be747d52ca156$var$_partitionMapWithIndex,
    partitionWithIndex: $da9be747d52ca156$var$_partitionWithIndex,
    filterMapWithIndex: $da9be747d52ca156$var$_filterMapWithIndex,
    filterWithIndex: $da9be747d52ca156$var$_filterWithIndex,
    alt: $da9be747d52ca156$var$_alt,
    zero: $da9be747d52ca156$export$7f9972325ebfd559,
    unfold: $da9be747d52ca156$export$c48e357c1a89b78d,
    reduce: $da9be747d52ca156$var$_reduce,
    foldMap: $da9be747d52ca156$var$_foldMap,
    reduceRight: $da9be747d52ca156$var$_reduceRight,
    traverse: $da9be747d52ca156$var$_traverse,
    sequence: $da9be747d52ca156$export$49bb65c2ea163039,
    reduceWithIndex: $da9be747d52ca156$var$_reduceWithIndex,
    foldMapWithIndex: $da9be747d52ca156$var$_foldMapWithIndex,
    reduceRightWithIndex: $da9be747d52ca156$var$_reduceRightWithIndex,
    traverseWithIndex: $da9be747d52ca156$var$_traverseWithIndex,
    extend: $da9be747d52ca156$var$_extend,
    wither: $da9be747d52ca156$var$_wither,
    wilt: $da9be747d52ca156$var$_wilt
};

});
parcelRegister("jmbk9", function(module, exports) {

$parcel$export(module.exports, "Eq", () => $e178db1dae8e1be4$export$a2050e5b0c4dcf10);
$parcel$export(module.exports, "Ord", () => $e178db1dae8e1be4$export$ee8aa95bfab51c5);
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * @category refinements
 * @since 2.11.0
 */ var $e178db1dae8e1be4$export$7e4aa119212bc614 = function(u) {
    return typeof u === 'number';
};
var $e178db1dae8e1be4$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $e178db1dae8e1be4$export$ee8aa95bfab51c5 = {
    equals: $e178db1dae8e1be4$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $e178db1dae8e1be4$export$88f31472ebc405c8 = {
    equals: $e178db1dae8e1be4$export$a2050e5b0c4dcf10.equals,
    compare: $e178db1dae8e1be4$export$ee8aa95bfab51c5.compare,
    top: Infinity,
    bottom: -Infinity
};
var $e178db1dae8e1be4$export$f6a3d19be20f5819 = {
    show: function(n) {
        return JSON.stringify(n);
    }
};
var $e178db1dae8e1be4$export$d423c79a04b3ae25 = {
    concat: function(first, second) {
        return first - second;
    }
};
var $e178db1dae8e1be4$export$e5fae4f686b09c06 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $e178db1dae8e1be4$export$5b0bccec79556292 = {
    concat: function(first, second) {
        return first * second;
    }
};
var $e178db1dae8e1be4$export$2517c0450e71e789 = {
    concat: $e178db1dae8e1be4$export$e5fae4f686b09c06.concat,
    empty: 0
};
var $e178db1dae8e1be4$export$ee1a63590489b690 = {
    concat: $e178db1dae8e1be4$export$5b0bccec79556292.concat,
    empty: 1
};
var $e178db1dae8e1be4$export$a455218a85c89869 = {
    add: $e178db1dae8e1be4$export$e5fae4f686b09c06.concat,
    zero: 0,
    mul: $e178db1dae8e1be4$export$5b0bccec79556292.concat,
    one: 1,
    sub: $e178db1dae8e1be4$export$d423c79a04b3ae25.concat,
    degree: function(_) {
        return 1;
    },
    div: function(first, second) {
        return first / second;
    },
    mod: function(first, second) {
        return first % second;
    }
};

});

parcelRegister("fYAej", function(module, exports) {

$parcel$export(module.exports, "separated", () => $ba1890174342f3cc$export$beaabdf62f4a639d);
/**
 * ```ts
 * interface Separated<E, A> {
 *    readonly left: E
 *    readonly right: A
 * }
 * ```
 *
 * Represents a result of separating a whole into two parts.
 *
 * @since 2.10.0
 */ 
var $lWM6H = parcelRequire("lWM6H");

var $gnzaQ = parcelRequire("gnzaQ");
var $ba1890174342f3cc$export$beaabdf62f4a639d = function(left, right) {
    return {
        left: left,
        right: right
    };
};
var $ba1890174342f3cc$var$_map = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $ba1890174342f3cc$export$871de8747c9eaa88(f));
};
var $ba1890174342f3cc$var$_mapLeft = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $ba1890174342f3cc$export$472de43a55e4aa49(f));
};
var $ba1890174342f3cc$var$_bimap = function(fa, g, f) {
    return (0, $lWM6H.pipe)(fa, $ba1890174342f3cc$export$eb54baf0b342cb1d(g, f));
};
var $ba1890174342f3cc$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $ba1890174342f3cc$export$beaabdf62f4a639d($ba1890174342f3cc$export$eabcd2c8791e7bf4(fa), f($ba1890174342f3cc$export$79ffe56a765070d2(fa)));
    };
};
var $ba1890174342f3cc$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $ba1890174342f3cc$export$beaabdf62f4a639d(f($ba1890174342f3cc$export$eabcd2c8791e7bf4(fa)), $ba1890174342f3cc$export$79ffe56a765070d2(fa));
    };
};
var $ba1890174342f3cc$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $ba1890174342f3cc$export$beaabdf62f4a639d(f($ba1890174342f3cc$export$eabcd2c8791e7bf4(fa)), g($ba1890174342f3cc$export$79ffe56a765070d2(fa)));
    };
};
var $ba1890174342f3cc$export$9156e739aa33e19f = 'Separated';
var $ba1890174342f3cc$export$fd0fe42029639505 = {
    URI: $ba1890174342f3cc$export$9156e739aa33e19f,
    mapLeft: $ba1890174342f3cc$var$_mapLeft,
    bimap: $ba1890174342f3cc$var$_bimap
};
var $ba1890174342f3cc$export$bd5b6bfc5fa2ee61 = {
    URI: $ba1890174342f3cc$export$9156e739aa33e19f,
    map: $ba1890174342f3cc$var$_map
};
var $ba1890174342f3cc$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $gnzaQ.flap)($ba1890174342f3cc$export$bd5b6bfc5fa2ee61);
var $ba1890174342f3cc$export$eabcd2c8791e7bf4 = function(s) {
    return s.left;
};
var $ba1890174342f3cc$export$79ffe56a765070d2 = function(s) {
    return s.right;
};

});

parcelRegister("loyJ7", function(module, exports) {

$parcel$export(module.exports, "wiltDefault", () => $f936c6d7e38f8d80$export$f4cb42390e44d1d2);
$parcel$export(module.exports, "witherDefault", () => $f936c6d7e38f8d80$export$1f5c6f948d11a182);
$parcel$export(module.exports, "filterE", () => $f936c6d7e38f8d80$export$c40604f35db61519);

var $9sd2T = parcelRequire("9sd2T");
function $f936c6d7e38f8d80$export$f4cb42390e44d1d2(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.separate);
        };
    };
}
function $f936c6d7e38f8d80$export$1f5c6f948d11a182(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.compact);
        };
    };
}
function $f936c6d7e38f8d80$export$c40604f35db61519(W) {
    return function(F) {
        var witherF = W.wither(F);
        return function(predicate) {
            return function(ga) {
                return witherF(ga, function(a) {
                    return F.map(predicate(a), function(b) {
                        return b ? $9sd2T.some(a) : $9sd2T.none;
                    });
                });
            };
        };
    };
}

});

parcelRegister("l7120", function(module, exports) {

$parcel$export(module.exports, "guard", () => $f5eb0d341c0535d2$export$864d727b48066337);
function $f5eb0d341c0535d2$export$864d727b48066337(F, P) {
    return function(b) {
        return b ? P.of(undefined) : F.zero();
    };
}

});



parcelRegister("9nKyz", function(module, exports) {

$parcel$export(module.exports, "make", () => $6d4a6039fd36e151$export$dd44f18ab656f3bb);
$parcel$export(module.exports, "getApplicative", () => $6d4a6039fd36e151$export$1402880adb2295a7);

var $lWM6H = parcelRequire("lWM6H");

var $gnzaQ = parcelRequire("gnzaQ");
var $6d4a6039fd36e151$export$dd44f18ab656f3bb = (0, $lWM6H.unsafeCoerce);
function $6d4a6039fd36e151$export$3cb5cd7f7776c81(S) {
    return {
        show: function(c) {
            return "make(".concat(S.show(c), ")");
        }
    };
}
var $6d4a6039fd36e151$export$804fed467fde44e4 = (0, $lWM6H.identity);
var $6d4a6039fd36e151$export$1af51209b1b91d07 = (0, $lWM6H.identity);
var $6d4a6039fd36e151$export$c55397fc301c5a = (0, $lWM6H.identity);
var $6d4a6039fd36e151$export$e759a9a7f8d04692 = (0, $lWM6H.identity);
var $6d4a6039fd36e151$export$c2a7ef2cc9b32b31 = (0, $lWM6H.identity);
var $6d4a6039fd36e151$export$3d48c7fefc7b8ec2 = (0, $lWM6H.identity);
var $6d4a6039fd36e151$export$575097c1c561f76f = (0, $lWM6H.identity);
var $6d4a6039fd36e151$export$2e73cb3f0f25ed55 = (0, $lWM6H.identity);
var $6d4a6039fd36e151$export$f37f1abb2c955577 = (0, $lWM6H.identity);
function $6d4a6039fd36e151$export$81090df2aa47ff12(S) {
    return {
        URI: $6d4a6039fd36e151$export$9156e739aa33e19f,
        _E: undefined,
        map: $6d4a6039fd36e151$var$_map,
        ap: function(fab, fa) {
            return $6d4a6039fd36e151$export$dd44f18ab656f3bb(S.concat(fab, fa));
        }
    };
}
function $6d4a6039fd36e151$export$1402880adb2295a7(M) {
    var A = $6d4a6039fd36e151$export$81090df2aa47ff12(M);
    return {
        URI: $6d4a6039fd36e151$export$9156e739aa33e19f,
        _E: undefined,
        map: A.map,
        ap: A.ap,
        of: function() {
            return $6d4a6039fd36e151$export$dd44f18ab656f3bb(M.empty);
        }
    };
}
var $6d4a6039fd36e151$var$_contramap = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $6d4a6039fd36e151$export$53b696d27ecb7ba7(f));
};
/* istanbul ignore next */ var $6d4a6039fd36e151$var$_map = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $6d4a6039fd36e151$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $6d4a6039fd36e151$var$_bimap = function(fa, f, g) {
    return (0, $lWM6H.pipe)(fa, $6d4a6039fd36e151$export$eb54baf0b342cb1d(f, g));
};
/* istanbul ignore next */ var $6d4a6039fd36e151$var$_mapLeft = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $6d4a6039fd36e151$export$472de43a55e4aa49(f));
};
var $6d4a6039fd36e151$export$53b696d27ecb7ba7 = function() {
    return 0, $lWM6H.unsafeCoerce;
};
var $6d4a6039fd36e151$export$871de8747c9eaa88 = function() {
    return 0, $lWM6H.unsafeCoerce;
};
var $6d4a6039fd36e151$export$eb54baf0b342cb1d = function(f) {
    return function(fa) {
        return $6d4a6039fd36e151$export$dd44f18ab656f3bb(f(fa));
    };
};
var $6d4a6039fd36e151$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $6d4a6039fd36e151$export$dd44f18ab656f3bb(f(fa));
    };
};
var $6d4a6039fd36e151$export$9156e739aa33e19f = 'Const';
var $6d4a6039fd36e151$export$bd5b6bfc5fa2ee61 = {
    URI: $6d4a6039fd36e151$export$9156e739aa33e19f,
    map: $6d4a6039fd36e151$var$_map
};
var $6d4a6039fd36e151$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $gnzaQ.flap)($6d4a6039fd36e151$export$bd5b6bfc5fa2ee61);
var $6d4a6039fd36e151$export$def901a57d5539c3 = {
    URI: $6d4a6039fd36e151$export$9156e739aa33e19f,
    contramap: $6d4a6039fd36e151$var$_contramap
};
var $6d4a6039fd36e151$export$fd0fe42029639505 = {
    URI: $6d4a6039fd36e151$export$9156e739aa33e19f,
    bimap: $6d4a6039fd36e151$var$_bimap,
    mapLeft: $6d4a6039fd36e151$var$_mapLeft
};
var $6d4a6039fd36e151$export$dfdd8a9a12668b21 = {
    URI: $6d4a6039fd36e151$export$9156e739aa33e19f,
    map: $6d4a6039fd36e151$var$_map,
    contramap: $6d4a6039fd36e151$var$_contramap,
    bimap: $6d4a6039fd36e151$var$_bimap,
    mapLeft: $6d4a6039fd36e151$var$_mapLeft
};

});

parcelRegister("jCSd8", function(module, exports) {

$parcel$export(module.exports, "monoidAll", () => $e49b9e0ffc5eea36$export$ea84ccdc68daa647);
$parcel$export(module.exports, "monoidAny", () => $e49b9e0ffc5eea36$export$c147905ca5134122);

var $enRcX = parcelRequire("enRcX");

var $lWM6H = parcelRequire("lWM6H");

var $9sd2T = parcelRequire("9sd2T");

var $iIsEa = parcelRequire("iIsEa");
var $e49b9e0ffc5eea36$export$96ec731ed4dcb222 = function(B) {
    return {
        concat: $iIsEa.min(B).concat,
        empty: B.top
    };
};
var $e49b9e0ffc5eea36$export$8960430cfd85939f = function(B) {
    return {
        concat: $iIsEa.max(B).concat,
        empty: B.bottom
    };
};
var $e49b9e0ffc5eea36$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: $iIsEa.reverse(M).concat,
        empty: M.empty
    };
};
var $e49b9e0ffc5eea36$export$8cf3da7c1c9174ea = function(monoids) {
    var empty = {};
    for(var k in monoids)if ($9sd2T.has.call(monoids, k)) empty[k] = monoids[k].empty;
    return {
        concat: $iIsEa.struct(monoids).concat,
        empty: empty
    };
};
var $e49b9e0ffc5eea36$export$65e3907585753458 = function() {
    var monoids = [];
    for(var _i = 0; _i < arguments.length; _i++)monoids[_i] = arguments[_i];
    return {
        concat: $iIsEa.tuple.apply($iIsEa, monoids).concat,
        empty: monoids.map(function(m) {
            return m.empty;
        })
    };
};
var $e49b9e0ffc5eea36$export$b314777ae20abca9 = function(M) {
    return $iIsEa.concatAll(M)(M.empty);
};
var $e49b9e0ffc5eea36$export$50d82750fd26461d = {
    concat: $iIsEa.semigroupVoid.concat,
    empty: undefined
};
var $e49b9e0ffc5eea36$export$4ab04e39033ac22a = $e49b9e0ffc5eea36$export$65e3907585753458;
var $e49b9e0ffc5eea36$export$dfc91d1e5b77420b = $e49b9e0ffc5eea36$export$8cf3da7c1c9174ea;
var $e49b9e0ffc5eea36$export$5ca84f9b29f1c1a2 = $e49b9e0ffc5eea36$export$66c1ae025e96b4bc;
var $e49b9e0ffc5eea36$export$9cc0388793460b00 = $e49b9e0ffc5eea36$export$8960430cfd85939f;
var $e49b9e0ffc5eea36$export$6d1c667712a51996 = $e49b9e0ffc5eea36$export$96ec731ed4dcb222;
var $e49b9e0ffc5eea36$export$93e2b83da34ff82a = $e49b9e0ffc5eea36$export$b314777ae20abca9;
var $e49b9e0ffc5eea36$export$ea84ccdc68daa647 = {
    concat: $iIsEa.semigroupAll.concat,
    empty: true
};
var $e49b9e0ffc5eea36$export$c147905ca5134122 = {
    concat: $iIsEa.semigroupAny.concat,
    empty: false
};
var $e49b9e0ffc5eea36$export$616ba591d6210ed8 = (0, $lWM6H.getMonoid);
var $e49b9e0ffc5eea36$export$5c6d2e402d334f37 = function() {
    return $e49b9e0ffc5eea36$export$66c1ae025e96b4bc((0, $enRcX.getMonoid)());
};
var $e49b9e0ffc5eea36$export$fc39f3d77fa2e58a = {
    concat: $iIsEa.semigroupString.concat,
    empty: ''
};
var $e49b9e0ffc5eea36$export$8f9c64d4a92a9eb6 = {
    concat: $iIsEa.semigroupSum.concat,
    empty: 0
};
var $e49b9e0ffc5eea36$export$cb362f92c995f3b8 = {
    concat: $iIsEa.semigroupProduct.concat,
    empty: 1
};

});
parcelRegister("enRcX", function(module, exports) {

$parcel$export(module.exports, "getMonoid", () => $a78c7ca9a610e88a$export$c2a7ef2cc9b32b31);
/**
 * @since 2.11.0
 */ 
var $lWM6H = parcelRequire("lWM6H");
var $a78c7ca9a610e88a$export$9156e739aa33e19f = 'Endomorphism';
var $a78c7ca9a610e88a$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return (0, $lWM6H.flow)(first, second);
        }
    };
};
var $a78c7ca9a610e88a$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $a78c7ca9a610e88a$export$e759a9a7f8d04692().concat,
        empty: (0, $lWM6H.identity)
    };
};

});


parcelRegister("5OFXS", function(module, exports) {

$parcel$export(module.exports, "none", () => $43c22c9a840c2054$export$f883a24d5edde77c);
$parcel$export(module.exports, "some", () => $43c22c9a840c2054$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "fromPredicate", () => $43c22c9a840c2054$export$23f31c55d7162b91);
$parcel$export(module.exports, "map", () => $43c22c9a840c2054$export$871de8747c9eaa88);
$parcel$export(module.exports, "isNone", () => $43c22c9a840c2054$export$e56af863d5645d5f);
$parcel$export(module.exports, "isSome", () => $43c22c9a840c2054$export$5d7e502287836e58);
$parcel$export(module.exports, "fromEither", () => $43c22c9a840c2054$export$80c878c9b1d77917);
$parcel$export(module.exports, "foldW", () => $43c22c9a840c2054$export$ccb09033cefa61e8);
$parcel$export(module.exports, "fold", () => $43c22c9a840c2054$export$93e2b83da34ff82a);
$parcel$export(module.exports, "getOrElse", () => $43c22c9a840c2054$export$8832081647a02ee7);
$parcel$export(module.exports, "fromNullable", () => $43c22c9a840c2054$export$b601f49376b4621a);
$parcel$export(module.exports, "toNullable", () => $43c22c9a840c2054$export$b187f57ee1822bc5);
$parcel$export(module.exports, "toUndefined", () => $43c22c9a840c2054$export$cb585b8513fa8577);
$parcel$export(module.exports, "chain", () => $43c22c9a840c2054$export$e08e3b67e392101e);
$parcel$export(module.exports, "option", () => $43c22c9a840c2054$export$a75d1723e6bda2ec);
$parcel$export(module.exports, "getFirstMonoid", () => $43c22c9a840c2054$export$56cd0d85e73e688f);

var $jsIAd = parcelRequire("jsIAd");

var $4AIBj = parcelRequire("4AIBj");

var $iXLA9 = parcelRequire("iXLA9");

var $coJMz = parcelRequire("coJMz");

var $lWM6H = parcelRequire("lWM6H");

var $gnzaQ = parcelRequire("gnzaQ");

var $9sd2T = parcelRequire("9sd2T");

var $806pa = parcelRequire("806pa");

var $iIsEa = parcelRequire("iIsEa");

var $fYAej = parcelRequire("fYAej");

var $loyJ7 = parcelRequire("loyJ7");

var $l7120 = parcelRequire("l7120");
var $43c22c9a840c2054$export$f883a24d5edde77c = $9sd2T.none;
var $43c22c9a840c2054$export$ad14ef4001db2bcd = $9sd2T.some;
function $43c22c9a840c2054$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? $43c22c9a840c2054$export$ad14ef4001db2bcd(a) : $43c22c9a840c2054$export$f883a24d5edde77c;
    };
}
var $43c22c9a840c2054$export$da405662c16fca8e = function(ma) {
    return ma._tag === 'Right' ? $43c22c9a840c2054$export$f883a24d5edde77c : $43c22c9a840c2054$export$ad14ef4001db2bcd(ma.left);
};
var $43c22c9a840c2054$export$482f3615ecf01dc6 = function(ma) {
    return ma._tag === 'Left' ? $43c22c9a840c2054$export$f883a24d5edde77c : $43c22c9a840c2054$export$ad14ef4001db2bcd(ma.right);
};
var $43c22c9a840c2054$var$_map = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $43c22c9a840c2054$export$871de8747c9eaa88(f));
};
var $43c22c9a840c2054$var$_ap = function(fab, fa) {
    return (0, $lWM6H.pipe)(fab, $43c22c9a840c2054$export$2f6ca3d3b1f80bf5(fa));
};
var $43c22c9a840c2054$var$_reduce = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $43c22c9a840c2054$export$533b26079ad0b4b(b, f));
};
var $43c22c9a840c2054$var$_foldMap = function(M) {
    var foldMapM = $43c22c9a840c2054$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $lWM6H.pipe)(fa, foldMapM(f));
    };
};
var $43c22c9a840c2054$var$_reduceRight = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $43c22c9a840c2054$export$7fef8bcdbb34f435(b, f));
};
var $43c22c9a840c2054$var$_traverse = function(F) {
    var traverseF = $43c22c9a840c2054$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $lWM6H.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $43c22c9a840c2054$var$_alt = function(fa, that) {
    return (0, $lWM6H.pipe)(fa, $43c22c9a840c2054$export$228be17d80722ab(that));
};
var $43c22c9a840c2054$var$_filter = function(fa, predicate) {
    return (0, $lWM6H.pipe)(fa, $43c22c9a840c2054$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $43c22c9a840c2054$var$_filterMap = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $43c22c9a840c2054$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $43c22c9a840c2054$var$_extend = function(wa, f) {
    return (0, $lWM6H.pipe)(wa, $43c22c9a840c2054$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $43c22c9a840c2054$var$_partition = function(fa, predicate) {
    return (0, $lWM6H.pipe)(fa, $43c22c9a840c2054$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $43c22c9a840c2054$var$_partitionMap = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $43c22c9a840c2054$export$3117e3f9ececb6bc(f));
};
var $43c22c9a840c2054$export$9156e739aa33e19f = 'Option';
var $43c22c9a840c2054$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(ma) {
            return $43c22c9a840c2054$export$e56af863d5645d5f(ma) ? 'none' : "some(".concat(S.show(ma.value), ")");
        }
    };
};
var $43c22c9a840c2054$export$804fed467fde44e4 = function(E) {
    return {
        equals: function(x, y) {
            return x === y || ($43c22c9a840c2054$export$e56af863d5645d5f(x) ? $43c22c9a840c2054$export$e56af863d5645d5f(y) : $43c22c9a840c2054$export$e56af863d5645d5f(y) ? false : E.equals(x.value, y.value));
        }
    };
};
var $43c22c9a840c2054$export$1af51209b1b91d07 = function(O) {
    return {
        equals: $43c22c9a840c2054$export$804fed467fde44e4(O).equals,
        compare: function(x, y) {
            return x === y ? 0 : $43c22c9a840c2054$export$5d7e502287836e58(x) ? $43c22c9a840c2054$export$5d7e502287836e58(y) ? O.compare(x.value, y.value) : 1 : -1;
        }
    };
};
var $43c22c9a840c2054$export$c2a7ef2cc9b32b31 = function(S) {
    return {
        concat: function(x, y) {
            return $43c22c9a840c2054$export$e56af863d5645d5f(x) ? y : $43c22c9a840c2054$export$e56af863d5645d5f(y) ? x : $43c22c9a840c2054$export$ad14ef4001db2bcd(S.concat(x.value, y.value));
        },
        empty: $43c22c9a840c2054$export$f883a24d5edde77c
    };
};
var $43c22c9a840c2054$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $43c22c9a840c2054$export$e56af863d5645d5f(fa) ? $43c22c9a840c2054$export$f883a24d5edde77c : $43c22c9a840c2054$export$ad14ef4001db2bcd(f(fa.value));
    };
};
var $43c22c9a840c2054$export$bd5b6bfc5fa2ee61 = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    map: $43c22c9a840c2054$var$_map
};
var $43c22c9a840c2054$export$6554612db691658e = (0, $lWM6H.dual)(2, (0, $gnzaQ.as)($43c22c9a840c2054$export$bd5b6bfc5fa2ee61));
var $43c22c9a840c2054$export$9284b360ca18a0fd = (0, $gnzaQ.asUnit)($43c22c9a840c2054$export$bd5b6bfc5fa2ee61);
var $43c22c9a840c2054$export$ba255e9e49e00608 = $43c22c9a840c2054$export$ad14ef4001db2bcd;
var $43c22c9a840c2054$export$59a71046037e6c20 = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    of: $43c22c9a840c2054$export$ba255e9e49e00608
};
var $43c22c9a840c2054$export$2f6ca3d3b1f80bf5 = function(fa) {
    return function(fab) {
        return $43c22c9a840c2054$export$e56af863d5645d5f(fab) ? $43c22c9a840c2054$export$f883a24d5edde77c : $43c22c9a840c2054$export$e56af863d5645d5f(fa) ? $43c22c9a840c2054$export$f883a24d5edde77c : $43c22c9a840c2054$export$ad14ef4001db2bcd(fab.value(fa.value));
    };
};
var $43c22c9a840c2054$export$efc21ddc6aeb363d = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    map: $43c22c9a840c2054$var$_map,
    ap: $43c22c9a840c2054$var$_ap
};
var $43c22c9a840c2054$export$1279d2b7807629fd = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    map: $43c22c9a840c2054$var$_map,
    ap: $43c22c9a840c2054$var$_ap,
    of: $43c22c9a840c2054$export$ba255e9e49e00608
};
var $43c22c9a840c2054$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $lWM6H.dual)(2, function(ma, f) {
    return $43c22c9a840c2054$export$e56af863d5645d5f(ma) ? $43c22c9a840c2054$export$f883a24d5edde77c : f(ma.value);
});
var $43c22c9a840c2054$export$f18d5acc27d70423 = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    map: $43c22c9a840c2054$var$_map,
    ap: $43c22c9a840c2054$var$_ap,
    chain: $43c22c9a840c2054$export$5b8affa63fc6df16
};
var $43c22c9a840c2054$export$fb641926d034ac7d = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    map: $43c22c9a840c2054$var$_map,
    ap: $43c22c9a840c2054$var$_ap,
    of: $43c22c9a840c2054$export$ba255e9e49e00608,
    chain: $43c22c9a840c2054$export$5b8affa63fc6df16
};
var $43c22c9a840c2054$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $43c22c9a840c2054$export$e56af863d5645d5f(fa) ? b : f(b, fa.value);
    };
};
var $43c22c9a840c2054$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $43c22c9a840c2054$export$e56af863d5645d5f(fa) ? M.empty : f(fa.value);
        };
    };
};
var $43c22c9a840c2054$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $43c22c9a840c2054$export$e56af863d5645d5f(fa) ? b : f(fa.value, b);
    };
};
var $43c22c9a840c2054$export$41404b31838667c9 = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    reduce: $43c22c9a840c2054$var$_reduce,
    foldMap: $43c22c9a840c2054$var$_foldMap,
    reduceRight: $43c22c9a840c2054$var$_reduceRight
};
var $43c22c9a840c2054$export$41d1a04d78e7b141 = (0, $lWM6H.dual)(2, function(self, that) {
    return $43c22c9a840c2054$export$e56af863d5645d5f(self) ? that() : self;
});
var $43c22c9a840c2054$export$1517cca7889d6aaa = $43c22c9a840c2054$export$41d1a04d78e7b141;
var $43c22c9a840c2054$export$228be17d80722ab = $43c22c9a840c2054$export$41d1a04d78e7b141;
var $43c22c9a840c2054$export$25ba4469a069167 = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    map: $43c22c9a840c2054$var$_map,
    alt: $43c22c9a840c2054$var$_alt
};
var $43c22c9a840c2054$export$7f9972325ebfd559 = function() {
    return $43c22c9a840c2054$export$f883a24d5edde77c;
};
var $43c22c9a840c2054$export$aaef8a3eae948f03 = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    zero: $43c22c9a840c2054$export$7f9972325ebfd559
};
var $43c22c9a840c2054$export$864d727b48066337 = /*#__PURE__*/ (0, $l7120.guard)($43c22c9a840c2054$export$aaef8a3eae948f03, $43c22c9a840c2054$export$59a71046037e6c20);
var $43c22c9a840c2054$export$4acb47accde578d2 = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    map: $43c22c9a840c2054$var$_map,
    ap: $43c22c9a840c2054$var$_ap,
    of: $43c22c9a840c2054$export$ba255e9e49e00608,
    alt: $43c22c9a840c2054$var$_alt,
    zero: $43c22c9a840c2054$export$7f9972325ebfd559
};
var $43c22c9a840c2054$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $43c22c9a840c2054$export$e56af863d5645d5f(wa) ? $43c22c9a840c2054$export$f883a24d5edde77c : $43c22c9a840c2054$export$ad14ef4001db2bcd(f(wa));
    };
};
var $43c22c9a840c2054$export$5b5dd0e212d2a5bc = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    map: $43c22c9a840c2054$var$_map,
    extend: $43c22c9a840c2054$var$_extend
};
var $43c22c9a840c2054$export$8e16b83750b44988 = /*#__PURE__*/ $43c22c9a840c2054$export$5b8affa63fc6df16((0, $lWM6H.identity));
var $43c22c9a840c2054$var$defaultSeparated = /*#__PURE__*/ (0, $fYAej.separated)($43c22c9a840c2054$export$f883a24d5edde77c, $43c22c9a840c2054$export$f883a24d5edde77c);
var $43c22c9a840c2054$export$709f6946f4e97408 = function(ma) {
    return $43c22c9a840c2054$export$e56af863d5645d5f(ma) ? $43c22c9a840c2054$var$defaultSeparated : (0, $fYAej.separated)($43c22c9a840c2054$export$da405662c16fca8e(ma.value), $43c22c9a840c2054$export$482f3615ecf01dc6(ma.value));
};
var $43c22c9a840c2054$export$4a21ac48141ac3c9 = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    compact: $43c22c9a840c2054$export$8e16b83750b44988,
    separate: $43c22c9a840c2054$export$709f6946f4e97408
};
var $43c22c9a840c2054$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $43c22c9a840c2054$export$e56af863d5645d5f(fa) ? $43c22c9a840c2054$export$f883a24d5edde77c : predicate(fa.value) ? fa : $43c22c9a840c2054$export$f883a24d5edde77c;
    };
};
var $43c22c9a840c2054$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $43c22c9a840c2054$export$e56af863d5645d5f(fa) ? $43c22c9a840c2054$export$f883a24d5edde77c : f(fa.value);
    };
};
var $43c22c9a840c2054$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return (0, $fYAej.separated)($43c22c9a840c2054$var$_filter(fa, (0, $806pa.not)(predicate)), $43c22c9a840c2054$var$_filter(fa, predicate));
    };
};
var $43c22c9a840c2054$export$3117e3f9ececb6bc = function(f) {
    return (0, $lWM6H.flow)($43c22c9a840c2054$export$871de8747c9eaa88(f), $43c22c9a840c2054$export$709f6946f4e97408);
};
var $43c22c9a840c2054$export$d00e1c48fb621173 = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    map: $43c22c9a840c2054$var$_map,
    compact: $43c22c9a840c2054$export$8e16b83750b44988,
    separate: $43c22c9a840c2054$export$709f6946f4e97408,
    filter: $43c22c9a840c2054$var$_filter,
    filterMap: $43c22c9a840c2054$var$_filterMap,
    partition: $43c22c9a840c2054$var$_partition,
    partitionMap: $43c22c9a840c2054$var$_partitionMap
};
var $43c22c9a840c2054$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $43c22c9a840c2054$export$e56af863d5645d5f(ta) ? F.of($43c22c9a840c2054$export$f883a24d5edde77c) : F.map(f(ta.value), $43c22c9a840c2054$export$ad14ef4001db2bcd);
        };
    };
};
var $43c22c9a840c2054$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $43c22c9a840c2054$export$e56af863d5645d5f(ta) ? F.of($43c22c9a840c2054$export$f883a24d5edde77c) : F.map(ta.value, $43c22c9a840c2054$export$ad14ef4001db2bcd);
    };
};
var $43c22c9a840c2054$export$a0202666c3bda011 = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    map: $43c22c9a840c2054$var$_map,
    reduce: $43c22c9a840c2054$var$_reduce,
    foldMap: $43c22c9a840c2054$var$_foldMap,
    reduceRight: $43c22c9a840c2054$var$_reduceRight,
    traverse: $43c22c9a840c2054$var$_traverse,
    sequence: $43c22c9a840c2054$export$49bb65c2ea163039
};
var $43c22c9a840c2054$var$_wither = /*#__PURE__*/ (0, $loyJ7.witherDefault)($43c22c9a840c2054$export$a0202666c3bda011, $43c22c9a840c2054$export$4a21ac48141ac3c9);
var $43c22c9a840c2054$var$_wilt = /*#__PURE__*/ (0, $loyJ7.wiltDefault)($43c22c9a840c2054$export$a0202666c3bda011, $43c22c9a840c2054$export$4a21ac48141ac3c9);
var $43c22c9a840c2054$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $43c22c9a840c2054$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $43c22c9a840c2054$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $43c22c9a840c2054$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $43c22c9a840c2054$export$748d317b4c426f96 = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    map: $43c22c9a840c2054$var$_map,
    reduce: $43c22c9a840c2054$var$_reduce,
    foldMap: $43c22c9a840c2054$var$_foldMap,
    reduceRight: $43c22c9a840c2054$var$_reduceRight,
    traverse: $43c22c9a840c2054$var$_traverse,
    sequence: $43c22c9a840c2054$export$49bb65c2ea163039,
    compact: $43c22c9a840c2054$export$8e16b83750b44988,
    separate: $43c22c9a840c2054$export$709f6946f4e97408,
    filter: $43c22c9a840c2054$var$_filter,
    filterMap: $43c22c9a840c2054$var$_filterMap,
    partition: $43c22c9a840c2054$var$_partition,
    partitionMap: $43c22c9a840c2054$var$_partitionMap,
    wither: $43c22c9a840c2054$var$_wither,
    wilt: $43c22c9a840c2054$var$_wilt
};
var $43c22c9a840c2054$export$8bf7aba4a9e09055 = function() {
    return $43c22c9a840c2054$export$f883a24d5edde77c;
};
var $43c22c9a840c2054$export$5f956d47d0619c3a = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    map: $43c22c9a840c2054$var$_map,
    ap: $43c22c9a840c2054$var$_ap,
    of: $43c22c9a840c2054$export$ba255e9e49e00608,
    chain: $43c22c9a840c2054$export$5b8affa63fc6df16,
    throwError: $43c22c9a840c2054$export$8bf7aba4a9e09055
};
var $43c22c9a840c2054$export$80c878c9b1d77917 = $43c22c9a840c2054$export$482f3615ecf01dc6;
var $43c22c9a840c2054$export$825ea6cb6fc48d49 = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    fromEither: $43c22c9a840c2054$export$80c878c9b1d77917
};
var $43c22c9a840c2054$export$5d7e502287836e58 = $9sd2T.isSome;
var $43c22c9a840c2054$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $43c22c9a840c2054$export$2d55ea551c238330 = function(onNone, onSome) {
    return function(ma) {
        return $43c22c9a840c2054$export$e56af863d5645d5f(ma) ? onNone() : onSome(ma.value);
    };
};
var $43c22c9a840c2054$export$ccb09033cefa61e8 = $43c22c9a840c2054$export$2d55ea551c238330;
var $43c22c9a840c2054$export$4659b591c19bdf3d = $43c22c9a840c2054$export$2d55ea551c238330;
var $43c22c9a840c2054$export$93e2b83da34ff82a = $43c22c9a840c2054$export$4659b591c19bdf3d;
var $43c22c9a840c2054$export$d8a997ff0e6436f3 = function(onNone) {
    return function(ma) {
        return $43c22c9a840c2054$export$e56af863d5645d5f(ma) ? onNone() : ma.value;
    };
};
var $43c22c9a840c2054$export$8832081647a02ee7 = $43c22c9a840c2054$export$d8a997ff0e6436f3;
var $43c22c9a840c2054$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $gnzaQ.flap)($43c22c9a840c2054$export$bd5b6bfc5fa2ee61);
var $43c22c9a840c2054$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $4AIBj.apFirst)($43c22c9a840c2054$export$efc21ddc6aeb363d);
var $43c22c9a840c2054$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $4AIBj.apSecond)($43c22c9a840c2054$export$efc21ddc6aeb363d);
var $43c22c9a840c2054$export$bffa455ba8c619a6 = $43c22c9a840c2054$export$8e16b83750b44988;
var $43c22c9a840c2054$export$3f23594af5f37336 = /*#__PURE__*/ (0, $lWM6H.dual)(2, $iXLA9.tap($43c22c9a840c2054$export$f18d5acc27d70423));
var $43c22c9a840c2054$export$be3ff275bb5a8ac9 = /*#__PURE__*/ (0, $lWM6H.dual)(2, (0, $coJMz.tapEither)($43c22c9a840c2054$export$825ea6cb6fc48d49, $43c22c9a840c2054$export$f18d5acc27d70423));
var $43c22c9a840c2054$export$ecd5e8ace626722c = /*#__PURE__*/ $43c22c9a840c2054$export$8b58be045bf06082((0, $lWM6H.identity));
var $43c22c9a840c2054$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $coJMz.fromEitherK)($43c22c9a840c2054$export$825ea6cb6fc48d49);
var $43c22c9a840c2054$export$a3eef2eba9908c3e = /*#__PURE__*/ (0, $coJMz.chainEitherK)($43c22c9a840c2054$export$825ea6cb6fc48d49, $43c22c9a840c2054$export$f18d5acc27d70423);
var $43c22c9a840c2054$export$c5f2bdbf9b43f0c0 = $43c22c9a840c2054$export$be3ff275bb5a8ac9;
var $43c22c9a840c2054$export$b601f49376b4621a = function(a) {
    return a == null ? $43c22c9a840c2054$export$f883a24d5edde77c : $43c22c9a840c2054$export$ad14ef4001db2bcd(a);
};
var $43c22c9a840c2054$export$d234c058d1d4e435 = function(f) {
    try {
        return $43c22c9a840c2054$export$ad14ef4001db2bcd(f());
    } catch (e) {
        return $43c22c9a840c2054$export$f883a24d5edde77c;
    }
};
var $43c22c9a840c2054$export$7f3d23c4b0794e72 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $43c22c9a840c2054$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        });
    };
};
var $43c22c9a840c2054$export$c69ca7b73fad45e1 = function(f) {
    return (0, $lWM6H.flow)(f, $43c22c9a840c2054$export$b601f49376b4621a);
};
var $43c22c9a840c2054$export$c81f992c08fd0bf3 = function(f) {
    return function(ma) {
        return $43c22c9a840c2054$export$e56af863d5645d5f(ma) ? $43c22c9a840c2054$export$f883a24d5edde77c : $43c22c9a840c2054$export$b601f49376b4621a(f(ma.value));
    };
};
var $43c22c9a840c2054$export$b187f57ee1822bc5 = /*#__PURE__*/ $43c22c9a840c2054$export$4659b591c19bdf3d((0, $lWM6H.constNull), (0, $lWM6H.identity));
var $43c22c9a840c2054$export$cb585b8513fa8577 = /*#__PURE__*/ $43c22c9a840c2054$export$4659b591c19bdf3d((0, $lWM6H.constUndefined), (0, $lWM6H.identity));
function $43c22c9a840c2054$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $43c22c9a840c2054$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $43c22c9a840c2054$export$e56af863d5645d5f(ma) ? false : E.equals(a, ma.value);
    };
}
var $43c22c9a840c2054$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $43c22c9a840c2054$export$e56af863d5645d5f(ma) ? false : predicate(ma.value);
    };
};
var $43c22c9a840c2054$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $43c22c9a840c2054$export$ba255e9e49e00608($9sd2T.emptyRecord);
var $43c22c9a840c2054$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $gnzaQ.bindTo)($43c22c9a840c2054$export$bd5b6bfc5fa2ee61);
var $43c22c9a840c2054$export$5d537b797c421217 = /*#__PURE__*/ (0, $gnzaQ.let)($43c22c9a840c2054$export$bd5b6bfc5fa2ee61);
var $43c22c9a840c2054$export$2385a24977818dd0 = /*#__PURE__*/ $iXLA9.bind($43c22c9a840c2054$export$f18d5acc27d70423);
var $43c22c9a840c2054$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $4AIBj.apS)($43c22c9a840c2054$export$efc21ddc6aeb363d);
var $43c22c9a840c2054$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $43c22c9a840c2054$export$ba255e9e49e00608($9sd2T.emptyReadonlyArray);
var $43c22c9a840c2054$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var o = f(0, $9sd2T.head(as));
        if ($43c22c9a840c2054$export$e56af863d5645d5f(o)) return $43c22c9a840c2054$export$f883a24d5edde77c;
        var out = [
            o.value
        ];
        for(var i = 1; i < as.length; i++){
            var o_1 = f(i, as[i]);
            if ($43c22c9a840c2054$export$e56af863d5645d5f(o_1)) return $43c22c9a840c2054$export$f883a24d5edde77c;
            out.push(o_1.value);
        }
        return $43c22c9a840c2054$export$ad14ef4001db2bcd(out);
    };
};
var $43c22c9a840c2054$export$d4e79db5dc14cc1 = function(f) {
    var g = $43c22c9a840c2054$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $9sd2T.isNonEmpty(as) ? g(as) : $43c22c9a840c2054$export$c74b6e34b2b6efb0;
    };
};
var $43c22c9a840c2054$export$104a2841e9cbad06 = $43c22c9a840c2054$export$d4e79db5dc14cc1;
var $43c22c9a840c2054$export$64f39b2a2b79e1b1 = function(f) {
    return $43c22c9a840c2054$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $43c22c9a840c2054$export$d330b60315c14cd1 = /*#__PURE__*/ $43c22c9a840c2054$export$64f39b2a2b79e1b1((0, $lWM6H.identity));
var $43c22c9a840c2054$export$e08e3b67e392101e = $43c22c9a840c2054$export$5b8affa63fc6df16;
var $43c22c9a840c2054$export$e3821ef4970c339c = $43c22c9a840c2054$export$3f23594af5f37336;
function $43c22c9a840c2054$export$4a60bf88193d4686(getOption) {
    return function(a) {
        return $43c22c9a840c2054$export$5d7e502287836e58(getOption(a));
    };
}
var $43c22c9a840c2054$export$c2a8dfc107523e74 = $43c22c9a840c2054$export$c81f992c08fd0bf3;
var $43c22c9a840c2054$export$a75d1723e6bda2ec = {
    URI: $43c22c9a840c2054$export$9156e739aa33e19f,
    map: $43c22c9a840c2054$var$_map,
    of: $43c22c9a840c2054$export$ba255e9e49e00608,
    ap: $43c22c9a840c2054$var$_ap,
    chain: $43c22c9a840c2054$export$5b8affa63fc6df16,
    reduce: $43c22c9a840c2054$var$_reduce,
    foldMap: $43c22c9a840c2054$var$_foldMap,
    reduceRight: $43c22c9a840c2054$var$_reduceRight,
    traverse: $43c22c9a840c2054$var$_traverse,
    sequence: $43c22c9a840c2054$export$49bb65c2ea163039,
    zero: $43c22c9a840c2054$export$7f9972325ebfd559,
    alt: $43c22c9a840c2054$var$_alt,
    extend: $43c22c9a840c2054$var$_extend,
    compact: $43c22c9a840c2054$export$8e16b83750b44988,
    separate: $43c22c9a840c2054$export$709f6946f4e97408,
    filter: $43c22c9a840c2054$var$_filter,
    filterMap: $43c22c9a840c2054$var$_filterMap,
    partition: $43c22c9a840c2054$var$_partition,
    partitionMap: $43c22c9a840c2054$var$_partitionMap,
    wither: $43c22c9a840c2054$var$_wither,
    wilt: $43c22c9a840c2054$var$_wilt,
    throwError: $43c22c9a840c2054$export$8bf7aba4a9e09055
};
var $43c22c9a840c2054$export$18979a515d2a828e = /*#__PURE__*/ (0, $4AIBj.getApplySemigroup)($43c22c9a840c2054$export$efc21ddc6aeb363d);
var $43c22c9a840c2054$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $jsIAd.getApplicativeMonoid)($43c22c9a840c2054$export$1279d2b7807629fd);
var $43c22c9a840c2054$export$56cd0d85e73e688f = function() {
    return $43c22c9a840c2054$export$c2a7ef2cc9b32b31((0, $iIsEa.first)());
};
var $43c22c9a840c2054$export$ca391a563a1f3001 = function() {
    return $43c22c9a840c2054$export$c2a7ef2cc9b32b31((0, $iIsEa.last)());
};

});
parcelRegister("jsIAd", function(module, exports) {

$parcel$export(module.exports, "getApplicativeMonoid", () => $e2b3372559168924$export$c8e1a8ea383fd0ff);
/**
 * The `Applicative` type class extends the `Apply` type class with a `of` function, which can be used to create values
 * of type `f a` from values of type `a`.
 *
 * Where `Apply` provides the ability to lift functions of two or more arguments to functions whose arguments are
 * wrapped using `f`, and `Functor` provides the ability to lift functions of one argument, `pure` can be seen as the
 * function which lifts functions of _zero_ arguments. That is, `Applicative` functors support a lifting operation for
 * any number of function arguments.
 *
 * Instances must satisfy the following laws in addition to the `Apply` laws:
 *
 * 1. Identity: `A.ap(A.of(a => a), fa) <-> fa`
 * 2. Homomorphism: `A.ap(A.of(ab), A.of(a)) <-> A.of(ab(a))`
 * 3. Interchange: `A.ap(fab, A.of(a)) <-> A.ap(A.of(ab => ab(a)), fab)`
 *
 * Note. `Functor`'s `map` can be derived: `A.map(x, f) = A.ap(A.of(f), x)`
 *
 * @since 2.0.0
 */ 
var $4AIBj = parcelRequire("4AIBj");

var $lWM6H = parcelRequire("lWM6H");

var $gnzaQ = parcelRequire("gnzaQ");
function $e2b3372559168924$export$c8e1a8ea383fd0ff(F) {
    var f = (0, $4AIBj.getApplySemigroup)(F);
    return function(M) {
        return {
            concat: f(M).concat,
            empty: F.of(M.empty)
        };
    };
}
function $e2b3372559168924$export$9833a940afed18f3(F, G) {
    var map = (0, $gnzaQ.getFunctorComposition)(F, G).map;
    var _ap = (0, $4AIBj.ap)(F, G);
    return {
        map: map,
        of: function(a) {
            return F.of(G.of(a));
        },
        ap: function(fgab, fga) {
            return (0, $lWM6H.pipe)(fgab, _ap(fga));
        }
    };
}

});

parcelRegister("806pa", function(module, exports) {

$parcel$export(module.exports, "not", () => $5d334ab8901f686d$export$6003a5f097c73977);

var $lWM6H = parcelRequire("lWM6H");
var $5d334ab8901f686d$var$contramap_ = function(predicate, f) {
    return (0, $lWM6H.pipe)(predicate, $5d334ab8901f686d$export$53b696d27ecb7ba7(f));
};
var $5d334ab8901f686d$export$53b696d27ecb7ba7 = function(f) {
    return function(predicate) {
        return (0, $lWM6H.flow)(f, predicate);
    };
};
var $5d334ab8901f686d$export$9156e739aa33e19f = 'Predicate';
var $5d334ab8901f686d$export$45c71cec3a7e90aa = function() {
    return {
        concat: function(first, second) {
            return (0, $lWM6H.pipe)(first, $5d334ab8901f686d$export$252bb8b3bbdf6749(second));
        }
    };
};
var $5d334ab8901f686d$export$d795ff673668f564 = function() {
    return {
        concat: $5d334ab8901f686d$export$45c71cec3a7e90aa().concat,
        empty: (0, $lWM6H.constFalse)
    };
};
var $5d334ab8901f686d$export$d900a29579818780 = function() {
    return {
        concat: function(first, second) {
            return (0, $lWM6H.pipe)(first, $5d334ab8901f686d$export$21c0ac7fe1cef1b8(second));
        }
    };
};
var $5d334ab8901f686d$export$4c43b04d78b174fa = function() {
    return {
        concat: $5d334ab8901f686d$export$d900a29579818780().concat,
        empty: (0, $lWM6H.constTrue)
    };
};
var $5d334ab8901f686d$export$def901a57d5539c3 = {
    URI: $5d334ab8901f686d$export$9156e739aa33e19f,
    contramap: $5d334ab8901f686d$var$contramap_
};
var $5d334ab8901f686d$export$6003a5f097c73977 = function(predicate) {
    return function(a) {
        return !predicate(a);
    };
};
var $5d334ab8901f686d$export$252bb8b3bbdf6749 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) || second(a);
        };
    };
};
var $5d334ab8901f686d$export$21c0ac7fe1cef1b8 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) && second(a);
        };
    };
};

});


parcelRegister("aOL40", function(module, exports) {

$parcel$export(module.exports, "pipe", () => $7e0314c0be76c1bb$export$a4627e546088548d);

var $4AIBj = parcelRequire("4AIBj");

var $iXLA9 = parcelRequire("iXLA9");

var $lWM6H = parcelRequire("lWM6H");
function $7e0314c0be76c1bb$export$871de8747c9eaa88(F) {
    return function(f) {
        return function(fa) {
            return F.map(fa, f);
        };
    };
}
function $7e0314c0be76c1bb$export$53b696d27ecb7ba7(F) {
    return function(f) {
        return function(fa) {
            return F.contramap(fa, f);
        };
    };
}
function $7e0314c0be76c1bb$export$8f07ddce13659f50(F) {
    return function(f) {
        return function(fa) {
            return F.mapWithIndex(fa, f);
        };
    };
}
function $7e0314c0be76c1bb$export$2f6ca3d3b1f80bf5(F) {
    return function(fa) {
        return function(fab) {
            return F.ap(fab, fa);
        };
    };
}
function $7e0314c0be76c1bb$export$e08e3b67e392101e(F) {
    return function(f) {
        return function(fa) {
            return F.chain(fa, f);
        };
    };
}
function $7e0314c0be76c1bb$export$eb54baf0b342cb1d(F) {
    return function(f, g) {
        return function(fea) {
            return F.bimap(fea, f, g);
        };
    };
}
function $7e0314c0be76c1bb$export$472de43a55e4aa49(F) {
    return function(f) {
        return function(fea) {
            return F.mapLeft(fea, f);
        };
    };
}
function $7e0314c0be76c1bb$export$8b58be045bf06082(F) {
    return function(f) {
        return function(wa) {
            return F.extend(wa, f);
        };
    };
}
function $7e0314c0be76c1bb$export$533b26079ad0b4b(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduce(fa, b, f);
        };
    };
}
function $7e0314c0be76c1bb$export$b66cdc0497d8a99a(F) {
    return function(M) {
        var foldMapM = F.foldMap(M);
        return function(f) {
            return function(fa) {
                return foldMapM(fa, f);
            };
        };
    };
}
function $7e0314c0be76c1bb$export$7fef8bcdbb34f435(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRight(fa, b, f);
        };
    };
}
function $7e0314c0be76c1bb$export$bbd3ef8720e22369(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceWithIndex(fa, b, f);
        };
    };
}
function $7e0314c0be76c1bb$export$18153bb1181268e5(F) {
    return function(M) {
        var foldMapWithIndexM = F.foldMapWithIndex(M);
        return function(f) {
            return function(fa) {
                return foldMapWithIndexM(fa, f);
            };
        };
    };
}
function $7e0314c0be76c1bb$export$ce2b2fe0b88ccd0a(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRightWithIndex(fa, b, f);
        };
    };
}
function $7e0314c0be76c1bb$export$228be17d80722ab(F) {
    return function(that) {
        return function(fa) {
            return F.alt(fa, that);
        };
    };
}
function $7e0314c0be76c1bb$export$3dea766d36a8935f(F) {
    return function(predicate) {
        return function(fa) {
            return F.filter(fa, predicate);
        };
    };
}
function $7e0314c0be76c1bb$export$a04c6c6965dd4709(F) {
    return function(f) {
        return function(fa) {
            return F.filterMap(fa, f);
        };
    };
}
function $7e0314c0be76c1bb$export$b29f828819edca8d(F) {
    return function(f) {
        return function(fa) {
            return F.partition(fa, f);
        };
    };
}
function $7e0314c0be76c1bb$export$3117e3f9ececb6bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMap(fa, f);
        };
    };
}
function $7e0314c0be76c1bb$export$36e42aef19fc7171(F) {
    return function(predicate) {
        return function(fa) {
            return F.filterWithIndex(fa, predicate);
        };
    };
}
function $7e0314c0be76c1bb$export$30c5cbe848021e97(F) {
    return function(f) {
        return function(fa) {
            return F.filterMapWithIndex(fa, f);
        };
    };
}
function $7e0314c0be76c1bb$export$dad5e500f2bab9bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionWithIndex(fa, f);
        };
    };
}
function $7e0314c0be76c1bb$export$bc7c0794b9c6f3ba(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMapWithIndex(fa, f);
        };
    };
}
function $7e0314c0be76c1bb$export$6684e88861ab74ec(F) {
    return function(f, g) {
        return function(fbc) {
            return F.promap(fbc, f, g);
        };
    };
}
function $7e0314c0be76c1bb$export$f672e0b6f7222cd7(F) {
    return function(ea) {
        return function(ab) {
            return F.compose(ab, ea);
        };
    };
}
var $7e0314c0be76c1bb$var$isFunctor = function(I) {
    return typeof I.map === 'function';
};
var $7e0314c0be76c1bb$var$isContravariant = function(I) {
    return typeof I.contramap === 'function';
};
var $7e0314c0be76c1bb$var$isFunctorWithIndex = function(I) {
    return typeof I.mapWithIndex === 'function';
};
var $7e0314c0be76c1bb$var$isApply = function(I) {
    return typeof I.ap === 'function';
};
var $7e0314c0be76c1bb$var$isChain = function(I) {
    return typeof I.chain === 'function';
};
var $7e0314c0be76c1bb$var$isBifunctor = function(I) {
    return typeof I.bimap === 'function';
};
var $7e0314c0be76c1bb$var$isExtend = function(I) {
    return typeof I.extend === 'function';
};
var $7e0314c0be76c1bb$var$isFoldable = function(I) {
    return typeof I.reduce === 'function';
};
var $7e0314c0be76c1bb$var$isFoldableWithIndex = function(I) {
    return typeof I.reduceWithIndex === 'function';
};
var $7e0314c0be76c1bb$var$isAlt = function(I) {
    return typeof I.alt === 'function';
};
var $7e0314c0be76c1bb$var$isCompactable = function(I) {
    return typeof I.compact === 'function';
};
var $7e0314c0be76c1bb$var$isFilterable = function(I) {
    return typeof I.filter === 'function';
};
var $7e0314c0be76c1bb$var$isFilterableWithIndex = function(I) {
    return typeof I.filterWithIndex === 'function';
};
var $7e0314c0be76c1bb$var$isProfunctor = function(I) {
    return typeof I.promap === 'function';
};
var $7e0314c0be76c1bb$var$isSemigroupoid = function(I) {
    return typeof I.compose === 'function';
};
var $7e0314c0be76c1bb$var$isMonadThrow = function(I) {
    return typeof I.throwError === 'function';
};
function $7e0314c0be76c1bb$export$1124ffa357d27237(I) {
    var r = {};
    if ($7e0314c0be76c1bb$var$isFunctor(I)) r.map = $7e0314c0be76c1bb$export$871de8747c9eaa88(I);
    if ($7e0314c0be76c1bb$var$isContravariant(I)) r.contramap = $7e0314c0be76c1bb$export$53b696d27ecb7ba7(I);
    if ($7e0314c0be76c1bb$var$isFunctorWithIndex(I)) r.mapWithIndex = $7e0314c0be76c1bb$export$8f07ddce13659f50(I);
    if ($7e0314c0be76c1bb$var$isApply(I)) {
        r.ap = $7e0314c0be76c1bb$export$2f6ca3d3b1f80bf5(I);
        r.apFirst = (0, $4AIBj.apFirst)(I);
        r.apSecond = (0, $4AIBj.apSecond)(I);
    }
    if ($7e0314c0be76c1bb$var$isChain(I)) {
        r.chain = $7e0314c0be76c1bb$export$e08e3b67e392101e(I);
        r.chainFirst = (0, $iXLA9.chainFirst)(I);
        r.flatten = r.chain((0, $lWM6H.identity));
    }
    if ($7e0314c0be76c1bb$var$isBifunctor(I)) {
        r.bimap = $7e0314c0be76c1bb$export$eb54baf0b342cb1d(I);
        r.mapLeft = $7e0314c0be76c1bb$export$472de43a55e4aa49(I);
    }
    if ($7e0314c0be76c1bb$var$isExtend(I)) {
        r.extend = $7e0314c0be76c1bb$export$8b58be045bf06082(I);
        r.duplicate = r.extend((0, $lWM6H.identity));
    }
    if ($7e0314c0be76c1bb$var$isFoldable(I)) {
        r.reduce = $7e0314c0be76c1bb$export$533b26079ad0b4b(I);
        r.foldMap = $7e0314c0be76c1bb$export$b66cdc0497d8a99a(I);
        r.reduceRight = $7e0314c0be76c1bb$export$7fef8bcdbb34f435(I);
    }
    if ($7e0314c0be76c1bb$var$isFoldableWithIndex(I)) {
        r.reduceWithIndex = $7e0314c0be76c1bb$export$bbd3ef8720e22369(I);
        r.foldMapWithIndex = $7e0314c0be76c1bb$export$18153bb1181268e5(I);
        r.reduceRightWithIndex = $7e0314c0be76c1bb$export$ce2b2fe0b88ccd0a(I);
    }
    if ($7e0314c0be76c1bb$var$isAlt(I)) r.alt = $7e0314c0be76c1bb$export$228be17d80722ab(I);
    if ($7e0314c0be76c1bb$var$isCompactable(I)) {
        r.compact = I.compact;
        r.separate = I.separate;
    }
    if ($7e0314c0be76c1bb$var$isFilterable(I)) {
        r.filter = $7e0314c0be76c1bb$export$3dea766d36a8935f(I);
        r.filterMap = $7e0314c0be76c1bb$export$a04c6c6965dd4709(I);
        r.partition = $7e0314c0be76c1bb$export$b29f828819edca8d(I);
        r.partitionMap = $7e0314c0be76c1bb$export$3117e3f9ececb6bc(I);
    }
    if ($7e0314c0be76c1bb$var$isFilterableWithIndex(I)) {
        r.filterWithIndex = $7e0314c0be76c1bb$export$36e42aef19fc7171(I);
        r.filterMapWithIndex = $7e0314c0be76c1bb$export$30c5cbe848021e97(I);
        r.partitionWithIndex = $7e0314c0be76c1bb$export$dad5e500f2bab9bc(I);
        r.partitionMapWithIndex = $7e0314c0be76c1bb$export$bc7c0794b9c6f3ba(I);
    }
    if ($7e0314c0be76c1bb$var$isProfunctor(I)) r.promap = $7e0314c0be76c1bb$export$6684e88861ab74ec(I);
    if ($7e0314c0be76c1bb$var$isSemigroupoid(I)) r.compose = $7e0314c0be76c1bb$export$f672e0b6f7222cd7(I);
    if ($7e0314c0be76c1bb$var$isMonadThrow(I)) {
        var fromOption = function(onNone) {
            return function(ma) {
                return ma._tag === 'None' ? I.throwError(onNone()) : I.of(ma.value);
            };
        };
        var fromEither = function(ma) {
            return ma._tag === 'Left' ? I.throwError(ma.left) : I.of(ma.right);
        };
        var fromPredicate = function(predicate, onFalse) {
            return function(a) {
                return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
            };
        };
        var filterOrElse = function(predicate, onFalse) {
            return function(ma) {
                return I.chain(ma, function(a) {
                    return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
                });
            };
        };
        r.fromOption = fromOption;
        r.fromEither = fromEither;
        r.fromPredicate = fromPredicate;
        r.filterOrElse = filterOrElse;
    }
    return r;
}
var $7e0314c0be76c1bb$export$a4627e546088548d = (0, $lWM6H.pipe);

});

parcelRegister("7x7NY", function(module, exports) {

$parcel$export(module.exports, "fromIso", () => $57c1ab64fea7ae17$export$3160d47a1ad63980);

var $5OFXS = parcelRequire("5OFXS");

var $aOL40 = parcelRequire("aOL40");

var $477ze = parcelRequire("477ze");

var $a1Wdc = parcelRequire("a1Wdc");

var $aYQcG = parcelRequire("aYQcG");
var $57c1ab64fea7ae17$export$493d36ec626b6698 = $aYQcG.at;
var $57c1ab64fea7ae17$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $57c1ab64fea7ae17$export$493d36ec626b6698(function(i) {
            return (0, $aOL40.pipe)(iso, $aYQcG.isoAsLens, $aYQcG.lensComposeLens(sia.at(i)));
        });
    };
};
var $57c1ab64fea7ae17$export$ba8573d258bae607 = $aYQcG.atReadonlyRecord;
var $57c1ab64fea7ae17$export$3d6583cb45ca961e = function(E) {
    var lookupE = $477ze.lookup(E);
    var deleteAtE = $477ze.deleteAt(E);
    var insertAtE = $477ze.insertAt(E);
    return function() {
        return $57c1ab64fea7ae17$export$493d36ec626b6698(function(key) {
            return $aYQcG.lens(function(s) {
                return lookupE(key, s);
            }, $5OFXS.fold(function() {
                return deleteAtE(key);
            }, function(a) {
                return insertAtE(key, a);
            }));
        });
    };
};
var $57c1ab64fea7ae17$export$388a7d8e51ea972f = function(E) {
    var elemE = $a1Wdc.elem(E);
    var insertE = $a1Wdc.insert(E);
    var removeE = $a1Wdc.remove(E);
    return $57c1ab64fea7ae17$export$493d36ec626b6698(function(a) {
        var insert = insertE(a);
        var remove = removeE(a);
        return $aYQcG.lens(function(s) {
            return elemE(a, s);
        }, function(b) {
            return function(s) {
                return b ? insert(s) : remove(s);
            };
        });
    });
};
var $57c1ab64fea7ae17$export$1cfc761eca4929a9 = $aYQcG.atReadonlyRecord;

});
parcelRegister("477ze", function(module, exports) {

$parcel$export(module.exports, "lookup", () => $2fedaf91b1c9eb4d$export$dfc7155ac0343b8);
$parcel$export(module.exports, "deleteAt", () => $2fedaf91b1c9eb4d$export$90f9093465da3136);
$parcel$export(module.exports, "insertAt", () => $2fedaf91b1c9eb4d$export$9f200c4466975173);

var $bOO3o = parcelRequire("bOO3o");

var $lWM6H = parcelRequire("lWM6H");

var $gnzaQ = parcelRequire("gnzaQ");

var $9sd2T = parcelRequire("9sd2T");

var $5OFXS = parcelRequire("5OFXS");

var $fYAej = parcelRequire("fYAej");

var $loyJ7 = parcelRequire("loyJ7");
var $2fedaf91b1c9eb4d$export$d81aa96f14f987cc = function(m) {
    return new Map(m);
};
function $2fedaf91b1c9eb4d$export$e98af36a72b77685(m) {
    return new Map(m);
}
function $2fedaf91b1c9eb4d$export$3cb5cd7f7776c81(SK, SA) {
    return {
        show: function(m) {
            var entries = [];
            m.forEach(function(a, k) {
                entries.push("[".concat(SK.show(k), ", ").concat(SA.show(a), "]"));
            });
            return "new Map([".concat(entries.sort().join(', '), "])");
        }
    };
}
var $2fedaf91b1c9eb4d$export$346677f925de839c = function(m) {
    return m.size;
};
var $2fedaf91b1c9eb4d$export$dd1bc94b04021eeb = function(m) {
    return m.size === 0;
};
function $2fedaf91b1c9eb4d$export$6a0d13241802fe80(E) {
    var lookupE = $2fedaf91b1c9eb4d$export$dfc7155ac0343b8(E);
    return function(k, m) {
        if (m === undefined) {
            var memberE_1 = $2fedaf91b1c9eb4d$export$6a0d13241802fe80(E);
            return function(m) {
                return memberE_1(k, m);
            };
        }
        return $9sd2T.isSome(lookupE(k, m));
    };
}
function $2fedaf91b1c9eb4d$export$5bf96401662340b7(E) {
    return function(a, m) {
        if (m === undefined) {
            var elemE_1 = $2fedaf91b1c9eb4d$export$5bf96401662340b7(E);
            return function(m) {
                return elemE_1(a, m);
            };
        }
        var values = m.values();
        var e;
        while(!(e = values.next()).done){
            var v = e.value;
            if (E.equals(a, v)) return true;
        }
        return false;
    };
}
var $2fedaf91b1c9eb4d$export$ed97f33186d4b816 = function(O) {
    return function(m) {
        return Array.from(m.keys()).sort(O.compare);
    };
};
var $2fedaf91b1c9eb4d$export$68c286be0e7e55b7 = function(O) {
    return function(m) {
        return Array.from(m.values()).sort(O.compare);
    };
};
function $2fedaf91b1c9eb4d$export$bb44f104e3c54dae(O) {
    var keysO = $2fedaf91b1c9eb4d$export$ed97f33186d4b816(O);
    return function(f) {
        return function(m) {
            var out = [];
            var ks = keysO(m);
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                out.push(f(key, m.get(key)));
            }
            return out;
        };
    };
}
var $2fedaf91b1c9eb4d$export$4aaa3912a3956cb7 = function(O) {
    return $2fedaf91b1c9eb4d$export$bb44f104e3c54dae(O)(function(k, a) {
        return [
            k,
            a
        ];
    });
};
function $2fedaf91b1c9eb4d$export$823be24f8766da23(ord, U) {
    var toReadonlyArrayO = $2fedaf91b1c9eb4d$export$4aaa3912a3956cb7(ord);
    return function(d) {
        var kas = toReadonlyArrayO(d);
        var len = kas.length;
        return U.unfold(0, function(b) {
            return b < len ? $9sd2T.some([
                kas[b],
                b + 1
            ]) : $9sd2T.none;
        });
    };
}
var $2fedaf91b1c9eb4d$export$ff82449ce381c54a = function(E) {
    var lookupWithKeyE = $2fedaf91b1c9eb4d$export$40b8019a6fc8a5ae(E);
    return function(k, a) {
        var lookupWithKeyEk = lookupWithKeyE(k);
        return function(m) {
            var found = lookupWithKeyEk(m);
            if ($9sd2T.isNone(found)) {
                var out = new Map(m);
                out.set(k, a);
                return out;
            } else if (found.value[1] !== a) {
                var out = new Map(m);
                out.set(found.value[0], a);
                return out;
            }
            return m;
        };
    };
};
var $2fedaf91b1c9eb4d$export$90f9093465da3136 = function(E) {
    var lookupWithKeyE = $2fedaf91b1c9eb4d$export$40b8019a6fc8a5ae(E);
    return function(k) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($9sd2T.isSome(found)) {
                var r = new Map(m);
                r.delete(found.value[0]);
                return r;
            }
            return m;
        };
    };
};
var $2fedaf91b1c9eb4d$export$b6d8713d53419d4c = function(E) {
    var modifyAtE = $2fedaf91b1c9eb4d$export$cba09f9e3d3e58eb(E);
    return function(k, a) {
        return modifyAtE(k, function() {
            return a;
        });
    };
};
var $2fedaf91b1c9eb4d$export$cba09f9e3d3e58eb = function(E) {
    var lookupWithKeyE = $2fedaf91b1c9eb4d$export$40b8019a6fc8a5ae(E);
    return function(k, f) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($9sd2T.isNone(found)) return $9sd2T.none;
            var _a = found.value, fk = _a[0], fv = _a[1];
            var next = f(fv);
            if (next === fv) return $9sd2T.some(m);
            var r = new Map(m);
            r.set(fk, next);
            return $9sd2T.some(r);
        };
    };
};
function $2fedaf91b1c9eb4d$export$3e41007ebfff0e64(E) {
    var lookupE = $2fedaf91b1c9eb4d$export$dfc7155ac0343b8(E);
    var deleteAtE = $2fedaf91b1c9eb4d$export$90f9093465da3136(E);
    return function(k) {
        var deleteAtEk = deleteAtE(k);
        return function(m) {
            return (0, $lWM6H.pipe)(lookupE(k, m), $5OFXS.map(function(a) {
                return [
                    a,
                    deleteAtEk(m)
                ];
            }));
        };
    };
}
function $2fedaf91b1c9eb4d$export$40b8019a6fc8a5ae(E) {
    return function(k, m) {
        if (m === undefined) {
            var lookupWithKeyE_1 = $2fedaf91b1c9eb4d$export$40b8019a6fc8a5ae(E);
            return function(m) {
                return lookupWithKeyE_1(k, m);
            };
        }
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, ka = _a[0], a = _a[1];
            if (E.equals(ka, k)) return $9sd2T.some([
                ka,
                a
            ]);
        }
        return $9sd2T.none;
    };
}
function $2fedaf91b1c9eb4d$export$dfc7155ac0343b8(E) {
    var lookupWithKeyE = $2fedaf91b1c9eb4d$export$40b8019a6fc8a5ae(E);
    return function(k, m) {
        if (m === undefined) {
            var lookupE_1 = $2fedaf91b1c9eb4d$export$dfc7155ac0343b8(E);
            return function(m) {
                return lookupE_1(k, m);
            };
        }
        return (0, $lWM6H.pipe)(lookupWithKeyE(k, m), $5OFXS.map(function(_a) {
            var _ = _a[0], a = _a[1];
            return a;
        }));
    };
}
function $2fedaf91b1c9eb4d$export$35d0420a84c5d3ae(SK, SA) {
    var lookupWithKeyS = $2fedaf91b1c9eb4d$export$40b8019a6fc8a5ae(SK);
    return function(me, that) {
        if (that === undefined) {
            var isSubmapSKSA_1 = $2fedaf91b1c9eb4d$export$35d0420a84c5d3ae(SK, SA);
            return function(that) {
                return isSubmapSKSA_1(that, me);
            };
        }
        var entries = me.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var d2OptA = lookupWithKeyS(k, that);
            if ($9sd2T.isNone(d2OptA) || !SK.equals(k, d2OptA.value[0]) || !SA.equals(a, d2OptA.value[1])) return false;
        }
        return true;
    };
}
var $2fedaf91b1c9eb4d$export$6e22c362a0406a2c = // the type annotation here is intended (otherwise it doesn't type-check)
new Map();
function $2fedaf91b1c9eb4d$export$804fed467fde44e4(SK, SA) {
    var isSubmapSKSA = $2fedaf91b1c9eb4d$export$35d0420a84c5d3ae(SK, SA);
    return (0, $bOO3o.fromEquals)(function(x, y) {
        return isSubmapSKSA(x, y) && isSubmapSKSA(y, x);
    });
}
function $2fedaf91b1c9eb4d$export$c2a7ef2cc9b32b31(SK, SA) {
    var lookupWithKeyS = $2fedaf91b1c9eb4d$export$40b8019a6fc8a5ae(SK);
    return {
        concat: function(mx, my) {
            if ($2fedaf91b1c9eb4d$export$dd1bc94b04021eeb(mx)) return my;
            if ($2fedaf91b1c9eb4d$export$dd1bc94b04021eeb(my)) return mx;
            var r = new Map(mx);
            var entries = my.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var mxOptA = lookupWithKeyS(k, mx);
                if ($9sd2T.isSome(mxOptA)) r.set(mxOptA.value[0], SA.concat(mxOptA.value[1], a));
                else r.set(k, a);
            }
            return r;
        },
        empty: $2fedaf91b1c9eb4d$export$6e22c362a0406a2c
    };
}
var $2fedaf91b1c9eb4d$export$439306a4dcaafbb9 = function(k, a) {
    return new Map([
        [
            k,
            a
        ]
    ]);
};
function $2fedaf91b1c9eb4d$export$b7d5d9bb9ff52072(E, M, F) {
    return function(fka) {
        var lookupWithKeyE = $2fedaf91b1c9eb4d$export$40b8019a6fc8a5ae(E);
        return F.reduce(fka, new Map(), function(b, _a) {
            var k = _a[0], a = _a[1];
            var bOpt = lookupWithKeyE(k, b);
            if ($9sd2T.isSome(bOpt)) b.set(bOpt.value[0], M.concat(bOpt.value[1], a));
            else b.set(k, a);
            return b;
        });
    };
}
var $2fedaf91b1c9eb4d$var$_mapWithIndex = function(fa, f) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, key = _a[0], a = _a[1];
        m.set(key, f(key, a));
    }
    return m;
};
var $2fedaf91b1c9eb4d$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = new Map();
        var right = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var ei = f(k, a);
            if ($9sd2T.isLeft(ei)) left.set(k, ei.left);
            else right.set(k, ei.right);
        }
        return (0, $fYAej.separated)(left, right);
    };
};
function $2fedaf91b1c9eb4d$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(m) {
        var left = new Map();
        var right = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) right.set(k, a);
            else left.set(k, a);
        }
        return (0, $fYAej.separated)(left, right);
    };
}
var $2fedaf91b1c9eb4d$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var m = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var o = f(k, a);
            if ($9sd2T.isSome(o)) m.set(k, o.value);
        }
        return m;
    };
};
function $2fedaf91b1c9eb4d$export$36e42aef19fc7171(predicateWithIndex) {
    return function(m) {
        var out = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) out.set(k, a);
        }
        return out;
    };
}
var $2fedaf91b1c9eb4d$var$_map = function(fa, f) {
    return $2fedaf91b1c9eb4d$var$_mapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $2fedaf91b1c9eb4d$var$_filter = function(fa, p) {
    return $2fedaf91b1c9eb4d$var$_filterWithIndex(fa, function(_, a) {
        return p(a);
    });
};
var $2fedaf91b1c9eb4d$var$_filterMap = function(fa, f) {
    return $2fedaf91b1c9eb4d$var$_filterMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $2fedaf91b1c9eb4d$var$_partition = function(fa, predicate) {
    return $2fedaf91b1c9eb4d$var$_partitionWithIndex(fa, function(_, a) {
        return predicate(a);
    });
};
var $2fedaf91b1c9eb4d$var$_partitionMap = function(fa, f) {
    return $2fedaf91b1c9eb4d$var$_partitionMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $2fedaf91b1c9eb4d$var$_filterWithIndex = function(fa, p) {
    return (0, $lWM6H.pipe)(fa, $2fedaf91b1c9eb4d$export$36e42aef19fc7171(p));
};
var $2fedaf91b1c9eb4d$var$_filterMapWithIndex = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $2fedaf91b1c9eb4d$export$30c5cbe848021e97(f));
};
var $2fedaf91b1c9eb4d$var$_partitionWithIndex = function(fa, p) {
    return (0, $lWM6H.pipe)(fa, $2fedaf91b1c9eb4d$export$dad5e500f2bab9bc(p));
};
var $2fedaf91b1c9eb4d$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $2fedaf91b1c9eb4d$export$bc7c0794b9c6f3ba(f));
};
var $2fedaf91b1c9eb4d$export$8e16b83750b44988 = function(fa) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], oa = _a[1];
        if ($9sd2T.isSome(oa)) m.set(k, oa.value);
    }
    return m;
};
var $2fedaf91b1c9eb4d$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $2fedaf91b1c9eb4d$var$_filter(fa, predicate);
    };
};
var $2fedaf91b1c9eb4d$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $2fedaf91b1c9eb4d$var$_filterMap(fa, f);
    };
};
var $2fedaf91b1c9eb4d$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $2fedaf91b1c9eb4d$var$_map(fa, f);
    };
};
var $2fedaf91b1c9eb4d$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return $2fedaf91b1c9eb4d$var$_mapWithIndex(fa, f);
    };
};
var $2fedaf91b1c9eb4d$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return $2fedaf91b1c9eb4d$var$_partition(fa, predicate);
    };
};
var $2fedaf91b1c9eb4d$export$3117e3f9ececb6bc = function(f) {
    return function(fa) {
        return $2fedaf91b1c9eb4d$var$_partitionMap(fa, f);
    };
};
var $2fedaf91b1c9eb4d$export$709f6946f4e97408 = function(fa) {
    var left = new Map();
    var right = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], ei = _a[1];
        if ($9sd2T.isLeft(ei)) left.set(k, ei.left);
        else right.set(k, ei.right);
    }
    return (0, $fYAej.separated)(left, right);
};
var $2fedaf91b1c9eb4d$export$9156e739aa33e19f = 'ReadonlyMap';
var $2fedaf91b1c9eb4d$export$baca17b4aff42f82 = function(E, S) {
    var unionES = $2fedaf91b1c9eb4d$export$971dd5b0dfd021b6(E, S);
    return {
        concat: function(first, second) {
            return unionES(second)(first);
        }
    };
};
var $2fedaf91b1c9eb4d$export$c487aac9f4157837 = function(E, S) {
    return {
        concat: $2fedaf91b1c9eb4d$export$baca17b4aff42f82(E, S).concat,
        empty: $2fedaf91b1c9eb4d$export$6e22c362a0406a2c
    };
};
var $2fedaf91b1c9eb4d$export$d379a869a72e4055 = function(E, S) {
    var intersectionES = $2fedaf91b1c9eb4d$export$bc86dfbf7795668c(E, S);
    return {
        concat: function(first, second) {
            return intersectionES(second)(first);
        }
    };
};
var $2fedaf91b1c9eb4d$export$fdb3296ca0a124e3 = function(E) {
    return function() {
        var differenceE = $2fedaf91b1c9eb4d$export$acaf96a27438246b(E);
        return {
            concat: function(first, second) {
                return differenceE(second)(first);
            }
        };
    };
};
function $2fedaf91b1c9eb4d$export$d600270efcad85ac() {
    return {
        URI: $2fedaf91b1c9eb4d$export$9156e739aa33e19f,
        _E: undefined,
        map: $2fedaf91b1c9eb4d$var$_map,
        mapWithIndex: $2fedaf91b1c9eb4d$var$_mapWithIndex,
        compact: $2fedaf91b1c9eb4d$export$8e16b83750b44988,
        separate: $2fedaf91b1c9eb4d$export$709f6946f4e97408,
        filter: $2fedaf91b1c9eb4d$var$_filter,
        filterMap: $2fedaf91b1c9eb4d$var$_filterMap,
        partition: $2fedaf91b1c9eb4d$var$_partition,
        partitionMap: $2fedaf91b1c9eb4d$var$_partitionMap,
        partitionMapWithIndex: $2fedaf91b1c9eb4d$var$_partitionMapWithIndex,
        partitionWithIndex: $2fedaf91b1c9eb4d$var$_partitionWithIndex,
        filterMapWithIndex: $2fedaf91b1c9eb4d$var$_filterMapWithIndex,
        filterWithIndex: $2fedaf91b1c9eb4d$var$_filterWithIndex
    };
}
var $2fedaf91b1c9eb4d$export$bd5b6bfc5fa2ee61 = {
    URI: $2fedaf91b1c9eb4d$export$9156e739aa33e19f,
    map: $2fedaf91b1c9eb4d$var$_map
};
var $2fedaf91b1c9eb4d$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $gnzaQ.flap)($2fedaf91b1c9eb4d$export$bd5b6bfc5fa2ee61);
var $2fedaf91b1c9eb4d$export$7c7748da5f3db60f = function() {
    return {
        URI: $2fedaf91b1c9eb4d$export$9156e739aa33e19f,
        _E: undefined,
        map: $2fedaf91b1c9eb4d$var$_map,
        mapWithIndex: $2fedaf91b1c9eb4d$var$_mapWithIndex
    };
};
var $2fedaf91b1c9eb4d$export$4a21ac48141ac3c9 = {
    URI: $2fedaf91b1c9eb4d$export$9156e739aa33e19f,
    compact: $2fedaf91b1c9eb4d$export$8e16b83750b44988,
    separate: $2fedaf91b1c9eb4d$export$709f6946f4e97408
};
var $2fedaf91b1c9eb4d$export$d00e1c48fb621173 = {
    URI: $2fedaf91b1c9eb4d$export$9156e739aa33e19f,
    map: $2fedaf91b1c9eb4d$var$_map,
    compact: $2fedaf91b1c9eb4d$export$8e16b83750b44988,
    separate: $2fedaf91b1c9eb4d$export$709f6946f4e97408,
    filter: $2fedaf91b1c9eb4d$var$_filter,
    filterMap: $2fedaf91b1c9eb4d$var$_filterMap,
    partition: $2fedaf91b1c9eb4d$var$_partition,
    partitionMap: $2fedaf91b1c9eb4d$var$_partitionMap
};
var $2fedaf91b1c9eb4d$export$533b26079ad0b4b = function(O) {
    var reduceWithIndexO = $2fedaf91b1c9eb4d$export$bbd3ef8720e22369(O);
    return function(b, f) {
        return reduceWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $2fedaf91b1c9eb4d$export$b66cdc0497d8a99a = function(O) {
    var foldMapWithIndexO = $2fedaf91b1c9eb4d$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexOM = foldMapWithIndexO(M);
        return function(f) {
            return foldMapWithIndexOM(function(_, a) {
                return f(a);
            });
        };
    };
};
var $2fedaf91b1c9eb4d$export$7fef8bcdbb34f435 = function(O) {
    var reduceRightWithIndexO = $2fedaf91b1c9eb4d$export$ce2b2fe0b88ccd0a(O);
    return function(b, f) {
        return reduceRightWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $2fedaf91b1c9eb4d$export$d544f02c7cebdaed = function(O) {
    var reduceO = $2fedaf91b1c9eb4d$export$533b26079ad0b4b(O);
    var foldMapO = $2fedaf91b1c9eb4d$export$b66cdc0497d8a99a(O);
    var reduceRightO = $2fedaf91b1c9eb4d$export$7fef8bcdbb34f435(O);
    return {
        URI: $2fedaf91b1c9eb4d$export$9156e739aa33e19f,
        _E: undefined,
        reduce: function(fa, b, f) {
            return (0, $lWM6H.pipe)(fa, reduceO(b, f));
        },
        foldMap: function(M) {
            var foldMapOM = foldMapO(M);
            return function(fa, f) {
                return (0, $lWM6H.pipe)(fa, foldMapOM(f));
            };
        },
        reduceRight: function(fa, b, f) {
            return (0, $lWM6H.pipe)(fa, reduceRightO(b, f));
        }
    };
};
var $2fedaf91b1c9eb4d$export$bbd3ef8720e22369 = function(O) {
    var keysO = $2fedaf91b1c9eb4d$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                var k = _a[_i];
                out = f(k, out, m.get(k));
            }
            return out;
        };
    };
};
var $2fedaf91b1c9eb4d$export$18153bb1181268e5 = function(O) {
    var keysO = $2fedaf91b1c9eb4d$export$ed97f33186d4b816(O);
    return function(M) {
        return function(f) {
            return function(m) {
                var out = M.empty;
                for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                    var k = _a[_i];
                    out = M.concat(out, f(k, m.get(k)));
                }
                return out;
            };
        };
    };
};
var $2fedaf91b1c9eb4d$export$ce2b2fe0b88ccd0a = function(O) {
    var keysO = $2fedaf91b1c9eb4d$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            var ks = keysO(m);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, m.get(k), out);
            }
            return out;
        };
    };
};
var $2fedaf91b1c9eb4d$export$6c59d75f118e7bc9 = function(O) {
    var F = $2fedaf91b1c9eb4d$export$d544f02c7cebdaed(O);
    var reduceWithIndexO = $2fedaf91b1c9eb4d$export$bbd3ef8720e22369(O);
    var foldMapWithIndexO = $2fedaf91b1c9eb4d$export$18153bb1181268e5(O);
    var reduceRightWithIndexO = $2fedaf91b1c9eb4d$export$ce2b2fe0b88ccd0a(O);
    return {
        URI: $2fedaf91b1c9eb4d$export$9156e739aa33e19f,
        _E: undefined,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        reduceWithIndex: function(fa, b, f) {
            return (0, $lWM6H.pipe)(fa, reduceWithIndexO(b, f));
        },
        foldMapWithIndex: function(M) {
            var foldMapWithIndexOM = foldMapWithIndexO(M);
            return function(fa, f) {
                return (0, $lWM6H.pipe)(fa, foldMapWithIndexOM(f));
            };
        },
        reduceRightWithIndex: function(fa, b, f) {
            return (0, $lWM6H.pipe)(fa, reduceRightWithIndexO(b, f));
        }
    };
};
var $2fedaf91b1c9eb4d$export$4e0ffba11065d2c1 = function(O) {
    var TWI = $2fedaf91b1c9eb4d$export$46b81797a3375b8c(O);
    var F = $2fedaf91b1c9eb4d$export$d544f02c7cebdaed(O);
    return {
        URI: $2fedaf91b1c9eb4d$export$9156e739aa33e19f,
        _E: undefined,
        map: $2fedaf91b1c9eb4d$var$_map,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence
    };
};
var $2fedaf91b1c9eb4d$export$46b81797a3375b8c = function(O) {
    var FWI = $2fedaf91b1c9eb4d$export$6c59d75f118e7bc9(O);
    var keysO = $2fedaf91b1c9eb4d$export$ed97f33186d4b816(O);
    var traverseWithIndex = function(F) {
        return function(ta, f) {
            var fm = F.of(new Map());
            var ks = keysO(ta);
            var len = ks.length;
            var _loop_1 = function(i) {
                var key = ks[i];
                var a = ta.get(key);
                fm = F.ap(F.map(fm, function(m) {
                    return function(b) {
                        return m.set(key, b);
                    };
                }), f(key, a));
            };
            for(var i = 0; i < len; i++)_loop_1(i);
            return fm;
        };
    };
    var traverse = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta, f) {
            return traverseWithIndexF(ta, function(_, a) {
                return f(a);
            });
        };
    };
    var sequence = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta) {
            return traverseWithIndexF(ta, (0, $lWM6H.SK));
        };
    };
    return {
        URI: $2fedaf91b1c9eb4d$export$9156e739aa33e19f,
        _E: undefined,
        map: $2fedaf91b1c9eb4d$var$_map,
        mapWithIndex: $2fedaf91b1c9eb4d$var$_mapWithIndex,
        reduce: FWI.reduce,
        foldMap: FWI.foldMap,
        reduceRight: FWI.reduceRight,
        reduceWithIndex: FWI.reduceWithIndex,
        foldMapWithIndex: FWI.foldMapWithIndex,
        reduceRightWithIndex: FWI.reduceRightWithIndex,
        traverse: traverse,
        sequence: sequence,
        traverseWithIndex: traverseWithIndex
    };
};
function $2fedaf91b1c9eb4d$export$bb8ef26a634cac7b(O) {
    var TWI = $2fedaf91b1c9eb4d$export$46b81797a3375b8c(O);
    return {
        URI: $2fedaf91b1c9eb4d$export$9156e739aa33e19f,
        _E: undefined,
        map: $2fedaf91b1c9eb4d$var$_map,
        compact: $2fedaf91b1c9eb4d$export$8e16b83750b44988,
        separate: $2fedaf91b1c9eb4d$export$709f6946f4e97408,
        filter: $2fedaf91b1c9eb4d$var$_filter,
        filterMap: $2fedaf91b1c9eb4d$var$_filterMap,
        partition: $2fedaf91b1c9eb4d$var$_partition,
        partitionMap: $2fedaf91b1c9eb4d$var$_partitionMap,
        reduce: TWI.reduce,
        foldMap: TWI.foldMap,
        reduceRight: TWI.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence,
        mapWithIndex: $2fedaf91b1c9eb4d$var$_mapWithIndex,
        reduceWithIndex: TWI.reduceWithIndex,
        foldMapWithIndex: TWI.foldMapWithIndex,
        reduceRightWithIndex: TWI.reduceRightWithIndex,
        traverseWithIndex: TWI.traverseWithIndex,
        wilt: (0, $loyJ7.wiltDefault)(TWI, $2fedaf91b1c9eb4d$export$4a21ac48141ac3c9),
        wither: (0, $loyJ7.witherDefault)(TWI, $2fedaf91b1c9eb4d$export$4a21ac48141ac3c9)
    };
}
var $2fedaf91b1c9eb4d$export$971dd5b0dfd021b6 = function(E, M) {
    var lookupE = $2fedaf91b1c9eb4d$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($2fedaf91b1c9eb4d$export$dd1bc94b04021eeb(first)) return second;
            if ($2fedaf91b1c9eb4d$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($9sd2T.isSome(oka)) out.set(k, M.concat(a, oka.value));
                else out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                var oka = lookupE(k)(out);
                if ($9sd2T.isNone(oka)) out.set(k, a);
            }
            return out;
        };
    };
};
var $2fedaf91b1c9eb4d$export$bc86dfbf7795668c = function(E, M) {
    var lookupE = $2fedaf91b1c9eb4d$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($2fedaf91b1c9eb4d$export$dd1bc94b04021eeb(first) || $2fedaf91b1c9eb4d$export$dd1bc94b04021eeb(second)) return $2fedaf91b1c9eb4d$export$6e22c362a0406a2c;
            var out = new Map();
            var entries = first.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($9sd2T.isSome(oka)) out.set(k, M.concat(a, oka.value));
            }
            return out;
        };
    };
};
var $2fedaf91b1c9eb4d$export$acaf96a27438246b = function(E) {
    var memberE = $2fedaf91b1c9eb4d$export$6a0d13241802fe80(E);
    return function(second) {
        return function(first) {
            if ($2fedaf91b1c9eb4d$export$dd1bc94b04021eeb(first)) return second;
            if ($2fedaf91b1c9eb4d$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                if (!memberE(k)(second)) out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                if (!memberE(k)(first)) out.set(k, a);
            }
            return out;
        };
    };
};
var $2fedaf91b1c9eb4d$export$9f200c4466975173 = $2fedaf91b1c9eb4d$export$ff82449ce381c54a;
var $2fedaf91b1c9eb4d$export$28562fb56044e6b5 = {
    URI: $2fedaf91b1c9eb4d$export$9156e739aa33e19f,
    map: $2fedaf91b1c9eb4d$var$_map,
    compact: $2fedaf91b1c9eb4d$export$8e16b83750b44988,
    separate: $2fedaf91b1c9eb4d$export$709f6946f4e97408,
    filter: $2fedaf91b1c9eb4d$var$_filter,
    filterMap: $2fedaf91b1c9eb4d$var$_filterMap,
    partition: $2fedaf91b1c9eb4d$var$_partition,
    partitionMap: $2fedaf91b1c9eb4d$var$_partitionMap
};

});

parcelRegister("a1Wdc", function(module, exports) {

$parcel$export(module.exports, "elem", () => $74d7270bc48c8b78$export$5bf96401662340b7);
$parcel$export(module.exports, "insert", () => $74d7270bc48c8b78$export$21a5ca8aa77d35ff);
$parcel$export(module.exports, "remove", () => $74d7270bc48c8b78$export$cd7f480d6b8286c3);

var $bOO3o = parcelRequire("bOO3o");

var $lWM6H = parcelRequire("lWM6H");

var $806pa = parcelRequire("806pa");

var $fYAej = parcelRequire("fYAej");
var $74d7270bc48c8b78$export$7d98477f9d1e986f = function(s) {
    return new Set(s);
};
var $74d7270bc48c8b78$export$439306a4dcaafbb9 = function(a) {
    return new Set([
        a
    ]);
};
var $74d7270bc48c8b78$export$9288e031f1846591 = function(E) {
    return function(as) {
        var len = as.length;
        var out = new Set();
        var has = $74d7270bc48c8b78$export$5bf96401662340b7(E);
        for(var i = 0; i < len; i++){
            var a = as[i];
            if (!has(a, out)) out.add(a);
        }
        return out;
    };
};
function $74d7270bc48c8b78$export$f416efe173c6901c(s) {
    return new Set(s);
}
function $74d7270bc48c8b78$export$871de8747c9eaa88(E) {
    var elemE = $74d7270bc48c8b78$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                var v = f(e);
                if (!elemE(v, r)) r.add(v);
            });
            return r;
        };
    };
}
function $74d7270bc48c8b78$export$e08e3b67e392101e(E) {
    var elemE = $74d7270bc48c8b78$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                f(e).forEach(function(e) {
                    if (!elemE(e, r)) r.add(e);
                });
            });
            return r;
        };
    };
}
function $74d7270bc48c8b78$export$3dea766d36a8935f(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var r = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) r.add(a);
        }
        return r;
    };
}
function $74d7270bc48c8b78$export$b29f828819edca8d(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var right = new Set();
        var left = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) right.add(a);
            else left.add(a);
        }
        return (0, $fYAej.separated)(left, right);
    };
}
function $74d7270bc48c8b78$export$971dd5b0dfd021b6(E) {
    var elemE = $74d7270bc48c8b78$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var unionE_1 = $74d7270bc48c8b78$export$971dd5b0dfd021b6(E);
            return function(that) {
                return unionE_1(me, that);
            };
        }
        if ($74d7270bc48c8b78$export$dd1bc94b04021eeb(me)) return that;
        if ($74d7270bc48c8b78$export$dd1bc94b04021eeb(that)) return me;
        var r = new Set(me);
        that.forEach(function(e) {
            if (!elemE(e, r)) r.add(e);
        });
        return r;
    };
}
function $74d7270bc48c8b78$export$bc86dfbf7795668c(E) {
    var elemE = $74d7270bc48c8b78$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var intersectionE_1 = $74d7270bc48c8b78$export$bc86dfbf7795668c(E);
            return function(that) {
                return intersectionE_1(that, me);
            };
        }
        if ($74d7270bc48c8b78$export$dd1bc94b04021eeb(me) || $74d7270bc48c8b78$export$dd1bc94b04021eeb(that)) return $74d7270bc48c8b78$export$6e22c362a0406a2c;
        var r = new Set();
        me.forEach(function(e) {
            if (elemE(e, that)) r.add(e);
        });
        return r;
    };
}
function $74d7270bc48c8b78$export$3117e3f9ececb6bc(EB, EC) {
    return function(f) {
        return function(set) {
            var values = set.values();
            var e;
            var left = new Set();
            var right = new Set();
            var hasB = $74d7270bc48c8b78$export$5bf96401662340b7(EB);
            var hasC = $74d7270bc48c8b78$export$5bf96401662340b7(EC);
            while(!(e = values.next()).done){
                var v = f(e.value);
                switch(v._tag){
                    case 'Left':
                        if (!hasB(v.left, left)) left.add(v.left);
                        break;
                    case 'Right':
                        if (!hasC(v.right, right)) right.add(v.right);
                        break;
                }
            }
            return (0, $fYAej.separated)(left, right);
        };
    };
}
function $74d7270bc48c8b78$export$acaf96a27438246b(E) {
    var elemE = $74d7270bc48c8b78$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var differenceE_1 = $74d7270bc48c8b78$export$acaf96a27438246b(E);
            return function(that) {
                return differenceE_1(that, me);
            };
        }
        return $74d7270bc48c8b78$export$3dea766d36a8935f(function(a) {
            return !elemE(a, that);
        })(me);
    };
}
function $74d7270bc48c8b78$export$533b26079ad0b4b(O) {
    var toReadonlyArrayO = $74d7270bc48c8b78$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(f, b);
        };
    };
}
function $74d7270bc48c8b78$export$b66cdc0497d8a99a(O, M) {
    var toReadonlyArrayO = $74d7270bc48c8b78$export$4aaa3912a3956cb7(O);
    return function(f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(function(b, a) {
                return M.concat(b, f(a));
            }, M.empty);
        };
    };
}
var $74d7270bc48c8b78$export$7fef8bcdbb34f435 = function(O) {
    var toReadonlyArrayO = $74d7270bc48c8b78$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduceRight(function(b, a) {
                return f(a, b);
            }, b);
        };
    };
};
function $74d7270bc48c8b78$export$21a5ca8aa77d35ff(E) {
    var elemE = $74d7270bc48c8b78$export$5bf96401662340b7(E);
    return function(a) {
        return function(set) {
            if (!elemE(a)(set)) {
                var r = new Set(set);
                r.add(a);
                return r;
            } else return set;
        };
    };
}
var $74d7270bc48c8b78$export$cd7f480d6b8286c3 = function(E) {
    return function(a) {
        return function(set) {
            return $74d7270bc48c8b78$export$3dea766d36a8935f(function(ax) {
                return !E.equals(a, ax);
            })(set);
        };
    };
};
var $74d7270bc48c8b78$export$e03c1c3201ee8bb7 = function(E) {
    var elemE = $74d7270bc48c8b78$export$5bf96401662340b7(E);
    var removeE = $74d7270bc48c8b78$export$cd7f480d6b8286c3(E);
    var insertE = $74d7270bc48c8b78$export$21a5ca8aa77d35ff(E);
    return function(a) {
        return function(set) {
            return (elemE(a, set) ? removeE : insertE)(a)(set);
        };
    };
};
var $74d7270bc48c8b78$export$8e16b83750b44988 = function(E) {
    return $74d7270bc48c8b78$export$a04c6c6965dd4709(E)((0, $lWM6H.identity));
};
function $74d7270bc48c8b78$export$709f6946f4e97408(EE, EA) {
    return function(fa) {
        var elemEE = $74d7270bc48c8b78$export$5bf96401662340b7(EE);
        var elemEA = $74d7270bc48c8b78$export$5bf96401662340b7(EA);
        var left = new Set();
        var right = new Set();
        fa.forEach(function(e) {
            switch(e._tag){
                case 'Left':
                    if (!elemEE(e.left, left)) left.add(e.left);
                    break;
                case 'Right':
                    if (!elemEA(e.right, right)) right.add(e.right);
                    break;
            }
        });
        return (0, $fYAej.separated)(left, right);
    };
}
function $74d7270bc48c8b78$export$a04c6c6965dd4709(E) {
    var elemE = $74d7270bc48c8b78$export$5bf96401662340b7(E);
    return function(f) {
        return function(fa) {
            var r = new Set();
            fa.forEach(function(a) {
                var ob = f(a);
                if (ob._tag === 'Some' && !elemE(ob.value, r)) r.add(ob.value);
            });
            return r;
        };
    };
}
var $74d7270bc48c8b78$export$6e22c362a0406a2c = new Set();
var $74d7270bc48c8b78$export$dd1bc94b04021eeb = function(set) {
    return set.size === 0;
};
var $74d7270bc48c8b78$export$346677f925de839c = function(set) {
    return set.size;
};
var $74d7270bc48c8b78$export$ad14ef4001db2bcd = function(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = predicate(e.value);
        return found;
    };
};
function $74d7270bc48c8b78$export$7ecc1a3b11b57dab(predicate) {
    return (0, $806pa.not)($74d7270bc48c8b78$export$ad14ef4001db2bcd((0, $806pa.not)(predicate)));
}
function $74d7270bc48c8b78$export$af04532ec9ff13d2(E) {
    var elemE = $74d7270bc48c8b78$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var isSubsetE_1 = $74d7270bc48c8b78$export$af04532ec9ff13d2(E);
            return function(that) {
                return isSubsetE_1(that, me);
            };
        }
        return $74d7270bc48c8b78$export$7ecc1a3b11b57dab(function(a) {
            return elemE(a, that);
        })(me);
    };
}
function $74d7270bc48c8b78$export$5bf96401662340b7(E) {
    return function(a, set) {
        if (set === undefined) {
            var elemE_1 = $74d7270bc48c8b78$export$5bf96401662340b7(E);
            return function(set) {
                return elemE_1(a, set);
            };
        }
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = E.equals(a, e.value);
        return found;
    };
}
var $74d7270bc48c8b78$export$4aaa3912a3956cb7 = function(O) {
    return function(set) {
        var out = [];
        set.forEach(function(e) {
            return out.push(e);
        });
        return out.sort(O.compare);
    };
};
var $74d7270bc48c8b78$export$9156e739aa33e19f = 'ReadonlySet';
function $74d7270bc48c8b78$export$3cb5cd7f7776c81(S) {
    return {
        show: function(s) {
            var entries = [];
            s.forEach(function(a) {
                entries.push(S.show(a));
            });
            return "new Set([".concat(entries.sort().join(', '), "])");
        }
    };
}
function $74d7270bc48c8b78$export$804fed467fde44e4(E) {
    var subsetE = $74d7270bc48c8b78$export$af04532ec9ff13d2(E);
    return (0, $bOO3o.fromEquals)(function(x, y) {
        return subsetE(x, y) && subsetE(y, x);
    });
}
var $74d7270bc48c8b78$export$baca17b4aff42f82 = function(E) {
    return {
        concat: $74d7270bc48c8b78$export$971dd5b0dfd021b6(E)
    };
};
var $74d7270bc48c8b78$export$c487aac9f4157837 = function(E) {
    return {
        concat: $74d7270bc48c8b78$export$baca17b4aff42f82(E).concat,
        empty: $74d7270bc48c8b78$export$6e22c362a0406a2c
    };
};
var $74d7270bc48c8b78$export$d379a869a72e4055 = function(E) {
    return {
        concat: $74d7270bc48c8b78$export$bc86dfbf7795668c(E)
    };
};
var $74d7270bc48c8b78$export$fdb3296ca0a124e3 = function(E) {
    return {
        concat: $74d7270bc48c8b78$export$acaf96a27438246b(E)
    };
};
var $74d7270bc48c8b78$export$571d59b505e6bb4e = $74d7270bc48c8b78$export$9288e031f1846591;

});

parcelRegister("aYQcG", function(module, exports) {

$parcel$export(module.exports, "iso", () => $7fe800802da793c3$export$1aba8f741a0eae06);
$parcel$export(module.exports, "isoAsLens", () => $7fe800802da793c3$export$d001ee9513dee7c1);
$parcel$export(module.exports, "lens", () => $7fe800802da793c3$export$21cde5187c2605a3);
$parcel$export(module.exports, "isoAsPrism", () => $7fe800802da793c3$export$fde8c5b9dff57abc);
$parcel$export(module.exports, "prism", () => $7fe800802da793c3$export$e469dcfea9910464);
$parcel$export(module.exports, "isoAsOptional", () => $7fe800802da793c3$export$4d3db894cf45abd5);
$parcel$export(module.exports, "optional", () => $7fe800802da793c3$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "isoAsTraversal", () => $7fe800802da793c3$export$e55a826b3ba968d2);
$parcel$export(module.exports, "traversal", () => $7fe800802da793c3$export$8666ce7a134c2314);
$parcel$export(module.exports, "lensAsOptional", () => $7fe800802da793c3$export$bae94c671b4dc75d);
$parcel$export(module.exports, "lensAsTraversal", () => $7fe800802da793c3$export$e5de01c31c85830c);
$parcel$export(module.exports, "lensComposeLens", () => $7fe800802da793c3$export$62d1b5266563d2b6);
$parcel$export(module.exports, "prismComposePrism", () => $7fe800802da793c3$export$af9c087537c23eb1);
$parcel$export(module.exports, "lensComposePrism", () => $7fe800802da793c3$export$ffffe1ca21811d93);
$parcel$export(module.exports, "optionalComposeOptional", () => $7fe800802da793c3$export$8e08893559c32e38);
$parcel$export(module.exports, "prismAsOptional", () => $7fe800802da793c3$export$70f4d204f3bdc8bd);
$parcel$export(module.exports, "lensId", () => $7fe800802da793c3$export$a4b03755c6673298);
$parcel$export(module.exports, "lensProp", () => $7fe800802da793c3$export$a6ba95b157529836);
$parcel$export(module.exports, "lensProps", () => $7fe800802da793c3$export$c19575454e66bf5f);
$parcel$export(module.exports, "lensComponent", () => $7fe800802da793c3$export$103f2a6258fae742);
$parcel$export(module.exports, "lensAtKey", () => $7fe800802da793c3$export$fc68a3bfc89f0b98);
$parcel$export(module.exports, "atReadonlyRecord", () => $7fe800802da793c3$export$ba8573d258bae607);
$parcel$export(module.exports, "prismSet", () => $7fe800802da793c3$export$97725fa315d6412c);
$parcel$export(module.exports, "prismAsTraversal", () => $7fe800802da793c3$export$18564f4597667b6a);
$parcel$export(module.exports, "prismModifyOption", () => $7fe800802da793c3$export$ddb3ff54eaa1c530);
$parcel$export(module.exports, "prismModify", () => $7fe800802da793c3$export$f545e0bcbe4b5ea7);
$parcel$export(module.exports, "prismComposeLens", () => $7fe800802da793c3$export$dad01448ef670850);
$parcel$export(module.exports, "prismFromNullable", () => $7fe800802da793c3$export$258cc98aa6d7d21b);
$parcel$export(module.exports, "prismFromPredicate", () => $7fe800802da793c3$export$8f316a2f03469694);
$parcel$export(module.exports, "prismSome", () => $7fe800802da793c3$export$782e8b2fe031f968);
$parcel$export(module.exports, "prismRight", () => $7fe800802da793c3$export$929e170fdd93186c);
$parcel$export(module.exports, "prismLeft", () => $7fe800802da793c3$export$97ae81cf28b21f26);
$parcel$export(module.exports, "optionalAsTraversal", () => $7fe800802da793c3$export$a595a5197cc37264);
$parcel$export(module.exports, "optionalModifyOption", () => $7fe800802da793c3$export$48aae8aebe6d3ee9);
$parcel$export(module.exports, "optionalModify", () => $7fe800802da793c3$export$6d575f282c3c1d48);
$parcel$export(module.exports, "optionalIndex", () => $7fe800802da793c3$export$47ac94aa95300c6f);
$parcel$export(module.exports, "indexReadonlyArray", () => $7fe800802da793c3$export$bb0c054375ca4b0);
$parcel$export(module.exports, "optionalIndexNonEmpty", () => $7fe800802da793c3$export$83e62439a4d30c4c);
$parcel$export(module.exports, "indexReadonlyNonEmptyArray", () => $7fe800802da793c3$export$165af7b747e6b1f1);
$parcel$export(module.exports, "optionalKey", () => $7fe800802da793c3$export$a6c26e1663200bf4);
$parcel$export(module.exports, "indexReadonlyRecord", () => $7fe800802da793c3$export$3c3468aec3b83bbf);
$parcel$export(module.exports, "optionalFindFirst", () => $7fe800802da793c3$export$220673392b48821b);
$parcel$export(module.exports, "optionalFindFirstNonEmpty", () => $7fe800802da793c3$export$cf29cfc68de9a659);
$parcel$export(module.exports, "traversalComposeTraversal", () => $7fe800802da793c3$export$2c68ab81171b083f);
$parcel$export(module.exports, "ApplicativeIdentity", () => $7fe800802da793c3$export$7c4912ca011fa00e);
$parcel$export(module.exports, "fromTraversable", () => $7fe800802da793c3$export$126b5a87c58d3f9c);
$parcel$export(module.exports, "traversalTraverse", () => $7fe800802da793c3$export$35db6fcbd934c57);
$parcel$export(module.exports, "index", () => $7fe800802da793c3$export$b610b8812bbcded9);
$parcel$export(module.exports, "at", () => $7fe800802da793c3$export$493d36ec626b6698);

var $iLEkM = parcelRequire("iLEkM");

var $cMujy = parcelRequire("cMujy");

var $lWM6H = parcelRequire("lWM6H");

var $5OFXS = parcelRequire("5OFXS");

var $eVPL0 = parcelRequire("eVPL0");

var $aOL40 = parcelRequire("aOL40");
var $7fe800802da793c3$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $7fe800802da793c3$export$1aba8f741a0eae06 = function(get, reverseGet) {
    return {
        get: get,
        reverseGet: reverseGet
    };
};
var $7fe800802da793c3$export$d001ee9513dee7c1 = function(sa) {
    return $7fe800802da793c3$export$21cde5187c2605a3(sa.get, (0, $lWM6H.flow)(sa.reverseGet, (0, $lWM6H.constant)));
};
var $7fe800802da793c3$export$fde8c5b9dff57abc = function(sa) {
    return $7fe800802da793c3$export$e469dcfea9910464((0, $lWM6H.flow)(sa.get, $5OFXS.some), sa.reverseGet);
};
var $7fe800802da793c3$export$4d3db894cf45abd5 = function(sa) {
    return $7fe800802da793c3$export$516e28dec6a4b6d4((0, $lWM6H.flow)(sa.get, $5OFXS.some), (0, $lWM6H.flow)(sa.reverseGet, (0, $lWM6H.constant)));
};
var $7fe800802da793c3$export$e55a826b3ba968d2 = function(sa) {
    return $7fe800802da793c3$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.reverseGet(a);
                });
            };
        };
    });
};
var $7fe800802da793c3$export$21cde5187c2605a3 = function(get, set) {
    return {
        get: get,
        set: set
    };
};
var $7fe800802da793c3$export$bae94c671b4dc75d = function(sa) {
    return $7fe800802da793c3$export$516e28dec6a4b6d4((0, $lWM6H.flow)(sa.get, $5OFXS.some), sa.set);
};
var $7fe800802da793c3$export$e5de01c31c85830c = function(sa) {
    return $7fe800802da793c3$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.set(a)(s);
                });
            };
        };
    });
};
var $7fe800802da793c3$export$62d1b5266563d2b6 = function(ab) {
    return function(sa) {
        return $7fe800802da793c3$export$21cde5187c2605a3(function(s) {
            return ab.get(sa.get(s));
        }, function(b) {
            return function(s) {
                return sa.set(ab.set(b)(sa.get(s)))(s);
            };
        });
    };
};
var $7fe800802da793c3$export$af9c087537c23eb1 = function(ab) {
    return function(sa) {
        return $7fe800802da793c3$export$e469dcfea9910464((0, $lWM6H.flow)(sa.getOption, $5OFXS.chain(ab.getOption)), (0, $lWM6H.flow)(ab.reverseGet, sa.reverseGet));
    };
};
var $7fe800802da793c3$export$ffffe1ca21811d93 = function(ab) {
    return function(sa) {
        return $7fe800802da793c3$export$8e08893559c32e38($7fe800802da793c3$export$70f4d204f3bdc8bd(ab))($7fe800802da793c3$export$bae94c671b4dc75d(sa));
    };
};
var $7fe800802da793c3$export$a4b03755c6673298 = function() {
    return $7fe800802da793c3$export$21cde5187c2605a3((0, $lWM6H.identity), (0, $lWM6H.constant));
};
var $7fe800802da793c3$export$a6ba95b157529836 = function(prop) {
    return function(sa) {
        return $7fe800802da793c3$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var _a;
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                return sa.set(Object.assign({}, oa, (_a = {}, _a[prop] = ap, _a)))(s);
            };
        });
    };
};
var $7fe800802da793c3$export$c19575454e66bf5f = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return function(sa) {
        return $7fe800802da793c3$export$21cde5187c2605a3(function(s) {
            var a = sa.get(s);
            var r = {};
            for(var _i = 0, props_1 = props; _i < props_1.length; _i++){
                var k = props_1[_i];
                r[k] = a[k];
            }
            return r;
        }, function(a) {
            return function(s) {
                var oa = sa.get(s);
                for(var _i = 0, props_2 = props; _i < props_2.length; _i++){
                    var k = props_2[_i];
                    if (a[k] !== oa[k]) return sa.set(Object.assign({}, oa, a))(s);
                }
                return s;
            };
        });
    };
};
var $7fe800802da793c3$export$103f2a6258fae742 = function(prop) {
    return function(sa) {
        return $7fe800802da793c3$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                var copy = oa.slice();
                copy[prop] = ap;
                return sa.set(copy)(s);
            };
        });
    };
};
var $7fe800802da793c3$export$fc68a3bfc89f0b98 = function(key) {
    return function(sa) {
        return (0, $aOL40.pipe)(sa, $7fe800802da793c3$export$62d1b5266563d2b6($7fe800802da793c3$export$ba8573d258bae607().at(key)));
    };
};
var $7fe800802da793c3$export$e469dcfea9910464 = function(getOption, reverseGet) {
    return {
        getOption: getOption,
        reverseGet: reverseGet
    };
};
var $7fe800802da793c3$export$70f4d204f3bdc8bd = function(sa) {
    return $7fe800802da793c3$export$516e28dec6a4b6d4(sa.getOption, function(a) {
        return $7fe800802da793c3$export$97725fa315d6412c(a)(sa);
    });
};
var $7fe800802da793c3$export$18564f4597667b6a = function(sa) {
    return $7fe800802da793c3$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $aOL40.pipe)(sa.getOption(s), $5OFXS.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return $7fe800802da793c3$export$97725fa315d6412c(a)(sa)(s);
                    });
                }));
            };
        };
    });
};
var $7fe800802da793c3$export$ddb3ff54eaa1c530 = function(f) {
    return function(sa) {
        return function(s) {
            return (0, $aOL40.pipe)(sa.getOption(s), $5OFXS.map(function(o) {
                var n = f(o);
                return n === o ? s : sa.reverseGet(n);
            }));
        };
    };
};
var $7fe800802da793c3$export$f545e0bcbe4b5ea7 = function(f) {
    return function(sa) {
        var g = $7fe800802da793c3$export$ddb3ff54eaa1c530(f)(sa);
        return function(s) {
            return (0, $aOL40.pipe)(g(s), $5OFXS.getOrElse(function() {
                return s;
            }));
        };
    };
};
var $7fe800802da793c3$export$97725fa315d6412c = function(a) {
    return $7fe800802da793c3$export$f545e0bcbe4b5ea7(function() {
        return a;
    });
};
var $7fe800802da793c3$export$dad01448ef670850 = function(ab) {
    return function(sa) {
        return $7fe800802da793c3$export$8e08893559c32e38($7fe800802da793c3$export$bae94c671b4dc75d(ab))($7fe800802da793c3$export$70f4d204f3bdc8bd(sa));
    };
};
var $7fe800802da793c3$export$258cc98aa6d7d21b = function() {
    return $7fe800802da793c3$export$e469dcfea9910464($5OFXS.fromNullable, (0, $lWM6H.identity));
};
var $7fe800802da793c3$export$8f316a2f03469694 = function(predicate) {
    return $7fe800802da793c3$export$e469dcfea9910464($5OFXS.fromPredicate(predicate), (0, $lWM6H.identity));
};
var $7fe800802da793c3$export$782e8b2fe031f968 = function() {
    return $7fe800802da793c3$export$e469dcfea9910464((0, $lWM6H.identity), $5OFXS.some);
};
var $7fe800802da793c3$export$929e170fdd93186c = function() {
    return $7fe800802da793c3$export$e469dcfea9910464($5OFXS.fromEither, $eVPL0.right);
};
var $7fe800802da793c3$export$97ae81cf28b21f26 = function() {
    return $7fe800802da793c3$export$e469dcfea9910464(function(s) {
        return $eVPL0.isLeft(s) ? $5OFXS.some(s.left) : $5OFXS.none;
    }, $eVPL0.left);
};
var $7fe800802da793c3$export$516e28dec6a4b6d4 = function(getOption, set) {
    return {
        getOption: getOption,
        set: set
    };
};
var $7fe800802da793c3$export$a595a5197cc37264 = function(sa) {
    return $7fe800802da793c3$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $aOL40.pipe)(sa.getOption(s), $5OFXS.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    });
};
var $7fe800802da793c3$export$48aae8aebe6d3ee9 = function(f) {
    return function(optional) {
        return function(s) {
            return (0, $aOL40.pipe)(optional.getOption(s), $5OFXS.map(function(a) {
                var n = f(a);
                return n === a ? s : optional.set(n)(s);
            }));
        };
    };
};
var $7fe800802da793c3$export$6d575f282c3c1d48 = function(f) {
    return function(optional) {
        var g = $7fe800802da793c3$export$48aae8aebe6d3ee9(f)(optional);
        return function(s) {
            return (0, $aOL40.pipe)(g(s), $5OFXS.getOrElse(function() {
                return s;
            }));
        };
    };
};
var $7fe800802da793c3$export$8e08893559c32e38 = function(ab) {
    return function(sa) {
        return $7fe800802da793c3$export$516e28dec6a4b6d4((0, $lWM6H.flow)(sa.getOption, $5OFXS.chain(ab.getOption)), function(b) {
            return $7fe800802da793c3$export$6d575f282c3c1d48(ab.set(b))(sa);
        });
    };
};
var $7fe800802da793c3$export$47ac94aa95300c6f = function(i) {
    return function(sa) {
        return (0, $aOL40.pipe)(sa, $7fe800802da793c3$export$8e08893559c32e38($7fe800802da793c3$export$bb0c054375ca4b0().index(i)));
    };
};
var $7fe800802da793c3$export$83e62439a4d30c4c = function(i) {
    return function(sa) {
        return (0, $aOL40.pipe)(sa, $7fe800802da793c3$export$8e08893559c32e38($7fe800802da793c3$export$165af7b747e6b1f1().index(i)));
    };
};
var $7fe800802da793c3$export$a6c26e1663200bf4 = function(key) {
    return function(sa) {
        return (0, $aOL40.pipe)(sa, $7fe800802da793c3$export$8e08893559c32e38($7fe800802da793c3$export$3c3468aec3b83bbf().index(key)));
    };
};
var $7fe800802da793c3$export$220673392b48821b = function(predicate) {
    return $7fe800802da793c3$export$516e28dec6a4b6d4($iLEkM.findFirst(predicate), function(a) {
        return function(s) {
            return (0, $aOL40.pipe)($iLEkM.findIndex(predicate)(s), $5OFXS.fold(function() {
                return s;
            }, function(i) {
                return $iLEkM.unsafeUpdateAt(i, a, s);
            }));
        };
    });
};
var $7fe800802da793c3$var$unsafeUpdateAt = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $7fe800802da793c3$var$__spreadArray([
            as[0]
        ], as.slice(1), true);
        xs[i] = a;
        return xs;
    }
};
var $7fe800802da793c3$export$cf29cfc68de9a659 = function(predicate) {
    return $7fe800802da793c3$export$516e28dec6a4b6d4($iLEkM.findFirst(predicate), function(a) {
        return function(as) {
            return (0, $aOL40.pipe)($iLEkM.findIndex(predicate)(as), $5OFXS.fold(function() {
                return as;
            }, function(i) {
                return $7fe800802da793c3$var$unsafeUpdateAt(i, a, as);
            }));
        };
    });
};
var $7fe800802da793c3$export$8666ce7a134c2314 = function(modifyF) {
    return {
        modifyF: modifyF
    };
};
function $7fe800802da793c3$export$2c68ab81171b083f(ab) {
    return function(sa) {
        return $7fe800802da793c3$export$8666ce7a134c2314(function(F) {
            return function(f) {
                return sa.modifyF(F)(ab.modifyF(F)(f));
            };
        });
    };
}
var $7fe800802da793c3$export$7c4912ca011fa00e = {
    URI: 'Identity',
    map: function(fa, f) {
        return f(fa);
    },
    of: (0, $lWM6H.identity),
    ap: /* istanbul ignore next */ function(fab, fa) {
        return fab(fa);
    }
};
var $7fe800802da793c3$var$isIdentity = function(F) {
    return F.URI === 'Identity';
};
function $7fe800802da793c3$export$126b5a87c58d3f9c(T) {
    return function() {
        return $7fe800802da793c3$export$8666ce7a134c2314(function(F) {
            // if `F` is `Identity` then `traverseF = map`
            var traverseF = $7fe800802da793c3$var$isIdentity(F) ? T.map : T.traverse(F);
            return function(f) {
                return function(s) {
                    return traverseF(s, f);
                };
            };
        });
    };
}
function $7fe800802da793c3$export$35db6fcbd934c57(T) {
    return $7fe800802da793c3$export$2c68ab81171b083f($7fe800802da793c3$export$126b5a87c58d3f9c(T)());
}
var $7fe800802da793c3$export$b610b8812bbcded9 = function(index) {
    return {
        index: index
    };
};
var $7fe800802da793c3$export$bb0c054375ca4b0 = function() {
    return $7fe800802da793c3$export$b610b8812bbcded9(function(i) {
        return $7fe800802da793c3$export$516e28dec6a4b6d4(function(as) {
            return $iLEkM.lookup(i, as);
        }, function(a) {
            return function(as) {
                return (0, $aOL40.pipe)($iLEkM.lookup(i, as), $5OFXS.fold(function() {
                    return as;
                }, function() {
                    return $iLEkM.unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
var $7fe800802da793c3$export$165af7b747e6b1f1 = function() {
    return $7fe800802da793c3$export$b610b8812bbcded9(function(i) {
        return $7fe800802da793c3$export$516e28dec6a4b6d4(function(as) {
            return $iLEkM.lookup(i, as);
        }, function(a) {
            return function(as) {
                return (0, $aOL40.pipe)($iLEkM.lookup(i, as), $5OFXS.fold(function() {
                    return as;
                }, function() {
                    return $7fe800802da793c3$var$unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
var $7fe800802da793c3$export$3c3468aec3b83bbf = function() {
    return $7fe800802da793c3$export$b610b8812bbcded9(function(k) {
        return $7fe800802da793c3$export$516e28dec6a4b6d4(function(r) {
            return $cMujy.lookup(k, r);
        }, function(a) {
            return function(r) {
                if (r[k] === a || $5OFXS.isNone($cMujy.lookup(k, r))) return r;
                return $cMujy.insertAt(k, a)(r);
            };
        });
    });
};
var $7fe800802da793c3$export$493d36ec626b6698 = function(at) {
    return {
        at: at
    };
};
function $7fe800802da793c3$export$ba8573d258bae607() {
    return $7fe800802da793c3$export$493d36ec626b6698(function(key) {
        return $7fe800802da793c3$export$21cde5187c2605a3(function(r) {
            return $cMujy.lookup(key, r);
        }, $5OFXS.fold(function() {
            return $cMujy.deleteAt(key);
        }, function(a) {
            return $cMujy.insertAt(key, a);
        }));
    });
}

});
parcelRegister("cMujy", function(module, exports) {

$parcel$export(module.exports, "deleteAt", () => $94e17b87f6286380$export$90f9093465da3136);
$parcel$export(module.exports, "lookup", () => $94e17b87f6286380$export$dfc7155ac0343b8);
$parcel$export(module.exports, "insertAt", () => $94e17b87f6286380$export$9f200c4466975173);

var $bOO3o = parcelRequire("bOO3o");

var $lWM6H = parcelRequire("lWM6H");

var $gnzaQ = parcelRequire("gnzaQ");

var $9sd2T = parcelRequire("9sd2T");

var $fYAej = parcelRequire("fYAej");

var $5iM4u = parcelRequire("5iM4u");

var $loyJ7 = parcelRequire("loyJ7");
var $94e17b87f6286380$export$6c8271f68d66a228 = function(r) {
    return Object.assign({}, r);
};
var $94e17b87f6286380$export$1a8926de16677683 = function(r) {
    return Object.assign({}, r);
};
var $94e17b87f6286380$export$346677f925de839c = function(r) {
    return Object.keys(r).length;
};
var $94e17b87f6286380$export$dd1bc94b04021eeb = function(r) {
    for(var k in r){
        if ($9sd2T.has.call(r, k)) return false;
    }
    return true;
};
var $94e17b87f6286380$var$keys_ = function(O) {
    return function(r) {
        return Object.keys(r).sort(O.compare);
    };
};
var $94e17b87f6286380$export$ed97f33186d4b816 = /*#__PURE__*/ $94e17b87f6286380$var$keys_($5iM4u.Ord);
function $94e17b87f6286380$export$bb44f104e3c54dae(O) {
    if (typeof O === 'function') return $94e17b87f6286380$export$bb44f104e3c54dae($5iM4u.Ord)(O);
    var keysO = $94e17b87f6286380$var$keys_(O);
    return function(f) {
        return function(r) {
            var out = [];
            for(var _i = 0, _a = keysO(r); _i < _a.length; _i++){
                var key = _a[_i];
                out.push(f(key, r[key]));
            }
            return out;
        };
    };
}
var $94e17b87f6286380$export$4aaa3912a3956cb7 = /*#__PURE__*/ $94e17b87f6286380$export$bb44f104e3c54dae($5iM4u.Ord)(function(k, a) {
    return [
        k,
        a
    ];
});
function $94e17b87f6286380$export$823be24f8766da23(U) {
    return function(r) {
        var sas = $94e17b87f6286380$export$4aaa3912a3956cb7(r);
        var len = sas.length;
        return U.unfold(0, function(b) {
            return b < len ? $9sd2T.some([
                sas[b],
                b + 1
            ]) : $9sd2T.none;
        });
    };
}
var $94e17b87f6286380$export$ff82449ce381c54a = function(k, a) {
    return function(r) {
        if ($9sd2T.has.call(r, k) && r[k] === a) return r;
        var out = Object.assign({}, r);
        out[k] = a;
        return out;
    };
};
var $94e17b87f6286380$export$a4f4bb6b1453fff5 = function(k, r) {
    return $9sd2T.has.call(r, k);
};
function $94e17b87f6286380$export$90f9093465da3136(k) {
    return function(r) {
        if (!$9sd2T.has.call(r, k)) return r;
        var out = Object.assign({}, r);
        delete out[k];
        return out;
    };
}
var $94e17b87f6286380$export$b6d8713d53419d4c = function(k, a) {
    return function(r) {
        if (!$94e17b87f6286380$export$a4f4bb6b1453fff5(k, r)) return $9sd2T.none;
        if (r[k] === a) return $9sd2T.some(r);
        var out = Object.assign({}, r);
        out[k] = a;
        return $9sd2T.some(out);
    };
};
var $94e17b87f6286380$export$cba09f9e3d3e58eb = function(k, f) {
    return function(r) {
        if (!$94e17b87f6286380$export$a4f4bb6b1453fff5(k, r)) return $9sd2T.none;
        var next = f(r[k]);
        if (next === r[k]) return $9sd2T.some(r);
        var out = Object.assign({}, r);
        out[k] = next;
        return $9sd2T.some(out);
    };
};
function $94e17b87f6286380$export$3e41007ebfff0e64(k) {
    var deleteAtk = $94e17b87f6286380$export$90f9093465da3136(k);
    return function(r) {
        var oa = $94e17b87f6286380$export$dfc7155ac0343b8(k, r);
        return $9sd2T.isNone(oa) ? $9sd2T.none : $9sd2T.some([
            oa.value,
            deleteAtk(r)
        ]);
    };
}
function $94e17b87f6286380$export$36e6f76a1d117b8a(E) {
    return function(me, that) {
        if (that === undefined) {
            var isSubrecordE_1 = $94e17b87f6286380$export$36e6f76a1d117b8a(E);
            return function(that) {
                return isSubrecordE_1(that, me);
            };
        }
        for(var k in me){
            if (!$9sd2T.has.call(that, k) || !E.equals(me[k], that[k])) return false;
        }
        return true;
    };
}
function $94e17b87f6286380$export$dfc7155ac0343b8(k, r) {
    if (r === undefined) return function(r) {
        return $94e17b87f6286380$export$dfc7155ac0343b8(k, r);
    };
    return $9sd2T.has.call(r, k) ? $9sd2T.some(r[k]) : $9sd2T.none;
}
var $94e17b87f6286380$export$6e22c362a0406a2c = {};
function $94e17b87f6286380$export$8f07ddce13659f50(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($9sd2T.has.call(r, k)) out[k] = f(k, r[k]);
        return out;
    };
}
function $94e17b87f6286380$export$871de8747c9eaa88(f) {
    return $94e17b87f6286380$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
}
function $94e17b87f6286380$export$bbd3ef8720e22369() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $94e17b87f6286380$export$bbd3ef8720e22369($5iM4u.Ord).apply(void 0, args);
    var keysO = $94e17b87f6286380$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = 0; i < len; i++){
                var k = ks[i];
                out = f(k, out, fa[k]);
            }
            return out;
        };
    };
}
function $94e17b87f6286380$export$18153bb1181268e5(O) {
    if ('compare' in O) {
        var keysO_1 = $94e17b87f6286380$var$keys_(O);
        return function(M) {
            return function(f) {
                return function(fa) {
                    var out = M.empty;
                    var ks = keysO_1(fa);
                    var len = ks.length;
                    for(var i = 0; i < len; i++){
                        var k = ks[i];
                        out = M.concat(out, f(k, fa[k]));
                    }
                    return out;
                };
            };
        };
    }
    return $94e17b87f6286380$export$18153bb1181268e5($5iM4u.Ord)(O);
}
function $94e17b87f6286380$export$ce2b2fe0b88ccd0a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $94e17b87f6286380$export$ce2b2fe0b88ccd0a($5iM4u.Ord).apply(void 0, args);
    var keysO = $94e17b87f6286380$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, fa[k], out);
            }
            return out;
        };
    };
}
var $94e17b87f6286380$export$439306a4dcaafbb9 = function(k, a) {
    var _a;
    return _a = {}, _a[k] = a, _a;
};
function $94e17b87f6286380$export$955fdc0d24efa249(F) {
    var traverseWithIndexOF = $94e17b87f6286380$var$_traverseWithIndex($5iM4u.Ord)(F);
    return function(f) {
        return function(ta) {
            return traverseWithIndexOF(ta, f);
        };
    };
}
function $94e17b87f6286380$export$df3f009e3d155b20(F) {
    var traverseOF = $94e17b87f6286380$export$b3c6f3d9661cffba($5iM4u.Ord)(F);
    return function(f) {
        return function(ta) {
            return traverseOF(ta, f);
        };
    };
}
function $94e17b87f6286380$export$49bb65c2ea163039(F) {
    return $94e17b87f6286380$export$5d141086b2c0bc6($5iM4u.Ord)(F);
}
var $94e17b87f6286380$export$6c36d01819ecdb31 = function(F) {
    var traverseF = $94e17b87f6286380$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $lWM6H.pipe)(fa, traverseF(f)), $94e17b87f6286380$export$8e16b83750b44988);
        };
    };
};
var $94e17b87f6286380$export$2439a3bc02b13b03 = function(F) {
    var traverseF = $94e17b87f6286380$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $lWM6H.pipe)(fa, traverseF(f)), $94e17b87f6286380$export$709f6946f4e97408);
        };
    };
};
function $94e17b87f6286380$export$bc7c0794b9c6f3ba(f) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($9sd2T.has.call(r, k)) {
            var e = f(k, r[k]);
            switch(e._tag){
                case 'Left':
                    left[k] = e.left;
                    break;
                case 'Right':
                    right[k] = e.right;
                    break;
            }
        }
        return (0, $fYAej.separated)(left, right);
    };
}
function $94e17b87f6286380$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($9sd2T.has.call(r, k)) {
            var a = r[k];
            if (predicateWithIndex(k, a)) right[k] = a;
            else left[k] = a;
        }
        return (0, $fYAej.separated)(left, right);
    };
}
function $94e17b87f6286380$export$30c5cbe848021e97(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($9sd2T.has.call(r, k)) {
            var ob = f(k, r[k]);
            if ($9sd2T.isSome(ob)) out[k] = ob.value;
        }
        return out;
    };
}
function $94e17b87f6286380$export$36e42aef19fc7171(predicateWithIndex) {
    return function(fa) {
        var out = {};
        var changed = false;
        for(var key in fa)if ($9sd2T.has.call(fa, key)) {
            var a = fa[key];
            if (predicateWithIndex(key, a)) out[key] = a;
            else changed = true;
        }
        return changed ? out : fa;
    };
}
function $94e17b87f6286380$export$b7d5d9bb9ff52072(M, F) {
    var fromFoldableMapM = $94e17b87f6286380$export$f658682c0065ad25(M, F);
    return function(fka) {
        return fromFoldableMapM(fka, (0, $lWM6H.identity));
    };
}
function $94e17b87f6286380$export$f658682c0065ad25(M, F) {
    return function(ta, f) {
        return F.reduce(ta, {}, function(r, a) {
            var _a = f(a), k = _a[0], b = _a[1];
            r[k] = $9sd2T.has.call(r, k) ? M.concat(r[k], b) : b;
            return r;
        });
    };
}
var $94e17b87f6286380$export$9f69d28786a8399c = $94e17b87f6286380$export$4aaa3912a3956cb7;
var $94e17b87f6286380$export$5150077fc2e7c662 = function(fa) {
    var out = {};
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var a = fa_1[_i];
        out[a[0]] = a[1];
    }
    return out;
};
function $94e17b87f6286380$export$7ecc1a3b11b57dab(predicate) {
    return function(r) {
        for(var k in r){
            if (!predicate(r[k])) return false;
        }
        return true;
    };
}
function $94e17b87f6286380$export$ad14ef4001db2bcd(predicate) {
    return function(r) {
        for(var k in r){
            if (predicate(r[k])) return true;
        }
        return false;
    };
}
function $94e17b87f6286380$export$5bf96401662340b7(E) {
    return function(a, fa) {
        if (fa === undefined) {
            var elemE_1 = $94e17b87f6286380$export$5bf96401662340b7(E);
            return function(fa) {
                return elemE_1(a, fa);
            };
        }
        for(var k in fa){
            if (E.equals(fa[k], a)) return true;
        }
        return false;
    };
}
var $94e17b87f6286380$export$971dd5b0dfd021b6 = function(M) {
    return function(second) {
        return function(first) {
            if ($94e17b87f6286380$export$dd1bc94b04021eeb(first)) return second;
            if ($94e17b87f6286380$export$dd1bc94b04021eeb(second)) return first;
            var out = {};
            for(var k in first)if ($94e17b87f6286380$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            else out[k] = first[k];
            for(var k in second)if (!$94e17b87f6286380$export$a4f4bb6b1453fff5(k, out)) out[k] = second[k];
            return out;
        };
    };
};
var $94e17b87f6286380$export$bc86dfbf7795668c = function(M) {
    return function(second) {
        return function(first) {
            if ($94e17b87f6286380$export$dd1bc94b04021eeb(first) || $94e17b87f6286380$export$dd1bc94b04021eeb(second)) return $94e17b87f6286380$export$6e22c362a0406a2c;
            var out = {};
            for(var k in first)if ($94e17b87f6286380$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            return out;
        };
    };
};
var $94e17b87f6286380$export$acaf96a27438246b = function(second) {
    return function(first) {
        if ($94e17b87f6286380$export$dd1bc94b04021eeb(first)) return second;
        if ($94e17b87f6286380$export$dd1bc94b04021eeb(second)) return first;
        var out = {};
        for(var k in first)if (!$94e17b87f6286380$export$a4f4bb6b1453fff5(k, second)) out[k] = first[k];
        for(var k in second)if (!$94e17b87f6286380$export$a4f4bb6b1453fff5(k, first)) out[k] = second[k];
        return out;
    };
};
var $94e17b87f6286380$export$a0135aecf4a782ab = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $94e17b87f6286380$export$871de8747c9eaa88(f));
};
var $94e17b87f6286380$export$45e3e46323e6d66c = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $94e17b87f6286380$export$8f07ddce13659f50(f));
};
var $94e17b87f6286380$export$8eef5fdba9512999 = function(O) {
    var reduceO = $94e17b87f6286380$export$533b26079ad0b4b(O);
    return function(fa, b, f) {
        return (0, $lWM6H.pipe)(fa, reduceO(b, f));
    };
};
var $94e17b87f6286380$export$11b0d0e0b70641d9 = function(O) {
    return function(M) {
        var foldMapM = $94e17b87f6286380$export$b66cdc0497d8a99a(O)(M);
        return function(fa, f) {
            return (0, $lWM6H.pipe)(fa, foldMapM(f));
        };
    };
};
var $94e17b87f6286380$export$ec882fc9def9e5db = function(O) {
    var reduceRightO = $94e17b87f6286380$export$7fef8bcdbb34f435(O);
    return function(fa, b, f) {
        return (0, $lWM6H.pipe)(fa, reduceRightO(b, f));
    };
};
var $94e17b87f6286380$export$ec7439dc64f73058 = function(fa, predicate) {
    return (0, $lWM6H.pipe)(fa, $94e17b87f6286380$export$3dea766d36a8935f(predicate));
};
var $94e17b87f6286380$export$e8609d6e184911e6 = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $94e17b87f6286380$export$a04c6c6965dd4709(f));
};
var $94e17b87f6286380$export$8d112ad5a197e16a = function(fa, predicate) {
    return (0, $lWM6H.pipe)(fa, $94e17b87f6286380$export$b29f828819edca8d(predicate));
};
var $94e17b87f6286380$export$f721fb25a1c72a8d = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $94e17b87f6286380$export$3117e3f9ececb6bc(f));
};
var $94e17b87f6286380$export$dd5ca3bcbad0b6af = function(O) {
    var reduceWithIndexO = $94e17b87f6286380$export$bbd3ef8720e22369(O);
    return function(fa, b, f) {
        return (0, $lWM6H.pipe)(fa, reduceWithIndexO(b, f));
    };
};
var $94e17b87f6286380$export$e08bbf939bdc3250 = function(O) {
    var foldMapWithIndexO = $94e17b87f6286380$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexM = foldMapWithIndexO(M);
        return function(fa, f) {
            return (0, $lWM6H.pipe)(fa, foldMapWithIndexM(f));
        };
    };
};
var $94e17b87f6286380$export$3b7618311030b1af = function(O) {
    var reduceRightWithIndexO = $94e17b87f6286380$export$ce2b2fe0b88ccd0a(O);
    return function(fa, b, f) {
        return (0, $lWM6H.pipe)(fa, reduceRightWithIndexO(b, f));
    };
};
var $94e17b87f6286380$export$18034ec93490e9d2 = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $94e17b87f6286380$export$bc7c0794b9c6f3ba(f));
};
var $94e17b87f6286380$export$31601036bfbf1c76 = function(fa, predicateWithIndex) {
    return (0, $lWM6H.pipe)(fa, $94e17b87f6286380$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $94e17b87f6286380$export$ac207938ecd8ddc4 = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $94e17b87f6286380$export$30c5cbe848021e97(f));
};
var $94e17b87f6286380$export$560430393fed15de = function(fa, predicateWithIndex) {
    return (0, $lWM6H.pipe)(fa, $94e17b87f6286380$export$36e42aef19fc7171(predicateWithIndex));
};
var $94e17b87f6286380$export$b3c6f3d9661cffba = function(O) {
    var traverseWithIndexO = $94e17b87f6286380$var$_traverseWithIndex(O);
    return function(F) {
        var traverseWithIndexOF = traverseWithIndexO(F);
        return function(ta, f) {
            return traverseWithIndexOF(ta, (0, $lWM6H.flow)((0, $lWM6H.SK), f));
        };
    };
};
var $94e17b87f6286380$export$5d141086b2c0bc6 = function(O) {
    var traverseO = $94e17b87f6286380$export$b3c6f3d9661cffba(O);
    return function(F) {
        var traverseOF = traverseO(F);
        return function(ta) {
            return traverseOF(ta, (0, $lWM6H.identity));
        };
    };
};
var $94e17b87f6286380$var$_traverseWithIndex = function(O) {
    return function(F) {
        var keysO = $94e17b87f6286380$var$keys_(O);
        return function(ta, f) {
            var ks = keysO(ta);
            if (ks.length === 0) return F.of($94e17b87f6286380$export$6e22c362a0406a2c);
            var fr = F.of({});
            var _loop_1 = function(key) {
                fr = F.ap(F.map(fr, function(r) {
                    return function(b) {
                        var _a;
                        return Object.assign({}, r, (_a = {}, _a[key] = b, _a));
                    };
                }), f(key, ta[key]));
            };
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                _loop_1(key);
            }
            return fr;
        };
    };
};
var $94e17b87f6286380$export$3dea766d36a8935f = function(predicate) {
    return $94e17b87f6286380$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
};
var $94e17b87f6286380$export$a04c6c6965dd4709 = function(f) {
    return $94e17b87f6286380$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $94e17b87f6286380$export$b29f828819edca8d = function(predicate) {
    return $94e17b87f6286380$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $94e17b87f6286380$export$3117e3f9ececb6bc = function(f) {
    return $94e17b87f6286380$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
function $94e17b87f6286380$export$533b26079ad0b4b() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceWithIndexO_1 = $94e17b87f6286380$export$bbd3ef8720e22369(args[0]);
        return function(b, f) {
            return reduceWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $94e17b87f6286380$export$533b26079ad0b4b($5iM4u.Ord).apply(void 0, args);
}
function $94e17b87f6286380$export$b66cdc0497d8a99a(O) {
    if ('compare' in O) {
        var foldMapWithIndexO_1 = $94e17b87f6286380$export$18153bb1181268e5(O);
        return function(M) {
            var foldMapWithIndexM = foldMapWithIndexO_1(M);
            return function(f) {
                return foldMapWithIndexM(function(_, a) {
                    return f(a);
                });
            };
        };
    }
    return $94e17b87f6286380$export$b66cdc0497d8a99a($5iM4u.Ord)(O);
}
function $94e17b87f6286380$export$7fef8bcdbb34f435() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceRightWithIndexO_1 = $94e17b87f6286380$export$ce2b2fe0b88ccd0a(args[0]);
        return function(b, f) {
            return reduceRightWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $94e17b87f6286380$export$7fef8bcdbb34f435($5iM4u.Ord).apply(void 0, args);
}
var $94e17b87f6286380$export$8e16b83750b44988 = function(r) {
    var out = {};
    for(var k in r)if ($9sd2T.has.call(r, k)) {
        var oa = r[k];
        if ($9sd2T.isSome(oa)) out[k] = oa.value;
    }
    return out;
};
var $94e17b87f6286380$export$709f6946f4e97408 = function(r) {
    var left = {};
    var right = {};
    for(var k in r)if ($9sd2T.has.call(r, k)) {
        var e = r[k];
        if ($9sd2T.isLeft(e)) left[k] = e.left;
        else right[k] = e.right;
    }
    return (0, $fYAej.separated)(left, right);
};
var $94e17b87f6286380$export$9156e739aa33e19f = 'ReadonlyRecord';
function $94e17b87f6286380$export$3cb5cd7f7776c81(O) {
    if ('compare' in O) return function(S) {
        return {
            show: function(r) {
                var elements = $94e17b87f6286380$export$bb44f104e3c54dae(O)(function(k, a) {
                    return "".concat(JSON.stringify(k), ": ").concat(S.show(a));
                })(r).join(', ');
                return elements === '' ? '{}' : "{ ".concat(elements, " }");
            }
        };
    };
    return $94e17b87f6286380$export$3cb5cd7f7776c81($5iM4u.Ord)(O);
}
function $94e17b87f6286380$export$804fed467fde44e4(E) {
    var isSubrecordE = $94e17b87f6286380$export$36e6f76a1d117b8a(E);
    return (0, $bOO3o.fromEquals)(function(x, y) {
        return isSubrecordE(x)(y) && isSubrecordE(y)(x);
    });
}
function $94e17b87f6286380$export$c2a7ef2cc9b32b31(S) {
    return {
        concat: function(first, second) {
            if ($94e17b87f6286380$export$dd1bc94b04021eeb(first)) return second;
            if ($94e17b87f6286380$export$dd1bc94b04021eeb(second)) return first;
            var r = Object.assign({}, first);
            for(var k in second)if ($9sd2T.has.call(second, k)) r[k] = $9sd2T.has.call(first, k) ? S.concat(first[k], second[k]) : second[k];
            return r;
        },
        empty: $94e17b87f6286380$export$6e22c362a0406a2c
    };
}
var $94e17b87f6286380$export$bd5b6bfc5fa2ee61 = {
    URI: $94e17b87f6286380$export$9156e739aa33e19f,
    map: $94e17b87f6286380$export$a0135aecf4a782ab
};
var $94e17b87f6286380$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $gnzaQ.flap)($94e17b87f6286380$export$bd5b6bfc5fa2ee61);
var $94e17b87f6286380$export$9fdffe0fe1e91cad = {
    URI: $94e17b87f6286380$export$9156e739aa33e19f,
    map: $94e17b87f6286380$export$a0135aecf4a782ab,
    mapWithIndex: $94e17b87f6286380$export$45e3e46323e6d66c
};
var $94e17b87f6286380$export$d544f02c7cebdaed = function(O) {
    return {
        URI: $94e17b87f6286380$export$9156e739aa33e19f,
        reduce: $94e17b87f6286380$export$8eef5fdba9512999(O),
        foldMap: $94e17b87f6286380$export$11b0d0e0b70641d9(O),
        reduceRight: $94e17b87f6286380$export$ec882fc9def9e5db(O)
    };
};
var $94e17b87f6286380$export$6c59d75f118e7bc9 = function(O) {
    return {
        URI: $94e17b87f6286380$export$9156e739aa33e19f,
        reduce: $94e17b87f6286380$export$8eef5fdba9512999(O),
        foldMap: $94e17b87f6286380$export$11b0d0e0b70641d9(O),
        reduceRight: $94e17b87f6286380$export$ec882fc9def9e5db(O),
        reduceWithIndex: $94e17b87f6286380$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $94e17b87f6286380$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $94e17b87f6286380$export$3b7618311030b1af(O)
    };
};
var $94e17b87f6286380$export$4a21ac48141ac3c9 = {
    URI: $94e17b87f6286380$export$9156e739aa33e19f,
    compact: $94e17b87f6286380$export$8e16b83750b44988,
    separate: $94e17b87f6286380$export$709f6946f4e97408
};
var $94e17b87f6286380$export$d00e1c48fb621173 = {
    URI: $94e17b87f6286380$export$9156e739aa33e19f,
    map: $94e17b87f6286380$export$a0135aecf4a782ab,
    compact: $94e17b87f6286380$export$8e16b83750b44988,
    separate: $94e17b87f6286380$export$709f6946f4e97408,
    filter: $94e17b87f6286380$export$ec7439dc64f73058,
    filterMap: $94e17b87f6286380$export$e8609d6e184911e6,
    partition: $94e17b87f6286380$export$8d112ad5a197e16a,
    partitionMap: $94e17b87f6286380$export$f721fb25a1c72a8d
};
var $94e17b87f6286380$export$c29a647071e542ec = {
    URI: $94e17b87f6286380$export$9156e739aa33e19f,
    map: $94e17b87f6286380$export$a0135aecf4a782ab,
    mapWithIndex: $94e17b87f6286380$export$45e3e46323e6d66c,
    compact: $94e17b87f6286380$export$8e16b83750b44988,
    separate: $94e17b87f6286380$export$709f6946f4e97408,
    filter: $94e17b87f6286380$export$ec7439dc64f73058,
    filterMap: $94e17b87f6286380$export$e8609d6e184911e6,
    partition: $94e17b87f6286380$export$8d112ad5a197e16a,
    partitionMap: $94e17b87f6286380$export$f721fb25a1c72a8d,
    filterMapWithIndex: $94e17b87f6286380$export$ac207938ecd8ddc4,
    filterWithIndex: $94e17b87f6286380$export$560430393fed15de,
    partitionMapWithIndex: $94e17b87f6286380$export$18034ec93490e9d2,
    partitionWithIndex: $94e17b87f6286380$export$31601036bfbf1c76
};
var $94e17b87f6286380$export$4e0ffba11065d2c1 = function(O) {
    return {
        URI: $94e17b87f6286380$export$9156e739aa33e19f,
        map: $94e17b87f6286380$export$a0135aecf4a782ab,
        reduce: $94e17b87f6286380$export$8eef5fdba9512999(O),
        foldMap: $94e17b87f6286380$export$11b0d0e0b70641d9(O),
        reduceRight: $94e17b87f6286380$export$ec882fc9def9e5db(O),
        traverse: $94e17b87f6286380$export$b3c6f3d9661cffba(O),
        sequence: $94e17b87f6286380$export$5d141086b2c0bc6(O)
    };
};
var $94e17b87f6286380$export$46b81797a3375b8c = function(O) {
    return {
        URI: $94e17b87f6286380$export$9156e739aa33e19f,
        map: $94e17b87f6286380$export$a0135aecf4a782ab,
        mapWithIndex: $94e17b87f6286380$export$45e3e46323e6d66c,
        reduce: $94e17b87f6286380$export$8eef5fdba9512999(O),
        foldMap: $94e17b87f6286380$export$11b0d0e0b70641d9(O),
        reduceRight: $94e17b87f6286380$export$ec882fc9def9e5db(O),
        reduceWithIndex: $94e17b87f6286380$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $94e17b87f6286380$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $94e17b87f6286380$export$3b7618311030b1af(O),
        traverse: $94e17b87f6286380$export$b3c6f3d9661cffba(O),
        sequence: $94e17b87f6286380$export$5d141086b2c0bc6(O),
        traverseWithIndex: $94e17b87f6286380$var$_traverseWithIndex(O)
    };
};
var $94e17b87f6286380$export$bb8ef26a634cac7b = function(O) {
    var T = $94e17b87f6286380$export$4e0ffba11065d2c1(O);
    return {
        URI: $94e17b87f6286380$export$9156e739aa33e19f,
        map: $94e17b87f6286380$export$a0135aecf4a782ab,
        reduce: $94e17b87f6286380$export$8eef5fdba9512999(O),
        foldMap: $94e17b87f6286380$export$11b0d0e0b70641d9(O),
        reduceRight: $94e17b87f6286380$export$ec882fc9def9e5db(O),
        traverse: T.traverse,
        sequence: T.sequence,
        compact: $94e17b87f6286380$export$8e16b83750b44988,
        separate: $94e17b87f6286380$export$709f6946f4e97408,
        filter: $94e17b87f6286380$export$ec7439dc64f73058,
        filterMap: $94e17b87f6286380$export$e8609d6e184911e6,
        partition: $94e17b87f6286380$export$8d112ad5a197e16a,
        partitionMap: $94e17b87f6286380$export$f721fb25a1c72a8d,
        wither: (0, $loyJ7.witherDefault)(T, $94e17b87f6286380$export$4a21ac48141ac3c9),
        wilt: (0, $loyJ7.wiltDefault)(T, $94e17b87f6286380$export$4a21ac48141ac3c9)
    };
};
var $94e17b87f6286380$export$baca17b4aff42f82 = function(S) {
    var unionS = $94e17b87f6286380$export$971dd5b0dfd021b6(S);
    return {
        concat: function(first, second) {
            return unionS(second)(first);
        }
    };
};
var $94e17b87f6286380$export$c487aac9f4157837 = function(S) {
    return {
        concat: $94e17b87f6286380$export$baca17b4aff42f82(S).concat,
        empty: $94e17b87f6286380$export$6e22c362a0406a2c
    };
};
var $94e17b87f6286380$export$d379a869a72e4055 = function(S) {
    var intersectionS = $94e17b87f6286380$export$bc86dfbf7795668c(S);
    return {
        concat: function(first, second) {
            return intersectionS(second)(first);
        }
    };
};
var $94e17b87f6286380$export$fdb3296ca0a124e3 = function() {
    return {
        concat: function(first, second) {
            return $94e17b87f6286380$export$acaf96a27438246b(second)(first);
        }
    };
};
var $94e17b87f6286380$export$41404b31838667c9 = {
    URI: $94e17b87f6286380$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $94e17b87f6286380$export$8eef5fdba9512999($5iM4u.Ord),
    foldMap: /*#__PURE__*/ $94e17b87f6286380$export$11b0d0e0b70641d9($5iM4u.Ord),
    reduceRight: /*#__PURE__*/ $94e17b87f6286380$export$ec882fc9def9e5db($5iM4u.Ord)
};
var $94e17b87f6286380$export$e8f7d17aaff345cb = {
    URI: $94e17b87f6286380$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $94e17b87f6286380$export$8eef5fdba9512999($5iM4u.Ord),
    foldMap: /*#__PURE__*/ $94e17b87f6286380$export$11b0d0e0b70641d9($5iM4u.Ord),
    reduceRight: /*#__PURE__*/ $94e17b87f6286380$export$ec882fc9def9e5db($5iM4u.Ord),
    reduceWithIndex: /*#__PURE__*/ $94e17b87f6286380$export$dd5ca3bcbad0b6af($5iM4u.Ord),
    foldMapWithIndex: /*#__PURE__*/ $94e17b87f6286380$export$e08bbf939bdc3250($5iM4u.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $94e17b87f6286380$export$3b7618311030b1af($5iM4u.Ord)
};
var $94e17b87f6286380$export$a0202666c3bda011 = {
    URI: $94e17b87f6286380$export$9156e739aa33e19f,
    map: $94e17b87f6286380$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $94e17b87f6286380$export$8eef5fdba9512999($5iM4u.Ord),
    foldMap: /*#__PURE__*/ $94e17b87f6286380$export$11b0d0e0b70641d9($5iM4u.Ord),
    reduceRight: /*#__PURE__*/ $94e17b87f6286380$export$ec882fc9def9e5db($5iM4u.Ord),
    traverse: /*#__PURE__*/ $94e17b87f6286380$export$b3c6f3d9661cffba($5iM4u.Ord),
    sequence: $94e17b87f6286380$export$49bb65c2ea163039
};
var $94e17b87f6286380$export$bd7b528d8c36ec41 = {
    URI: $94e17b87f6286380$export$9156e739aa33e19f,
    map: $94e17b87f6286380$export$a0135aecf4a782ab,
    mapWithIndex: $94e17b87f6286380$export$45e3e46323e6d66c,
    reduce: /*#__PURE__*/ $94e17b87f6286380$export$8eef5fdba9512999($5iM4u.Ord),
    foldMap: /*#__PURE__*/ $94e17b87f6286380$export$11b0d0e0b70641d9($5iM4u.Ord),
    reduceRight: /*#__PURE__*/ $94e17b87f6286380$export$ec882fc9def9e5db($5iM4u.Ord),
    reduceWithIndex: /*#__PURE__*/ $94e17b87f6286380$export$dd5ca3bcbad0b6af($5iM4u.Ord),
    foldMapWithIndex: /*#__PURE__*/ $94e17b87f6286380$export$e08bbf939bdc3250($5iM4u.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $94e17b87f6286380$export$3b7618311030b1af($5iM4u.Ord),
    traverse: /*#__PURE__*/ $94e17b87f6286380$export$b3c6f3d9661cffba($5iM4u.Ord),
    sequence: $94e17b87f6286380$export$49bb65c2ea163039,
    traverseWithIndex: /*#__PURE__*/ $94e17b87f6286380$var$_traverseWithIndex($5iM4u.Ord)
};
var $94e17b87f6286380$var$_wither = /*#__PURE__*/ (0, $loyJ7.witherDefault)($94e17b87f6286380$export$a0202666c3bda011, $94e17b87f6286380$export$4a21ac48141ac3c9);
var $94e17b87f6286380$var$_wilt = /*#__PURE__*/ (0, $loyJ7.wiltDefault)($94e17b87f6286380$export$a0202666c3bda011, $94e17b87f6286380$export$4a21ac48141ac3c9);
var $94e17b87f6286380$export$748d317b4c426f96 = {
    URI: $94e17b87f6286380$export$9156e739aa33e19f,
    map: $94e17b87f6286380$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $94e17b87f6286380$export$8eef5fdba9512999($5iM4u.Ord),
    foldMap: /*#__PURE__*/ $94e17b87f6286380$export$11b0d0e0b70641d9($5iM4u.Ord),
    reduceRight: /*#__PURE__*/ $94e17b87f6286380$export$ec882fc9def9e5db($5iM4u.Ord),
    traverse: /*#__PURE__*/ $94e17b87f6286380$export$b3c6f3d9661cffba($5iM4u.Ord),
    sequence: $94e17b87f6286380$export$49bb65c2ea163039,
    compact: $94e17b87f6286380$export$8e16b83750b44988,
    separate: $94e17b87f6286380$export$709f6946f4e97408,
    filter: $94e17b87f6286380$export$ec7439dc64f73058,
    filterMap: $94e17b87f6286380$export$e8609d6e184911e6,
    partition: $94e17b87f6286380$export$8d112ad5a197e16a,
    partitionMap: $94e17b87f6286380$export$f721fb25a1c72a8d,
    wither: $94e17b87f6286380$var$_wither,
    wilt: $94e17b87f6286380$var$_wilt
};
var $94e17b87f6286380$export$9f200c4466975173 = $94e17b87f6286380$export$ff82449ce381c54a;
function $94e17b87f6286380$export$5a15a386532a5ea4(k, r) {
    return $9sd2T.has.call(r === undefined ? this : r, k);
}
var $94e17b87f6286380$export$74b9182b22de2bc1 = {
    URI: $94e17b87f6286380$export$9156e739aa33e19f,
    map: $94e17b87f6286380$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $94e17b87f6286380$export$8eef5fdba9512999($5iM4u.Ord),
    foldMap: /*#__PURE__*/ $94e17b87f6286380$export$11b0d0e0b70641d9($5iM4u.Ord),
    reduceRight: /*#__PURE__*/ $94e17b87f6286380$export$ec882fc9def9e5db($5iM4u.Ord),
    traverse: /*#__PURE__*/ $94e17b87f6286380$export$b3c6f3d9661cffba($5iM4u.Ord),
    sequence: $94e17b87f6286380$export$49bb65c2ea163039,
    compact: $94e17b87f6286380$export$8e16b83750b44988,
    separate: $94e17b87f6286380$export$709f6946f4e97408,
    filter: $94e17b87f6286380$export$ec7439dc64f73058,
    filterMap: $94e17b87f6286380$export$e8609d6e184911e6,
    partition: $94e17b87f6286380$export$8d112ad5a197e16a,
    partitionMap: $94e17b87f6286380$export$f721fb25a1c72a8d,
    mapWithIndex: $94e17b87f6286380$export$45e3e46323e6d66c,
    reduceWithIndex: /*#__PURE__*/ $94e17b87f6286380$export$dd5ca3bcbad0b6af($5iM4u.Ord),
    foldMapWithIndex: /*#__PURE__*/ $94e17b87f6286380$export$e08bbf939bdc3250($5iM4u.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $94e17b87f6286380$export$3b7618311030b1af($5iM4u.Ord),
    filterMapWithIndex: $94e17b87f6286380$export$ac207938ecd8ddc4,
    filterWithIndex: $94e17b87f6286380$export$560430393fed15de,
    partitionMapWithIndex: $94e17b87f6286380$export$18034ec93490e9d2,
    partitionWithIndex: $94e17b87f6286380$export$31601036bfbf1c76,
    traverseWithIndex: /*#__PURE__*/ $94e17b87f6286380$var$_traverseWithIndex($5iM4u.Ord),
    wither: $94e17b87f6286380$var$_wither,
    wilt: $94e17b87f6286380$var$_wilt
};

});
parcelRegister("5iM4u", function(module, exports) {

$parcel$export(module.exports, "Eq", () => $3dc3ec2f3faa4083$export$a2050e5b0c4dcf10);
$parcel$export(module.exports, "Ord", () => $3dc3ec2f3faa4083$export$ee8aa95bfab51c5);
$parcel$export(module.exports, "isEmpty", () => $3dc3ec2f3faa4083$export$dd1bc94b04021eeb);

var $eAcXw = parcelRequire("eAcXw");
var $3dc3ec2f3faa4083$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $3dc3ec2f3faa4083$export$c16b1dbe8a4166b6 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $3dc3ec2f3faa4083$export$6e22c362a0406a2c = '';
var $3dc3ec2f3faa4083$export$8f55868b713abdc3 = {
    concat: $3dc3ec2f3faa4083$export$c16b1dbe8a4166b6.concat,
    empty: $3dc3ec2f3faa4083$export$6e22c362a0406a2c
};
var $3dc3ec2f3faa4083$export$ee8aa95bfab51c5 = {
    equals: $3dc3ec2f3faa4083$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $3dc3ec2f3faa4083$export$f6a3d19be20f5819 = {
    show: function(s) {
        return JSON.stringify(s);
    }
};
var $3dc3ec2f3faa4083$export$844ec244b1367d54 = function(u) {
    return typeof u === 'string';
};
var $3dc3ec2f3faa4083$export$d80c591a9e16646 = function(s) {
    return s.toUpperCase();
};
var $3dc3ec2f3faa4083$export$84b9399c77df0edf = function(s) {
    return s.toLowerCase();
};
var $3dc3ec2f3faa4083$export$77ad94ebf1c2b9ed = function(searchValue, replaceValue) {
    return function(s) {
        return s.replace(searchValue, replaceValue);
    };
};
var $3dc3ec2f3faa4083$export$87c2784dc9fc4ab = function(s) {
    return s.trim();
};
var $3dc3ec2f3faa4083$export$c5557f40488c48ec = function(s) {
    return s.trimLeft();
};
var $3dc3ec2f3faa4083$export$da8e5da96e287379 = function(s) {
    return s.trimRight();
};
var $3dc3ec2f3faa4083$export$58adb3bec8346d0f = function(start, end) {
    return function(s) {
        return s.slice(start, end);
    };
};
var $3dc3ec2f3faa4083$export$dd1bc94b04021eeb = function(s) {
    return s.length === 0;
};
var $3dc3ec2f3faa4083$export$346677f925de839c = function(s) {
    return s.length;
};
var $3dc3ec2f3faa4083$export$65980d18b75784e2 = function(separator) {
    return function(s) {
        var out = s.split(separator);
        return (0, $eAcXw.isNonEmpty)(out) ? out : [
            s
        ];
    };
};
var $3dc3ec2f3faa4083$export$ee2e0f811dca1807 = function(searchString, position) {
    return function(s) {
        return s.includes(searchString, position);
    };
};
var $3dc3ec2f3faa4083$export$68326237475e9a7d = function(searchString, position) {
    return function(s) {
        return s.startsWith(searchString, position);
    };
};
var $3dc3ec2f3faa4083$export$10fdab3683b55b22 = function(searchString, position) {
    return function(s) {
        return s.endsWith(searchString, position);
    };
};

});


parcelRegister("eVPL0", function(module, exports) {

$parcel$export(module.exports, "left", () => $adee89795420cf22$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "right", () => $adee89795420cf22$export$79ffe56a765070d2);
$parcel$export(module.exports, "isLeft", () => $adee89795420cf22$export$d649b6842e09f2b);
$parcel$export(module.exports, "map", () => $adee89795420cf22$export$871de8747c9eaa88);
$parcel$export(module.exports, "match", () => $adee89795420cf22$export$4659b591c19bdf3d);
$parcel$export(module.exports, "fold", () => $adee89795420cf22$export$93e2b83da34ff82a);
$parcel$export(module.exports, "Do", () => $adee89795420cf22$export$dfcca0b9d3f9c8f1);
$parcel$export(module.exports, "bind", () => $adee89795420cf22$export$2385a24977818dd0);
$parcel$export(module.exports, "traverseArray", () => $adee89795420cf22$export$64f39b2a2b79e1b1);
$parcel$export(module.exports, "chain", () => $adee89795420cf22$export$e08e3b67e392101e);

var $jsIAd = parcelRequire("jsIAd");

var $4AIBj = parcelRequire("4AIBj");

var $iXLA9 = parcelRequire("iXLA9");

var $eL2y0 = parcelRequire("eL2y0");

var $coJMz = parcelRequire("coJMz");

var $lWM6H = parcelRequire("lWM6H");

var $gnzaQ = parcelRequire("gnzaQ");

var $9sd2T = parcelRequire("9sd2T");

var $fYAej = parcelRequire("fYAej");

var $loyJ7 = parcelRequire("loyJ7");
var $adee89795420cf22$export$eabcd2c8791e7bf4 = $9sd2T.left;
var $adee89795420cf22$export$79ffe56a765070d2 = $9sd2T.right;
var $adee89795420cf22$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $lWM6H.dual)(2, function(ma, f) {
    return $adee89795420cf22$export$d649b6842e09f2b(ma) ? ma : f(ma.right);
});
var $adee89795420cf22$var$_map = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $adee89795420cf22$export$871de8747c9eaa88(f));
};
var $adee89795420cf22$var$_ap = function(fab, fa) {
    return (0, $lWM6H.pipe)(fab, $adee89795420cf22$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $adee89795420cf22$var$_reduce = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $adee89795420cf22$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $adee89795420cf22$var$_foldMap = function(M) {
    return function(fa, f) {
        var foldMapM = $adee89795420cf22$export$b66cdc0497d8a99a(M);
        return (0, $lWM6H.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $adee89795420cf22$var$_reduceRight = function(fa, b, f) {
    return (0, $lWM6H.pipe)(fa, $adee89795420cf22$export$7fef8bcdbb34f435(b, f));
};
var $adee89795420cf22$var$_traverse = function(F) {
    var traverseF = $adee89795420cf22$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $lWM6H.pipe)(ta, traverseF(f));
    };
};
var $adee89795420cf22$var$_bimap = function(fa, f, g) {
    return (0, $lWM6H.pipe)(fa, $adee89795420cf22$export$eb54baf0b342cb1d(f, g));
};
var $adee89795420cf22$var$_mapLeft = function(fa, f) {
    return (0, $lWM6H.pipe)(fa, $adee89795420cf22$export$472de43a55e4aa49(f));
};
/* istanbul ignore next */ var $adee89795420cf22$var$_alt = function(fa, that) {
    return (0, $lWM6H.pipe)(fa, $adee89795420cf22$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $adee89795420cf22$var$_extend = function(wa, f) {
    return (0, $lWM6H.pipe)(wa, $adee89795420cf22$export$8b58be045bf06082(f));
};
var $adee89795420cf22$var$_chainRec = function(a, f) {
    return (0, $eL2y0.tailRec)(f(a), function(e) {
        return $adee89795420cf22$export$d649b6842e09f2b(e) ? $adee89795420cf22$export$79ffe56a765070d2($adee89795420cf22$export$eabcd2c8791e7bf4(e.left)) : $adee89795420cf22$export$d649b6842e09f2b(e.right) ? $adee89795420cf22$export$eabcd2c8791e7bf4(f(e.right.left)) : $adee89795420cf22$export$79ffe56a765070d2($adee89795420cf22$export$79ffe56a765070d2(e.right.right));
    });
};
var $adee89795420cf22$export$9156e739aa33e19f = 'Either';
var $adee89795420cf22$export$3cb5cd7f7776c81 = function(SE, SA) {
    return {
        show: function(ma) {
            return $adee89795420cf22$export$d649b6842e09f2b(ma) ? "left(".concat(SE.show(ma.left), ")") : "right(".concat(SA.show(ma.right), ")");
        }
    };
};
var $adee89795420cf22$export$804fed467fde44e4 = function(EL, EA) {
    return {
        equals: function(x, y) {
            return x === y || ($adee89795420cf22$export$d649b6842e09f2b(x) ? $adee89795420cf22$export$d649b6842e09f2b(y) && EL.equals(x.left, y.left) : $adee89795420cf22$export$a9d71693f0c1a85d(y) && EA.equals(x.right, y.right));
        }
    };
};
var $adee89795420cf22$export$e759a9a7f8d04692 = function(S) {
    return {
        concat: function(x, y) {
            return $adee89795420cf22$export$d649b6842e09f2b(y) ? x : $adee89795420cf22$export$d649b6842e09f2b(x) ? y : $adee89795420cf22$export$79ffe56a765070d2(S.concat(x.right, y.right));
        }
    };
};
var $adee89795420cf22$export$cfae3069ac05ff4c = function(M) {
    var empty = $adee89795420cf22$export$eabcd2c8791e7bf4(M.empty);
    return {
        URI: $adee89795420cf22$export$9156e739aa33e19f,
        _E: undefined,
        compact: function(ma) {
            return $adee89795420cf22$export$d649b6842e09f2b(ma) ? ma : ma.right._tag === 'None' ? empty : $adee89795420cf22$export$79ffe56a765070d2(ma.right.value);
        },
        separate: function(ma) {
            return $adee89795420cf22$export$d649b6842e09f2b(ma) ? (0, $fYAej.separated)(ma, ma) : $adee89795420cf22$export$d649b6842e09f2b(ma.right) ? (0, $fYAej.separated)($adee89795420cf22$export$79ffe56a765070d2(ma.right.left), empty) : (0, $fYAej.separated)(empty, $adee89795420cf22$export$79ffe56a765070d2(ma.right.right));
        }
    };
};
var $adee89795420cf22$export$a4e870b0a57ec14e = function(M) {
    var empty = $adee89795420cf22$export$eabcd2c8791e7bf4(M.empty);
    var _a = $adee89795420cf22$export$cfae3069ac05ff4c(M), compact = _a.compact, separate = _a.separate;
    var filter = function(ma, predicate) {
        return $adee89795420cf22$export$d649b6842e09f2b(ma) ? ma : predicate(ma.right) ? ma : empty;
    };
    var partition = function(ma, p) {
        return $adee89795420cf22$export$d649b6842e09f2b(ma) ? (0, $fYAej.separated)(ma, ma) : p(ma.right) ? (0, $fYAej.separated)(empty, $adee89795420cf22$export$79ffe56a765070d2(ma.right)) : (0, $fYAej.separated)($adee89795420cf22$export$79ffe56a765070d2(ma.right), empty);
    };
    return {
        URI: $adee89795420cf22$export$9156e739aa33e19f,
        _E: undefined,
        map: $adee89795420cf22$var$_map,
        compact: compact,
        separate: separate,
        filter: filter,
        filterMap: function(ma, f) {
            if ($adee89795420cf22$export$d649b6842e09f2b(ma)) return ma;
            var ob = f(ma.right);
            return ob._tag === 'None' ? empty : $adee89795420cf22$export$79ffe56a765070d2(ob.value);
        },
        partition: partition,
        partitionMap: function(ma, f) {
            if ($adee89795420cf22$export$d649b6842e09f2b(ma)) return (0, $fYAej.separated)(ma, ma);
            var e = f(ma.right);
            return $adee89795420cf22$export$d649b6842e09f2b(e) ? (0, $fYAej.separated)($adee89795420cf22$export$79ffe56a765070d2(e.left), empty) : (0, $fYAej.separated)(empty, $adee89795420cf22$export$79ffe56a765070d2(e.right));
        }
    };
};
var $adee89795420cf22$export$bb8ef26a634cac7b = function(M) {
    var F_ = $adee89795420cf22$export$a4e870b0a57ec14e(M);
    var C = $adee89795420cf22$export$cfae3069ac05ff4c(M);
    return {
        URI: $adee89795420cf22$export$9156e739aa33e19f,
        _E: undefined,
        map: $adee89795420cf22$var$_map,
        compact: F_.compact,
        separate: F_.separate,
        filter: F_.filter,
        filterMap: F_.filterMap,
        partition: F_.partition,
        partitionMap: F_.partitionMap,
        traverse: $adee89795420cf22$var$_traverse,
        sequence: $adee89795420cf22$export$49bb65c2ea163039,
        reduce: $adee89795420cf22$var$_reduce,
        foldMap: $adee89795420cf22$var$_foldMap,
        reduceRight: $adee89795420cf22$var$_reduceRight,
        wither: (0, $loyJ7.witherDefault)($adee89795420cf22$export$a0202666c3bda011, C),
        wilt: (0, $loyJ7.wiltDefault)($adee89795420cf22$export$a0202666c3bda011, C)
    };
};
var $adee89795420cf22$export$d9540e18497e6036 = function(SE) {
    return {
        URI: $adee89795420cf22$export$9156e739aa33e19f,
        _E: undefined,
        map: $adee89795420cf22$var$_map,
        ap: function(fab, fa) {
            return $adee89795420cf22$export$d649b6842e09f2b(fab) ? $adee89795420cf22$export$d649b6842e09f2b(fa) ? $adee89795420cf22$export$eabcd2c8791e7bf4(SE.concat(fab.left, fa.left)) : fab : $adee89795420cf22$export$d649b6842e09f2b(fa) ? fa : $adee89795420cf22$export$79ffe56a765070d2(fab.right(fa.right));
        },
        of: $adee89795420cf22$export$ba255e9e49e00608
    };
};
var $adee89795420cf22$export$a81dd5ed716f5f73 = function(SE) {
    return {
        URI: $adee89795420cf22$export$9156e739aa33e19f,
        _E: undefined,
        map: $adee89795420cf22$var$_map,
        alt: function(me, that) {
            if ($adee89795420cf22$export$a9d71693f0c1a85d(me)) return me;
            var ea = that();
            return $adee89795420cf22$export$d649b6842e09f2b(ea) ? $adee89795420cf22$export$eabcd2c8791e7bf4(SE.concat(me.left, ea.left)) : ea;
        }
    };
};
var $adee89795420cf22$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $adee89795420cf22$export$d649b6842e09f2b(fa) ? fa : $adee89795420cf22$export$79ffe56a765070d2(f(fa.right));
    };
};
var $adee89795420cf22$export$bd5b6bfc5fa2ee61 = {
    URI: $adee89795420cf22$export$9156e739aa33e19f,
    map: $adee89795420cf22$var$_map
};
var $adee89795420cf22$export$6554612db691658e = (0, $lWM6H.dual)(2, (0, $gnzaQ.as)($adee89795420cf22$export$bd5b6bfc5fa2ee61));
var $adee89795420cf22$export$9284b360ca18a0fd = (0, $gnzaQ.asUnit)($adee89795420cf22$export$bd5b6bfc5fa2ee61);
var $adee89795420cf22$export$ba255e9e49e00608 = $adee89795420cf22$export$79ffe56a765070d2;
var $adee89795420cf22$export$59a71046037e6c20 = {
    URI: $adee89795420cf22$export$9156e739aa33e19f,
    of: $adee89795420cf22$export$ba255e9e49e00608
};
var $adee89795420cf22$export$321be6e231de8eac = function(fa) {
    return function(fab) {
        return $adee89795420cf22$export$d649b6842e09f2b(fab) ? fab : $adee89795420cf22$export$d649b6842e09f2b(fa) ? fa : $adee89795420cf22$export$79ffe56a765070d2(fab.right(fa.right));
    };
};
var $adee89795420cf22$export$2f6ca3d3b1f80bf5 = $adee89795420cf22$export$321be6e231de8eac;
var $adee89795420cf22$export$efc21ddc6aeb363d = {
    URI: $adee89795420cf22$export$9156e739aa33e19f,
    map: $adee89795420cf22$var$_map,
    ap: $adee89795420cf22$var$_ap
};
var $adee89795420cf22$export$1279d2b7807629fd = {
    URI: $adee89795420cf22$export$9156e739aa33e19f,
    map: $adee89795420cf22$var$_map,
    ap: $adee89795420cf22$var$_ap,
    of: $adee89795420cf22$export$ba255e9e49e00608
};
var $adee89795420cf22$export$f18d5acc27d70423 = {
    URI: $adee89795420cf22$export$9156e739aa33e19f,
    map: $adee89795420cf22$var$_map,
    ap: $adee89795420cf22$var$_ap,
    chain: $adee89795420cf22$export$5b8affa63fc6df16
};
var $adee89795420cf22$export$fb641926d034ac7d = {
    URI: $adee89795420cf22$export$9156e739aa33e19f,
    map: $adee89795420cf22$var$_map,
    ap: $adee89795420cf22$var$_ap,
    of: $adee89795420cf22$export$ba255e9e49e00608,
    chain: $adee89795420cf22$export$5b8affa63fc6df16
};
var $adee89795420cf22$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $adee89795420cf22$export$d649b6842e09f2b(fa) ? b : f(b, fa.right);
    };
};
var $adee89795420cf22$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $adee89795420cf22$export$d649b6842e09f2b(fa) ? M.empty : f(fa.right);
        };
    };
};
var $adee89795420cf22$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $adee89795420cf22$export$d649b6842e09f2b(fa) ? b : f(fa.right, b);
    };
};
var $adee89795420cf22$export$41404b31838667c9 = {
    URI: $adee89795420cf22$export$9156e739aa33e19f,
    reduce: $adee89795420cf22$var$_reduce,
    foldMap: $adee89795420cf22$var$_foldMap,
    reduceRight: $adee89795420cf22$var$_reduceRight
};
var $adee89795420cf22$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $adee89795420cf22$export$d649b6842e09f2b(ta) ? F.of($adee89795420cf22$export$eabcd2c8791e7bf4(ta.left)) : F.map(f(ta.right), $adee89795420cf22$export$79ffe56a765070d2);
        };
    };
};
var $adee89795420cf22$export$49bb65c2ea163039 = function(F) {
    return function(ma) {
        return $adee89795420cf22$export$d649b6842e09f2b(ma) ? F.of($adee89795420cf22$export$eabcd2c8791e7bf4(ma.left)) : F.map(ma.right, $adee89795420cf22$export$79ffe56a765070d2);
    };
};
var $adee89795420cf22$export$a0202666c3bda011 = {
    URI: $adee89795420cf22$export$9156e739aa33e19f,
    map: $adee89795420cf22$var$_map,
    reduce: $adee89795420cf22$var$_reduce,
    foldMap: $adee89795420cf22$var$_foldMap,
    reduceRight: $adee89795420cf22$var$_reduceRight,
    traverse: $adee89795420cf22$var$_traverse,
    sequence: $adee89795420cf22$export$49bb65c2ea163039
};
var $adee89795420cf22$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $adee89795420cf22$export$d649b6842e09f2b(fa) ? $adee89795420cf22$export$eabcd2c8791e7bf4(f(fa.left)) : $adee89795420cf22$export$79ffe56a765070d2(g(fa.right));
    };
};
var $adee89795420cf22$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $adee89795420cf22$export$d649b6842e09f2b(fa) ? $adee89795420cf22$export$eabcd2c8791e7bf4(f(fa.left)) : fa;
    };
};
var $adee89795420cf22$export$fd0fe42029639505 = {
    URI: $adee89795420cf22$export$9156e739aa33e19f,
    bimap: $adee89795420cf22$var$_bimap,
    mapLeft: $adee89795420cf22$var$_mapLeft
};
var $adee89795420cf22$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return $adee89795420cf22$export$d649b6842e09f2b(fa) ? that() : fa;
    };
};
var $adee89795420cf22$export$228be17d80722ab = $adee89795420cf22$export$1517cca7889d6aaa;
var $adee89795420cf22$export$25ba4469a069167 = {
    URI: $adee89795420cf22$export$9156e739aa33e19f,
    map: $adee89795420cf22$var$_map,
    alt: $adee89795420cf22$var$_alt
};
var $adee89795420cf22$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $adee89795420cf22$export$d649b6842e09f2b(wa) ? wa : $adee89795420cf22$export$79ffe56a765070d2(f(wa));
    };
};
var $adee89795420cf22$export$5b5dd0e212d2a5bc = {
    URI: $adee89795420cf22$export$9156e739aa33e19f,
    map: $adee89795420cf22$var$_map,
    extend: $adee89795420cf22$var$_extend
};
var $adee89795420cf22$export$be58f7327716329d = {
    URI: $adee89795420cf22$export$9156e739aa33e19f,
    map: $adee89795420cf22$var$_map,
    ap: $adee89795420cf22$var$_ap,
    chain: $adee89795420cf22$export$5b8affa63fc6df16,
    chainRec: $adee89795420cf22$var$_chainRec
};
var $adee89795420cf22$export$8bf7aba4a9e09055 = $adee89795420cf22$export$eabcd2c8791e7bf4;
var $adee89795420cf22$export$5f956d47d0619c3a = {
    URI: $adee89795420cf22$export$9156e739aa33e19f,
    map: $adee89795420cf22$var$_map,
    ap: $adee89795420cf22$var$_ap,
    of: $adee89795420cf22$export$ba255e9e49e00608,
    chain: $adee89795420cf22$export$5b8affa63fc6df16,
    throwError: $adee89795420cf22$export$8bf7aba4a9e09055
};
var $adee89795420cf22$export$825ea6cb6fc48d49 = {
    URI: $adee89795420cf22$export$9156e739aa33e19f,
    fromEither: (0, $lWM6H.identity)
};
var $adee89795420cf22$export$23f31c55d7162b91 = /*#__PURE__*/ (0, $coJMz.fromPredicate)($adee89795420cf22$export$825ea6cb6fc48d49);
var $adee89795420cf22$export$172ec0a6ebfeb6fa = /*#__PURE__*/ (0, $coJMz.fromOption)($adee89795420cf22$export$825ea6cb6fc48d49);
var $adee89795420cf22$export$d649b6842e09f2b = $9sd2T.isLeft;
var $adee89795420cf22$export$a9d71693f0c1a85d = $9sd2T.isRight;
var $adee89795420cf22$export$2d55ea551c238330 = function(onLeft, onRight) {
    return function(ma) {
        return $adee89795420cf22$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : onRight(ma.right);
    };
};
var $adee89795420cf22$export$ccb09033cefa61e8 = $adee89795420cf22$export$2d55ea551c238330;
var $adee89795420cf22$export$4659b591c19bdf3d = $adee89795420cf22$export$2d55ea551c238330;
var $adee89795420cf22$export$93e2b83da34ff82a = $adee89795420cf22$export$4659b591c19bdf3d;
var $adee89795420cf22$export$d8a997ff0e6436f3 = function(onLeft) {
    return function(ma) {
        return $adee89795420cf22$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma.right;
    };
};
var $adee89795420cf22$export$8832081647a02ee7 = $adee89795420cf22$export$d8a997ff0e6436f3;
var $adee89795420cf22$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $gnzaQ.flap)($adee89795420cf22$export$bd5b6bfc5fa2ee61);
var $adee89795420cf22$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $4AIBj.apFirst)($adee89795420cf22$export$efc21ddc6aeb363d);
var $adee89795420cf22$export$ac044f4aa9961a4f = $adee89795420cf22$export$5f28d9feedcfd46e;
var $adee89795420cf22$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $4AIBj.apSecond)($adee89795420cf22$export$efc21ddc6aeb363d);
var $adee89795420cf22$export$8a00020751233172 = $adee89795420cf22$export$ed01bc59c3d06bf3;
var $adee89795420cf22$export$3f23594af5f37336 = /*#__PURE__*/ (0, $lWM6H.dual)(2, $iXLA9.tap($adee89795420cf22$export$f18d5acc27d70423));
var $adee89795420cf22$export$2409099f1fc434fb = /*#__PURE__*/ $adee89795420cf22$export$5b8affa63fc6df16((0, $lWM6H.identity));
var $adee89795420cf22$export$bffa455ba8c619a6 = $adee89795420cf22$export$2409099f1fc434fb;
var $adee89795420cf22$export$ecd5e8ace626722c = /*#__PURE__*/ $adee89795420cf22$export$8b58be045bf06082((0, $lWM6H.identity));
var $adee89795420cf22$export$a907462f448b49f8 = /*#__PURE__*/ (0, $coJMz.fromOptionK)($adee89795420cf22$export$825ea6cb6fc48d49);
var $adee89795420cf22$export$12d26179deb6a68a = /*#__PURE__*/ (0, $coJMz.chainOptionK)($adee89795420cf22$export$825ea6cb6fc48d49, $adee89795420cf22$export$f18d5acc27d70423);
var $adee89795420cf22$export$377cc334277e5c3c = $adee89795420cf22$export$12d26179deb6a68a;
/** @internal */ var $adee89795420cf22$var$_FromEither = {
    fromEither: $adee89795420cf22$export$825ea6cb6fc48d49.fromEither
};
var $adee89795420cf22$export$cd139e14432f317b = /*#__PURE__*/ $9sd2T.liftNullable($adee89795420cf22$var$_FromEither);
var $adee89795420cf22$export$ea4a22f93200df79 = /*#__PURE__*/ $9sd2T.liftOption($adee89795420cf22$var$_FromEither);
/** @internal */ var $adee89795420cf22$var$_FlatMap = {
    flatMap: $adee89795420cf22$export$5b8affa63fc6df16
};
var $adee89795420cf22$export$1a0515933c5c84fe = /*#__PURE__*/ $9sd2T.flatMapNullable($adee89795420cf22$var$_FromEither, $adee89795420cf22$var$_FlatMap);
var $adee89795420cf22$export$b5f02b7beb8ed7d8 = /*#__PURE__*/ $9sd2T.flatMapOption($adee89795420cf22$var$_FromEither, $adee89795420cf22$var$_FlatMap);
var $adee89795420cf22$export$30af8ca9498ddf5b = /*#__PURE__*/ (0, $coJMz.filterOrElse)($adee89795420cf22$export$825ea6cb6fc48d49, $adee89795420cf22$export$f18d5acc27d70423);
var $adee89795420cf22$export$84511cf4503ec9dd = $adee89795420cf22$export$30af8ca9498ddf5b;
var $adee89795420cf22$export$b0e76d9850c64156 = function(ma) {
    return $adee89795420cf22$export$d649b6842e09f2b(ma) ? $adee89795420cf22$export$79ffe56a765070d2(ma.left) : $adee89795420cf22$export$eabcd2c8791e7bf4(ma.right);
};
var $adee89795420cf22$export$efd845e0c87089a6 = function(onLeft) {
    return function(ma) {
        return $adee89795420cf22$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma;
    };
};
var $adee89795420cf22$export$41d1a04d78e7b141 = $adee89795420cf22$export$efd845e0c87089a6;
var $adee89795420cf22$export$b601f49376b4621a = function(e) {
    return function(a) {
        return a == null ? $adee89795420cf22$export$eabcd2c8791e7bf4(e) : $adee89795420cf22$export$79ffe56a765070d2(a);
    };
};
var $adee89795420cf22$export$d234c058d1d4e435 = function(f, onThrow) {
    try {
        return $adee89795420cf22$export$79ffe56a765070d2(f());
    } catch (e) {
        return $adee89795420cf22$export$eabcd2c8791e7bf4(onThrow(e));
    }
};
var $adee89795420cf22$export$7f3d23c4b0794e72 = function(f, onThrow) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $adee89795420cf22$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        }, onThrow);
    };
};
var $adee89795420cf22$export$c69ca7b73fad45e1 = function(e) {
    var from = $adee89795420cf22$export$b601f49376b4621a(e);
    return function(f) {
        return (0, $lWM6H.flow)(f, from);
    };
};
var $adee89795420cf22$export$c81f992c08fd0bf3 = function(e) {
    var from = $adee89795420cf22$export$c69ca7b73fad45e1(e);
    return function(f) {
        return $adee89795420cf22$export$5b8affa63fc6df16(from(f));
    };
};
var $adee89795420cf22$export$a0886ed3a572729f = /*#__PURE__*/ $adee89795420cf22$export$ccb09033cefa61e8((0, $lWM6H.identity), (0, $lWM6H.identity));
function $adee89795420cf22$export$cc3b967c039ed3e7(e) {
    try {
        return e instanceof Error ? e : new Error(String(e));
    } catch (error) {
        return new Error();
    }
}
function $adee89795420cf22$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $adee89795420cf22$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $adee89795420cf22$export$d649b6842e09f2b(ma) ? false : E.equals(a, ma.right);
    };
}
var $adee89795420cf22$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $adee89795420cf22$export$d649b6842e09f2b(ma) ? false : predicate(ma.right);
    };
};
var $adee89795420cf22$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $adee89795420cf22$export$ba255e9e49e00608($9sd2T.emptyRecord);
var $adee89795420cf22$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $gnzaQ.bindTo)($adee89795420cf22$export$bd5b6bfc5fa2ee61);
var $adee89795420cf22$export$5d537b797c421217 = /*#__PURE__*/ (0, $gnzaQ.let)($adee89795420cf22$export$bd5b6bfc5fa2ee61);
var $adee89795420cf22$export$2385a24977818dd0 = /*#__PURE__*/ $iXLA9.bind($adee89795420cf22$export$f18d5acc27d70423);
var $adee89795420cf22$export$e0d5b1cbe98976d9 = $adee89795420cf22$export$2385a24977818dd0;
var $adee89795420cf22$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $4AIBj.apS)($adee89795420cf22$export$efc21ddc6aeb363d);
var $adee89795420cf22$export$5c01f27714264b3d = $adee89795420cf22$export$8cbfc0239f42bb49;
var $adee89795420cf22$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $adee89795420cf22$export$ba255e9e49e00608($9sd2T.emptyReadonlyArray);
var $adee89795420cf22$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var e = f(0, $9sd2T.head(as));
        if ($adee89795420cf22$export$d649b6842e09f2b(e)) return e;
        var out = [
            e.right
        ];
        for(var i = 1; i < as.length; i++){
            var e_1 = f(i, as[i]);
            if ($adee89795420cf22$export$d649b6842e09f2b(e_1)) return e_1;
            out.push(e_1.right);
        }
        return $adee89795420cf22$export$79ffe56a765070d2(out);
    };
};
var $adee89795420cf22$export$d4e79db5dc14cc1 = function(f) {
    var g = $adee89795420cf22$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $9sd2T.isNonEmpty(as) ? g(as) : $adee89795420cf22$export$c74b6e34b2b6efb0;
    };
};
var $adee89795420cf22$export$104a2841e9cbad06 = $adee89795420cf22$export$d4e79db5dc14cc1;
var $adee89795420cf22$export$64f39b2a2b79e1b1 = function(f) {
    return $adee89795420cf22$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $adee89795420cf22$export$d330b60315c14cd1 = /*#__PURE__*/ $adee89795420cf22$export$64f39b2a2b79e1b1((0, $lWM6H.identity));
var $adee89795420cf22$export$8e5885f0163d737a = $adee89795420cf22$export$5b8affa63fc6df16;
var $adee89795420cf22$export$e08e3b67e392101e = $adee89795420cf22$export$5b8affa63fc6df16;
var $adee89795420cf22$export$e3821ef4970c339c = $adee89795420cf22$export$3f23594af5f37336;
var $adee89795420cf22$export$5de78197fc44b933 = $adee89795420cf22$export$3f23594af5f37336;
function $adee89795420cf22$export$27924e57e9afff7f(s, onError) {
    return $adee89795420cf22$export$d234c058d1d4e435(function() {
        return JSON.parse(s);
    }, onError);
}
var $adee89795420cf22$export$702e019c6853c7a = function(u, onError) {
    return $adee89795420cf22$export$d234c058d1d4e435(function() {
        var s = JSON.stringify(u);
        if (typeof s !== 'string') throw new Error('Converting unsupported structure to JSON');
        return s;
    }, onError);
};
var $adee89795420cf22$export$5f5be1bb6cd1fded = {
    URI: $adee89795420cf22$export$9156e739aa33e19f,
    map: $adee89795420cf22$var$_map,
    of: $adee89795420cf22$export$ba255e9e49e00608,
    ap: $adee89795420cf22$var$_ap,
    chain: $adee89795420cf22$export$5b8affa63fc6df16,
    reduce: $adee89795420cf22$var$_reduce,
    foldMap: $adee89795420cf22$var$_foldMap,
    reduceRight: $adee89795420cf22$var$_reduceRight,
    traverse: $adee89795420cf22$var$_traverse,
    sequence: $adee89795420cf22$export$49bb65c2ea163039,
    bimap: $adee89795420cf22$var$_bimap,
    mapLeft: $adee89795420cf22$var$_mapLeft,
    alt: $adee89795420cf22$var$_alt,
    extend: $adee89795420cf22$var$_extend,
    chainRec: $adee89795420cf22$var$_chainRec,
    throwError: $adee89795420cf22$export$8bf7aba4a9e09055
};
var $adee89795420cf22$export$18979a515d2a828e = /*#__PURE__*/ (0, $4AIBj.getApplySemigroup)($adee89795420cf22$export$efc21ddc6aeb363d);
var $adee89795420cf22$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $jsIAd.getApplicativeMonoid)($adee89795420cf22$export$1279d2b7807629fd);
var $adee89795420cf22$export$5c6835227ac7f658 = function(SE, SA) {
    return (0, $4AIBj.getApplySemigroup)($adee89795420cf22$export$d9540e18497e6036(SE))(SA);
};
var $adee89795420cf22$export$c6554235dd19af66 = function(SE, MA) {
    return (0, $jsIAd.getApplicativeMonoid)($adee89795420cf22$export$d9540e18497e6036(SE))(MA);
};
function $adee89795420cf22$export$6843f928420ce3e4(SE) {
    var ap = $adee89795420cf22$export$d9540e18497e6036(SE).ap;
    var alt = $adee89795420cf22$export$a81dd5ed716f5f73(SE).alt;
    return {
        URI: $adee89795420cf22$export$9156e739aa33e19f,
        _E: undefined,
        map: $adee89795420cf22$var$_map,
        of: $adee89795420cf22$export$ba255e9e49e00608,
        chain: $adee89795420cf22$export$5b8affa63fc6df16,
        bimap: $adee89795420cf22$var$_bimap,
        mapLeft: $adee89795420cf22$var$_mapLeft,
        reduce: $adee89795420cf22$var$_reduce,
        foldMap: $adee89795420cf22$var$_foldMap,
        reduceRight: $adee89795420cf22$var$_reduceRight,
        extend: $adee89795420cf22$var$_extend,
        traverse: $adee89795420cf22$var$_traverse,
        sequence: $adee89795420cf22$export$49bb65c2ea163039,
        chainRec: $adee89795420cf22$var$_chainRec,
        throwError: $adee89795420cf22$export$8bf7aba4a9e09055,
        ap: ap,
        alt: alt
    };
}

});
parcelRegister("eL2y0", function(module, exports) {

$parcel$export(module.exports, "tailRec", () => $abe76e5f304138d8$export$2e586eaa876dd2fd);
/**
 * @since 2.0.0
 */ var $abe76e5f304138d8$export$2e586eaa876dd2fd = function(startWith, f) {
    var ab = f(startWith);
    while(ab._tag === 'Left')ab = f(ab.left);
    return ab.right;
};

});




parcelRegister("cWuKG", function(module, exports) {

$parcel$export(module.exports, "asLens", () => $96c2c1838712f62d$export$ba6dbfc52e933ec);
$parcel$export(module.exports, "asPrism", () => $96c2c1838712f62d$export$6963d4cf5712e556);
$parcel$export(module.exports, "asOptional", () => $96c2c1838712f62d$export$81a625dd455a09de);
$parcel$export(module.exports, "asTraversal", () => $96c2c1838712f62d$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $96c2c1838712f62d$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "reverse", () => $96c2c1838712f62d$export$66c1ae025e96b4bc);
$parcel$export(module.exports, "modify", () => $96c2c1838712f62d$export$3ff57735a52b8713);

var $lWM6H = parcelRequire("lWM6H");

var $aOL40 = parcelRequire("aOL40");

var $aYQcG = parcelRequire("aYQcG");
var $96c2c1838712f62d$export$1aba8f741a0eae06 = $aYQcG.iso;
var $96c2c1838712f62d$export$d560c7e4a29451c2 = function() {
    return $96c2c1838712f62d$export$1aba8f741a0eae06((0, $lWM6H.identity), (0, $lWM6H.identity));
};
var $96c2c1838712f62d$export$ba6dbfc52e933ec = $aYQcG.isoAsLens;
var $96c2c1838712f62d$export$6963d4cf5712e556 = $aYQcG.isoAsPrism;
var $96c2c1838712f62d$export$81a625dd455a09de = $aYQcG.isoAsOptional;
var $96c2c1838712f62d$export$ef38eac73d6f828f = $aYQcG.isoAsTraversal;
var $96c2c1838712f62d$export$f672e0b6f7222cd7 = function(ab) {
    return function(sa) {
        return $96c2c1838712f62d$export$1aba8f741a0eae06((0, $lWM6H.flow)(sa.get, ab.get), (0, $lWM6H.flow)(ab.reverseGet, sa.reverseGet));
    };
};
var $96c2c1838712f62d$export$220ad92d18dabdd7 = $96c2c1838712f62d$export$f672e0b6f7222cd7;
var $96c2c1838712f62d$export$f5c3e419c6a355ce = function(ab) {
    return (0, $lWM6H.flow)($96c2c1838712f62d$export$ba6dbfc52e933ec, $aYQcG.lensComposeLens(ab));
};
var $96c2c1838712f62d$export$c1dc05e399870f6 = function(ab) {
    return (0, $lWM6H.flow)($96c2c1838712f62d$export$6963d4cf5712e556, $aYQcG.prismComposePrism(ab));
};
var $96c2c1838712f62d$export$323f76c400675c8b = function(ab) {
    return (0, $lWM6H.flow)($96c2c1838712f62d$export$81a625dd455a09de, $aYQcG.optionalComposeOptional(ab));
};
var $96c2c1838712f62d$export$aa978f69e007229f = function(ab) {
    return (0, $lWM6H.flow)($96c2c1838712f62d$export$ef38eac73d6f828f, $aYQcG.traversalComposeTraversal(ab));
};
var $96c2c1838712f62d$export$66c1ae025e96b4bc = function(sa) {
    return $96c2c1838712f62d$export$1aba8f741a0eae06(sa.reverseGet, sa.get);
};
var $96c2c1838712f62d$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            return sa.reverseGet(f(sa.get(s)));
        };
    };
};
function $96c2c1838712f62d$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $aOL40.pipe)(sa.get(s), f, function(fa) {
                    return F.map(fa, sa.reverseGet);
                });
            };
        };
    };
}
var $96c2c1838712f62d$export$b601f49376b4621a = function(sa) {
    return $96c2c1838712f62d$export$c1dc05e399870f6($aYQcG.prismFromNullable())(sa);
};
function $96c2c1838712f62d$export$3dea766d36a8935f(predicate) {
    return $96c2c1838712f62d$export$c1dc05e399870f6($aYQcG.prismFromPredicate(predicate));
}
var $96c2c1838712f62d$export$977f3f6a9323c0f6 = function(prop) {
    return (0, $lWM6H.flow)($96c2c1838712f62d$export$ba6dbfc52e933ec, $aYQcG.lensProp(prop));
};
var $96c2c1838712f62d$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return (0, $lWM6H.flow)($96c2c1838712f62d$export$ba6dbfc52e933ec, $aYQcG.lensProps.apply($aYQcG, props));
};
var $96c2c1838712f62d$export$d8556a2a8f973135 = function(prop) {
    return (0, $lWM6H.flow)($96c2c1838712f62d$export$ba6dbfc52e933ec, $aYQcG.lensComponent(prop));
};
var $96c2c1838712f62d$export$b610b8812bbcded9 = function(i) {
    return (0, $lWM6H.flow)($96c2c1838712f62d$export$81a625dd455a09de, $aYQcG.optionalIndex(i));
};
var $96c2c1838712f62d$export$84162b00c25b711c = function(i) {
    return (0, $lWM6H.flow)($96c2c1838712f62d$export$81a625dd455a09de, $aYQcG.optionalIndexNonEmpty(i));
};
var $96c2c1838712f62d$export$df61b30b684217c0 = function(key) {
    return (0, $lWM6H.flow)($96c2c1838712f62d$export$81a625dd455a09de, $aYQcG.optionalKey(key));
};
var $96c2c1838712f62d$export$976574c443b9185b = function(key) {
    return (0, $lWM6H.flow)($96c2c1838712f62d$export$ba6dbfc52e933ec, $aYQcG.lensAtKey(key));
};
var $96c2c1838712f62d$export$ad14ef4001db2bcd = /*#__PURE__*/ $96c2c1838712f62d$export$c1dc05e399870f6(/*#__PURE__*/ $aYQcG.prismSome());
var $96c2c1838712f62d$export$79ffe56a765070d2 = /*#__PURE__*/ $96c2c1838712f62d$export$c1dc05e399870f6(/*#__PURE__*/ $aYQcG.prismRight());
var $96c2c1838712f62d$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $96c2c1838712f62d$export$c1dc05e399870f6(/*#__PURE__*/ $aYQcG.prismLeft());
function $96c2c1838712f62d$export$df3f009e3d155b20(T) {
    return (0, $lWM6H.flow)($96c2c1838712f62d$export$ef38eac73d6f828f, $aYQcG.traversalTraverse(T));
}
function $96c2c1838712f62d$export$9a2f228bed5035c2(predicate) {
    return $96c2c1838712f62d$export$323f76c400675c8b($aYQcG.optionalFindFirst(predicate));
}
function $96c2c1838712f62d$export$28e1f787311e0a21(predicate) {
    return $96c2c1838712f62d$export$323f76c400675c8b($aYQcG.optionalFindFirstNonEmpty(predicate));
}
var $96c2c1838712f62d$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $96c2c1838712f62d$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $96c2c1838712f62d$var$imap_ = function(ea, ab, ba) {
    return $96c2c1838712f62d$export$1aba8f741a0eae06((0, $lWM6H.flow)(ea.get, ab), (0, $lWM6H.flow)(ba, ea.reverseGet));
};
var $96c2c1838712f62d$export$9156e739aa33e19f = 'monocle-ts/Iso';
var $96c2c1838712f62d$export$dbdf692cc5737cfd = {
    URI: $96c2c1838712f62d$export$9156e739aa33e19f,
    imap: $96c2c1838712f62d$var$imap_
};
var $96c2c1838712f62d$export$67666a3fb7d250d8 = {
    URI: $96c2c1838712f62d$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $96c2c1838712f62d$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $96c2c1838712f62d$export$3a8840c5b2ecf003 = {
    URI: $96c2c1838712f62d$export$9156e739aa33e19f,
    compose: $96c2c1838712f62d$export$67666a3fb7d250d8.compose,
    id: $96c2c1838712f62d$export$d560c7e4a29451c2
};

});

parcelRegister("4CMYJ", function(module, exports) {

$parcel$export(module.exports, "fromAt", () => $35e0b427d0d0369c$export$c4dd3e639c7af330);
$parcel$export(module.exports, "fromIso", () => $35e0b427d0d0369c$export$3160d47a1ad63980);
/**
 * **This module is experimental**
 *
 * Experimental features are published in order to get early feedback from the community.
 *
 * A feature tagged as _Experimental_ is in a high state of flux, you're at risk of it changing without notice.
 *
 * @since 2.3.0
 */ 
var $5OFXS = parcelRequire("5OFXS");

var $aOL40 = parcelRequire("aOL40");

var $aYQcG = parcelRequire("aYQcG");

var $477ze = parcelRequire("477ze");
var $35e0b427d0d0369c$export$b610b8812bbcded9 = $aYQcG.index;
var $35e0b427d0d0369c$export$c4dd3e639c7af330 = function(at) {
    return $35e0b427d0d0369c$export$b610b8812bbcded9(function(i) {
        return $aYQcG.lensComposePrism($aYQcG.prismSome())(at.at(i));
    });
};
var $35e0b427d0d0369c$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $35e0b427d0d0369c$export$b610b8812bbcded9(function(i) {
            return (0, $aOL40.pipe)(iso, $aYQcG.isoAsOptional, $aYQcG.optionalComposeOptional(sia.index(i)));
        });
    };
};
var $35e0b427d0d0369c$export$bb0c054375ca4b0 = $aYQcG.indexReadonlyArray;
var $35e0b427d0d0369c$export$165af7b747e6b1f1 = $aYQcG.indexReadonlyNonEmptyArray;
var $35e0b427d0d0369c$export$3c3468aec3b83bbf = $aYQcG.indexReadonlyRecord;
var $35e0b427d0d0369c$export$92da200d6ddb6846 = function(E) {
    var lookupE = $477ze.lookup(E);
    var insertAtE = $477ze.insertAt(E);
    return function() {
        return $35e0b427d0d0369c$export$b610b8812bbcded9(function(key) {
            return $aYQcG.optional(function(s) {
                return lookupE(key, s);
            }, function(next) {
                var insert = insertAtE(key, next);
                return function(s) {
                    return (0, $aOL40.pipe)(lookupE(key, s), $5OFXS.fold(function() {
                        return s;
                    }, function(prev) {
                        return next === prev ? s : insert(s);
                    }));
                };
            });
        });
    };
};
var $35e0b427d0d0369c$export$2cd1c249765cd0a4 = $aYQcG.indexReadonlyArray;
var $35e0b427d0d0369c$export$720226bf1ef46cb2 = $aYQcG.indexReadonlyRecord;

});

parcelRegister("2pOLl", function(module, exports) {

$parcel$export(module.exports, "lens", () => $1c254af2ead122a0$export$21cde5187c2605a3);
$parcel$export(module.exports, "id", () => $1c254af2ead122a0$export$d560c7e4a29451c2);
$parcel$export(module.exports, "asOptional", () => $1c254af2ead122a0$export$81a625dd455a09de);
$parcel$export(module.exports, "asTraversal", () => $1c254af2ead122a0$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $1c254af2ead122a0$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "composeLens", () => $1c254af2ead122a0$export$f5c3e419c6a355ce);
$parcel$export(module.exports, "composeIso", () => $1c254af2ead122a0$export$220ad92d18dabdd7);
$parcel$export(module.exports, "composePrism", () => $1c254af2ead122a0$export$c1dc05e399870f6);
$parcel$export(module.exports, "composeOptional", () => $1c254af2ead122a0$export$323f76c400675c8b);
$parcel$export(module.exports, "composeTraversal", () => $1c254af2ead122a0$export$aa978f69e007229f);
$parcel$export(module.exports, "modify", () => $1c254af2ead122a0$export$3ff57735a52b8713);
$parcel$export(module.exports, "modifyF", () => $1c254af2ead122a0$export$a28005d3e6beb9a6);
$parcel$export(module.exports, "fromNullable", () => $1c254af2ead122a0$export$b601f49376b4621a);
$parcel$export(module.exports, "filter", () => $1c254af2ead122a0$export$3dea766d36a8935f);
$parcel$export(module.exports, "prop", () => $1c254af2ead122a0$export$977f3f6a9323c0f6);
$parcel$export(module.exports, "props", () => $1c254af2ead122a0$export$8128bb6492cf3de7);
$parcel$export(module.exports, "component", () => $1c254af2ead122a0$export$d8556a2a8f973135);
$parcel$export(module.exports, "index", () => $1c254af2ead122a0$export$b610b8812bbcded9);
$parcel$export(module.exports, "indexNonEmpty", () => $1c254af2ead122a0$export$84162b00c25b711c);
$parcel$export(module.exports, "key", () => $1c254af2ead122a0$export$df61b30b684217c0);
$parcel$export(module.exports, "atKey", () => $1c254af2ead122a0$export$976574c443b9185b);
$parcel$export(module.exports, "some", () => $1c254af2ead122a0$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "right", () => $1c254af2ead122a0$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $1c254af2ead122a0$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "traverse", () => $1c254af2ead122a0$export$df3f009e3d155b20);
$parcel$export(module.exports, "findFirst", () => $1c254af2ead122a0$export$9a2f228bed5035c2);
$parcel$export(module.exports, "findFirstNonEmpty", () => $1c254af2ead122a0$export$28e1f787311e0a21);
$parcel$export(module.exports, "imap", () => $1c254af2ead122a0$export$b2517b0ab3a58435);
$parcel$export(module.exports, "URI", () => $1c254af2ead122a0$export$9156e739aa33e19f);
$parcel$export(module.exports, "Invariant", () => $1c254af2ead122a0$export$dbdf692cc5737cfd);
$parcel$export(module.exports, "Semigroupoid", () => $1c254af2ead122a0$export$67666a3fb7d250d8);
$parcel$export(module.exports, "Category", () => $1c254af2ead122a0$export$3a8840c5b2ecf003);

var $lWM6H = parcelRequire("lWM6H");

var $aOL40 = parcelRequire("aOL40");

var $aYQcG = parcelRequire("aYQcG");
var $1c254af2ead122a0$export$21cde5187c2605a3 = $aYQcG.lens;
var $1c254af2ead122a0$export$d560c7e4a29451c2 = $aYQcG.lensId;
var $1c254af2ead122a0$export$81a625dd455a09de = $aYQcG.lensAsOptional;
var $1c254af2ead122a0$export$ef38eac73d6f828f = $aYQcG.lensAsTraversal;
var $1c254af2ead122a0$export$f672e0b6f7222cd7 = $aYQcG.lensComposeLens;
var $1c254af2ead122a0$export$f5c3e419c6a355ce = $1c254af2ead122a0$export$f672e0b6f7222cd7;
var $1c254af2ead122a0$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $lWM6H.flow)($aYQcG.isoAsLens, $1c254af2ead122a0$export$f672e0b6f7222cd7);
var $1c254af2ead122a0$export$c1dc05e399870f6 = $aYQcG.lensComposePrism;
var $1c254af2ead122a0$export$323f76c400675c8b = function(ab) {
    return (0, $lWM6H.flow)($1c254af2ead122a0$export$81a625dd455a09de, $aYQcG.optionalComposeOptional(ab));
};
var $1c254af2ead122a0$export$aa978f69e007229f = function(ab) {
    return (0, $lWM6H.flow)($1c254af2ead122a0$export$ef38eac73d6f828f, $aYQcG.traversalComposeTraversal(ab));
};
var $1c254af2ead122a0$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            var o = sa.get(s);
            var n = f(o);
            return o === n ? s : sa.set(n)(s);
        };
    };
};
function $1c254af2ead122a0$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $aOL40.pipe)(sa.get(s), f, function(fa) {
                    return F.map(fa, function(a) {
                        return sa.set(a)(s);
                    });
                });
            };
        };
    };
}
var $1c254af2ead122a0$export$b601f49376b4621a = function(sa) {
    return $1c254af2ead122a0$export$c1dc05e399870f6($aYQcG.prismFromNullable())(sa);
};
function $1c254af2ead122a0$export$3dea766d36a8935f(predicate) {
    return $1c254af2ead122a0$export$c1dc05e399870f6($aYQcG.prismFromPredicate(predicate));
}
var $1c254af2ead122a0$export$977f3f6a9323c0f6 = $aYQcG.lensProp;
var $1c254af2ead122a0$export$8128bb6492cf3de7 = $aYQcG.lensProps;
var $1c254af2ead122a0$export$d8556a2a8f973135 = $aYQcG.lensComponent;
var $1c254af2ead122a0$export$b610b8812bbcded9 = function(i) {
    return (0, $lWM6H.flow)($1c254af2ead122a0$export$81a625dd455a09de, $aYQcG.optionalIndex(i));
};
var $1c254af2ead122a0$export$84162b00c25b711c = function(i) {
    return (0, $lWM6H.flow)($1c254af2ead122a0$export$81a625dd455a09de, $aYQcG.optionalIndexNonEmpty(i));
};
var $1c254af2ead122a0$export$df61b30b684217c0 = function(key) {
    return (0, $lWM6H.flow)($1c254af2ead122a0$export$81a625dd455a09de, $aYQcG.optionalKey(key));
};
var $1c254af2ead122a0$export$976574c443b9185b = $aYQcG.lensAtKey;
var $1c254af2ead122a0$export$ad14ef4001db2bcd = /*#__PURE__*/ $1c254af2ead122a0$export$c1dc05e399870f6(/*#__PURE__*/ $aYQcG.prismSome());
var $1c254af2ead122a0$export$79ffe56a765070d2 = /*#__PURE__*/ $1c254af2ead122a0$export$c1dc05e399870f6(/*#__PURE__*/ $aYQcG.prismRight());
var $1c254af2ead122a0$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $1c254af2ead122a0$export$c1dc05e399870f6(/*#__PURE__*/ $aYQcG.prismLeft());
function $1c254af2ead122a0$export$df3f009e3d155b20(T) {
    return (0, $lWM6H.flow)($1c254af2ead122a0$export$ef38eac73d6f828f, $aYQcG.traversalTraverse(T));
}
function $1c254af2ead122a0$export$9a2f228bed5035c2(predicate) {
    return $1c254af2ead122a0$export$323f76c400675c8b($aYQcG.optionalFindFirst(predicate));
}
function $1c254af2ead122a0$export$28e1f787311e0a21(predicate) {
    return $1c254af2ead122a0$export$323f76c400675c8b($aYQcG.optionalFindFirstNonEmpty(predicate));
}
var $1c254af2ead122a0$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $1c254af2ead122a0$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $1c254af2ead122a0$var$imap_ = function(ea, ab, ba) {
    return $1c254af2ead122a0$export$21cde5187c2605a3((0, $lWM6H.flow)(ea.get, ab), (0, $lWM6H.flow)(ba, ea.set));
};
var $1c254af2ead122a0$export$9156e739aa33e19f = 'monocle-ts/Lens';
var $1c254af2ead122a0$export$dbdf692cc5737cfd = {
    URI: $1c254af2ead122a0$export$9156e739aa33e19f,
    imap: $1c254af2ead122a0$var$imap_
};
var $1c254af2ead122a0$export$67666a3fb7d250d8 = {
    URI: $1c254af2ead122a0$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $1c254af2ead122a0$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $1c254af2ead122a0$export$3a8840c5b2ecf003 = {
    URI: $1c254af2ead122a0$export$9156e739aa33e19f,
    compose: $1c254af2ead122a0$export$67666a3fb7d250d8.compose,
    id: $1c254af2ead122a0$export$d560c7e4a29451c2
};

});

parcelRegister("7hEeH", function(module, exports) {

$parcel$export(module.exports, "asTraversal", () => $54d954f6de0fa13d$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $54d954f6de0fa13d$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "modifyOption", () => $54d954f6de0fa13d$export$a2ef9d652875bdfa);
$parcel$export(module.exports, "modify", () => $54d954f6de0fa13d$export$3ff57735a52b8713);

var $lWM6H = parcelRequire("lWM6H");

var $5OFXS = parcelRequire("5OFXS");

var $aOL40 = parcelRequire("aOL40");

var $aYQcG = parcelRequire("aYQcG");
var $54d954f6de0fa13d$export$516e28dec6a4b6d4 = $aYQcG.optional;
var $54d954f6de0fa13d$export$d560c7e4a29451c2 = function() {
    return $54d954f6de0fa13d$export$516e28dec6a4b6d4($5OFXS.some, (0, $lWM6H.constant));
};
var $54d954f6de0fa13d$export$ef38eac73d6f828f = $aYQcG.optionalAsTraversal;
var $54d954f6de0fa13d$export$f672e0b6f7222cd7 = $aYQcG.optionalComposeOptional;
var $54d954f6de0fa13d$export$323f76c400675c8b = $54d954f6de0fa13d$export$f672e0b6f7222cd7;
var $54d954f6de0fa13d$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $lWM6H.flow)($aYQcG.isoAsOptional, $54d954f6de0fa13d$export$f672e0b6f7222cd7);
var $54d954f6de0fa13d$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $lWM6H.flow)($aYQcG.lensAsOptional, $aYQcG.optionalComposeOptional);
var $54d954f6de0fa13d$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $lWM6H.flow)($aYQcG.prismAsOptional, $aYQcG.optionalComposeOptional);
var $54d954f6de0fa13d$export$aa978f69e007229f = function(ab) {
    return (0, $lWM6H.flow)($54d954f6de0fa13d$export$ef38eac73d6f828f, $aYQcG.traversalComposeTraversal(ab));
};
var $54d954f6de0fa13d$export$a2ef9d652875bdfa = $aYQcG.optionalModifyOption;
var $54d954f6de0fa13d$export$b2a7969df3fe0aa3 = function(a) {
    return $54d954f6de0fa13d$export$a2ef9d652875bdfa(function() {
        return a;
    });
};
var $54d954f6de0fa13d$export$3ff57735a52b8713 = $aYQcG.optionalModify;
function $54d954f6de0fa13d$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $aOL40.pipe)(sa.getOption(s), $5OFXS.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    };
}
var $54d954f6de0fa13d$export$b601f49376b4621a = /*#__PURE__*/ $54d954f6de0fa13d$export$f672e0b6f7222cd7(/*#__PURE__*/ $aYQcG.prismAsOptional(/*#__PURE__*/ $aYQcG.prismFromNullable()));
function $54d954f6de0fa13d$export$3dea766d36a8935f(predicate) {
    return $54d954f6de0fa13d$export$f672e0b6f7222cd7($aYQcG.prismAsOptional($aYQcG.prismFromPredicate(predicate)));
}
var $54d954f6de0fa13d$export$977f3f6a9323c0f6 = function(prop) {
    return $54d954f6de0fa13d$export$f672e0b6f7222cd7((0, $aOL40.pipe)($aYQcG.lensId(), $aYQcG.lensProp(prop), $aYQcG.lensAsOptional));
};
var $54d954f6de0fa13d$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $54d954f6de0fa13d$export$f672e0b6f7222cd7((0, $aOL40.pipe)($aYQcG.lensId(), $aYQcG.lensProps.apply($aYQcG, props), $aYQcG.lensAsOptional));
};
var $54d954f6de0fa13d$export$d8556a2a8f973135 = function(prop) {
    return $54d954f6de0fa13d$export$f672e0b6f7222cd7((0, $aOL40.pipe)($aYQcG.lensId(), $aYQcG.lensComponent(prop), $aYQcG.lensAsOptional));
};
var $54d954f6de0fa13d$export$b610b8812bbcded9 = $aYQcG.optionalIndex;
var $54d954f6de0fa13d$export$84162b00c25b711c = $aYQcG.optionalIndexNonEmpty;
var $54d954f6de0fa13d$export$df61b30b684217c0 = $aYQcG.optionalKey;
var $54d954f6de0fa13d$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $aOL40.pipe)(sa, $54d954f6de0fa13d$export$f672e0b6f7222cd7($aYQcG.lensAsOptional($aYQcG.atReadonlyRecord().at(key))));
    };
};
var $54d954f6de0fa13d$export$ad14ef4001db2bcd = /*#__PURE__*/ $54d954f6de0fa13d$export$f672e0b6f7222cd7(/*#__PURE__*/ $aYQcG.prismAsOptional(/*#__PURE__*/ $aYQcG.prismSome()));
var $54d954f6de0fa13d$export$79ffe56a765070d2 = /*#__PURE__*/ $54d954f6de0fa13d$export$f672e0b6f7222cd7(/*#__PURE__*/ $aYQcG.prismAsOptional(/*#__PURE__*/ $aYQcG.prismRight()));
var $54d954f6de0fa13d$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $54d954f6de0fa13d$export$f672e0b6f7222cd7(/*#__PURE__*/ $aYQcG.prismAsOptional(/*#__PURE__*/ $aYQcG.prismLeft()));
function $54d954f6de0fa13d$export$df3f009e3d155b20(T) {
    return (0, $lWM6H.flow)($54d954f6de0fa13d$export$ef38eac73d6f828f, $aYQcG.traversalTraverse(T));
}
function $54d954f6de0fa13d$export$9a2f228bed5035c2(predicate) {
    return $54d954f6de0fa13d$export$f672e0b6f7222cd7($aYQcG.optionalFindFirst(predicate));
}
function $54d954f6de0fa13d$export$28e1f787311e0a21(predicate) {
    return $54d954f6de0fa13d$export$f672e0b6f7222cd7($aYQcG.optionalFindFirstNonEmpty(predicate));
}
var $54d954f6de0fa13d$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $54d954f6de0fa13d$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $54d954f6de0fa13d$var$imap_ = function(ea, ab, ba) {
    return $54d954f6de0fa13d$export$516e28dec6a4b6d4((0, $lWM6H.flow)(ea.getOption, $5OFXS.map(ab)), (0, $lWM6H.flow)(ba, ea.set));
};
var $54d954f6de0fa13d$export$9156e739aa33e19f = 'monocle-ts/Optional';
var $54d954f6de0fa13d$export$dbdf692cc5737cfd = {
    URI: $54d954f6de0fa13d$export$9156e739aa33e19f,
    imap: $54d954f6de0fa13d$var$imap_
};
var $54d954f6de0fa13d$export$67666a3fb7d250d8 = {
    URI: $54d954f6de0fa13d$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $54d954f6de0fa13d$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $54d954f6de0fa13d$export$3a8840c5b2ecf003 = {
    URI: $54d954f6de0fa13d$export$9156e739aa33e19f,
    compose: $54d954f6de0fa13d$export$67666a3fb7d250d8.compose,
    id: $54d954f6de0fa13d$export$d560c7e4a29451c2
};

});

parcelRegister("bwWgx", function(module, exports) {

$parcel$export(module.exports, "fromPredicate", () => $864fe13fcc485996$export$23f31c55d7162b91);
$parcel$export(module.exports, "asOptional", () => $864fe13fcc485996$export$81a625dd455a09de);
$parcel$export(module.exports, "asTraversal", () => $864fe13fcc485996$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $864fe13fcc485996$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "composeLens", () => $864fe13fcc485996$export$f5c3e419c6a355ce);

var $lWM6H = parcelRequire("lWM6H");

var $5OFXS = parcelRequire("5OFXS");

var $aOL40 = parcelRequire("aOL40");

var $aYQcG = parcelRequire("aYQcG");
var $864fe13fcc485996$export$e469dcfea9910464 = $aYQcG.prism;
var $864fe13fcc485996$export$d560c7e4a29451c2 = function() {
    return $864fe13fcc485996$export$e469dcfea9910464($5OFXS.some, (0, $lWM6H.identity));
};
var $864fe13fcc485996$export$23f31c55d7162b91 = $aYQcG.prismFromPredicate;
var $864fe13fcc485996$export$81a625dd455a09de = $aYQcG.prismAsOptional;
var $864fe13fcc485996$export$ef38eac73d6f828f = $aYQcG.prismAsTraversal;
var $864fe13fcc485996$export$f672e0b6f7222cd7 = $aYQcG.prismComposePrism;
var $864fe13fcc485996$export$c1dc05e399870f6 = $864fe13fcc485996$export$f672e0b6f7222cd7;
var $864fe13fcc485996$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $lWM6H.flow)($aYQcG.isoAsPrism, $864fe13fcc485996$export$f672e0b6f7222cd7);
var $864fe13fcc485996$export$f5c3e419c6a355ce = $aYQcG.prismComposeLens;
var $864fe13fcc485996$export$323f76c400675c8b = function(ab) {
    return (0, $lWM6H.flow)($864fe13fcc485996$export$81a625dd455a09de, $aYQcG.optionalComposeOptional(ab));
};
var $864fe13fcc485996$export$aa978f69e007229f = function(ab) {
    return (0, $lWM6H.flow)($864fe13fcc485996$export$ef38eac73d6f828f, $aYQcG.traversalComposeTraversal(ab));
};
var $864fe13fcc485996$export$adaa4cf7ef1b65be = $aYQcG.prismSet;
var $864fe13fcc485996$export$a2ef9d652875bdfa = $aYQcG.prismModifyOption;
var $864fe13fcc485996$export$3ff57735a52b8713 = $aYQcG.prismModify;
function $864fe13fcc485996$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $aOL40.pipe)(sa.getOption(s), $5OFXS.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), sa.reverseGet);
                }));
            };
        };
    };
}
var $864fe13fcc485996$export$b601f49376b4621a = /*#__PURE__*/ $864fe13fcc485996$export$f672e0b6f7222cd7(/*#__PURE__*/ $aYQcG.prismFromNullable());
function $864fe13fcc485996$export$3dea766d36a8935f(predicate) {
    return $864fe13fcc485996$export$f672e0b6f7222cd7($aYQcG.prismFromPredicate(predicate));
}
var $864fe13fcc485996$export$977f3f6a9323c0f6 = function(prop) {
    return $864fe13fcc485996$export$f5c3e419c6a355ce((0, $aOL40.pipe)($aYQcG.lensId(), $aYQcG.lensProp(prop)));
}; // TODO: simplify?
var $864fe13fcc485996$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $864fe13fcc485996$export$f5c3e419c6a355ce((0, $aOL40.pipe)($aYQcG.lensId(), $aYQcG.lensProps.apply($aYQcG, props)));
};
var $864fe13fcc485996$export$d8556a2a8f973135 = function(prop) {
    return $864fe13fcc485996$export$f5c3e419c6a355ce((0, $aOL40.pipe)($aYQcG.lensId(), $aYQcG.lensComponent(prop)));
};
var $864fe13fcc485996$export$b610b8812bbcded9 = function(i) {
    return (0, $lWM6H.flow)($864fe13fcc485996$export$81a625dd455a09de, $aYQcG.optionalIndex(i));
};
var $864fe13fcc485996$export$84162b00c25b711c = function(i) {
    return (0, $lWM6H.flow)($864fe13fcc485996$export$81a625dd455a09de, $aYQcG.optionalIndexNonEmpty(i));
};
var $864fe13fcc485996$export$df61b30b684217c0 = function(key) {
    return (0, $lWM6H.flow)($864fe13fcc485996$export$81a625dd455a09de, $aYQcG.optionalKey(key));
};
var $864fe13fcc485996$export$976574c443b9185b = function(key) {
    return function(sa) {
        return $aYQcG.prismComposeLens($aYQcG.atReadonlyRecord().at(key))(sa);
    };
};
var $864fe13fcc485996$export$ad14ef4001db2bcd = /*#__PURE__*/ $864fe13fcc485996$export$f672e0b6f7222cd7(/*#__PURE__*/ $aYQcG.prismSome());
var $864fe13fcc485996$export$79ffe56a765070d2 = /*#__PURE__*/ $864fe13fcc485996$export$f672e0b6f7222cd7(/*#__PURE__*/ $aYQcG.prismRight());
var $864fe13fcc485996$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $864fe13fcc485996$export$f672e0b6f7222cd7(/*#__PURE__*/ $aYQcG.prismLeft());
function $864fe13fcc485996$export$df3f009e3d155b20(T) {
    return (0, $lWM6H.flow)($864fe13fcc485996$export$ef38eac73d6f828f, $aYQcG.traversalTraverse(T));
}
function $864fe13fcc485996$export$9a2f228bed5035c2(predicate) {
    return $864fe13fcc485996$export$323f76c400675c8b($aYQcG.optionalFindFirst(predicate));
}
function $864fe13fcc485996$export$28e1f787311e0a21(predicate) {
    return $864fe13fcc485996$export$323f76c400675c8b($aYQcG.optionalFindFirstNonEmpty(predicate));
}
var $864fe13fcc485996$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $864fe13fcc485996$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $864fe13fcc485996$var$imap_ = function(ea, ab, ba) {
    return $864fe13fcc485996$export$e469dcfea9910464((0, $lWM6H.flow)(ea.getOption, $5OFXS.map(ab)), (0, $lWM6H.flow)(ba, ea.reverseGet));
};
var $864fe13fcc485996$export$9156e739aa33e19f = 'monocle-ts/Prism';
var $864fe13fcc485996$export$dbdf692cc5737cfd = {
    URI: $864fe13fcc485996$export$9156e739aa33e19f,
    imap: $864fe13fcc485996$var$imap_
};
var $864fe13fcc485996$export$67666a3fb7d250d8 = {
    URI: $864fe13fcc485996$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $864fe13fcc485996$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $864fe13fcc485996$export$3a8840c5b2ecf003 = {
    URI: $864fe13fcc485996$export$9156e739aa33e19f,
    compose: $864fe13fcc485996$export$67666a3fb7d250d8.compose,
    id: $864fe13fcc485996$export$d560c7e4a29451c2
};

});

parcelRegister("l4Tkk", function(module, exports) {

$parcel$export(module.exports, "fromTraversable", () => $f584e378e58ae488$export$126b5a87c58d3f9c);
$parcel$export(module.exports, "compose", () => $f584e378e58ae488$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "modify", () => $f584e378e58ae488$export$3ff57735a52b8713);
$parcel$export(module.exports, "set", () => $f584e378e58ae488$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "filter", () => $f584e378e58ae488$export$3dea766d36a8935f);

var $9nKyz = parcelRequire("9nKyz");

var $lWM6H = parcelRequire("lWM6H");

var $aOL40 = parcelRequire("aOL40");

var $iLEkM = parcelRequire("iLEkM");

var $aYQcG = parcelRequire("aYQcG");
var $f584e378e58ae488$export$8666ce7a134c2314 = $aYQcG.traversal;
var $f584e378e58ae488$export$d560c7e4a29451c2 = function() {
    return $f584e378e58ae488$export$8666ce7a134c2314(function(_) {
        return function(f) {
            return f;
        };
    });
};
var $f584e378e58ae488$export$126b5a87c58d3f9c = $aYQcG.fromTraversable;
var $f584e378e58ae488$export$f672e0b6f7222cd7 = $aYQcG.traversalComposeTraversal;
var $f584e378e58ae488$export$aa978f69e007229f = $f584e378e58ae488$export$f672e0b6f7222cd7;
var $f584e378e58ae488$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $lWM6H.flow)($aYQcG.isoAsTraversal, $f584e378e58ae488$export$f672e0b6f7222cd7);
var $f584e378e58ae488$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $lWM6H.flow)($aYQcG.lensAsTraversal, $aYQcG.traversalComposeTraversal);
var $f584e378e58ae488$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $lWM6H.flow)($aYQcG.prismAsTraversal, $aYQcG.traversalComposeTraversal);
var $f584e378e58ae488$export$323f76c400675c8b = /*#__PURE__*/ (0, $lWM6H.flow)($aYQcG.optionalAsTraversal, $aYQcG.traversalComposeTraversal);
var $f584e378e58ae488$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return sa.modifyF($aYQcG.ApplicativeIdentity)(f);
    };
};
var $f584e378e58ae488$export$adaa4cf7ef1b65be = function(a) {
    return $f584e378e58ae488$export$3ff57735a52b8713(function() {
        return a;
    });
};
var $f584e378e58ae488$export$b601f49376b4621a = function(sa) {
    return $f584e378e58ae488$export$c1dc05e399870f6($aYQcG.prismFromNullable())(sa);
};
function $f584e378e58ae488$export$3dea766d36a8935f(predicate) {
    return $f584e378e58ae488$export$f672e0b6f7222cd7($aYQcG.prismAsTraversal($aYQcG.prismFromPredicate(predicate)));
}
var $f584e378e58ae488$export$977f3f6a9323c0f6 = function(prop) {
    return $f584e378e58ae488$export$f672e0b6f7222cd7((0, $aOL40.pipe)($aYQcG.lensId(), $aYQcG.lensProp(prop), $aYQcG.lensAsTraversal));
};
var $f584e378e58ae488$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $f584e378e58ae488$export$f672e0b6f7222cd7((0, $aOL40.pipe)($aYQcG.lensId(), $aYQcG.lensProps.apply($aYQcG, props), $aYQcG.lensAsTraversal));
};
var $f584e378e58ae488$export$d8556a2a8f973135 = function(prop) {
    return $f584e378e58ae488$export$f672e0b6f7222cd7((0, $aOL40.pipe)($aYQcG.lensId(), $aYQcG.lensComponent(prop), $aYQcG.lensAsTraversal));
};
var $f584e378e58ae488$export$b610b8812bbcded9 = function(i) {
    return function(sa) {
        return (0, $aOL40.pipe)(sa, $f584e378e58ae488$export$f672e0b6f7222cd7($aYQcG.optionalAsTraversal($aYQcG.indexReadonlyArray().index(i))));
    };
};
var $f584e378e58ae488$export$84162b00c25b711c = function(i) {
    return function(sa) {
        return (0, $aOL40.pipe)(sa, $f584e378e58ae488$export$f672e0b6f7222cd7($aYQcG.optionalAsTraversal($aYQcG.indexReadonlyNonEmptyArray().index(i))));
    };
};
var $f584e378e58ae488$export$df61b30b684217c0 = function(key) {
    return function(sa) {
        return (0, $aOL40.pipe)(sa, $f584e378e58ae488$export$f672e0b6f7222cd7($aYQcG.optionalAsTraversal($aYQcG.indexReadonlyRecord().index(key))));
    };
};
var $f584e378e58ae488$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $aOL40.pipe)(sa, $f584e378e58ae488$export$f672e0b6f7222cd7($aYQcG.lensAsTraversal($aYQcG.atReadonlyRecord().at(key))));
    };
};
var $f584e378e58ae488$export$ad14ef4001db2bcd = /*#__PURE__*/ $f584e378e58ae488$export$f672e0b6f7222cd7(/*#__PURE__*/ $aYQcG.prismAsTraversal(/*#__PURE__*/ $aYQcG.prismSome()));
var $f584e378e58ae488$export$79ffe56a765070d2 = /*#__PURE__*/ $f584e378e58ae488$export$f672e0b6f7222cd7(/*#__PURE__*/ $aYQcG.prismAsTraversal(/*#__PURE__*/ $aYQcG.prismRight()));
var $f584e378e58ae488$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $f584e378e58ae488$export$f672e0b6f7222cd7(/*#__PURE__*/ $aYQcG.prismAsTraversal(/*#__PURE__*/ $aYQcG.prismLeft()));
var $f584e378e58ae488$export$df3f009e3d155b20 = $aYQcG.traversalTraverse;
function $f584e378e58ae488$export$9a2f228bed5035c2(predicate) {
    return $f584e378e58ae488$export$323f76c400675c8b($aYQcG.optionalFindFirst(predicate));
}
function $f584e378e58ae488$export$28e1f787311e0a21(predicate) {
    return $f584e378e58ae488$export$323f76c400675c8b($aYQcG.optionalFindFirstNonEmpty(predicate));
}
var $f584e378e58ae488$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(sa) {
            return sa.modifyF($9nKyz.getApplicative(M))(function(a) {
                return $9nKyz.make(f(a));
            });
        };
    };
};
var $f584e378e58ae488$export$93e2b83da34ff82a = function(M) {
    return $f584e378e58ae488$export$b66cdc0497d8a99a(M)((0, $lWM6H.identity));
};
var $f584e378e58ae488$export$2774c37398bee8b2 = function(s) {
    return function(sa) {
        return $f584e378e58ae488$export$b66cdc0497d8a99a($iLEkM.getMonoid())($iLEkM.of)(sa)(s);
    };
};
var $f584e378e58ae488$export$9156e739aa33e19f = 'monocle-ts/Traversal';
var $f584e378e58ae488$export$67666a3fb7d250d8 = {
    URI: $f584e378e58ae488$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $f584e378e58ae488$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $f584e378e58ae488$export$3a8840c5b2ecf003 = {
    URI: $f584e378e58ae488$export$9156e739aa33e19f,
    compose: $f584e378e58ae488$export$67666a3fb7d250d8.compose,
    id: $f584e378e58ae488$export$d560c7e4a29451c2
};

});


parcelRegister("91zXM", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fromFoldable = exports.fromTraversable = exports.Setter = exports.Fold = exports.Getter = exports.Index = exports.At = exports.Traversal = exports.Optional = exports.Prism = exports.Lens = exports.Iso = exports.traversal = exports.optional = exports.prism = exports.lens = exports.index = exports.iso = exports.at = void 0;

var $4ZBbi = parcelRequire("4ZBbi");

var $6lpQu = parcelRequire("6lpQu");

var $3abDJ = parcelRequire("3abDJ");

var $iGicm = parcelRequire("iGicm");

var $hBXBN = parcelRequire("hBXBN");

var $e64KP = parcelRequire("e64KP");

var $1yPNT = parcelRequire("1yPNT");
exports.at = $1yPNT;

var $gAqOT = parcelRequire("gAqOT");
exports.iso = $gAqOT;

var $6IlK1 = parcelRequire("6IlK1");
exports.index = $6IlK1;

var $hD0qb = parcelRequire("hD0qb");
exports.lens = $hD0qb;

var $2xbaP = parcelRequire("2xbaP");
exports.optional = $2xbaP;

var $14R6c = parcelRequire("14R6c");
exports.prism = $14R6c;

var $alZsa = parcelRequire("alZsa");
exports.traversal = $alZsa;
//
// compat
//
var fromIso = function(iso) {
    return new Iso(iso.get, iso.reverseGet);
};
var fromLens = function(lens) {
    return new Lens(lens.get, lens.set);
};
var fromPrism = function(prism) {
    return new Prism(prism.getOption, prism.reverseGet);
};
var fromOptional = function(optional) {
    return new Optional(optional.getOption, optional.set);
};
var fromTraversal = function(traversal) {
    return new Traversal(traversal.modifyF);
};
var fromAt = function(at) {
    return new At(function(i) {
        return fromLens(at.at(i));
    });
};
var fromIndex = function(ix) {
    return new Index(function(i) {
        return fromOptional(ix.index(i));
    });
};
//
// old APIs
//
var update = function(o, k, a) {
    var _a;
    return a === o[k] ? o : Object.assign({}, o, (_a = {}, _a[k] = a, _a));
};
/**
 * Laws:
 * 1. `reverseGet(get(s)) = s`
 * 2. `get(reversetGet(a)) = a`
 *
 * @category constructor
 * @since 1.0.0
 */ var Iso = /** @class */ function() {
    function Iso(get, reverseGet) {
        this.get = get;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Iso';
        /**
         * @since 1.0.0
         */ this.unwrap = this.get;
        /**
         * @since 1.0.0
         */ this.to = this.get;
        /**
         * @since 1.0.0
         */ this.wrap = this.reverseGet;
        /**
         * @since 1.0.0
         */ this.from = this.reverseGet;
    }
    /**
     * reverse the `Iso`: the source becomes the target and the target becomes the source
     * @since 1.0.0
     */ Iso.prototype.reverse = function() {
        return fromIso($gAqOT.reverse(this));
    };
    /**
     * @since 1.0.0
     */ Iso.prototype.modify = function(f) {
        return $gAqOT.modify(f)(this);
    };
    /**
     * view an `Iso` as a `Lens`
     *
     * @since 1.0.0
     */ Iso.prototype.asLens = function() {
        return fromLens($gAqOT.asLens(this));
    };
    /**
     * view an `Iso` as a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.asPrism = function() {
        return fromPrism($gAqOT.asPrism(this));
    };
    /**
     * view an `Iso` as a `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.asOptional = function() {
        return fromOptional($gAqOT.asOptional(this));
    };
    /**
     * view an `Iso` as a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.asTraversal = function() {
        return fromTraversal($gAqOT.asTraversal(this));
    };
    /**
     * view an `Iso` as a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * view an `Iso` as a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view an `Iso` as a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose an `Iso` with an `Iso`
     *
     * @since 1.0.0
     */ Iso.prototype.compose = function(ab) {
        return fromIso($gAqOT.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Iso.prototype.composeIso = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Iso` with a `Lens `
     *
     * @since 1.0.0
     */ Iso.prototype.composeLens = function(ab) {
        return fromLens((0, $e64KP.pipe)(this, $gAqOT.asLens, $hD0qb.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.composePrism = function(ab) {
        return fromPrism((0, $e64KP.pipe)(this, $gAqOT.asPrism, $14R6c.compose(ab)));
    };
    /**
     * compose an `Iso` with an `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.composeOptional = function(ab) {
        return fromOptional((0, $e64KP.pipe)(this, $gAqOT.asOptional, $2xbaP.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $e64KP.pipe)(this, $gAqOT.asTraversal, $alZsa.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Iso` with a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose an `Iso` with a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    return Iso;
}();
exports.Iso = Iso;
/**
 * Laws:
 * 1. `get(set(a)(s)) = a`
 * 2. `set(get(s))(s) = s`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Lens = /** @class */ function() {
    function Lens(get, set) {
        this.get = get;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Lens';
    }
    /**
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     *   address: {
     *     city: string
     *   }
     * }
     *
     * const city = Lens.fromPath<Person>()(['address', 'city'])
     *
     * const person: Person = { name: 'Giulio', age: 43, address: { city: 'Milan' } }
     *
     * assert.strictEqual(city.get(person), 'Milan')
     * assert.deepStrictEqual(city.set('London')(person), { name: 'Giulio', age: 43, address: { city: 'London' } })
     *
     * @since 1.0.0
     */ Lens.fromPath = function() {
        var fromProp = Lens.fromProp();
        return function(path) {
            var lens = fromProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromProp(prop));
            }, lens);
        };
    };
    /**
     * Returns a `Lens` from a type and a prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     * }
     *
     * const age = Lens.fromProp<Person>()('age')
     *
     * const person: Person = { name: 'Giulio', age: 43 }
     *
     * assert.strictEqual(age.get(person), 43)
     * assert.deepStrictEqual(age.set(44)(person), { name: 'Giulio', age: 44 })
     *
     * @since 1.0.0
     */ Lens.fromProp = function() {
        return function(prop) {
            return fromLens((0, $e64KP.pipe)($hD0qb.id(), $hD0qb.prop(prop)));
        };
    };
    Lens.fromProps = function() {
        return function(props) {
            return fromLens((0, $e64KP.pipe)($hD0qb.id(), $hD0qb.props.apply($hD0qb, props)));
        };
    };
    /**
     * Returns a `Lens` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * interface Outer {
     *   inner?: Inner
     * }
     *
     * interface Inner {
     *   value: number
     *   foo: string
     * }
     *
     * const inner = Lens.fromNullableProp<Outer>()('inner', { value: 0, foo: 'foo' })
     * const value = Lens.fromProp<Inner>()('value')
     * const lens = inner.compose(value)
     *
     * assert.deepStrictEqual(lens.set(1)({}), { inner: { value: 1, foo: 'foo' } })
     * assert.strictEqual(lens.get({}), 0)
     * assert.deepStrictEqual(lens.set(1)({ inner: { value: 1, foo: 'bar' } }), { inner: { value: 1, foo: 'bar' } })
     * assert.strictEqual(lens.get({ inner: { value: 1, foo: 'bar' } }), 1)
     *
     * @since 1.0.0
     */ Lens.fromNullableProp = function() {
        return function(k, defaultValue) {
            return new Lens(function(s) {
                var osk = (0, $hBXBN.fromNullable)(s[k]);
                if ((0, $hBXBN.isNone)(osk)) return defaultValue;
                else return osk.value;
            }, function(a) {
                return function(s) {
                    return update(s, k, a);
                };
            });
        };
    };
    /**
     * @since 1.0.0
     */ Lens.prototype.modify = function(f) {
        return $hD0qb.modify(f)(this);
    };
    /**
     * view a `Lens` as a Optional
     *
     * @since 1.0.0
     */ Lens.prototype.asOptional = function() {
        return fromOptional($hD0qb.asOptional(this));
    };
    /**
     * view a `Lens` as a `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.asTraversal = function() {
        return fromTraversal($hD0qb.asTraversal(this));
    };
    /**
     * view a `Lens` as a `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Lens` as a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view a `Lens` as a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Lens` with a `Lens`
     *
     * @since 1.0.0
     */ Lens.prototype.compose = function(ab) {
        return fromLens($hD0qb.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Lens.prototype.composeLens = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Lens` with a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose a `Lens` with a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Lens` with an `Optional`
     *
     * @since 1.0.0
     */ Lens.prototype.composeOptional = function(ab) {
        return fromOptional((0, $e64KP.pipe)(this, $hD0qb.asOptional, $2xbaP.compose(ab)));
    };
    /**
     * compose a `Lens` with an `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $e64KP.pipe)(this, $hD0qb.asTraversal, $alZsa.compose(ab)));
    };
    /**
     * compose a `Lens` with an `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Lens` with an `Iso`
     *
     * @since 1.0.0
     */ Lens.prototype.composeIso = function(ab) {
        return fromLens((0, $e64KP.pipe)(this, $hD0qb.compose((0, $e64KP.pipe)(ab, $gAqOT.asLens))));
    };
    /**
     * compose a `Lens` with a `Prism`
     *
     * @since 1.0.0
     */ Lens.prototype.composePrism = function(ab) {
        return fromOptional($hD0qb.composePrism(ab)(this));
    };
    return Lens;
}();
exports.Lens = Lens;
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, reverseGet)) = s`
 * 2. `getOption(reverseGet(a)) = some(a)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Prism = /** @class */ function() {
    function Prism(getOption, reverseGet) {
        this.getOption = getOption;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Prism';
    }
    Prism.fromPredicate = function(predicate) {
        return fromPrism($14R6c.fromPredicate(predicate));
    };
    /**
     * @since 1.0.0
     */ Prism.some = function() {
        return somePrism;
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modify = function(f) {
        var _this = this;
        return function(s) {
            var os = _this.modifyOption(f)(s);
            if ((0, $hBXBN.isNone)(os)) return s;
            else return os.value;
        };
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modifyOption = function(f) {
        var _this = this;
        return function(s) {
            return $hBXBN.option.map(_this.getOption(s), function(v) {
                var n = f(v);
                return n === v ? s : _this.reverseGet(n);
            });
        };
    };
    /**
     * set the target of a `Prism` with a value
     *
     * @since 1.0.0
     */ Prism.prototype.set = function(a) {
        return this.modify(function() {
            return a;
        });
    };
    /**
     * view a `Prism` as a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.asOptional = function() {
        return fromOptional($14R6c.asOptional(this));
    };
    /**
     * view a `Prism` as a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.asTraversal = function() {
        return fromTraversal($14R6c.asTraversal(this));
    };
    /**
     * view a `Prism` as a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Prism` as a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $hBXBN.isNone)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * compose a `Prism` with a `Prism`
     *
     * @since 1.0.0
     */ Prism.prototype.compose = function(ab) {
        return fromPrism($14R6c.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Prism.prototype.composePrism = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Prism` with a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.composeOptional = function(ab) {
        return fromOptional((0, $e64KP.pipe)(this, $14R6c.asOptional, $2xbaP.compose(ab)));
    };
    /**
     * compose a `Prism` with a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $e64KP.pipe)(this, $14R6c.asTraversal, $alZsa.compose(ab)));
    };
    /**
     * compose a `Prism` with a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Prism` with a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Prism` with a `Iso`
     *
     * @since 1.0.0
     */ Prism.prototype.composeIso = function(ab) {
        return fromPrism((0, $e64KP.pipe)(this, $14R6c.compose((0, $e64KP.pipe)(ab, $gAqOT.asPrism))));
    };
    /**
     * compose a `Prism` with a `Lens`
     *
     * @since 1.0.0
     */ Prism.prototype.composeLens = function(ab) {
        return fromOptional($14R6c.composeLens(ab)(this));
    };
    /**
     * compose a `Prism` with a `Getter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Prism;
}();
exports.Prism = Prism;
var somePrism = /*#__PURE__*/ new Prism($3abDJ.identity, $hBXBN.some);
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, a => set(a)(s))) = s`
 * 2. `getOption(set(a)(s)) = pipe(getOption(s), map(_ => a))`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Optional = /** @class */ function() {
    function Optional(getOption, set) {
        this.getOption = getOption;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Optional';
    }
    /**
     * Returns an `Optional` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface Phone {
     *   number: string
     * }
     * interface Employment {
     *   phone?: Phone
     * }
     * interface Info {
     *   employment?: Employment
     * }
     * interface Response {
     *   info?: Info
     * }
     *
     * const numberFromResponse = Optional.fromPath<Response>()(['info', 'employment', 'phone', 'number'])
     *
     * const response1: Response = {
     *   info: {
     *     employment: {
     *       phone: {
     *         number: '555-1234'
     *       }
     *     }
     *   }
     * }
     * const response2: Response = {
     *   info: {
     *     employment: {}
     *   }
     * }
     *
     * numberFromResponse.getOption(response1) // some('555-1234')
     * numberFromResponse.getOption(response2) // none
     *
     * @since 2.1.0
     */ Optional.fromPath = function() {
        var fromNullableProp = Optional.fromNullableProp();
        return function(path) {
            var optional = fromNullableProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromNullableProp(prop));
            }, optional);
        };
    };
    /**
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface S {
     *   a: number | undefined | null
     * }
     *
     * const optional = Optional.fromNullableProp<S>()('a')
     *
     * const s1: S = { a: undefined }
     * const s2: S = { a: null }
     * const s3: S = { a: 1 }
     *
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), s2)
     * assert.deepStrictEqual(optional.set(2)(s3), { a: 2 })
     *
     * @since 1.0.0
     */ Optional.fromNullableProp = function() {
        return function(k) {
            return new Optional(function(s) {
                return (0, $hBXBN.fromNullable)(s[k]);
            }, function(a) {
                return function(s) {
                    return s[k] == null ? s : update(s, k, a);
                };
            });
        };
    };
    /**
     * Returns an `Optional` from an option (`Option<A>`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     * import * as O from 'fp-ts/Option'
     *
     * interface S {
     *   a: O.Option<number>
     * }
     *
     * const optional = Optional.fromOptionProp<S>()('a')
     * const s1: S = { a: O.none }
     * const s2: S = { a: O.some(1) }
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), { a: O.some(2) })
     *
     * @since 1.0.0
     */ Optional.fromOptionProp = function() {
        var formProp = Lens.fromProp();
        return function(prop) {
            return formProp(prop).composePrism(somePrism);
        };
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modify = function(f) {
        return $2xbaP.modify(f)(this);
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modifyOption = function(f) {
        return $2xbaP.modifyOption(f)(this);
    };
    /**
     * view a `Optional` as a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.asTraversal = function() {
        return fromTraversal($2xbaP.asTraversal(this));
    };
    /**
     * view an `Optional` as a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $hBXBN.isNone)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * view an `Optional` as a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Optional` with a `Optional`
     *
     * @since 1.0.0
     */ Optional.prototype.compose = function(ab) {
        return fromOptional($2xbaP.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Optional.prototype.composeOptional = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Optional` with a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $e64KP.pipe)(this, $2xbaP.asTraversal, $alZsa.compose(ab)));
    };
    /**
     * compose an `Optional` with a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Optional` with a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose an `Optional` with a `Lens`
     *
     * @since 1.0.0
     */ Optional.prototype.composeLens = function(ab) {
        return fromOptional((0, $e64KP.pipe)(this, $2xbaP.compose((0, $e64KP.pipe)(ab, $hD0qb.asOptional))));
    };
    /**
     * compose an `Optional` with a `Prism`
     *
     * @since 1.0.0
     */ Optional.prototype.composePrism = function(ab) {
        return fromOptional((0, $e64KP.pipe)(this, $2xbaP.compose((0, $e64KP.pipe)(ab, $14R6c.asOptional))));
    };
    /**
     * compose an `Optional` with a `Iso`
     *
     * @since 1.0.0
     */ Optional.prototype.composeIso = function(ab) {
        return fromOptional((0, $e64KP.pipe)(this, $2xbaP.compose((0, $e64KP.pipe)(ab, $gAqOT.asOptional))));
    };
    /**
     * compose an `Optional` with a `Getter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Optional;
}();
exports.Optional = Optional;
/**
 * @category constructor
 * @since 1.0.0
 */ var Traversal = /** @class */ function() {
    function Traversal(// Van Laarhoven representation
    modifyF) {
        this.modifyF = modifyF;
        /**
         * @since 1.0.0
         */ this._tag = 'Traversal';
    }
    /**
     * @since 1.0.0
     */ Traversal.prototype.modify = function(f) {
        return $alZsa.modify(f)(this);
    };
    /**
     * @since 1.0.0
     */ Traversal.prototype.set = function(a) {
        return $alZsa.set(a)(this);
    };
    Traversal.prototype.filter = function(predicate) {
        return fromTraversal($alZsa.filter(predicate)(this));
    };
    /**
     * view a `Traversal` as a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.modifyF((0, $6lpQu.getApplicative)(M))(function(a) {
                    return (0, $6lpQu.make)(f(a));
                });
            };
        });
    };
    /**
     * view a `Traversal` as a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Traversal` with a `Traversal`
     *
     * @since 1.0.0
     */ Traversal.prototype.compose = function(ab) {
        return fromTraversal($alZsa.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeTraversal = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Traversal` with a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Optional`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeOptional = function(ab) {
        return this.compose(ab.asTraversal());
    };
    /**
     * compose a `Traversal` with a `Lens`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeLens = function(ab) {
        return fromTraversal((0, $e64KP.pipe)(this, $alZsa.compose((0, $e64KP.pipe)(ab, $hD0qb.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Prism`
     *
     * @since 1.0.0
     */ Traversal.prototype.composePrism = function(ab) {
        return fromTraversal((0, $e64KP.pipe)(this, $alZsa.compose((0, $e64KP.pipe)(ab, $14R6c.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Iso`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeIso = function(ab) {
        return fromTraversal((0, $e64KP.pipe)(this, $alZsa.compose((0, $e64KP.pipe)(ab, $gAqOT.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Getter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Traversal;
}();
exports.Traversal = Traversal;
/**
 * @category constructor
 * @since 1.2.0
 */ var At = /** @class */ function() {
    function At(at) {
        this.at = at;
        /**
         * @since 1.0.0
         */ this._tag = 'At';
    }
    /**
     * lift an instance of `At` using an `Iso`
     *
     * @since 1.2.0
     */ At.prototype.fromIso = function(iso) {
        return fromAt($1yPNT.fromIso(iso)(this));
    };
    return At;
}();
exports.At = At;
/**
 * @category constructor
 * @since 1.2.0
 */ var Index = /** @class */ function() {
    function Index(index) {
        this.index = index;
        /**
         * @since 1.0.0
         */ this._tag = 'Index';
    }
    /**
     * @since 1.2.0
     */ Index.fromAt = function(at) {
        return fromIndex($6IlK1.fromAt(at));
    };
    /**
     * lift an instance of `Index` using an `Iso`
     *
     * @since 1.2.0
     */ Index.prototype.fromIso = function(iso) {
        return fromIndex($6IlK1.fromIso(iso)(this));
    };
    return Index;
}();
exports.Index = Index;
/**
 * @category constructor
 * @since 1.0.0
 */ var Getter = /** @class */ function() {
    function Getter(get) {
        this.get = get;
        /**
         * @since 1.0.0
         */ this._tag = 'Getter';
    }
    /**
     * view a `Getter` as a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Getter` with a `Getter`
     *
     * @since 1.0.0
     */ Getter.prototype.compose = function(ab) {
        var _this = this;
        return new Getter(function(s) {
            return ab.get(_this.get(s));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Getter.prototype.composeGetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Getter` with a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Getter` with a `Lens`
     *
     * @since 1.0.0
     */ Getter.prototype.composeLens = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Iso`
     *
     * @since 1.0.0
     */ Getter.prototype.composeIso = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeTraversal = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeOptional = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Prism`
     *
     * @since 1.0.0
     */ Getter.prototype.composePrism = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Getter;
}();
exports.Getter = Getter;
/**
 * @category constructor
 * @since 1.0.0
 */ var Fold = /** @class */ function() {
    function Fold(foldMap) {
        this.foldMap = foldMap;
        /**
         * @since 1.0.0
         */ this._tag = 'Fold';
        this.getAll = foldMap($4ZBbi.getMonoid())($4ZBbi.of);
        this.exist = foldMap($iGicm.monoidAny);
        this.all = foldMap($iGicm.monoidAll);
        this.foldMapFirst = foldMap((0, $hBXBN.getFirstMonoid)());
    }
    /**
     * compose a `Fold` with a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.compose = function(ab) {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.foldMap(M)(ab.foldMap(M)(f));
            };
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Fold.prototype.composeFold = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Fold` with a `Getter`
     *
     * @since 1.0.0
     */ Fold.prototype.composeGetter = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Traversal`
     *
     * @since 1.0.0
     */ Fold.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Optional`
     *
     * @since 1.0.0
     */ Fold.prototype.composeOptional = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Lens`
     *
     * @since 1.0.0
     */ Fold.prototype.composeLens = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Prism`
     *
     * @since 1.0.0
     */ Fold.prototype.composePrism = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Iso`
     *
     * @since 1.0.0
     */ Fold.prototype.composeIso = function(ab) {
        return this.compose(ab.asFold());
    };
    Fold.prototype.find = function(p) {
        return this.foldMapFirst((0, $hBXBN.fromPredicate)(p));
    };
    /**
     * get the first target of a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.headOption = function(s) {
        return this.find(function() {
            return true;
        })(s);
    };
    return Fold;
}();
exports.Fold = Fold;
/**
 * @category constructor
 * @since 1.0.0
 */ var Setter = /** @class */ function() {
    function Setter(modify) {
        this.modify = modify;
        /**
         * @since 1.0.0
         */ this._tag = 'Setter';
    }
    /**
     * @since 1.0.0
     */ Setter.prototype.set = function(a) {
        return this.modify((0, $3abDJ.constant)(a));
    };
    /**
     * compose a `Setter` with a `Setter`
     *
     * @since 1.0.0
     */ Setter.prototype.compose = function(ab) {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(ab.modify(f));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Setter.prototype.composeSetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Setter` with a `Traversal`
     *
     * @since 1.0.0
     */ Setter.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Optional`
     *
     * @since 1.0.0
     */ Setter.prototype.composeOptional = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Lens`
     *
     * @since 1.0.0
     */ Setter.prototype.composeLens = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Prism`
     *
     * @since 1.0.0
     */ Setter.prototype.composePrism = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Iso`
     *
     * @since 1.0.0
     */ Setter.prototype.composeIso = function(ab) {
        return this.compose(ab.asSetter());
    };
    return Setter;
}();
exports.Setter = Setter;
function fromTraversable(T) {
    var f = $alZsa.fromTraversable(T);
    return function() {
        return fromTraversal(f());
    };
}
exports.fromTraversable = fromTraversable;
function fromFoldable(F) {
    return function() {
        return new Fold(function(M) {
            var foldMapFM = F.foldMap(M);
            return function(f) {
                return function(s) {
                    return foldMapFM(s, f);
                };
            };
        });
    };
}
exports.fromFoldable = fromFoldable;

});
parcelRegister("6lpQu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.const_ = module.exports.Bifunctor = module.exports.Contravariant = module.exports.flap = module.exports.Functor = module.exports.URI = module.exports.mapLeft = module.exports.bimap = module.exports.map = module.exports.contramap = module.exports.getBooleanAlgebra = module.exports.getHeytingAlgebra = module.exports.getRing = module.exports.getSemiring = module.exports.getMonoid = module.exports.getSemigroup = module.exports.getBounded = module.exports.getOrd = module.exports.getEq = module.exports.make = void 0;
module.exports.getShow = $49e8c0a71580b80f$var$getShow;
module.exports.getApply = $49e8c0a71580b80f$var$getApply;
module.exports.getApplicative = $49e8c0a71580b80f$var$getApplicative;

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");
/**
 * @category constructors
 * @since 2.0.0
 */ module.exports.make = $3abDJ.unsafeCoerce;
/**
 * @category instances
 * @since 2.0.0
 */ function $49e8c0a71580b80f$var$getShow(S) {
    return {
        show: function(c) {
            return "make(".concat(S.show(c), ")");
        }
    };
}
/**
 * @category instances
 * @since 2.0.0
 */ module.exports.getEq = $3abDJ.identity;
/**
 * @category instances
 * @since 2.6.0
 */ module.exports.getOrd = $3abDJ.identity;
/**
 * @category instances
 * @since 2.6.0
 */ module.exports.getBounded = $3abDJ.identity;
/**
 * @category instances
 * @since 2.6.0
 */ module.exports.getSemigroup = $3abDJ.identity;
/**
 * @category instances
 * @since 2.6.0
 */ module.exports.getMonoid = $3abDJ.identity;
/**
 * @category instances
 * @since 2.6.0
 */ module.exports.getSemiring = $3abDJ.identity;
/**
 * @category instances
 * @since 2.6.0
 */ module.exports.getRing = $3abDJ.identity;
/**
 * @category instances
 * @since 2.6.0
 */ module.exports.getHeytingAlgebra = $3abDJ.identity;
/**
 * @category instances
 * @since 2.6.0
 */ module.exports.getBooleanAlgebra = $3abDJ.identity;
/**
 * @category instances
 * @since 2.0.0
 */ function $49e8c0a71580b80f$var$getApply(S) {
    return {
        URI: module.exports.URI,
        _E: undefined,
        map: $49e8c0a71580b80f$var$_map,
        ap: function(fab, fa) {
            return (0, module.exports.make)(S.concat(fab, fa));
        }
    };
}
/**
 * @category instances
 * @since 2.0.0
 */ function $49e8c0a71580b80f$var$getApplicative(M) {
    var A = $49e8c0a71580b80f$var$getApply(M);
    return {
        URI: module.exports.URI,
        _E: undefined,
        map: A.map,
        ap: A.ap,
        of: function() {
            return (0, module.exports.make)(M.empty);
        }
    };
}
var $49e8c0a71580b80f$var$_contramap = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.contramap)(f));
};
/* istanbul ignore next */ var $49e8c0a71580b80f$var$_map = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.map)(f));
};
/* istanbul ignore next */ var $49e8c0a71580b80f$var$_bimap = function(fa, f, g) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.bimap)(f, g));
};
/* istanbul ignore next */ var $49e8c0a71580b80f$var$_mapLeft = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.mapLeft)(f));
};
/**
 * @since 2.0.0
 */ var $49e8c0a71580b80f$var$contramap = function() {
    return $3abDJ.unsafeCoerce;
};
module.exports.contramap = $49e8c0a71580b80f$var$contramap;
/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
 * use the type constructor `F` to represent some computational context.
 *
 * @category mapping
 * @since 2.0.0
 */ var $49e8c0a71580b80f$var$map = function() {
    return $3abDJ.unsafeCoerce;
};
module.exports.map = $49e8c0a71580b80f$var$map;
/**
 * Map a pair of functions over the two type arguments of the bifunctor.
 *
 * @category mapping
 * @since 2.6.2
 */ var $49e8c0a71580b80f$var$bimap = function(f) {
    return function(fa) {
        return (0, module.exports.make)(f(fa));
    };
};
module.exports.bimap = $49e8c0a71580b80f$var$bimap;
/**
 * Map a function over the first type argument of a bifunctor.
 *
 * @category error handling
 * @since 2.6.2
 */ var $49e8c0a71580b80f$var$mapLeft = function(f) {
    return function(fa) {
        return (0, module.exports.make)(f(fa));
    };
};
module.exports.mapLeft = $49e8c0a71580b80f$var$mapLeft;
/**
 * @category type lambdas
 * @since 2.0.0
 */ module.exports.URI = 'Const';
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Functor = {
    URI: module.exports.URI,
    map: $49e8c0a71580b80f$var$_map
};
/**
 * @category mapping
 * @since 2.10.0
 */ module.exports.flap = (0, $emm1u.flap)(module.exports.Functor);
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Contravariant = {
    URI: module.exports.URI,
    contramap: $49e8c0a71580b80f$var$_contramap
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Bifunctor = {
    URI: module.exports.URI,
    bimap: $49e8c0a71580b80f$var$_bimap,
    mapLeft: $49e8c0a71580b80f$var$_mapLeft
};
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Functor` instance, pass `C.Functor` instead of `C.const_`
 * (where `C` is from `import C from 'fp-ts/Const'`)
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.const_ = {
    URI: module.exports.URI,
    map: $49e8c0a71580b80f$var$_map,
    contramap: $49e8c0a71580b80f$var$_contramap,
    bimap: $49e8c0a71580b80f$var$_bimap,
    mapLeft: $49e8c0a71580b80f$var$_mapLeft
};

});

parcelRegister("iGicm", function(module, exports) {
"use strict";
var $d99a4413a17fc050$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d99a4413a17fc050$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d99a4413a17fc050$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d99a4413a17fc050$var$__createBinding(result, mod, k);
    }
    $d99a4413a17fc050$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monoidProduct = module.exports.monoidSum = module.exports.monoidString = module.exports.getEndomorphismMonoid = module.exports.getFunctionMonoid = module.exports.monoidAny = module.exports.monoidAll = module.exports.fold = module.exports.getMeetMonoid = module.exports.getJoinMonoid = module.exports.getDualMonoid = module.exports.getStructMonoid = module.exports.getTupleMonoid = module.exports.monoidVoid = module.exports.concatAll = module.exports.tuple = module.exports.struct = module.exports.reverse = module.exports.max = module.exports.min = void 0;

var $gHVXW = parcelRequire("gHVXW");

var $3abDJ = parcelRequire("3abDJ");

var $d99a4413a17fc050$var$_ = $d99a4413a17fc050$var$__importStar((parcelRequire("704qB")));

var $d99a4413a17fc050$var$Se = $d99a4413a17fc050$var$__importStar((parcelRequire("3OUuJ")));
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * Get a monoid where `concat` will return the minimum, based on the provided bounded order.
 *
 * The `empty` value is the `top` value.
 *
 * @example
 * import * as N from 'fp-ts/number'
 * import * as M from 'fp-ts/Monoid'
 *
 * const M1 = M.min(N.Bounded)
 *
 * assert.deepStrictEqual(M1.concat(1, 2), 1)
 *
 * @category constructors
 * @since 2.10.0
 */ var $d99a4413a17fc050$var$min = function(B) {
    return {
        concat: $d99a4413a17fc050$var$Se.min(B).concat,
        empty: B.top
    };
};
module.exports.min = $d99a4413a17fc050$var$min;
/**
 * Get a monoid where `concat` will return the maximum, based on the provided bounded order.
 *
 * The `empty` value is the `bottom` value.
 *
 * @example
 * import * as N from 'fp-ts/number'
 * import * as M from 'fp-ts/Monoid'
 *
 * const M1 = M.max(N.Bounded)
 *
 * assert.deepStrictEqual(M1.concat(1, 2), 2)
 *
 * @category constructors
 * @since 2.10.0
 */ var $d99a4413a17fc050$var$max = function(B) {
    return {
        concat: $d99a4413a17fc050$var$Se.max(B).concat,
        empty: B.bottom
    };
};
module.exports.max = $d99a4413a17fc050$var$max;
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Monoid`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse } from 'fp-ts/Monoid'
 * import * as S from 'fp-ts/string'
 *
 * assert.deepStrictEqual(reverse(S.Monoid).concat('a', 'b'), 'ba')
 *
 * @since 2.10.0
 */ var $d99a4413a17fc050$var$reverse = function(M) {
    return {
        concat: $d99a4413a17fc050$var$Se.reverse(M).concat,
        empty: M.empty
    };
};
module.exports.reverse = $d99a4413a17fc050$var$reverse;
/**
 * Given a struct of monoids returns a monoid for the struct.
 *
 * @example
 * import { struct } from 'fp-ts/Monoid'
 * import * as N from 'fp-ts/number'
 *
 * interface Point {
 *   readonly x: number
 *   readonly y: number
 * }
 *
 * const M = struct<Point>({
 *   x: N.MonoidSum,
 *   y: N.MonoidSum
 * })
 *
 * assert.deepStrictEqual(M.concat({ x: 1, y: 2 }, { x: 3, y: 4 }), { x: 4, y: 6 })
 *
 * @since 2.10.0
 */ var $d99a4413a17fc050$var$struct = function(monoids) {
    var empty = {};
    for(var k in monoids)if ($d99a4413a17fc050$var$_.has.call(monoids, k)) empty[k] = monoids[k].empty;
    return {
        concat: $d99a4413a17fc050$var$Se.struct(monoids).concat,
        empty: empty
    };
};
module.exports.struct = $d99a4413a17fc050$var$struct;
/**
 * Given a tuple of monoids returns a monoid for the tuple.
 *
 * @example
 * import { tuple } from 'fp-ts/Monoid'
 * import * as B from 'fp-ts/boolean'
 * import * as N from 'fp-ts/number'
 * import * as S from 'fp-ts/string'
 *
 * const M1 = tuple(S.Monoid, N.MonoidSum)
 * assert.deepStrictEqual(M1.concat(['a', 1], ['b', 2]), ['ab', 3])
 *
 * const M2 = tuple(S.Monoid, N.MonoidSum, B.MonoidAll)
 * assert.deepStrictEqual(M2.concat(['a', 1, true], ['b', 2, false]), ['ab', 3, false])
 *
 * @since 2.10.0
 */ var $d99a4413a17fc050$var$tuple = function() {
    var monoids = [];
    for(var _i = 0; _i < arguments.length; _i++)monoids[_i] = arguments[_i];
    return {
        concat: $d99a4413a17fc050$var$Se.tuple.apply($d99a4413a17fc050$var$Se, monoids).concat,
        empty: monoids.map(function(m) {
            return m.empty;
        })
    };
};
module.exports.tuple = $d99a4413a17fc050$var$tuple;
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Given a sequence of `as`, concat them and return the total.
 *
 * If `as` is empty, return the monoid `empty` value.
 *
 * @example
 * import { concatAll } from 'fp-ts/Monoid'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(concatAll(N.MonoidSum)([1, 2, 3]), 6)
 * assert.deepStrictEqual(concatAll(N.MonoidSum)([]), 0)
 *
 * @since 2.10.0
 */ var $d99a4413a17fc050$var$concatAll = function(M) {
    return $d99a4413a17fc050$var$Se.concatAll(M)(M.empty);
};
module.exports.concatAll = $d99a4413a17fc050$var$concatAll;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * Use [`Monoid`](./void.ts.html#monoid) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.monoidVoid = {
    concat: $d99a4413a17fc050$var$Se.semigroupVoid.concat,
    empty: undefined
};
/**
 * Use [`tuple`](#tuple) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getTupleMonoid = module.exports.tuple;
/**
 * Use [`struct`](#struct) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getStructMonoid = module.exports.struct;
/**
 * Use [`reverse`](#reverse) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getDualMonoid = module.exports.reverse;
/**
 * Use [`max`](#max) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getJoinMonoid = module.exports.max;
/**
 * Use [`min`](#min) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getMeetMonoid = module.exports.min;
/**
 * Use [`concatAll`](#concatall) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.fold = module.exports.concatAll;
/**
 * Use [`MonoidAll`](./boolean.ts.html#monoidall) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.monoidAll = {
    concat: $d99a4413a17fc050$var$Se.semigroupAll.concat,
    empty: true
};
/**
 * Use [`MonoidAny`](./boolean.ts.html#monoidany) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.monoidAny = {
    concat: $d99a4413a17fc050$var$Se.semigroupAny.concat,
    empty: false
};
/**
 * Use [`getMonoid`](./function.ts.html#getmonoid) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getFunctionMonoid = $3abDJ.getMonoid;
/**
 * Use [`getEndomorphismMonoid`](./function.ts.html#getendomorphismmonoid) instead.
 *
 * **Note**. The execution order in [`getEndomorphismMonoid`](./function.ts.html#getendomorphismmonoid) is reversed.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ var $d99a4413a17fc050$var$getEndomorphismMonoid = function() {
    return (0, module.exports.reverse)((0, $gHVXW.getMonoid)());
};
module.exports.getEndomorphismMonoid = $d99a4413a17fc050$var$getEndomorphismMonoid;
/**
 * Use [`Monoid`](./string.ts.html#monoid) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.monoidString = {
    concat: $d99a4413a17fc050$var$Se.semigroupString.concat,
    empty: ''
};
/**
 * Use [`MonoidSum`](./number.ts.html#monoidsum) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.monoidSum = {
    concat: $d99a4413a17fc050$var$Se.semigroupSum.concat,
    empty: 0
};
/**
 * Use [`MonoidProduct`](./number.ts.html#monoidproduct) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.monoidProduct = {
    concat: $d99a4413a17fc050$var$Se.semigroupProduct.concat,
    empty: 1
};

});
parcelRegister("gHVXW", function(module, exports) {
"use strict";
/**
 * @since 2.11.0
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMonoid = module.exports.getSemigroup = module.exports.URI = void 0;

var $3abDJ = parcelRequire("3abDJ");
/**
 * @category type lambdas
 * @since 2.11.0
 */ module.exports.URI = 'Endomorphism';
/**
 * Endomorphism form a `Semigroup` where the `concat` operation is the usual function composition.
 *
 * @category instances
 * @since 2.11.0
 */ var $c29da045f2aabc7d$var$getSemigroup = function() {
    return {
        concat: function(first, second) {
            return (0, $3abDJ.flow)(first, second);
        }
    };
};
module.exports.getSemigroup = $c29da045f2aabc7d$var$getSemigroup;
/**
 * Endomorphism form a `Monoid` where the `empty` value is the `identity` function.
 *
 * @category instances
 * @since 2.11.0
 */ var $c29da045f2aabc7d$var$getMonoid = function() {
    return {
        concat: (0, module.exports.getSemigroup)().concat,
        empty: $3abDJ.identity
    };
};
module.exports.getMonoid = $c29da045f2aabc7d$var$getMonoid;

});


parcelRegister("e64KP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = void 0;
module.exports.map = $a4355058f5d5dd1a$var$map;
module.exports.contramap = $a4355058f5d5dd1a$var$contramap;
module.exports.mapWithIndex = $a4355058f5d5dd1a$var$mapWithIndex;
module.exports.ap = $a4355058f5d5dd1a$var$ap;
module.exports.chain = $a4355058f5d5dd1a$var$chain;
module.exports.bimap = $a4355058f5d5dd1a$var$bimap;
module.exports.mapLeft = $a4355058f5d5dd1a$var$mapLeft;
module.exports.extend = $a4355058f5d5dd1a$var$extend;
module.exports.reduce = $a4355058f5d5dd1a$var$reduce;
module.exports.foldMap = $a4355058f5d5dd1a$var$foldMap;
module.exports.reduceRight = $a4355058f5d5dd1a$var$reduceRight;
module.exports.reduceWithIndex = $a4355058f5d5dd1a$var$reduceWithIndex;
module.exports.foldMapWithIndex = $a4355058f5d5dd1a$var$foldMapWithIndex;
module.exports.reduceRightWithIndex = $a4355058f5d5dd1a$var$reduceRightWithIndex;
module.exports.alt = $a4355058f5d5dd1a$var$alt;
module.exports.filter = $a4355058f5d5dd1a$var$filter;
module.exports.filterMap = $a4355058f5d5dd1a$var$filterMap;
module.exports.partition = $a4355058f5d5dd1a$var$partition;
module.exports.partitionMap = $a4355058f5d5dd1a$var$partitionMap;
module.exports.filterWithIndex = $a4355058f5d5dd1a$var$filterWithIndex;
module.exports.filterMapWithIndex = $a4355058f5d5dd1a$var$filterMapWithIndex;
module.exports.partitionWithIndex = $a4355058f5d5dd1a$var$partitionWithIndex;
module.exports.partitionMapWithIndex = $a4355058f5d5dd1a$var$partitionMapWithIndex;
module.exports.promap = $a4355058f5d5dd1a$var$promap;
module.exports.compose = $a4355058f5d5dd1a$var$compose;
module.exports.pipeable = $a4355058f5d5dd1a$var$pipeable;

var $4sfjE = parcelRequire("4sfjE");

var $ERVGH = parcelRequire("ERVGH");

var $3abDJ = parcelRequire("3abDJ");
function $a4355058f5d5dd1a$var$map(F) {
    return function(f) {
        return function(fa) {
            return F.map(fa, f);
        };
    };
}
function $a4355058f5d5dd1a$var$contramap(F) {
    return function(f) {
        return function(fa) {
            return F.contramap(fa, f);
        };
    };
}
function $a4355058f5d5dd1a$var$mapWithIndex(F) {
    return function(f) {
        return function(fa) {
            return F.mapWithIndex(fa, f);
        };
    };
}
function $a4355058f5d5dd1a$var$ap(F) {
    return function(fa) {
        return function(fab) {
            return F.ap(fab, fa);
        };
    };
}
function $a4355058f5d5dd1a$var$chain(F) {
    return function(f) {
        return function(fa) {
            return F.chain(fa, f);
        };
    };
}
function $a4355058f5d5dd1a$var$bimap(F) {
    return function(f, g) {
        return function(fea) {
            return F.bimap(fea, f, g);
        };
    };
}
function $a4355058f5d5dd1a$var$mapLeft(F) {
    return function(f) {
        return function(fea) {
            return F.mapLeft(fea, f);
        };
    };
}
function $a4355058f5d5dd1a$var$extend(F) {
    return function(f) {
        return function(wa) {
            return F.extend(wa, f);
        };
    };
}
function $a4355058f5d5dd1a$var$reduce(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduce(fa, b, f);
        };
    };
}
function $a4355058f5d5dd1a$var$foldMap(F) {
    return function(M) {
        var foldMapM = F.foldMap(M);
        return function(f) {
            return function(fa) {
                return foldMapM(fa, f);
            };
        };
    };
}
function $a4355058f5d5dd1a$var$reduceRight(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRight(fa, b, f);
        };
    };
}
function $a4355058f5d5dd1a$var$reduceWithIndex(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceWithIndex(fa, b, f);
        };
    };
}
function $a4355058f5d5dd1a$var$foldMapWithIndex(F) {
    return function(M) {
        var foldMapWithIndexM = F.foldMapWithIndex(M);
        return function(f) {
            return function(fa) {
                return foldMapWithIndexM(fa, f);
            };
        };
    };
}
function $a4355058f5d5dd1a$var$reduceRightWithIndex(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRightWithIndex(fa, b, f);
        };
    };
}
function $a4355058f5d5dd1a$var$alt(F) {
    return function(that) {
        return function(fa) {
            return F.alt(fa, that);
        };
    };
}
function $a4355058f5d5dd1a$var$filter(F) {
    return function(predicate) {
        return function(fa) {
            return F.filter(fa, predicate);
        };
    };
}
function $a4355058f5d5dd1a$var$filterMap(F) {
    return function(f) {
        return function(fa) {
            return F.filterMap(fa, f);
        };
    };
}
function $a4355058f5d5dd1a$var$partition(F) {
    return function(f) {
        return function(fa) {
            return F.partition(fa, f);
        };
    };
}
function $a4355058f5d5dd1a$var$partitionMap(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMap(fa, f);
        };
    };
}
function $a4355058f5d5dd1a$var$filterWithIndex(F) {
    return function(predicate) {
        return function(fa) {
            return F.filterWithIndex(fa, predicate);
        };
    };
}
function $a4355058f5d5dd1a$var$filterMapWithIndex(F) {
    return function(f) {
        return function(fa) {
            return F.filterMapWithIndex(fa, f);
        };
    };
}
function $a4355058f5d5dd1a$var$partitionWithIndex(F) {
    return function(f) {
        return function(fa) {
            return F.partitionWithIndex(fa, f);
        };
    };
}
function $a4355058f5d5dd1a$var$partitionMapWithIndex(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMapWithIndex(fa, f);
        };
    };
}
function $a4355058f5d5dd1a$var$promap(F) {
    return function(f, g) {
        return function(fbc) {
            return F.promap(fbc, f, g);
        };
    };
}
function $a4355058f5d5dd1a$var$compose(F) {
    return function(ea) {
        return function(ab) {
            return F.compose(ab, ea);
        };
    };
}
var $a4355058f5d5dd1a$var$isFunctor = function(I) {
    return typeof I.map === 'function';
};
var $a4355058f5d5dd1a$var$isContravariant = function(I) {
    return typeof I.contramap === 'function';
};
var $a4355058f5d5dd1a$var$isFunctorWithIndex = function(I) {
    return typeof I.mapWithIndex === 'function';
};
var $a4355058f5d5dd1a$var$isApply = function(I) {
    return typeof I.ap === 'function';
};
var $a4355058f5d5dd1a$var$isChain = function(I) {
    return typeof I.chain === 'function';
};
var $a4355058f5d5dd1a$var$isBifunctor = function(I) {
    return typeof I.bimap === 'function';
};
var $a4355058f5d5dd1a$var$isExtend = function(I) {
    return typeof I.extend === 'function';
};
var $a4355058f5d5dd1a$var$isFoldable = function(I) {
    return typeof I.reduce === 'function';
};
var $a4355058f5d5dd1a$var$isFoldableWithIndex = function(I) {
    return typeof I.reduceWithIndex === 'function';
};
var $a4355058f5d5dd1a$var$isAlt = function(I) {
    return typeof I.alt === 'function';
};
var $a4355058f5d5dd1a$var$isCompactable = function(I) {
    return typeof I.compact === 'function';
};
var $a4355058f5d5dd1a$var$isFilterable = function(I) {
    return typeof I.filter === 'function';
};
var $a4355058f5d5dd1a$var$isFilterableWithIndex = function(I) {
    return typeof I.filterWithIndex === 'function';
};
var $a4355058f5d5dd1a$var$isProfunctor = function(I) {
    return typeof I.promap === 'function';
};
var $a4355058f5d5dd1a$var$isSemigroupoid = function(I) {
    return typeof I.compose === 'function';
};
var $a4355058f5d5dd1a$var$isMonadThrow = function(I) {
    return typeof I.throwError === 'function';
};
/** @deprecated */ function $a4355058f5d5dd1a$var$pipeable(I) {
    var r = {};
    if ($a4355058f5d5dd1a$var$isFunctor(I)) r.map = $a4355058f5d5dd1a$var$map(I);
    if ($a4355058f5d5dd1a$var$isContravariant(I)) r.contramap = $a4355058f5d5dd1a$var$contramap(I);
    if ($a4355058f5d5dd1a$var$isFunctorWithIndex(I)) r.mapWithIndex = $a4355058f5d5dd1a$var$mapWithIndex(I);
    if ($a4355058f5d5dd1a$var$isApply(I)) {
        r.ap = $a4355058f5d5dd1a$var$ap(I);
        r.apFirst = (0, $4sfjE.apFirst)(I);
        r.apSecond = (0, $4sfjE.apSecond)(I);
    }
    if ($a4355058f5d5dd1a$var$isChain(I)) {
        r.chain = $a4355058f5d5dd1a$var$chain(I);
        r.chainFirst = (0, $ERVGH.chainFirst)(I);
        r.flatten = r.chain($3abDJ.identity);
    }
    if ($a4355058f5d5dd1a$var$isBifunctor(I)) {
        r.bimap = $a4355058f5d5dd1a$var$bimap(I);
        r.mapLeft = $a4355058f5d5dd1a$var$mapLeft(I);
    }
    if ($a4355058f5d5dd1a$var$isExtend(I)) {
        r.extend = $a4355058f5d5dd1a$var$extend(I);
        r.duplicate = r.extend($3abDJ.identity);
    }
    if ($a4355058f5d5dd1a$var$isFoldable(I)) {
        r.reduce = $a4355058f5d5dd1a$var$reduce(I);
        r.foldMap = $a4355058f5d5dd1a$var$foldMap(I);
        r.reduceRight = $a4355058f5d5dd1a$var$reduceRight(I);
    }
    if ($a4355058f5d5dd1a$var$isFoldableWithIndex(I)) {
        r.reduceWithIndex = $a4355058f5d5dd1a$var$reduceWithIndex(I);
        r.foldMapWithIndex = $a4355058f5d5dd1a$var$foldMapWithIndex(I);
        r.reduceRightWithIndex = $a4355058f5d5dd1a$var$reduceRightWithIndex(I);
    }
    if ($a4355058f5d5dd1a$var$isAlt(I)) r.alt = $a4355058f5d5dd1a$var$alt(I);
    if ($a4355058f5d5dd1a$var$isCompactable(I)) {
        r.compact = I.compact;
        r.separate = I.separate;
    }
    if ($a4355058f5d5dd1a$var$isFilterable(I)) {
        r.filter = $a4355058f5d5dd1a$var$filter(I);
        r.filterMap = $a4355058f5d5dd1a$var$filterMap(I);
        r.partition = $a4355058f5d5dd1a$var$partition(I);
        r.partitionMap = $a4355058f5d5dd1a$var$partitionMap(I);
    }
    if ($a4355058f5d5dd1a$var$isFilterableWithIndex(I)) {
        r.filterWithIndex = $a4355058f5d5dd1a$var$filterWithIndex(I);
        r.filterMapWithIndex = $a4355058f5d5dd1a$var$filterMapWithIndex(I);
        r.partitionWithIndex = $a4355058f5d5dd1a$var$partitionWithIndex(I);
        r.partitionMapWithIndex = $a4355058f5d5dd1a$var$partitionMapWithIndex(I);
    }
    if ($a4355058f5d5dd1a$var$isProfunctor(I)) r.promap = $a4355058f5d5dd1a$var$promap(I);
    if ($a4355058f5d5dd1a$var$isSemigroupoid(I)) r.compose = $a4355058f5d5dd1a$var$compose(I);
    if ($a4355058f5d5dd1a$var$isMonadThrow(I)) {
        var fromOption = function(onNone) {
            return function(ma) {
                return ma._tag === 'None' ? I.throwError(onNone()) : I.of(ma.value);
            };
        };
        var fromEither = function(ma) {
            return ma._tag === 'Left' ? I.throwError(ma.left) : I.of(ma.right);
        };
        var fromPredicate = function(predicate, onFalse) {
            return function(a) {
                return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
            };
        };
        var filterOrElse = function(predicate, onFalse) {
            return function(ma) {
                return I.chain(ma, function(a) {
                    return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
                });
            };
        };
        r.fromOption = fromOption;
        r.fromEither = fromEither;
        r.fromPredicate = fromPredicate;
        r.filterOrElse = filterOrElse;
    }
    return r;
}
/**
 * Use [`pipe`](https://gcanti.github.io/fp-ts/modules/function.ts.html#pipe) from `function` module instead.
 *
 * @since 2.0.0
 * @deprecated
 */ module.exports.pipe = $3abDJ.pipe;

});

parcelRegister("1yPNT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.atRecord = module.exports.atReadonlySet = module.exports.atReadonlyMap = module.exports.atReadonlyRecord = module.exports.fromIso = module.exports.at = void 0;

var $hBXBN = parcelRequire("hBXBN");

var $e64KP = parcelRequire("e64KP");

var $5iJ4o = parcelRequire("5iJ4o");

var $fdVMO = parcelRequire("fdVMO");

var $azsim = parcelRequire("azsim");
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.3.8
 */ module.exports.at = $azsim.at;
/**
 * Lift an instance of `At` using an `Iso`.
 *
 * @category constructors
 * @since 2.3.0
 */ var $1231269573c19939$var$fromIso = function(iso) {
    return function(sia) {
        return (0, module.exports.at)(function(i) {
            return (0, $e64KP.pipe)(iso, $azsim.isoAsLens, $azsim.lensComposeLens(sia.at(i)));
        });
    };
};
module.exports.fromIso = $1231269573c19939$var$fromIso;
/**
 * @category constructors
 * @since 2.3.7
 */ module.exports.atReadonlyRecord = $azsim.atReadonlyRecord;
/**
 * @category constructors
 * @since 2.3.7
 */ var $1231269573c19939$var$atReadonlyMap = function(E) {
    var lookupE = $5iJ4o.lookup(E);
    var deleteAtE = $5iJ4o.deleteAt(E);
    var insertAtE = $5iJ4o.insertAt(E);
    return function() {
        return (0, module.exports.at)(function(key) {
            return $azsim.lens(function(s) {
                return lookupE(key, s);
            }, $hBXBN.fold(function() {
                return deleteAtE(key);
            }, function(a) {
                return insertAtE(key, a);
            }));
        });
    };
};
module.exports.atReadonlyMap = $1231269573c19939$var$atReadonlyMap;
/**
 * @category constructors
 * @since 2.3.7
 */ var $1231269573c19939$var$atReadonlySet = function(E) {
    var elemE = $fdVMO.elem(E);
    var insertE = $fdVMO.insert(E);
    var removeE = $fdVMO.remove(E);
    return (0, module.exports.at)(function(a) {
        var insert = insertE(a);
        var remove = removeE(a);
        return $azsim.lens(function(s) {
            return elemE(a, s);
        }, function(b) {
            return function(s) {
                return b ? insert(s) : remove(s);
            };
        });
    });
};
module.exports.atReadonlySet = $1231269573c19939$var$atReadonlySet;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * Use `atReadonlyRecord` instead.
 *
 * @category constructors
 * @since 2.3.2
 * @deprecated
 */ module.exports.atRecord = $azsim.atReadonlyRecord;

});
parcelRegister("5iJ4o", function(module, exports) {
"use strict";
var $3dc1981a7f07c3b4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3dc1981a7f07c3b4$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3dc1981a7f07c3b4$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3dc1981a7f07c3b4$var$__createBinding(result, mod, k);
    }
    $3dc1981a7f07c3b4$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.readonlyMap = module.exports.insertAt = module.exports.difference = module.exports.intersection = module.exports.union = module.exports.getTraversableWithIndex = module.exports.getTraversable = module.exports.getFoldableWithIndex = module.exports.reduceRightWithIndex = module.exports.foldMapWithIndex = module.exports.reduceWithIndex = module.exports.getFoldable = module.exports.reduceRight = module.exports.foldMap = module.exports.reduce = module.exports.Filterable = module.exports.Compactable = module.exports.getFunctorWithIndex = module.exports.flap = module.exports.Functor = module.exports.getDifferenceMagma = module.exports.getIntersectionSemigroup = module.exports.getUnionMonoid = module.exports.getUnionSemigroup = module.exports.URI = module.exports.separate = module.exports.partitionMap = module.exports.partition = module.exports.mapWithIndex = module.exports.map = module.exports.filterMap = module.exports.filter = module.exports.compact = module.exports.filterMapWithIndex = module.exports.partitionMapWithIndex = module.exports.singleton = module.exports.empty = module.exports.modifyAt = module.exports.updateAt = module.exports.deleteAt = module.exports.upsertAt = module.exports.toReadonlyArray = module.exports.values = module.exports.keys = module.exports.isEmpty = module.exports.size = module.exports.fromMap = void 0;
module.exports.toMap = $3dc1981a7f07c3b4$var$toMap;
module.exports.getShow = $3dc1981a7f07c3b4$var$getShow;
module.exports.member = $3dc1981a7f07c3b4$var$member;
module.exports.elem = $3dc1981a7f07c3b4$var$elem;
module.exports.collect = $3dc1981a7f07c3b4$var$collect;
module.exports.toUnfoldable = $3dc1981a7f07c3b4$var$toUnfoldable;
module.exports.pop = $3dc1981a7f07c3b4$var$pop;
module.exports.lookupWithKey = $3dc1981a7f07c3b4$var$lookupWithKey;
module.exports.lookup = $3dc1981a7f07c3b4$var$lookup;
module.exports.isSubmap = $3dc1981a7f07c3b4$var$isSubmap;
module.exports.getEq = $3dc1981a7f07c3b4$var$getEq;
module.exports.getMonoid = $3dc1981a7f07c3b4$var$getMonoid;
module.exports.fromFoldable = $3dc1981a7f07c3b4$var$fromFoldable;
module.exports.partitionWithIndex = $3dc1981a7f07c3b4$var$partitionWithIndex;
module.exports.filterWithIndex = $3dc1981a7f07c3b4$var$filterWithIndex;
module.exports.getFilterableWithIndex = $3dc1981a7f07c3b4$var$getFilterableWithIndex;
module.exports.getWitherable = $3dc1981a7f07c3b4$var$getWitherable;

var $5Ikl1 = parcelRequire("5Ikl1");

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");

var $3dc1981a7f07c3b4$var$_ = $3dc1981a7f07c3b4$var$__importStar((parcelRequire("704qB")));

var $3dc1981a7f07c3b4$var$O = $3dc1981a7f07c3b4$var$__importStar((parcelRequire("hBXBN")));

var $fIQoU = parcelRequire("fIQoU");

var $4p4Yq = parcelRequire("4p4Yq");
/**
 * @category conversions
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$fromMap = function(m) {
    return new Map(m);
};
module.exports.fromMap = $3dc1981a7f07c3b4$var$fromMap;
/**
 * @category conversions
 * @since 2.5.0
 */ function $3dc1981a7f07c3b4$var$toMap(m) {
    return new Map(m);
}
/**
 * @category instances
 * @since 2.5.0
 */ function $3dc1981a7f07c3b4$var$getShow(SK, SA) {
    return {
        show: function(m) {
            var entries = [];
            m.forEach(function(a, k) {
                entries.push("[".concat(SK.show(k), ", ").concat(SA.show(a), "]"));
            });
            return "new Map([".concat(entries.sort().join(', '), "])");
        }
    };
}
/**
 * Calculate the number of key/value pairs in a map
 *
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$size = function(m) {
    return m.size;
};
module.exports.size = $3dc1981a7f07c3b4$var$size;
/**
 * Test whether or not a map is empty
 *
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$isEmpty = function(m) {
    return m.size === 0;
};
module.exports.isEmpty = $3dc1981a7f07c3b4$var$isEmpty;
function $3dc1981a7f07c3b4$var$member(E) {
    var lookupE = $3dc1981a7f07c3b4$var$lookup(E);
    return function(k, m) {
        if (m === undefined) {
            var memberE_1 = $3dc1981a7f07c3b4$var$member(E);
            return function(m) {
                return memberE_1(k, m);
            };
        }
        return $3dc1981a7f07c3b4$var$_.isSome(lookupE(k, m));
    };
}
function $3dc1981a7f07c3b4$var$elem(E) {
    return function(a, m) {
        if (m === undefined) {
            var elemE_1 = $3dc1981a7f07c3b4$var$elem(E);
            return function(m) {
                return elemE_1(a, m);
            };
        }
        var values = m.values();
        var e;
        while(!(e = values.next()).done){
            var v = e.value;
            if (E.equals(a, v)) return true;
        }
        return false;
    };
}
/**
 * Get a sorted `ReadonlyArray` of the keys contained in a `ReadonlyMap`.
 *
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$keys = function(O) {
    return function(m) {
        return Array.from(m.keys()).sort(O.compare);
    };
};
module.exports.keys = $3dc1981a7f07c3b4$var$keys;
/**
 * Get a sorted `ReadonlyArray` of the values contained in a `ReadonlyMap`.
 *
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$values = function(O) {
    return function(m) {
        return Array.from(m.values()).sort(O.compare);
    };
};
module.exports.values = $3dc1981a7f07c3b4$var$values;
/**
 * @since 2.5.0
 */ function $3dc1981a7f07c3b4$var$collect(O) {
    var keysO = (0, module.exports.keys)(O);
    return function(f) {
        return function(m) {
            var out = [];
            var ks = keysO(m);
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                out.push(f(key, m.get(key)));
            }
            return out;
        };
    };
}
/**
 * Get a sorted `ReadonlyArray` of the key/value pairs contained in a `ReadonlyMap`.
 *
 * @category conversions
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$toReadonlyArray = function(O) {
    return $3dc1981a7f07c3b4$var$collect(O)(function(k, a) {
        return [
            k,
            a
        ];
    });
};
module.exports.toReadonlyArray = $3dc1981a7f07c3b4$var$toReadonlyArray;
function $3dc1981a7f07c3b4$var$toUnfoldable(ord, U) {
    var toReadonlyArrayO = (0, module.exports.toReadonlyArray)(ord);
    return function(d) {
        var kas = toReadonlyArrayO(d);
        var len = kas.length;
        return U.unfold(0, function(b) {
            return b < len ? $3dc1981a7f07c3b4$var$_.some([
                kas[b],
                b + 1
            ]) : $3dc1981a7f07c3b4$var$_.none;
        });
    };
}
/**
 * Insert or replace a key/value pair in a `ReadonlyMap`.
 *
 * @since 2.10.0
 */ var $3dc1981a7f07c3b4$var$upsertAt = function(E) {
    var lookupWithKeyE = $3dc1981a7f07c3b4$var$lookupWithKey(E);
    return function(k, a) {
        var lookupWithKeyEk = lookupWithKeyE(k);
        return function(m) {
            var found = lookupWithKeyEk(m);
            if ($3dc1981a7f07c3b4$var$_.isNone(found)) {
                var out = new Map(m);
                out.set(k, a);
                return out;
            } else if (found.value[1] !== a) {
                var out = new Map(m);
                out.set(found.value[0], a);
                return out;
            }
            return m;
        };
    };
};
module.exports.upsertAt = $3dc1981a7f07c3b4$var$upsertAt;
/**
 * Delete a key and value from a map
 *
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$deleteAt = function(E) {
    var lookupWithKeyE = $3dc1981a7f07c3b4$var$lookupWithKey(E);
    return function(k) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($3dc1981a7f07c3b4$var$_.isSome(found)) {
                var r = new Map(m);
                r.delete(found.value[0]);
                return r;
            }
            return m;
        };
    };
};
module.exports.deleteAt = $3dc1981a7f07c3b4$var$deleteAt;
/**
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$updateAt = function(E) {
    var modifyAtE = (0, module.exports.modifyAt)(E);
    return function(k, a) {
        return modifyAtE(k, function() {
            return a;
        });
    };
};
module.exports.updateAt = $3dc1981a7f07c3b4$var$updateAt;
/**
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$modifyAt = function(E) {
    var lookupWithKeyE = $3dc1981a7f07c3b4$var$lookupWithKey(E);
    return function(k, f) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($3dc1981a7f07c3b4$var$_.isNone(found)) return $3dc1981a7f07c3b4$var$_.none;
            var _a = found.value, fk = _a[0], fv = _a[1];
            var next = f(fv);
            if (next === fv) return $3dc1981a7f07c3b4$var$_.some(m);
            var r = new Map(m);
            r.set(fk, next);
            return $3dc1981a7f07c3b4$var$_.some(r);
        };
    };
};
module.exports.modifyAt = $3dc1981a7f07c3b4$var$modifyAt;
/**
 * Delete a key and value from a map, returning the value as well as the subsequent map
 *
 * @since 2.5.0
 */ function $3dc1981a7f07c3b4$var$pop(E) {
    var lookupE = $3dc1981a7f07c3b4$var$lookup(E);
    var deleteAtE = (0, module.exports.deleteAt)(E);
    return function(k) {
        var deleteAtEk = deleteAtE(k);
        return function(m) {
            return (0, $3abDJ.pipe)(lookupE(k, m), $3dc1981a7f07c3b4$var$O.map(function(a) {
                return [
                    a,
                    deleteAtEk(m)
                ];
            }));
        };
    };
}
function $3dc1981a7f07c3b4$var$lookupWithKey(E) {
    return function(k, m) {
        if (m === undefined) {
            var lookupWithKeyE_1 = $3dc1981a7f07c3b4$var$lookupWithKey(E);
            return function(m) {
                return lookupWithKeyE_1(k, m);
            };
        }
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, ka = _a[0], a = _a[1];
            if (E.equals(ka, k)) return $3dc1981a7f07c3b4$var$_.some([
                ka,
                a
            ]);
        }
        return $3dc1981a7f07c3b4$var$_.none;
    };
}
function $3dc1981a7f07c3b4$var$lookup(E) {
    var lookupWithKeyE = $3dc1981a7f07c3b4$var$lookupWithKey(E);
    return function(k, m) {
        if (m === undefined) {
            var lookupE_1 = $3dc1981a7f07c3b4$var$lookup(E);
            return function(m) {
                return lookupE_1(k, m);
            };
        }
        return (0, $3abDJ.pipe)(lookupWithKeyE(k, m), $3dc1981a7f07c3b4$var$O.map(function(_a) {
            var _ = _a[0], a = _a[1];
            return a;
        }));
    };
}
function $3dc1981a7f07c3b4$var$isSubmap(SK, SA) {
    var lookupWithKeyS = $3dc1981a7f07c3b4$var$lookupWithKey(SK);
    return function(me, that) {
        if (that === undefined) {
            var isSubmapSKSA_1 = $3dc1981a7f07c3b4$var$isSubmap(SK, SA);
            return function(that) {
                return isSubmapSKSA_1(that, me);
            };
        }
        var entries = me.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var d2OptA = lookupWithKeyS(k, that);
            if ($3dc1981a7f07c3b4$var$_.isNone(d2OptA) || !SK.equals(k, d2OptA.value[0]) || !SA.equals(a, d2OptA.value[1])) return false;
        }
        return true;
    };
}
/**
 * @since 2.5.0
 */ module.exports.empty = // the type annotation here is intended (otherwise it doesn't type-check)
new Map();
/**
 * @category instances
 * @since 2.5.0
 */ function $3dc1981a7f07c3b4$var$getEq(SK, SA) {
    var isSubmapSKSA = $3dc1981a7f07c3b4$var$isSubmap(SK, SA);
    return (0, $5Ikl1.fromEquals)(function(x, y) {
        return isSubmapSKSA(x, y) && isSubmapSKSA(y, x);
    });
}
/**
 * Gets `Monoid` instance for Maps given `Semigroup` instance for their values
 *
 * @category instances
 * @since 2.5.0
 */ function $3dc1981a7f07c3b4$var$getMonoid(SK, SA) {
    var lookupWithKeyS = $3dc1981a7f07c3b4$var$lookupWithKey(SK);
    return {
        concat: function(mx, my) {
            if ((0, module.exports.isEmpty)(mx)) return my;
            if ((0, module.exports.isEmpty)(my)) return mx;
            var r = new Map(mx);
            var entries = my.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var mxOptA = lookupWithKeyS(k, mx);
                if ($3dc1981a7f07c3b4$var$_.isSome(mxOptA)) r.set(mxOptA.value[0], SA.concat(mxOptA.value[1], a));
                else r.set(k, a);
            }
            return r;
        },
        empty: module.exports.empty
    };
}
/**
 * Create a map with one key/value pair
 *
 * @category constructors
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$singleton = function(k, a) {
    return new Map([
        [
            k,
            a
        ]
    ]);
};
module.exports.singleton = $3dc1981a7f07c3b4$var$singleton;
function $3dc1981a7f07c3b4$var$fromFoldable(E, M, F) {
    return function(fka) {
        var lookupWithKeyE = $3dc1981a7f07c3b4$var$lookupWithKey(E);
        return F.reduce(fka, new Map(), function(b, _a) {
            var k = _a[0], a = _a[1];
            var bOpt = lookupWithKeyE(k, b);
            if ($3dc1981a7f07c3b4$var$_.isSome(bOpt)) b.set(bOpt.value[0], M.concat(bOpt.value[1], a));
            else b.set(k, a);
            return b;
        });
    };
}
var $3dc1981a7f07c3b4$var$_mapWithIndex = function(fa, f) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, key = _a[0], a = _a[1];
        m.set(key, f(key, a));
    }
    return m;
};
/**
 * @since 2.10.0
 */ var $3dc1981a7f07c3b4$var$partitionMapWithIndex = function(f) {
    return function(fa) {
        var left = new Map();
        var right = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var ei = f(k, a);
            if ($3dc1981a7f07c3b4$var$_.isLeft(ei)) left.set(k, ei.left);
            else right.set(k, ei.right);
        }
        return (0, $fIQoU.separated)(left, right);
    };
};
module.exports.partitionMapWithIndex = $3dc1981a7f07c3b4$var$partitionMapWithIndex;
function $3dc1981a7f07c3b4$var$partitionWithIndex(predicateWithIndex) {
    return function(m) {
        var left = new Map();
        var right = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) right.set(k, a);
            else left.set(k, a);
        }
        return (0, $fIQoU.separated)(left, right);
    };
}
/**
 * @since 2.10.0
 */ var $3dc1981a7f07c3b4$var$filterMapWithIndex = function(f) {
    return function(fa) {
        var m = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var o = f(k, a);
            if ($3dc1981a7f07c3b4$var$_.isSome(o)) m.set(k, o.value);
        }
        return m;
    };
};
module.exports.filterMapWithIndex = $3dc1981a7f07c3b4$var$filterMapWithIndex;
function $3dc1981a7f07c3b4$var$filterWithIndex(predicateWithIndex) {
    return function(m) {
        var out = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) out.set(k, a);
        }
        return out;
    };
}
var $3dc1981a7f07c3b4$var$_map = function(fa, f) {
    return $3dc1981a7f07c3b4$var$_mapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $3dc1981a7f07c3b4$var$_filter = function(fa, p) {
    return $3dc1981a7f07c3b4$var$_filterWithIndex(fa, function(_, a) {
        return p(a);
    });
};
var $3dc1981a7f07c3b4$var$_filterMap = function(fa, f) {
    return $3dc1981a7f07c3b4$var$_filterMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $3dc1981a7f07c3b4$var$_partition = function(fa, predicate) {
    return $3dc1981a7f07c3b4$var$_partitionWithIndex(fa, function(_, a) {
        return predicate(a);
    });
};
var $3dc1981a7f07c3b4$var$_partitionMap = function(fa, f) {
    return $3dc1981a7f07c3b4$var$_partitionMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $3dc1981a7f07c3b4$var$_filterWithIndex = function(fa, p) {
    return (0, $3abDJ.pipe)(fa, $3dc1981a7f07c3b4$var$filterWithIndex(p));
};
var $3dc1981a7f07c3b4$var$_filterMapWithIndex = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.filterMapWithIndex)(f));
};
var $3dc1981a7f07c3b4$var$_partitionWithIndex = function(fa, p) {
    return (0, $3abDJ.pipe)(fa, $3dc1981a7f07c3b4$var$partitionWithIndex(p));
};
var $3dc1981a7f07c3b4$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.partitionMapWithIndex)(f));
};
/**
 * @category filtering
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$compact = function(fa) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], oa = _a[1];
        if ($3dc1981a7f07c3b4$var$_.isSome(oa)) m.set(k, oa.value);
    }
    return m;
};
module.exports.compact = $3dc1981a7f07c3b4$var$compact;
/**
 * @category filtering
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$filter = function(predicate) {
    return function(fa) {
        return $3dc1981a7f07c3b4$var$_filter(fa, predicate);
    };
};
module.exports.filter = $3dc1981a7f07c3b4$var$filter;
/**
 * @category filtering
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$filterMap = function(f) {
    return function(fa) {
        return $3dc1981a7f07c3b4$var$_filterMap(fa, f);
    };
};
module.exports.filterMap = $3dc1981a7f07c3b4$var$filterMap;
/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
 * use the type constructor `F` to represent some computational context.
 *
 * @category mapping
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$map = function(f) {
    return function(fa) {
        return $3dc1981a7f07c3b4$var$_map(fa, f);
    };
};
module.exports.map = $3dc1981a7f07c3b4$var$map;
/**
 * @category mapping
 * @since 2.7.1
 */ var $3dc1981a7f07c3b4$var$mapWithIndex = function(f) {
    return function(fa) {
        return $3dc1981a7f07c3b4$var$_mapWithIndex(fa, f);
    };
};
module.exports.mapWithIndex = $3dc1981a7f07c3b4$var$mapWithIndex;
/**
 * @category filtering
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$partition = function(predicate) {
    return function(fa) {
        return $3dc1981a7f07c3b4$var$_partition(fa, predicate);
    };
};
module.exports.partition = $3dc1981a7f07c3b4$var$partition;
/**
 * @category filtering
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$partitionMap = function(f) {
    return function(fa) {
        return $3dc1981a7f07c3b4$var$_partitionMap(fa, f);
    };
};
module.exports.partitionMap = $3dc1981a7f07c3b4$var$partitionMap;
/**
 * @category filtering
 * @since 2.5.0
 */ var $3dc1981a7f07c3b4$var$separate = function(fa) {
    var left = new Map();
    var right = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], ei = _a[1];
        if ($3dc1981a7f07c3b4$var$_.isLeft(ei)) left.set(k, ei.left);
        else right.set(k, ei.right);
    }
    return (0, $fIQoU.separated)(left, right);
};
module.exports.separate = $3dc1981a7f07c3b4$var$separate;
/**
 * @category type lambdas
 * @since 2.5.0
 */ module.exports.URI = 'ReadonlyMap';
/**
 * @category instances
 * @since 2.11.0
 */ var $3dc1981a7f07c3b4$var$getUnionSemigroup = function(E, S) {
    var unionES = (0, module.exports.union)(E, S);
    return {
        concat: function(first, second) {
            return unionES(second)(first);
        }
    };
};
module.exports.getUnionSemigroup = $3dc1981a7f07c3b4$var$getUnionSemigroup;
/**
 * @category instances
 * @since 2.11.0
 */ var $3dc1981a7f07c3b4$var$getUnionMonoid = function(E, S) {
    return {
        concat: (0, module.exports.getUnionSemigroup)(E, S).concat,
        empty: module.exports.empty
    };
};
module.exports.getUnionMonoid = $3dc1981a7f07c3b4$var$getUnionMonoid;
/**
 * @category instances
 * @since 2.11.0
 */ var $3dc1981a7f07c3b4$var$getIntersectionSemigroup = function(E, S) {
    var intersectionES = (0, module.exports.intersection)(E, S);
    return {
        concat: function(first, second) {
            return intersectionES(second)(first);
        }
    };
};
module.exports.getIntersectionSemigroup = $3dc1981a7f07c3b4$var$getIntersectionSemigroup;
/**
 * @category instances
 * @since 2.11.0
 */ var $3dc1981a7f07c3b4$var$getDifferenceMagma = function(E) {
    return function() {
        var differenceE = (0, module.exports.difference)(E);
        return {
            concat: function(first, second) {
                return differenceE(second)(first);
            }
        };
    };
};
module.exports.getDifferenceMagma = $3dc1981a7f07c3b4$var$getDifferenceMagma;
/**
 * @category filtering
 * @since 2.5.0
 */ function $3dc1981a7f07c3b4$var$getFilterableWithIndex() {
    return {
        URI: module.exports.URI,
        _E: undefined,
        map: $3dc1981a7f07c3b4$var$_map,
        mapWithIndex: $3dc1981a7f07c3b4$var$_mapWithIndex,
        compact: module.exports.compact,
        separate: module.exports.separate,
        filter: $3dc1981a7f07c3b4$var$_filter,
        filterMap: $3dc1981a7f07c3b4$var$_filterMap,
        partition: $3dc1981a7f07c3b4$var$_partition,
        partitionMap: $3dc1981a7f07c3b4$var$_partitionMap,
        partitionMapWithIndex: $3dc1981a7f07c3b4$var$_partitionMapWithIndex,
        partitionWithIndex: $3dc1981a7f07c3b4$var$_partitionWithIndex,
        filterMapWithIndex: $3dc1981a7f07c3b4$var$_filterMapWithIndex,
        filterWithIndex: $3dc1981a7f07c3b4$var$_filterWithIndex
    };
}
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Functor = {
    URI: module.exports.URI,
    map: $3dc1981a7f07c3b4$var$_map
};
/**
 * @category mapping
 * @since 2.10.0
 */ module.exports.flap = (0, $emm1u.flap)(module.exports.Functor);
/**
 * @category instances
 * @since 2.10.0
 */ var $3dc1981a7f07c3b4$var$getFunctorWithIndex = function() {
    return {
        URI: module.exports.URI,
        _E: undefined,
        map: $3dc1981a7f07c3b4$var$_map,
        mapWithIndex: $3dc1981a7f07c3b4$var$_mapWithIndex
    };
};
module.exports.getFunctorWithIndex = $3dc1981a7f07c3b4$var$getFunctorWithIndex;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Compactable = {
    URI: module.exports.URI,
    compact: module.exports.compact,
    separate: module.exports.separate
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Filterable = {
    URI: module.exports.URI,
    map: $3dc1981a7f07c3b4$var$_map,
    compact: module.exports.compact,
    separate: module.exports.separate,
    filter: $3dc1981a7f07c3b4$var$_filter,
    filterMap: $3dc1981a7f07c3b4$var$_filterMap,
    partition: $3dc1981a7f07c3b4$var$_partition,
    partitionMap: $3dc1981a7f07c3b4$var$_partitionMap
};
/**
 * @category folding
 * @since 2.11.0
 */ var $3dc1981a7f07c3b4$var$reduce = function(O) {
    var reduceWithIndexO = (0, module.exports.reduceWithIndex)(O);
    return function(b, f) {
        return reduceWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
module.exports.reduce = $3dc1981a7f07c3b4$var$reduce;
/**
 * @category folding
 * @since 2.11.0
 */ var $3dc1981a7f07c3b4$var$foldMap = function(O) {
    var foldMapWithIndexO = (0, module.exports.foldMapWithIndex)(O);
    return function(M) {
        var foldMapWithIndexOM = foldMapWithIndexO(M);
        return function(f) {
            return foldMapWithIndexOM(function(_, a) {
                return f(a);
            });
        };
    };
};
module.exports.foldMap = $3dc1981a7f07c3b4$var$foldMap;
/**
 * @category folding
 * @since 2.11.0
 */ var $3dc1981a7f07c3b4$var$reduceRight = function(O) {
    var reduceRightWithIndexO = (0, module.exports.reduceRightWithIndex)(O);
    return function(b, f) {
        return reduceRightWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
module.exports.reduceRight = $3dc1981a7f07c3b4$var$reduceRight;
/**
 * @category folding
 * @since 2.10.0
 */ var $3dc1981a7f07c3b4$var$getFoldable = function(O) {
    var reduceO = (0, module.exports.reduce)(O);
    var foldMapO = (0, module.exports.foldMap)(O);
    var reduceRightO = (0, module.exports.reduceRight)(O);
    return {
        URI: module.exports.URI,
        _E: undefined,
        reduce: function(fa, b, f) {
            return (0, $3abDJ.pipe)(fa, reduceO(b, f));
        },
        foldMap: function(M) {
            var foldMapOM = foldMapO(M);
            return function(fa, f) {
                return (0, $3abDJ.pipe)(fa, foldMapOM(f));
            };
        },
        reduceRight: function(fa, b, f) {
            return (0, $3abDJ.pipe)(fa, reduceRightO(b, f));
        }
    };
};
module.exports.getFoldable = $3dc1981a7f07c3b4$var$getFoldable;
/**
 * @category folding
 * @since 2.11.0
 */ var $3dc1981a7f07c3b4$var$reduceWithIndex = function(O) {
    var keysO = (0, module.exports.keys)(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                var k = _a[_i];
                out = f(k, out, m.get(k));
            }
            return out;
        };
    };
};
module.exports.reduceWithIndex = $3dc1981a7f07c3b4$var$reduceWithIndex;
/**
 * @category folding
 * @since 2.11.0
 */ var $3dc1981a7f07c3b4$var$foldMapWithIndex = function(O) {
    var keysO = (0, module.exports.keys)(O);
    return function(M) {
        return function(f) {
            return function(m) {
                var out = M.empty;
                for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                    var k = _a[_i];
                    out = M.concat(out, f(k, m.get(k)));
                }
                return out;
            };
        };
    };
};
module.exports.foldMapWithIndex = $3dc1981a7f07c3b4$var$foldMapWithIndex;
/**
 * @category folding
 * @since 2.11.0
 */ var $3dc1981a7f07c3b4$var$reduceRightWithIndex = function(O) {
    var keysO = (0, module.exports.keys)(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            var ks = keysO(m);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, m.get(k), out);
            }
            return out;
        };
    };
};
module.exports.reduceRightWithIndex = $3dc1981a7f07c3b4$var$reduceRightWithIndex;
/**
 * @category folding
 * @since 2.10.0
 */ var $3dc1981a7f07c3b4$var$getFoldableWithIndex = function(O) {
    var F = (0, module.exports.getFoldable)(O);
    var reduceWithIndexO = (0, module.exports.reduceWithIndex)(O);
    var foldMapWithIndexO = (0, module.exports.foldMapWithIndex)(O);
    var reduceRightWithIndexO = (0, module.exports.reduceRightWithIndex)(O);
    return {
        URI: module.exports.URI,
        _E: undefined,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        reduceWithIndex: function(fa, b, f) {
            return (0, $3abDJ.pipe)(fa, reduceWithIndexO(b, f));
        },
        foldMapWithIndex: function(M) {
            var foldMapWithIndexOM = foldMapWithIndexO(M);
            return function(fa, f) {
                return (0, $3abDJ.pipe)(fa, foldMapWithIndexOM(f));
            };
        },
        reduceRightWithIndex: function(fa, b, f) {
            return (0, $3abDJ.pipe)(fa, reduceRightWithIndexO(b, f));
        }
    };
};
module.exports.getFoldableWithIndex = $3dc1981a7f07c3b4$var$getFoldableWithIndex;
/**
 * @category traversing
 * @since 2.10.0
 */ var $3dc1981a7f07c3b4$var$getTraversable = function(O) {
    var TWI = (0, module.exports.getTraversableWithIndex)(O);
    var F = (0, module.exports.getFoldable)(O);
    return {
        URI: module.exports.URI,
        _E: undefined,
        map: $3dc1981a7f07c3b4$var$_map,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence
    };
};
module.exports.getTraversable = $3dc1981a7f07c3b4$var$getTraversable;
/**
 * @category traversing
 * @since 2.10.0
 */ var $3dc1981a7f07c3b4$var$getTraversableWithIndex = function(O) {
    var FWI = (0, module.exports.getFoldableWithIndex)(O);
    var keysO = (0, module.exports.keys)(O);
    var traverseWithIndex = function(F) {
        return function(ta, f) {
            var fm = F.of(new Map());
            var ks = keysO(ta);
            var len = ks.length;
            var _loop_1 = function(i) {
                var key = ks[i];
                var a = ta.get(key);
                fm = F.ap(F.map(fm, function(m) {
                    return function(b) {
                        return m.set(key, b);
                    };
                }), f(key, a));
            };
            for(var i = 0; i < len; i++)_loop_1(i);
            return fm;
        };
    };
    var traverse = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta, f) {
            return traverseWithIndexF(ta, function(_, a) {
                return f(a);
            });
        };
    };
    var sequence = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta) {
            return traverseWithIndexF(ta, $3abDJ.SK);
        };
    };
    return {
        URI: module.exports.URI,
        _E: undefined,
        map: $3dc1981a7f07c3b4$var$_map,
        mapWithIndex: $3dc1981a7f07c3b4$var$_mapWithIndex,
        reduce: FWI.reduce,
        foldMap: FWI.foldMap,
        reduceRight: FWI.reduceRight,
        reduceWithIndex: FWI.reduceWithIndex,
        foldMapWithIndex: FWI.foldMapWithIndex,
        reduceRightWithIndex: FWI.reduceRightWithIndex,
        traverse: traverse,
        sequence: sequence,
        traverseWithIndex: traverseWithIndex
    };
};
module.exports.getTraversableWithIndex = $3dc1981a7f07c3b4$var$getTraversableWithIndex;
/**
 * @category filtering
 * @since 2.5.0
 */ function $3dc1981a7f07c3b4$var$getWitherable(O) {
    var TWI = (0, module.exports.getTraversableWithIndex)(O);
    return {
        URI: module.exports.URI,
        _E: undefined,
        map: $3dc1981a7f07c3b4$var$_map,
        compact: module.exports.compact,
        separate: module.exports.separate,
        filter: $3dc1981a7f07c3b4$var$_filter,
        filterMap: $3dc1981a7f07c3b4$var$_filterMap,
        partition: $3dc1981a7f07c3b4$var$_partition,
        partitionMap: $3dc1981a7f07c3b4$var$_partitionMap,
        reduce: TWI.reduce,
        foldMap: TWI.foldMap,
        reduceRight: TWI.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence,
        mapWithIndex: $3dc1981a7f07c3b4$var$_mapWithIndex,
        reduceWithIndex: TWI.reduceWithIndex,
        foldMapWithIndex: TWI.foldMapWithIndex,
        reduceRightWithIndex: TWI.reduceRightWithIndex,
        traverseWithIndex: TWI.traverseWithIndex,
        wilt: (0, $4p4Yq.wiltDefault)(TWI, module.exports.Compactable),
        wither: (0, $4p4Yq.witherDefault)(TWI, module.exports.Compactable)
    };
}
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * @since 2.11.0
 */ var $3dc1981a7f07c3b4$var$union = function(E, M) {
    var lookupE = $3dc1981a7f07c3b4$var$lookup(E);
    return function(second) {
        return function(first) {
            if ((0, module.exports.isEmpty)(first)) return second;
            if ((0, module.exports.isEmpty)(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($3dc1981a7f07c3b4$var$_.isSome(oka)) out.set(k, M.concat(a, oka.value));
                else out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                var oka = lookupE(k)(out);
                if ($3dc1981a7f07c3b4$var$_.isNone(oka)) out.set(k, a);
            }
            return out;
        };
    };
};
module.exports.union = $3dc1981a7f07c3b4$var$union;
/**
 * @since 2.11.0
 */ var $3dc1981a7f07c3b4$var$intersection = function(E, M) {
    var lookupE = $3dc1981a7f07c3b4$var$lookup(E);
    return function(second) {
        return function(first) {
            if ((0, module.exports.isEmpty)(first) || (0, module.exports.isEmpty)(second)) return module.exports.empty;
            var out = new Map();
            var entries = first.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($3dc1981a7f07c3b4$var$_.isSome(oka)) out.set(k, M.concat(a, oka.value));
            }
            return out;
        };
    };
};
module.exports.intersection = $3dc1981a7f07c3b4$var$intersection;
/**
 * @since 2.11.0
 */ var $3dc1981a7f07c3b4$var$difference = function(E) {
    var memberE = $3dc1981a7f07c3b4$var$member(E);
    return function(second) {
        return function(first) {
            if ((0, module.exports.isEmpty)(first)) return second;
            if ((0, module.exports.isEmpty)(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                if (!memberE(k)(second)) out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                if (!memberE(k)(first)) out.set(k, a);
            }
            return out;
        };
    };
};
module.exports.difference = $3dc1981a7f07c3b4$var$difference;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * Use [`upsertAt`](#upsertat) instead.
 *
 @category zone of death
 * @since 2.5.0
 * @deprecated
 */ module.exports.insertAt = module.exports.upsertAt;
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Functor` instance, pass `RM.Functor` instead of `RM.readonlyMap`
 * (where `RM` is from `import RM from 'fp-ts/ReadonlyMap'`)
 *
 * @category zone of death
 * @since 2.5.0
 * @deprecated
 */ module.exports.readonlyMap = {
    URI: module.exports.URI,
    map: $3dc1981a7f07c3b4$var$_map,
    compact: module.exports.compact,
    separate: module.exports.separate,
    filter: $3dc1981a7f07c3b4$var$_filter,
    filterMap: $3dc1981a7f07c3b4$var$_filterMap,
    partition: $3dc1981a7f07c3b4$var$_partition,
    partitionMap: $3dc1981a7f07c3b4$var$_partitionMap
};

});

parcelRegister("fdVMO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromArray = module.exports.getDifferenceMagma = module.exports.getIntersectionSemigroup = module.exports.getUnionMonoid = module.exports.getUnionSemigroup = module.exports.URI = module.exports.toReadonlyArray = module.exports.some = module.exports.size = module.exports.isEmpty = module.exports.empty = module.exports.compact = module.exports.toggle = module.exports.remove = module.exports.reduceRight = module.exports.fromReadonlyArray = module.exports.singleton = module.exports.fromSet = void 0;
module.exports.toSet = $b154e50df59ba62b$var$toSet;
module.exports.map = $b154e50df59ba62b$var$map;
module.exports.chain = $b154e50df59ba62b$var$chain;
module.exports.filter = $b154e50df59ba62b$var$filter;
module.exports.partition = $b154e50df59ba62b$var$partition;
module.exports.union = $b154e50df59ba62b$var$union;
module.exports.intersection = $b154e50df59ba62b$var$intersection;
module.exports.partitionMap = $b154e50df59ba62b$var$partitionMap;
module.exports.difference = $b154e50df59ba62b$var$difference;
module.exports.reduce = $b154e50df59ba62b$var$reduce;
module.exports.foldMap = $b154e50df59ba62b$var$foldMap;
module.exports.insert = $b154e50df59ba62b$var$insert;
module.exports.separate = $b154e50df59ba62b$var$separate;
module.exports.filterMap = $b154e50df59ba62b$var$filterMap;
module.exports.every = $b154e50df59ba62b$var$every;
module.exports.isSubset = $b154e50df59ba62b$var$isSubset;
module.exports.elem = $b154e50df59ba62b$var$elem;
module.exports.getShow = $b154e50df59ba62b$var$getShow;
module.exports.getEq = $b154e50df59ba62b$var$getEq;

var $5Ikl1 = parcelRequire("5Ikl1");

var $3abDJ = parcelRequire("3abDJ");

var $6t3HJ = parcelRequire("6t3HJ");

var $fIQoU = parcelRequire("fIQoU");
/**
 * @category conversions
 * @since 2.5.0
 */ var $b154e50df59ba62b$var$fromSet = function(s) {
    return new Set(s);
};
module.exports.fromSet = $b154e50df59ba62b$var$fromSet;
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * Create a set with one element
 *
 * @category constructors
 * @since 2.5.0
 */ var $b154e50df59ba62b$var$singleton = function(a) {
    return new Set([
        a
    ]);
};
module.exports.singleton = $b154e50df59ba62b$var$singleton;
/**
 * Create a `ReadonlySet` from a `ReadonlyArray`
 *
 * @category conversions
 * @since 2.10.0
 */ var $b154e50df59ba62b$var$fromReadonlyArray = function(E) {
    return function(as) {
        var len = as.length;
        var out = new Set();
        var has = $b154e50df59ba62b$var$elem(E);
        for(var i = 0; i < len; i++){
            var a = as[i];
            if (!has(a, out)) out.add(a);
        }
        return out;
    };
};
module.exports.fromReadonlyArray = $b154e50df59ba62b$var$fromReadonlyArray;
/**
 * @category conversions
 * @since 2.5.0
 */ function $b154e50df59ba62b$var$toSet(s) {
    return new Set(s);
}
/**
 * Projects a Set through a function
 *
 * @since 2.5.0
 */ function $b154e50df59ba62b$var$map(E) {
    var elemE = $b154e50df59ba62b$var$elem(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                var v = f(e);
                if (!elemE(v, r)) r.add(v);
            });
            return r;
        };
    };
}
/**
 * @since 2.5.0
 */ function $b154e50df59ba62b$var$chain(E) {
    var elemE = $b154e50df59ba62b$var$elem(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                f(e).forEach(function(e) {
                    if (!elemE(e, r)) r.add(e);
                });
            });
            return r;
        };
    };
}
function $b154e50df59ba62b$var$filter(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var r = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) r.add(a);
        }
        return r;
    };
}
function $b154e50df59ba62b$var$partition(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var right = new Set();
        var left = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) right.add(a);
            else left.add(a);
        }
        return (0, $fIQoU.separated)(left, right);
    };
}
function $b154e50df59ba62b$var$union(E) {
    var elemE = $b154e50df59ba62b$var$elem(E);
    return function(me, that) {
        if (that === undefined) {
            var unionE_1 = $b154e50df59ba62b$var$union(E);
            return function(that) {
                return unionE_1(me, that);
            };
        }
        if ((0, module.exports.isEmpty)(me)) return that;
        if ((0, module.exports.isEmpty)(that)) return me;
        var r = new Set(me);
        that.forEach(function(e) {
            if (!elemE(e, r)) r.add(e);
        });
        return r;
    };
}
function $b154e50df59ba62b$var$intersection(E) {
    var elemE = $b154e50df59ba62b$var$elem(E);
    return function(me, that) {
        if (that === undefined) {
            var intersectionE_1 = $b154e50df59ba62b$var$intersection(E);
            return function(that) {
                return intersectionE_1(that, me);
            };
        }
        if ((0, module.exports.isEmpty)(me) || (0, module.exports.isEmpty)(that)) return module.exports.empty;
        var r = new Set();
        me.forEach(function(e) {
            if (elemE(e, that)) r.add(e);
        });
        return r;
    };
}
/**
 * @since 2.5.0
 */ function $b154e50df59ba62b$var$partitionMap(EB, EC) {
    return function(f) {
        return function(set) {
            var values = set.values();
            var e;
            var left = new Set();
            var right = new Set();
            var hasB = $b154e50df59ba62b$var$elem(EB);
            var hasC = $b154e50df59ba62b$var$elem(EC);
            while(!(e = values.next()).done){
                var v = f(e.value);
                switch(v._tag){
                    case 'Left':
                        if (!hasB(v.left, left)) left.add(v.left);
                        break;
                    case 'Right':
                        if (!hasC(v.right, right)) right.add(v.right);
                        break;
                }
            }
            return (0, $fIQoU.separated)(left, right);
        };
    };
}
function $b154e50df59ba62b$var$difference(E) {
    var elemE = $b154e50df59ba62b$var$elem(E);
    return function(me, that) {
        if (that === undefined) {
            var differenceE_1 = $b154e50df59ba62b$var$difference(E);
            return function(that) {
                return differenceE_1(that, me);
            };
        }
        return $b154e50df59ba62b$var$filter(function(a) {
            return !elemE(a, that);
        })(me);
    };
}
/**
 * @since 2.5.0
 */ function $b154e50df59ba62b$var$reduce(O) {
    var toReadonlyArrayO = (0, module.exports.toReadonlyArray)(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(f, b);
        };
    };
}
/**
 * @since 2.5.0
 */ function $b154e50df59ba62b$var$foldMap(O, M) {
    var toReadonlyArrayO = (0, module.exports.toReadonlyArray)(O);
    return function(f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(function(b, a) {
                return M.concat(b, f(a));
            }, M.empty);
        };
    };
}
/**
 * @category folding
 * @since 2.11.0
 */ var $b154e50df59ba62b$var$reduceRight = function(O) {
    var toReadonlyArrayO = (0, module.exports.toReadonlyArray)(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduceRight(function(b, a) {
                return f(a, b);
            }, b);
        };
    };
};
module.exports.reduceRight = $b154e50df59ba62b$var$reduceRight;
/**
 * Insert a value into a set
 *
 * @since 2.5.0
 */ function $b154e50df59ba62b$var$insert(E) {
    var elemE = $b154e50df59ba62b$var$elem(E);
    return function(a) {
        return function(set) {
            if (!elemE(a)(set)) {
                var r = new Set(set);
                r.add(a);
                return r;
            } else return set;
        };
    };
}
/**
 * Delete a value from a set
 *
 * @since 2.5.0
 */ var $b154e50df59ba62b$var$remove = function(E) {
    return function(a) {
        return function(set) {
            return $b154e50df59ba62b$var$filter(function(ax) {
                return !E.equals(a, ax);
            })(set);
        };
    };
};
module.exports.remove = $b154e50df59ba62b$var$remove;
/**
 * Checks an element is a member of a set;
 * If yes, removes the value from the set
 * If no, inserts the value to the set
 *
 * @since 2.10.0
 */ var $b154e50df59ba62b$var$toggle = function(E) {
    var elemE = $b154e50df59ba62b$var$elem(E);
    var removeE = (0, module.exports.remove)(E);
    var insertE = $b154e50df59ba62b$var$insert(E);
    return function(a) {
        return function(set) {
            return (elemE(a, set) ? removeE : insertE)(a)(set);
        };
    };
};
module.exports.toggle = $b154e50df59ba62b$var$toggle;
/**
 * @since 2.5.0
 */ var $b154e50df59ba62b$var$compact = function(E) {
    return $b154e50df59ba62b$var$filterMap(E)($3abDJ.identity);
};
module.exports.compact = $b154e50df59ba62b$var$compact;
/**
 * @since 2.5.0
 */ function $b154e50df59ba62b$var$separate(EE, EA) {
    return function(fa) {
        var elemEE = $b154e50df59ba62b$var$elem(EE);
        var elemEA = $b154e50df59ba62b$var$elem(EA);
        var left = new Set();
        var right = new Set();
        fa.forEach(function(e) {
            switch(e._tag){
                case 'Left':
                    if (!elemEE(e.left, left)) left.add(e.left);
                    break;
                case 'Right':
                    if (!elemEA(e.right, right)) right.add(e.right);
                    break;
            }
        });
        return (0, $fIQoU.separated)(left, right);
    };
}
/**
 * @since 2.5.0
 */ function $b154e50df59ba62b$var$filterMap(E) {
    var elemE = $b154e50df59ba62b$var$elem(E);
    return function(f) {
        return function(fa) {
            var r = new Set();
            fa.forEach(function(a) {
                var ob = f(a);
                if (ob._tag === 'Some' && !elemE(ob.value, r)) r.add(ob.value);
            });
            return r;
        };
    };
}
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * @since 2.5.0
 */ module.exports.empty = new Set();
/**
 * Test whether a `ReadonlySet` is empty.
 *
 * @since 2.10.0
 */ var $b154e50df59ba62b$var$isEmpty = function(set) {
    return set.size === 0;
};
module.exports.isEmpty = $b154e50df59ba62b$var$isEmpty;
/**
 * Calculate the number of elements in a `ReadonlySet`.
 *
 * @since 2.10.0
 */ var $b154e50df59ba62b$var$size = function(set) {
    return set.size;
};
module.exports.size = $b154e50df59ba62b$var$size;
/**
 * @since 2.5.0
 */ var $b154e50df59ba62b$var$some = function(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = predicate(e.value);
        return found;
    };
};
module.exports.some = $b154e50df59ba62b$var$some;
function $b154e50df59ba62b$var$every(predicate) {
    return (0, $6t3HJ.not)((0, module.exports.some)((0, $6t3HJ.not)(predicate)));
}
function $b154e50df59ba62b$var$isSubset(E) {
    var elemE = $b154e50df59ba62b$var$elem(E);
    return function(me, that) {
        if (that === undefined) {
            var isSubsetE_1 = $b154e50df59ba62b$var$isSubset(E);
            return function(that) {
                return isSubsetE_1(that, me);
            };
        }
        return $b154e50df59ba62b$var$every(function(a) {
            return elemE(a, that);
        })(me);
    };
}
function $b154e50df59ba62b$var$elem(E) {
    return function(a, set) {
        if (set === undefined) {
            var elemE_1 = $b154e50df59ba62b$var$elem(E);
            return function(set) {
                return elemE_1(a, set);
            };
        }
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = E.equals(a, e.value);
        return found;
    };
}
/**
 * Get a sorted `ReadonlyArray` of the values contained in a `ReadonlySet`.
 *
 * @category conversions
 * @since 2.5.0
 */ var $b154e50df59ba62b$var$toReadonlyArray = function(O) {
    return function(set) {
        var out = [];
        set.forEach(function(e) {
            return out.push(e);
        });
        return out.sort(O.compare);
    };
};
module.exports.toReadonlyArray = $b154e50df59ba62b$var$toReadonlyArray;
/**
 * @category type lambdas
 * @since 2.11.0
 */ module.exports.URI = 'ReadonlySet';
/**
 * @category instances
 * @since 2.5.0
 */ function $b154e50df59ba62b$var$getShow(S) {
    return {
        show: function(s) {
            var entries = [];
            s.forEach(function(a) {
                entries.push(S.show(a));
            });
            return "new Set([".concat(entries.sort().join(', '), "])");
        }
    };
}
/**
 * @category instances
 * @since 2.5.0
 */ function $b154e50df59ba62b$var$getEq(E) {
    var subsetE = $b154e50df59ba62b$var$isSubset(E);
    return (0, $5Ikl1.fromEquals)(function(x, y) {
        return subsetE(x, y) && subsetE(y, x);
    });
}
/**
 * @category instances
 * @since 2.11.0
 */ var $b154e50df59ba62b$var$getUnionSemigroup = function(E) {
    return {
        concat: $b154e50df59ba62b$var$union(E)
    };
};
module.exports.getUnionSemigroup = $b154e50df59ba62b$var$getUnionSemigroup;
/**
 * @category instances
 * @since 2.5.0
 */ var $b154e50df59ba62b$var$getUnionMonoid = function(E) {
    return {
        concat: (0, module.exports.getUnionSemigroup)(E).concat,
        empty: module.exports.empty
    };
};
module.exports.getUnionMonoid = $b154e50df59ba62b$var$getUnionMonoid;
/**
 * @category instances
 * @since 2.5.0
 */ var $b154e50df59ba62b$var$getIntersectionSemigroup = function(E) {
    return {
        concat: $b154e50df59ba62b$var$intersection(E)
    };
};
module.exports.getIntersectionSemigroup = $b154e50df59ba62b$var$getIntersectionSemigroup;
/**
 * @category instances
 * @since 2.11.0
 */ var $b154e50df59ba62b$var$getDifferenceMagma = function(E) {
    return {
        concat: $b154e50df59ba62b$var$difference(E)
    };
};
module.exports.getDifferenceMagma = $b154e50df59ba62b$var$getDifferenceMagma;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * Use [`fromReadonlyArray`](#fromreadonlyarray) instead.
 *
 * @category zone of death
 * @since 2.5.0
 * @deprecated
 */ module.exports.fromArray = module.exports.fromReadonlyArray;

});

parcelRegister("azsim", function(module, exports) {
"use strict";
var $7b231f1342b4f60a$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.atReadonlyRecord = module.exports.at = module.exports.indexReadonlyRecord = module.exports.indexReadonlyNonEmptyArray = module.exports.indexReadonlyArray = module.exports.index = module.exports.traversalTraverse = module.exports.fromTraversable = module.exports.ApplicativeIdentity = module.exports.traversalComposeTraversal = module.exports.traversal = module.exports.optionalFindFirstNonEmpty = module.exports.optionalFindFirst = module.exports.optionalKey = module.exports.optionalIndexNonEmpty = module.exports.optionalIndex = module.exports.optionalComposeOptional = module.exports.optionalModify = module.exports.optionalModifyOption = module.exports.optionalAsTraversal = module.exports.optional = module.exports.prismLeft = module.exports.prismRight = module.exports.prismSome = module.exports.prismFromPredicate = module.exports.prismFromNullable = module.exports.prismComposeLens = module.exports.prismSet = module.exports.prismModify = module.exports.prismModifyOption = module.exports.prismAsTraversal = module.exports.prismAsOptional = module.exports.prism = module.exports.lensAtKey = module.exports.lensComponent = module.exports.lensProps = module.exports.lensProp = module.exports.lensId = module.exports.lensComposePrism = module.exports.prismComposePrism = module.exports.lensComposeLens = module.exports.lensAsTraversal = module.exports.lensAsOptional = module.exports.lens = module.exports.isoAsTraversal = module.exports.isoAsOptional = module.exports.isoAsPrism = module.exports.isoAsLens = module.exports.iso = void 0;

var $3zj3N = parcelRequire("3zj3N");

var $eC5G3 = parcelRequire("eC5G3");

var $3abDJ = parcelRequire("3abDJ");

var $hBXBN = parcelRequire("hBXBN");

var $5uDEp = parcelRequire("5uDEp");

var $e64KP = parcelRequire("e64KP");
// -------------------------------------------------------------------------------------
// Iso
// -------------------------------------------------------------------------------------
/** @internal */ var $7b231f1342b4f60a$var$iso = function(get, reverseGet) {
    return {
        get: get,
        reverseGet: reverseGet
    };
};
module.exports.iso = $7b231f1342b4f60a$var$iso;
/** @internal */ var $7b231f1342b4f60a$var$isoAsLens = function(sa) {
    return (0, module.exports.lens)(sa.get, (0, $3abDJ.flow)(sa.reverseGet, $3abDJ.constant));
};
module.exports.isoAsLens = $7b231f1342b4f60a$var$isoAsLens;
/** @internal */ var $7b231f1342b4f60a$var$isoAsPrism = function(sa) {
    return (0, module.exports.prism)((0, $3abDJ.flow)(sa.get, $hBXBN.some), sa.reverseGet);
};
module.exports.isoAsPrism = $7b231f1342b4f60a$var$isoAsPrism;
/** @internal */ var $7b231f1342b4f60a$var$isoAsOptional = function(sa) {
    return (0, module.exports.optional)((0, $3abDJ.flow)(sa.get, $hBXBN.some), (0, $3abDJ.flow)(sa.reverseGet, $3abDJ.constant));
};
module.exports.isoAsOptional = $7b231f1342b4f60a$var$isoAsOptional;
/** @internal */ var $7b231f1342b4f60a$var$isoAsTraversal = function(sa) {
    return (0, module.exports.traversal)(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.reverseGet(a);
                });
            };
        };
    });
};
module.exports.isoAsTraversal = $7b231f1342b4f60a$var$isoAsTraversal;
// -------------------------------------------------------------------------------------
// Lens
// -------------------------------------------------------------------------------------
/** @internal */ var $7b231f1342b4f60a$var$lens = function(get, set) {
    return {
        get: get,
        set: set
    };
};
module.exports.lens = $7b231f1342b4f60a$var$lens;
/** @internal */ var $7b231f1342b4f60a$var$lensAsOptional = function(sa) {
    return (0, module.exports.optional)((0, $3abDJ.flow)(sa.get, $hBXBN.some), sa.set);
};
module.exports.lensAsOptional = $7b231f1342b4f60a$var$lensAsOptional;
/** @internal */ var $7b231f1342b4f60a$var$lensAsTraversal = function(sa) {
    return (0, module.exports.traversal)(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.set(a)(s);
                });
            };
        };
    });
};
module.exports.lensAsTraversal = $7b231f1342b4f60a$var$lensAsTraversal;
/** @internal */ var $7b231f1342b4f60a$var$lensComposeLens = function(ab) {
    return function(sa) {
        return (0, module.exports.lens)(function(s) {
            return ab.get(sa.get(s));
        }, function(b) {
            return function(s) {
                return sa.set(ab.set(b)(sa.get(s)))(s);
            };
        });
    };
};
module.exports.lensComposeLens = $7b231f1342b4f60a$var$lensComposeLens;
/** @internal */ var $7b231f1342b4f60a$var$prismComposePrism = function(ab) {
    return function(sa) {
        return (0, module.exports.prism)((0, $3abDJ.flow)(sa.getOption, $hBXBN.chain(ab.getOption)), (0, $3abDJ.flow)(ab.reverseGet, sa.reverseGet));
    };
};
module.exports.prismComposePrism = $7b231f1342b4f60a$var$prismComposePrism;
/** @internal */ var $7b231f1342b4f60a$var$lensComposePrism = function(ab) {
    return function(sa) {
        return (0, module.exports.optionalComposeOptional)((0, module.exports.prismAsOptional)(ab))((0, module.exports.lensAsOptional)(sa));
    };
};
module.exports.lensComposePrism = $7b231f1342b4f60a$var$lensComposePrism;
/** @internal */ var $7b231f1342b4f60a$var$lensId = function() {
    return (0, module.exports.lens)($3abDJ.identity, $3abDJ.constant);
};
module.exports.lensId = $7b231f1342b4f60a$var$lensId;
/** @internal */ var $7b231f1342b4f60a$var$lensProp = function(prop) {
    return function(sa) {
        return (0, module.exports.lens)(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var _a;
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                return sa.set(Object.assign({}, oa, (_a = {}, _a[prop] = ap, _a)))(s);
            };
        });
    };
};
module.exports.lensProp = $7b231f1342b4f60a$var$lensProp;
/** @internal */ var $7b231f1342b4f60a$var$lensProps = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return function(sa) {
        return (0, module.exports.lens)(function(s) {
            var a = sa.get(s);
            var r = {};
            for(var _i = 0, props_1 = props; _i < props_1.length; _i++){
                var k = props_1[_i];
                r[k] = a[k];
            }
            return r;
        }, function(a) {
            return function(s) {
                var oa = sa.get(s);
                for(var _i = 0, props_2 = props; _i < props_2.length; _i++){
                    var k = props_2[_i];
                    if (a[k] !== oa[k]) return sa.set(Object.assign({}, oa, a))(s);
                }
                return s;
            };
        });
    };
};
module.exports.lensProps = $7b231f1342b4f60a$var$lensProps;
/** @internal */ var $7b231f1342b4f60a$var$lensComponent = function(prop) {
    return function(sa) {
        return (0, module.exports.lens)(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                var copy = oa.slice();
                copy[prop] = ap;
                return sa.set(copy)(s);
            };
        });
    };
};
module.exports.lensComponent = $7b231f1342b4f60a$var$lensComponent;
/** @internal */ var $7b231f1342b4f60a$var$lensAtKey = function(key) {
    return function(sa) {
        return (0, $e64KP.pipe)(sa, (0, module.exports.lensComposeLens)($7b231f1342b4f60a$var$atReadonlyRecord().at(key)));
    };
};
module.exports.lensAtKey = $7b231f1342b4f60a$var$lensAtKey;
// -------------------------------------------------------------------------------------
// Prism
// -------------------------------------------------------------------------------------
/** @internal */ var $7b231f1342b4f60a$var$prism = function(getOption, reverseGet) {
    return {
        getOption: getOption,
        reverseGet: reverseGet
    };
};
module.exports.prism = $7b231f1342b4f60a$var$prism;
/** @internal */ var $7b231f1342b4f60a$var$prismAsOptional = function(sa) {
    return (0, module.exports.optional)(sa.getOption, function(a) {
        return (0, module.exports.prismSet)(a)(sa);
    });
};
module.exports.prismAsOptional = $7b231f1342b4f60a$var$prismAsOptional;
/** @internal */ var $7b231f1342b4f60a$var$prismAsTraversal = function(sa) {
    return (0, module.exports.traversal)(function(F) {
        return function(f) {
            return function(s) {
                return (0, $e64KP.pipe)(sa.getOption(s), $hBXBN.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return (0, module.exports.prismSet)(a)(sa)(s);
                    });
                }));
            };
        };
    });
};
module.exports.prismAsTraversal = $7b231f1342b4f60a$var$prismAsTraversal;
/** @internal */ var $7b231f1342b4f60a$var$prismModifyOption = function(f) {
    return function(sa) {
        return function(s) {
            return (0, $e64KP.pipe)(sa.getOption(s), $hBXBN.map(function(o) {
                var n = f(o);
                return n === o ? s : sa.reverseGet(n);
            }));
        };
    };
};
module.exports.prismModifyOption = $7b231f1342b4f60a$var$prismModifyOption;
/** @internal */ var $7b231f1342b4f60a$var$prismModify = function(f) {
    return function(sa) {
        var g = (0, module.exports.prismModifyOption)(f)(sa);
        return function(s) {
            return (0, $e64KP.pipe)(g(s), $hBXBN.getOrElse(function() {
                return s;
            }));
        };
    };
};
module.exports.prismModify = $7b231f1342b4f60a$var$prismModify;
/** @internal */ var $7b231f1342b4f60a$var$prismSet = function(a) {
    return (0, module.exports.prismModify)(function() {
        return a;
    });
};
module.exports.prismSet = $7b231f1342b4f60a$var$prismSet;
/** @internal */ var $7b231f1342b4f60a$var$prismComposeLens = function(ab) {
    return function(sa) {
        return (0, module.exports.optionalComposeOptional)((0, module.exports.lensAsOptional)(ab))((0, module.exports.prismAsOptional)(sa));
    };
};
module.exports.prismComposeLens = $7b231f1342b4f60a$var$prismComposeLens;
/** @internal */ var $7b231f1342b4f60a$var$prismFromNullable = function() {
    return (0, module.exports.prism)($hBXBN.fromNullable, $3abDJ.identity);
};
module.exports.prismFromNullable = $7b231f1342b4f60a$var$prismFromNullable;
/** @internal */ var $7b231f1342b4f60a$var$prismFromPredicate = function(predicate) {
    return (0, module.exports.prism)($hBXBN.fromPredicate(predicate), $3abDJ.identity);
};
module.exports.prismFromPredicate = $7b231f1342b4f60a$var$prismFromPredicate;
/** @internal */ var $7b231f1342b4f60a$var$prismSome = function() {
    return (0, module.exports.prism)($3abDJ.identity, $hBXBN.some);
};
module.exports.prismSome = $7b231f1342b4f60a$var$prismSome;
/** @internal */ var $7b231f1342b4f60a$var$prismRight = function() {
    return (0, module.exports.prism)($hBXBN.fromEither, $5uDEp.right);
};
module.exports.prismRight = $7b231f1342b4f60a$var$prismRight;
/** @internal */ var $7b231f1342b4f60a$var$prismLeft = function() {
    return (0, module.exports.prism)(function(s) {
        return $5uDEp.isLeft(s) ? $hBXBN.some(s.left) : $hBXBN.none;
    }, $5uDEp.left);
};
module.exports.prismLeft = $7b231f1342b4f60a$var$prismLeft;
// -------------------------------------------------------------------------------------
// Optional
// -------------------------------------------------------------------------------------
/** @internal */ var $7b231f1342b4f60a$var$optional = function(getOption, set) {
    return {
        getOption: getOption,
        set: set
    };
};
module.exports.optional = $7b231f1342b4f60a$var$optional;
/** @internal */ var $7b231f1342b4f60a$var$optionalAsTraversal = function(sa) {
    return (0, module.exports.traversal)(function(F) {
        return function(f) {
            return function(s) {
                return (0, $e64KP.pipe)(sa.getOption(s), $hBXBN.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    });
};
module.exports.optionalAsTraversal = $7b231f1342b4f60a$var$optionalAsTraversal;
/** @internal */ var $7b231f1342b4f60a$var$optionalModifyOption = function(f) {
    return function(optional) {
        return function(s) {
            return (0, $e64KP.pipe)(optional.getOption(s), $hBXBN.map(function(a) {
                var n = f(a);
                return n === a ? s : optional.set(n)(s);
            }));
        };
    };
};
module.exports.optionalModifyOption = $7b231f1342b4f60a$var$optionalModifyOption;
/** @internal */ var $7b231f1342b4f60a$var$optionalModify = function(f) {
    return function(optional) {
        var g = (0, module.exports.optionalModifyOption)(f)(optional);
        return function(s) {
            return (0, $e64KP.pipe)(g(s), $hBXBN.getOrElse(function() {
                return s;
            }));
        };
    };
};
module.exports.optionalModify = $7b231f1342b4f60a$var$optionalModify;
/** @internal */ var $7b231f1342b4f60a$var$optionalComposeOptional = function(ab) {
    return function(sa) {
        return (0, module.exports.optional)((0, $3abDJ.flow)(sa.getOption, $hBXBN.chain(ab.getOption)), function(b) {
            return (0, module.exports.optionalModify)(ab.set(b))(sa);
        });
    };
};
module.exports.optionalComposeOptional = $7b231f1342b4f60a$var$optionalComposeOptional;
/** @internal */ var $7b231f1342b4f60a$var$optionalIndex = function(i) {
    return function(sa) {
        return (0, $e64KP.pipe)(sa, (0, module.exports.optionalComposeOptional)((0, module.exports.indexReadonlyArray)().index(i)));
    };
};
module.exports.optionalIndex = $7b231f1342b4f60a$var$optionalIndex;
/** @internal */ var $7b231f1342b4f60a$var$optionalIndexNonEmpty = function(i) {
    return function(sa) {
        return (0, $e64KP.pipe)(sa, (0, module.exports.optionalComposeOptional)((0, module.exports.indexReadonlyNonEmptyArray)().index(i)));
    };
};
module.exports.optionalIndexNonEmpty = $7b231f1342b4f60a$var$optionalIndexNonEmpty;
/** @internal */ var $7b231f1342b4f60a$var$optionalKey = function(key) {
    return function(sa) {
        return (0, $e64KP.pipe)(sa, (0, module.exports.optionalComposeOptional)((0, module.exports.indexReadonlyRecord)().index(key)));
    };
};
module.exports.optionalKey = $7b231f1342b4f60a$var$optionalKey;
/** @internal */ var $7b231f1342b4f60a$var$optionalFindFirst = function(predicate) {
    return (0, module.exports.optional)($3zj3N.findFirst(predicate), function(a) {
        return function(s) {
            return (0, $e64KP.pipe)($3zj3N.findIndex(predicate)(s), $hBXBN.fold(function() {
                return s;
            }, function(i) {
                return $3zj3N.unsafeUpdateAt(i, a, s);
            }));
        };
    });
};
module.exports.optionalFindFirst = $7b231f1342b4f60a$var$optionalFindFirst;
var $7b231f1342b4f60a$var$unsafeUpdateAt = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $7b231f1342b4f60a$var$__spreadArray([
            as[0]
        ], as.slice(1), true);
        xs[i] = a;
        return xs;
    }
};
/** @internal */ var $7b231f1342b4f60a$var$optionalFindFirstNonEmpty = function(predicate) {
    return (0, module.exports.optional)($3zj3N.findFirst(predicate), function(a) {
        return function(as) {
            return (0, $e64KP.pipe)($3zj3N.findIndex(predicate)(as), $hBXBN.fold(function() {
                return as;
            }, function(i) {
                return $7b231f1342b4f60a$var$unsafeUpdateAt(i, a, as);
            }));
        };
    });
};
module.exports.optionalFindFirstNonEmpty = $7b231f1342b4f60a$var$optionalFindFirstNonEmpty;
// -------------------------------------------------------------------------------------
// Traversal
// -------------------------------------------------------------------------------------
/** @internal */ var $7b231f1342b4f60a$var$traversal = function(modifyF) {
    return {
        modifyF: modifyF
    };
};
module.exports.traversal = $7b231f1342b4f60a$var$traversal;
/** @internal */ function $7b231f1342b4f60a$var$traversalComposeTraversal(ab) {
    return function(sa) {
        return (0, module.exports.traversal)(function(F) {
            return function(f) {
                return sa.modifyF(F)(ab.modifyF(F)(f));
            };
        });
    };
}
module.exports.traversalComposeTraversal = $7b231f1342b4f60a$var$traversalComposeTraversal;
/** @internal */ module.exports.ApplicativeIdentity = {
    URI: 'Identity',
    map: function(fa, f) {
        return f(fa);
    },
    of: $3abDJ.identity,
    ap: /* istanbul ignore next */ function(fab, fa) {
        return fab(fa);
    }
};
var $7b231f1342b4f60a$var$isIdentity = function(F) {
    return F.URI === 'Identity';
};
function $7b231f1342b4f60a$var$fromTraversable(T) {
    return function() {
        return (0, module.exports.traversal)(function(F) {
            // if `F` is `Identity` then `traverseF = map`
            var traverseF = $7b231f1342b4f60a$var$isIdentity(F) ? T.map : T.traverse(F);
            return function(f) {
                return function(s) {
                    return traverseF(s, f);
                };
            };
        });
    };
}
module.exports.fromTraversable = $7b231f1342b4f60a$var$fromTraversable;
/** @internal */ function $7b231f1342b4f60a$var$traversalTraverse(T) {
    return $7b231f1342b4f60a$var$traversalComposeTraversal($7b231f1342b4f60a$var$fromTraversable(T)());
}
module.exports.traversalTraverse = $7b231f1342b4f60a$var$traversalTraverse;
// -------------------------------------------------------------------------------------
// Ix
// -------------------------------------------------------------------------------------
/** @internal */ var $7b231f1342b4f60a$var$index = function(index) {
    return {
        index: index
    };
};
module.exports.index = $7b231f1342b4f60a$var$index;
/** @internal */ var $7b231f1342b4f60a$var$indexReadonlyArray = function() {
    return (0, module.exports.index)(function(i) {
        return (0, module.exports.optional)(function(as) {
            return $3zj3N.lookup(i, as);
        }, function(a) {
            return function(as) {
                return (0, $e64KP.pipe)($3zj3N.lookup(i, as), $hBXBN.fold(function() {
                    return as;
                }, function() {
                    return $3zj3N.unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
module.exports.indexReadonlyArray = $7b231f1342b4f60a$var$indexReadonlyArray;
/** @internal */ var $7b231f1342b4f60a$var$indexReadonlyNonEmptyArray = function() {
    return (0, module.exports.index)(function(i) {
        return (0, module.exports.optional)(function(as) {
            return $3zj3N.lookup(i, as);
        }, function(a) {
            return function(as) {
                return (0, $e64KP.pipe)($3zj3N.lookup(i, as), $hBXBN.fold(function() {
                    return as;
                }, function() {
                    return $7b231f1342b4f60a$var$unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
module.exports.indexReadonlyNonEmptyArray = $7b231f1342b4f60a$var$indexReadonlyNonEmptyArray;
/** @internal */ var $7b231f1342b4f60a$var$indexReadonlyRecord = function() {
    return (0, module.exports.index)(function(k) {
        return (0, module.exports.optional)(function(r) {
            return $eC5G3.lookup(k, r);
        }, function(a) {
            return function(r) {
                if (r[k] === a || $hBXBN.isNone($eC5G3.lookup(k, r))) return r;
                return $eC5G3.insertAt(k, a)(r);
            };
        });
    });
};
module.exports.indexReadonlyRecord = $7b231f1342b4f60a$var$indexReadonlyRecord;
// -------------------------------------------------------------------------------------
// At
// -------------------------------------------------------------------------------------
/** @internal */ var $7b231f1342b4f60a$var$at = function(at) {
    return {
        at: at
    };
};
module.exports.at = $7b231f1342b4f60a$var$at;
/** @internal */ function $7b231f1342b4f60a$var$atReadonlyRecord() {
    return (0, module.exports.at)(function(key) {
        return (0, module.exports.lens)(function(r) {
            return $eC5G3.lookup(key, r);
        }, $hBXBN.fold(function() {
            return $eC5G3.deleteAt(key);
        }, function(a) {
            return $eC5G3.insertAt(key, a);
        }));
    });
}
module.exports.atReadonlyRecord = $7b231f1342b4f60a$var$atReadonlyRecord;

});
parcelRegister("eC5G3", function(module, exports) {
"use strict";
var $aa3904b18ac0db4d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $aa3904b18ac0db4d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $aa3904b18ac0db4d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $aa3904b18ac0db4d$var$__createBinding(result, mod, k);
    }
    $aa3904b18ac0db4d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Compactable = module.exports.getFoldableWithIndex = module.exports.getFoldable = module.exports.FunctorWithIndex = module.exports.flap = module.exports.Functor = module.exports.URI = module.exports.separate = module.exports.compact = module.exports.partitionMap = module.exports.partition = module.exports.filterMap = module.exports.filter = module.exports._sequence = module.exports._traverse = module.exports._filterWithIndex = module.exports._filterMapWithIndex = module.exports._partitionWithIndex = module.exports._partitionMapWithIndex = module.exports._reduceRightWithIndex = module.exports._foldMapWithIndex = module.exports._reduceWithIndex = module.exports._partitionMap = module.exports._partition = module.exports._filterMap = module.exports._filter = module.exports._reduceRight = module.exports._foldMap = module.exports._reduce = module.exports._mapWithIndex = module.exports._map = module.exports.difference = module.exports.intersection = module.exports.union = module.exports.fromEntries = module.exports.toEntries = module.exports.wilt = module.exports.wither = module.exports.singleton = module.exports.empty = module.exports.modifyAt = module.exports.updateAt = module.exports.has = module.exports.upsertAt = module.exports.toReadonlyArray = module.exports.keys = module.exports.isEmpty = module.exports.size = module.exports.toRecord = module.exports.fromRecord = void 0;
module.exports.readonlyRecord = module.exports.insertAt = module.exports.Witherable = module.exports.TraversableWithIndex = module.exports.Traversable = module.exports.FoldableWithIndex = module.exports.Foldable = module.exports.getDifferenceMagma = module.exports.getIntersectionSemigroup = module.exports.getUnionMonoid = module.exports.getUnionSemigroup = module.exports.getWitherable = module.exports.getTraversableWithIndex = module.exports.getTraversable = module.exports.FilterableWithIndex = module.exports.Filterable = void 0;
module.exports.collect = $aa3904b18ac0db4d$var$collect;
module.exports.toUnfoldable = $aa3904b18ac0db4d$var$toUnfoldable;
module.exports.deleteAt = $aa3904b18ac0db4d$var$deleteAt;
module.exports.pop = $aa3904b18ac0db4d$var$pop;
module.exports.isSubrecord = $aa3904b18ac0db4d$var$isSubrecord;
module.exports.lookup = $aa3904b18ac0db4d$var$lookup;
module.exports.mapWithIndex = $aa3904b18ac0db4d$var$mapWithIndex;
module.exports.map = $aa3904b18ac0db4d$var$map;
module.exports.reduceWithIndex = $aa3904b18ac0db4d$var$reduceWithIndex;
module.exports.foldMapWithIndex = $aa3904b18ac0db4d$var$foldMapWithIndex;
module.exports.reduceRightWithIndex = $aa3904b18ac0db4d$var$reduceRightWithIndex;
module.exports.traverseWithIndex = $aa3904b18ac0db4d$var$traverseWithIndex;
module.exports.traverse = $aa3904b18ac0db4d$var$traverse;
module.exports.sequence = $aa3904b18ac0db4d$var$sequence;
module.exports.partitionMapWithIndex = $aa3904b18ac0db4d$var$partitionMapWithIndex;
module.exports.partitionWithIndex = $aa3904b18ac0db4d$var$partitionWithIndex;
module.exports.filterMapWithIndex = $aa3904b18ac0db4d$var$filterMapWithIndex;
module.exports.filterWithIndex = $aa3904b18ac0db4d$var$filterWithIndex;
module.exports.fromFoldable = $aa3904b18ac0db4d$var$fromFoldable;
module.exports.fromFoldableMap = $aa3904b18ac0db4d$var$fromFoldableMap;
module.exports.every = $aa3904b18ac0db4d$var$every;
module.exports.some = $aa3904b18ac0db4d$var$some;
module.exports.elem = $aa3904b18ac0db4d$var$elem;
module.exports.reduce = $aa3904b18ac0db4d$var$reduce;
module.exports.foldMap = $aa3904b18ac0db4d$var$foldMap;
module.exports.reduceRight = $aa3904b18ac0db4d$var$reduceRight;
module.exports.getShow = $aa3904b18ac0db4d$var$getShow;
module.exports.getEq = $aa3904b18ac0db4d$var$getEq;
module.exports.getMonoid = $aa3904b18ac0db4d$var$getMonoid;
module.exports.hasOwnProperty = $aa3904b18ac0db4d$var$hasOwnProperty;

var $5Ikl1 = parcelRequire("5Ikl1");

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");

var $aa3904b18ac0db4d$var$_ = $aa3904b18ac0db4d$var$__importStar((parcelRequire("704qB")));

var $fIQoU = parcelRequire("fIQoU");

var $aa3904b18ac0db4d$var$S = $aa3904b18ac0db4d$var$__importStar((parcelRequire("a1nAP")));

var $4p4Yq = parcelRequire("4p4Yq");
/**
 * Builds a `ReadonlyRecord` by copying a `Record`.
 *
 * @example
 * import { ReadonlyRecord, fromRecord } from "fp-ts/ReadonlyRecord"
 *
 * const x: Record<string, number> = { a: 1, b: 2 };
 * const y: ReadonlyRecord<string, number> = fromRecord(x);
 * assert.deepStrictEqual(x,y);
 * // `y.a = 5` gives compiler error
 *
 * @category conversions
 * @since 2.5.0
 */ var $aa3904b18ac0db4d$var$fromRecord = function(r) {
    return Object.assign({}, r);
};
module.exports.fromRecord = $aa3904b18ac0db4d$var$fromRecord;
/**
 * Builds a mutable `Record` from a `ReadonlyRecord`.
 *
 * @example
 * import { ReadonlyRecord, toRecord } from "fp-ts/ReadonlyRecord"
 *
 * const x: ReadonlyRecord<string, number> = { a: 1, b: 2 };
 * const y: Record<string, number> = toRecord(x);
 * assert.deepStrictEqual(x,y);
 * y.a = 5; // it's ok, y is mutable
 *
 * @category conversions
 * @since 2.5.0
 */ var $aa3904b18ac0db4d$var$toRecord = function(r) {
    return Object.assign({}, r);
};
module.exports.toRecord = $aa3904b18ac0db4d$var$toRecord;
/**
 * Calculate the number of key/value pairs in a `ReadonlyRecord`,
 *
 * @example
 * import { size } from "fp-ts/ReadonlyRecord";
 *
 * assert.deepStrictEqual(size({ a: true, b: 2, c: "three" }), 3);
 *
 * @since 2.5.0
 */ var $aa3904b18ac0db4d$var$size = function(r) {
    return Object.keys(r).length;
};
module.exports.size = $aa3904b18ac0db4d$var$size;
/**
 * Test whether a `ReadonlyRecord` is empty.
 *
 * @example
 * import { isEmpty } from "fp-ts/ReadonlyRecord"
 *
 * assert.deepStrictEqual(isEmpty({}), true);
 * assert.deepStrictEqual(isEmpty({ a: 3 }), false);
 * @since 2.5.0
 */ var $aa3904b18ac0db4d$var$isEmpty = function(r) {
    for(var k in r){
        if ($aa3904b18ac0db4d$var$_.has.call(r, k)) return false;
    }
    return true;
};
module.exports.isEmpty = $aa3904b18ac0db4d$var$isEmpty;
var $aa3904b18ac0db4d$var$keys_ = function(O) {
    return function(r) {
        return Object.keys(r).sort(O.compare);
    };
};
/**
 * @since 2.5.0
 */ module.exports.keys = $aa3904b18ac0db4d$var$keys_($aa3904b18ac0db4d$var$S.Ord);
function $aa3904b18ac0db4d$var$collect(O) {
    if (typeof O === 'function') return $aa3904b18ac0db4d$var$collect($aa3904b18ac0db4d$var$S.Ord)(O);
    var keysO = $aa3904b18ac0db4d$var$keys_(O);
    return function(f) {
        return function(r) {
            var out = [];
            for(var _i = 0, _a = keysO(r); _i < _a.length; _i++){
                var key = _a[_i];
                out.push(f(key, r[key]));
            }
            return out;
        };
    };
}
/**
 * Get a sorted `ReadonlyArray` of the key/value pairs contained in a `ReadonlyRecord`.
 *
 * @example
 * import { toReadonlyArray } from 'fp-ts/ReadonlyRecord'
 *
 * const x = { c: 3, a: "foo", b: false };
 * assert.deepStrictEqual(toReadonlyArray(x), [
 *   ["a", "foo"],
 *   ["b", false],
 *   ["c", 3],
 * ]);
 *
 * @category conversions
 * @since 2.5.0
 */ module.exports.toReadonlyArray = /*#__PURE__*/ $aa3904b18ac0db4d$var$collect($aa3904b18ac0db4d$var$S.Ord)(function(k, a) {
    return [
        k,
        a
    ];
});
function $aa3904b18ac0db4d$var$toUnfoldable(U) {
    return function(r) {
        var sas = (0, module.exports.toReadonlyArray)(r);
        var len = sas.length;
        return U.unfold(0, function(b) {
            return b < len ? $aa3904b18ac0db4d$var$_.some([
                sas[b],
                b + 1
            ]) : $aa3904b18ac0db4d$var$_.none;
        });
    };
}
/**
 * Insert or replace a key/value pair in a `ReadonlyRecord`.
 *
 * @example
 * import { upsertAt } from 'fp-ts/ReadonlyRecord'
 *
 * assert.deepStrictEqual(upsertAt("a", 5)({ a: 1, b: 2 }), { a: 5, b: 2 });
 * assert.deepStrictEqual(upsertAt("c", 5)({ a: 1, b: 2 }), { a: 1, b: 2, c: 5 });
 *
 * @since 2.10.0
 */ var $aa3904b18ac0db4d$var$upsertAt = function(k, a) {
    return function(r) {
        if ($aa3904b18ac0db4d$var$_.has.call(r, k) && r[k] === a) return r;
        var out = Object.assign({}, r);
        out[k] = a;
        return out;
    };
};
module.exports.upsertAt = $aa3904b18ac0db4d$var$upsertAt;
/**
 * Test whether or not a key exists in a `ReadonlyRecord`.
 *
 * Note. This function is not pipeable because is a `Refinement`.
 *
 * @example
 * import { has } from 'fp-ts/ReadonlyRecord'
 *
 * assert.deepStrictEqual(has("a", { a: 1, b: 2 }), true);
 * assert.deepStrictEqual(has("c", { a: 1, b: 2 }), false);
 *
 * @since 2.10.0
 */ var $aa3904b18ac0db4d$var$has = function(k, r) {
    return $aa3904b18ac0db4d$var$_.has.call(r, k);
};
module.exports.has = $aa3904b18ac0db4d$var$has;
function $aa3904b18ac0db4d$var$deleteAt(k) {
    return function(r) {
        if (!$aa3904b18ac0db4d$var$_.has.call(r, k)) return r;
        var out = Object.assign({}, r);
        delete out[k];
        return out;
    };
}
/**
 * Replace a key/value pair in a `ReadonlyRecord`.
 *
 * @returns If the specified key exists it returns an `Option` containing a new `Record`
 * with the entry updated, otherwise it returns `None`
 *
 * @example
 * import { updateAt } from 'fp-ts/ReadonlyRecord'
 * import { option } from 'fp-ts'
 *
 * assert.deepStrictEqual(updateAt("a", 3)({ a: 1, b: 2 }), option.some({ a: 3, b: 2 }));
 * assert.deepStrictEqual(updateAt("c", 3)({ a: 1, b: 2 }), option.none);
 *
 * @since 2.5.0
 */ var $aa3904b18ac0db4d$var$updateAt = function(k, a) {
    return function(r) {
        if (!(0, module.exports.has)(k, r)) return $aa3904b18ac0db4d$var$_.none;
        if (r[k] === a) return $aa3904b18ac0db4d$var$_.some(r);
        var out = Object.assign({}, r);
        out[k] = a;
        return $aa3904b18ac0db4d$var$_.some(out);
    };
};
module.exports.updateAt = $aa3904b18ac0db4d$var$updateAt;
/**
 * Applies a mapping function to one specific key/value pair in a `ReadonlyRecord`.
 *
 * @returns If the specified key exists it returns an `Option` containing a new `Record`
 * with the entry updated, otherwise it returns `None`
 *
 * @example
 * import { modifyAt } from 'fp-ts/ReadonlyRecord'
 * import { option } from 'fp-ts'
 *
 * assert.deepStrictEqual(modifyAt("a", (x: number) => x * 3)({ a: 1, b: 2 }), option.some({ a: 3, b: 2 }));
 * assert.deepStrictEqual(modifyAt("c", (x: number) => x * 3)({ a: 1, b: 2 }), option.none);
 *
 * @since 2.5.0
 */ var $aa3904b18ac0db4d$var$modifyAt = function(k, f) {
    return function(r) {
        if (!(0, module.exports.has)(k, r)) return $aa3904b18ac0db4d$var$_.none;
        var next = f(r[k]);
        if (next === r[k]) return $aa3904b18ac0db4d$var$_.some(r);
        var out = Object.assign({}, r);
        out[k] = next;
        return $aa3904b18ac0db4d$var$_.some(out);
    };
};
module.exports.modifyAt = $aa3904b18ac0db4d$var$modifyAt;
function $aa3904b18ac0db4d$var$pop(k) {
    var deleteAtk = $aa3904b18ac0db4d$var$deleteAt(k);
    return function(r) {
        var oa = $aa3904b18ac0db4d$var$lookup(k, r);
        return $aa3904b18ac0db4d$var$_.isNone(oa) ? $aa3904b18ac0db4d$var$_.none : $aa3904b18ac0db4d$var$_.some([
            oa.value,
            deleteAtk(r)
        ]);
    };
}
function $aa3904b18ac0db4d$var$isSubrecord(E) {
    return function(me, that) {
        if (that === undefined) {
            var isSubrecordE_1 = $aa3904b18ac0db4d$var$isSubrecord(E);
            return function(that) {
                return isSubrecordE_1(that, me);
            };
        }
        for(var k in me){
            if (!$aa3904b18ac0db4d$var$_.has.call(that, k) || !E.equals(me[k], that[k])) return false;
        }
        return true;
    };
}
function $aa3904b18ac0db4d$var$lookup(k, r) {
    if (r === undefined) return function(r) {
        return $aa3904b18ac0db4d$var$lookup(k, r);
    };
    return $aa3904b18ac0db4d$var$_.has.call(r, k) ? $aa3904b18ac0db4d$var$_.some(r[k]) : $aa3904b18ac0db4d$var$_.none;
}
/**
 * @since 2.5.0
 */ module.exports.empty = {};
function $aa3904b18ac0db4d$var$mapWithIndex(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($aa3904b18ac0db4d$var$_.has.call(r, k)) out[k] = f(k, r[k]);
        return out;
    };
}
function $aa3904b18ac0db4d$var$map(f) {
    return $aa3904b18ac0db4d$var$mapWithIndex(function(_, a) {
        return f(a);
    });
}
function $aa3904b18ac0db4d$var$reduceWithIndex() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $aa3904b18ac0db4d$var$reduceWithIndex($aa3904b18ac0db4d$var$S.Ord).apply(void 0, args);
    var keysO = $aa3904b18ac0db4d$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = 0; i < len; i++){
                var k = ks[i];
                out = f(k, out, fa[k]);
            }
            return out;
        };
    };
}
function $aa3904b18ac0db4d$var$foldMapWithIndex(O) {
    if ('compare' in O) {
        var keysO_1 = $aa3904b18ac0db4d$var$keys_(O);
        return function(M) {
            return function(f) {
                return function(fa) {
                    var out = M.empty;
                    var ks = keysO_1(fa);
                    var len = ks.length;
                    for(var i = 0; i < len; i++){
                        var k = ks[i];
                        out = M.concat(out, f(k, fa[k]));
                    }
                    return out;
                };
            };
        };
    }
    return $aa3904b18ac0db4d$var$foldMapWithIndex($aa3904b18ac0db4d$var$S.Ord)(O);
}
function $aa3904b18ac0db4d$var$reduceRightWithIndex() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $aa3904b18ac0db4d$var$reduceRightWithIndex($aa3904b18ac0db4d$var$S.Ord).apply(void 0, args);
    var keysO = $aa3904b18ac0db4d$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, fa[k], out);
            }
            return out;
        };
    };
}
/**
 * Create a `ReadonlyRecord` with one key/value pair.
 *
 * @example
 * import { singleton } from "fp-ts/ReadonlyRecord";
 *
 * assert.deepStrictEqual(singleton("a", 1), { a: 1 });
 *
 * @category constructors
 * @since 2.5.0
 */ var $aa3904b18ac0db4d$var$singleton = function(k, a) {
    var _a;
    return _a = {}, _a[k] = a, _a;
};
module.exports.singleton = $aa3904b18ac0db4d$var$singleton;
function $aa3904b18ac0db4d$var$traverseWithIndex(F) {
    var traverseWithIndexOF = $aa3904b18ac0db4d$var$_traverseWithIndex($aa3904b18ac0db4d$var$S.Ord)(F);
    return function(f) {
        return function(ta) {
            return traverseWithIndexOF(ta, f);
        };
    };
}
function $aa3904b18ac0db4d$var$traverse(F) {
    var traverseOF = (0, module.exports._traverse)($aa3904b18ac0db4d$var$S.Ord)(F);
    return function(f) {
        return function(ta) {
            return traverseOF(ta, f);
        };
    };
}
function $aa3904b18ac0db4d$var$sequence(F) {
    return (0, module.exports._sequence)($aa3904b18ac0db4d$var$S.Ord)(F);
}
/**
 * @category filtering
 * @since 2.6.5
 */ var $aa3904b18ac0db4d$var$wither = function(F) {
    var traverseF = $aa3904b18ac0db4d$var$traverse(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $3abDJ.pipe)(fa, traverseF(f)), module.exports.compact);
        };
    };
};
module.exports.wither = $aa3904b18ac0db4d$var$wither;
/**
 * @category filtering
 * @since 2.6.5
 */ var $aa3904b18ac0db4d$var$wilt = function(F) {
    var traverseF = $aa3904b18ac0db4d$var$traverse(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $3abDJ.pipe)(fa, traverseF(f)), module.exports.separate);
        };
    };
};
module.exports.wilt = $aa3904b18ac0db4d$var$wilt;
function $aa3904b18ac0db4d$var$partitionMapWithIndex(f) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($aa3904b18ac0db4d$var$_.has.call(r, k)) {
            var e = f(k, r[k]);
            switch(e._tag){
                case 'Left':
                    left[k] = e.left;
                    break;
                case 'Right':
                    right[k] = e.right;
                    break;
            }
        }
        return (0, $fIQoU.separated)(left, right);
    };
}
function $aa3904b18ac0db4d$var$partitionWithIndex(predicateWithIndex) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($aa3904b18ac0db4d$var$_.has.call(r, k)) {
            var a = r[k];
            if (predicateWithIndex(k, a)) right[k] = a;
            else left[k] = a;
        }
        return (0, $fIQoU.separated)(left, right);
    };
}
function $aa3904b18ac0db4d$var$filterMapWithIndex(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($aa3904b18ac0db4d$var$_.has.call(r, k)) {
            var ob = f(k, r[k]);
            if ($aa3904b18ac0db4d$var$_.isSome(ob)) out[k] = ob.value;
        }
        return out;
    };
}
function $aa3904b18ac0db4d$var$filterWithIndex(predicateWithIndex) {
    return function(fa) {
        var out = {};
        var changed = false;
        for(var key in fa)if ($aa3904b18ac0db4d$var$_.has.call(fa, key)) {
            var a = fa[key];
            if (predicateWithIndex(key, a)) out[key] = a;
            else changed = true;
        }
        return changed ? out : fa;
    };
}
function $aa3904b18ac0db4d$var$fromFoldable(M, F) {
    var fromFoldableMapM = $aa3904b18ac0db4d$var$fromFoldableMap(M, F);
    return function(fka) {
        return fromFoldableMapM(fka, $3abDJ.identity);
    };
}
function $aa3904b18ac0db4d$var$fromFoldableMap(M, F) {
    return function(ta, f) {
        return F.reduce(ta, {}, function(r, a) {
            var _a = f(a), k = _a[0], b = _a[1];
            r[k] = $aa3904b18ac0db4d$var$_.has.call(r, k) ? M.concat(r[k], b) : b;
            return r;
        });
    };
}
/**
 * Alias of [`toReadonlyArray`](#toreadonlyarray).
 *
 * @example
 * import { toEntries } from 'fp-ts/ReadonlyRecord'
 *
 * assert.deepStrictEqual(toEntries({ b: 2, a: 1 }), [['a', 1], ['b', 2]])
 *
 * @category conversions
 * @since 2.12.0
 */ module.exports.toEntries = module.exports.toReadonlyArray;
/**
 * Converts a `ReadonlyArray` of `[key, value]` tuples into a `ReadonlyRecord`.
 *
 * @example
 * import { fromEntries } from 'fp-ts/ReadonlyRecord'
 *
 * assert.deepStrictEqual(fromEntries([['a', 1], ['b', 2], ['a', 3]]), { b: 2, a: 3 })
 *
 * @since 2.12.0
 * @category conversions
 */ var $aa3904b18ac0db4d$var$fromEntries = function(fa) {
    var out = {};
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var a = fa_1[_i];
        out[a[0]] = a[1];
    }
    return out;
};
module.exports.fromEntries = $aa3904b18ac0db4d$var$fromEntries;
function $aa3904b18ac0db4d$var$every(predicate) {
    return function(r) {
        for(var k in r){
            if (!predicate(r[k])) return false;
        }
        return true;
    };
}
/**
 * Test if at least one value in a `ReadonlyRecord` satisfies the predicate.
 *
 * @example
 * import { some } from "fp-ts/ReadonlyRecord"
 *
 * assert.deepStrictEqual(some((n: number) => n >= 0)({ a: 1, b: -2 }), true);
 * assert.deepStrictEqual(some((n: number) => n >= 0)({ a: -1, b: -2 }), false);
 *
 * @since 2.5.0
 */ function $aa3904b18ac0db4d$var$some(predicate) {
    return function(r) {
        for(var k in r){
            if (predicate(r[k])) return true;
        }
        return false;
    };
}
function $aa3904b18ac0db4d$var$elem(E) {
    return function(a, fa) {
        if (fa === undefined) {
            var elemE_1 = $aa3904b18ac0db4d$var$elem(E);
            return function(fa) {
                return elemE_1(a, fa);
            };
        }
        for(var k in fa){
            if (E.equals(fa[k], a)) return true;
        }
        return false;
    };
}
/**
 * Union of two `ReadonlyRecord`s.
 * Takes two `ReadonlyRecord`s and produces a `ReadonlyRecord` combining all the
 * entries of the two inputs.
 * It uses the `concat` function of the provided `Magma` to
 * combine the elements with the same key.
 *
 * @example
 * import { union } from "fp-ts/ReadonlyRecord";
 * import { Magma } from "fp-ts/Magma";
 *
 * const m1: Magma<number> = { concat: (x: number, y: number) => x + y };
 * assert.deepStrictEqual(union(m1)({ a: 3, c: 3 })({ a: 1, b: 2 }), { a: 4, b: 2, c: 3 });
 * const m2: Magma<number> = { concat: (x: number) => x };
 * assert.deepStrictEqual(union(m2)({ a: 3, c: 3 })({ a: 1, b: 2 }), { a: 1, b: 2, c: 3 });
 *
 * @since 2.11.0
 */ var $aa3904b18ac0db4d$var$union = function(M) {
    return function(second) {
        return function(first) {
            if ((0, module.exports.isEmpty)(first)) return second;
            if ((0, module.exports.isEmpty)(second)) return first;
            var out = {};
            for(var k in first)if ((0, module.exports.has)(k, second)) out[k] = M.concat(first[k], second[k]);
            else out[k] = first[k];
            for(var k in second)if (!(0, module.exports.has)(k, out)) out[k] = second[k];
            return out;
        };
    };
};
module.exports.union = $aa3904b18ac0db4d$var$union;
/**
 * Intersection of two `ReadonlyRecord`s.
 * Takes two `ReadonlyRecord`s and produces a `ReadonlyRecord` combining only the
 * entries of the two inputswith the same key.
 * It uses the `concat` function of the provided `Magma` to
 * combine the elements.
 *
 * @example
 * import { intersection } from "fp-ts/ReadonlyRecord";
 * import { Magma } from "fp-ts/Magma";
 *
 * const m1: Magma<number> = { concat: (x: number, y: number) => x + y };
 * assert.deepStrictEqual(intersection(m1)({ a: 3, c: 3 })({ a: 1, b: 2 }), { a: 4});
 * const m2: Magma<number> = { concat: (x: number) => x };
 * assert.deepStrictEqual(intersection(m2)({ a: 3, c: 3 })({ a: 1, b: 2 }), { a: 1});
 *
 * @since 2.11.0
 */ var $aa3904b18ac0db4d$var$intersection = function(M) {
    return function(second) {
        return function(first) {
            if ((0, module.exports.isEmpty)(first) || (0, module.exports.isEmpty)(second)) return module.exports.empty;
            var out = {};
            for(var k in first)if ((0, module.exports.has)(k, second)) out[k] = M.concat(first[k], second[k]);
            return out;
        };
    };
};
module.exports.intersection = $aa3904b18ac0db4d$var$intersection;
/**
 * Difference between two `ReadonlyRecord`s.
 * Takes two `ReadonlyRecord`s and produces a `ReadonlyRecord` composed by the
 * entries of the two inputs, removing the entries with the same
 * key in both inputs.
 *
 * @example
 * import { difference } from "fp-ts/ReadonlyRecord";
 *
 * assert.deepStrictEqual(difference({ a: 1 })({ a: 1, b: 2 }), { b: 2 });
 * assert.deepStrictEqual(difference({ a: 3 })({ a: 1, b: 2 }), { b: 2 });
 * assert.deepStrictEqual(difference({ a: 3, c: 3 })({ a: 1, b: 2 }), { b: 2, c: 3 });
 *
 * @since 2.11.0
 */ var $aa3904b18ac0db4d$var$difference = function(second) {
    return function(first) {
        if ((0, module.exports.isEmpty)(first)) return second;
        if ((0, module.exports.isEmpty)(second)) return first;
        var out = {};
        for(var k in first)if (!(0, module.exports.has)(k, second)) out[k] = first[k];
        for(var k in second)if (!(0, module.exports.has)(k, first)) out[k] = second[k];
        return out;
    };
};
module.exports.difference = $aa3904b18ac0db4d$var$difference;
/** @internal */ var $aa3904b18ac0db4d$var$_map = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, $aa3904b18ac0db4d$var$map(f));
};
module.exports._map = $aa3904b18ac0db4d$var$_map;
/** @internal */ /* istanbul ignore next */ var $aa3904b18ac0db4d$var$_mapWithIndex = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, $aa3904b18ac0db4d$var$mapWithIndex(f));
};
module.exports._mapWithIndex = $aa3904b18ac0db4d$var$_mapWithIndex;
/** @internal */ /* istanbul ignore next */ var $aa3904b18ac0db4d$var$_reduce = function(O) {
    var reduceO = $aa3904b18ac0db4d$var$reduce(O);
    return function(fa, b, f) {
        return (0, $3abDJ.pipe)(fa, reduceO(b, f));
    };
};
module.exports._reduce = $aa3904b18ac0db4d$var$_reduce;
/** @internal */ var $aa3904b18ac0db4d$var$_foldMap = function(O) {
    return function(M) {
        var foldMapM = $aa3904b18ac0db4d$var$foldMap(O)(M);
        return function(fa, f) {
            return (0, $3abDJ.pipe)(fa, foldMapM(f));
        };
    };
};
module.exports._foldMap = $aa3904b18ac0db4d$var$_foldMap;
/** @internal */ /* istanbul ignore next */ var $aa3904b18ac0db4d$var$_reduceRight = function(O) {
    var reduceRightO = $aa3904b18ac0db4d$var$reduceRight(O);
    return function(fa, b, f) {
        return (0, $3abDJ.pipe)(fa, reduceRightO(b, f));
    };
};
module.exports._reduceRight = $aa3904b18ac0db4d$var$_reduceRight;
/** @internal */ /* istanbul ignore next */ var $aa3904b18ac0db4d$var$_filter = function(fa, predicate) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.filter)(predicate));
};
module.exports._filter = $aa3904b18ac0db4d$var$_filter;
/** @internal */ /* istanbul ignore next */ var $aa3904b18ac0db4d$var$_filterMap = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.filterMap)(f));
};
module.exports._filterMap = $aa3904b18ac0db4d$var$_filterMap;
/** @internal */ /* istanbul ignore next */ var $aa3904b18ac0db4d$var$_partition = function(fa, predicate) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.partition)(predicate));
};
module.exports._partition = $aa3904b18ac0db4d$var$_partition;
/** @internal */ /* istanbul ignore next */ var $aa3904b18ac0db4d$var$_partitionMap = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.partitionMap)(f));
};
module.exports._partitionMap = $aa3904b18ac0db4d$var$_partitionMap;
/** @internal */ /* istanbul ignore next */ var $aa3904b18ac0db4d$var$_reduceWithIndex = function(O) {
    var reduceWithIndexO = $aa3904b18ac0db4d$var$reduceWithIndex(O);
    return function(fa, b, f) {
        return (0, $3abDJ.pipe)(fa, reduceWithIndexO(b, f));
    };
};
module.exports._reduceWithIndex = $aa3904b18ac0db4d$var$_reduceWithIndex;
/** @internal */ var $aa3904b18ac0db4d$var$_foldMapWithIndex = function(O) {
    var foldMapWithIndexO = $aa3904b18ac0db4d$var$foldMapWithIndex(O);
    return function(M) {
        var foldMapWithIndexM = foldMapWithIndexO(M);
        return function(fa, f) {
            return (0, $3abDJ.pipe)(fa, foldMapWithIndexM(f));
        };
    };
};
module.exports._foldMapWithIndex = $aa3904b18ac0db4d$var$_foldMapWithIndex;
/** @internal */ /* istanbul ignore next */ var $aa3904b18ac0db4d$var$_reduceRightWithIndex = function(O) {
    var reduceRightWithIndexO = $aa3904b18ac0db4d$var$reduceRightWithIndex(O);
    return function(fa, b, f) {
        return (0, $3abDJ.pipe)(fa, reduceRightWithIndexO(b, f));
    };
};
module.exports._reduceRightWithIndex = $aa3904b18ac0db4d$var$_reduceRightWithIndex;
/** @internal */ /* istanbul ignore next */ var $aa3904b18ac0db4d$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, $aa3904b18ac0db4d$var$partitionMapWithIndex(f));
};
module.exports._partitionMapWithIndex = $aa3904b18ac0db4d$var$_partitionMapWithIndex;
/** @internal */ /* istanbul ignore next */ var $aa3904b18ac0db4d$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $3abDJ.pipe)(fa, $aa3904b18ac0db4d$var$partitionWithIndex(predicateWithIndex));
};
module.exports._partitionWithIndex = $aa3904b18ac0db4d$var$_partitionWithIndex;
/** @internal */ /* istanbul ignore next */ var $aa3904b18ac0db4d$var$_filterMapWithIndex = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, $aa3904b18ac0db4d$var$filterMapWithIndex(f));
};
module.exports._filterMapWithIndex = $aa3904b18ac0db4d$var$_filterMapWithIndex;
/** @internal */ /* istanbul ignore next */ var $aa3904b18ac0db4d$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $3abDJ.pipe)(fa, $aa3904b18ac0db4d$var$filterWithIndex(predicateWithIndex));
};
module.exports._filterWithIndex = $aa3904b18ac0db4d$var$_filterWithIndex;
/** @internal */ var $aa3904b18ac0db4d$var$_traverse = function(O) {
    var traverseWithIndexO = $aa3904b18ac0db4d$var$_traverseWithIndex(O);
    return function(F) {
        var traverseWithIndexOF = traverseWithIndexO(F);
        return function(ta, f) {
            return traverseWithIndexOF(ta, (0, $3abDJ.flow)($3abDJ.SK, f));
        };
    };
};
module.exports._traverse = $aa3904b18ac0db4d$var$_traverse;
/** @internal */ var $aa3904b18ac0db4d$var$_sequence = function(O) {
    var traverseO = (0, module.exports._traverse)(O);
    return function(F) {
        var traverseOF = traverseO(F);
        return function(ta) {
            return traverseOF(ta, $3abDJ.identity);
        };
    };
};
module.exports._sequence = $aa3904b18ac0db4d$var$_sequence;
var $aa3904b18ac0db4d$var$_traverseWithIndex = function(O) {
    return function(F) {
        var keysO = $aa3904b18ac0db4d$var$keys_(O);
        return function(ta, f) {
            var ks = keysO(ta);
            if (ks.length === 0) return F.of(module.exports.empty);
            var fr = F.of({});
            var _loop_1 = function(key) {
                fr = F.ap(F.map(fr, function(r) {
                    return function(b) {
                        var _a;
                        return Object.assign({}, r, (_a = {}, _a[key] = b, _a));
                    };
                }), f(key, ta[key]));
            };
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                _loop_1(key);
            }
            return fr;
        };
    };
};
/**
 * Given a `Predicate`, it produces a new `ReadonlyRecord` keeping only the entries with a
 * value that satisfies the provided predicate.
 *
 * @example
 * import { filter } from "fp-ts/ReadonlyRecord"
 *
 * assert.deepStrictEqual(filter((s: string) => s.length < 4)({ a: "foo", b: "bar", c: "verylong" }), {
 *   a: "foo",
 *   b: "bar",
 * });
 *
 * @category filtering
 * @since 2.5.0
 */ var $aa3904b18ac0db4d$var$filter = function(predicate) {
    return $aa3904b18ac0db4d$var$filterWithIndex(function(_, a) {
        return predicate(a);
    });
};
module.exports.filter = $aa3904b18ac0db4d$var$filter;
/**
 * Maps a `ReadonlyRecord` with an iterating function that returns an `Option`
 * and it keeps only the `Some` values discarding the `None`s.
 *
 * @example
 * import { filterMap } from "fp-ts/ReadonlyRecord"
 * import { option } from "fp-ts"
 *
 * const f = (s: string) => s.length < 4 ? option.some(`${s} is short`): option.none
 * assert.deepStrictEqual(filterMap(f)({ a: "foo", b: "bar", c: "verylong" }), {
 *   a: "foo is short",
 *   b: "bar is short",
 * });
 *
 * @category filtering
 * @since 2.5.0
 */ var $aa3904b18ac0db4d$var$filterMap = function(f) {
    return $aa3904b18ac0db4d$var$filterMapWithIndex(function(_, a) {
        return f(a);
    });
};
module.exports.filterMap = $aa3904b18ac0db4d$var$filterMap;
/**
 * Partition a `ReadonlyRecord` into two parts according to a `Predicate`.
 *
 * @example
 * import { partition } from "fp-ts/ReadonlyRecord"
 *
 * assert.deepStrictEqual(partition((s: string) => s.length < 4)({ a: "foo", b: "bar", c: "verylong" }), {
 *   left:{
 *     c: "verylong"
 *   },
 *   right: {
 *     a: "foo",
 *     b: "bar",
 *   },
 * });
 *
 * @category filtering
 * @since 2.5.0
 */ var $aa3904b18ac0db4d$var$partition = function(predicate) {
    return $aa3904b18ac0db4d$var$partitionWithIndex(function(_, a) {
        return predicate(a);
    });
};
module.exports.partition = $aa3904b18ac0db4d$var$partition;
/**
 * Maps a `ReadonlyRecord` with a function returning an `Either` and
 * partitions the resulting `ReadonlyRecord` into `Left`s and `Right`s.
 *
 * @example
 * import { partitionMap } from "fp-ts/ReadonlyRecord"
 * import { either } from "fp-ts"
 *
 * const f = (s: string) => (s.length < 4 ? either.right(`${s} is short`) : either.left(`${s} is not short`));
 * assert.deepStrictEqual(partitionMap(f)({ a: "foo", b: "bar", c: "verylong" }), {
 *   left: {
 *     c: "verylong is not short",
 *   },
 *   right: {
 *     a: "foo is short",
 *     b: "bar is short",
 *   },
 * });
 *
 * @category filtering
 * @since 2.5.0
 */ var $aa3904b18ac0db4d$var$partitionMap = function(f) {
    return $aa3904b18ac0db4d$var$partitionMapWithIndex(function(_, a) {
        return f(a);
    });
};
module.exports.partitionMap = $aa3904b18ac0db4d$var$partitionMap;
function $aa3904b18ac0db4d$var$reduce() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceWithIndexO_1 = $aa3904b18ac0db4d$var$reduceWithIndex(args[0]);
        return function(b, f) {
            return reduceWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $aa3904b18ac0db4d$var$reduce($aa3904b18ac0db4d$var$S.Ord).apply(void 0, args);
}
function $aa3904b18ac0db4d$var$foldMap(O) {
    if ('compare' in O) {
        var foldMapWithIndexO_1 = $aa3904b18ac0db4d$var$foldMapWithIndex(O);
        return function(M) {
            var foldMapWithIndexM = foldMapWithIndexO_1(M);
            return function(f) {
                return foldMapWithIndexM(function(_, a) {
                    return f(a);
                });
            };
        };
    }
    return $aa3904b18ac0db4d$var$foldMap($aa3904b18ac0db4d$var$S.Ord)(O);
}
function $aa3904b18ac0db4d$var$reduceRight() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceRightWithIndexO_1 = $aa3904b18ac0db4d$var$reduceRightWithIndex(args[0]);
        return function(b, f) {
            return reduceRightWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $aa3904b18ac0db4d$var$reduceRight($aa3904b18ac0db4d$var$S.Ord).apply(void 0, args);
}
/**
 * Compact a `ReadonlyRecord` of `Option`s discarding the `None` values and
 * keeping the `Some` values.
 *
 * @example
 * import { compact } from 'fp-ts/ReadonlyRecord'
 * import { option } from 'fp-ts'
 *
 * assert.deepStrictEqual(compact({ a: option.some("foo"), b: option.none, c: option.some("bar") }), {
 *   a: "foo",
 *   c: "bar",
 * });
 *
 * @category filtering
 * @since 2.5.0
 */ var $aa3904b18ac0db4d$var$compact = function(r) {
    var out = {};
    for(var k in r)if ($aa3904b18ac0db4d$var$_.has.call(r, k)) {
        var oa = r[k];
        if ($aa3904b18ac0db4d$var$_.isSome(oa)) out[k] = oa.value;
    }
    return out;
};
module.exports.compact = $aa3904b18ac0db4d$var$compact;
/**
 * Separate a `ReadonlyRecord` of `Either`s into `Left`s and `Right`s.
 *
 * @example
 * import { separate } from 'fp-ts/ReadonlyRecord'
 * import { either } from 'fp-ts'
 *
 * assert.deepStrictEqual(
 *   separate({ a: either.right("foo"), b: either.left("bar"), c: either.right("baz") }),
 *   {
 *     right: {
 *       a: "foo",
 *       c: "baz",
 *     },
 *     left: {
 *       b: "bar",
 *     },
 *   }
 * );
 *
 * @category filtering
 * @since 2.5.0
 */ var $aa3904b18ac0db4d$var$separate = function(r) {
    var left = {};
    var right = {};
    for(var k in r)if ($aa3904b18ac0db4d$var$_.has.call(r, k)) {
        var e = r[k];
        if ($aa3904b18ac0db4d$var$_.isLeft(e)) left[k] = e.left;
        else right[k] = e.right;
    }
    return (0, $fIQoU.separated)(left, right);
};
module.exports.separate = $aa3904b18ac0db4d$var$separate;
/**
 * @category type lambdas
 * @since 2.5.0
 */ module.exports.URI = 'ReadonlyRecord';
function $aa3904b18ac0db4d$var$getShow(O) {
    if ('compare' in O) return function(S) {
        return {
            show: function(r) {
                var elements = $aa3904b18ac0db4d$var$collect(O)(function(k, a) {
                    return "".concat(JSON.stringify(k), ": ").concat(S.show(a));
                })(r).join(', ');
                return elements === '' ? '{}' : "{ ".concat(elements, " }");
            }
        };
    };
    return $aa3904b18ac0db4d$var$getShow($aa3904b18ac0db4d$var$S.Ord)(O);
}
function $aa3904b18ac0db4d$var$getEq(E) {
    var isSubrecordE = $aa3904b18ac0db4d$var$isSubrecord(E);
    return (0, $5Ikl1.fromEquals)(function(x, y) {
        return isSubrecordE(x)(y) && isSubrecordE(y)(x);
    });
}
function $aa3904b18ac0db4d$var$getMonoid(S) {
    return {
        concat: function(first, second) {
            if ((0, module.exports.isEmpty)(first)) return second;
            if ((0, module.exports.isEmpty)(second)) return first;
            var r = Object.assign({}, first);
            for(var k in second)if ($aa3904b18ac0db4d$var$_.has.call(second, k)) r[k] = $aa3904b18ac0db4d$var$_.has.call(first, k) ? S.concat(first[k], second[k]) : second[k];
            return r;
        },
        empty: module.exports.empty
    };
}
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Functor = {
    URI: module.exports.URI,
    map: module.exports._map
};
/**
 * Takes a value and a `ReadonlyRecord` of functions and returns a
 * `ReadonlyRecord` by applying each function to the input value.
 *
 * @example
 * import { flap } from "fp-ts/ReadonlyRecord"
 *
 * const fab = { x: (n: number) => `${n} times 2`, y: (n: number) => `${n * 2}` };
 * assert.deepStrictEqual(flap(3)(fab), {
 *   x: "3 times 2",
 *   y: "6",
 * });
 *
 * @category mapping
 * @since 2.10.0
 */ module.exports.flap = (0, $emm1u.flap)(module.exports.Functor);
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.FunctorWithIndex = {
    URI: module.exports.URI,
    map: module.exports._map,
    mapWithIndex: module.exports._mapWithIndex
};
/**
 * Produces a `Foldable` instance for a `ReadonlyRecord`, using the
 * provided `Ord` to sort the `ReadonlyRecord`'s entries by key.
 *
 * @category folding
 * @since 2.11.0
 */ var $aa3904b18ac0db4d$var$getFoldable = function(O) {
    return {
        URI: module.exports.URI,
        reduce: (0, module.exports._reduce)(O),
        foldMap: (0, module.exports._foldMap)(O),
        reduceRight: (0, module.exports._reduceRight)(O)
    };
};
module.exports.getFoldable = $aa3904b18ac0db4d$var$getFoldable;
/**
 * Produces a `FoldableWithIndex1` instance for a `ReadonlyRecord`, using the
 * provided `Ord` to sort the `ReadonlyRecord`'s entries by key.
 *
 * @category folding
 * @since 2.11.0
 */ var $aa3904b18ac0db4d$var$getFoldableWithIndex = function(O) {
    return {
        URI: module.exports.URI,
        reduce: (0, module.exports._reduce)(O),
        foldMap: (0, module.exports._foldMap)(O),
        reduceRight: (0, module.exports._reduceRight)(O),
        reduceWithIndex: (0, module.exports._reduceWithIndex)(O),
        foldMapWithIndex: (0, module.exports._foldMapWithIndex)(O),
        reduceRightWithIndex: (0, module.exports._reduceRightWithIndex)(O)
    };
};
module.exports.getFoldableWithIndex = $aa3904b18ac0db4d$var$getFoldableWithIndex;
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Compactable = {
    URI: module.exports.URI,
    compact: module.exports.compact,
    separate: module.exports.separate
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Filterable = {
    URI: module.exports.URI,
    map: module.exports._map,
    compact: module.exports.compact,
    separate: module.exports.separate,
    filter: module.exports._filter,
    filterMap: module.exports._filterMap,
    partition: module.exports._partition,
    partitionMap: module.exports._partitionMap
};
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.FilterableWithIndex = {
    URI: module.exports.URI,
    map: module.exports._map,
    mapWithIndex: module.exports._mapWithIndex,
    compact: module.exports.compact,
    separate: module.exports.separate,
    filter: module.exports._filter,
    filterMap: module.exports._filterMap,
    partition: module.exports._partition,
    partitionMap: module.exports._partitionMap,
    filterMapWithIndex: module.exports._filterMapWithIndex,
    filterWithIndex: module.exports._filterWithIndex,
    partitionMapWithIndex: module.exports._partitionMapWithIndex,
    partitionWithIndex: module.exports._partitionWithIndex
};
/**
 * Produces a `Traversable` instance for a `ReadonlyRecord`, using the
 * provided `Ord` to sort the `ReadonlyRecord`'s entries by key.
 *
 * @category traversing
 * @since 2.11.0
 */ var $aa3904b18ac0db4d$var$getTraversable = function(O) {
    return {
        URI: module.exports.URI,
        map: module.exports._map,
        reduce: (0, module.exports._reduce)(O),
        foldMap: (0, module.exports._foldMap)(O),
        reduceRight: (0, module.exports._reduceRight)(O),
        traverse: (0, module.exports._traverse)(O),
        sequence: (0, module.exports._sequence)(O)
    };
};
module.exports.getTraversable = $aa3904b18ac0db4d$var$getTraversable;
/**
 * Produces a `TraversableWithIndex` instance for a `ReadonlyRecord`, using the
 * provided `Ord` to sort the `ReadonlyRecord`'s entries by key.
 *
 * @category traversing
 * @since 2.11.0
 */ var $aa3904b18ac0db4d$var$getTraversableWithIndex = function(O) {
    return {
        URI: module.exports.URI,
        map: module.exports._map,
        mapWithIndex: module.exports._mapWithIndex,
        reduce: (0, module.exports._reduce)(O),
        foldMap: (0, module.exports._foldMap)(O),
        reduceRight: (0, module.exports._reduceRight)(O),
        reduceWithIndex: (0, module.exports._reduceWithIndex)(O),
        foldMapWithIndex: (0, module.exports._foldMapWithIndex)(O),
        reduceRightWithIndex: (0, module.exports._reduceRightWithIndex)(O),
        traverse: (0, module.exports._traverse)(O),
        sequence: (0, module.exports._sequence)(O),
        traverseWithIndex: $aa3904b18ac0db4d$var$_traverseWithIndex(O)
    };
};
module.exports.getTraversableWithIndex = $aa3904b18ac0db4d$var$getTraversableWithIndex;
/**
 * @category filtering
 * @since 2.11.0
 */ var $aa3904b18ac0db4d$var$getWitherable = function(O) {
    var T = (0, module.exports.getTraversable)(O);
    return {
        URI: module.exports.URI,
        map: module.exports._map,
        reduce: (0, module.exports._reduce)(O),
        foldMap: (0, module.exports._foldMap)(O),
        reduceRight: (0, module.exports._reduceRight)(O),
        traverse: T.traverse,
        sequence: T.sequence,
        compact: module.exports.compact,
        separate: module.exports.separate,
        filter: module.exports._filter,
        filterMap: module.exports._filterMap,
        partition: module.exports._partition,
        partitionMap: module.exports._partitionMap,
        wither: (0, $4p4Yq.witherDefault)(T, module.exports.Compactable),
        wilt: (0, $4p4Yq.wiltDefault)(T, module.exports.Compactable)
    };
};
module.exports.getWitherable = $aa3904b18ac0db4d$var$getWitherable;
/**
 * Given a `Semigroup` in the base type, it produces a `Semigroup`
 * in the `ReadonlyRecord` of the base type.
 * The resulting `Semigroup` concatenates two `ReadonlyRecord`s by
 * `union`.
 *
 * @example
 * import { getUnionSemigroup, ReadonlyRecord } from "fp-ts/ReadonlyRecord"
 * import { Semigroup } from "fp-ts/Semigroup"
 *
 * const sNumber: Semigroup<number> = { concat: (x, y) => x - y };
 * const sReadonlyRecord: Semigroup<ReadonlyRecord<string, number>> = getUnionSemigroup(sNumber);
 * assert.deepStrictEqual(sReadonlyRecord.concat({ a: 1, b: 2 }, { b: 3, c: 4 }), { a: 1, b: -1, c: 4 });
 *
 * @category instances
 * @since 2.11.0
 */ var $aa3904b18ac0db4d$var$getUnionSemigroup = function(S) {
    var unionS = (0, module.exports.union)(S);
    return {
        concat: function(first, second) {
            return unionS(second)(first);
        }
    };
};
module.exports.getUnionSemigroup = $aa3904b18ac0db4d$var$getUnionSemigroup;
/**
 * Same as `getMonoid`.
 * Returns a `Monoid` instance for `ReadonlyRecord`s given a `Semigroup`
 * instance for the base type.
 * The `Monoid` makes the union of two `ReadonlyRecord`s combining the
 * entries that have the same key with the provided `Semigroup`.
 *
 * @example
 * import { SemigroupSum } from 'fp-ts/number'
 * import { getUnionMonoid } from 'fp-ts/ReadonlyRecord'
 *
 * const M = getUnionMonoid(SemigroupSum);
 * assert.deepStrictEqual(M.concat({ foo: 123, bar: 234 }, { foo: 456, baz: 567 }), { foo: 579 , bar: 234, baz: 567 });
 *
 * @category instances
 * @since 2.11.0
 */ var $aa3904b18ac0db4d$var$getUnionMonoid = function(S) {
    return {
        concat: (0, module.exports.getUnionSemigroup)(S).concat,
        empty: module.exports.empty
    };
};
module.exports.getUnionMonoid = $aa3904b18ac0db4d$var$getUnionMonoid;
/**
 * Given a `Semigroup` in the base type, it produces a `Semigroup`
 * in the `ReadonlyRecord` of the base type.
 * The resulting `Semigroup` concatenates two `ReadonlyRecord`s by
 * `intersection`.
 *
 * @example
 * import { getIntersectionSemigroup, ReadonlyRecord } from "fp-ts/ReadonlyRecord"
 * import { Semigroup } from "fp-ts/Semigroup"
 *
 * const sNumber: Semigroup<number> = { concat: (x, y) => x - y };
 * const sReadonlyRecord: Semigroup<ReadonlyRecord<string, number>> = getIntersectionSemigroup(sNumber);
 * assert.deepStrictEqual(sReadonlyRecord.concat({ a: 1, b: 2 }, { b: 3, c: 4 }), { b: -1 });
 *
 * @category instances
 * @since 2.11.0
 */ var $aa3904b18ac0db4d$var$getIntersectionSemigroup = function(S) {
    var intersectionS = (0, module.exports.intersection)(S);
    return {
        concat: function(first, second) {
            return intersectionS(second)(first);
        }
    };
};
module.exports.getIntersectionSemigroup = $aa3904b18ac0db4d$var$getIntersectionSemigroup;
/**
 * Produces a `Magma` with a `concat` function that combines
 * two `ReadonlyRecord`s by making the `difference`.
 *
 * @example
 * import { getDifferenceMagma, difference, ReadonlyRecord } from "fp-ts/ReadonlyRecord"
 * import { Magma } from "fp-ts/Magma"
 *
 * const r1 = { a: 3, c: 3 };
 * const r2 = { a: 1, b: 2 };
 * const m: Magma<ReadonlyRecord<string, number>> = getDifferenceMagma<number>();
 * assert.deepStrictEqual(m.concat(r1, r2), difference(r2)(r1));
 * assert.deepStrictEqual(m.concat(r1, r2), { c: 3, b: 2 });
 *
 * @category instances
 * @since 2.11.0
 */ var $aa3904b18ac0db4d$var$getDifferenceMagma = function() {
    return {
        concat: function(first, second) {
            return (0, module.exports.difference)(second)(first);
        }
    };
};
module.exports.getDifferenceMagma = $aa3904b18ac0db4d$var$getDifferenceMagma;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * Use `getFoldable` instead.
 *
 * @category zone of death
 * @since 2.7.0
 * @deprecated
 */ module.exports.Foldable = {
    URI: module.exports.URI,
    reduce: /*#__PURE__*/ (0, module.exports._reduce)($aa3904b18ac0db4d$var$S.Ord),
    foldMap: /*#__PURE__*/ (0, module.exports._foldMap)($aa3904b18ac0db4d$var$S.Ord),
    reduceRight: /*#__PURE__*/ (0, module.exports._reduceRight)($aa3904b18ac0db4d$var$S.Ord)
};
/**
 * Use `getFoldableWithIndex` instead.
 *
 * @category zone of death
 * @since 2.7.0
 * @deprecated
 */ module.exports.FoldableWithIndex = {
    URI: module.exports.URI,
    reduce: /*#__PURE__*/ (0, module.exports._reduce)($aa3904b18ac0db4d$var$S.Ord),
    foldMap: /*#__PURE__*/ (0, module.exports._foldMap)($aa3904b18ac0db4d$var$S.Ord),
    reduceRight: /*#__PURE__*/ (0, module.exports._reduceRight)($aa3904b18ac0db4d$var$S.Ord),
    reduceWithIndex: /*#__PURE__*/ (0, module.exports._reduceWithIndex)($aa3904b18ac0db4d$var$S.Ord),
    foldMapWithIndex: /*#__PURE__*/ (0, module.exports._foldMapWithIndex)($aa3904b18ac0db4d$var$S.Ord),
    reduceRightWithIndex: /*#__PURE__*/ (0, module.exports._reduceRightWithIndex)($aa3904b18ac0db4d$var$S.Ord)
};
/**
 * Use `getTraversable` instead.
 *
 * @category zone of death
 * @since 2.7.0
 * @deprecated
 */ module.exports.Traversable = {
    URI: module.exports.URI,
    map: module.exports._map,
    reduce: /*#__PURE__*/ (0, module.exports._reduce)($aa3904b18ac0db4d$var$S.Ord),
    foldMap: /*#__PURE__*/ (0, module.exports._foldMap)($aa3904b18ac0db4d$var$S.Ord),
    reduceRight: /*#__PURE__*/ (0, module.exports._reduceRight)($aa3904b18ac0db4d$var$S.Ord),
    traverse: /*#__PURE__*/ (0, module.exports._traverse)($aa3904b18ac0db4d$var$S.Ord),
    sequence: $aa3904b18ac0db4d$var$sequence
};
/**
 * Use `getTraversableWithIndex` instead.
 *
 * @category zone of death
 * @since 2.7.0
 * @deprecated
 */ module.exports.TraversableWithIndex = {
    URI: module.exports.URI,
    map: module.exports._map,
    mapWithIndex: module.exports._mapWithIndex,
    reduce: /*#__PURE__*/ (0, module.exports._reduce)($aa3904b18ac0db4d$var$S.Ord),
    foldMap: /*#__PURE__*/ (0, module.exports._foldMap)($aa3904b18ac0db4d$var$S.Ord),
    reduceRight: /*#__PURE__*/ (0, module.exports._reduceRight)($aa3904b18ac0db4d$var$S.Ord),
    reduceWithIndex: /*#__PURE__*/ (0, module.exports._reduceWithIndex)($aa3904b18ac0db4d$var$S.Ord),
    foldMapWithIndex: /*#__PURE__*/ (0, module.exports._foldMapWithIndex)($aa3904b18ac0db4d$var$S.Ord),
    reduceRightWithIndex: /*#__PURE__*/ (0, module.exports._reduceRightWithIndex)($aa3904b18ac0db4d$var$S.Ord),
    traverse: /*#__PURE__*/ (0, module.exports._traverse)($aa3904b18ac0db4d$var$S.Ord),
    sequence: $aa3904b18ac0db4d$var$sequence,
    traverseWithIndex: /*#__PURE__*/ $aa3904b18ac0db4d$var$_traverseWithIndex($aa3904b18ac0db4d$var$S.Ord)
};
var $aa3904b18ac0db4d$var$_wither = /*#__PURE__*/ (0, $4p4Yq.witherDefault)(module.exports.Traversable, module.exports.Compactable);
var $aa3904b18ac0db4d$var$_wilt = /*#__PURE__*/ (0, $4p4Yq.wiltDefault)(module.exports.Traversable, module.exports.Compactable);
/**
 * Use `getWitherable` instead.
 *
 * @category zone of death
 * @since 2.7.0
 * @deprecated
 */ module.exports.Witherable = {
    URI: module.exports.URI,
    map: module.exports._map,
    reduce: /*#__PURE__*/ (0, module.exports._reduce)($aa3904b18ac0db4d$var$S.Ord),
    foldMap: /*#__PURE__*/ (0, module.exports._foldMap)($aa3904b18ac0db4d$var$S.Ord),
    reduceRight: /*#__PURE__*/ (0, module.exports._reduceRight)($aa3904b18ac0db4d$var$S.Ord),
    traverse: /*#__PURE__*/ (0, module.exports._traverse)($aa3904b18ac0db4d$var$S.Ord),
    sequence: $aa3904b18ac0db4d$var$sequence,
    compact: module.exports.compact,
    separate: module.exports.separate,
    filter: module.exports._filter,
    filterMap: module.exports._filterMap,
    partition: module.exports._partition,
    partitionMap: module.exports._partitionMap,
    wither: $aa3904b18ac0db4d$var$_wither,
    wilt: $aa3904b18ac0db4d$var$_wilt
};
/**
 * Use [`upsertAt`](#upsertat) instead.
 *
 * @category zone of death
 * @since 2.5.0
 * @deprecated
 */ module.exports.insertAt = module.exports.upsertAt;
function $aa3904b18ac0db4d$var$hasOwnProperty(k, r) {
    return $aa3904b18ac0db4d$var$_.has.call(r === undefined ? this : r, k);
}
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Functor` instance, pass `RR.Functor` instead of `RR.readonlyRecord`
 * (where `RR` is from `import RR from 'fp-ts/ReadonlyRecord'`)
 *
 * @category zone of death
 * @since 2.5.0
 * @deprecated
 */ module.exports.readonlyRecord = {
    URI: module.exports.URI,
    map: module.exports._map,
    reduce: /*#__PURE__*/ (0, module.exports._reduce)($aa3904b18ac0db4d$var$S.Ord),
    foldMap: /*#__PURE__*/ (0, module.exports._foldMap)($aa3904b18ac0db4d$var$S.Ord),
    reduceRight: /*#__PURE__*/ (0, module.exports._reduceRight)($aa3904b18ac0db4d$var$S.Ord),
    traverse: /*#__PURE__*/ (0, module.exports._traverse)($aa3904b18ac0db4d$var$S.Ord),
    sequence: $aa3904b18ac0db4d$var$sequence,
    compact: module.exports.compact,
    separate: module.exports.separate,
    filter: module.exports._filter,
    filterMap: module.exports._filterMap,
    partition: module.exports._partition,
    partitionMap: module.exports._partitionMap,
    mapWithIndex: module.exports._mapWithIndex,
    reduceWithIndex: /*#__PURE__*/ (0, module.exports._reduceWithIndex)($aa3904b18ac0db4d$var$S.Ord),
    foldMapWithIndex: /*#__PURE__*/ (0, module.exports._foldMapWithIndex)($aa3904b18ac0db4d$var$S.Ord),
    reduceRightWithIndex: /*#__PURE__*/ (0, module.exports._reduceRightWithIndex)($aa3904b18ac0db4d$var$S.Ord),
    filterMapWithIndex: module.exports._filterMapWithIndex,
    filterWithIndex: module.exports._filterWithIndex,
    partitionMapWithIndex: module.exports._partitionMapWithIndex,
    partitionWithIndex: module.exports._partitionWithIndex,
    traverseWithIndex: /*#__PURE__*/ $aa3904b18ac0db4d$var$_traverseWithIndex($aa3904b18ac0db4d$var$S.Ord),
    wither: $aa3904b18ac0db4d$var$_wither,
    wilt: $aa3904b18ac0db4d$var$_wilt
};

});
parcelRegister("a1nAP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.endsWith = module.exports.startsWith = module.exports.includes = module.exports.split = module.exports.size = module.exports.isEmpty = module.exports.slice = module.exports.trimRight = module.exports.trimLeft = module.exports.trim = module.exports.replace = module.exports.toLowerCase = module.exports.toUpperCase = module.exports.isString = module.exports.Show = module.exports.Ord = module.exports.Monoid = module.exports.empty = module.exports.Semigroup = module.exports.Eq = void 0;

var $bKKbt = parcelRequire("bKKbt");
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @example
 * import * as S from 'fp-ts/string'
 *
 * assert.deepStrictEqual(S.Eq.equals('a', 'a'), true)
 * assert.deepStrictEqual(S.Eq.equals('a', 'b'), false)
 *
 * @category instances
 * @since 2.10.0
 */ module.exports.Eq = {
    equals: function(first, second) {
        return first === second;
    }
};
/**
 * `string` semigroup under concatenation.
 *
 * @example
 * import * as S from 'fp-ts/string'
 *
 * assert.deepStrictEqual(S.Semigroup.concat('a', 'b'), 'ab')
 *
 * @category instances
 * @since 2.10.0
 */ module.exports.Semigroup = {
    concat: function(first, second) {
        return first + second;
    }
};
/**
 * An empty `string`.
 *
 * @since 2.10.0
 */ module.exports.empty = '';
/**
 * `string` monoid under concatenation.
 *
 * The `empty` value is `''`.
 *
 * @example
 * import * as S from 'fp-ts/string'
 *
 * assert.deepStrictEqual(S.Monoid.concat('a', 'b'), 'ab')
 * assert.deepStrictEqual(S.Monoid.concat('a', S.Monoid.empty), 'a')
 *
 * @category instances
 * @since 2.10.0
 */ module.exports.Monoid = {
    concat: module.exports.Semigroup.concat,
    empty: module.exports.empty
};
/**
 * @example
 * import * as S from 'fp-ts/string'
 *
 * assert.deepStrictEqual(S.Ord.compare('a', 'a'), 0)
 * assert.deepStrictEqual(S.Ord.compare('a', 'b'), -1)
 * assert.deepStrictEqual(S.Ord.compare('b', 'a'), 1)
 *
 * @category instances
 * @since 2.10.0
 */ module.exports.Ord = {
    equals: module.exports.Eq.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
/**
 * @example
 * import * as S from 'fp-ts/string'
 *
 * assert.deepStrictEqual(S.Show.show('a'), '"a"')
 *
 * @category instances
 * @since 2.10.0
 */ module.exports.Show = {
    show: function(s) {
        return JSON.stringify(s);
    }
};
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * @example
 * import * as S from 'fp-ts/string'
 *
 * assert.deepStrictEqual(S.isString('a'), true)
 * assert.deepStrictEqual(S.isString(1), false)
 *
 * @category refinements
 * @since 2.11.0
 */ var $74bc4c73e0dee4a0$var$isString = function(u) {
    return typeof u === 'string';
};
module.exports.isString = $74bc4c73e0dee4a0$var$isString;
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @example
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe('a', S.toUpperCase), 'A')
 *
 * @since 2.11.0
 */ var $74bc4c73e0dee4a0$var$toUpperCase = function(s) {
    return s.toUpperCase();
};
module.exports.toUpperCase = $74bc4c73e0dee4a0$var$toUpperCase;
/**
 * @example
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe('A', S.toLowerCase), 'a')
 *
 * @since 2.11.0
 */ var $74bc4c73e0dee4a0$var$toLowerCase = function(s) {
    return s.toLowerCase();
};
module.exports.toLowerCase = $74bc4c73e0dee4a0$var$toLowerCase;
/**
 * @example
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe('abc', S.replace('b', 'd')), 'adc')
 *
 * @since 2.11.0
 */ var $74bc4c73e0dee4a0$var$replace = function(searchValue, replaceValue) {
    return function(s) {
        return s.replace(searchValue, replaceValue);
    };
};
module.exports.replace = $74bc4c73e0dee4a0$var$replace;
/**
 * @example
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe(' a ', S.trim), 'a')
 *
 * @since 2.11.0
 */ var $74bc4c73e0dee4a0$var$trim = function(s) {
    return s.trim();
};
module.exports.trim = $74bc4c73e0dee4a0$var$trim;
/**
 * @example
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe(' a ', S.trimLeft), 'a ')
 *
 * @since 2.11.0
 */ var $74bc4c73e0dee4a0$var$trimLeft = function(s) {
    return s.trimLeft();
};
module.exports.trimLeft = $74bc4c73e0dee4a0$var$trimLeft;
/**
 * @example
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe(' a ', S.trimRight), ' a')
 *
 * @since 2.11.0
 */ var $74bc4c73e0dee4a0$var$trimRight = function(s) {
    return s.trimRight();
};
module.exports.trimRight = $74bc4c73e0dee4a0$var$trimRight;
/**
 * @example
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe('abcd', S.slice(1, 3)), 'bc')
 *
 * @since 2.11.0
 */ var $74bc4c73e0dee4a0$var$slice = function(start, end) {
    return function(s) {
        return s.slice(start, end);
    };
};
module.exports.slice = $74bc4c73e0dee4a0$var$slice;
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Test whether a `string` is empty.
 *
 * @example
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe('', S.isEmpty), true)
 * assert.deepStrictEqual(pipe('a', S.isEmpty), false)
 *
 * @since 2.10.0
 */ var $74bc4c73e0dee4a0$var$isEmpty = function(s) {
    return s.length === 0;
};
module.exports.isEmpty = $74bc4c73e0dee4a0$var$isEmpty;
/**
 * Calculate the number of characters in a `string`.
 *
 * @example
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe('abc', S.size), 3)
 *
 * @since 2.10.0
 */ var $74bc4c73e0dee4a0$var$size = function(s) {
    return s.length;
};
module.exports.size = $74bc4c73e0dee4a0$var$size;
/**
 * @example
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe('abc', S.split('')), ['a', 'b', 'c'])
 * assert.deepStrictEqual(pipe('', S.split('')), [''])
 *
 * @since 2.11.0
 */ var $74bc4c73e0dee4a0$var$split = function(separator) {
    return function(s) {
        var out = s.split(separator);
        return (0, $bKKbt.isNonEmpty)(out) ? out : [
            s
        ];
    };
};
module.exports.split = $74bc4c73e0dee4a0$var$split;
/**
 * @example
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe('abc', S.includes('b')), true)
 * assert.deepStrictEqual(pipe('abc', S.includes('d')), false)
 *
 * @since 2.11.0
 */ var $74bc4c73e0dee4a0$var$includes = function(searchString, position) {
    return function(s) {
        return s.includes(searchString, position);
    };
};
module.exports.includes = $74bc4c73e0dee4a0$var$includes;
/**
 * @example
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe('abc', S.startsWith('a')), true)
 * assert.deepStrictEqual(pipe('bc', S.startsWith('a')), false)
 *
 * @since 2.11.0
 */ var $74bc4c73e0dee4a0$var$startsWith = function(searchString, position) {
    return function(s) {
        return s.startsWith(searchString, position);
    };
};
module.exports.startsWith = $74bc4c73e0dee4a0$var$startsWith;
/**
 * @example
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe('abc', S.endsWith('c')), true)
 * assert.deepStrictEqual(pipe('ab', S.endsWith('c')), false)
 *
 * @since 2.11.0
 */ var $74bc4c73e0dee4a0$var$endsWith = function(searchString, position) {
    return function(s) {
        return s.endsWith(searchString, position);
    };
};
module.exports.endsWith = $74bc4c73e0dee4a0$var$endsWith;

});




parcelRegister("gAqOT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Category = module.exports.Semigroupoid = module.exports.Invariant = module.exports.URI = module.exports.imap = module.exports.findFirstNonEmpty = module.exports.findFirst = module.exports.traverse = module.exports.left = module.exports.right = module.exports.some = module.exports.atKey = module.exports.key = module.exports.indexNonEmpty = module.exports.index = module.exports.component = module.exports.props = module.exports.prop = module.exports.filter = module.exports.fromNullable = module.exports.modifyF = module.exports.modify = module.exports.reverse = module.exports.composeTraversal = module.exports.composeOptional = module.exports.composePrism = module.exports.composeLens = module.exports.composeIso = module.exports.compose = module.exports.asTraversal = module.exports.asOptional = module.exports.asPrism = module.exports.asLens = module.exports.id = module.exports.iso = void 0;

var $3abDJ = parcelRequire("3abDJ");

var $e64KP = parcelRequire("e64KP");

var $azsim = parcelRequire("azsim");
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.3.8
 */ module.exports.iso = $azsim.iso;
/**
 * @category constructors
 * @since 2.3.0
 */ var $c134cffed030288a$var$id = function() {
    return (0, module.exports.iso)($3abDJ.identity, $3abDJ.identity);
};
module.exports.id = $c134cffed030288a$var$id;
// -------------------------------------------------------------------------------------
// converters
// -------------------------------------------------------------------------------------
/**
 * View an `Iso` as a `Lens`.
 *
 * @category converters
 * @since 2.3.0
 */ module.exports.asLens = $azsim.isoAsLens;
/**
 * View an `Iso` as a `Prism`.
 *
 * @category converters
 * @since 2.3.0
 */ module.exports.asPrism = $azsim.isoAsPrism;
/**
 * View an `Iso` as a `Optional`.
 *
 * @category converters
 * @since 2.3.0
 */ module.exports.asOptional = $azsim.isoAsOptional;
/**
 * View an `Iso` as a `Traversal`.
 *
 * @category converters
 * @since 2.3.0
 */ module.exports.asTraversal = $azsim.isoAsTraversal;
// -------------------------------------------------------------------------------------
// compositions
// -------------------------------------------------------------------------------------
/**
 * Compose an `Iso` with an `Iso`.
 *
 * @category compositions
 * @since 2.3.0
 */ var $c134cffed030288a$var$compose = function(ab) {
    return function(sa) {
        return (0, module.exports.iso)((0, $3abDJ.flow)(sa.get, ab.get), (0, $3abDJ.flow)(ab.reverseGet, sa.reverseGet));
    };
};
module.exports.compose = $c134cffed030288a$var$compose;
/**
 * Alias of `compose`.
 *
 * @category compositions
 * @since 2.3.8
 */ module.exports.composeIso = module.exports.compose;
/**
 * Compose an `Iso` with a `Lens`.
 *
 * @category compositions
 * @since 2.3.8
 */ var $c134cffed030288a$var$composeLens = function(ab) {
    return (0, $3abDJ.flow)(module.exports.asLens, $azsim.lensComposeLens(ab));
};
module.exports.composeLens = $c134cffed030288a$var$composeLens;
/**
 * Compose an `Iso` with a `Prism`.
 *
 * @category compositions
 * @since 2.3.8
 */ var $c134cffed030288a$var$composePrism = function(ab) {
    return (0, $3abDJ.flow)(module.exports.asPrism, $azsim.prismComposePrism(ab));
};
module.exports.composePrism = $c134cffed030288a$var$composePrism;
/**
 * Compose an `Iso` with a `Optional`.
 *
 * @category compositions
 * @since 2.3.8
 */ var $c134cffed030288a$var$composeOptional = function(ab) {
    return (0, $3abDJ.flow)(module.exports.asOptional, $azsim.optionalComposeOptional(ab));
};
module.exports.composeOptional = $c134cffed030288a$var$composeOptional;
/**
 * Compose an `Iso` with a `Traversal`.
 *
 * @category compositions
 * @since 2.3.8
 */ var $c134cffed030288a$var$composeTraversal = function(ab) {
    return (0, $3abDJ.flow)(module.exports.asTraversal, $azsim.traversalComposeTraversal(ab));
};
module.exports.composeTraversal = $c134cffed030288a$var$composeTraversal;
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.3.0
 */ var $c134cffed030288a$var$reverse = function(sa) {
    return (0, module.exports.iso)(sa.reverseGet, sa.get);
};
module.exports.reverse = $c134cffed030288a$var$reverse;
/**
 * @category combinators
 * @since 2.3.0
 */ var $c134cffed030288a$var$modify = function(f) {
    return function(sa) {
        return function(s) {
            return sa.reverseGet(f(sa.get(s)));
        };
    };
};
module.exports.modify = $c134cffed030288a$var$modify;
function $c134cffed030288a$var$modifyF(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $e64KP.pipe)(sa.get(s), f, function(fa) {
                    return F.map(fa, sa.reverseGet);
                });
            };
        };
    };
}
module.exports.modifyF = $c134cffed030288a$var$modifyF;
/**
 * Return a `Prism` from a `Iso` focused on a nullable value.
 *
 * @category combinators
 * @since 2.3.8
 */ var $c134cffed030288a$var$fromNullable = function(sa) {
    return (0, module.exports.composePrism)($azsim.prismFromNullable())(sa);
};
module.exports.fromNullable = $c134cffed030288a$var$fromNullable;
function $c134cffed030288a$var$filter(predicate) {
    return (0, module.exports.composePrism)($azsim.prismFromPredicate(predicate));
}
module.exports.filter = $c134cffed030288a$var$filter;
/**
 * Return a `Lens` from a `Iso` and a prop.
 *
 * @category combinators
 * @since 2.3.8
 */ var $c134cffed030288a$var$prop = function(prop) {
    return (0, $3abDJ.flow)(module.exports.asLens, $azsim.lensProp(prop));
};
module.exports.prop = $c134cffed030288a$var$prop;
/**
 * Return a `Lens` from a `Iso` and a list of props.
 *
 * @category combinators
 * @since 2.3.8
 */ var $c134cffed030288a$var$props = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return (0, $3abDJ.flow)(module.exports.asLens, $azsim.lensProps.apply($azsim, props));
};
module.exports.props = $c134cffed030288a$var$props;
/**
 * Return a `Lens` from a `Iso` focused on a component of a tuple.
 *
 * @category combinators
 * @since 2.3.8
 */ var $c134cffed030288a$var$component = function(prop) {
    return (0, $3abDJ.flow)(module.exports.asLens, $azsim.lensComponent(prop));
};
module.exports.component = $c134cffed030288a$var$component;
/**
 * Return a `Optional` from a `Iso` focused on an index of a `ReadonlyArray`.
 *
 * @category combinators
 * @since 2.3.8
 */ var $c134cffed030288a$var$index = function(i) {
    return (0, $3abDJ.flow)(module.exports.asOptional, $azsim.optionalIndex(i));
};
module.exports.index = $c134cffed030288a$var$index;
/**
 * Return a `Optional` from a `Iso` focused on an index of a `ReadonlyNonEmptyArray`.
 *
 * @category combinators
 * @since 2.3.8
 */ var $c134cffed030288a$var$indexNonEmpty = function(i) {
    return (0, $3abDJ.flow)(module.exports.asOptional, $azsim.optionalIndexNonEmpty(i));
};
module.exports.indexNonEmpty = $c134cffed030288a$var$indexNonEmpty;
/**
 * Return a `Optional` from a `Iso` focused on a key of a `ReadonlyRecord`.
 *
 * @category combinators
 * @since 2.3.8
 */ var $c134cffed030288a$var$key = function(key) {
    return (0, $3abDJ.flow)(module.exports.asOptional, $azsim.optionalKey(key));
};
module.exports.key = $c134cffed030288a$var$key;
/**
 * Return a `Lens` from a `Iso` focused on a required key of a `ReadonlyRecord`.
 *
 * @category combinators
 * @since 2.3.8
 */ var $c134cffed030288a$var$atKey = function(key) {
    return (0, $3abDJ.flow)(module.exports.asLens, $azsim.lensAtKey(key));
};
module.exports.atKey = $c134cffed030288a$var$atKey;
/**
 * Return a `Prism` from a `Iso` focused on the `Some` of a `Option` type.
 *
 * @category combinators
 * @since 2.3.8
 */ module.exports.some = /*#__PURE__*/ (0, module.exports.composePrism)(/*#__PURE__*/ $azsim.prismSome());
/**
 * Return a `Prism` from a `Iso` focused on the `Right` of a `Either` type.
 *
 * @category combinators
 * @since 2.3.8
 */ module.exports.right = /*#__PURE__*/ (0, module.exports.composePrism)(/*#__PURE__*/ $azsim.prismRight());
/**
 * Return a `Prism` from a `Iso` focused on the `Left` of a `Either` type.
 *
 * @category combinators
 * @since 2.3.8
 */ module.exports.left = /*#__PURE__*/ (0, module.exports.composePrism)(/*#__PURE__*/ $azsim.prismLeft());
/**
 * Return a `Traversal` from a `Iso` focused on a `Traversable`.
 *
 * @category combinators
 * @since 2.3.8
 */ function $c134cffed030288a$var$traverse(T) {
    return (0, $3abDJ.flow)(module.exports.asTraversal, $azsim.traversalTraverse(T));
}
module.exports.traverse = $c134cffed030288a$var$traverse;
function $c134cffed030288a$var$findFirst(predicate) {
    return (0, module.exports.composeOptional)($azsim.optionalFindFirst(predicate));
}
module.exports.findFirst = $c134cffed030288a$var$findFirst;
function $c134cffed030288a$var$findFirstNonEmpty(predicate) {
    return (0, module.exports.composeOptional)($azsim.optionalFindFirstNonEmpty(predicate));
}
module.exports.findFirstNonEmpty = $c134cffed030288a$var$findFirstNonEmpty;
// -------------------------------------------------------------------------------------
// pipeables
// -------------------------------------------------------------------------------------
/**
 * @category Invariant
 * @since 2.3.0
 */ var $c134cffed030288a$var$imap = function(f, g) {
    return function(ea) {
        return $c134cffed030288a$var$imap_(ea, f, g);
    };
};
module.exports.imap = $c134cffed030288a$var$imap;
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $c134cffed030288a$var$imap_ = function(ea, ab, ba) {
    return (0, module.exports.iso)((0, $3abDJ.flow)(ea.get, ab), (0, $3abDJ.flow)(ba, ea.reverseGet));
};
/**
 * @category instances
 * @since 2.3.0
 */ module.exports.URI = 'monocle-ts/Iso';
/**
 * @category instances
 * @since 2.3.0
 */ module.exports.Invariant = {
    URI: module.exports.URI,
    imap: $c134cffed030288a$var$imap_
};
/**
 * @category instances
 * @since 2.3.8
 */ module.exports.Semigroupoid = {
    URI: module.exports.URI,
    compose: function(ab, ea) {
        return (0, module.exports.compose)(ab)(ea);
    }
};
/**
 * @category instances
 * @since 2.3.0
 */ module.exports.Category = {
    URI: module.exports.URI,
    compose: module.exports.Semigroupoid.compose,
    id: module.exports.id
};

});

parcelRegister("6IlK1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.indexRecord = module.exports.indexArray = module.exports.indexReadonlyMap = module.exports.indexReadonlyRecord = module.exports.indexReadonlyNonEmptyArray = module.exports.indexReadonlyArray = module.exports.fromIso = module.exports.fromAt = module.exports.index = void 0;

var $hBXBN = parcelRequire("hBXBN");

var $e64KP = parcelRequire("e64KP");

var $azsim = parcelRequire("azsim");

var $5iJ4o = parcelRequire("5iJ4o");
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.3.8
 */ module.exports.index = $azsim.index;
/**
 * @category constructors
 * @since 2.3.0
 */ var $4e37b783357f26ce$var$fromAt = function(at) {
    return (0, module.exports.index)(function(i) {
        return $azsim.lensComposePrism($azsim.prismSome())(at.at(i));
    });
};
module.exports.fromAt = $4e37b783357f26ce$var$fromAt;
/**
 * Lift an instance of `Index` using an `Iso`.
 *
 * @category constructors
 * @since 2.3.0
 */ var $4e37b783357f26ce$var$fromIso = function(iso) {
    return function(sia) {
        return (0, module.exports.index)(function(i) {
            return (0, $e64KP.pipe)(iso, $azsim.isoAsOptional, $azsim.optionalComposeOptional(sia.index(i)));
        });
    };
};
module.exports.fromIso = $4e37b783357f26ce$var$fromIso;
/**
 * @category constructors
 * @since 2.3.7
 */ module.exports.indexReadonlyArray = $azsim.indexReadonlyArray;
/**
 * @category constructors
 * @since 2.3.8
 */ module.exports.indexReadonlyNonEmptyArray = $azsim.indexReadonlyNonEmptyArray;
/**
 * @category constructors
 * @since 2.3.7
 */ module.exports.indexReadonlyRecord = $azsim.indexReadonlyRecord;
/**
 * @category constructors
 * @since 2.3.7
 */ var $4e37b783357f26ce$var$indexReadonlyMap = function(E) {
    var lookupE = $5iJ4o.lookup(E);
    var insertAtE = $5iJ4o.insertAt(E);
    return function() {
        return (0, module.exports.index)(function(key) {
            return $azsim.optional(function(s) {
                return lookupE(key, s);
            }, function(next) {
                var insert = insertAtE(key, next);
                return function(s) {
                    return (0, $e64KP.pipe)(lookupE(key, s), $hBXBN.fold(function() {
                        return s;
                    }, function(prev) {
                        return next === prev ? s : insert(s);
                    }));
                };
            });
        });
    };
};
module.exports.indexReadonlyMap = $4e37b783357f26ce$var$indexReadonlyMap;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * Use `indexReadonlyArray` instead.
 *
 * @category constructors
 * @since 2.3.2
 * @deprecated
 */ module.exports.indexArray = $azsim.indexReadonlyArray;
/**
 * Use `indexReadonlyRecord` instead.
 *
 * @category constructors
 * @since 2.3.2
 * @deprecated
 */ module.exports.indexRecord = $azsim.indexReadonlyRecord;

});

parcelRegister("hD0qb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Category = module.exports.Semigroupoid = module.exports.Invariant = module.exports.URI = module.exports.imap = module.exports.findFirstNonEmpty = module.exports.findFirst = module.exports.traverse = module.exports.left = module.exports.right = module.exports.some = module.exports.atKey = module.exports.key = module.exports.indexNonEmpty = module.exports.index = module.exports.component = module.exports.props = module.exports.prop = module.exports.filter = module.exports.fromNullable = module.exports.modifyF = module.exports.modify = module.exports.composeTraversal = module.exports.composeOptional = module.exports.composePrism = module.exports.composeIso = module.exports.composeLens = module.exports.compose = module.exports.asTraversal = module.exports.asOptional = module.exports.id = module.exports.lens = void 0;

var $3abDJ = parcelRequire("3abDJ");

var $e64KP = parcelRequire("e64KP");

var $azsim = parcelRequire("azsim");
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.3.8
 */ module.exports.lens = $azsim.lens;
/**
 * @category constructors
 * @since 2.3.0
 */ module.exports.id = $azsim.lensId;
// -------------------------------------------------------------------------------------
// converters
// -------------------------------------------------------------------------------------
/**
 * View a `Lens` as a `Optional`.
 *
 * @category converters
 * @since 2.3.0
 */ module.exports.asOptional = $azsim.lensAsOptional;
/**
 * View a `Lens` as a `Traversal`.
 *
 * @category converters
 * @since 2.3.0
 */ module.exports.asTraversal = $azsim.lensAsTraversal;
// -------------------------------------------------------------------------------------
// compositions
// -------------------------------------------------------------------------------------
/**
 * Compose a `Lens` with a `Lens`.
 *
 * @category compositions
 * @since 2.3.0
 */ module.exports.compose = $azsim.lensComposeLens;
/**
 * Alias of `compose`.
 *
 * @category compositions
 * @since 2.3.8
 */ module.exports.composeLens = module.exports.compose;
/**
 * Compose a `Lens` with a `Iso`.
 *
 * @category compositions
 * @since 2.3.8
 */ module.exports.composeIso = /*#__PURE__*/ (0, $3abDJ.flow)($azsim.isoAsLens, module.exports.compose);
/**
 * Compose a `Lens` with a `Prism`.
 *
 * @category compositions
 * @since 2.3.0
 */ module.exports.composePrism = $azsim.lensComposePrism;
/**
 * Compose a `Lens` with an `Optional`.
 *
 * @category compositions
 * @since 2.3.0
 */ var $cd5667d9f49d43d6$var$composeOptional = function(ab) {
    return (0, $3abDJ.flow)(module.exports.asOptional, $azsim.optionalComposeOptional(ab));
};
module.exports.composeOptional = $cd5667d9f49d43d6$var$composeOptional;
/**
 * Compose a `Lens` with an `Traversal`.
 *
 * @category compositions
 * @since 2.3.8
 */ var $cd5667d9f49d43d6$var$composeTraversal = function(ab) {
    return (0, $3abDJ.flow)(module.exports.asTraversal, $azsim.traversalComposeTraversal(ab));
};
module.exports.composeTraversal = $cd5667d9f49d43d6$var$composeTraversal;
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @category combinators
 * @since 2.3.0
 */ var $cd5667d9f49d43d6$var$modify = function(f) {
    return function(sa) {
        return function(s) {
            var o = sa.get(s);
            var n = f(o);
            return o === n ? s : sa.set(n)(s);
        };
    };
};
module.exports.modify = $cd5667d9f49d43d6$var$modify;
function $cd5667d9f49d43d6$var$modifyF(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $e64KP.pipe)(sa.get(s), f, function(fa) {
                    return F.map(fa, function(a) {
                        return sa.set(a)(s);
                    });
                });
            };
        };
    };
}
module.exports.modifyF = $cd5667d9f49d43d6$var$modifyF;
/**
 * Return a `Optional` from a `Lens` focused on a nullable value.
 *
 * @category combinators
 * @since 2.3.0
 */ var $cd5667d9f49d43d6$var$fromNullable = function(sa) {
    return (0, module.exports.composePrism)($azsim.prismFromNullable())(sa);
};
module.exports.fromNullable = $cd5667d9f49d43d6$var$fromNullable;
function $cd5667d9f49d43d6$var$filter(predicate) {
    return (0, module.exports.composePrism)($azsim.prismFromPredicate(predicate));
}
module.exports.filter = $cd5667d9f49d43d6$var$filter;
/**
 * Return a `Lens` from a `Lens` and a prop.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.prop = $azsim.lensProp;
/**
 * Return a `Lens` from a `Lens` and a list of props.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.props = $azsim.lensProps;
/**
 * Return a `Lens` from a `Lens` focused on a component of a tuple.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.component = $azsim.lensComponent;
/**
 * Return a `Optional` from a `Lens` focused on an index of a `ReadonlyArray`.
 *
 * @category combinators
 * @since 2.3.0
 */ var $cd5667d9f49d43d6$var$index = function(i) {
    return (0, $3abDJ.flow)(module.exports.asOptional, $azsim.optionalIndex(i));
};
module.exports.index = $cd5667d9f49d43d6$var$index;
/**
 * Return a `Optional` from a `Lens` focused on an index of a `ReadonlyNonEmptyArray`.
 *
 * @category combinators
 * @since 2.3.8
 */ var $cd5667d9f49d43d6$var$indexNonEmpty = function(i) {
    return (0, $3abDJ.flow)(module.exports.asOptional, $azsim.optionalIndexNonEmpty(i));
};
module.exports.indexNonEmpty = $cd5667d9f49d43d6$var$indexNonEmpty;
/**
 * Return a `Optional` from a `Lens` focused on a key of a `ReadonlyRecord`.
 *
 * @category combinators
 * @since 2.3.0
 */ var $cd5667d9f49d43d6$var$key = function(key) {
    return (0, $3abDJ.flow)(module.exports.asOptional, $azsim.optionalKey(key));
};
module.exports.key = $cd5667d9f49d43d6$var$key;
/**
 * Return a `Lens` from a `Lens` focused on a required key of a `ReadonlyRecord`.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.atKey = $azsim.lensAtKey;
/**
 * Return a `Optional` from a `Lens` focused on the `Some` of a `Option` type.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.some = /*#__PURE__*/ (0, module.exports.composePrism)(/*#__PURE__*/ $azsim.prismSome());
/**
 * Return a `Optional` from a `Lens` focused on the `Right` of a `Either` type.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.right = /*#__PURE__*/ (0, module.exports.composePrism)(/*#__PURE__*/ $azsim.prismRight());
/**
 * Return a `Optional` from a `Lens` focused on the `Left` of a `Either` type.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.left = /*#__PURE__*/ (0, module.exports.composePrism)(/*#__PURE__*/ $azsim.prismLeft());
/**
 * Return a `Traversal` from a `Lens` focused on a `Traversable`.
 *
 * @category combinators
 * @since 2.3.0
 */ function $cd5667d9f49d43d6$var$traverse(T) {
    return (0, $3abDJ.flow)(module.exports.asTraversal, $azsim.traversalTraverse(T));
}
module.exports.traverse = $cd5667d9f49d43d6$var$traverse;
function $cd5667d9f49d43d6$var$findFirst(predicate) {
    return (0, module.exports.composeOptional)($azsim.optionalFindFirst(predicate));
}
module.exports.findFirst = $cd5667d9f49d43d6$var$findFirst;
function $cd5667d9f49d43d6$var$findFirstNonEmpty(predicate) {
    return (0, module.exports.composeOptional)($azsim.optionalFindFirstNonEmpty(predicate));
}
module.exports.findFirstNonEmpty = $cd5667d9f49d43d6$var$findFirstNonEmpty;
// -------------------------------------------------------------------------------------
// pipeables
// -------------------------------------------------------------------------------------
/**
 * @category Invariant
 * @since 2.3.0
 */ var $cd5667d9f49d43d6$var$imap = function(f, g) {
    return function(ea) {
        return $cd5667d9f49d43d6$var$imap_(ea, f, g);
    };
};
module.exports.imap = $cd5667d9f49d43d6$var$imap;
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $cd5667d9f49d43d6$var$imap_ = function(ea, ab, ba) {
    return (0, module.exports.lens)((0, $3abDJ.flow)(ea.get, ab), (0, $3abDJ.flow)(ba, ea.set));
};
/**
 * @category instances
 * @since 2.3.0
 */ module.exports.URI = 'monocle-ts/Lens';
/**
 * @category instances
 * @since 2.3.0
 */ module.exports.Invariant = {
    URI: module.exports.URI,
    imap: $cd5667d9f49d43d6$var$imap_
};
/**
 * @category instances
 * @since 2.3.8
 */ module.exports.Semigroupoid = {
    URI: module.exports.URI,
    compose: function(ab, ea) {
        return (0, module.exports.compose)(ab)(ea);
    }
};
/**
 * @category instances
 * @since 2.3.0
 */ module.exports.Category = {
    URI: module.exports.URI,
    compose: module.exports.Semigroupoid.compose,
    id: module.exports.id
};

});

parcelRegister("2xbaP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Category = module.exports.Semigroupoid = module.exports.Invariant = module.exports.URI = module.exports.imap = module.exports.findFirstNonEmpty = module.exports.findFirst = module.exports.traverse = module.exports.left = module.exports.right = module.exports.some = module.exports.atKey = module.exports.key = module.exports.indexNonEmpty = module.exports.index = module.exports.component = module.exports.props = module.exports.prop = module.exports.filter = module.exports.fromNullable = module.exports.modifyF = module.exports.modify = module.exports.setOption = module.exports.modifyOption = module.exports.composeTraversal = module.exports.composePrism = module.exports.composeLens = module.exports.composeIso = module.exports.composeOptional = module.exports.compose = module.exports.asTraversal = module.exports.id = module.exports.optional = void 0;

var $3abDJ = parcelRequire("3abDJ");

var $hBXBN = parcelRequire("hBXBN");

var $e64KP = parcelRequire("e64KP");

var $azsim = parcelRequire("azsim");
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.3.8
 */ module.exports.optional = $azsim.optional;
/**
 * @category constructors
 * @since 2.3.0
 */ var $1d8754ae6063b922$var$id = function() {
    return (0, module.exports.optional)($hBXBN.some, $3abDJ.constant);
};
module.exports.id = $1d8754ae6063b922$var$id;
// -------------------------------------------------------------------------------------
// converters
// -------------------------------------------------------------------------------------
/**
 * View a `Optional` as a `Traversal`.
 *
 * @category converters
 * @since 2.3.0
 */ module.exports.asTraversal = $azsim.optionalAsTraversal;
// -------------------------------------------------------------------------------------
// compositions
// -------------------------------------------------------------------------------------
/**
 * Compose a `Optional` with a `Optional`.
 *
 * @category compositions
 * @since 2.3.0
 */ module.exports.compose = $azsim.optionalComposeOptional;
/**
 * Alias of `compose`.
 *
 * @category compositions
 * @since 2.3.8
 */ module.exports.composeOptional = module.exports.compose;
/**
 * Compose a `Optional` with a `Iso`.
 *
 * @category compositions
 * @since 2.3.8
 */ module.exports.composeIso = /*#__PURE__*/ (0, $3abDJ.flow)($azsim.isoAsOptional, module.exports.compose);
/**
 * Compose a `Optional` with a `Lens`.
 *
 * @category compositions
 * @since 2.3.7
 */ module.exports.composeLens = /*#__PURE__*/ (0, $3abDJ.flow)($azsim.lensAsOptional, $azsim.optionalComposeOptional);
/**
 * Compose a `Optional` with a `Prism`.
 *
 * @category compositions
 * @since 2.3.7
 */ module.exports.composePrism = /*#__PURE__*/ (0, $3abDJ.flow)($azsim.prismAsOptional, $azsim.optionalComposeOptional);
/**
 * Compose a `Optional` with an `Traversal`.
 *
 * @category compositions
 * @since 2.3.8
 */ var $1d8754ae6063b922$var$composeTraversal = function(ab) {
    return (0, $3abDJ.flow)(module.exports.asTraversal, $azsim.traversalComposeTraversal(ab));
};
module.exports.composeTraversal = $1d8754ae6063b922$var$composeTraversal;
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @category combinators
 * @since 2.3.0
 */ module.exports.modifyOption = $azsim.optionalModifyOption;
/**
 * @category combinators
 * @since 2.3.7
 */ var $1d8754ae6063b922$var$setOption = function(a) {
    return (0, module.exports.modifyOption)(function() {
        return a;
    });
};
module.exports.setOption = $1d8754ae6063b922$var$setOption;
/**
 * @category combinators
 * @since 2.3.0
 */ module.exports.modify = $azsim.optionalModify;
function $1d8754ae6063b922$var$modifyF(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $e64KP.pipe)(sa.getOption(s), $hBXBN.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    };
}
module.exports.modifyF = $1d8754ae6063b922$var$modifyF;
/**
 * Return an `Optional` from a `Optional` focused on a nullable value.
 *
 * @category combinators
 * @since 2.3.3
 */ module.exports.fromNullable = /*#__PURE__*/ (0, module.exports.compose)(/*#__PURE__*/ $azsim.prismAsOptional(/*#__PURE__*/ $azsim.prismFromNullable()));
function $1d8754ae6063b922$var$filter(predicate) {
    return (0, module.exports.compose)($azsim.prismAsOptional($azsim.prismFromPredicate(predicate)));
}
module.exports.filter = $1d8754ae6063b922$var$filter;
/**
 * Return a `Optional` from a `Optional` and a prop.
 *
 * @category combinators
 * @since 2.3.0
 */ var $1d8754ae6063b922$var$prop = function(prop) {
    return (0, module.exports.compose)((0, $e64KP.pipe)($azsim.lensId(), $azsim.lensProp(prop), $azsim.lensAsOptional));
};
module.exports.prop = $1d8754ae6063b922$var$prop;
/**
 * Return a `Optional` from a `Optional` and a list of props.
 *
 * @category combinators
 * @since 2.3.0
 */ var $1d8754ae6063b922$var$props = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return (0, module.exports.compose)((0, $e64KP.pipe)($azsim.lensId(), $azsim.lensProps.apply($azsim, props), $azsim.lensAsOptional));
};
module.exports.props = $1d8754ae6063b922$var$props;
/**
 * Return a `Optional` from a `Optional` focused on a component of a tuple.
 *
 * @category combinators
 * @since 2.3.0
 */ var $1d8754ae6063b922$var$component = function(prop) {
    return (0, module.exports.compose)((0, $e64KP.pipe)($azsim.lensId(), $azsim.lensComponent(prop), $azsim.lensAsOptional));
};
module.exports.component = $1d8754ae6063b922$var$component;
/**
 * Return a `Optional` from a `Optional` focused on an index of a `ReadonlyArray`.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.index = $azsim.optionalIndex;
/**
 * Return a `Optional` from a `Optional` focused on an index of a `ReadonlyNonEmptyArray`.
 *
 * @category combinators
 * @since 2.3.8
 */ module.exports.indexNonEmpty = $azsim.optionalIndexNonEmpty;
/**
 * Return a `Optional` from a `Optional` focused on a key of a `ReadonlyRecord`.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.key = $azsim.optionalKey;
/**
 * Return a `Optional` from a `Optional` focused on a required key of a `ReadonlyRecord`.
 *
 * @category combinators
 * @since 2.3.0
 */ var $1d8754ae6063b922$var$atKey = function(key) {
    return function(sa) {
        return (0, $e64KP.pipe)(sa, (0, module.exports.compose)($azsim.lensAsOptional($azsim.atReadonlyRecord().at(key))));
    };
};
module.exports.atKey = $1d8754ae6063b922$var$atKey;
/**
 * Return a `Optional` from a `Optional` focused on the `Some` of a `Option` type.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.some = /*#__PURE__*/ (0, module.exports.compose)(/*#__PURE__*/ $azsim.prismAsOptional(/*#__PURE__*/ $azsim.prismSome()));
/**
 * Return a `Optional` from a `Optional` focused on the `Right` of a `Either` type.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.right = /*#__PURE__*/ (0, module.exports.compose)(/*#__PURE__*/ $azsim.prismAsOptional(/*#__PURE__*/ $azsim.prismRight()));
/**
 * Return a `Optional` from a `Optional` focused on the `Left` of a `Either` type.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.left = /*#__PURE__*/ (0, module.exports.compose)(/*#__PURE__*/ $azsim.prismAsOptional(/*#__PURE__*/ $azsim.prismLeft()));
/**
 * Return a `Traversal` from a `Optional` focused on a `Traversable`.
 *
 * @category combinators
 * @since 2.3.0
 */ function $1d8754ae6063b922$var$traverse(T) {
    return (0, $3abDJ.flow)(module.exports.asTraversal, $azsim.traversalTraverse(T));
}
module.exports.traverse = $1d8754ae6063b922$var$traverse;
function $1d8754ae6063b922$var$findFirst(predicate) {
    return (0, module.exports.compose)($azsim.optionalFindFirst(predicate));
}
module.exports.findFirst = $1d8754ae6063b922$var$findFirst;
function $1d8754ae6063b922$var$findFirstNonEmpty(predicate) {
    return (0, module.exports.compose)($azsim.optionalFindFirstNonEmpty(predicate));
}
module.exports.findFirstNonEmpty = $1d8754ae6063b922$var$findFirstNonEmpty;
// -------------------------------------------------------------------------------------
// pipeables
// -------------------------------------------------------------------------------------
/**
 * @category Invariant
 * @since 2.3.0
 */ var $1d8754ae6063b922$var$imap = function(f, g) {
    return function(ea) {
        return $1d8754ae6063b922$var$imap_(ea, f, g);
    };
};
module.exports.imap = $1d8754ae6063b922$var$imap;
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $1d8754ae6063b922$var$imap_ = function(ea, ab, ba) {
    return (0, module.exports.optional)((0, $3abDJ.flow)(ea.getOption, $hBXBN.map(ab)), (0, $3abDJ.flow)(ba, ea.set));
};
/**
 * @category instances
 * @since 2.3.0
 */ module.exports.URI = 'monocle-ts/Optional';
/**
 * @category instances
 * @since 2.3.0
 */ module.exports.Invariant = {
    URI: module.exports.URI,
    imap: $1d8754ae6063b922$var$imap_
};
/**
 * @category instances
 * @since 2.3.8
 */ module.exports.Semigroupoid = {
    URI: module.exports.URI,
    compose: function(ab, ea) {
        return (0, module.exports.compose)(ab)(ea);
    }
};
/**
 * @category instances
 * @since 2.3.0
 */ module.exports.Category = {
    URI: module.exports.URI,
    compose: module.exports.Semigroupoid.compose,
    id: module.exports.id
};

});

parcelRegister("14R6c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Category = module.exports.Semigroupoid = module.exports.Invariant = module.exports.URI = module.exports.imap = module.exports.findFirstNonEmpty = module.exports.findFirst = module.exports.traverse = module.exports.left = module.exports.right = module.exports.some = module.exports.atKey = module.exports.key = module.exports.indexNonEmpty = module.exports.index = module.exports.component = module.exports.props = module.exports.prop = module.exports.filter = module.exports.fromNullable = module.exports.modifyF = module.exports.modify = module.exports.modifyOption = module.exports.set = module.exports.composeTraversal = module.exports.composeOptional = module.exports.composeLens = module.exports.composeIso = module.exports.composePrism = module.exports.compose = module.exports.asTraversal = module.exports.asOptional = module.exports.fromPredicate = module.exports.id = module.exports.prism = void 0;

var $3abDJ = parcelRequire("3abDJ");

var $hBXBN = parcelRequire("hBXBN");

var $e64KP = parcelRequire("e64KP");

var $azsim = parcelRequire("azsim");
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.3.8
 */ module.exports.prism = $azsim.prism;
/**
 * @category constructors
 * @since 2.3.0
 */ var $0c8f5a8b277a7780$var$id = function() {
    return (0, module.exports.prism)($hBXBN.some, $3abDJ.identity);
};
module.exports.id = $0c8f5a8b277a7780$var$id;
/**
 * @category constructors
 * @since 2.3.0
 */ module.exports.fromPredicate = $azsim.prismFromPredicate;
// -------------------------------------------------------------------------------------
// converters
// -------------------------------------------------------------------------------------
/**
 * View a `Prism` as a `Optional`.
 *
 * @category converters
 * @since 2.3.0
 */ module.exports.asOptional = $azsim.prismAsOptional;
/**
 * View a `Prism` as a `Traversal`.
 *
 * @category converters
 * @since 2.3.0
 */ module.exports.asTraversal = $azsim.prismAsTraversal;
// -------------------------------------------------------------------------------------
// compositions
// -------------------------------------------------------------------------------------
/**
 * Compose a `Prism` with a `Prism`.
 *
 * @category compositions
 * @since 2.3.0
 */ module.exports.compose = $azsim.prismComposePrism;
/**
 * Alias of `compose`.
 *
 * @category compositions
 * @since 2.3.8
 */ module.exports.composePrism = module.exports.compose;
/**
 * Compose a `Prism` with a `Iso`.
 *
 * @category compositions
 * @since 2.3.8
 */ module.exports.composeIso = /*#__PURE__*/ (0, $3abDJ.flow)($azsim.isoAsPrism, module.exports.compose);
/**
 * Compose a `Prism` with a `Lens`.
 *
 * @category compositions
 * @since 2.3.0
 */ module.exports.composeLens = $azsim.prismComposeLens;
/**
 * Compose a `Prism` with an `Optional`.
 *
 * @category compositions
 * @since 2.3.0
 */ var $0c8f5a8b277a7780$var$composeOptional = function(ab) {
    return (0, $3abDJ.flow)(module.exports.asOptional, $azsim.optionalComposeOptional(ab));
};
module.exports.composeOptional = $0c8f5a8b277a7780$var$composeOptional;
/**
 * Compose a `Prism` with an `Traversal`.
 *
 * @category compositions
 * @since 2.3.8
 */ var $0c8f5a8b277a7780$var$composeTraversal = function(ab) {
    return (0, $3abDJ.flow)(module.exports.asTraversal, $azsim.traversalComposeTraversal(ab));
};
module.exports.composeTraversal = $0c8f5a8b277a7780$var$composeTraversal;
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @category combinators
 * @since 2.3.0
 */ module.exports.set = $azsim.prismSet;
/**
 * @category combinators
 * @since 2.3.0
 */ module.exports.modifyOption = $azsim.prismModifyOption;
/**
 * @category combinators
 * @since 2.3.0
 */ module.exports.modify = $azsim.prismModify;
function $0c8f5a8b277a7780$var$modifyF(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $e64KP.pipe)(sa.getOption(s), $hBXBN.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), sa.reverseGet);
                }));
            };
        };
    };
}
module.exports.modifyF = $0c8f5a8b277a7780$var$modifyF;
/**
 * Return a `Prism` from a `Prism` focused on a nullable value.
 *
 * @category combinators
 * @since 2.3.3
 */ module.exports.fromNullable = /*#__PURE__*/ (0, module.exports.compose)(/*#__PURE__*/ $azsim.prismFromNullable());
function $0c8f5a8b277a7780$var$filter(predicate) {
    return (0, module.exports.compose)($azsim.prismFromPredicate(predicate));
}
module.exports.filter = $0c8f5a8b277a7780$var$filter;
/**
 * Return a `Optional` from a `Prism` and a prop.
 *
 * @category combinators
 * @since 2.3.0
 */ var $0c8f5a8b277a7780$var$prop = function(prop) {
    return (0, module.exports.composeLens)((0, $e64KP.pipe)($azsim.lensId(), $azsim.lensProp(prop)));
}; // TODO: simplify?
module.exports.prop = $0c8f5a8b277a7780$var$prop;
/**
 * Return a `Optional` from a `Prism` and a list of props.
 *
 * @category combinators
 * @since 2.3.0
 */ var $0c8f5a8b277a7780$var$props = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return (0, module.exports.composeLens)((0, $e64KP.pipe)($azsim.lensId(), $azsim.lensProps.apply($azsim, props)));
};
module.exports.props = $0c8f5a8b277a7780$var$props;
/**
 * Return a `Optional` from a `Prism` focused on a component of a tuple.
 *
 * @category combinators
 * @since 2.3.0
 */ var $0c8f5a8b277a7780$var$component = function(prop) {
    return (0, module.exports.composeLens)((0, $e64KP.pipe)($azsim.lensId(), $azsim.lensComponent(prop)));
};
module.exports.component = $0c8f5a8b277a7780$var$component;
/**
 * Return a `Optional` from a `Prism` focused on an index of a `ReadonlyArray`.
 *
 * @category combinators
 * @since 2.3.0
 */ var $0c8f5a8b277a7780$var$index = function(i) {
    return (0, $3abDJ.flow)(module.exports.asOptional, $azsim.optionalIndex(i));
};
module.exports.index = $0c8f5a8b277a7780$var$index;
/**
 * Return a `Optional` from a `Prism` focused on an index of a `ReadonlyNonEmptyArray`.
 *
 * @category combinators
 * @since 2.3.8
 */ var $0c8f5a8b277a7780$var$indexNonEmpty = function(i) {
    return (0, $3abDJ.flow)(module.exports.asOptional, $azsim.optionalIndexNonEmpty(i));
};
module.exports.indexNonEmpty = $0c8f5a8b277a7780$var$indexNonEmpty;
/**
 * Return a `Optional` from a `Prism` focused on a key of a `ReadonlyRecord`.
 *
 * @category combinators
 * @since 2.3.0
 */ var $0c8f5a8b277a7780$var$key = function(key) {
    return (0, $3abDJ.flow)(module.exports.asOptional, $azsim.optionalKey(key));
};
module.exports.key = $0c8f5a8b277a7780$var$key;
/**
 * Return a `Optional` from a `Prism` focused on a required key of a `ReadonlyRecord`.
 *
 * @category combinators
 * @since 2.3.0
 */ var $0c8f5a8b277a7780$var$atKey = function(key) {
    return function(sa) {
        return $azsim.prismComposeLens($azsim.atReadonlyRecord().at(key))(sa);
    };
};
module.exports.atKey = $0c8f5a8b277a7780$var$atKey;
/**
 * Return a `Prism` from a `Prism` focused on the `Some` of a `Option` type.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.some = /*#__PURE__*/ (0, module.exports.compose)(/*#__PURE__*/ $azsim.prismSome());
/**
 * Return a `Prism` from a `Prism` focused on the `Right` of a `Either` type.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.right = /*#__PURE__*/ (0, module.exports.compose)(/*#__PURE__*/ $azsim.prismRight());
/**
 * Return a `Prism` from a `Prism` focused on the `Left` of a `Either` type.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.left = /*#__PURE__*/ (0, module.exports.compose)(/*#__PURE__*/ $azsim.prismLeft());
/**
 * Return a `Traversal` from a `Prism` focused on a `Traversable`.
 *
 * @category combinators
 * @since 2.3.0
 */ function $0c8f5a8b277a7780$var$traverse(T) {
    return (0, $3abDJ.flow)(module.exports.asTraversal, $azsim.traversalTraverse(T));
}
module.exports.traverse = $0c8f5a8b277a7780$var$traverse;
function $0c8f5a8b277a7780$var$findFirst(predicate) {
    return (0, module.exports.composeOptional)($azsim.optionalFindFirst(predicate));
}
module.exports.findFirst = $0c8f5a8b277a7780$var$findFirst;
function $0c8f5a8b277a7780$var$findFirstNonEmpty(predicate) {
    return (0, module.exports.composeOptional)($azsim.optionalFindFirstNonEmpty(predicate));
}
module.exports.findFirstNonEmpty = $0c8f5a8b277a7780$var$findFirstNonEmpty;
// -------------------------------------------------------------------------------------
// pipeables
// -------------------------------------------------------------------------------------
/**
 * @category Invariant
 * @since 2.3.0
 */ var $0c8f5a8b277a7780$var$imap = function(f, g) {
    return function(ea) {
        return $0c8f5a8b277a7780$var$imap_(ea, f, g);
    };
};
module.exports.imap = $0c8f5a8b277a7780$var$imap;
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $0c8f5a8b277a7780$var$imap_ = function(ea, ab, ba) {
    return (0, module.exports.prism)((0, $3abDJ.flow)(ea.getOption, $hBXBN.map(ab)), (0, $3abDJ.flow)(ba, ea.reverseGet));
};
/**
 * @category instances
 * @since 2.3.0
 */ module.exports.URI = 'monocle-ts/Prism';
/**
 * @category instances
 * @since 2.3.0
 */ module.exports.Invariant = {
    URI: module.exports.URI,
    imap: $0c8f5a8b277a7780$var$imap_
};
/**
 * @category instances
 * @since 2.3.8
 */ module.exports.Semigroupoid = {
    URI: module.exports.URI,
    compose: function(ab, ea) {
        return (0, module.exports.compose)(ab)(ea);
    }
};
/**
 * @category instances
 * @since 2.3.0
 */ module.exports.Category = {
    URI: module.exports.URI,
    compose: module.exports.Semigroupoid.compose,
    id: module.exports.id
};

});

parcelRegister("alZsa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Category = module.exports.Semigroupoid = module.exports.URI = module.exports.getAll = module.exports.fold = module.exports.foldMap = module.exports.findFirstNonEmpty = module.exports.findFirst = module.exports.traverse = module.exports.left = module.exports.right = module.exports.some = module.exports.atKey = module.exports.key = module.exports.indexNonEmpty = module.exports.index = module.exports.component = module.exports.props = module.exports.prop = module.exports.filter = module.exports.fromNullable = module.exports.set = module.exports.modify = module.exports.composeOptional = module.exports.composePrism = module.exports.composeLens = module.exports.composeIso = module.exports.composeTraversal = module.exports.compose = module.exports.fromTraversable = module.exports.id = module.exports.traversal = void 0;

var $6lpQu = parcelRequire("6lpQu");

var $3abDJ = parcelRequire("3abDJ");

var $e64KP = parcelRequire("e64KP");

var $3zj3N = parcelRequire("3zj3N");

var $azsim = parcelRequire("azsim");
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.3.8
 */ module.exports.traversal = $azsim.traversal;
/**
 * @category constructors
 * @since 2.3.0
 */ var $789b88e2f455f9fa$var$id = function() {
    return (0, module.exports.traversal)(function(_) {
        return function(f) {
            return f;
        };
    });
};
module.exports.id = $789b88e2f455f9fa$var$id;
/**
 * Create a `Traversal` from a `Traversable`.
 *
 * @category constructor
 * @since 2.3.0
 */ module.exports.fromTraversable = $azsim.fromTraversable;
// -------------------------------------------------------------------------------------
// compositions
// -------------------------------------------------------------------------------------
/**
 * Compose a `Traversal` with a `Traversal`.
 *
 * @category compositions
 * @since 2.3.0
 */ module.exports.compose = $azsim.traversalComposeTraversal;
/**
 * Alias of `compose`.
 *
 * @category compositions
 * @since 2.3.8
 */ module.exports.composeTraversal = module.exports.compose;
/**
 * Compose a `Traversal` with a `Iso`.
 *
 * @category compositions
 * @since 2.3.8
 */ module.exports.composeIso = /*#__PURE__*/ (0, $3abDJ.flow)($azsim.isoAsTraversal, module.exports.compose);
/**
 * Compose a `Traversal` with a `Lens`.
 *
 * @category compositions
 * @since 2.3.8
 */ module.exports.composeLens = /*#__PURE__*/ (0, $3abDJ.flow)($azsim.lensAsTraversal, $azsim.traversalComposeTraversal);
/**
 * Compose a `Traversal` with a `Prism`.
 *
 * @category compositions
 * @since 2.3.8
 */ module.exports.composePrism = /*#__PURE__*/ (0, $3abDJ.flow)($azsim.prismAsTraversal, $azsim.traversalComposeTraversal);
/**
 * Compose a `Traversal` with a `Optional`.
 *
 * @category compositions
 * @since 2.3.8
 */ module.exports.composeOptional = /*#__PURE__*/ (0, $3abDJ.flow)($azsim.optionalAsTraversal, $azsim.traversalComposeTraversal);
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @category combinators
 * @since 2.3.0
 */ var $789b88e2f455f9fa$var$modify = function(f) {
    return function(sa) {
        return sa.modifyF($azsim.ApplicativeIdentity)(f);
    };
};
module.exports.modify = $789b88e2f455f9fa$var$modify;
/**
 * @category combinators
 * @since 2.3.0
 */ var $789b88e2f455f9fa$var$set = function(a) {
    return (0, module.exports.modify)(function() {
        return a;
    });
};
module.exports.set = $789b88e2f455f9fa$var$set;
/**
 * Return a `Traversal` from a `Traversal` focused on a nullable value.
 *
 * @category combinators
 * @since 2.3.0
 */ var $789b88e2f455f9fa$var$fromNullable = function(sa) {
    return (0, module.exports.composePrism)($azsim.prismFromNullable())(sa);
};
module.exports.fromNullable = $789b88e2f455f9fa$var$fromNullable;
function $789b88e2f455f9fa$var$filter(predicate) {
    return (0, module.exports.compose)($azsim.prismAsTraversal($azsim.prismFromPredicate(predicate)));
}
module.exports.filter = $789b88e2f455f9fa$var$filter;
/**
 * Return a `Traversal` from a `Traversal` and a prop.
 *
 * @category combinators
 * @since 2.3.0
 */ var $789b88e2f455f9fa$var$prop = function(prop) {
    return (0, module.exports.compose)((0, $e64KP.pipe)($azsim.lensId(), $azsim.lensProp(prop), $azsim.lensAsTraversal));
};
module.exports.prop = $789b88e2f455f9fa$var$prop;
/**
 * Return a `Traversal` from a `Traversal` and a list of props.
 *
 * @category combinators
 * @since 2.3.0
 */ var $789b88e2f455f9fa$var$props = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return (0, module.exports.compose)((0, $e64KP.pipe)($azsim.lensId(), $azsim.lensProps.apply($azsim, props), $azsim.lensAsTraversal));
};
module.exports.props = $789b88e2f455f9fa$var$props;
/**
 * Return a `Traversal` from a `Traversal` focused on a component of a tuple.
 *
 * @category combinators
 * @since 2.3.0
 */ var $789b88e2f455f9fa$var$component = function(prop) {
    return (0, module.exports.compose)((0, $e64KP.pipe)($azsim.lensId(), $azsim.lensComponent(prop), $azsim.lensAsTraversal));
};
module.exports.component = $789b88e2f455f9fa$var$component;
/**
 * Return a `Traversal` from a `Traversal` focused on an index of a `ReadonlyArray`.
 *
 * @category combinators
 * @since 2.3.0
 */ var $789b88e2f455f9fa$var$index = function(i) {
    return function(sa) {
        return (0, $e64KP.pipe)(sa, (0, module.exports.compose)($azsim.optionalAsTraversal($azsim.indexReadonlyArray().index(i))));
    };
};
module.exports.index = $789b88e2f455f9fa$var$index;
/**
 * @category combinators
 * @since 2.3.8
 */ var $789b88e2f455f9fa$var$indexNonEmpty = function(i) {
    return function(sa) {
        return (0, $e64KP.pipe)(sa, (0, module.exports.compose)($azsim.optionalAsTraversal($azsim.indexReadonlyNonEmptyArray().index(i))));
    };
};
module.exports.indexNonEmpty = $789b88e2f455f9fa$var$indexNonEmpty;
/**
 * Return a `Traversal` from a `Traversal` focused on a key of a `ReadonlyRecord`.
 *
 * @category combinators
 * @since 2.3.0
 */ var $789b88e2f455f9fa$var$key = function(key) {
    return function(sa) {
        return (0, $e64KP.pipe)(sa, (0, module.exports.compose)($azsim.optionalAsTraversal($azsim.indexReadonlyRecord().index(key))));
    };
};
module.exports.key = $789b88e2f455f9fa$var$key;
/**
 * Return a `Traversal` from a `Traversal` focused on a required key of a `ReadonlyRecord`.
 *
 * @category combinators
 * @since 2.3.0
 */ var $789b88e2f455f9fa$var$atKey = function(key) {
    return function(sa) {
        return (0, $e64KP.pipe)(sa, (0, module.exports.compose)($azsim.lensAsTraversal($azsim.atReadonlyRecord().at(key))));
    };
};
module.exports.atKey = $789b88e2f455f9fa$var$atKey;
/**
 * Return a `Traversal` from a `Traversal` focused on the `Some` of a `Option` type.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.some = /*#__PURE__*/ (0, module.exports.compose)(/*#__PURE__*/ $azsim.prismAsTraversal(/*#__PURE__*/ $azsim.prismSome()));
/**
 * Return a `Traversal` from a `Traversal` focused on the `Right` of a `Either` type.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.right = /*#__PURE__*/ (0, module.exports.compose)(/*#__PURE__*/ $azsim.prismAsTraversal(/*#__PURE__*/ $azsim.prismRight()));
/**
 * Return a `Traversal` from a `Traversal` focused on the `Left` of a `Either` type.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.left = /*#__PURE__*/ (0, module.exports.compose)(/*#__PURE__*/ $azsim.prismAsTraversal(/*#__PURE__*/ $azsim.prismLeft()));
/**
 * Return a `Traversal` from a `Traversal` focused on a `Traversable`.
 *
 * @category combinators
 * @since 2.3.0
 */ module.exports.traverse = $azsim.traversalTraverse;
function $789b88e2f455f9fa$var$findFirst(predicate) {
    return (0, module.exports.composeOptional)($azsim.optionalFindFirst(predicate));
}
module.exports.findFirst = $789b88e2f455f9fa$var$findFirst;
function $789b88e2f455f9fa$var$findFirstNonEmpty(predicate) {
    return (0, module.exports.composeOptional)($azsim.optionalFindFirstNonEmpty(predicate));
}
module.exports.findFirstNonEmpty = $789b88e2f455f9fa$var$findFirstNonEmpty;
/**
 * Map each target to a `Monoid` and combine the results.
 *
 * @category combinators
 * @since 2.3.0
 */ var $789b88e2f455f9fa$var$foldMap = function(M) {
    return function(f) {
        return function(sa) {
            return sa.modifyF($6lpQu.getApplicative(M))(function(a) {
                return $6lpQu.make(f(a));
            });
        };
    };
};
module.exports.foldMap = $789b88e2f455f9fa$var$foldMap;
/**
 * Map each target to a `Monoid` and combine the results.
 *
 * @category combinators
 * @since 2.3.0
 */ var $789b88e2f455f9fa$var$fold = function(M) {
    return (0, module.exports.foldMap)(M)($3abDJ.identity);
};
module.exports.fold = $789b88e2f455f9fa$var$fold;
/**
 * Get all the targets of a `Traversal`.
 *
 * @category combinators
 * @since 2.3.0
 */ var $789b88e2f455f9fa$var$getAll = function(s) {
    return function(sa) {
        return (0, module.exports.foldMap)($3zj3N.getMonoid())($3zj3N.of)(sa)(s);
    };
};
module.exports.getAll = $789b88e2f455f9fa$var$getAll;
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.3.0
 */ module.exports.URI = 'monocle-ts/Traversal';
/**
 * @category instances
 * @since 2.3.8
 */ module.exports.Semigroupoid = {
    URI: module.exports.URI,
    compose: function(ab, ea) {
        return (0, module.exports.compose)(ab)(ea);
    }
};
/**
 * @category instances
 * @since 2.3.0
 */ module.exports.Category = {
    URI: module.exports.URI,
    compose: module.exports.Semigroupoid.compose,
    id: module.exports.id
};

});


parcelRegister("d9Pe6", function(module, exports) {
/**
xxHash implementation in pure Javascript

Copyright (C) 2013, Pierre Curto
MIT license
*/ 
var $6ZWSX = parcelRequire("6ZWSX");
var $9943da28254ec932$require$Buffer = $6ZWSX.Buffer;

var $9Vawi = parcelRequire("9Vawi");
var $9943da28254ec932$require$UINT32 = $9Vawi.UINT32;
/*
	Merged this sequence of method calls as it speeds up
	the calculations by a factor of 2
 */ // this.v1.add( other.multiply(PRIME32_2) ).rotl(13).multiply(PRIME32_1);
$9943da28254ec932$require$UINT32.prototype.xxh_update = function(low, high) {
    var b00 = $9943da28254ec932$var$PRIME32_2._low;
    var b16 = $9943da28254ec932$var$PRIME32_2._high;
    var c16, c00;
    c00 = low * b00;
    c16 = c00 >>> 16;
    c16 += high * b00;
    c16 &= 0xFFFF // Not required but improves performance
    ;
    c16 += low * b16;
    var a00 = this._low + (c00 & 0xFFFF);
    var a16 = a00 >>> 16;
    a16 += this._high + (c16 & 0xFFFF);
    var v = a16 << 16 | a00 & 0xFFFF;
    v = v << 13 | v >>> 19;
    a00 = v & 0xFFFF;
    a16 = v >>> 16;
    b00 = $9943da28254ec932$var$PRIME32_1._low;
    b16 = $9943da28254ec932$var$PRIME32_1._high;
    c00 = a00 * b00;
    c16 = c00 >>> 16;
    c16 += a16 * b00;
    c16 &= 0xFFFF // Not required but improves performance
    ;
    c16 += a00 * b16;
    this._low = c00 & 0xFFFF;
    this._high = c16 & 0xFFFF;
};
/*
 * Constants
 */ var $9943da28254ec932$var$PRIME32_1 = $9943da28254ec932$require$UINT32('2654435761');
var $9943da28254ec932$var$PRIME32_2 = $9943da28254ec932$require$UINT32('2246822519');
var $9943da28254ec932$var$PRIME32_3 = $9943da28254ec932$require$UINT32('3266489917');
var $9943da28254ec932$var$PRIME32_4 = $9943da28254ec932$require$UINT32('668265263');
var $9943da28254ec932$var$PRIME32_5 = $9943da28254ec932$require$UINT32('374761393');
/**
* Convert string to proper UTF-8 array
* @param str Input string
* @returns {Uint8Array} UTF8 array is returned as uint8 array
*/ function $9943da28254ec932$var$toUTF8Array(str) {
    var utf8 = [];
    for(var i = 0, n = str.length; i < n; i++){
        var charcode = str.charCodeAt(i);
        if (charcode < 0x80) utf8.push(charcode);
        else if (charcode < 0x800) utf8.push(0xc0 | charcode >> 6, 0x80 | charcode & 0x3f);
        else if (charcode < 0xd800 || charcode >= 0xe000) utf8.push(0xe0 | charcode >> 12, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
        else {
            i++;
            // UTF-16 encodes 0x10000-0x10FFFF by
            // subtracting 0x10000 and splitting the
            // 20 bits of 0x0-0xFFFFF into two halves
            charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
            utf8.push(0xf0 | charcode >> 18, 0x80 | charcode >> 12 & 0x3f, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
        }
    }
    return new Uint8Array(utf8);
}
/**
 * XXH object used as a constructor or a function
 * @constructor
 * or
 * @param {Object|String} input data
 * @param {Number|UINT32} seed
 * @return ThisExpression
 * or
 * @return {UINT32} xxHash
 */ function $9943da28254ec932$var$XXH() {
    if (arguments.length == 2) return new $9943da28254ec932$var$XXH(arguments[1]).update(arguments[0]).digest();
    if (!(this instanceof $9943da28254ec932$var$XXH)) return new $9943da28254ec932$var$XXH(arguments[0]);
    $9943da28254ec932$var$init.call(this, arguments[0]);
}
/**
 * Initialize the XXH instance with the given seed
 * @method init
 * @param {Number|Object} seed as a number or an unsigned 32 bits integer
 * @return ThisExpression
 */ function $9943da28254ec932$var$init(seed) {
    this.seed = seed instanceof $9943da28254ec932$require$UINT32 ? seed.clone() : $9943da28254ec932$require$UINT32(seed);
    this.v1 = this.seed.clone().add($9943da28254ec932$var$PRIME32_1).add($9943da28254ec932$var$PRIME32_2);
    this.v2 = this.seed.clone().add($9943da28254ec932$var$PRIME32_2);
    this.v3 = this.seed.clone();
    this.v4 = this.seed.clone().subtract($9943da28254ec932$var$PRIME32_1);
    this.total_len = 0;
    this.memsize = 0;
    this.memory = null;
    return this;
}
$9943da28254ec932$var$XXH.prototype.init = $9943da28254ec932$var$init;
/**
 * Add data to be computed for the XXH hash
 * @method update
 * @param {String|Buffer|ArrayBuffer} input as a string or nodejs Buffer or ArrayBuffer
 * @return ThisExpression
 */ $9943da28254ec932$var$XXH.prototype.update = function(input) {
    var isString = typeof input == 'string';
    var isArrayBuffer;
    // Convert all strings to utf-8 first (issue #5)
    if (isString) {
        input = $9943da28254ec932$var$toUTF8Array(input);
        isString = false;
        isArrayBuffer = true;
    }
    if (typeof ArrayBuffer !== "undefined" && input instanceof ArrayBuffer) {
        isArrayBuffer = true;
        input = new Uint8Array(input);
    }
    var p = 0;
    var len = input.length;
    var bEnd = p + len;
    if (len == 0) return this;
    this.total_len += len;
    if (this.memsize == 0) {
        if (isString) this.memory = '';
        else if (isArrayBuffer) this.memory = new Uint8Array(16);
        else this.memory = new $9943da28254ec932$require$Buffer(16);
    }
    if (this.memsize + len < 16) {
        // XXH_memcpy(this.memory + this.memsize, input, len)
        if (isString) this.memory += input;
        else if (isArrayBuffer) this.memory.set(input.subarray(0, len), this.memsize);
        else input.copy(this.memory, this.memsize, 0, len);
        this.memsize += len;
        return this;
    }
    if (this.memsize > 0) {
        // XXH_memcpy(this.memory + this.memsize, input, 16-this.memsize);
        if (isString) this.memory += input.slice(0, 16 - this.memsize);
        else if (isArrayBuffer) this.memory.set(input.subarray(0, 16 - this.memsize), this.memsize);
        else input.copy(this.memory, this.memsize, 0, 16 - this.memsize);
        var p32 = 0;
        if (isString) {
            this.v1.xxh_update(this.memory.charCodeAt(p32 + 1) << 8 | this.memory.charCodeAt(p32), this.memory.charCodeAt(p32 + 3) << 8 | this.memory.charCodeAt(p32 + 2));
            p32 += 4;
            this.v2.xxh_update(this.memory.charCodeAt(p32 + 1) << 8 | this.memory.charCodeAt(p32), this.memory.charCodeAt(p32 + 3) << 8 | this.memory.charCodeAt(p32 + 2));
            p32 += 4;
            this.v3.xxh_update(this.memory.charCodeAt(p32 + 1) << 8 | this.memory.charCodeAt(p32), this.memory.charCodeAt(p32 + 3) << 8 | this.memory.charCodeAt(p32 + 2));
            p32 += 4;
            this.v4.xxh_update(this.memory.charCodeAt(p32 + 1) << 8 | this.memory.charCodeAt(p32), this.memory.charCodeAt(p32 + 3) << 8 | this.memory.charCodeAt(p32 + 2));
        } else {
            this.v1.xxh_update(this.memory[p32 + 1] << 8 | this.memory[p32], this.memory[p32 + 3] << 8 | this.memory[p32 + 2]);
            p32 += 4;
            this.v2.xxh_update(this.memory[p32 + 1] << 8 | this.memory[p32], this.memory[p32 + 3] << 8 | this.memory[p32 + 2]);
            p32 += 4;
            this.v3.xxh_update(this.memory[p32 + 1] << 8 | this.memory[p32], this.memory[p32 + 3] << 8 | this.memory[p32 + 2]);
            p32 += 4;
            this.v4.xxh_update(this.memory[p32 + 1] << 8 | this.memory[p32], this.memory[p32 + 3] << 8 | this.memory[p32 + 2]);
        }
        p += 16 - this.memsize;
        this.memsize = 0;
        if (isString) this.memory = '';
    }
    if (p <= bEnd - 16) {
        var limit = bEnd - 16;
        do {
            if (isString) {
                this.v1.xxh_update(input.charCodeAt(p + 1) << 8 | input.charCodeAt(p), input.charCodeAt(p + 3) << 8 | input.charCodeAt(p + 2));
                p += 4;
                this.v2.xxh_update(input.charCodeAt(p + 1) << 8 | input.charCodeAt(p), input.charCodeAt(p + 3) << 8 | input.charCodeAt(p + 2));
                p += 4;
                this.v3.xxh_update(input.charCodeAt(p + 1) << 8 | input.charCodeAt(p), input.charCodeAt(p + 3) << 8 | input.charCodeAt(p + 2));
                p += 4;
                this.v4.xxh_update(input.charCodeAt(p + 1) << 8 | input.charCodeAt(p), input.charCodeAt(p + 3) << 8 | input.charCodeAt(p + 2));
            } else {
                this.v1.xxh_update(input[p + 1] << 8 | input[p], input[p + 3] << 8 | input[p + 2]);
                p += 4;
                this.v2.xxh_update(input[p + 1] << 8 | input[p], input[p + 3] << 8 | input[p + 2]);
                p += 4;
                this.v3.xxh_update(input[p + 1] << 8 | input[p], input[p + 3] << 8 | input[p + 2]);
                p += 4;
                this.v4.xxh_update(input[p + 1] << 8 | input[p], input[p + 3] << 8 | input[p + 2]);
            }
            p += 4;
        }while (p <= limit);
    }
    if (p < bEnd) {
        // XXH_memcpy(this.memory, p, bEnd-p);
        if (isString) this.memory += input.slice(p);
        else if (isArrayBuffer) this.memory.set(input.subarray(p, bEnd), this.memsize);
        else input.copy(this.memory, this.memsize, p, bEnd);
        this.memsize = bEnd - p;
    }
    return this;
};
/**
 * Finalize the XXH computation. The XXH instance is ready for reuse for the given seed
 * @method digest
 * @return {UINT32} xxHash
 */ $9943da28254ec932$var$XXH.prototype.digest = function() {
    var input = this.memory;
    var isString = typeof input == 'string';
    var p = 0;
    var bEnd = this.memsize;
    var h32, h;
    var u = new $9943da28254ec932$require$UINT32;
    if (this.total_len >= 16) h32 = this.v1.rotl(1).add(this.v2.rotl(7).add(this.v3.rotl(12).add(this.v4.rotl(18))));
    else h32 = this.seed.clone().add($9943da28254ec932$var$PRIME32_5);
    h32.add(u.fromNumber(this.total_len));
    while(p <= bEnd - 4){
        if (isString) u.fromBits(input.charCodeAt(p + 1) << 8 | input.charCodeAt(p), input.charCodeAt(p + 3) << 8 | input.charCodeAt(p + 2));
        else u.fromBits(input[p + 1] << 8 | input[p], input[p + 3] << 8 | input[p + 2]);
        h32.add(u.multiply($9943da28254ec932$var$PRIME32_3)).rotl(17).multiply($9943da28254ec932$var$PRIME32_4);
        p += 4;
    }
    while(p < bEnd){
        u.fromBits(isString ? input.charCodeAt(p++) : input[p++], 0);
        h32.add(u.multiply($9943da28254ec932$var$PRIME32_5)).rotl(11).multiply($9943da28254ec932$var$PRIME32_1);
    }
    h = h32.clone().shiftRight(15);
    h32.xor(h).multiply($9943da28254ec932$var$PRIME32_2);
    h = h32.clone().shiftRight(13);
    h32.xor(h).multiply($9943da28254ec932$var$PRIME32_3);
    h = h32.clone().shiftRight(16);
    h32.xor(h);
    // Reset the state
    this.init(this.seed);
    return h32;
};
module.exports = $9943da28254ec932$var$XXH;

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("9Vawi", function(module, exports) {

$parcel$export(module.exports, "UINT32", () => $739198f7e7745070$export$55e9b618f09601c9, (v) => $739198f7e7745070$export$55e9b618f09601c9 = v);
$parcel$export(module.exports, "UINT64", () => $739198f7e7745070$export$eb2099ed807a836e, (v) => $739198f7e7745070$export$eb2099ed807a836e = v);
var $739198f7e7745070$export$55e9b618f09601c9;
var $739198f7e7745070$export$eb2099ed807a836e;

$739198f7e7745070$export$55e9b618f09601c9 = (parcelRequire("2G4yx"));

$739198f7e7745070$export$eb2099ed807a836e = (parcelRequire("chclZ"));

});
parcelRegister("2G4yx", function(module, exports) {
(function(root) {
    // Local cache for typical radices
    var radixPowerCache = {
        36: UINT32(Math.pow(36, 5)),
        16: UINT32(Math.pow(16, 7)),
        10: UINT32(Math.pow(10, 9)),
        2: UINT32(Math.pow(2, 30))
    };
    var radixCache = {
        36: UINT32(36),
        16: UINT32(16),
        10: UINT32(10),
        2: UINT32(2)
    };
    /**
	 *	Represents an unsigned 32 bits integer
	 * @constructor
	 * @param {Number|String|Number} low bits     | integer as a string 		 | integer as a number
	 * @param {Number|Number|Undefined} high bits | radix (optional, default=10)
	 * @return 
	 */ function UINT32(l, h) {
        if (!(this instanceof UINT32)) return new UINT32(l, h);
        this._low = 0;
        this._high = 0;
        this.remainder = null;
        if (typeof h == 'undefined') return fromNumber.call(this, l);
        if (typeof l == 'string') return fromString.call(this, l, h);
        fromBits.call(this, l, h);
    }
    /**
	 * Set the current _UINT32_ object with its low and high bits
	 * @method fromBits
	 * @param {Number} low bits
	 * @param {Number} high bits
	 * @return ThisExpression
	 */ function fromBits(l, h) {
        this._low = l | 0;
        this._high = h | 0;
        return this;
    }
    UINT32.prototype.fromBits = fromBits;
    /**
	 * Set the current _UINT32_ object from a number
	 * @method fromNumber
	 * @param {Number} number
	 * @return ThisExpression
	 */ function fromNumber(value) {
        this._low = value & 0xFFFF;
        this._high = value >>> 16;
        return this;
    }
    UINT32.prototype.fromNumber = fromNumber;
    /**
	 * Set the current _UINT32_ object from a string
	 * @method fromString
	 * @param {String} integer as a string
	 * @param {Number} radix (optional, default=10)
	 * @return ThisExpression
	 */ function fromString(s, radix) {
        var value = parseInt(s, radix || 10);
        this._low = value & 0xFFFF;
        this._high = value >>> 16;
        return this;
    }
    UINT32.prototype.fromString = fromString;
    /**
	 * Convert this _UINT32_ to a number
	 * @method toNumber
	 * @return {Number} the converted UINT32
	 */ UINT32.prototype.toNumber = function() {
        return this._high * 65536 + this._low;
    };
    /**
	 * Convert this _UINT32_ to a string
	 * @method toString
	 * @param {Number} radix (optional, default=10)
	 * @return {String} the converted UINT32
	 */ UINT32.prototype.toString = function(radix) {
        return this.toNumber().toString(radix || 10);
    };
    /**
	 * Add two _UINT32_. The current _UINT32_ stores the result
	 * @method add
	 * @param {Object} other UINT32
	 * @return ThisExpression
	 */ UINT32.prototype.add = function(other) {
        var a00 = this._low + other._low;
        var a16 = a00 >>> 16;
        a16 += this._high + other._high;
        this._low = a00 & 0xFFFF;
        this._high = a16 & 0xFFFF;
        return this;
    };
    /**
	 * Subtract two _UINT32_. The current _UINT32_ stores the result
	 * @method subtract
	 * @param {Object} other UINT32
	 * @return ThisExpression
	 */ UINT32.prototype.subtract = function(other) {
        //TODO inline
        return this.add(other.clone().negate());
    };
    /**
	 * Multiply two _UINT32_. The current _UINT32_ stores the result
	 * @method multiply
	 * @param {Object} other UINT32
	 * @return ThisExpression
	 */ UINT32.prototype.multiply = function(other) {
        /*
			a = a00 + a16
			b = b00 + b16
			a*b = (a00 + a16)(b00 + b16)
				= a00b00 + a00b16 + a16b00 + a16b16

			a16b16 overflows the 32bits
		 */ var a16 = this._high;
        var a00 = this._low;
        var b16 = other._high;
        var b00 = other._low;
        /* Removed to increase speed under normal circumstances (i.e. not multiplying by 0 or 1)
		// this == 0 or other == 1: nothing to do
		if ((a00 == 0 && a16 == 0) || (b00 == 1 && b16 == 0)) return this

		// other == 0 or this == 1: this = other
		if ((b00 == 0 && b16 == 0) || (a00 == 1 && a16 == 0)) {
			this._low = other._low
			this._high = other._high
			return this
		}
*/ var c16, c00;
        c00 = a00 * b00;
        c16 = c00 >>> 16;
        c16 += a16 * b00;
        c16 &= 0xFFFF // Not required but improves performance
        ;
        c16 += a00 * b16;
        this._low = c00 & 0xFFFF;
        this._high = c16 & 0xFFFF;
        return this;
    };
    /**
	 * Divide two _UINT32_. The current _UINT32_ stores the result.
	 * The remainder is made available as the _remainder_ property on
	 * the _UINT32_ object. It can be null, meaning there are no remainder.
	 * @method div
	 * @param {Object} other UINT32
	 * @return ThisExpression
	 */ UINT32.prototype.div = function(other) {
        if (other._low == 0 && other._high == 0) throw Error('division by zero');
        // other == 1
        if (other._high == 0 && other._low == 1) {
            this.remainder = new UINT32(0);
            return this;
        }
        // other > this: 0
        if (other.gt(this)) {
            this.remainder = this.clone();
            this._low = 0;
            this._high = 0;
            return this;
        }
        // other == this: 1
        if (this.eq(other)) {
            this.remainder = new UINT32(0);
            this._low = 1;
            this._high = 0;
            return this;
        }
        // Shift the divisor left until it is higher than the dividend
        var _other = other.clone();
        var i = -1;
        while(!this.lt(_other)){
            // High bit can overflow the default 16bits
            // Its ok since we right shift after this loop
            // The overflown bit must be kept though
            _other.shiftLeft(1, true);
            i++;
        }
        // Set the remainder
        this.remainder = this.clone();
        // Initialize the current result to 0
        this._low = 0;
        this._high = 0;
        for(; i >= 0; i--){
            _other.shiftRight(1);
            // If shifted divisor is smaller than the dividend
            // then subtract it from the dividend
            if (!this.remainder.lt(_other)) {
                this.remainder.subtract(_other);
                // Update the current result
                if (i >= 16) this._high |= 1 << i - 16;
                else this._low |= 1 << i;
            }
        }
        return this;
    };
    /**
	 * Negate the current _UINT32_
	 * @method negate
	 * @return ThisExpression
	 */ UINT32.prototype.negate = function() {
        var v = (~this._low & 0xFFFF) + 1;
        this._low = v & 0xFFFF;
        this._high = ~this._high + (v >>> 16) & 0xFFFF;
        return this;
    };
    /**
	 * Equals
	 * @method eq
	 * @param {Object} other UINT32
	 * @return {Boolean}
	 */ UINT32.prototype.equals = UINT32.prototype.eq = function(other) {
        return this._low == other._low && this._high == other._high;
    };
    /**
	 * Greater than (strict)
	 * @method gt
	 * @param {Object} other UINT32
	 * @return {Boolean}
	 */ UINT32.prototype.greaterThan = UINT32.prototype.gt = function(other) {
        if (this._high > other._high) return true;
        if (this._high < other._high) return false;
        return this._low > other._low;
    };
    /**
	 * Less than (strict)
	 * @method lt
	 * @param {Object} other UINT32
	 * @return {Boolean}
	 */ UINT32.prototype.lessThan = UINT32.prototype.lt = function(other) {
        if (this._high < other._high) return true;
        if (this._high > other._high) return false;
        return this._low < other._low;
    };
    /**
	 * Bitwise OR
	 * @method or
	 * @param {Object} other UINT32
	 * @return ThisExpression
	 */ UINT32.prototype.or = function(other) {
        this._low |= other._low;
        this._high |= other._high;
        return this;
    };
    /**
	 * Bitwise AND
	 * @method and
	 * @param {Object} other UINT32
	 * @return ThisExpression
	 */ UINT32.prototype.and = function(other) {
        this._low &= other._low;
        this._high &= other._high;
        return this;
    };
    /**
	 * Bitwise NOT
	 * @method not
	 * @return ThisExpression
	 */ UINT32.prototype.not = function() {
        this._low = ~this._low & 0xFFFF;
        this._high = ~this._high & 0xFFFF;
        return this;
    };
    /**
	 * Bitwise XOR
	 * @method xor
	 * @param {Object} other UINT32
	 * @return ThisExpression
	 */ UINT32.prototype.xor = function(other) {
        this._low ^= other._low;
        this._high ^= other._high;
        return this;
    };
    /**
	 * Bitwise shift right
	 * @method shiftRight
	 * @param {Number} number of bits to shift
	 * @return ThisExpression
	 */ UINT32.prototype.shiftRight = UINT32.prototype.shiftr = function(n) {
        if (n > 16) {
            this._low = this._high >> n - 16;
            this._high = 0;
        } else if (n == 16) {
            this._low = this._high;
            this._high = 0;
        } else {
            this._low = this._low >> n | this._high << 16 - n & 0xFFFF;
            this._high >>= n;
        }
        return this;
    };
    /**
	 * Bitwise shift left
	 * @method shiftLeft
	 * @param {Number} number of bits to shift
	 * @param {Boolean} allow overflow
	 * @return ThisExpression
	 */ UINT32.prototype.shiftLeft = UINT32.prototype.shiftl = function(n, allowOverflow) {
        if (n > 16) {
            this._high = this._low << n - 16;
            this._low = 0;
            if (!allowOverflow) this._high &= 0xFFFF;
        } else if (n == 16) {
            this._high = this._low;
            this._low = 0;
        } else {
            this._high = this._high << n | this._low >> 16 - n;
            this._low = this._low << n & 0xFFFF;
            if (!allowOverflow) // Overflow only allowed on the high bits...
            this._high &= 0xFFFF;
        }
        return this;
    };
    /**
	 * Bitwise rotate left
	 * @method rotl
	 * @param {Number} number of bits to rotate
	 * @return ThisExpression
	 */ UINT32.prototype.rotateLeft = UINT32.prototype.rotl = function(n) {
        var v = this._high << 16 | this._low;
        v = v << n | v >>> 32 - n;
        this._low = v & 0xFFFF;
        this._high = v >>> 16;
        return this;
    };
    /**
	 * Bitwise rotate right
	 * @method rotr
	 * @param {Number} number of bits to rotate
	 * @return ThisExpression
	 */ UINT32.prototype.rotateRight = UINT32.prototype.rotr = function(n) {
        var v = this._high << 16 | this._low;
        v = v >>> n | v << 32 - n;
        this._low = v & 0xFFFF;
        this._high = v >>> 16;
        return this;
    };
    /**
	 * Clone the current _UINT32_
	 * @method clone
	 * @return {Object} cloned UINT32
	 */ UINT32.prototype.clone = function() {
        return new UINT32(this._low, this._high);
    };
    if (typeof define != 'undefined' && define.amd) // AMD / RequireJS
    define([], function() {
        return UINT32;
    });
    else if (0, module.exports) // Node.js
    module.exports = UINT32;
    else // Browser
    root['UINT32'] = UINT32;
})(module.exports);

});

parcelRegister("chclZ", function(module, exports) {
(function(root) {
    // Local cache for typical radices
    var radixPowerCache = {
        16: UINT64(Math.pow(16, 5)),
        10: UINT64(Math.pow(10, 5)),
        2: UINT64(Math.pow(2, 5))
    };
    var radixCache = {
        16: UINT64(16),
        10: UINT64(10),
        2: UINT64(2)
    };
    /**
	 *	Represents an unsigned 64 bits integer
	 * @constructor
	 * @param {Number} first low bits (8)
	 * @param {Number} second low bits (8)
	 * @param {Number} first high bits (8)
	 * @param {Number} second high bits (8)
	 * or
	 * @param {Number} low bits (32)
	 * @param {Number} high bits (32)
	 * or
	 * @param {String|Number} integer as a string 		 | integer as a number
	 * @param {Number|Undefined} radix (optional, default=10)
	 * @return 
	 */ function UINT64(a00, a16, a32, a48) {
        if (!(this instanceof UINT64)) return new UINT64(a00, a16, a32, a48);
        this.remainder = null;
        if (typeof a00 == 'string') return fromString.call(this, a00, a16);
        if (typeof a16 == 'undefined') return fromNumber.call(this, a00);
        fromBits.apply(this, arguments);
    }
    /**
	 * Set the current _UINT64_ object with its low and high bits
	 * @method fromBits
	 * @param {Number} first low bits (8)
	 * @param {Number} second low bits (8)
	 * @param {Number} first high bits (8)
	 * @param {Number} second high bits (8)
	 * or
	 * @param {Number} low bits (32)
	 * @param {Number} high bits (32)
	 * @return ThisExpression
	 */ function fromBits(a00, a16, a32, a48) {
        if (typeof a32 == 'undefined') {
            this._a00 = a00 & 0xFFFF;
            this._a16 = a00 >>> 16;
            this._a32 = a16 & 0xFFFF;
            this._a48 = a16 >>> 16;
            return this;
        }
        this._a00 = a00 | 0;
        this._a16 = a16 | 0;
        this._a32 = a32 | 0;
        this._a48 = a48 | 0;
        return this;
    }
    UINT64.prototype.fromBits = fromBits;
    /**
	 * Set the current _UINT64_ object from a number
	 * @method fromNumber
	 * @param {Number} number
	 * @return ThisExpression
	 */ function fromNumber(value) {
        this._a00 = value & 0xFFFF;
        this._a16 = value >>> 16;
        this._a32 = 0;
        this._a48 = 0;
        return this;
    }
    UINT64.prototype.fromNumber = fromNumber;
    /**
	 * Set the current _UINT64_ object from a string
	 * @method fromString
	 * @param {String} integer as a string
	 * @param {Number} radix (optional, default=10)
	 * @return ThisExpression
	 */ function fromString(s, radix) {
        radix = radix || 10;
        this._a00 = 0;
        this._a16 = 0;
        this._a32 = 0;
        this._a48 = 0;
        /*
			In Javascript, bitwise operators only operate on the first 32 bits 
			of a number, even though parseInt() encodes numbers with a 53 bits 
			mantissa.
			Therefore UINT64(<Number>) can only work on 32 bits.
			The radix maximum value is 36 (as per ECMA specs) (26 letters + 10 digits)
			maximum input value is m = 32bits as 1 = 2^32 - 1
			So the maximum substring length n is:
			36^(n+1) - 1 = 2^32 - 1
			36^(n+1) = 2^32
			(n+1)ln(36) = 32ln(2)
			n = 32ln(2)/ln(36) - 1
			n = 5.189644915687692
			n = 5
		 */ var radixUint = radixPowerCache[radix] || new UINT64(Math.pow(radix, 5));
        for(var i = 0, len = s.length; i < len; i += 5){
            var size = Math.min(5, len - i);
            var value = parseInt(s.slice(i, i + size), radix);
            this.multiply(size < 5 ? new UINT64(Math.pow(radix, size)) : radixUint).add(new UINT64(value));
        }
        return this;
    }
    UINT64.prototype.fromString = fromString;
    /**
	 * Convert this _UINT64_ to a number (last 32 bits are dropped)
	 * @method toNumber
	 * @return {Number} the converted UINT64
	 */ UINT64.prototype.toNumber = function() {
        return this._a16 * 65536 + this._a00;
    };
    /**
	 * Convert this _UINT64_ to a string
	 * @method toString
	 * @param {Number} radix (optional, default=10)
	 * @return {String} the converted UINT64
	 */ UINT64.prototype.toString = function(radix) {
        radix = radix || 10;
        var radixUint = radixCache[radix] || new UINT64(radix);
        if (!this.gt(radixUint)) return this.toNumber().toString(radix);
        var self = this.clone();
        var res = new Array(64);
        for(var i = 63; i >= 0; i--){
            self.div(radixUint);
            res[i] = self.remainder.toNumber().toString(radix);
            if (!self.gt(radixUint)) break;
        }
        res[i - 1] = self.toNumber().toString(radix);
        return res.join('');
    };
    /**
	 * Add two _UINT64_. The current _UINT64_ stores the result
	 * @method add
	 * @param {Object} other UINT64
	 * @return ThisExpression
	 */ UINT64.prototype.add = function(other) {
        var a00 = this._a00 + other._a00;
        var a16 = a00 >>> 16;
        a16 += this._a16 + other._a16;
        var a32 = a16 >>> 16;
        a32 += this._a32 + other._a32;
        var a48 = a32 >>> 16;
        a48 += this._a48 + other._a48;
        this._a00 = a00 & 0xFFFF;
        this._a16 = a16 & 0xFFFF;
        this._a32 = a32 & 0xFFFF;
        this._a48 = a48 & 0xFFFF;
        return this;
    };
    /**
	 * Subtract two _UINT64_. The current _UINT64_ stores the result
	 * @method subtract
	 * @param {Object} other UINT64
	 * @return ThisExpression
	 */ UINT64.prototype.subtract = function(other) {
        return this.add(other.clone().negate());
    };
    /**
	 * Multiply two _UINT64_. The current _UINT64_ stores the result
	 * @method multiply
	 * @param {Object} other UINT64
	 * @return ThisExpression
	 */ UINT64.prototype.multiply = function(other) {
        /*
			a = a00 + a16 + a32 + a48
			b = b00 + b16 + b32 + b48
			a*b = (a00 + a16 + a32 + a48)(b00 + b16 + b32 + b48)
				= a00b00 + a00b16 + a00b32 + a00b48
				+ a16b00 + a16b16 + a16b32 + a16b48
				+ a32b00 + a32b16 + a32b32 + a32b48
				+ a48b00 + a48b16 + a48b32 + a48b48

			a16b48, a32b32, a48b16, a48b32 and a48b48 overflow the 64 bits
			so it comes down to:
			a*b	= a00b00 + a00b16 + a00b32 + a00b48
				+ a16b00 + a16b16 + a16b32
				+ a32b00 + a32b16
				+ a48b00
				= a00b00
				+ a00b16 + a16b00
				+ a00b32 + a16b16 + a32b00
				+ a00b48 + a16b32 + a32b16 + a48b00
		 */ var a00 = this._a00;
        var a16 = this._a16;
        var a32 = this._a32;
        var a48 = this._a48;
        var b00 = other._a00;
        var b16 = other._a16;
        var b32 = other._a32;
        var b48 = other._a48;
        var c00 = a00 * b00;
        var c16 = c00 >>> 16;
        c16 += a00 * b16;
        var c32 = c16 >>> 16;
        c16 &= 0xFFFF;
        c16 += a16 * b00;
        c32 += c16 >>> 16;
        c32 += a00 * b32;
        var c48 = c32 >>> 16;
        c32 &= 0xFFFF;
        c32 += a16 * b16;
        c48 += c32 >>> 16;
        c32 &= 0xFFFF;
        c32 += a32 * b00;
        c48 += c32 >>> 16;
        c48 += a00 * b48;
        c48 &= 0xFFFF;
        c48 += a16 * b32;
        c48 &= 0xFFFF;
        c48 += a32 * b16;
        c48 &= 0xFFFF;
        c48 += a48 * b00;
        this._a00 = c00 & 0xFFFF;
        this._a16 = c16 & 0xFFFF;
        this._a32 = c32 & 0xFFFF;
        this._a48 = c48 & 0xFFFF;
        return this;
    };
    /**
	 * Divide two _UINT64_. The current _UINT64_ stores the result.
	 * The remainder is made available as the _remainder_ property on
	 * the _UINT64_ object. It can be null, meaning there are no remainder.
	 * @method div
	 * @param {Object} other UINT64
	 * @return ThisExpression
	 */ UINT64.prototype.div = function(other) {
        if (other._a16 == 0 && other._a32 == 0 && other._a48 == 0) {
            if (other._a00 == 0) throw Error('division by zero');
            // other == 1: this
            if (other._a00 == 1) {
                this.remainder = new UINT64(0);
                return this;
            }
        }
        // other > this: 0
        if (other.gt(this)) {
            this.remainder = this.clone();
            this._a00 = 0;
            this._a16 = 0;
            this._a32 = 0;
            this._a48 = 0;
            return this;
        }
        // other == this: 1
        if (this.eq(other)) {
            this.remainder = new UINT64(0);
            this._a00 = 1;
            this._a16 = 0;
            this._a32 = 0;
            this._a48 = 0;
            return this;
        }
        // Shift the divisor left until it is higher than the dividend
        var _other = other.clone();
        var i = -1;
        while(!this.lt(_other)){
            // High bit can overflow the default 16bits
            // Its ok since we right shift after this loop
            // The overflown bit must be kept though
            _other.shiftLeft(1, true);
            i++;
        }
        // Set the remainder
        this.remainder = this.clone();
        // Initialize the current result to 0
        this._a00 = 0;
        this._a16 = 0;
        this._a32 = 0;
        this._a48 = 0;
        for(; i >= 0; i--){
            _other.shiftRight(1);
            // If shifted divisor is smaller than the dividend
            // then subtract it from the dividend
            if (!this.remainder.lt(_other)) {
                this.remainder.subtract(_other);
                // Update the current result
                if (i >= 48) this._a48 |= 1 << i - 48;
                else if (i >= 32) this._a32 |= 1 << i - 32;
                else if (i >= 16) this._a16 |= 1 << i - 16;
                else this._a00 |= 1 << i;
            }
        }
        return this;
    };
    /**
	 * Negate the current _UINT64_
	 * @method negate
	 * @return ThisExpression
	 */ UINT64.prototype.negate = function() {
        var v = (~this._a00 & 0xFFFF) + 1;
        this._a00 = v & 0xFFFF;
        v = (~this._a16 & 0xFFFF) + (v >>> 16);
        this._a16 = v & 0xFFFF;
        v = (~this._a32 & 0xFFFF) + (v >>> 16);
        this._a32 = v & 0xFFFF;
        this._a48 = ~this._a48 + (v >>> 16) & 0xFFFF;
        return this;
    };
    /**

	 * @method eq
	 * @param {Object} other UINT64
	 * @return {Boolean}
	 */ UINT64.prototype.equals = UINT64.prototype.eq = function(other) {
        return this._a48 == other._a48 && this._a00 == other._a00 && this._a32 == other._a32 && this._a16 == other._a16;
    };
    /**
	 * Greater than (strict)
	 * @method gt
	 * @param {Object} other UINT64
	 * @return {Boolean}
	 */ UINT64.prototype.greaterThan = UINT64.prototype.gt = function(other) {
        if (this._a48 > other._a48) return true;
        if (this._a48 < other._a48) return false;
        if (this._a32 > other._a32) return true;
        if (this._a32 < other._a32) return false;
        if (this._a16 > other._a16) return true;
        if (this._a16 < other._a16) return false;
        return this._a00 > other._a00;
    };
    /**
	 * Less than (strict)
	 * @method lt
	 * @param {Object} other UINT64
	 * @return {Boolean}
	 */ UINT64.prototype.lessThan = UINT64.prototype.lt = function(other) {
        if (this._a48 < other._a48) return true;
        if (this._a48 > other._a48) return false;
        if (this._a32 < other._a32) return true;
        if (this._a32 > other._a32) return false;
        if (this._a16 < other._a16) return true;
        if (this._a16 > other._a16) return false;
        return this._a00 < other._a00;
    };
    /**
	 * Bitwise OR
	 * @method or
	 * @param {Object} other UINT64
	 * @return ThisExpression
	 */ UINT64.prototype.or = function(other) {
        this._a00 |= other._a00;
        this._a16 |= other._a16;
        this._a32 |= other._a32;
        this._a48 |= other._a48;
        return this;
    };
    /**
	 * Bitwise AND
	 * @method and
	 * @param {Object} other UINT64
	 * @return ThisExpression
	 */ UINT64.prototype.and = function(other) {
        this._a00 &= other._a00;
        this._a16 &= other._a16;
        this._a32 &= other._a32;
        this._a48 &= other._a48;
        return this;
    };
    /**
	 * Bitwise XOR
	 * @method xor
	 * @param {Object} other UINT64
	 * @return ThisExpression
	 */ UINT64.prototype.xor = function(other) {
        this._a00 ^= other._a00;
        this._a16 ^= other._a16;
        this._a32 ^= other._a32;
        this._a48 ^= other._a48;
        return this;
    };
    /**
	 * Bitwise NOT
	 * @method not
	 * @return ThisExpression
	 */ UINT64.prototype.not = function() {
        this._a00 = ~this._a00 & 0xFFFF;
        this._a16 = ~this._a16 & 0xFFFF;
        this._a32 = ~this._a32 & 0xFFFF;
        this._a48 = ~this._a48 & 0xFFFF;
        return this;
    };
    /**
	 * Bitwise shift right
	 * @method shiftRight
	 * @param {Number} number of bits to shift
	 * @return ThisExpression
	 */ UINT64.prototype.shiftRight = UINT64.prototype.shiftr = function(n) {
        n %= 64;
        if (n >= 48) {
            this._a00 = this._a48 >> n - 48;
            this._a16 = 0;
            this._a32 = 0;
            this._a48 = 0;
        } else if (n >= 32) {
            n -= 32;
            this._a00 = (this._a32 >> n | this._a48 << 16 - n) & 0xFFFF;
            this._a16 = this._a48 >> n & 0xFFFF;
            this._a32 = 0;
            this._a48 = 0;
        } else if (n >= 16) {
            n -= 16;
            this._a00 = (this._a16 >> n | this._a32 << 16 - n) & 0xFFFF;
            this._a16 = (this._a32 >> n | this._a48 << 16 - n) & 0xFFFF;
            this._a32 = this._a48 >> n & 0xFFFF;
            this._a48 = 0;
        } else {
            this._a00 = (this._a00 >> n | this._a16 << 16 - n) & 0xFFFF;
            this._a16 = (this._a16 >> n | this._a32 << 16 - n) & 0xFFFF;
            this._a32 = (this._a32 >> n | this._a48 << 16 - n) & 0xFFFF;
            this._a48 = this._a48 >> n & 0xFFFF;
        }
        return this;
    };
    /**
	 * Bitwise shift left
	 * @method shiftLeft
	 * @param {Number} number of bits to shift
	 * @param {Boolean} allow overflow
	 * @return ThisExpression
	 */ UINT64.prototype.shiftLeft = UINT64.prototype.shiftl = function(n, allowOverflow) {
        n %= 64;
        if (n >= 48) {
            this._a48 = this._a00 << n - 48;
            this._a32 = 0;
            this._a16 = 0;
            this._a00 = 0;
        } else if (n >= 32) {
            n -= 32;
            this._a48 = this._a16 << n | this._a00 >> 16 - n;
            this._a32 = this._a00 << n & 0xFFFF;
            this._a16 = 0;
            this._a00 = 0;
        } else if (n >= 16) {
            n -= 16;
            this._a48 = this._a32 << n | this._a16 >> 16 - n;
            this._a32 = (this._a16 << n | this._a00 >> 16 - n) & 0xFFFF;
            this._a16 = this._a00 << n & 0xFFFF;
            this._a00 = 0;
        } else {
            this._a48 = this._a48 << n | this._a32 >> 16 - n;
            this._a32 = (this._a32 << n | this._a16 >> 16 - n) & 0xFFFF;
            this._a16 = (this._a16 << n | this._a00 >> 16 - n) & 0xFFFF;
            this._a00 = this._a00 << n & 0xFFFF;
        }
        if (!allowOverflow) this._a48 &= 0xFFFF;
        return this;
    };
    /**
	 * Bitwise rotate left
	 * @method rotl
	 * @param {Number} number of bits to rotate
	 * @return ThisExpression
	 */ UINT64.prototype.rotateLeft = UINT64.prototype.rotl = function(n) {
        n %= 64;
        if (n == 0) return this;
        if (n >= 32) {
            // A.B.C.D
            // B.C.D.A rotl(16)
            // C.D.A.B rotl(32)
            var v = this._a00;
            this._a00 = this._a32;
            this._a32 = v;
            v = this._a48;
            this._a48 = this._a16;
            this._a16 = v;
            if (n == 32) return this;
            n -= 32;
        }
        var high = this._a48 << 16 | this._a32;
        var low = this._a16 << 16 | this._a00;
        var _high = high << n | low >>> 32 - n;
        var _low = low << n | high >>> 32 - n;
        this._a00 = _low & 0xFFFF;
        this._a16 = _low >>> 16;
        this._a32 = _high & 0xFFFF;
        this._a48 = _high >>> 16;
        return this;
    };
    /**
	 * Bitwise rotate right
	 * @method rotr
	 * @param {Number} number of bits to rotate
	 * @return ThisExpression
	 */ UINT64.prototype.rotateRight = UINT64.prototype.rotr = function(n) {
        n %= 64;
        if (n == 0) return this;
        if (n >= 32) {
            // A.B.C.D
            // D.A.B.C rotr(16)
            // C.D.A.B rotr(32)
            var v = this._a00;
            this._a00 = this._a32;
            this._a32 = v;
            v = this._a48;
            this._a48 = this._a16;
            this._a16 = v;
            if (n == 32) return this;
            n -= 32;
        }
        var high = this._a48 << 16 | this._a32;
        var low = this._a16 << 16 | this._a00;
        var _high = high >>> n | low << 32 - n;
        var _low = low >>> n | high << 32 - n;
        this._a00 = _low & 0xFFFF;
        this._a16 = _low >>> 16;
        this._a32 = _high & 0xFFFF;
        this._a48 = _high >>> 16;
        return this;
    };
    /**
	 * Clone the current _UINT64_
	 * @method clone
	 * @return {Object} cloned UINT64
	 */ UINT64.prototype.clone = function() {
        return new UINT64(this._a00, this._a16, this._a32, this._a48);
    };
    if (typeof define != 'undefined' && define.amd) // AMD / RequireJS
    define([], function() {
        return UINT64;
    });
    else if (0, module.exports) // Node.js
    module.exports = UINT64;
    else // Browser
    root['UINT64'] = UINT64;
})(module.exports);

});



parcelRegister("7oN96", function(module, exports) {
/**
xxHash64 implementation in pure Javascript

Copyright (C) 2016, Pierre Curto
MIT license
*/ 
var $6ZWSX = parcelRequire("6ZWSX");
var $5630e5a750f18a96$require$Buffer = $6ZWSX.Buffer;

var $9Vawi = parcelRequire("9Vawi");
var $5630e5a750f18a96$require$UINT64 = $9Vawi.UINT64;
/*
 * Constants
 */ var $5630e5a750f18a96$var$PRIME64_1 = $5630e5a750f18a96$require$UINT64('11400714785074694791');
var $5630e5a750f18a96$var$PRIME64_2 = $5630e5a750f18a96$require$UINT64('14029467366897019727');
var $5630e5a750f18a96$var$PRIME64_3 = $5630e5a750f18a96$require$UINT64('1609587929392839161');
var $5630e5a750f18a96$var$PRIME64_4 = $5630e5a750f18a96$require$UINT64('9650029242287828579');
var $5630e5a750f18a96$var$PRIME64_5 = $5630e5a750f18a96$require$UINT64('2870177450012600261');
/**
* Convert string to proper UTF-8 array
* @param str Input string
* @returns {Uint8Array} UTF8 array is returned as uint8 array
*/ function $5630e5a750f18a96$var$toUTF8Array(str) {
    var utf8 = [];
    for(var i = 0, n = str.length; i < n; i++){
        var charcode = str.charCodeAt(i);
        if (charcode < 0x80) utf8.push(charcode);
        else if (charcode < 0x800) utf8.push(0xc0 | charcode >> 6, 0x80 | charcode & 0x3f);
        else if (charcode < 0xd800 || charcode >= 0xe000) utf8.push(0xe0 | charcode >> 12, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
        else {
            i++;
            // UTF-16 encodes 0x10000-0x10FFFF by
            // subtracting 0x10000 and splitting the
            // 20 bits of 0x0-0xFFFFF into two halves
            charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
            utf8.push(0xf0 | charcode >> 18, 0x80 | charcode >> 12 & 0x3f, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
        }
    }
    return new Uint8Array(utf8);
}
/**
 * XXH64 object used as a constructor or a function
 * @constructor
 * or
 * @param {Object|String} input data
 * @param {Number|UINT64} seed
 * @return ThisExpression
 * or
 * @return {UINT64} xxHash
 */ function $5630e5a750f18a96$var$XXH64() {
    if (arguments.length == 2) return new $5630e5a750f18a96$var$XXH64(arguments[1]).update(arguments[0]).digest();
    if (!(this instanceof $5630e5a750f18a96$var$XXH64)) return new $5630e5a750f18a96$var$XXH64(arguments[0]);
    $5630e5a750f18a96$var$init.call(this, arguments[0]);
}
/**
 * Initialize the XXH64 instance with the given seed
 * @method init
 * @param {Number|Object} seed as a number or an unsigned 32 bits integer
 * @return ThisExpression
 */ function $5630e5a750f18a96$var$init(seed) {
    this.seed = seed instanceof $5630e5a750f18a96$require$UINT64 ? seed.clone() : $5630e5a750f18a96$require$UINT64(seed);
    this.v1 = this.seed.clone().add($5630e5a750f18a96$var$PRIME64_1).add($5630e5a750f18a96$var$PRIME64_2);
    this.v2 = this.seed.clone().add($5630e5a750f18a96$var$PRIME64_2);
    this.v3 = this.seed.clone();
    this.v4 = this.seed.clone().subtract($5630e5a750f18a96$var$PRIME64_1);
    this.total_len = 0;
    this.memsize = 0;
    this.memory = null;
    return this;
}
$5630e5a750f18a96$var$XXH64.prototype.init = $5630e5a750f18a96$var$init;
/**
 * Add data to be computed for the XXH64 hash
 * @method update
 * @param {String|Buffer|ArrayBuffer} input as a string or nodejs Buffer or ArrayBuffer
 * @return ThisExpression
 */ $5630e5a750f18a96$var$XXH64.prototype.update = function(input) {
    var isString = typeof input == 'string';
    var isArrayBuffer;
    // Convert all strings to utf-8 first (issue #5)
    if (isString) {
        input = $5630e5a750f18a96$var$toUTF8Array(input);
        isString = false;
        isArrayBuffer = true;
    }
    if (typeof ArrayBuffer !== "undefined" && input instanceof ArrayBuffer) {
        isArrayBuffer = true;
        input = new Uint8Array(input);
    }
    var p = 0;
    var len = input.length;
    var bEnd = p + len;
    if (len == 0) return this;
    this.total_len += len;
    if (this.memsize == 0) {
        if (isString) this.memory = '';
        else if (isArrayBuffer) this.memory = new Uint8Array(32);
        else this.memory = new $5630e5a750f18a96$require$Buffer(32);
    }
    if (this.memsize + len < 32) {
        // XXH64_memcpy(this.memory + this.memsize, input, len)
        if (isString) this.memory += input;
        else if (isArrayBuffer) this.memory.set(input.subarray(0, len), this.memsize);
        else input.copy(this.memory, this.memsize, 0, len);
        this.memsize += len;
        return this;
    }
    if (this.memsize > 0) {
        // XXH64_memcpy(this.memory + this.memsize, input, 16-this.memsize);
        if (isString) this.memory += input.slice(0, 32 - this.memsize);
        else if (isArrayBuffer) this.memory.set(input.subarray(0, 32 - this.memsize), this.memsize);
        else input.copy(this.memory, this.memsize, 0, 32 - this.memsize);
        var p64 = 0;
        if (isString) {
            var other;
            other = $5630e5a750f18a96$require$UINT64(this.memory.charCodeAt(p64 + 1) << 8 | this.memory.charCodeAt(p64), this.memory.charCodeAt(p64 + 3) << 8 | this.memory.charCodeAt(p64 + 2), this.memory.charCodeAt(p64 + 5) << 8 | this.memory.charCodeAt(p64 + 4), this.memory.charCodeAt(p64 + 7) << 8 | this.memory.charCodeAt(p64 + 6));
            this.v1.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
            p64 += 8;
            other = $5630e5a750f18a96$require$UINT64(this.memory.charCodeAt(p64 + 1) << 8 | this.memory.charCodeAt(p64), this.memory.charCodeAt(p64 + 3) << 8 | this.memory.charCodeAt(p64 + 2), this.memory.charCodeAt(p64 + 5) << 8 | this.memory.charCodeAt(p64 + 4), this.memory.charCodeAt(p64 + 7) << 8 | this.memory.charCodeAt(p64 + 6));
            this.v2.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
            p64 += 8;
            other = $5630e5a750f18a96$require$UINT64(this.memory.charCodeAt(p64 + 1) << 8 | this.memory.charCodeAt(p64), this.memory.charCodeAt(p64 + 3) << 8 | this.memory.charCodeAt(p64 + 2), this.memory.charCodeAt(p64 + 5) << 8 | this.memory.charCodeAt(p64 + 4), this.memory.charCodeAt(p64 + 7) << 8 | this.memory.charCodeAt(p64 + 6));
            this.v3.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
            p64 += 8;
            other = $5630e5a750f18a96$require$UINT64(this.memory.charCodeAt(p64 + 1) << 8 | this.memory.charCodeAt(p64), this.memory.charCodeAt(p64 + 3) << 8 | this.memory.charCodeAt(p64 + 2), this.memory.charCodeAt(p64 + 5) << 8 | this.memory.charCodeAt(p64 + 4), this.memory.charCodeAt(p64 + 7) << 8 | this.memory.charCodeAt(p64 + 6));
            this.v4.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
        } else {
            var other;
            other = $5630e5a750f18a96$require$UINT64(this.memory[p64 + 1] << 8 | this.memory[p64], this.memory[p64 + 3] << 8 | this.memory[p64 + 2], this.memory[p64 + 5] << 8 | this.memory[p64 + 4], this.memory[p64 + 7] << 8 | this.memory[p64 + 6]);
            this.v1.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
            p64 += 8;
            other = $5630e5a750f18a96$require$UINT64(this.memory[p64 + 1] << 8 | this.memory[p64], this.memory[p64 + 3] << 8 | this.memory[p64 + 2], this.memory[p64 + 5] << 8 | this.memory[p64 + 4], this.memory[p64 + 7] << 8 | this.memory[p64 + 6]);
            this.v2.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
            p64 += 8;
            other = $5630e5a750f18a96$require$UINT64(this.memory[p64 + 1] << 8 | this.memory[p64], this.memory[p64 + 3] << 8 | this.memory[p64 + 2], this.memory[p64 + 5] << 8 | this.memory[p64 + 4], this.memory[p64 + 7] << 8 | this.memory[p64 + 6]);
            this.v3.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
            p64 += 8;
            other = $5630e5a750f18a96$require$UINT64(this.memory[p64 + 1] << 8 | this.memory[p64], this.memory[p64 + 3] << 8 | this.memory[p64 + 2], this.memory[p64 + 5] << 8 | this.memory[p64 + 4], this.memory[p64 + 7] << 8 | this.memory[p64 + 6]);
            this.v4.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
        }
        p += 32 - this.memsize;
        this.memsize = 0;
        if (isString) this.memory = '';
    }
    if (p <= bEnd - 32) {
        var limit = bEnd - 32;
        do {
            if (isString) {
                var other;
                other = $5630e5a750f18a96$require$UINT64(input.charCodeAt(p + 1) << 8 | input.charCodeAt(p), input.charCodeAt(p + 3) << 8 | input.charCodeAt(p + 2), input.charCodeAt(p + 5) << 8 | input.charCodeAt(p + 4), input.charCodeAt(p + 7) << 8 | input.charCodeAt(p + 6));
                this.v1.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
                p += 8;
                other = $5630e5a750f18a96$require$UINT64(input.charCodeAt(p + 1) << 8 | input.charCodeAt(p), input.charCodeAt(p + 3) << 8 | input.charCodeAt(p + 2), input.charCodeAt(p + 5) << 8 | input.charCodeAt(p + 4), input.charCodeAt(p + 7) << 8 | input.charCodeAt(p + 6));
                this.v2.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
                p += 8;
                other = $5630e5a750f18a96$require$UINT64(input.charCodeAt(p + 1) << 8 | input.charCodeAt(p), input.charCodeAt(p + 3) << 8 | input.charCodeAt(p + 2), input.charCodeAt(p + 5) << 8 | input.charCodeAt(p + 4), input.charCodeAt(p + 7) << 8 | input.charCodeAt(p + 6));
                this.v3.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
                p += 8;
                other = $5630e5a750f18a96$require$UINT64(input.charCodeAt(p + 1) << 8 | input.charCodeAt(p), input.charCodeAt(p + 3) << 8 | input.charCodeAt(p + 2), input.charCodeAt(p + 5) << 8 | input.charCodeAt(p + 4), input.charCodeAt(p + 7) << 8 | input.charCodeAt(p + 6));
                this.v4.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
            } else {
                var other;
                other = $5630e5a750f18a96$require$UINT64(input[p + 1] << 8 | input[p], input[p + 3] << 8 | input[p + 2], input[p + 5] << 8 | input[p + 4], input[p + 7] << 8 | input[p + 6]);
                this.v1.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
                p += 8;
                other = $5630e5a750f18a96$require$UINT64(input[p + 1] << 8 | input[p], input[p + 3] << 8 | input[p + 2], input[p + 5] << 8 | input[p + 4], input[p + 7] << 8 | input[p + 6]);
                this.v2.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
                p += 8;
                other = $5630e5a750f18a96$require$UINT64(input[p + 1] << 8 | input[p], input[p + 3] << 8 | input[p + 2], input[p + 5] << 8 | input[p + 4], input[p + 7] << 8 | input[p + 6]);
                this.v3.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
                p += 8;
                other = $5630e5a750f18a96$require$UINT64(input[p + 1] << 8 | input[p], input[p + 3] << 8 | input[p + 2], input[p + 5] << 8 | input[p + 4], input[p + 7] << 8 | input[p + 6]);
                this.v4.add(other.multiply($5630e5a750f18a96$var$PRIME64_2)).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
            }
            p += 8;
        }while (p <= limit);
    }
    if (p < bEnd) {
        // XXH64_memcpy(this.memory, p, bEnd-p);
        if (isString) this.memory += input.slice(p);
        else if (isArrayBuffer) this.memory.set(input.subarray(p, bEnd), this.memsize);
        else input.copy(this.memory, this.memsize, p, bEnd);
        this.memsize = bEnd - p;
    }
    return this;
};
/**
 * Finalize the XXH64 computation. The XXH64 instance is ready for reuse for the given seed
 * @method digest
 * @return {UINT64} xxHash
 */ $5630e5a750f18a96$var$XXH64.prototype.digest = function() {
    var input = this.memory;
    var isString = typeof input == 'string';
    var p = 0;
    var bEnd = this.memsize;
    var h64, h;
    var u = new $5630e5a750f18a96$require$UINT64;
    if (this.total_len >= 32) {
        h64 = this.v1.clone().rotl(1);
        h64.add(this.v2.clone().rotl(7));
        h64.add(this.v3.clone().rotl(12));
        h64.add(this.v4.clone().rotl(18));
        h64.xor(this.v1.multiply($5630e5a750f18a96$var$PRIME64_2).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1));
        h64.multiply($5630e5a750f18a96$var$PRIME64_1).add($5630e5a750f18a96$var$PRIME64_4);
        h64.xor(this.v2.multiply($5630e5a750f18a96$var$PRIME64_2).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1));
        h64.multiply($5630e5a750f18a96$var$PRIME64_1).add($5630e5a750f18a96$var$PRIME64_4);
        h64.xor(this.v3.multiply($5630e5a750f18a96$var$PRIME64_2).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1));
        h64.multiply($5630e5a750f18a96$var$PRIME64_1).add($5630e5a750f18a96$var$PRIME64_4);
        h64.xor(this.v4.multiply($5630e5a750f18a96$var$PRIME64_2).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1));
        h64.multiply($5630e5a750f18a96$var$PRIME64_1).add($5630e5a750f18a96$var$PRIME64_4);
    } else h64 = this.seed.clone().add($5630e5a750f18a96$var$PRIME64_5);
    h64.add(u.fromNumber(this.total_len));
    while(p <= bEnd - 8){
        if (isString) u.fromBits(input.charCodeAt(p + 1) << 8 | input.charCodeAt(p), input.charCodeAt(p + 3) << 8 | input.charCodeAt(p + 2), input.charCodeAt(p + 5) << 8 | input.charCodeAt(p + 4), input.charCodeAt(p + 7) << 8 | input.charCodeAt(p + 6));
        else u.fromBits(input[p + 1] << 8 | input[p], input[p + 3] << 8 | input[p + 2], input[p + 5] << 8 | input[p + 4], input[p + 7] << 8 | input[p + 6]);
        u.multiply($5630e5a750f18a96$var$PRIME64_2).rotl(31).multiply($5630e5a750f18a96$var$PRIME64_1);
        h64.xor(u).rotl(27).multiply($5630e5a750f18a96$var$PRIME64_1).add($5630e5a750f18a96$var$PRIME64_4);
        p += 8;
    }
    if (p + 4 <= bEnd) {
        if (isString) u.fromBits(input.charCodeAt(p + 1) << 8 | input.charCodeAt(p), input.charCodeAt(p + 3) << 8 | input.charCodeAt(p + 2), 0, 0);
        else u.fromBits(input[p + 1] << 8 | input[p], input[p + 3] << 8 | input[p + 2], 0, 0);
        h64.xor(u.multiply($5630e5a750f18a96$var$PRIME64_1)).rotl(23).multiply($5630e5a750f18a96$var$PRIME64_2).add($5630e5a750f18a96$var$PRIME64_3);
        p += 4;
    }
    while(p < bEnd){
        u.fromBits(isString ? input.charCodeAt(p++) : input[p++], 0, 0, 0);
        h64.xor(u.multiply($5630e5a750f18a96$var$PRIME64_5)).rotl(11).multiply($5630e5a750f18a96$var$PRIME64_1);
    }
    h = h64.clone().shiftRight(33);
    h64.xor(h).multiply($5630e5a750f18a96$var$PRIME64_2);
    h = h64.clone().shiftRight(29);
    h64.xor(h).multiply($5630e5a750f18a96$var$PRIME64_3);
    h = h64.clone().shiftRight(32);
    h64.xor(h);
    // Reset the state
    this.init(this.seed);
    return h64;
};
module.exports = $5630e5a750f18a96$var$XXH64;

});

parcelRegister("iH75M", function(module, exports) {
"use strict";
var $d9c1be84d93c8898$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d9c1be84d93c8898$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d9c1be84d93c8898$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d9c1be84d93c8898$var$__createBinding(result, mod, k);
    }
    $d9c1be84d93c8898$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.right = $d9c1be84d93c8898$var$right;
module.exports.left = $d9c1be84d93c8898$var$left;
module.exports.rightF = $d9c1be84d93c8898$var$rightF;
module.exports.leftF = $d9c1be84d93c8898$var$leftF;
module.exports.fromNullable = $d9c1be84d93c8898$var$fromNullable;
module.exports.fromNullableK = $d9c1be84d93c8898$var$fromNullableK;
module.exports.chainNullableK = $d9c1be84d93c8898$var$chainNullableK;
module.exports.map = $d9c1be84d93c8898$var$map;
module.exports.ap = $d9c1be84d93c8898$var$ap;
module.exports.chain = $d9c1be84d93c8898$var$chain;
module.exports.flatMap = $d9c1be84d93c8898$var$flatMap;
module.exports.alt = $d9c1be84d93c8898$var$alt;
module.exports.bimap = $d9c1be84d93c8898$var$bimap;
module.exports.mapBoth = $d9c1be84d93c8898$var$mapBoth;
module.exports.mapLeft = $d9c1be84d93c8898$var$mapLeft;
module.exports.mapError = $d9c1be84d93c8898$var$mapError;
module.exports.altValidation = $d9c1be84d93c8898$var$altValidation;
module.exports.match = $d9c1be84d93c8898$var$match;
module.exports.matchE = $d9c1be84d93c8898$var$matchE;
module.exports.getOrElse = $d9c1be84d93c8898$var$getOrElse;
module.exports.orElse = $d9c1be84d93c8898$var$orElse;
module.exports.orElseFirst = $d9c1be84d93c8898$var$orElseFirst;
module.exports.tapError = $d9c1be84d93c8898$var$tapError;
module.exports.orLeft = $d9c1be84d93c8898$var$orLeft;
module.exports.swap = $d9c1be84d93c8898$var$swap;
module.exports.toUnion = $d9c1be84d93c8898$var$toUnion;
module.exports.getEitherM = $d9c1be84d93c8898$var$getEitherM;

var $4sfjE = parcelRequire("4sfjE");

var $d9c1be84d93c8898$var$E = $d9c1be84d93c8898$var$__importStar((parcelRequire("5uDEp")));

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");
function $d9c1be84d93c8898$var$right(F) {
    return (0, $3abDJ.flow)($d9c1be84d93c8898$var$E.right, F.of);
}
function $d9c1be84d93c8898$var$left(F) {
    return (0, $3abDJ.flow)($d9c1be84d93c8898$var$E.left, F.of);
}
function $d9c1be84d93c8898$var$rightF(F) {
    return function(fa) {
        return F.map(fa, $d9c1be84d93c8898$var$E.right);
    };
}
function $d9c1be84d93c8898$var$leftF(F) {
    return function(fe) {
        return F.map(fe, $d9c1be84d93c8898$var$E.left);
    };
}
function $d9c1be84d93c8898$var$fromNullable(F) {
    return function(e) {
        return (0, $3abDJ.flow)($d9c1be84d93c8898$var$E.fromNullable(e), F.of);
    };
}
function $d9c1be84d93c8898$var$fromNullableK(F) {
    var fromNullableF = $d9c1be84d93c8898$var$fromNullable(F);
    return function(e) {
        var fromNullableFE = fromNullableF(e);
        return function(f) {
            return (0, $3abDJ.flow)(f, fromNullableFE);
        };
    };
}
function $d9c1be84d93c8898$var$chainNullableK(M) {
    var chainM = $d9c1be84d93c8898$var$chain(M);
    var fromNullableKM = $d9c1be84d93c8898$var$fromNullableK(M);
    return function(e) {
        var fromNullableKMe = fromNullableKM(e);
        return function(f) {
            return chainM(fromNullableKMe(f));
        };
    };
}
function $d9c1be84d93c8898$var$map(F) {
    return (0, $emm1u.map)(F, $d9c1be84d93c8898$var$E.Functor);
}
function $d9c1be84d93c8898$var$ap(F) {
    return (0, $4sfjE.ap)(F, $d9c1be84d93c8898$var$E.Apply);
}
function $d9c1be84d93c8898$var$chain(M) {
    var flatMapM = $d9c1be84d93c8898$var$flatMap(M);
    return function(f) {
        return function(ma) {
            return flatMapM(ma, f);
        };
    };
}
/** @internal */ function $d9c1be84d93c8898$var$flatMap(M) {
    return function(ma, f) {
        return M.chain(ma, function(e) {
            return $d9c1be84d93c8898$var$E.isLeft(e) ? M.of(e) : f(e.right);
        });
    };
}
function $d9c1be84d93c8898$var$alt(M) {
    return function(second) {
        return function(first) {
            return M.chain(first, function(e) {
                return $d9c1be84d93c8898$var$E.isLeft(e) ? second() : M.of(e);
            });
        };
    };
}
function $d9c1be84d93c8898$var$bimap(F) {
    var mapBothF = $d9c1be84d93c8898$var$mapBoth(F);
    return function(f, g) {
        return function(self) {
            return mapBothF(self, f, g);
        };
    };
}
/** @internal */ function $d9c1be84d93c8898$var$mapBoth(F) {
    return function(self, f, g) {
        return F.map(self, $d9c1be84d93c8898$var$E.bimap(f, g));
    };
}
function $d9c1be84d93c8898$var$mapLeft(F) {
    var mapErrorF = $d9c1be84d93c8898$var$mapError(F);
    return function(f) {
        return function(self) {
            return mapErrorF(self, f);
        };
    };
}
/** @internal */ function $d9c1be84d93c8898$var$mapError(F) {
    return function(self, f) {
        return F.map(self, $d9c1be84d93c8898$var$E.mapLeft(f));
    };
}
function $d9c1be84d93c8898$var$altValidation(M, S) {
    return function(second) {
        return function(first) {
            return M.chain(first, $d9c1be84d93c8898$var$E.match(function(e1) {
                return M.map(second(), $d9c1be84d93c8898$var$E.mapLeft(function(e2) {
                    return S.concat(e1, e2);
                }));
            }, $d9c1be84d93c8898$var$right(M)));
        };
    };
}
function $d9c1be84d93c8898$var$match(F) {
    return function(onLeft, onRight) {
        return function(ma) {
            return F.map(ma, $d9c1be84d93c8898$var$E.match(onLeft, onRight));
        };
    };
}
function $d9c1be84d93c8898$var$matchE(M) {
    return function(onLeft, onRight) {
        return function(ma) {
            return M.chain(ma, $d9c1be84d93c8898$var$E.match(onLeft, onRight));
        };
    };
}
function $d9c1be84d93c8898$var$getOrElse(M) {
    return function(onLeft) {
        return function(ma) {
            return M.chain(ma, $d9c1be84d93c8898$var$E.match(onLeft, M.of));
        };
    };
}
function $d9c1be84d93c8898$var$orElse(M) {
    return function(onLeft) {
        return function(ma) {
            return M.chain(ma, function(e) {
                return $d9c1be84d93c8898$var$E.isLeft(e) ? onLeft(e.left) : M.of(e);
            });
        };
    };
}
function $d9c1be84d93c8898$var$orElseFirst(M) {
    var tapErrorM = $d9c1be84d93c8898$var$tapError(M);
    return function(onLeft) {
        return function(ma) {
            return tapErrorM(ma, onLeft);
        };
    };
}
/** @internal */ function $d9c1be84d93c8898$var$tapError(M) {
    var orElseM = $d9c1be84d93c8898$var$orElse(M);
    return function(ma, onLeft) {
        return (0, $3abDJ.pipe)(ma, orElseM(function(e) {
            return M.map(onLeft(e), function(eb) {
                return $d9c1be84d93c8898$var$E.isLeft(eb) ? eb : $d9c1be84d93c8898$var$E.left(e);
            });
        }));
    };
}
function $d9c1be84d93c8898$var$orLeft(M) {
    return function(onLeft) {
        return function(ma) {
            return M.chain(ma, $d9c1be84d93c8898$var$E.match(function(e) {
                return M.map(onLeft(e), $d9c1be84d93c8898$var$E.left);
            }, function(a) {
                return M.of($d9c1be84d93c8898$var$E.right(a));
            }));
        };
    };
}
function $d9c1be84d93c8898$var$swap(F) {
    return function(ma) {
        return F.map(ma, $d9c1be84d93c8898$var$E.swap);
    };
}
function $d9c1be84d93c8898$var$toUnion(F) {
    return function(fa) {
        return F.map(fa, $d9c1be84d93c8898$var$E.toUnion);
    };
}
/** @deprecated  */ /* istanbul ignore next */ function $d9c1be84d93c8898$var$getEitherM(M) {
    var _ap = $d9c1be84d93c8898$var$ap(M);
    var _map = $d9c1be84d93c8898$var$map(M);
    var _chain = $d9c1be84d93c8898$var$chain(M);
    var _alt = $d9c1be84d93c8898$var$alt(M);
    var _bimap = $d9c1be84d93c8898$var$bimap(M);
    var _mapLeft = $d9c1be84d93c8898$var$mapLeft(M);
    var _fold = $d9c1be84d93c8898$var$matchE(M);
    var _getOrElse = $d9c1be84d93c8898$var$getOrElse(M);
    var _orElse = $d9c1be84d93c8898$var$orElse(M);
    return {
        map: function(fa, f) {
            return (0, $3abDJ.pipe)(fa, _map(f));
        },
        ap: function(fab, fa) {
            return (0, $3abDJ.pipe)(fab, _ap(fa));
        },
        of: $d9c1be84d93c8898$var$right(M),
        chain: function(ma, f) {
            return (0, $3abDJ.pipe)(ma, _chain(f));
        },
        alt: function(fa, that) {
            return (0, $3abDJ.pipe)(fa, _alt(that));
        },
        bimap: function(fea, f, g) {
            return (0, $3abDJ.pipe)(fea, _bimap(f, g));
        },
        mapLeft: function(fea, f) {
            return (0, $3abDJ.pipe)(fea, _mapLeft(f));
        },
        fold: function(fa, onLeft, onRight) {
            return (0, $3abDJ.pipe)(fa, _fold(onLeft, onRight));
        },
        getOrElse: function(fa, onLeft) {
            return (0, $3abDJ.pipe)(fa, _getOrElse(onLeft));
        },
        orElse: function(fa, f) {
            return (0, $3abDJ.pipe)(fa, _orElse(f));
        },
        swap: $d9c1be84d93c8898$var$swap(M),
        rightM: $d9c1be84d93c8898$var$rightF(M),
        leftM: $d9c1be84d93c8898$var$leftF(M),
        left: $d9c1be84d93c8898$var$left(M)
    };
}

});

parcelRegister("mttaN", function(module, exports) {
"use strict";
var $0438ea395f983b92$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0438ea395f983b92$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0438ea395f983b92$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0438ea395f983b92$var$__createBinding(result, mod, k);
    }
    $0438ea395f983b92$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chainFirst = module.exports.chain = module.exports.sequenceSeqArray = module.exports.traverseSeqArray = module.exports.traverseSeqArrayWithIndex = module.exports.sequenceArray = module.exports.traverseArray = module.exports.traverseArrayWithIndex = module.exports.traverseReadonlyArrayWithIndexSeq = module.exports.traverseReadonlyNonEmptyArrayWithIndexSeq = module.exports.traverseReadonlyArrayWithIndex = module.exports.traverseReadonlyNonEmptyArrayWithIndex = module.exports.ApT = module.exports.apS = module.exports.bind = module.exports.let = module.exports.bindTo = module.exports.Do = module.exports.never = module.exports.FromTask = module.exports.chainFirstIOK = module.exports.chainIOK = module.exports.fromIOK = module.exports.tapIO = module.exports.tap = module.exports.flatMapIO = module.exports.FromIO = module.exports.MonadTask = module.exports.fromTask = module.exports.MonadIO = module.exports.Monad = module.exports.Chain = module.exports.ApplicativeSeq = module.exports.ApplySeq = module.exports.ApplicativePar = module.exports.apSecond = module.exports.apFirst = module.exports.ApplyPar = module.exports.Pointed = module.exports.flap = module.exports.asUnit = module.exports.as = module.exports.Functor = module.exports.URI = module.exports.flatten = module.exports.flatMap = module.exports.of = module.exports.ap = module.exports.map = module.exports.fromIO = void 0;
module.exports.getMonoid = module.exports.getSemigroup = module.exports.taskSeq = module.exports.task = void 0;
module.exports.delay = $0438ea395f983b92$var$delay;
module.exports.getRaceMonoid = $0438ea395f983b92$var$getRaceMonoid;

var $eImHL = parcelRequire("eImHL");

var $4sfjE = parcelRequire("4sfjE");

var $0438ea395f983b92$var$chainable = $0438ea395f983b92$var$__importStar((parcelRequire("ERVGH")));

var $bycRW = parcelRequire("bycRW");

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");

var $0438ea395f983b92$var$_ = $0438ea395f983b92$var$__importStar((parcelRequire("704qB")));
// -------------------------------------------------------------------------------------
// conversions
// -------------------------------------------------------------------------------------
/**
 * @category conversions
 * @since 2.0.0
 */ var $0438ea395f983b92$var$fromIO = function(ma) {
    return function() {
        return Promise.resolve().then(ma);
    };
};
module.exports.fromIO = $0438ea395f983b92$var$fromIO;
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * Creates a task that will complete after a time delay
 *
 * @example
 * import { sequenceT } from 'fp-ts/Apply'
 * import * as T from 'fp-ts/Task'
 * import { takeRight } from 'fp-ts/Array'
 *
 * async function test() {
 *   const log: Array<string> = []
 *   const append = (message: string): T.Task<void> =>
 *     T.fromIO(() => {
 *       log.push(message)
 *     })
 *   const fa = append('a')
 *   const fb = T.delay(20)(append('b'))
 *   const fc = T.delay(10)(append('c'))
 *   const fd = append('d')
 *   await sequenceT(T.ApplyPar)(fa, fb, fc, fd)()
 *   assert.deepStrictEqual(takeRight(2)(log), ['c', 'b'])
 * }
 *
 * test()
 *
 * @since 2.0.0
 */ function $0438ea395f983b92$var$delay(millis) {
    return function(ma) {
        return function() {
            return new Promise(function(resolve) {
                setTimeout(function() {
                    Promise.resolve().then(ma).then(resolve);
                }, millis);
            });
        };
    };
}
var $0438ea395f983b92$var$_map = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, module.exports.map)(f));
};
var $0438ea395f983b92$var$_apPar = function(fab, fa) {
    return (0, $3abDJ.pipe)(fab, (0, module.exports.ap)(fa));
};
var $0438ea395f983b92$var$_apSeq = function(fab, fa) {
    return (0, module.exports.flatMap)(fab, function(f) {
        return (0, $3abDJ.pipe)(fa, (0, module.exports.map)(f));
    });
};
/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
 * use the type constructor `F` to represent some computational context.
 *
 * @category mapping
 * @since 2.0.0
 */ var $0438ea395f983b92$var$map = function(f) {
    return function(fa) {
        return function() {
            return Promise.resolve().then(fa).then(f);
        };
    };
};
module.exports.map = $0438ea395f983b92$var$map;
/**
 * @since 2.0.0
 */ var $0438ea395f983b92$var$ap = function(fa) {
    return function(fab) {
        return function() {
            return Promise.all([
                Promise.resolve().then(fab),
                Promise.resolve().then(fa)
            ]).then(function(_a) {
                var f = _a[0], a = _a[1];
                return f(a);
            });
        };
    };
};
module.exports.ap = $0438ea395f983b92$var$ap;
/**
 * @category constructors
 * @since 2.0.0
 */ var $0438ea395f983b92$var$of = function(a) {
    return function() {
        return Promise.resolve(a);
    };
};
module.exports.of = $0438ea395f983b92$var$of;
/**
 * @category sequencing
 * @since 2.14.0
 */ module.exports.flatMap = (0, $3abDJ.dual)(2, function(ma, f) {
    return function() {
        return Promise.resolve().then(ma).then(function(a) {
            return f(a)();
        });
    };
});
/**
 * @category sequencing
 * @since 2.0.0
 */ module.exports.flatten = (0, module.exports.flatMap)($3abDJ.identity);
/**
 * @category type lambdas
 * @since 2.0.0
 */ module.exports.URI = 'Task';
/**
 * Monoid returning the first completed task.
 *
 * Note: uses `Promise.race` internally.
 *
 * @example
 * import * as T from 'fp-ts/Task'
 *
 * async function test() {
 *   const S = T.getRaceMonoid<string>()
 *   const fa = T.delay(20)(T.of('a'))
 *   const fb = T.delay(10)(T.of('b'))
 *   assert.deepStrictEqual(await S.concat(fa, fb)(), 'b')
 * }
 *
 * test()
 *
 * @category instances
 * @since 2.0.0
 */ function $0438ea395f983b92$var$getRaceMonoid() {
    return {
        concat: function(x, y) {
            return function() {
                return Promise.race([
                    Promise.resolve().then(x),
                    Promise.resolve().then(y)
                ]);
            };
        },
        empty: module.exports.never
    };
}
/**
 * @category instances
 * @since 2.7.0
 */ module.exports.Functor = {
    URI: module.exports.URI,
    map: $0438ea395f983b92$var$_map
};
/**
 * Maps the value to the specified constant value.
 *
 * @category mapping
 * @since 2.16.0
 */ module.exports.as = (0, $3abDJ.dual)(2, (0, $emm1u.as)(module.exports.Functor));
/**
 * Maps the value to the void constant value.
 *
 * @category mapping
 * @since 2.16.0
 */ module.exports.asUnit = (0, $emm1u.asUnit)(module.exports.Functor);
/**
 * @category mapping
 * @since 2.10.0
 */ module.exports.flap = (0, $emm1u.flap)(module.exports.Functor);
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Pointed = {
    URI: module.exports.URI,
    of: module.exports.of
};
/**
 * Runs computations in parallel.
 *
 * @category instances
 * @since 2.10.0
 */ module.exports.ApplyPar = {
    URI: module.exports.URI,
    map: $0438ea395f983b92$var$_map,
    ap: $0438ea395f983b92$var$_apPar
};
/**
 * Combine two effectful actions, keeping only the result of the first.
 *
 * @since 2.0.0
 */ module.exports.apFirst = (0, $4sfjE.apFirst)(module.exports.ApplyPar);
/**
 * Combine two effectful actions, keeping only the result of the second.
 *
 * @since 2.0.0
 */ module.exports.apSecond = (0, $4sfjE.apSecond)(module.exports.ApplyPar);
/**
 * Runs computations in parallel.
 *
 * @category instances
 * @since 2.7.0
 */ module.exports.ApplicativePar = {
    URI: module.exports.URI,
    map: $0438ea395f983b92$var$_map,
    ap: $0438ea395f983b92$var$_apPar,
    of: module.exports.of
};
/**
 * Runs computations sequentially.
 *
 * @category instances
 * @since 2.10.0
 */ module.exports.ApplySeq = {
    URI: module.exports.URI,
    map: $0438ea395f983b92$var$_map,
    ap: $0438ea395f983b92$var$_apSeq
};
/**
 * Runs computations sequentially.
 *
 * @category instances
 * @since 2.7.0
 */ module.exports.ApplicativeSeq = {
    URI: module.exports.URI,
    map: $0438ea395f983b92$var$_map,
    ap: $0438ea395f983b92$var$_apSeq,
    of: module.exports.of
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Chain = {
    URI: module.exports.URI,
    map: $0438ea395f983b92$var$_map,
    ap: $0438ea395f983b92$var$_apPar,
    chain: module.exports.flatMap
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.Monad = {
    URI: module.exports.URI,
    map: $0438ea395f983b92$var$_map,
    of: module.exports.of,
    ap: $0438ea395f983b92$var$_apPar,
    chain: module.exports.flatMap
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.MonadIO = {
    URI: module.exports.URI,
    map: $0438ea395f983b92$var$_map,
    of: module.exports.of,
    ap: $0438ea395f983b92$var$_apPar,
    chain: module.exports.flatMap,
    fromIO: module.exports.fromIO
};
/**
 * @category zone of death
 * @since 2.7.0
 * @deprecated
 */ module.exports.fromTask = $3abDJ.identity;
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.MonadTask = {
    URI: module.exports.URI,
    map: $0438ea395f983b92$var$_map,
    of: module.exports.of,
    ap: $0438ea395f983b92$var$_apPar,
    chain: module.exports.flatMap,
    fromIO: module.exports.fromIO,
    fromTask: module.exports.fromTask
};
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.FromIO = {
    URI: module.exports.URI,
    fromIO: module.exports.fromIO
};
/** @internal */ var $0438ea395f983b92$var$_FlatMap = {
    flatMap: module.exports.flatMap
};
/** @internal */ var $0438ea395f983b92$var$_FromIO = {
    fromIO: module.exports.FromIO.fromIO
};
/**
 * @category sequencing
 * @since 2.16.0
 */ module.exports.flatMapIO = $0438ea395f983b92$var$_.flatMapIO($0438ea395f983b92$var$_FromIO, $0438ea395f983b92$var$_FlatMap);
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * @category combinators
 * @since 2.15.0
 */ module.exports.tap = (0, $3abDJ.dual)(2, $0438ea395f983b92$var$chainable.tap(module.exports.Chain));
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * @example
 * import { pipe } from 'fp-ts/function'
 * import * as T from 'fp-ts/Task'
 * import * as Console from 'fp-ts/Console'
 *
 * // Will produce `Hello, fp-ts` to the stdout
 * const effect = pipe(
 *   T.of('fp-ts'),
 *   T.tapIO((value) => Console.log(`Hello, ${value}`)),
 * )
 *
 * async function test() {
 *   assert.deepStrictEqual(await effect(), 'fp-ts')
 * }
 *
 * test()
 *
 * @category combinators
 * @since 2.16.0
 */ module.exports.tapIO = (0, $3abDJ.dual)(2, (0, $bycRW.tapIO)(module.exports.FromIO, module.exports.Chain));
/**
 * @category lifting
 * @since 2.4.0
 */ module.exports.fromIOK = /*#__PURE__*/ (0, $bycRW.fromIOK)(module.exports.FromIO);
/**
 * Alias of `flatMapIO`.
 *
 * @category legacy
 * @since 2.4.0
 */ module.exports.chainIOK = module.exports.flatMapIO;
/**
 * Alias of `tapIO`.
 *
 * @category legacy
 * @since 2.10.0
 */ module.exports.chainFirstIOK = module.exports.tapIO;
/**
 * @category instances
 * @since 2.10.0
 */ module.exports.FromTask = {
    URI: module.exports.URI,
    fromIO: module.exports.fromIO,
    fromTask: module.exports.fromTask
};
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * A `Task` that never completes.
 *
 * @since 2.0.0
 */ var $0438ea395f983b92$var$never = function() {
    return new Promise(function(_) {
        return undefined;
    });
};
module.exports.never = $0438ea395f983b92$var$never;
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * @category do notation
 * @since 2.9.0
 */ module.exports.Do = (0, module.exports.of)($0438ea395f983b92$var$_.emptyRecord);
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.bindTo = (0, $emm1u.bindTo)(module.exports.Functor);
var $0438ea395f983b92$var$let_ = /*#__PURE__*/ (0, $emm1u.let)(module.exports.Functor);
module.exports.let = $0438ea395f983b92$var$let_;
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.bind = $0438ea395f983b92$var$chainable.bind(module.exports.Chain);
/**
 * @category do notation
 * @since 2.8.0
 */ module.exports.apS = (0, $4sfjE.apS)(module.exports.ApplyPar);
/**
 * @since 2.11.0
 */ module.exports.ApT = (0, module.exports.of)($0438ea395f983b92$var$_.emptyReadonlyArray);
// -------------------------------------------------------------------------------------
// array utils
// -------------------------------------------------------------------------------------
/**
 * Equivalent to `ReadonlyNonEmptyArray#traverseWithIndex(ApplicativePar)`.
 *
 * @category traversing
 * @since 2.11.0
 */ var $0438ea395f983b92$var$traverseReadonlyNonEmptyArrayWithIndex = function(f) {
    return function(as) {
        return function() {
            return Promise.all(as.map(function(a, i) {
                return Promise.resolve().then(function() {
                    return f(i, a)();
                });
            }));
        };
    };
};
module.exports.traverseReadonlyNonEmptyArrayWithIndex = $0438ea395f983b92$var$traverseReadonlyNonEmptyArrayWithIndex;
/**
 * Equivalent to `ReadonlyArray#traverseWithIndex(ApplicativePar)`.
 *
 * @category traversing
 * @since 2.11.0
 */ var $0438ea395f983b92$var$traverseReadonlyArrayWithIndex = function(f) {
    var g = (0, module.exports.traverseReadonlyNonEmptyArrayWithIndex)(f);
    return function(as) {
        return $0438ea395f983b92$var$_.isNonEmpty(as) ? g(as) : module.exports.ApT;
    };
};
module.exports.traverseReadonlyArrayWithIndex = $0438ea395f983b92$var$traverseReadonlyArrayWithIndex;
/**
 * Equivalent to `ReadonlyNonEmptyArray#traverseWithIndex(ApplicativeSeq)`.
 *
 * @category traversing
 * @since 2.11.0
 */ var $0438ea395f983b92$var$traverseReadonlyNonEmptyArrayWithIndexSeq = function(f) {
    return function(as) {
        return function() {
            return $0438ea395f983b92$var$_.tail(as).reduce(function(acc, a, i) {
                return acc.then(function(bs) {
                    return Promise.resolve().then(f(i + 1, a)).then(function(b) {
                        bs.push(b);
                        return bs;
                    });
                });
            }, Promise.resolve().then(f(0, $0438ea395f983b92$var$_.head(as))).then($0438ea395f983b92$var$_.singleton));
        };
    };
};
module.exports.traverseReadonlyNonEmptyArrayWithIndexSeq = $0438ea395f983b92$var$traverseReadonlyNonEmptyArrayWithIndexSeq;
/**
 * Equivalent to `ReadonlyArray#traverseWithIndex(ApplicativeSeq)`.
 *
 * @category traversing
 * @since 2.11.0
 */ var $0438ea395f983b92$var$traverseReadonlyArrayWithIndexSeq = function(f) {
    var g = (0, module.exports.traverseReadonlyNonEmptyArrayWithIndexSeq)(f);
    return function(as) {
        return $0438ea395f983b92$var$_.isNonEmpty(as) ? g(as) : module.exports.ApT;
    };
};
module.exports.traverseReadonlyArrayWithIndexSeq = $0438ea395f983b92$var$traverseReadonlyArrayWithIndexSeq;
/**
 * Equivalent to `ReadonlyArray#traverseWithIndex(Applicative)`.
 *
 * @category traversing
 * @since 2.9.0
 */ module.exports.traverseArrayWithIndex = module.exports.traverseReadonlyArrayWithIndex;
/**
 * Equivalent to `ReadonlyArray#traverse(Applicative)`.
 *
 * @category traversing
 * @since 2.9.0
 */ var $0438ea395f983b92$var$traverseArray = function(f) {
    return (0, module.exports.traverseReadonlyArrayWithIndex)(function(_, a) {
        return f(a);
    });
};
module.exports.traverseArray = $0438ea395f983b92$var$traverseArray;
/**
 * Equivalent to `ReadonlyArray#sequence(Applicative)`.
 *
 * @category traversing
 * @since 2.9.0
 */ module.exports.sequenceArray = /*#__PURE__*/ (0, module.exports.traverseArray)($3abDJ.identity);
/**
 * Equivalent to `ReadonlyArray#traverseWithIndex(ApplicativeSeq)`.
 *
 * @category traversing
 * @since 2.9.0
 */ module.exports.traverseSeqArrayWithIndex = module.exports.traverseReadonlyArrayWithIndexSeq;
/**
 * Equivalent to `ReadonlyArray#traverse(ApplicativeSeq)`.
 *
 * @category traversing
 * @since 2.9.0
 */ var $0438ea395f983b92$var$traverseSeqArray = function(f) {
    return (0, module.exports.traverseReadonlyArrayWithIndexSeq)(function(_, a) {
        return f(a);
    });
};
module.exports.traverseSeqArray = $0438ea395f983b92$var$traverseSeqArray;
/**
 * Equivalent to `ReadonlyArray#sequence(ApplicativeSeq)`.
 *
 * @category traversing
 * @since 2.9.0
 */ module.exports.sequenceSeqArray = /*#__PURE__*/ (0, module.exports.traverseSeqArray)($3abDJ.identity);
// -------------------------------------------------------------------------------------
// legacy
// -------------------------------------------------------------------------------------
/**
 * Alias of `flatMap`.
 *
 * @category legacy
 * @since 2.0.0
 */ module.exports.chain = module.exports.flatMap;
/**
 * Alias of `tap`.
 *
 * @category legacy
 * @since 2.0.0
 */ module.exports.chainFirst = module.exports.tap;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Functor` instance, pass `T.Functor` instead of `T.task`
 * (where `T` is from `import T from 'fp-ts/Task'`)
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.task = {
    URI: module.exports.URI,
    map: $0438ea395f983b92$var$_map,
    of: module.exports.of,
    ap: $0438ea395f983b92$var$_apPar,
    chain: module.exports.flatMap,
    fromIO: module.exports.fromIO,
    fromTask: module.exports.fromTask
};
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Functor` instance, pass `T.Functor` instead of `T.taskSeq`
 * (where `T` is from `import T from 'fp-ts/Task'`)
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.taskSeq = {
    URI: module.exports.URI,
    map: $0438ea395f983b92$var$_map,
    of: module.exports.of,
    ap: $0438ea395f983b92$var$_apSeq,
    chain: module.exports.flatMap,
    fromIO: module.exports.fromIO,
    fromTask: module.exports.fromTask
};
/**
 * Use [`getApplySemigroup`](./Apply.ts.html#getapplysemigroup) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getSemigroup = (0, $4sfjE.getApplySemigroup)(module.exports.ApplySeq);
/**
 * Use [`getApplicativeMonoid`](./Applicative.ts.html#getapplicativemonoid) instead.
 *
 * Lift a monoid into 'Task', the inner values are concatenated using the provided `Monoid`.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ module.exports.getMonoid = (0, $eImHL.getApplicativeMonoid)(module.exports.ApplicativeSeq);

});
parcelRegister("bycRW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromIOK = $868cda2efa4d06d8$var$fromIOK;
module.exports.chainIOK = $868cda2efa4d06d8$var$chainIOK;
module.exports.chainFirstIOK = $868cda2efa4d06d8$var$chainFirstIOK;
module.exports.tapIO = $868cda2efa4d06d8$var$tapIO;

var $ERVGH = parcelRequire("ERVGH");

var $3abDJ = parcelRequire("3abDJ");
function $868cda2efa4d06d8$var$fromIOK(F) {
    return function(f) {
        return (0, $3abDJ.flow)(f, F.fromIO);
    };
}
function $868cda2efa4d06d8$var$chainIOK(F, M) {
    return function(f) {
        var g = (0, $3abDJ.flow)(f, F.fromIO);
        return function(first) {
            return M.chain(first, g);
        };
    };
}
function $868cda2efa4d06d8$var$chainFirstIOK(F, M) {
    var tapIOM = $868cda2efa4d06d8$var$tapIO(F, M);
    return function(f) {
        return function(first) {
            return tapIOM(first, f);
        };
    };
}
/** @internal */ function $868cda2efa4d06d8$var$tapIO(F, M) {
    var chainFirstM = (0, $ERVGH.tap)(M);
    return function(self, f) {
        return chainFirstM(self, (0, $3abDJ.flow)(f, F.fromIO));
    };
}

});


parcelRegister("hkN9y", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c9ea6eb6e1b0be83$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c9ea6eb6e1b0be83$var$MAX_UINT32 = 4294967295;
function $c9ea6eb6e1b0be83$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $1U9GM = parcelRequire("1U9GM");
var $c9ea6eb6e1b0be83$require$Buffer = $1U9GM.Buffer;
var $c9ea6eb6e1b0be83$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c9ea6eb6e1b0be83$var$crypto && $c9ea6eb6e1b0be83$var$crypto.getRandomValues) module.exports = $c9ea6eb6e1b0be83$var$randomBytes;
else module.exports = $c9ea6eb6e1b0be83$var$oldBrowser;
function $c9ea6eb6e1b0be83$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c9ea6eb6e1b0be83$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $c9ea6eb6e1b0be83$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c9ea6eb6e1b0be83$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c9ea6eb6e1b0be83$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes.slice(generated, generated + $c9ea6eb6e1b0be83$var$MAX_BYTES));
        else $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $hPtJY.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6ZWSX.SlowBuffer(size);
};

});


parcelRegister("1R2J7", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $loYLU = parcelRequire("loYLU");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $26nOC = parcelRequire("26nOC");
function $159cdb2c74f453a8$var$Hash(hash) {
    $26nOC.call(this, 'digest');
    this._hash = hash;
}
$dlqwk($159cdb2c74f453a8$var$Hash, $26nOC);
$159cdb2c74f453a8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$159cdb2c74f453a8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $loYLU();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $a8qBR();
    return new $159cdb2c74f453a8$var$Hash($5Z1sR(alg));
};

});
parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("loYLU", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");

var $1U9GM = parcelRequire("1U9GM");
var $f94afad95abc0930$require$Buffer = $1U9GM.Buffer;
var $f94afad95abc0930$var$ARRAY16 = new Array(16);
function $f94afad95abc0930$var$MD5() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dlqwk($f94afad95abc0930$var$MD5, $eLdEM);
$f94afad95abc0930$var$MD5.prototype._update = function() {
    var M = $f94afad95abc0930$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f94afad95abc0930$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f94afad95abc0930$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f94afad95abc0930$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f94afad95abc0930$var$fnF(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnG(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnH(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnI(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f94afad95abc0930$var$MD5;

});
parcelRegister("eLdEM", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $abf00c68ae11d39d$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $abf00c68ae11d39d$require$Transform = $ioRHp.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $abf00c68ae11d39d$var$HashBase(blockSize) {
    $abf00c68ae11d39d$require$Transform.call(this);
    this._block = $abf00c68ae11d39d$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($abf00c68ae11d39d$var$HashBase, $abf00c68ae11d39d$require$Transform);
$abf00c68ae11d39d$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
var $abf00c68ae11d39d$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $abf00c68ae11d39d$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($abf00c68ae11d39d$require$Buffer.prototype instanceof Uint8Array || $abf00c68ae11d39d$require$Buffer.TYPED_ARRAY_SUPPORT);
function $abf00c68ae11d39d$var$toBuffer(data, encoding) {
    // No need to do anything for exact instance
    // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
    if (data instanceof $abf00c68ae11d39d$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $abf00c68ae11d39d$require$Buffer.from(data, encoding);
    /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */ if ($abf00c68ae11d39d$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        if (data.byteLength === 0) return $abf00c68ae11d39d$require$Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        ;
        var res = $abf00c68ae11d39d$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        // Recheck result size, as offset/length doesn't work on Node.js <5.10
        // We just go to Uint8Array case if this fails
        if (res.byteLength === data.byteLength) return res;
    }
    /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */ if ($abf00c68ae11d39d$var$useUint8Array && data instanceof Uint8Array) return $abf00c68ae11d39d$require$Buffer.from(data);
    /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */ if ($abf00c68ae11d39d$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $abf00c68ae11d39d$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$abf00c68ae11d39d$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    data = $abf00c68ae11d39d$var$toBuffer(data, encoding) // asserts correct input type
    ;
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$abf00c68ae11d39d$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$abf00c68ae11d39d$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$abf00c68ae11d39d$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $abf00c68ae11d39d$var$HashBase;

});
parcelRegister("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("aBufs"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("6XbcT"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("fFuzr"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("k3Gr9"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("6G2fH"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("hzqCm"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("coyuH"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5440e9199a418654$var$R = typeof Reflect === 'object' ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === 'function' ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === 'function') $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("aBufs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = $7b84d2ca8f0d8afd$var$Readable;
/*<replacement>*/ var $7b84d2ca8f0d8afd$var$Duplex;
/*</replacement>*/ $7b84d2ca8f0d8afd$var$Readable.ReadableState = $7b84d2ca8f0d8afd$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $7b84d2ca8f0d8afd$require$EE = $7etJZ.EventEmitter;
var $7b84d2ca8f0d8afd$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $7b84d2ca8f0d8afd$require$Buffer = $6ZWSX.Buffer;
var $7b84d2ca8f0d8afd$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk) {
    return $7b84d2ca8f0d8afd$require$Buffer.from(chunk);
}
function $7b84d2ca8f0d8afd$var$_isUint8Array(obj) {
    return $7b84d2ca8f0d8afd$require$Buffer.isBuffer(obj) || obj instanceof $7b84d2ca8f0d8afd$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $7b84d2ca8f0d8afd$var$debug;
if ($kjyEk && $kjyEk.debuglog) $7b84d2ca8f0d8afd$var$debug = $kjyEk.debuglog('stream');
else $7b84d2ca8f0d8afd$var$debug = function debug() {};

var $6aKSQ = parcelRequire("6aKSQ");

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $7b84d2ca8f0d8afd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $7b84d2ca8f0d8afd$require$_require$codes = $967Aq.codes;
var $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE = $7b84d2ca8f0d8afd$require$_require$codes.ERR_INVALID_ARG_TYPE, $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED = $7b84d2ca8f0d8afd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $7b84d2ca8f0d8afd$var$StringDecoder;
var $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator;
var $7b84d2ca8f0d8afd$var$from;

(parcelRequire("dlqwk"))($7b84d2ca8f0d8afd$var$Readable, $jJj7p);
var $7b84d2ca8f0d8afd$var$errorOrDestroy = $fnDgj.errorOrDestroy;
var $7b84d2ca8f0d8afd$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $7b84d2ca8f0d8afd$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $7b84d2ca8f0d8afd$var$ReadableState(options, stream, isDuplex) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $7b84d2ca8f0d8afd$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $7b84d2ca8f0d8afd$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $6aKSQ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $7b84d2ca8f0d8afd$var$Readable(options) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    if (!(this instanceof $7b84d2ca8f0d8afd$var$Readable)) return new $7b84d2ca8f0d8afd$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $7b84d2ca8f0d8afd$var$Duplex;
    this._readableState = new $7b84d2ca8f0d8afd$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $jJj7p.call(this);
}
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$7b84d2ca8f0d8afd$var$Readable.prototype.destroy = $fnDgj.destroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._undestroy = $fnDgj.undestroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$7b84d2ca8f0d8afd$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $7b84d2ca8f0d8afd$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$7b84d2ca8f0d8afd$var$Readable.prototype.unshift = function(chunk) {
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, null, true, false);
};
function $7b84d2ca8f0d8afd$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $7b84d2ca8f0d8afd$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $7b84d2ca8f0d8afd$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk);
        if (er) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $7b84d2ca8f0d8afd$require$Buffer.prototype) chunk = $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
                    else $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
                } else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $7b84d2ca8f0d8afd$var$emitReadable(stream);
    }
    $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
}
function $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk) {
    var er;
    if (!$7b84d2ca8f0d8afd$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$7b84d2ca8f0d8afd$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$7b84d2ca8f0d8afd$var$Readable.prototype.setEncoding = function(enc) {
    if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $7b84d2ca8f0d8afd$var$MAX_HWM = 0x40000000;
function $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n) {
    if (n >= $7b84d2ca8f0d8afd$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $7b84d2ca8f0d8afd$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$7b84d2ca8f0d8afd$var$Readable.prototype.read = function(n) {
    $7b84d2ca8f0d8afd$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $7b84d2ca8f0d8afd$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
        else $7b84d2ca8f0d8afd$var$emitReadable(this);
        return null;
    }
    n = $7b84d2ca8f0d8afd$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $7b84d2ca8f0d8afd$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $7b84d2ca8f0d8afd$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $7b84d2ca8f0d8afd$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $7b84d2ca8f0d8afd$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $7b84d2ca8f0d8afd$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $7b84d2ca8f0d8afd$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $7b84d2ca8f0d8afd$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $7b84d2ca8f0d8afd$var$onEofChunk(stream, state) {
    $7b84d2ca8f0d8afd$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $7b84d2ca8f0d8afd$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $7b84d2ca8f0d8afd$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $7b84d2ca8f0d8afd$var$emitReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $7b84d2ca8f0d8afd$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$emitReadable_, stream);
    }
}
function $7b84d2ca8f0d8afd$var$emitReadable_(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $7b84d2ca8f0d8afd$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$maybeReadMore_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $7b84d2ca8f0d8afd$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$7b84d2ca8f0d8afd$var$Readable.prototype._read = function(n) {
    $7b84d2ca8f0d8afd$var$errorOrDestroy(this, new $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$7b84d2ca8f0d8afd$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $7b84d2ca8f0d8afd$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $7b84d2ca8f0d8afd$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $7b84d2ca8f0d8afd$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $7b84d2ca8f0d8afd$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $7b84d2ca8f0d8afd$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $7b84d2ca8f0d8afd$var$debug('ondata');
        var ret = dest.write(chunk);
        $7b84d2ca8f0d8afd$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $7b84d2ca8f0d8afd$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $7b84d2ca8f0d8afd$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($7b84d2ca8f0d8afd$var$EElistenerCount(dest, 'error') === 0) $7b84d2ca8f0d8afd$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $7b84d2ca8f0d8afd$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $7b84d2ca8f0d8afd$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $7b84d2ca8f0d8afd$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $7b84d2ca8f0d8afd$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $7b84d2ca8f0d8afd$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $7b84d2ca8f0d8afd$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $7b84d2ca8f0d8afd$var$flow(src);
        }
    };
}
$7b84d2ca8f0d8afd$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$7b84d2ca8f0d8afd$var$Readable.prototype.on = function(ev, fn) {
    var res = $jJj7p.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $7b84d2ca8f0d8afd$var$debug('on readable', state.length, state.reading);
            if (state.length) $7b84d2ca8f0d8afd$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($7b84d2ca8f0d8afd$var$nReadingNextTick, this);
        }
    }
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.addListener = $7b84d2ca8f0d8afd$var$Readable.prototype.on;
$7b84d2ca8f0d8afd$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jJj7p.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jJj7p.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
function $7b84d2ca8f0d8afd$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $7b84d2ca8f0d8afd$var$nReadingNextTick(self1) {
    $7b84d2ca8f0d8afd$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$7b84d2ca8f0d8afd$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $7b84d2ca8f0d8afd$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $7b84d2ca8f0d8afd$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$resume_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$resume_(stream, state) {
    $7b84d2ca8f0d8afd$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $7b84d2ca8f0d8afd$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$7b84d2ca8f0d8afd$var$Readable.prototype.pause = function() {
    $7b84d2ca8f0d8afd$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $7b84d2ca8f0d8afd$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $7b84d2ca8f0d8afd$var$flow(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$7b84d2ca8f0d8afd$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $7b84d2ca8f0d8afd$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $7b84d2ca8f0d8afd$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $7b84d2ca8f0d8afd$var$kProxyEvents.length; n++)stream.on($7b84d2ca8f0d8afd$var$kProxyEvents[n], this.emit.bind(this, $7b84d2ca8f0d8afd$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $7b84d2ca8f0d8afd$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $7b84d2ca8f0d8afd$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator === undefined) $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator = (parcelRequire("3etzH"));
    return $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$7b84d2ca8f0d8afd$var$Readable._fromList = $7b84d2ca8f0d8afd$var$fromList;
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $7b84d2ca8f0d8afd$var$endReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$endReadableNT, state, stream);
    }
}
function $7b84d2ca8f0d8afd$var$endReadableNT(state, stream) {
    $7b84d2ca8f0d8afd$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $7b84d2ca8f0d8afd$var$Readable.from = function(iterable, opts) {
    if ($7b84d2ca8f0d8afd$var$from === undefined) $7b84d2ca8f0d8afd$var$from = (parcelRequire("gN4Jr"));
    return $7b84d2ca8f0d8afd$var$from($7b84d2ca8f0d8afd$var$Readable, iterable, opts);
};
function $7b84d2ca8f0d8afd$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jJj7p", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("6aKSQ", function(module, exports) {
'use strict';
function $47e80b5d1f4ca857$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $47e80b5d1f4ca857$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $47e80b5d1f4ca857$var$ownKeys(Object(source), !0).forEach(function(key) {
            $47e80b5d1f4ca857$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $47e80b5d1f4ca857$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $47e80b5d1f4ca857$var$_defineProperty(obj, key, value) {
    key = $47e80b5d1f4ca857$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $47e80b5d1f4ca857$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $47e80b5d1f4ca857$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $47e80b5d1f4ca857$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $47e80b5d1f4ca857$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $47e80b5d1f4ca857$var$_toPropertyKey(arg) {
    var key = $47e80b5d1f4ca857$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $47e80b5d1f4ca857$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $47e80b5d1f4ca857$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $47e80b5d1f4ca857$var$inspect = $kjyEk.inspect;
var $47e80b5d1f4ca857$var$custom = $47e80b5d1f4ca857$var$inspect && $47e80b5d1f4ca857$var$inspect.custom || 'inspect';
function $47e80b5d1f4ca857$var$copyBuffer(src, target, offset) {
    $47e80b5d1f4ca857$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $47e80b5d1f4ca857$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $47e80b5d1f4ca857$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $47e80b5d1f4ca857$var$Buffer.alloc(0);
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $47e80b5d1f4ca857$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $47e80b5d1f4ca857$var$custom,
            value: function value(_, options) {
                return $47e80b5d1f4ca857$var$inspect(this, $47e80b5d1f4ca857$var$_objectSpread($47e80b5d1f4ca857$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fnDgj", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $b32775a19d7a76d1$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
    });
    return this;
}
function $b32775a19d7a76d1$var$emitErrorAndCloseNT(self, err) {
    $b32775a19d7a76d1$var$emitErrorNT(self, err);
    $b32775a19d7a76d1$var$emitCloseNT(self);
}
function $b32775a19d7a76d1$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $b32775a19d7a76d1$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b32775a19d7a76d1$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $b32775a19d7a76d1$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $b32775a19d7a76d1$var$destroy,
    undestroy: $b32775a19d7a76d1$var$undestroy,
    errorOrDestroy: $b32775a19d7a76d1$var$errorOrDestroy
};

});

parcelRegister("5yyyA", function(module, exports) {
'use strict';

var $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE = (parcelRequire("967Aq")).codes.ERR_INVALID_OPT_VALUE;
function $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $40baeeffbb52bbd0$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $40baeeffbb52bbd0$var$getHighWaterMark
};

});
parcelRegister("967Aq", function(module, exports) {

$parcel$export(module.exports, "codes", () => $69fa8f23fe6fc7e7$export$e45cb6485273080e, (v) => $69fa8f23fe6fc7e7$export$e45cb6485273080e = v);
var $69fa8f23fe6fc7e7$export$e45cb6485273080e;
'use strict';
function $69fa8f23fe6fc7e7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $69fa8f23fe6fc7e7$var$codes = {};
function $69fa8f23fe6fc7e7$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $69fa8f23fe6fc7e7$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $69fa8f23fe6fc7e7$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $69fa8f23fe6fc7e7$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $69fa8f23fe6fc7e7$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $69fa8f23fe6fc7e7$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $69fa8f23fe6fc7e7$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$69fa8f23fe6fc7e7$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $69fa8f23fe6fc7e7$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($69fa8f23fe6fc7e7$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, 'type'));
    else {
        var type = $69fa8f23fe6fc7e7$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$69fa8f23fe6fc7e7$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$69fa8f23fe6fc7e7$export$e45cb6485273080e = $69fa8f23fe6fc7e7$var$codes;

});


parcelRegister("fFuzr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
/*<replacement>*/ var $b682660ac74fe757$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $b682660ac74fe757$var$Duplex;

var $aBufs = parcelRequire("aBufs");

var $6XbcT = parcelRequire("6XbcT");

(parcelRequire("dlqwk"))($b682660ac74fe757$var$Duplex, $aBufs);
// Allow the keys array to be GC'ed.
var $b682660ac74fe757$var$keys = $b682660ac74fe757$var$objectKeys($6XbcT.prototype);
for(var $b682660ac74fe757$var$v = 0; $b682660ac74fe757$var$v < $b682660ac74fe757$var$keys.length; $b682660ac74fe757$var$v++){
    var $b682660ac74fe757$var$method = $b682660ac74fe757$var$keys[$b682660ac74fe757$var$v];
    if (!$b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method]) $b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method] = $6XbcT.prototype[$b682660ac74fe757$var$method];
}
function $b682660ac74fe757$var$Duplex(options) {
    if (!(this instanceof $b682660ac74fe757$var$Duplex)) return new $b682660ac74fe757$var$Duplex(options);
    $aBufs.call(this, options);
    $6XbcT.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $b682660ac74fe757$var$onend);
        }
    }
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $b682660ac74fe757$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($b682660ac74fe757$var$onEndNT, this);
}
function $b682660ac74fe757$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("6XbcT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = $5100f23d2ab8fadd$var$Writable;
/* <replacement> */ function $5100f23d2ab8fadd$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5100f23d2ab8fadd$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5100f23d2ab8fadd$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5100f23d2ab8fadd$var$Duplex;
/*</replacement>*/ $5100f23d2ab8fadd$var$Writable.WritableState = $5100f23d2ab8fadd$var$WritableState;

/*<replacement>*/ var $5100f23d2ab8fadd$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $5100f23d2ab8fadd$require$Buffer = $6ZWSX.Buffer;
var $5100f23d2ab8fadd$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk) {
    return $5100f23d2ab8fadd$require$Buffer.from(chunk);
}
function $5100f23d2ab8fadd$var$_isUint8Array(obj) {
    return $5100f23d2ab8fadd$require$Buffer.isBuffer(obj) || obj instanceof $5100f23d2ab8fadd$var$OurUint8Array;
}

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $5100f23d2ab8fadd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $5100f23d2ab8fadd$require$_require$codes = $967Aq.codes;
var $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE = $5100f23d2ab8fadd$require$_require$codes.ERR_INVALID_ARG_TYPE, $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED = $5100f23d2ab8fadd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK = $5100f23d2ab8fadd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_DESTROYED, $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_NULL_VALUES, $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING = $5100f23d2ab8fadd$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $5100f23d2ab8fadd$var$errorOrDestroy = $fnDgj.errorOrDestroy;

(parcelRequire("dlqwk"))($5100f23d2ab8fadd$var$Writable, $jJj7p);
function $5100f23d2ab8fadd$var$nop() {}

function $5100f23d2ab8fadd$var$WritableState(options, stream, isDuplex) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $5100f23d2ab8fadd$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $5100f23d2ab8fadd$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5100f23d2ab8fadd$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(this);
}
$5100f23d2ab8fadd$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5100f23d2ab8fadd$var$WritableState.prototype, 'buffer', {
            get: $5100f23d2ab8fadd$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5100f23d2ab8fadd$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $5100f23d2ab8fadd$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5100f23d2ab8fadd$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($5100f23d2ab8fadd$var$realHasInstance.call(this, object)) return true;
            if (this !== $5100f23d2ab8fadd$var$Writable) return false;
            return object && object._writableState instanceof $5100f23d2ab8fadd$var$WritableState;
        }
    });
} else $5100f23d2ab8fadd$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $5100f23d2ab8fadd$var$Writable(options) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5100f23d2ab8fadd$var$Duplex;
    if (!isDuplex && !$5100f23d2ab8fadd$var$realHasInstance.call($5100f23d2ab8fadd$var$Writable, this)) return new $5100f23d2ab8fadd$var$Writable(options);
    this._writableState = new $5100f23d2ab8fadd$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $jJj7p.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5100f23d2ab8fadd$var$Writable.prototype.pipe = function() {
    $5100f23d2ab8fadd$var$errorOrDestroy(this, new $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE());
};
function $5100f23d2ab8fadd$var$writeAfterEnd(stream, cb) {
    var er = new $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5100f23d2ab8fadd$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$5100f23d2ab8fadd$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5100f23d2ab8fadd$var$_isUint8Array(chunk);
    if (isBuf && !$5100f23d2ab8fadd$require$Buffer.isBuffer(chunk)) chunk = $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $5100f23d2ab8fadd$var$nop;
    if (state.ending) $5100f23d2ab8fadd$var$writeAfterEnd(this, cb);
    else if (isBuf || $5100f23d2ab8fadd$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5100f23d2ab8fadd$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5100f23d2ab8fadd$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$5100f23d2ab8fadd$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(this, state);
    }
};
$5100f23d2ab8fadd$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $5100f23d2ab8fadd$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5100f23d2ab8fadd$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5100f23d2ab8fadd$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($5100f23d2ab8fadd$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    }
}
function $5100f23d2ab8fadd$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5100f23d2ab8fadd$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK();
    $5100f23d2ab8fadd$var$onwriteStateUpdate(state);
    if (er) $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5100f23d2ab8fadd$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($5100f23d2ab8fadd$var$afterWrite, stream, state, finished, cb);
        else $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb);
    }
}
function $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5100f23d2ab8fadd$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5100f23d2ab8fadd$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $5100f23d2ab8fadd$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5100f23d2ab8fadd$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5100f23d2ab8fadd$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$5100f23d2ab8fadd$var$Writable.prototype._writev = null;
$5100f23d2ab8fadd$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $5100f23d2ab8fadd$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $5100f23d2ab8fadd$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5100f23d2ab8fadd$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $5100f23d2ab8fadd$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    });
}
function $5100f23d2ab8fadd$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($5100f23d2ab8fadd$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $5100f23d2ab8fadd$var$finishMaybe(stream, state) {
    var need = $5100f23d2ab8fadd$var$needFinish(state);
    if (need) {
        $5100f23d2ab8fadd$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $5100f23d2ab8fadd$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5100f23d2ab8fadd$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5100f23d2ab8fadd$var$Writable.prototype.destroy = $fnDgj.destroy;
$5100f23d2ab8fadd$var$Writable.prototype._undestroy = $fnDgj.undestroy;
$5100f23d2ab8fadd$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config('throwDeprecation')) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("3etzH", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
var $25a99ede456543b7$var$_Object$setPrototypeO;
function $25a99ede456543b7$var$_defineProperty(obj, key, value) {
    key = $25a99ede456543b7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $25a99ede456543b7$var$_toPropertyKey(arg) {
    var key = $25a99ede456543b7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $25a99ede456543b7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $hzqCm = parcelRequire("hzqCm");
var $25a99ede456543b7$var$kLastResolve = Symbol('lastResolve');
var $25a99ede456543b7$var$kLastReject = Symbol('lastReject');
var $25a99ede456543b7$var$kError = Symbol('error');
var $25a99ede456543b7$var$kEnded = Symbol('ended');
var $25a99ede456543b7$var$kLastPromise = Symbol('lastPromise');
var $25a99ede456543b7$var$kHandlePromise = Symbol('handlePromise');
var $25a99ede456543b7$var$kStream = Symbol('stream');
function $25a99ede456543b7$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $25a99ede456543b7$var$readAndResolve(iter) {
    var resolve = iter[$25a99ede456543b7$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$25a99ede456543b7$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$25a99ede456543b7$var$kLastPromise] = null;
            iter[$25a99ede456543b7$var$kLastResolve] = null;
            iter[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(data, false));
        }
    }
}
function $25a99ede456543b7$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($25a99ede456543b7$var$readAndResolve, iter);
}
function $25a99ede456543b7$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$25a99ede456543b7$var$kEnded]) {
                resolve($25a99ede456543b7$var$createIterResult(undefined, true));
                return;
            }
            iter[$25a99ede456543b7$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $25a99ede456543b7$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($25a99ede456543b7$var$_Object$setPrototypeO = {
    get stream () {
        return this[$25a99ede456543b7$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$25a99ede456543b7$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$25a99ede456543b7$var$kEnded]) return Promise.resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        if (this[$25a99ede456543b7$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$25a99ede456543b7$var$kError]) reject(_this[$25a99ede456543b7$var$kError]);
                else resolve($25a99ede456543b7$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$25a99ede456543b7$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($25a99ede456543b7$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$25a99ede456543b7$var$kStream].read();
            if (data !== null) return Promise.resolve($25a99ede456543b7$var$createIterResult(data, false));
            promise = new Promise(this[$25a99ede456543b7$var$kHandlePromise]);
        }
        this[$25a99ede456543b7$var$kLastPromise] = promise;
        return promise;
    }
}, $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$25a99ede456543b7$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        });
    });
}), $25a99ede456543b7$var$_Object$setPrototypeO), $25a99ede456543b7$var$AsyncIteratorPrototype);
var $25a99ede456543b7$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kStream, {
        value: stream,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastResolve, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastReject, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kError, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$25a99ede456543b7$var$kStream].read();
            if (data) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                resolve($25a99ede456543b7$var$createIterResult(data, false));
            } else {
                iterator[$25a99ede456543b7$var$kLastResolve] = resolve;
                iterator[$25a99ede456543b7$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$25a99ede456543b7$var$kLastPromise] = null;
    $hzqCm(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$25a99ede456543b7$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                reject(err);
            }
            iterator[$25a99ede456543b7$var$kError] = err;
            return;
        }
        var resolve = iterator[$25a99ede456543b7$var$kLastResolve];
        if (resolve !== null) {
            iterator[$25a99ede456543b7$var$kLastPromise] = null;
            iterator[$25a99ede456543b7$var$kLastResolve] = null;
            iterator[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        }
        iterator[$25a99ede456543b7$var$kEnded] = true;
    });
    stream.on('readable', $25a99ede456543b7$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $25a99ede456543b7$var$createReadableStreamAsyncIterator;

});
parcelRegister("hzqCm", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("967Aq")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $ccaa5a4968d6bb28$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $ccaa5a4968d6bb28$var$noop() {}
function $ccaa5a4968d6bb28$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $ccaa5a4968d6bb28$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $ccaa5a4968d6bb28$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $ccaa5a4968d6bb28$var$once(callback || $ccaa5a4968d6bb28$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($ccaa5a4968d6bb28$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $ccaa5a4968d6bb28$var$eos;

});


parcelRegister("gN4Jr", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("k3Gr9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $e9a50192eb9e2af9$var$Transform;

var $967Aq = parcelRequire("967Aq");
var $e9a50192eb9e2af9$require$_require$codes = $967Aq.codes;
var $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED = $e9a50192eb9e2af9$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK = $e9a50192eb9e2af9$require$_require$codes.ERR_MULTIPLE_CALLBACK, $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0 = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $fFuzr = parcelRequire("fFuzr");

(parcelRequire("dlqwk"))($e9a50192eb9e2af9$var$Transform, $fFuzr);
function $e9a50192eb9e2af9$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $e9a50192eb9e2af9$var$Transform(options) {
    if (!(this instanceof $e9a50192eb9e2af9$var$Transform)) return new $e9a50192eb9e2af9$var$Transform(options);
    $fFuzr.call(this, options);
    this._transformState = {
        afterTransform: $e9a50192eb9e2af9$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $e9a50192eb9e2af9$var$prefinish);
}
function $e9a50192eb9e2af9$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $e9a50192eb9e2af9$var$done(_this, er, data);
    });
    else $e9a50192eb9e2af9$var$done(this, null, null);
}
$e9a50192eb9e2af9$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $fFuzr.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$e9a50192eb9e2af9$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$e9a50192eb9e2af9$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$e9a50192eb9e2af9$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$e9a50192eb9e2af9$var$Transform.prototype._destroy = function(err, cb) {
    $fFuzr.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $e9a50192eb9e2af9$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("6G2fH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $4dc8698e5416b71e$var$PassThrough;

var $k3Gr9 = parcelRequire("k3Gr9");

(parcelRequire("dlqwk"))($4dc8698e5416b71e$var$PassThrough, $k3Gr9);
function $4dc8698e5416b71e$var$PassThrough(options) {
    if (!(this instanceof $4dc8698e5416b71e$var$PassThrough)) return new $4dc8698e5416b71e$var$PassThrough(options);
    $k3Gr9.call(this, options);
}
$4dc8698e5416b71e$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("coyuH", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $90627bba44315748$var$eos;
function $90627bba44315748$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $967Aq = parcelRequire("967Aq");
var $90627bba44315748$require$_require$codes = $967Aq.codes;
var $90627bba44315748$var$ERR_MISSING_ARGS = $90627bba44315748$require$_require$codes.ERR_MISSING_ARGS, $90627bba44315748$var$ERR_STREAM_DESTROYED = $90627bba44315748$require$_require$codes.ERR_STREAM_DESTROYED;
function $90627bba44315748$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $90627bba44315748$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $90627bba44315748$var$destroyer(stream, reading, writing, callback) {
    callback = $90627bba44315748$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($90627bba44315748$var$eos === undefined) $90627bba44315748$var$eos = (parcelRequire("hzqCm"));
    $90627bba44315748$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($90627bba44315748$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $90627bba44315748$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $90627bba44315748$var$call(fn) {
    fn();
}
function $90627bba44315748$var$pipe(from, to) {
    return from.pipe(to);
}
function $90627bba44315748$var$popCallback(streams) {
    if (!streams.length) return $90627bba44315748$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $90627bba44315748$var$noop;
    return streams.pop();
}
function $90627bba44315748$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $90627bba44315748$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $90627bba44315748$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $90627bba44315748$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($90627bba44315748$var$call);
            if (reading) return;
            destroys.forEach($90627bba44315748$var$call);
            callback(error);
        });
    });
    return streams.reduce($90627bba44315748$var$pipe);
}
module.exports = $90627bba44315748$var$pipeline;

});




parcelRegister("a8qBR", function(module, exports) {
'use strict';

var $6ZWSX = parcelRequire("6ZWSX");
var $760f4ae3157f7f0b$require$Buffer = $6ZWSX.Buffer;

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");
var $760f4ae3157f7f0b$var$ARRAY16 = new Array(16);
var $760f4ae3157f7f0b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $760f4ae3157f7f0b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $760f4ae3157f7f0b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $760f4ae3157f7f0b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $760f4ae3157f7f0b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $760f4ae3157f7f0b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $760f4ae3157f7f0b$var$RIPEMD160() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($760f4ae3157f7f0b$var$RIPEMD160, $eLdEM);
$760f4ae3157f7f0b$var$RIPEMD160.prototype._update = function() {
    var words = $760f4ae3157f7f0b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $760f4ae3157f7f0b$var$fn1(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[0], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn5(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[0], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 32) {
            tl = $760f4ae3157f7f0b$var$fn2(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[1], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn4(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[1], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 48) {
            tl = $760f4ae3157f7f0b$var$fn3(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[2], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn3(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[2], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 64) {
            tl = $760f4ae3157f7f0b$var$fn4(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[3], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn2(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[3], $760f4ae3157f7f0b$var$sr[i]);
        } else {
            tl = $760f4ae3157f7f0b$var$fn5(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[4], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn1(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[4], $760f4ae3157f7f0b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $760f4ae3157f7f0b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $760f4ae3157f7f0b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$760f4ae3157f7f0b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $760f4ae3157f7f0b$require$Buffer.alloc ? $760f4ae3157f7f0b$require$Buffer.alloc(20) : new $760f4ae3157f7f0b$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $760f4ae3157f7f0b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $760f4ae3157f7f0b$var$fn1(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn2(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn3(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn4(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn5(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $760f4ae3157f7f0b$var$RIPEMD160;

});

parcelRegister("5Z1sR", function(module, exports) {
var $45b3c90d57600982$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $45b3c90d57600982$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

$45b3c90d57600982$var$exports.sha = (parcelRequire("dECyV"));

$45b3c90d57600982$var$exports.sha1 = (parcelRequire("dVcFO"));

$45b3c90d57600982$var$exports.sha224 = (parcelRequire("3wNjm"));

$45b3c90d57600982$var$exports.sha256 = (parcelRequire("3BFQx"));

$45b3c90d57600982$var$exports.sha384 = (parcelRequire("5qHaZ"));

$45b3c90d57600982$var$exports.sha512 = (parcelRequire("bZI17"));

});
parcelRegister("dECyV", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + W[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRegister("O5ywn", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === 'string') {
        enc = enc || 'utf8';
        data = $0968fae43eb53960$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $0968fae43eb53960$var$Hash;

});


parcelRegister("dVcFO", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $a22a6de6a357c37a$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + W[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRegister("3wNjm", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRegister("3BFQx", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $2a05499bef58a0cf$var$gamma1(W[i - 2]) + W[i - 7] + $2a05499bef58a0cf$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + W[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRegister("5qHaZ", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRegister("bZI17", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRegister("26nOC", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $187e9d8dfda3dbba$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $187e9d8dfda3dbba$require$Transform = $ioRHp.Transform;

var $eNRCS = parcelRequire("eNRCS");
var $187e9d8dfda3dbba$require$StringDecoder = $eNRCS.StringDecoder;

var $dlqwk = parcelRequire("dlqwk");
function $187e9d8dfda3dbba$var$CipherBase(hashMode) {
    $187e9d8dfda3dbba$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dlqwk($187e9d8dfda3dbba$var$CipherBase, $187e9d8dfda3dbba$require$Transform);
var $187e9d8dfda3dbba$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $187e9d8dfda3dbba$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($187e9d8dfda3dbba$require$Buffer.prototype instanceof Uint8Array || $187e9d8dfda3dbba$require$Buffer.TYPED_ARRAY_SUPPORT);
function $187e9d8dfda3dbba$var$toBuffer(data, encoding) {
    /*
	 * No need to do anything for exact instance
	 * This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
	 */ if (data instanceof $187e9d8dfda3dbba$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $187e9d8dfda3dbba$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($187e9d8dfda3dbba$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $187e9d8dfda3dbba$require$Buffer.alloc(0);
        var res = $187e9d8dfda3dbba$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        /*
		 * Recheck result size, as offset/length doesn't work on Node.js <5.10
		 * We just go to Uint8Array case if this fails
		 */ if (res.byteLength === data.byteLength) return res;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($187e9d8dfda3dbba$var$useUint8Array && data instanceof Uint8Array) return $187e9d8dfda3dbba$require$Buffer.from(data);
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if ($187e9d8dfda3dbba$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $187e9d8dfda3dbba$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$187e9d8dfda3dbba$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $187e9d8dfda3dbba$var$toBuffer(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAutoPadding = function() {};
$187e9d8dfda3dbba$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$187e9d8dfda3dbba$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$187e9d8dfda3dbba$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$187e9d8dfda3dbba$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $187e9d8dfda3dbba$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $187e9d8dfda3dbba$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $187e9d8dfda3dbba$var$CipherBase;

});


parcelRegister("1iL1D", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $77ZZs = parcelRequire("77ZZs");

var $26nOC = parcelRequire("26nOC");

var $1U9GM = parcelRequire("1U9GM");
var $0f2bf322914b61b2$require$Buffer = $1U9GM.Buffer;

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");
var $0f2bf322914b61b2$var$ZEROS = $0f2bf322914b61b2$require$Buffer.alloc(128);
function $0f2bf322914b61b2$var$Hmac(alg, key) {
    $26nOC.call(this, 'digest');
    if (typeof key === 'string') key = $0f2bf322914b61b2$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $a8qBR() : $5Z1sR(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $0f2bf322914b61b2$require$Buffer.concat([
        key,
        $0f2bf322914b61b2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $a8qBR() : $5Z1sR(alg);
    this._hash.update(ipad);
}
$dlqwk($0f2bf322914b61b2$var$Hmac, $26nOC);
$0f2bf322914b61b2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$0f2bf322914b61b2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $a8qBR() : $5Z1sR(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $0f2bf322914b61b2$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $77ZZs($8nM4g, key);
    return new $0f2bf322914b61b2$var$Hmac(alg, key);
};

});
parcelRegister("77ZZs", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $530945d1f5e7b9b5$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");
var $530945d1f5e7b9b5$var$ZEROS = $530945d1f5e7b9b5$require$Buffer.alloc(128);
var $530945d1f5e7b9b5$var$blocksize = 64;
function $530945d1f5e7b9b5$var$Hmac(alg, key) {
    $26nOC.call(this, 'digest');
    if (typeof key === 'string') key = $530945d1f5e7b9b5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $530945d1f5e7b9b5$var$blocksize) key = alg(key);
    else if (key.length < $530945d1f5e7b9b5$var$blocksize) key = $530945d1f5e7b9b5$require$Buffer.concat([
        key,
        $530945d1f5e7b9b5$var$ZEROS
    ], $530945d1f5e7b9b5$var$blocksize);
    var ipad = this._ipad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    var opad = this._opad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    for(var i = 0; i < $530945d1f5e7b9b5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dlqwk($530945d1f5e7b9b5$var$Hmac, $26nOC);
$530945d1f5e7b9b5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$530945d1f5e7b9b5$var$Hmac.prototype._final = function() {
    var h = this._alg($530945d1f5e7b9b5$require$Buffer.concat(this._hash));
    return this._alg($530945d1f5e7b9b5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $530945d1f5e7b9b5$var$Hmac;

});

parcelRegister("8nM4g", function(module, exports) {

var $loYLU = parcelRequire("loYLU");
module.exports = function(buffer) {
    return new $loYLU().update(buffer).digest();
};

});


parcelRegister("6swAi", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});

parcelRegister("5dQ72", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $3cd697166017b735$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $1VtKc = parcelRequire("1VtKc");

var $kiaDM = parcelRequire("kiaDM");
var $3cd697166017b735$var$ZERO_BUF;
var $3cd697166017b735$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3cd697166017b735$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $3cd697166017b735$var$checks = [];
function $3cd697166017b735$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3cd697166017b735$var$subtle || !$3cd697166017b735$var$subtle.importKey || !$3cd697166017b735$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3cd697166017b735$var$checks[algo] !== undefined) return $3cd697166017b735$var$checks[algo];
    $3cd697166017b735$var$ZERO_BUF = $3cd697166017b735$var$ZERO_BUF || $3cd697166017b735$require$Buffer.alloc(8);
    var prom = $3cd697166017b735$var$browserPbkdf2($3cd697166017b735$var$ZERO_BUF, $3cd697166017b735$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $3cd697166017b735$var$checks[algo] = prom;
    return prom;
}
var $3cd697166017b735$var$nextTick;
function $3cd697166017b735$var$getNextTick() {
    if ($3cd697166017b735$var$nextTick) return $3cd697166017b735$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3cd697166017b735$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3cd697166017b735$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3cd697166017b735$var$nextTick = $parcel$global.setImmediate;
    else $3cd697166017b735$var$nextTick = $parcel$global.setTimeout;
    return $3cd697166017b735$var$nextTick;
}
function $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3cd697166017b735$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $3cd697166017b735$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3cd697166017b735$require$Buffer.from(res);
    });
}
function $3cd697166017b735$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    digest = digest || 'sha1';
    var algo = $3cd697166017b735$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $3cd697166017b735$var$getNextTick()(function() {
            var out;
            try {
                out = $1VtKc(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, 'Password');
    salt = $kiaDM(salt, $6YaY3, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    $3cd697166017b735$var$resolvePromise($3cd697166017b735$var$checkNative(algo).then(function(resp) {
        if (resp) return $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $1VtKc(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("7dtUH", function(module, exports) {
var $5410f37dea3a95ee$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $5410f37dea3a95ee$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("6YaY3", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
var $5130da986dd86f24$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $5130da986dd86f24$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $5130da986dd86f24$var$pVersionMajor = parseInt($hPtJY.version.split('.')[0].slice(1), 10);
    $5130da986dd86f24$var$defaultEncoding = $5130da986dd86f24$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $5130da986dd86f24$var$defaultEncoding = 'utf-8';
module.exports = $5130da986dd86f24$var$defaultEncoding;

});

parcelRegister("1VtKc", function(module, exports) {

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $1U9GM = parcelRequire("1U9GM");
var $16722fe28cdbf3c2$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $kiaDM = parcelRequire("kiaDM");
var $16722fe28cdbf3c2$var$ZEROS = $16722fe28cdbf3c2$require$Buffer.alloc(128);
var $16722fe28cdbf3c2$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $16722fe28cdbf3c2$var$Hmac(alg, key, saltLen) {
    var hash = $16722fe28cdbf3c2$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $16722fe28cdbf3c2$require$Buffer.concat([
        key,
        $16722fe28cdbf3c2$var$ZEROS
    ], blocksize);
    var ipad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    var opad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $16722fe28cdbf3c2$var$sizes[alg];
}
$16722fe28cdbf3c2$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $16722fe28cdbf3c2$var$getDigest(alg) {
    function shaFunc(data) {
        return $5Z1sR(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $a8qBR().update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func;
    if (alg === 'md5') return $8nM4g;
    return shaFunc;
}
function $16722fe28cdbf3c2$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, 'Password');
    salt = $kiaDM(salt, $6YaY3, 'Salt');
    digest = digest || 'sha1';
    var hmac = new $16722fe28cdbf3c2$var$Hmac(digest, password, salt.length);
    var DK = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(keylen);
    var block1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $16722fe28cdbf3c2$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $16722fe28cdbf3c2$var$pbkdf2;

});
parcelRegister("kiaDM", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $ec5dbe1d2de061b3$require$Buffer = $1U9GM.Buffer;
module.exports = function(thing, encoding, name) {
    if ($ec5dbe1d2de061b3$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === 'string') return $ec5dbe1d2de061b3$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $ec5dbe1d2de061b3$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView');
};

});



parcelRegister("dyok1", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $9de15128f81796e0$export$cfaef8ed399428b0, (v) => $9de15128f81796e0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $9de15128f81796e0$export$a80c7deaea7cbd80, (v) => $9de15128f81796e0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $9de15128f81796e0$export$ed7577ae6e1cd0ef, (v) => $9de15128f81796e0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $9de15128f81796e0$export$5dcbef3aa594f567, (v) => $9de15128f81796e0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $9de15128f81796e0$export$5bc8001ca71ed9c5, (v) => $9de15128f81796e0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $9de15128f81796e0$export$3e714e2c5d5d8cb2, (v) => $9de15128f81796e0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $9de15128f81796e0$export$94c3e544fd062b7f, (v) => $9de15128f81796e0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $9de15128f81796e0$export$9f77e0932fb78f72, (v) => $9de15128f81796e0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $9de15128f81796e0$export$d865ce2836f5927f, (v) => $9de15128f81796e0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $9de15128f81796e0$export$95e62ad65da8b7d2, (v) => $9de15128f81796e0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $9de15128f81796e0$export$209139ff098c441a, (v) => $9de15128f81796e0$export$209139ff098c441a = v);
var $9de15128f81796e0$export$cfaef8ed399428b0;
var $9de15128f81796e0$export$a80c7deaea7cbd80;
var $9de15128f81796e0$export$ed7577ae6e1cd0ef;
var $9de15128f81796e0$export$5dcbef3aa594f567;
var $9de15128f81796e0$export$5bc8001ca71ed9c5;
var $9de15128f81796e0$export$3e714e2c5d5d8cb2;
var $9de15128f81796e0$export$94c3e544fd062b7f;
var $9de15128f81796e0$export$9f77e0932fb78f72;
var $9de15128f81796e0$export$d865ce2836f5927f;
var $9de15128f81796e0$export$95e62ad65da8b7d2;
var $9de15128f81796e0$export$209139ff098c441a;
'use strict';
$9de15128f81796e0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9de15128f81796e0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9de15128f81796e0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9de15128f81796e0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9de15128f81796e0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9de15128f81796e0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9de15128f81796e0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9de15128f81796e0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9de15128f81796e0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9de15128f81796e0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9de15128f81796e0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9de15128f81796e0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9de15128f81796e0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9de15128f81796e0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("enfpo", function(module, exports) {
'use strict';

var $koC21 = parcelRequire("koC21");
function $a76f2a83ec677410$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $a76f2a83ec677410$var$Cipher;
$a76f2a83ec677410$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a76f2a83ec677410$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a76f2a83ec677410$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a76f2a83ec677410$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a76f2a83ec677410$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a76f2a83ec677410$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a76f2a83ec677410$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a76f2a83ec677410$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $koC21.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("dB8Kv", function(module, exports) {
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $dyok1 = parcelRequire("dyok1");

var $enfpo = parcelRequire("enfpo");
function $9e6584766ef755d8$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $9e6584766ef755d8$var$DES(options) {
    $enfpo.call(this, options);
    var state = new $9e6584766ef755d8$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dlqwk($9e6584766ef755d8$var$DES, $enfpo);
module.exports = $9e6584766ef755d8$var$DES;
$9e6584766ef755d8$var$DES.create = function create(options) {
    return new $9e6584766ef755d8$var$DES(options);
};
var $9e6584766ef755d8$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$9e6584766ef755d8$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $koC21.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $dyok1.readUInt32BE(key, 0);
    var kR = $dyok1.readUInt32BE(key, 4);
    $dyok1.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $9e6584766ef755d8$var$shiftTable[i >>> 1];
        kL = $dyok1.r28shl(kL, shift);
        kR = $dyok1.r28shl(kR, shift);
        $dyok1.pc2(kL, kR, state.keys, i);
    }
};
$9e6584766ef755d8$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dyok1.readUInt32BE(inp, inOff);
    var r = $dyok1.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dyok1.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dyok1.writeUInt32BE(out, l, outOff);
    $dyok1.writeUInt32BE(out, r, outOff + 4);
};
$9e6584766ef755d8$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$9e6584766ef755d8$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$koC21.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$9e6584766ef755d8$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(r, l, out, off);
};
$9e6584766ef755d8$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(l, r, out, off);
};

});

parcelRegister("eiYbc", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $a6a16d933acb8abd$export$f9bb8d20ccc7477a, (v) => $a6a16d933acb8abd$export$f9bb8d20ccc7477a = v);
var $a6a16d933acb8abd$export$f9bb8d20ccc7477a;
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
var $a6a16d933acb8abd$var$proto = {};
function $a6a16d933acb8abd$var$CBCState(iv) {
    $koC21.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $a6a16d933acb8abd$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dlqwk(CBC, Base);
    var keys = Object.keys($a6a16d933acb8abd$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $a6a16d933acb8abd$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$a6a16d933acb8abd$export$f9bb8d20ccc7477a = $a6a16d933acb8abd$var$instantiate;
$a6a16d933acb8abd$var$proto._cbcInit = function _cbcInit() {
    var state = new $a6a16d933acb8abd$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$a6a16d933acb8abd$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("5ye6K", function(module, exports) {
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $enfpo = parcelRequire("enfpo");

var $dB8Kv = parcelRequire("dB8Kv");
function $40ab123e2a8964f5$var$EDEState(type, key) {
    $koC21.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $dB8Kv.create({
            type: 'encrypt',
            key: k1
        }),
        $dB8Kv.create({
            type: 'decrypt',
            key: k2
        }),
        $dB8Kv.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $dB8Kv.create({
            type: 'decrypt',
            key: k3
        }),
        $dB8Kv.create({
            type: 'encrypt',
            key: k2
        }),
        $dB8Kv.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $40ab123e2a8964f5$var$EDE(options) {
    $enfpo.call(this, options);
    var state = new $40ab123e2a8964f5$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dlqwk($40ab123e2a8964f5$var$EDE, $enfpo);
module.exports = $40ab123e2a8964f5$var$EDE;
$40ab123e2a8964f5$var$EDE.create = function create(options) {
    return new $40ab123e2a8964f5$var$EDE(options);
};
$40ab123e2a8964f5$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$40ab123e2a8964f5$var$EDE.prototype._pad = $dB8Kv.prototype._pad;
$40ab123e2a8964f5$var$EDE.prototype._unpad = $dB8Kv.prototype._unpad;

});

parcelRegister("f6p9h", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $afeaec8849bcc81c$export$5b0f6292f11d1d18, (v) => $afeaec8849bcc81c$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $afeaec8849bcc81c$export$e85a0c9a1067c5d3, (v) => $afeaec8849bcc81c$export$e85a0c9a1067c5d3 = v);
var $afeaec8849bcc81c$export$5b0f6292f11d1d18;
var $afeaec8849bcc81c$export$e85a0c9a1067c5d3;
$afeaec8849bcc81c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$afeaec8849bcc81c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("3QymJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18, (v) => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3, (v) => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = v);
var $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18;
var $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3;

var $dUX5c = parcelRequire("dUX5c");
$2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dUX5c(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dUX5c(out, pad);
};

});
parcelRegister("dUX5c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a21e55eeffd2595b$require$Buffer = $6ZWSX.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a21e55eeffd2595b$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("2cuuO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $19a45ba19082fc97$export$5b0f6292f11d1d18, (v) => $19a45ba19082fc97$export$5b0f6292f11d1d18 = v);
var $19a45ba19082fc97$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $19a45ba19082fc97$require$Buffer = $1U9GM.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $19a45ba19082fc97$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dUX5c(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $19a45ba19082fc97$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$19a45ba19082fc97$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("03mhO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $00a19188a96aa70f$export$5b0f6292f11d1d18, (v) => $00a19188a96aa70f$export$5b0f6292f11d1d18 = v);
var $00a19188a96aa70f$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $00a19188a96aa70f$require$Buffer = $1U9GM.Buffer;
function $00a19188a96aa70f$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00a19188a96aa70f$require$Buffer.concat([
        self._prev.slice(1),
        $00a19188a96aa70f$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00a19188a96aa70f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00a19188a96aa70f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00a19188a96aa70f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fK9OU", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b762c4f45662bf18$export$5b0f6292f11d1d18, (v) => $b762c4f45662bf18$export$5b0f6292f11d1d18 = v);
var $b762c4f45662bf18$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $b762c4f45662bf18$require$Buffer = $1U9GM.Buffer;
function $b762c4f45662bf18$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $b762c4f45662bf18$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $b762c4f45662bf18$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(buffer.length);
    buffer = $b762c4f45662bf18$require$Buffer.concat([
        buffer,
        $b762c4f45662bf18$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$b762c4f45662bf18$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $b762c4f45662bf18$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fFe8N", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b675a769a603e0fc$export$5b0f6292f11d1d18, (v) => $b675a769a603e0fc$export$5b0f6292f11d1d18 = v);
var $b675a769a603e0fc$export$5b0f6292f11d1d18;

var $6ZWSX = parcelRequire("6ZWSX");
var $b675a769a603e0fc$require$Buffer = $6ZWSX.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $b675a769a603e0fc$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$b675a769a603e0fc$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $b675a769a603e0fc$require$Buffer.concat([
        self._cache,
        $b675a769a603e0fc$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});

parcelRegister("fJbMg", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b73431c24e9fa039$export$5b0f6292f11d1d18, (v) => $b73431c24e9fa039$export$5b0f6292f11d1d18 = v);
var $b73431c24e9fa039$export$5b0f6292f11d1d18;

var $dUX5c = parcelRequire("dUX5c");

var $1U9GM = parcelRequire("1U9GM");
var $b73431c24e9fa039$require$Buffer = $1U9GM.Buffer;

var $3VKgl = parcelRequire("3VKgl");
function $b73431c24e9fa039$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $3VKgl(self._prev);
    return out;
}
var $b73431c24e9fa039$var$blockSize = 16;
$b73431c24e9fa039$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $b73431c24e9fa039$var$blockSize);
    var start = self._cache.length;
    self._cache = $b73431c24e9fa039$require$Buffer.concat([
        self._cache,
        $b73431c24e9fa039$require$Buffer.allocUnsafe(chunkNum * $b73431c24e9fa039$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $b73431c24e9fa039$var$getBlock(self);
        var offset = start + i * $b73431c24e9fa039$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});
parcelRegister("3VKgl", function(module, exports) {
function $2dca94c326c7eb9a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $2dca94c326c7eb9a$var$incr32;

});


parcelRegister("5vmVB", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7Zvov", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7JHF0", function(module, exports) {
var $5a1e9a6ed4e8de8a$var$r;
module.exports = function rand(len) {
    if (!$5a1e9a6ed4e8de8a$var$r) $5a1e9a6ed4e8de8a$var$r = new $5a1e9a6ed4e8de8a$var$Rand(null);
    return $5a1e9a6ed4e8de8a$var$r.generate(len);
};
function $5a1e9a6ed4e8de8a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5a1e9a6ed4e8de8a$var$Rand;
$5a1e9a6ed4e8de8a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5a1e9a6ed4e8de8a$var$crypto = (parcelRequire("kjyEk"));
    if (typeof $5a1e9a6ed4e8de8a$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        return $5a1e9a6ed4e8de8a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("b6RFW", function(module, exports) {

exports = module.exports = (parcelRequire("d4xg3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3LwY7"));

exports.Duplex = (parcelRequire("DwJuQ"));

exports.Transform = (parcelRequire("b7kl8"));

exports.PassThrough = (parcelRequire("4wWcs"));

});
parcelRegister("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ module.exports = $9845726cca5dc7eb$var$Readable;

var $767Wy = parcelRequire("767Wy");
/*</replacement>*/ /*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $h3oXE = parcelRequire("h3oXE");
var $9845726cca5dc7eb$require$Buffer = $h3oXE.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $9845726cca5dc7eb$var$util = Object.create((parcelRequire("dH2Jp")));

$9845726cca5dc7eb$var$util.inherits = (parcelRequire("dlqwk"));

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug = void 0;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog('stream');
else $9845726cca5dc7eb$var$debug = function() {};

var $185iR = parcelRequire("185iR");

var $fMCbt = parcelRequire("fMCbt");
var $9845726cca5dc7eb$var$StringDecoder;
$9845726cca5dc7eb$var$util.inherits($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($767Wy(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $185iR();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("imDDS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $9845726cca5dc7eb$var$needMoreData(state);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $9845726cca5dc7eb$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("imDDS")).StringDecoder;
    this._readableState.decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $9845726cca5dc7eb$var$MAX_HWM = 0x800000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $9845726cca5dc7eb$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $9845726cca5dc7eb$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $bUlqC.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
        else $9845726cca5dc7eb$var$emitReadable_(stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    $9845726cca5dc7eb$var$debug('emit readable');
    stream.emit('readable');
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $9845726cca5dc7eb$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $bUlqC.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $bUlqC.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
            else if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug('resume');
        state.flowing = true;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    if (!state.reading) {
        $9845726cca5dc7eb$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $9845726cca5dc7eb$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $9845726cca5dc7eb$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $9845726cca5dc7eb$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $9845726cca5dc7eb$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $9845726cca5dc7eb$var$copyFromBufferString(n, list) : $9845726cca5dc7eb$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$copyFromBuffer(n, list) {
    var ret = $9845726cca5dc7eb$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("bUlqC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = {
    nextTick: $8ab58be9444f732a$var$nextTick
};
function $8ab58be9444f732a$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $hPtJY.nextTick(fn);
        case 2:
            return $hPtJY.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $hPtJY.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $hPtJY.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $hPtJY.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("767Wy", function(module, exports) {
var $52af415c3a3d4253$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $52af415c3a3d4253$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("h3oXE", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $c6a6143e40fe9703$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $c6a6143e40fe9703$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($c6a6143e40fe9703$var$Buffer.from && $c6a6143e40fe9703$var$Buffer.alloc && $c6a6143e40fe9703$var$Buffer.allocUnsafe && $c6a6143e40fe9703$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $c6a6143e40fe9703$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $c6a6143e40fe9703$var$SafeBuffer;
}
function $c6a6143e40fe9703$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $c6a6143e40fe9703$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$c6a6143e40fe9703$var$copyProps($c6a6143e40fe9703$var$Buffer, $c6a6143e40fe9703$var$SafeBuffer);
$c6a6143e40fe9703$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $c6a6143e40fe9703$var$Buffer(arg, encodingOrOffset, length);
};
$c6a6143e40fe9703$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $c6a6143e40fe9703$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$c6a6143e40fe9703$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $c6a6143e40fe9703$var$Buffer(size);
};
$c6a6143e40fe9703$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6ZWSX.SlowBuffer(size);
};

});

parcelRegister("dH2Jp", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $9f8168ed52eee242$export$43bee75e5e14138e, (v) => $9f8168ed52eee242$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $9f8168ed52eee242$export$f9ce7b637dfbe238, (v) => $9f8168ed52eee242$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $9f8168ed52eee242$export$630801d484da15df, (v) => $9f8168ed52eee242$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $9f8168ed52eee242$export$bedb7023a7733221, (v) => $9f8168ed52eee242$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $9f8168ed52eee242$export$7e4aa119212bc614, (v) => $9f8168ed52eee242$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $9f8168ed52eee242$export$844ec244b1367d54, (v) => $9f8168ed52eee242$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $9f8168ed52eee242$export$a244864fd9645c7f, (v) => $9f8168ed52eee242$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $9f8168ed52eee242$export$fce6876652108ab, (v) => $9f8168ed52eee242$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $9f8168ed52eee242$export$49841c62b9eff15, (v) => $9f8168ed52eee242$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $9f8168ed52eee242$export$a6cdc56e425d0d0a, (v) => $9f8168ed52eee242$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $9f8168ed52eee242$export$871608497c498473, (v) => $9f8168ed52eee242$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $9f8168ed52eee242$export$e6127cc7fe7395c3, (v) => $9f8168ed52eee242$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $9f8168ed52eee242$export$f6e2535fb5126e54, (v) => $9f8168ed52eee242$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $9f8168ed52eee242$export$c3825b437cbdea5c, (v) => $9f8168ed52eee242$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $9f8168ed52eee242$export$a7884ebc965f8f54, (v) => $9f8168ed52eee242$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $9f8168ed52eee242$export$43bee75e5e14138e;
var $9f8168ed52eee242$export$f9ce7b637dfbe238;
var $9f8168ed52eee242$export$630801d484da15df;
var $9f8168ed52eee242$export$bedb7023a7733221;
var $9f8168ed52eee242$export$7e4aa119212bc614;
var $9f8168ed52eee242$export$844ec244b1367d54;
var $9f8168ed52eee242$export$a244864fd9645c7f;
var $9f8168ed52eee242$export$fce6876652108ab;
var $9f8168ed52eee242$export$49841c62b9eff15;
var $9f8168ed52eee242$export$a6cdc56e425d0d0a;
var $9f8168ed52eee242$export$871608497c498473;
var $9f8168ed52eee242$export$e6127cc7fe7395c3;
var $9f8168ed52eee242$export$f6e2535fb5126e54;
var $9f8168ed52eee242$export$c3825b437cbdea5c;
var $9f8168ed52eee242$export$a7884ebc965f8f54;
function $9f8168ed52eee242$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $9f8168ed52eee242$var$objectToString(arg) === '[object Array]';
}
$9f8168ed52eee242$export$43bee75e5e14138e = $9f8168ed52eee242$var$isArray;
function $9f8168ed52eee242$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$9f8168ed52eee242$export$f9ce7b637dfbe238 = $9f8168ed52eee242$var$isBoolean;
function $9f8168ed52eee242$var$isNull(arg) {
    return arg === null;
}
$9f8168ed52eee242$export$630801d484da15df = $9f8168ed52eee242$var$isNull;
function $9f8168ed52eee242$var$isNullOrUndefined(arg) {
    return arg == null;
}
$9f8168ed52eee242$export$bedb7023a7733221 = $9f8168ed52eee242$var$isNullOrUndefined;
function $9f8168ed52eee242$var$isNumber(arg) {
    return typeof arg === 'number';
}
$9f8168ed52eee242$export$7e4aa119212bc614 = $9f8168ed52eee242$var$isNumber;
function $9f8168ed52eee242$var$isString(arg) {
    return typeof arg === 'string';
}
$9f8168ed52eee242$export$844ec244b1367d54 = $9f8168ed52eee242$var$isString;
function $9f8168ed52eee242$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$9f8168ed52eee242$export$a244864fd9645c7f = $9f8168ed52eee242$var$isSymbol;
function $9f8168ed52eee242$var$isUndefined(arg) {
    return arg === void 0;
}
$9f8168ed52eee242$export$fce6876652108ab = $9f8168ed52eee242$var$isUndefined;
function $9f8168ed52eee242$var$isRegExp(re) {
    return $9f8168ed52eee242$var$objectToString(re) === '[object RegExp]';
}
$9f8168ed52eee242$export$49841c62b9eff15 = $9f8168ed52eee242$var$isRegExp;
function $9f8168ed52eee242$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$9f8168ed52eee242$export$a6cdc56e425d0d0a = $9f8168ed52eee242$var$isObject;
function $9f8168ed52eee242$var$isDate(d) {
    return $9f8168ed52eee242$var$objectToString(d) === '[object Date]';
}
$9f8168ed52eee242$export$871608497c498473 = $9f8168ed52eee242$var$isDate;
function $9f8168ed52eee242$var$isError(e) {
    return $9f8168ed52eee242$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$9f8168ed52eee242$export$e6127cc7fe7395c3 = $9f8168ed52eee242$var$isError;
function $9f8168ed52eee242$var$isFunction(arg) {
    return typeof arg === 'function';
}
$9f8168ed52eee242$export$f6e2535fb5126e54 = $9f8168ed52eee242$var$isFunction;
function $9f8168ed52eee242$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$9f8168ed52eee242$export$c3825b437cbdea5c = $9f8168ed52eee242$var$isPrimitive;

$9f8168ed52eee242$export$a7884ebc965f8f54 = (parcelRequire("6ZWSX")).Buffer.isBuffer;
function $9f8168ed52eee242$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("185iR", function(module, exports) {
'use strict';
function $0d2aa6ea56b3e1e2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $h3oXE = parcelRequire("h3oXE");
var $0d2aa6ea56b3e1e2$require$Buffer = $h3oXE.Buffer;

var $kjyEk = parcelRequire("kjyEk");
function $0d2aa6ea56b3e1e2$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $0d2aa6ea56b3e1e2$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $0d2aa6ea56b3e1e2$require$Buffer.alloc(0);
        var ret = $0d2aa6ea56b3e1e2$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $0d2aa6ea56b3e1e2$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($kjyEk && $kjyEk.inspect && $kjyEk.inspect.custom) module.exports.prototype[$kjyEk.inspect.custom] = function() {
    var obj = $kjyEk.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("fMCbt", function(module, exports) {
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy
};

});

parcelRegister("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ /*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

/*<replacement>*/ var $076d08b0309449dc$var$util = Object.create((parcelRequire("dH2Jp")));

$076d08b0309449dc$var$util.inherits = (parcelRequire("dlqwk"));

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");
$076d08b0309449dc$var$util.inherits($076d08b0309449dc$var$Duplex, $d4xg3);
// avoid scope creep, the keys array can then be collected
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $076d08b0309449dc$var$onend);
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $bUlqC.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$076d08b0309449dc$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $bUlqC.nextTick(cb, err);
};

});
parcelRegister("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$asyncWrite = (0, $bUlqC.nextTick);
/*</replacement>*/ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$util = Object.create((parcelRequire("dH2Jp")));

$2bdf55c2c4f390d3$var$util.inherits = (parcelRequire("dlqwk"));

/*</replacement>*/ /*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $h3oXE = parcelRequire("h3oXE");
var $2bdf55c2c4f390d3$require$Buffer = $h3oXE.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");
$2bdf55c2c4f390d3$var$util.inherits($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, 'buffer', {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this) && !(this instanceof $2bdf55c2c4f390d3$var$Duplex)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $bUlqC.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $bUlqC.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ended) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $bUlqC.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $bUlqC.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $2bdf55c2c4f390d3$var$asyncWrite($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
};
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $bUlqC.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $bUlqC.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("imDDS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $d5e9082788fdd47b$export$63a7aa211a91ed69, (v) => $d5e9082788fdd47b$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $d5e9082788fdd47b$export$63a7aa211a91ed69;
'use strict';

var $h3oXE = parcelRequire("h3oXE");
var $d5e9082788fdd47b$require$Buffer = $h3oXE.Buffer;
/*</replacement>*/ var $d5e9082788fdd47b$var$isEncoding = $d5e9082788fdd47b$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $d5e9082788fdd47b$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $d5e9082788fdd47b$var$normalizeEncoding(enc) {
    var nenc = $d5e9082788fdd47b$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($d5e9082788fdd47b$require$Buffer.isEncoding === $d5e9082788fdd47b$var$isEncoding || !$d5e9082788fdd47b$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$d5e9082788fdd47b$export$63a7aa211a91ed69 = $d5e9082788fdd47b$var$StringDecoder;
function $d5e9082788fdd47b$var$StringDecoder(encoding) {
    this.encoding = $d5e9082788fdd47b$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $d5e9082788fdd47b$var$utf16Text;
            this.end = $d5e9082788fdd47b$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $d5e9082788fdd47b$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $d5e9082788fdd47b$var$base64Text;
            this.end = $d5e9082788fdd47b$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $d5e9082788fdd47b$var$simpleWrite;
            this.end = $d5e9082788fdd47b$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $d5e9082788fdd47b$require$Buffer.allocUnsafe(nb);
}
$d5e9082788fdd47b$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$d5e9082788fdd47b$var$StringDecoder.prototype.end = $d5e9082788fdd47b$var$utf8End;
// Returns only complete characters in a Buffer
$d5e9082788fdd47b$var$StringDecoder.prototype.text = $d5e9082788fdd47b$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$d5e9082788fdd47b$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $d5e9082788fdd47b$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $d5e9082788fdd47b$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $d5e9082788fdd47b$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $d5e9082788fdd47b$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $d5e9082788fdd47b$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $d5e9082788fdd47b$var$utf8Text(buf, i) {
    var total = $d5e9082788fdd47b$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $d5e9082788fdd47b$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $d5e9082788fdd47b$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $d5e9082788fdd47b$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $d5e9082788fdd47b$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $d5e9082788fdd47b$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $d5e9082788fdd47b$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $d5e9082788fdd47b$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $8180203f7f0d3074$var$Transform;

var $DwJuQ = parcelRequire("DwJuQ");

/*<replacement>*/ var $8180203f7f0d3074$var$util = Object.create((parcelRequire("dH2Jp")));

$8180203f7f0d3074$var$util.inherits = (parcelRequire("dlqwk"));
/*</replacement>*/ $8180203f7f0d3074$var$util.inherits($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

/*<replacement>*/ var $34c74be520d619f2$var$util = Object.create((parcelRequire("dH2Jp")));

$34c74be520d619f2$var$util.inherits = (parcelRequire("dlqwk"));
/*</replacement>*/ $34c74be520d619f2$var$util.inherits($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("fuV4H", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("gEVtY", function(module, exports) {
'use strict';
var $c20cf89948514165$var$utils = module.exports;

var $jX0xT = parcelRequire("jX0xT");

var $koC21 = parcelRequire("koC21");

var $lC4vN = parcelRequire("lC4vN");
$c20cf89948514165$var$utils.assert = $koC21;
$c20cf89948514165$var$utils.toArray = $lC4vN.toArray;
$c20cf89948514165$var$utils.zero2 = $lC4vN.zero2;
$c20cf89948514165$var$utils.toHex = $lC4vN.toHex;
$c20cf89948514165$var$utils.encode = $lC4vN.encode;
// Represent num in a w-NAF form
function $c20cf89948514165$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$c20cf89948514165$var$utils.getNAF = $c20cf89948514165$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $c20cf89948514165$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$c20cf89948514165$var$utils.getJSF = $c20cf89948514165$var$getJSF;
function $c20cf89948514165$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$c20cf89948514165$var$utils.cachedProperty = $c20cf89948514165$var$cachedProperty;
function $c20cf89948514165$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $c20cf89948514165$var$utils.toArray(bytes, 'hex') : bytes;
}
$c20cf89948514165$var$utils.parseBytes = $c20cf89948514165$var$parseBytes;
function $c20cf89948514165$var$intFromLE(bytes) {
    return new $jX0xT(bytes, 'hex', 'le');
}
$c20cf89948514165$var$utils.intFromLE = $c20cf89948514165$var$intFromLE;

});
parcelRegister("jX0xT", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("lC4vN", function(module, exports) {
'use strict';
var $fbc0a58a3f4350d8$var$utils = module.exports;
function $fbc0a58a3f4350d8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$fbc0a58a3f4350d8$var$utils.toArray = $fbc0a58a3f4350d8$var$toArray;
function $fbc0a58a3f4350d8$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$fbc0a58a3f4350d8$var$utils.zero2 = $fbc0a58a3f4350d8$var$zero2;
function $fbc0a58a3f4350d8$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $fbc0a58a3f4350d8$var$zero2(msg[i].toString(16));
    return res;
}
$fbc0a58a3f4350d8$var$utils.toHex = $fbc0a58a3f4350d8$var$toHex;
$fbc0a58a3f4350d8$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $fbc0a58a3f4350d8$var$toHex(arr);
    else return arr;
};

});


parcelRegister("cP1GP", function(module, exports) {
'use strict';
var $955b8f041d2341cf$var$curve = module.exports;

$955b8f041d2341cf$var$curve.base = (parcelRequire("hSu7V"));

$955b8f041d2341cf$var$curve.short = (parcelRequire("eYNyQ"));

$955b8f041d2341cf$var$curve.mont = (parcelRequire("av2Yx"));

$955b8f041d2341cf$var$curve.edwards = (parcelRequire("dqmX9"));

});
parcelRegister("hSu7V", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d03ed95a59c9b218$var$getNAF = $gEVtY.getNAF;
var $d03ed95a59c9b218$var$getJSF = $gEVtY.getJSF;
var $d03ed95a59c9b218$var$assert = $gEVtY.assert;
function $d03ed95a59c9b218$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $jX0xT(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $jX0xT.red(conf.prime) : $jX0xT.mont(this.p);
    // Useful for many curves
    this.zero = new $jX0xT(0).toRed(this.red);
    this.one = new $jX0xT(1).toRed(this.red);
    this.two = new $jX0xT(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $jX0xT(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $d03ed95a59c9b218$var$BaseCurve;
$d03ed95a59c9b218$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$d03ed95a59c9b218$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$d03ed95a59c9b218$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $d03ed95a59c9b218$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $d03ed95a59c9b218$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $d03ed95a59c9b218$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $d03ed95a59c9b218$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $d03ed95a59c9b218$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $d03ed95a59c9b218$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $d03ed95a59c9b218$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $d03ed95a59c9b218$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$d03ed95a59c9b218$var$BaseCurve.BasePoint = $d03ed95a59c9b218$var$BasePoint;
$d03ed95a59c9b218$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$d03ed95a59c9b218$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$d03ed95a59c9b218$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $gEVtY.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$d03ed95a59c9b218$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$d03ed95a59c9b218$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$d03ed95a59c9b218$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $gEVtY.encode(this._encode(compact), enc);
};
$d03ed95a59c9b218$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$d03ed95a59c9b218$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$d03ed95a59c9b218$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$d03ed95a59c9b218$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("eYNyQ", function(module, exports) {
'use strict';

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $ae7d1d0c45b43ec6$var$assert = $gEVtY.assert;
function $ae7d1d0c45b43ec6$var$ShortCurve(conf) {
    $hSu7V.call(this, 'short', conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dlqwk($ae7d1d0c45b43ec6$var$ShortCurve, $hSu7V);
module.exports = $ae7d1d0c45b43ec6$var$ShortCurve;
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $jX0xT(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $jX0xT(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae7d1d0c45b43ec6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $jX0xT(vec.a, 16),
            b: new $jX0xT(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $jX0xT.mont(num);
    var tinv = new $jX0xT(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $jX0xT(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $jX0xT(1);
    var y1 = new $jX0xT(0);
    var x2 = new $jX0xT(0);
    var y2 = new $jX0xT(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae7d1d0c45b43ec6$var$Point(curve, x, y, isRed) {
    $hSu7V.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dlqwk($ae7d1d0c45b43ec6$var$Point, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae7d1d0c45b43ec6$var$Point(this, x, y, isRed);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae7d1d0c45b43ec6$var$Point.fromJSON(this, obj, red);
};
$ae7d1d0c45b43ec6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae7d1d0c45b43ec6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$ae7d1d0c45b43ec6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae7d1d0c45b43ec6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.mul = function mul(k) {
    k = new $jX0xT(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae7d1d0c45b43ec6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae7d1d0c45b43ec6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae7d1d0c45b43ec6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae7d1d0c45b43ec6$var$JPoint(curve, x, y, z) {
    $hSu7V.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $jX0xT(0);
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = new $jX0xT(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dlqwk($ae7d1d0c45b43ec6$var$JPoint, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae7d1d0c45b43ec6$var$JPoint(this, x, y, z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $jX0xT(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("av2Yx", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");

var $gEVtY = parcelRequire("gEVtY");
function $7a4f1b7c0dc1f992$var$MontCurve(conf) {
    $hSu7V.call(this, 'mont', conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.i4 = new $jX0xT(4).toRed(this.red).redInvm();
    this.two = new $jX0xT(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dlqwk($7a4f1b7c0dc1f992$var$MontCurve, $hSu7V);
module.exports = $7a4f1b7c0dc1f992$var$MontCurve;
$7a4f1b7c0dc1f992$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $7a4f1b7c0dc1f992$var$Point(curve, x, z) {
    $hSu7V.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $jX0xT(x, 16);
        this.z = new $jX0xT(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dlqwk($7a4f1b7c0dc1f992$var$Point, $hSu7V.BasePoint);
$7a4f1b7c0dc1f992$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($gEVtY.toArray(bytes, enc), 1);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.point = function point(x, z) {
    return new $7a4f1b7c0dc1f992$var$Point(this, x, z);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $7a4f1b7c0dc1f992$var$Point.fromJSON(this, obj);
};
$7a4f1b7c0dc1f992$var$Point.prototype.precompute = function precompute() {
// No-op
};
$7a4f1b7c0dc1f992$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$7a4f1b7c0dc1f992$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $7a4f1b7c0dc1f992$var$Point(curve, obj[0], obj[1] || curve.one);
};
$7a4f1b7c0dc1f992$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$7a4f1b7c0dc1f992$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$7a4f1b7c0dc1f992$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$7a4f1b7c0dc1f992$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$7a4f1b7c0dc1f992$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$7a4f1b7c0dc1f992$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$7a4f1b7c0dc1f992$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("dqmX9", function(module, exports) {
'use strict';

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $9c5f8216d530af0e$var$assert = $gEVtY.assert;
function $9c5f8216d530af0e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hSu7V.call(this, 'edwards', conf);
    this.a = new $jX0xT(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $jX0xT(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $jX0xT(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $9c5f8216d530af0e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dlqwk($9c5f8216d530af0e$var$EdwardsCurve, $hSu7V);
module.exports = $9c5f8216d530af0e$var$EdwardsCurve;
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$9c5f8216d530af0e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $jX0xT(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $9c5f8216d530af0e$var$Point(curve, x, y, z, t) {
    $hSu7V.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = z ? new $jX0xT(z, 16) : this.curve.one;
        this.t = t && new $jX0xT(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dlqwk($9c5f8216d530af0e$var$Point, $hSu7V.BasePoint);
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $9c5f8216d530af0e$var$Point.fromJSON(this, obj);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $9c5f8216d530af0e$var$Point(this, x, y, z, t);
};
$9c5f8216d530af0e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $9c5f8216d530af0e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$9c5f8216d530af0e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$9c5f8216d530af0e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$9c5f8216d530af0e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$9c5f8216d530af0e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$9c5f8216d530af0e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$9c5f8216d530af0e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$9c5f8216d530af0e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$9c5f8216d530af0e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$9c5f8216d530af0e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$9c5f8216d530af0e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$9c5f8216d530af0e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$9c5f8216d530af0e$var$Point.prototype.toP = $9c5f8216d530af0e$var$Point.prototype.normalize;
$9c5f8216d530af0e$var$Point.prototype.mixedAdd = $9c5f8216d530af0e$var$Point.prototype.add;

});


parcelRegister("fbTbW", function(module, exports) {
'use strict';
var $b0f2b206068f1378$var$curves = module.exports;

var $kiSKt = parcelRequire("kiSKt");

var $cP1GP = parcelRequire("cP1GP");

var $gEVtY = parcelRequire("gEVtY");
var $b0f2b206068f1378$var$assert = $gEVtY.assert;
function $b0f2b206068f1378$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $cP1GP.short(options);
    else if (options.type === 'edwards') this.curve = new $cP1GP.edwards(options);
    else this.curve = new $cP1GP.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b0f2b206068f1378$var$assert(this.g.validate(), 'Invalid curve');
    $b0f2b206068f1378$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$b0f2b206068f1378$var$curves.PresetCurve = $b0f2b206068f1378$var$PresetCurve;
function $b0f2b206068f1378$var$defineCurve(name, options) {
    Object.defineProperty($b0f2b206068f1378$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b0f2b206068f1378$var$PresetCurve(options);
            Object.defineProperty($b0f2b206068f1378$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b0f2b206068f1378$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$b0f2b206068f1378$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$b0f2b206068f1378$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$b0f2b206068f1378$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kiSKt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b0f2b206068f1378$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kiSKt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b0f2b206068f1378$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$b0f2b206068f1378$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $b0f2b206068f1378$var$pre;

try {
    $b0f2b206068f1378$var$pre = (parcelRequire("lNVWe"));
} catch (e) {
    $b0f2b206068f1378$var$pre = undefined;
}
$b0f2b206068f1378$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $kiSKt.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $b0f2b206068f1378$var$pre
    ]
});

});
parcelRegister("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRegister("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
'use strict';

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});

parcelRegister("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
'use strict';

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
'use strict';

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRegister("IUW6G", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'big');
    else return $btcbI.split32(this.h, 'big');
};

});
parcelRegister("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
'use strict';

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRegister("gBE2w", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $btcbI.toHex32(this.h.slice(0, 7), 'big');
    else return $btcbI.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("a9EzX", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'big');
    else return $btcbI.split32(this.h, 'big');
};

});


parcelRegister("7j4cV", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h.slice(0, 12), 'big');
    else return $btcbI.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("lMBCM", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'big');
    else return $btcbI.split32(this.h, 'big');
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
'use strict';

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $btcbI.toHex32(this.h, 'little');
    else return $btcbI.split32(this.h, 'little');
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ap2lu", function(module, exports) {
'use strict';

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("lNVWe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("220Zx", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $kKonu = parcelRequire("kKonu");

var $gEVtY = parcelRequire("gEVtY");

var $fbTbW = parcelRequire("fbTbW");

var $7JHF0 = parcelRequire("7JHF0");
var $17ac898fe5b06379$var$assert = $gEVtY.assert;

var $lPqzs = parcelRequire("lPqzs");

var $i46nc = parcelRequire("i46nc");
function $17ac898fe5b06379$var$EC(options) {
    if (!(this instanceof $17ac898fe5b06379$var$EC)) return new $17ac898fe5b06379$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $17ac898fe5b06379$var$assert(Object.prototype.hasOwnProperty.call($fbTbW, options), 'Unknown curve ' + options);
        options = $fbTbW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $fbTbW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $17ac898fe5b06379$var$EC;
$17ac898fe5b06379$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lPqzs(this, options);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lPqzs.fromPrivate(this, priv, enc);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lPqzs.fromPublic(this, pub, enc);
};
$17ac898fe5b06379$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $7JHF0(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $jX0xT(2));
    for(;;){
        var priv = new $jX0xT(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$17ac898fe5b06379$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($jX0xT.isBN(msg) || typeof msg === 'number') {
        msg = new $jX0xT(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $jX0xT(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $jX0xT(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$17ac898fe5b06379$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$jX0xT.isBN(msg)) {
        $17ac898fe5b06379$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $17ac898fe5b06379$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$17ac898fe5b06379$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $17ac898fe5b06379$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $17ac898fe5b06379$var$assert(new $jX0xT(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $jX0xT(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $jX0xT(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $i46nc({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$17ac898fe5b06379$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $i46nc(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$17ac898fe5b06379$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $17ac898fe5b06379$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $i46nc(signature, enc);
    var n = this.n;
    var e = new $jX0xT(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$17ac898fe5b06379$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $i46nc(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("kKonu", function(module, exports) {
'use strict';

var $kiSKt = parcelRequire("kiSKt");

var $lC4vN = parcelRequire("lC4vN");

var $koC21 = parcelRequire("koC21");
function $f1ab03780ebd0ab4$var$HmacDRBG(options) {
    if (!(this instanceof $f1ab03780ebd0ab4$var$HmacDRBG)) return new $f1ab03780ebd0ab4$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $lC4vN.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $lC4vN.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $lC4vN.toArray(options.pers, options.persEnc || 'hex');
    $koC21(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $f1ab03780ebd0ab4$var$HmacDRBG;
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kiSKt.hmac(this.hash, this.K);
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $lC4vN.toArray(entropy, entropyEnc);
    add = $lC4vN.toArray(add, addEnc);
    $koC21(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $lC4vN.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $lC4vN.encode(res, enc);
};

});

parcelRegister("lPqzs", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $fe42f8d68750188b$var$assert = $gEVtY.assert;
function $fe42f8d68750188b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fe42f8d68750188b$var$KeyPair;
$fe42f8d68750188b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fe42f8d68750188b$var$KeyPair) return pub;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fe42f8d68750188b$var$KeyPair) return priv;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$fe42f8d68750188b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fe42f8d68750188b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$fe42f8d68750188b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $jX0xT(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fe42f8d68750188b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $fe42f8d68750188b$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $fe42f8d68750188b$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fe42f8d68750188b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fe42f8d68750188b$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$fe42f8d68750188b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("i46nc", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d26d8b510bde7292$var$assert = $gEVtY.assert;
function $d26d8b510bde7292$var$Signature(options, enc) {
    if (options instanceof $d26d8b510bde7292$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d26d8b510bde7292$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $jX0xT(options.r, 16);
    this.s = new $jX0xT(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d26d8b510bde7292$var$Signature;
function $d26d8b510bde7292$var$Position() {
    this.place = 0;
}
function $d26d8b510bde7292$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d26d8b510bde7292$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d26d8b510bde7292$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $gEVtY.toArray(data, enc);
    var p = new $d26d8b510bde7292$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d26d8b510bde7292$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d26d8b510bde7292$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d26d8b510bde7292$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $jX0xT(r);
    this.s = new $jX0xT(s);
    this.recoveryParam = null;
    return true;
};
function $d26d8b510bde7292$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d26d8b510bde7292$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d26d8b510bde7292$var$rmPadding(r);
    s = $d26d8b510bde7292$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d26d8b510bde7292$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d26d8b510bde7292$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d26d8b510bde7292$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $gEVtY.encode(res, enc);
};

});


parcelRegister("esmmS", function(module, exports) {
'use strict';

var $kiSKt = parcelRequire("kiSKt");

var $fbTbW = parcelRequire("fbTbW");

var $gEVtY = parcelRequire("gEVtY");
var $a865080dcef76248$var$assert = $gEVtY.assert;
var $a865080dcef76248$var$parseBytes = $gEVtY.parseBytes;

var $1D85n = parcelRequire("1D85n");

var $7XcGE = parcelRequire("7XcGE");
function $a865080dcef76248$var$EDDSA(curve) {
    $a865080dcef76248$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $a865080dcef76248$var$EDDSA)) return new $a865080dcef76248$var$EDDSA(curve);
    curve = $fbTbW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kiSKt.sha512;
}
module.exports = $a865080dcef76248$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $a865080dcef76248$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $a865080dcef76248$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $a865080dcef76248$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $a865080dcef76248$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$a865080dcef76248$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $gEVtY.intFromLE(hash.digest()).umod(this.curve.n);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1D85n.fromPublic(this, pub);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1D85n.fromSecret(this, secret);
};
$a865080dcef76248$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7XcGE) return sig;
    return new $7XcGE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $a865080dcef76248$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$a865080dcef76248$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $gEVtY.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $gEVtY.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$a865080dcef76248$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$a865080dcef76248$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $gEVtY.intFromLE(bytes);
};
$a865080dcef76248$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("1D85n", function(module, exports) {
'use strict';

var $gEVtY = parcelRequire("gEVtY");
var $12ffb49ca423a34b$var$assert = $gEVtY.assert;
var $12ffb49ca423a34b$var$parseBytes = $gEVtY.parseBytes;
var $12ffb49ca423a34b$var$cachedProperty = $gEVtY.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $12ffb49ca423a34b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $12ffb49ca423a34b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $12ffb49ca423a34b$var$parseBytes(params.pub);
}
$12ffb49ca423a34b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $12ffb49ca423a34b$var$KeyPair) return pub;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$12ffb49ca423a34b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $12ffb49ca423a34b$var$KeyPair) return secret;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$12ffb49ca423a34b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$12ffb49ca423a34b$var$KeyPair.prototype.sign = function sign(message) {
    $12ffb49ca423a34b$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $12ffb49ca423a34b$var$assert(this._secret, 'KeyPair is public only');
    return $gEVtY.encode(this.secret(), enc);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $gEVtY.encode(this.pubBytes(), enc);
};
module.exports = $12ffb49ca423a34b$var$KeyPair;

});

parcelRegister("7XcGE", function(module, exports) {
'use strict';

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $5ca7e26f93e1a560$var$assert = $gEVtY.assert;
var $5ca7e26f93e1a560$var$cachedProperty = $gEVtY.cachedProperty;
var $5ca7e26f93e1a560$var$parseBytes = $gEVtY.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5ca7e26f93e1a560$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $5ca7e26f93e1a560$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $5ca7e26f93e1a560$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $5ca7e26f93e1a560$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $jX0xT) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5ca7e26f93e1a560$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5ca7e26f93e1a560$var$Signature.prototype.toHex = function toHex() {
    return $gEVtY.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $5ca7e26f93e1a560$var$Signature;

});


parcelRegister("9qVGS", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8fBln", function(module, exports) {

var $10gXo = parcelRequire("10gXo");

var $dlqwk = parcelRequire("dlqwk");
var $601cb1289d0f28d5$var$api = module.exports;
$601cb1289d0f28d5$var$api.define = function define(name, body) {
    return new $601cb1289d0f28d5$var$Entity(name, body);
};
function $601cb1289d0f28d5$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$601cb1289d0f28d5$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("aeJDW")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $dlqwk(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$601cb1289d0f28d5$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($10gXo.decoders[enc]);
    return this.decoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$601cb1289d0f28d5$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($10gXo.encoders[enc]);
    return this.encoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("10gXo", function(module, exports) {
var $0bb2f1d33a97833b$var$asn1 = module.exports;

$0bb2f1d33a97833b$var$asn1.bignum = (parcelRequire("9qVGS"));

$0bb2f1d33a97833b$var$asn1.define = (parcelRequire("8fBln")).define;

$0bb2f1d33a97833b$var$asn1.base = (parcelRequire("5JhaY"));

$0bb2f1d33a97833b$var$asn1.constants = (parcelRequire("3TcQc"));

$0bb2f1d33a97833b$var$asn1.decoders = (parcelRequire("89TTw"));

$0bb2f1d33a97833b$var$asn1.encoders = (parcelRequire("ljw8S"));

});
parcelRegister("5JhaY", function(module, exports) {
var $42be7a86790be210$var$base = module.exports;

$42be7a86790be210$var$base.Reporter = (parcelRequire("k2jVB")).Reporter;

$42be7a86790be210$var$base.DecoderBuffer = (parcelRequire("33sbF")).DecoderBuffer;

$42be7a86790be210$var$base.EncoderBuffer = (parcelRequire("33sbF")).EncoderBuffer;

$42be7a86790be210$var$base.Node = (parcelRequire("h4y6g"));

});
parcelRegister("k2jVB", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $e96373d85f7a5083$export$957313a2f485e5ed, (v) => $e96373d85f7a5083$export$957313a2f485e5ed = v);
var $e96373d85f7a5083$export$957313a2f485e5ed;

var $dlqwk = parcelRequire("dlqwk");
function $e96373d85f7a5083$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$e96373d85f7a5083$export$957313a2f485e5ed = $e96373d85f7a5083$var$Reporter;
$e96373d85f7a5083$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $e96373d85f7a5083$var$ReporterError;
};
$e96373d85f7a5083$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$e96373d85f7a5083$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$e96373d85f7a5083$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$e96373d85f7a5083$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$e96373d85f7a5083$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$e96373d85f7a5083$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$e96373d85f7a5083$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$e96373d85f7a5083$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$e96373d85f7a5083$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $e96373d85f7a5083$var$ReporterError;
    if (inherited) err = msg;
    else err = new $e96373d85f7a5083$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$e96373d85f7a5083$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $e96373d85f7a5083$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dlqwk($e96373d85f7a5083$var$ReporterError, Error);
$e96373d85f7a5083$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $e96373d85f7a5083$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("33sbF", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $2397844df508f52e$export$bf9f79cdc4a49163, (v) => $2397844df508f52e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $2397844df508f52e$export$8ff24f7760c7a78e, (v) => $2397844df508f52e$export$8ff24f7760c7a78e = v);
var $2397844df508f52e$export$bf9f79cdc4a49163;
var $2397844df508f52e$export$8ff24f7760c7a78e;

var $dlqwk = parcelRequire("dlqwk");

var $5JhaY = parcelRequire("5JhaY");
var $2397844df508f52e$require$Reporter = $5JhaY.Reporter;

var $6ZWSX = parcelRequire("6ZWSX");
var $2397844df508f52e$require$Buffer = $6ZWSX.Buffer;
function $2397844df508f52e$var$DecoderBuffer(base, options) {
    $2397844df508f52e$require$Reporter.call(this, options);
    if (!$2397844df508f52e$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dlqwk($2397844df508f52e$var$DecoderBuffer, $2397844df508f52e$require$Reporter);
$2397844df508f52e$export$bf9f79cdc4a49163 = $2397844df508f52e$var$DecoderBuffer;
$2397844df508f52e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $2397844df508f52e$require$Reporter.prototype.save.call(this)
    };
};
$2397844df508f52e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $2397844df508f52e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$2397844df508f52e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$2397844df508f52e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $2397844df508f52e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $2397844df508f52e$var$EncoderBuffer)) item = new $2397844df508f52e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $2397844df508f52e$require$Buffer.byteLength(value);
    } else if ($2397844df508f52e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$2397844df508f52e$export$8ff24f7760c7a78e = $2397844df508f52e$var$EncoderBuffer;
$2397844df508f52e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $2397844df508f52e$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($2397844df508f52e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("h4y6g", function(module, exports) {

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$Reporter = $5JhaY.Reporter;

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$EncoderBuffer = $5JhaY.EncoderBuffer;

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$DecoderBuffer = $5JhaY.DecoderBuffer;

var $koC21 = parcelRequire("koC21");
// Supported tags
var $c6dd42f3395d566f$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $c6dd42f3395d566f$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($c6dd42f3395d566f$var$tags);
// Overrided methods list
var $c6dd42f3395d566f$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $c6dd42f3395d566f$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c6dd42f3395d566f$var$Node;
var $c6dd42f3395d566f$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$c6dd42f3395d566f$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $c6dd42f3395d566f$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c6dd42f3395d566f$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $c6dd42f3395d566f$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c6dd42f3395d566f$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $koC21(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $koC21.equal(state.children.length, 1, 'Root node can have only one child');
};
$c6dd42f3395d566f$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $koC21(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $koC21(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c6dd42f3395d566f$var$overrided.forEach(function(method) {
    $c6dd42f3395d566f$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$c6dd42f3395d566f$var$tags.forEach(function(tag) {
    $c6dd42f3395d566f$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $koC21(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c6dd42f3395d566f$var$Node.prototype.use = function use(item) {
    $koC21(item);
    var state = this._baseState;
    $koC21(state.use === null);
    state.use = item;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $koC21(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $koC21(state.key === null);
    state.key = newKey;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $koC21(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $koC21(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c6dd42f3395d566f$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $c6dd42f3395d566f$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$c6dd42f3395d566f$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $koC21(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c6dd42f3395d566f$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$c6dd42f3395d566f$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c6dd42f3395d566f$require$EncoderBuffer(data, this.reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c6dd42f3395d566f$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $koC21(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$c6dd42f3395d566f$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c6dd42f3395d566f$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("3TcQc", function(module, exports) {
var $2d507811e368678d$var$constants = module.exports;
// Helper
$2d507811e368678d$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$2d507811e368678d$var$constants.der = (parcelRequire("1G1m0"));

});
parcelRegister("1G1m0", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $138ac3909863432c$export$3584c46ed60baee8, (v) => $138ac3909863432c$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $138ac3909863432c$export$f18596ef8d632e49, (v) => $138ac3909863432c$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $138ac3909863432c$export$2b067c6666111485, (v) => $138ac3909863432c$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $138ac3909863432c$export$f17df38a421ab9e3, (v) => $138ac3909863432c$export$f17df38a421ab9e3 = v);
var $138ac3909863432c$export$3584c46ed60baee8;
var $138ac3909863432c$export$f18596ef8d632e49;
var $138ac3909863432c$export$2b067c6666111485;
var $138ac3909863432c$export$f17df38a421ab9e3;

var $3TcQc = parcelRequire("3TcQc");
$138ac3909863432c$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$138ac3909863432c$export$f18596ef8d632e49 = $3TcQc._reverse($138ac3909863432c$export$3584c46ed60baee8);
$138ac3909863432c$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$138ac3909863432c$export$f17df38a421ab9e3 = $3TcQc._reverse($138ac3909863432c$export$2b067c6666111485);

});


parcelRegister("89TTw", function(module, exports) {
var $5f0a857a78ce037a$var$decoders = module.exports;

$5f0a857a78ce037a$var$decoders.der = (parcelRequire("fkoHA"));

$5f0a857a78ce037a$var$decoders.pem = (parcelRequire("9wGrq"));

});
parcelRegister("fkoHA", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $10gXo = parcelRequire("10gXo");
var $b28be291c8d179e1$var$base = $10gXo.base;
var $b28be291c8d179e1$var$bignum = $10gXo.bignum;
// Import DER constants
var $b28be291c8d179e1$var$der = $10gXo.constants.der;
function $b28be291c8d179e1$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b28be291c8d179e1$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b28be291c8d179e1$var$DERDecoder;
$b28be291c8d179e1$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $b28be291c8d179e1$var$base.DecoderBuffer)) data = new $b28be291c8d179e1$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b28be291c8d179e1$var$DERNode(parent) {
    $b28be291c8d179e1$var$base.Node.call(this, 'der', parent);
}
$dlqwk($b28be291c8d179e1$var$DERNode, $b28be291c8d179e1$var$base.Node);
$b28be291c8d179e1$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $b28be291c8d179e1$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b28be291c8d179e1$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $b28be291c8d179e1$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $b28be291c8d179e1$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$b28be291c8d179e1$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$b28be291c8d179e1$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b28be291c8d179e1$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $b28be291c8d179e1$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b28be291c8d179e1$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $b28be291c8d179e1$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $b28be291c8d179e1$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $b28be291c8d179e1$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b28be291c8d179e1$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("9wGrq", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $6ZWSX = parcelRequire("6ZWSX");
var $6ef8062b6cdbe0f4$require$Buffer = $6ZWSX.Buffer;

var $fkoHA = parcelRequire("fkoHA");
function $6ef8062b6cdbe0f4$var$PEMDecoder(entity) {
    $fkoHA.call(this, entity);
    this.enc = 'pem';
}
$dlqwk($6ef8062b6cdbe0f4$var$PEMDecoder, $fkoHA);
module.exports = $6ef8062b6cdbe0f4$var$PEMDecoder;
$6ef8062b6cdbe0f4$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $6ef8062b6cdbe0f4$require$Buffer(base64, 'base64');
    return $fkoHA.prototype.decode.call(this, input, options);
};

});


parcelRegister("ljw8S", function(module, exports) {
var $f8444e153c0591ac$var$encoders = module.exports;

$f8444e153c0591ac$var$encoders.der = (parcelRequire("2j6ve"));

$f8444e153c0591ac$var$encoders.pem = (parcelRequire("bPffB"));

});
parcelRegister("2j6ve", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $6ZWSX = parcelRequire("6ZWSX");
var $1ae2666fc718ae87$require$Buffer = $6ZWSX.Buffer;

var $10gXo = parcelRequire("10gXo");
var $1ae2666fc718ae87$var$base = $10gXo.base;
// Import DER constants
var $1ae2666fc718ae87$var$der = $10gXo.constants.der;
function $1ae2666fc718ae87$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1ae2666fc718ae87$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1ae2666fc718ae87$var$DEREncoder;
$1ae2666fc718ae87$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $1ae2666fc718ae87$var$DERNode(parent) {
    $1ae2666fc718ae87$var$base.Node.call(this, 'der', parent);
}
$dlqwk($1ae2666fc718ae87$var$DERNode, $1ae2666fc718ae87$var$base.Node);
$1ae2666fc718ae87$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $1ae2666fc718ae87$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $1ae2666fc718ae87$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $1ae2666fc718ae87$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $1ae2666fc718ae87$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $1ae2666fc718ae87$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$1ae2666fc718ae87$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $1ae2666fc718ae87$var$two(date.getFullYear()),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $1ae2666fc718ae87$var$two(date.getFullYear() % 100),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $1ae2666fc718ae87$require$Buffer(numArray);
    }
    if ($1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $1ae2666fc718ae87$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $1ae2666fc718ae87$require$Buffer(out));
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$1ae2666fc718ae87$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$1ae2666fc718ae87$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($1ae2666fc718ae87$var$der.tagByName.hasOwnProperty(tag)) res = $1ae2666fc718ae87$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $1ae2666fc718ae87$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("bPffB", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $2j6ve = parcelRequire("2j6ve");
function $89c04996afa84ca7$var$PEMEncoder(entity) {
    $2j6ve.call(this, entity);
    this.enc = 'pem';
}
$dlqwk($89c04996afa84ca7$var$PEMEncoder, $2j6ve);
module.exports = $89c04996afa84ca7$var$PEMEncoder;
$89c04996afa84ca7$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $2j6ve.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("aeJDW", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("bDaUv", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $10gXo = parcelRequire("10gXo");
var $877bcccea3fc6be5$var$Time = $10gXo.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $877bcccea3fc6be5$var$AttributeTypeValue = $10gXo.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $877bcccea3fc6be5$var$AlgorithmIdentifier = $10gXo.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $877bcccea3fc6be5$var$SubjectPublicKeyInfo = $10gXo.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $877bcccea3fc6be5$var$RelativeDistinguishedName = $10gXo.define('RelativeDistinguishedName', function() {
    this.setof($877bcccea3fc6be5$var$AttributeTypeValue);
});
var $877bcccea3fc6be5$var$RDNSequence = $10gXo.define('RDNSequence', function() {
    this.seqof($877bcccea3fc6be5$var$RelativeDistinguishedName);
});
var $877bcccea3fc6be5$var$Name = $10gXo.define('Name', function() {
    this.choice({
        rdnSequence: this.use($877bcccea3fc6be5$var$RDNSequence)
    });
});
var $877bcccea3fc6be5$var$Validity = $10gXo.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($877bcccea3fc6be5$var$Time), this.key('notAfter').use($877bcccea3fc6be5$var$Time));
});
var $877bcccea3fc6be5$var$Extension = $10gXo.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $877bcccea3fc6be5$var$TBSCertificate = $10gXo.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key('issuer').use($877bcccea3fc6be5$var$Name), this.key('validity').use($877bcccea3fc6be5$var$Validity), this.key('subject').use($877bcccea3fc6be5$var$Name), this.key('subjectPublicKeyInfo').use($877bcccea3fc6be5$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($877bcccea3fc6be5$var$Extension).optional());
});
var $877bcccea3fc6be5$var$X509Certificate = $10gXo.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($877bcccea3fc6be5$var$TBSCertificate), this.key('signatureAlgorithm').use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $877bcccea3fc6be5$var$X509Certificate;

});

parcelRegister("fd3gh", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b12a999e54d2bf45$require$Buffer = $6ZWSX.Buffer;

var $1zUcV = parcelRequire("1zUcV");

var $jqmf0 = parcelRequire("jqmf0");
module.exports = function createECDH(curve) {
    return new $b12a999e54d2bf45$var$ECDH(curve);
};
var $b12a999e54d2bf45$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$b12a999e54d2bf45$var$aliases.p224 = $b12a999e54d2bf45$var$aliases.secp224r1;
$b12a999e54d2bf45$var$aliases.p256 = $b12a999e54d2bf45$var$aliases.secp256r1 = $b12a999e54d2bf45$var$aliases.prime256v1;
$b12a999e54d2bf45$var$aliases.p192 = $b12a999e54d2bf45$var$aliases.secp192r1 = $b12a999e54d2bf45$var$aliases.prime192v1;
$b12a999e54d2bf45$var$aliases.p384 = $b12a999e54d2bf45$var$aliases.secp384r1;
$b12a999e54d2bf45$var$aliases.p521 = $b12a999e54d2bf45$var$aliases.secp521r1;
function $b12a999e54d2bf45$var$ECDH(curve) {
    this.curveType = $b12a999e54d2bf45$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $1zUcV.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$b12a999e54d2bf45$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$b12a999e54d2bf45$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(other)) other = new $b12a999e54d2bf45$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $b12a999e54d2bf45$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $b12a999e54d2bf45$var$formatReturnValue(key, enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $b12a999e54d2bf45$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(pub)) pub = new $b12a999e54d2bf45$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$b12a999e54d2bf45$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(priv)) priv = new $b12a999e54d2bf45$require$Buffer(priv, enc);
    var _priv = new $jqmf0(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $b12a999e54d2bf45$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $b12a999e54d2bf45$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $b12a999e54d2bf45$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $b12a999e54d2bf45$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("1zUcV", function(module, exports) {
'use strict';
var $1264a8f63e75be39$var$elliptic = module.exports;

$1264a8f63e75be39$var$elliptic.version = (parcelRequire("fuV4H")).version;

$1264a8f63e75be39$var$elliptic.utils = (parcelRequire("gEVtY"));

$1264a8f63e75be39$var$elliptic.rand = (parcelRequire("7JHF0"));

$1264a8f63e75be39$var$elliptic.curve = (parcelRequire("cP1GP"));

$1264a8f63e75be39$var$elliptic.curves = (parcelRequire("fbTbW"));

// Protocols
$1264a8f63e75be39$var$elliptic.ec = (parcelRequire("220Zx"));

$1264a8f63e75be39$var$elliptic.eddsa = (parcelRequire("esmmS"));

});

parcelRegister("jqmf0", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("98aLY", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $hkN9y = parcelRequire("hkN9y");

var $1R2J7 = parcelRequire("1R2J7");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3pDg3 = parcelRequire("3pDg3");

var $3Sg1O = parcelRequire("3Sg1O");

var $1U9GM = parcelRequire("1U9GM");
var $6a5d37a95541eeab$require$Buffer = $1U9GM.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6a5d37a95541eeab$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6a5d37a95541eeab$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $6rDPA(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $3Sg1O(paddedMsg, key);
    else return $3pDg3(paddedMsg, key);
};
function $6a5d37a95541eeab$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $1R2J7('sha1').update($6a5d37a95541eeab$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $hkN9y(hLen);
    var maskedDb = $6nrMP($6a5d37a95541eeab$require$Buffer.concat([
        iHash,
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5BMkJ(seed, dblen));
    var maskedSeed = $6nrMP(seed, $5BMkJ(maskedDb, hLen));
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6a5d37a95541eeab$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6a5d37a95541eeab$var$nonZero(k - mLen - 3);
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6a5d37a95541eeab$var$nonZero(len) {
    var out = $6a5d37a95541eeab$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $hkN9y(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $hkN9y(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("aNeDF", function(module, exports) {
'use strict';

var $fC6a8 = parcelRequire("fC6a8");

var $5v6nH = parcelRequire("5v6nH");

var $3ILSx = parcelRequire("3ILSx");

var $7Zu82 = parcelRequire("7Zu82");

var $lORrZ = parcelRequire("lORrZ");

var $1U9GM = parcelRequire("1U9GM");
var $7db9d5f82e4113aa$require$Buffer = $1U9GM.Buffer;
function $7db9d5f82e4113aa$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5v6nH[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $lORrZ.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $7Zu82.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $7db9d5f82e4113aa$require$Buffer.concat(out);
}
function $7db9d5f82e4113aa$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$7db9d5f82e4113aa$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $7db9d5f82e4113aa$require$Buffer.from(buffer);
    var stripped = $3ILSx(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $fC6a8.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $fC6a8.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $fC6a8.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $fC6a8.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $fC6a8.EncryptedPrivateKey.decode(data, 'der');
            data = $7db9d5f82e4113aa$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $fC6a8.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $fC6a8.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fC6a8.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $fC6a8.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $fC6a8.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $fC6a8.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $fC6a8.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $fC6a8.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$7db9d5f82e4113aa$var$parseKeys.signature = $fC6a8.signature;
module.exports = $7db9d5f82e4113aa$var$parseKeys;

});
parcelRegister("fC6a8", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $b5df2f5887fb7e8d$export$c98397a6eb8d0678, (v) => $b5df2f5887fb7e8d$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b, (v) => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $b5df2f5887fb7e8d$export$4471f5c65d097c11, (v) => $b5df2f5887fb7e8d$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de, (v) => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $b5df2f5887fb7e8d$export$8f54525b330fd87b, (v) => $b5df2f5887fb7e8d$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7, (v) => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce, (v) => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $b5df2f5887fb7e8d$export$8ad762e3e6399afe, (v) => $b5df2f5887fb7e8d$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0, (v) => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $b5df2f5887fb7e8d$export$c9cd164b539ebb63, (v) => $b5df2f5887fb7e8d$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b5df2f5887fb7e8d$export$c98397a6eb8d0678;
var $b5df2f5887fb7e8d$export$f4aab6816f64fa6b;
var $b5df2f5887fb7e8d$export$4471f5c65d097c11;
var $b5df2f5887fb7e8d$export$ca8b6604d6ce14de;
var $b5df2f5887fb7e8d$export$8f54525b330fd87b;
var $b5df2f5887fb7e8d$export$23cd2842b44ca3e7;
var $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce;
var $b5df2f5887fb7e8d$export$8ad762e3e6399afe;
var $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0;
var $b5df2f5887fb7e8d$export$c9cd164b539ebb63;
'use strict';

var $10gXo = parcelRequire("10gXo");

$b5df2f5887fb7e8d$export$c98397a6eb8d0678 = (parcelRequire("bDaUv"));
var $b5df2f5887fb7e8d$var$RSAPrivateKey = $10gXo.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$b5df2f5887fb7e8d$export$f4aab6816f64fa6b = $b5df2f5887fb7e8d$var$RSAPrivateKey;
var $b5df2f5887fb7e8d$var$RSAPublicKey = $10gXo.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$b5df2f5887fb7e8d$export$4471f5c65d097c11 = $b5df2f5887fb7e8d$var$RSAPublicKey;
var $b5df2f5887fb7e8d$var$AlgorithmIdentifier = $10gXo.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $b5df2f5887fb7e8d$var$PublicKey = $10gXo.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$b5df2f5887fb7e8d$export$ca8b6604d6ce14de = $b5df2f5887fb7e8d$var$PublicKey;
var $b5df2f5887fb7e8d$var$PrivateKeyInfo = $10gXo.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$b5df2f5887fb7e8d$export$8f54525b330fd87b = $b5df2f5887fb7e8d$var$PrivateKeyInfo;
var $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo = $10gXo.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo;
var $b5df2f5887fb7e8d$var$DSAPrivateKey = $10gXo.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = $b5df2f5887fb7e8d$var$DSAPrivateKey;
$b5df2f5887fb7e8d$export$8ad762e3e6399afe = $10gXo.define('DSAparam', function() {
    this['int']();
});
var $b5df2f5887fb7e8d$var$ECParameters = $10gXo.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $b5df2f5887fb7e8d$var$ECPrivateKey = $10gXo.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($b5df2f5887fb7e8d$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = $b5df2f5887fb7e8d$var$ECPrivateKey;
$b5df2f5887fb7e8d$export$c9cd164b539ebb63 = $10gXo.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});

parcelRegister("5v6nH", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("3ILSx", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $2b5a9edea8bfc145$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $2b5a9edea8bfc145$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $2b5a9edea8bfc145$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bSYjd = parcelRequire("bSYjd");

var $7Zu82 = parcelRequire("7Zu82");

var $1U9GM = parcelRequire("1U9GM");
var $2b5a9edea8bfc145$require$Buffer = $1U9GM.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($2b5a9edea8bfc145$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($2b5a9edea8bfc145$var$fullRegex);
        decrypted = $2b5a9edea8bfc145$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $2b5a9edea8bfc145$require$Buffer.from(match[2], 'hex');
        var cipherText = $2b5a9edea8bfc145$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $bSYjd(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7Zu82.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $2b5a9edea8bfc145$require$Buffer.concat(out);
    }
    var tag = key.match($2b5a9edea8bfc145$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRegister("bSYjd", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $8a7384f85993cf90$require$Buffer = $1U9GM.Buffer;

var $loYLU = parcelRequire("loYLU");
/* eslint-disable camelcase */ function $8a7384f85993cf90$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8a7384f85993cf90$require$Buffer.isBuffer(password)) password = $8a7384f85993cf90$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$8a7384f85993cf90$require$Buffer.isBuffer(salt)) salt = $8a7384f85993cf90$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $8a7384f85993cf90$require$Buffer.alloc(keyLen);
    var iv = $8a7384f85993cf90$require$Buffer.alloc(ivLen || 0);
    var tmp = $8a7384f85993cf90$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $loYLU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8a7384f85993cf90$var$EVP_BytesToKey;

});

parcelRegister("7Zu82", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5d1599d560efe1c2$export$2f64596b8cbf08b4, (v) => $5d1599d560efe1c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5d1599d560efe1c2$export$36b6d6ef312eab39, (v) => $5d1599d560efe1c2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5d1599d560efe1c2$export$58a258485f1e49f6, (v) => $5d1599d560efe1c2$export$58a258485f1e49f6 = v);
var $5d1599d560efe1c2$export$bdd223f16383713e;
var $5d1599d560efe1c2$export$26e5786e8ac8e530;
var $5d1599d560efe1c2$export$2f64596b8cbf08b4;
var $5d1599d560efe1c2$export$20533d26f07f1ee0;
var $5d1599d560efe1c2$export$12ada9414fbc594c;
var $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a;
var $5d1599d560efe1c2$export$36b6d6ef312eab39;
var $5d1599d560efe1c2$export$f5e7e39d57cd9700;
var $5d1599d560efe1c2$export$dedd8dc3dc62b370;
var $5d1599d560efe1c2$export$58a258485f1e49f6;

var $8Zgnw = parcelRequire("8Zgnw");

var $aSTOs = parcelRequire("aSTOs");

var $2lZ3i = parcelRequire("2lZ3i");
function $5d1599d560efe1c2$var$getCiphers() {
    return Object.keys($2lZ3i);
}
$5d1599d560efe1c2$export$bdd223f16383713e = $5d1599d560efe1c2$export$26e5786e8ac8e530 = $8Zgnw.createCipher;
$5d1599d560efe1c2$export$2f64596b8cbf08b4 = $5d1599d560efe1c2$export$20533d26f07f1ee0 = $8Zgnw.createCipheriv;
$5d1599d560efe1c2$export$12ada9414fbc594c = $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a = $aSTOs.createDecipher;
$5d1599d560efe1c2$export$36b6d6ef312eab39 = $5d1599d560efe1c2$export$f5e7e39d57cd9700 = $aSTOs.createDecipheriv;
$5d1599d560efe1c2$export$dedd8dc3dc62b370 = $5d1599d560efe1c2$export$58a258485f1e49f6 = $5d1599d560efe1c2$var$getCiphers;

});
parcelRegister("8Zgnw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $68b0b9a01ec378ac$export$2f64596b8cbf08b4, (v) => $68b0b9a01ec378ac$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $68b0b9a01ec378ac$export$bdd223f16383713e, (v) => $68b0b9a01ec378ac$export$bdd223f16383713e = v);
var $68b0b9a01ec378ac$export$2f64596b8cbf08b4;
var $68b0b9a01ec378ac$export$bdd223f16383713e;

var $5Su5u = parcelRequire("5Su5u");

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $68b0b9a01ec378ac$require$Buffer = $1U9GM.Buffer;

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $68b0b9a01ec378ac$var$Cipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $68b0b9a01ec378ac$var$Splitter();
    this._cipher = new $j0hdX.AES(key);
    this._prev = $68b0b9a01ec378ac$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($68b0b9a01ec378ac$var$Cipher, $26nOC);
$68b0b9a01ec378ac$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $68b0b9a01ec378ac$require$Buffer.concat(out);
};
var $68b0b9a01ec378ac$var$PADDING = $68b0b9a01ec378ac$require$Buffer.alloc(16, 0x10);
$68b0b9a01ec378ac$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($68b0b9a01ec378ac$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$68b0b9a01ec378ac$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $68b0b9a01ec378ac$var$Splitter() {
    this.cache = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(0);
}
$68b0b9a01ec378ac$var$Splitter.prototype.add = function(data) {
    this.cache = $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$68b0b9a01ec378ac$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$68b0b9a01ec378ac$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $68b0b9a01ec378ac$var$createCipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $68b0b9a01ec378ac$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $68b0b9a01ec378ac$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $hzsAp(config.module, password, iv);
    else if (config.type === 'auth') return new $lyZ5N(config.module, password, iv);
    return new $68b0b9a01ec378ac$var$Cipher(config.module, password, iv);
}
function $68b0b9a01ec378ac$var$createCipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $68b0b9a01ec378ac$var$createCipheriv(suite, keys.key, keys.iv);
}
$68b0b9a01ec378ac$export$2f64596b8cbf08b4 = $68b0b9a01ec378ac$var$createCipheriv;
$68b0b9a01ec378ac$export$bdd223f16383713e = $68b0b9a01ec378ac$var$createCipher;

});
parcelRegister("5Su5u", function(module, exports) {








var $447955a9e06650da$var$modeModules = {
    ECB: (parcelRequire("f6p9h")),
    CBC: (parcelRequire("3QymJ")),
    CFB: (parcelRequire("2cuuO")),
    CFB8: (parcelRequire("03mhO")),
    CFB1: (parcelRequire("fK9OU")),
    OFB: (parcelRequire("fFe8N")),
    CTR: (parcelRequire("fJbMg")),
    GCM: (parcelRequire("fJbMg"))
};

var $2lZ3i = parcelRequire("2lZ3i");
for(var $447955a9e06650da$var$key in $2lZ3i)$2lZ3i[$447955a9e06650da$var$key].module = $447955a9e06650da$var$modeModules[$2lZ3i[$447955a9e06650da$var$key].mode];
module.exports = $2lZ3i;

});
parcelRegister("2lZ3i", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("lyZ5N", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $fb2c299f1eae7447$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");

var $5Z5i8 = parcelRequire("5Z5i8");

var $dUX5c = parcelRequire("dUX5c");

var $3VKgl = parcelRequire("3VKgl");
function $fb2c299f1eae7447$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $fb2c299f1eae7447$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $5Z5i8(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($fb2c299f1eae7447$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($fb2c299f1eae7447$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $fb2c299f1eae7447$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $fb2c299f1eae7447$require$Buffer.from(self._finID);
    $3VKgl(out);
    return out;
}
function $fb2c299f1eae7447$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    var h = $fb2c299f1eae7447$require$Buffer.alloc(4, 0);
    this._cipher = new $j0hdX.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $5Z5i8(ck);
    iv = $fb2c299f1eae7447$var$calcIv(this, iv, ck);
    this._prev = $fb2c299f1eae7447$require$Buffer.from(iv);
    this._cache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._secCache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dlqwk($fb2c299f1eae7447$var$StreamCipher, $26nOC);
$fb2c299f1eae7447$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $fb2c299f1eae7447$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$fb2c299f1eae7447$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $dUX5c(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $fb2c299f1eae7447$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$fb2c299f1eae7447$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$fb2c299f1eae7447$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $fb2c299f1eae7447$var$StreamCipher;

});
parcelRegister("j0hdX", function(module, exports) {

$parcel$export(module.exports, "AES", () => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5, (v) => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5;

var $1U9GM = parcelRequire("1U9GM");
var $dd5b60bed61b3c64$require$Buffer = $1U9GM.Buffer;
function $dd5b60bed61b3c64$var$asUInt32Array(buf) {
    if (!$dd5b60bed61b3c64$require$Buffer.isBuffer(buf)) buf = $dd5b60bed61b3c64$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $dd5b60bed61b3c64$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $dd5b60bed61b3c64$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $dd5b60bed61b3c64$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $dd5b60bed61b3c64$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $dd5b60bed61b3c64$var$AES(key) {
    this._key = $dd5b60bed61b3c64$var$asUInt32Array(key);
    this._reset();
}
$dd5b60bed61b3c64$var$AES.blockSize = 16;
$dd5b60bed61b3c64$var$AES.keySize = 32;
$dd5b60bed61b3c64$var$AES.prototype.blockSize = $dd5b60bed61b3c64$var$AES.blockSize;
$dd5b60bed61b3c64$var$AES.prototype.keySize = $dd5b60bed61b3c64$var$AES.keySize;
$dd5b60bed61b3c64$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
            t ^= $dd5b60bed61b3c64$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $dd5b60bed61b3c64$var$G.INV_SUB_MIX[0][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 24]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[1][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 16 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[2][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 8 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[3][$dd5b60bed61b3c64$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    return $dd5b60bed61b3c64$var$cryptBlock(M, this._keySchedule, $dd5b60bed61b3c64$var$G.SUB_MIX, $dd5b60bed61b3c64$var$G.SBOX, this._nRounds);
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.decryptBlock = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $dd5b60bed61b3c64$var$cryptBlock(M, this._invKeySchedule, $dd5b60bed61b3c64$var$G.INV_SUB_MIX, $dd5b60bed61b3c64$var$G.INV_SBOX, this._nRounds);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.scrub = function() {
    $dd5b60bed61b3c64$var$scrubVec(this._keySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._invKeySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._key);
};
$dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = $dd5b60bed61b3c64$var$AES;

});

parcelRegister("5Z5i8", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $45b6c10c8dc18438$require$Buffer = $1U9GM.Buffer;
var $45b6c10c8dc18438$var$ZEROES = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
function $45b6c10c8dc18438$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $45b6c10c8dc18438$var$fromArray(out) {
    var buf = $45b6c10c8dc18438$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $45b6c10c8dc18438$var$GHASH(key) {
    this.h = key;
    this.state = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
    this.cache = $45b6c10c8dc18438$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$45b6c10c8dc18438$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$45b6c10c8dc18438$var$GHASH.prototype._multiply = function() {
    var Vi = $45b6c10c8dc18438$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $45b6c10c8dc18438$var$fromArray(Zi);
};
$45b6c10c8dc18438$var$GHASH.prototype.update = function(buf) {
    this.cache = $45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$45b6c10c8dc18438$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        $45b6c10c8dc18438$var$ZEROES
    ], 16));
    this.ghash($45b6c10c8dc18438$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $45b6c10c8dc18438$var$GHASH;

});


parcelRegister("hzsAp", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $ccabe1300e92c82b$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");
function $ccabe1300e92c82b$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    this._cipher = new $j0hdX.AES(key);
    this._prev = $ccabe1300e92c82b$require$Buffer.from(iv);
    this._cache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._secCache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dlqwk($ccabe1300e92c82b$var$StreamCipher, $26nOC);
$ccabe1300e92c82b$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$ccabe1300e92c82b$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $ccabe1300e92c82b$var$StreamCipher;

});


parcelRegister("aSTOs", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $7eca3dd1d6757703$export$12ada9414fbc594c, (v) => $7eca3dd1d6757703$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $7eca3dd1d6757703$export$36b6d6ef312eab39, (v) => $7eca3dd1d6757703$export$36b6d6ef312eab39 = v);
var $7eca3dd1d6757703$export$12ada9414fbc594c;
var $7eca3dd1d6757703$export$36b6d6ef312eab39;

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $7eca3dd1d6757703$require$Buffer = $1U9GM.Buffer;

var $5Su5u = parcelRequire("5Su5u");

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $7eca3dd1d6757703$var$Decipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $7eca3dd1d6757703$var$Splitter();
    this._last = void 0;
    this._cipher = new $j0hdX.AES(key);
    this._prev = $7eca3dd1d6757703$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($7eca3dd1d6757703$var$Decipher, $26nOC);
$7eca3dd1d6757703$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $7eca3dd1d6757703$require$Buffer.concat(out);
};
$7eca3dd1d6757703$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $7eca3dd1d6757703$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$7eca3dd1d6757703$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7eca3dd1d6757703$var$Splitter() {
    this.cache = $7eca3dd1d6757703$require$Buffer.allocUnsafe(0);
}
$7eca3dd1d6757703$var$Splitter.prototype.add = function(data) {
    this.cache = $7eca3dd1d6757703$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7eca3dd1d6757703$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7eca3dd1d6757703$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $7eca3dd1d6757703$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $7eca3dd1d6757703$var$createDecipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $7eca3dd1d6757703$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $7eca3dd1d6757703$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $hzsAp(config.module, password, iv, true);
    else if (config.type === 'auth') return new $lyZ5N(config.module, password, iv, true);
    return new $7eca3dd1d6757703$var$Decipher(config.module, password, iv);
}
function $7eca3dd1d6757703$var$createDecipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $7eca3dd1d6757703$var$createDecipheriv(suite, keys.key, keys.iv);
}
$7eca3dd1d6757703$export$12ada9414fbc594c = $7eca3dd1d6757703$var$createDecipher;
$7eca3dd1d6757703$export$36b6d6ef312eab39 = $7eca3dd1d6757703$var$createDecipheriv;

});



parcelRegister("lORrZ", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $fe27baa2ca96071e$export$448fa22aedc9dbca, (v) => $fe27baa2ca96071e$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $fe27baa2ca96071e$export$b80c7ba289c8fa56, (v) => $fe27baa2ca96071e$export$b80c7ba289c8fa56 = v);
var $fe27baa2ca96071e$export$448fa22aedc9dbca;
var $fe27baa2ca96071e$export$b80c7ba289c8fa56;

$fe27baa2ca96071e$export$448fa22aedc9dbca = (parcelRequire("5dQ72"));

$fe27baa2ca96071e$export$b80c7ba289c8fa56 = (parcelRequire("1VtKc"));

});


parcelRegister("5BMkJ", function(module, exports) {

var $1R2J7 = parcelRequire("1R2J7");

var $1U9GM = parcelRequire("1U9GM");
var $4155e6705a7c8e0e$require$Buffer = $1U9GM.Buffer;
module.exports = function(seed, len) {
    var t = $4155e6705a7c8e0e$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $4155e6705a7c8e0e$var$i2ops(i++);
        t = $4155e6705a7c8e0e$require$Buffer.concat([
            t,
            $1R2J7('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4155e6705a7c8e0e$var$i2ops(c) {
    var out = $4155e6705a7c8e0e$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("6nrMP", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("6rDPA", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("3pDg3", function(module, exports) {

var $6rDPA = parcelRequire("6rDPA");

var $1U9GM = parcelRequire("1U9GM");
var $27c228af35759e80$require$Buffer = $1U9GM.Buffer;
function $27c228af35759e80$var$withPublic(paddedMsg, key) {
    return $27c228af35759e80$require$Buffer.from(paddedMsg.toRed($6rDPA.mont(key.modulus)).redPow(new $6rDPA(key.publicExponent)).fromRed().toArray());
}
module.exports = $27c228af35759e80$var$withPublic;

});

parcelRegister("3Sg1O", function(module, exports) {
'use strict';

var $dEXSZ = parcelRequire("dEXSZ");

var $hkN9y = parcelRequire("hkN9y");

var $1U9GM = parcelRequire("1U9GM");
var $2d22d91c93a13ae5$require$Buffer = $1U9GM.Buffer;
function $2d22d91c93a13ae5$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $dEXSZ($hkN9y(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $2d22d91c93a13ae5$var$blind(priv) {
    var r = $2d22d91c93a13ae5$var$getr(priv);
    var blinder = r.toRed($dEXSZ.mont(priv.modulus)).redPow(new $dEXSZ(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $2d22d91c93a13ae5$var$crt(msg, priv) {
    var blinds = $2d22d91c93a13ae5$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $dEXSZ(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($dEXSZ.mont(priv.prime1));
    var c2 = blinded.toRed($dEXSZ.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($2d22d91c93a13ae5$require$Buffer, 'be', len);
}
$2d22d91c93a13ae5$var$crt.getr = $2d22d91c93a13ae5$var$getr;
module.exports = $2d22d91c93a13ae5$var$crt;

});


parcelRegister("jU8t7", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3Sg1O = parcelRequire("3Sg1O");

var $1R2J7 = parcelRequire("1R2J7");

var $3pDg3 = parcelRequire("3pDg3");

var $1U9GM = parcelRequire("1U9GM");
var $e7d9d10092031842$require$Buffer = $1U9GM.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $6rDPA(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $3pDg3(new $6rDPA(enc), key);
    else msg = $3Sg1O(enc, key);
    var zBuffer = $e7d9d10092031842$require$Buffer.alloc(k - msg.length);
    msg = $e7d9d10092031842$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e7d9d10092031842$var$oaep(key, msg);
    else if (padding === 1) return $e7d9d10092031842$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $e7d9d10092031842$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $1R2J7('sha1').update($e7d9d10092031842$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $6nrMP(maskedSeed, $5BMkJ(maskedDb, hLen));
    var db = $6nrMP(maskedDb, $5BMkJ(seed, k - hLen - 1));
    if ($e7d9d10092031842$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $e7d9d10092031842$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $e7d9d10092031842$var$compare(a, b) {
    a = $e7d9d10092031842$require$Buffer.from(a);
    b = $e7d9d10092031842$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});

parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});


var $ayMG0 = parcelRequire("ayMG0");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


/**
 * App.
 *
 * The main app file where the rest branch out.
 *
 * @since 0.1.0
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $2a96cca22bca25a2$exports = {};
'use strict';
function $2a96cca22bca25a2$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $acw62 = parcelRequire("acw62");
var $2a96cca22bca25a2$var$React__default = $2a96cca22bca25a2$var$_interopDefault($acw62);
function $2a96cca22bca25a2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2a96cca22bca25a2$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $2a96cca22bca25a2$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $2a96cca22bca25a2$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $2a96cca22bca25a2$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $2a96cca22bca25a2$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($acw62.PureComponent);
        $2a96cca22bca25a2$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $2a96cca22bca25a2$var$_defineProperty(SideEffect, "canUseDOM", $2a96cca22bca25a2$var$canUseDOM);
        return SideEffect;
    };
}
$2a96cca22bca25a2$exports = $2a96cca22bca25a2$var$withSideEffect;


var $77ddc6be16b1d7de$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== 'undefined';
var $77ddc6be16b1d7de$var$hasMap = typeof Map === 'function';
var $77ddc6be16b1d7de$var$hasSet = typeof Set === 'function';
var $77ddc6be16b1d7de$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $77ddc6be16b1d7de$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($77ddc6be16b1d7de$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$77ddc6be16b1d7de$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($77ddc6be16b1d7de$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($77ddc6be16b1d7de$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$77ddc6be16b1d7de$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$77ddc6be16b1d7de$exports = function isEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $acw62 = parcelRequire("acw62");
var $5f82c58e3d599bd6$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$5f82c58e3d599bd6$exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $837d879502e60b4b$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $837d879502e60b4b$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $837d879502e60b4b$var$VALID_TAG_NAMES = Object.keys($837d879502e60b4b$var$TAG_NAMES).map(function(name) {
    return $837d879502e60b4b$var$TAG_NAMES[name];
});
var $837d879502e60b4b$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $837d879502e60b4b$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $837d879502e60b4b$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $837d879502e60b4b$var$HTML_TAG_MAP = Object.keys($837d879502e60b4b$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$837d879502e60b4b$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $837d879502e60b4b$var$SELF_CLOSING_TAGS = [
    $837d879502e60b4b$var$TAG_NAMES.NOSCRIPT,
    $837d879502e60b4b$var$TAG_NAMES.SCRIPT,
    $837d879502e60b4b$var$TAG_NAMES.STYLE
];
var $837d879502e60b4b$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $837d879502e60b4b$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $837d879502e60b4b$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $837d879502e60b4b$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $837d879502e60b4b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $837d879502e60b4b$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $837d879502e60b4b$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $837d879502e60b4b$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $837d879502e60b4b$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $837d879502e60b4b$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$TAG_NAMES.TITLE);
    var innermostTemplate = $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $837d879502e60b4b$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $837d879502e60b4b$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $837d879502e60b4b$var$_extends({}, tagAttrs, current);
    }, {});
};
var $837d879502e60b4b$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$837d879502e60b4b$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$837d879502e60b4b$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $837d879502e60b4b$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $837d879502e60b4b$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $837d879502e60b4b$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $837d879502e60b4b$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $837d879502e60b4b$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $837d879502e60b4b$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $837d879502e60b4b$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($5f82c58e3d599bd6$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $837d879502e60b4b$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $837d879502e60b4b$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $837d879502e60b4b$var$getBaseTagFromPropsList([
            $837d879502e60b4b$var$TAG_PROPERTIES.HREF,
            $837d879502e60b4b$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $837d879502e60b4b$var$getAttributesFromPropsList($837d879502e60b4b$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$HELMET_PROPS.DEFER),
        encode: $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $837d879502e60b4b$var$getAttributesFromPropsList($837d879502e60b4b$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $837d879502e60b4b$var$getTagsFromPropsList($837d879502e60b4b$var$TAG_NAMES.LINK, [
            $837d879502e60b4b$var$TAG_PROPERTIES.REL,
            $837d879502e60b4b$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $837d879502e60b4b$var$getTagsFromPropsList($837d879502e60b4b$var$TAG_NAMES.META, [
            $837d879502e60b4b$var$TAG_PROPERTIES.NAME,
            $837d879502e60b4b$var$TAG_PROPERTIES.CHARSET,
            $837d879502e60b4b$var$TAG_PROPERTIES.HTTPEQUIV,
            $837d879502e60b4b$var$TAG_PROPERTIES.PROPERTY,
            $837d879502e60b4b$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $837d879502e60b4b$var$getTagsFromPropsList($837d879502e60b4b$var$TAG_NAMES.NOSCRIPT, [
            $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $837d879502e60b4b$var$getOnChangeClientState(propsList),
        scriptTags: $837d879502e60b4b$var$getTagsFromPropsList($837d879502e60b4b$var$TAG_NAMES.SCRIPT, [
            $837d879502e60b4b$var$TAG_PROPERTIES.SRC,
            $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $837d879502e60b4b$var$getTagsFromPropsList($837d879502e60b4b$var$TAG_NAMES.STYLE, [
            $837d879502e60b4b$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $837d879502e60b4b$var$getTitleFromPropsList(propsList),
        titleAttributes: $837d879502e60b4b$var$getAttributesFromPropsList($837d879502e60b4b$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $837d879502e60b4b$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $837d879502e60b4b$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $837d879502e60b4b$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $837d879502e60b4b$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $837d879502e60b4b$var$rafPolyfill : $parcel$global.requestAnimationFrame || $837d879502e60b4b$var$rafPolyfill;
var $837d879502e60b4b$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $837d879502e60b4b$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $837d879502e60b4b$var$cafPolyfill;
var $837d879502e60b4b$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $837d879502e60b4b$var$_helmetCallback = null;
var $837d879502e60b4b$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($837d879502e60b4b$var$_helmetCallback) $837d879502e60b4b$var$cancelAnimationFrame($837d879502e60b4b$var$_helmetCallback);
    if (newState.defer) $837d879502e60b4b$var$_helmetCallback = $837d879502e60b4b$var$requestAnimationFrame(function() {
        $837d879502e60b4b$var$commitTagChanges(newState, function() {
            $837d879502e60b4b$var$_helmetCallback = null;
        });
    });
    else {
        $837d879502e60b4b$var$commitTagChanges(newState);
        $837d879502e60b4b$var$_helmetCallback = null;
    }
};
var $837d879502e60b4b$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $837d879502e60b4b$var$updateAttributes($837d879502e60b4b$var$TAG_NAMES.BODY, bodyAttributes);
    $837d879502e60b4b$var$updateAttributes($837d879502e60b4b$var$TAG_NAMES.HTML, htmlAttributes);
    $837d879502e60b4b$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.BASE, baseTag),
        linkTags: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.LINK, linkTags),
        metaTags: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.META, metaTags),
        noscriptTags: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $837d879502e60b4b$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $837d879502e60b4b$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $837d879502e60b4b$var$flattenArray(title);
    $837d879502e60b4b$var$updateAttributes($837d879502e60b4b$var$TAG_NAMES.TITLE, attributes);
};
var $837d879502e60b4b$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($837d879502e60b4b$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($837d879502e60b4b$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($837d879502e60b4b$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($837d879502e60b4b$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $837d879502e60b4b$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($837d879502e60b4b$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $837d879502e60b4b$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $837d879502e60b4b$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($837d879502e60b4b$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $837d879502e60b4b$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $837d879502e60b4b$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $837d879502e60b4b$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $837d879502e60b4b$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $837d879502e60b4b$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $837d879502e60b4b$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $837d879502e60b4b$var$HELMET_ATTRIBUTE + "=\"true\">" + $837d879502e60b4b$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $837d879502e60b4b$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML || attribute === $837d879502e60b4b$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $837d879502e60b4b$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $837d879502e60b4b$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $837d879502e60b4b$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $837d879502e60b4b$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$837d879502e60b4b$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $837d879502e60b4b$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$837d879502e60b4b$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $837d879502e60b4b$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$837d879502e60b4b$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $837d879502e60b4b$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($837d879502e60b4b$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $837d879502e60b4b$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$837d879502e60b4b$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $837d879502e60b4b$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $837d879502e60b4b$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, mappedTag);
    });
};
var $837d879502e60b4b$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $837d879502e60b4b$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $837d879502e60b4b$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $837d879502e60b4b$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $837d879502e60b4b$var$ATTRIBUTE_NAMES.BODY:
        case $837d879502e60b4b$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $837d879502e60b4b$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $837d879502e60b4b$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $837d879502e60b4b$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $837d879502e60b4b$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $837d879502e60b4b$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.META, metaTags, encode),
        noscript: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $837d879502e60b4b$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $837d879502e60b4b$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $837d879502e60b4b$var$classCallCheck(this, HelmetWrapper);
            return $837d879502e60b4b$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($77ddc6be16b1d7de$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $837d879502e60b4b$var$TAG_NAMES.SCRIPT:
                case $837d879502e60b4b$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $837d879502e60b4b$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $837d879502e60b4b$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $837d879502e60b4b$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $837d879502e60b4b$var$TAG_NAMES.TITLE:
                    return $837d879502e60b4b$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $837d879502e60b4b$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $837d879502e60b4b$var$TAG_NAMES.BODY:
                    return $837d879502e60b4b$var$_extends({}, newProps, {
                        bodyAttributes: $837d879502e60b4b$var$_extends({}, newChildProps)
                    });
                case $837d879502e60b4b$var$TAG_NAMES.HTML:
                    return $837d879502e60b4b$var$_extends({}, newProps, {
                        htmlAttributes: $837d879502e60b4b$var$_extends({}, newChildProps)
                    });
            }
            return $837d879502e60b4b$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $837d879502e60b4b$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $837d879502e60b4b$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $837d879502e60b4b$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $837d879502e60b4b$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $837d879502e60b4b$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $837d879502e60b4b$var$TAG_NAMES.LINK:
                    case $837d879502e60b4b$var$TAG_NAMES.META:
                    case $837d879502e60b4b$var$TAG_NAMES.NOSCRIPT:
                    case $837d879502e60b4b$var$TAG_NAMES.SCRIPT:
                    case $837d879502e60b4b$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $837d879502e60b4b$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $837d879502e60b4b$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, newProps);
        };
        $837d879502e60b4b$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $837d879502e60b4b$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $837d879502e60b4b$var$NullComponent = function NullComponent() {
    return null;
};
var $837d879502e60b4b$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($2a96cca22bca25a2$exports)))($837d879502e60b4b$var$reducePropsToState, $837d879502e60b4b$var$handleClientStateChange, $837d879502e60b4b$var$mapStateOnServer)($837d879502e60b4b$var$NullComponent);
var $837d879502e60b4b$export$dcef8f9bb9a41431 = $837d879502e60b4b$var$Helmet($837d879502e60b4b$var$HelmetSideEffects);
$837d879502e60b4b$export$dcef8f9bb9a41431.renderStatic = $837d879502e60b4b$export$dcef8f9bb9a41431.rewind;
var $837d879502e60b4b$export$2e2bcd8739ae039 = $837d879502e60b4b$export$dcef8f9bb9a41431;




var $8nd05 = parcelRequire("8nd05");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");


var $3z1Ay = parcelRequire("3z1Ay");

var $bBbjn = parcelRequire("bBbjn");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $b6f2914bcc222460$var$ThemeContext = /*#__PURE__*/ $acw62.createContext(null);
var $b6f2914bcc222460$export$2e2bcd8739ae039 = $b6f2914bcc222460$var$ThemeContext;


function $feefabedf550ce3f$export$2e2bcd8739ae039() {
    const theme = $acw62.useContext((0, $b6f2914bcc222460$export$2e2bcd8739ae039));
    return theme;
}



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");




const $20a8501e6e2f4912$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $20a8501e6e2f4912$export$2e2bcd8739ae039 = $20a8501e6e2f4912$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $ayMG0 = parcelRequire("ayMG0");
function $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $fff44a152eb20ab0$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $feefabedf550ce3f$export$2e2bcd8739ae039)();
    const theme = $acw62.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $20a8501e6e2f4912$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b6f2914bcc222460$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $fff44a152eb20ab0$export$2e2bcd8739ae039 = $fff44a152eb20ab0$var$ThemeProvider;



parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");
'use client';
function $1f701f7d1726bc9a$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $1f701f7d1726bc9a$var$useTheme(defaultTheme = null) {
    const contextTheme = $acw62.useContext((0, $eP9YU.T));
    return !contextTheme || $1f701f7d1726bc9a$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $1f701f7d1726bc9a$export$2e2bcd8739ae039 = $1f701f7d1726bc9a$var$useTheme;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
const $3bcebab40d8ce666$var$_excluded = [
    "value"
];
const $3bcebab40d8ce666$var$RtlContext = /*#__PURE__*/ $acw62.createContext();
function $3bcebab40d8ce666$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $1En50.default)(_ref, $3bcebab40d8ce666$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3bcebab40d8ce666$var$RtlContext.Provider, (0, $8nd05.default)({
        value: value != null ? value : true
    }, props));
}
const $3bcebab40d8ce666$export$b2dd014b6c321cb = ()=>{
    const value = $acw62.useContext($3bcebab40d8ce666$var$RtlContext);
    return value != null ? value : false;
};
var $3bcebab40d8ce666$export$2e2bcd8739ae039 = $3bcebab40d8ce666$var$RtlProvider;



var $aMyfV = parcelRequire("aMyfV");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $50ef44b883b4d7f9$var$EMPTY_THEME = {};
function $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $acw62.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $8nd05.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $8nd05.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $8nd05.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $50ef44b883b4d7f9$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $1f701f7d1726bc9a$export$2e2bcd8739ae039)($50ef44b883b4d7f9$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $feefabedf550ce3f$export$2e2bcd8739ae039)() || $50ef44b883b4d7f9$var$EMPTY_THEME;
    const engineTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fff44a152eb20ab0$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eP9YU.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bcebab40d8ce666$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aMyfV.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $50ef44b883b4d7f9$export$2e2bcd8739ae039 = $50ef44b883b4d7f9$var$ThemeProvider;


/**
 * Split this component for RSC import
 */ parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
const $1507b440b55b1cf7$export$ff0fa3047d11164c = 'mode';
const $1507b440b55b1cf7$export$665054ea9d94dab9 = 'color-scheme';
const $1507b440b55b1cf7$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $1507b440b55b1cf7$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $1507b440b55b1cf7$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $1507b440b55b1cf7$export$665054ea9d94dab9, attribute: attribute = $1507b440b55b1cf7$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    return /*#__PURE__*/ (0, $ayMG0.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  var mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  var colorScheme = '';
  if (mode === 'system') {
    // handle system mode
    var mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
    } else {
      colorScheme = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
    }
  }
  if (mode === 'light') {
    colorScheme = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  }
  if (mode === 'dark') {
    colorScheme = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  }
  if (colorScheme) {
    ${colorSchemeNode}.setAttribute('${attribute}', colorScheme);
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

'use client';
function $d8b25f9d3c9e642d$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $d8b25f9d3c9e642d$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $d8b25f9d3c9e642d$export$3caa7590cc1987bd(state) {
    return $d8b25f9d3c9e642d$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $d8b25f9d3c9e642d$var$initializeValue(key, defaultValue) {
    if (typeof window === 'undefined') return undefined;
    let value;
    try {
        value = localStorage.getItem(key) || undefined;
        if (!value) // the first time that user enters the site.
        localStorage.setItem(key, defaultValue);
    } catch (e) {
    // Unsupported
    }
    return value || defaultValue;
}
function $d8b25f9d3c9e642d$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $1507b440b55b1cf7$export$ff0fa3047d11164c), colorSchemeStorageKey: colorSchemeStorageKey = (0, $1507b440b55b1cf7$export$665054ea9d94dab9), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const [state, setState] = $acw62.useState(()=>{
        const initialMode = $d8b25f9d3c9e642d$var$initializeValue(modeStorageKey, defaultMode);
        const lightColorScheme = $d8b25f9d3c9e642d$var$initializeValue(`${colorSchemeStorageKey}-light`, defaultLightColorScheme);
        const darkColorScheme = $d8b25f9d3c9e642d$var$initializeValue(`${colorSchemeStorageKey}-dark`, defaultDarkColorScheme);
        return {
            mode: initialMode,
            systemMode: $d8b25f9d3c9e642d$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const colorScheme = $d8b25f9d3c9e642d$export$3caa7590cc1987bd(state);
    const setMode = $acw62.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode != null ? mode : defaultMode;
            try {
                localStorage.setItem(modeStorageKey, newMode);
            } catch (e) {
            // Unsupported
            }
            return (0, $8nd05.default)({}, currentState, {
                mode: newMode,
                systemMode: $d8b25f9d3c9e642d$export$ab3d447356dfa3e5(newMode)
            });
        });
    }, [
        modeStorageKey,
        defaultMode
    ]);
    const setColorScheme = $acw62.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            try {
                localStorage.setItem(`${colorSchemeStorageKey}-light`, defaultLightColorScheme);
                localStorage.setItem(`${colorSchemeStorageKey}-dark`, defaultDarkColorScheme);
            } catch (e) {
            // Unsupported
            }
            return (0, $8nd05.default)({}, currentState, {
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            });
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = (0, $8nd05.default)({}, currentState);
                $d8b25f9d3c9e642d$var$processState(currentState, (mode)=>{
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-${mode}`, value);
                    } catch (e) {
                    // Unsupported
                    }
                    if (mode === 'light') newState.lightColorScheme = value;
                    if (mode === 'dark') newState.darkColorScheme = value;
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = (0, $8nd05.default)({}, currentState);
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-light`, newLightColorScheme);
                    } catch (error) {
                    // Unsupported
                    }
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-dark`, newDarkColorScheme);
                    } catch (error) {
                    // Unsupported
                    }
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        colorSchemeStorageKey,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $acw62.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event != null && event.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return (0, $8nd05.default)({}, currentState, {
                systemMode: systemMode
            });
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $acw62.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $acw62.useEffect(()=>{
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, []);
    // Handle when localStorage has changed
    $acw62.useEffect(()=>{
        if (storageWindow) {
            const handleStorage = (event)=>{
                const value = event.newValue;
                if (typeof event.key === 'string' && event.key.startsWith(colorSchemeStorageKey) && (!value || joinedColorSchemes.match(value))) {
                    // If the key is deleted, value will be null then reset color scheme to the default one.
                    if (event.key.endsWith('light')) setColorScheme({
                        light: value
                    });
                    if (event.key.endsWith('dark')) setColorScheme({
                        dark: value
                    });
                }
                if (event.key === modeStorageKey && (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value))) setMode(value || defaultMode);
            };
            // For syncing color-scheme changes between iframes
            storageWindow.addEventListener('storage', handleStorage);
            return ()=>{
                storageWindow.removeEventListener('storage', handleStorage);
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        modeStorageKey,
        colorSchemeStorageKey,
        joinedColorSchemes,
        defaultMode,
        storageWindow
    ]);
    return (0, $8nd05.default)({}, state, {
        colorScheme: colorScheme,
        setMode: setMode,
        setColorScheme: setColorScheme
    });
}



var $ayMG0 = parcelRequire("ayMG0");
const $8dfeca3d89da820b$var$_excluded = [
    "colorSchemes",
    "components",
    "generateCssVars",
    "cssVarPrefix"
];
const $8dfeca3d89da820b$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $8dfeca3d89da820b$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, attribute: defaultAttribute = (0, $1507b440b55b1cf7$export$14ebe5b26ee7fb38), modeStorageKey: defaultModeStorageKey = (0, $1507b440b55b1cf7$export$ff0fa3047d11164c), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $1507b440b55b1cf7$export$665054ea9d94dab9), defaultMode: designSystemMode = 'light', defaultColorScheme: designSystemColorScheme, disableTransitionOnChange: designSystemTransitionOnChange = false, resolveTheme: resolveTheme, excludeVariablesFromRoot: excludeVariablesFromRoot } = options;
    if (!defaultTheme.colorSchemes || typeof designSystemColorScheme === 'string' && !defaultTheme.colorSchemes[designSystemColorScheme] || typeof designSystemColorScheme === 'object' && !defaultTheme.colorSchemes[designSystemColorScheme == null ? void 0 : designSystemColorScheme.light] || typeof designSystemColorScheme === 'object' && !defaultTheme.colorSchemes[designSystemColorScheme == null ? void 0 : designSystemColorScheme.dark]) console.error(`MUI: \`${designSystemColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
    const ColorSchemeContext = /*#__PURE__*/ $acw62.createContext(undefined);
    const useColorScheme = ()=>{
        const value = $acw62.useContext(ColorSchemeContext);
        if (!value) throw new Error((0, $cpmCj.default)(19));
        return value;
    };
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp = defaultTheme, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, attribute: attribute = defaultAttribute, defaultMode: defaultMode = designSystemMode, defaultColorScheme: defaultColorScheme = designSystemColorScheme, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, colorSchemeSelector: colorSchemeSelector = ':root', disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false } = props;
        const hasMounted = $acw62.useRef(false);
        const upperTheme = (0, $feefabedf550ce3f$export$2e2bcd8739ae039)();
        const ctx = $acw62.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const scopedTheme = themeProp[themeId];
        const _ref = scopedTheme || themeProp, { colorSchemes: colorSchemes = {}, components: components = {}, generateCssVars: generateCssVars = ()=>({
                vars: {},
                css: {}
            }), cssVarPrefix: cssVarPrefix } = _ref, restThemeProp = (0, $1En50.default)(_ref, $8dfeca3d89da820b$var$_excluded);
        const allColorSchemes = Object.keys(colorSchemes);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $d8b25f9d3c9e642d$export$2e2bcd8739ae039)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageWindow: storageWindow
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        const calculatedMode = (()=>{
            if (mode) return mode;
            // This scope occurs on the server
            if (defaultMode === 'system') return designSystemMode;
            return defaultMode;
        })();
        const calculatedColorScheme = (()=>{
            if (!colorScheme) {
                // This scope occurs on the server
                if (calculatedMode === 'dark') return defaultDarkColorScheme;
                // use light color scheme, if default mode is 'light' | 'system'
                return defaultLightColorScheme;
            }
            return colorScheme;
        })();
        // 2. Create CSS variables and store them in objects (to be generated in stylesheets in the final step)
        const { css: rootCss, vars: rootVars } = generateCssVars();
        // 3. Start composing the theme object
        const theme = (0, $8nd05.default)({}, restThemeProp, {
            components: components,
            colorSchemes: colorSchemes,
            cssVarPrefix: cssVarPrefix,
            vars: rootVars,
            getColorSchemeSelector: (targetColorScheme)=>`[${attribute}="${targetColorScheme}"] &`
        });
        // 4. Create color CSS variables and store them in objects (to be generated in stylesheets in the final step)
        //    The default color scheme stylesheet is constructed to have the least CSS specificity.
        //    The other color schemes uses selector, default as data attribute, to increase the CSS specificity so that they can override the default color scheme stylesheet.
        const defaultColorSchemeStyleSheet = {};
        const otherColorSchemesStyleSheet = {};
        Object.entries(colorSchemes).forEach(([key, scheme])=>{
            const { css: css, vars: vars } = generateCssVars(key);
            theme.vars = (0, $3z1Ay.default)(theme.vars, vars);
            if (key === calculatedColorScheme) {
                // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = (0, $8nd05.default)({}, theme[schemeKey], scheme[schemeKey]);
                    else theme[schemeKey] = scheme[schemeKey];
                });
                if (theme.palette) theme.palette.colorScheme = key;
            }
            const resolvedDefaultColorScheme = (()=>{
                if (typeof defaultColorScheme === 'string') return defaultColorScheme;
                if (defaultMode === 'dark') return defaultColorScheme.dark;
                return defaultColorScheme.light;
            })();
            if (key === resolvedDefaultColorScheme) {
                if (excludeVariablesFromRoot) {
                    const excludedVariables = {};
                    excludeVariablesFromRoot(cssVarPrefix).forEach((cssVar)=>{
                        excludedVariables[cssVar] = css[cssVar];
                        delete css[cssVar];
                    });
                    defaultColorSchemeStyleSheet[`[${attribute}="${key}"]`] = excludedVariables;
                }
                defaultColorSchemeStyleSheet[`${colorSchemeSelector}, [${attribute}="${key}"]`] = css;
            } else otherColorSchemesStyleSheet[`${colorSchemeSelector === ':root' ? '' : colorSchemeSelector}[${attribute}="${key}"]`] = css;
        });
        theme.vars = (0, $3z1Ay.default)(theme.vars, rootVars);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        $acw62.useEffect(()=>{
            if (colorScheme && colorSchemeNode) // attaches attribute to <html> because the css variables are attached to :root (html)
            colorSchemeNode.setAttribute(attribute, colorScheme);
        }, [
            colorScheme,
            attribute,
            colorSchemeNode
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $acw62.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($8dfeca3d89da820b$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $acw62.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $acw62.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || nested && (upperTheme == null ? void 0 : upperTheme.cssVarPrefix) === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
            children: [
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bBbjn.default), {
                            styles: {
                                [colorSchemeSelector]: rootCss
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bBbjn.default), {
                            styles: defaultColorSchemeStyleSheet
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bBbjn.default), {
                            styles: otherColorSchemesStyleSheet
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50ef44b883b4d7f9$export$2e2bcd8739ae039), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: resolveTheme ? resolveTheme(theme) : theme,
                    children: children
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof designSystemColorScheme === 'string' ? designSystemColorScheme : designSystemColorScheme.light;
    const defaultDarkColorScheme = typeof designSystemColorScheme === 'string' ? designSystemColorScheme : designSystemColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $1507b440b55b1cf7$export$2e2bcd8739ae039)((0, $8nd05.default)({
            attribute: defaultAttribute,
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultMode: designSystemMode,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey
        }, params));
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}



var $9dZwz = parcelRequire("9dZwz");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $b82d0f0117f79ef3$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}


var $8nd05 = parcelRequire("8nd05");
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}



var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $2b8c5837678016ea$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $2b8c5837678016ea$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $2b8c5837678016ea$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().indexOf('opacity') >= 0) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $2b8c5837678016ea$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $2b8c5837678016ea$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                Object.assign(css, {
                    [cssVar]: $2b8c5837678016ea$var$getCssValue(keys, value)
                });
                $2b8c5837678016ea$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $2b8c5837678016ea$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${value})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}


const $508fc6c60afa1bca$var$_excluded = [
    "colorSchemes",
    "components",
    "defaultColorScheme"
];
function $508fc6c60afa1bca$var$prepareCssVars(theme, parserConfig) {
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, defaultColorScheme: defaultColorScheme = 'light' } = theme, otherTheme = (0, $1En50.default)(theme, $508fc6c60afa1bca$var$_excluded);
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $2b8c5837678016ea$export$2e2bcd8739ae039)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: light } = colorSchemes, otherColorSchemes = (0, $1En50.default)(colorSchemes, [
        defaultColorScheme
    ].map((0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)));
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $2b8c5837678016ea$export$2e2bcd8739ae039)(scheme, parserConfig);
        themeVars = (0, $3z1Ay.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (light) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $2b8c5837678016ea$export$2e2bcd8739ae039)(light, parserConfig);
        themeVars = (0, $3z1Ay.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    const generateCssVars = (colorScheme)=>{
        var _parserConfig$getSele2;
        if (!colorScheme) {
            var _parserConfig$getSele;
            const css = (0, $8nd05.default)({}, rootCss);
            return {
                css: css,
                vars: rootVars,
                selector: (parserConfig == null || (_parserConfig$getSele = parserConfig.getSelector) == null ? void 0 : _parserConfig$getSele.call(parserConfig, colorScheme, css)) || ':root'
            };
        }
        const css = (0, $8nd05.default)({}, colorSchemesMap[colorScheme].css);
        return {
            css: css,
            vars: colorSchemesMap[colorScheme].vars,
            selector: (parserConfig == null || (_parserConfig$getSele2 = parserConfig.getSelector) == null ? void 0 : _parserConfig$getSele2.call(parserConfig, colorScheme, css)) || ':root'
        };
    };
    return {
        vars: themeVars,
        generateCssVars: generateCssVars
    };
}
var $508fc6c60afa1bca$export$2e2bcd8739ae039 = $508fc6c60afa1bca$var$prepareCssVars;



var $9dZwz = parcelRequire("9dZwz");
var $kOOck = parcelRequire("kOOck");

var $kSnzZ = parcelRequire("kSnzZ");
function $b87504e8f71bd950$export$2e2bcd8739ae039(keys) {
    var _keys$;
    return !!keys[0].match(/(cssVarPrefix|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!((_keys$ = keys[1]) != null && _keys$.match(/(mode|contrastThreshold|tonalOffset)/));
}



var $ijOKP = parcelRequire("ijOKP");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $23fa506264c010ed$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $23fa506264c010ed$export$2e2bcd8739ae039 = $23fa506264c010ed$var$getOverlayAlpha;


const $9afe1ce524e8f62d$var$_excluded = [
    "colorSchemes",
    "cssVarPrefix",
    "shouldSkipGeneratingVar"
], $9afe1ce524e8f62d$var$_excluded2 = [
    "palette"
];
const $9afe1ce524e8f62d$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return undefined;
    const overlay = (0, $23fa506264c010ed$export$2e2bcd8739ae039)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $9afe1ce524e8f62d$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $9afe1ce524e8f62d$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $9afe1ce524e8f62d$var$toRgb(color) {
    if (!color || !color.startsWith('hsl')) return color;
    return (0, $kSnzZ.hslToRgb)(color);
}
function $9afe1ce524e8f62d$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $kSnzZ.private_safeColorChannel)($9afe1ce524e8f62d$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
const $9afe1ce524e8f62d$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $9afe1ce524e8f62d$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $b82d0f0117f79ef3$export$2e2bcd8739ae039)(cssVarPrefix);
function $9afe1ce524e8f62d$export$2e2bcd8739ae039(options = {}, ...args) {
    var _colorSchemesInput$li, _colorSchemesInput$da, _colorSchemesInput$li2, _colorSchemesInput$li3, _colorSchemesInput$da2, _colorSchemesInput$da3;
    const { colorSchemes: colorSchemesInput = {}, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $b87504e8f71bd950$export$2e2bcd8739ae039) } = options, input = (0, $1En50.default)(options, $9afe1ce524e8f62d$var$_excluded);
    const getCssVar = $9afe1ce524e8f62d$export$65418b4d9082cc44(cssVarPrefix);
    const _createThemeWithoutVa = (0, $ijOKP.default)((0, $8nd05.default)({}, input, colorSchemesInput.light && {
        palette: (_colorSchemesInput$li = colorSchemesInput.light) == null ? void 0 : _colorSchemesInput$li.palette
    })), { palette: lightPalette } = _createThemeWithoutVa, muiTheme = (0, $1En50.default)(_createThemeWithoutVa, $9afe1ce524e8f62d$var$_excluded2);
    const { palette: darkPalette } = (0, $ijOKP.default)({
        palette: (0, $8nd05.default)({
            mode: 'dark'
        }, (_colorSchemesInput$da = colorSchemesInput.dark) == null ? void 0 : _colorSchemesInput$da.palette)
    });
    let theme = (0, $8nd05.default)({}, muiTheme, {
        cssVarPrefix: cssVarPrefix,
        getCssVar: getCssVar,
        colorSchemes: (0, $8nd05.default)({}, colorSchemesInput, {
            light: (0, $8nd05.default)({}, colorSchemesInput.light, {
                palette: lightPalette,
                opacity: (0, $8nd05.default)({
                    inputPlaceholder: 0.42,
                    inputUnderline: 0.42,
                    switchTrackDisabled: 0.12,
                    switchTrack: 0.38
                }, (_colorSchemesInput$li2 = colorSchemesInput.light) == null ? void 0 : _colorSchemesInput$li2.opacity),
                overlays: ((_colorSchemesInput$li3 = colorSchemesInput.light) == null ? void 0 : _colorSchemesInput$li3.overlays) || []
            }),
            dark: (0, $8nd05.default)({}, colorSchemesInput.dark, {
                palette: darkPalette,
                opacity: (0, $8nd05.default)({
                    inputPlaceholder: 0.5,
                    inputUnderline: 0.7,
                    switchTrackDisabled: 0.2,
                    switchTrack: 0.3
                }, (_colorSchemesInput$da2 = colorSchemesInput.dark) == null ? void 0 : _colorSchemesInput$da2.opacity),
                overlays: ((_colorSchemesInput$da3 = colorSchemesInput.dark) == null ? void 0 : _colorSchemesInput$da3.overlays) || $9afe1ce524e8f62d$var$defaultDarkOverlays
            })
        })
    });
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (key === 'light') {
            $9afe1ce524e8f62d$var$setColor(palette.common, 'background', '#fff');
            $9afe1ce524e8f62d$var$setColor(palette.common, 'onBackground', '#000');
        } else {
            $9afe1ce524e8f62d$var$setColor(palette.common, 'background', '#000');
            $9afe1ce524e8f62d$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $9afe1ce524e8f62d$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (key === 'light') {
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorColor', (0, $kSnzZ.private_safeDarken)(palette.error.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoColor', (0, $kSnzZ.private_safeDarken)(palette.info.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successColor', (0, $kSnzZ.private_safeDarken)(palette.success.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningColor', (0, $kSnzZ.private_safeDarken)(palette.warning.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorFilledColor', $9afe1ce524e8f62d$var$silent(()=>lightPalette.getContrastText(palette.error.main)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoFilledColor', $9afe1ce524e8f62d$var$silent(()=>lightPalette.getContrastText(palette.info.main)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successFilledColor', $9afe1ce524e8f62d$var$silent(()=>lightPalette.getContrastText(palette.success.main)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningFilledColor', $9afe1ce524e8f62d$var$silent(()=>lightPalette.getContrastText(palette.warning.main)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorStandardBg', (0, $kSnzZ.private_safeLighten)(palette.error.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoStandardBg', (0, $kSnzZ.private_safeLighten)(palette.info.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successStandardBg', (0, $kSnzZ.private_safeLighten)(palette.success.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningStandardBg', (0, $kSnzZ.private_safeLighten)(palette.warning.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $9afe1ce524e8f62d$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $9afe1ce524e8f62d$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $9afe1ce524e8f62d$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $9afe1ce524e8f62d$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $9afe1ce524e8f62d$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $9afe1ce524e8f62d$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $9afe1ce524e8f62d$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $9afe1ce524e8f62d$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $9afe1ce524e8f62d$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $9afe1ce524e8f62d$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'primaryBg', (0, $kSnzZ.private_safeLighten)(palette.primary.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $kSnzZ.private_safeLighten)(palette.secondary.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'errorBg', (0, $kSnzZ.private_safeLighten)(palette.error.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'infoBg', (0, $kSnzZ.private_safeLighten)(palette.info.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'successBg', (0, $kSnzZ.private_safeLighten)(palette.success.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'warningBg', (0, $kSnzZ.private_safeLighten)(palette.warning.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'primaryTrack', (0, $kSnzZ.private_safeLighten)(palette.primary.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'secondaryTrack', (0, $kSnzZ.private_safeLighten)(palette.secondary.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'errorTrack', (0, $kSnzZ.private_safeLighten)(palette.error.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'infoTrack', (0, $kSnzZ.private_safeLighten)(palette.info.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'successTrack', (0, $kSnzZ.private_safeLighten)(palette.success.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'warningTrack', (0, $kSnzZ.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $kSnzZ.private_safeEmphasize)(palette.background.default, 0.8);
            $9afe1ce524e8f62d$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $9afe1ce524e8f62d$var$setColor(palette.SnackbarContent, 'color', $9afe1ce524e8f62d$var$silent(()=>lightPalette.getContrastText(snackbarContentBackground)));
            $9afe1ce524e8f62d$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $kSnzZ.private_safeEmphasize)(palette.background.paper, 0.15));
            $9afe1ce524e8f62d$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $9afe1ce524e8f62d$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $kSnzZ.private_safeLighten)(palette.primary.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $kSnzZ.private_safeLighten)(palette.secondary.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'errorDisabledColor', (0, $kSnzZ.private_safeLighten)(palette.error.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'infoDisabledColor', (0, $kSnzZ.private_safeLighten)(palette.info.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'successDisabledColor', (0, $kSnzZ.private_safeLighten)(palette.success.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'warningDisabledColor', (0, $kSnzZ.private_safeLighten)(palette.warning.main, 0.62));
            $9afe1ce524e8f62d$var$setColor(palette.TableCell, 'border', (0, $kSnzZ.private_safeLighten)((0, $kSnzZ.private_safeAlpha)(palette.divider, 1), 0.88));
            $9afe1ce524e8f62d$var$setColor(palette.Tooltip, 'bg', (0, $kSnzZ.private_safeAlpha)(palette.grey[700], 0.92));
        } else {
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorColor', (0, $kSnzZ.private_safeLighten)(palette.error.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoColor', (0, $kSnzZ.private_safeLighten)(palette.info.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successColor', (0, $kSnzZ.private_safeLighten)(palette.success.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningColor', (0, $kSnzZ.private_safeLighten)(palette.warning.light, 0.6));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorFilledColor', $9afe1ce524e8f62d$var$silent(()=>darkPalette.getContrastText(palette.error.dark)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoFilledColor', $9afe1ce524e8f62d$var$silent(()=>darkPalette.getContrastText(palette.info.dark)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successFilledColor', $9afe1ce524e8f62d$var$silent(()=>darkPalette.getContrastText(palette.success.dark)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningFilledColor', $9afe1ce524e8f62d$var$silent(()=>darkPalette.getContrastText(palette.warning.dark)));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorStandardBg', (0, $kSnzZ.private_safeDarken)(palette.error.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoStandardBg', (0, $kSnzZ.private_safeDarken)(palette.info.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successStandardBg', (0, $kSnzZ.private_safeDarken)(palette.success.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningStandardBg', (0, $kSnzZ.private_safeDarken)(palette.warning.light, 0.9));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $9afe1ce524e8f62d$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $9afe1ce524e8f62d$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $9afe1ce524e8f62d$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $9afe1ce524e8f62d$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $9afe1ce524e8f62d$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $9afe1ce524e8f62d$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $9afe1ce524e8f62d$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $9afe1ce524e8f62d$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $9afe1ce524e8f62d$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $9afe1ce524e8f62d$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $9afe1ce524e8f62d$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $9afe1ce524e8f62d$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $9afe1ce524e8f62d$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'primaryBg', (0, $kSnzZ.private_safeDarken)(palette.primary.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $kSnzZ.private_safeDarken)(palette.secondary.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'errorBg', (0, $kSnzZ.private_safeDarken)(palette.error.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'infoBg', (0, $kSnzZ.private_safeDarken)(palette.info.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'successBg', (0, $kSnzZ.private_safeDarken)(palette.success.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.LinearProgress, 'warningBg', (0, $kSnzZ.private_safeDarken)(palette.warning.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'primaryTrack', (0, $kSnzZ.private_safeDarken)(palette.primary.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'secondaryTrack', (0, $kSnzZ.private_safeDarken)(palette.secondary.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'errorTrack', (0, $kSnzZ.private_safeDarken)(palette.error.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'infoTrack', (0, $kSnzZ.private_safeDarken)(palette.info.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'successTrack', (0, $kSnzZ.private_safeDarken)(palette.success.main, 0.5));
            $9afe1ce524e8f62d$var$setColor(palette.Slider, 'warningTrack', (0, $kSnzZ.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $kSnzZ.private_safeEmphasize)(palette.background.default, 0.98);
            $9afe1ce524e8f62d$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $9afe1ce524e8f62d$var$setColor(palette.SnackbarContent, 'color', $9afe1ce524e8f62d$var$silent(()=>darkPalette.getContrastText(snackbarContentBackground)));
            $9afe1ce524e8f62d$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $kSnzZ.private_safeEmphasize)(palette.background.paper, 0.15));
            $9afe1ce524e8f62d$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $9afe1ce524e8f62d$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $kSnzZ.private_safeDarken)(palette.primary.main, 0.55));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $kSnzZ.private_safeDarken)(palette.secondary.main, 0.55));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'errorDisabledColor', (0, $kSnzZ.private_safeDarken)(palette.error.main, 0.55));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'infoDisabledColor', (0, $kSnzZ.private_safeDarken)(palette.info.main, 0.55));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'successDisabledColor', (0, $kSnzZ.private_safeDarken)(palette.success.main, 0.55));
            $9afe1ce524e8f62d$var$setColor(palette.Switch, 'warningDisabledColor', (0, $kSnzZ.private_safeDarken)(palette.warning.main, 0.55));
            $9afe1ce524e8f62d$var$setColor(palette.TableCell, 'border', (0, $kSnzZ.private_safeDarken)((0, $kSnzZ.private_safeAlpha)(palette.divider, 1), 0.68));
            $9afe1ce524e8f62d$var$setColor(palette.Tooltip, 'bg', (0, $kSnzZ.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $9afe1ce524e8f62d$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $9afe1ce524e8f62d$var$setColorChannel(palette.background, 'paper');
        $9afe1ce524e8f62d$var$setColorChannel(palette.common, 'background');
        $9afe1ce524e8f62d$var$setColorChannel(palette.common, 'onBackground');
        $9afe1ce524e8f62d$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $9afe1ce524e8f62d$var$setColor(palette[color], 'mainChannel', (0, $kSnzZ.private_safeColorChannel)($9afe1ce524e8f62d$var$toRgb(colors.main)));
                if (colors.light) $9afe1ce524e8f62d$var$setColor(palette[color], 'lightChannel', (0, $kSnzZ.private_safeColorChannel)($9afe1ce524e8f62d$var$toRgb(colors.light)));
                if (colors.dark) $9afe1ce524e8f62d$var$setColor(palette[color], 'darkChannel', (0, $kSnzZ.private_safeColorChannel)($9afe1ce524e8f62d$var$toRgb(colors.dark)));
                if (colors.contrastText) $9afe1ce524e8f62d$var$setColor(palette[color], 'contrastTextChannel', (0, $kSnzZ.private_safeColorChannel)($9afe1ce524e8f62d$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $9afe1ce524e8f62d$var$setColorChannel(palette[color], 'primary');
                    $9afe1ce524e8f62d$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $9afe1ce524e8f62d$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $9afe1ce524e8f62d$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar
    };
    const { vars: themeVars, generateCssVars: generateCssVars } = (0, $508fc6c60afa1bca$export$2e2bcd8739ae039)(theme, parserConfig);
    theme.vars = themeVars;
    theme.generateCssVars = generateCssVars;
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $kOOck.default), input == null ? void 0 : input.unstable_sxConfig);
    theme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    return theme;
}



var $d6q8u = parcelRequire("d6q8u");
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultMode="dark"`
 */ const $f1b759b2363a287f$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(24)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index + 1}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $f1b759b2363a287f$export$2e2bcd8739ae039 = $f1b759b2363a287f$var$excludeVariablesFromRoot;



var $4jPsi = parcelRequire("4jPsi");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
const $2b983880bbf899cb$export$f84bd70098573c5c = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
var $2b983880bbf899cb$export$2e2bcd8739ae039 = function InitColorSchemeScript(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1507b440b55b1cf7$export$2e2bcd8739ae039), (0, $8nd05.default)({}, $2b983880bbf899cb$export$f84bd70098573c5c, props));
};


'use client';
const $aa64e0883cb2d190$var$defaultTheme = (0, $9afe1ce524e8f62d$export$2e2bcd8739ae039)();
const { CssVarsProvider: $aa64e0883cb2d190$export$99adf6d9ed169a14, useColorScheme: $aa64e0883cb2d190$export$6343629ee1b29116, getInitColorSchemeScript: $aa64e0883cb2d190$var$getInitColorSchemeScriptSystem } = (0, $8dfeca3d89da820b$export$2e2bcd8739ae039)({
    themeId: (0, $4jPsi.default),
    theme: $aa64e0883cb2d190$var$defaultTheme,
    attribute: (0, $2b983880bbf899cb$export$f84bd70098573c5c).attribute,
    colorSchemeStorageKey: (0, $2b983880bbf899cb$export$f84bd70098573c5c).colorSchemeStorageKey,
    modeStorageKey: (0, $2b983880bbf899cb$export$f84bd70098573c5c).modeStorageKey,
    defaultColorScheme: {
        light: (0, $2b983880bbf899cb$export$f84bd70098573c5c).defaultLightColorScheme,
        dark: (0, $2b983880bbf899cb$export$f84bd70098573c5c).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = (0, $8nd05.default)({}, theme, {
            typography: (0, $d6q8u.default)(theme.palette, theme.typography)
        });
        newTheme.unstable_sx = function sx(props) {
            return (0, $9dZwz.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    },
    excludeVariablesFromRoot: $f1b759b2363a287f$export$2e2bcd8739ae039
});
const $aa64e0883cb2d190$export$f9a57b4a2abf8ed = $aa64e0883cb2d190$var$getInitColorSchemeScriptSystem;



var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * Utility functions.
 *
 * These all probably should be in `util/Promise` or something.
 *
 * @since 0.4.0
 */ 
var $eVPL0 = parcelRequire("eVPL0");
const $128066113e324b22$export$2fbe0fdfc24beb3d = (dec)=>(json)=>(0, $eVPL0.match)((failures)=>Promise.reject({
                error: 'JSON decode failure',
                response: json,
                failures: failures
            }), (good)=>Promise.resolve(good))(dec.decode(json));
const $128066113e324b22$export$15d025c4720fa74d = (x)=>x === null ? Promise.reject(new Error('got null')) : Promise.resolve(x);
const $128066113e324b22$export$50eef411b4a58360 = (str)=>{
    try {
        return Promise.resolve(JSON.parse(str));
    } catch (e) {
        return Promise.reject(e);
    }
};


/**
 * Authenication Paramaters
 *
 * @since 0.4.0
 */ 
var $eVPL0 = parcelRequire("eVPL0");
var $87701c398fec8638$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $87701c398fec8638$var$__assign = undefined && undefined.__assign || function() {
    $87701c398fec8638$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $87701c398fec8638$var$__assign.apply(this, arguments);
};
var $87701c398fec8638$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $87701c398fec8638$export$fd43912fe64ec8ed = (0, $eVPL0.left);
var $87701c398fec8638$export$af2dba6db4e9e1f0 = function(value, context, message) {
    return $87701c398fec8638$export$fd43912fe64ec8ed([
        {
            value: value,
            context: context,
            message: message
        }
    ]);
};
var $87701c398fec8638$export$fe7c49d056ea1d88 = (0, $eVPL0.right);
/**
 * @category Codec
 * @since 1.0.0
 */ var $87701c398fec8638$export$92738401e1603719 = /** @class */ function() {
    function Type(/** a unique name for this codec */ name, /** a custom type guard */ is, /** succeeds if a value of type I can be decoded to a value of type A */ validate, /** converts a value of type A to a value of type O */ encode) {
        this.name = name;
        this.is = is;
        this.validate = validate;
        this.encode = encode;
        this.decode = this.decode.bind(this);
    }
    /**
     * @since 1.0.0
     */ Type.prototype.pipe = function(ab, name) {
        var _this = this;
        if (name === void 0) name = "pipe(".concat(this.name, ", ").concat(ab.name, ")");
        return new Type(name, ab.is, function(i, c) {
            var e = _this.validate(i, c);
            if ((0, $eVPL0.isLeft)(e)) return e;
            return ab.validate(e.right, c);
        }, this.encode === $87701c398fec8638$export$f0954fd7d5368655 && ab.encode === $87701c398fec8638$export$f0954fd7d5368655 ? $87701c398fec8638$export$f0954fd7d5368655 : function(b) {
            return _this.encode(ab.encode(b));
        });
    };
    /**
     * @since 1.0.0
     */ Type.prototype.asDecoder = function() {
        return this;
    };
    /**
     * @since 1.0.0
     */ Type.prototype.asEncoder = function() {
        return this;
    };
    /**
     * a version of `validate` with a default context
     * @since 1.0.0
     */ Type.prototype.decode = function(i) {
        return this.validate(i, [
            {
                key: '',
                type: this,
                actual: i
            }
        ]);
    };
    return Type;
}();
var $87701c398fec8638$export$f0954fd7d5368655 = function(a) {
    return a;
};
function $87701c398fec8638$export$aad197c7121a6651(f) {
    return f.displayName || f.name || "<function".concat(f.length, ">");
}
function $87701c398fec8638$export$540babbc0c244fa1(key, decoder) {
    return {
        key: key,
        type: decoder
    };
}
function $87701c398fec8638$export$c5d593f2380f5045(c, key, decoder, actual) {
    var len = c.length;
    var r = Array(len + 1);
    for(var i = 0; i < len; i++)r[i] = c[i];
    r[len] = {
        key: key,
        type: decoder,
        actual: actual
    };
    return r;
}
function $87701c398fec8638$var$pushAll(xs, ys) {
    var l = ys.length;
    for(var i = 0; i < l; i++)xs.push(ys[i]);
}
var $87701c398fec8638$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $87701c398fec8638$var$getNameFromProps(props) {
    return Object.keys(props).map(function(k) {
        return "".concat(k, ": ").concat(props[k].name);
    }).join(', ');
}
function $87701c398fec8638$var$useIdentity(codecs) {
    for(var i = 0; i < codecs.length; i++){
        if (codecs[i].encode !== $87701c398fec8638$export$f0954fd7d5368655) return false;
    }
    return true;
}
function $87701c398fec8638$var$getInterfaceTypeName(props) {
    return "{ ".concat($87701c398fec8638$var$getNameFromProps(props), " }");
}
function $87701c398fec8638$var$getPartialTypeName(inner) {
    return "Partial<".concat(inner, ">");
}
function $87701c398fec8638$var$enumerableRecord(keys, domain, codomain, name) {
    if (name === void 0) name = "{ [K in ".concat(domain.name, "]: ").concat(codomain.name, " }");
    var len = keys.length;
    var props = {};
    for(var i = 0; i < len; i++)props[keys[i]] = codomain;
    var exactCodec = $87701c398fec8638$export$29be874c1daba180(props, name);
    return new $87701c398fec8638$export$b3333eddd0be649b(name, function(u) {
        return exactCodec.is(u);
    }, exactCodec.validate, exactCodec.encode, domain, codomain);
}
function $87701c398fec8638$export$e1d2dd375485c85d(domain) {
    var _a;
    if ($87701c398fec8638$var$isLiteralC(domain)) {
        var literal_1 = domain.value;
        if ($87701c398fec8638$export$22b082955e083ec3.is(literal_1)) return _a = {}, _a[literal_1] = null, _a;
    } else if ($87701c398fec8638$var$isKeyofC(domain)) return domain.keys;
    else if ($87701c398fec8638$var$isUnionC(domain)) {
        var keys = domain.types.map(function(type) {
            return $87701c398fec8638$export$e1d2dd375485c85d(type);
        });
        return keys.some($87701c398fec8638$export$1db45310990710a5.is) ? undefined : Object.assign.apply(Object, $87701c398fec8638$var$__spreadArray([
            {}
        ], keys, false));
    }
    return undefined;
}
function $87701c398fec8638$var$stripNonDomainKeys(o, domain) {
    var keys = Object.keys(o);
    var len = keys.length;
    var shouldStrip = false;
    var r = {};
    for(var i = 0; i < len; i++){
        var k = keys[i];
        if (domain.is(k)) r[k] = o[k];
        else shouldStrip = true;
    }
    return shouldStrip ? r : o;
}
function $87701c398fec8638$var$nonEnumerableRecord(domain, codomain, name) {
    if (name === void 0) name = "{ [K in ".concat(domain.name, "]: ").concat(codomain.name, " }");
    return new $87701c398fec8638$export$b3333eddd0be649b(name, function(u) {
        if ($87701c398fec8638$export$ecfbd036cf5a99af.is(u)) return Object.keys(u).every(function(k) {
            return !domain.is(k) || codomain.is(u[k]);
        });
        return $87701c398fec8638$var$isAnyC(codomain) && Array.isArray(u);
    }, function(u, c) {
        if ($87701c398fec8638$export$ecfbd036cf5a99af.is(u)) {
            var a = {};
            var errors = [];
            var keys = Object.keys(u);
            var len = keys.length;
            var changed = false;
            for(var i = 0; i < len; i++){
                var k = keys[i];
                var ok = u[k];
                var domainResult = domain.validate(k, $87701c398fec8638$export$c5d593f2380f5045(c, k, domain, k));
                if ((0, $eVPL0.isLeft)(domainResult)) changed = true;
                else {
                    var vk = domainResult.right;
                    changed = changed || vk !== k;
                    k = vk;
                    var codomainResult = codomain.validate(ok, $87701c398fec8638$export$c5d593f2380f5045(c, k, codomain, ok));
                    if ((0, $eVPL0.isLeft)(codomainResult)) $87701c398fec8638$var$pushAll(errors, codomainResult.left);
                    else {
                        var vok = codomainResult.right;
                        changed = changed || vok !== ok;
                        a[k] = vok;
                    }
                }
            }
            return errors.length > 0 ? $87701c398fec8638$export$fd43912fe64ec8ed(errors) : $87701c398fec8638$export$fe7c49d056ea1d88(changed ? a : u);
        }
        if ($87701c398fec8638$var$isAnyC(codomain) && Array.isArray(u)) return $87701c398fec8638$export$fe7c49d056ea1d88(u);
        return $87701c398fec8638$export$af2dba6db4e9e1f0(u, c);
    }, domain.encode === $87701c398fec8638$export$f0954fd7d5368655 && codomain.encode === $87701c398fec8638$export$f0954fd7d5368655 ? function(a) {
        return $87701c398fec8638$var$stripNonDomainKeys(a, domain);
    } : function(a) {
        var s = {};
        var keys = Object.keys($87701c398fec8638$var$stripNonDomainKeys(a, domain));
        var len = keys.length;
        for(var i = 0; i < len; i++){
            var k = keys[i];
            s[String(domain.encode(k))] = codomain.encode(a[k]);
        }
        return s;
    }, domain, codomain);
}
function $87701c398fec8638$var$getUnionName(codecs) {
    return '(' + codecs.map(function(type) {
        return type.name;
    }).join(' | ') + ')';
}
function $87701c398fec8638$export$18aef43295bbe906(base, us) {
    var equal = true;
    var primitive = true;
    var baseIsNotADictionary = !$87701c398fec8638$export$ecfbd036cf5a99af.is(base);
    for(var _i = 0, us_1 = us; _i < us_1.length; _i++){
        var u = us_1[_i];
        if (u !== base) equal = false;
        if ($87701c398fec8638$export$ecfbd036cf5a99af.is(u)) primitive = false;
    }
    if (equal) return base;
    else if (primitive) return us[us.length - 1];
    var r = {};
    for(var _a = 0, us_2 = us; _a < us_2.length; _a++){
        var u = us_2[_a];
        for(var k in u)if (!$87701c398fec8638$var$hasOwnProperty.call(r, k) || baseIsNotADictionary || u[k] !== base[k]) r[k] = u[k];
    }
    return r;
}
function $87701c398fec8638$var$getProps(codec) {
    switch(codec._tag){
        case 'RefinementType':
        case 'ReadonlyType':
            return $87701c398fec8638$var$getProps(codec.type);
        case 'InterfaceType':
        case 'StrictType':
        case 'PartialType':
            return codec.props;
        case 'IntersectionType':
            return codec.types.reduce(function(props, type) {
                return Object.assign(props, $87701c398fec8638$var$getProps(type));
            }, {});
    }
}
function $87701c398fec8638$var$stripKeys(o, props) {
    var keys = Object.getOwnPropertyNames(o);
    var shouldStrip = false;
    var r = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$87701c398fec8638$var$hasOwnProperty.call(props, key)) shouldStrip = true;
        else r[key] = o[key];
    }
    return shouldStrip ? r : o;
}
function $87701c398fec8638$var$getExactTypeName(codec) {
    if ($87701c398fec8638$var$isTypeC(codec)) return "{| ".concat($87701c398fec8638$var$getNameFromProps(codec.props), " |}");
    else if ($87701c398fec8638$var$isPartialC(codec)) return $87701c398fec8638$var$getPartialTypeName("{| ".concat($87701c398fec8638$var$getNameFromProps(codec.props), " |}"));
    return "Exact<".concat(codec.name, ">");
}
function $87701c398fec8638$var$isNonEmpty(as) {
    return as.length > 0;
}
var $87701c398fec8638$export$5a86f723dfda3441 = {};
function $87701c398fec8638$var$intersect(a, b) {
    var r = [];
    for(var _i = 0, a_1 = a; _i < a_1.length; _i++){
        var v = a_1[_i];
        if (b.indexOf(v) !== -1) r.push(v);
    }
    return r;
}
function $87701c398fec8638$var$mergeTags(a, b) {
    if (a === $87701c398fec8638$export$5a86f723dfda3441) return b;
    if (b === $87701c398fec8638$export$5a86f723dfda3441) return a;
    var r = Object.assign({}, a);
    for(var k in b)if ($87701c398fec8638$var$hasOwnProperty.call(a, k)) {
        var intersection_1 = $87701c398fec8638$var$intersect(a[k], b[k]);
        if ($87701c398fec8638$var$isNonEmpty(intersection_1)) r[k] = intersection_1;
        else {
            r = $87701c398fec8638$export$5a86f723dfda3441;
            break;
        }
    } else r[k] = b[k];
    return r;
}
function $87701c398fec8638$var$intersectTags(a, b) {
    if (a === $87701c398fec8638$export$5a86f723dfda3441 || b === $87701c398fec8638$export$5a86f723dfda3441) return $87701c398fec8638$export$5a86f723dfda3441;
    var r = $87701c398fec8638$export$5a86f723dfda3441;
    for(var k in a)if ($87701c398fec8638$var$hasOwnProperty.call(b, k)) {
        var intersection_2 = $87701c398fec8638$var$intersect(a[k], b[k]);
        if (intersection_2.length === 0) {
            if (r === $87701c398fec8638$export$5a86f723dfda3441) r = {};
            r[k] = a[k].concat(b[k]);
        }
    }
    return r;
}
// tslint:disable-next-line: deprecation
function $87701c398fec8638$var$isAnyC(codec) {
    return codec._tag === 'AnyType';
}
function $87701c398fec8638$var$isLiteralC(codec) {
    return codec._tag === 'LiteralType';
}
function $87701c398fec8638$var$isKeyofC(codec) {
    return codec._tag === 'KeyofType';
}
function $87701c398fec8638$var$isTypeC(codec) {
    return codec._tag === 'InterfaceType';
}
function $87701c398fec8638$var$isPartialC(codec) {
    return codec._tag === 'PartialType';
}
// tslint:disable-next-line: deprecation
function $87701c398fec8638$var$isStrictC(codec) {
    return codec._tag === 'StrictType';
}
function $87701c398fec8638$var$isExactC(codec) {
    return codec._tag === 'ExactType';
}
// tslint:disable-next-line: deprecation
function $87701c398fec8638$var$isRefinementC(codec) {
    return codec._tag === 'RefinementType';
}
function $87701c398fec8638$var$isIntersectionC(codec) {
    return codec._tag === 'IntersectionType';
}
function $87701c398fec8638$var$isUnionC(codec) {
    return codec._tag === 'UnionType';
}
function $87701c398fec8638$var$isRecursiveC(codec) {
    return codec._tag === 'RecursiveType';
}
function $87701c398fec8638$var$isReadonlyC(codec) {
    return codec._tag === 'ReadonlyType';
}
var $87701c398fec8638$var$lazyCodecs = [];
function $87701c398fec8638$export$af63d7414243dad3(codec) {
    if ($87701c398fec8638$var$lazyCodecs.indexOf(codec) !== -1) return $87701c398fec8638$export$5a86f723dfda3441;
    if ($87701c398fec8638$var$isTypeC(codec) || $87701c398fec8638$var$isStrictC(codec)) {
        var index = $87701c398fec8638$export$5a86f723dfda3441;
        // tslint:disable-next-line: forin
        for(var k in codec.props){
            var prop = codec.props[k];
            if ($87701c398fec8638$var$isLiteralC(prop)) {
                if (index === $87701c398fec8638$export$5a86f723dfda3441) index = {};
                index[k] = [
                    prop.value
                ];
            }
        }
        return index;
    } else if ($87701c398fec8638$var$isExactC(codec) || $87701c398fec8638$var$isRefinementC(codec) || $87701c398fec8638$var$isReadonlyC(codec)) return $87701c398fec8638$export$af63d7414243dad3(codec.type);
    else if ($87701c398fec8638$var$isIntersectionC(codec)) return codec.types.reduce(function(tags, codec) {
        return $87701c398fec8638$var$mergeTags(tags, $87701c398fec8638$export$af63d7414243dad3(codec));
    }, $87701c398fec8638$export$5a86f723dfda3441);
    else if ($87701c398fec8638$var$isUnionC(codec)) return codec.types.slice(1).reduce(function(tags, codec) {
        return $87701c398fec8638$var$intersectTags(tags, $87701c398fec8638$export$af63d7414243dad3(codec));
    }, $87701c398fec8638$export$af63d7414243dad3(codec.types[0]));
    else if ($87701c398fec8638$var$isRecursiveC(codec)) {
        $87701c398fec8638$var$lazyCodecs.push(codec);
        var tags = $87701c398fec8638$export$af63d7414243dad3(codec.type);
        $87701c398fec8638$var$lazyCodecs.pop();
        return tags;
    }
    return $87701c398fec8638$export$5a86f723dfda3441;
}
function $87701c398fec8638$export$ddfa24987dade61b(codecs) {
    var tags = $87701c398fec8638$export$af63d7414243dad3(codecs[0]);
    var keys = Object.keys(tags);
    var len = codecs.length;
    var _loop_1 = function(k) {
        var all = tags[k].slice();
        var index = [
            tags[k]
        ];
        for(var i = 1; i < len; i++){
            var codec = codecs[i];
            var ctags = $87701c398fec8638$export$af63d7414243dad3(codec);
            var values = ctags[k];
            // tslint:disable-next-line: strict-type-predicates
            if (values === undefined) return "continue-keys";
            else {
                if (values.some(function(v) {
                    return all.indexOf(v) !== -1;
                })) return "continue-keys";
                else {
                    all.push.apply(all, values);
                    index.push(values);
                }
            }
        }
        return {
            value: [
                k,
                index
            ]
        };
    };
    keys: for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
        var k = keys_1[_i];
        var state_1 = _loop_1(k);
        if (typeof state_1 === "object") return state_1.value;
        switch(state_1){
            case "continue-keys":
                continue keys;
        }
    }
    return undefined;
}
// -------------------------------------------------------------------------------------
// primitives
// -------------------------------------------------------------------------------------
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$95d6ca0ebe20dc35 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(NullType, _super);
    function NullType() {
        var _this = _super.call(this, 'null', function(u) {
            return u === null;
        }, function(u, c) {
            return _this.is(u) ? $87701c398fec8638$export$fe7c49d056ea1d88(u) : $87701c398fec8638$export$af2dba6db4e9e1f0(u, c);
        }, $87701c398fec8638$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'NullType';
        return _this;
    }
    return NullType;
}($87701c398fec8638$export$92738401e1603719);
var $87701c398fec8638$export$9d93593e0583cfae = new $87701c398fec8638$export$95d6ca0ebe20dc35();
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$f2e4e29641fb7943 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(UndefinedType, _super);
    function UndefinedType() {
        var _this = _super.call(this, 'undefined', function(u) {
            return u === void 0;
        }, function(u, c) {
            return _this.is(u) ? $87701c398fec8638$export$fe7c49d056ea1d88(u) : $87701c398fec8638$export$af2dba6db4e9e1f0(u, c);
        }, $87701c398fec8638$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'UndefinedType';
        return _this;
    }
    return UndefinedType;
}($87701c398fec8638$export$92738401e1603719);
var $87701c398fec8638$export$1db45310990710a5 = new $87701c398fec8638$export$f2e4e29641fb7943();
/**
 * @since 1.2.0
 */ var $87701c398fec8638$export$ba8a14deee5e9cf6 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(VoidType, _super);
    function VoidType() {
        var _this = _super.call(this, 'void', $87701c398fec8638$export$1db45310990710a5.is, $87701c398fec8638$export$1db45310990710a5.validate, $87701c398fec8638$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'VoidType';
        return _this;
    }
    return VoidType;
}($87701c398fec8638$export$92738401e1603719);
var $87701c398fec8638$export$83daf831650100a1 = new $87701c398fec8638$export$ba8a14deee5e9cf6();
/**
 * @since 1.5.0
 */ var $87701c398fec8638$export$df145d679177b39 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(UnknownType, _super);
    function UnknownType() {
        var _this = _super.call(this, 'unknown', function(_) {
            return true;
        }, $87701c398fec8638$export$fe7c49d056ea1d88, $87701c398fec8638$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'UnknownType';
        return _this;
    }
    return UnknownType;
}($87701c398fec8638$export$92738401e1603719);
var $87701c398fec8638$export$19282c40b967aec6 = new $87701c398fec8638$export$df145d679177b39();
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$2b93044cbf134323 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(StringType, _super);
    function StringType() {
        var _this = _super.call(this, 'string', function(u) {
            return typeof u === 'string';
        }, function(u, c) {
            return _this.is(u) ? $87701c398fec8638$export$fe7c49d056ea1d88(u) : $87701c398fec8638$export$af2dba6db4e9e1f0(u, c);
        }, $87701c398fec8638$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'StringType';
        return _this;
    }
    return StringType;
}($87701c398fec8638$export$92738401e1603719);
var $87701c398fec8638$export$22b082955e083ec3 = new $87701c398fec8638$export$2b93044cbf134323();
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$86a7aca748b1e260 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(NumberType, _super);
    function NumberType() {
        var _this = _super.call(this, 'number', function(u) {
            return typeof u === 'number';
        }, function(u, c) {
            return _this.is(u) ? $87701c398fec8638$export$fe7c49d056ea1d88(u) : $87701c398fec8638$export$af2dba6db4e9e1f0(u, c);
        }, $87701c398fec8638$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'NumberType';
        return _this;
    }
    return NumberType;
}($87701c398fec8638$export$92738401e1603719);
var $87701c398fec8638$export$98e628dec113755e = new $87701c398fec8638$export$86a7aca748b1e260();
/**
 * @since 2.1.0
 */ var $87701c398fec8638$export$619c1c26d1e391ec = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(BigIntType, _super);
    function BigIntType() {
        var _this = _super.call(this, 'bigint', // tslint:disable-next-line: valid-typeof
        function(u) {
            return typeof u === 'bigint';
        }, function(u, c) {
            return _this.is(u) ? $87701c398fec8638$export$fe7c49d056ea1d88(u) : $87701c398fec8638$export$af2dba6db4e9e1f0(u, c);
        }, $87701c398fec8638$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'BigIntType';
        return _this;
    }
    return BigIntType;
}($87701c398fec8638$export$92738401e1603719);
var $87701c398fec8638$export$a0f65b52274bcc00 = new $87701c398fec8638$export$619c1c26d1e391ec();
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$240f7fffab1b25a0 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(BooleanType, _super);
    function BooleanType() {
        var _this = _super.call(this, 'boolean', function(u) {
            return typeof u === 'boolean';
        }, function(u, c) {
            return _this.is(u) ? $87701c398fec8638$export$fe7c49d056ea1d88(u) : $87701c398fec8638$export$af2dba6db4e9e1f0(u, c);
        }, $87701c398fec8638$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'BooleanType';
        return _this;
    }
    return BooleanType;
}($87701c398fec8638$export$92738401e1603719);
var $87701c398fec8638$export$4a21f16c33752377 = new $87701c398fec8638$export$240f7fffab1b25a0();
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$ac86d7574eec6a20 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(AnyArrayType, _super);
    function AnyArrayType() {
        var _this = _super.call(this, 'UnknownArray', Array.isArray, function(u, c) {
            return _this.is(u) ? $87701c398fec8638$export$fe7c49d056ea1d88(u) : $87701c398fec8638$export$af2dba6db4e9e1f0(u, c);
        }, $87701c398fec8638$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'AnyArrayType';
        return _this;
    }
    return AnyArrayType;
}($87701c398fec8638$export$92738401e1603719);
var $87701c398fec8638$export$837c7bec7087434c = new $87701c398fec8638$export$ac86d7574eec6a20();
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$114de0f37b8f7d23 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(AnyDictionaryType, _super);
    function AnyDictionaryType() {
        var _this = _super.call(this, 'UnknownRecord', function(u) {
            return u !== null && typeof u === 'object' && !Array.isArray(u);
        }, function(u, c) {
            return _this.is(u) ? $87701c398fec8638$export$fe7c49d056ea1d88(u) : $87701c398fec8638$export$af2dba6db4e9e1f0(u, c);
        }, $87701c398fec8638$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'AnyDictionaryType';
        return _this;
    }
    return AnyDictionaryType;
}($87701c398fec8638$export$92738401e1603719);
var $87701c398fec8638$export$ecfbd036cf5a99af = new $87701c398fec8638$export$114de0f37b8f7d23();
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$d6c96d9c1c53b151 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(LiteralType, _super);
    function LiteralType(name, is, validate, encode, value) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.value = value;
        /**
         * @since 1.0.0
         */ _this._tag = 'LiteralType';
        return _this;
    }
    return LiteralType;
}($87701c398fec8638$export$92738401e1603719);
function $87701c398fec8638$export$c8ec6e1ec9fefcb0(value, name) {
    if (name === void 0) name = JSON.stringify(value);
    var is = function(u) {
        return u === value;
    };
    return new $87701c398fec8638$export$d6c96d9c1c53b151(name, is, function(u, c) {
        return is(u) ? $87701c398fec8638$export$fe7c49d056ea1d88(value) : $87701c398fec8638$export$af2dba6db4e9e1f0(u, c);
    }, $87701c398fec8638$export$f0954fd7d5368655, value);
}
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$9716a65a8e770652 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(KeyofType, _super);
    function KeyofType(name, is, validate, encode, keys) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.keys = keys;
        /**
         * @since 1.0.0
         */ _this._tag = 'KeyofType';
        return _this;
    }
    return KeyofType;
}($87701c398fec8638$export$92738401e1603719);
function $87701c398fec8638$export$7e1278799275f68e(keys, name) {
    if (name === void 0) name = Object.keys(keys).map(function(k) {
        return JSON.stringify(k);
    }).join(' | ');
    var is = function(u) {
        return $87701c398fec8638$export$22b082955e083ec3.is(u) && $87701c398fec8638$var$hasOwnProperty.call(keys, u);
    };
    return new $87701c398fec8638$export$9716a65a8e770652(name, is, function(u, c) {
        return is(u) ? $87701c398fec8638$export$fe7c49d056ea1d88(u) : $87701c398fec8638$export$af2dba6db4e9e1f0(u, c);
    }, $87701c398fec8638$export$f0954fd7d5368655, keys);
}
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$75d4a1b670774175 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(RefinementType, _super);
    function RefinementType(name, is, validate, encode, type, predicate) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        _this.predicate = predicate;
        /**
         * @since 1.0.0
         */ _this._tag = 'RefinementType';
        return _this;
    }
    return RefinementType;
}($87701c398fec8638$export$92738401e1603719);
function $87701c398fec8638$export$96ff94e0adb1d772(codec, predicate, name) {
    return $87701c398fec8638$export$99656c995101768a(codec, predicate, name);
}
var $87701c398fec8638$export$fdd676b64b72b00 = $87701c398fec8638$export$96ff94e0adb1d772($87701c398fec8638$export$98e628dec113755e, function(n) {
    return Number.isInteger(n);
}, 'Int');
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$430fa421231b5068 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(RecursiveType, _super);
    function RecursiveType(name, is, validate, encode, runDefinition) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.runDefinition = runDefinition;
        /**
         * @since 1.0.0
         */ _this._tag = 'RecursiveType';
        return _this;
    }
    return RecursiveType;
}($87701c398fec8638$export$92738401e1603719);
Object.defineProperty($87701c398fec8638$export$430fa421231b5068.prototype, 'type', {
    get: function() {
        return this.runDefinition();
    },
    enumerable: true,
    configurable: true
});
function $87701c398fec8638$export$74c5cab0f9a94551(name, definition) {
    var cache;
    var runDefinition = function() {
        if (!cache) {
            cache = definition(Self);
            cache.name = name;
        }
        return cache;
    };
    var Self = new $87701c398fec8638$export$430fa421231b5068(name, function(u) {
        return runDefinition().is(u);
    }, function(u, c) {
        return runDefinition().validate(u, c);
    }, function(a) {
        return runDefinition().encode(a);
    }, runDefinition);
    return Self;
}
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$49c146ea18b05474 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(ArrayType, _super);
    function ArrayType(name, is, validate, encode, type) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        /**
         * @since 1.0.0
         */ _this._tag = 'ArrayType';
        return _this;
    }
    return ArrayType;
}($87701c398fec8638$export$92738401e1603719);
function $87701c398fec8638$export$2f23118c22fb2630(item, name) {
    if (name === void 0) name = "Array<".concat(item.name, ">");
    return new $87701c398fec8638$export$49c146ea18b05474(name, function(u) {
        return $87701c398fec8638$export$837c7bec7087434c.is(u) && u.every(item.is);
    }, function(u, c) {
        var e = $87701c398fec8638$export$837c7bec7087434c.validate(u, c);
        if ((0, $eVPL0.isLeft)(e)) return e;
        var us = e.right;
        var len = us.length;
        var as = us;
        var errors = [];
        for(var i = 0; i < len; i++){
            var ui = us[i];
            var result = item.validate(ui, $87701c398fec8638$export$c5d593f2380f5045(c, String(i), item, ui));
            if ((0, $eVPL0.isLeft)(result)) $87701c398fec8638$var$pushAll(errors, result.left);
            else {
                var ai = result.right;
                if (ai !== ui) {
                    if (as === us) as = us.slice();
                    as[i] = ai;
                }
            }
        }
        return errors.length > 0 ? $87701c398fec8638$export$fd43912fe64ec8ed(errors) : $87701c398fec8638$export$fe7c49d056ea1d88(as);
    }, item.encode === $87701c398fec8638$export$f0954fd7d5368655 ? $87701c398fec8638$export$f0954fd7d5368655 : function(a) {
        return a.map(item.encode);
    }, item);
}
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$f57ee166a379f505 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(InterfaceType, _super);
    function InterfaceType(name, is, validate, encode, props) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.props = props;
        /**
         * @since 1.0.0
         */ _this._tag = 'InterfaceType';
        return _this;
    }
    return InterfaceType;
}($87701c398fec8638$export$92738401e1603719);
function $87701c398fec8638$export$bf9fb029d174d554(props, name) {
    if (name === void 0) name = $87701c398fec8638$var$getInterfaceTypeName(props);
    var keys = Object.keys(props);
    var types = keys.map(function(key) {
        return props[key];
    });
    var len = keys.length;
    return new $87701c398fec8638$export$f57ee166a379f505(name, function(u) {
        if ($87701c398fec8638$export$ecfbd036cf5a99af.is(u)) {
            for(var i = 0; i < len; i++){
                var k = keys[i];
                var uk = u[k];
                if (uk === undefined && !$87701c398fec8638$var$hasOwnProperty.call(u, k) || !types[i].is(uk)) return false;
            }
            return true;
        }
        return false;
    }, function(u, c) {
        var e = $87701c398fec8638$export$ecfbd036cf5a99af.validate(u, c);
        if ((0, $eVPL0.isLeft)(e)) return e;
        var o = e.right;
        var a = o;
        var errors = [];
        for(var i = 0; i < len; i++){
            var k = keys[i];
            var ak = a[k];
            var type_1 = types[i];
            var result = type_1.validate(ak, $87701c398fec8638$export$c5d593f2380f5045(c, k, type_1, ak));
            if ((0, $eVPL0.isLeft)(result)) $87701c398fec8638$var$pushAll(errors, result.left);
            else {
                var vak = result.right;
                if (vak !== ak || vak === undefined && !$87701c398fec8638$var$hasOwnProperty.call(a, k)) {
                    /* istanbul ignore next */ if (a === o) a = $87701c398fec8638$var$__assign({}, o);
                    a[k] = vak;
                }
            }
        }
        return errors.length > 0 ? $87701c398fec8638$export$fd43912fe64ec8ed(errors) : $87701c398fec8638$export$fe7c49d056ea1d88(a);
    }, $87701c398fec8638$var$useIdentity(types) ? $87701c398fec8638$export$f0954fd7d5368655 : function(a) {
        var s = $87701c398fec8638$var$__assign({}, a);
        for(var i = 0; i < len; i++){
            var k = keys[i];
            var encode = types[i].encode;
            if (encode !== $87701c398fec8638$export$f0954fd7d5368655) s[k] = encode(a[k]);
        }
        return s;
    }, props);
}
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$3c1c44baadfdf95a = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(PartialType, _super);
    function PartialType(name, is, validate, encode, props) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.props = props;
        /**
         * @since 1.0.0
         */ _this._tag = 'PartialType';
        return _this;
    }
    return PartialType;
}($87701c398fec8638$export$92738401e1603719);
function $87701c398fec8638$export$e45945969df8035a(props, name) {
    if (name === void 0) name = $87701c398fec8638$var$getPartialTypeName($87701c398fec8638$var$getInterfaceTypeName(props));
    var keys = Object.keys(props);
    var types = keys.map(function(key) {
        return props[key];
    });
    var len = keys.length;
    return new $87701c398fec8638$export$3c1c44baadfdf95a(name, function(u) {
        if ($87701c398fec8638$export$ecfbd036cf5a99af.is(u)) {
            for(var i = 0; i < len; i++){
                var k = keys[i];
                var uk = u[k];
                if (uk !== undefined && !props[k].is(uk)) return false;
            }
            return true;
        }
        return false;
    }, function(u, c) {
        var e = $87701c398fec8638$export$ecfbd036cf5a99af.validate(u, c);
        if ((0, $eVPL0.isLeft)(e)) return e;
        var o = e.right;
        var a = o;
        var errors = [];
        for(var i = 0; i < len; i++){
            var k = keys[i];
            var ak = a[k];
            var type_2 = props[k];
            var result = type_2.validate(ak, $87701c398fec8638$export$c5d593f2380f5045(c, k, type_2, ak));
            if ((0, $eVPL0.isLeft)(result)) {
                if (ak !== undefined) $87701c398fec8638$var$pushAll(errors, result.left);
            } else {
                var vak = result.right;
                if (vak !== ak) {
                    /* istanbul ignore next */ if (a === o) a = $87701c398fec8638$var$__assign({}, o);
                    a[k] = vak;
                }
            }
        }
        return errors.length > 0 ? $87701c398fec8638$export$fd43912fe64ec8ed(errors) : $87701c398fec8638$export$fe7c49d056ea1d88(a);
    }, $87701c398fec8638$var$useIdentity(types) ? $87701c398fec8638$export$f0954fd7d5368655 : function(a) {
        var s = $87701c398fec8638$var$__assign({}, a);
        for(var i = 0; i < len; i++){
            var k = keys[i];
            var ak = a[k];
            if (ak !== undefined) s[k] = types[i].encode(ak);
        }
        return s;
    }, props);
}
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$b3333eddd0be649b = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(DictionaryType, _super);
    function DictionaryType(name, is, validate, encode, domain, codomain) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.domain = domain;
        _this.codomain = codomain;
        /**
         * @since 1.0.0
         */ _this._tag = 'DictionaryType';
        return _this;
    }
    return DictionaryType;
}($87701c398fec8638$export$92738401e1603719);
function $87701c398fec8638$export$e5185e241753e543(domain, codomain, name) {
    var keys = $87701c398fec8638$export$e1d2dd375485c85d(domain);
    return keys ? $87701c398fec8638$var$enumerableRecord(Object.keys(keys), domain, codomain, name) : $87701c398fec8638$var$nonEnumerableRecord(domain, codomain, name);
}
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$9b31524cbbc7993 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(UnionType, _super);
    function UnionType(name, is, validate, encode, types) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.types = types;
        /**
         * @since 1.0.0
         */ _this._tag = 'UnionType';
        return _this;
    }
    return UnionType;
}($87701c398fec8638$export$92738401e1603719);
function $87701c398fec8638$export$971dd5b0dfd021b6(codecs, name) {
    if (name === void 0) name = $87701c398fec8638$var$getUnionName(codecs);
    var index = $87701c398fec8638$export$ddfa24987dade61b(codecs);
    if (index !== undefined && codecs.length > 0) {
        var tag_1 = index[0], groups_1 = index[1];
        var len_1 = groups_1.length;
        var find_1 = function(value) {
            for(var i = 0; i < len_1; i++){
                if (groups_1[i].indexOf(value) !== -1) return i;
            }
            return undefined;
        };
        // tslint:disable-next-line: deprecation
        return new $87701c398fec8638$export$b00fe6dbb0de05b6(name, function(u) {
            if ($87701c398fec8638$export$ecfbd036cf5a99af.is(u)) {
                var i = find_1(u[tag_1]);
                return i !== undefined ? codecs[i].is(u) : false;
            }
            return false;
        }, function(u, c) {
            var e = $87701c398fec8638$export$ecfbd036cf5a99af.validate(u, c);
            if ((0, $eVPL0.isLeft)(e)) return e;
            var r = e.right;
            var i = find_1(r[tag_1]);
            if (i === undefined) return $87701c398fec8638$export$af2dba6db4e9e1f0(u, c);
            var codec = codecs[i];
            return codec.validate(r, $87701c398fec8638$export$c5d593f2380f5045(c, String(i), codec, r));
        }, $87701c398fec8638$var$useIdentity(codecs) ? $87701c398fec8638$export$f0954fd7d5368655 : function(a) {
            var i = find_1(a[tag_1]);
            if (i === undefined) // https://github.com/gcanti/io-ts/pull/305
            throw new Error("no codec found to encode value in union codec ".concat(name));
            else return codecs[i].encode(a);
        }, codecs, tag_1);
    } else return new $87701c398fec8638$export$9b31524cbbc7993(name, function(u) {
        return codecs.some(function(type) {
            return type.is(u);
        });
    }, function(u, c) {
        var errors = [];
        for(var i = 0; i < codecs.length; i++){
            var codec = codecs[i];
            var result = codec.validate(u, $87701c398fec8638$export$c5d593f2380f5045(c, String(i), codec, u));
            if ((0, $eVPL0.isLeft)(result)) $87701c398fec8638$var$pushAll(errors, result.left);
            else return $87701c398fec8638$export$fe7c49d056ea1d88(result.right);
        }
        return $87701c398fec8638$export$fd43912fe64ec8ed(errors);
    }, $87701c398fec8638$var$useIdentity(codecs) ? $87701c398fec8638$export$f0954fd7d5368655 : function(a) {
        for(var _i = 0, codecs_1 = codecs; _i < codecs_1.length; _i++){
            var codec = codecs_1[_i];
            if (codec.is(a)) return codec.encode(a);
        }
        // https://github.com/gcanti/io-ts/pull/305
        throw new Error("no codec found to encode value in union type ".concat(name));
    }, codecs);
}
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$28e23bba31d0f3b2 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(IntersectionType, _super);
    function IntersectionType(name, is, validate, encode, types) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.types = types;
        /**
         * @since 1.0.0
         */ _this._tag = 'IntersectionType';
        return _this;
    }
    return IntersectionType;
}($87701c398fec8638$export$92738401e1603719);
function $87701c398fec8638$export$bc86dfbf7795668c(codecs, name) {
    if (name === void 0) name = "(".concat(codecs.map(function(type) {
        return type.name;
    }).join(' & '), ")");
    var len = codecs.length;
    return new $87701c398fec8638$export$28e23bba31d0f3b2(name, function(u) {
        return codecs.every(function(type) {
            return type.is(u);
        });
    }, codecs.length === 0 ? $87701c398fec8638$export$fe7c49d056ea1d88 : function(u, c) {
        var us = [];
        var errors = [];
        for(var i = 0; i < len; i++){
            var codec = codecs[i];
            var result = codec.validate(u, $87701c398fec8638$export$c5d593f2380f5045(c, String(i), codec, u));
            if ((0, $eVPL0.isLeft)(result)) $87701c398fec8638$var$pushAll(errors, result.left);
            else us.push(result.right);
        }
        return errors.length > 0 ? $87701c398fec8638$export$fd43912fe64ec8ed(errors) : $87701c398fec8638$export$fe7c49d056ea1d88($87701c398fec8638$export$18aef43295bbe906(u, us));
    }, codecs.length === 0 ? $87701c398fec8638$export$f0954fd7d5368655 : function(a) {
        return $87701c398fec8638$export$18aef43295bbe906(a, codecs.map(function(codec) {
            return codec.encode(a);
        }));
    }, codecs);
}
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$4e91a628a05a1342 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(TupleType, _super);
    function TupleType(name, is, validate, encode, types) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.types = types;
        /**
         * @since 1.0.0
         */ _this._tag = 'TupleType';
        return _this;
    }
    return TupleType;
}($87701c398fec8638$export$92738401e1603719);
function $87701c398fec8638$export$65e3907585753458(codecs, name) {
    if (name === void 0) name = "[".concat(codecs.map(function(type) {
        return type.name;
    }).join(', '), "]");
    var len = codecs.length;
    return new $87701c398fec8638$export$4e91a628a05a1342(name, function(u) {
        return $87701c398fec8638$export$837c7bec7087434c.is(u) && u.length === len && codecs.every(function(type, i) {
            return type.is(u[i]);
        });
    }, function(u, c) {
        var e = $87701c398fec8638$export$837c7bec7087434c.validate(u, c);
        if ((0, $eVPL0.isLeft)(e)) return e;
        var us = e.right;
        var as = us.length > len ? us.slice(0, len) : us; // strip additional components
        var errors = [];
        for(var i = 0; i < len; i++){
            var a = us[i];
            var type_3 = codecs[i];
            var result = type_3.validate(a, $87701c398fec8638$export$c5d593f2380f5045(c, String(i), type_3, a));
            if ((0, $eVPL0.isLeft)(result)) $87701c398fec8638$var$pushAll(errors, result.left);
            else {
                var va = result.right;
                if (va !== a) {
                    /* istanbul ignore next */ if (as === us) as = us.slice();
                    as[i] = va;
                }
            }
        }
        return errors.length > 0 ? $87701c398fec8638$export$fd43912fe64ec8ed(errors) : $87701c398fec8638$export$fe7c49d056ea1d88(as);
    }, $87701c398fec8638$var$useIdentity(codecs) ? $87701c398fec8638$export$f0954fd7d5368655 : function(a) {
        return codecs.map(function(type, i) {
            return type.encode(a[i]);
        });
    }, codecs);
}
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$13011d386df050c2 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(ReadonlyType, _super);
    function ReadonlyType(name, is, validate, encode, type) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        /**
         * @since 1.0.0
         */ _this._tag = 'ReadonlyType';
        return _this;
    }
    return ReadonlyType;
}($87701c398fec8638$export$92738401e1603719);
function $87701c398fec8638$export$6ec456bd5b7b3c51(codec, name) {
    if (name === void 0) name = "Readonly<".concat(codec.name, ">");
    return new $87701c398fec8638$export$13011d386df050c2(name, codec.is, codec.validate, codec.encode, codec);
}
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$fe6530276c28a251 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(ReadonlyArrayType, _super);
    function ReadonlyArrayType(name, is, validate, encode, type) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        /**
         * @since 1.0.0
         */ _this._tag = 'ReadonlyArrayType';
        return _this;
    }
    return ReadonlyArrayType;
}($87701c398fec8638$export$92738401e1603719);
function $87701c398fec8638$export$95ca155af9fd5713(item, name) {
    if (name === void 0) name = "ReadonlyArray<".concat(item.name, ">");
    var codec = $87701c398fec8638$export$2f23118c22fb2630(item);
    return new $87701c398fec8638$export$fe6530276c28a251(name, codec.is, codec.validate, codec.encode, item);
}
var $87701c398fec8638$export$29be874c1daba180 = function(props, name) {
    return $87701c398fec8638$export$5f3c29cf4492ebb9($87701c398fec8638$export$bf9fb029d174d554(props), name);
};
/**
 * @since 1.1.0
 */ var $87701c398fec8638$export$aee107ca284ccf4e = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(ExactType, _super);
    function ExactType(name, is, validate, encode, type) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        /**
         * @since 1.0.0
         */ _this._tag = 'ExactType';
        return _this;
    }
    return ExactType;
}($87701c398fec8638$export$92738401e1603719);
function $87701c398fec8638$export$5f3c29cf4492ebb9(codec, name) {
    if (name === void 0) name = $87701c398fec8638$var$getExactTypeName(codec);
    var props = $87701c398fec8638$var$getProps(codec);
    return new $87701c398fec8638$export$aee107ca284ccf4e(name, codec.is, function(u, c) {
        var e = $87701c398fec8638$export$ecfbd036cf5a99af.validate(u, c);
        if ((0, $eVPL0.isLeft)(e)) return e;
        var ce = codec.validate(u, c);
        if ((0, $eVPL0.isLeft)(ce)) return ce;
        return (0, $eVPL0.right)($87701c398fec8638$var$stripKeys(ce.right, props));
    }, function(a) {
        return codec.encode($87701c398fec8638$var$stripKeys(a, props));
    }, codec);
}
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$47dda4034ce65bf2 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(FunctionType, _super);
    function FunctionType() {
        var _this = _super.call(this, 'Function', // tslint:disable-next-line:strict-type-predicates
        function(u) {
            return typeof u === 'function';
        }, function(u, c) {
            return _this.is(u) ? $87701c398fec8638$export$fe7c49d056ea1d88(u) : $87701c398fec8638$export$af2dba6db4e9e1f0(u, c);
        }, $87701c398fec8638$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'FunctionType';
        return _this;
    }
    return FunctionType;
}($87701c398fec8638$export$92738401e1603719);
var $87701c398fec8638$export$f3890eeaf6851387 = new $87701c398fec8638$export$47dda4034ce65bf2();
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$203633b10d4a485e = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(NeverType, _super);
    function NeverType() {
        var _this = _super.call(this, 'never', function(_) {
            return false;
        }, function(u, c) {
            return $87701c398fec8638$export$af2dba6db4e9e1f0(u, c);
        }, /* istanbul ignore next */ function() {
            throw new Error('cannot encode never');
        }) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'NeverType';
        return _this;
    }
    return NeverType;
}($87701c398fec8638$export$92738401e1603719);
var $87701c398fec8638$export$b3e22bcfd64c1022 = new $87701c398fec8638$export$203633b10d4a485e();
/**
 * @since 1.0.0
 */ var $87701c398fec8638$export$ec4c9a150bae86cd = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(AnyType, _super);
    function AnyType() {
        var _this = _super.call(this, 'any', function(_) {
            return true;
        }, $87701c398fec8638$export$fe7c49d056ea1d88, $87701c398fec8638$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'AnyType';
        return _this;
    }
    return AnyType;
}($87701c398fec8638$export$92738401e1603719);
var $87701c398fec8638$export$4154a199d7d90455 = new $87701c398fec8638$export$ec4c9a150bae86cd();
function $87701c398fec8638$export$99656c995101768a(codec, predicate, name) {
    if (name === void 0) name = "(".concat(codec.name, " | ").concat($87701c398fec8638$export$aad197c7121a6651(predicate), ")");
    return new $87701c398fec8638$export$75d4a1b670774175(name, function(u) {
        return codec.is(u) && predicate(u);
    }, function(i, c) {
        var e = codec.validate(i, c);
        if ((0, $eVPL0.isLeft)(e)) return e;
        var a = e.right;
        return predicate(a) ? $87701c398fec8638$export$fe7c49d056ea1d88(a) : $87701c398fec8638$export$af2dba6db4e9e1f0(a, c);
    }, codec.encode, codec, predicate);
}
var $87701c398fec8638$export$70ffa26850098d01 = $87701c398fec8638$export$99656c995101768a($87701c398fec8638$export$98e628dec113755e, Number.isInteger, 'Integer');
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * @since 1.3.0
 * @deprecated
 */ var $87701c398fec8638$export$b00fe6dbb0de05b6 = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(TaggedUnionType, _super);
    function TaggedUnionType(name, // tslint:disable-next-line: deprecation
    is, // tslint:disable-next-line: deprecation
    validate, // tslint:disable-next-line: deprecation
    encode, codecs, tag) {
        var _this = _super.call(this, name, is, validate, encode, codecs) // <= workaround for https://github.com/Microsoft/TypeScript/issues/13455
         || this;
        _this.tag = tag;
        return _this;
    }
    return TaggedUnionType;
}($87701c398fec8638$export$9b31524cbbc7993);
var $87701c398fec8638$export$fd8e3b454da0843e = function(tag, codecs, name) {
    if (name === void 0) name = $87701c398fec8638$var$getUnionName(codecs);
    var U = $87701c398fec8638$export$971dd5b0dfd021b6(codecs, name);
    // tslint:disable-next-line: deprecation
    if (U instanceof $87701c398fec8638$export$b00fe6dbb0de05b6) return U;
    else {
        console.warn("[io-ts] Cannot build a tagged union for ".concat(name, ", returning a de-optimized union"));
        // tslint:disable-next-line: deprecation
        return new $87701c398fec8638$export$b00fe6dbb0de05b6(name, U.is, U.validate, U.encode, codecs, tag);
    }
};
var $87701c398fec8638$export$519bb523eb7aafa2 /* istanbul ignore next */  = function(value, context) {
    return {
        value: value,
        context: context
    };
};
var $87701c398fec8638$export$6cb944b539722d98 /* istanbul ignore next */  = function(decoder) {
    return [
        {
            key: '',
            type: decoder
        }
    ];
};
var $87701c398fec8638$export$4ee70ab773570fb9 = $87701c398fec8638$export$ecfbd036cf5a99af;
/**
 * @since 1.0.0
 * @deprecated
 */ var $87701c398fec8638$export$53f0d9fcb05d9d1d = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(ObjectType, _super);
    function ObjectType() {
        var _this = _super.call(this, 'object', function(u) {
            return u !== null && typeof u === 'object';
        }, function(u, c) {
            return _this.is(u) ? $87701c398fec8638$export$fe7c49d056ea1d88(u) : $87701c398fec8638$export$af2dba6db4e9e1f0(u, c);
        }, $87701c398fec8638$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'ObjectType';
        return _this;
    }
    return ObjectType;
}($87701c398fec8638$export$92738401e1603719);
var $87701c398fec8638$export$be5493f9613cbbe = new $87701c398fec8638$export$53f0d9fcb05d9d1d();
var $87701c398fec8638$export$d3757880ed390b62 = $87701c398fec8638$export$e5185e241753e543;
/**
 * @since 1.0.0
 * @deprecated
 */ var $87701c398fec8638$export$b343c5704aeb93fd = /** @class */ function(_super) {
    $87701c398fec8638$var$__extends(StrictType, _super);
    function StrictType(name, // tslint:disable-next-line: deprecation
    is, // tslint:disable-next-line: deprecation
    validate, // tslint:disable-next-line: deprecation
    encode, props) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.props = props;
        /**
         * @since 1.0.0
         */ _this._tag = 'StrictType';
        return _this;
    }
    return StrictType;
}($87701c398fec8638$export$92738401e1603719);
function $87701c398fec8638$export$cf0b2a6c63f9e656(codec) {
    return codec;
}
function $87701c398fec8638$export$8de3e08801b34e5a(codec) {
    return function() {
        return codec;
    };
}


const $fb517bfb22ffdf52$export$b95309641e3cb54f = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    token: (0, $87701c398fec8638$export$22b082955e083ec3),
    secret: (0, $87701c398fec8638$export$22b082955e083ec3)
});
const $fb517bfb22ffdf52$export$276c05d401700074 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    accessToken: (0, $87701c398fec8638$export$22b082955e083ec3),
    refreshToken: (0, $87701c398fec8638$export$22b082955e083ec3)
});
const $fb517bfb22ffdf52$export$12e76865728ad4c1 = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    $fb517bfb22ffdf52$export$b95309641e3cb54f,
    $fb517bfb22ffdf52$export$276c05d401700074
]);
const $fb517bfb22ffdf52$export$e6c26dc59f3b265a = (auth)=>auth.hasOwnProperty('secret');
const $fb517bfb22ffdf52$export$2f872c0f2117be69 = (jwt)=>{
    const base64 = jwt.accessToken.split('.')[1]?.replace(/-/g, '+').replace(/_/g, '/');
    if (!base64) return undefined;
    return JSON.parse(atob(base64));
};


/**
 * Requastor performing "JSON Web Token"-style authentication.
 *
 * @since 0.1.0
 */ 
var $eVPL0 = parcelRequire("eVPL0");
/**
 * Methods for making http requests.
 */ const $d61b813a8b093ee0$export$14cc81df70b6707e = (method, url, headers, body)=>fetch(url, {
        method: method,
        mode: 'cors',
        headers: headers,
        body: body
    }).then((resp)=>resp.status >= 400 ? Promise.reject(resp) : resp.text());



const $8e5fcdc8638502b4$export$b56467c8644db4b4 = (endpoint, jwt)=>{
    const authorization = ()=>{
        return `Bearer ${jwt.accessToken}`;
    };
    const requestRaw = (path, method, data)=>(0, $d61b813a8b093ee0$export$14cc81df70b6707e)(method, endpoint + '/' + path, {
            Authorization: authorization(),
            'Content-Type': 'application/json;charset=utf-8'
        }, data && JSON.stringify(data)).then((0, $128066113e324b22$export$50eef411b4a58360));
    const request = (dec)=>(path, method, data)=>requestRaw(path, method, data).then((resp)=>(0, $eVPL0.match)((failures)=>Promise.reject({
                        error: 'JSON decode failure',
                        response: resp,
                        failures: failures
                    }), (good)=>Promise.resolve(good))(dec.decode(resp))).catch((e)=>Promise.reject({
                    error: 'Request error',
                    response: e
                }));
    return {
        requestRaw: requestRaw,
        request: request
    };
};



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");
'use client';
let $7a3a319e7e555608$var$globalId = 0;
function $7a3a319e7e555608$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $acw62.useState(idOverride);
    const id = idOverride || defaultId;
    $acw62.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $7a3a319e7e555608$var$globalId += 1;
            setDefaultId(`mui-${$7a3a319e7e555608$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $7a3a319e7e555608$var$maybeReactUseId = $acw62['useId'.toString()];
function $7a3a319e7e555608$export$2e2bcd8739ae039(idOverride) {
    if ($7a3a319e7e555608$var$maybeReactUseId !== undefined) {
        const reactId = $7a3a319e7e555608$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $7a3a319e7e555608$var$useGlobalId(idOverride);
}




var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $3z1Ay = parcelRequire("3z1Ay");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $7a8a64e8a5211ee5$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $7a8a64e8a5211ee5$export$2e2bcd8739ae039 = $7a8a64e8a5211ee5$var$isHostComponent;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $7cf4d6c2077a48de$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

function $4c8156a231c9130b$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $71912e551e227707$export$2e2bcd8739ae039(node) {
    const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $acw62 = parcelRequire("acw62");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $aab859a020ad749e$var$useEnhancedEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $aab859a020ad749e$export$2e2bcd8739ae039 = $aab859a020ad749e$var$useEnhancedEffect;


var $acw62 = parcelRequire("acw62");

'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $0c5a7e8ccbc07697$var$useEventCallback(fn) {
    const ref = $acw62.useRef(fn);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $acw62.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $0c5a7e8ccbc07697$export$2e2bcd8739ae039 = $0c5a7e8ccbc07697$var$useEventCallback;


var $acw62 = parcelRequire("acw62");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $c8b9145416f64bb2$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $27fddc0219860a83$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $032c0e7078a9cb7d$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $032c0e7078a9cb7d$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $032c0e7078a9cb7d$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $032c0e7078a9cb7d$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $032c0e7078a9cb7d$var$isEmpty(obj) {
    return $032c0e7078a9cb7d$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $032c0e7078a9cb7d$var$TextareaAutosize = /*#__PURE__*/ $acw62.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $1En50.default)(props, $032c0e7078a9cb7d$var$_excluded);
    const { current: isControlled } = $acw62.useRef(value != null);
    const textareaRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(forwardedRef, textareaRef);
    const heightRef = $acw62.useRef(null);
    const hiddenTextareaRef = $acw62.useRef(null);
    const calculateTextareaStyles = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $71912e551e227707$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingBottom) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingTop);
        const border = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderBottomWidth) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $acw62.useRef(-1);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        const debouncedHandleResize = (0, $7cf4d6c2077a48de$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef == null ? void 0 : textareaRef.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $71912e551e227707$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", (0, $8nd05.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: (0, $8nd05.default)({}, $032c0e7078a9cb7d$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $032c0e7078a9cb7d$export$2e2bcd8739ae039 = $032c0e7078a9cb7d$var$TextareaAutosize;


function $766e740713576b8d$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $8426ae8303951a73$var$FormControlContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $8426ae8303951a73$export$2e2bcd8739ae039 = $8426ae8303951a73$var$FormControlContext;



var $acw62 = parcelRequire("acw62");

'use client';
function $946238fa82894619$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $8426ae8303951a73$export$2e2bcd8739ae039));
}



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

'use client';
var $72d5a979b2ad8bc9$export$2e2bcd8739ae039 = (0, $27fddc0219860a83$export$2e2bcd8739ae039);



'use client';
var $ec346974df496fc5$export$2e2bcd8739ae039 = (0, $aab859a020ad749e$export$2e2bcd8739ae039);



var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

parcelRequire("acw62");


var $bBbjn = parcelRequire("bBbjn");

var $6o2lr = parcelRequire("6o2lr");

'use client';
const $59c0686cf27fa016$export$35e57303dbd8a66 = (0, $6o2lr.default)();
function $59c0686cf27fa016$var$useTheme(defaultTheme = $59c0686cf27fa016$export$35e57303dbd8a66) {
    return (0, $1f701f7d1726bc9a$export$2e2bcd8739ae039)(defaultTheme);
}
var $59c0686cf27fa016$export$2e2bcd8739ae039 = $59c0686cf27fa016$var$useTheme;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $6942d6ec85232a9d$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $59c0686cf27fa016$export$2e2bcd8739ae039)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bBbjn.default), {
        styles: globalStyles
    });
}
var $6942d6ec85232a9d$export$2e2bcd8739ae039 = $6942d6ec85232a9d$var$GlobalStyles;



var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $03fc756f7adfd498$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6942d6ec85232a9d$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        defaultTheme: (0, $jR9F1.default),
        themeId: (0, $4jPsi.default)
    }));
}
var $03fc756f7adfd498$export$2e2bcd8739ae039 = $03fc756f7adfd498$var$GlobalStyles;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $1e4827e2a850b1f0$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $1e4827e2a850b1f0$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($1e4827e2a850b1f0$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $1e4827e2a850b1f0$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $1e4827e2a850b1f0$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9b9dde6aa920e08c$export$ef57d5c8ca2278f6(slot) {
    return (0, $4Cod0.default)('MuiInputBase', slot);
}
const $9b9dde6aa920e08c$var$inputBaseClasses = (0, $beCSm.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $9b9dde6aa920e08c$export$2e2bcd8739ae039 = $9b9dde6aa920e08c$var$inputBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $69d1b2c99a8dc649$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $69d1b2c99a8dc649$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $69d1b2c99a8dc649$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $69d1b2c99a8dc649$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $jTnBY.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9b9dde6aa920e08c$export$ef57d5c8ca2278f6), classes);
};
const $69d1b2c99a8dc649$export$298a043133d72a38 = (0, $d8seH.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $69d1b2c99a8dc649$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $69d1b2c99a8dc649$export$a1ad29c901026019 = (0, $d8seH.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $69d1b2c99a8dc649$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $8nd05.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $8nd05.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $69d1b2c99a8dc649$var$inputGlobalStyles = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03fc756f7adfd498$export$2e2bcd8739ae039), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $69d1b2c99a8dc649$var$InputBase = /*#__PURE__*/ $acw62.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $1En50.default)(props, $69d1b2c99a8dc649$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef();
    const handleInputRefWarning = $acw62.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $acw62.useState(false);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $acw62.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $acw62.useCallback((obj)=>{
        if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $cpmCj.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $acw62.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $8nd05.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $8nd05.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $032c0e7078a9cb7d$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $69d1b2c99a8dc649$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $69d1b2c99a8dc649$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $69d1b2c99a8dc649$export$a1ad29c901026019;
    inputProps = (0, $8nd05.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $69d1b2c99a8dc649$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $8nd05.default)({}, rootProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $9QePP.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Input, (0, $8nd05.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $8nd05.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $9QePP.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $8nd05.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $69d1b2c99a8dc649$export$2e2bcd8739ae039 = $69d1b2c99a8dc649$var$InputBase;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $80c774dd7f29b734$export$cdb270390122322b(slot) {
    return (0, $4Cod0.default)('MuiInput', slot);
}
const $80c774dd7f29b734$var$inputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $beCSm.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $80c774dd7f29b734$export$2e2bcd8739ae039 = $80c774dd7f29b734$var$inputClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $76910a07fd4ac4fe$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $76910a07fd4ac4fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $80c774dd7f29b734$export$cdb270390122322b), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $76910a07fd4ac4fe$var$InputRoot = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $69d1b2c99a8dc649$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $8nd05.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).disabled}, .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $76910a07fd4ac4fe$var$InputInput = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})({});
const $76910a07fd4ac4fe$var$Input = /*#__PURE__*/ $acw62.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $1En50.default)(props, $76910a07fd4ac4fe$var$_excluded);
    const classes = $76910a07fd4ac4fe$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3z1Ay.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $76910a07fd4ac4fe$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $76910a07fd4ac4fe$var$InputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$76910a07fd4ac4fe$var$Input.muiName = 'Input';
var $76910a07fd4ac4fe$export$2e2bcd8739ae039 = $76910a07fd4ac4fe$var$Input;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3z1Ay = parcelRequire("3z1Ay");



var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $b0b42157daacd8b1$export$3331e419f1a48437(slot) {
    return (0, $4Cod0.default)('MuiFilledInput', slot);
}
const $b0b42157daacd8b1$var$filledInputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $beCSm.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $b0b42157daacd8b1$export$2e2bcd8739ae039 = $b0b42157daacd8b1$var$filledInputClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bb335d5457c07f5b$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $bb335d5457c07f5b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $b0b42157daacd8b1$export$3331e419f1a48437), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $bb335d5457c07f5b$var$FilledInputRoot = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $69d1b2c99a8dc649$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $8nd05.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}, .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $bb335d5457c07f5b$var$FilledInputInput = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $bb335d5457c07f5b$var$FilledInput = /*#__PURE__*/ $acw62.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $1En50.default)(props, $bb335d5457c07f5b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $bb335d5457c07f5b$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3z1Ay.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $bb335d5457c07f5b$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $bb335d5457c07f5b$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$bb335d5457c07f5b$var$FilledInput.muiName = 'Input';
var $bb335d5457c07f5b$export$2e2bcd8739ae039 = $bb335d5457c07f5b$var$FilledInput;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $8Indx = parcelRequire("8Indx");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $746323a953600e78$var$_span;
const $746323a953600e78$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $746323a953600e78$var$NotchedOutlineRoot = (0, $d8seH.default)('fieldset', {
    shouldForwardProp: (0, $8Uq77.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $746323a953600e78$var$NotchedOutlineLegend = (0, $d8seH.default)('legend', {
    shouldForwardProp: (0, $8Uq77.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $8nd05.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $746323a953600e78$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $1En50.default)(props, $746323a953600e78$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $8nd05.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineRoot, (0, $8nd05.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: label
            }) : $746323a953600e78$var$_span || ($746323a953600e78$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $6a1dc6d1d7e1816a$export$89922944c7227687(slot) {
    return (0, $4Cod0.default)('MuiOutlinedInput', slot);
}
const $6a1dc6d1d7e1816a$var$outlinedInputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $beCSm.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $6a1dc6d1d7e1816a$export$2e2bcd8739ae039 = $6a1dc6d1d7e1816a$var$outlinedInputClasses;




var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d5d55d2dd82639e9$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $d5d55d2dd82639e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $6a1dc6d1d7e1816a$export$89922944c7227687), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $d5d55d2dd82639e9$var$OutlinedInputRoot = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $69d1b2c99a8dc649$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $8nd05.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).focused} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).error} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).disabled} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $d5d55d2dd82639e9$var$NotchedOutlineRoot = (0, $d8seH.default)((0, $746323a953600e78$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $d5d55d2dd82639e9$var$OutlinedInputInput = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $d5d55d2dd82639e9$var$OutlinedInput = /*#__PURE__*/ $acw62.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $1En50.default)(props, $d5d55d2dd82639e9$var$_excluded);
    const classes = $d5d55d2dd82639e9$var$useUtilityClasses(props);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $d5d55d2dd82639e9$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $d5d55d2dd82639e9$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d5d55d2dd82639e9$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $8nd05.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$d5d55d2dd82639e9$var$OutlinedInput.muiName = 'Input';
var $d5d55d2dd82639e9$export$2e2bcd8739ae039 = $d5d55d2dd82639e9$var$OutlinedInput;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c678fac155df4fc3$export$f7d501e40371cd17(slot) {
    return (0, $4Cod0.default)('MuiFormLabel', slot);
}
const $c678fac155df4fc3$var$formLabelClasses = (0, $beCSm.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $c678fac155df4fc3$export$2e2bcd8739ae039 = $c678fac155df4fc3$var$formLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9b0ab7de0d37835d$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $9b0ab7de0d37835d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c678fac155df4fc3$export$f7d501e40371cd17), classes);
};
const $9b0ab7de0d37835d$export$aa5bc7f8a4705b27 = (0, $d8seH.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$AsteriskComponent = (0, $d8seH.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $1En50.default)(props, $9b0ab7de0d37835d$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $9b0ab7de0d37835d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$export$aa5bc7f8a4705b27, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $9b0ab7de0d37835d$export$2e2bcd8739ae039 = $9b0ab7de0d37835d$var$FormLabel;



var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f(slot) {
    return (0, $4Cod0.default)('MuiInputLabel', slot);
}
const $9313ead0c5e2e8ca$var$inputLabelClasses = (0, $beCSm.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $9313ead0c5e2e8ca$export$2e2bcd8739ae039 = $9313ead0c5e2e8ca$var$inputLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $09846a8ab0aba36e$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $09846a8ab0aba36e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $jTnBY.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $09846a8ab0aba36e$var$InputLabelRoot = (0, $d8seH.default)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $8nd05.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $8nd05.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $8nd05.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $09846a8ab0aba36e$var$InputLabel = /*#__PURE__*/ $acw62.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $1En50.default)(props, $09846a8ab0aba36e$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $09846a8ab0aba36e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($09846a8ab0aba36e$var$InputLabelRoot, (0, $8nd05.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $09846a8ab0aba36e$export$2e2bcd8739ae039 = $09846a8ab0aba36e$var$InputLabel;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");


var $jTnBY = parcelRequire("jTnBY");

var $acw62 = parcelRequire("acw62");
function $37dfa52af4926933$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $90a633ad7a979daa$export$2e2bcd8739ae039 = (0, $37dfa52af4926933$export$2e2bcd8739ae039);




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ce03a37a8cfb980d$export$149c8b8bab2289d1(slot) {
    return (0, $4Cod0.default)('MuiFormControl', slot);
}
const $ce03a37a8cfb980d$var$formControlClasses = (0, $beCSm.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $ce03a37a8cfb980d$export$2e2bcd8739ae039 = $ce03a37a8cfb980d$var$formControlClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bcd22a386c6068c0$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $bcd22a386c6068c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $jTnBY.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ce03a37a8cfb980d$export$149c8b8bab2289d1), classes);
};
const $bcd22a386c6068c0$var$FormControlRoot = (0, $d8seH.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, styles[`margin${(0, $jTnBY.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $bcd22a386c6068c0$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $1En50.default)(props, $bcd22a386c6068c0$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $bcd22a386c6068c0$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $1e4827e2a850b1f0$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(child.props, true) || (0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $acw62.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $acw62.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($bcd22a386c6068c0$var$FormControlRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $bcd22a386c6068c0$export$2e2bcd8739ae039 = $bcd22a386c6068c0$var$FormControl;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $d8seH = parcelRequire("d8seH");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a46b344d341d82c0$export$a394fa61b1d583a9(slot) {
    return (0, $4Cod0.default)('MuiFormHelperText', slot);
}
const $a46b344d341d82c0$var$formHelperTextClasses = (0, $beCSm.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $a46b344d341d82c0$export$2e2bcd8739ae039 = $a46b344d341d82c0$var$formHelperTextClasses;



var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d23aa5c3ca6913fb$var$_span;
const $d23aa5c3ca6913fb$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $d23aa5c3ca6913fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $jTnBY.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $a46b344d341d82c0$export$a394fa61b1d583a9), classes);
};
const $d23aa5c3ca6913fb$var$FormHelperTextRoot = (0, $d8seH.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $a46b344d341d82c0$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $a46b344d341d82c0$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $d23aa5c3ca6913fb$var$FormHelperText = /*#__PURE__*/ $acw62.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $1En50.default)(props, $d23aa5c3ca6913fb$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $d23aa5c3ca6913fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d23aa5c3ca6913fb$var$FormHelperTextRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $d23aa5c3ca6913fb$var$_span || ($d23aa5c3ca6913fb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $d23aa5c3ca6913fb$export$2e2bcd8739ae039 = $d23aa5c3ca6913fb$var$FormHelperText;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");

var $acw62 = parcelRequire("acw62");
function $1d88113360503233$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($acw62.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $c10afe25107351d9$export$2e2bcd8739ae039 = (0, $4c8156a231c9130b$export$2e2bcd8739ae039);



var $jTnBY = parcelRequire("jTnBY");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");


var $8nd05 = parcelRequire("8nd05");

/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $c20bfbd9e98e2eff$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $8nd05.default)({}, otherProps, {
        ownerState: (0, $8nd05.default)({}, otherProps.ownerState, ownerState)
    });
}
var $c20bfbd9e98e2eff$export$2e2bcd8739ae039 = $c20bfbd9e98e2eff$var$appendOwnerState;



var $8nd05 = parcelRequire("8nd05");

var $9QePP = parcelRequire("9QePP");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $afac4abdaa8d83ea$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $afac4abdaa8d83ea$export$2e2bcd8739ae039 = $afac4abdaa8d83ea$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $3ebb326a10a78a15$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $3ebb326a10a78a15$export$2e2bcd8739ae039 = $3ebb326a10a78a15$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $135391549c807611$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $9QePP.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $8nd05.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $8nd05.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)((0, $8nd05.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $3ebb326a10a78a15$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $3ebb326a10a78a15$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $9QePP.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $8nd05.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $8nd05.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $135391549c807611$export$2e2bcd8739ae039 = $135391549c807611$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $5f5557fdc8e8d8fa$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $5f5557fdc8e8d8fa$export$2e2bcd8739ae039 = $5f5557fdc8e8d8fa$var$resolveComponentProps;


'use client';
const $aa69d7725f45330b$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $aa69d7725f45330b$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $1En50.default)(parameters, $aa69d7725f45330b$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $135391549c807611$export$2e2bcd8739ae039)((0, $8nd05.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(elementType, (0, $8nd05.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $aa69d7725f45330b$export$2e2bcd8739ae039 = $aa69d7725f45330b$var$useSlotProps;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $2ddba918a398c481$var$ListContext = /*#__PURE__*/ $acw62.createContext({});
var $2ddba918a398c481$export$2e2bcd8739ae039 = $2ddba918a398c481$var$ListContext;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adbbc5717e0d0350$export$c6bd6795ed6e3203(slot) {
    return (0, $4Cod0.default)('MuiList', slot);
}
const $adbbc5717e0d0350$var$listClasses = (0, $beCSm.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $adbbc5717e0d0350$export$2e2bcd8739ae039 = $adbbc5717e0d0350$var$listClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $640cd381f5e8b3ea$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $640cd381f5e8b3ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $adbbc5717e0d0350$export$c6bd6795ed6e3203), classes);
};
const $640cd381f5e8b3ea$var$ListRoot = (0, $d8seH.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $640cd381f5e8b3ea$var$List = /*#__PURE__*/ $acw62.forwardRef(function List(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $1En50.default)(props, $640cd381f5e8b3ea$var$_excluded);
    const context = $acw62.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $640cd381f5e8b3ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($640cd381f5e8b3ea$var$ListRoot, (0, $8nd05.default)({
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $640cd381f5e8b3ea$export$2e2bcd8739ae039 = $640cd381f5e8b3ea$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $0200cab69b9251c8$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $0d80e79907b6bdbc$export$2e2bcd8739ae039 = (0, $0200cab69b9251c8$export$2e2bcd8739ae039);





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $fbb3fa0cdc277971$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $fbb3fa0cdc277971$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $fbb3fa0cdc277971$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $fbb3fa0cdc277971$var$MenuList = /*#__PURE__*/ $acw62.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $1En50.default)(props, $fbb3fa0cdc277971$var$_excluded);
    const listRef = $acw62.useRef(null);
    const textCriteriaRef = $acw62.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $0d80e79907b6bdbc$export$2e2bcd8739ae039)((0, $c10afe25107351d9$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $fbb3fa0cdc277971$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $acw62.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $acw62.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $640cd381f5e8b3ea$export$2e2bcd8739ae039), (0, $8nd05.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $fbb3fa0cdc277971$export$2e2bcd8739ae039 = $fbb3fa0cdc277971$var$MenuList;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");








var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $0f2866359d6621f3$export$2e2bcd8739ae039 = (0, $7cf4d6c2077a48de$export$2e2bcd8739ae039);




var $707049eb9639aeac$export$2e2bcd8739ae039 = (0, $71912e551e227707$export$2e2bcd8739ae039);




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
'use client';
const $dd1092ee97d527c8$var$UNINITIALIZED = {};
function $dd1092ee97d527c8$export$2e2bcd8739ae039(init, initArg) {
    const ref = $acw62.useRef($dd1092ee97d527c8$var$UNINITIALIZED);
    if (ref.current === $dd1092ee97d527c8$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $acw62 = parcelRequire("acw62");
'use client';
const $a0e38fa988f617e0$var$EMPTY = [];
function $a0e38fa988f617e0$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(fn, $a0e38fa988f617e0$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $fcd4c6205d65c7df$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $fcd4c6205d65c7df$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $fcd4c6205d65c7df$export$2e2bcd8739ae039() {
    const timeout = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)($fcd4c6205d65c7df$export$786b4da70f00938b.create).current;
    (0, $a0e38fa988f617e0$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}





var $1En50 = parcelRequire("1En50");
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}




var $acw62 = parcelRequire("acw62");

var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1En50.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;


parcelRequire("acw62");


var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");
'use client';
function $0c87a2f38cd49c7a$export$2e2bcd8739ae039() {
    const theme = (0, $59c0686cf27fa016$export$2e2bcd8739ae039)((0, $jR9F1.default));
    return theme[0, $4jPsi.default] || theme;
}


const $cc10aae84e3e4b9c$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $cc10aae84e3e4b9c$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d6f4882a3b1c59f2$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $d6f4882a3b1c59f2$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d6f4882a3b1c59f2$var$styles = {
    entering: {
        opacity: 1,
        transform: $d6f4882a3b1c59f2$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $d6f4882a3b1c59f2$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d6f4882a3b1c59f2$var$Grow = /*#__PURE__*/ $acw62.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $d6f4882a3b1c59f2$var$_excluded);
    const timer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const autoTimeout = $acw62.useRef();
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(nodeRef, (0, $1d88113360503233$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d6f4882a3b1c59f2$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $d6f4882a3b1c59f2$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    transform: $d6f4882a3b1c59f2$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $d6f4882a3b1c59f2$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$d6f4882a3b1c59f2$var$Grow.muiSupportAuto = true;
var $d6f4882a3b1c59f2$export$2e2bcd8739ae039 = $d6f4882a3b1c59f2$var$Grow;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");


var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $f30200a1e85b3f20$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $f30200a1e85b3f20$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $f30200a1e85b3f20$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $f30200a1e85b3f20$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $f30200a1e85b3f20$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($f30200a1e85b3f20$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $f30200a1e85b3f20$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $f30200a1e85b3f20$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $f30200a1e85b3f20$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $f30200a1e85b3f20$var$defaultGetTabbable, isEnabled: isEnabled = $f30200a1e85b3f20$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $acw62.useRef(false);
    const sentinelStart = $acw62.useRef(null);
    const sentinelEnd = $acw62.useRef(null);
    const nodeToRestore = $acw62.useRef(null);
    const reactFocusEventTarget = $acw62.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $acw62.useRef(false);
    const rootRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $f30200a1e85b3f20$export$2e2bcd8739ae039 = $f30200a1e85b3f20$var$FocusTrap;



var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $2117883cc21a32b2$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $2117883cc21a32b2$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $acw62.useState(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(/*#__PURE__*/ $acw62.isValidElement(children) ? (0, $1d88113360503233$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($2117883cc21a32b2$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $acw62.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $acw62.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: mountNode ? /*#__PURE__*/ $11492dca620dcaa5$exports.createPortal(children, mountNode) : mountNode
    });
});
var $2117883cc21a32b2$export$2e2bcd8739ae039 = $2117883cc21a32b2$var$Portal;



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");








var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5e5a92158e7d9bd4$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $5e5a92158e7d9bd4$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5e5a92158e7d9bd4$var$Fade = /*#__PURE__*/ $acw62.forwardRef(function Fade(props, ref) {
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $5e5a92158e7d9bd4$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(nodeRef, (0, $1d88113360503233$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $5e5a92158e7d9bd4$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $5e5a92158e7d9bd4$export$2e2bcd8739ae039 = $5e5a92158e7d9bd4$var$Fade;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5c4c540114ae85ab$export$9927a91fd93152bd(slot) {
    return (0, $4Cod0.default)('MuiBackdrop', slot);
}
const $5c4c540114ae85ab$var$backdropClasses = (0, $beCSm.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $5c4c540114ae85ab$export$2e2bcd8739ae039 = $5c4c540114ae85ab$var$backdropClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4838e5a14e330013$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $4838e5a14e330013$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5c4c540114ae85ab$export$9927a91fd93152bd), classes);
};
const $4838e5a14e330013$var$BackdropRoot = (0, $d8seH.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $4838e5a14e330013$var$Backdrop = /*#__PURE__*/ $acw62.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $5e5a92158e7d9bd4$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $1En50.default)(props, $4838e5a14e330013$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $4838e5a14e330013$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4838e5a14e330013$var$BackdropRoot, (0, $8nd05.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $9QePP.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $8nd05.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $4838e5a14e330013$export$2e2bcd8739ae039 = $4838e5a14e330013$var$Backdrop;



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $cfb86ebe4ea00eb7$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




// Is a vertical scrollbar displayed?
function $52971d86e2bcd483$var$isOverflowing(container) {
    const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $71912e551e227707$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $52971d86e2bcd483$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $52971d86e2bcd483$var$getPaddingRight(element) {
    return parseInt((0, $71912e551e227707$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $52971d86e2bcd483$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $52971d86e2bcd483$export$e1bd0c6150f13d96(element, show);
    });
}
function $52971d86e2bcd483$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $52971d86e2bcd483$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($52971d86e2bcd483$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $0200cab69b9251c8$export$2e2bcd8739ae039)((0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $71912e551e227707$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $52971d86e2bcd483$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $52971d86e2bcd483$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $52971d86e2bcd483$var$getHiddenSiblings(container);
        $52971d86e2bcd483$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $52971d86e2bcd483$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $52971d86e2bcd483$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $f86e7d122c1fa324$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $f86e7d122c1fa324$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $f86e7d122c1fa324$var$defaultManager = new (0, $52971d86e2bcd483$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $f86e7d122c1fa324$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $f86e7d122c1fa324$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $acw62.useRef({});
    const mountNodeRef = $acw62.useRef(null);
    const modalRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $acw62.useState(!open);
    const hasTransition = $f86e7d122c1fa324$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $4c8156a231c9130b$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $f86e7d122c1fa324$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $acw62.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $52971d86e2bcd483$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $acw62.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $acw62.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $8nd05.default)({}, propsEventHandlers, otherHandlers);
        return (0, $8nd05.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $8nd05.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $cfb86ebe4ea00eb7$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $cfb86ebe4ea00eb7$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $f86e7d122c1fa324$export$2e2bcd8739ae039 = $f86e7d122c1fa324$var$useModal;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $0cea91a79e26c98a$export$67960e22b12a638d(slot) {
    return (0, $4Cod0.default)('MuiModal', slot);
}
const $0cea91a79e26c98a$var$modalClasses = (0, $beCSm.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $0cea91a79e26c98a$export$2e2bcd8739ae039 = $0cea91a79e26c98a$var$modalClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0bdcbfecdf3275a2$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $0bdcbfecdf3275a2$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $0cea91a79e26c98a$export$67960e22b12a638d), classes);
};
const $0bdcbfecdf3275a2$var$ModalRoot = (0, $d8seH.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $0bdcbfecdf3275a2$var$ModalBackdrop = (0, $d8seH.default)((0, $4838e5a14e330013$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $0bdcbfecdf3275a2$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $0bdcbfecdf3275a2$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $1En50.default)(props, $0bdcbfecdf3275a2$var$_excluded);
    const propsWithDefaults = (0, $8nd05.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $f86e7d122c1fa324$export$2e2bcd8739ae039)((0, $8nd05.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $8nd05.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $0bdcbfecdf3275a2$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $0bdcbfecdf3275a2$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $8nd05.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $9QePP.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2117883cc21a32b2$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, (0, $8nd05.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(BackdropSlot, (0, $8nd05.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f30200a1e85b3f20$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $acw62.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $0bdcbfecdf3275a2$export$2e2bcd8739ae039 = $0bdcbfecdf3275a2$var$Modal;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");


var $1iOpW = parcelRequire("1iOpW");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4ec306d48089c2c9$export$29cdb466b9b6f20b(slot) {
    return (0, $4Cod0.default)('MuiPaper', slot);
}
const $4ec306d48089c2c9$var$paperClasses = (0, $beCSm.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $4ec306d48089c2c9$export$2e2bcd8739ae039 = $4ec306d48089c2c9$var$paperClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $595185d0d7275c3b$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $595185d0d7275c3b$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4ec306d48089c2c9$export$29cdb466b9b6f20b), classes);
};
const $595185d0d7275c3b$var$PaperRoot = (0, $d8seH.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $8nd05.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $8nd05.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $kSnzZ.alpha)('#fff', (0, $23fa506264c010ed$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $kSnzZ.alpha)('#fff', (0, $23fa506264c010ed$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $595185d0d7275c3b$var$Paper = /*#__PURE__*/ $acw62.forwardRef(function Paper(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $1En50.default)(props, $595185d0d7275c3b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $595185d0d7275c3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($595185d0d7275c3b$var$PaperRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other));
});
var $595185d0d7275c3b$export$2e2bcd8739ae039 = $595185d0d7275c3b$var$Paper;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ea2c25a800e729b1$export$88f455dd56c95edb(slot) {
    return (0, $4Cod0.default)('MuiPopover', slot);
}
const $ea2c25a800e729b1$var$popoverClasses = (0, $beCSm.default)('MuiPopover', [
    'root',
    'paper'
]);
var $ea2c25a800e729b1$export$2e2bcd8739ae039 = $ea2c25a800e729b1$var$popoverClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $012baef8dc9ae9d0$var$_excluded = [
    "onEntering"
], $012baef8dc9ae9d0$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $012baef8dc9ae9d0$var$_excluded3 = [
    "slotProps"
];
function $012baef8dc9ae9d0$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $012baef8dc9ae9d0$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $012baef8dc9ae9d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ea2c25a800e729b1$export$88f455dd56c95edb), classes);
};
const $012baef8dc9ae9d0$export$bcce13685275fc99 = (0, $d8seH.default)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $012baef8dc9ae9d0$export$821346c38a2d9390 = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $012baef8dc9ae9d0$var$Popover = /*#__PURE__*/ $acw62.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $012baef8dc9ae9d0$var$_excluded), other = (0, $1En50.default)(props, $012baef8dc9ae9d0$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $acw62.useRef();
    const handlePaperRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $8nd05.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $012baef8dc9ae9d0$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $acw62.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $c10afe25107351d9$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $012baef8dc9ae9d0$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $acw62.useCallback((elemRect)=>{
        return {
            vertical: $012baef8dc9ae9d0$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $acw62.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $acw62.useState(open);
    const setPositioningStyles = $acw62.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $acw62.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $acw62.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $acw62.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $c10afe25107351d9$export$2e2bcd8739ae039)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $012baef8dc9ae9d0$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $012baef8dc9ae9d0$export$821346c38a2d9390;
    const paperProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: (0, $8nd05.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $8nd05.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $1En50.default)(_useSlotProps, $012baef8dc9ae9d0$var$_excluded3);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, (0, $8nd05.default)({}, rootProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, (0, $8nd05.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $012baef8dc9ae9d0$export$2e2bcd8739ae039 = $012baef8dc9ae9d0$var$Popover;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fb1e7d0ac8fac824$export$2cf86a63a84fe23d(slot) {
    return (0, $4Cod0.default)('MuiMenu', slot);
}
const $fb1e7d0ac8fac824$var$menuClasses = (0, $beCSm.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $fb1e7d0ac8fac824$export$2e2bcd8739ae039 = $fb1e7d0ac8fac824$var$menuClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $364f3db28d8d2e79$var$_excluded = [
    "onEntering"
], $364f3db28d8d2e79$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $364f3db28d8d2e79$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $364f3db28d8d2e79$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $364f3db28d8d2e79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fb1e7d0ac8fac824$export$2cf86a63a84fe23d), classes);
};
const $364f3db28d8d2e79$var$MenuRoot = (0, $d8seH.default)((0, $012baef8dc9ae9d0$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $364f3db28d8d2e79$export$4f7c51a5920c9f33 = (0, $d8seH.default)((0, $012baef8dc9ae9d0$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $364f3db28d8d2e79$var$MenuMenuList = (0, $d8seH.default)((0, $fbb3fa0cdc277971$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $364f3db28d8d2e79$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $364f3db28d8d2e79$var$_excluded), other = (0, $1En50.default)(props, $364f3db28d8d2e79$var$_excluded2);
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $364f3db28d8d2e79$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $acw62.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $364f3db28d8d2e79$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuRoot, (0, $8nd05.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $364f3db28d8d2e79$var$RTL_ORIGIN : $364f3db28d8d2e79$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $8nd05.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuMenuList, (0, $8nd05.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $9QePP.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $364f3db28d8d2e79$export$2e2bcd8739ae039 = $364f3db28d8d2e79$var$Menu;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $49a1663d7631a8fa$export$1ee13051fd9e2ab5(slot) {
    return (0, $4Cod0.default)('MuiNativeSelect', slot);
}
const $49a1663d7631a8fa$var$nativeSelectClasses = (0, $beCSm.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $49a1663d7631a8fa$export$2e2bcd8739ae039 = $49a1663d7631a8fa$var$nativeSelectClasses;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $db2c454fb2e8bc3c$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $db2c454fb2e8bc3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $49a1663d7631a8fa$export$1ee13051fd9e2ab5), classes);
};
const $db2c454fb2e8bc3c$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $8nd05.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $db2c454fb2e8bc3c$var$NativeSelectSelect = (0, $d8seH.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $8Uq77.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($db2c454fb2e8bc3c$export$c1eccd1617458c87);
const $db2c454fb2e8bc3c$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $db2c454fb2e8bc3c$var$NativeSelectIcon = (0, $d8seH.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($db2c454fb2e8bc3c$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $db2c454fb2e8bc3c$var$NativeSelectInput = /*#__PURE__*/ $acw62.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $db2c454fb2e8bc3c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $db2c454fb2e8bc3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectSelect, (0, $8nd05.default)({
                ownerState: ownerState,
                className: (0, $9QePP.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $db2c454fb2e8bc3c$export$2e2bcd8739ae039 = $db2c454fb2e8bc3c$var$NativeSelectInput;




var $d8seH = parcelRequire("d8seH");
var $PJRTc = parcelRequire("PJRTc");


var $acw62 = parcelRequire("acw62");
'use client';
function $77aad105771eb889$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $acw62.useRef(controlled !== undefined);
    const [valueState, setValue] = $acw62.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $acw62.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $295ecbe78b5bad73$export$2e2bcd8739ae039 = (0, $77aad105771eb889$export$2e2bcd8739ae039);



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $844e08aea9053c4b$export$2c0c1ee5a3392e(slot) {
    return (0, $4Cod0.default)('MuiSelect', slot);
}
const $844e08aea9053c4b$var$selectClasses = (0, $beCSm.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $844e08aea9053c4b$export$2e2bcd8739ae039 = $844e08aea9053c4b$var$selectClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $8bd650259be885cb$var$_span;
const $8bd650259be885cb$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $8bd650259be885cb$var$SelectSelect = (0, $d8seH.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $db2c454fb2e8bc3c$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $8bd650259be885cb$var$SelectIcon = (0, $d8seH.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $db2c454fb2e8bc3c$export$e7a817afd12a40d0));
const $8bd650259be885cb$var$SelectNativeInput = (0, $d8seH.default)('input', {
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $8bd650259be885cb$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $8bd650259be885cb$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $8bd650259be885cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $844e08aea9053c4b$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $8bd650259be885cb$var$SelectInput = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $8bd650259be885cb$var$_excluded);
    const [value, setValueState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $acw62.useRef(null);
    const displayRef = $acw62.useRef(null);
    const [displayNode, setDisplayNode] = $acw62.useState(null);
    const { current: isOpenControlled } = $acw62.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $acw62.useState();
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $acw62.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $acw62.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $acw62.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $acw62.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $acw62.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $cpmCj.default)(2));
            selected = value.some((v)=>$8bd650259be885cb$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $8bd650259be885cb$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $8bd650259be885cb$var$useUtilityClasses(ownerState);
    const paperProps = (0, $8nd05.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectSelect, (0, $8nd05.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $9QePP.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $8bd650259be885cb$var$isEmpty(display) ? $8bd650259be885cb$var$_span || ($8bd650259be885cb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectNativeInput, (0, $8nd05.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $364f3db28d8d2e79$export$2e2bcd8739ae039), (0, $8nd05.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $8nd05.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $8nd05.default)({}, MenuProps.slotProps, {
                    paper: (0, $8nd05.default)({}, paperProps, {
                        style: (0, $8nd05.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $8bd650259be885cb$export$2e2bcd8739ae039 = $8bd650259be885cb$var$SelectInput;




parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $5a863bd9b12ca76b$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');







var $1iOpW = parcelRequire("1iOpW");


var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $96e1233e8d06bb2d$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $96e1233e8d06bb2d$var$_excluded2 = [
    "root"
];
const $96e1233e8d06bb2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $96e1233e8d06bb2d$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $96e1233e8d06bb2d$var$StyledInput = (0, $d8seH.default)((0, $76910a07fd4ac4fe$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledOutlinedInput = (0, $d8seH.default)((0, $d5d55d2dd82639e9$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledFilledInput = (0, $d8seH.default)((0, $bb335d5457c07f5b$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$Select = /*#__PURE__*/ $acw62.forwardRef(function Select(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $5a863bd9b12ca76b$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $1En50.default)(props, $96e1233e8d06bb2d$var$_excluded);
    const inputComponent = native ? (0, $db2c454fb2e8bc3c$export$2e2bcd8739ae039) : (0, $8bd650259be885cb$export$2e2bcd8739ae039);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $96e1233e8d06bb2d$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $1En50.default)(classes, $96e1233e8d06bb2d$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, (0, $1d88113360503233$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(InputComponent, (0, $8nd05.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $8nd05.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $8nd05.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $3z1Ay.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $9QePP.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$96e1233e8d06bb2d$var$Select.muiName = 'Select';
var $96e1233e8d06bb2d$export$2e2bcd8739ae039 = $96e1233e8d06bb2d$var$Select;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $25a6b464d3ca38da$export$c1bdcbaf0596aeda(slot) {
    return (0, $4Cod0.default)('MuiTextField', slot);
}
const $25a6b464d3ca38da$var$textFieldClasses = (0, $beCSm.default)('MuiTextField', [
    'root'
]);
var $25a6b464d3ca38da$export$2e2bcd8739ae039 = $25a6b464d3ca38da$var$textFieldClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d8826083c5af4ea7$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $d8826083c5af4ea7$var$variantComponent = {
    standard: (0, $76910a07fd4ac4fe$export$2e2bcd8739ae039),
    filled: (0, $bb335d5457c07f5b$export$2e2bcd8739ae039),
    outlined: (0, $d5d55d2dd82639e9$export$2e2bcd8739ae039)
};
const $d8826083c5af4ea7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $25a6b464d3ca38da$export$c1bdcbaf0596aeda), classes);
};
const $d8826083c5af4ea7$var$TextFieldRoot = (0, $d8seH.default)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $d8826083c5af4ea7$var$TextField = /*#__PURE__*/ $acw62.forwardRef(function TextField(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $1En50.default)(props, $d8826083c5af4ea7$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $d8826083c5af4ea7$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $d8826083c5af4ea7$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $ayMG0.jsx)(InputComponent, (0, $8nd05.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d8826083c5af4ea7$var$TextFieldRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), (0, $8nd05.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), (0, $8nd05.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), (0, $8nd05.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $d8826083c5af4ea7$export$2e2bcd8739ae039 = $d8826083c5af4ea7$var$TextField;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4FZD0 = parcelRequire("4FZD0");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


'use client';
var $331f3746e6346411$export$2e2bcd8739ae039 = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

'use client';
let $15e2b45accdb3531$var$hadKeyboardEvent = true;
let $15e2b45accdb3531$var$hadFocusVisibleRecently = false;
const $15e2b45accdb3531$var$hadFocusVisibleRecentlyTimeout = new (0, $fcd4c6205d65c7df$export$786b4da70f00938b)();
const $15e2b45accdb3531$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $15e2b45accdb3531$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $15e2b45accdb3531$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $15e2b45accdb3531$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $15e2b45accdb3531$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $15e2b45accdb3531$var$handlePointerDown() {
    $15e2b45accdb3531$var$hadKeyboardEvent = false;
}
function $15e2b45accdb3531$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($15e2b45accdb3531$var$hadFocusVisibleRecently) $15e2b45accdb3531$var$hadKeyboardEvent = true;
    }
}
function $15e2b45accdb3531$var$prepare(doc) {
    doc.addEventListener('keydown', $15e2b45accdb3531$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $15e2b45accdb3531$var$handleVisibilityChange, true);
}
function $15e2b45accdb3531$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $15e2b45accdb3531$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $15e2b45accdb3531$var$handleVisibilityChange, true);
}
function $15e2b45accdb3531$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $15e2b45accdb3531$var$hadKeyboardEvent || $15e2b45accdb3531$var$focusTriggersKeyboardModality(target);
}
function $15e2b45accdb3531$export$2e2bcd8739ae039() {
    const ref = $acw62.useCallback((node)=>{
        if (node != null) $15e2b45accdb3531$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $acw62.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $15e2b45accdb3531$var$hadFocusVisibleRecently = true;
            $15e2b45accdb3531$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $15e2b45accdb3531$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($15e2b45accdb3531$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $8fc8239a3939454e$export$2e2bcd8739ae039 = (0, $15e2b45accdb3531$export$2e2bcd8739ae039);



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, 'appear', props),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', props),
            exit: $04540450bf60efa1$var$getProp(child, 'exit', props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $04540450bf60efa1$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $04540450bf60efa1$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $04540450bf60efa1$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $8nd05.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $1En50.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;



var $9QePP = parcelRequire("9QePP");

var $jjlaj = parcelRequire("jjlaj");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $cb2cd8c78d72bd92$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $acw62.useState(false);
    const rippleClassName = (0, $9QePP.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $9QePP.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $acw62.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
var $cb2cd8c78d72bd92$export$2e2bcd8739ae039 = $cb2cd8c78d72bd92$var$Ripple;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $755fb323846f60d4$export$b464606f735ab902(slot) {
    return (0, $4Cod0.default)('MuiTouchRipple', slot);
}
const $755fb323846f60d4$var$touchRippleClasses = (0, $beCSm.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $755fb323846f60d4$export$2e2bcd8739ae039 = $755fb323846f60d4$var$touchRippleClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $855224273a002a0f$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $855224273a002a0f$var$_ = (t)=>t, $855224273a002a0f$var$_t, $855224273a002a0f$var$_t2, $855224273a002a0f$var$_t3, $855224273a002a0f$var$_t4;
const $855224273a002a0f$var$DURATION = 550;
const $855224273a002a0f$export$95d0c9356b2231a3 = 80;
const $855224273a002a0f$var$enterKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t || ($855224273a002a0f$var$_t = $855224273a002a0f$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $855224273a002a0f$var$exitKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t2 || ($855224273a002a0f$var$_t2 = $855224273a002a0f$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $855224273a002a0f$var$pulsateKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t3 || ($855224273a002a0f$var$_t3 = $855224273a002a0f$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $855224273a002a0f$export$f6b7418508c72c25 = (0, $d8seH.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $855224273a002a0f$export$676cfe7b12693c4b = (0, $d8seH.default)((0, $cb2cd8c78d72bd92$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($855224273a002a0f$var$_t4 || ($855224273a002a0f$var$_t4 = $855224273a002a0f$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $755fb323846f60d4$export$2e2bcd8739ae039).rippleVisible, $855224273a002a0f$var$enterKeyframe, $855224273a002a0f$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $755fb323846f60d4$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $755fb323846f60d4$export$2e2bcd8739ae039).child, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childLeaving, $855224273a002a0f$var$exitKeyframe, $855224273a002a0f$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childPulsate, $855224273a002a0f$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $855224273a002a0f$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $1En50.default)(props, $855224273a002a0f$var$_excluded);
    const [ripples, setRipples] = $acw62.useState([]);
    const nextKey = $acw62.useRef(0);
    const rippleCallback = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $acw62.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $acw62.useRef(null);
    const container = $acw62.useRef(null);
    const startCommit = $acw62.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $9QePP.default)(classes.ripple, (0, $755fb323846f60d4$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $9QePP.default)(classes.rippleVisible, (0, $755fb323846f60d4$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $9QePP.default)(classes.ripplePulsate, (0, $755fb323846f60d4$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $9QePP.default)(classes.child, (0, $755fb323846f60d4$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $9QePP.default)(classes.childLeaving, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $9QePP.default)(classes.childPulsate, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $855224273a002a0f$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $acw62.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($855224273a002a0f$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $acw62.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $acw62.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $acw62.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$f6b7418508c72c25, (0, $8nd05.default)({
        className: (0, $9QePP.default)((0, $755fb323846f60d4$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $855224273a002a0f$export$2e2bcd8739ae039 = $855224273a002a0f$var$TouchRipple;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $42d7f65840078ec1$export$fccb0498dcd99783(slot) {
    return (0, $4Cod0.default)('MuiButtonBase', slot);
}
const $42d7f65840078ec1$var$buttonBaseClasses = (0, $beCSm.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $42d7f65840078ec1$export$2e2bcd8739ae039 = $42d7f65840078ec1$var$buttonBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4a35786d89db9dda$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $4a35786d89db9dda$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $42d7f65840078ec1$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $4a35786d89db9dda$export$7ec0dcc5e3cdcd36 = (0, $d8seH.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $42d7f65840078ec1$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $4a35786d89db9dda$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $1En50.default)(props, $4a35786d89db9dda$var$_excluded);
    const buttonRef = $acw62.useRef(null);
    const rippleRef = $acw62.useRef(null);
    const handleRippleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $8fc8239a3939454e$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $acw62.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $acw62.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $acw62.useRef(false);
    const handleKeyDown = (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $8nd05.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $4a35786d89db9dda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a35786d89db9dda$export$7ec0dcc5e3cdcd36, (0, $8nd05.default)({
        as: ComponentProp,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $ayMG0.jsx)((0, $855224273a002a0f$export$2e2bcd8739ae039), (0, $8nd05.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $4a35786d89db9dda$export$2e2bcd8739ae039 = $4a35786d89db9dda$var$ButtonBase;



var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $11f546081ba06ace$export$5a6f9035944c8119(slot) {
    return (0, $4Cod0.default)('MuiButton', slot);
}
const $11f546081ba06ace$var$buttonClasses = (0, $beCSm.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $11f546081ba06ace$export$2e2bcd8739ae039 = $11f546081ba06ace$var$buttonClasses;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $8639dcef822d5d4c$var$ButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $8639dcef822d5d4c$export$2e2bcd8739ae039 = $8639dcef822d5d4c$var$ButtonGroupContext;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $25b1293270900846$var$ButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $25b1293270900846$export$2e2bcd8739ae039 = $25b1293270900846$var$ButtonGroupButtonContext;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4a02bab8c70a697b$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $4a02bab8c70a697b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`,
            `${variant}Size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $jTnBY.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $jTnBY.default)(size)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $11f546081ba06ace$export$5a6f9035944c8119), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $4a02bab8c70a697b$var$commonIconStyles = (ownerState)=>(0, $8nd05.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $4a02bab8c70a697b$var$ButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $8nd05.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $8nd05.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $8nd05.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).focusVisible}`]: (0, $8nd05.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).disabled}`]: (0, $8nd05.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $4a02bab8c70a697b$var$ButtonStartIcon = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $4a02bab8c70a697b$var$commonIconStyles(ownerState)));
const $4a02bab8c70a697b$var$ButtonEndIcon = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $4a02bab8c70a697b$var$commonIconStyles(ownerState)));
const $4a02bab8c70a697b$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $acw62.useContext((0, $8639dcef822d5d4c$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $acw62.useContext((0, $25b1293270900846$export$2e2bcd8739ae039));
    const resolvedProps = (0, $4FZD0.default)(contextProps, inProps);
    const props = (0, $1iOpW.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $1En50.default)(props, $4a02bab8c70a697b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $4a02bab8c70a697b$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a02bab8c70a697b$var$ButtonRoot, (0, $8nd05.default)({
        ownerState: ownerState,
        className: (0, $9QePP.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $4a02bab8c70a697b$export$2e2bcd8739ae039 = $4a02bab8c70a697b$var$Button;




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $hcz0Q = parcelRequire("hcz0Q");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $837556bdf75d281f$export$24c1f8f60cbac79e(slot) {
    return (0, $4Cod0.default)('MuiTypography', slot);
}
const $837556bdf75d281f$var$typographyClasses = (0, $beCSm.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $837556bdf75d281f$export$2e2bcd8739ae039 = $837556bdf75d281f$var$typographyClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2531239e3a525689$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $2531239e3a525689$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $jTnBY.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $837556bdf75d281f$export$24c1f8f60cbac79e), classes);
};
const $2531239e3a525689$export$140e2f5526d3cad8 = (0, $d8seH.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $2531239e3a525689$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $2531239e3a525689$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $2531239e3a525689$var$transformDeprecatedColors = (color)=>{
    return $2531239e3a525689$var$colorTransformations[color] || color;
};
const $2531239e3a525689$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $2531239e3a525689$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $hcz0Q.default)((0, $8nd05.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $2531239e3a525689$var$defaultVariantMapping } = props, other = (0, $1En50.default)(props, $2531239e3a525689$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $2531239e3a525689$var$defaultVariantMapping[variant]) || 'span';
    const classes = $2531239e3a525689$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2531239e3a525689$export$140e2f5526d3cad8, (0, $8nd05.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }, other));
});
var $2531239e3a525689$export$2e2bcd8739ae039 = $2531239e3a525689$var$Typography;



const $2c1fe747552479b7$var$setReq = (config, updateReq)=>(jwt)=>{
        sessionStorage.setItem('login', JSON.stringify(jwt));
        updateReq((0, $8e5fcdc8638502b4$export$b56467c8644db4b4)(config.SilicaEndpoint, jwt));
    };
function $2c1fe747552479b7$export$2e2bcd8739ae039({ config: config, updateReq: updateReq }) {
    const [user, setUser] = (0, $acw62.useState)('');
    const [password, setPassword] = (0, $acw62.useState)('');
    (0, $acw62.useEffect)(()=>{
        (0, $128066113e324b22$export$15d025c4720fa74d)(sessionStorage.getItem('login')).then((0, $128066113e324b22$export$50eef411b4a58360)).then((0, $128066113e324b22$export$2fbe0fdfc24beb3d)((0, $fb517bfb22ffdf52$export$276c05d401700074))).then((jwt)=>{
            const { Auth0: Auth0 } = config;
            const jwtDecode = (0, $fb517bfb22ffdf52$export$2f872c0f2117be69)(jwt);
            const expt = jwtDecode?.exp ?? 0;
            const ctime = new Date().getTime() / 1000;
            const exp = expt - (ctime + (expt - ctime) / 2);
            if (exp < 0) (0, $d61b813a8b093ee0$export$14cc81df70b6707e)('POST', `${Auth0.domain}/oauth/token`, {}, JSON.stringify({
                grant_type: 'refresh_token',
                client_id: Auth0.clientId,
                client_secret: Auth0.clientSecret,
                refresh_token: jwt.refreshToken
            })).then((0, $128066113e324b22$export$50eef411b4a58360)).then((o)=>{
                const res = o;
                $2c1fe747552479b7$var$setReq(config, updateReq)({
                    accessToken: res.access_token,
                    refreshToken: res.refresh_token
                });
            });
            else $2c1fe747552479b7$var$setReq(config, updateReq)(jwt);
        }).catch((_fail)=>{
            console.log('Login information out of date or unreadable.');
        });
    });
    function attemptLogin() {
        const { Auth0: Auth0 } = config;
        (0, $d61b813a8b093ee0$export$14cc81df70b6707e)('POST', `${Auth0.domain}/oauth/token`, {
            'Content-Type': 'application/json'
        }, JSON.stringify({
            grant_type: 'password',
            username: user,
            password: password,
            client_id: Auth0.clientId,
            client_secret: Auth0.clientSecret,
            audience: Auth0.audience,
            scope: 'offline_access' // refresh token
        })).then((0, $128066113e324b22$export$50eef411b4a58360)).then((o)=>{
            const res = o;
            $2c1fe747552479b7$var$setReq(config, updateReq)({
                accessToken: res.access_token,
                refreshToken: res.refresh_token
            });
        }).catch((e)=>{
            console.log(e);
            alert('Auth failed');
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
        component: "form",
        name: "Login",
        id: "Login",
        sx: {
            p: 3,
            width: '33%',
            margin: 'auto',
            mt: 3,
            ['@media (max-width: 600px)']: {
                width: '80%'
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                pb: 2,
                variant: "h2",
                children: "Login"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                required: true,
                label: "Username",
                fullWidth: true,
                onChange: (ev)=>setUser(ev.target.value),
                sx: {
                    mb: 2
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                required: true,
                type: "password",
                label: "Password",
                fullWidth: true,
                onChange: (ev)=>setPassword(ev.target.value),
                sx: {
                    mb: 2
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                type: "submit",
                variant: "contained",
                color: "primary",
                fullWidth: true,
                onClick: (e)=>{
                    e.preventDefault();
                    attemptLogin();
                },
                children: "Login"
            })
        ]
    });
}



const $401fc7c7dcb14efc$var$Login = ({ config: config, updateReq: updateReq })=>{
    if (config === undefined) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2c1fe747552479b7$export$2e2bcd8739ae039), {
        config: config,
        updateReq: (req)=>{
            updateReq(req);
        }
    });
};
var $401fc7c7dcb14efc$export$2e2bcd8739ae039 = $401fc7c7dcb14efc$var$Login;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
class $df26a3ab557252de$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props), this.render = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "logout-wrapper",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    children: "Thank you for logging out."
                })
            });
        this.state = {};
        sessionStorage.removeItem('login');
        this.props.updateReq(undefined);
    }
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * Concrete Opening Types and Codecs.
 *
 * @since 0.1.0
 */ 
/**
 * Concrete Division and Strategy Types and Guards, used in the submitted model.
 *
 * @since 0.1.0
 */ /**
 * Panels
 *
 * @since 0.1.0
 */ 
const $e81bee764b11314c$export$8212cedec4cdb9b4 = (0, $87701c398fec8638$export$19282c40b967aec6);
const $e81bee764b11314c$export$b6cd41bf561db12f = (0, $87701c398fec8638$export$19282c40b967aec6);


/**
 * Dividing Planes into Panels.
 *
 * @since 0.1.0
 */ 
/**
 * Number types and guards.
 *
 * @since 0.1.0
 */ 
const $0b3a4acf236478d7$export$6cdc1cb9345ffadf = (0, $87701c398fec8638$export$98e628dec113755e);
const $0b3a4acf236478d7$export$3081247862d57e3d = (0, $87701c398fec8638$export$98e628dec113755e);
const $0b3a4acf236478d7$export$39cb9d2b5a061c63 = (0, $87701c398fec8638$export$98e628dec113755e);


/**
 * Sides of a panel.
 *
 * @since 0.1.0
 */ 
const $d3d186bf12d5d83d$export$80a00690bda7f17e = (0, $87701c398fec8638$export$7e1278799275f68e)({
    'left': true,
    'right': true,
    'top': true,
    'bottom': true
});


const $3f8c4654a543878d$export$88a6666ae2487175 = (codecA, codecB)=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        $3f8c4654a543878d$export$2d2e742902638f5a(codecA, codecB),
        $3f8c4654a543878d$export$8b09b678196dbb55(codecA, codecB)
    ]);
const $3f8c4654a543878d$export$2d2e742902638f5a = (codecA, codecB)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Manual'),
        Division: $3f8c4654a543878d$export$642e60965a9deb15(codecA, codecB)
    });
const $3f8c4654a543878d$export$8b09b678196dbb55 = (_codecA, codecB)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Minimal'),
        Info: codecB
    });
const $3f8c4654a543878d$export$642e60965a9deb15 = (codecA, codecB)=>(0, $87701c398fec8638$export$74c5cab0f9a94551)('Division', ()=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
            $3f8c4654a543878d$export$e39a294c3f591275(codecA, codecB),
            $3f8c4654a543878d$export$2fa75514ae09d2c6(codecA, codecB)
        ]));
const $3f8c4654a543878d$export$e39a294c3f591275 = (_codecA, codecB)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Whole'),
        Info: codecB
    });
const $3f8c4654a543878d$export$2fa75514ae09d2c6 = (codecA, codecB)=>(0, $87701c398fec8638$export$74c5cab0f9a94551)('DivisionDivided', ()=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
            type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Divided'),
            Left: $3f8c4654a543878d$export$642e60965a9deb15(codecA, codecB),
            LeftEdge: codecA,
            Right: $3f8c4654a543878d$export$642e60965a9deb15(codecA, codecB),
            RightEdge: codecA,
            Curve: $3f8c4654a543878d$export$b0e83c3ef8d2db1
        }));
const $3f8c4654a543878d$export$d332ea2e09d9f4e7 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Angled'),
    Side: (0, $d3d186bf12d5d83d$export$80a00690bda7f17e),
    Angle: (0, $0b3a4acf236478d7$export$6cdc1cb9345ffadf),
    Corner: (0, $0b3a4acf236478d7$export$39cb9d2b5a061c63),
    Distance: (0, $0b3a4acf236478d7$export$3081247862d57e3d)
});
const $3f8c4654a543878d$export$ec53dfc5affd5e5 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Bezier'),
    Side: (0, $d3d186bf12d5d83d$export$80a00690bda7f17e)
});
const $3f8c4654a543878d$export$b0e83c3ef8d2db1 = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    $3f8c4654a543878d$export$d332ea2e09d9f4e7,
    $3f8c4654a543878d$export$ec53dfc5affd5e5
]);


const $f53a175514b17aaf$export$88a6666ae2487175 = $3f8c4654a543878d$export$88a6666ae2487175((0, $e81bee764b11314c$export$8212cedec4cdb9b4), (0, $e81bee764b11314c$export$b6cd41bf561db12f));
const $f53a175514b17aaf$export$642e60965a9deb15 = $3f8c4654a543878d$export$642e60965a9deb15((0, $e81bee764b11314c$export$8212cedec4cdb9b4), (0, $e81bee764b11314c$export$b6cd41bf561db12f));
const $f53a175514b17aaf$export$e39a294c3f591275 = $3f8c4654a543878d$export$e39a294c3f591275((0, $e81bee764b11314c$export$8212cedec4cdb9b4), (0, $e81bee764b11314c$export$b6cd41bf561db12f));
const $f53a175514b17aaf$export$2fa75514ae09d2c6 = $3f8c4654a543878d$export$2fa75514ae09d2c6((0, $e81bee764b11314c$export$8212cedec4cdb9b4), (0, $e81bee764b11314c$export$b6cd41bf561db12f));



/**
 * Polymorphic Opening Types and Guards.
 *
 * @since 0.1.0
 */ 
/**
 * Misc type helpers.
 *
 * @internal
 */ 
const $24396fcf7207086e$export$428ef1f8ddd66578 = new (0, $87701c398fec8638$export$92738401e1603719)('true', (input)=>input === true, (input, context)=>input === true ? (0, $87701c398fec8638$export$fe7c49d056ea1d88)(input) : (0, $87701c398fec8638$export$af2dba6db4e9e1f0)(input, context), (0, $87701c398fec8638$export$f0954fd7d5368655));
const $24396fcf7207086e$export$96ebffb07897cd9c = (pre)=>new (0, $87701c398fec8638$export$92738401e1603719)(`Prefix<${pre}>`, $24396fcf7207086e$export$68326237475e9a7d(pre), (input, context)=>$24396fcf7207086e$export$68326237475e9a7d(pre)(input) ? (0, $87701c398fec8638$export$fe7c49d056ea1d88)(input) : (0, $87701c398fec8638$export$af2dba6db4e9e1f0)(input, context), (0, $87701c398fec8638$export$f0954fd7d5368655));
const $24396fcf7207086e$export$68326237475e9a7d = (pre)=>(x)=>typeof x === 'string' && x.startsWith(pre);



/**
 * Custom Container types used in our models.
 *
 * @since 0.1.0
 */ 

var $5uDEp = parcelRequire("5uDEp");

var $3abDJ = parcelRequire("3abDJ");

var $9I22g = parcelRequire("9I22g");

const $8af43a568842d8c3$export$d8deaab87a4e223a = (codecT)=>new (0, $87701c398fec8638$export$92738401e1603719)(`NonEmpty<${codecT.name}`, $8af43a568842d8c3$var$isNonEmpty(codecT), (input, context)=>(0, $3abDJ.pipe)((0, $87701c398fec8638$export$2f23118c22fb2630)(codecT).validate(input, context), $5uDEp.chain((xs)=>$8af43a568842d8c3$export$abae9d370f12ca88(xs) ? (0, $87701c398fec8638$export$fe7c49d056ea1d88)(xs) : (0, $87701c398fec8638$export$af2dba6db4e9e1f0)(xs, context, 'Empty Array'))), (xs)=>(0, $9I22g.map)((x)=>codecT.encode(x))(xs));
const $8af43a568842d8c3$var$isNonEmpty = (codecT)=>(x)=>(0, $87701c398fec8638$export$2f23118c22fb2630)(codecT).is(x) && x.length > 0;
const $8af43a568842d8c3$export$abae9d370f12ca88 = (x)=>x.length > 0;
const $8af43a568842d8c3$export$4c7897fafd92b108 = (xs)=>xs[xs.length - 1];
const $8af43a568842d8c3$export$bb628a54ab399bc9 = (i)=>(xs)=>[
            ...xs.slice(i, xs.length),
            ...xs.slice(0, i)
        ];
const $8af43a568842d8c3$export$f9380c9a627682d3 = (i)=>(ys)=>{
        const y = ys[i];
        return y !== undefined ? [
            ys.slice(0, i),
            y,
            ys.slice(i + 1)
        ] : i < 0 ? [
            [],
            ys[0],
            ys.slice(1)
        ] : [
            ys.slice(0, -1),
            $8af43a568842d8c3$export$4c7897fafd92b108(ys),
            []
        ];
    };
const $8af43a568842d8c3$export$c40cf5aab899f397 = (xs, x)=>[
        ...xs,
        x
    ];


const $c984ccf21dc251c8$export$b78c334b45c4d289 = (codecA, codecB)=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        codecA,
        (0, $87701c398fec8638$export$65e3907585753458)([
            codecB,
            codecB,
            codecB
        ]),
        (0, $87701c398fec8638$export$65e3907585753458)([
            codecB,
            codecB
        ]),
        (0, $87701c398fec8638$export$65e3907585753458)([
            codecB
        ])
    ]);


/**
 * Measurements along curbs, walls, and ceilings of openings.
 *
 * @since 0.1.0
 */ 

const $29a0713b257db71e$export$fbc933da488a5097 = (s)=>(0, $87701c398fec8638$export$bc86dfbf7795668c)([
        $29a0713b257db71e$export$76df7375f104822f,
        $29a0713b257db71e$export$3733ff8eae35cf02(s)
    ]);
const $29a0713b257db71e$export$3733ff8eae35cf02 = (s)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        Direction: $29a0713b257db71e$export$c586fe36a25c612f(s)
    });
const $29a0713b257db71e$export$c586fe36a25c612f = (s)=>new (0, $87701c398fec8638$export$92738401e1603719)('Directed ' + s, (input)=>$29a0713b257db71e$var$isDirected(s)(input), (input, context)=>$29a0713b257db71e$var$isDirected(s)(input) ? (0, $87701c398fec8638$export$fe7c49d056ea1d88)(input) : (0, $87701c398fec8638$export$af2dba6db4e9e1f0)(input, context), (0, $87701c398fec8638$export$f0954fd7d5368655));
const $29a0713b257db71e$var$isDirected = (s)=>(x)=>typeof x === 'string' && $29a0713b257db71e$var$mapDirected[s].hasOwnProperty(x);
const $29a0713b257db71e$var$mapDirected = {
    Bottom: {
        'up': true,
        'down': true,
        'right': true
    },
    Left: {
        'down': true
    },
    Right: {
        'up': true
    },
    Top: {
        'up': true,
        'down': true,
        'left': true
    },
    In: {
        'in': true
    },
    Out: {
        'out': true
    }
};
const $29a0713b257db71e$export$4b793e9421eec011 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Major: (0, $0b3a4acf236478d7$export$3081247862d57e3d)
});
const $29a0713b257db71e$export$7c58e9b1273798cb = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Mag: (0, $87701c398fec8638$export$98e628dec113755e)
});
const $29a0713b257db71e$export$e2a340ef166bef1c = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    $29a0713b257db71e$export$4b793e9421eec011,
    $29a0713b257db71e$export$7c58e9b1273798cb
]);
const $29a0713b257db71e$export$2289e9b7d91d85ed = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Minor: (0, $87701c398fec8638$export$98e628dec113755e)
});
const $29a0713b257db71e$export$6cdc1cb9345ffadf = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Angle: (0, $87701c398fec8638$export$98e628dec113755e)
});
const $29a0713b257db71e$export$6a3d31f6eb68b04 = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    $29a0713b257db71e$export$2289e9b7d91d85ed,
    $29a0713b257db71e$export$6cdc1cb9345ffadf
]);
const $29a0713b257db71e$export$851b30bb93ac5d3e = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Circular'),
    Deflection: (0, $87701c398fec8638$export$98e628dec113755e)
});
const $29a0713b257db71e$export$49df95eaaf7f0778 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Sinusoidal'),
    Deflection: (0, $87701c398fec8638$export$98e628dec113755e)
});
const $29a0713b257db71e$export$e3aa8e6f6be594b2 = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    $29a0713b257db71e$export$851b30bb93ac5d3e,
    $29a0713b257db71e$export$49df95eaaf7f0778
]);
const $29a0713b257db71e$export$76df7375f104822f = (0, $87701c398fec8638$export$bc86dfbf7795668c)([
    (0, $87701c398fec8638$export$bf9fb029d174d554)({
        Major: $29a0713b257db71e$export$e2a340ef166bef1c
    }),
    (0, $87701c398fec8638$export$e45945969df8035a)({
        MajorPri: (0, $87701c398fec8638$export$98e628dec113755e),
        Minor: $29a0713b257db71e$export$6a3d31f6eb68b04,
        MinorPri: (0, $87701c398fec8638$export$98e628dec113755e),
        Curvature: $29a0713b257db71e$export$e3aa8e6f6be594b2
    })
]);
const $29a0713b257db71e$export$ddab1c902ba589aa = (0, $87701c398fec8638$export$7e1278799275f68e)({
    inside: true,
    center: true,
    outside: true
});


const $9e5a9e415e4680b7$export$605846925e53c7e7 = (codecA, codecB, codecC, codecD)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        Info: codecD,
        Left: $9e5a9e415e4680b7$export$e0952392860efc05('Left', codecA),
        Section: $9e5a9e415e4680b7$export$c9fa421845f71161(codecA, codecB, codecC)
    });
const $9e5a9e415e4680b7$export$c9fa421845f71161 = (codecA, codecB, codecC)=>(0, $87701c398fec8638$export$74c5cab0f9a94551)('SectionTree', ()=>(0, $87701c398fec8638$export$bc86dfbf7795668c)([
            $9e5a9e415e4680b7$export$6e2c8f0811a474ce(codecA, codecB, codecC),
            (0, $87701c398fec8638$export$bf9fb029d174d554)({
                Rest: (0, $c984ccf21dc251c8$export$b78c334b45c4d289)($9e5a9e415e4680b7$export$cb4338d67ffa8a1d(codecA, codecB), $9e5a9e415e4680b7$export$c9fa421845f71161(codecA, codecB, codecC))
            })
        ]));
const $9e5a9e415e4680b7$export$cb4338d67ffa8a1d = (codecA, codecB)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        Angle: $9e5a9e415e4680b7$export$6a0d2ab5fd042395(codecB),
        Right: $9e5a9e415e4680b7$export$e0952392860efc05('Right', codecA)
    });
const $9e5a9e415e4680b7$export$6e2c8f0811a474ce = (codecA, codecB, codecC)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        Angle: $9e5a9e415e4680b7$export$6a0d2ab5fd042395(codecB),
        Ceiling: $9e5a9e415e4680b7$export$e0952392860efc05('Top', codecA),
        Info: codecC,
        Floor: $9e5a9e415e4680b7$export$e0952392860efc05('Bottom', codecA)
    });
const $9e5a9e415e4680b7$export$6a0d2ab5fd042395 = (codecA)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        Angle: (0, $0b3a4acf236478d7$export$6cdc1cb9345ffadf),
        Corner: $9e5a9e415e4680b7$export$26aa7833c998c5d3,
        Info: codecA
    });
const $9e5a9e415e4680b7$export$26aa7833c998c5d3 = (0, $87701c398fec8638$export$7e1278799275f68e)({
    'miter': true,
    'round': true,
    'bevel': true
});
const $9e5a9e415e4680b7$export$e0952392860efc05 = (s, codecA)=>(0, $87701c398fec8638$export$bc86dfbf7795668c)([
        $9e5a9e415e4680b7$export$751eeb54ec295719,
        (0, $87701c398fec8638$export$bf9fb029d174d554)({
            Curbs: (0, $87701c398fec8638$export$2f23118c22fb2630)($9e5a9e415e4680b7$export$47693eceeb381646(s, codecA))
        })
    ]);
const $9e5a9e415e4680b7$export$47693eceeb381646 = (s, codecA)=>(0, $87701c398fec8638$export$bc86dfbf7795668c)([
        $9e5a9e415e4680b7$export$751eeb54ec295719,
        (0, $87701c398fec8638$export$e45945969df8035a)({
            '!mid': (0, $24396fcf7207086e$export$428ef1f8ddd66578),
            Anomalies: (0, $87701c398fec8638$export$2f23118c22fb2630)($9e5a9e415e4680b7$export$e3e414bd3035dc6e)
        }),
        (0, $87701c398fec8638$export$bf9fb029d174d554)({
            Info: codecA,
            Measure: (0, $29a0713b257db71e$export$fbc933da488a5097)(s)
        })
    ]);
const $9e5a9e415e4680b7$export$e6d3b4e5ac18cdaf = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Offset: (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        (0, $87701c398fec8638$export$98e628dec113755e),
        (0, $87701c398fec8638$export$9d93593e0583cfae)
    ]),
    Location: (0, $29a0713b257db71e$export$ddab1c902ba589aa)
});
const $9e5a9e415e4680b7$export$77f3a24ca0ca8504 = (0, $87701c398fec8638$export$7e1278799275f68e)({
    start: true,
    end: true
});
const $9e5a9e415e4680b7$export$8caee09accd95d7f = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Offset: (0, $87701c398fec8638$export$98e628dec113755e),
    Location: $9e5a9e415e4680b7$export$77f3a24ca0ca8504
});
const $9e5a9e415e4680b7$export$751eeb54ec295719 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Bredth: (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        (0, $29a0713b257db71e$export$fbc933da488a5097)('In'),
        (0, $87701c398fec8638$export$9d93593e0583cfae)
    ]),
    Offset: (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        $9e5a9e415e4680b7$export$e6d3b4e5ac18cdaf,
        (0, $87701c398fec8638$export$9d93593e0583cfae)
    ]),
    OuterHeight: (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        (0, $87701c398fec8638$export$98e628dec113755e),
        (0, $87701c398fec8638$export$9d93593e0583cfae)
    ])
});
const $9e5a9e415e4680b7$export$e3e414bd3035dc6e = (0, $87701c398fec8638$export$bc86dfbf7795668c)([
    (0, $87701c398fec8638$export$bf9fb029d174d554)({
        Offset: $9e5a9e415e4680b7$export$8caee09accd95d7f,
        Depth: (0, $87701c398fec8638$export$98e628dec113755e),
        Size: (0, $0b3a4acf236478d7$export$3081247862d57e3d)
    }),
    (0, $87701c398fec8638$export$e45945969df8035a)({
        Width: (0, $0b3a4acf236478d7$export$3081247862d57e3d),
        Description: (0, $87701c398fec8638$export$22b082955e083ec3)
    })
]);
const $9e5a9e415e4680b7$export$65617b430e4b9024 = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)(0),
    (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)(1),
    (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)(2)
]);


const $3ed4c97548491c68$export$2bc9b43c3505f735 = (0, $87701c398fec8638$export$19282c40b967aec6);
const $3ed4c97548491c68$export$3cc22bc1e76aaeab = (0, $f53a175514b17aaf$export$88a6666ae2487175);
const $3ed4c97548491c68$export$aab3aabd86eaa25f = (0, $87701c398fec8638$export$19282c40b967aec6);
const $3ed4c97548491c68$export$605846925e53c7e7 = $9e5a9e415e4680b7$export$605846925e53c7e7((0, $e81bee764b11314c$export$8212cedec4cdb9b4), $3ed4c97548491c68$export$2bc9b43c3505f735, $3ed4c97548491c68$export$3cc22bc1e76aaeab, $3ed4c97548491c68$export$aab3aabd86eaa25f);
const $3ed4c97548491c68$export$6e2c8f0811a474ce = $9e5a9e415e4680b7$export$6e2c8f0811a474ce((0, $e81bee764b11314c$export$8212cedec4cdb9b4), $3ed4c97548491c68$export$2bc9b43c3505f735, $3ed4c97548491c68$export$3cc22bc1e76aaeab);
const $3ed4c97548491c68$export$c9fa421845f71161 = $9e5a9e415e4680b7$export$c9fa421845f71161((0, $e81bee764b11314c$export$8212cedec4cdb9b4), $3ed4c97548491c68$export$2bc9b43c3505f735, $3ed4c97548491c68$export$3cc22bc1e76aaeab);
const $3ed4c97548491c68$export$cb4338d67ffa8a1d = $9e5a9e415e4680b7$export$cb4338d67ffa8a1d((0, $e81bee764b11314c$export$8212cedec4cdb9b4), $3ed4c97548491c68$export$2bc9b43c3505f735);
const $3ed4c97548491c68$export$e0952392860efc05 = (s)=>$9e5a9e415e4680b7$export$e0952392860efc05(s, (0, $e81bee764b11314c$export$8212cedec4cdb9b4));
const $3ed4c97548491c68$export$47693eceeb381646 = (s)=>$9e5a9e415e4680b7$export$47693eceeb381646(s, (0, $e81bee764b11314c$export$8212cedec4cdb9b4));
const $3ed4c97548491c68$export$9cdde8a99c1ac30f = (_position)=>(direction)=>(undirectedMeasurement)=>({
                Offset: {
                    Location: 'center',
                    Offset: 0
                },
                OuterHeight: null,
                Info: null,
                Bredth: null,
                Measure: {
                    Direction: direction,
                    ...undirectedMeasurement
                }
            });
const $3ed4c97548491c68$export$ced784817d9a4f97 = (p)=>(d)=>(distance, outage)=>$3ed4c97548491c68$export$9cdde8a99c1ac30f(p)(d)({
                Major: {
                    Mag: distance
                },
                Minor: {
                    Minor: outage
                }
            });
const $3ed4c97548491c68$export$c4287d255ec67471 = (p)=>(d)=>(major, minor)=>$3ed4c97548491c68$export$9cdde8a99c1ac30f(p)(d)({
                Major: {
                    Major: major
                },
                Minor: {
                    Minor: minor
                }
            });
const $3ed4c97548491c68$export$6a0d2ab5fd042395 = $9e5a9e415e4680b7$export$6a0d2ab5fd042395($3ed4c97548491c68$export$2bc9b43c3505f735);
const $3ed4c97548491c68$export$e6d3b4e5ac18cdaf = $9e5a9e415e4680b7$export$e6d3b4e5ac18cdaf;
const $3ed4c97548491c68$export$8caee09accd95d7f = $9e5a9e415e4680b7$export$8caee09accd95d7f;
const $3ed4c97548491c68$export$e3e414bd3035dc6e = $9e5a9e415e4680b7$export$e3e414bd3035dc6e;
const $3ed4c97548491c68$export$65617b430e4b9024 = $9e5a9e415e4680b7$export$65617b430e4b9024;



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $024a60f892d3fa61$export$46f01d01378ec5a2(slot) {
    return (0, $4Cod0.default)('MuiDivider', slot);
}
const $024a60f892d3fa61$var$dividerClasses = (0, $beCSm.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $024a60f892d3fa61$export$2e2bcd8739ae039 = $024a60f892d3fa61$var$dividerClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f875d00b2138afe4$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $f875d00b2138afe4$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $024a60f892d3fa61$export$46f01d01378ec5a2), classes);
};
const $f875d00b2138afe4$var$DividerRoot = (0, $d8seH.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $kSnzZ.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        borderTopStyle: 'solid',
        borderLeftStyle: 'solid',
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderTopStyle: 'inherit'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderLeftStyle: 'inherit'
        }
    }), ({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const $f875d00b2138afe4$var$DividerWrapper = (0, $d8seH.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $f875d00b2138afe4$var$Divider = /*#__PURE__*/ $acw62.forwardRef(function Divider(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, orientation: orientation = 'horizontal', role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $1En50.default)(props, $f875d00b2138afe4$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $f875d00b2138afe4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $f875d00b2138afe4$var$Divider.muiSkipListHighlight = true;
var $f875d00b2138afe4$export$2e2bcd8739ae039 = $f875d00b2138afe4$var$Divider;


var $611927cd5409b9fd$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($611927cd5409b9fd$exports, "__esModule", {
    value: true
});
$611927cd5409b9fd$exports.default = void 0;

var $611927cd5409b9fd$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $611927cd5409b9fd$var$_default = $611927cd5409b9fd$exports.default = (0, $611927cd5409b9fd$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8"
}), 'Undo');


var $b0e556da8a0e80f9$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($b0e556da8a0e80f9$exports, "__esModule", {
    value: true
});
$b0e556da8a0e80f9$exports.default = void 0;

var $b0e556da8a0e80f9$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b0e556da8a0e80f9$var$_default = $b0e556da8a0e80f9$exports.default = (0, $b0e556da8a0e80f9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.11 8.53 5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47M6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47m1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93"
}), 'RotateLeft');


var $204e25e6fe5291f6$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($204e25e6fe5291f6$exports, "__esModule", {
    value: true
});
$204e25e6fe5291f6$exports.default = void 0;

var $204e25e6fe5291f6$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $204e25e6fe5291f6$var$_default = $204e25e6fe5291f6$exports.default = (0, $204e25e6fe5291f6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.55 5.55 11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03m3.89-2.42 1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48"
}), 'RotateRight');



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $7027da6f4b17de9d$var$usePreviousProps = (value)=>{
    const ref = $acw62.useRef({});
    $acw62.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $7027da6f4b17de9d$export$2e2bcd8739ae039 = $7027da6f4b17de9d$var$usePreviousProps;


'use client';
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $23a03a376a300fc5$var$stripDiacritics(string) {
    return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}
function $23a03a376a300fc5$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $23a03a376a300fc5$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $23a03a376a300fc5$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $23a03a376a300fc5$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $23a03a376a300fc5$var$defaultFilterOptions = $23a03a376a300fc5$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $23a03a376a300fc5$var$pageSize = 5;
const $23a03a376a300fc5$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
const $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE = [];
function $23a03a376a300fc5$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $23a03a376a300fc5$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $23a03a376a300fc5$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $acw62.useRef(false);
    const firstFocus = $acw62.useRef(true);
    const inputRef = $acw62.useRef(null);
    const listboxRef = $acw62.useRef(null);
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const [focusedTag, setFocusedTag] = $acw62.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $acw62.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: '',
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $acw62.useState(false);
    const resetInputValue = $acw62.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = '';
        else if (newValue == null) newInputValue = '';
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, 'reset');
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $acw62.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $7027da6f4b17de9d$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $acw62.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $acw62.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason = 'auto' })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = 'next', reason: reason = 'auto' })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return $23a03a376a300fc5$var$findIndex(filteredOptions, (option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $acw62.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $23a03a376a300fc5$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $23a03a376a300fc5$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((node)=>{
        (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $acw62.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $acw62.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $23a03a376a300fc5$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === '' && direction === 'previous') nextTag = value.length - 1;
        } else {
            nextTag += direction === 'next' ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                'ArrowLeft',
                'ArrowRight'
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$23a03a376a300fc5$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $23a03a376a300fc5$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    handleFocusTag(event, 'previous');
                    break;
                case 'ArrowRight':
                    handleFocusTag(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $8nd05.default)({
                'aria-owns': listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $8nd05.default)({
                key: index,
                'data-tag-index': index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}
var $23a03a376a300fc5$export$2e2bcd8739ae039 = $23a03a376a300fc5$var$useAutocomplete;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
var $41136b35f34e8eee$exports = {};
"use strict";
'use client';
Object.defineProperty($41136b35f34e8eee$exports, "__esModule", {
    value: true
});
$41136b35f34e8eee$exports.default = void 0;

var $41136b35f34e8eee$var$React = $41136b35f34e8eee$var$_interopRequireWildcard((parcelRequire("acw62")));
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");
function $41136b35f34e8eee$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($41136b35f34e8eee$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $41136b35f34e8eee$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $41136b35f34e8eee$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $41136b35f34e8eee$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $41136b35f34e8eee$var$useTheme(defaultTheme = null) {
    const contextTheme = $41136b35f34e8eee$var$React.useContext($eP9YU.T);
    return !contextTheme || $41136b35f34e8eee$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $41136b35f34e8eee$var$_default = $41136b35f34e8eee$exports.default = $41136b35f34e8eee$var$useTheme;






var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}


function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}







function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};










var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};


var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}







function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};




var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $8Indx = parcelRequire("8Indx");



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1(slot) {
    return (0, $4Cod0.default)('MuiPopper', slot);
}
const $bb1b487b0ea8f7b1$var$popperClasses = (0, $beCSm.default)('MuiPopper', [
    'root'
]);
var $bb1b487b0ea8f7b1$export$2e2bcd8739ae039 = $bb1b487b0ea8f7b1$var$popperClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5a1e9a841ed0d0fc$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $5a1e9a841ed0d0fc$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $5a1e9a841ed0d0fc$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $5a1e9a841ed0d0fc$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $5a1e9a841ed0d0fc$var$isVirtualElement(element) {
    return !$5a1e9a841ed0d0fc$var$isHTMLElement(element);
}
const $5a1e9a841ed0d0fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1), classes);
};
const $5a1e9a841ed0d0fc$var$defaultPopperOptions = {};
const $5a1e9a841ed0d0fc$var$PopperTooltip = /*#__PURE__*/ $acw62.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $5a1e9a841ed0d0fc$var$_excluded);
    const tooltipRef = $acw62.useRef(null);
    const ownRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $acw62.useRef(null);
    const handlePopperRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $acw62.useRef(handlePopperRef);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $acw62.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $5a1e9a841ed0d0fc$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $acw62.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $acw62.useState($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    $acw62.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $acw62.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $288fbeb449f53487$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $8nd05.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $5a1e9a841ed0d0fc$var$useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $8nd05.default)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $5a1e9a841ed0d0fc$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $5a1e9a841ed0d0fc$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $1En50.default)(props, $5a1e9a841ed0d0fc$var$_excluded2);
    const [exited, setExited] = $acw62.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $5a1e9a841ed0d0fc$var$isHTMLElement(resolvedAnchorEl) ? (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2117883cc21a32b2$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5a1e9a841ed0d0fc$var$PopperTooltip, (0, $8nd05.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $8nd05.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $5a1e9a841ed0d0fc$export$2e2bcd8739ae039 = $5a1e9a841ed0d0fc$var$Popper;



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a4669aa090d445bd$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $a4669aa090d445bd$var$PopperRoot = (0, $d8seH.default)((0, $5a1e9a841ed0d0fc$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $a4669aa090d445bd$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($41136b35f34e8eee$exports)))();
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $1En50.default)(props, $a4669aa090d445bd$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $8nd05.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a4669aa090d445bd$var$PopperRoot, (0, $8nd05.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $a4669aa090d445bd$export$2e2bcd8739ae039 = $a4669aa090d445bd$var$Popper;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d7f4cf29715b69dd$export$6816d4fc0981ec7(slot) {
    return (0, $4Cod0.default)('MuiListSubheader', slot);
}
const $d7f4cf29715b69dd$var$listSubheaderClasses = (0, $beCSm.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $d7f4cf29715b69dd$export$2e2bcd8739ae039 = $d7f4cf29715b69dd$var$listSubheaderClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5408b2039b9d572c$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $5408b2039b9d572c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d7f4cf29715b69dd$export$6816d4fc0981ec7), classes);
};
const $5408b2039b9d572c$var$ListSubheaderRoot = (0, $d8seH.default)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === 'primary' && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $5408b2039b9d572c$var$ListSubheader = /*#__PURE__*/ $acw62.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $1En50.default)(props, $5408b2039b9d572c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $5408b2039b9d572c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5408b2039b9d572c$var$ListSubheaderRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$5408b2039b9d572c$var$ListSubheader.muiSkipListHighlight = true;
var $5408b2039b9d572c$export$2e2bcd8739ae039 = $5408b2039b9d572c$var$ListSubheader;




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e40d2047b7c1e09d$export$5e8702d71474f093(slot) {
    return (0, $4Cod0.default)('MuiIconButton', slot);
}
const $e40d2047b7c1e09d$var$iconButtonClasses = (0, $beCSm.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $e40d2047b7c1e09d$export$2e2bcd8739ae039 = $e40d2047b7c1e09d$var$iconButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $71c322247f7fbf93$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $71c322247f7fbf93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`,
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e40d2047b7c1e09d$export$5e8702d71474f093), classes);
};
const $71c322247f7fbf93$var$IconButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $8nd05.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $8nd05.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $8nd05.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $e40d2047b7c1e09d$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $71c322247f7fbf93$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $1En50.default)(props, $71c322247f7fbf93$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $71c322247f7fbf93$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($71c322247f7fbf93$var$IconButtonRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $71c322247f7fbf93$export$2e2bcd8739ae039 = $71c322247f7fbf93$var$IconButton;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $62d1787512a69c15$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');





var $jTnBY = parcelRequire("jTnBY");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $db0771a9e6a32b1d$export$31444911e4ee6fdd(slot) {
    return (0, $4Cod0.default)('MuiChip', slot);
}
const $db0771a9e6a32b1d$var$chipClasses = (0, $beCSm.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $db0771a9e6a32b1d$export$2e2bcd8739ae039 = $db0771a9e6a32b1d$var$chipClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $47d4f79319086dc5$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $47d4f79319086dc5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $jTnBY.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $jTnBY.default)(color)}`,
            `${variant}${(0, $jTnBY.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $jTnBY.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $jTnBY.default)(size)}`,
            `avatarColor${(0, $jTnBY.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(size)}`,
            `iconColor${(0, $jTnBY.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $jTnBY.default)(size)}`,
            `deleteIconColor${(0, $jTnBY.default)(color)}`,
            `deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $db0771a9e6a32b1d$export$31444911e4ee6fdd), classes);
};
const $47d4f79319086dc5$var$ChipRoot = (0, $d8seH.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $jTnBY.default)(iconColor)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $jTnBY.default)(size)}`],
            styles[`color${(0, $jTnBY.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $jTnBY.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $jTnBY.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $jTnBY.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $8nd05.default)({
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: (0, $8nd05.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === 'small' && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $8nd05.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== 'default' && {
            color: 'inherit'
        })),
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: (0, $8nd05.default)({
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $kSnzZ.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $kSnzZ.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === 'small' && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== 'default' && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === 'small' && {
        height: 24
    }, ownerState.color !== 'default' && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== 'default' && {
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.clickable && {
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== 'default' && {
        [`&:hover, &.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.variant === 'outlined' && {
        backgroundColor: 'transparent',
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $47d4f79319086dc5$var$ChipLabel = (0, $d8seH.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $jTnBY.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: 'nowrap'
    }, ownerState.variant === 'outlined' && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === 'small' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $47d4f79319086dc5$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $47d4f79319086dc5$var$Chip = /*#__PURE__*/ $acw62.forwardRef(function Chip(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $1En50.default)(props, $47d4f79319086dc5$var$_excluded);
    const chipRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $4a35786d89db9dda$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $acw62.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $47d4f79319086dc5$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $4a35786d89db9dda$export$2e2bcd8739ae039) ? (0, $8nd05.default)({
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $acw62.isValidElement(deleteIconProp) ? /*#__PURE__*/ $acw62.cloneElement(deleteIconProp, {
        className: (0, $9QePP.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62d1787512a69c15$export$2e2bcd8739ae039), {
        className: (0, $9QePP.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $acw62.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $acw62.cloneElement(avatarProp, {
        className: (0, $9QePP.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $acw62.isValidElement(iconProp)) icon = /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($47d4f79319086dc5$var$ChipRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)($47d4f79319086dc5$var$ChipLabel, {
                className: (0, $9QePP.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $47d4f79319086dc5$export$2e2bcd8739ae039 = $47d4f79319086dc5$var$Chip;






parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $f7280bbf95507cba$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');




var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $723a67e53eb4dc4c$export$8ee01529667e66d9(slot) {
    return (0, $4Cod0.default)('MuiAutocomplete', slot);
}
const $723a67e53eb4dc4c$var$autocompleteClasses = (0, $beCSm.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $723a67e53eb4dc4c$export$2e2bcd8739ae039 = $723a67e53eb4dc4c$var$autocompleteClasses;



var $jTnBY = parcelRequire("jTnBY");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $9396253983985262$var$_ClearIcon, $9396253983985262$var$_ArrowDropDownIcon;
const $9396253983985262$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $9396253983985262$var$_excluded2 = [
    "ref"
], $9396253983985262$var$_excluded3 = [
    "key"
], $9396253983985262$var$_excluded4 = [
    "key"
];
const $9396253983985262$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $jTnBY.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $723a67e53eb4dc4c$export$8ee01529667e66d9), classes);
};
const $9396253983985262$var$AutocompleteRoot = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focused} .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).inputRoot}`]: {
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).root}`]: {
        padding: 9,
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).hiddenLabel}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $9396253983985262$var$AutocompleteEndAdornment = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment',
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $9396253983985262$var$AutocompleteClearIndicator = (0, $d8seH.default)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator',
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $9396253983985262$var$AutocompletePopupIndicator = (0, $d8seH.default)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $8nd05.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $9396253983985262$var$AutocompletePopper = (0, $d8seH.default)((0, $a4669aa090d445bd$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    }));
const $9396253983985262$var$AutocompletePaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body1, {
        overflow: 'auto'
    }));
const $9396253983985262$var$AutocompleteLoading = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading',
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $9396253983985262$var$AutocompleteNoOptions = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions',
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $9396253983985262$var$AutocompleteListbox = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Listbox',
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $9396253983985262$var$AutocompleteGroupLabel = (0, $d8seH.default)((0, $5408b2039b9d572c$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel',
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $9396253983985262$var$AutocompleteGroupUl = (0, $d8seH.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl',
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $9396253983985262$var$Autocomplete = /*#__PURE__*/ $acw62.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $9396253983985262$var$_ClearIcon || ($9396253983985262$var$_ClearIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7280bbf95507cba$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = 'ul', ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', openOnFocus: openOnFocus = false, openText: openText = 'Open', PaperComponent: PaperComponent = (0, $595185d0d7275c3b$export$2e2bcd8739ae039), PopperComponent: PopperComponent = (0, $a4669aa090d445bd$export$2e2bcd8739ae039), popupIcon: popupIcon = $9396253983985262$var$_ArrowDropDownIcon || ($9396253983985262$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a863bd9b12ca76b$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $9396253983985262$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $23a03a376a300fc5$export$2e2bcd8739ae039)((0, $8nd05.default)({}, props, {
        componentName: 'Autocomplete'
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $1En50.default)(_getListboxProps, $9396253983985262$var$_excluded2);
    const combinedListboxRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $8nd05.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $9396253983985262$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $8nd05.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>{
            const _getCustomizedTagProp = getCustomizedTagProps({
                index: index
            }), { key: key } = _getCustomizedTagProp, customTagProps = (0, $1En50.default)(_getCustomizedTagProp, $9396253983985262$var$_excluded3);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), (0, $8nd05.default)({
                label: getOptionLabel(option),
                size: size
            }, customTagProps, ChipProps), key);
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key } = props2, otherProps = (0, $1En50.default)(props2, $9396253983985262$var$_excluded4);
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", (0, $8nd05.default)({}, otherProps, {
            children: getOptionLabel(option)
        }), key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $8nd05.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteRoot, (0, $8nd05.default)({
                ref: ref,
                className: (0, $9QePP.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $8nd05.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteClearIndicator, (0, $8nd05.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $9QePP.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopupIndicator, (0, $8nd05.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $9QePP.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $8nd05.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopper, (0, $8nd05.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, $9QePP.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompletePaper, (0, $8nd05.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, $9QePP.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteListbox, (0, $8nd05.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
var $9396253983985262$export$2e2bcd8739ae039 = $9396253983985262$var$Autocomplete;



var $c842ddb70f8ccad0$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($c842ddb70f8ccad0$exports, "__esModule", {
    value: true
});
$c842ddb70f8ccad0$exports.default = void 0;

var $c842ddb70f8ccad0$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c842ddb70f8ccad0$var$_default = $c842ddb70f8ccad0$exports.default = (0, $c842ddb70f8ccad0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

const $c197ad7e0b56b287$var$LanguageContext = /*#__PURE__*/ (0, $acw62.createContext)('eng');
const $c197ad7e0b56b287$export$195746d839abd8b5 = $c197ad7e0b56b287$var$LanguageContext.Provider;
const $c197ad7e0b56b287$export$c1fd9f444a3dc711 = ()=>(0, $acw62.useContext)($c197ad7e0b56b287$var$LanguageContext);
// This translation list is a little special, because we want people to be able to find languages they recognize.
const $c197ad7e0b56b287$var$languageTransList = [
    {
        key: 'eng',
        names: {
            eng: 'English',
            cmn: 'English'
        }
    },
    {
        key: 'cmn',
        names: {
            eng: "\u5B98\u8BDD",
            cmn: "\u5B98\u8BDD"
        }
    }
];
const $c197ad7e0b56b287$var$languageTrans = {
    eng: 'Language'
};
const $c197ad7e0b56b287$export$138a47b7521a65dc = ({ value: value, update: update })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
        style: {
            padding: '12px 4px'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$e743e65751cd982a), {
            size: "small",
            value: value,
            label: $c197ad7e0b56b287$var$languageTrans,
            items: $c197ad7e0b56b287$var$languageTransList,
            update: update
        })
    });


const $250e0f5c3f8134c4$export$e743e65751cd982a = (ps)=>{
    const mentry = ps.items.find((item)=>item.key === ps.value);
    const entry = mentry ?? {
        key: ps.value,
        names: {}
    };
    const options = mentry === undefined ? [
        entry,
        ...ps.items
    ] : ps.items;
    const lang = (0, $c197ad7e0b56b287$export$c1fd9f444a3dc711)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9396253983985262$export$2e2bcd8739ae039), {
        id: ps.id,
        autoHighlight: true,
        autoSelect: true,
        disableClearable: true,
        size: ps.size,
        sx: {
            minWidth: '20ex'
        },
        value: entry,
        onChange: (_ev, item)=>ps.update(()=>item.key),
        options: options,
        getOptionLabel: (item)=>item.names[lang] ?? item.key,
        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                ...params,
                size: ps.size,
                label: (ps.label ?? {})[lang]
            }),
        popupIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {})
    });
};
const $250e0f5c3f8134c4$export$954be10a9d390636 = (ps)=>{
    const lang = (0, $c197ad7e0b56b287$export$c1fd9f444a3dc711)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9396253983985262$export$2e2bcd8739ae039), {
        id: ps.id,
        multiple: true,
        autoHighlight: true,
        autoSelect: true,
        disableClearable: true,
        size: ps.size,
        sx: {
            width: Math.max(3, ...ps.items.map((item)=>(item.names[lang] ?? item.key).length + 6)).toString() + 'ex'
        },
        value: ps.value.map((sel)=>ps.items.find((item)=>item.key === sel) ?? {
                key: sel,
                names: {}
            }),
        onChange: (_ev, item)=>ps.update(()=>item.map((e)=>e.key)),
        options: ps.items,
        getOptionLabel: (item)=>item.names[lang] ?? item.key,
        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                ...params,
                label: (ps.label ?? {})[lang]
            })
    });
};
var $250e0f5c3f8134c4$export$2e2bcd8739ae039 = $250e0f5c3f8134c4$export$e743e65751cd982a;


function $3897a8a6f8a8857c$var$isBuffer(obj) {
    return obj && obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}
function $3897a8a6f8a8857c$var$keyIdentity(key) {
    return key;
}
function $3897a8a6f8a8857c$export$bffa455ba8c619a6(target, opts) {
    opts = opts || {};
    const delimiter = opts.delimiter || '.';
    const maxDepth = opts.maxDepth;
    const transformKey = opts.transformKey || $3897a8a6f8a8857c$var$keyIdentity;
    const output = {};
    function step(object, prev, currentDepth) {
        currentDepth = currentDepth || 1;
        Object.keys(object).forEach(function(key) {
            const value = object[key];
            const isarray = opts.safe && Array.isArray(value);
            const type = Object.prototype.toString.call(value);
            const isbuffer = $3897a8a6f8a8857c$var$isBuffer(value);
            const isobject = type === '[object Object]' || type === '[object Array]';
            const newKey = prev ? prev + delimiter + transformKey(key) : transformKey(key);
            if (!isarray && !isbuffer && isobject && Object.keys(value).length && (!opts.maxDepth || currentDepth < maxDepth)) return step(value, newKey, currentDepth + 1);
            output[newKey] = value;
        });
    }
    step(target);
    return output;
}
function $3897a8a6f8a8857c$export$4315a2af848d75d7(target, opts) {
    opts = opts || {};
    const delimiter = opts.delimiter || '.';
    const overwrite = opts.overwrite || false;
    const transformKey = opts.transformKey || $3897a8a6f8a8857c$var$keyIdentity;
    const result = {};
    const isbuffer = $3897a8a6f8a8857c$var$isBuffer(target);
    if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') return target;
    // safely ensure that the key is
    // an integer.
    function getkey(key) {
        const parsedKey = Number(key);
        return isNaN(parsedKey) || key.indexOf('.') !== -1 || opts.object ? key : parsedKey;
    }
    function addKeys(keyPrefix, recipient, target) {
        return Object.keys(target).reduce(function(result, key) {
            result[keyPrefix + delimiter + key] = target[key];
            return result;
        }, recipient);
    }
    function isEmpty(val) {
        const type = Object.prototype.toString.call(val);
        const isArray = type === '[object Array]';
        const isObject = type === '[object Object]';
        if (!val) return true;
        else if (isArray) return !val.length;
        else if (isObject) return !Object.keys(val).length;
    }
    target = Object.keys(target).reduce(function(result, key) {
        const type = Object.prototype.toString.call(target[key]);
        const isObject = type === '[object Object]' || type === '[object Array]';
        if (!isObject || isEmpty(target[key])) {
            result[key] = target[key];
            return result;
        } else return addKeys(key, result, $3897a8a6f8a8857c$export$bffa455ba8c619a6(target[key], opts));
    }, {});
    Object.keys(target).forEach(function(key) {
        const split = key.split(delimiter).map(transformKey);
        let key1 = getkey(split.shift());
        let key2 = getkey(split[0]);
        let recipient = result;
        while(key2 !== undefined){
            if (key1 === '__proto__') return;
            const type = Object.prototype.toString.call(recipient[key1]);
            const isobject = type === '[object Object]' || type === '[object Array]';
            // do not write over falsey, non-undefined values if overwrite is false
            if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') return;
            if (overwrite && !isobject || !overwrite && recipient[key1] == null) recipient[key1] = typeof key2 === 'number' && !opts.object ? [] : {};
            recipient = recipient[key1];
            if (split.length > 0) {
                key1 = getkey(split.shift());
                key2 = getkey(split[0]);
            }
        }
        // unflatten again for 'messy objects'
        recipient[key1] = $3897a8a6f8a8857c$export$4315a2af848d75d7(target[key], opts);
    });
    return result;
}



var $3abDJ = parcelRequire("3abDJ");

const $d9f4ffa0bf773b73$export$e51a5d37c3a60929 = ()=>({
        weak: new WeakMap(),
        strong: new Map()
    });
const $d9f4ffa0bf773b73$var$memory = $d9f4ffa0bf773b73$export$e51a5d37c3a60929();
const $d9f4ffa0bf773b73$export$588732934346abbf = (m, ...keys)=>{
    for (const key of keys)// we want as much garbage collection as possible, so objects and functions go in a weak map
    if (typeof key === 'object' && key !== null || typeof key === 'function') {
        const mnext = m.weak.get(key);
        const next = mnext ?? $d9f4ffa0bf773b73$export$e51a5d37c3a60929();
        if (mnext === undefined) m.weak.set(key, next);
        m = next;
    } else {
        const mnext = m.strong.get(key);
        const next = mnext ?? $d9f4ffa0bf773b73$export$e51a5d37c3a60929();
        if (mnext === undefined) m.strong.set(key, next);
        m = next;
    }
    return m;
};
const $d9f4ffa0bf773b73$export$e7aa7bc5c1b3cfb3 = (m, calc, ...keys)=>{
    m = $d9f4ffa0bf773b73$export$588732934346abbf(m, ...keys);
    if (!m.isSet) {
        m.value = calc();
        m.isSet = true;
    }
    return m.value;
};
const $d9f4ffa0bf773b73$export$88a748dde262235d = (m, calc, ...keys)=>{
    m = $d9f4ffa0bf773b73$export$588732934346abbf(m, ...keys);
    if (!m.isSet) {
        m.value = calc();
        console.log('miss', keys, m.value);
        m.isSet = true;
    } else console.log('set', keys, m.value);
    return m.value;
};
const $d9f4ffa0bf773b73$export$7fc4ea9a72a632dc = (m, calc, ...keys)=>{
    m = $d9f4ffa0bf773b73$export$588732934346abbf(m, ...keys);
    switch(m.isSet){
        // first time for these keys
        case undefined:
            m.value = [];
            return new Promise((resolve, reject)=>{
                m.value.push({
                    resolve: resolve,
                    reject: reject
                });
                calc().then((x)=>{
                    m.value.forEach((ex)=>ex.resolve(x));
                    m.value = Promise.resolve(x);
                    m.isSet = true;
                }).catch((e)=>{
                    // don't cache failures
                    m.value.forEach((ex)=>ex.reject(e));
                    m.isSet = undefined;
                });
                m.isSet = false;
            });
        // promise hasn't been resolved yet
        case false:
            return new Promise((resolve, reject)=>{
                m.value.push({
                    resolve: resolve,
                    reject: reject
                });
            });
        // promise has been resolved
        case true:
            return m.value;
    }
};
const $d9f4ffa0bf773b73$export$7c73462e0d25e514 = (key, args, res)=>$d9f4ffa0bf773b73$export$e7aa7bc5c1b3cfb3($d9f4ffa0bf773b73$var$memory, res, key, ...args);
const $d9f4ffa0bf773b73$export$6e68fd820909a51e = (key, args, res)=>$d9f4ffa0bf773b73$export$88a748dde262235d($d9f4ffa0bf773b73$var$memory, res, key, ...args);
const $d9f4ffa0bf773b73$export$49ac4be000c880a7 = (f, ...xs)=>$d9f4ffa0bf773b73$export$e7aa7bc5c1b3cfb3($d9f4ffa0bf773b73$var$memory, ()=>()=>f(...xs), $d9f4ffa0bf773b73$export$49ac4be000c880a7, f, ...xs);
const $d9f4ffa0bf773b73$export$e8308fa57e490f0c = (f, ...keys)=>$d9f4ffa0bf773b73$export$e7aa7bc5c1b3cfb3($d9f4ffa0bf773b73$var$memory, ()=>{
        const m = $d9f4ffa0bf773b73$export$e51a5d37c3a60929();
        return (...ps)=>$d9f4ffa0bf773b73$export$e7aa7bc5c1b3cfb3(m, ()=>f(...ps), ...ps);
    }, f, ...keys);
const $d9f4ffa0bf773b73$export$1fc724eaada7a444 = (f, ...keys)=>$d9f4ffa0bf773b73$export$88a748dde262235d($d9f4ffa0bf773b73$var$memory, ()=>{
        const m = $d9f4ffa0bf773b73$export$e51a5d37c3a60929();
        return (...ps)=>$d9f4ffa0bf773b73$export$88a748dde262235d(m, ()=>f(...ps), ...ps);
    }, f, ...keys);
const $d9f4ffa0bf773b73$export$13bb4c54e43ebb22 = (f, ...keys)=>$d9f4ffa0bf773b73$export$e7aa7bc5c1b3cfb3($d9f4ffa0bf773b73$var$memory, ()=>{
        const m = $d9f4ffa0bf773b73$export$e51a5d37c3a60929();
        return (...ps)=>$d9f4ffa0bf773b73$export$7fc4ea9a72a632dc(m, ()=>f(...ps), ...ps);
    }, f, ...keys);



var $4ZBbi = parcelRequire("4ZBbi");

var $hBXBN = parcelRequire("hBXBN");
/**
 * Optics for pure manipulation of concrete `Openings`.
 *
 * @since 0.1.0
 */ 
var $kisy7 = parcelRequire("kisy7");
var $b24b46566310b44c$exports = {};
"use strict";
Object.defineProperty($b24b46566310b44c$exports, "__esModule", {
    value: true
});
$b24b46566310b44c$exports.indexArray = void 0;

var $91zXM = parcelRequire("91zXM");

var $4ZBbi = parcelRequire("4ZBbi");

var $hBXBN = parcelRequire("hBXBN");
/**
 * @category constructor
 * @since 1.2.0
 */ function $b24b46566310b44c$var$indexArray() {
    return new $91zXM.Index(function(i) {
        return new $91zXM.Optional(function(as) {
            return (0, $4ZBbi.lookup)(i, as);
        }, function(a) {
            return function(as) {
                var oas = (0, $4ZBbi.updateAt)(i, a)(as);
                if ((0, $hBXBN.isNone)(oas)) return as;
                else return oas.value;
            };
        });
    });
}
$b24b46566310b44c$exports.indexArray = $b24b46566310b44c$var$indexArray;


/**
 * Optics for pure manipulation of concrete `Division`s.
 *
 * @since 0.1.0
 */ /**
 * Optics for pure manipulation of polymorphic `Division`s.
 *
 * @since 0.1.0
 */ 
var $kisy7 = parcelRequire("kisy7");

var $5OFXS = parcelRequire("5OFXS");
/**
 * Optics for internal use.
 *
 * @internal
 * @since 0.1.0
 */ 
var $kisy7 = parcelRequire("kisy7");

var $5OFXS = parcelRequire("5OFXS");


var $9I22g = parcelRequire("9I22g");

var $4ZBbi = parcelRequire("4ZBbi");
const $1379b6c01f560d41$export$dde4ed1e3c4ae515 = ()=>new (0, $kisy7.Optional)((s)=>(0, $5OFXS.some)(s), (a)=>(_s)=>a);
const $1379b6c01f560d41$export$9364064a021bcaeb = new (0, $kisy7.Lens)((s)=>s === undefined ? '' : s, (a)=>(_s)=>a === '' ? undefined : a);
const $1379b6c01f560d41$export$bf4ccabcbd35b59a = (o)=>new (0, $kisy7.Lens)((s)=>s === undefined ? o : s, (a)=>(_s)=>a === o ? undefined : a);
const $1379b6c01f560d41$export$4fa4efdde929acb0 = ()=>new (0, $kisy7.Lens)((xs)=>xs === undefined ? [] : xs, (xs)=>(_xs)=>(0, $8af43a568842d8c3$export$abae9d370f12ca88)(xs) ? xs : undefined);
const $1379b6c01f560d41$export$198cba5001cec8dc = (x)=>new (0, $kisy7.Lens)((xs)=>xs.some((a)=>x === a), (present)=>(xs)=>xs.some((a)=>x === a) ? present ? xs : xs.filter((a)=>a !== x) : present ? [
                ...xs,
                x
            ] : xs);
const $1379b6c01f560d41$export$b610b8812bbcded9 = (i)=>new (0, $kisy7.Lens)((s)=>s[i], (a)=>(s)=>[
                ...s.slice(0, i),
                a,
                ...s.slice(i + 1)
            ]);
const $1379b6c01f560d41$export$b69442bcc2eaec57 = (0, $kisy7.fromTraversable)((0, $9I22g.Traversable))();
const $1379b6c01f560d41$export$d25223d48e034add = (value)=>(0, $kisy7.Prism).fromPredicate((x)=>x === value);
const $1379b6c01f560d41$export$5bf6277736efcace = ()=>new (0, $kisy7.Optional)($4ZBbi.last, (a)=>(s)=>s.length === 0 ? s : [
                ...s.slice(0, s.length - 1),
                a
            ]);


const $3d70d84ca5121a5e$export$db1a5e286b0fec91 = ()=>new (0, $kisy7.Lens)((s)=>{
        switch(s.type){
            case 'Manual':
                return s.Division;
            case 'Minimal':
                return {
                    type: 'Whole',
                    Info: s.Info
                };
        }
    }, (a)=>(s)=>{
            switch(s.type){
                case 'Manual':
                    return {
                        type: 'Manual',
                        Division: a
                    };
                case 'Minimal':
                    return {
                        type: 'Manual',
                        Division: a
                    };
            }
        });
const $3d70d84ca5121a5e$export$2b09f9e2ab3d9b0b = (is)=>is.reduce((a, i)=>a.compose($3d70d84ca5121a5e$export$ddcc0c9c3b00c1b5(i)), (0, $1379b6c01f560d41$export$dde4ed1e3c4ae515)());
const $3d70d84ca5121a5e$export$ddcc0c9c3b00c1b5 = (i)=>new (0, $kisy7.Optional)((s)=>s.type === 'Divided' ? (0, $5OFXS.some)(s[i]) : (0, $5OFXS.none), (a)=>(s)=>s.type === 'Divided' ? {
                ...s,
                [i]: a
            } : s);


const $4264ed72b222fae4$export$db1a5e286b0fec91 = $3d70d84ca5121a5e$export$db1a5e286b0fec91();
const $4264ed72b222fae4$export$2b09f9e2ab3d9b0b = (is)=>$3d70d84ca5121a5e$export$2b09f9e2ab3d9b0b(is);
const $4264ed72b222fae4$export$ddcc0c9c3b00c1b5 = (i)=>$3d70d84ca5121a5e$export$ddcc0c9c3b00c1b5(i);


/**
 * Optics for pure manipulations of `Opening`s.
 *
 * @since 0.1.0
 */ 
var $kisy7 = parcelRequire("kisy7");

/**
 * Optics for the Boxes module.
 *
 * @since 0.1.0
 */ 
var $kisy7 = parcelRequire("kisy7");

var $5OFXS = parcelRequire("5OFXS");
const $37e4362694b22dd4$export$9e0f7fb68478c8fe = (i)=>new (0, $kisy7.Optional)((s)=>Array.isArray(s) ? (0, $5OFXS.fromNullable)(s[i]) : (0, $5OFXS.none), (a)=>(s)=>Array.isArray(s) ? $37e4362694b22dd4$var$setAt(i, a)(s) : s);
const $37e4362694b22dd4$export$80bf7733f1207381 = ()=>new (0, $kisy7.Prism)((s)=>Array.isArray(s) ? (0, $5OFXS.none) : (0, $5OFXS.some)(s), (a)=>a);
/**
 * Set the `i`th element in an array to `x`.
 *
 * @since 0.4.0
 */ const $37e4362694b22dd4$var$setAt = (i, x)=>(xs)=>{
        if (i >= xs.length) return xs;
        const xs_ = xs.slice();
        xs_[i] = x;
        return xs_;
    };
const $37e4362694b22dd4$export$1cb786250da2dfa6 = ()=>new (0, $kisy7.Lens)((s)=>s, (a)=>(s)=>a === null ? s : a);


const $b649ba990a31d3d2$export$55ddb4f38f3e3471 = ()=>(0, $kisy7.Lens).fromProp()('Section');
const $b649ba990a31d3d2$export$7fbf24f5b3ed34f2 = (is)=>is.reduce((a, i)=>a.compose($b649ba990a31d3d2$export$b5d4f8e2fc0f4662(i)), (0, $1379b6c01f560d41$export$dde4ed1e3c4ae515)());
const $b649ba990a31d3d2$export$9a9688b7050d170c = (is)=>$b649ba990a31d3d2$export$7fbf24f5b3ed34f2(is).compose($b649ba990a31d3d2$export$d6b22eef3a505f1e().asOptional());
const $b649ba990a31d3d2$export$b5d4f8e2fc0f4662 = (i)=>$b649ba990a31d3d2$export$b455f688a19f877e().asOptional().compose((0, $37e4362694b22dd4$export$9e0f7fb68478c8fe)(i));
const $b649ba990a31d3d2$export$b455f688a19f877e = ()=>(0, $kisy7.Lens).fromProp()('Rest');
const $b649ba990a31d3d2$export$d6b22eef3a505f1e = ()=>new (0, $kisy7.Lens)((s)=>s, (a)=>({ Rest: Rest })=>({
                ...a,
                Rest: Rest
            }));
const $b649ba990a31d3d2$export$16295f510e35177d = ()=>(0, $kisy7.Lens).fromProp()('Info');



var $kisy7 = parcelRequire("kisy7");

var $hBXBN = parcelRequire("hBXBN");

/**
 * Number types and guards.
 *
 * @since 0.1.0
 */ 
const $0afff5a8d5fc1877$export$6cdc1cb9345ffadf = (0, $87701c398fec8638$export$98e628dec113755e);
const $0afff5a8d5fc1877$export$5de3937cb4b592ed = (theta)=>Math.sin(theta * Math.PI / 180);
const $0afff5a8d5fc1877$export$50d414a77b60d802 = (theta)=>Math.cos(theta * Math.PI / 180);
const $0afff5a8d5fc1877$export$fcdd3b0b3246a325 = (theta)=>Math.tan(theta * Math.PI / 180);
const $0afff5a8d5fc1877$export$a830b5ed334924be = (theta)=>1 / Math.sin(theta * Math.PI / 180);
const $0afff5a8d5fc1877$export$e17a63917e2ebf0f = (theta)=>1 / Math.cos(theta * Math.PI / 180);
const $0afff5a8d5fc1877$export$ef569ec50496610c = (theta)=>1 / Math.tan(theta * Math.PI / 180);
const $0afff5a8d5fc1877$export$41726bdb1fc63f = (x)=>Math.asin(x) * 180 / Math.PI;
const $0afff5a8d5fc1877$export$fd6306be3fde5b04 = (x)=>Math.acos(x) * 180 / Math.PI;
const $0afff5a8d5fc1877$export$628dc4eed22b0fbd = (x)=>Math.atan(x) * 180 / Math.PI;
const $0afff5a8d5fc1877$export$43298db932064b4a = (x)=>Math.asin(1 / x) * 180 / Math.PI;
const $0afff5a8d5fc1877$export$ec42f46098b24bb4 = (x)=>Math.acos(1 / x) * 180 / Math.PI;
const $0afff5a8d5fc1877$export$4919a578c4aafd3 = (x)=>Math.atan(1 / x) * 180 / Math.PI;
const $0afff5a8d5fc1877$export$b8b770ee6a0d9760 = (v)=>Math.atan2(v[1], v[0]) * 180 / Math.PI;



const $24a1c1ffbf73ec6a$export$72683dc2d378b18d = (0, $kisy7.Lens).fromProp()('Major');
const $24a1c1ffbf73ec6a$export$f19dd2c890563e4e = ()=>new (0, $kisy7.Lens)($24a1c1ffbf73ec6a$var$getMajor, (a)=>(m)=>({
                ...m,
                Major: a
            }));
const $24a1c1ffbf73ec6a$var$getMajor = (m)=>(0, $29a0713b257db71e$export$4b793e9421eec011).is(m.Major) ? m.Major : $24a1c1ffbf73ec6a$var$getMajorFromMagMinor(m.Major, m.Minor);
const $24a1c1ffbf73ec6a$var$getMajorFromMagMinor = (mag, minor)=>({
        Major: (0, $29a0713b257db71e$export$2289e9b7d91d85ed).is(minor) ? Math.sqrt(mag.Mag * mag.Mag - minor.Minor * minor.Minor) : (0, $29a0713b257db71e$export$6cdc1cb9345ffadf).is(minor) ? mag.Mag * $0afff5a8d5fc1877$export$50d414a77b60d802(minor.Angle) : 0
    });
const $24a1c1ffbf73ec6a$export$950eef7f5163a0d8 = (0, $kisy7.Lens).fromProp()('Mag');
const $24a1c1ffbf73ec6a$export$47b1e05306f58d86 = ()=>new (0, $kisy7.Lens)($24a1c1ffbf73ec6a$var$getMag, (a)=>(m)=>({
                ...m,
                Major: a
            }));
const $24a1c1ffbf73ec6a$var$getMag = (m)=>(0, $29a0713b257db71e$export$7c58e9b1273798cb).is(m.Major) ? m.Major : $24a1c1ffbf73ec6a$var$getMagFromMajorMinor(m.Major, m.Minor);
const $24a1c1ffbf73ec6a$var$getMagFromMajorMinor = (major, minor)=>({
        Mag: (0, $29a0713b257db71e$export$2289e9b7d91d85ed).is(minor) ? Math.sqrt(major.Major * major.Major + minor.Minor * minor.Minor) : (0, $29a0713b257db71e$export$6cdc1cb9345ffadf).is(minor) ? major.Major / $0afff5a8d5fc1877$export$50d414a77b60d802(minor.Angle) : 0
    });
const $24a1c1ffbf73ec6a$export$920ff3912d63136f = (0, $kisy7.Lens).fromProp()('Minor');
const $24a1c1ffbf73ec6a$export$a8e06f16a42ea0c0 = ()=>new (0, $kisy7.Lens)($24a1c1ffbf73ec6a$var$getMinor, (a)=>(m)=>({
                ...m,
                Minor: a
            }));
const $24a1c1ffbf73ec6a$var$getMinor = (m)=>(0, $29a0713b257db71e$export$2289e9b7d91d85ed).is(m.Minor) ? m.Minor : (0, $29a0713b257db71e$export$6cdc1cb9345ffadf).is(m.Minor) ? $24a1c1ffbf73ec6a$var$getMinorFromAngleMajor(m.Minor, m.Major) : {
        Minor: 0
    };
const $24a1c1ffbf73ec6a$var$getMinorFromAngleMajor = (angle, major)=>({
        Minor: (0, $29a0713b257db71e$export$4b793e9421eec011).is(major) ? major.Major * $0afff5a8d5fc1877$export$fcdd3b0b3246a325(angle.Angle) : (0, $29a0713b257db71e$export$7c58e9b1273798cb).is(major) ? major.Mag * $0afff5a8d5fc1877$export$5de3937cb4b592ed(angle.Angle) : 0
    });
const $24a1c1ffbf73ec6a$export$7488d395d2b6c9ad = (0, $kisy7.Lens).fromProp()('Angle');
const $24a1c1ffbf73ec6a$export$48495abd2e55b326 = ()=>new (0, $kisy7.Lens)($24a1c1ffbf73ec6a$var$getAngle, (a)=>(m)=>({
                ...m,
                Minor: a
            }));
const $24a1c1ffbf73ec6a$var$getAngle = (m)=>(0, $29a0713b257db71e$export$6cdc1cb9345ffadf).is(m.Minor) ? m.Minor : (0, $29a0713b257db71e$export$2289e9b7d91d85ed).is(m.Minor) ? $24a1c1ffbf73ec6a$var$getAngleFromMinorMajor(m.Minor.Minor, m.Major) : {
        Angle: 0
    };
const $24a1c1ffbf73ec6a$var$getAngleFromMinorMajor = (minor, major)=>({
        Angle: (0, $29a0713b257db71e$export$4b793e9421eec011).is(major) ? $0afff5a8d5fc1877$export$628dc4eed22b0fbd(minor / major.Major) : (0, $29a0713b257db71e$export$7c58e9b1273798cb).is(major) ? $0afff5a8d5fc1877$export$41726bdb1fc63f(minor / major.Mag) : 0
    });
const $24a1c1ffbf73ec6a$export$56f5d6e97ec6d267 = ()=>(0, $kisy7.Lens).fromNullableProp()('MajorPri', 0);
const $24a1c1ffbf73ec6a$export$318fb53fd74078b1 = ()=>(0, $kisy7.Lens).fromNullableProp()('MinorPri', 0);
const $24a1c1ffbf73ec6a$export$ca8573e762c22a4a = ()=>(0, $kisy7.Lens).fromProp()('Curvature');
const $24a1c1ffbf73ec6a$export$33854bd4069f2975 = new (0, $kisy7.Prism)((s)=>(0, $29a0713b257db71e$export$e3aa8e6f6be594b2).is(s) ? $hBXBN.some(s) : $hBXBN.none, (a)=>a);
const $24a1c1ffbf73ec6a$export$a68afe694dce1e5f = ()=>$24a1c1ffbf73ec6a$export$ca8573e762c22a4a().composePrism($24a1c1ffbf73ec6a$export$33854bd4069f2975);
const $24a1c1ffbf73ec6a$export$bb8ae3e95e780206 = new (0, $kisy7.Lens)((s)=>(0, $29a0713b257db71e$export$851b30bb93ac5d3e).is(s) ? s.Deflection : s.Deflection, (a)=>(s)=>(0, $29a0713b257db71e$export$851b30bb93ac5d3e).is(s) ? {
            type: 'Circular',
            Deflection: a
        } : {
            type: 'Sinusoidal',
            Deflection: a
        });
const $24a1c1ffbf73ec6a$export$c7133ab33cb183d1 = ()=>(0, $kisy7.Lens).fromProp()('Major');
const $24a1c1ffbf73ec6a$export$b65c007c1e3a96bd = ()=>(0, $kisy7.Lens).fromProp()('Minor');
const $24a1c1ffbf73ec6a$export$c2dbfe937271b7c9 = new (0, $kisy7.Prism)((s)=>(0, $29a0713b257db71e$export$6a3d31f6eb68b04).is(s) ? $hBXBN.some(s) : $hBXBN.none, (a)=>a);
const $24a1c1ffbf73ec6a$export$fb23277430a92f0b = ()=>$24a1c1ffbf73ec6a$export$b65c007c1e3a96bd().compose((0, $1379b6c01f560d41$export$bf4ccabcbd35b59a)({
        Minor: 0
    }));
const $24a1c1ffbf73ec6a$export$7b9966c43d6cd366 = ()=>(0, $kisy7.Lens).fromNullableProp()('MajorPri', 0);
const $24a1c1ffbf73ec6a$export$7b78e7c08fc28a8d = ()=>(0, $kisy7.Lens).fromNullableProp()('MinorPri', 0);
const $24a1c1ffbf73ec6a$export$eedf77da96dc18fd = new (0, $kisy7.Optional)((s)=>(0, $29a0713b257db71e$export$4b793e9421eec011).is(s) ? $hBXBN.some(s) : $hBXBN.none, (a)=>(_)=>a);
const $24a1c1ffbf73ec6a$export$49e492a77b2432d2 = new (0, $kisy7.Optional)((s)=>(0, $29a0713b257db71e$export$7c58e9b1273798cb).is(s) ? $hBXBN.some(s) : $hBXBN.none, (a)=>(_)=>a);
const $24a1c1ffbf73ec6a$export$b4a9ef5e6a6a374b = new (0, $kisy7.Optional)((s)=>(0, $29a0713b257db71e$export$2289e9b7d91d85ed).is(s) ? $hBXBN.some(s) : $hBXBN.none, (a)=>(_)=>a);
const $24a1c1ffbf73ec6a$export$74df88334df32eb = new (0, $kisy7.Optional)((s)=>(0, $29a0713b257db71e$export$6cdc1cb9345ffadf).is(s) ? $hBXBN.some(s) : $hBXBN.none, (a)=>(_)=>a);
const $24a1c1ffbf73ec6a$export$b65cefd51408839e = new (0, $kisy7.Lens)((s)=>(0, $29a0713b257db71e$export$2289e9b7d91d85ed).is(s) ? s.Minor : s.Angle, (a)=>(s)=>(0, $29a0713b257db71e$export$2289e9b7d91d85ed).is(s) ? {
            Minor: a
        } : {
            Angle: a
        });
const $24a1c1ffbf73ec6a$export$1f745ac5de3c6f65 = new (0, $kisy7.Lens)((s)=>(0, $29a0713b257db71e$export$4b793e9421eec011).is(s) ? s.Major : s.Mag, (a)=>(s)=>(0, $29a0713b257db71e$export$4b793e9421eec011).is(s) ? {
            Major: a
        } : {
            Mag: a
        });



const $7cd1993fbd4e2816$export$55ddb4f38f3e3471 = $b649ba990a31d3d2$export$55ddb4f38f3e3471();
const $7cd1993fbd4e2816$export$f331b00682592a13 = (0, $kisy7.Lens).fromProp()('Left');
const $7cd1993fbd4e2816$export$399a1bfe5b91ffeb = (section, division)=>$b649ba990a31d3d2$export$55ddb4f38f3e3471().asOptional().compose($b649ba990a31d3d2$export$9a9688b7050d170c(section)).compose($7cd1993fbd4e2816$export$a17ff4db1a9492cf.asOptional()).compose((0, $4264ed72b222fae4$export$2b09f9e2ab3d9b0b)(division));
const $7cd1993fbd4e2816$export$a17ff4db1a9492cf = $b649ba990a31d3d2$export$16295f510e35177d().compose((0, $4264ed72b222fae4$export$db1a5e286b0fec91));
const $7cd1993fbd4e2816$export$610f62c7aa3089e1 = (0, $kisy7.Lens).fromProp()('Angle');
const $7cd1993fbd4e2816$export$22b201a4321decb4 = (0, $kisy7.Lens).fromProp()('Ceiling');
const $7cd1993fbd4e2816$export$fa51e980dce07996 = (0, $kisy7.Lens).fromProp()('Floor');
const $7cd1993fbd4e2816$export$6235ff76db6ce16b = (0, $kisy7.Lens).fromProp()('Right');
const $7cd1993fbd4e2816$export$e55a2abedcf0ccb2 = (i)=>$7cd1993fbd4e2816$export$d6944a878584a5be(i).composeLens((0, $24a1c1ffbf73ec6a$export$f19dd2c890563e4e)());
const $7cd1993fbd4e2816$export$1b048a032ffa75f1 = (i)=>$7cd1993fbd4e2816$export$d6944a878584a5be(i).composeLens((0, $24a1c1ffbf73ec6a$export$a8e06f16a42ea0c0)());
const $7cd1993fbd4e2816$export$d6944a878584a5be = (i)=>$7cd1993fbd4e2816$export$dc9bbc5f653d95c5(i).composeLens($7cd1993fbd4e2816$export$64d0857fae0810a());
const $7cd1993fbd4e2816$export$b507c067f87a1ee3 = (i)=>(0, $b24b46566310b44c$exports.indexArray)().index(i);
const $7cd1993fbd4e2816$export$64d0857fae0810a = ()=>(0, $kisy7.Lens).fromProp()('Measure');
const $7cd1993fbd4e2816$export$69b7b3d0e7041036 = ()=>(0, $kisy7.Lens).fromProp()('Direction');
const $7cd1993fbd4e2816$export$2bc3f6e4ecf71926 = ()=>$7cd1993fbd4e2816$export$64d0857fae0810a().compose($7cd1993fbd4e2816$export$69b7b3d0e7041036());
const $7cd1993fbd4e2816$export$9f7b78c3cf25ccc0 = ()=>(0, $kisy7.Lens).fromNullableProp()('Bredth', {
        Direction: 'in',
        Major: {
            Major: 0
        },
        Minor: {
            Minor: 0
        }
    });
const $7cd1993fbd4e2816$export$9a9688b7050d170c = $b649ba990a31d3d2$export$9a9688b7050d170c;
const $7cd1993fbd4e2816$export$7fbf24f5b3ed34f2 = $b649ba990a31d3d2$export$7fbf24f5b3ed34f2;
const $7cd1993fbd4e2816$export$d6b22eef3a505f1e = $b649ba990a31d3d2$export$d6b22eef3a505f1e();
const $7cd1993fbd4e2816$export$b455f688a19f877e = $b649ba990a31d3d2$export$b455f688a19f877e();
const $7cd1993fbd4e2816$export$dc9bbc5f653d95c5 = (i)=>$7cd1993fbd4e2816$export$713f889793d36194().composeOptional($7cd1993fbd4e2816$export$b507c067f87a1ee3(i));
const $7cd1993fbd4e2816$export$713f889793d36194 = ()=>(0, $kisy7.Lens).fromProp()('Curbs');
const $7cd1993fbd4e2816$export$f0c8a0ba199d2458 = ()=>(0, $kisy7.Lens).fromNullableProp()('Bredth', {
        Direction: 'in',
        Major: {
            Major: 0
        },
        Minor: {
            Minor: 0
        }
    });
const $7cd1993fbd4e2816$export$3c6339f3d1c3afe = ()=>(0, $kisy7.Lens).fromNullableProp()('OuterHeight', 0);
const $7cd1993fbd4e2816$export$2b7df9035e85967e = ()=>(0, $kisy7.Lens).fromNullableProp()('Offset', {
        'Location': 'center',
        Offset: 0
    });
const $7cd1993fbd4e2816$export$5533399da1c0a4e9 = (0, $kisy7.Lens).fromNullableProp()('Offset', 0);
const $7cd1993fbd4e2816$export$906166a266b7aba6 = (0, $kisy7.Lens).fromNullableProp()('Location', 'center');
const $7cd1993fbd4e2816$export$d02f08a4d9289b25 = (direction)=>new (0, $kisy7.Lens)((a)=>{
        if (a === null) return {
            Direction: direction
        };
        return a;
    }, (a)=>(_s)=>a);
const $7cd1993fbd4e2816$export$542c4f0e3b6c4e9a = ()=>(0, $kisy7.Lens).fromNullableProp()('OuterHeight', 0);
const $7cd1993fbd4e2816$export$dff7844ca8741e9e = ()=>(0, $kisy7.Lens).fromNullableProp()('Offset', {
        Location: 'center',
        Offset: 0
    });
const $7cd1993fbd4e2816$export$182cfb6ee9f0ec10 = (0, $kisy7.Lens).fromProp()('Angle');
const $7cd1993fbd4e2816$export$1970e45fbd175d71 = (0, $kisy7.Lens).fromProp()('Angle');
const $7cd1993fbd4e2816$export$bded910e06efb486 = (0, $kisy7.Lens).fromProp()('Location');
const $7cd1993fbd4e2816$export$a8d54a49011fa91e = (0, $kisy7.Lens).fromProp()('Offset');
const $7cd1993fbd4e2816$export$db5c2c6cb5f889c9 = (0, $kisy7.Lens).fromProp()('Offset');
const $7cd1993fbd4e2816$export$755b4a2da66c7c53 = (0, $kisy7.Lens).fromProp()('Depth');
const $7cd1993fbd4e2816$export$b56d6dad1ac368cc = (0, $kisy7.Lens).fromProp()('Size');
const $7cd1993fbd4e2816$export$4bf33f1a29468b71 = (0, $kisy7.Lens).fromNullableProp()('Width', 1);
const $7cd1993fbd4e2816$export$f9c6394e850e155b = (0, $kisy7.Lens).fromNullableProp()('Description', '');
const $7cd1993fbd4e2816$export$1ddff3fb4c314189 = ()=>(0, $kisy7.Lens).fromNullableProp()('Anomalies', []);
const $7cd1993fbd4e2816$export$7f08c7dd77feeddf = $7cd1993fbd4e2816$export$f331b00682592a13.composeOptional($7cd1993fbd4e2816$export$e55a2abedcf0ccb2(0));
const $7cd1993fbd4e2816$export$5307e779122cdba3 = (sectionPath)=>$7cd1993fbd4e2816$export$55ddb4f38f3e3471.composeOptional($7cd1993fbd4e2816$export$7fbf24f5b3ed34f2(sectionPath));
const $7cd1993fbd4e2816$export$41825531c89a6885 = (sectionPath)=>$7cd1993fbd4e2816$export$5307e779122cdba3(sectionPath).composeLens($7cd1993fbd4e2816$export$b455f688a19f877e);
const $7cd1993fbd4e2816$export$dda7e91d312139d5 = (sectionPath)=>$7cd1993fbd4e2816$export$41825531c89a6885(sectionPath).compose((0, $37e4362694b22dd4$export$80bf7733f1207381)().asOptional()).composeLens($7cd1993fbd4e2816$export$6235ff76db6ce16b);
const $7cd1993fbd4e2816$export$fa92f5254c8d958e = (sectionPath)=>$7cd1993fbd4e2816$export$dda7e91d312139d5(sectionPath).composeOptional($7cd1993fbd4e2816$export$e55a2abedcf0ccb2(0));
const $7cd1993fbd4e2816$export$981b762a699bf121 = (sectionPath)=>$7cd1993fbd4e2816$export$55ddb4f38f3e3471.composeOptional($7cd1993fbd4e2816$export$9a9688b7050d170c(sectionPath)).composeLens($7cd1993fbd4e2816$export$fa51e980dce07996).composeOptional($7cd1993fbd4e2816$export$1b048a032ffa75f1(0));
const $7cd1993fbd4e2816$export$d17c71c4bf4a5c5f = (sectionPath)=>$7cd1993fbd4e2816$export$55ddb4f38f3e3471.composeOptional($7cd1993fbd4e2816$export$9a9688b7050d170c(sectionPath)).composeLens($7cd1993fbd4e2816$export$22b201a4321decb4).composeOptional($7cd1993fbd4e2816$export$1b048a032ffa75f1(0));
const $7cd1993fbd4e2816$export$4705361e940d7b1c = (sectionPath)=>$7cd1993fbd4e2816$export$5307e779122cdba3(sectionPath).composeLens($7cd1993fbd4e2816$export$d6b22eef3a505f1e).composeLens($7cd1993fbd4e2816$export$22b201a4321decb4);
const $7cd1993fbd4e2816$export$b3cabf50b3789f41 = (sectionPath)=>$7cd1993fbd4e2816$export$4705361e940d7b1c(sectionPath).composeLens($7cd1993fbd4e2816$export$713f889793d36194());
const $7cd1993fbd4e2816$export$faa3e63c9e26e74b = (sectionPath)=>$7cd1993fbd4e2816$export$5307e779122cdba3(sectionPath).composeLens($7cd1993fbd4e2816$export$d6b22eef3a505f1e).composeLens($7cd1993fbd4e2816$export$fa51e980dce07996);
const $7cd1993fbd4e2816$export$682a8673c220e1ba = (sectionPath)=>$7cd1993fbd4e2816$export$faa3e63c9e26e74b(sectionPath).composeLens($7cd1993fbd4e2816$export$713f889793d36194());
const $7cd1993fbd4e2816$export$4b914d875cce7f80 = (0, $kisy7.Lens).fromProp()('type');





var $fWUU5 = parcelRequire("fWUU5");

var $jmbk9 = parcelRequire("jmbk9");

var $5iM4u = parcelRequire("5iM4u");

var $4sfjE = parcelRequire("4sfjE");
const $859db0da13774873$export$26b3113b39d13706 = (optic, update)=>(f)=>update(optic.modify(f));
const $859db0da13774873$export$2db37b7a33042541 = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)($859db0da13774873$export$26b3113b39d13706);
const $859db0da13774873$export$a8a2d88d3f853ebe = (f, updater)=>(g)=>updater((x)=>f(g(x)));
const $859db0da13774873$export$214b7a7bebf20ecb = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)($859db0da13774873$export$a8a2d88d3f853ebe);
const $859db0da13774873$export$7824cc40e1e06c48 = (path)=>path.filter((e, i, a)=>(e == '0' || e == '1' || e == '2') && a[i - 1] == 'Rest').map((e)=>parseInt(e));
const $859db0da13774873$export$94cf03f7c51c3d2e = (opening)=>(cond)=>(x)=>{
            const flattened = (0, $3897a8a6f8a8857c$export$bffa455ba8c619a6)(opening);
            return cond(flattened[x]) ? (0, $hBXBN.some)(x) : (0, $hBXBN.none);
        };
const $859db0da13774873$export$63fd079925ff5900 = (x)=>x.includes('Right.Curbs.0.Measure.Major') || x.includes('Left.Curbs.0.Measure.Major') ? (0, $hBXBN.some)(x) : (0, $hBXBN.none);
const $859db0da13774873$export$5ce253e23cc41ef9 = (x)=>x.includes('Floor.Curbs.0.Measure.Minor') || x.includes('Ceiling.Curbs.0.Measure.Minor') ? (0, $hBXBN.some)(x) : (0, $hBXBN.none);
const $859db0da13774873$export$307c1e1f2812aff3 = (opening)=>(0, $3abDJ.pipe)(opening, (0, $3897a8a6f8a8857c$export$bffa455ba8c619a6), Object.keys, $4ZBbi.filterMap($859db0da13774873$export$63fd079925ff5900), $4ZBbi.filterMap($859db0da13774873$export$94cf03f7c51c3d2e(opening)((x)=>x === null)));
const $859db0da13774873$export$ef204fcad96329e0 = (opening)=>(0, $3abDJ.pipe)(opening, (0, $3897a8a6f8a8857c$export$bffa455ba8c619a6), Object.keys, $4ZBbi.filterMap($859db0da13774873$export$63fd079925ff5900), $4ZBbi.filterMap($859db0da13774873$export$94cf03f7c51c3d2e(opening)((x)=>(0, $3abDJ.pipe)((0, $hBXBN.some)(x), (0, $hBXBN.exists)((n)=>typeof n === 'number')))));
const $859db0da13774873$export$69d5cfade2a8c6e3 = (opening)=>(0, $3abDJ.pipe)(opening, (0, $3897a8a6f8a8857c$export$bffa455ba8c619a6), Object.keys, $4ZBbi.filterMap($859db0da13774873$export$5ce253e23cc41ef9), $4ZBbi.filterMap($859db0da13774873$export$94cf03f7c51c3d2e(opening)((x)=>x === null)));
const $859db0da13774873$export$bb227cc910b3196d = (opening)=>(0, $3abDJ.pipe)(opening, (0, $3897a8a6f8a8857c$export$bffa455ba8c619a6), Object.keys, $4ZBbi.filterMap($859db0da13774873$export$5ce253e23cc41ef9), $4ZBbi.filterMap($859db0da13774873$export$94cf03f7c51c3d2e(opening)((x)=>(0, $3abDJ.pipe)((0, $hBXBN.some)(x), (0, $hBXBN.exists)((n)=>typeof n === 'number')))));
const $859db0da13774873$export$99baaf1cd59c432a = (direction)=>(value)=>{
        switch(direction){
            case 'down':
            case 'left':
                return -value;
            case 'right':
            case 'up':
                return value;
        }
    };
/**
 * Gets the Major measurement, converting it to a
 * positive or negative value, depending on measurement direction.
 *
 *
 * Used to calculate missing value in vertical loop components
 *
 * @param m Measurement Object that is part of vertical opening loop
 * @returns number
 */ const $859db0da13774873$var$transformMajorVerticalValue = (m)=>(0, $3abDJ.pipe)((0, $24a1c1ffbf73ec6a$export$f19dd2c890563e4e)().composeLens((0, $24a1c1ffbf73ec6a$export$72683dc2d378b18d)).get(m), $859db0da13774873$export$99baaf1cd59c432a(m.Direction));
/**
 * Gets the Minor measurement, converting it to a
 * positive or negative value, depending on measurement direction.
 *
 *
 * Used to calculate missing value in vertical loop components
 *
 * @param m Measurement Object that is part of vertical opening loop
 * @returns number
 */ const $859db0da13774873$var$transformMinorVerticalValue = (m)=>(0, $3abDJ.pipe)((0, $24a1c1ffbf73ec6a$export$a8e06f16a42ea0c0)().composeLens((0, $24a1c1ffbf73ec6a$export$920ff3912d63136f)).get(m), $859db0da13774873$export$99baaf1cd59c432a(m.Direction));
const $859db0da13774873$export$5f7e2dc64dd560eb = (m)=>{
    switch(m.Direction){
        case 'down':
            return $859db0da13774873$var$transformMajorVerticalValue(m);
        case 'up':
            return $859db0da13774873$var$transformMajorVerticalValue(m);
        case 'left':
            return $859db0da13774873$var$transformMinorVerticalValue(m);
        case 'right':
            return $859db0da13774873$var$transformMinorVerticalValue(m);
    }
};
const $859db0da13774873$export$4a2b94a7d4a61db0 = (...args)=>[
        ...args
    ].map($859db0da13774873$export$5f7e2dc64dd560eb).reduce((a, b)=>a + b, 0);
const $859db0da13774873$export$1200a50d87d523c9 = (0, $3abDJ.flow)($859db0da13774873$export$4a2b94a7d4a61db0, Math.abs);
const $859db0da13774873$export$d62b3998ac4360f9 = (opening)=>(objPath)=>objPath.includes('Left') ? (0, $7cd1993fbd4e2816$export$f331b00682592a13).composeOptional((0, $7cd1993fbd4e2816$export$d6944a878584a5be)(0)).getOption(opening) : $hBXBN.none;
const $859db0da13774873$export$50de894af45a7450 = (opening)=>(objPath)=>objPath.includes('Right') ? (0, $7cd1993fbd4e2816$export$dda7e91d312139d5)($859db0da13774873$export$7824cc40e1e06c48(objPath.split('.'))).composeOptional((0, $7cd1993fbd4e2816$export$d6944a878584a5be)(0)).getOption(opening) : $hBXBN.none;
const $859db0da13774873$export$8e7cd42b1d159751 = (opening)=>(objPath)=>objPath.includes('Ceiling') ? (0, $7cd1993fbd4e2816$export$55ddb4f38f3e3471).composeOptional((0, $b649ba990a31d3d2$export$9a9688b7050d170c)($859db0da13774873$export$7824cc40e1e06c48(objPath.split('.')))).composeLens((0, $7cd1993fbd4e2816$export$fa51e980dce07996)).composeOptional((0, $7cd1993fbd4e2816$export$d6944a878584a5be)(0)).getOption(opening) : $hBXBN.none;
const $859db0da13774873$export$d78719457f347e = (opening)=>(objPath)=>objPath.includes('Ceiling') ? (0, $7cd1993fbd4e2816$export$55ddb4f38f3e3471).composeOptional((0, $b649ba990a31d3d2$export$9a9688b7050d170c)($859db0da13774873$export$7824cc40e1e06c48(objPath.split('.')))).composeLens((0, $7cd1993fbd4e2816$export$22b201a4321decb4)).composeOptional((0, $7cd1993fbd4e2816$export$d6944a878584a5be)(0)).getOption(opening) : $hBXBN.none;
const $859db0da13774873$export$faf55870cc26caba = (opening)=>(objectPaths)=>{
        const leftMeasurements = (0, $3abDJ.pipe)(objectPaths, $4ZBbi.map($859db0da13774873$export$d62b3998ac4360f9(opening)), $4ZBbi.compact);
        const rightMeasurements = (0, $3abDJ.pipe)(objectPaths, $4ZBbi.map($859db0da13774873$export$50de894af45a7450(opening)), $4ZBbi.compact);
        return $4ZBbi.concatW(leftMeasurements)(rightMeasurements);
    };
const $859db0da13774873$export$1e105740b5dab939 = (opening)=>(objectPaths)=>{
        const topMeasurements = (0, $3abDJ.pipe)(objectPaths, $4ZBbi.map($859db0da13774873$export$8e7cd42b1d159751(opening)), $4ZBbi.compact);
        const bottomMeasurements = (0, $3abDJ.pipe)(objectPaths, $4ZBbi.map($859db0da13774873$export$d78719457f347e(opening)), $4ZBbi.compact);
        return $4ZBbi.concatW(topMeasurements)(bottomMeasurements);
    };
const $859db0da13774873$export$cc8fdfd4c3714fec = (opening)=>{
    // Locked vertical component paths
    const lockedVerticalPaths = $859db0da13774873$export$ef204fcad96329e0(opening);
    // Vertical measurements
    const verticalComponents = $859db0da13774873$export$faf55870cc26caba(opening)(lockedVerticalPaths);
    // Locked horizontal component paths
    const lockedHorizontalPaths = $859db0da13774873$export$bb227cc910b3196d(opening);
    // Horizontal measurements
    const horizontalComponents = $859db0da13774873$export$1e105740b5dab939(opening)(lockedHorizontalPaths);
    return $859db0da13774873$export$1200a50d87d523c9(...verticalComponents, ...horizontalComponents);
};
const $859db0da13774873$export$2b11a78b8ccd10d4 = (ev)=>ev.target.value;
const $859db0da13774873$export$cb0d9aba43c3445a = (ev)=>ev.target.value;
const $859db0da13774873$var$optionIsEmptyString = (str)=>(0, $3abDJ.pipe)($hBXBN.some($5iM4u.isEmpty), $hBXBN.ap(str), $hBXBN.toUndefined);
const $859db0da13774873$export$e907cebc8d2b213b = (templateValue)=>(modValue)=>{
        if ($hBXBN.isNone(templateValue) && $hBXBN.isNone(modValue)) return false;
        if ($hBXBN.isSome(templateValue) && $hBXBN.isNone(modValue)) return false;
        if ($hBXBN.isNone(templateValue) && $hBXBN.isSome(modValue)) return true;
        if ($859db0da13774873$var$optionIsEmptyString(templateValue) && $859db0da13774873$var$optionIsEmptyString(modValue)) return false;
        if ($hBXBN.isSome(templateValue) && $859db0da13774873$var$optionIsEmptyString(modValue)) return false;
        if ($859db0da13774873$var$optionIsEmptyString(templateValue) && $hBXBN.isSome(modValue)) return false;
        if ($859db0da13774873$export$93d3907feb8a9f3(templateValue, modValue)) return false;
        return true;
    };
const $859db0da13774873$var$equalsZero = (y)=>$859db0da13774873$export$b8cc20c7346ec074($hBXBN.some(0), y);
const $859db0da13774873$export$6e7dd58ef09e0995 = (templateValue)=>(modValue)=>{
        if ($hBXBN.isSome(templateValue) && $hBXBN.isNone(modValue)) return false;
        if ($859db0da13774873$var$equalsZero(modValue)) return false;
        if ($859db0da13774873$export$b8cc20c7346ec074(templateValue, modValue)) return false;
        return true;
    };
const $859db0da13774873$export$995b48be52afb12a = (modified)=>modified ? 'Modified' : undefined;
const $859db0da13774873$export$af7888a0bb3446c8 = $fWUU5.sort($jmbk9.Ord);
const $859db0da13774873$var$slice = (i, xs, ys)=>xs.slice(0, i).concat(ys).concat(xs.slice(i, xs.length));
/**
 * Returns an Option of the curb direction
 * at the start of the stretch
 *
 * @param curbs Stretch of curbs
 * @returns Option<string>
 */ const $859db0da13774873$var$oStartingCurbDirection = (curbs)=>(0, $3abDJ.pipe)(curbs, $hBXBN.fromNullable, $hBXBN.map($4ZBbi.map((0, $7cd1993fbd4e2816$export$2bc3f6e4ecf71926)().get)), $hBXBN.chain($4ZBbi.head));
/**
 * Returns an Option of the curb direction
 * at the end of the stretch
 *
 * @param curbs Stretch of curbs
 * @returns Option<string>
 */ const $859db0da13774873$var$oEndingCurbDirection = (curbs)=>(0, $3abDJ.pipe)(curbs, $hBXBN.fromNullable, $hBXBN.map($4ZBbi.map((0, $7cd1993fbd4e2816$export$2bc3f6e4ecf71926)().get)), $hBXBN.chain($4ZBbi.last));
const $859db0da13774873$export$93d3907feb8a9f3 = $hBXBN.getEq($5iM4u.Eq).equals;
const $859db0da13774873$export$b8cc20c7346ec074 = $hBXBN.getEq($jmbk9.Eq).equals;
const $859db0da13774873$var$divideCurbMeasurementByTwo = ()=>(0, $7cd1993fbd4e2816$export$64d0857fae0810a)().compose((0, $24a1c1ffbf73ec6a$export$c7133ab33cb183d1)()).compose((0, $24a1c1ffbf73ec6a$export$1f745ac5de3c6f65)).modify((a)=>a / 2);
const $859db0da13774873$var$duplicateCurb = (idx)=>(x)=>(0, $3abDJ.pipe)(x, (a)=>(0, $7cd1993fbd4e2816$export$b507c067f87a1ee3)(idx).getOption(a), $hBXBN.map((0, $7cd1993fbd4e2816$export$1ddff3fb4c314189)().set([])), $hBXBN.chain((a)=>$4ZBbi.insertAt(idx + 1, a)(x)), $hBXBN.fold(()=>x, (a)=>a));
const $859db0da13774873$var$splitCurb = (idx)=>(0, $3abDJ.flow)($859db0da13774873$var$duplicateCurb(idx), (0, $7cd1993fbd4e2816$export$b507c067f87a1ee3)(idx).modify($859db0da13774873$var$divideCurbMeasurementByTwo()), (0, $7cd1993fbd4e2816$export$b507c067f87a1ee3)(idx + 1).modify($859db0da13774873$var$divideCurbMeasurementByTwo()));
const $859db0da13774873$export$e6dfa37982393983 = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(strechOptic)=>(curbsPath)=>(position)=>(directions)=>(placement = 'before')=>(value = {
                        type: 'Major'
                    })=>(amount)=>(opening)=>{
                                const major = value.type === 'Major' ? Math.abs(amount) : 200;
                                const minor = value.type === 'Minor' ? amount : 0;
                                const curbs = directions.map((direction)=>(0, $3ed4c97548491c68$export$c4287d255ec67471)(position)(direction)(major, minor));
                                const newCurbsPath = (0, $3abDJ.pipe)(curbsPath, $hBXBN.fromPredicate(()=>placement === 'after' || placement === 'split'), $hBXBN.fold(()=>curbsPath, (c)=>c + 1));
                                const stretchCurbs = $hBXBN.toNullable(strechOptic.getOption(opening));
                                if (stretchCurbs) switch(position){
                                    case 'Bottom':
                                        {
                                            if (placement === 'split') return strechOptic.modify($859db0da13774873$var$splitCurb(curbsPath))(opening);
                                            const newCurbs = $859db0da13774873$var$slice(newCurbsPath, stretchCurbs, curbs);
                                            const startIsUp = $859db0da13774873$export$93d3907feb8a9f3($859db0da13774873$var$oStartingCurbDirection(newCurbs), (0, $hBXBN.some)('up'));
                                            const endIsDown = $859db0da13774873$export$93d3907feb8a9f3($859db0da13774873$var$oEndingCurbDirection(newCurbs), (0, $hBXBN.some)('down'));
                                            return strechOptic.set(startIsUp || endIsDown ? stretchCurbs : newCurbs)(opening);
                                        }
                                    case 'Top':
                                        {
                                            if (placement === 'split') return strechOptic.modify($859db0da13774873$var$splitCurb(curbsPath))(opening);
                                            const newCurbs = $859db0da13774873$var$slice(newCurbsPath, stretchCurbs, curbs);
                                            const startIsDown = $859db0da13774873$export$93d3907feb8a9f3($859db0da13774873$var$oStartingCurbDirection(newCurbs), (0, $hBXBN.some)('down'));
                                            const endIsUp = $859db0da13774873$export$93d3907feb8a9f3($859db0da13774873$var$oEndingCurbDirection(newCurbs), (0, $hBXBN.some)('up'));
                                            return strechOptic.set(startIsDown || endIsUp ? stretchCurbs : $859db0da13774873$var$slice(newCurbsPath, stretchCurbs, curbs))(opening);
                                        }
                                    default:
                                        return strechOptic.set($859db0da13774873$var$slice(newCurbsPath, stretchCurbs, curbs))(opening);
                                }
                                // No op
                                return opening;
                            };
/**
 * Checks if curb array has a length greater than 1
 */ const $859db0da13774873$var$greaterThanOne = (curbs)=>curbs.length > 1;
/**
 * Checks if curb's direction is left or right
 */ const $859db0da13774873$var$isLeftOrRight = (c)=>(0, $7cd1993fbd4e2816$export$2bc3f6e4ecf71926)().get(c) === 'left' || (0, $7cd1993fbd4e2816$export$2bc3f6e4ecf71926)().get(c) === 'right';
/**
 * Checks if a ceiling curb has two left curbs or if a floor curb has two right curbs
 */ const $859db0da13774873$var$leavesOneInStretchDirection = (curbIndex)=>(curbs)=>(0, $3abDJ.pipe)(curbs, $4ZBbi.deleteAt(curbIndex), $hBXBN.chain($4ZBbi.findFirst($859db0da13774873$var$isLeftOrRight)), $hBXBN.isSome);
/**
 * Checks that removing a curb does not put a curb going up next to a curb going down
 */ const $859db0da13774873$var$adjacentNotInOppositeDirection = (curbIndex)=>(curbs)=>{
        const curb = $4ZBbi.lookup(curbIndex)(curbs);
        if (!$hBXBN.toNullable(curb)) return false;
        if (curbIndex === 0 || curbIndex === curbs.length - 1) return true;
        const curbBeforeDirection = (0, $3abDJ.pipe)(curbs, $4ZBbi.lookup(curbIndex - 1), $hBXBN.toNullable);
        if (!curbBeforeDirection) return false;
        const curbAfterDirection = (0, $3abDJ.pipe)(curbs, $4ZBbi.lookup(curbIndex + 1), $hBXBN.toNullable);
        if (!curbAfterDirection) return false;
        const adjacentDirections = [
            (0, $7cd1993fbd4e2816$export$2bc3f6e4ecf71926)().get(curbAfterDirection),
            (0, $7cd1993fbd4e2816$export$2bc3f6e4ecf71926)().get(curbBeforeDirection)
        ];
        return !(adjacentDirections.includes('up') && adjacentDirections.includes('down'));
    };
/**
 * Higher order function for validating if delete curb operation creates stretch with valid starting curb
 */ const $859db0da13774873$var$checkStartingCurb = (horizontalDirection)=>(verticalDirection)=>(curbIndex)=>(curbs)=>(0, $3abDJ.pipe)($4ZBbi.deleteAt(curbIndex)(curbs), $hBXBN.chain($hBXBN.fromPredicate($4ZBbi.some((d)=>$859db0da13774873$export$93d3907feb8a9f3((0, $hBXBN.some)((0, $7cd1993fbd4e2816$export$2bc3f6e4ecf71926)().get(d)), (0, $hBXBN.some)(horizontalDirection))))), $hBXBN.match(()=>true, (potentialNewStretch)=>!$859db0da13774873$export$93d3907feb8a9f3($859db0da13774873$var$oStartingCurbDirection(potentialNewStretch), (0, $hBXBN.some)(verticalDirection))));
/**
 * Higher order function for validating if delete curb operation creates stretch with valid ending curb
 */ const $859db0da13774873$var$checkEndingCurb = (horizontalDirection)=>(verticalDirection)=>(curbIndex)=>(curbs)=>(0, $3abDJ.pipe)($4ZBbi.deleteAt(curbIndex)(curbs), $hBXBN.chain($hBXBN.fromPredicate($4ZBbi.some((d)=>$859db0da13774873$export$93d3907feb8a9f3((0, $hBXBN.some)((0, $7cd1993fbd4e2816$export$2bc3f6e4ecf71926)().get(d)), (0, $hBXBN.some)(horizontalDirection))))), $hBXBN.match(()=>true, (potentialNewStretch)=>!$859db0da13774873$export$93d3907feb8a9f3($859db0da13774873$var$oEndingCurbDirection(potentialNewStretch), (0, $hBXBN.some)(verticalDirection))));
/**
 * Checks that removing a curb in the ceiling does not put a down curb at the start of the stretch.
 */ const $859db0da13774873$var$noDownwardAtStartOfCeiling = $859db0da13774873$var$checkStartingCurb('left')('down');
/**
 * Checks that removing a curb in the floor does not put an up curb at the start of the stretch.
 */ const $859db0da13774873$var$noUpwardAtStartOfFloor = $859db0da13774873$var$checkStartingCurb('right')('up');
/**
 * Checks that removing a curb in the ceiling does not put an up curb at the end of the stretch.
 */ const $859db0da13774873$var$noUpwardAtEndOfCeiling = $859db0da13774873$var$checkEndingCurb('left')('up');
/**
 * Checks that removing a curb in the floor does not put a down curb at the end of the stretch.
 */ const $859db0da13774873$var$noDownwardAtEndOfFloor = $859db0da13774873$var$checkEndingCurb('right')('down');
const $859db0da13774873$export$c34ffede45b96058 = (curbIndex)=>(curbs)=>{
        return (0, $3abDJ.pipe)(curbs, $hBXBN.fromNullable, $hBXBN.chain($hBXBN.fromPredicate($859db0da13774873$var$greaterThanOne)), $hBXBN.chain($hBXBN.fromPredicate($859db0da13774873$var$leavesOneInStretchDirection(curbIndex))), $hBXBN.chain($hBXBN.fromPredicate($859db0da13774873$var$adjacentNotInOppositeDirection(curbIndex))), $hBXBN.chain($hBXBN.fromPredicate($859db0da13774873$var$noDownwardAtStartOfCeiling(curbIndex))), $hBXBN.chain($hBXBN.fromPredicate($859db0da13774873$var$noUpwardAtStartOfFloor(curbIndex))), $hBXBN.chain($hBXBN.fromPredicate($859db0da13774873$var$noUpwardAtEndOfCeiling(curbIndex))), $hBXBN.chain($hBXBN.fromPredicate($859db0da13774873$var$noDownwardAtEndOfFloor(curbIndex))), $hBXBN.chain($4ZBbi.deleteAt(curbIndex)), $hBXBN.getOrElse((0, $3abDJ.constant)(curbs)));
    };
const $859db0da13774873$export$7cef9a0ddfdbfe95 = (opening)=>(sectionPath)=>(0, $3abDJ.pipe)(opening, (0, $7cd1993fbd4e2816$export$b3cabf50b3789f41)(sectionPath).getOption, $hBXBN.match(()=>0, (curbs)=>curbs.length));
const $859db0da13774873$export$7f18cc751d497f74 = (opening)=>(sectionPath)=>(0, $3abDJ.pipe)(opening, (0, $7cd1993fbd4e2816$export$682a8673c220e1ba)(sectionPath).getOption, $hBXBN.match(()=>0, (curbs)=>curbs.length));
const $859db0da13774873$export$bcf5aed4f605ca0b = (curbLength)=>(index)=>[
            0,
            curbLength - 1
        ].includes(index);
const $859db0da13774873$export$48335093a6a587c5 = (path)=>(stretchLength)=>(curbPath)=>{
            const isCeiling = path.includes('Ceiling');
            if (isCeiling) return stretchLength - 1 - curbPath;
            return curbPath;
        };
const $859db0da13774873$export$329748c2c017309e = ()=>0;
const $859db0da13774873$export$f54c5d255b7aebea = (a)=>{
    if (a.includes('Left-Curbs-0-Measure')) return 'Joint-0-box';
    if ($4ZBbi.some((x)=>a.includes(x))([
        'Angle',
        'Ceiling',
        'Floor',
        'Corner',
        'Curbs'
    ])) {
        // Split to Right
        const s = a.split('-');
        // Find index of right
        const i = s.findIndex((v)=>v === 'Right');
        // Slice on right
        if (i > -1) {
            const upToRight = s.slice(0, i + 1);
            return upToRight.join('-');
        } else {
            // No Right value
            const altI = s.findIndex((v)=>v === 'Ceiling' || v === 'Floor');
            // Slice on value
            const upToIndicator = s.slice(0, altI);
            return upToIndicator.join('-') + '-Joint-0-box';
        }
    }
    return a;
};
const $859db0da13774873$export$3b84eb83553bd4f6 = (oneOrThree)=>{
    return (0, $3abDJ.pipe)('Right' in oneOrThree ? $hBXBN.none : $hBXBN.some(oneOrThree), $hBXBN.foldW(()=>[
            (0, $3ed4c97548491c68$export$65617b430e4b9024).encode(0)
        ], (tree)=>(0, $3abDJ.pipe)(tree, (a)=>a.length, $hBXBN.fromPredicate((0, $3ed4c97548491c68$export$65617b430e4b9024).is), $hBXBN.foldW(()=>null, (a)=>{
            return [
                (0, $3ed4c97548491c68$export$65617b430e4b9024).encode(a)
            ];
        }))));
};
const $859db0da13774873$export$54ec779613319349 = (step)=>(isJoint)=>isJoint ? step.slice(0, -1) : step;
const $859db0da13774873$export$a55705775057cc10 = (path)=>{
    const i = path.indexOf('Curbs');
    const next = path[i + 1];
    if (next === undefined) return -1;
    const nextI = parseInt(next);
    if (Number.isInteger(nextI)) return nextI;
    return -1;
};
const $859db0da13774873$export$d46ff510f7ea94a5 = (0, $4sfjE.sequenceT)($hBXBN.Applicative);




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4FZD0 = parcelRequire("4FZD0");

var $8Indx = parcelRequire("8Indx");

var $cpmCj = parcelRequire("cpmCj");

var $1jJMI = parcelRequire("1jJMI");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $e0579d99723e0dfe$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $1jJMI.default)(value, min, max);
}
function $e0579d99723e0dfe$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $e0579d99723e0dfe$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $e0579d99723e0dfe$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $e0579d99723e0dfe$export$677b39864803984e($e0579d99723e0dfe$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $cpmCj.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $cpmCj.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $e0579d99723e0dfe$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $e0579d99723e0dfe$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const $e0579d99723e0dfe$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $e0579d99723e0dfe$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $e0579d99723e0dfe$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $e0579d99723e0dfe$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $e0579d99723e0dfe$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$e0579d99723e0dfe$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $e0579d99723e0dfe$export$29fb7152bd3f781a(color) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $e0579d99723e0dfe$export$c852d90bf7403b62(color) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $e0579d99723e0dfe$export$677b39864803984e($e0579d99723e0dfe$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $e0579d99723e0dfe$export$d061e26956a60b0a(foreground, background) {
    const lumA = $e0579d99723e0dfe$export$c852d90bf7403b62(foreground);
    const lumB = $e0579d99723e0dfe$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $e0579d99723e0dfe$export$58f0f39f63f3cf42(color, value) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    value = $e0579d99723e0dfe$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $e0579d99723e0dfe$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    coefficient = $e0579d99723e0dfe$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    coefficient = $e0579d99723e0dfe$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e0579d99723e0dfe$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $e0579d99723e0dfe$export$c852d90bf7403b62(color) > 0.5 ? $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient) : $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient);
}
function $e0579d99723e0dfe$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $e0579d99723e0dfe$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e0579d99723e0dfe$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $e0579d99723e0dfe$export$677b39864803984e(background);
    const overlayColor = $e0579d99723e0dfe$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}




var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $254a3802f36599bb$export$21f89b560b65a301(slot) {
    return (0, $4Cod0.default)('MuiToggleButton', slot);
}
const $254a3802f36599bb$var$toggleButtonClasses = (0, $beCSm.default)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
var $254a3802f36599bb$export$2e2bcd8739ae039 = $254a3802f36599bb$var$toggleButtonClasses;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $fe0e5fe90030f3ad$var$ToggleButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $fe0e5fe90030f3ad$export$2e2bcd8739ae039 = $fe0e5fe90030f3ad$var$ToggleButtonGroupContext;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $e49d517bbbfb7eee$export$2e2bcd8739ae039 = $e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext;


// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $9775671ab3ebd2db$export$2e2bcd8739ae039(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.indexOf(value) >= 0;
    return value === candidate;
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ab85d69438d76ec5$var$_excluded = [
    "value"
], $ab85d69438d76ec5$var$_excluded2 = [
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "onChange",
    "onClick",
    "selected",
    "size",
    "value"
];
const $ab85d69438d76ec5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fullWidth: fullWidth, selected: selected, disabled: disabled, size: size, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            `size${(0, $jTnBY.default)(size)}`,
            color
        ]
    };
    return (0, $8Indx.default)(slots, (0, $254a3802f36599bb$export$21f89b560b65a301), classes);
};
const $ab85d69438d76ec5$var$ToggleButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    let selectedColor = ownerState.color === 'standard' ? theme.palette.text.primary : theme.palette[ownerState.color].main;
    let selectedColorChannel;
    if (theme.vars) {
        selectedColor = ownerState.color === 'standard' ? theme.vars.palette.text.primary : theme.vars.palette[ownerState.color].main;
        selectedColorChannel = ownerState.color === 'standard' ? theme.vars.palette.text.primaryChannel : theme.vars.palette[ownerState.color].mainChannel;
    }
    return (0, $8nd05.default)({}, theme.typography.button, {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active
    }, ownerState.fullWidth && {
        width: '100%'
    }, {
        [`&.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $e0579d99723e0dfe$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).selected}`]: {
            color: selectedColor,
            backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $e0579d99723e0dfe$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $e0579d99723e0dfe$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $e0579d99723e0dfe$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity)
                }
            }
        }
    }, ownerState.size === 'small' && {
        padding: 7,
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && {
        padding: 15,
        fontSize: theme.typography.pxToRem(15)
    });
});
const $ab85d69438d76ec5$var$ToggleButton = /*#__PURE__*/ $acw62.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const _React$useContext = $acw62.useContext((0, $fe0e5fe90030f3ad$export$2e2bcd8739ae039)), { value: contextValue } = _React$useContext, contextProps = (0, $1En50.default)(_React$useContext, $ab85d69438d76ec5$var$_excluded);
    const toggleButtonGroupButtonContextPositionClassName = $acw62.useContext((0, $e49d517bbbfb7eee$export$2e2bcd8739ae039));
    const resolvedProps = (0, $4FZD0.default)((0, $8nd05.default)({}, contextProps, {
        selected: (0, $9775671ab3ebd2db$export$2e2bcd8739ae039)(inProps.value, contextValue)
    }), inProps);
    const props = (0, $1iOpW.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: fullWidth = false, onChange: onChange, onClick: onClick, selected: selected, size: size = 'medium', value: value } = props, other = (0, $1En50.default)(props, $ab85d69438d76ec5$var$_excluded2);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    });
    const classes = $ab85d69438d76ec5$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ab85d69438d76ec5$var$ToggleButtonRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected
    }, other, {
        children: children
    }));
});
var $ab85d69438d76ec5$export$2e2bcd8739ae039 = $ab85d69438d76ec5$var$ToggleButton;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");
function $9b0e6fd5d31b1b95$export$2e2bcd8739ae039(children) {
    return $acw62.Children.toArray(children).filter((child)=>/*#__PURE__*/ $acw62.isValidElement(child));
}



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d382e18949ecbd32$export$44aa3ae5b353cef1(slot) {
    return (0, $4Cod0.default)('MuiToggleButtonGroup', slot);
}
const $d382e18949ecbd32$var$toggleButtonGroupClasses = (0, $beCSm.default)('MuiToggleButtonGroup', [
    'root',
    'selected',
    'horizontal',
    'vertical',
    'disabled',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'fullWidth',
    'firstButton',
    'lastButton',
    'middleButton'
]);
var $d382e18949ecbd32$export$2e2bcd8739ae039 = $d382e18949ecbd32$var$toggleButtonGroupClasses;






var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7479184c3cda7f5d$var$_excluded = [
    "children",
    "className",
    "color",
    "disabled",
    "exclusive",
    "fullWidth",
    "onChange",
    "orientation",
    "size",
    "value"
];
const $7479184c3cda7f5d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, fullWidth: fullWidth, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation === 'vertical' && 'vertical',
            fullWidth && 'fullWidth'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $jTnBY.default)(orientation)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d382e18949ecbd32$export$44aa3ae5b353cef1), classes);
};
const $7479184c3cda7f5d$var$ToggleButtonGroupRoot = (0, $d8seH.default)('div', {
    name: 'MuiToggleButtonGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}`]: styles.grouped
            },
            {
                [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.orientation)}`]
            },
            {
                [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
            },
            {
                [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
            },
            {
                [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.orientation === 'vertical' && {
        flexDirection: 'column'
    }, ownerState.fullWidth && {
        width: '100%'
    }, {
        [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}`]: (0, $8nd05.default)({}, ownerState.orientation === 'horizontal' ? {
            [`&.${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).selected} + .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}.${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).selected}`]: {
                borderLeft: 0,
                marginLeft: 0
            }
        } : {
            [`&.${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).selected} + .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}.${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).selected}`]: {
                borderTop: 0,
                marginTop: 0
            }
        })
    }, ownerState.orientation === 'horizontal' ? {
        [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).firstButton},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}`]: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).lastButton},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}`]: {
            marginLeft: -1,
            borderLeft: '1px solid transparent',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }
    } : {
        [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).firstButton},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}`]: {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).lastButton},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}`]: {
            marginTop: -1,
            borderTop: '1px solid transparent',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }
    }, ownerState.orientation === 'horizontal' ? {
        [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).lastButton}.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).disabled},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).disabled}`]: {
            borderLeft: '1px solid transparent'
        }
    } : {
        [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).lastButton}.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).disabled},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).disabled}`]: {
            borderTop: '1px solid transparent'
        }
    }));
const $7479184c3cda7f5d$var$ToggleButtonGroup = /*#__PURE__*/ $acw62.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiToggleButtonGroup'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, exclusive: exclusive = false, fullWidth: fullWidth = false, onChange: onChange, orientation: orientation = 'horizontal', size: size = 'medium', value: value } = props, other = (0, $1En50.default)(props, $7479184c3cda7f5d$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size
    });
    const classes = $7479184c3cda7f5d$var$useUtilityClasses(ownerState);
    const handleChange = $acw62.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = $acw62.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = $acw62.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value: value,
            size: size,
            fullWidth: fullWidth,
            color: color,
            disabled: disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, $9b0e6fd5d31b1b95$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7479184c3cda7f5d$var$ToggleButtonGroupRoot, (0, $8nd05.default)({
        role: "group",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fe0e5fe90030f3ad$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e49d517bbbfb7eee$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
var $7479184c3cda7f5d$export$2e2bcd8739ae039 = $7479184c3cda7f5d$var$ToggleButtonGroup;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $bOOlK = parcelRequire("bOOlK");

var $9dZwz = parcelRequire("9dZwz");
var $hcz0Q = parcelRequire("hcz0Q");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $b85125360b778ad2$var$_excluded = [
    "className",
    "component"
];
function $b85125360b778ad2$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $bOOlK.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $9dZwz.default));
    const Box = /*#__PURE__*/ $acw62.forwardRef(function Box(inProps, ref) {
        const theme = (0, $59c0686cf27fa016$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $hcz0Q.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $1En50.default)(_extendSxProp, $b85125360b778ad2$var$_excluded);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, (0, $8nd05.default)({
            as: component,
            ref: ref,
            className: (0, $9QePP.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $bnost = parcelRequire("bnost");

var $ijOKP = parcelRequire("ijOKP");

var $4jPsi = parcelRequire("4jPsi");

var $beCSm = parcelRequire("beCSm");
const $cf808af3a1d339c9$var$boxClasses = (0, $beCSm.default)('MuiBox', [
    'root'
]);
var $cf808af3a1d339c9$export$2e2bcd8739ae039 = $cf808af3a1d339c9$var$boxClasses;


'use client';
const $00a20d475386f68c$var$defaultTheme = (0, $ijOKP.default)();
const $00a20d475386f68c$var$Box = (0, $b85125360b778ad2$export$2e2bcd8739ae039)({
    themeId: (0, $4jPsi.default),
    defaultTheme: $00a20d475386f68c$var$defaultTheme,
    defaultClassName: (0, $cf808af3a1d339c9$export$2e2bcd8739ae039).root,
    generateClassName: (0, $bnost.default).generate
});
var $00a20d475386f68c$export$2e2bcd8739ae039 = $00a20d475386f68c$var$Box;



var $d8seH = parcelRequire("d8seH");
const $eec4876afb001649$var$StyledToggleButtonGroup = (0, $d8seH.default)((0, $7479184c3cda7f5d$export$2e2bcd8739ae039))(({ theme: theme })=>({
        '& .MuiButtonBase-root': {
            height: 40,
            '&.MuiToggleButton-sizeMedium': {
                height: 56
            },
            '&.Mui-selected': {
                color: theme.vars.palette.action.active,
                backgroundColor: theme.vars.palette.app?.active,
                fontWeight: 600,
                borderLeft: `1px solid ${theme.vars.palette.app?.choreBorder} !important`,
                '&:not(:first-of-type)': {
                    marginLeft: '-1px !important'
                },
                '&:hover': {
                    borderLeftColor: `${theme.vars.palette.app?.border} !important`
                }
            },
            '&:first-of-type': {
                borderTopLeftRadius: 6,
                borderBottomLeftRadius: 6
            },
            '&:last-of-type': {
                borderTopRightRadius: 6,
                borderBottomRightRadius: 6
            }
        },
        '&.divided .MuiButtonBase-root.Mui-selected': {
            color: theme.vars.palette.app?.light,
            backgroundColor: theme.vars.palette.background.default,
            fontWeight: 400
        },
        '&.divided .MuiButtonBase-root:not(:first-of-type)': {
            borderLeftColor: 'transparent !important',
            position: 'relative',
            '&:before': {
                content: '""',
                position: 'absolute',
                left: '-1px',
                height: 'calc(100% - 12px)',
                width: '1px',
                backgroundColor: theme.vars.palette.app?.border
            }
        },
        '&.divided .MuiButtonBase-root:not(:last-of-type)': {
            borderRightColor: 'transparent !important',
            position: 'relative',
            '&:before': {
                content: '""',
                position: 'absolute',
                right: '-1px',
                height: 'calc(100% - 12px)',
                width: '1px',
                backgroundColor: theme.vars.palette.app?.border
            }
        }
    }));
const $eec4876afb001649$var$QButtonGroupLabel = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039))(({ theme: theme })=>({
        background: theme.vars.palette.background.default,
        position: 'absolute',
        top: '-9px',
        fontSize: '12px',
        color: theme.vars.palette.app?.light,
        zIndex: 9
    }));
const $eec4876afb001649$var$QButtonGroup = (ps)=>{
    const [value, setValue] = $acw62.useState(ps.value);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "inline-flex",
        alignItems: "center",
        flexDirection: "column",
        position: "relative",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($eec4876afb001649$var$QButtonGroupLabel, {
                pr: 1,
                pl: 1,
                children: (ps.label ?? {})[ps.lang ?? 'eng']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($eec4876afb001649$var$StyledToggleButtonGroup, {
                value: value,
                size: ps.size,
                className: ps.divider ? 'divided' : '',
                exclusive: !Array.isArray(value),
                onChange: (_, v)=>{
                    setValue(v);
                    ps.update && ps.update(()=>v);
                },
                children: ps.items.map((item, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                        value: item.key ?? '',
                        onClick: ()=>item.update && item.update(()=>!(Array.isArray(value) ? value.indexOf(item.key) > -1 : value === item.key)),
                        children: [
                            item.names[ps.lang ?? 'eng'],
                            item.icon
                        ]
                    }, i))
            })
        ]
    });
};
var $eec4876afb001649$export$2e2bcd8739ae039 = $eec4876afb001649$var$QButtonGroup;


const $12648447b9c23b90$export$c7c44baae9d9f25f = (ps)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($12648447b9c23b90$export$9787cd7a227de46b, {
                mode: ps.mode,
                onOpeningModeChange: ps.onOpeningModeChange
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($12648447b9c23b90$var$ProjectionControl, {
                projection: ps.projection,
                onProjectionChange: ps.onProjectionChange
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($12648447b9c23b90$export$5f49873043849529, {
                lengthUnit: ps.lengthUnit,
                onLengthUnitChange: ps.onLengthUnitChange
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($12648447b9c23b90$export$394a0c49a20b4378, {
                angleLocation: ps.angleLocation,
                onAngleLocationChange: ps.onAngleLocationChange
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {
                orientation: "vertical",
                variant: "middle",
                sx: {
                    margin: '12px 0'
                },
                flexItem: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($12648447b9c23b90$export$f2500353cb92e6ec, {
                onUndo: ps.onUndo
            })
        ]
    });
const $12648447b9c23b90$var$projectionTransList = [
    {
        key: 'Flat',
        names: {
            eng: 'Flat'
        }
    },
    {
        key: 'FloorPlan',
        names: {
            eng: 'FloorPlan'
        }
    },
    {
        key: 'Isometric',
        names: {
            eng: 'Isometric'
        }
    }
];
const $12648447b9c23b90$var$ProjectionControl = ({ projection: projection, onProjectionChange: onProjectionChange })=>{
    const handleRotationChange = (amount)=>onProjectionChange((prev)=>prev.type === 'Isometric' ? {
                ...prev,
                Rotate: (prev.Rotate || 0) + amount
            } : prev);
    const rotateTransList = [
        {
            key: 'Left',
            names: {},
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b0e556da8a0e80f9$exports))), {}),
            update: ()=>handleRotationChange(15)
        },
        {
            key: 'Right',
            names: {},
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($204e25e6fe5291f6$exports))), {}),
            update: ()=>handleRotationChange(-15)
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            projection.type !== 'Isometric' ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eec4876afb001649$export$2e2bcd8739ae039), {
                    lang: "eng",
                    size: "small",
                    divider: true,
                    label: {
                        eng: 'Rotate'
                    },
                    items: rotateTransList
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$2e2bcd8739ae039), {
                    size: "small",
                    id: "projection",
                    value: projection.type,
                    label: {
                        eng: 'View Mode'
                    },
                    items: $12648447b9c23b90$var$projectionTransList,
                    update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$4b914d875cce7f80), onProjectionChange)
                })
            })
        ]
    });
};
const $12648447b9c23b90$var$lengthUnitTransList = [
    {
        key: 'inch',
        names: {
            eng: 'inch'
        }
    },
    {
        key: 'mm',
        names: {
            eng: 'mm'
        }
    }
];
const $12648447b9c23b90$var$angleTransList = [
    {
        key: 'interior',
        names: {
            eng: 'interior'
        }
    },
    {
        key: 'exterior',
        names: {
            eng: 'exterior'
        }
    }
];
const $12648447b9c23b90$export$5f49873043849529 = (ps)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$2e2bcd8739ae039), {
            size: "small",
            value: ps.lengthUnit,
            label: {
                eng: 'Unit'
            },
            items: $12648447b9c23b90$var$lengthUnitTransList,
            update: ps.onLengthUnitChange
        })
    });
const $12648447b9c23b90$export$394a0c49a20b4378 = (ps)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$2e2bcd8739ae039), {
            size: "small",
            id: "control-angle-location-label",
            value: ps.angleLocation,
            label: {
                eng: 'Angles'
            },
            items: $12648447b9c23b90$var$angleTransList,
            update: ps.onAngleLocationChange
        })
    });
const $12648447b9c23b90$export$9787cd7a227de46b = (ps)=>{
    const modeTransList = [
        {
            key: 'Wall',
            names: {
                eng: 'Wall'
            },
            update: ()=>ps.onOpeningModeChange(()=>'Wall')
        },
        {
            key: 'Panel',
            names: {
                eng: 'Panel'
            },
            update: ()=>ps.onOpeningModeChange(()=>'Panel')
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eec4876afb001649$export$2e2bcd8739ae039), {
            lang: "eng",
            size: "small",
            items: modeTransList,
            value: ps.mode
        })
    });
};
const $12648447b9c23b90$export$f2500353cb92e6ec = (ps)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
        variant: "outlined",
        onClick: ()=>ps.onUndo(),
        sx: {
            margin: '12px 10px',
            fontSize: '16px',
            textTransform: 'none'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($611927cd5409b9fd$exports))), {
                sx: {
                    marginRight: '8px'
                }
            }),
            "Undo"
        ]
    });
var $12648447b9c23b90$export$2e2bcd8739ae039 = $12648447b9c23b90$var$ProjectionControl;


/**
 * Generic file importer.
 *
 * @since 0.4.0
 */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

/**
 * Generic file uploader.
 *
 * @since 0.4.0
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");




var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");





'use client';
var $4105219ee6538ed1$export$2e2bcd8739ae039 = (0, $7a3a319e7e555608$export$2e2bcd8739ae039);





var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $add5737403c6a16a$export$837848f5f6cee923(slot) {
    return (0, $4Cod0.default)('MuiTooltip', slot);
}
const $add5737403c6a16a$var$tooltipClasses = (0, $beCSm.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $add5737403c6a16a$export$2e2bcd8739ae039 = $add5737403c6a16a$var$tooltipClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $96a8b4f445fd9172$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $96a8b4f445fd9172$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $96a8b4f445fd9172$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $jTnBY.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $add5737403c6a16a$export$837848f5f6cee923), classes);
};
const $96a8b4f445fd9172$var$TooltipPopper = (0, $d8seH.default)((0, $a4669aa090d445bd$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $8nd05.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
        pointerEvents: 'auto'
    }, !open && {
        pointerEvents: 'none'
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: '-0.71em',
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: '-0.71em',
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: (0, $8nd05.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: '-0.71em'
        } : {
            right: 0,
            marginRight: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '100% 100%'
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: (0, $8nd05.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: '-0.71em'
        } : {
            left: 0,
            marginLeft: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '0 0'
            }
        })
    }));
const $96a8b4f445fd9172$var$TooltipTooltip = (0, $d8seH.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $jTnBY.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kSnzZ.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: 'relative',
        margin: 0
    }, ownerState.touch && {
        padding: '8px 16px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$96a8b4f445fd9172$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $8nd05.default)({
            transformOrigin: 'right center'
        }, !ownerState.isRtl ? (0, $8nd05.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        }) : (0, $8nd05.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        })),
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $8nd05.default)({
            transformOrigin: 'left center'
        }, !ownerState.isRtl ? (0, $8nd05.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        }) : (0, $8nd05.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        })),
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $8nd05.default)({
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        }, ownerState.touch && {
            marginBottom: '24px'
        }),
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $8nd05.default)({
            transformOrigin: 'center top',
            marginTop: '14px'
        }, ownerState.touch && {
            marginTop: '24px'
        })
    }));
const $96a8b4f445fd9172$var$TooltipArrow = (0, $d8seH.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kSnzZ.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    }));
let $96a8b4f445fd9172$var$hystersisOpen = false;
const $96a8b4f445fd9172$var$hystersisTimer = new (0, $fcd4c6205d65c7df$export$786b4da70f00938b)();
let $96a8b4f445fd9172$var$cursorPosition = {
    x: 0,
    y: 0
};
function $96a8b4f445fd9172$export$b9ee5a7ace0541f8() {
    $96a8b4f445fd9172$var$hystersisOpen = false;
    $96a8b4f445fd9172$var$hystersisTimer.clear();
}
function $96a8b4f445fd9172$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $96a8b4f445fd9172$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $96a8b4f445fd9172$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $acw62.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $acw62.useState();
    const [arrowRef, setArrowRef] = $acw62.useState(null);
    const ignoreNonTouchEvents = $acw62.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const enterTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const touchTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $4105219ee6538ed1$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $acw62.useRef();
    const stopTouchInteraction = (0, $331f3746e6346411$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $acw62.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.clear();
        $96a8b4f445fd9172$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $331f3746e6346411$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $96a8b4f445fd9172$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $96a8b4f445fd9172$var$hystersisOpen && enterNextDelay) enterTimer.start($96a8b4f445fd9172$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $8fc8239a3939454e$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $acw62.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $96a8b4f445fd9172$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $8nd05.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $9QePP.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $96a8b4f445fd9172$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $96a8b4f445fd9172$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $96a8b4f445fd9172$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $96a8b4f445fd9172$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $acw62.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $8nd05.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $96a8b4f445fd9172$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $96a8b4f445fd9172$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $96a8b4f445fd9172$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $96a8b4f445fd9172$var$TooltipArrow;
    const popperProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(PopperComponent, (0, $8nd05.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $9QePP.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(TransitionComponent, (0, $8nd05.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(TooltipComponent, (0, $8nd05.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $9QePP.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(ArrowComponent, (0, $8nd05.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $9QePP.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PopperComponent, (0, $8nd05.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $a4669aa090d445bd$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $96a8b4f445fd9172$var$cursorPosition.y,
                            left: $96a8b4f445fd9172$var$cursorPosition.x,
                            right: $96a8b4f445fd9172$var$cursorPosition.x,
                            bottom: $96a8b4f445fd9172$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(TooltipComponent, (0, $8nd05.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ayMG0.jsx)(ArrowComponent, (0, $8nd05.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $96a8b4f445fd9172$export$2e2bcd8739ae039 = $96a8b4f445fd9172$var$Tooltip;


var $fc8006a90dad711b$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($fc8006a90dad711b$exports, "__esModule", {
    value: true
});
$fc8006a90dad711b$exports.default = void 0;

var $fc8006a90dad711b$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $fc8006a90dad711b$var$_default = $fc8006a90dad711b$exports.default = (0, $fc8006a90dad711b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 20h14v-2H5zm0-10h4v6h6v-6h4l-7-7z"
}), 'Upload');




var $d8seH = parcelRequire("d8seH");
const $b26796b341c8171a$var$Input = (0, $d8seH.default)('input')({
    display: 'none'
});
const $b26796b341c8171a$var$onChange = (fu)=>(e)=>{
        e.preventDefault();
        const files = e.target.files;
        if (files) {
            const reader = new FileReader();
            reader.onload = (e)=>{
                if (fu.props.onSuccess) /* ... for now skip ArrayBuffer */ {
                    if (e.target && e.target.result && typeof e.target.result === 'string') fu.props.onSuccess(e.target.result);
                }
            };
            reader.onerror = (e)=>{
                if (fu.props.onError) fu.props.onError(e);
            };
            if (files[0]) reader.readAsText(files[0], 'UTF-8');
            fu.setState({
                files: files
            });
        }
    };
class $b26796b341c8171a$export$2e2bcd8739ae039 extends $acw62.Component {
    constructor(ps){
        super(ps);
        this.state = {};
    }
    render() {
        const { title: title, accept: accept } = this.props;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
            title: title ?? '',
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                htmlFor: "contained-button-file",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b26796b341c8171a$var$Input, {
                        accept: accept ?? '*',
                        id: "contained-button-file",
                        type: "file",
                        onChange: $b26796b341c8171a$var$onChange(this)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                        size: "medium",
                        component: "span",
                        color: "info",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fc8006a90dad711b$exports))), {
                            fontSize: "inherit"
                        })
                    })
                ]
            })
        });
    }
}



const $437a2d9ce62cfb25$export$d0dbb306591aec74 = (ps)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        m: "auto",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b26796b341c8171a$export$2e2bcd8739ae039), {
            title: `Import ${ps.name}`,
            accept: ".json",
            onSuccess: (x)=>(0, $128066113e324b22$export$50eef411b4a58360)(x).then((0, $128066113e324b22$export$2fbe0fdfc24beb3d)(ps.codec)).then(ps.success).catch(ps.failure),
            onError: ps.failure ? ps.failure : console.warn
        })
    });
var $437a2d9ce62cfb25$export$2e2bcd8739ae039 = $437a2d9ce62cfb25$export$d0dbb306591aec74;


/**
 * Generic file exporter.
 *
 * @since 0.4.0
 */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

/**
 * Generic file downloader.
 *
 * @since 0.4.0
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $546f4335ad644031$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($546f4335ad644031$exports, "__esModule", {
    value: true
});
$546f4335ad644031$exports.default = void 0;

var $546f4335ad644031$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $546f4335ad644031$var$_default = $546f4335ad644031$exports.default = (0, $546f4335ad644031$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"
}), 'Download');



const $615738504270bac3$var$mimetype = {
    json: 'application/json',
    svg: 'image/svg+xml',
    dxf: 'image/vnd.dxf',
    pdf: 'application/pdf',
    png: 'image/png'
};
const $615738504270bac3$export$24422be91ad4011f = (file, onError)=>{
    try {
        const a = window.document.createElement('a');
        a.target = '_blank';
        const type = $615738504270bac3$var$mimetype[file.type];
        const content = file.getContent();
        a.href = file.base64 ? `data:${type};base64,` + content : window.URL.createObjectURL(new Blob([
            content
        ], {
            type: type
        }));
        a.download = `${file.name}.${file.type}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } catch (_e) {
        onError && onError('File Download failed');
    }
};
const $615738504270bac3$var$onClick = (fd)=>()=>$615738504270bac3$export$24422be91ad4011f(fd.props.file, fd.props.onError);
class $615738504270bac3$export$2e2bcd8739ae039 extends $acw62.Component {
    constructor(ps){
        super(ps);
        this.state = {};
    }
    render() {
        const { title: title } = this.props;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
            title: title ?? '',
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                onClick: $615738504270bac3$var$onClick(this),
                size: "medium",
                component: "span",
                color: "info",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($546f4335ad644031$exports))), {
                    fontSize: "inherit"
                })
            })
        });
    }
}


const $a29c4ff9777c8b77$export$f883e605db67eacf = (ps)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        m: "auto",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $615738504270bac3$export$2e2bcd8739ae039), {
            title: `Export ${ps.name}`,
            file: {
                name: `${ps.name}.${new Date().toISOString().replace(/:/g, '-').replace(/\..*/, '')}`,
                type: 'json',
                getContent: ()=>JSON.stringify(ps.getContent(), null, 2)
            },
            onError: ps.onError ?? console.warn
        })
    });
var $a29c4ff9777c8b77$export$2e2bcd8739ae039 = $a29c4ff9777c8b77$export$f883e605db67eacf;



var $ayMG0 = parcelRequire("ayMG0");
var $dc32784d2379f560$export$f727f52c778e92d5;
$dc32784d2379f560$export$f727f52c778e92d5 = `fTj-9a_toolbar`;


const $efbb6eb46c8dd746$export$bfbece8a621a006f = ({ children: children, className: className })=>/*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
        className: `${className ?? ''} ${$dc32784d2379f560$export$f727f52c778e92d5}`,
        children: children
    });


/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/**
 * Deep Utilities.
 *
 * @since 0.2.0
 */ var $b27b7d62ee741cd2$exports = {};


$b27b7d62ee741cd2$exports = {
    h32: (parcelRequire("d9Pe6")),
    h64: (parcelRequire("7oN96"))
};


/**
 * Check whether something is a boolean.
 */ const $7afee0a6452426b4$export$28ac561dc09c20ca = (x)=>typeof x === 'boolean';
const $7afee0a6452426b4$export$630801d484da15df = (x)=>x === null;
const $7afee0a6452426b4$export$fce6876652108ab = (x)=>x === undefined;
const $7afee0a6452426b4$export$43bee75e5e14138e = (x)=>Object.getPrototypeOf(x) === Array.prototype;
const $7afee0a6452426b4$export$a6cdc56e425d0d0a = (x)=>{
    const pt = Object.getPrototypeOf(x);
    return pt === Object.prototype || pt === null;
};
const $7afee0a6452426b4$export$871608497c498473 = (x)=>Object.getPrototypeOf(x) === Date.prototype;


const $ca0affc99e9d76c6$export$e9bab7fafb253603 = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (typeof a !== 'object' || typeof b !== 'object') return a === b;
    // shortcut pointer equality
    if (a === b) return true;
    if ((0, $7afee0a6452426b4$export$a6cdc56e425d0d0a)(a) && (0, $7afee0a6452426b4$export$a6cdc56e425d0d0a)(b)) {
        const av = Object.entries(a);
        const bv = Object.entries(b);
        if (av.length === bv.length) {
            av.sort(([x], [y])=>x < y ? -1 : x === y ? 0 : 1);
            bv.sort(([x], [y])=>x < y ? -1 : x === y ? 0 : 1);
            return $ca0affc99e9d76c6$export$e9bab7fafb253603(av, bv);
        }
    }
    if ((0, $7afee0a6452426b4$export$43bee75e5e14138e)(a) && (0, $7afee0a6452426b4$export$43bee75e5e14138e)(b) && a.length === b.length) return a.every((x, i)=>$ca0affc99e9d76c6$export$e9bab7fafb253603(x, b[i]));
    if ((0, $7afee0a6452426b4$export$871608497c498473)(a) && (0, $7afee0a6452426b4$export$871608497c498473)(b)) return a.getTime() === b.getTime();
    return false;
};
const $ca0affc99e9d76c6$export$784d13d8ee351f07 = (a)=>{
    if (typeof a !== 'object') return a;
    else if (a === null) return a;
    else if ((0, $7afee0a6452426b4$export$43bee75e5e14138e)(a)) return a.map($ca0affc99e9d76c6$export$784d13d8ee351f07);
    else if ((0, $7afee0a6452426b4$export$871608497c498473)(a)) return new Date(a.getTime());
    else if ((0, $7afee0a6452426b4$export$a6cdc56e425d0d0a)(a)) return Object.assign(Object.create(Object.getPrototypeOf(a)), ...Object.entries(a).map(([k, v])=>({
            [k]: $ca0affc99e9d76c6$export$784d13d8ee351f07(v)
        })));
    else throw {
        error: 'deepCopy: Unknown Type',
        value: a
    };
};
const $ca0affc99e9d76c6$export$d6af199866bfb566 = (key)=>(a)=>{
        const h = (0, $b27b7d62ee741cd2$exports.h64)(key);
        const hs = (x)=>{
            if (x === undefined) h.update('undefined');
            else if (x === null) h.update('null');
            else if (typeof x === 'number' || typeof x === 'boolean' || typeof x === 'function') {
                h.update(typeof x);
                h.update(x.toString());
            } else if (typeof x === 'string') {
                h.update('string');
                h.update(x);
            } else if ((0, $7afee0a6452426b4$export$43bee75e5e14138e)(x)) {
                h.update(`array ${x.length.toString()}`);
                x.forEach(hs);
            } else if ((0, $7afee0a6452426b4$export$871608497c498473)(x)) {
                h.update('date');
                h.update(x.getTime().toString());
            } else if ((0, $7afee0a6452426b4$export$a6cdc56e425d0d0a)(x)) {
                const entries = Object.entries(x).sort(([x], [y])=>x < y ? -1 : x === y ? 0 : 1);
                h.update(`object ${entries}`);
                entries.forEach(([k, v])=>{
                    h.update(k);
                    hs(v);
                });
            } else throw {
                error: 'deepHash: Unknown Type',
                value: x
            };
        };
        hs(a);
        return h.digest().toString(16);
    };


const $46f7ab6e3a21029a$export$357889f174732d38 = (root = {}, lens = {})=>(path, i = 0)=>{
        const p = path[i];
        if (p !== undefined && lens && i < path.length) return $46f7ab6e3a21029a$export$357889f174732d38(root, lens[p])(path, ++i);
        else {
            if (lens === null || Array.isArray(lens) || Object.keys(lens).length > 0) return {
                lens: (0, $ca0affc99e9d76c6$export$784d13d8ee351f07)(lens),
                path: path
            };
            if (path.length) return $46f7ab6e3a21029a$export$357889f174732d38(root, root)(path.slice(0, -1), 0);
            else return undefined;
        }
    };



var $kisy7 = parcelRequire("kisy7");

var $4ZBbi = parcelRequire("4ZBbi");

var $hBXBN = parcelRequire("hBXBN");
var $29b3dcb11c87a56f$exports = {};
"use strict";
Object.defineProperty($29b3dcb11c87a56f$exports, "__esModule", {
    value: true
});
$29b3dcb11c87a56f$exports.Show = $29b3dcb11c87a56f$exports.Ord = $29b3dcb11c87a56f$exports.MonoidAny = $29b3dcb11c87a56f$exports.MonoidAll = $29b3dcb11c87a56f$exports.SemigroupAny = $29b3dcb11c87a56f$exports.SemigroupAll = $29b3dcb11c87a56f$exports.BooleanAlgebra = $29b3dcb11c87a56f$exports.Eq = $29b3dcb11c87a56f$exports.fold = $29b3dcb11c87a56f$exports.match = $29b3dcb11c87a56f$exports.foldW = $29b3dcb11c87a56f$exports.matchW = $29b3dcb11c87a56f$exports.isBoolean = void 0;
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * @category refinements
 * @since 2.11.0
 */ var $29b3dcb11c87a56f$var$isBoolean = function(u) {
    return typeof u === 'boolean';
};
$29b3dcb11c87a56f$exports.isBoolean = $29b3dcb11c87a56f$var$isBoolean;
/**
 * Less strict version of [`match`](#match).
 *
 * The `W` suffix (short for **W**idening) means that the handler return types will be merged.
 *
 * @category pattern matching
 * @since 2.10.0
 */ var $29b3dcb11c87a56f$var$matchW = function(onFalse, onTrue) {
    return function(value) {
        return value ? onTrue() : onFalse();
    };
};
$29b3dcb11c87a56f$exports.matchW = $29b3dcb11c87a56f$var$matchW;
/**
 * Alias of [`matchW`](#matchw).
 *
 * @category pattern matching
 * @since 2.10.0
 */ $29b3dcb11c87a56f$exports.foldW = $29b3dcb11c87a56f$exports.matchW;
/**
 * Defines the fold over a boolean value.
 * Takes two thunks `onTrue`, `onFalse` and a `boolean` value.
 * If `value` is false, `onFalse()` is returned, otherwise `onTrue()`.
 *
 * @example
 * import { some, map } from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 * import { match } from 'fp-ts/boolean'
 *
 * assert.deepStrictEqual(
 *  pipe(
 *    some(true),
 *    map(match(() => 'false', () => 'true'))
 *  ),
 *  some('true')
 * )
 *
 * @category pattern matching
 * @since 2.10.0
 */ $29b3dcb11c87a56f$exports.match = $29b3dcb11c87a56f$exports.foldW;
/**
 * Alias of [`match`](#match).
 *
 * @category pattern matching
 * @since 2.2.0
 */ $29b3dcb11c87a56f$exports.fold = $29b3dcb11c87a56f$exports.match;
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.10.0
 */ $29b3dcb11c87a56f$exports.Eq = {
    equals: function(first, second) {
        return first === second;
    }
};
/**
 * @category instances
 * @since 2.10.0
 */ $29b3dcb11c87a56f$exports.BooleanAlgebra = {
    meet: function(first, second) {
        return first && second;
    },
    join: function(first, second) {
        return first || second;
    },
    zero: false,
    one: true,
    implies: function(first, second) {
        return !first || second;
    },
    not: function(b) {
        return !b;
    }
};
/**
 * `boolean` semigroup under conjunction.
 *
 * @example
 * import { SemigroupAll } from 'fp-ts/boolean'
 *
 * assert.deepStrictEqual(SemigroupAll.concat(true, true), true)
 * assert.deepStrictEqual(SemigroupAll.concat(true, false), false)
 *
 * @category instances
 * @since 2.10.0
 */ $29b3dcb11c87a56f$exports.SemigroupAll = {
    concat: function(first, second) {
        return first && second;
    }
};
/**
 * `boolean` semigroup under disjunction.
 *
 * @example
 * import { SemigroupAny } from 'fp-ts/boolean'
 *
 * assert.deepStrictEqual(SemigroupAny.concat(true, true), true)
 * assert.deepStrictEqual(SemigroupAny.concat(true, false), true)
 * assert.deepStrictEqual(SemigroupAny.concat(false, false), false)
 *
 * @category instances
 * @since 2.10.0
 */ $29b3dcb11c87a56f$exports.SemigroupAny = {
    concat: function(first, second) {
        return first || second;
    }
};
/**
 * `boolean` monoid under conjunction.
 *
 * The `empty` value is `true`.
 *
 * @example
 * import { MonoidAll } from 'fp-ts/boolean'
 *
 * assert.deepStrictEqual(MonoidAll.concat(true, true), true)
 * assert.deepStrictEqual(MonoidAll.concat(true, false), false)
 *
 * @category instances
 * @since 2.10.0
 */ $29b3dcb11c87a56f$exports.MonoidAll = {
    concat: $29b3dcb11c87a56f$exports.SemigroupAll.concat,
    empty: true
};
/**
 * `boolean` monoid under disjunction.
 *
 * The `empty` value is `false`.
 *
 * @example
 * import { MonoidAny } from 'fp-ts/boolean'
 *
 * assert.deepStrictEqual(MonoidAny.concat(true, true), true)
 * assert.deepStrictEqual(MonoidAny.concat(true, false), true)
 * assert.deepStrictEqual(MonoidAny.concat(false, false), false)
 *
 * @category instances
 * @since 2.10.0
 */ $29b3dcb11c87a56f$exports.MonoidAny = {
    concat: $29b3dcb11c87a56f$exports.SemigroupAny.concat,
    empty: false
};
/**
 * @category instances
 * @since 2.10.0
 */ $29b3dcb11c87a56f$exports.Ord = {
    equals: $29b3dcb11c87a56f$exports.Eq.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
/**
 * @category instances
 * @since 2.10.0
 */ $29b3dcb11c87a56f$exports.Show = {
    show: function(b) {
        return JSON.stringify(b);
    }
};



var $5uDEp = parcelRequire("5uDEp");

/**
 * Walls.
 *
 * Front-end related wall drawings, checks for updated props and appends XML to the current react reference.
 *
 * @since 0.2.0
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * DOM Utilities.
 *
 * @since 0.2.0
 */ 

var $4ZBbi = parcelRequire("4ZBbi");

var $hBXBN = parcelRequire("hBXBN");


var $5uDEp = parcelRequire("5uDEp");

var $3abDJ = parcelRequire("3abDJ");

var $kisy7 = parcelRequire("kisy7");



const $5ef56094387f3e7e$export$5118471ee5d5453b = (f)=>(ele)=>{
        Array.from(ele.querySelectorAll('text')).forEach(f);
    };
const $5ef56094387f3e7e$export$9a26da0f93b0b2fc = (f)=>$5ef56094387f3e7e$export$5118471ee5d5453b((e)=>{
        if (e.tagName !== 'text') return;
        const p = e.parentElement;
        if (p === null) return;
        const textNode = e.firstChild;
        if (!(textNode instanceof Text)) return;
        const newText = f(p)(textNode.data);
        if (newText === textNode.data) return;
        textNode.data = newText;
    });
const $5ef56094387f3e7e$var$measurementPathLength = (s)=>(0, $3abDJ.pipe)(s, $hBXBN.fromNullable, $hBXBN.chain((s)=>(0, $859db0da13774873$export$d46ff510f7ea94a5)($4ZBbi.findLastIndex((a)=>a === 'Measure')(s), $hBXBN.some(s))), $hBXBN.map(([idx, path])=>path.slice(idx)), $hBXBN.map((a)=>a.length));
const $5ef56094387f3e7e$var$optionalOpeningTextValue = (shortenedPath, opening, stretchOptic)=>{
    // Build curb optic
    const curbOptic = (0, $3abDJ.pipe)(shortenedPath, (0, $859db0da13774873$export$a55705775057cc10), (cp)=>stretchOptic.compose((0, $7cd1993fbd4e2816$export$dc9bbc5f653d95c5)(cp)));
    // Get the path length
    const existingPathLength = $5ef56094387f3e7e$var$measurementPathLength(shortenedPath);
    // Try to retrieve data
    return (0, $3abDJ.pipe)((0, $859db0da13774873$export$d46ff510f7ea94a5)($hBXBN.some(curbOptic), existingPathLength), $hBXBN.map(([optic, len])=>{
        return (0, $3abDJ.pipe)(len > 1, $29b3dcb11c87a56f$exports.fold(()=>optic.composeLens((0, $7cd1993fbd4e2816$export$64d0857fae0810a)()).composeLens((0, $24a1c1ffbf73ec6a$export$c7133ab33cb183d1)()).composeLens((0, $24a1c1ffbf73ec6a$export$1f745ac5de3c6f65)), ()=>optic.composeLens((0, $7cd1993fbd4e2816$export$64d0857fae0810a)()).composeLens((0, $24a1c1ffbf73ec6a$export$fb23277430a92f0b)()).composeLens((0, $24a1c1ffbf73ec6a$export$b65cefd51408839e))));
    }), $hBXBN.fold(()=>$hBXBN.some(0), (lens)=>lens.getOption(opening)));
};
const $5ef56094387f3e7e$var$POSSIBLE_SECTION_PARAMS = [
    'Left',
    'Angle',
    'Ceiling',
    'Floor',
    'Rest',
    'Info'
];
const $5ef56094387f3e7e$var$getPathFromSectionTree = (pathId)=>(0, $3abDJ.pipe)(pathId.replace('-lbl', '').split('-'), $4ZBbi.findLastIndex((s)=>$5ef56094387f3e7e$var$POSSIBLE_SECTION_PARAMS.includes(s)), $hBXBN.map((idx)=>pathId.replace('-lbl', '').split('-').slice(idx)), $hBXBN.foldW((0, $3abDJ.constant)(null), (a)=>a));
const $5ef56094387f3e7e$var$getSectionStepFromId = (0, $3abDJ.flow)((x)=>x.split('-'), (0, $859db0da13774873$export$7824cc40e1e06c48));
const $5ef56094387f3e7e$var$createFloorOptic = (0, $3abDJ.flow)((0, $859db0da13774873$export$7824cc40e1e06c48), (0, $7cd1993fbd4e2816$export$faa3e63c9e26e74b));
const $5ef56094387f3e7e$export$375a8416951f4bb0 = (pathId)=>(0, $3abDJ.pipe)(pathId, (x)=>x.split('-'), (b)=>{
        const floorOptic = $5ef56094387f3e7e$var$createFloorOptic(b);
        const curbOptic = (0, $3abDJ.pipe)(b, (0, $859db0da13774873$export$a55705775057cc10), (a)=>floorOptic.composeOptional((0, $7cd1993fbd4e2816$export$dc9bbc5f653d95c5)(a)));
        return $5ef56094387f3e7e$export$57cec44475e77e80(pathId) ? $5uDEp.left(curbOptic) : $5uDEp.right(floorOptic);
    });
const $5ef56094387f3e7e$export$bc679dff364cd315 = (s)=>s.split('-').includes('EdgeOuterHeight');
const $5ef56094387f3e7e$export$99482d80c6cfc1f6 = (s)=>s.split('-').includes('EdgeBredth');
const $5ef56094387f3e7e$export$cac3980734d91fbe = (s)=>s.split('-').includes('Edge');
const $5ef56094387f3e7e$export$56e1424916b718f3 = (s)=>$5ef56094387f3e7e$export$bc679dff364cd315(s) ? 'OuterHeight' : $5ef56094387f3e7e$export$99482d80c6cfc1f6(s) ? 'Offset' : 'Bredth';
const $5ef56094387f3e7e$export$57cec44475e77e80 = (s)=>s.split('-').includes('Curbs');
const $5ef56094387f3e7e$var$stretchOuterHeightOptic = (floorOptic)=>floorOptic.composeLens((0, $7cd1993fbd4e2816$export$3c6339f3d1c3afe)());
const $5ef56094387f3e7e$var$curbOuterHeightOptic = (curbOptic)=>curbOptic.composeLens((0, $7cd1993fbd4e2816$export$542c4f0e3b6c4e9a)());
const $5ef56094387f3e7e$var$conditionalOuterHeightOptic = (a)=>(0, $3abDJ.pipe)(a, $5uDEp.fold($5ef56094387f3e7e$var$curbOuterHeightOptic, $5ef56094387f3e7e$var$stretchOuterHeightOptic));
const $5ef56094387f3e7e$var$stretchOffsetOptic = (floorOptic)=>floorOptic.composeLens((0, $7cd1993fbd4e2816$export$2b7df9035e85967e)());
const $5ef56094387f3e7e$var$curbOffsetOptic = (curbOptic)=>curbOptic.composeLens((0, $7cd1993fbd4e2816$export$dff7844ca8741e9e)());
const $5ef56094387f3e7e$var$conditionalBredthOptic = (a)=>(0, $3abDJ.pipe)(a, $5uDEp.fold($5ef56094387f3e7e$var$curbOffsetOptic, $5ef56094387f3e7e$var$stretchOffsetOptic), $5ef56094387f3e7e$var$composeShiftOffsetOptics);
const $5ef56094387f3e7e$var$stretchEdgeOptic = (floorOptic)=>floorOptic.composeLens((0, $7cd1993fbd4e2816$export$f0c8a0ba199d2458)());
const $5ef56094387f3e7e$var$curbEdgeOptic = (curbOptic)=>curbOptic.composeLens((0, $7cd1993fbd4e2816$export$9f7b78c3cf25ccc0)());
const $5ef56094387f3e7e$var$conditionalEdgeOptic = (a)=>(0, $3abDJ.pipe)(a, $5uDEp.fold($5ef56094387f3e7e$var$curbEdgeOptic, $5ef56094387f3e7e$var$stretchEdgeOptic), $5ef56094387f3e7e$var$composeMajorMeasurementValueOptics);
const $5ef56094387f3e7e$var$bredthOrEdgeOptics = (pathId)=>(a)=>(0, $3abDJ.pipe)(pathId, (s)=>$5ef56094387f3e7e$export$99482d80c6cfc1f6(s) ? $5uDEp.right($5ef56094387f3e7e$var$conditionalBredthOptic(a)) : $5uDEp.left($5ef56094387f3e7e$var$conditionalEdgeOptic(a)), $5uDEp.fold((e)=>e, (a)=>a));
const $5ef56094387f3e7e$var$determineFloorPlanOptics = (pathId)=>(a)=>(0, $3abDJ.pipe)(pathId, (s)=>$5ef56094387f3e7e$export$bc679dff364cd315(s) ? $5uDEp.right($5ef56094387f3e7e$var$conditionalOuterHeightOptic(a)) : $5uDEp.left($5ef56094387f3e7e$var$bredthOrEdgeOptics(s)(a)), $5uDEp.fold((e)=>e, (a)=>a));
const $5ef56094387f3e7e$var$accessFloorPlanOptic = (optic)=>(opening)=>optic.getOption(opening);
const $5ef56094387f3e7e$export$e7e8c93e06b1fc6 = (pathId)=>(0, $3abDJ.pipe)(pathId, $5ef56094387f3e7e$export$375a8416951f4bb0, $5ef56094387f3e7e$var$determineFloorPlanOptics(pathId));
const $5ef56094387f3e7e$var$composeMajorMeasurementValueOptics = (a)=>a.composeLens((0, $24a1c1ffbf73ec6a$export$f19dd2c890563e4e)()).composeLens((0, $24a1c1ffbf73ec6a$export$72683dc2d378b18d));
const $5ef56094387f3e7e$var$composeShiftOffsetOptics = (a)=>a.composeLens((0, $7cd1993fbd4e2816$export$5533399da1c0a4e9));
const $5ef56094387f3e7e$export$5086e32780cf3aff = (0, $3abDJ.flow)($5ef56094387f3e7e$export$e7e8c93e06b1fc6, $5ef56094387f3e7e$var$accessFloorPlanOptic);
const $5ef56094387f3e7e$export$dc50ddf20a42cc09 = (pathId, opening)=>{
    const sectionStep = $5ef56094387f3e7e$var$getSectionStepFromId(pathId);
    const pathFromSectionTree = $5ef56094387f3e7e$var$getPathFromSectionTree(pathId);
    const firstIdx = (0, $3abDJ.pipe)(pathFromSectionTree, $hBXBN.fromNullable, $hBXBN.chain($4ZBbi.head), $hBXBN.toUndefined);
    if (pathId.includes('Edge')) /*
		 * TODO: A curb bredth, offset, and outer height may be null when the stretch bredth,
		 * offset, and outer height are defined in the Opening design. The drawing will
		 * fill in the amount from the stretch but the converter function isn't currently
		 * able to get that other stretch value
		 */ return $5ef56094387f3e7e$export$5086e32780cf3aff(pathId)(opening);
    if (pathFromSectionTree) switch(firstIdx){
        case 'Left':
            {
                const pathNoLeft = pathFromSectionTree.slice(1); // Removed ['Left']
                const newLeftFirstIdx = (0, $3abDJ.pipe)(pathNoLeft, $4ZBbi.head, $hBXBN.toUndefined);
                if (newLeftFirstIdx) {
                    if (newLeftFirstIdx === 'Corner') return $hBXBN.some(0);
                    return $5ef56094387f3e7e$var$optionalOpeningTextValue(pathNoLeft, opening, (0, $7cd1993fbd4e2816$export$f331b00682592a13).asOptional());
                }
                return $hBXBN.some(0);
            }
        case 'Angle':
            /*
			 * The angle for the right wall is accessed differentely
			 * then all the other joint angles
			 */ if (pathId.includes('Right')) return (0, $7cd1993fbd4e2816$export$55ddb4f38f3e3471).composeOptional((0, $7cd1993fbd4e2816$export$7fbf24f5b3ed34f2)(sectionStep)).composeLens((0, $7cd1993fbd4e2816$export$b455f688a19f877e)).composePrism((0, $37e4362694b22dd4$export$80bf7733f1207381)()).composeLens((0, $7cd1993fbd4e2816$export$1970e45fbd175d71)).composeLens((0, $7cd1993fbd4e2816$export$182cfb6ee9f0ec10)).getOption(opening);
            return (0, $7cd1993fbd4e2816$export$55ddb4f38f3e3471).composeOptional((0, $7cd1993fbd4e2816$export$7fbf24f5b3ed34f2)(sectionStep)).composeLens((0, $kisy7.Lens).fromPath()([
                'Angle',
                'Angle'
            ])).getOption(opening);
        case 'Ceiling':
            return $5ef56094387f3e7e$var$optionalOpeningTextValue(pathFromSectionTree, opening, (0, $7cd1993fbd4e2816$export$4705361e940d7b1c)(sectionStep));
        case 'Floor':
            return $5ef56094387f3e7e$var$optionalOpeningTextValue(pathFromSectionTree, opening, (0, $7cd1993fbd4e2816$export$faa3e63c9e26e74b)(sectionStep));
        case 'Rest':
            {
                const pathNoSection = pathFromSectionTree.slice(2); // Removed ['Rest', 'Right']
                const newRestFirstIdx = (0, $3abDJ.pipe)(pathNoSection, $4ZBbi.head, $hBXBN.toUndefined);
                if (newRestFirstIdx) {
                    if (newRestFirstIdx === 'Corner') return $hBXBN.some(0);
                    return $5ef56094387f3e7e$var$optionalOpeningTextValue(pathNoSection, opening, (0, $7cd1993fbd4e2816$export$dda7e91d312139d5)(sectionStep));
                }
                return $hBXBN.some(0);
            }
        default:
            console.warn(`SectionTree parameter "${firstIdx}" not recognized.`);
            return $hBXBN.some(0);
    }
    return $hBXBN.some(0);
};
const $5ef56094387f3e7e$export$da227b5f76807204 = (f)=>(div)=>{
        Array.from(div.querySelectorAll('text')).map(f);
    };
const $5ef56094387f3e7e$export$2ce4735ffca1427e = (opening)=>(f)=>(el)=>{
            // Get the element that has the path id
            const p = el.parentElement;
            if (p === null) return;
            const pathId = p.id;
            if (pathId === null) return;
            const val = (0, $3abDJ.pipe)($5ef56094387f3e7e$export$dc50ddf20a42cc09(pathId, opening), $hBXBN.map((n)=>f(n)(pathId)), $hBXBN.foldW((0, $3abDJ.constant)(''), (s)=>s));
            const dataNode = el.firstChild;
            if (val && dataNode instanceof Text) dataNode.data = val;
        };
const $5ef56094387f3e7e$export$fc65e6186004f4eb = (f)=>(el)=>{
        // Get the element that has the path id
        const p = el.parentElement;
        if (p === null) return;
        const pathId = p.id;
        if (pathId === null) return;
        const dataNode = el.firstChild;
        if (!(dataNode instanceof Text)) return;
        /*
	 * TODO: Unlike `convertOpeningTextElements` this value is using the
	 * text element data value. Therefore the conversion is incorrect if
	 * the units are switched while on the Panels tab
	 *
	 * Is there a way to get the value from the opening object given the
	 * differing structure of the element ID
	 */ const val = (0, $3abDJ.pipe)(dataNode.data, parseFloat, (n)=>f(n)(pathId), $hBXBN.fromNullable, $hBXBN.foldW((0, $3abDJ.constant)(''), (s)=>s));
        if (val) dataNode.data = val;
    };






var $dMYym = parcelRequire("dMYym");

var $3abDJ = parcelRequire("3abDJ");

var $acw62 = parcelRequire("acw62");

var $hBXBN = parcelRequire("hBXBN");

var $4ZBbi = parcelRequire("4ZBbi");

var $acw62 = parcelRequire("acw62");

var $4ZBbi = parcelRequire("4ZBbi");

var $hBXBN = parcelRequire("hBXBN");

var $3abDJ = parcelRequire("3abDJ");

const $c49fcf209b4b4b92$var$changedTouches = (a)=>a.changedTouches;
const $c49fcf209b4b4b92$export$f0a8ef43892f4b4d = (a)=>{
    const touches = [];
    for(let i = 0; i < a.length; i++){
        const touch = a.item(i);
        if (touch) touches.push(touch);
    }
    return touches;
};
const $c49fcf209b4b4b92$var$deltaClient = (a, b)=>{
    return {
        dx: b.clientX - a.clientX,
        dy: b.clientY - a.clientY
    };
};
const $c49fcf209b4b4b92$var$angleFromTouchDelta = (deltas)=>Math.atan2(deltas.dy, deltas.dx) * (180 / Math.PI);
const $c49fcf209b4b4b92$var$angleFromTouches = (initialTouch, lastTouch)=>(0, $3abDJ.pipe)((0, $859db0da13774873$export$d46ff510f7ea94a5)($hBXBN.fromNullable(initialTouch), $hBXBN.fromNullable(lastTouch)), $hBXBN.map($4ZBbi.map($c49fcf209b4b4b92$var$changedTouches)), $hBXBN.map($4ZBbi.map($c49fcf209b4b4b92$export$f0a8ef43892f4b4d)), $hBXBN.map($4ZBbi.map($4ZBbi.head)), $hBXBN.chain($4ZBbi.sequence($hBXBN.Applicative)), $hBXBN.chain((a)=>(0, $859db0da13774873$export$d46ff510f7ea94a5)($hBXBN.fromNullable(a[0]), $hBXBN.fromNullable(a[1]))), $hBXBN.map((a)=>$c49fcf209b4b4b92$var$deltaClient(...a)), $hBXBN.map($c49fcf209b4b4b92$var$angleFromTouchDelta));
const $c49fcf209b4b4b92$var$useTouchAngle = (updateNumberOrNull, value, updateTrackingAngle, trackingAngle)=>{
    const ref = $acw62.useRef(null);
    const [initialTouch, setInitialTouch] = $acw62.useState(null);
    const [lastTouch, setLastTouch] = $acw62.useState(null);
    const [movingTouch, setMovingTouch] = $acw62.useState(null);
    $acw62.useEffect(()=>{
        function handleTouchEnd(e) {
            /*
			 * If the user zooms, this gets set
			 * because the event still (?) fires with one touch despite being
			 * the end of a zoom event, Therefore, down on the start listener
			 * we clear the last as a reset for the new touch angle calculation
			 */ setLastTouch(e);
            setMovingTouch(null);
            updateTrackingAngle(()=>null);
        }
        function handleTouchStart(e) {
            /*
			 * If the user presses down, activating the pie menu and then release
			 * a zero angle is calculated and set. This defined angle then prevents other angles from
			 * being set because the user decided to tap instead of drag.
			 *
			 * Therefore, set the angle to null when the user first taps to make sure their movement
			 * always sets a new angle
			 */ if (e.touches.length === 1) {
                updateNumberOrNull(()=>null);
                setLastTouch(null);
                setMovingTouch(null);
                setInitialTouch(e);
                updateTrackingAngle(()=>null);
            }
        }
        function handleTouchMove(e) {
            if (e.touches.length === 1) setMovingTouch(e);
        }
        const el = ref?.current;
        if (el) {
            el.addEventListener('touchstart', handleTouchStart);
            el.addEventListener('touchend', handleTouchEnd);
            el.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                el.removeEventListener('touchstart', handleTouchStart);
                el.removeEventListener('touchend', handleTouchEnd);
                el.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return;
    }, [
        updateNumberOrNull,
        updateTrackingAngle
    ]);
    $acw62.useEffect(()=>{
        const oAngle = $c49fcf209b4b4b92$var$angleFromTouches(initialTouch, lastTouch);
        const oValue = $hBXBN.fromNullable(value);
        (0, $3abDJ.pipe)(oAngle, $hBXBN.chain($hBXBN.fromPredicate(()=>$hBXBN.isNone(oValue))), $hBXBN.fold((0, $3abDJ.constant)(null), (a)=>{
            updateNumberOrNull(()=>a);
            setLastTouch(null);
            setInitialTouch(null);
        }));
    }, [
        initialTouch,
        lastTouch,
        updateNumberOrNull,
        value
    ]);
    $acw62.useEffect(()=>{
        const oAngle = $c49fcf209b4b4b92$var$angleFromTouches(initialTouch, movingTouch);
        (0, $3abDJ.pipe)(oAngle, $hBXBN.fold((0, $3abDJ.constant)(null), (a)=>updateTrackingAngle(()=>a)));
    }, [
        initialTouch,
        movingTouch,
        updateTrackingAngle,
        trackingAngle
    ]);
    return {
        ref: ref
    };
};
var $c49fcf209b4b4b92$export$2e2bcd8739ae039 = $c49fcf209b4b4b92$var$useTouchAngle;



const $1c171a81388d816c$var$MAX_ZOOM = 0.10;
const $1c171a81388d816c$var$MIN_ZOOM = 4;
const $1c171a81388d816c$var$handleTouchZoom = (svgSize)=>(m)=>(viewBox)=>(distanceRatio)=>{
                if (!svgSize) return null;
                const w = viewBox.w;
                const h = viewBox.h;
                const dw = w * distanceRatio - w;
                const dh = h * distanceRatio - h;
                const dx = dw * m.x / svgSize.w;
                const dy = dh * m.y / svgSize.h;
                const newScale = svgSize.w / (viewBox.w - dw);
                const isOutOfBounds = newScale < $1c171a81388d816c$var$MAX_ZOOM || newScale > $1c171a81388d816c$var$MIN_ZOOM;
                return isOutOfBounds ? viewBox : {
                    x: viewBox.x + dx,
                    y: viewBox.y + dy,
                    w: viewBox.w - dw,
                    h: viewBox.h - dh
                };
            };
/*
 * Calculate new SVG viewbox zoom from mouse interaction
 */ const $1c171a81388d816c$var$handleMouseZoom = (svgSize)=>(m)=>(viewBox)=>(distanceDelta)=>{
                if (!svgSize) return null;
                const w = viewBox.w;
                const h = viewBox.h;
                const dw = w * Math.sign(distanceDelta) * -0.05;
                const dh = h * Math.sign(distanceDelta) * -0.05;
                const dx = dw * m.x / svgSize.w;
                const dy = dh * m.y / svgSize.h;
                const newScale = svgSize.w / (viewBox.w - dw);
                const isOutOfBounds = newScale < $1c171a81388d816c$var$MAX_ZOOM || newScale > $1c171a81388d816c$var$MIN_ZOOM;
                return isOutOfBounds ? viewBox : {
                    x: viewBox.x + dx,
                    y: viewBox.y + dy,
                    w: viewBox.w - dw,
                    h: viewBox.h - dh
                };
            };
/*
 * Update x and y values in SVG viewbox
 */ const $1c171a81388d816c$var$updateViewboxXY = (xy)=>({ x: x, y: y, ...rest })=>{
        return {
            x: x + xy.x,
            y: y + xy.y,
            ...rest
        };
    };
/*
 * Add two `TouchPageChange` types together for calculating zoom values
 */ const $1c171a81388d816c$var$sumTouchPageData = (b, a)=>{
    return {
        x: b.x + a.pageX,
        y: b.y + a.pageY
    };
};
/*
 * Average of multiple `TouchPageChange` types used for calculating zoom values
 */ const $1c171a81388d816c$var$avgTouchPageData = (a)=>(0, $3abDJ.pipe)(a, $4ZBbi.reduce({
        x: 0,
        y: 0
    }, $1c171a81388d816c$var$sumTouchPageData), ({ x: x, y: y })=>({
            x: x / a.length,
            y: y / a.length
        }));
/*
 * Average of multiple `XY` type coordinates
 */ const $1c171a81388d816c$var$avgXY = (a)=>(0, $3abDJ.pipe)(a, $4ZBbi.reduce({
        x: 0,
        y: 0
    }, (b, a)=>({
            x: b.x + a.x,
            y: b.y + a.y
        })), ({ x: x, y: y })=>({
            x: x / a.length,
            y: y / a.length
        }));
/*
 * Calculate mouse delta given to `TouchPageChange` objects
 */ const $1c171a81388d816c$var$touchMovement = (a, b)=>({
        mx: b.x - a.x,
        my: b.y - a.y
    });
/*
 * Get delta x and y from `TouchPageChange`'s as a ratio of the SVG to container scale
 */ const $1c171a81388d816c$var$deltaPageScale = (scale)=>(movement)=>({
            dx: (0 - movement.mx) / scale,
            dy: (0 - movement.my) / scale
        });
/*
 * Calculate an average `TouchPageChange` from a TouchList
 */ const $1c171a81388d816c$var$touchAvgFromTouches = (a)=>(0, $3abDJ.pipe)(a, (0, $c49fcf209b4b4b92$export$f0a8ef43892f4b4d), $1c171a81388d816c$var$avgTouchPageData);
/*
 * Change in coordinates between mouse events as a ratio of the SVG to container scale
 */ const $1c171a81388d816c$var$deltaMouse = (scale)=>(initial, ev)=>({
            dx: (initial.x - ev.movementX) / scale,
            dy: (initial.y - ev.movementY) / scale
        });
/*
 * Transform a `Touch` to an `XY` given a vertical offset
 */ const $1c171a81388d816c$var$toXY = (offsetTop)=>(touch)=>{
        return {
            x: touch.clientX,
            y: touch.clientY - offsetTop
        };
    };
/*
 * Distance between two points (`XY`)
 */ const $1c171a81388d816c$var$distance = (xy1, xy2)=>Math.sqrt(Math.pow(xy2.x - xy1.x, 2) + Math.pow(xy2.y - xy1.y, 2));
const $1c171a81388d816c$var$useDrawingInteractions = (onDown, activeElId)=>{
    /*
	 * Ref for container that holds SVG
	 *
	 *
	 * Left side of this container must be
	 * against the left side of the window or
	 * you need a left offset
	 */ const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    /*
	 * Zoom for SVG
	 *
	 * scale = svg width / viewbox w
	 */ const [scale, setScale] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    /*
	 * State for tracking svg size used in calculating scale and zoom
	 */ const [svgSize, setSvgSize] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    /*
	 * State for svg viewBox attribute. Viewbox is used for svg zooming
	 */ const [viewBox, setViewBox] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        x: 0,
        y: 0,
        w: 1024,
        h: 1024
    });
    /*
	 * State for correctly positioning the viewBox when zooming
	 */ const [offsetTop, setOffsetTop] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    /*
	 * Calculate zoom scale
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (svgSize?.w) setScale(svgSize.w / viewBox.w);
    }, [
        svgSize?.w,
        viewBox.w
    ]);
    /*
	 * Initial calculation to set svgSize and offset
	 * from top to use for zooming
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (containerRef?.current) {
            const rect = containerRef?.current.getBoundingClientRect();
            setSvgSize({
                w: rect.width,
                h: rect.height
            });
            setOffsetTop(rect.top);
        }
    }, [
        containerRef
    ]);
    /*
	 * Panning ability for mouse and touch events
	 *
	 */ const [panning, setPanning] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    /*
	 * State to track first point of contact with mouse from user
	 */ const [mouseStartPosition, setMouseStartPosition] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        x: 0,
        y: 0
    });
    /*
	 *
	 * Mouse events
	 *
	 */ const onMouseDown = (e)=>{
        onDown(e);
        setPanning(true);
        setMouseStartPosition({
            x: e.movementX,
            y: e.movementY
        });
    };
    const mousePanWithScale = $1c171a81388d816c$var$deltaMouse(scale);
    const onMouseMove = (e)=>{
        if (panning) {
            const d = mousePanWithScale(mouseStartPosition, e);
            setViewBox({
                x: viewBox.x + d.dx,
                y: viewBox.y + d.dy,
                w: viewBox.w,
                h: viewBox.h
            });
        }
    };
    const onMouseUp = (e)=>{
        if (panning) {
            const d = mousePanWithScale(mouseStartPosition, e);
            setViewBox({
                x: viewBox.x + d.dx,
                y: viewBox.y + d.dy,
                w: viewBox.w,
                h: viewBox.h
            });
            setPanning(false);
        }
    };
    const onMouseLeave = (_)=>{
        setPanning(false);
    };
    const wheel = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((e)=>{
        e.preventDefault();
        (0, $3abDJ.pipe)($1c171a81388d816c$var$handleMouseZoom(svgSize)({
            x: e.pageX,
            y: e.pageY - offsetTop
        })(viewBox)(e.deltaY), $hBXBN.fromNullable, $hBXBN.fold((0, $3abDJ.constant)(null), setViewBox));
    }, [
        offsetTop,
        svgSize,
        viewBox
    ]);
    /*
	 * Add container event listeners for mouse
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = containerRef?.current;
        if (el) {
            /*
			 * Event handler needs to be passed to node
			 * as opposed to being passed as React prop because
			 * React does not support non-passive wheel events
			 */ containerRef.current.addEventListener('wheel', wheel, {
                passive: false
            });
            return ()=>{
                el?.removeEventListener('wheel', wheel);
            };
        }
        return;
    }, [
        wheel
    ]);
    const [touchStartPosition, setTouchStartPosition] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        x: 0,
        y: 0
    });
    const [touchStartDistance, setTouchStartDistance] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    /*
	 *
	 * Touch events
	 *
	 */ const onTouchStart = (e)=>{
        (0, $3abDJ.pipe)(e, $hBXBN.fromPredicate((event)=>(0, $3abDJ.pipe)(event.touches, (0, $c49fcf209b4b4b92$export$f0a8ef43892f4b4d)).length === 1), $hBXBN.fold((0, $3abDJ.constant)(null), onDown));
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const containerEl = containerRef?.current;
        function handlePanTouchStart(e) {
            e.preventDefault();
            // Pan
            (0, $3abDJ.pipe)(e.touches, (0, $c49fcf209b4b4b92$export$f0a8ef43892f4b4d), $hBXBN.fromPredicate((touchList)=>touchList.length === 1), $hBXBN.fold((0, $3abDJ.constant)(null), (touches)=>{
                setPanning(true);
                (0, $3abDJ.pipe)(touches, $1c171a81388d816c$var$avgTouchPageData, setTouchStartPosition);
            }));
            // Zoom
            (0, $3abDJ.pipe)(e.touches, (a)=>(0, $859db0da13774873$export$d46ff510f7ea94a5)((0, $3abDJ.pipe)(a.item(0), $hBXBN.fromNullable, $hBXBN.map($1c171a81388d816c$var$toXY(offsetTop))), (0, $3abDJ.pipe)(a.item(1), $hBXBN.fromNullable, $hBXBN.map($1c171a81388d816c$var$toXY(offsetTop)))), $hBXBN.fold((0, $3abDJ.constant)(null), (touchPoints)=>{
                const dist = $1c171a81388d816c$var$distance(...touchPoints);
                const center = $1c171a81388d816c$var$avgXY(touchPoints);
                setPanning(false);
                setTouchStartDistance(dist);
                setTouchStartPosition(center);
            }));
        }
        function handlePanTouchMove(e) {
            e.preventDefault();
            // Pan
            (0, $3abDJ.pipe)(e.touches, (0, $c49fcf209b4b4b92$export$f0a8ef43892f4b4d), $hBXBN.fromPredicate((touchList)=>touchList.length === 1), $hBXBN.chain($hBXBN.fromPredicate(()=>panning && !activeElId)), $hBXBN.map($1c171a81388d816c$var$avgTouchPageData), $hBXBN.map((b)=>$1c171a81388d816c$var$touchMovement(touchStartPosition, b)), $hBXBN.map((mov)=>$1c171a81388d816c$var$deltaPageScale(scale)(mov)), $hBXBN.map((a)=>$1c171a81388d816c$var$updateViewboxXY({
                    x: a.dx,
                    y: a.dy
                })), $hBXBN.fold((0, $3abDJ.constant)(null), setViewBox));
            (0, $3abDJ.pipe)(e.touches, $hBXBN.fromPredicate(()=>panning && !activeElId), $hBXBN.map($1c171a81388d816c$var$touchAvgFromTouches), $hBXBN.fold((0, $3abDJ.constant)(null), setTouchStartPosition));
            // Zoom
            (0, $3abDJ.pipe)(e.touches, (a)=>(0, $859db0da13774873$export$d46ff510f7ea94a5)((0, $3abDJ.pipe)(a.item(0), $hBXBN.fromNullable, $hBXBN.map($1c171a81388d816c$var$toXY(offsetTop))), (0, $3abDJ.pipe)(a.item(1), $hBXBN.fromNullable, $hBXBN.map($1c171a81388d816c$var$toXY(offsetTop)))), $hBXBN.map((xys)=>{
                const center = $1c171a81388d816c$var$avgXY(xys);
                const scale = $1c171a81388d816c$var$distance(...xys) / touchStartDistance;
                setTouchStartDistance($1c171a81388d816c$var$distance(...xys));
                return $1c171a81388d816c$var$handleTouchZoom(svgSize)(center)(viewBox)(scale);
            }), $hBXBN.chain($hBXBN.fromNullable), $hBXBN.fold((0, $3abDJ.constant)(null), (vb)=>{
                setViewBox(vb);
            }));
        }
        function handleTouchEnd() {
            setPanning(false);
            setTouchStartPosition({
                x: 0,
                y: 0
            });
            setTouchStartDistance(0);
        }
        if (containerEl) {
            containerEl.addEventListener('touchstart', handlePanTouchStart, {
                passive: false
            });
            containerEl.addEventListener('touchmove', handlePanTouchMove, {
                passive: false
            });
            containerEl.addEventListener('touchend', handleTouchEnd);
            return ()=>{
                containerEl.removeEventListener('touchstart', handlePanTouchStart);
                containerEl.removeEventListener('touchmove', handlePanTouchMove);
                containerEl.removeEventListener('touchend', handleTouchEnd);
            };
        }
        return;
    }, [
        containerRef,
        panning,
        scale,
        touchStartPosition,
        activeElId,
        offsetTop,
        svgSize,
        viewBox,
        touchStartDistance
    ]);
    return {
        onTouchStart: onTouchStart,
        onMouseDown: onMouseDown,
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        onMouseUp: onMouseUp,
        zooming: Boolean(touchStartDistance),
        containerRef: containerRef,
        viewBox: viewBox
    };
};
var $1c171a81388d816c$export$2e2bcd8739ae039 = $1c171a81388d816c$var$useDrawingInteractions;




var $3abDJ = parcelRequire("3abDJ");

var $acw62 = parcelRequire("acw62");
var $1363e2a0573b425c$exports = {};
"use strict";
var $1363e2a0573b425c$var$__assign = $1363e2a0573b425c$exports && $1363e2a0573b425c$exports.__assign || function() {
    $1363e2a0573b425c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1363e2a0573b425c$var$__assign.apply(this, arguments);
};
var $1363e2a0573b425c$var$__createBinding = $1363e2a0573b425c$exports && $1363e2a0573b425c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1363e2a0573b425c$var$__setModuleDefault = $1363e2a0573b425c$exports && $1363e2a0573b425c$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1363e2a0573b425c$var$__importStar = $1363e2a0573b425c$exports && $1363e2a0573b425c$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1363e2a0573b425c$var$__createBinding(result, mod, k);
    }
    $1363e2a0573b425c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($1363e2a0573b425c$exports, "__esModule", {
    value: true
});
$1363e2a0573b425c$exports.Foldable = $1363e2a0573b425c$exports.getDifferenceMagma = $1363e2a0573b425c$exports.getIntersectionSemigroup = $1363e2a0573b425c$exports.getUnionMonoid = $1363e2a0573b425c$exports.getUnionSemigroup = $1363e2a0573b425c$exports.getWitherable = $1363e2a0573b425c$exports.getTraversableWithIndex = $1363e2a0573b425c$exports.getTraversable = $1363e2a0573b425c$exports.FilterableWithIndex = $1363e2a0573b425c$exports.Filterable = $1363e2a0573b425c$exports.Compactable = $1363e2a0573b425c$exports.getFoldableWithIndex = $1363e2a0573b425c$exports.getFoldable = $1363e2a0573b425c$exports.FunctorWithIndex = $1363e2a0573b425c$exports.flap = $1363e2a0573b425c$exports.Functor = $1363e2a0573b425c$exports.getMonoid = $1363e2a0573b425c$exports.getEq = $1363e2a0573b425c$exports.URI = $1363e2a0573b425c$exports.separate = $1363e2a0573b425c$exports.compact = $1363e2a0573b425c$exports.partitionMap = $1363e2a0573b425c$exports.partition = $1363e2a0573b425c$exports.filterMap = $1363e2a0573b425c$exports.filter = $1363e2a0573b425c$exports.difference = $1363e2a0573b425c$exports.intersection = $1363e2a0573b425c$exports.union = $1363e2a0573b425c$exports.elem = $1363e2a0573b425c$exports.some = $1363e2a0573b425c$exports.every = $1363e2a0573b425c$exports.fromEntries = $1363e2a0573b425c$exports.toEntries = $1363e2a0573b425c$exports.filterMapWithIndex = $1363e2a0573b425c$exports.partitionMapWithIndex = $1363e2a0573b425c$exports.wilt = $1363e2a0573b425c$exports.wither = $1363e2a0573b425c$exports.singleton = $1363e2a0573b425c$exports.map = $1363e2a0573b425c$exports.mapWithIndex = $1363e2a0573b425c$exports.lookup = $1363e2a0573b425c$exports.isSubrecord = $1363e2a0573b425c$exports.modifyAt = $1363e2a0573b425c$exports.updateAt = $1363e2a0573b425c$exports.has = $1363e2a0573b425c$exports.upsertAt = $1363e2a0573b425c$exports.toArray = $1363e2a0573b425c$exports.keys = $1363e2a0573b425c$exports.isEmpty = $1363e2a0573b425c$exports.size = void 0;
$1363e2a0573b425c$exports.record = $1363e2a0573b425c$exports.hasOwnProperty = $1363e2a0573b425c$exports.insertAt = $1363e2a0573b425c$exports.empty = $1363e2a0573b425c$exports.Witherable = $1363e2a0573b425c$exports.TraversableWithIndex = $1363e2a0573b425c$exports.Traversable = $1363e2a0573b425c$exports.FoldableWithIndex = void 0;
$1363e2a0573b425c$exports.collect = $1363e2a0573b425c$var$collect;
$1363e2a0573b425c$exports.toUnfoldable = $1363e2a0573b425c$var$toUnfoldable;
$1363e2a0573b425c$exports.deleteAt = $1363e2a0573b425c$var$deleteAt;
$1363e2a0573b425c$exports.pop = $1363e2a0573b425c$var$pop;
$1363e2a0573b425c$exports.reduceWithIndex = $1363e2a0573b425c$var$reduceWithIndex;
$1363e2a0573b425c$exports.foldMapWithIndex = $1363e2a0573b425c$var$foldMapWithIndex;
$1363e2a0573b425c$exports.reduceRightWithIndex = $1363e2a0573b425c$var$reduceRightWithIndex;
$1363e2a0573b425c$exports.traverseWithIndex = $1363e2a0573b425c$var$traverseWithIndex;
$1363e2a0573b425c$exports.traverse = $1363e2a0573b425c$var$traverse;
$1363e2a0573b425c$exports.sequence = $1363e2a0573b425c$var$sequence;
$1363e2a0573b425c$exports.partitionWithIndex = $1363e2a0573b425c$var$partitionWithIndex;
$1363e2a0573b425c$exports.filterWithIndex = $1363e2a0573b425c$var$filterWithIndex;
$1363e2a0573b425c$exports.fromFoldable = $1363e2a0573b425c$var$fromFoldable;
$1363e2a0573b425c$exports.fromFoldableMap = $1363e2a0573b425c$var$fromFoldableMap;
$1363e2a0573b425c$exports.reduce = $1363e2a0573b425c$var$reduce;
$1363e2a0573b425c$exports.foldMap = $1363e2a0573b425c$var$foldMap;
$1363e2a0573b425c$exports.reduceRight = $1363e2a0573b425c$var$reduceRight;
$1363e2a0573b425c$exports.getShow = $1363e2a0573b425c$var$getShow;

var $1363e2a0573b425c$var$A = $1363e2a0573b425c$var$__importStar((parcelRequire("4ZBbi")));

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");

var $1363e2a0573b425c$var$_ = $1363e2a0573b425c$var$__importStar((parcelRequire("704qB")));

var $1363e2a0573b425c$var$RR = $1363e2a0573b425c$var$__importStar((parcelRequire("eC5G3")));

var $1363e2a0573b425c$var$Se = $1363e2a0573b425c$var$__importStar((parcelRequire("3OUuJ")));

var $1363e2a0573b425c$var$S = $1363e2a0573b425c$var$__importStar((parcelRequire("a1nAP")));

var $4p4Yq = parcelRequire("4p4Yq");
// -------------------------------------------------------------------------------------
// model
// -------------------------------------------------------------------------------------
/**
 * Calculate the number of key/value pairs in a `Record`.
 *
 * @example
 * import { size } from "fp-ts/Record";
 *
 * assert.deepStrictEqual(size({ a: true, b: 2, c: "three" }), 3);
 *
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.size = $1363e2a0573b425c$var$RR.size;
/**
 * Test whether a `Record` is empty.
 *
 * @example
 * import { isEmpty } from "fp-ts/Record";
 *
 * assert.deepStrictEqual(isEmpty({}), true);
 * assert.deepStrictEqual(isEmpty({ a: 3 }), false);
 *
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.isEmpty = $1363e2a0573b425c$var$RR.isEmpty;
var $1363e2a0573b425c$var$keys_ = function(O) {
    return function(r) {
        return Object.keys(r).sort(O.compare);
    };
};
/**
 * The keys of a `Record`, sorted alphabetically.
 *
 * @example
 * import { keys } from "fp-ts/Record";
 *
 * assert.deepStrictEqual(keys({ c: 1, a: 2, b: 3 }), ["a", "b", "c"]);
 *
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.keys = $1363e2a0573b425c$var$keys_($1363e2a0573b425c$var$S.Ord);
function $1363e2a0573b425c$var$collect(O) {
    if (typeof O === 'function') return $1363e2a0573b425c$var$collect($1363e2a0573b425c$var$S.Ord)(O);
    var keysO = $1363e2a0573b425c$var$keys_(O);
    return function(f) {
        return function(r) {
            var out = [];
            for(var _i = 0, _a = keysO(r); _i < _a.length; _i++){
                var key = _a[_i];
                out.push(f(key, r[key]));
            }
            return out;
        };
    };
}
/**
 * Get a sorted `Array` of the key/value pairs contained in a `Record`.
 * Sorted alphabetically by key.
 *
 * @example
 * import { toArray } from 'fp-ts/Record'
 *
 * const x = { c: 3, a: "foo", b: false };
 * assert.deepStrictEqual(toArray(x), [
 *   ["a", "foo"],
 *   ["b", false],
 *   ["c", 3],
 * ]);
 *
 * @category conversions
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.toArray = $1363e2a0573b425c$var$collect($1363e2a0573b425c$var$S.Ord)(function(k, a) {
    return [
        k,
        a
    ];
});
function $1363e2a0573b425c$var$toUnfoldable(U) {
    return function(r) {
        var sas = (0, $1363e2a0573b425c$exports.toArray)(r);
        var len = sas.length;
        return U.unfold(0, function(b) {
            return b < len ? $1363e2a0573b425c$var$_.some([
                sas[b],
                b + 1
            ]) : $1363e2a0573b425c$var$_.none;
        });
    };
}
/**
 * Insert or replace a key/value pair in a `Record`.
 *
 * @example
 * import { upsertAt } from 'fp-ts/Record'
 *
 * assert.deepStrictEqual(upsertAt("a", 5)({ a: 1, b: 2 }), { a: 5, b: 2 });
 * assert.deepStrictEqual(upsertAt("c", 5)({ a: 1, b: 2 }), { a: 1, b: 2, c: 5 });
 *
 * @since 2.10.0
 */ $1363e2a0573b425c$exports.upsertAt = $1363e2a0573b425c$var$RR.upsertAt;
/**
 * Test whether or not a key exists in a `Record`.
 *
 * Note. This function is not pipeable because is a `Refinement`.
 *
 * @example
 * import { has } from 'fp-ts/Record'
 *
 * assert.deepStrictEqual(has("a", { a: 1, b: 2 }), true);
 * assert.deepStrictEqual(has("c", { a: 1, b: 2 }), false);
 *
 * @since 2.10.0
 */ $1363e2a0573b425c$exports.has = $1363e2a0573b425c$var$RR.has;
function $1363e2a0573b425c$var$deleteAt(k) {
    return function(r) {
        if (!$1363e2a0573b425c$var$_.has.call(r, k)) return r;
        var out = Object.assign({}, r);
        delete out[k];
        return out;
    };
}
/**
 * Replace a key/value pair in a `Record`.
 *
 * @returns If the specified key exists it returns an `Option` containing a new `Record`
 * with the entry updated, otherwise it returns `None`
 *
 * @example
 * import { updateAt } from 'fp-ts/Record'
 * import { option } from 'fp-ts'
 *
 * assert.deepStrictEqual(updateAt("a", 3)({ a: 1, b: 2 }), option.some({ a: 3, b: 2 }));
 * assert.deepStrictEqual(updateAt("c", 3)({ a: 1, b: 2 }), option.none);
 *
 * @since 2.0.0
 */ var $1363e2a0573b425c$var$updateAt = function(k, a) {
    return (0, $1363e2a0573b425c$exports.modifyAt)(k, function() {
        return a;
    });
};
$1363e2a0573b425c$exports.updateAt = $1363e2a0573b425c$var$updateAt;
/**
 * Applies a mapping function to one spcific key/value pair in a `Record`.
 *
 * @returns If the specified key exists it returns an `Option` containing a new `Record`
 * with the entry updated, otherwise it returns `None`
 *
 * @example
 * import { modifyAt } from 'fp-ts/Record'
 * import { option } from 'fp-ts'
 *
 * assert.deepStrictEqual(modifyAt("a", (x: number) => x * 3)({ a: 1, b: 2 }), option.some({ a: 3, b: 2 }));
 * assert.deepStrictEqual(modifyAt("c", (x: number) => x * 3)({ a: 1, b: 2 }), option.none);
 *
 * @since 2.0.0
 */ var $1363e2a0573b425c$var$modifyAt = function(k, f) {
    return function(r) {
        if (!(0, $1363e2a0573b425c$exports.has)(k, r)) return $1363e2a0573b425c$var$_.none;
        var out = Object.assign({}, r);
        out[k] = f(r[k]);
        return $1363e2a0573b425c$var$_.some(out);
    };
};
$1363e2a0573b425c$exports.modifyAt = $1363e2a0573b425c$var$modifyAt;
function $1363e2a0573b425c$var$pop(k) {
    var deleteAtk = $1363e2a0573b425c$var$deleteAt(k);
    return function(r) {
        var oa = (0, $1363e2a0573b425c$exports.lookup)(k, r);
        return $1363e2a0573b425c$var$_.isNone(oa) ? $1363e2a0573b425c$var$_.none : $1363e2a0573b425c$var$_.some([
            oa.value,
            deleteAtk(r)
        ]);
    };
}
// TODO: remove non-curried overloading in v3
/**
 * Test whether one `Record` contains all of the keys and values
 * contained in another `Record`.
 *
 * @example
 * import { isSubrecord } from 'fp-ts/Record'
 * import { string } from 'fp-ts'
 *
 * assert.deepStrictEqual(
 *   isSubrecord(string.Eq)({ a: "foo", b: "bar", c: "baz" })({ a: "foo", b: "bar", c: "baz" }),
 *   true
 * );
 * assert.deepStrictEqual(
 *   isSubrecord(string.Eq)({ a: "foo", b: "bar", c: "baz" })({ a: "foo", c: "baz" }),
 *   true
 * );
 * assert.deepStrictEqual(
 *   isSubrecord(string.Eq)({ a: "foo", b: "bar", c: "baz" })({ a: "foo", b: "not-bar", c: "baz" }),
 *   false
 * );
 * assert.deepStrictEqual(
 *   isSubrecord(string.Eq)({ a: "foo", b: "bar" })({ a: "foo", b: "bar", c: "baz" }),
 *   false
 * );
 *
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.isSubrecord = $1363e2a0573b425c$var$RR.isSubrecord;
// TODO: remove non-curried overloading in v3
/**
 * Lookup the value for a key in a `Record`.
 *
 * @returns If the specified key exists it returns an `Option` containing the value,
 * otherwise it returns `None`
 *
 * @example
 * import { lookup } from 'fp-ts/Record'
 * import { option } from 'fp-ts'
 *
 * assert.deepStrictEqual(lookup("b")({ a: "foo", b: "bar" }), option.some("bar"));
 * assert.deepStrictEqual(lookup("c")({ a: "foo", b: "bar" }), option.none);
 *
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.lookup = $1363e2a0573b425c$var$RR.lookup;
/**
 * Map a `Record` passing the key/value pairs to the iterating function.
 *
 * @example
 * import { mapWithIndex } from "fp-ts/Record";
 *
 * const f = (k: string, n: number) => `${k.toUpperCase()}-${n}`;
 * assert.deepStrictEqual(mapWithIndex(f)({ a: 3, b: 5 }), { a: "A-3", b: "B-5" });
 *
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.mapWithIndex = $1363e2a0573b425c$var$RR.mapWithIndex;
/**
 * Map a `Record` passing the values to the iterating function.
 *
 * @example
 * import { map } from "fp-ts/Record";
 *
 * const f = (n: number) => `-${n}-`;
 * assert.deepStrictEqual(map(f)({ a: 3, b: 5 }), { a: "-3-", b: "-5-" });
 *
 * @category mapping
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.map = $1363e2a0573b425c$var$RR.map;
function $1363e2a0573b425c$var$reduceWithIndex() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? $1363e2a0573b425c$var$RR.reduceWithIndex(args[0]) : $1363e2a0573b425c$var$RR.reduceWithIndex($1363e2a0573b425c$var$S.Ord).apply(void 0, args);
}
function $1363e2a0573b425c$var$foldMapWithIndex(O) {
    return 'compare' in O ? $1363e2a0573b425c$var$RR.foldMapWithIndex(O) : $1363e2a0573b425c$var$RR.foldMapWithIndex($1363e2a0573b425c$var$S.Ord)(O);
}
function $1363e2a0573b425c$var$reduceRightWithIndex() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? $1363e2a0573b425c$var$RR.reduceRightWithIndex(args[0]) : $1363e2a0573b425c$var$RR.reduceRightWithIndex($1363e2a0573b425c$var$S.Ord).apply(void 0, args);
}
/**
 * Create a `Record` with one key/value pair.
 *
 * @example
 * import { singleton } from "fp-ts/Record";
 *
 * assert.deepStrictEqual(singleton("a", 1), { a: 1 });
 *
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.singleton = $1363e2a0573b425c$var$RR.singleton;
function $1363e2a0573b425c$var$traverseWithIndex(F) {
    return $1363e2a0573b425c$var$RR.traverseWithIndex(F);
}
function $1363e2a0573b425c$var$traverse(F) {
    return $1363e2a0573b425c$var$RR.traverse(F);
}
function $1363e2a0573b425c$var$sequence(F) {
    return $1363e2a0573b425c$var$RR.sequence(F);
}
/**
 * @category filtering
 * @since 2.6.5
 */ var $1363e2a0573b425c$var$wither = function(F) {
    var traverseF = $1363e2a0573b425c$var$traverse(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $3abDJ.pipe)(fa, traverseF(f)), $1363e2a0573b425c$exports.compact);
        };
    };
};
$1363e2a0573b425c$exports.wither = $1363e2a0573b425c$var$wither;
/**
 * @category filtering
 * @since 2.6.5
 */ var $1363e2a0573b425c$var$wilt = function(F) {
    var traverseF = $1363e2a0573b425c$var$traverse(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $3abDJ.pipe)(fa, traverseF(f)), $1363e2a0573b425c$exports.separate);
        };
    };
};
$1363e2a0573b425c$exports.wilt = $1363e2a0573b425c$var$wilt;
/**
 * Maps a `Record` with a function returning an `Either` and
 * partitions the resulting `Record` into `Left`s and `Right`s.
 *
 * @example
 * import { partitionMapWithIndex } from "fp-ts/Record"
 * import { either } from "fp-ts"
 *
 * const f = (key: string, a: number) =>
 *   a >= 0 ? either.right(`${key} is >= 0 (${a})`) : either.left(`${key} is < 0 (${a})`);
 * assert.deepStrictEqual(partitionMapWithIndex(f)({ a: -1, b: 2, c: 123 }), {
 *   left: {
 *     a: "a is < 0 (-1)",
 *   },
 *   right: {
 *     b: "b is >= 0 (2)",
 *     c: "c is >= 0 (123)",
 *   },
 * });
 *
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.partitionMapWithIndex = $1363e2a0573b425c$var$RR.partitionMapWithIndex;
function $1363e2a0573b425c$var$partitionWithIndex(predicateWithIndex) {
    return $1363e2a0573b425c$var$RR.partitionWithIndex(predicateWithIndex);
}
/**
 * Maps a `Record` with an iterating function that takes key and value and
 * returns an `Option`, keeping only the `Some` values and discarding `None`s.
 *
 * @example
 * import { filterMapWithIndex } from "fp-ts/Record"
 * import { option } from "fp-ts"
 *
 * const f = (key: string, a: number) => (a >= 0 ? option.some(`${key}${a}`) : option.none);
 * assert.deepStrictEqual(filterMapWithIndex(f)({ a: -1, b: 2, c: 3 }), {
 *   b: "b2",
 *   c: "c3",
 * });
 *
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.filterMapWithIndex = $1363e2a0573b425c$var$RR.filterMapWithIndex;
function $1363e2a0573b425c$var$filterWithIndex(predicateWithIndex) {
    return $1363e2a0573b425c$var$RR.filterWithIndex(predicateWithIndex);
}
function $1363e2a0573b425c$var$fromFoldable(M, F) {
    return $1363e2a0573b425c$var$RR.fromFoldable(M, F);
}
/**
 * Alias of [`toArray`](#toArray).
 *
 * @example
 * import { toEntries } from 'fp-ts/Record'
 *
 * assert.deepStrictEqual(toEntries({ b: 2, a: 1 }), [['a', 1], ['b', 2]])
 *
 * @since 2.12.0
 * @category conversions
 */ $1363e2a0573b425c$exports.toEntries = $1363e2a0573b425c$exports.toArray;
/**
 * Converts an `Array` of `[key, value]` tuples into a `Record`.
 *
 * @example
 * import { fromEntries } from 'fp-ts/Record'
 *
 * assert.deepStrictEqual(fromEntries([['a', 1], ['b', 2], ['a', 3]]), { b: 2, a: 3 })
 *
 * @since 2.12.0
 * @category conversions
 */ var $1363e2a0573b425c$var$fromEntries = function(fa) {
    return $1363e2a0573b425c$var$fromFoldable($1363e2a0573b425c$var$Se.last(), $1363e2a0573b425c$var$A.Foldable)(fa);
};
$1363e2a0573b425c$exports.fromEntries = $1363e2a0573b425c$var$fromEntries;
function $1363e2a0573b425c$var$fromFoldableMap(M, F) {
    return $1363e2a0573b425c$var$RR.fromFoldableMap(M, F);
}
/**
 * Test if every value in a `Record` satisfies the predicate.
 *
 * @example
 * import { every } from "fp-ts/Record"
 *
 * assert.deepStrictEqual(every((n: number) => n >= 0)({ a: 1, b: 2 }), true);
 * assert.deepStrictEqual(every((n: number) => n >= 0)({ a: 1, b: -1 }), false);
 *
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.every = $1363e2a0573b425c$var$RR.every;
/**
 * Test if at least one value in a `Record` satisfies the predicate.
 *
 * @example
 * import { some } from "fp-ts/Record"
 *
 * assert.deepStrictEqual(some((n: number) => n >= 0)({ a: 1, b: -2 }), true);
 * assert.deepStrictEqual(some((n: number) => n >= 0)({ a: -1, b: -2 }), false);
 *
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.some = $1363e2a0573b425c$var$RR.some;
// TODO: remove non-curried overloading in v3
/**
 * Given an `Eq` checks if a `Record` contains an entry with
 * value equal to a provided value.
 *
 * @example
 * import { elem } from "fp-ts/Record"
 * import { number } from "fp-ts"
 *
 * assert.deepStrictEqual(elem(number.Eq)(123, { foo: 123, bar: 234 }), true);
 * assert.deepStrictEqual(elem(number.Eq)(-7, { foo: 123, bar: 234 }), false);
 *
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.elem = $1363e2a0573b425c$var$RR.elem;
/**
 * Union of two `Record`s.
 * Takes two `Record`s and produces a `Record` combining all the
 * entries of the two inputs.
 * It uses the `concat` function of the provided `Magma` to
 * combine the elements with the same key.
 *
 * @example
 * import { union } from "fp-ts/Record";
 * import { Magma } from "fp-ts/Magma";
 *
 * const m1: Magma<number> = { concat: (x: number, y: number) => x + y };
 * assert.deepStrictEqual(union(m1)({ a: 3, c: 3 })({ a: 1, b: 2 }), { a: 4, b: 2, c: 3 });
 * const m2: Magma<number> = { concat: (x: number) => x };
 * assert.deepStrictEqual(union(m2)({ a: 3, c: 3 })({ a: 1, b: 2 }), { a: 1, b: 2, c: 3 });
 *
 * @since 2.11.0
 */ var $1363e2a0573b425c$var$union = function(M) {
    var unionM = $1363e2a0573b425c$var$RR.union(M);
    return function(second) {
        return function(first) {
            if ((0, $1363e2a0573b425c$exports.isEmpty)(first)) return $1363e2a0573b425c$var$__assign({}, second);
            if ((0, $1363e2a0573b425c$exports.isEmpty)(second)) return $1363e2a0573b425c$var$__assign({}, first);
            return unionM(second)(first);
        };
    };
};
$1363e2a0573b425c$exports.union = $1363e2a0573b425c$var$union;
/**
 * Intersection of two `Record`s.
 * Takes two `Record`s and produces a `Record` combining only the
 * entries of the two inputswith the same key.
 * It uses the `concat` function of the provided `Magma` to
 * combine the elements.
 *
 * @example
 * import { intersection } from "fp-ts/Record";
 * import { Magma } from "fp-ts/Magma";
 *
 * const m1: Magma<number> = { concat: (x: number, y: number) => x + y };
 * assert.deepStrictEqual(intersection(m1)({ a: 3, c: 3 })({ a: 1, b: 2 }), { a: 4});
 * const m2: Magma<number> = { concat: (x: number) => x };
 * assert.deepStrictEqual(intersection(m2)({ a: 3, c: 3 })({ a: 1, b: 2 }), { a: 1});
 *
 * @since 2.11.0
 */ var $1363e2a0573b425c$var$intersection = function(M) {
    return function(second) {
        return function(first) {
            if ((0, $1363e2a0573b425c$exports.isEmpty)(first) || (0, $1363e2a0573b425c$exports.isEmpty)(second)) return {};
            return $1363e2a0573b425c$var$RR.intersection(M)(second)(first);
        };
    };
};
$1363e2a0573b425c$exports.intersection = $1363e2a0573b425c$var$intersection;
/**
 * Difference between two `Record`s.
 * Takes two `Record`s and produces a `Record` composed by the
 * entries of the two inputs, removing the entries with the same
 * key in both inputs.
 *
 * @example
 * import { difference } from "fp-ts/Record";
 *
 * assert.deepStrictEqual(difference({ a: 1 })({ a: 1, b: 2 }), { b: 2 });
 * assert.deepStrictEqual(difference({ a: 3 })({ a: 1, b: 2 }), { b: 2 });
 * assert.deepStrictEqual(difference({ a: 3, c: 3 })({ a: 1, b: 2 }), { b: 2, c: 3 });
 *
 * @since 2.11.0
 */ var $1363e2a0573b425c$var$difference = function(second) {
    return function(first) {
        if ((0, $1363e2a0573b425c$exports.isEmpty)(first)) return $1363e2a0573b425c$var$__assign({}, second);
        if ((0, $1363e2a0573b425c$exports.isEmpty)(second)) return $1363e2a0573b425c$var$__assign({}, first);
        return $1363e2a0573b425c$var$RR.difference(second)(first);
    };
};
$1363e2a0573b425c$exports.difference = $1363e2a0573b425c$var$difference;
var $1363e2a0573b425c$var$_map = $1363e2a0573b425c$var$RR._map;
var $1363e2a0573b425c$var$_mapWithIndex = $1363e2a0573b425c$var$RR._mapWithIndex;
var $1363e2a0573b425c$var$_reduce = $1363e2a0573b425c$var$RR._reduce;
var $1363e2a0573b425c$var$_foldMap = $1363e2a0573b425c$var$RR._foldMap;
var $1363e2a0573b425c$var$_reduceRight = $1363e2a0573b425c$var$RR._reduceRight;
var $1363e2a0573b425c$var$_filter = $1363e2a0573b425c$var$RR._filter;
var $1363e2a0573b425c$var$_filterMap = $1363e2a0573b425c$var$RR._filterMap;
var $1363e2a0573b425c$var$_partition = $1363e2a0573b425c$var$RR._partition;
var $1363e2a0573b425c$var$_partitionMap = $1363e2a0573b425c$var$RR._partitionMap;
var $1363e2a0573b425c$var$_reduceWithIndex = $1363e2a0573b425c$var$RR._reduceWithIndex;
var $1363e2a0573b425c$var$_foldMapWithIndex = $1363e2a0573b425c$var$RR._foldMapWithIndex;
var $1363e2a0573b425c$var$_reduceRightWithIndex = $1363e2a0573b425c$var$RR._reduceRightWithIndex;
var $1363e2a0573b425c$var$_partitionMapWithIndex = $1363e2a0573b425c$var$RR._partitionMapWithIndex;
var $1363e2a0573b425c$var$_partitionWithIndex = $1363e2a0573b425c$var$RR._partitionWithIndex;
var $1363e2a0573b425c$var$_filterMapWithIndex = $1363e2a0573b425c$var$RR._filterMapWithIndex;
var $1363e2a0573b425c$var$_filterWithIndex = $1363e2a0573b425c$var$RR._filterWithIndex;
var $1363e2a0573b425c$var$_traverse = $1363e2a0573b425c$var$RR._traverse;
var $1363e2a0573b425c$var$_sequence = $1363e2a0573b425c$var$RR._sequence;
var $1363e2a0573b425c$var$_traverseWithIndex = function(O) {
    return function(F) {
        var keysO = $1363e2a0573b425c$var$keys_(O);
        return function(ta, f) {
            var ks = keysO(ta);
            if (ks.length === 0) return F.of({});
            var fr = F.of({});
            var _loop_1 = function(key) {
                fr = F.ap(F.map(fr, function(r) {
                    return function(b) {
                        r[key] = b;
                        return r;
                    };
                }), f(key, ta[key]));
            };
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                _loop_1(key);
            }
            return fr;
        };
    };
};
/**
 * Given a `Predicate`, it produces a new `Record` keeping only the entries with a
 * value that satisfies the provided predicate.
 *
 * @example
 * import { filter } from "fp-ts/Record"
 *
 * assert.deepStrictEqual(filter((s: string) => s.length < 4)({ a: "foo", b: "bar", c: "verylong" }), {
 *   a: "foo",
 *   b: "bar",
 * });
 *
 * @category filtering
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.filter = $1363e2a0573b425c$var$RR.filter;
/**
 * Maps a `Record` with an iterating function that returns an `Option`
 * and it keeps only the `Some` values discarding the `None`s.
 *
 * @example
 * import { filterMap } from "fp-ts/Record"
 * import { option } from "fp-ts"
 *
 * const f = (s: string) => s.length < 4 ? option.some(`${s} is short`): option.none
 * assert.deepStrictEqual(filterMap(f)({ a: "foo", b: "bar", c: "verylong" }), {
 *   a: "foo is short",
 *   b: "bar is short",
 * });
 *
 * @category filtering
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.filterMap = $1363e2a0573b425c$var$RR.filterMap;
/**
 * Partition a `Record` into two parts according to a `Predicate`.
 *
 * @example
 * import { partition } from "fp-ts/Record"
 *
 * assert.deepStrictEqual(partition((s: string) => s.length < 4)({ a: "foo", b: "bar", c: "verylong" }), {
 *   left:{
 *     c: "verylong"
 *   },
 *   right: {
 *     a: "foo",
 *     b: "bar",
 *   },
 * });
 *
 * @category filtering
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.partition = $1363e2a0573b425c$var$RR.partition;
/**
 * Maps a `Record` with a function returning an `Either` and
 * partitions the resulting `Record` into `Left`s and `Right`s.
 *
 * @example
 * import { partitionMap } from "fp-ts/Record"
 * import { either } from "fp-ts"
 *
 * const f = (s: string) => (s.length < 4 ? either.right(`${s} is short`) : either.left(`${s} is not short`));
 * assert.deepStrictEqual(partitionMap(f)({ a: "foo", b: "bar", c: "verylong" }), {
 *   left: {
 *     c: "verylong is not short",
 *   },
 *   right: {
 *     a: "foo is short",
 *     b: "bar is short",
 *   },
 * });
 *
 * @category filtering
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.partitionMap = $1363e2a0573b425c$var$RR.partitionMap;
function $1363e2a0573b425c$var$reduce() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? $1363e2a0573b425c$var$RR.reduce(args[0]) : $1363e2a0573b425c$var$RR.reduce($1363e2a0573b425c$var$S.Ord).apply(void 0, args);
}
function $1363e2a0573b425c$var$foldMap(O) {
    return 'compare' in O ? $1363e2a0573b425c$var$RR.foldMap(O) : $1363e2a0573b425c$var$RR.foldMap($1363e2a0573b425c$var$S.Ord)(O);
}
function $1363e2a0573b425c$var$reduceRight() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? $1363e2a0573b425c$var$RR.reduceRight(args[0]) : $1363e2a0573b425c$var$RR.reduceRight($1363e2a0573b425c$var$S.Ord).apply(void 0, args);
}
/**
 * Compact a `Record` of `Option`s discarding the `None` values and
 * keeping the `Some` values.
 *
 * @example
 * import { compact } from 'fp-ts/Record'
 * import { option } from 'fp-ts'
 *
 * assert.deepStrictEqual(compact({ a: option.some("foo"), b: option.none, c: option.some("bar") }), {
 *   a: "foo",
 *   c: "bar",
 * });
 *
 * @category filtering
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.compact = $1363e2a0573b425c$var$RR.compact;
/**
 * Separate a `Record` of `Either`s into `Left`s and `Right`s.
 *
 * @example
 * import { separate } from 'fp-ts/Record'
 * import { either } from 'fp-ts'
 *
 * assert.deepStrictEqual(
 *   separate({ a: either.right("foo"), b: either.left("bar"), c: either.right("baz") }),
 *   {
 *     right: {
 *       a: "foo",
 *       c: "baz",
 *     },
 *     left: {
 *       b: "bar",
 *     },
 *   }
 * );
 *
 * @category filtering
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.separate = $1363e2a0573b425c$var$RR.separate;
/**
 * @category type lambdas
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.URI = 'Record';
function $1363e2a0573b425c$var$getShow(O) {
    return 'compare' in O ? $1363e2a0573b425c$var$RR.getShow(O) : $1363e2a0573b425c$var$RR.getShow($1363e2a0573b425c$var$S.Ord)(O);
}
/**
 * Given an `Eq` for the base type, it produces an `Eq`
 * for a `Record` of that base type.
 *
 * @example
 * import { getEq } from "fp-ts/Record";
 * import { string } from "fp-ts";
 * import { Eq } from "fp-ts/Eq";
 *
 * const eq: Eq<Record<string, string>> = getEq(string.Eq);
 * assert.deepStrictEqual(eq.equals({ a: "foo" }, { b: "bar" }), false);
 * assert.deepStrictEqual(eq.equals({ a: "foo" }, { a: "foo" }), true);
 *
 * @category instances
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.getEq = $1363e2a0573b425c$var$RR.getEq;
/**
 * Returns a `Monoid` instance for `Record`s, given a `Semigroup`
 * instance for the base type.
 * The `Monoid` makes the union of two `Record`s comining the
 * overlapping entries with the provided `Semigroup`.
 *
 * @example
 * import { SemigroupSum } from 'fp-ts/number'
 * import { getMonoid } from 'fp-ts/Record'
 *
 * const M = getMonoid(SemigroupSum);
 * assert.deepStrictEqual(M.concat({ foo: 123, bar: 234 }, { foo: 456, baz: 567 }), { foo: 579 , bar: 234, baz: 567 });
 *
 * @category instances
 * @since 2.0.0
 */ $1363e2a0573b425c$exports.getMonoid = $1363e2a0573b425c$var$RR.getMonoid;
/**
 * @category instances
 * @since 2.7.0
 */ $1363e2a0573b425c$exports.Functor = {
    URI: $1363e2a0573b425c$exports.URI,
    map: $1363e2a0573b425c$var$_map
};
/**
 * Takes a value and a `Record` of functions and returns a
 * `Record` by applying each function to the input value.
 *
 * @example
 * import { flap } from "fp-ts/Record"
 *
 * const fab = { x: (n: number) => `${n} times 2`, y: (n: number) => `${n * 2}` };
 * assert.deepStrictEqual(flap(3)(fab), {
 *   x: "3 times 2",
 *   y: "6",
 * });
 *
 * @category mapping
 * @since 2.10.0
 */ $1363e2a0573b425c$exports.flap = (0, $emm1u.flap)($1363e2a0573b425c$exports.Functor);
/**
 * @category instances
 * @since 2.7.0
 */ $1363e2a0573b425c$exports.FunctorWithIndex = {
    URI: $1363e2a0573b425c$exports.URI,
    map: $1363e2a0573b425c$var$_map,
    mapWithIndex: $1363e2a0573b425c$var$_mapWithIndex
};
/**
 * Produces a `Foldable` instance for a `Record`, using the
 * provided `Ord` to sort the `Record`'s entries by key.
 *
 * @category folding
 * @since 2.11.0
 */ var $1363e2a0573b425c$var$getFoldable = function(O) {
    return {
        URI: $1363e2a0573b425c$exports.URI,
        reduce: $1363e2a0573b425c$var$_reduce(O),
        foldMap: $1363e2a0573b425c$var$_foldMap(O),
        reduceRight: $1363e2a0573b425c$var$_reduceRight(O)
    };
};
$1363e2a0573b425c$exports.getFoldable = $1363e2a0573b425c$var$getFoldable;
/**
 * Produces a `FoldableWithIndex1` instance for a `Record`, using the
 * provided `Ord` to sort the `Record`'s entries by key.
 *
 * @category folding
 * @since 2.11.0
 */ var $1363e2a0573b425c$var$getFoldableWithIndex = function(O) {
    return {
        URI: $1363e2a0573b425c$exports.URI,
        reduce: $1363e2a0573b425c$var$_reduce(O),
        foldMap: $1363e2a0573b425c$var$_foldMap(O),
        reduceRight: $1363e2a0573b425c$var$_reduceRight(O),
        reduceWithIndex: $1363e2a0573b425c$var$_reduceWithIndex(O),
        foldMapWithIndex: $1363e2a0573b425c$var$_foldMapWithIndex(O),
        reduceRightWithIndex: $1363e2a0573b425c$var$_reduceRightWithIndex(O)
    };
};
$1363e2a0573b425c$exports.getFoldableWithIndex = $1363e2a0573b425c$var$getFoldableWithIndex;
/**
 * @category instances
 * @since 2.7.0
 */ $1363e2a0573b425c$exports.Compactable = {
    URI: $1363e2a0573b425c$exports.URI,
    compact: $1363e2a0573b425c$exports.compact,
    separate: $1363e2a0573b425c$exports.separate
};
/**
 * @category instances
 * @since 2.7.0
 */ $1363e2a0573b425c$exports.Filterable = {
    URI: $1363e2a0573b425c$exports.URI,
    map: $1363e2a0573b425c$var$_map,
    compact: $1363e2a0573b425c$exports.compact,
    separate: $1363e2a0573b425c$exports.separate,
    filter: $1363e2a0573b425c$var$_filter,
    filterMap: $1363e2a0573b425c$var$_filterMap,
    partition: $1363e2a0573b425c$var$_partition,
    partitionMap: $1363e2a0573b425c$var$_partitionMap
};
/**
 * @category instances
 * @since 2.7.0
 */ $1363e2a0573b425c$exports.FilterableWithIndex = {
    URI: $1363e2a0573b425c$exports.URI,
    map: $1363e2a0573b425c$var$_map,
    mapWithIndex: $1363e2a0573b425c$var$_mapWithIndex,
    compact: $1363e2a0573b425c$exports.compact,
    separate: $1363e2a0573b425c$exports.separate,
    filter: $1363e2a0573b425c$var$_filter,
    filterMap: $1363e2a0573b425c$var$_filterMap,
    partition: $1363e2a0573b425c$var$_partition,
    partitionMap: $1363e2a0573b425c$var$_partitionMap,
    filterMapWithIndex: $1363e2a0573b425c$var$_filterMapWithIndex,
    filterWithIndex: $1363e2a0573b425c$var$_filterWithIndex,
    partitionMapWithIndex: $1363e2a0573b425c$var$_partitionMapWithIndex,
    partitionWithIndex: $1363e2a0573b425c$var$_partitionWithIndex
};
/**
 * Produces a `Traversable` instance for a `Record`, using the
 * provided `Ord` to sort the `Record`'s entries by key.
 *
 * @category traversing
 * @since 2.11.0
 */ var $1363e2a0573b425c$var$getTraversable = function(O) {
    return {
        URI: $1363e2a0573b425c$exports.URI,
        map: $1363e2a0573b425c$var$_map,
        reduce: $1363e2a0573b425c$var$_reduce(O),
        foldMap: $1363e2a0573b425c$var$_foldMap(O),
        reduceRight: $1363e2a0573b425c$var$_reduceRight(O),
        traverse: $1363e2a0573b425c$var$_traverse(O),
        sequence: $1363e2a0573b425c$var$_sequence(O)
    };
};
$1363e2a0573b425c$exports.getTraversable = $1363e2a0573b425c$var$getTraversable;
/**
 * Produces a `TraversableWithIndex` instance for a `Record`, using the
 * provided `Ord` to sort the `Record`'s entries by key.
 *
 * @category traversing
 * @since 2.11.0
 */ var $1363e2a0573b425c$var$getTraversableWithIndex = function(O) {
    return {
        URI: $1363e2a0573b425c$exports.URI,
        map: $1363e2a0573b425c$var$_map,
        mapWithIndex: $1363e2a0573b425c$var$_mapWithIndex,
        reduce: $1363e2a0573b425c$var$_reduce(O),
        foldMap: $1363e2a0573b425c$var$_foldMap(O),
        reduceRight: $1363e2a0573b425c$var$_reduceRight(O),
        reduceWithIndex: $1363e2a0573b425c$var$_reduceWithIndex(O),
        foldMapWithIndex: $1363e2a0573b425c$var$_foldMapWithIndex(O),
        reduceRightWithIndex: $1363e2a0573b425c$var$_reduceRightWithIndex(O),
        traverse: $1363e2a0573b425c$var$_traverse(O),
        sequence: $1363e2a0573b425c$var$_sequence(O),
        traverseWithIndex: $1363e2a0573b425c$var$_traverseWithIndex(O)
    };
};
$1363e2a0573b425c$exports.getTraversableWithIndex = $1363e2a0573b425c$var$getTraversableWithIndex;
/**
 * @category filtering
 * @since 2.11.0
 */ var $1363e2a0573b425c$var$getWitherable = function(O) {
    var T = (0, $1363e2a0573b425c$exports.getTraversable)(O);
    return {
        URI: $1363e2a0573b425c$exports.URI,
        map: $1363e2a0573b425c$var$_map,
        reduce: $1363e2a0573b425c$var$_reduce(O),
        foldMap: $1363e2a0573b425c$var$_foldMap(O),
        reduceRight: $1363e2a0573b425c$var$_reduceRight(O),
        traverse: T.traverse,
        sequence: T.sequence,
        compact: $1363e2a0573b425c$exports.compact,
        separate: $1363e2a0573b425c$exports.separate,
        filter: $1363e2a0573b425c$var$_filter,
        filterMap: $1363e2a0573b425c$var$_filterMap,
        partition: $1363e2a0573b425c$var$_partition,
        partitionMap: $1363e2a0573b425c$var$_partitionMap,
        wither: (0, $4p4Yq.witherDefault)(T, $1363e2a0573b425c$exports.Compactable),
        wilt: (0, $4p4Yq.wiltDefault)(T, $1363e2a0573b425c$exports.Compactable)
    };
};
$1363e2a0573b425c$exports.getWitherable = $1363e2a0573b425c$var$getWitherable;
/**
 * Given a `Semigroup` in the base type, it produces a `Semigroup`
 * in the `Record` of the base type.
 * The resulting `Semigroup` concatenates two `Record`s by
 * `union`.
 *
 * @example
 * import { getUnionSemigroup } from "fp-ts/Record"
 * import { Semigroup } from "fp-ts/Semigroup"
 *
 * const sNumber: Semigroup<number> = { concat: (x, y) => x - y };
 * const sRecord: Semigroup<Record<string, number>> = getUnionSemigroup(sNumber);
 * assert.deepStrictEqual(sRecord.concat({ a: 1, b: 2 }, { b: 3, c: 4 }), { a: 1, b: -1, c: 4 });
 *
 * @category instances
 * @since 2.11.0
 */ var $1363e2a0573b425c$var$getUnionSemigroup = function(S) {
    var unionS = (0, $1363e2a0573b425c$exports.union)(S);
    return {
        concat: function(first, second) {
            return unionS(second)(first);
        }
    };
};
$1363e2a0573b425c$exports.getUnionSemigroup = $1363e2a0573b425c$var$getUnionSemigroup;
/**
 * Same as `getMonoid`.
 * Returns a `Monoid` instance for `Record`s given a `Semigroup`
 * instance for the base type.
 * The `Monoid` makes the union of two `Record`s combining the
 * entries that have the same key with the provided `Semigroup`.
 *
 * @example
 * import { SemigroupSum } from 'fp-ts/number'
 * import { getUnionMonoid } from 'fp-ts/Record'
 *
 * const M = getUnionMonoid(SemigroupSum);
 * assert.deepStrictEqual(M.concat({ foo: 123, bar: 234 }, { foo: 456, baz: 567 }), { foo: 579 , bar: 234, baz: 567 });
 *
 * @category instances
 * @since 2.11.0
 */ var $1363e2a0573b425c$var$getUnionMonoid = function(S) {
    return {
        concat: (0, $1363e2a0573b425c$exports.getUnionSemigroup)(S).concat,
        empty: {}
    };
};
$1363e2a0573b425c$exports.getUnionMonoid = $1363e2a0573b425c$var$getUnionMonoid;
/**
 * Given a `Semigroup` in the base type, it produces a `Semigroup`
 * in the `Record` of the base type.
 * The resulting `Semigroup` concatenates two `Record`s by
 * `intersection`.
 *
 * @example
 * import { getIntersectionSemigroup } from "fp-ts/Record"
 * import { Semigroup } from "fp-ts/Semigroup"
 *
 * const sNumber: Semigroup<number> = { concat: (x, y) => x - y };
 * const sRecord: Semigroup<Record<string, number>> = getIntersectionSemigroup(sNumber);
 * assert.deepStrictEqual(sRecord.concat({ a: 1, b: 2 }, { b: 3, c: 4 }), { b: -1 });
 *
 * @category instances
 * @since 2.11.0
 */ var $1363e2a0573b425c$var$getIntersectionSemigroup = function(S) {
    var intersectionS = (0, $1363e2a0573b425c$exports.intersection)(S);
    return {
        concat: function(first, second) {
            return intersectionS(second)(first);
        }
    };
};
$1363e2a0573b425c$exports.getIntersectionSemigroup = $1363e2a0573b425c$var$getIntersectionSemigroup;
/**
 * Produces a `Magma` with a `concat` function that combines
 * two `Record`s by making the `difference`.
 *
 * @example
 * import { getDifferenceMagma, difference } from "fp-ts/Record"
 * import { Magma } from "fp-ts/Magma"
 *
 * const r1 = { a: 3, c: 3 };
 * const r2 = { a: 1, b: 2 };
 * const m: Magma<Record<string, number>> = getDifferenceMagma<number>();
 * assert.deepStrictEqual(m.concat(r1, r2), difference(r2)(r1));
 * assert.deepStrictEqual(m.concat(r1, r2), { c: 3, b: 2 });
 *
 * @category instances
 * @since 2.11.0
 */ var $1363e2a0573b425c$var$getDifferenceMagma = function() {
    return {
        concat: function(first, second) {
            return (0, $1363e2a0573b425c$exports.difference)(second)(first);
        }
    };
};
$1363e2a0573b425c$exports.getDifferenceMagma = $1363e2a0573b425c$var$getDifferenceMagma;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * Use `getFoldable` instead.
 *
 * @category zone of death
 * @since 2.7.0
 * @deprecated
 */ $1363e2a0573b425c$exports.Foldable = {
    URI: $1363e2a0573b425c$exports.URI,
    reduce: /*#__PURE__*/ $1363e2a0573b425c$var$_reduce($1363e2a0573b425c$var$S.Ord),
    foldMap: /*#__PURE__*/ $1363e2a0573b425c$var$_foldMap($1363e2a0573b425c$var$S.Ord),
    reduceRight: /*#__PURE__*/ $1363e2a0573b425c$var$_reduceRight($1363e2a0573b425c$var$S.Ord)
};
/**
 * Use `getFoldableWithIndex` instead.
 *
 * @category zone of death
 * @since 2.7.0
 * @deprecated
 */ $1363e2a0573b425c$exports.FoldableWithIndex = {
    URI: $1363e2a0573b425c$exports.URI,
    reduce: /*#__PURE__*/ $1363e2a0573b425c$var$_reduce($1363e2a0573b425c$var$S.Ord),
    foldMap: /*#__PURE__*/ $1363e2a0573b425c$var$_foldMap($1363e2a0573b425c$var$S.Ord),
    reduceRight: /*#__PURE__*/ $1363e2a0573b425c$var$_reduceRight($1363e2a0573b425c$var$S.Ord),
    reduceWithIndex: /*#__PURE__*/ $1363e2a0573b425c$var$_reduceWithIndex($1363e2a0573b425c$var$S.Ord),
    foldMapWithIndex: /*#__PURE__*/ $1363e2a0573b425c$var$_foldMapWithIndex($1363e2a0573b425c$var$S.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $1363e2a0573b425c$var$_reduceRightWithIndex($1363e2a0573b425c$var$S.Ord)
};
/**
 * Use `getTraversable` instead.
 *
 * @category zone of death
 * @since 2.7.0
 * @deprecated
 */ $1363e2a0573b425c$exports.Traversable = {
    URI: $1363e2a0573b425c$exports.URI,
    map: $1363e2a0573b425c$var$_map,
    reduce: /*#__PURE__*/ $1363e2a0573b425c$var$_reduce($1363e2a0573b425c$var$S.Ord),
    foldMap: /*#__PURE__*/ $1363e2a0573b425c$var$_foldMap($1363e2a0573b425c$var$S.Ord),
    reduceRight: /*#__PURE__*/ $1363e2a0573b425c$var$_reduceRight($1363e2a0573b425c$var$S.Ord),
    traverse: /*#__PURE__*/ $1363e2a0573b425c$var$_traverse($1363e2a0573b425c$var$S.Ord),
    sequence: $1363e2a0573b425c$var$sequence
};
/**
 * Use the `getTraversableWithIndex` instead.
 *
 * @category zone of death
 * @since 2.7.0
 * @deprecated
 */ $1363e2a0573b425c$exports.TraversableWithIndex = {
    URI: $1363e2a0573b425c$exports.URI,
    map: $1363e2a0573b425c$var$_map,
    mapWithIndex: $1363e2a0573b425c$var$_mapWithIndex,
    reduce: /*#__PURE__*/ $1363e2a0573b425c$var$_reduce($1363e2a0573b425c$var$S.Ord),
    foldMap: /*#__PURE__*/ $1363e2a0573b425c$var$_foldMap($1363e2a0573b425c$var$S.Ord),
    reduceRight: /*#__PURE__*/ $1363e2a0573b425c$var$_reduceRight($1363e2a0573b425c$var$S.Ord),
    reduceWithIndex: /*#__PURE__*/ $1363e2a0573b425c$var$_reduceWithIndex($1363e2a0573b425c$var$S.Ord),
    foldMapWithIndex: /*#__PURE__*/ $1363e2a0573b425c$var$_foldMapWithIndex($1363e2a0573b425c$var$S.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $1363e2a0573b425c$var$_reduceRightWithIndex($1363e2a0573b425c$var$S.Ord),
    traverse: /*#__PURE__*/ $1363e2a0573b425c$var$_traverse($1363e2a0573b425c$var$S.Ord),
    sequence: $1363e2a0573b425c$var$sequence,
    traverseWithIndex: /*#__PURE__*/ $1363e2a0573b425c$var$_traverseWithIndex($1363e2a0573b425c$var$S.Ord)
};
var $1363e2a0573b425c$var$_wither = /*#__PURE__*/ (0, $4p4Yq.witherDefault)($1363e2a0573b425c$exports.Traversable, $1363e2a0573b425c$exports.Compactable);
var $1363e2a0573b425c$var$_wilt = /*#__PURE__*/ (0, $4p4Yq.wiltDefault)($1363e2a0573b425c$exports.Traversable, $1363e2a0573b425c$exports.Compactable);
/**
 * Use `getWitherable` instead.
 *
 * @category zone of death
 * @since 2.7.0
 * @deprecated
 */ $1363e2a0573b425c$exports.Witherable = {
    URI: $1363e2a0573b425c$exports.URI,
    map: $1363e2a0573b425c$var$_map,
    reduce: /*#__PURE__*/ $1363e2a0573b425c$var$_reduce($1363e2a0573b425c$var$S.Ord),
    foldMap: /*#__PURE__*/ $1363e2a0573b425c$var$_foldMap($1363e2a0573b425c$var$S.Ord),
    reduceRight: /*#__PURE__*/ $1363e2a0573b425c$var$_reduceRight($1363e2a0573b425c$var$S.Ord),
    traverse: /*#__PURE__*/ $1363e2a0573b425c$var$_traverse($1363e2a0573b425c$var$S.Ord),
    sequence: $1363e2a0573b425c$var$sequence,
    compact: $1363e2a0573b425c$exports.compact,
    separate: $1363e2a0573b425c$exports.separate,
    filter: $1363e2a0573b425c$var$_filter,
    filterMap: $1363e2a0573b425c$var$_filterMap,
    partition: $1363e2a0573b425c$var$_partition,
    partitionMap: $1363e2a0573b425c$var$_partitionMap,
    wither: $1363e2a0573b425c$var$_wither,
    wilt: $1363e2a0573b425c$var$_wilt
};
/**
 * Use a new `{}` instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ $1363e2a0573b425c$exports.empty = {};
/**
 * Use [`upsertAt`](#upsertat) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ $1363e2a0573b425c$exports.insertAt = $1363e2a0573b425c$exports.upsertAt;
/**
 * Use [`has`](#has) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ $1363e2a0573b425c$exports.hasOwnProperty = $1363e2a0573b425c$var$RR.hasOwnProperty;
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Functor` instance, pass `R.Functor` instead of `R.record`
 * (where `R` is from `import R from 'fp-ts/Record'`)
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ $1363e2a0573b425c$exports.record = {
    URI: $1363e2a0573b425c$exports.URI,
    map: $1363e2a0573b425c$var$_map,
    reduce: /*#__PURE__*/ $1363e2a0573b425c$var$_reduce($1363e2a0573b425c$var$S.Ord),
    foldMap: /*#__PURE__*/ $1363e2a0573b425c$var$_foldMap($1363e2a0573b425c$var$S.Ord),
    reduceRight: /*#__PURE__*/ $1363e2a0573b425c$var$_reduceRight($1363e2a0573b425c$var$S.Ord),
    traverse: /*#__PURE__*/ $1363e2a0573b425c$var$_traverse($1363e2a0573b425c$var$S.Ord),
    sequence: $1363e2a0573b425c$var$sequence,
    compact: $1363e2a0573b425c$exports.compact,
    separate: $1363e2a0573b425c$exports.separate,
    filter: $1363e2a0573b425c$var$_filter,
    filterMap: $1363e2a0573b425c$var$_filterMap,
    partition: $1363e2a0573b425c$var$_partition,
    partitionMap: $1363e2a0573b425c$var$_partitionMap,
    mapWithIndex: $1363e2a0573b425c$var$_mapWithIndex,
    reduceWithIndex: /*#__PURE__*/ $1363e2a0573b425c$var$_reduceWithIndex($1363e2a0573b425c$var$S.Ord),
    foldMapWithIndex: /*#__PURE__*/ $1363e2a0573b425c$var$_foldMapWithIndex($1363e2a0573b425c$var$S.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $1363e2a0573b425c$var$_reduceRightWithIndex($1363e2a0573b425c$var$S.Ord),
    filterMapWithIndex: $1363e2a0573b425c$var$_filterMapWithIndex,
    filterWithIndex: $1363e2a0573b425c$var$_filterWithIndex,
    partitionMapWithIndex: $1363e2a0573b425c$var$_partitionMapWithIndex,
    partitionWithIndex: $1363e2a0573b425c$var$_partitionWithIndex,
    traverseWithIndex: /*#__PURE__*/ $1363e2a0573b425c$var$_traverseWithIndex($1363e2a0573b425c$var$S.Ord),
    wither: $1363e2a0573b425c$var$_wither,
    wilt: $1363e2a0573b425c$var$_wilt
};



var $hBXBN = parcelRequire("hBXBN");
/**
 * Fetch drawings from Silica.
 *
 * @since 0.1.0
 */ 


/**
 * Calculation requests to Silica.
 *
 * @since 0.1.0
 */ 
/**
 * Client Facing Messages
 *
 * @since 0.4.0
 */ 
const $8ea287ed6a1d6b5d$export$a1acd213b060f8cd = (0, $87701c398fec8638$export$7e1278799275f68e)({
    info: true,
    warning: true,
    error: true
});
const $8ea287ed6a1d6b5d$export$f69c19e57285b83a = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    level: $8ea287ed6a1d6b5d$export$a1acd213b060f8cd,
    text: (0, $87701c398fec8638$export$22b082955e083ec3)
});


const $3af43b025e4dfccf$export$42bfa9b2d4dad91a = (req)=>(want, codecT)=>req.request((0, $87701c398fec8638$export$bc86dfbf7795668c)([
            codecT,
            $3af43b025e4dfccf$export$e6db9f12b0eff880
        ]))('calc/shower', 'POST', want);
const $3af43b025e4dfccf$export$b3fe3ca90b75e2ea = (codecS, codecT)=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        (0, $87701c398fec8638$export$9d93593e0583cfae),
        codecS,
        codecT
    ]);
const $3af43b025e4dfccf$export$e6db9f12b0eff880 = (0, $87701c398fec8638$export$e45945969df8035a)({
    messages: (0, $87701c398fec8638$export$2f23118c22fb2630)((0, $8ea287ed6a1d6b5d$export$f69c19e57285b83a))
});


/**
 * Projections.
 *
 * @since 0.1.0
 */ 

const $6bf252fd3b9e3e1f$export$21aac317b2cc5cc3 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Flat')
});
const $6bf252fd3b9e3e1f$export$af7a23dd79a12b07 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('FloorPlan')
});
const $6bf252fd3b9e3e1f$export$6ed3d3a10e06e6d7 = (0, $87701c398fec8638$export$bc86dfbf7795668c)([
    (0, $87701c398fec8638$export$bf9fb029d174d554)({
        type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Isometric')
    }),
    (0, $87701c398fec8638$export$e45945969df8035a)({
        Rotate: (0, $0b3a4acf236478d7$export$6cdc1cb9345ffadf)
    })
]);
const $6bf252fd3b9e3e1f$export$dfa3a012bb2ef2e1 = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    $6bf252fd3b9e3e1f$export$21aac317b2cc5cc3,
    $6bf252fd3b9e3e1f$export$af7a23dd79a12b07,
    $6bf252fd3b9e3e1f$export$6ed3d3a10e06e6d7
]);
const $6bf252fd3b9e3e1f$export$d1aeeeccadc876de = (0, $87701c398fec8638$export$7e1278799275f68e)({
    Isometric: true,
    FloorPlan: true,
    Flat: true
});
const $6bf252fd3b9e3e1f$export$c0e8bbab2e538679 = {
    Isometric: 'Isometric',
    FloorPlan: 'Floor Plan',
    Flat: 'Flat'
};


const $024bf0fd6c0169f2$export$b25a33d1d8eb4655 = (req)=>(opening, drawings)=>(0, $3af43b025e4dfccf$export$42bfa9b2d4dad91a)(req)({
            silicaOpening: opening,
            silicaDrawings: drawings
        }, $024bf0fd6c0169f2$export$16601530c8f94d82).then(({ silicaDrawings: silicaDrawings, messages: messages })=>(0, $87701c398fec8638$export$2f23118c22fb2630)((0, $87701c398fec8638$export$22b082955e083ec3)).is(silicaDrawings) && silicaDrawings.length === drawings.length ? Promise.resolve(silicaDrawings) : Promise.reject({
                error: 'Failed to receive correct drawings',
                messages: messages
            }));
const $024bf0fd6c0169f2$export$8a2243cf33d62845 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Opening'),
    Projection: (0, $6bf252fd3b9e3e1f$export$dfa3a012bb2ef2e1),
    CurbEdges: (0, $87701c398fec8638$export$4a21f16c33752377),
    DrawFloor: (0, $87701c398fec8638$export$4a21f16c33752377),
    RulerDirection: (0, $87701c398fec8638$export$7e1278799275f68e)({
        out: null,
        away: null
    })
});
const $024bf0fd6c0169f2$export$5c680799be07c2e3 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Panels'),
    Projection: (0, $6bf252fd3b9e3e1f$export$dfa3a012bb2ef2e1)
});
const $024bf0fd6c0169f2$export$dca20402ebea5ece = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    $024bf0fd6c0169f2$export$8a2243cf33d62845,
    $024bf0fd6c0169f2$export$5c680799be07c2e3
]);
const $024bf0fd6c0169f2$export$16601530c8f94d82 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    silicaOpening: (0, $3af43b025e4dfccf$export$b3fe3ca90b75e2ea)((0, $24396fcf7207086e$export$428ef1f8ddd66578), (0, $3ed4c97548491c68$export$605846925e53c7e7)),
    silicaDrawings: (0, $3af43b025e4dfccf$export$b3fe3ca90b75e2ea)((0, $87701c398fec8638$export$2f23118c22fb2630)($024bf0fd6c0169f2$export$dca20402ebea5ece), (0, $87701c398fec8638$export$2f23118c22fb2630)((0, $87701c398fec8638$export$22b082955e083ec3)))
});



const $51c3da3432a3b533$var$useDrawingViewer = (req, value, projection, drawingsArray)=>{
    const [lastHash, setLastHash] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [lastDrawing, setLastDrawing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [drawings, setDrawings] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [svgInner, setSvgInner] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const hashKey = Math.random();
    const getDrawing = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((hash)=>(0, $3abDJ.pipe)(drawings, $1363e2a0573b425c$exports.lookup(hash), $hBXBN.chain($hBXBN.fromNullable), $hBXBN.fold(()=>(0, $024bf0fd6c0169f2$export$b25a33d1d8eb4655)(req)(value, drawingsArray).then((silicaDrawings)=>{
                const drawing = silicaDrawings[0];
                if (drawing === undefined) return Promise.reject(new Error('No drawings.'));
                setDrawings((prev)=>({
                        ...prev,
                        [hash]: drawing
                    }));
                return drawing;
            }), (s)=>Promise.resolve(s))), [
        drawings,
        req,
        value,
        drawingsArray
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        // This should hold everything that the drawing returned by the server depends on.
        const drawingDependant = {
            projection: projection,
            opening: value
        };
        const drawHash = (0, $ca0affc99e9d76c6$export$d6af199866bfb566)(hashKey)(drawingDependant);
        if (drawHash === lastHash) return;
        getDrawing(drawHash).then((drawing)=>{
            setLastHash(drawHash);
            setLastDrawing(drawing);
        });
    }, [
        getDrawing,
        lastHash,
        projection,
        value,
        hashKey
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (lastDrawing) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(lastDrawing, 'application/xml');
            const svg = doc.querySelector('svg');
            setSvgInner(svg?.innerHTML || '');
        }
    }, [
        lastDrawing
    ]);
    return {
        svgInner: svgInner,
        hashKey: hashKey
    };
};
var $51c3da3432a3b533$export$2e2bcd8739ae039 = $51c3da3432a3b533$var$useDrawingViewer;


const $d9a024fae628eb36$export$9c6d46f8824eeb0f = (ac)=>(el)=>(id)=>{
            if (id.endsWith('-Angle-lbl')) return ac.build(el);
            return null;
        };
const $d9a024fae628eb36$export$1a9db84504b4086f = (lc)=>(el)=>(id)=>{
            if (id.endsWith('-Measure-lbl') || id.endsWith('-Edge-lbl') || id.endsWith('-EdgeMeasuredLine-lbl') || id.endsWith('EdgeBredth-lbl') || id.endsWith('-Minor-lbl') || id.endsWith('-EdgeHeight-lbl') || id.endsWith('-EdgeOuterHeight-lbl')) return lc.build(el);
            return null;
        };
const $d9a024fae628eb36$var$WallViewer = ({ req: req, value: value, projection: projection, visible: visible, lengthConverter: lengthConverter, angleConverter: angleConverter, space: space, activeElementId: activeElementId, onDown: onDown, angle: angle, updateAngle: updateAngle, updateWall: updateWall, trackingAngle: trackingAngle, updateTrackingAngle: updateTrackingAngle, ...props })=>{
    const { ref: ref } = (0, $c49fcf209b4b4b92$export$2e2bcd8739ae039)(updateAngle, angle, updateTrackingAngle, trackingAngle);
    const { viewBox: viewBox, containerRef: containerRef, zooming: zooming, ...mouseHandlers } = (0, $1c171a81388d816c$export$2e2bcd8739ae039)(onDown, activeElementId);
    const { svgInner: svgInner, hashKey: hashKey } = (0, $51c3da3432a3b533$export$2e2bcd8739ae039)(req, value, projection, [
        {
            type: 'Opening',
            Projection: projection,
            RulerDirection: projection.type == 'Flat' ? 'away' : 'out',
            CurbEdges: projection.type === 'FloorPlan',
            DrawFloor: projection.type === 'FloorPlan' // remove?
        }
    ]);
    $acw62.useEffect(()=>{
        if (zooming) updateWall((0, $3fac04c221567571$export$38d827c6ff272312));
    }, [
        zooming,
        updateWall
    ]);
    $acw62.useEffect(()=>{
        if (containerRef?.current) (0, $5ef56094387f3e7e$export$da227b5f76807204)((0, $5ef56094387f3e7e$export$2ce4735ffca1427e)(value)($d9a024fae628eb36$export$1a9db84504b4086f(lengthConverter)))(containerRef?.current);
    }, [
        lengthConverter,
        svgInner,
        value,
        containerRef
    ]);
    $acw62.useEffect(()=>{
        if (containerRef?.current) (0, $5ef56094387f3e7e$export$da227b5f76807204)((0, $5ef56094387f3e7e$export$2ce4735ffca1427e)(value)($d9a024fae628eb36$export$9c6d46f8824eeb0f(angleConverter)))(containerRef?.current);
    }, [
        angleConverter,
        svgInner,
        value,
        containerRef
    ]);
    const propHash = (0, $ca0affc99e9d76c6$export$d6af199866bfb566)(hashKey)({
        req: req,
        value: value,
        projection: projection,
        visible: visible,
        onDown: onDown,
        ...props
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        id: (0, $3fac04c221567571$export$82687d13756d4b3d),
        ref: containerRef,
        className: `hash-${propHash} drawing`,
        sx: {
            width: '100%',
            flexGrow: 1
        },
        ...mouseHandlers,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            ref: ref,
            component: "svg",
            dangerouslySetInnerHTML: {
                __html: svgInner
            },
            sx: {
                [`& #${activeElementId}`]: {
                    stroke: (0, $dMYym.default)[300],
                    strokeOpacity: 0.5,
                    fill: (0, $dMYym.default)[300]
                }
            },
            viewBox: `${viewBox.x} ${viewBox.y} ${viewBox.w} ${viewBox.h}`
        })
    });
};
var $d9a024fae628eb36$export$2e2bcd8739ae039 = $d9a024fae628eb36$var$WallViewer;


/**
 * Piemenu.
 *
 * @since 0.2.0
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $3ErGR = parcelRequire("3ErGR");

var $bKnBV = parcelRequire("bKnBV");
var $eU5ou = parcelRequire("eU5ou");

var $3abDJ = parcelRequire("3abDJ");

var $acw62 = parcelRequire("acw62");

var $hBXBN = parcelRequire("hBXBN");

var $4ZBbi = parcelRequire("4ZBbi");

var $b25hP = parcelRequire("b25hP");





const $3a7a8634e41a2445$var$actClick = (entry)=>(e)=>{
        e.preventDefault();
        entry.onSelect({
            x: e.clientX,
            y: e.clientY
        });
    };
const $3a7a8634e41a2445$var$actTouch = (entry)=>(e)=>{
        e.stopPropagation();
        (0, $3abDJ.pipe)(e.touches[0], $hBXBN.fromNullable, $hBXBN.fold((0, $3abDJ.constant)(null), (touch)=>{
            entry.onSelect({
                x: touch.clientX,
                y: touch.clientX
            });
        }));
    };
const $3a7a8634e41a2445$var$actKeyDown = (entry)=>(e)=>{
        e.preventDefault();
        entry.onSelect({
            x: e.currentTarget.getBoundingClientRect().x,
            y: e.currentTarget.getBoundingClientRect().y
        });
    };
const $3a7a8634e41a2445$var$handleSliceKeydown = (onClose)=>(onEnter)=>(event)=>{
            switch(event.key){
                case 'Enter':
                    onEnter(event);
                    break;
                case 'Escape':
                    onClose();
                    break;
                default:
            }
        };
const $3a7a8634e41a2445$var$parity = (i)=>i % 2 === 0 ? 'even' : 'odd';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3a7a8634e41a2445$var$buildIcon = (icon)=>typeof icon === 'string' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("text", {
        alignmentBaseline: "middle",
        textAnchor: "middle",
        children: [
            " ",
            icon,
            " "
        ]
    }) : icon;
const $3a7a8634e41a2445$var$generateEntrySliceArray = (0, $3abDJ.flow)($hBXBN.fromNullable, $hBXBN.map((a)=>a.length < 8 ? $4ZBbi.concatW($4ZBbi.replicate(8 - a.length, null))(a) : a));
const $3a7a8634e41a2445$var$getFillColor = (parity)=>parity === 'even' ? (0, $eU5ou.default)[100] : (0, $bKnBV.default)[100];
const $3a7a8634e41a2445$var$handleRotationChange = (num1, num2)=>(f)=>(0, $3abDJ.pipe)(num1, $hBXBN.fromNullable, $hBXBN.fold(()=>(0, $3abDJ.pipe)(num2, $hBXBN.fromNullable, $hBXBN.fold((0, $3abDJ.constant)(null), f)), (a)=>(0, $3abDJ.pipe)(num2, $hBXBN.fromNullable, $hBXBN.fold(f, (a2)=>(0, $3abDJ.pipe)($b25hP.Eq.equals(a, a2), $29b3dcb11c87a56f$exports.fold(f, (0, $3abDJ.constant)(null)))))));
const $3a7a8634e41a2445$var$rangeAnd = (range)=>(angle)=>angle > range[0] && angle < range[1];
const $3a7a8634e41a2445$var$rangeOr = (range)=>(angle)=>angle > range[0] || angle < range[1];
const $3a7a8634e41a2445$var$angleIndexMap = {
    4: $3a7a8634e41a2445$var$rangeAnd([
        -22.5,
        22.5
    ]),
    3: $3a7a8634e41a2445$var$rangeAnd([
        22.5,
        67.5
    ]),
    2: $3a7a8634e41a2445$var$rangeAnd([
        67.5,
        112.5
    ]),
    1: $3a7a8634e41a2445$var$rangeAnd([
        112.5,
        157.5
    ]),
    0: $3a7a8634e41a2445$var$rangeOr([
        157.5,
        -157.5
    ]),
    7: $3a7a8634e41a2445$var$rangeAnd([
        -157.5,
        -112.5
    ]),
    6: $3a7a8634e41a2445$var$rangeAnd([
        -112.5,
        -67.5
    ]),
    5: $3a7a8634e41a2445$var$rangeAnd([
        -67.5,
        -22.5
    ])
};
const $3a7a8634e41a2445$var$PieMenu = ({ onClose: onClose, x: x, y: y, drawingRotation: drawingRotation, updateOpening: updateOpening, angleConverter: angleConverter, lengthConverter: lengthConverter, entries: entries, angle: angle, updateAngle: updateAngle, trackingAngle: trackingAngle = null, updateTrackingAngle: updateTrackingAngle, ...props })=>{
    const [rotationShadow, setRotationShadow] = $acw62.useState((0, $be9adc3c682f2c7a$export$138306ecf3692138));
    $acw62.useEffect(()=>{
        if (angle && updateAngle) {
            updateAngle(()=>null);
            if (entries?.length && entries.length > 0) {
                if (angle > -22.5 && angle < 22.5) entries[4]?.onSelect({
                    x: x,
                    y: y
                });
                if (angle > 22.5 && angle < 67.5) entries[3]?.onSelect({
                    x: x,
                    y: y
                });
                if (angle > 67.5 && angle < 112.5) entries[2]?.onSelect({
                    x: x,
                    y: y
                });
                if (angle > 112.5 && angle < 157.5) entries[1]?.onSelect({
                    x: x,
                    y: y
                });
                if (angle > 157.5 || angle < -157.5) entries[0]?.onSelect({
                    x: x,
                    y: y
                });
                if (angle > -157.5 && angle < -112.5) entries[7]?.onSelect({
                    x: x,
                    y: y
                });
                if (angle > -112.5 && angle < -67.5) entries[6]?.onSelect({
                    x: x,
                    y: y
                });
                if (angle > -67.5 && angle < -22.5) entries[5]?.onSelect({
                    x: x,
                    y: y
                });
            }
        }
    }, [
        angle,
        entries,
        x,
        y,
        updateAngle
    ]);
    $acw62.useEffect(()=>{
        setRotationShadow(drawingRotation);
    }, [
        drawingRotation
    ]);
    $acw62.useEffect(()=>{
        $3a7a8634e41a2445$var$handleRotationChange(drawingRotation, rotationShadow)(onClose);
    }, [
        drawingRotation,
        rotationShadow,
        onClose
    ]);
    const r = props.radius ?? 120;
    const dia = 2 * r;
    const [position, setPosition] = $acw62.useState({
        x: 0,
        y: 0
    });
    $acw62.useEffect(()=>{
        setPosition({
            x: x,
            y: y
        });
    }, [
        x,
        y
    ]);
    const style = {
        left: position.x - r,
        top: position.y - r
    };
    const entry = (i, entry)=>/*#__PURE__*/ (0, $ayMG0.jsx)($3a7a8634e41a2445$var$Slice, {
            onClose: onClose,
            title: entry?.title,
            icon: entry?.icon,
            i: i,
            r: r,
            actClick: $3a7a8634e41a2445$var$actClick(entry || {
                icon: '',
                onSelect: onClose
            }),
            actTouch: $3a7a8634e41a2445$var$actTouch(entry || {
                icon: '',
                onSelect: onClose
            }),
            actKeyDown: $3a7a8634e41a2445$var$actKeyDown(entry || {
                icon: '',
                onSelect: onClose
            }),
            movingAngle: trackingAngle,
            range: $3a7a8634e41a2445$var$angleIndexMap[i]
        }, entry?.title);
    const drawingEl = document.getElementById((0, $3fac04c221567571$export$82687d13756d4b3d));
    // Close the pie if mounted and user presses 'Escape' key
    $acw62.useEffect(()=>{
        function handleKeyDown(event) {
            if (event.key === 'Escape') onClose();
        }
        if (drawingEl) {
            drawingEl.addEventListener('keydown', handleKeyDown);
            drawingEl.addEventListener('wheel', onClose, {
                passive: true
            });
            drawingEl.addEventListener('mousedown', onClose);
            drawingEl.addEventListener('touchstart', onClose);
            return ()=>{
                drawingEl.removeEventListener('keydown', handleKeyDown);
                drawingEl.removeEventListener('wheel', onClose);
                drawingEl.removeEventListener('mousedown', onClose);
                drawingEl.removeEventListener('touchstart', onClose);
            };
        }
        return;
    }, [
        onClose,
        drawingEl
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ErGR.default), {
        onWheel: onClose,
        name: "PieMenu",
        sx: {
            height: dia,
            width: dia,
            fontSize: '14px',
            fontFamily: '"Poppins", sans-serif'
        },
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: `-${r + 1} -${r + 1} ${dia + 2} ${dia + 2}`,
        className: 'PieMenu',
        style: style,
        children: [
            updateAngle && updateTrackingAngle ? /*#__PURE__*/ (0, $ayMG0.jsx)($3a7a8634e41a2445$var$PieHole, {
                trackingAngle: trackingAngle,
                updateTrackingAngle: updateTrackingAngle,
                updateAngle: updateAngle,
                value: angle,
                radius: r
            }) : null,
            (0, $3abDJ.pipe)(entries, $hBXBN.fromNullable, $hBXBN.chain($3a7a8634e41a2445$var$generateEntrySliceArray), $hBXBN.foldW(()=>$4ZBbi.replicate(8, null), $4ZBbi.mapWithIndex(entry)))
        ]
    });
};
const $3a7a8634e41a2445$var$Slice = ({ i: i, r: r, title: title, icon: icon, onClose: onClose, actClick: actClick, actTouch: actTouch, actKeyDown: actKeyDown, range: range, movingAngle: movingAngle })=>{
    const n = 8;
    const theta = (i - 0.5) * 2 * Math.PI / n;
    const phi = (i + 0.5) * 2 * Math.PI / n;
    const ir = r / 3;
    const ps = [
        [
            theta,
            r
        ],
        [
            phi,
            r
        ],
        [
            phi,
            ir
        ],
        [
            theta,
            ir
        ],
        [
            (theta + phi) / 2,
            (ir + r) / 2
        ]
    ];
    const x = ps.map(([ang, m])=>(-Math.cos(ang) * m).toFixed(6));
    const y = ps.map(([ang, m])=>(Math.sin(ang) * m).toFixed(6));
    const ix = x[4];
    const iy = y[4];
    const ref = $acw62.useRef(null);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                style: {
                    filter: movingAngle && range && range(movingAngle) ? 'brightness(0.8)' : ''
                },
                ref: ref,
                name: title,
                onTouchEnd: actTouch,
                onMouseUp: actClick,
                onKeyUp: $3a7a8634e41a2445$var$handleSliceKeydown(onClose)(actKeyDown),
                tabIndex: 1,
                d: `M ${x[0]} ${y[0]} A ${r} ${r} 0 0 0 ${x[1]} ${y[1]} ` + `L ${x[2]} ${y[2]} A ${ir} ${ir} 0 0 1 ${x[3]} ${y[3]} z`,
                className: 'PieSlice',
                fill: (0, $3abDJ.pipe)(i, $3a7a8634e41a2445$var$parity, $3a7a8634e41a2445$var$getFillColor),
                children: title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                    children: title
                }) : null
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                transform: `translate(${ix} ${iy})`,
                children: $3a7a8634e41a2445$var$buildIcon(icon)
            })
        ]
    });
};
const $3a7a8634e41a2445$var$PieHole = ({ radius: radius, value: value = null, updateAngle: updateAngle, trackingAngle: trackingAngle = null, updateTrackingAngle: updateTrackingAngle })=>{
    const { ref: ref } = (0, $c49fcf209b4b4b92$export$2e2bcd8739ae039)(updateAngle, value, updateTrackingAngle, trackingAngle);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
        ref: ref,
        tabIndex: 2,
        className: 'PieHole',
        r: radius / 3
    }, -1);
};
var $3a7a8634e41a2445$export$2e2bcd8739ae039 = $3a7a8634e41a2445$var$PieMenu;


/**
 * TexModal.
 *
 * @since 0.2.0
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * Generic Dialog.
 *
 * @since 0.2.0
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $jTnBY = parcelRequire("jTnBY");




var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c5762e789acf7dcc$export$2177af0aa15c34c2(slot) {
    return (0, $4Cod0.default)('MuiDialog', slot);
}
const $c5762e789acf7dcc$var$dialogClasses = (0, $beCSm.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $c5762e789acf7dcc$export$2e2bcd8739ae039 = $c5762e789acf7dcc$var$dialogClasses;



var $acw62 = parcelRequire("acw62");
const $68187f174395cd28$var$DialogContext = /*#__PURE__*/ $acw62.createContext({});
var $68187f174395cd28$export$2e2bcd8739ae039 = $68187f174395cd28$var$DialogContext;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4f13784bd714c44e$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $4f13784bd714c44e$var$DialogBackdrop = (0, $d8seH.default)((0, $4838e5a14e330013$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $4f13784bd714c44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $jTnBY.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $jTnBY.default)(scroll)}`,
            `paperWidth${(0, $jTnBY.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c5762e789acf7dcc$export$2177af0aa15c34c2), classes);
};
const $4f13784bd714c44e$var$DialogRoot = (0, $d8seH.default)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $4f13784bd714c44e$var$DialogContainer = (0, $d8seH.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $jTnBY.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $4f13784bd714c44e$var$DialogPaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $jTnBY.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $jTnBY.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $4f13784bd714c44e$var$Dialog = /*#__PURE__*/ $acw62.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $595185d0d7275c3b$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $5e5a92158e7d9bd4$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $4f13784bd714c44e$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $4f13784bd714c44e$var$useUtilityClasses(ownerState);
    const backdropClick = $acw62.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $acw62.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $4f13784bd714c44e$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $8nd05.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogContainer, {
                className: (0, $9QePP.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogPaper, (0, $8nd05.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $9QePP.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68187f174395cd28$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $4f13784bd714c44e$export$2e2bcd8739ae039 = $4f13784bd714c44e$var$Dialog;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f2e7257b2514744a$export$f5d2ec7e4c47e088(slot) {
    return (0, $4Cod0.default)('MuiDialogTitle', slot);
}
const $f2e7257b2514744a$var$dialogTitleClasses = (0, $beCSm.default)('MuiDialogTitle', [
    'root'
]);
var $f2e7257b2514744a$export$2e2bcd8739ae039 = $f2e7257b2514744a$var$dialogTitleClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a6ac58aca374c76c$var$_excluded = [
    "className",
    "id"
];
const $a6ac58aca374c76c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f2e7257b2514744a$export$f5d2ec7e4c47e088), classes);
};
const $a6ac58aca374c76c$var$DialogTitleRoot = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $a6ac58aca374c76c$var$DialogTitle = /*#__PURE__*/ $acw62.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp } = props, other = (0, $1En50.default)(props, $a6ac58aca374c76c$var$_excluded);
    const ownerState = props;
    const classes = $a6ac58aca374c76c$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $acw62.useContext((0, $68187f174395cd28$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a6ac58aca374c76c$var$DialogTitleRoot, (0, $8nd05.default)({
        component: "h2",
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $a6ac58aca374c76c$export$2e2bcd8739ae039 = $a6ac58aca374c76c$var$DialogTitle;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3OJTQ = parcelRequire("3OJTQ");

var $hcz0Q = parcelRequire("hcz0Q");

var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $e1c9164ec15102c7$var$GridContext = /*#__PURE__*/ $acw62.createContext();
var $e1c9164ec15102c7$export$2e2bcd8739ae039 = $e1c9164ec15102c7$var$GridContext;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f35b8acab3fc2f62$export$9973ac5fd0181f33(slot) {
    return (0, $4Cod0.default)('MuiGrid', slot);
}
const $f35b8acab3fc2f62$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $f35b8acab3fc2f62$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $f35b8acab3fc2f62$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $f35b8acab3fc2f62$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $f35b8acab3fc2f62$var$gridClasses = (0, $beCSm.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$f35b8acab3fc2f62$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$f35b8acab3fc2f62$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$f35b8acab3fc2f62$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $f35b8acab3fc2f62$export$2e2bcd8739ae039 = $f35b8acab3fc2f62$var$gridClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9450fbc34cc5b2ea$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $9450fbc34cc5b2ea$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function $9450fbc34cc5b2ea$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $3OJTQ.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $8nd05.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $9450fbc34cc5b2ea$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $3OJTQ.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $3OJTQ.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $9450fbc34cc5b2ea$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $3OJTQ.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $3OJTQ.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $9450fbc34cc5b2ea$var$GridRoot = (0, $d8seH.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $9450fbc34cc5b2ea$export$71d4225eeb1bc13e, $9450fbc34cc5b2ea$export$380604d7c79f9e8f, $9450fbc34cc5b2ea$export$4315fba5128fb4a1, $9450fbc34cc5b2ea$export$ca2a698f6020fda);
function $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $9450fbc34cc5b2ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f35b8acab3fc2f62$export$9973ac5fd0181f33), classes);
};
const $9450fbc34cc5b2ea$var$Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const props = (0, $hcz0Q.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $1En50.default)(props, $9450fbc34cc5b2ea$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $acw62.useContext((0, $e1c9164ec15102c7$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $8nd05.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $9450fbc34cc5b2ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1c9164ec15102c7$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9450fbc34cc5b2ea$var$GridRoot, (0, $8nd05.default)({
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $9450fbc34cc5b2ea$export$2e2bcd8739ae039 = $9450fbc34cc5b2ea$var$Grid;


class $ac3318f5da8b5303$export$a38dccb8826b7b75 extends $acw62.Component {
    constructor(ps){
        super(ps);
        this.state = {
            ...this.state,
            value: ps.initialValue ?? ''
        };
    }
    render() {
        const { message: message, onSave: onSave, onClose: onClose, children: children, open: open } = this.props;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4f13784bd714c44e$export$2e2bcd8739ae039), {
            onClose: onClose,
            open: open,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6ac58aca374c76c$export$2e2bcd8739ae039), {
                    children: message
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    p: 2,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                        onSubmit: (e)=>{
                            e.preventDefault();
                            onSave(this.state.value);
                            onClose();
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                children: children
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    justifyContent: 'center'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        sx: {
                                            p: 1
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                            type: "submit",
                                            variant: "outlined",
                                            children: "Ok"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        sx: {
                                            p: 1
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                            variant: "outlined",
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                onClose();
                                            },
                                            children: "Close"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
}




const $b5ff0091b950cfbc$var$TextModal = ({ open: open, onClose: onClose, message: message, onSave: onSave, initialValue: initialValue })=>{
    const [value, setValue] = $acw62.useState('');
    const handleChangeValue = (e)=>setValue(e.target.value);
    $acw62.useEffect(()=>{
        if (initialValue) setValue(initialValue);
    }, [
        initialValue
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac3318f5da8b5303$export$a38dccb8826b7b75), {
        open: open,
        onClose: onClose,
        onSave: ()=>onSave(value),
        message: message,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                p: 1
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                required: true,
                label: "Input",
                value: value,
                autoFocus: true,
                onChange: handleChangeValue
            })
        })
    });
};
var $b5ff0091b950cfbc$export$2e2bcd8739ae039 = $b5ff0091b950cfbc$var$TextModal;


/**
 * EdgeBredth dialog.
 *
 * @since 0.2.0
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/**
 * Generic cell.
 *
 * @note probably to be removed soon.
 *
 * @since 0.2.0
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

class $f062ea81eaef967d$export$f6f0c3fe4ec306ea extends $acw62.Component {
    constructor(ps){
        super(ps);
        this.state = {};
    }
    render() {
        const { onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onDragStart: onDragStart, children: children, style: style, selected: selected } = this.props;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: `Cell ${selected ? 'selected' : ''}`,
            style: {
                ...style
            },
            onClick: ()=>{
                onClick ? onClick() : undefined;
            },
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onDragStart: onDragStart,
            children: children
        });
    }
}





class $ede9b8cdb515782e$export$26effe6b987106b5 extends $acw62.Component {
    constructor(ps){
        super(ps);
        this.state = {
            value: this.props.initialValue ?? '',
            selected: this.props.location
        };
    }
    select(location) {
        this.setState({
            selected: location
        });
    }
    render() {
        const { message: message, onSave: onSave, onClose: onClose, open: open } = this.props;
        const { value: value, selected: selected } = this.state;
        const cells = [
            'inside',
            'center',
            'outside'
        ];
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac3318f5da8b5303$export$a38dccb8826b7b75), {
            open: open,
            onClose: onClose,
            onSave: ()=>{
                onSave(value, selected);
            },
            message: message ?? 'Please make a selection',
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "EdgeBredth",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "Cells",
                        children: cells.map((e, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $f062ea81eaef967d$export$f6f0c3fe4ec306ea), {
                                selected: selected === e,
                                onClick: ()=>{
                                    this.select(e);
                                },
                                onDragStart: (e)=>{
                                    e.preventDefault();
                                },
                                style: {
                                    border: '1px solid',
                                    margin: '4px auto',
                                    padding: '4px',
                                    width: '50%'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: e
                                })
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            p: 1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                            required: true,
                            id: "outlined-required",
                            label: "Input",
                            value: value,
                            onChange: (e)=>this.setState({
                                    value: e.target.value
                                }),
                            autoFocus: true
                        })
                    })
                ]
            })
        });
    }
}





var $3abDJ = parcelRequire("3abDJ");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");












var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4dba6b402693f5d6$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $4dba6b402693f5d6$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $4dba6b402693f5d6$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $4dba6b402693f5d6$var$resolveContainer(containerProp);
    const transform = $4dba6b402693f5d6$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4dba6b402693f5d6$var$Slide = /*#__PURE__*/ $acw62.forwardRef(function Slide(props, ref) {
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $4dba6b402693f5d6$var$_excluded);
    const childrenRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $8nd05.default)({}, transitionProps));
        node.style.transition = theme.transitions.create('transform', (0, $8nd05.default)({}, transitionProps));
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $acw62.useCallback(()=>{
        if (childrenRef.current) $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $acw62.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $acw62.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                ref: handleRef,
                style: (0, $8nd05.default)({
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $4dba6b402693f5d6$export$2e2bcd8739ae039 = $4dba6b402693f5d6$var$Slide;




var $jTnBY = parcelRequire("jTnBY");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $367f15b5d414b8d7$export$b801318a856c9cd2(slot) {
    return (0, $4Cod0.default)('MuiDrawer', slot);
}
const $367f15b5d414b8d7$var$drawerClasses = (0, $beCSm.default)('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var $367f15b5d414b8d7$export$2e2bcd8739ae039 = $367f15b5d414b8d7$var$drawerClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1ed9758f3bc045cc$var$_excluded = [
    "BackdropProps"
], $1ed9758f3bc045cc$var$_excluded2 = [
    "anchor",
    "BackdropProps",
    "children",
    "className",
    "elevation",
    "hideBackdrop",
    "ModalProps",
    "onClose",
    "open",
    "PaperProps",
    "SlideProps",
    "TransitionComponent",
    "transitionDuration",
    "variant"
];
const $1ed9758f3bc045cc$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        styles.modal
    ];
};
const $1ed9758f3bc045cc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, $jTnBY.default)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, $jTnBY.default)(anchor)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $367f15b5d414b8d7$export$b801318a856c9cd2), classes);
};
const $1ed9758f3bc045cc$var$DrawerRoot = (0, $d8seH.default)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: $1ed9758f3bc045cc$var$overridesResolver
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    }));
const $1ed9758f3bc045cc$var$DrawerDockedRoot = (0, $d8seH.default)('div', {
    shouldForwardProp: (0, $8Uq77.default),
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: $1ed9758f3bc045cc$var$overridesResolver
})({
    flex: '0 0 auto'
});
const $1ed9758f3bc045cc$var$DrawerPaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $jTnBY.default)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, $jTnBY.default)(ownerState.anchor)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0
    }, ownerState.anchor === 'left' && {
        left: 0
    }, ownerState.anchor === 'top' && {
        top: 0,
        left: 0,
        right: 0,
        height: 'auto',
        maxHeight: '100%'
    }, ownerState.anchor === 'right' && {
        right: 0
    }, ownerState.anchor === 'bottom' && {
        top: 'auto',
        left: 0,
        bottom: 0,
        right: 0,
        height: 'auto',
        maxHeight: '100%'
    }, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
        borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
        borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $1ed9758f3bc045cc$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $1ed9758f3bc045cc$export$2a62b49acb270576(anchor) {
    return [
        'left',
        'right'
    ].indexOf(anchor) !== -1;
}
function $1ed9758f3bc045cc$export$830f4f08342d299e({ direction: direction }, anchor) {
    return direction === 'rtl' && $1ed9758f3bc045cc$export$2a62b49acb270576(anchor) ? $1ed9758f3bc045cc$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $1ed9758f3bc045cc$var$Drawer = /*#__PURE__*/ $acw62.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $4dba6b402693f5d6$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = 'temporary' } = props, ModalProps = (0, $1En50.default)(props.ModalProps, $1ed9758f3bc045cc$var$_excluded), other = (0, $1En50.default)(props, $1ed9758f3bc045cc$var$_excluded2);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $1ed9758f3bc045cc$export$830f4f08342d299e({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant
    }, other);
    const classes = $1ed9758f3bc045cc$var$useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, $ayMG0.jsx)($1ed9758f3bc045cc$var$DrawerPaper, (0, $8nd05.default)({
        elevation: variant === 'temporary' ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $9QePP.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    }));
    if (variant === 'permanent') return /*#__PURE__*/ (0, $ayMG0.jsx)($1ed9758f3bc045cc$var$DrawerDockedRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: open,
        direction: $1ed9758f3bc045cc$var$oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps, {
        children: drawer
    }));
    if (variant === 'persistent') return /*#__PURE__*/ (0, $ayMG0.jsx)($1ed9758f3bc045cc$var$DrawerDockedRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1ed9758f3bc045cc$var$DrawerRoot, (0, $8nd05.default)({
        BackdropProps: (0, $8nd05.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        className: (0, $9QePP.default)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref
    }, other, ModalProps, {
        children: slidingDrawer
    }));
});
var $1ed9758f3bc045cc$export$2e2bcd8739ae039 = $1ed9758f3bc045cc$var$Drawer;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");
var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d3b4e1a115786e57$export$b12cb262231eef32(slot) {
    return (0, $4Cod0.default)('MuiToolbar', slot);
}
const $d3b4e1a115786e57$var$toolbarClasses = (0, $beCSm.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $d3b4e1a115786e57$export$2e2bcd8739ae039 = $d3b4e1a115786e57$var$toolbarClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ef8072c26f712b4c$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $ef8072c26f712b4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d3b4e1a115786e57$export$b12cb262231eef32), classes);
};
const $ef8072c26f712b4c$var$ToolbarRoot = (0, $d8seH.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === 'dense' && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === 'regular' && theme.mixins.toolbar);
const $ef8072c26f712b4c$var$Toolbar = /*#__PURE__*/ $acw62.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular' } = props, other = (0, $1En50.default)(props, $ef8072c26f712b4c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $ef8072c26f712b4c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ef8072c26f712b4c$var$ToolbarRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $ef8072c26f712b4c$export$2e2bcd8739ae039 = $ef8072c26f712b4c$var$Toolbar;


const $b87865122010d3d3$export$9908b510f6387fca = '70px';
const $b87865122010d3d3$var$StyledToolbar = (0, $d8seH.default)((0, $ef8072c26f712b4c$export$2e2bcd8739ae039))(({ theme: theme })=>({
        '&.MuiToolbar-root': {
            backgroundColor: theme.vars.palette.background.default,
            height: $b87865122010d3d3$export$9908b510f6387fca,
            minHeight: $b87865122010d3d3$export$9908b510f6387fca
        }
    }));
const $b87865122010d3d3$export$9cfe29ba9f08864a = ({ children: children, ...toolbarProps })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b87865122010d3d3$var$StyledToolbar, {
        ...toolbarProps,
        children: children
    });
};



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");
const $6fafb98b52e2ec12$var$QDrawerActions = /*#__PURE__*/ $acw62.forwardRef(({ children: children, ...boxProps }, ref)=>{
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        zIndex: 1,
        ref: ref,
        position: "absolute",
        bottom: 0,
        right: 0,
        left: 0,
        display: "flex",
        alignItems: 'center',
        padding: 3,
        justifyContent: 'flex-end',
        flex: '0 0 auto',
        boxShadow: `0px -1px 10px ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.06)'}`,
        ...boxProps,
        children: children
    });
});
var $6fafb98b52e2ec12$export$2e2bcd8739ae039 = $6fafb98b52e2ec12$var$QDrawerActions;


const $cd5b64deee448fed$var$QDrawerContainer = ({ children: children, actions: actions, ContainerProps: ContainerProps, FormProps: FormProps })=>{
    /*
	 * The main content form needs a defined height
	 * for the overflow scroll to work properly
	 */ const [contentHeight, setContentHeight] = $acw62.useState(null);
    const actionsRef = /*#__PURE__*/ $acw62.createRef();
    const containerRef = $acw62.useRef(null);
    $acw62.useLayoutEffect(()=>{
        function updateHeight() {
            if (actionsRef?.current && containerRef?.current) {
                const elHeight = actionsRef.current.getBoundingClientRect().height;
                const containerHeight = containerRef.current.getBoundingClientRect().height;
                setContentHeight(containerHeight - elHeight - 16);
            }
        }
        // Run on initial render
        updateHeight();
        window.addEventListener('resize', updateHeight);
        return ()=>window.removeEventListener('resize', updateHeight);
    }, [
        actionsRef,
        containerRef
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        ml: "15px",
        ref: containerRef,
        ...ContainerProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                maxHeight: `${contentHeight || 0}px`,
                height: `${contentHeight || 0}px`,
                flex: '1 1 auto',
                sx: {
                    overflowY: 'auto'
                },
                display: "flex",
                flexDirection: "column",
                component: "form",
                ...FormProps,
                children: children
            }),
            actions && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6fafb98b52e2ec12$export$2e2bcd8739ae039), {
                ref: actionsRef,
                children: actions
            })
        ]
    });
};
var $cd5b64deee448fed$export$2e2bcd8739ae039 = $cd5b64deee448fed$var$QDrawerContainer;




var $d8seH = parcelRequire("d8seH");
const $f3dbd6d6fe6bce40$var$GhostButton = (0, $d8seH.default)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039))(({ theme: theme })=>({
        border: theme.palette.mode === 'dark' ? '1px solid #808080' : '1px solid #EDF2F7',
        background: 'rgba(0,0,0,0)',
        color: theme.palette.mode === 'dark' ? '#808080' : '#000',
        padding: '8px 31px'
    }));
var $f3dbd6d6fe6bce40$export$2e2bcd8739ae039 = $f3dbd6d6fe6bce40$var$GhostButton;



var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");
parcelRequire("acw62");
const $6b8f7b4f44c11bf4$var$addDarkModeBg = {
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    backgroundImage: 'none',
    color: 'black',
    '[data-mui-color-scheme="dark"] &': {
        backgroundColor: '#000',
        backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1))',
        color: '#808080'
    }
};
const $6b8f7b4f44c11bf4$var$Title = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039))($6b8f7b4f44c11bf4$var$addDarkModeBg);
const $6b8f7b4f44c11bf4$var$QDrawerTitle = ({ children: children, ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)($6b8f7b4f44c11bf4$var$Title, {
        p: 1,
        pl: 2,
        textAlign: "center",
        variant: "h2",
        ...props,
        children: children
    });
var $6b8f7b4f44c11bf4$export$2e2bcd8739ae039 = $6b8f7b4f44c11bf4$var$QDrawerTitle;




var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ab8dae130526a9ed$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $0888b018db76353f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 9H4v2h16zM4 15h16v-2H4z"
}), 'DragHandle');



var $3abDJ = parcelRequire("3abDJ");

var $acw62 = parcelRequire("acw62");

var $5OFXS = parcelRequire("5OFXS");
const $e5b355aa80e91b06$var$useResize = ({ minWidth: minWidth })=>{
    const [isResizing, setIsResizing] = (0, $acw62.useState)(false);
    const [width, setWidth] = (0, $acw62.useState)(minWidth);
    // Allow the handler to update the width
    const enableResize = (0, $acw62.useCallback)(()=>{
        setIsResizing(true);
    }, [
        setIsResizing
    ]);
    // Prevent the handler from updating the width
    const disableResize = (0, $acw62.useCallback)(()=>{
        setIsResizing(false);
    }, [
        setIsResizing
    ]);
    /*
	 * Calculate width for drawer on right side of screen
	 * and set the new width
	 */ const resize = (0, $acw62.useCallback)((e)=>(0, $3abDJ.pipe)(e.clientX, $5OFXS.fromPredicate(()=>isResizing), $5OFXS.map((x)=>window.innerWidth - x), $5OFXS.chain($5OFXS.fromPredicate((x)=>x >= minWidth)), $5OFXS.foldW((0, $3abDJ.constant)(null), setWidth)), [
        minWidth,
        isResizing,
        setWidth
    ]);
    /*
	 * Calculate width for drawer on right side of screen
	 * and set the new width for touch events
	 */ const resizeTouch = (0, $acw62.useCallback)((e)=>(0, $3abDJ.pipe)(e.targetTouches[0]?.clientX, $5OFXS.fromNullable, $5OFXS.chain($5OFXS.fromPredicate((0, $3abDJ.constant)(isResizing))), $5OFXS.map((a)=>window.innerWidth - a), $5OFXS.chain($5OFXS.fromPredicate((x)=>x >= minWidth)), $5OFXS.foldW((0, $3abDJ.constant)(null), setWidth)), [
        minWidth,
        isResizing,
        setWidth
    ]);
    (0, $acw62.useEffect)(()=>{
        document.addEventListener('mousemove', resize);
        document.addEventListener('mouseup', disableResize);
        document.addEventListener('touchmove', resizeTouch);
        document.addEventListener('touchend', disableResize);
        return ()=>{
            document.removeEventListener('mousemove', resize);
            document.removeEventListener('mouseup', disableResize);
            document.removeEventListener('touchmove', resizeTouch);
            document.removeEventListener('touchend', disableResize);
        };
    }, [
        disableResize,
        resize,
        resizeTouch
    ]);
    return {
        width: width,
        enableResize: enableResize
    };
};
var $e5b355aa80e91b06$export$2e2bcd8739ae039 = $e5b355aa80e91b06$var$useResize;


const $68a0b503497ce0e5$var$QRightDrawer = ({ children: children, minWidth: minWidth, Content: Content, lengthConverter: lengthConverter, angleConverter: angleConverter, update: update, value: value, exit: exit, title: title, ...props })=>{
    const { width: width, enableResize: enableResize } = (0, $e5b355aa80e91b06$export$2e2bcd8739ae039)({
        minWidth: minWidth || 300
    });
    const handleClose = $acw62.useCallback(()=>{
        exit && exit();
    }, [
        exit
    ]);
    const preventDefault = (e)=>e.preventDefault();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ed9758f3bc045cc$export$2e2bcd8739ae039), {
        variant: "persistent",
        anchor: "right",
        sx: {
            width: width,
            flexShrink: 0,
            ['& .MuiDrawer-paper']: {
                width: width,
                boxSizing: 'border-box'
            }
        },
        PaperProps: {
            sx: {
                overflow: 'hidden'
            }
        },
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b87865122010d3d3$export$9cfe29ba9f08864a), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                sx: {
                    position: 'absolute',
                    top: '73px',
                    left: '10px'
                },
                "aria-label": "close drawer",
                onClick: handleClose,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab8dae130526a9ed$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                onMouseDown: enableResize,
                onTouchStart: enableResize,
                sx: {
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    left: '0px',
                    top: 0,
                    bottom: 0,
                    cursor: 'col-resize'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0888b018db76353f$export$2e2bcd8739ae039), {
                    sx: {
                        transform: 'rotate(90deg)'
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6b8f7b4f44c11bf4$export$2e2bcd8739ae039), {
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd5b64deee448fed$export$2e2bcd8739ae039), {
                FormProps: {
                    onSubmit: preventDefault
                },
                actions: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3dbd6d6fe6bce40$export$2e2bcd8739ae039), {
                    onClick: handleClose,
                    sx: {
                        mx: '1'
                    },
                    children: "Close"
                }),
                children: Content && /*#__PURE__*/ (0, $ayMG0.jsx)(Content, {
                    angleConverter: angleConverter,
                    lengthConverter: lengthConverter,
                    value: value,
                    update: update
                })
            })
        ]
    });
};
var $68a0b503497ce0e5$export$2e2bcd8739ae039 = $68a0b503497ce0e5$var$QRightDrawer;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



var $3abDJ = parcelRequire("3abDJ");


var $hBXBN = parcelRequire("hBXBN");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $3abDJ = parcelRequire("3abDJ");
const $df2af751bdad3651$export$c5db55acc87904b6 = ({ value: value, update: update, ...props })=>{
    // State and setters for debounced value
    const [inputValue, setInputValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(value);
    const handleOnUpdate = (0, $3abDJ.flow)((0, $859db0da13774873$export$2b11a78b8ccd10d4), setInputValue);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
        type: "text",
        InputLabelProps: {
            shrink: true
        },
        onBlur: (0, $3abDJ.flow)((0, $859db0da13774873$export$cb0d9aba43c3445a), (0, $3abDJ.constant), update),
        onChange: handleOnUpdate,
        value: inputValue,
        ...props
    });
};
const $df2af751bdad3651$export$37a4329863986fc6 = /*#__PURE__*/ (0, $acw62.memo)($df2af751bdad3651$export$c5db55acc87904b6);
var $df2af751bdad3651$export$2e2bcd8739ae039 = $df2af751bdad3651$export$c5db55acc87904b6;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3abDJ = parcelRequire("3abDJ");
var $7f42eb8d37961918$exports = {};
"use strict";
var $7f42eb8d37961918$var$__createBinding = $7f42eb8d37961918$exports && $7f42eb8d37961918$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7f42eb8d37961918$var$__setModuleDefault = $7f42eb8d37961918$exports && $7f42eb8d37961918$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7f42eb8d37961918$var$__importStar = $7f42eb8d37961918$exports && $7f42eb8d37961918$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7f42eb8d37961918$var$__createBinding(result, mod, k);
    }
    $7f42eb8d37961918$var$__setModuleDefault(result, mod);
    return result;
};
var $7f42eb8d37961918$var$__awaiter = $7f42eb8d37961918$exports && $7f42eb8d37961918$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7f42eb8d37961918$var$__generator = $7f42eb8d37961918$exports && $7f42eb8d37961918$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($7f42eb8d37961918$exports, "__esModule", {
    value: true
});
$7f42eb8d37961918$exports.throwError = $7f42eb8d37961918$exports.of = $7f42eb8d37961918$exports.altW = $7f42eb8d37961918$exports.alt = $7f42eb8d37961918$exports.flatten = $7f42eb8d37961918$exports.flattenW = $7f42eb8d37961918$exports.flatMap = $7f42eb8d37961918$exports.apW = $7f42eb8d37961918$exports.ap = $7f42eb8d37961918$exports.mapLeft = $7f42eb8d37961918$exports.mapError = $7f42eb8d37961918$exports.bimap = $7f42eb8d37961918$exports.mapBoth = $7f42eb8d37961918$exports.map = $7f42eb8d37961918$exports.fromIOEitherK = $7f42eb8d37961918$exports.chainTaskOptionK = $7f42eb8d37961918$exports.chainTaskOptionKW = $7f42eb8d37961918$exports.fromTaskOptionK = $7f42eb8d37961918$exports.swap = $7f42eb8d37961918$exports.orLeft = $7f42eb8d37961918$exports.orElseFirstTaskK = $7f42eb8d37961918$exports.orElseFirstIOK = $7f42eb8d37961918$exports.tapError = $7f42eb8d37961918$exports.orElseW = $7f42eb8d37961918$exports.orElse = $7f42eb8d37961918$exports.chainNullableK = $7f42eb8d37961918$exports.fromNullableK = $7f42eb8d37961918$exports.fromNullable = $7f42eb8d37961918$exports.toUnion = $7f42eb8d37961918$exports.tryCatchK = $7f42eb8d37961918$exports.tryCatch = $7f42eb8d37961918$exports.getOrElseW = $7f42eb8d37961918$exports.getOrElse = $7f42eb8d37961918$exports.foldW = $7f42eb8d37961918$exports.matchEW = $7f42eb8d37961918$exports.fold = $7f42eb8d37961918$exports.matchE = $7f42eb8d37961918$exports.matchW = $7f42eb8d37961918$exports.match = $7f42eb8d37961918$exports.fromTaskOption = $7f42eb8d37961918$exports.fromIOEither = $7f42eb8d37961918$exports.fromEither = $7f42eb8d37961918$exports.fromTask = $7f42eb8d37961918$exports.fromIO = $7f42eb8d37961918$exports.leftIO = $7f42eb8d37961918$exports.rightIO = $7f42eb8d37961918$exports.leftTask = $7f42eb8d37961918$exports.rightTask = $7f42eb8d37961918$exports.right = $7f42eb8d37961918$exports.left = void 0;
$7f42eb8d37961918$exports.fromEitherK = $7f42eb8d37961918$exports.filterOrElseW = $7f42eb8d37961918$exports.filterOrElse = $7f42eb8d37961918$exports.fromPredicate = $7f42eb8d37961918$exports.chainFirstEitherKW = $7f42eb8d37961918$exports.chainFirstEitherK = $7f42eb8d37961918$exports.chainEitherKW = $7f42eb8d37961918$exports.chainEitherK = $7f42eb8d37961918$exports.flatMapTaskOption = $7f42eb8d37961918$exports.flatMapIOEither = $7f42eb8d37961918$exports.flatMapTask = $7f42eb8d37961918$exports.flatMapIO = $7f42eb8d37961918$exports.flatMapEither = $7f42eb8d37961918$exports.flatMapOption = $7f42eb8d37961918$exports.flatMapNullable = $7f42eb8d37961918$exports.liftOption = $7f42eb8d37961918$exports.liftNullable = $7f42eb8d37961918$exports.chainOptionKW = $7f42eb8d37961918$exports.chainOptionK = $7f42eb8d37961918$exports.fromOptionK = $7f42eb8d37961918$exports.fromOption = $7f42eb8d37961918$exports.Alt = $7f42eb8d37961918$exports.Bifunctor = $7f42eb8d37961918$exports.tapTask = $7f42eb8d37961918$exports.tapIO = $7f42eb8d37961918$exports.tapEither = $7f42eb8d37961918$exports.tap = $7f42eb8d37961918$exports.FromTask = $7f42eb8d37961918$exports.FromIO = $7f42eb8d37961918$exports.FromEither = $7f42eb8d37961918$exports.MonadThrow = $7f42eb8d37961918$exports.MonadTask = $7f42eb8d37961918$exports.MonadIO = $7f42eb8d37961918$exports.Monad = $7f42eb8d37961918$exports.Chain = $7f42eb8d37961918$exports.ApplicativeSeq = $7f42eb8d37961918$exports.ApplySeq = $7f42eb8d37961918$exports.ApplicativePar = $7f42eb8d37961918$exports.apSecondW = $7f42eb8d37961918$exports.apSecond = $7f42eb8d37961918$exports.apFirstW = $7f42eb8d37961918$exports.apFirst = $7f42eb8d37961918$exports.ApplyPar = $7f42eb8d37961918$exports.Pointed = $7f42eb8d37961918$exports.flap = $7f42eb8d37961918$exports.asUnit = $7f42eb8d37961918$exports.as = $7f42eb8d37961918$exports.Functor = $7f42eb8d37961918$exports.getCompactable = $7f42eb8d37961918$exports.URI = void 0;
$7f42eb8d37961918$exports.getSemigroup = $7f42eb8d37961918$exports.getApplyMonoid = $7f42eb8d37961918$exports.getApplySemigroup = $7f42eb8d37961918$exports.taskEitherSeq = $7f42eb8d37961918$exports.taskEither = $7f42eb8d37961918$exports.orElseFirstW = $7f42eb8d37961918$exports.orElseFirst = $7f42eb8d37961918$exports.chainFirstW = $7f42eb8d37961918$exports.chainFirst = $7f42eb8d37961918$exports.chainW = $7f42eb8d37961918$exports.chain = $7f42eb8d37961918$exports.sequenceSeqArray = $7f42eb8d37961918$exports.traverseSeqArray = $7f42eb8d37961918$exports.traverseSeqArrayWithIndex = $7f42eb8d37961918$exports.sequenceArray = $7f42eb8d37961918$exports.traverseArray = $7f42eb8d37961918$exports.traverseArrayWithIndex = $7f42eb8d37961918$exports.traverseReadonlyArrayWithIndexSeq = $7f42eb8d37961918$exports.traverseReadonlyNonEmptyArrayWithIndexSeq = $7f42eb8d37961918$exports.traverseReadonlyArrayWithIndex = $7f42eb8d37961918$exports.traverseReadonlyNonEmptyArrayWithIndex = $7f42eb8d37961918$exports.ApT = $7f42eb8d37961918$exports.apSW = $7f42eb8d37961918$exports.apS = $7f42eb8d37961918$exports.bindW = $7f42eb8d37961918$exports.bind = $7f42eb8d37961918$exports.let = $7f42eb8d37961918$exports.bindTo = $7f42eb8d37961918$exports.Do = $7f42eb8d37961918$exports.bracketW = $7f42eb8d37961918$exports.bracket = $7f42eb8d37961918$exports.chainIOEitherK = $7f42eb8d37961918$exports.chainIOEitherKW = $7f42eb8d37961918$exports.chainFirstTaskK = $7f42eb8d37961918$exports.chainTaskK = $7f42eb8d37961918$exports.fromTaskK = $7f42eb8d37961918$exports.chainFirstIOK = $7f42eb8d37961918$exports.chainIOK = $7f42eb8d37961918$exports.fromIOK = void 0;
$7f42eb8d37961918$exports.getApplicativeTaskValidation = $7f42eb8d37961918$var$getApplicativeTaskValidation;
$7f42eb8d37961918$exports.getAltTaskValidation = $7f42eb8d37961918$var$getAltTaskValidation;
$7f42eb8d37961918$exports.getFilterable = $7f42eb8d37961918$var$getFilterable;
$7f42eb8d37961918$exports.taskify = $7f42eb8d37961918$var$taskify;
$7f42eb8d37961918$exports.getTaskValidation = $7f42eb8d37961918$var$getTaskValidation;

var $eImHL = parcelRequire("eImHL");

var $4sfjE = parcelRequire("4sfjE");

var $7f42eb8d37961918$var$chainable = $7f42eb8d37961918$var$__importStar((parcelRequire("ERVGH")));
var $eb68b3531da38f36$exports = {};
"use strict";
var $eb68b3531da38f36$var$__createBinding = $eb68b3531da38f36$exports && $eb68b3531da38f36$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $eb68b3531da38f36$var$__setModuleDefault = $eb68b3531da38f36$exports && $eb68b3531da38f36$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $eb68b3531da38f36$var$__importStar = $eb68b3531da38f36$exports && $eb68b3531da38f36$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $eb68b3531da38f36$var$__createBinding(result, mod, k);
    }
    $eb68b3531da38f36$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($eb68b3531da38f36$exports, "__esModule", {
    value: true
});
$eb68b3531da38f36$exports.compact = $eb68b3531da38f36$var$compact;
$eb68b3531da38f36$exports.separate = $eb68b3531da38f36$var$separate;
$eb68b3531da38f36$exports.getCompactableComposition = $eb68b3531da38f36$var$getCompactableComposition;

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");

var $hBXBN = parcelRequire("hBXBN");

var $eb68b3531da38f36$var$S = $eb68b3531da38f36$var$__importStar((parcelRequire("fIQoU")));
function $eb68b3531da38f36$var$compact(F, G) {
    return function(fga) {
        return F.map(fga, G.compact);
    };
}
function $eb68b3531da38f36$var$separate(F, C, G) {
    var _compact = $eb68b3531da38f36$var$compact(F, C);
    var _map = (0, $emm1u.map)(F, G);
    return function(fge) {
        return $eb68b3531da38f36$var$S.separated(_compact((0, $3abDJ.pipe)(fge, _map($hBXBN.getLeft))), _compact((0, $3abDJ.pipe)(fge, _map($hBXBN.getRight))));
    };
}
/** @deprecated */ function $eb68b3531da38f36$var$getCompactableComposition(F, G) {
    var map = (0, $emm1u.getFunctorComposition)(F, G).map;
    return {
        map: map,
        compact: $eb68b3531da38f36$var$compact(F, G),
        separate: $eb68b3531da38f36$var$separate(F, G, G)
    };
}



var $7f42eb8d37961918$var$E = $7f42eb8d37961918$var$__importStar((parcelRequire("5uDEp")));

var $7f42eb8d37961918$var$ET = $7f42eb8d37961918$var$__importStar((parcelRequire("iH75M")));
var $296ec91c31ad8460$exports = {};
"use strict";
Object.defineProperty($296ec91c31ad8460$exports, "__esModule", {
    value: true
});
$296ec91c31ad8460$exports.filter = $296ec91c31ad8460$var$filter;
$296ec91c31ad8460$exports.filterMap = $296ec91c31ad8460$var$filterMap;
$296ec91c31ad8460$exports.partition = $296ec91c31ad8460$var$partition;
$296ec91c31ad8460$exports.partitionMap = $296ec91c31ad8460$var$partitionMap;
$296ec91c31ad8460$exports.getFilterableComposition = $296ec91c31ad8460$var$getFilterableComposition;


var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");

var $hBXBN = parcelRequire("hBXBN");

var $6t3HJ = parcelRequire("6t3HJ");

var $fIQoU = parcelRequire("fIQoU");
function $296ec91c31ad8460$var$filter(F, G) {
    return function(predicate) {
        return function(fga) {
            return F.map(fga, function(ga) {
                return G.filter(ga, predicate);
            });
        };
    };
}
function $296ec91c31ad8460$var$filterMap(F, G) {
    return function(f) {
        return function(fga) {
            return F.map(fga, function(ga) {
                return G.filterMap(ga, f);
            });
        };
    };
}
function $296ec91c31ad8460$var$partition(F, G) {
    var _filter = $296ec91c31ad8460$var$filter(F, G);
    return function(predicate) {
        var left = _filter((0, $6t3HJ.not)(predicate));
        var right = _filter(predicate);
        return function(fgb) {
            return (0, $fIQoU.separated)(left(fgb), right(fgb));
        };
    };
}
function $296ec91c31ad8460$var$partitionMap(F, G) {
    var _filterMap = $296ec91c31ad8460$var$filterMap(F, G);
    return function(f) {
        return function(fga) {
            return (0, $fIQoU.separated)((0, $3abDJ.pipe)(fga, _filterMap(function(a) {
                return (0, $hBXBN.getLeft)(f(a));
            })), (0, $3abDJ.pipe)(fga, _filterMap(function(a) {
                return (0, $hBXBN.getRight)(f(a));
            })));
        };
    };
}
/** @deprecated */ function $296ec91c31ad8460$var$getFilterableComposition(F, G) {
    var map = (0, $emm1u.getFunctorComposition)(F, G).map;
    var _compact = (0, $eb68b3531da38f36$exports.compact)(F, G);
    var _separate = (0, $eb68b3531da38f36$exports.separate)(F, G, G);
    var _filter = $296ec91c31ad8460$var$filter(F, G);
    var _filterMap = $296ec91c31ad8460$var$filterMap(F, G);
    var _partition = $296ec91c31ad8460$var$partition(F, G);
    var _partitionMap = $296ec91c31ad8460$var$partitionMap(F, G);
    return {
        map: map,
        compact: _compact,
        separate: _separate,
        filter: function(fga, f) {
            return (0, $3abDJ.pipe)(fga, _filter(f));
        },
        filterMap: function(fga, f) {
            return (0, $3abDJ.pipe)(fga, _filterMap(f));
        },
        partition: function(fga, p) {
            return (0, $3abDJ.pipe)(fga, _partition(p));
        },
        partitionMap: function(fga, f) {
            return (0, $3abDJ.pipe)(fga, _partitionMap(f));
        }
    };
}



var $eLQyV = parcelRequire("eLQyV");

var $bycRW = parcelRequire("bycRW");
var $eb6e6c65abb42686$exports = {};
"use strict";
Object.defineProperty($eb6e6c65abb42686$exports, "__esModule", {
    value: true
});
$eb6e6c65abb42686$exports.fromTaskK = $eb6e6c65abb42686$var$fromTaskK;
$eb6e6c65abb42686$exports.chainTaskK = $eb6e6c65abb42686$var$chainTaskK;
$eb6e6c65abb42686$exports.chainFirstTaskK = $eb6e6c65abb42686$var$chainFirstTaskK;
$eb6e6c65abb42686$exports.tapTask = $eb6e6c65abb42686$var$tapTask;

var $ERVGH = parcelRequire("ERVGH");

var $3abDJ = parcelRequire("3abDJ");
function $eb6e6c65abb42686$var$fromTaskK(F) {
    return function(f) {
        return (0, $3abDJ.flow)(f, F.fromTask);
    };
}
function $eb6e6c65abb42686$var$chainTaskK(F, M) {
    return function(f) {
        var g = (0, $3abDJ.flow)(f, F.fromTask);
        return function(first) {
            return M.chain(first, g);
        };
    };
}
function $eb6e6c65abb42686$var$chainFirstTaskK(F, M) {
    var tapTaskM = $eb6e6c65abb42686$var$tapTask(F, M);
    return function(f) {
        return function(first) {
            return tapTaskM(first, f);
        };
    };
}
/** @internal */ function $eb6e6c65abb42686$var$tapTask(F, M) {
    var tapM = (0, $ERVGH.tap)(M);
    return function(self, f) {
        return tapM(self, (0, $3abDJ.flow)(f, F.fromTask));
    };
}



var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");

var $7f42eb8d37961918$var$_ = $7f42eb8d37961918$var$__importStar((parcelRequire("704qB")));

var $7f42eb8d37961918$var$T = $7f42eb8d37961918$var$__importStar((parcelRequire("mttaN")));
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.left = $7f42eb8d37961918$var$ET.left($7f42eb8d37961918$var$T.Pointed);
/**
 * @category constructors
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.right = $7f42eb8d37961918$var$ET.right($7f42eb8d37961918$var$T.Pointed);
/**
 * @category constructors
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.rightTask = $7f42eb8d37961918$var$ET.rightF($7f42eb8d37961918$var$T.Functor);
/**
 * @category constructors
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.leftTask = $7f42eb8d37961918$var$ET.leftF($7f42eb8d37961918$var$T.Functor);
/**
 * @category constructors
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.rightIO = (0, $3abDJ.flow)($7f42eb8d37961918$var$T.fromIO, $7f42eb8d37961918$exports.rightTask);
/**
 * @category constructors
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.leftIO = (0, $3abDJ.flow)($7f42eb8d37961918$var$T.fromIO, $7f42eb8d37961918$exports.leftTask);
// -------------------------------------------------------------------------------------
// conversions
// -------------------------------------------------------------------------------------
/**
 * @category conversions
 * @since 2.7.0
 */ $7f42eb8d37961918$exports.fromIO = $7f42eb8d37961918$exports.rightIO;
/**
 * @category conversions
 * @since 2.7.0
 */ $7f42eb8d37961918$exports.fromTask = $7f42eb8d37961918$exports.rightTask;
/**
 * @category conversions
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.fromEither = $7f42eb8d37961918$var$T.of;
/**
 * @category conversions
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.fromIOEither = $7f42eb8d37961918$var$T.fromIO;
/**
 * @category conversions
 * @since 2.11.0
 */ var $7f42eb8d37961918$var$fromTaskOption = function(onNone) {
    return $7f42eb8d37961918$var$T.map($7f42eb8d37961918$var$E.fromOption(onNone));
};
$7f42eb8d37961918$exports.fromTaskOption = $7f42eb8d37961918$var$fromTaskOption;
/**
 * @category pattern matching
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.match = /*#__PURE__*/ $7f42eb8d37961918$var$ET.match($7f42eb8d37961918$var$T.Functor);
/**
 * Less strict version of [`match`](#match).
 *
 * The `W` suffix (short for **W**idening) means that the handler return types will be merged.
 *
 * @category pattern matching
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.matchW = $7f42eb8d37961918$exports.match;
/**
 * The `E` suffix (short for **E**ffect) means that the handlers return an effect (`Task`).
 *
 * @category pattern matching
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.matchE = $7f42eb8d37961918$var$ET.matchE($7f42eb8d37961918$var$T.Monad);
/**
 * Alias of [`matchE`](#matche).
 *
 * @category pattern matching
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.fold = $7f42eb8d37961918$exports.matchE;
/**
 * Less strict version of [`matchE`](#matche).
 *
 * The `W` suffix (short for **W**idening) means that the handler return types will be merged.
 *
 * @category pattern matching
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.matchEW = $7f42eb8d37961918$exports.matchE;
/**
 * Alias of [`matchEW`](#matchew).
 *
 * @category pattern matching
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.foldW = $7f42eb8d37961918$exports.matchEW;
/**
 * @category error handling
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.getOrElse = /*#__PURE__*/ $7f42eb8d37961918$var$ET.getOrElse($7f42eb8d37961918$var$T.Monad);
/**
 * Less strict version of [`getOrElse`](#getorelse).
 *
 * The `W` suffix (short for **W**idening) means that the handler return type will be merged.
 *
 * @category error handling
 * @since 2.6.0
 */ $7f42eb8d37961918$exports.getOrElseW = $7f42eb8d37961918$exports.getOrElse;
/**
 * Transforms a `Promise` that may reject to a `Promise` that never rejects and returns an `Either` instead.
 *
 * See also [`tryCatchK`](#trycatchk).
 *
 * @example
 * import { left, right } from 'fp-ts/Either'
 * import { tryCatch } from 'fp-ts/TaskEither'
 *
 * tryCatch(() => Promise.resolve(1), String)().then(result => {
 *   assert.deepStrictEqual(result, right(1))
 * })
 * tryCatch(() => Promise.reject('error'), String)().then(result => {
 *   assert.deepStrictEqual(result, left('error'))
 * })
 *
 * @category interop
 * @since 2.0.0
 */ var $7f42eb8d37961918$var$tryCatch = function(f, onRejected) {
    return function() {
        return $7f42eb8d37961918$var$__awaiter(void 0, void 0, void 0, function() {
            var reason_1;
            return $7f42eb8d37961918$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            f().then($7f42eb8d37961918$var$_.right)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        reason_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $7f42eb8d37961918$var$_.left(onRejected(reason_1))
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
};
$7f42eb8d37961918$exports.tryCatch = $7f42eb8d37961918$var$tryCatch;
/**
 * Converts a function returning a `Promise` to one returning a `TaskEither`.
 *
 * @category interop
 * @since 2.5.0
 */ var $7f42eb8d37961918$var$tryCatchK = function(f, onRejected) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return (0, $7f42eb8d37961918$exports.tryCatch)(function() {
            return f.apply(void 0, a);
        }, onRejected);
    };
};
$7f42eb8d37961918$exports.tryCatchK = $7f42eb8d37961918$var$tryCatchK;
/**
 * @category conversions
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.toUnion = $7f42eb8d37961918$var$ET.toUnion($7f42eb8d37961918$var$T.Functor);
/**
 * @category conversions
 * @since 2.12.0
 */ $7f42eb8d37961918$exports.fromNullable = $7f42eb8d37961918$var$ET.fromNullable($7f42eb8d37961918$var$T.Pointed);
/**
 * Use `liftNullable`.
 *
 * @category legacy
 * @since 2.12.0
 */ $7f42eb8d37961918$exports.fromNullableK = $7f42eb8d37961918$var$ET.fromNullableK($7f42eb8d37961918$var$T.Pointed);
/**
 * Use `flatMapNullable`.
 *
 * @category legacy
 * @since 2.12.0
 */ $7f42eb8d37961918$exports.chainNullableK = /*#__PURE__*/ $7f42eb8d37961918$var$ET.chainNullableK($7f42eb8d37961918$var$T.Monad);
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * Returns `ma` if is a `Right` or the value returned by `onLeft` otherwise.
 *
 * See also [alt](#alt).
 *
 * @example
 * import * as E from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 * import * as TE from 'fp-ts/TaskEither'
 *
 * async function test() {
 *   const errorHandler = TE.orElse((error: string) => TE.right(`recovering from ${error}...`))
 *   assert.deepStrictEqual(await pipe(TE.right('ok'), errorHandler)(), E.right('ok'))
 *   assert.deepStrictEqual(await pipe(TE.left('ko'), errorHandler)(), E.right('recovering from ko...'))
 * }
 *
 * test()
 *
 * @category error handling
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.orElse = /*#__PURE__*/ $7f42eb8d37961918$var$ET.orElse($7f42eb8d37961918$var$T.Monad);
/**
 * Less strict version of [`orElse`](#orelse).
 *
 * The `W` suffix (short for **W**idening) means that the return types will be merged.
 *
 * @category error handling
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.orElseW = $7f42eb8d37961918$exports.orElse;
/**
 * Returns an effect that effectfully "peeks" at the failure of this effect.
 *
 * @category error handling
 * @since 2.15.0
 */ $7f42eb8d37961918$exports.tapError = (0, $3abDJ.dual)(2, $7f42eb8d37961918$var$ET.tapError($7f42eb8d37961918$var$T.Monad));
/**
 * @category error handling
 * @since 2.12.0
 */ var $7f42eb8d37961918$var$orElseFirstIOK = function(onLeft) {
    return (0, $7f42eb8d37961918$exports.tapError)((0, $7f42eb8d37961918$exports.fromIOK)(onLeft));
};
$7f42eb8d37961918$exports.orElseFirstIOK = $7f42eb8d37961918$var$orElseFirstIOK;
/**
 * @category error handling
 * @since 2.12.0
 */ var $7f42eb8d37961918$var$orElseFirstTaskK = function(onLeft) {
    return (0, $7f42eb8d37961918$exports.tapError)((0, $7f42eb8d37961918$exports.fromTaskK)(onLeft));
};
$7f42eb8d37961918$exports.orElseFirstTaskK = $7f42eb8d37961918$var$orElseFirstTaskK;
/**
 * @category error handling
 * @since 2.11.0
 */ $7f42eb8d37961918$exports.orLeft = /*#__PURE__*/ $7f42eb8d37961918$var$ET.orLeft($7f42eb8d37961918$var$T.Monad);
/**
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.swap = $7f42eb8d37961918$var$ET.swap($7f42eb8d37961918$var$T.Functor);
/**
 * @category lifting
 * @since 2.11.0
 */ var $7f42eb8d37961918$var$fromTaskOptionK = function(onNone) {
    var from = (0, $7f42eb8d37961918$exports.fromTaskOption)(onNone);
    return function(f) {
        return (0, $3abDJ.flow)(f, from);
    };
};
$7f42eb8d37961918$exports.fromTaskOptionK = $7f42eb8d37961918$var$fromTaskOptionK;
/**
 * Use `flatMapTaskOption`.
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @category legacy
 * @since 2.12.3
 */ var $7f42eb8d37961918$var$chainTaskOptionKW = function(onNone) {
    return function(f) {
        return function(ma) {
            return (0, $7f42eb8d37961918$exports.flatMap)(ma, (0, $7f42eb8d37961918$exports.fromTaskOptionK)(onNone)(f));
        };
    };
};
$7f42eb8d37961918$exports.chainTaskOptionKW = $7f42eb8d37961918$var$chainTaskOptionKW;
/**
 * Use `flatMapTaskOption`.
 *
 * @category legacy
 * @since 2.11.0
 */ $7f42eb8d37961918$exports.chainTaskOptionK = $7f42eb8d37961918$exports.chainTaskOptionKW;
/**
 * @category lifting
 * @since 2.4.0
 */ var $7f42eb8d37961918$var$fromIOEitherK = function(f) {
    return (0, $3abDJ.flow)(f, $7f42eb8d37961918$exports.fromIOEither);
};
$7f42eb8d37961918$exports.fromIOEitherK = $7f42eb8d37961918$var$fromIOEitherK;
var $7f42eb8d37961918$var$_map = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, $7f42eb8d37961918$exports.map)(f));
};
var $7f42eb8d37961918$var$_apPar = function(fab, fa) {
    return (0, $3abDJ.pipe)(fab, (0, $7f42eb8d37961918$exports.ap)(fa));
};
var $7f42eb8d37961918$var$_apSeq = function(fab, fa) {
    return (0, $7f42eb8d37961918$exports.flatMap)(fab, function(f) {
        return (0, $3abDJ.pipe)(fa, (0, $7f42eb8d37961918$exports.map)(f));
    });
};
/* istanbul ignore next */ var $7f42eb8d37961918$var$_alt = function(fa, that) {
    return (0, $3abDJ.pipe)(fa, (0, $7f42eb8d37961918$exports.alt)(that));
};
/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
 * use the type constructor `F` to represent some computational context.
 *
 * @category mapping
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.map = $7f42eb8d37961918$var$ET.map($7f42eb8d37961918$var$T.Functor);
/**
 * Returns a `TaskEither` whose failure and success channels have been mapped by the specified pair of functions, `f` and `g`.
 *
 * @example
 * import * as TaskEither from 'fp-ts/TaskEither'
 * import * as Either from 'fp-ts/Either'
 *
 * const f = (s: string) => new Error(s)
 * const g = (n: number) => n * 2
 *
 * async function test() {
 *   assert.deepStrictEqual(await TaskEither.mapBoth(TaskEither.right(1), f, g)(), Either.right(2))
 *   assert.deepStrictEqual(await TaskEither.mapBoth(TaskEither.left('err'), f, g)(), Either.left(new Error('err')))
 * }
 *
 * test()
 *
 * @category error handling
 * @since 2.16.0
 */ $7f42eb8d37961918$exports.mapBoth = (0, $3abDJ.dual)(3, $7f42eb8d37961918$var$ET.mapBoth($7f42eb8d37961918$var$T.Functor));
/**
 * Alias of `mapBoth`.
 *
 * @category legacy
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.bimap = $7f42eb8d37961918$exports.mapBoth;
/**
 * Returns a `TaskEither` with its error channel mapped using the specified function.
 *
 * @example
 * import * as TaskEither from 'fp-ts/TaskEither'
 * import * as Either from 'fp-ts/Either'
 *
 * const f = (s: string) => new Error(s)
 *
 * async function test() {
 *   assert.deepStrictEqual(await TaskEither.mapError(TaskEither.right(1), f)(), Either.right(1))
 *   assert.deepStrictEqual(await TaskEither.mapError(TaskEither.left('err'), f)(), Either.left(new Error('err')))
 * }
 *
 * test()
 *
 * @category error handling
 * @since 2.16.0
 */ $7f42eb8d37961918$exports.mapError = (0, $3abDJ.dual)(2, $7f42eb8d37961918$var$ET.mapError($7f42eb8d37961918$var$T.Functor));
/**
 * Alias of `mapError`.
 *
 * @category legacy
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.mapLeft = $7f42eb8d37961918$exports.mapError;
/**
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.ap = /*#__PURE__*/ $7f42eb8d37961918$var$ET.ap($7f42eb8d37961918$var$T.ApplyPar);
/**
 * Less strict version of [`ap`](#ap).
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @since 2.8.0
 */ $7f42eb8d37961918$exports.apW = $7f42eb8d37961918$exports.ap;
/**
 * @category sequencing
 * @since 2.14.0
 */ $7f42eb8d37961918$exports.flatMap = (0, $3abDJ.dual)(2, $7f42eb8d37961918$var$ET.flatMap($7f42eb8d37961918$var$T.Monad));
/**
 * Less strict version of [`flatten`](#flatten).
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @category sequencing
 * @since 2.11.0
 */ $7f42eb8d37961918$exports.flattenW = /*#__PURE__*/ (0, $7f42eb8d37961918$exports.flatMap)($3abDJ.identity);
/**
 * @category sequencing
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.flatten = $7f42eb8d37961918$exports.flattenW;
/**
 * Identifies an associative operation on a type constructor. It is similar to `Semigroup`, except that it applies to
 * types of kind `* -> *`.
 *
 * In case of `TaskEither` returns `fa` if is a `Right` or the value returned by `that` otherwise.
 *
 * See also [orElse](#orelse).
 *
 * @example
 * import * as E from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 * import * as TE from 'fp-ts/TaskEither'
 *
 * async function test() {
 *   assert.deepStrictEqual(
 *     await pipe(
 *       TE.right(1),
 *       TE.alt(() => TE.right(2))
 *     )(),
 *     E.right(1)
 *   )
 *   assert.deepStrictEqual(
 *     await pipe(
 *       TE.left('a'),
 *       TE.alt(() => TE.right(2))
 *     )(),
 *     E.right(2)
 *   )
 *   assert.deepStrictEqual(
 *     await pipe(
 *       TE.left('a'),
 *       TE.alt(() => TE.left('b'))
 *     )(),
 *     E.left('b')
 *   )
 * }
 *
 * test()
 *
 * @category error handling
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.alt = /*#__PURE__*/ $7f42eb8d37961918$var$ET.alt($7f42eb8d37961918$var$T.Monad);
/**
 * Less strict version of [`alt`](#alt).
 *
 * The `W` suffix (short for **W**idening) means that the error and the return types will be merged.
 *
 * @category error handling
 * @since 2.9.0
 */ $7f42eb8d37961918$exports.altW = $7f42eb8d37961918$exports.alt;
/**
 * @category constructors
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.of = $7f42eb8d37961918$exports.right;
/**
 * @since 2.7.0
 */ $7f42eb8d37961918$exports.throwError = $7f42eb8d37961918$exports.left;
/**
 * @category type lambdas
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.URI = 'TaskEither';
/**
 * The default [`ApplicativePar`](#applicativepar) instance returns the first error, if you want to
 * get all errors you need to provide a way to concatenate them via a `Semigroup`.
 *
 * @example
 * import * as E from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 * import * as RA from 'fp-ts/ReadonlyArray'
 * import * as S from 'fp-ts/Semigroup'
 * import * as string from 'fp-ts/string'
 * import * as T from 'fp-ts/Task'
 * import * as TE from 'fp-ts/TaskEither'
 *
 * interface User {
 *   readonly id: string
 *   readonly name: string
 * }
 *
 * const remoteDatabase: ReadonlyArray<User> = [
 *   { id: 'id1', name: 'John' },
 *   { id: 'id2', name: 'Mary' },
 *   { id: 'id3', name: 'Joey' }
 * ]
 *
 * const fetchUser = (id: string): TE.TaskEither<string, User> =>
 *   pipe(
 *     remoteDatabase,
 *     RA.findFirst((user) => user.id === id),
 *     TE.fromOption(() => `${id} not found`)
 *   )
 *
 * async function test() {
 *   assert.deepStrictEqual(
 *     await pipe(['id4', 'id5'], RA.traverse(TE.ApplicativePar)(fetchUser))(),
 *     E.left('id4 not found') // <= first error
 *   )
 *
 *   const Applicative = TE.getApplicativeTaskValidation(
 *     T.ApplyPar,
 *     pipe(string.Semigroup, S.intercalate(', '))
 *   )
 *
 *   assert.deepStrictEqual(
 *     await pipe(['id4', 'id5'], RA.traverse(Applicative)(fetchUser))(),
 *     E.left('id4 not found, id5 not found') // <= all errors
 *   )
 * }
 *
 * test()
 *
 * @category error handling
 * @since 2.7.0
 */ function $7f42eb8d37961918$var$getApplicativeTaskValidation(A, S) {
    var ap = (0, $4sfjE.ap)(A, $7f42eb8d37961918$var$E.getApplicativeValidation(S));
    return {
        URI: $7f42eb8d37961918$exports.URI,
        _E: undefined,
        map: $7f42eb8d37961918$var$_map,
        ap: function(fab, fa) {
            return (0, $3abDJ.pipe)(fab, ap(fa));
        },
        of: $7f42eb8d37961918$exports.of
    };
}
/**
 * The default [`Alt`](#alt) instance returns the last error, if you want to
 * get all errors you need to provide a way to concatenate them via a `Semigroup`.
 *
 * See [`getAltValidation`](./Either.ts.html#getaltvalidation).
 *
 * @category error handling
 * @since 2.7.0
 */ function $7f42eb8d37961918$var$getAltTaskValidation(S) {
    var alt = $7f42eb8d37961918$var$ET.altValidation($7f42eb8d37961918$var$T.Monad, S);
    return {
        URI: $7f42eb8d37961918$exports.URI,
        _E: undefined,
        map: $7f42eb8d37961918$var$_map,
        alt: function(fa, that) {
            return (0, $3abDJ.pipe)(fa, alt(that));
        }
    };
}
/**
 * @category filtering
 * @since 2.10.0
 */ var $7f42eb8d37961918$var$getCompactable = function(M) {
    var C = $7f42eb8d37961918$var$E.getCompactable(M);
    return {
        URI: $7f42eb8d37961918$exports.URI,
        _E: undefined,
        compact: (0, $eb68b3531da38f36$exports.compact)($7f42eb8d37961918$var$T.Functor, C),
        separate: (0, $eb68b3531da38f36$exports.separate)($7f42eb8d37961918$var$T.Functor, C, $7f42eb8d37961918$var$E.Functor)
    };
};
$7f42eb8d37961918$exports.getCompactable = $7f42eb8d37961918$var$getCompactable;
/**
 * @category filtering
 * @since 2.1.0
 */ function $7f42eb8d37961918$var$getFilterable(M) {
    var F = $7f42eb8d37961918$var$E.getFilterable(M);
    var C = (0, $7f42eb8d37961918$exports.getCompactable)(M);
    var filter = (0, $296ec91c31ad8460$exports.filter)($7f42eb8d37961918$var$T.Functor, F);
    var filterMap = (0, $296ec91c31ad8460$exports.filterMap)($7f42eb8d37961918$var$T.Functor, F);
    var partition = (0, $296ec91c31ad8460$exports.partition)($7f42eb8d37961918$var$T.Functor, F);
    var partitionMap = (0, $296ec91c31ad8460$exports.partitionMap)($7f42eb8d37961918$var$T.Functor, F);
    return {
        URI: $7f42eb8d37961918$exports.URI,
        _E: undefined,
        map: $7f42eb8d37961918$var$_map,
        compact: C.compact,
        separate: C.separate,
        filter: function(fa, predicate) {
            return (0, $3abDJ.pipe)(fa, filter(predicate));
        },
        filterMap: function(fa, f) {
            return (0, $3abDJ.pipe)(fa, filterMap(f));
        },
        partition: function(fa, predicate) {
            return (0, $3abDJ.pipe)(fa, partition(predicate));
        },
        partitionMap: function(fa, f) {
            return (0, $3abDJ.pipe)(fa, partitionMap(f));
        }
    };
}
/**
 * @category instances
 * @since 2.7.0
 */ $7f42eb8d37961918$exports.Functor = {
    URI: $7f42eb8d37961918$exports.URI,
    map: $7f42eb8d37961918$var$_map
};
/**
 * Maps the `Right` value of this `TaskEither` to the specified constant value.
 *
 * @category mapping
 * @since 2.16.0
 */ $7f42eb8d37961918$exports.as = (0, $3abDJ.dual)(2, (0, $emm1u.as)($7f42eb8d37961918$exports.Functor));
/**
 * Maps the `Right` value of this `TaskEither` to the void constant value.
 *
 * @category mapping
 * @since 2.16.0
 */ $7f42eb8d37961918$exports.asUnit = (0, $emm1u.asUnit)($7f42eb8d37961918$exports.Functor);
/**
 * @category mapping
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.flap = (0, $emm1u.flap)($7f42eb8d37961918$exports.Functor);
/**
 * @category instances
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.Pointed = {
    URI: $7f42eb8d37961918$exports.URI,
    of: $7f42eb8d37961918$exports.of
};
/**
 * Runs computations in parallel.
 *
 * @category instances
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.ApplyPar = {
    URI: $7f42eb8d37961918$exports.URI,
    map: $7f42eb8d37961918$var$_map,
    ap: $7f42eb8d37961918$var$_apPar
};
/**
 * Combine two effectful actions, keeping only the result of the first.
 *
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.apFirst = (0, $4sfjE.apFirst)($7f42eb8d37961918$exports.ApplyPar);
/**
 * Less strict version of [`apFirst`](#apfirst).
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @since 2.12.0
 */ $7f42eb8d37961918$exports.apFirstW = $7f42eb8d37961918$exports.apFirst;
/**
 * Combine two effectful actions, keeping only the result of the second.
 *
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.apSecond = (0, $4sfjE.apSecond)($7f42eb8d37961918$exports.ApplyPar);
/**
 * Less strict version of [`apSecond`](#apsecond).
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @since 2.12.0
 */ $7f42eb8d37961918$exports.apSecondW = $7f42eb8d37961918$exports.apSecond;
/**
 * Runs computations in parallel.
 *
 * @category instances
 * @since 2.7.0
 */ $7f42eb8d37961918$exports.ApplicativePar = {
    URI: $7f42eb8d37961918$exports.URI,
    map: $7f42eb8d37961918$var$_map,
    ap: $7f42eb8d37961918$var$_apPar,
    of: $7f42eb8d37961918$exports.of
};
/**
 * Runs computations sequentially.
 *
 * @category instances
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.ApplySeq = {
    URI: $7f42eb8d37961918$exports.URI,
    map: $7f42eb8d37961918$var$_map,
    ap: $7f42eb8d37961918$var$_apSeq
};
/**
 * Runs computations sequentially.
 *
 * @category instances
 * @since 2.7.0
 */ $7f42eb8d37961918$exports.ApplicativeSeq = {
    URI: $7f42eb8d37961918$exports.URI,
    map: $7f42eb8d37961918$var$_map,
    ap: $7f42eb8d37961918$var$_apSeq,
    of: $7f42eb8d37961918$exports.of
};
/**
 * @category instances
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.Chain = {
    URI: $7f42eb8d37961918$exports.URI,
    map: $7f42eb8d37961918$var$_map,
    ap: $7f42eb8d37961918$var$_apPar,
    chain: $7f42eb8d37961918$exports.flatMap
};
/**
 * @category instances
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.Monad = {
    URI: $7f42eb8d37961918$exports.URI,
    map: $7f42eb8d37961918$var$_map,
    ap: $7f42eb8d37961918$var$_apPar,
    chain: $7f42eb8d37961918$exports.flatMap,
    of: $7f42eb8d37961918$exports.of
};
/**
 * @category instances
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.MonadIO = {
    URI: $7f42eb8d37961918$exports.URI,
    map: $7f42eb8d37961918$var$_map,
    ap: $7f42eb8d37961918$var$_apPar,
    chain: $7f42eb8d37961918$exports.flatMap,
    of: $7f42eb8d37961918$exports.of,
    fromIO: $7f42eb8d37961918$exports.fromIO
};
/**
 * @category instances
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.MonadTask = {
    URI: $7f42eb8d37961918$exports.URI,
    map: $7f42eb8d37961918$var$_map,
    ap: $7f42eb8d37961918$var$_apPar,
    chain: $7f42eb8d37961918$exports.flatMap,
    of: $7f42eb8d37961918$exports.of,
    fromIO: $7f42eb8d37961918$exports.fromIO,
    fromTask: $7f42eb8d37961918$exports.fromTask
};
/**
 * @category instances
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.MonadThrow = {
    URI: $7f42eb8d37961918$exports.URI,
    map: $7f42eb8d37961918$var$_map,
    ap: $7f42eb8d37961918$var$_apPar,
    chain: $7f42eb8d37961918$exports.flatMap,
    of: $7f42eb8d37961918$exports.of,
    throwError: $7f42eb8d37961918$exports.throwError
};
/**
 * @category instances
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.FromEither = {
    URI: $7f42eb8d37961918$exports.URI,
    fromEither: $7f42eb8d37961918$exports.fromEither
};
/**
 * @category instances
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.FromIO = {
    URI: $7f42eb8d37961918$exports.URI,
    fromIO: $7f42eb8d37961918$exports.fromIO
};
/**
 * @category instances
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.FromTask = {
    URI: $7f42eb8d37961918$exports.URI,
    fromIO: $7f42eb8d37961918$exports.fromIO,
    fromTask: $7f42eb8d37961918$exports.fromTask
};
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * @category combinators
 * @since 2.15.0
 */ $7f42eb8d37961918$exports.tap = (0, $3abDJ.dual)(2, $7f42eb8d37961918$var$chainable.tap($7f42eb8d37961918$exports.Chain));
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * @example
 * import * as E from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 * import * as TE from 'fp-ts/TaskEither'
 *
 * const checkString = (value: string) => pipe(
 *   TE.of(value),
 *   TE.tapEither(() => value.length > 0 ? E.right('ok') : E.left('error'))
 * )
 *
 * async function test() {
 *   assert.deepStrictEqual(await checkString('')(), E.left('error'))
 *   assert.deepStrictEqual(await checkString('fp-ts')(), E.right('fp-ts'))
 * }
 *
 * test()
 *
 * @category combinators
 * @since 2.16.0
 */ $7f42eb8d37961918$exports.tapEither = (0, $3abDJ.dual)(2, (0, $eLQyV.tapEither)($7f42eb8d37961918$exports.FromEither, $7f42eb8d37961918$exports.Chain));
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * @example
 * import { pipe } from 'fp-ts/function'
 * import * as TE from 'fp-ts/TaskEither'
 * import * as E from 'fp-ts/Either'
 * import * as Console from 'fp-ts/Console'
 *
 *
 * // Will produce `Hello, fp-ts` to the stdout
 * const effectA = TE.tapIO(
 *   TE.of(1),
 *   (value) => Console.log(`Hello, ${value}`)
 * )
 *
 * // No output to the stdout
 * const effectB = pipe(
 *   TE.left('error'),
 *   TE.tapIO((value) => Console.log(`Hello, ${value}`))
 * )
 *
 * async function test() {
 *   assert.deepStrictEqual(await effectA(), E.of(1))
 *   assert.deepStrictEqual(await effectB(), E.left('error'))
 * }
 *
 * test()
 *
 * @category combinators
 * @since 2.16.0
 */ $7f42eb8d37961918$exports.tapIO = (0, $3abDJ.dual)(2, (0, $bycRW.tapIO)($7f42eb8d37961918$exports.FromIO, $7f42eb8d37961918$exports.Chain));
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * @example
 * import * as TE from 'fp-ts/TaskEither'
 * import * as T from 'fp-ts/Task'
 * import * as E from 'fp-ts/Either'
 *
 *
 * const effect = TE.tapIO(
 *   TE.of(1),
 *   (value) => T.of(value + 1)
 * )
 *
 * async function test() {
 *   assert.deepStrictEqual(await effect(), E.of(1))
 * }
 *
 * test()
 *
 * @category combinators
 * @since 2.16.0
 */ $7f42eb8d37961918$exports.tapTask = (0, $3abDJ.dual)(2, (0, $eb6e6c65abb42686$exports.tapTask)($7f42eb8d37961918$exports.FromTask, $7f42eb8d37961918$exports.Chain));
/**
 * @category instances
 * @since 2.7.0
 */ $7f42eb8d37961918$exports.Bifunctor = {
    URI: $7f42eb8d37961918$exports.URI,
    bimap: $7f42eb8d37961918$exports.mapBoth,
    mapLeft: $7f42eb8d37961918$exports.mapError
};
/**
 * @category instances
 * @since 2.7.0
 */ $7f42eb8d37961918$exports.Alt = {
    URI: $7f42eb8d37961918$exports.URI,
    map: $7f42eb8d37961918$var$_map,
    alt: $7f42eb8d37961918$var$_alt
};
/**
 * @category conversions
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.fromOption = /*#__PURE__*/ (0, $eLQyV.fromOption)($7f42eb8d37961918$exports.FromEither);
/**
 * Use `liftOption`.
 *
 * @category legacy
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.fromOptionK = /*#__PURE__*/ (0, $eLQyV.fromOptionK)($7f42eb8d37961918$exports.FromEither);
/**
 * Use `flatMapOption`.
 *
 * @category legacy
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.chainOptionK = (0, $eLQyV.chainOptionK)($7f42eb8d37961918$exports.FromEither, $7f42eb8d37961918$exports.Chain);
/**
 * Use `flatMapOption`.
 *
 * @category legacy
 * @since 2.13.2
 */ $7f42eb8d37961918$exports.chainOptionKW = $7f42eb8d37961918$exports.chainOptionK;
/** @internal */ var $7f42eb8d37961918$var$_FromEither = {
    fromEither: $7f42eb8d37961918$exports.FromEither.fromEither
};
/**
 * @category lifting
 * @since 2.15.0
 */ $7f42eb8d37961918$exports.liftNullable = $7f42eb8d37961918$var$_.liftNullable($7f42eb8d37961918$var$_FromEither);
/**
 * @category lifting
 * @since 2.15.0
 */ $7f42eb8d37961918$exports.liftOption = $7f42eb8d37961918$var$_.liftOption($7f42eb8d37961918$var$_FromEither);
/** @internal */ var $7f42eb8d37961918$var$_FlatMap = {
    flatMap: $7f42eb8d37961918$exports.flatMap
};
/** @internal */ var $7f42eb8d37961918$var$_FromIO = {
    fromIO: $7f42eb8d37961918$exports.FromIO.fromIO
};
/** @internal */ var $7f42eb8d37961918$var$_FromTask = {
    fromTask: $7f42eb8d37961918$exports.fromTask
};
/**
 * @category sequencing
 * @since 2.15.0
 */ $7f42eb8d37961918$exports.flatMapNullable = $7f42eb8d37961918$var$_.flatMapNullable($7f42eb8d37961918$var$_FromEither, $7f42eb8d37961918$var$_FlatMap);
/**
 * @category sequencing
 * @since 2.15.0
 */ $7f42eb8d37961918$exports.flatMapOption = $7f42eb8d37961918$var$_.flatMapOption($7f42eb8d37961918$var$_FromEither, $7f42eb8d37961918$var$_FlatMap);
/**
 * @category sequencing
 * @since 2.15.0
 */ $7f42eb8d37961918$exports.flatMapEither = $7f42eb8d37961918$var$_.flatMapEither($7f42eb8d37961918$var$_FromEither, $7f42eb8d37961918$var$_FlatMap);
/**
 * @category sequencing
 * @since 2.15.0
 */ $7f42eb8d37961918$exports.flatMapIO = $7f42eb8d37961918$var$_.flatMapIO($7f42eb8d37961918$var$_FromIO, $7f42eb8d37961918$var$_FlatMap);
/**
 * @category sequencing
 * @since 2.16.0
 */ $7f42eb8d37961918$exports.flatMapTask = $7f42eb8d37961918$var$_.flatMapTask($7f42eb8d37961918$var$_FromTask, $7f42eb8d37961918$var$_FlatMap);
/**
 * @category sequencing
 * @since 2.16.0
 */ $7f42eb8d37961918$exports.flatMapIOEither = (0, $3abDJ.dual)(2, function(self, f) {
    return (0, $7f42eb8d37961918$exports.flatMap)(self, (0, $7f42eb8d37961918$exports.fromIOEitherK)(f));
});
/**
 * @category sequencing
 * @since 2.16.0
 */ $7f42eb8d37961918$exports.flatMapTaskOption = (0, $3abDJ.dual)(3, function(self, f, onNone) {
    return (0, $7f42eb8d37961918$exports.flatMap)(self, function(a) {
        return (0, $7f42eb8d37961918$exports.fromTaskOption)(function() {
            return onNone(a);
        })(f(a));
    });
});
/**
 * Alias of `flatMapEither`.
 *
 * @category legacy
 * @since 2.4.0
 */ $7f42eb8d37961918$exports.chainEitherK = $7f42eb8d37961918$exports.flatMapEither;
/**
 * Alias of `flatMapEither`.
 *
 * @category legacy
 * @since 2.6.1
 */ $7f42eb8d37961918$exports.chainEitherKW = $7f42eb8d37961918$exports.flatMapEither;
/**
 * Alias of `tapEither`.
 *
 * @category legacy
 * @since 2.12.0
 */ $7f42eb8d37961918$exports.chainFirstEitherK = $7f42eb8d37961918$exports.tapEither;
/**
 * Alias of `tapEither`.
 *
 * Less strict version of [`chainFirstEitherK`](#chainfirsteitherk).
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @category legacy
 * @since 2.12.0
 */ $7f42eb8d37961918$exports.chainFirstEitherKW = $7f42eb8d37961918$exports.tapEither;
/**
 * @category lifting
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.fromPredicate = (0, $eLQyV.fromPredicate)($7f42eb8d37961918$exports.FromEither);
/**
 * @category filtering
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.filterOrElse = (0, $eLQyV.filterOrElse)($7f42eb8d37961918$exports.FromEither, $7f42eb8d37961918$exports.Chain);
/**
 * Less strict version of [`filterOrElse`](#filterorelse).
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @category filtering
 * @since 2.9.0
 */ $7f42eb8d37961918$exports.filterOrElseW = $7f42eb8d37961918$exports.filterOrElse;
/**
 * @category lifting
 * @since 2.4.0
 */ $7f42eb8d37961918$exports.fromEitherK = (0, $eLQyV.fromEitherK)($7f42eb8d37961918$exports.FromEither);
/**
 * @category lifting
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.fromIOK = (0, $bycRW.fromIOK)($7f42eb8d37961918$exports.FromIO);
/**
 * Alias of `flatMapIO`.
 *
 * @category legacy
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.chainIOK = $7f42eb8d37961918$exports.flatMapIO;
/**
 * Alias of `tapIO`.
 *
 * @category legacy
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.chainFirstIOK = $7f42eb8d37961918$exports.tapIO;
/**
 * @category lifting
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.fromTaskK = (0, $eb6e6c65abb42686$exports.fromTaskK)($7f42eb8d37961918$exports.FromTask);
/**
 * Alias of `flatMapTask`.
 *
 * @category legacy
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.chainTaskK = $7f42eb8d37961918$exports.flatMapTask;
/**
 * Alias of `tapTask`.
 *
 * @category legacy
 * @since 2.10.0
 */ $7f42eb8d37961918$exports.chainFirstTaskK = $7f42eb8d37961918$exports.tapTask;
/**
 * Alias of `flatMapIOEither`.
 *
 * Less strict version of [`chainIOEitherK`](#chainioeitherk).
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @category legacy
 * @since 2.6.1
 */ $7f42eb8d37961918$exports.chainIOEitherKW = $7f42eb8d37961918$exports.flatMapIOEither;
/**
 * Alias of `flatMapIOEither`.
 *
 * @category legacy
 * @since 2.4.0
 */ $7f42eb8d37961918$exports.chainIOEitherK = $7f42eb8d37961918$exports.flatMapIOEither;
function $7f42eb8d37961918$var$taskify(f) {
    return function() {
        var args = Array.prototype.slice.call(arguments);
        return function() {
            return new Promise(function(resolve) {
                var cbResolver = function(e, r) {
                    return e != null ? resolve($7f42eb8d37961918$var$_.left(e)) : resolve($7f42eb8d37961918$var$_.right(r));
                };
                f.apply(null, args.concat(cbResolver));
            });
        };
    };
}
/**
 * Make sure that a resource is cleaned up in the event of an exception (\*). The release action is called regardless of
 * whether the body action throws (\*) or returns.
 *
 * (\*) i.e. returns a `Left`
 *
 * @since 2.0.0
 */ var $7f42eb8d37961918$var$bracket = function(acquire, use, release) {
    return (0, $7f42eb8d37961918$exports.bracketW)(acquire, use, release);
};
$7f42eb8d37961918$exports.bracket = $7f42eb8d37961918$var$bracket;
/**
 * Less strict version of [`bracket`](#bracket).
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @since 2.12.0
 */ var $7f42eb8d37961918$var$bracketW = function(acquire, use, release) {
    return (0, $7f42eb8d37961918$exports.flatMap)(acquire, function(a) {
        return $7f42eb8d37961918$var$T.flatMap(use(a), function(e) {
            return (0, $7f42eb8d37961918$exports.flatMap)(release(a, e), function() {
                return $7f42eb8d37961918$var$T.of(e);
            });
        });
    });
};
$7f42eb8d37961918$exports.bracketW = $7f42eb8d37961918$var$bracketW;
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * @category do notation
 * @since 2.9.0
 */ $7f42eb8d37961918$exports.Do = (0, $7f42eb8d37961918$exports.of)($7f42eb8d37961918$var$_.emptyRecord);
/**
 * @category do notation
 * @since 2.8.0
 */ $7f42eb8d37961918$exports.bindTo = (0, $emm1u.bindTo)($7f42eb8d37961918$exports.Functor);
var $7f42eb8d37961918$var$let_ = /*#__PURE__*/ (0, $emm1u.let)($7f42eb8d37961918$exports.Functor);
$7f42eb8d37961918$exports.let = $7f42eb8d37961918$var$let_;
/**
 * @category do notation
 * @since 2.8.0
 */ $7f42eb8d37961918$exports.bind = $7f42eb8d37961918$var$chainable.bind($7f42eb8d37961918$exports.Chain);
/**
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @category do notation
 * @since 2.8.0
 */ $7f42eb8d37961918$exports.bindW = $7f42eb8d37961918$exports.bind;
/**
 * @category do notation
 * @since 2.8.0
 */ $7f42eb8d37961918$exports.apS = (0, $4sfjE.apS)($7f42eb8d37961918$exports.ApplyPar);
/**
 * Less strict version of [`apS`](#aps).
 *
 * The `W` suffix (short for **W**idening) means that the error types will be merged.
 *
 * @category do notation
 * @since 2.8.0
 */ $7f42eb8d37961918$exports.apSW = $7f42eb8d37961918$exports.apS;
/**
 * @since 2.11.0
 */ $7f42eb8d37961918$exports.ApT = (0, $7f42eb8d37961918$exports.of)($7f42eb8d37961918$var$_.emptyReadonlyArray);
// -------------------------------------------------------------------------------------
// array utils
// -------------------------------------------------------------------------------------
/**
 * Equivalent to `ReadonlyNonEmptyArray#traverseWithIndex(ApplicativePar)`.
 *
 * @category traversing
 * @since 2.11.0
 */ var $7f42eb8d37961918$var$traverseReadonlyNonEmptyArrayWithIndex = function(f) {
    return (0, $3abDJ.flow)($7f42eb8d37961918$var$T.traverseReadonlyNonEmptyArrayWithIndex(f), $7f42eb8d37961918$var$T.map($7f42eb8d37961918$var$E.traverseReadonlyNonEmptyArrayWithIndex($3abDJ.SK)));
};
$7f42eb8d37961918$exports.traverseReadonlyNonEmptyArrayWithIndex = $7f42eb8d37961918$var$traverseReadonlyNonEmptyArrayWithIndex;
/**
 * Equivalent to `ReadonlyArray#traverseWithIndex(ApplicativePar)`.
 *
 * @category traversing
 * @since 2.11.0
 */ var $7f42eb8d37961918$var$traverseReadonlyArrayWithIndex = function(f) {
    var g = (0, $7f42eb8d37961918$exports.traverseReadonlyNonEmptyArrayWithIndex)(f);
    return function(as) {
        return $7f42eb8d37961918$var$_.isNonEmpty(as) ? g(as) : $7f42eb8d37961918$exports.ApT;
    };
};
$7f42eb8d37961918$exports.traverseReadonlyArrayWithIndex = $7f42eb8d37961918$var$traverseReadonlyArrayWithIndex;
/**
 * Equivalent to `ReadonlyArray#traverseWithIndex(ApplicativeSeq)`.
 *
 * @category traversing
 * @since 2.11.0
 */ var $7f42eb8d37961918$var$traverseReadonlyNonEmptyArrayWithIndexSeq = function(f) {
    return function(as) {
        return function() {
            return $7f42eb8d37961918$var$_.tail(as).reduce(function(acc, a, i) {
                return acc.then(function(ebs) {
                    return $7f42eb8d37961918$var$_.isLeft(ebs) ? acc : f(i + 1, a)().then(function(eb) {
                        if ($7f42eb8d37961918$var$_.isLeft(eb)) return eb;
                        ebs.right.push(eb.right);
                        return ebs;
                    });
                });
            }, f(0, $7f42eb8d37961918$var$_.head(as))().then($7f42eb8d37961918$var$E.map($7f42eb8d37961918$var$_.singleton)));
        };
    };
};
$7f42eb8d37961918$exports.traverseReadonlyNonEmptyArrayWithIndexSeq = $7f42eb8d37961918$var$traverseReadonlyNonEmptyArrayWithIndexSeq;
/**
 * Equivalent to `ReadonlyArray#traverseWithIndex(ApplicativeSeq)`.
 *
 * @category traversing
 * @since 2.11.0
 */ var $7f42eb8d37961918$var$traverseReadonlyArrayWithIndexSeq = function(f) {
    var g = (0, $7f42eb8d37961918$exports.traverseReadonlyNonEmptyArrayWithIndexSeq)(f);
    return function(as) {
        return $7f42eb8d37961918$var$_.isNonEmpty(as) ? g(as) : $7f42eb8d37961918$exports.ApT;
    };
};
$7f42eb8d37961918$exports.traverseReadonlyArrayWithIndexSeq = $7f42eb8d37961918$var$traverseReadonlyArrayWithIndexSeq;
/**
 * Equivalent to `ReadonlyArray#traverseWithIndex(Applicative)`.
 *
 * @category traversing
 * @since 2.9.0
 */ $7f42eb8d37961918$exports.traverseArrayWithIndex = $7f42eb8d37961918$exports.traverseReadonlyArrayWithIndex;
/**
 * Equivalent to `ReadonlyArray#traverse(Applicative)`.
 *
 * @category traversing
 * @since 2.9.0
 */ var $7f42eb8d37961918$var$traverseArray = function(f) {
    return (0, $7f42eb8d37961918$exports.traverseReadonlyArrayWithIndex)(function(_, a) {
        return f(a);
    });
};
$7f42eb8d37961918$exports.traverseArray = $7f42eb8d37961918$var$traverseArray;
/**
 * Equivalent to `ReadonlyArray#sequence(Applicative)`.
 *
 * @category traversing
 * @since 2.9.0
 */ $7f42eb8d37961918$exports.sequenceArray = /*#__PURE__*/ (0, $7f42eb8d37961918$exports.traverseArray)($3abDJ.identity);
/**
 * Equivalent to `ReadonlyArray#traverseWithIndex(ApplicativeSeq)`.
 *
 * @category traversing
 * @since 2.9.0
 */ $7f42eb8d37961918$exports.traverseSeqArrayWithIndex = $7f42eb8d37961918$exports.traverseReadonlyArrayWithIndexSeq;
/**
 * Equivalent to `ReadonlyArray#traverse(ApplicativeSeq)`.
 *
 * @category traversing
 * @since 2.9.0
 */ var $7f42eb8d37961918$var$traverseSeqArray = function(f) {
    return (0, $7f42eb8d37961918$exports.traverseReadonlyArrayWithIndexSeq)(function(_, a) {
        return f(a);
    });
};
$7f42eb8d37961918$exports.traverseSeqArray = $7f42eb8d37961918$var$traverseSeqArray;
/**
 * Equivalent to `ReadonlyArray#sequence(ApplicativeSeq)`.
 *
 * @category traversing
 * @since 2.9.0
 */ $7f42eb8d37961918$exports.sequenceSeqArray = /*#__PURE__*/ (0, $7f42eb8d37961918$exports.traverseSeqArray)($3abDJ.identity);
// -------------------------------------------------------------------------------------
// legacy
// -------------------------------------------------------------------------------------
/**
 * Alias of `flatMap`.
 *
 * @category legacy
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.chain = $7f42eb8d37961918$exports.flatMap;
/**
 * Alias of `flatMap`.
 *
 * @category legacy
 * @since 2.6.0
 */ $7f42eb8d37961918$exports.chainW = $7f42eb8d37961918$exports.flatMap;
/**
 * Alias of `tap`.
 *
 * @category legacy
 * @since 2.0.0
 */ $7f42eb8d37961918$exports.chainFirst = $7f42eb8d37961918$exports.tap;
/**
 * Alias of `tap`.
 *
 * @category legacy
 * @since 2.8.0
 */ $7f42eb8d37961918$exports.chainFirstW = $7f42eb8d37961918$exports.tap;
/**
 * Alias of `tapError`.
 *
 * @category legacy
 * @since 2.11.0
 */ $7f42eb8d37961918$exports.orElseFirst = $7f42eb8d37961918$exports.tapError;
/**
 * Alias of `tapError`.
 *
 * @category legacy
 * @since 2.11.0
 */ $7f42eb8d37961918$exports.orElseFirstW = $7f42eb8d37961918$exports.tapError;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Functor` instance, pass `TE.Functor` instead of `TE.taskEither`
 * (where `TE` is from `import TE from 'fp-ts/TaskEither'`)
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ $7f42eb8d37961918$exports.taskEither = {
    URI: $7f42eb8d37961918$exports.URI,
    bimap: $7f42eb8d37961918$exports.mapBoth,
    mapLeft: $7f42eb8d37961918$exports.mapError,
    map: $7f42eb8d37961918$var$_map,
    of: $7f42eb8d37961918$exports.of,
    ap: $7f42eb8d37961918$var$_apPar,
    chain: $7f42eb8d37961918$exports.flatMap,
    alt: $7f42eb8d37961918$var$_alt,
    fromIO: $7f42eb8d37961918$exports.fromIO,
    fromTask: $7f42eb8d37961918$exports.fromTask,
    throwError: $7f42eb8d37961918$exports.throwError
};
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Functor` instance, pass `TE.Functor` instead of `TE.taskEitherSeq`
 * (where `TE` is from `import TE from 'fp-ts/TaskEither'`)
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ $7f42eb8d37961918$exports.taskEitherSeq = {
    URI: $7f42eb8d37961918$exports.URI,
    bimap: $7f42eb8d37961918$exports.mapBoth,
    mapLeft: $7f42eb8d37961918$exports.mapError,
    map: $7f42eb8d37961918$var$_map,
    of: $7f42eb8d37961918$exports.of,
    ap: $7f42eb8d37961918$var$_apSeq,
    chain: $7f42eb8d37961918$exports.flatMap,
    alt: $7f42eb8d37961918$var$_alt,
    fromIO: $7f42eb8d37961918$exports.fromIO,
    fromTask: $7f42eb8d37961918$exports.fromTask,
    throwError: $7f42eb8d37961918$exports.throwError
};
/**
 * Use [`getApplySemigroup`](./Apply.ts.html#getapplysemigroup) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ $7f42eb8d37961918$exports.getApplySemigroup = /*#__PURE__*/ (0, $4sfjE.getApplySemigroup)($7f42eb8d37961918$exports.ApplySeq);
/**
 * Use [`getApplicativeMonoid`](./Applicative.ts.html#getapplicativemonoid) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ $7f42eb8d37961918$exports.getApplyMonoid = /*#__PURE__*/ (0, $eImHL.getApplicativeMonoid)($7f42eb8d37961918$exports.ApplicativeSeq);
/**
 * Use [`getApplySemigroup`](./Apply.ts.html#getapplysemigroup) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ var $7f42eb8d37961918$var$getSemigroup = function(S) {
    return (0, $4sfjE.getApplySemigroup)($7f42eb8d37961918$var$T.ApplySeq)($7f42eb8d37961918$var$E.getSemigroup(S));
};
$7f42eb8d37961918$exports.getSemigroup = $7f42eb8d37961918$var$getSemigroup;
/**
 * Use [`getApplicativeTaskValidation`](#getapplicativetaskvalidation) and [`getAltTaskValidation`](#getalttaskvalidation) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ function $7f42eb8d37961918$var$getTaskValidation(SE) {
    var applicativeTaskValidation = $7f42eb8d37961918$var$getApplicativeTaskValidation($7f42eb8d37961918$var$T.ApplicativePar, SE);
    var altTaskValidation = $7f42eb8d37961918$var$getAltTaskValidation(SE);
    return {
        URI: $7f42eb8d37961918$exports.URI,
        _E: undefined,
        map: $7f42eb8d37961918$var$_map,
        ap: applicativeTaskValidation.ap,
        of: $7f42eb8d37961918$exports.of,
        chain: $7f42eb8d37961918$exports.flatMap,
        bimap: $7f42eb8d37961918$exports.mapBoth,
        mapLeft: $7f42eb8d37961918$exports.mapError,
        alt: altTaskValidation.alt,
        fromIO: $7f42eb8d37961918$exports.fromIO,
        fromTask: $7f42eb8d37961918$exports.fromTask,
        throwError: $7f42eb8d37961918$exports.throwError
    };
}



var $hBXBN = parcelRequire("hBXBN");



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

/**
 * Units.
 *
 * @since 0.2.0
 */ 
var $3abDJ = parcelRequire("3abDJ");

const $4beeab19e80c1290$var$noProductFactor = (x)=>x;
const $4beeab19e80c1290$export$a30d9f878a2b791a = {
    name: 'plain',
    build: (x)=>x.toString(),
    parse: (str)=>$4beeab19e80c1290$var$notNaN(parseFloat(str)),
    defaultProduct: $4beeab19e80c1290$var$noProductFactor
};
const $4beeab19e80c1290$export$4ac1902d8b310847 = {
    name: 'pieces',
    build: (x)=>Math.round(x).toString() + ' pc',
    parse: (str)=>$4beeab19e80c1290$var$notNaN(Math.round(parseFloat(str))),
    defaultProduct: $4beeab19e80c1290$var$noProductFactor
};
/**
 * Greatest common divisor.
 *
 * @since 0.2.0
 */ const $4beeab19e80c1290$var$gcd = (a, b)=>isNaN(a) || isNaN(b) ? NaN : a === 0 ? b : b === 0 ? a : a > b ? $4beeab19e80c1290$var$gcd(a % b, b) : $4beeab19e80c1290$var$gcd(b % a, a);
const $4beeab19e80c1290$var$lengthUnits = {
    inch: true,
    mm: true
};
const $4beeab19e80c1290$export$8cba090a009adf02 = (0, $87701c398fec8638$export$7e1278799275f68e)($4beeab19e80c1290$var$lengthUnits);
const $4beeab19e80c1290$var$decimalFromInchString = (str)=>str.split(/(?!^)-|\s/) // Split on space or dash
    .map((e)=>e.split('/') // Split fraction
        .map(parseFloat) // Turn everything into a float
        .reduce((a, b)=>a / b)) // Get fraction as decimal
    .reduce((a, b)=>a >= 0 ? a + b : a - b); // Add whole number and decimal
const $4beeab19e80c1290$var$notNaN = (num)=>{
    if (isNaN(num)) return Promise.reject(new Error('Value is not a number.'));
    else return Promise.resolve(num);
};
const $4beeab19e80c1290$var$nonNaN = {
    name: 'non-nan',
    build: (x)=>isNaN(x) ? 0 : x,
    parse: $4beeab19e80c1290$var$notNaN,
    defaultProduct: $4beeab19e80c1290$var$noProductFactor
};
const $4beeab19e80c1290$export$e8bcfcb317682b2e = (f, g, name)=>({
        name: name ? name : f.name + ' ' + g.name,
        build: (x)=>g.build(f.build(x)),
        parse: (a)=>g.parse(a).then(f.parse),
        defaultProduct: g.defaultProduct ? g.defaultProduct : f.defaultProduct ? f.defaultProduct : $4beeab19e80c1290$var$noProductFactor
    });
const $4beeab19e80c1290$export$1832c645056d4ce2 = {
    name: 'non-negative',
    build: (x)=>Number(x),
    parse: (x)=>x >= 0 ? Promise.resolve(x) : Promise.reject(new Error('Negative Number Entered')),
    defaultProduct: $4beeab19e80c1290$var$noProductFactor
};
const $4beeab19e80c1290$var$fractionalInch = (inches)=>{
    if (inches > 0 && inches < 1) return true;
    if (inches > -1 && inches < 0) return true;
    return false;
};
const $4beeab19e80c1290$var$numberIsZero = (inches)=>inches === 0;
const $4beeab19e80c1290$var$digitsSuper = {
    '0': "\u2070",
    '1': "\xb9",
    '2': "\xb2",
    '3': "\xb3",
    '4': "\u2074",
    '5': "\u2075",
    '6': "\u2076",
    '7': "\u2077",
    '8': "\u2078",
    '9': "\u2079"
};
const $4beeab19e80c1290$var$digitsSub = {
    '0': "\u2080",
    '1': "\u2081",
    '2': "\u2082",
    '3': "\u2083",
    '4': "\u2084",
    '5': "\u2085",
    '6': "\u2086",
    '7': "\u2087",
    '8': "\u2088",
    '9': "\u2089"
};
const $4beeab19e80c1290$var$fromSubSuperDigits = {
    "\u2070": '0',
    "\xb9": '1',
    "\xb2": '2',
    "\xb3": '3',
    "\u2074": '4',
    "\u2075": '5',
    "\u2076": '6',
    "\u2077": '7',
    "\u2078": '8',
    "\u2079": '9',
    "\u2080": '0',
    "\u2081": '1',
    "\u2082": '2',
    "\u2083": '3',
    "\u2084": '4',
    "\u2085": '5',
    "\u2086": '6',
    "\u2087": '7',
    "\u2088": '8',
    "\u2089": '9'
};
const $4beeab19e80c1290$var$mapChars = (chars)=>(x)=>x.split('').map((d)=>chars[d] ?? d).join('');
const $4beeab19e80c1290$var$toDigits = (digits)=>(n)=>$4beeab19e80c1290$var$mapChars(digits)(n.toFixed(0));
const $4beeab19e80c1290$var$toSuper = $4beeab19e80c1290$var$toDigits($4beeab19e80c1290$var$digitsSuper);
const $4beeab19e80c1290$var$toSub = $4beeab19e80c1290$var$toDigits($4beeab19e80c1290$var$digitsSub);
const $4beeab19e80c1290$var$fromSuper = $4beeab19e80c1290$var$mapChars($4beeab19e80c1290$var$fromSubSuperDigits);
const $4beeab19e80c1290$var$splitSuper = (x)=>x.replace(/([0-9])([¹²³⁰-⁹])/, '$1 $2');
const $4beeab19e80c1290$var$inches = {
    name: 'inches',
    build: (x)=>{
        const len = Math.round(x * 16);
        const inches = len / 16;
        const sixteenths = Math.abs(len % 16);
        const factor = $4beeab19e80c1290$var$gcd(sixteenths, 16);
        const wholeInches = !$4beeab19e80c1290$var$fractionalInch(inches) ? `${String(inches).replace(/(\..+)/, '')}` : $4beeab19e80c1290$var$fractionalInch(inches) && inches < 0 ? '-' : '';
        const fraction = !$4beeab19e80c1290$var$numberIsZero(sixteenths) ? $4beeab19e80c1290$var$toSuper(sixteenths / factor) + '/' + $4beeab19e80c1290$var$toSub(16 / factor) : '';
        return wholeInches + fraction + '"';
    },
    // parse inch string to millimeters number
    parse: (0, $3abDJ.flow)($4beeab19e80c1290$var$splitSuper, $4beeab19e80c1290$var$fromSuper, $4beeab19e80c1290$var$decimalFromInchString, $4beeab19e80c1290$var$notNaN),
    defaultProduct: (x)=>x
};
const $4beeab19e80c1290$var$millimeters = {
    name: 'millimeters',
    // build mm to mm string
    build: (length)=>`${Math.round(length)} mm`,
    // parse millimeters string to inch number
    parse: (num)=>Promise.resolve(Math.round(parseFloat(num))),
    defaultProduct: (x)=>x * 25
};
const $4beeab19e80c1290$var$inchToMM = {
    name: 'inch to mm',
    build: (length)=>length * 25.4,
    parse: (length)=>Promise.resolve(length / 25.4),
    defaultProduct: (x)=>x * 25
};
const $4beeab19e80c1290$var$mmToInch = {
    name: 'mm to inch',
    build: (length)=>length / 25.4,
    parse: (length)=>Promise.resolve(length * 25.4),
    defaultProduct: (x)=>x / 25
};
const $4beeab19e80c1290$var$inchesFromMillimeters = $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$mmToInch, $4beeab19e80c1290$var$inches, 'Inches');
const $4beeab19e80c1290$export$d871edfc009fc342 = $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$nonNaN, $4beeab19e80c1290$var$inchesFromMillimeters, 'Inches');
const $4beeab19e80c1290$export$79819a9ed12e640d = $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$nonNaN, $4beeab19e80c1290$var$millimeters, 'Millimeters');
const $4beeab19e80c1290$export$c28241ee8f9378ea = {
    inch: {
        inch: $4beeab19e80c1290$var$inches,
        mm: $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$inchToMM, $4beeab19e80c1290$var$millimeters, 'Millimeters')
    },
    mm: {
        inch: $4beeab19e80c1290$export$d871edfc009fc342,
        mm: $4beeab19e80c1290$export$79819a9ed12e640d
    }
};
const $4beeab19e80c1290$export$586f2408ab04b194 = {
    inch: $4beeab19e80c1290$export$d871edfc009fc342,
    mm: $4beeab19e80c1290$export$79819a9ed12e640d
};
const $4beeab19e80c1290$var$AreaUnits = {
    "ft\xb2": true,
    "in\xb2": true,
    "m\xb2": true,
    "mm\xb2": true
};
const $4beeab19e80c1290$export$df892d23cb2130bd = (0, $87701c398fec8638$export$7e1278799275f68e)($4beeab19e80c1290$var$AreaUnits);
const $4beeab19e80c1290$var$fmtSqft = {
    build: (x)=>x.toFixed(1) + " ft\xb2",
    parse: (str)=>$4beeab19e80c1290$var$notNaN(parseFloat(str)),
    name: 'square feet',
    defaultProduct: $4beeab19e80c1290$var$noProductFactor
};
const $4beeab19e80c1290$var$fmtSqin = {
    build: (x)=>x.toFixed(0) + " in\xb2",
    parse: (str)=>$4beeab19e80c1290$var$notNaN(parseFloat(str)),
    name: 'square inch',
    defaultProduct: $4beeab19e80c1290$var$noProductFactor
};
const $4beeab19e80c1290$var$fmtSqm = {
    build: (x)=>x.toFixed(2) + " m\xb2",
    parse: (str)=>$4beeab19e80c1290$var$notNaN(parseFloat(str)),
    name: 'square meter',
    defaultProduct: $4beeab19e80c1290$var$noProductFactor
};
const $4beeab19e80c1290$var$fmtSqmm = {
    build: (x)=>x.toFixed(0) + " mm\xb2",
    parse: (str)=>$4beeab19e80c1290$var$notNaN(parseFloat(str)),
    name: 'square millimeter',
    defaultProduct: $4beeab19e80c1290$var$noProductFactor
};
const $4beeab19e80c1290$var$scale = (factor)=>({
        build: (x)=>x * factor,
        parse: (x)=>Promise.resolve(x / factor),
        name: `times ${factor.toString()}`,
        defaultProduct: $4beeab19e80c1290$var$noProductFactor
    });
const $4beeab19e80c1290$export$d551e90b004eb1bb = {
    "ft\xb2": {
        "ft\xb2": $4beeab19e80c1290$var$fmtSqft,
        "in\xb2": $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$scale(144), $4beeab19e80c1290$var$fmtSqin),
        "m\xb2": $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$scale(144 / 39.37 ** 2), $4beeab19e80c1290$var$fmtSqm),
        "mm\xb2": $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$scale(92903.04), $4beeab19e80c1290$var$fmtSqmm)
    },
    "in\xb2": {
        "ft\xb2": $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$scale(1 / 144), $4beeab19e80c1290$var$fmtSqft),
        "in\xb2": $4beeab19e80c1290$var$fmtSqin,
        "m\xb2": $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$scale(1 / 39.37 ** 2), $4beeab19e80c1290$var$fmtSqm),
        "mm\xb2": $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$scale(645.16), $4beeab19e80c1290$var$fmtSqmm)
    },
    "m\xb2": {
        "ft\xb2": $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$scale(39.37 ** 2 / 144), $4beeab19e80c1290$var$fmtSqft),
        "in\xb2": $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$scale(39.37 ** 2), $4beeab19e80c1290$var$fmtSqin),
        "m\xb2": $4beeab19e80c1290$var$fmtSqm,
        "mm\xb2": $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$scale(1000 ** 2), $4beeab19e80c1290$var$fmtSqmm)
    },
    "mm\xb2": {
        "ft\xb2": $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$scale(1 / 144 / 645.16), $4beeab19e80c1290$var$fmtSqft),
        "in\xb2": $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$scale(1 / 645.16), $4beeab19e80c1290$var$fmtSqin),
        "m\xb2": $4beeab19e80c1290$export$e8bcfcb317682b2e($4beeab19e80c1290$var$scale(1 / 1000 ** 2), $4beeab19e80c1290$var$fmtSqm),
        "mm\xb2": $4beeab19e80c1290$var$fmtSqmm
    }
};
const $4beeab19e80c1290$var$validateAngle = (x)=>isNaN(x) ? $4beeab19e80c1290$var$PromiseErr('Angle must be a number.') : x < -180 ? $4beeab19e80c1290$var$PromiseErr('Angle is too small.') : x > 180 ? $4beeab19e80c1290$var$PromiseErr('Angle is too large.') : Promise.resolve(x);
const $4beeab19e80c1290$export$6e98d19a58527322 = {
    interior: {
        name: 'Interior',
        /*
		 * Currently, Silica model uses exterior angles in the opening design
		 * so for consistently we treat the argument in `build` as an exterior angle
		 */ build: (angle)=>`${Math.round(180 - angle)}\xb0`,
        parse: (str)=>Promise.resolve(Math.round(180 - parseFloat(str))).then($4beeab19e80c1290$var$validateAngle),
        defaultProduct: $4beeab19e80c1290$var$noProductFactor
    },
    exterior: {
        name: 'Exterior',
        /*
		 * Currently, Silica model uses exterior angles in the opening design
		 * so for consistently we treat the argument in `build` as an exterior angle
		 */ build: (angle)=>`${Math.round(angle)}\xb0`,
        parse: (str)=>Promise.resolve(Math.round(parseFloat(str))).then($4beeab19e80c1290$var$validateAngle),
        defaultProduct: $4beeab19e80c1290$var$noProductFactor
    }
};
/**
 * PromiseErr, helper.
 *
 * @since 0.2.0
 */ const $4beeab19e80c1290$var$PromiseErr = (err)=>Promise.reject(new Error(err));
const $4beeab19e80c1290$export$438c7e8be0d632b1 = {
    name: 'range',
    build: (x)=>x.toString(),
    parse: (num, min, max)=>{
        if (min !== undefined && !isNaN(min) && parseFloat(num) < min) return Promise.reject(new Error(`Value should be greater than ${min}.`));
        if (max !== undefined && !isNaN(max) && parseFloat(num) > max) return Promise.reject(new Error(`Value should be less than ${max}.`));
        if (isNaN(parseFloat(num))) return Promise.reject(new Error('Value is not a number.'));
        return Promise.resolve(num);
    },
    defaultProduct: $4beeab19e80c1290$var$noProductFactor
};


const $686182291220ef6d$var$LengthUnitContext = /*#__PURE__*/ (0, $acw62.createContext)('mm');
const $686182291220ef6d$export$2cb30ce74344c798 = $686182291220ef6d$var$LengthUnitContext.Provider;
const $686182291220ef6d$export$75ed5fc290e0237f = ()=>(0, $acw62.useContext)($686182291220ef6d$var$LengthUnitContext);
const $686182291220ef6d$var$AreaUnitContext = /*#__PURE__*/ (0, $acw62.createContext)("m\xb2");
const $686182291220ef6d$export$e3bf5f6c648445ae = $686182291220ef6d$var$AreaUnitContext.Provider;
const $686182291220ef6d$export$b74c4ac715472989 = ()=>(0, $acw62.useContext)($686182291220ef6d$var$AreaUnitContext);
const $686182291220ef6d$var$lengthUnitTransList = [
    {
        key: 'mm',
        names: {
            eng: 'mm'
        }
    },
    {
        key: 'inch',
        names: {
            eng: 'Inch'
        }
    }
];
const $686182291220ef6d$var$lengthUnitTrans = {
    eng: 'Length Unit'
};
const $686182291220ef6d$export$f3d6fdaa595556c9 = ({ value: value, update: update })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
        style: {
            padding: '12px 4px'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$e743e65751cd982a), {
            size: "small",
            value: value,
            label: $686182291220ef6d$var$lengthUnitTrans,
            items: $686182291220ef6d$var$lengthUnitTransList,
            update: update
        })
    });
const $686182291220ef6d$export$6d532e72457ed852 = (unit)=>{
    const lengthUnit = $686182291220ef6d$export$75ed5fc290e0237f();
    const areaUnit = $686182291220ef6d$export$b74c4ac715472989();
    if ((0, $4beeab19e80c1290$export$8cba090a009adf02).is(unit)) return (0, $4beeab19e80c1290$export$c28241ee8f9378ea)[unit][lengthUnit];
    else if ((0, $4beeab19e80c1290$export$df892d23cb2130bd).is(unit)) return (0, $4beeab19e80c1290$export$d551e90b004eb1bb)[unit][areaUnit];
    else if (unit == 'deg') return (0, $4beeab19e80c1290$export$6e98d19a58527322).interior;
    else if (unit == 'pc') return 0, $4beeab19e80c1290$export$4ac1902d8b310847;
    return 0, $4beeab19e80c1290$export$a30d9f878a2b791a;
};




const $da9256d9077496fe$export$3954df07e1538196 = (ev)=>ev.target.select();
const $da9256d9077496fe$export$a902121087114074 = ({ value: value, update: update, unit: unit, tlabel: tlabel, id: id, min: min, max: max, ...props })=>{
    // Handle state for user input value
    const [inputValue, setInputValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // Handle state for converter parse error
    const [parseError, setParseError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // Get the suitable converter for the unit we're handling.
    const converter = (0, $686182291220ef6d$export$6d532e72457ed852)(unit);
    const lang = (0, $c197ad7e0b56b287$export$c1fd9f444a3dc711)();
    /*
	 * Set the input value to the built
	 * value using converter
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setInputValue(converter.build(value));
    }, [
        value,
        converter
    ]);
    /*
	 * Parse the string to check for an error setting the
	 * parse error or removing the error
	 */ const checkParseError = (0, $acw62.useCallback)(async ()=>await (0, $3abDJ.pipe)($7f42eb8d37961918$exports.tryCatch(()=>converter.parse(String(inputValue)), (error)=>error instanceof Error ? setParseError(error.message) : console.warn('Unknown parsing failure.')), $7f42eb8d37961918$exports.chain((parsedValue)=>$7f42eb8d37961918$exports.tryCatch(()=>(0, $4beeab19e80c1290$export$438c7e8be0d632b1).parse(parsedValue.toString(), min, max).then((0, $3abDJ.constant)(setParseError(''))), (error)=>error instanceof Error ? setParseError(error.message) : console.warn('Second validation failed.'))))(), [
        converter,
        inputValue,
        min,
        max
    ]);
    /*
	 * If the input value is truthy, run the parser
	 * to look for errors when the input value changes
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (inputValue) checkParseError();
    }, [
        inputValue,
        checkParseError
    ]);
    /*
	 * If there is not a parsing error parse the input value
	 * and submit the update
	 */ const handleOnUpdate = (parsingError)=>(value)=>(0, $3abDJ.pipe)(value, $hBXBN.fromPredicate(()=>!parsingError), $hBXBN.map(String), $hBXBN.foldW(()=>setParseError('You must fix the error before submitting.'), (v)=>converter.parse(v).then((num)=>update(()=>{
                        if (min && num < min) num = min;
                        else if (max && num > max) num = max;
                        return num;
                    }))));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
        sx: {
            my: 1,
            width: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    alignItems: 'center'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                    label: (tlabel ?? {})[lang],
                    error: Boolean(parseError),
                    onFocus: $da9256d9077496fe$export$3954df07e1538196,
                    onChange: (0, $3abDJ.flow)((0, $859db0da13774873$export$2b11a78b8ccd10d4), setInputValue),
                    onBlur: (0, $3abDJ.flow)((0, $859db0da13774873$export$cb0d9aba43c3445a), handleOnUpdate(Boolean(parseError))),
                    value: inputValue,
                    id: id,
                    inputProps: {
                        style: {
                            padding: '8px 16px',
                            color: '#718096'
                        }
                    },
                    sx: {
                        width: '100%',
                        minWidth: '110px'
                    },
                    ...props
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                sx: {
                    ml: 0
                },
                error: Boolean(parseError),
                children: parseError
            })
        ]
    });
};
const $da9256d9077496fe$export$24d6ae21130964e6 = /*#__PURE__*/ (0, $acw62.memo)($da9256d9077496fe$export$a902121087114074);
var $da9256d9077496fe$export$2e2bcd8739ae039 = $da9256d9077496fe$export$a902121087114074;



var $ayMG0 = parcelRequire("ayMG0");

const $a78a34cfe7b3ca73$var$QDrawerError = ({ children: children, ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
        px: 1,
        textAlign: "left",
        color: 'error',
        variant: "body1",
        ...props,
        children: children
    });
var $a78a34cfe7b3ca73$export$2e2bcd8739ae039 = $a78a34cfe7b3ca73$var$QDrawerError;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");
const $64d5986579a9eba5$var$QInputLabel = (0, $d8seH.default)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039))({
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 400
});
var $64d5986579a9eba5$export$2e2bcd8739ae039 = $64d5986579a9eba5$var$QInputLabel;


const $e552c4cb7a4510b7$var$ToggleButtonLayout = ({ label: label, htmlFor: htmlFor, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        my: 1,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        children: [
            label && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $64d5986579a9eba5$export$2e2bcd8739ae039), {
                htmlFor: htmlFor,
                sx: {
                    paddingRight: '10px',
                    py: '12px'
                },
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                children: children
            })
        ]
    });
var $e552c4cb7a4510b7$export$2e2bcd8739ae039 = $e552c4cb7a4510b7$var$ToggleButtonLayout;


const $be5424d0b03618f0$var$handleLocation = (update)=>(_, newLocation)=>{
        update((0, $3abDJ.constant)(newLocation));
    };
const $be5424d0b03618f0$var$AnomalyEdit = ({ anomaly: anomaly, update: update })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$2e2bcd8739ae039), {
                unit: "mm",
                min: 0,
                value: anomaly.Offset.Offset,
                update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$db5c2c6cb5f889c9).composeLens((0, $7cd1993fbd4e2816$export$a8d54a49011fa91e)), update),
                tlabel: {
                    eng: 'Offset'
                },
                sx: {
                    mx: 0,
                    mt: 2
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e552c4cb7a4510b7$export$2e2bcd8739ae039), {
                htmlFor: "start of offset measurement",
                label: "Location",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7479184c3cda7f5d$export$2e2bcd8739ae039), {
                    value: anomaly.Offset.Location,
                    exclusive: true,
                    onChange: $be5424d0b03618f0$var$handleLocation((0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$db5c2c6cb5f889c9).composeLens((0, $7cd1993fbd4e2816$export$bded910e06efb486)), update)),
                    "aria-label": "start of offset measurement",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                            value: "start",
                            "aria-label": "start",
                            children: "Start"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                            value: "end",
                            "aria-label": "end",
                            children: "End"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$2e2bcd8739ae039), {
                unit: "mm",
                min: 0,
                value: anomaly.Size,
                update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$b56d6dad1ac368cc), update),
                tlabel: {
                    eng: 'Size'
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$2e2bcd8739ae039), {
                unit: "mm",
                value: anomaly.Depth,
                update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$755b4a2da66c7c53), update),
                tlabel: {
                    eng: 'Depth'
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$2e2bcd8739ae039), {
                unit: "mm",
                min: 0,
                value: anomaly.Width || 0,
                update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$4bf33f1a29468b71), update),
                tlabel: {
                    eng: 'Width'
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df2af751bdad3651$export$2e2bcd8739ae039), {
                InputLabelProps: {
                    shrink: true
                },
                sx: {
                    my: 2
                },
                multiline: true,
                rows: 4,
                name: "Description",
                label: "Description",
                value: anomaly.Description || '',
                update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$f9c6394e850e155b), update),
                fullWidth: true
            })
        ]
    });
const $be5424d0b03618f0$var$AnomalyForm = (optic)=>({ lengthConverter: lengthConverter, update: update, value: value })=>(0, $3abDJ.pipe)(value, (a)=>optic.compose((0, $1379b6c01f560d41$export$5bf6277736efcace)()).getOption(a), $hBXBN.fold((0, $3abDJ.constant)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a78a34cfe7b3ca73$export$2e2bcd8739ae039), {
            children: "Anomaly Not Found"
        })), (anomaly)=>/*#__PURE__*/ (0, $ayMG0.jsx)($be5424d0b03618f0$var$AnomalyEdit, {
                anomaly: anomaly,
                lengthConverter: lengthConverter,
                update: (0, $859db0da13774873$export$2db37b7a33042541)(optic.compose((0, $1379b6c01f560d41$export$5bf6277736efcace)()), update)
            })));
var $be5424d0b03618f0$export$2e2bcd8739ae039 = $be5424d0b03618f0$var$AnomalyForm;



var $ayMG0 = parcelRequire("ayMG0");

var $3abDJ = parcelRequire("3abDJ");


var $hBXBN = parcelRequire("hBXBN");

var $ayMG0 = parcelRequire("ayMG0");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");





var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $bmoVh = parcelRequire("bmoVh");




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $247ae09dccc3464c$export$5162da8f798e0959(slot) {
    return (0, $4Cod0.default)('MuiCollapse', slot);
}
const $247ae09dccc3464c$var$collapseClasses = (0, $beCSm.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $247ae09dccc3464c$export$2e2bcd8739ae039 = $247ae09dccc3464c$var$collapseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $848dc8709a4309c5$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $848dc8709a4309c5$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $247ae09dccc3464c$export$5162da8f798e0959), classes);
};
const $848dc8709a4309c5$var$CollapseRoot = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height')
    }, ownerState.orientation === 'horizontal' && {
        height: 'auto',
        width: 0,
        transition: theme.transitions.create('width')
    }, ownerState.state === 'entered' && (0, $8nd05.default)({
        height: 'auto',
        overflow: 'visible'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto'
    }), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
        visibility: 'hidden'
    }));
const $848dc8709a4309c5$var$CollapseWrapper = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: 'flex',
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
const $848dc8709a4309c5$var$CollapseWrapperInner = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $848dc8709a4309c5$var$Collapse = /*#__PURE__*/ $acw62.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $bmoVh.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $848dc8709a4309c5$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $848dc8709a4309c5$var$useUtilityClasses(ownerState);
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const timer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const wrapperRef = $acw62.useRef(null);
    const autoTransitionDuration = $acw62.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseRoot, (0, $8nd05.default)({
                as: component,
                className: (0, $9QePP.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: (0, $8nd05.default)({
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, $8nd05.default)({}, ownerState, {
                    state: state
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseWrapper, {
                    ownerState: (0, $8nd05.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseWrapperInner, {
                        ownerState: (0, $8nd05.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$848dc8709a4309c5$var$Collapse.muiSupportAuto = true;
var $848dc8709a4309c5$export$2e2bcd8739ae039 = $848dc8709a4309c5$var$Collapse;


var $d8seH = parcelRequire("d8seH");

var $3abDJ = parcelRequire("3abDJ");

var $hBXBN = parcelRequire("hBXBN");

var $4ZBbi = parcelRequire("4ZBbi");
parcelRequire("acw62");







var $3abDJ = parcelRequire("3abDJ");

var $acw62 = parcelRequire("acw62");
const $9e39118f6baea535$var$useToggle = (initialValue)=>{
    const [value, setValue] = $acw62.useState(initialValue || false);
    const toggle = ()=>(0, $3abDJ.pipe)(!value, setValue);
    return {
        value: value,
        toggle: toggle
    };
};
var $9e39118f6baea535$export$2e2bcd8739ae039 = $9e39118f6baea535$var$useToggle;



var $ayMG0 = parcelRequire("ayMG0");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $5bbfcb95732dc207$var$AccordionContext = /*#__PURE__*/ $acw62.createContext({});
var $5bbfcb95732dc207$export$2e2bcd8739ae039 = $5bbfcb95732dc207$var$AccordionContext;




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");




'use client';
const $49e8399bd2388464$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $49e8399bd2388464$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $49e8399bd2388464$var$_excluded3 = [
    "component"
];
function $49e8399bd2388464$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $1En50.default)(parameters, $49e8399bd2388464$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $1En50.default)(externalForwardedProps, $49e8399bd2388464$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $135391549c807611$export$2e2bcd8739ae039)((0, $8nd05.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $1En50.default)(_mergeSlotProps.props, $49e8399bd2388464$var$_excluded3);
    const ref = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $8nd05.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(elementType, (0, $8nd05.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e14e8c767477d992$export$80fb6a2cb3f13b8b(slot) {
    return (0, $4Cod0.default)('MuiAccordion', slot);
}
const $e14e8c767477d992$var$accordionClasses = (0, $beCSm.default)('MuiAccordion', [
    'root',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $e14e8c767477d992$export$2e2bcd8739ae039 = $e14e8c767477d992$var$accordionClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5c228c234852d575$var$_excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "slots",
    "slotProps",
    "TransitionComponent",
    "TransitionProps"
];
const $5c228c234852d575$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        region: [
            'region'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e14e8c767477d992$export$80fb6a2cb3f13b8b), classes);
};
const $5c228c234852d575$var$AccordionRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $e14e8c767477d992$export$2e2bcd8739ae039).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${(0, $e14e8c767477d992$export$2e2bcd8739ae039).expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, $e14e8c767477d992$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}, ({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $e14e8c767477d992$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    }));
const $5c228c234852d575$var$Accordion = /*#__PURE__*/ $acw62.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp } = props, other = (0, $1En50.default)(props, $5c228c234852d575$var$_excluded);
    const [expanded, setExpandedState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $acw62.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $acw62.Children.toArray(childrenProp);
    const contextValue = $acw62.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    });
    const classes = $5c228c234852d575$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = (0, $8nd05.default)({
        transition: TransitionComponentProp
    }, slots);
    const backwardCompatibleSlotProps = (0, $8nd05.default)({
        transition: TransitionPropsProp
    }, slotProps);
    const [TransitionSlot, transitionProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $848dc8709a4309c5$export$2e2bcd8739ae039),
        externalForwardedProps: {
            slots: backwardCompatibleSlots,
            slotProps: backwardCompatibleSlotProps
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($5c228c234852d575$var$AccordionRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5bbfcb95732dc207$export$2e2bcd8739ae039).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, (0, $8nd05.default)({
                in: expanded,
                timeout: "auto"
            }, transitionProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props['aria-controls'],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
var $5c228c234852d575$export$2e2bcd8739ae039 = $5c228c234852d575$var$Accordion;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e4b72c3145e33d8$export$a6afb527becfac26(slot) {
    return (0, $4Cod0.default)('MuiAccordionDetails', slot);
}
const $6e4b72c3145e33d8$var$accordionDetailsClasses = (0, $beCSm.default)('MuiAccordionDetails', [
    'root'
]);
var $6e4b72c3145e33d8$export$2e2bcd8739ae039 = $6e4b72c3145e33d8$var$accordionDetailsClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1b78273c1c27a2e1$var$_excluded = [
    "className"
];
const $1b78273c1c27a2e1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6e4b72c3145e33d8$export$a6afb527becfac26), classes);
};
const $1b78273c1c27a2e1$var$AccordionDetailsRoot = (0, $d8seH.default)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const $1b78273c1c27a2e1$var$AccordionDetails = /*#__PURE__*/ $acw62.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $1b78273c1c27a2e1$var$_excluded);
    const ownerState = props;
    const classes = $1b78273c1c27a2e1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1b78273c1c27a2e1$var$AccordionDetailsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $1b78273c1c27a2e1$export$2e2bcd8739ae039 = $1b78273c1c27a2e1$var$AccordionDetails;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d55ba52db43b55df$export$282216ad123d6580(slot) {
    return (0, $4Cod0.default)('MuiAccordionSummary', slot);
}
const $d55ba52db43b55df$var$accordionSummaryClasses = (0, $beCSm.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $d55ba52db43b55df$export$2e2bcd8739ae039 = $d55ba52db43b55df$var$accordionSummaryClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1a792f5a0c37e2ab$var$_excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const $1a792f5a0c37e2ab$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d55ba52db43b55df$export$282216ad123d6580), classes);
};
const $1a792f5a0c37e2ab$var$AccordionSummaryRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
});
const $1a792f5a0c37e2ab$var$AccordionSummaryContent = (0, $d8seH.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    }));
const $1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper = (0, $d8seH.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    }));
const $1a792f5a0c37e2ab$var$AccordionSummary = /*#__PURE__*/ $acw62.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick } = props, other = (0, $1En50.default)(props, $1a792f5a0c37e2ab$var$_excluded);
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $acw62.useContext((0, $5bbfcb95732dc207$export$2e2bcd8739ae039));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, $8nd05.default)({}, props, {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    const classes = $1a792f5a0c37e2ab$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a792f5a0c37e2ab$var$AccordionSummaryRoot, (0, $8nd05.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $9QePP.default)(classes.root, className),
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($1a792f5a0c37e2ab$var$AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $ayMG0.jsx)($1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
var $1a792f5a0c37e2ab$export$2e2bcd8739ae039 = $1a792f5a0c37e2ab$var$AccordionSummary;


var $d8seH = parcelRequire("d8seH");
var $570fd50501d08ed5$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($570fd50501d08ed5$exports, "__esModule", {
    value: true
});
$570fd50501d08ed5$exports.default = void 0;

var $570fd50501d08ed5$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $570fd50501d08ed5$var$_default = $570fd50501d08ed5$exports.default = (0, $570fd50501d08ed5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');


parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $54b24075f0eeecff$var$useAccordion = (initialValue)=>{
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(initialValue || false);
    const handleChange = (panel)=>(_, isExpanded)=>{
            setExpanded(isExpanded ? panel : false);
        };
    return {
        expanded: expanded,
        handleChange: handleChange
    };
};
var $54b24075f0eeecff$export$2e2bcd8739ae039 = $54b24075f0eeecff$var$useAccordion;


var $29a5410bebd3849f$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($29a5410bebd3849f$exports, "__esModule", {
    value: true
});
$29a5410bebd3849f$exports.default = void 0;

var $29a5410bebd3849f$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $29a5410bebd3849f$var$_default = $29a5410bebd3849f$exports.default = (0, $29a5410bebd3849f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13H5v-2h14z"
}), 'Remove');


const $574565f284cb845e$var$QAccordionSummary = (0, $d8seH.default)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039))({
    background: 'transparent',
    '&.Mui-expanded': {
        minHeight: 'unset'
    },
    '& .Mui-expanded': {
        margin: '12px 0px'
    }
});
const $574565f284cb845e$export$5411951f06927d69 = ({ title: title, value: value })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        flexGrow: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                pr: 3,
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                color: "primary",
                pr: 2,
                children: value
            })
        ]
    });
};
const $574565f284cb845e$var$QAccordion = ({ summary: summary, details: details, panelName: panelName, initialExpanded: initialExpanded })=>{
    const { expanded: expanded, handleChange: handleChange } = (0, $54b24075f0eeecff$export$2e2bcd8739ae039)(initialExpanded ? panelName : false);
    const open = expanded === panelName;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
        sx: {
            '&.Mui-expanded': {
                margin: 0
            }
        },
        onChange: handleChange(panelName),
        expanded: open,
        TransitionProps: {
            unmountOnExit: true
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($574565f284cb845e$var$QAccordionSummary, {
                expandIcon: open ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($29a5410bebd3849f$exports))), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($570fd50501d08ed5$exports))), {}),
                children: summary
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                sx: {
                    textAlign: 'left'
                },
                children: details
            })
        ]
    });
};
var $574565f284cb845e$export$2e2bcd8739ae039 = $574565f284cb845e$var$QAccordion;



const $be94dfe364aa33e2$var$QCollapse = (0, $d8seH.default)((0, $848dc8709a4309c5$export$2e2bcd8739ae039))({
    minHeight: 'unset!important'
});
// Curvature can be either `Circular` or `Sinusoidal`
const $be94dfe364aa33e2$var$handleCurvatureType = (update)=>(_, newType)=>{
        switch(newType){
            case 'Circular':
                // update circular
                update((prev)=>(0, $3abDJ.pipe)((0, $24a1c1ffbf73ec6a$export$a68afe694dce1e5f)().getOption(prev), $hBXBN.fold(()=>({
                            ...prev,
                            Curvature: {
                                type: 'Circular',
                                Deflection: 0
                            }
                        }), (a)=>({
                            ...prev,
                            Curvature: {
                                type: 'Circular',
                                Deflection: (0, $24a1c1ffbf73ec6a$export$bb8ae3e95e780206).get(a)
                            }
                        }))));
                break;
            case 'Sinusoidal':
                // update Sinusoidal
                update((prev)=>(0, $3abDJ.pipe)((0, $24a1c1ffbf73ec6a$export$a68afe694dce1e5f)().getOption(prev), $hBXBN.fold(()=>({
                            ...prev,
                            Curvature: {
                                type: 'Sinusoidal',
                                Deflection: 0
                            }
                        }), (a)=>({
                            ...prev,
                            Curvature: {
                                type: 'Sinusoidal',
                                Deflection: (0, $24a1c1ffbf73ec6a$export$bb8ae3e95e780206).get(a)
                            }
                        }))));
                break;
            case 'None':
                update((prev)=>({
                        ...prev,
                        Curvature: undefined
                    }));
        }
    };
// Measurement can be either `Major`, `Mag`, `undefined`
const $be94dfe364aa33e2$var$handleMajorType = (measurement)=>(update)=>(_, newType)=>{
            switch(newType){
                case 'Major':
                    // update Major
                    update(()=>(0, $24a1c1ffbf73ec6a$export$f19dd2c890563e4e)().get(measurement));
                    break;
                case 'Magnitude':
                    // update Magnitude
                    update(()=>(0, $24a1c1ffbf73ec6a$export$47b1e05306f58d86)().get(measurement));
            }
        };
// Measurement can be either `Major`, `Mag`, `undefined`
const $be94dfe364aa33e2$var$handleMinorType = (measurement)=>(update)=>(_, newType)=>{
            switch(newType){
                case 'Minor':
                    // update Minor
                    update(()=>(0, $24a1c1ffbf73ec6a$export$a8e06f16a42ea0c0)().get(measurement));
                    break;
                case 'Angle':
                    // update Angle
                    update(()=>(0, $24a1c1ffbf73ec6a$export$48495abd2e55b326)().get(measurement));
                    break;
            }
        };
const $be94dfe364aa33e2$var$handleOutageType = (update)=>(_, newType)=>{
        switch(newType){
            case 0:
                update((0, $24a1c1ffbf73ec6a$export$b65cefd51408839e).set(0));
                break;
            case -1:
                update((0, $24a1c1ffbf73ec6a$export$b65cefd51408839e).modify((a)=>a >= 0 ? a * -1 : a));
                break;
            case 1:
                update((0, $24a1c1ffbf73ec6a$export$b65cefd51408839e).modify((a)=>a <= 0 ? a * -1 : a));
        }
    };
const $be94dfe364aa33e2$var$curvatureOption = (curvature)=>typeof curvature === 'undefined' ? $hBXBN.none : $hBXBN.some(curvature);
const $be94dfe364aa33e2$var$handleClearMajorPriority = (update)=>()=>(0, $3abDJ.pipe)((0, $24a1c1ffbf73ec6a$export$7b9966c43d6cd366)().modify((0, $3abDJ.constant)((0, $859db0da13774873$export$329748c2c017309e)())), update);
const $be94dfe364aa33e2$var$handleClearMinorPriority = (update)=>(0, $3abDJ.pipe)((0, $24a1c1ffbf73ec6a$export$7b78e7c08fc28a8d)().modify((0, $3abDJ.constant)((0, $859db0da13774873$export$329748c2c017309e)())), update);
function $be94dfe364aa33e2$var$MajorEdit({ update: update, value: value }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$a902121087114074), {
        autoFocus: true,
        unit: "mm",
        min: 0,
        value: (0, $24a1c1ffbf73ec6a$export$72683dc2d378b18d).get(value),
        update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $24a1c1ffbf73ec6a$export$72683dc2d378b18d), update),
        tlabel: {
            eng: 'Major Value'
        }
    });
}
function $be94dfe364aa33e2$var$MagnitudeEdit({ update: update, value: value }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$a902121087114074), {
        autoFocus: true,
        unit: "mm",
        min: 0,
        value: (0, $24a1c1ffbf73ec6a$export$950eef7f5163a0d8).get(value),
        update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $24a1c1ffbf73ec6a$export$950eef7f5163a0d8), update),
        tlabel: {
            eng: 'Magnitude Value'
        }
    });
}
function $be94dfe364aa33e2$var$MajorMeasureEdit({ value: value, update: update }) {
    return (0, $29a0713b257db71e$export$4b793e9421eec011).is(value) ? /*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$MajorEdit, {
        update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $24a1c1ffbf73ec6a$export$eedf77da96dc18fd), update),
        value: value
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$MagnitudeEdit, {
        update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $24a1c1ffbf73ec6a$export$49e492a77b2432d2), update),
        value: value
    });
}
function $be94dfe364aa33e2$var$MajorMeasurePicker({ update: update, value: value }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e552c4cb7a4510b7$export$2e2bcd8739ae039), {
        htmlFor: "major measurement type",
        label: "Major Type",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7479184c3cda7f5d$export$2e2bcd8739ae039), {
            value: (0, $29a0713b257db71e$export$4b793e9421eec011).is((0, $24a1c1ffbf73ec6a$export$c7133ab33cb183d1)().get(value)) ? 'Major' : 'Magnitude',
            exclusive: true,
            onChange: $be94dfe364aa33e2$var$handleMajorType(value)((0, $859db0da13774873$export$2db37b7a33042541)((0, $24a1c1ffbf73ec6a$export$c7133ab33cb183d1)(), update)),
            "aria-label": "major measurement type",
            id: "major measurement type",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                    value: "Major",
                    "aria-label": "Major",
                    children: "Major"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                    value: "Magnitude",
                    "aria-label": "Magnitude",
                    children: "Magnitude"
                })
            ]
        })
    });
}
function $be94dfe364aa33e2$var$ClearMajorPriorityButton({ update: update }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
        variant: "text",
        onClick: (0, $3abDJ.flow)($be94dfe364aa33e2$var$handleClearMajorPriority(update)),
        children: "Clear Major Priority"
    });
}
function $be94dfe364aa33e2$var$ClearMinorPriorityButton({ update: update }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
        variant: "text",
        onClick: ()=>$be94dfe364aa33e2$var$handleClearMinorPriority(update),
        children: "Clear Minor Priority"
    });
}
function $be94dfe364aa33e2$var$MinorAngleEdit({ update: update, value: value }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$a902121087114074), {
        unit: "deg",
        value: (0, $24a1c1ffbf73ec6a$export$7488d395d2b6c9ad).get(value),
        update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $24a1c1ffbf73ec6a$export$7488d395d2b6c9ad), update),
        tlabel: {
            eng: 'Angle Value'
        },
        sx: {
            width: '180px',
            mr: 3.5
        }
    });
}
function $be94dfe364aa33e2$var$MinorEdit({ update: update, value: minor }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$a902121087114074), {
        unit: "mm",
        value: (0, $24a1c1ffbf73ec6a$export$920ff3912d63136f).get(minor),
        update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $24a1c1ffbf73ec6a$export$920ff3912d63136f), update),
        tlabel: {
            eng: 'Outage'
        },
        sx: {
            width: '180px',
            mr: 3.5
        }
    });
}
function $be94dfe364aa33e2$var$MinorMeasureEdit({ value: value, update: update, measurementDir: measurementDir }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        alignItems: "flex-start",
        children: [
            (0, $29a0713b257db71e$export$6cdc1cb9345ffadf).is(value) ? /*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$MinorAngleEdit, {
                value: value,
                update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $24a1c1ffbf73ec6a$export$74df88334df32eb), update)
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$MinorEdit, {
                value: value,
                update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $24a1c1ffbf73ec6a$export$b4a9ef5e6a6a374b), update)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$MinorOutagePicker, {
                update: update,
                value: value,
                measurementDir: measurementDir
            })
        ]
    });
}
function $be94dfe364aa33e2$var$MinorMeasurePicker({ update: update, value: value }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e552c4cb7a4510b7$export$2e2bcd8739ae039), {
        htmlFor: "minor measurement outage direction",
        label: "Minor Type",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7479184c3cda7f5d$export$2e2bcd8739ae039), {
            value: (0, $3abDJ.pipe)((0, $24a1c1ffbf73ec6a$export$fb23277430a92f0b)().get(value), (a)=>(0, $29a0713b257db71e$export$2289e9b7d91d85ed).is(a) ? 'Minor' : 'Angle'),
            exclusive: true,
            onChange: $be94dfe364aa33e2$var$handleMinorType(value)((0, $859db0da13774873$export$2db37b7a33042541)((0, $24a1c1ffbf73ec6a$export$fb23277430a92f0b)(), update)),
            "aria-label": "minor measurement outage direction",
            id: "minor measurement outage direction",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                    value: "Minor",
                    "aria-label": "Minor",
                    children: "Minor"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                    value: "Angle",
                    "aria-label": "Angle",
                    children: "Angle"
                })
            ]
        })
    });
}
const $be94dfe364aa33e2$var$isVerticalCurb = (dir)=>(0, $3abDJ.pipe)([
        'up',
        'down'
    ], $4ZBbi.some((verticalDir)=>(0, $859db0da13774873$export$93d3907feb8a9f3)($hBXBN.some(dir), $hBXBN.some(verticalDir))));
const $be94dfe364aa33e2$var$OutageIcon = ({ src: src })=>/*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        src: src,
        height: "22px",
        width: "30px"
    });
function $be94dfe364aa33e2$var$MinorOutagePicker({ update: update, value: value, measurementDir: measurementDir }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e552c4cb7a4510b7$export$2e2bcd8739ae039), {
        htmlFor: "minor measurement outage direction",
        label: "Outage Direction",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7479184c3cda7f5d$export$2e2bcd8739ae039), {
            value: (0, $3abDJ.pipe)((0, $24a1c1ffbf73ec6a$export$b65cefd51408839e).get(value), (a)=>a === 0 ? a : a > 0 ? 1 : -1),
            exclusive: true,
            onChange: $be94dfe364aa33e2$var$handleOutageType(update),
            "aria-label": "minor measurement outage direction",
            id: "minor measurement outage direction",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                    sx: {
                        px: 1
                    },
                    value: 0,
                    "aria-label": "zero",
                    children: (0, $3abDJ.pipe)(measurementDir, $be94dfe364aa33e2$var$isVerticalCurb, $29b3dcb11c87a56f$exports.match((0, $3abDJ.constant)(/*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$OutageIcon, {
                        src: "/img/opening/outage-horizontal-0.svg"
                    })), (0, $3abDJ.constant)(/*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$OutageIcon, {
                        src: "/img/opening/outage-vertical-0.svg"
                    }))))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                    sx: {
                        px: 1
                    },
                    value: -1,
                    "aria-label": "negative",
                    children: (0, $3abDJ.pipe)(measurementDir, $be94dfe364aa33e2$var$isVerticalCurb, $29b3dcb11c87a56f$exports.match((0, $3abDJ.constant)(/*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$OutageIcon, {
                        src: "/img/opening/outage-horizontal-1.svg"
                    })), (0, $3abDJ.constant)(/*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$OutageIcon, {
                        src: "/img/opening/outage-vertical-2.svg"
                    }))))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                    sx: {
                        px: 1
                    },
                    value: 1,
                    "aria-label": "positive",
                    children: (0, $3abDJ.pipe)(measurementDir, $be94dfe364aa33e2$var$isVerticalCurb, $29b3dcb11c87a56f$exports.match((0, $3abDJ.constant)(/*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$OutageIcon, {
                        src: "/img/opening/outage-horizontal-2.svg"
                    })), (0, $3abDJ.constant)(/*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$OutageIcon, {
                        src: "/img/opening/outage-vertical-1.svg"
                    }))))
                })
            ]
        })
    });
}
function $be94dfe364aa33e2$var$CurvatureEdit({ update: update, value: value }) {
    return (0, $3abDJ.pipe)((0, $24a1c1ffbf73ec6a$export$a68afe694dce1e5f)().getOption(value), $hBXBN.fold(()=>null, (a)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$a902121087114074), {
            unit: "mm",
            value: (0, $24a1c1ffbf73ec6a$export$bb8ae3e95e780206).get(a),
            update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $24a1c1ffbf73ec6a$export$a68afe694dce1e5f)().composeLens((0, $24a1c1ffbf73ec6a$export$bb8ae3e95e780206)), update),
            tlabel: {
                eng: 'Curvature Value'
            }
        })));
}
function $be94dfe364aa33e2$var$CurvaturePicker({ value: value, update: update }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e552c4cb7a4510b7$export$2e2bcd8739ae039), {
        htmlFor: "type of curvature",
        label: "Curvature",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7479184c3cda7f5d$export$2e2bcd8739ae039), {
            value: (0, $3abDJ.pipe)(value.Curvature, $be94dfe364aa33e2$var$curvatureOption, $hBXBN.fold(()=>'None', (a)=>(0, $29a0713b257db71e$export$851b30bb93ac5d3e).is(a) ? 'Circular' : 'Sinusoidal')),
            exclusive: true,
            onChange: $be94dfe364aa33e2$var$handleCurvatureType(update),
            "aria-label": "type of curvature",
            id: "type of curvature",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                    value: "None",
                    "aria-label": "None",
                    children: "None"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                    value: "Circular",
                    "aria-label": "Circular",
                    children: "Circular"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                    value: "Sinusoidal",
                    "aria-label": "Sinusoidal",
                    children: "Sinusoidal"
                })
            ]
        })
    });
}
const $be94dfe364aa33e2$var$ToggleAdvancedButton = ({ show: show, toggle: toggle })=>{
    const handleClick = ()=>toggle();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        textAlign: "right",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
            sx: {
                textDecoration: 'underline',
                display: 'inline-flex',
                fontSize: '0.75rem'
            },
            onClick: handleClick,
            children: [
                show ? 'Hide' : 'Show',
                " Advanced"
            ]
        })
    });
};
function $be94dfe364aa33e2$export$7a6e2153e2f7d8f4({ value: value, update: update }) {
    const { toggle: toggleAdvanced, value: showAdvanced } = (0, $9e39118f6baea535$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$ToggleAdvancedButton, {
                show: showAdvanced,
                toggle: toggleAdvanced
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$QCollapse, {
                orientation: "vertical",
                in: showAdvanced,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$MajorMeasurePicker, {
                    update: update,
                    value: value
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$MajorMeasureEdit, {
                update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $24a1c1ffbf73ec6a$export$c7133ab33cb183d1)(), (0, $859db0da13774873$export$214b7a7bebf20ecb)((0, $24a1c1ffbf73ec6a$export$7b9966c43d6cd366)().set(1), update)),
                value: (0, $24a1c1ffbf73ec6a$export$c7133ab33cb183d1)().get(value)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($be94dfe364aa33e2$var$QCollapse, {
                orientation: "vertical",
                in: showAdvanced,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$ClearMajorPriorityButton, {
                        update: update
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$MinorMeasurePicker, {
                        update: update,
                        value: value
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$MinorMeasureEdit, {
                value: (0, $24a1c1ffbf73ec6a$export$fb23277430a92f0b)().get(value),
                update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $24a1c1ffbf73ec6a$export$fb23277430a92f0b)(), (0, $859db0da13774873$export$214b7a7bebf20ecb)((0, $24a1c1ffbf73ec6a$export$7b78e7c08fc28a8d)().set(1), update)),
                measurementDir: value.Direction
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($be94dfe364aa33e2$var$QCollapse, {
                orientation: "vertical",
                in: showAdvanced,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$ClearMinorPriorityButton, {
                        update: update
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$CurvaturePicker, {
                        update: update,
                        value: value
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($be94dfe364aa33e2$var$CurvatureEdit, {
                        update: update,
                        value: value
                    })
                ]
            })
        ]
    });
}
const $be94dfe364aa33e2$export$1bd63e0e3d8ea5e2 = ({ value: value })=>{
    const convert = (0, $686182291220ef6d$export$6d532e72457ed852)('mm');
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$5411951f06927d69), {
        title: "Measurement",
        value: (0, $3abDJ.pipe)(value, (m)=>(0, $24a1c1ffbf73ec6a$export$f19dd2c890563e4e)().composeLens((0, $24a1c1ffbf73ec6a$export$72683dc2d378b18d)).get(m), convert.build)
    });
};







var $ayMG0 = parcelRequire("ayMG0");





// TODO: Build function for creating translation lists given values for certain languages
const $53a8291ee828fb05$var$shiftLocationTransList = [
    {
        key: 'center',
        names: {
            eng: 'center'
        }
    },
    {
        key: 'inside',
        names: {
            eng: 'inside'
        }
    },
    {
        key: 'outside',
        names: {
            eng: 'outside'
        }
    }
];
const $53a8291ee828fb05$export$e7d317c2bd46cfa9 = ({ value: value, update: update })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$2e2bcd8739ae039), {
                tlabel: {
                    eng: 'Offset'
                },
                unit: "inch",
                update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$5533399da1c0a4e9), update),
                value: (0, $7cd1993fbd4e2816$export$5533399da1c0a4e9).get(value)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                py: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$2e2bcd8739ae039), {
                    size: "small",
                    id: "location",
                    value: (0, $7cd1993fbd4e2816$export$906166a266b7aba6).get(value),
                    label: {
                        eng: 'Location'
                    },
                    items: $53a8291ee828fb05$var$shiftLocationTransList,
                    update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$906166a266b7aba6), update)
                })
            })
        ]
    });
};
var $53a8291ee828fb05$export$2e2bcd8739ae039 = $53a8291ee828fb05$export$e7d317c2bd46cfa9;



const $c9d7ee5a45b15060$var$CurbForm = (optic, focus)=>({ value: value, lengthConverter: lengthConverter, angleConverter: angleConverter, update: update })=>$hBXBN.fold((0, $3abDJ.constant)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a78a34cfe7b3ca73$export$2e2bcd8739ae039), {
            children: "Curb Not Found"
        })), (curb)=>{
            const measurement = (0, $7cd1993fbd4e2816$export$64d0857fae0810a)().get(curb);
            const updateCurb = (0, $859db0da13774873$export$2db37b7a33042541)(optic, update);
            const updateMeasurement = (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$64d0857fae0810a)(), updateCurb);
            const bredth = (0, $7cd1993fbd4e2816$export$9f7b78c3cf25ccc0)().get(curb);
            const updateBredth = (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$9f7b78c3cf25ccc0)(), updateCurb);
            const outerHeight = (0, $7cd1993fbd4e2816$export$542c4f0e3b6c4e9a)().get(curb);
            const updateOuterHeight = (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$542c4f0e3b6c4e9a)(), updateCurb);
            const offset = (0, $7cd1993fbd4e2816$export$dff7844ca8741e9e)().get(curb);
            const updateOffset = (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$dff7844ca8741e9e)(), updateCurb);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$2e2bcd8739ae039), {
                        initialExpanded: focus === 'Measurement',
                        panelName: "measurement",
                        summary: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be94dfe364aa33e2$export$1bd63e0e3d8ea5e2), {
                            value: measurement
                        }),
                        details: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be94dfe364aa33e2$export$7a6e2153e2f7d8f4), {
                            update: updateMeasurement,
                            value: measurement
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$2e2bcd8739ae039), {
                        initialExpanded: focus === 'Bredth',
                        panelName: "bredth",
                        summary: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$5411951f06927d69), {
                            title: "Bredth",
                            value: (0, $3abDJ.pipe)(value, (m)=>(0, $3abDJ.pipe)(optic.composeLens((0, $7cd1993fbd4e2816$export$9f7b78c3cf25ccc0)()).composeLens((0, $24a1c1ffbf73ec6a$export$f19dd2c890563e4e)()).composeLens((0, $24a1c1ffbf73ec6a$export$72683dc2d378b18d)).getOption(m), $hBXBN.getOrElse((0, $3abDJ.constant)(0))), lengthConverter.build)
                        }),
                        details: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be94dfe364aa33e2$export$7a6e2153e2f7d8f4), {
                            update: updateBredth,
                            value: bredth
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$2e2bcd8739ae039), {
                        initialExpanded: focus === 'OuterHeight',
                        panelName: "OuterHeight",
                        summary: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$5411951f06927d69), {
                            title: "Outer Height",
                            value: (0, $3abDJ.pipe)(value, (m)=>(0, $3abDJ.pipe)(optic.composeLens((0, $7cd1993fbd4e2816$export$542c4f0e3b6c4e9a)()).getOption(m), $hBXBN.getOrElse((0, $3abDJ.constant)(0))), lengthConverter.build)
                        }),
                        details: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$2e2bcd8739ae039), {
                            tlabel: {
                                eng: 'Outer Height'
                            },
                            unit: "mm",
                            update: updateOuterHeight,
                            value: outerHeight
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$2e2bcd8739ae039), {
                        initialExpanded: focus === 'Offset',
                        panelName: "Offset",
                        summary: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$5411951f06927d69), {
                            title: "Offset",
                            value: (0, $3abDJ.pipe)(value, (m)=>(0, $3abDJ.pipe)(optic.composeLens((0, $7cd1993fbd4e2816$export$dff7844ca8741e9e)()).composeLens((0, $7cd1993fbd4e2816$export$5533399da1c0a4e9)).getOption(m), $hBXBN.getOrElse((0, $3abDJ.constant)(0))), lengthConverter.build)
                        }),
                        details: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $53a8291ee828fb05$export$2e2bcd8739ae039), {
                            lengthConverter: lengthConverter,
                            angleConverter: angleConverter,
                            update: updateOffset,
                            value: offset
                        })
                    })
                ]
            });
        })(optic.getOption(value));
var $c9d7ee5a45b15060$export$2e2bcd8739ae039 = $c9d7ee5a45b15060$var$CurbForm;



var $ayMG0 = parcelRequire("ayMG0");

var $3abDJ = parcelRequire("3abDJ");
parcelRequire("acw62");


var $hBXBN = parcelRequire("hBXBN");





const $376f75f5cc6b0b4d$export$d61e22249646300c = ({ value: value, angleConverter: angleConverter })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$5411951f06927d69), {
        title: "Angle",
        value: (0, $3abDJ.pipe)(value, (m)=>(0, $7cd1993fbd4e2816$export$182cfb6ee9f0ec10).get(m), angleConverter.build)
    });
const $376f75f5cc6b0b4d$var$JointEdit = ({ value: value, update: update })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$2e2bcd8739ae039), {
            unit: "deg",
            value: (0, $7cd1993fbd4e2816$export$182cfb6ee9f0ec10).get(value),
            update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$182cfb6ee9f0ec10), update),
            tlabel: {
                eng: 'Angle Value'
            },
            sx: {
                width: '180px',
                mr: 3.5
            }
        })
    });
};
const $376f75f5cc6b0b4d$export$4a09770f57533a6d = (_)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
const $376f75f5cc6b0b4d$var$SectionForm = (optic, focus)=>({ value: value, lengthConverter: lengthConverter, angleConverter: angleConverter, update: update })=>$hBXBN.fold((0, $3abDJ.constant)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a78a34cfe7b3ca73$export$2e2bcd8739ae039), {
            children: "Section Not Found"
        })), (section)=>{
            const joint = (0, $7cd1993fbd4e2816$export$610f62c7aa3089e1).get(section);
            const updateSectionTree = (0, $859db0da13774873$export$2db37b7a33042541)(optic, update);
            const updateSectionJoint = (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$610f62c7aa3089e1), updateSectionTree);
            const rightWallJoint = (0, $7cd1993fbd4e2816$export$b455f688a19f877e).composePrism((0, $37e4362694b22dd4$export$80bf7733f1207381)()).composeLens((0, $7cd1993fbd4e2816$export$1970e45fbd175d71)).getOption(section);
            const updateRightJoint = (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$b455f688a19f877e).composePrism((0, $37e4362694b22dd4$export$80bf7733f1207381)()).composeLens((0, $7cd1993fbd4e2816$export$1970e45fbd175d71)), updateSectionTree);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$2e2bcd8739ae039), {
                        initialExpanded: focus === 'Angle',
                        panelName: "Angle",
                        summary: /*#__PURE__*/ (0, $ayMG0.jsx)($376f75f5cc6b0b4d$export$d61e22249646300c, {
                            lengthConverter: lengthConverter,
                            angleConverter: angleConverter,
                            value: joint
                        }),
                        details: /*#__PURE__*/ (0, $ayMG0.jsx)($376f75f5cc6b0b4d$var$JointEdit, {
                            lengthConverter: lengthConverter,
                            angleConverter: angleConverter,
                            update: updateSectionJoint,
                            value: joint
                        })
                    }),
                    (0, $3abDJ.pipe)(rightWallJoint, $hBXBN.fold((0, $3abDJ.constant)(null), (rightJoint)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$2e2bcd8739ae039), {
                            initialExpanded: focus === 'Right',
                            panelName: "Right Wall Angle",
                            summary: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$5411951f06927d69), {
                                title: "Right Wall Angle",
                                value: (0, $3abDJ.pipe)(rightJoint, (m)=>(0, $7cd1993fbd4e2816$export$182cfb6ee9f0ec10).get(m), angleConverter.build)
                            }),
                            details: /*#__PURE__*/ (0, $ayMG0.jsx)($376f75f5cc6b0b4d$var$JointEdit, {
                                lengthConverter: lengthConverter,
                                angleConverter: angleConverter,
                                update: updateRightJoint,
                                value: rightJoint
                            })
                        })))
                ]
            });
        })(optic.getOption(value));
var $376f75f5cc6b0b4d$export$2e2bcd8739ae039 = $376f75f5cc6b0b4d$var$SectionForm;



var $acw62 = parcelRequire("acw62");
const $3e9fa0c7ea742540$var$useDrawingDragAngles = ()=>{
    const [angle, setAngle] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    /*
	 * The tracking angle is used to
	 * activate the slices "hover" styling since the element's
	 * touch move handler is not trigged when the touch moves over
	 * the element IF the touch started on a different element
	 */ const [trackingAngle, setTrackingAngle] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    return {
        angle: angle,
        setAngle: setAngle,
        trackingAngle: trackingAngle,
        setTrackingAngle: setTrackingAngle
    };
};
var $3e9fa0c7ea742540$export$2e2bcd8739ae039 = $3e9fa0c7ea742540$var$useDrawingDragAngles;




var $ayMG0 = parcelRequire("ayMG0");

var $3abDJ = parcelRequire("3abDJ");


var $hBXBN = parcelRequire("hBXBN");







const $30121d0c32d17b94$var$FloorForm = (optic, focus)=>({ value: value, lengthConverter: lengthConverter, angleConverter: angleConverter, update: update })=>$hBXBN.fold((0, $3abDJ.constant)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a78a34cfe7b3ca73$export$2e2bcd8739ae039), {
            children: "Curb Not Found"
        })), (stretch)=>{
            const updateStretch = (0, $859db0da13774873$export$2db37b7a33042541)(optic, update);
            const bredth = (0, $7cd1993fbd4e2816$export$f0c8a0ba199d2458)().get(stretch);
            const updateBredth = (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$f0c8a0ba199d2458)(), updateStretch);
            const outerHeight = (0, $7cd1993fbd4e2816$export$3c6339f3d1c3afe)().get(stretch);
            const updateOuterHeight = (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$3c6339f3d1c3afe)(), updateStretch);
            const offset = (0, $7cd1993fbd4e2816$export$2b7df9035e85967e)().get(stretch);
            const updateOffset = (0, $859db0da13774873$export$2db37b7a33042541)((0, $7cd1993fbd4e2816$export$2b7df9035e85967e)(), updateStretch);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$2e2bcd8739ae039), {
                        initialExpanded: focus === 'Bredth',
                        panelName: "bredth",
                        summary: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$5411951f06927d69), {
                            title: "Bredth",
                            value: (0, $3abDJ.pipe)(value, (m)=>(0, $3abDJ.pipe)(optic.composeLens((0, $7cd1993fbd4e2816$export$f0c8a0ba199d2458)()).composeLens((0, $24a1c1ffbf73ec6a$export$c7133ab33cb183d1)()).composeLens((0, $24a1c1ffbf73ec6a$export$1f745ac5de3c6f65)).getOption(m), $hBXBN.getOrElse((0, $3abDJ.constant)(0))), lengthConverter.build)
                        }),
                        details: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be94dfe364aa33e2$export$7a6e2153e2f7d8f4), {
                            update: updateBredth,
                            value: bredth
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$2e2bcd8739ae039), {
                        initialExpanded: focus === 'OuterHeight',
                        panelName: "OuterHeight",
                        summary: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$5411951f06927d69), {
                            title: "Outer Height",
                            value: (0, $3abDJ.pipe)(value, (m)=>(0, $3abDJ.pipe)(optic.composeLens((0, $7cd1993fbd4e2816$export$3c6339f3d1c3afe)()).getOption(m), $hBXBN.getOrElse((0, $3abDJ.constant)(0))), lengthConverter.build)
                        }),
                        details: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$2e2bcd8739ae039), {
                            tlabel: {
                                eng: 'Outer Height'
                            },
                            unit: "mm",
                            update: updateOuterHeight,
                            value: outerHeight
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$2e2bcd8739ae039), {
                        initialExpanded: focus === 'Offset',
                        panelName: "Offset",
                        summary: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$5411951f06927d69), {
                            title: "Offset",
                            value: (0, $3abDJ.pipe)(value, (m)=>(0, $3abDJ.pipe)(optic.composeLens((0, $7cd1993fbd4e2816$export$2b7df9035e85967e)()).composeLens((0, $7cd1993fbd4e2816$export$5533399da1c0a4e9)).getOption(m), $hBXBN.getOrElse((0, $3abDJ.constant)(0))), lengthConverter.build)
                        }),
                        details: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $53a8291ee828fb05$export$2e2bcd8739ae039), {
                            lengthConverter: lengthConverter,
                            angleConverter: angleConverter,
                            update: updateOffset,
                            value: offset
                        })
                    })
                ]
            });
        })(optic.getOption(value));
var $30121d0c32d17b94$export$2e2bcd8739ae039 = $30121d0c32d17b94$var$FloorForm;


const $3fac04c221567571$export$153167b25e1d9ca1 = ()=>(0, $kisy7.Lens).fromProp()('open');
const $3fac04c221567571$export$26895d26fe110088 = (0, $kisy7.Lens).fromNullableProp()('rightDrawer', {});
const $3fac04c221567571$export$96e4b36520c26a2c = (0, $kisy7.Lens).fromNullableProp()('modal', {
    onSave: ()=>{},
    onClose: ()=>{},
    open: false
});
const $3fac04c221567571$export$f5fe3efefaef00fb = (0, $kisy7.Lens).fromNullableProp()('edgeBredthModal', {
    onClose: ()=>{},
    onSave: ()=>{},
    open: false,
    location: 'center'
});
const $3fac04c221567571$export$8dd4f870fd52db16 = (0, $kisy7.Lens).fromNullableProp()('pie', {
    onClose: ()=>{},
    clicked: false,
    x: 0,
    y: 0
});
const $3fac04c221567571$export$a55705775057cc10 = (path)=>{
    const i = path.indexOf('Curbs');
    const next = path[i + 1];
    if (next === undefined) return -1;
    const nextI = parseInt(next);
    if (Number.isInteger(nextI)) return nextI;
    return -1;
};
const $3fac04c221567571$var$defaultAnomaly = (0, $3ed4c97548491c68$export$e3e414bd3035dc6e).encode({
    Offset: {
        Location: 'start',
        Offset: 1
    },
    Size: 1,
    Depth: 1
});
const $3fac04c221567571$var$addAnomalySlice = (updateWall)=>(updateOpening)=>(anomalyOptic)=>({
                icon: 'Add Anomaly',
                onSelect: (_)=>{
                    // Add new anomaly to end of array
                    updateOpening(anomalyOptic.modify($4ZBbi.append($3fac04c221567571$var$defaultAnomaly)));
                    updateWall((0, $3abDJ.flow)($3fac04c221567571$var$openDrawer({
                        title: 'Anomaly',
                        Content: (0, $be5424d0b03618f0$export$2e2bcd8739ae039)(anomalyOptic)
                    }), $3fac04c221567571$export$38d827c6ff272312));
                }
            });
const $3fac04c221567571$var$getMinimalSection = (minimalOpening)=>(angle)=>{
        const opticAngle = (0, $kisy7.Lens).fromPath()([
            'Angle',
            'Angle'
        ]);
        return opticAngle.set(angle)(minimalOpening.Section);
    };
const $3fac04c221567571$var$addSection = (minimalOpening)=>(sectionPath, angle = 90)=>(op)=>{
            const newSection = $3fac04c221567571$var$getMinimalSection(minimalOpening)(angle);
            const rest = $hBXBN.toNullable((0, $7cd1993fbd4e2816$export$41825531c89a6885)(sectionPath).getOption(op));
            if (Array.isArray(rest)) {
                if (rest.length < 3) return (0, $7cd1993fbd4e2816$export$41825531c89a6885)(sectionPath).modify((_old)=>[
                        ...rest,
                        newSection
                    ])(op);
            }
            return (0, $7cd1993fbd4e2816$export$41825531c89a6885)(sectionPath).modify((_old)=>[
                    newSection
                ])(op);
        };
const $3fac04c221567571$var$addSectionSlice = (minimalOpening)=>(updateWall, sectionPath)=>(updateOpening)=>({
                icon: 'Add sect.',
                onSelect: (xy)=>{
                    updateWall($3fac04c221567571$var$openPie({
                        ...xy,
                        radius: 110,
                        entries: [
                            {
                                icon: "90\xb0",
                                onSelect: ()=>{
                                    updateOpening($3fac04c221567571$var$addSection(minimalOpening)(sectionPath, 90));
                                    updateWall($3fac04c221567571$export$38d827c6ff272312);
                                }
                            },
                            null,
                            {
                                icon: "135\xb0",
                                onSelect: ()=>{
                                    updateOpening($3fac04c221567571$var$addSection(minimalOpening)(sectionPath, 45));
                                    updateWall($3fac04c221567571$export$38d827c6ff272312);
                                }
                            },
                            null,
                            {
                                icon: "225\xb0",
                                onSelect: ()=>{
                                    updateOpening($3fac04c221567571$var$addSection(minimalOpening)(sectionPath, -45));
                                    updateWall($3fac04c221567571$export$38d827c6ff272312);
                                }
                            },
                            null,
                            {
                                icon: "270\xb0",
                                onSelect: ()=>{
                                    updateOpening($3fac04c221567571$var$addSection(minimalOpening)(sectionPath, -90));
                                    updateWall($3fac04c221567571$export$38d827c6ff272312);
                                }
                            }
                        ],
                        onClose: ()=>updateWall($3fac04c221567571$export$38d827c6ff272312)
                    }));
                }
            });
const $3fac04c221567571$var$delSlice = (sectionPath)=>(op)=>{
        if (sectionPath.length == 0) return op;
        const opticPrev = (0, $7cd1993fbd4e2816$export$41825531c89a6885)(sectionPath.slice(0, -1));
        const wall = $hBXBN.toNullable((0, $7cd1993fbd4e2816$export$41825531c89a6885)(sectionPath).getOption(op));
        const rest = ($hBXBN.toNullable(opticPrev.getOption(op)) ?? []).filter((_e, i)=>i !== sectionPath.slice(-1)[0]);
        if (!wall) return op;
        return opticPrev.modify(()=>rest.length > 0 ? rest : wall)(op);
    };
const $3fac04c221567571$var$delSectionSlice = (updateWall)=>(sectionPath)=>(updateOpening)=>({
                icon: 'Del sec.',
                onSelect: ()=>{
                    updateOpening($3fac04c221567571$var$delSlice(sectionPath));
                    updateWall($3fac04c221567571$export$38d827c6ff272312);
                }
            });
const $3fac04c221567571$var$editSectionSlice = (updateWall)=>(sectionPath)=>({
            icon: 'Spec',
            onSelect: (_XY)=>updateWall((0, $3abDJ.flow)($3fac04c221567571$var$openDrawer({
                    title: 'Section',
                    Content: (0, $376f75f5cc6b0b4d$export$2e2bcd8739ae039)((0, $7cd1993fbd4e2816$export$5307e779122cdba3)(sectionPath))
                }), $3fac04c221567571$export$38d827c6ff272312))
        });
const $3fac04c221567571$var$sectionActions = (minimalOpening)=>(updateWall)=>(sectionPath)=>(updateOpening)=>(isJoint)=>[
                        $3fac04c221567571$var$addSectionSlice(minimalOpening)(updateWall, (0, $859db0da13774873$export$54ec779613319349)(sectionPath)(isJoint))(updateOpening),
                        $3fac04c221567571$var$editSectionSlice(updateWall)(sectionPath),
                        null,
                        null,
                        $3fac04c221567571$var$delSectionSlice(updateWall)(sectionPath)(updateOpening)
                    ];
const $3fac04c221567571$var$sectionSlice = (minimalOpening)=>(updateWall)=>(sectionPath)=>(updateOpening)=>(isJoint)=>({
                        icon: 'Section',
                        onSelect: (xy)=>{
                            updateWall($3fac04c221567571$var$openPie({
                                entries: $3fac04c221567571$var$sectionActions(minimalOpening)(updateWall)(sectionPath)(updateOpening)(isJoint),
                                onClose: ()=>updateWall($3fac04c221567571$export$38d827c6ff272312),
                                ...xy
                            }));
                        }
                    });
const $3fac04c221567571$var$editMeasurementSlice = (updateWall)=>(curbOptic)=>({
            icon: 'Spec',
            onSelect: (_XY)=>updateWall((0, $3abDJ.flow)($3fac04c221567571$var$openDrawer({
                    title: 'Curb',
                    Content: (0, $c9d7ee5a45b15060$export$2e2bcd8739ae039)(curbOptic, 'Measurement')
                }), $3fac04c221567571$export$38d827c6ff272312))
        });
const $3fac04c221567571$var$leftCurbActions = (updateWall)=>(updateOpening)=>[
            null,
            $3fac04c221567571$var$editMeasurementSlice(updateWall)((0, $7cd1993fbd4e2816$export$f331b00682592a13).compose((0, $7cd1993fbd4e2816$export$713f889793d36194)()).composeOptional((0, $7cd1993fbd4e2816$export$b507c067f87a1ee3)(0))),
            $3fac04c221567571$var$addAnomalySlice(updateWall)(updateOpening)((0, $7cd1993fbd4e2816$export$f331b00682592a13).compose((0, $7cd1993fbd4e2816$export$713f889793d36194)()).composeOptional((0, $7cd1993fbd4e2816$export$b507c067f87a1ee3)(0)).composeLens((0, $7cd1993fbd4e2816$export$1ddff3fb4c314189)()))
        ];
const $3fac04c221567571$var$rightCurbActions = (updateWall)=>(updateOpening)=>(minimalOpening)=>(sectionPath)=>[
                    $3fac04c221567571$var$sectionSlice(minimalOpening)(updateWall)(sectionPath)(updateOpening)(false),
                    $3fac04c221567571$var$editMeasurementSlice(updateWall)((0, $7cd1993fbd4e2816$export$dda7e91d312139d5)(sectionPath).composeLens((0, $7cd1993fbd4e2816$export$713f889793d36194)()).composeOptional((0, $7cd1993fbd4e2816$export$b507c067f87a1ee3)(0))),
                    $3fac04c221567571$var$addAnomalySlice(updateWall)(updateOpening)((0, $7cd1993fbd4e2816$export$dda7e91d312139d5)(sectionPath).composeLens((0, $7cd1993fbd4e2816$export$713f889793d36194)()).composeOptional((0, $7cd1993fbd4e2816$export$b507c067f87a1ee3)(0)).composeLens((0, $7cd1993fbd4e2816$export$1ddff3fb4c314189)()))
                ];
const $3fac04c221567571$var$upperLeftNotchSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: $3fac04c221567571$var$image('notch-ul.svg'),
                        title: 'Notch',
                        onSelect: ()=>{
                            // Add default notch to end of ceiling stretch
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$b3cabf50b3789f41)(sectionPath))(curbsPath)('Top')([
                                'down',
                                'left'
                            ])('after')()(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$upperRightNotchSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: $3fac04c221567571$var$image('notch-ur.svg'),
                        title: 'Notch',
                        onSelect: ()=>{
                            // Add default notch to start of ceiling stretch
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$b3cabf50b3789f41)(sectionPath))(curbsPath)('Top')([
                                'left',
                                'up'
                            ])()()(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$ceilingNotchActions = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>[
                        $3fac04c221567571$var$upperLeftNotchSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath),
                        null,
                        null,
                        null,
                        $3fac04c221567571$var$upperRightNotchSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath)
                    ];
const $3fac04c221567571$var$addNotch = (updateWall)=>(entries)=>({
            icon: 'Notch',
            onSelect: (xy)=>updateWall($3fac04c221567571$var$openPie({
                    ...xy,
                    entries: entries,
                    onClose: ()=>updateWall($3fac04c221567571$export$38d827c6ff272312)
                }))
        });
const $3fac04c221567571$var$upperLeftRakeSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: $3fac04c221567571$var$image('rake-ul-up.svg'),
                        onSelect: ()=>{
                            // Add default ceiling rake to end
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$b3cabf50b3789f41)(sectionPath))(curbsPath)('Top')([
                                'left'
                            ])('after')({
                                type: 'Minor'
                            })(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$upperRightRakeSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: $3fac04c221567571$var$image('rake-ur-down.svg'),
                        onSelect: ()=>{
                            // Add default ceiling rake to start of stretch
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$b3cabf50b3789f41)(sectionPath))(curbsPath)('Top')([
                                'left'
                            ])()({
                                type: 'Minor'
                            })(-lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$ceilingRakeActions = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>[
                        $3fac04c221567571$var$upperLeftRakeSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath),
                        null,
                        null,
                        null,
                        $3fac04c221567571$var$upperRightRakeSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath)
                    ];
const $3fac04c221567571$var$addRake = (updateWall)=>(entries)=>({
            icon: 'Rake',
            onSelect: (xy)=>updateWall($3fac04c221567571$var$openPie({
                    ...xy,
                    entries: entries,
                    onClose: ()=>updateWall($3fac04c221567571$export$38d827c6ff272312)
                }))
        });
const $3fac04c221567571$var$ceilingLeftDownNibSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: 'Down',
                        onSelect: (_xy)=>{
                            // Add default ceiling nib to end
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$b3cabf50b3789f41)(sectionPath))(curbsPath)('Top')([
                                'down'
                            ])('after')({
                                type: 'Major'
                            })(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$ceilingLeftUpNibSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: 'Up',
                        onSelect: (_xy)=>{
                            // Add default ceiling nib to end
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$b3cabf50b3789f41)(sectionPath))(curbsPath)('Top')([
                                'up'
                            ])('after')({
                                type: 'Major'
                            })(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$ceilingRightUpNibSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: 'Down',
                        onSelect: (_xy)=>{
                            // Add default ceiling nib to start
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$b3cabf50b3789f41)(sectionPath))(curbsPath)('Top')([
                                'up'
                            ])('before')({
                                type: 'Major'
                            })(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$ceilingRightDownNibSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: 'Down',
                        onSelect: (_xy)=>{
                            // Add default ceiling nib to start
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$b3cabf50b3789f41)(sectionPath))(curbsPath)('Top')([
                                'down'
                            ])('before')({
                                type: 'Major'
                            })(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$showNibSlice = (slice)=>(conditions)=>(0, $3abDJ.pipe)(slice, $3fac04c221567571$var$oPieEntry(conditions), $hBXBN.toNullable);
const $3fac04c221567571$var$ceilingNibActions = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>(stretchLength)=>[
                            null,
                            $3fac04c221567571$var$ceilingLeftDownNibSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath),
                            null,
                            $3fac04c221567571$var$ceilingRightUpNibSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath),
                            null,
                            $3fac04c221567571$var$showNibSlice($3fac04c221567571$var$ceilingRightDownNibSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath))([
                                $3fac04c221567571$var$isNotStartCurb(curbsPath)
                            ]),
                            null,
                            $3fac04c221567571$var$showNibSlice($3fac04c221567571$var$ceilingLeftUpNibSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath))([
                                $3fac04c221567571$var$isNotEndCurb(stretchLength)(curbsPath)
                            ])
                        ];
const $3fac04c221567571$var$addNib = (updateWall)=>(entries)=>({
            icon: 'Nib',
            onSelect: (xy)=>updateWall($3fac04c221567571$var$openPie({
                    ...xy,
                    entries: entries,
                    onClose: ()=>updateWall($3fac04c221567571$export$38d827c6ff272312)
                }))
        });
const $3fac04c221567571$var$lowerLeftNotchSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: $3fac04c221567571$var$image('notch-ll.svg'),
                        title: 'Notch',
                        onSelect: ()=>{
                            // Add default notch to end of ceiling stretch
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$682a8673c220e1ba)(sectionPath))(curbsPath)('Bottom')([
                                'right',
                                'down'
                            ])()()(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$lowerRightNotchSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: $3fac04c221567571$var$image('notch-lr.svg'),
                        title: 'Notch',
                        onSelect: ()=>{
                            // Add default notch to start of ceiling stretch
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$682a8673c220e1ba)(sectionPath))(curbsPath)('Bottom')([
                                'up',
                                'right'
                            ])('after')()(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$floorNotchActions = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>[
                        $3fac04c221567571$var$lowerLeftNotchSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath),
                        null,
                        null,
                        null,
                        $3fac04c221567571$var$lowerRightNotchSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath)
                    ];
const $3fac04c221567571$var$lowerLeftRakeSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: $3fac04c221567571$var$image('rake-ll-down.svg'),
                        onSelect: ()=>{
                            // Add default floor rake to end
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$682a8673c220e1ba)(sectionPath))(curbsPath)('Bottom')([
                                'right'
                            ])()({
                                type: 'Minor'
                            })(-lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$lowerRightRakeSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: $3fac04c221567571$var$image('rake-lr-up.svg'),
                        onSelect: ()=>{
                            // Add default floor rake to start of stretch
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$682a8673c220e1ba)(sectionPath))(curbsPath)('Bottom')([
                                'right'
                            ])('after')({
                                type: 'Minor'
                            })(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$floorRakeActions = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>[
                        $3fac04c221567571$var$lowerLeftRakeSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath),
                        null,
                        null,
                        null,
                        $3fac04c221567571$var$lowerRightRakeSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath)
                    ];
const $3fac04c221567571$var$floorLeftDownNibSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: 'Down',
                        onSelect: (_xy)=>{
                            // Add default floor nib to end
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$682a8673c220e1ba)(sectionPath))(curbsPath)('Bottom')([
                                'down'
                            ])('before')()(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$floorLeftUpNibSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: 'Up',
                        onSelect: (_xy)=>{
                            // Add default floor nib to end
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$682a8673c220e1ba)(sectionPath))(curbsPath)('Bottom')([
                                'up'
                            ])('before')()(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$floorRightUpNibSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: 'Up',
                        onSelect: (_xy)=>{
                            // Add default floor nib to start
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$682a8673c220e1ba)(sectionPath))(curbsPath)('Bottom')([
                                'up'
                            ])('after')()(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$isNotStartCurb = (curbPath)=>()=>curbPath != 0;
const $3fac04c221567571$var$isNotEndCurb = (stretchLength)=>(curbPath)=>()=>curbPath != stretchLength - 1;
const $3fac04c221567571$var$isNotVerticalCurb = (curb)=>()=>(0, $3abDJ.pipe)(curb, $hBXBN.fold((0, $3abDJ.constant)(true), (a)=>![
                'up',
                'down'
            ].includes((0, $7cd1993fbd4e2816$export$2bc3f6e4ecf71926)().get(a))));
const $3fac04c221567571$var$floorRightDownNibSlice = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: 'Down',
                        onSelect: (_xy)=>{
                            // Add default floor nib to start
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$682a8673c220e1ba)(sectionPath))(curbsPath)('Bottom')([
                                'down'
                            ])('after')()(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$oPieEntry = (conditions)=>(a)=>(0, $3abDJ.pipe)(conditions, $4ZBbi.reduce($hBXBN.fromNullable(a), (oPrev, condition)=>(0, $3abDJ.pipe)(oPrev, $hBXBN.chain($hBXBN.fromPredicate(condition)))));
const $3fac04c221567571$var$floorNibActions = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>(stretchLength)=>[
                            null,
                            $3fac04c221567571$var$floorLeftDownNibSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath),
                            null,
                            $3fac04c221567571$var$showNibSlice($3fac04c221567571$var$floorRightDownNibSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath))([
                                $3fac04c221567571$var$isNotEndCurb(stretchLength)(curbsPath)
                            ]),
                            null,
                            $3fac04c221567571$var$floorRightUpNibSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath),
                            null,
                            $3fac04c221567571$var$showNibSlice($3fac04c221567571$var$floorLeftUpNibSlice(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath))([
                                $3fac04c221567571$var$isNotStartCurb(curbsPath)
                            ])
                        ];
const $3fac04c221567571$var$removeCurbSlice = (updateWall)=>(updateOpening)=>(update)=>({
                icon: 'Remove',
                onSelect: ()=>{
                    (0, $3abDJ.pipe)(update, updateOpening);
                    updateWall($3fac04c221567571$export$38d827c6ff272312);
                }
            });
const $3fac04c221567571$var$splitCeilingCurb = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: 'Split',
                        onSelect: ()=>{
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$b3cabf50b3789f41)(sectionPath))(curbsPath)('Top')([
                                'left'
                            ])('split')()(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$splitFloorCurb = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>({
                        icon: 'Split',
                        onSelect: ()=>{
                            (0, $3abDJ.pipe)((0, $859db0da13774873$export$e6dfa37982393983)((0, $7cd1993fbd4e2816$export$682a8673c220e1ba)(sectionPath))(curbsPath)('Bottom')([
                                'right'
                            ])('split')()(lengthConverter.defaultProduct(18)), updateOpening);
                            updateWall($3fac04c221567571$export$38d827c6ff272312);
                        }
                    });
const $3fac04c221567571$var$ceilingCurbActions = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>(stretchLength)=>(opening)=>[
                                null,
                                $3fac04c221567571$var$editMeasurementSlice(updateWall)((0, $7cd1993fbd4e2816$export$4705361e940d7b1c)(sectionPath).composeLens((0, $7cd1993fbd4e2816$export$713f889793d36194)()).composeOptional((0, $7cd1993fbd4e2816$export$b507c067f87a1ee3)(curbsPath))),
                                $3fac04c221567571$var$addAnomalySlice(updateWall)(updateOpening)((0, $7cd1993fbd4e2816$export$4705361e940d7b1c)(sectionPath).compose((0, $7cd1993fbd4e2816$export$dc9bbc5f653d95c5)(curbsPath)).composeLens((0, $7cd1993fbd4e2816$export$1ddff3fb4c314189)())),
                                $3fac04c221567571$var$addNotch(updateWall)($3fac04c221567571$var$ceilingNotchActions(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath)),
                                $3fac04c221567571$var$addRake(updateWall)($3fac04c221567571$var$ceilingRakeActions(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath)),
                                (0, $3abDJ.pipe)($3fac04c221567571$var$addNib(updateWall)($3fac04c221567571$var$ceilingNibActions(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath)(stretchLength)), $hBXBN.fromPredicate($3fac04c221567571$var$isNotVerticalCurb((0, $7cd1993fbd4e2816$export$b3cabf50b3789f41)(sectionPath).compose((0, $7cd1993fbd4e2816$export$b507c067f87a1ee3)(curbsPath)).getOption(opening))), $hBXBN.toNullable),
                                stretchLength > 1 ? $3fac04c221567571$var$removeCurbSlice(updateWall)(updateOpening)((0, $7cd1993fbd4e2816$export$b3cabf50b3789f41)(sectionPath).modify((0, $859db0da13774873$export$c34ffede45b96058)(curbsPath))) : null,
                                $3fac04c221567571$var$splitCeilingCurb(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath)
                            ];
const $3fac04c221567571$var$floorCurbActions = (updateWall)=>(updateOpening)=>(lengthConverter)=>(sectionPath)=>(curbsPath)=>(stretchLength)=>(opening)=>[
                                null,
                                $3fac04c221567571$var$editMeasurementSlice(updateWall)((0, $7cd1993fbd4e2816$export$faa3e63c9e26e74b)(sectionPath).composeLens((0, $7cd1993fbd4e2816$export$713f889793d36194)()).composeOptional((0, $7cd1993fbd4e2816$export$b507c067f87a1ee3)(curbsPath))),
                                $3fac04c221567571$var$addAnomalySlice(updateWall)(updateOpening)((0, $7cd1993fbd4e2816$export$faa3e63c9e26e74b)(sectionPath).compose((0, $7cd1993fbd4e2816$export$dc9bbc5f653d95c5)(curbsPath)).composeLens((0, $7cd1993fbd4e2816$export$1ddff3fb4c314189)())),
                                $3fac04c221567571$var$addNotch(updateWall)($3fac04c221567571$var$floorNotchActions(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath)),
                                $3fac04c221567571$var$addRake(updateWall)($3fac04c221567571$var$floorRakeActions(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath)),
                                (0, $3abDJ.pipe)($3fac04c221567571$var$addNib(updateWall)($3fac04c221567571$var$floorNibActions(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath)(stretchLength)), $hBXBN.fromPredicate($3fac04c221567571$var$isNotVerticalCurb((0, $7cd1993fbd4e2816$export$682a8673c220e1ba)(sectionPath).compose((0, $7cd1993fbd4e2816$export$b507c067f87a1ee3)(curbsPath)).getOption(opening))), $hBXBN.toNullable),
                                stretchLength > 1 ? $3fac04c221567571$var$removeCurbSlice(updateWall)(updateOpening)((0, $7cd1993fbd4e2816$export$682a8673c220e1ba)(sectionPath).modify((0, $859db0da13774873$export$c34ffede45b96058)(curbsPath))) : null,
                                $3fac04c221567571$var$splitFloorCurb(updateWall)(updateOpening)(lengthConverter)(sectionPath)(curbsPath)
                            ];
const $3fac04c221567571$var$editFloorSlice = (updateWall)=>(stretchOptic)=>(focus)=>({
                icon: 'Spec',
                onSelect: (_XY)=>updateWall((0, $3abDJ.flow)($3fac04c221567571$var$openDrawer({
                        title: 'Floor',
                        Content: (0, $30121d0c32d17b94$export$2e2bcd8739ae039)(stretchOptic, focus)
                    }), $3fac04c221567571$export$38d827c6ff272312))
            });
const $3fac04c221567571$var$editFloorCurbSlice = (updateWall)=>(curbOptic)=>(focus)=>({
                icon: 'Spec',
                onSelect: ()=>updateWall((0, $3abDJ.flow)($3fac04c221567571$var$openDrawer({
                        title: 'Curb',
                        Content: (0, $c9d7ee5a45b15060$export$2e2bcd8739ae039)(curbOptic, focus)
                    }), $3fac04c221567571$export$38d827c6ff272312))
            });
const $3fac04c221567571$var$floorPlanStretchActions = (updateWall)=>(stretchOptic)=>(focus)=>[
                null,
                $3fac04c221567571$var$editFloorSlice(updateWall)(stretchOptic)(focus)
            ];
const $3fac04c221567571$var$floorPlanCurbActions = (updateWall)=>(curbOptic)=>(focus)=>[
                null,
                $3fac04c221567571$var$editFloorCurbSlice(updateWall)(curbOptic)(focus)
            ];
const $3fac04c221567571$var$image = (href, x = -15, y = -15, w = 30, h = 30)=>/*#__PURE__*/ (0, $ayMG0.jsx)("image", {
        x: x,
        y: y,
        width: w,
        height: h,
        href: '/img/opening/' + href
    });
const $3fac04c221567571$export$82687d13756d4b3d = 'Drawing';
const $3fac04c221567571$var$onMouseDown = (minimalOpening)=>(updateWall)=>(props)=>(updateElId)=>(e)=>{
                    const target = e.target;
                    let xy = {
                        x: 0,
                        y: 0
                    };
                    if ('clientX' in e) xy = {
                        x: e.clientX,
                        y: e.clientY
                    };
                    if ('targetTouches' in e) {
                        const firstTouch = e.targetTouches[0];
                        if (firstTouch) xy = {
                            x: firstTouch.clientX,
                            y: firstTouch.clientY
                        };
                    }
                    if (!(target && target instanceof Node)) return;
                    const ele = target.parentElement;
                    if (!ele) return;
                    if (ele.id === $3fac04c221567571$export$82687d13756d4b3d) /*
		 * User is trying to click away
		 * inside of drawing
		 */ updateWall($3fac04c221567571$export$38d827c6ff272312);
                    const path = ele.id.split('-').slice(0, -1);
                    const lens = (0, $46f7ab6e3a21029a$export$357889f174732d38)(props.value, props.value)(path);
                    const classList = Array.from(ele.classList);
                    const isLabel = classList.includes('figure-label'), isBox = classList.includes('figure-box'), isCorner = path.includes('Corner');
                    if (isBox || isLabel) {
                        updateElId(()=>ele.id);
                        $3fac04c221567571$var$handle(minimalOpening)(updateWall)(props)(isBox, isLabel, isCorner)(xy)(path, lens)(ele.id);
                    }
                };
/* Main */ const $3fac04c221567571$var$handle = (minimalOpening)=>(updateWall)=>(props)=>(isBox, isLabel, isCorner)=>(xy)=>(path, lens)=>(id)=>{
                            const sectionPath = (0, $859db0da13774873$export$7824cc40e1e06c48)(path);
                            if (path.includes('Left')) $3fac04c221567571$var$handleLeft(updateWall)(props)(isBox, isCorner)(xy);
                            else if (path.includes('Right') && !isCorner) $3fac04c221567571$var$handleRight(minimalOpening)(updateWall)(props, sectionPath)(isBox, isLabel, isCorner)(xy)(path, lens);
                            else $3fac04c221567571$var$handleSection(minimalOpening)(updateWall)(props, sectionPath)(isBox, isLabel, isCorner)(xy)(path, lens)(id);
                        };
const $3fac04c221567571$var$handleLeft = (updateWall)=>(props)=>(_isBox, isCorner)=>(xy)=>{
                // User clicks on left curb
                // TODO: Handle corner click
                if (isCorner) return;
                // Open pie with single curb options
                updateWall($3fac04c221567571$var$openPie({
                    ...xy,
                    radius: 120,
                    entries: $3fac04c221567571$var$leftCurbActions(updateWall)(props.update),
                    onClose: ()=>updateWall($3fac04c221567571$export$38d827c6ff272312)
                }));
            };
const $3fac04c221567571$var$handleSection = (minimalOpening)=>(updateWall)=>(props, sectionPath)=>(isBox, _isLabel, isCorner)=>(xy)=>(path, lens)=>(id)=>{
                            const isAngle = path.includes('Angle'), isCeiling = path.includes('Ceiling'), isEdge = path.includes('Edge'), isEdgeBredth = path.includes('EdgeBredth'), isEdgeOuterHeight = path.includes('EdgeOuterHeight'), isFloor = path.includes('Floor'), isJoint = path.includes('Joint');
                            if (isEdge || isEdgeOuterHeight || isEdgeBredth) {
                                $3fac04c221567571$var$handleFloorPlan(updateWall)(id)(xy);
                                return;
                            }
                            if (isJoint) $3fac04c221567571$var$handleJoint(minimalOpening)(updateWall)(props, sectionPath)(xy);
                            if (isCeiling) $3fac04c221567571$var$handleCeiling(updateWall)(props, sectionPath)(isBox, isCorner)(xy)(path, lens);
                            else if (isFloor) $3fac04c221567571$var$handleFloor(updateWall)(props, sectionPath)(isCorner)(xy)(path);
                            else if (isAngle) $3fac04c221567571$var$handleAngle(updateWall)(sectionPath)(path);
                        };
const $3fac04c221567571$var$handleAngle = (updateWall)=>(sectionPath)=>(path)=>{
            const sectionOptic = (0, $7cd1993fbd4e2816$export$5307e779122cdba3)(sectionPath);
            const focus = (0, $3abDJ.pipe)(path.includes('Right'), $29b3dcb11c87a56f$exports.fold((0, $3abDJ.constant)('Angle'), (0, $3abDJ.constant)('Right')));
            updateWall($3fac04c221567571$var$openDrawer({
                title: 'Section',
                Content: (0, $376f75f5cc6b0b4d$export$2e2bcd8739ae039)(sectionOptic, focus)
            }));
        };
const $3fac04c221567571$var$handleCeiling = (updateWall)=>(props, sectionPath)=>(_isBox, isCorner)=>(xy)=>(path, _lens)=>{
                    const curbsPath = (0, $3abDJ.pipe)(path, $3fac04c221567571$export$a55705775057cc10);
                    const curbLength = (0, $859db0da13774873$export$7cef9a0ddfdbfe95)(props.value)(sectionPath);
                    // TODO: Handle corner click
                    if (isCorner) return;
                    updateWall($3fac04c221567571$var$openPie({
                        ...xy,
                        radius: 120,
                        entries: $3fac04c221567571$var$ceilingCurbActions(updateWall)(props.update)(props.lengthConverter)(sectionPath)(curbsPath)(curbLength)(props.value),
                        onClose: ()=>updateWall($3fac04c221567571$export$38d827c6ff272312)
                    }));
                };
const $3fac04c221567571$var$handleFloor = (updateWall)=>(props, sectionPath)=>(isCorner)=>(xy)=>(path)=>{
                    const curbsPath = $3fac04c221567571$export$a55705775057cc10(path);
                    const curbLength = (0, $859db0da13774873$export$7f18cc751d497f74)(props.value)(sectionPath);
                    // TODO: Handle corner click
                    if (isCorner) return;
                    updateWall($3fac04c221567571$var$openPie({
                        ...xy,
                        radius: 120,
                        entries: $3fac04c221567571$var$floorCurbActions(updateWall)(props.update)(props.lengthConverter)(sectionPath)(curbsPath)(curbLength)(props.value),
                        onClose: ()=>updateWall($3fac04c221567571$export$38d827c6ff272312)
                    }));
                };
const $3fac04c221567571$var$handleFloorPlan = (updateWall)=>(elementId)=>(xy)=>{
            (0, $3abDJ.pipe)(elementId, (0, $5ef56094387f3e7e$export$375a8416951f4bb0), $5uDEp.fold(/*
			 * TODO: A curb bredth, offset, and outer height may be null when the stretch bredth,
			 * offset, and outer height are defined in the Opening design. The drawing will
			 * fill in the amount from the stretch but the optic will return zero and won't use the
			 * equivalent stretch value
			 */ (curbOptic)=>updateWall($3fac04c221567571$var$openPie({
                    ...xy,
                    radius: 120,
                    entries: $3fac04c221567571$var$floorPlanCurbActions(updateWall)(curbOptic)((0, $5ef56094387f3e7e$export$56e1424916b718f3)(elementId)),
                    onClose: ()=>updateWall($3fac04c221567571$export$38d827c6ff272312)
                })), (stretchOptic)=>updateWall($3fac04c221567571$var$openPie({
                    ...xy,
                    radius: 120,
                    entries: $3fac04c221567571$var$floorPlanStretchActions(updateWall)(stretchOptic)((0, $5ef56094387f3e7e$export$56e1424916b718f3)(elementId)),
                    onClose: ()=>updateWall($3fac04c221567571$export$38d827c6ff272312)
                }))));
        };
const $3fac04c221567571$var$handleJoint = (minimalOpening)=>(updateWall)=>(props, sectionPath)=>(xy)=>{
                updateWall($3fac04c221567571$var$openPie({
                    ...xy,
                    radius: 120,
                    entries: [
                        $3fac04c221567571$var$sectionSlice(minimalOpening)(updateWall)(sectionPath)(props.update)(true)
                    ],
                    onClose: ()=>updateWall($3fac04c221567571$export$38d827c6ff272312)
                }));
            };
const $3fac04c221567571$var$handleRight = (minimalOpening)=>(updateWall)=>(props, sectionPath)=>(_isBox, _isLabel, _isCorner)=>(xy)=>(path, _lens)=>{
                        if (path.includes('Angle')) {
                            $3fac04c221567571$var$handleAngle(updateWall)(sectionPath)(path);
                            return;
                        }
                        updateWall($3fac04c221567571$var$openPie({
                            ...xy,
                            radius: 120,
                            entries: $3fac04c221567571$var$rightCurbActions(updateWall)(props.update)(minimalOpening)(sectionPath),
                            onClose: ()=>updateWall($3fac04c221567571$export$38d827c6ff272312)
                        }));
                    };
/**
 *
 * `Update` actions for `WalledState`
 *
 */ const $3fac04c221567571$var$openDrawer = (drawer)=>$3fac04c221567571$export$26895d26fe110088.set({
        open: true,
        ...drawer
    });
const $3fac04c221567571$var$closeDrawer = $3fac04c221567571$export$26895d26fe110088.set({
    open: false
});
const $3fac04c221567571$var$openPie = (pieProps)=>$3fac04c221567571$export$8dd4f870fd52db16.set(pieProps);
const $3fac04c221567571$export$38d827c6ff272312 = $3fac04c221567571$export$8dd4f870fd52db16.modify((prevState)=>({
        ...prevState,
        entries: undefined,
        radius: 0
    }));
const $3fac04c221567571$var$WallEditor = (props)=>{
    // Minimal opening data object for creating new sections
    const [minimalOpening, setMinimalOpening] = $acw62.useState(null);
    // Main state control object for WallEditor
    const [walledState, setWalledState] = $acw62.useState({
        rightDrawer: undefined,
        modal: undefined,
        edgeBredthModal: undefined,
        pie: undefined
    });
    // State for managing pie slice selection and highlighting on touch screens
    const { angle: angle, setAngle: setAngle, trackingAngle: trackingAngle, setTrackingAngle: setTrackingAngle } = (0, $3e9fa0c7ea742540$export$2e2bcd8739ae039)();
    // Reassign setWalledState to help with Updater pattern
    const updateWall = setWalledState;
    // Network call for the latest minimal opening data
    const fetchMinimalOpening = $acw62.useCallback(()=>{
        props.req.request((0, $3ed4c97548491c68$export$605846925e53c7e7))('minimal/silica/opening', 'GET').then((opening)=>setMinimalOpening(opening)).catch((failure)=>console.warn('Failed to fetch minimal opening.', failure));
    }, [
        props.req
    ]);
    // Fetch the minimal opening after component mounts
    $acw62.useEffect(()=>fetchMinimalOpening(), [
        fetchMinimalOpening
    ]);
    // Destructure state object to pass props to corresponding components
    const { pie: pie, modal: modal, edgeBredthModal: edgeBredthModal, rightDrawer: rightDrawer } = walledState;
    const exit = ()=>updateWall($3fac04c221567571$var$closeDrawer);
    const [elId, setElId] = $acw62.useState('');
    $acw62.useEffect(()=>{
        if (!pie?.entries) setElId('');
    }, [
        pie?.entries
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            minimalOpening && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9a024fae628eb36$export$2e2bcd8739ae039), {
                ...props,
                angle: angle,
                updateAngle: setAngle,
                trackingAngle: trackingAngle,
                updateTrackingAngle: setTrackingAngle,
                updateWall: updateWall,
                activeElementId: elId,
                onDown: $3fac04c221567571$var$onMouseDown(minimalOpening)(updateWall)(props)(setElId)
            }),
            pie ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3a7a8634e41a2445$export$2e2bcd8739ae039), {
                trackingAngle: trackingAngle,
                updateTrackingAngle: setTrackingAngle,
                angle: angle,
                updateAngle: setAngle,
                drawingRotation: props.projection.type === 'Isometric' ? props.projection.Rotate : undefined,
                updateOpening: props.update,
                angleConverter: props.angleConverter,
                lengthConverter: props.lengthConverter,
                ...pie
            }) : null,
            modal ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5ff0091b950cfbc$export$2e2bcd8739ae039), {
                ...modal
            }) : null,
            edgeBredthModal ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ede9b8cdb515782e$export$26effe6b987106b5), {
                ...edgeBredthModal
            }) : null,
            rightDrawer?.open ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68a0b503497ce0e5$export$2e2bcd8739ae039), {
                ...rightDrawer,
                exit: exit,
                value: props.value,
                lengthConverter: props.lengthConverter,
                angleConverter: props.angleConverter,
                update: props.update
            }) : null
        ]
    });
};
var $3fac04c221567571$export$2e2bcd8739ae039 = $3fac04c221567571$var$WallEditor;





var $kisy7 = parcelRequire("kisy7");
var $21724a0ba57e8f23$export$605846925e53c7e7;
var $21724a0ba57e8f23$export$ef9b1a59e592288f;
$21724a0ba57e8f23$export$605846925e53c7e7 = `J4xbdG_Opening`;
$21724a0ba57e8f23$export$ef9b1a59e592288f = `J4xbdG_Select`;



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");



var $5OFXS = parcelRequire("5OFXS");

/**
 * Panels.
 *
 * Front-end related panel drawings, checks for updated props and appends XML to the current react reference.
 *
 * @since 0.2.0
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





var $dMYym = parcelRequire("dMYym");




/**
 * Angle and length unit conversion.
 */ const $270369b6eaa434fe$var$convertAngleUnits = (ac)=>(el)=>(id)=>{
            if (id.endsWith('-Angle-lbl')) return ac.build(el);
            return null;
        };
const $270369b6eaa434fe$var$convertLengthUnits = (lc)=>(el)=>(id)=>{
            if (!id.includes('Angle') && id.endsWith('-lbl')) return lc.build(el);
            return null;
        };
const $270369b6eaa434fe$var$PanelViewer = ({ lengthConverter: lengthConverter, angleConverter: angleConverter, req: req, value: value, visible: visible, projection: projection, onDown: onDown, activeElementId: activeElementId, updatePanel: updatePanel, angle: angle, updateAngle: updateAngle, trackingAngle: trackingAngle, updateTrackingAngle: updateTrackingAngle, ...props })=>{
    const { ref: ref } = (0, $c49fcf209b4b4b92$export$2e2bcd8739ae039)(updateAngle, angle, updateTrackingAngle, trackingAngle);
    const { viewBox: viewBox, containerRef: containerRef, zooming: zooming, ...mouseHandlers } = (0, $1c171a81388d816c$export$2e2bcd8739ae039)(onDown, activeElementId);
    const { svgInner: svgInner, hashKey: hashKey } = (0, $51c3da3432a3b533$export$2e2bcd8739ae039)(req, value, projection, [
        {
            type: 'Panels',
            Projection: projection
        }
    ]);
    $acw62.useEffect(()=>{
        if (zooming) updatePanel((0, $922bec9229673d1a$export$38d827c6ff272312));
    }, [
        zooming,
        updatePanel
    ]);
    $acw62.useEffect(()=>{
        if (containerRef?.current) (0, $5ef56094387f3e7e$export$da227b5f76807204)((0, $5ef56094387f3e7e$export$fc65e6186004f4eb)($270369b6eaa434fe$var$convertLengthUnits(lengthConverter)))(containerRef?.current);
    }, [
        lengthConverter,
        svgInner,
        value,
        containerRef
    ]);
    $acw62.useEffect(()=>{
        if (containerRef?.current) (0, $5ef56094387f3e7e$export$da227b5f76807204)((0, $5ef56094387f3e7e$export$fc65e6186004f4eb)($270369b6eaa434fe$var$convertAngleUnits(angleConverter)))(containerRef?.current);
    }, [
        angleConverter,
        svgInner,
        value,
        containerRef
    ]);
    const propHash = (0, $ca0affc99e9d76c6$export$d6af199866bfb566)(hashKey)({
        req: req,
        value: value,
        projection: projection,
        visible: visible,
        onDown: onDown,
        ...props
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        id: (0, $3fac04c221567571$export$82687d13756d4b3d),
        ref: containerRef,
        className: `hash-${propHash} drawing`,
        sx: {
            width: '100%',
            flexGrow: 1
        },
        ...mouseHandlers,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            ref: ref,
            component: "svg",
            dangerouslySetInnerHTML: {
                __html: svgInner
            },
            sx: {
                [`& #${activeElementId}`]: {
                    stroke: (0, $dMYym.default)[300],
                    strokeOpacity: 0.5,
                    fill: (0, $dMYym.default)[300]
                }
            },
            viewBox: `${viewBox.x} ${viewBox.y} ${viewBox.w} ${viewBox.h}`
        })
    });
};
var $270369b6eaa434fe$export$2e2bcd8739ae039 = $270369b6eaa434fe$var$PanelViewer;



var $kisy7 = parcelRequire("kisy7");

var $3abDJ = parcelRequire("3abDJ");

const $922bec9229673d1a$export$96e4b36520c26a2c = (0, $kisy7.Lens).fromNullableProp()('modal', {
    onSave: ()=>{},
    onClose: ()=>{},
    open: false
});
const $922bec9229673d1a$export$8dd4f870fd52db16 = (0, $kisy7.Lens).fromNullableProp()('pie', {
    onClose: ()=>{},
    clicked: false,
    x: 0,
    y: 0
});
const $922bec9229673d1a$var$closeModal = $922bec9229673d1a$export$96e4b36520c26a2c.modify(()=>({
        open: false,
        onClose: ()=>{},
        onSave: ()=>{}
    }));
const $922bec9229673d1a$export$38d827c6ff272312 = $922bec9229673d1a$export$8dd4f870fd52db16.modify((prevState)=>({
        ...prevState,
        entries: undefined,
        radius: 0
    }));
const $922bec9229673d1a$var$openModal = (modalProps)=>$922bec9229673d1a$export$96e4b36520c26a2c.set({
        ...modalProps,
        open: true
    });
const $922bec9229673d1a$var$openPie = (pieProps)=>$922bec9229673d1a$export$8dd4f870fd52db16.set(pieProps);
const $922bec9229673d1a$var$splitPie = (updatePanel, updateOpening, lengthConverter, path, side, _corner = 0)=>(xy)=>{
        if (side === undefined) updatePanel($922bec9229673d1a$var$openPie({
            ...xy,
            entries: [
                {
                    icon: "\u2190",
                    title: 'Split panel from the right.',
                    onSelect: ()=>updatePanel((0, $3abDJ.flow)($922bec9229673d1a$var$splitModal(updatePanel, updateOpening, lengthConverter, path, 'right'), $922bec9229673d1a$export$38d827c6ff272312))
                },
                path.division.length > 0 ? {
                    icon: 'x',
                    title: 'Remove split.',
                    onSelect: ()=>{
                        $922bec9229673d1a$var$removeSplit(updateOpening, path)();
                        updatePanel($922bec9229673d1a$export$38d827c6ff272312);
                    }
                } : null,
                {
                    icon: "\u2193",
                    title: 'Split panel from the top.',
                    onSelect: ()=>updatePanel((0, $3abDJ.flow)($922bec9229673d1a$var$splitModal(updatePanel, updateOpening, lengthConverter, path, 'top'), $922bec9229673d1a$export$38d827c6ff272312))
                },
                null,
                {
                    icon: "\u2192",
                    title: 'Split panel from the left.',
                    onSelect: ()=>updatePanel((0, $3abDJ.flow)($922bec9229673d1a$var$splitModal(updatePanel, updateOpening, lengthConverter, path, 'left'), $922bec9229673d1a$export$38d827c6ff272312))
                },
                null,
                {
                    icon: "\u2191",
                    title: 'Split panel from the bottom.',
                    onSelect: ()=>updatePanel((0, $3abDJ.flow)($922bec9229673d1a$var$splitModal(updatePanel, updateOpening, lengthConverter, path, 'bottom'), $922bec9229673d1a$export$38d827c6ff272312))
                }
            ],
            onClose: ()=>updatePanel($922bec9229673d1a$export$38d827c6ff272312)
        }));
        else return;
    };
const $922bec9229673d1a$var$topPie = (updatePanel)=>(updateOpening)=>(lengthConverter)=>(updateElId)=>(e)=>{
                    /*
	 * if (pe.state.pie !== undefined) {
	 * 	return updatePanel(closePie);
	 * }
	 */ let xy = {
                        x: 0,
                        y: 0
                    };
                    if ('clientX' in e) xy = {
                        x: e.clientX,
                        y: e.clientY
                    };
                    if ('targetTouches' in e) {
                        const firstTouch = e.targetTouches[0];
                        if (firstTouch) xy = {
                            x: firstTouch.clientX,
                            y: firstTouch.clientY
                        };
                    }
                    const target = e.target;
                    if (!(target && target instanceof Node)) return;
                    const ele = target.parentElement;
                    if (!ele) return;
                    if (ele.classList.contains('Panel') || ele.classList.contains('Split')) {
                        const path = $922bec9229673d1a$var$parseDivisionPath(ele.id.split('-'));
                        if (typeof path === 'string') {
                            console.warn('Invalid Division Path:', path, ele.id.split('-'));
                            return;
                        }
                        updateElId(()=>ele.id);
                        updatePanel($922bec9229673d1a$var$openPie({
                            ...xy,
                            entries: [
                                null,
                                null,
                                {
                                    icon: "\u2B1A\u2502\u2B1A",
                                    title: 'Split.',
                                    onSelect: $922bec9229673d1a$var$splitPie(updatePanel, updateOpening, lengthConverter, path)
                                },
                                null,
                                null,
                                null,
                                null,
                                null
                            ],
                            onClose: ()=>updatePanel($922bec9229673d1a$export$38d827c6ff272312)
                        }));
                    } else console.log(ele, xy);
                };
const $922bec9229673d1a$var$splitModal = (updatePanel, updateOpening, lengthConverter, path, side)=>$922bec9229673d1a$var$openModal({
        open: true,
        message: `Distance from ${side} to split:`,
        onSave: $922bec9229673d1a$var$doSplit(updateOpening, lengthConverter, path, side),
        onClose: ()=>updatePanel((0, $3abDJ.flow)($922bec9229673d1a$export$38d827c6ff272312, $922bec9229673d1a$var$closeModal))
    });
const $922bec9229673d1a$var$parseSectionPath = (path)=>{
    const section = [];
    let i = 0;
    for(;; i++){
        const step = path[i];
        if (step === undefined) break;
        if (step === 'Rest') continue;
        const n = parseInt(step);
        if (isNaN(n)) break;
        if (n === 0 || n === 1 || n === 2) section.push(n);
        else return `Invalid Section Id ${i}`;
    }
    return {
        section: section,
        consumed: i
    };
};
const $922bec9229673d1a$var$parseDivisionPath = (path)=>{
    const sectionParse = $922bec9229673d1a$var$parseSectionPath(path);
    if (typeof sectionParse === 'string') return sectionParse;
    let i = sectionParse.consumed;
    if (path[i] !== 'Panels' && path[i] !== 'Split') return 'This path does not select a Division';
    i++;
    const division = [];
    for(;; i++){
        const step = path[i];
        if (step === undefined) break;
        const n = parseInt(step);
        if (isNaN(n)) break;
        if (n > 1 || n < 0) return `Invalid Division Id ${i}`;
        division.push(n === 0 ? 'Left' : 'Right');
    }
    return {
        section: sectionParse.section,
        division: division,
        consumed: i
    };
};
const $922bec9229673d1a$var$doSplit = (updateOpening, lengthConverter, path, side)=>(amountStr)=>lengthConverter.parse(amountStr).then((amount)=>updateOpening((op)=>{
                const optic = (0, $7cd1993fbd4e2816$export$399a1bfe5b91ffeb)(path.section, path.division);
                const existing = (0, $5OFXS.toNullable)(optic.getOption(op));
                if (existing === null) {
                    console.warn('No Division at Division Path', path);
                    return op;
                }
                const whole = {
                    type: 'Whole',
                    Info: null
                };
                const division = {
                    type: 'Divided',
                    Left: whole,
                    Right: existing,
                    LeftEdge: null,
                    RightEdge: null,
                    Curve: {
                        type: 'Angled',
                        Angle: 0,
                        Corner: 0,
                        Distance: amount,
                        Side: side
                    }
                };
                return optic.modify((_old)=>division)(op);
            })).catch(console.warn);
const $922bec9229673d1a$var$removeSplit = (updateOpening, path)=>()=>updateOpening((op)=>{
            const lastStep = path.division[path.division.length - 1];
            if (lastStep === undefined) return op;
            const parentDivisionPath = path.division.slice(0, -1);
            const siblingStep = lastStep === 'Left' ? 'Right' : 'Left';
            const parentOptic = (0, $7cd1993fbd4e2816$export$399a1bfe5b91ffeb)(path.section, parentDivisionPath);
            const sibling = (0, $5OFXS.toNullable)(parentOptic.compose((0, $4264ed72b222fae4$export$ddcc0c9c3b00c1b5)(siblingStep)).getOption(op));
            if (sibling === null) return op;
            return parentOptic.modify((_old)=>sibling)(op);
        });
const $922bec9229673d1a$var$PanelEditor = (props)=>{
    // Main state control object for PanelEditor
    const [panelState, setPanelState] = $acw62.useState({
        modal: undefined,
        pie: undefined
    });
    // State for managing pie slice selection and highlighting on touch screens
    const { angle: angle, setAngle: setAngle, trackingAngle: trackingAngle, setTrackingAngle: setTrackingAngle } = (0, $3e9fa0c7ea742540$export$2e2bcd8739ae039)();
    const { pie: pie, modal: modal } = panelState;
    const [elId, setElId] = $acw62.useState('');
    $acw62.useEffect(()=>{
        if (!pie?.entries) setElId('');
    }, [
        pie?.entries
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $270369b6eaa434fe$export$2e2bcd8739ae039), {
                ...props,
                angle: angle,
                updateAngle: setAngle,
                trackingAngle: trackingAngle,
                updateTrackingAngle: setTrackingAngle,
                updatePanel: setPanelState,
                onDown: $922bec9229673d1a$var$topPie(setPanelState)(props.update)(props.lengthConverter)(setElId),
                activeElementId: elId
            }),
            pie ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3a7a8634e41a2445$export$2e2bcd8739ae039), {
                ...pie,
                angle: angle,
                updateAngle: setAngle,
                trackingAngle: trackingAngle,
                updateTrackingAngle: setTrackingAngle,
                drawingRotation: props.projection.type === 'Isometric' ? props.projection.Rotate : undefined,
                updateOpening: props.update,
                angleConverter: props.angleConverter,
                lengthConverter: props.lengthConverter
            }) : null,
            modal ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5ff0091b950cfbc$export$2e2bcd8739ae039), {
                ...modal
            }) : null
        ]
    });
};
var $922bec9229673d1a$export$2e2bcd8739ae039 = $922bec9229673d1a$var$PanelEditor;


const $be9adc3c682f2c7a$export$62f60cd32d97bbcb = (0, $87701c398fec8638$export$7e1278799275f68e)({
    Wall: true,
    Panel: true
});
const $be9adc3c682f2c7a$var$updateOpening = (page, pushHistory = true)=>(f)=>{
        if (pushHistory) page.history.push(page.state.opening);
        page.setState((0, $kisy7.Lens).fromProp()('opening').modify(f));
    };
const $be9adc3c682f2c7a$var$setOpening = (page)=>(opening)=>{
        page.setState(()=>({
                opening: opening
            }));
    };
const $be9adc3c682f2c7a$export$138306ecf3692138 = 0;
class $be9adc3c682f2c7a$export$2e2bcd8739ae039 extends $acw62.Component {
    constructor(props){
        super(props), this.history = [];
        this.state = {
            loading: false,
            mode: 'Wall',
            space: {
                x: 0,
                y: 0,
                width: 1024.00,
                height: 1024.00,
                scale: 1,
                click: false,
                scroll: false,
                drag: false
            },
            projection: {
                type: 'Isometric',
                Rotate: $be9adc3c682f2c7a$export$138306ecf3692138
            },
            unit: 'inch',
            angle: 'interior',
            opening: props.opening
        };
    }
    render() {
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: $21724a0ba57e8f23$export$605846925e53c7e7,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $efbb6eb46c8dd746$export$bfbece8a621a006f), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $437a2d9ce62cfb25$export$d0dbb306591aec74), {
                            codec: (0, $3ed4c97548491c68$export$605846925e53c7e7),
                            name: "Opening",
                            success: $be9adc3c682f2c7a$var$setOpening(this),
                            failure: (e)=>{
                                alert('Import failed, check console for details.');
                                console.warn(e);
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a29c4ff9777c8b77$export$f883e605db67eacf), {
                            name: "Opening",
                            getContent: ()=>this.state.opening
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12648447b9c23b90$export$c7c44baae9d9f25f), {
                            projection: this.state.projection,
                            onProjectionChange: (p)=>{
                                this.setState((prevState)=>({
                                        projection: p(prevState.projection)
                                    }));
                            },
                            lengthUnit: this.state.unit,
                            onLengthUnitChange: (u)=>{
                                this.setState((prevState)=>({
                                        unit: u(prevState.unit)
                                    }));
                            },
                            angleLocation: this.state.angle,
                            onAngleLocationChange: (a)=>{
                                this.setState((prevState)=>({
                                        angle: a(prevState.angle)
                                    }));
                            },
                            mode: this.state.mode,
                            onOpeningModeChange: (o)=>{
                                this.setState((prevState)=>({
                                        mode: o(prevState.mode)
                                    }));
                            },
                            onUndo: ()=>{
                                const opening = this.history.pop();
                                if (!opening) return;
                                $be9adc3c682f2c7a$var$setOpening(this)(opening);
                            }
                        })
                    ]
                }),
                this.state.mode === 'Panel' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $922bec9229673d1a$export$2e2bcd8739ae039), {
                    req: this.props.req,
                    visible: this.state.mode === 'Panel',
                    value: this.state.opening,
                    space: this.state.space,
                    projection: this.state.projection,
                    lengthConverter: (0, $4beeab19e80c1290$export$586f2408ab04b194)[this.state.unit],
                    angleConverter: (0, $4beeab19e80c1290$export$6e98d19a58527322)[this.state.angle],
                    update: $be9adc3c682f2c7a$var$updateOpening(this),
                    spaceControl: (space)=>{
                        this.setState({
                            space: space
                        });
                    }
                }),
                this.state.mode === 'Wall' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fac04c221567571$export$2e2bcd8739ae039), {
                    req: this.props.req,
                    visible: this.state.mode === 'Wall',
                    value: this.state.opening,
                    space: this.state.space,
                    projection: this.state.projection,
                    curbEdges: false,
                    lengthConverter: (0, $4beeab19e80c1290$export$586f2408ab04b194)[this.state.unit],
                    angleConverter: (0, $4beeab19e80c1290$export$6e98d19a58527322)[this.state.angle],
                    update: $be9adc3c682f2c7a$var$updateOpening(this),
                    spaceControl: (space)=>{
                        this.setState({
                            space: space
                        });
                    }
                })
            ]
        });
    }
}


class $88b24329de9be42f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props), this.render = ()=>!this.state.opening ? /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                children: "Loading..."
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be9adc3c682f2c7a$export$2e2bcd8739ae039), {
                req: this.props.req,
                opening: this.state.opening
            });
        this.state = {};
        this.getNewOpening();
    }
    getNewOpening() {
        this.props.req.request((0, $3ed4c97548491c68$export$605846925e53c7e7))('minimal/silica/opening', 'GET').then((opening)=>this.setState({
                opening: opening
            })).catch((failure)=>console.warn('Failed to fetch minimal opening.', failure));
    }
    componentDidUpdate(prevProps, _prevState) {
        // keep minimal opening up to date
        if (prevProps.req !== this.props.req) this.getNewOpening();
    }
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * Building Templates and getting information about them.
 *
 * @since 0.4.0
 */ 
/**
 * Templates for simplified interaction with any model.
 *
 * @since 0.1.0
 */ 
/**
 * Options on Templates.
 *
 * @since 0.1.0
 */ 
/**
 * Language and Translation support.
 *
 * @since 0.1.0
 */ 
const $a968eea762bc3488$var$trans = {
    eng: (0, $87701c398fec8638$export$22b082955e083ec3),
    cmn: (0, $87701c398fec8638$export$22b082955e083ec3)
};
const $a968eea762bc3488$export$ce4fe1c9e6520c1a = (0, $87701c398fec8638$export$7e1278799275f68e)($a968eea762bc3488$var$trans);
const $a968eea762bc3488$export$1f12680e68c5100d = (0, $87701c398fec8638$export$e45945969df8035a)($a968eea762bc3488$var$trans);


/**
 * Dependencies on selected `Entry`s of `Option`s.
 *
 * @since 0.4.0
 */ 

const $b0dad51325a37f96$export$fbbf45eff21470e3 = (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    (0, $8af43a568842d8c3$export$d8deaab87a4e223a)((0, $87701c398fec8638$export$22b082955e083ec3)),
    (0, $87701c398fec8638$export$1db45310990710a5)
]));
const $b0dad51325a37f96$export$8caee5e3bee8beba = (isSelected)=>(dep)=>Object.entries(dep).every(([opt, ents])=>ents === undefined || ents.find(isSelected(opt)) !== undefined);


const $61579f0751ad4904$export$36d18380658d5d20 = (codecT, codecS)=>(0, $87701c398fec8638$export$bc86dfbf7795668c)([
        (0, $87701c398fec8638$export$e45945969df8035a)({
            Collate: (0, $87701c398fec8638$export$22b082955e083ec3),
            Rank: (0, $87701c398fec8638$export$98e628dec113755e)
        }),
        (0, $87701c398fec8638$export$bf9fb029d174d554)({
            Depends: (0, $b0dad51325a37f96$export$fbbf45eff21470e3),
            Label: codecS,
            Names: (0, $a968eea762bc3488$export$1f12680e68c5100d),
            Range: (0, $87701c398fec8638$export$2f23118c22fb2630)($61579f0751ad4904$export$3bb977b3ba9d3b59(codecT)),
            Value: codecT
        })
    ]);
const $61579f0751ad4904$export$3bb977b3ba9d3b59 = (codecT)=>(0, $87701c398fec8638$export$bc86dfbf7795668c)([
        (0, $87701c398fec8638$export$bf9fb029d174d554)({
            Label: codecT,
            Image: (0, $87701c398fec8638$export$22b082955e083ec3),
            Names: (0, $a968eea762bc3488$export$1f12680e68c5100d),
            Value: (0, $87701c398fec8638$export$19282c40b967aec6)
        }),
        (0, $87701c398fec8638$export$e45945969df8035a)({
            Rank: (0, $87701c398fec8638$export$98e628dec113755e)
        })
    ]);


/**
 * Variable contexts in templates.
 *
 * @since 0.1.0
 */ 



const $d92db2d2d4e06f06$export$c867a5c9595a1350 = (codecT)=>(0, $87701c398fec8638$export$bc86dfbf7795668c)([
        (0, $87701c398fec8638$export$e45945969df8035a)({
            Collate: (0, $87701c398fec8638$export$22b082955e083ec3),
            Rank: (0, $87701c398fec8638$export$98e628dec113755e)
        }),
        (0, $87701c398fec8638$export$bf9fb029d174d554)({
            Depends: (0, $b0dad51325a37f96$export$fbbf45eff21470e3),
            Label: codecT,
            Names: (0, $a968eea762bc3488$export$1f12680e68c5100d),
            Range: $d92db2d2d4e06f06$export$9a58ef0d7ad3278c,
            Value: (0, $87701c398fec8638$export$98e628dec113755e)
        })
    ]);
const $d92db2d2d4e06f06$export$adb7e19bd67fc44b = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Range'),
    Min: (0, $87701c398fec8638$export$98e628dec113755e),
    Max: (0, $87701c398fec8638$export$98e628dec113755e),
    Step: (0, $87701c398fec8638$export$98e628dec113755e)
});
const $d92db2d2d4e06f06$export$34cb5241245008dd = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Set'),
    Set: (0, $8af43a568842d8c3$export$d8deaab87a4e223a)((0, $87701c398fec8638$export$98e628dec113755e))
});
const $d92db2d2d4e06f06$export$9a58ef0d7ad3278c = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    $d92db2d2d4e06f06$export$adb7e19bd67fc44b,
    $d92db2d2d4e06f06$export$34cb5241245008dd
]);




const $3ce5c81126ed634f$export$eb2fcfdbd7ba97d4 = (codecT)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        Fold: (0, $87701c398fec8638$export$4a21f16c33752377),
        Items: (0, $87701c398fec8638$export$2f23118c22fb2630)(codecT),
        Label: (0, $87701c398fec8638$export$22b082955e083ec3),
        Names: (0, $a968eea762bc3488$export$1f12680e68c5100d)
    });
const $3ce5c81126ed634f$var$ItemTypes = {
    Opt: true,
    Var: true
};
const $3ce5c81126ed634f$export$8f6b088d8af509cb = (ps)=>ps.type === 'Opt';
const $3ce5c81126ed634f$export$6d08773d2e66f8f2 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$7e1278799275f68e)($3ce5c81126ed634f$var$ItemTypes),
    Label: (0, $87701c398fec8638$export$22b082955e083ec3)
});




const $6689c5083829c982$export$36d18380658d5d20 = (0, $61579f0751ad4904$export$36d18380658d5d20)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $87701c398fec8638$export$22b082955e083ec3));
const $6689c5083829c982$export$c867a5c9595a1350 = (0, $d92db2d2d4e06f06$export$c867a5c9595a1350)((0, $87701c398fec8638$export$22b082955e083ec3));
const $6689c5083829c982$export$eb2fcfdbd7ba97d4 = (0, $3ce5c81126ed634f$export$eb2fcfdbd7ba97d4)((0, $3ce5c81126ed634f$export$6d08773d2e66f8f2));
const $6689c5083829c982$export$14416b8d99d47caa = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $24396fcf7207086e$export$96ebffb07897cd9c)('Templated'),
    Data: (0, $87701c398fec8638$export$19282c40b967aec6),
    Id: (0, $87701c398fec8638$export$22b082955e083ec3),
    Names: (0, $a968eea762bc3488$export$1f12680e68c5100d),
    Opts: (0, $87701c398fec8638$export$2f23118c22fb2630)($6689c5083829c982$export$36d18380658d5d20),
    Vars: (0, $87701c398fec8638$export$2f23118c22fb2630)($6689c5083829c982$export$c867a5c9595a1350),
    Groups: (0, $87701c398fec8638$export$2f23118c22fb2630)($6689c5083829c982$export$eb2fcfdbd7ba97d4)
});
const $6689c5083829c982$export$34f8187f64e206fc = (t)=>({
        key: t.Id,
        names: t.Names
    });


const $d807307be9b2068b$export$8837f4fc672e936d = (req)=>(mode)=>req.request((0, $87701c398fec8638$export$2f23118c22fb2630)((0, $6689c5083829c982$export$14416b8d99d47caa)))(`template/list${mode === undefined ? '' : '/' + mode}`, 'GET');


var $2daa5edab02aa632$export$ce69bd05624d0c48;
$2daa5edab02aa632$export$ce69bd05624d0c48 = `SmhLea_template`;




var $ayMG0 = parcelRequire("ayMG0");
/**
 * TemplateViewer.
 *
 * Front-end related template drawings.
 *
 * @since 0.4.0
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * Building Templates and getting information about them.
 *
 * @since 0.4.0
 */ 


/**
 * Retail Prices
 *
 * @since 0.4.0
 */ 
const $286b2f47b4833d97$export$4ccb4651fc0a59cb = (0, $87701c398fec8638$export$bc86dfbf7795668c)([
    (0, $87701c398fec8638$export$e45945969df8035a)({
        RetailPrice: (0, $87701c398fec8638$export$22b082955e083ec3),
        Discount: (0, $87701c398fec8638$export$98e628dec113755e)
    }),
    (0, $87701c398fec8638$export$bf9fb029d174d554)({
        TotalPrice: (0, $87701c398fec8638$export$22b082955e083ec3)
    })
]);



/**
 * Drawings
 *
 * @since 0.4.0
 */ 
const $66b022cba2882e0a$export$93514d28bd18d75a = (0, $87701c398fec8638$export$7e1278799275f68e)({
    svg: true,
    png: true,
    dxf: true,
    pdf: true
});
const $66b022cba2882e0a$export$6c98c30b3a286440 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Format: $66b022cba2882e0a$export$93514d28bd18d75a,
    Data: (0, $87701c398fec8638$export$22b082955e083ec3)
});
const $66b022cba2882e0a$export$f156a189c8056443 = {
    Format: 'svg',
    Data: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="512" height="512"><text x="512" y="512">Missing</text></svg>'
};


/**
 * Lightweight optics with memoization.
 */ 
const $78df2dbbf84a78b3$export$c983f826f44ff86 = (x)=>(_)=>x;
function $78df2dbbf84a78b3$export$a4627e546088548d(...fs) {
    return (0, $d9f4ffa0bf773b73$export$7c73462e0d25e514)($78df2dbbf84a78b3$export$a4627e546088548d, fs, ()=>(x)=>fs.reduce((a, f)=>f(a), x));
}
function $78df2dbbf84a78b3$export$da72aebfdbddbf65(...fs) {
    return (0, $d9f4ffa0bf773b73$export$7c73462e0d25e514)($78df2dbbf84a78b3$export$da72aebfdbddbf65, fs, ()=>(x)=>fs.reduce((a, f)=>f(a), x));
}
function $78df2dbbf84a78b3$export$4a2befb31d1f42b(...fs) {
    return (0, $d9f4ffa0bf773b73$export$6e68fd820909a51e)($78df2dbbf84a78b3$export$4a2befb31d1f42b, fs, ()=>(x)=>fs.reduce((a, f)=>{
                const b = f(a);
                console.warn(f, a, b);
                return b;
            }, x));
}
function $78df2dbbf84a78b3$export$1af3c925c49f37a2(...fs) {
    return (0, $d9f4ffa0bf773b73$export$7c73462e0d25e514)($78df2dbbf84a78b3$export$1af3c925c49f37a2, fs, ()=>(x)=>fs.reduceRight((a, f)=>f(a), x));
}
function $78df2dbbf84a78b3$export$6570330dfbd8b98c(...fs) {
    return (0, $d9f4ffa0bf773b73$export$7c73462e0d25e514)($78df2dbbf84a78b3$export$6570330dfbd8b98c, fs, ()=>(x)=>fs.reduceRight((a, f)=>f(a), x));
}
function $78df2dbbf84a78b3$export$994c302d5a30cdab(...fs) {
    return (0, $d9f4ffa0bf773b73$export$6e68fd820909a51e)($78df2dbbf84a78b3$export$994c302d5a30cdab, fs, ()=>(x)=>fs.reduceRight((a, f)=>{
                const b = f(a);
                console.warn(f, a, b);
                return b;
            }, x));
} /* eslint-enable @typescript-eslint/no-explicit-any */ 



const $58f80d7b57eba59b$export$94132a0e348806d4 = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((key)=>(f)=>(x)=>{
            const oldv = x[key];
            const v = f(oldv);
            return v === oldv ? x : Object.assign({}, x, {
                [key]: v
            });
        });
const $58f80d7b57eba59b$export$b17a4b0e65bc778c = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((key)=>(f)=>(x)=>{
            const oldv = x[key];
            const v = f(oldv);
            return v === oldv ? x : Object.assign({}, x, {
                [key]: v
            });
        });
const $58f80d7b57eba59b$export$7061c75fc5af8b7e = (k)=>(f)=>(m)=>{
            const nv = f(m.get(k));
            if (!nv || nv === m.get(k)) return m;
            const nm = new Map(m);
            nm.set(k, nv);
            return nm;
        };
const $58f80d7b57eba59b$export$b610b8812bbcded9 = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((i)=>(f)=>(xs)=>{
            // we check the length instead of the value because A could extend undefined.
            if (xs.length <= i) return xs;
            const oldv = xs[i];
            const v = f(oldv);
            if (v === oldv) return xs;
            const ys = xs.slice();
            ys[i] = v;
            return ys;
        });
const $58f80d7b57eba59b$export$79b2f7037acddd43 = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((predicate)=>(f)=>(xs)=>{
            let diff = false;
            const ys = xs.map((x)=>{
                if (!predicate(x)) return x;
                const y = f(x);
                if (y !== x) {
                    diff = true;
                    return y;
                }
                return x;
            });
            return diff ? ys : xs;
        });
const $58f80d7b57eba59b$export$7ecc1a3b11b57dab = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((f)=>(xs)=>{
        let diff = false;
        const ys = xs.map((x)=>{
            const y = f(x);
            if (y !== x) {
                diff = true;
                return y;
            }
            return x;
        });
        return diff ? ys : xs;
    });
const $58f80d7b57eba59b$export$9c59b80dda569a6e = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((t)=>(f)=>(x)=>t(x) ? f(x) : x);
const $58f80d7b57eba59b$export$b1b145d64c7b5823 = (f)=>(x)=>{
        if (x === undefined) return x;
        const y = f(x);
        return y === x ? x : y;
    };
const $58f80d7b57eba59b$export$36faa878fcded3d7 = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((def)=>(f)=>(x)=>{
            const y = x === undefined ? def : x;
            const v = f(y);
            return v === def ? undefined : v === y ? x : v;
        });
const $58f80d7b57eba59b$export$9364064a021bcaeb = $58f80d7b57eba59b$export$36faa878fcded3d7('');
const $58f80d7b57eba59b$export$adaa4cf7ef1b65be = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((optic)=>(0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((x)=>optic((0, $78df2dbbf84a78b3$export$c983f826f44ff86)(x))));
const $58f80d7b57eba59b$export$3988ae62b71be9a3 = (optic)=>(x)=>{
        const ys = [];
        optic((y)=>{
            ys.push(y);
            return y;
        })(x);
        return ys;
    };
const $58f80d7b57eba59b$export$43f5536de9872e14 = (optic)=>(x)=>$58f80d7b57eba59b$export$3988ae62b71be9a3(optic)(x)[0];
const $58f80d7b57eba59b$export$f8b8b9ce72e9ccbf = (f)=>(x)=>x === undefined ? undefined : f(x);
const $58f80d7b57eba59b$export$c106dd0671a0fc2d = (f)=>(x)=>{
        const y = f(x);
        console.warn(x, 'to', y);
        return y;
    };
const $58f80d7b57eba59b$export$2b91d3689f613272 = (f)=>(a)=>a === undefined ? a : f(a);
const $58f80d7b57eba59b$export$4a65a988b6cd1e7e = (optic)=>(f)=>(t)=>{
            const nf = (a)=>{
                const na = f(a);
                return !na || na === a ? a : na;
            };
            return t === undefined ? t : optic(nf)(t);
        };






var $eVPL0 = parcelRequire("eVPL0");

const $231c8c9a18f317a9$export$f25d54de1f4102d2 = (x)=>(y)=>x + y;
const $231c8c9a18f317a9$export$4d5c9005feaec1dd = (x)=>(y)=>y - x;
const $231c8c9a18f317a9$export$4e2d2ead65e5f7e3 = (x)=>(y)=>x - y;
const $231c8c9a18f317a9$export$b5bc26e198ce73d0 = (x)=>(y)=>x * y;
const $231c8c9a18f317a9$export$3a89f8d6f6bf6c9f = (a)=>{
    const b = 1 - a;
    return (x)=>(y)=>a * x + b * y;
};



const $ff8824db188fc32d$export$7b39984cb652f36a = (f)=>(xs)=>xs.map(f);
const $ff8824db188fc32d$export$650746792cd2f81e = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((f)=>(0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((xs)=>xs.map(f)));
const $ff8824db188fc32d$export$e24e067557f99d49 = (f)=>(xs)=>(ys)=>{
            const zs = [];
            xs.forEach((x, i)=>{
                const y = ys[i];
                if (y === undefined) return;
                zs.push(f(x)(y));
            });
            return zs;
        };
const $ff8824db188fc32d$export$16baaa20b202a186 = (f, g)=>(xs)=>{
        let x = xs[0];
        if (x === undefined) return [];
        const ys = [
            f(x)
        ];
        for (const y of xs.slice(1)){
            ys.push(g(x, y));
            x = y;
        }
        return ys;
    };




var $eVPL0 = parcelRequire("eVPL0");
/**
 * Check whether an object has a property.
 */ const $11ac65d824358a4b$export$dd642ef726dcde21 = (obj, key)=>Object.bind(obj).hasOwnProperty(key);



var $3abDJ = parcelRequire("3abDJ");
const $954b786faa54682b$export$226b3eccf92c9ed9 = (isT)=>(x)=>typeof x === 'object' && x !== null && (0, $11ac65d824358a4b$export$dd642ef726dcde21)(x, 'length') && x.length === 1 && (0, $11ac65d824358a4b$export$dd642ef726dcde21)(x, '0') && isT(x[0]);
const $954b786faa54682b$export$66c1ae025e96b4bc = (xs)=>xs;
const $954b786faa54682b$export$9cd59f9826255e47 = (xs)=>[
        xs[0]
    ];
const $954b786faa54682b$export$871de8747c9eaa88 = (f)=>(o)=>[
            f(o[0])
        ];
const $954b786faa54682b$export$8901015135f2fb22 = (f)=>(xs, ys)=>[
            f(xs[0], ys[0])
        ];
const $954b786faa54682b$export$48ec4a2b1cfc6557 = (x)=>[
        x
    ];
const $954b786faa54682b$export$ad7cae49b56e2eb8 = $954b786faa54682b$export$48ec4a2b1cfc6557;
const $954b786faa54682b$export$9aa05a5866350bcf = (codecT)=>new (0, $87701c398fec8638$export$92738401e1603719)(`One<${codecT.name}>`, $954b786faa54682b$export$226b3eccf92c9ed9(codecT.is), (input, context)=>(0, $3abDJ.pipe)((0, $87701c398fec8638$export$2f23118c22fb2630)(codecT).validate(input, context), $eVPL0.chain((xs)=>$954b786faa54682b$export$eab7a3fb0b7c5d96(xs) ? (0, $87701c398fec8638$export$fe7c49d056ea1d88)(xs) : (0, $87701c398fec8638$export$af2dba6db4e9e1f0)(xs, context, `Has ${xs.length} elements.`))), (x)=>[
            codecT.encode(x[0])
        ]);
const $954b786faa54682b$export$eab7a3fb0b7c5d96 = (x)=>x.length === 1;
var $954b786faa54682b$export$2e2bcd8739ae039 = $954b786faa54682b$export$9aa05a5866350bcf;




var $eVPL0 = parcelRequire("eVPL0");


var $3abDJ = parcelRequire("3abDJ");
const $45e62f175e4efe27$export$226b3eccf92c9ed9 = (isT)=>(x)=>typeof x === 'object' && x !== null && (0, $11ac65d824358a4b$export$dd642ef726dcde21)(x, 'length') && x.length === 2 && (0, $11ac65d824358a4b$export$dd642ef726dcde21)(x, '0') && isT(x[0]) && (0, $11ac65d824358a4b$export$dd642ef726dcde21)(x, '1') && isT(x[1]);
const $45e62f175e4efe27$export$66c1ae025e96b4bc = (xs)=>xs;
const $45e62f175e4efe27$export$9cd59f9826255e47 = (xs)=>[
        xs[0],
        xs[1]
    ];
const $45e62f175e4efe27$export$871de8747c9eaa88 = (f)=>(o)=>[
            f(o[0]),
            f(o[1])
        ];
const $45e62f175e4efe27$export$8901015135f2fb22 = (f)=>(xs, ys)=>[
            f(xs[0], ys[0]),
            f(xs[1], ys[1])
        ];
const $45e62f175e4efe27$export$48ec4a2b1cfc6557 = (x)=>[
        x,
        x
    ];
const $45e62f175e4efe27$export$ad7cae49b56e2eb8 = (x)=>(y)=>[
            x,
            y
        ];
var $45e62f175e4efe27$export$2e2bcd8739ae039 = $45e62f175e4efe27$export$ad7cae49b56e2eb8;
const $45e62f175e4efe27$export$9276dd97bf62cc8d = (codecT)=>new (0, $87701c398fec8638$export$92738401e1603719)(`Two<${codecT.name}>`, $45e62f175e4efe27$export$226b3eccf92c9ed9(codecT.is), (input, context)=>(0, $3abDJ.pipe)((0, $87701c398fec8638$export$2f23118c22fb2630)(codecT).validate(input, context), $eVPL0.chain((xs)=>$45e62f175e4efe27$export$eab7a3fb0b7c5d96(xs) ? (0, $87701c398fec8638$export$fe7c49d056ea1d88)(xs) : (0, $87701c398fec8638$export$af2dba6db4e9e1f0)(xs, context, `Has ${xs.length} elements.`))), (x)=>[
            codecT.encode(x[0]),
            codecT.encode(x[1])
        ]);
const $45e62f175e4efe27$export$eab7a3fb0b7c5d96 = (x)=>x.length === 2;




var $eVPL0 = parcelRequire("eVPL0");


var $3abDJ = parcelRequire("3abDJ");
const $b921273116a71fbe$export$226b3eccf92c9ed9 = (isT)=>(x)=>typeof x === 'object' && x !== null && (0, $11ac65d824358a4b$export$dd642ef726dcde21)(x, 'length') && x.length === 2 && (0, $11ac65d824358a4b$export$dd642ef726dcde21)(x, '0') && isT(x[0]) && (0, $11ac65d824358a4b$export$dd642ef726dcde21)(x, '1') && isT(x[1]) && (0, $11ac65d824358a4b$export$dd642ef726dcde21)(x, '2') && isT(x[2]);
const $b921273116a71fbe$export$66c1ae025e96b4bc = (xs)=>xs;
const $b921273116a71fbe$export$9cd59f9826255e47 = (xs)=>[
        xs[0],
        xs[1],
        xs[2]
    ];
const $b921273116a71fbe$export$871de8747c9eaa88 = (f)=>(o)=>[
            f(o[0]),
            f(o[1]),
            f(o[2])
        ];
const $b921273116a71fbe$export$8901015135f2fb22 = (f)=>(xs, ys)=>[
            f(xs[0], ys[0]),
            f(xs[1], ys[1]),
            f(xs[2], ys[2])
        ];
const $b921273116a71fbe$export$48ec4a2b1cfc6557 = (x)=>[
        x,
        x,
        x
    ];
const $b921273116a71fbe$export$ad7cae49b56e2eb8 = (x)=>(y)=>(z)=>[
                x,
                y,
                z
            ];
var $b921273116a71fbe$export$2e2bcd8739ae039 = $b921273116a71fbe$export$ad7cae49b56e2eb8;
const $b921273116a71fbe$export$eadfa7aed248243e = (codecT)=>new (0, $87701c398fec8638$export$92738401e1603719)(`Three<${codecT.name}>`, $b921273116a71fbe$export$226b3eccf92c9ed9(codecT.is), (input, context)=>(0, $3abDJ.pipe)((0, $87701c398fec8638$export$2f23118c22fb2630)(codecT).validate(input, context), $eVPL0.chain((xs)=>$b921273116a71fbe$export$eab7a3fb0b7c5d96(xs) ? (0, $87701c398fec8638$export$fe7c49d056ea1d88)(xs) : (0, $87701c398fec8638$export$af2dba6db4e9e1f0)(xs, context, `Has ${xs.length} elements.`))), (x)=>[
            codecT.encode(x[0]),
            codecT.encode(x[1]),
            codecT.encode(x[2])
        ]);
const $b921273116a71fbe$export$eab7a3fb0b7c5d96 = (x)=>x.length === 3;



const $8724f1f29c7ffe96$export$1f447d93bf6229c9 = (codecT)=>codecT;


const $d99ec1e84f6a18d9$export$871de8747c9eaa88 = (f)=>(v)=>v.map(f);
const $d99ec1e84f6a18d9$export$8901015135f2fb22 = (f)=>(u)=>(v)=>u.map((x, i)=>f(x)(v[i]));
const $d99ec1e84f6a18d9$export$e16d8520af44a096 = $d99ec1e84f6a18d9$export$8901015135f2fb22($231c8c9a18f317a9$export$f25d54de1f4102d2);
const $d99ec1e84f6a18d9$export$f93b5905241a7cca = $d99ec1e84f6a18d9$export$8901015135f2fb22($231c8c9a18f317a9$export$4e2d2ead65e5f7e3);
const $d99ec1e84f6a18d9$export$94132a0e348806d4 = (u)=>(v)=>$d99ec1e84f6a18d9$export$8901015135f2fb22($231c8c9a18f317a9$export$b5bc26e198ce73d0)(u)(v).reduce((a, x)=>a + x, 0);
const $d99ec1e84f6a18d9$export$dcdf75081b88279d = (f)=>$d99ec1e84f6a18d9$export$871de8747c9eaa88($231c8c9a18f317a9$export$b5bc26e198ce73d0(f));
const $d99ec1e84f6a18d9$export$3a89f8d6f6bf6c9f = (x)=>$d99ec1e84f6a18d9$export$8901015135f2fb22($231c8c9a18f317a9$export$3a89f8d6f6bf6c9f(x));
const $d99ec1e84f6a18d9$export$1991ecd29cc92c6b = (xs)=>Math.sqrt($d99ec1e84f6a18d9$export$e33d8f7c086e4f6a(xs));
const $d99ec1e84f6a18d9$export$346677f925de839c = (len)=>(xs)=>$d99ec1e84f6a18d9$export$dcdf75081b88279d(len / $d99ec1e84f6a18d9$export$1991ecd29cc92c6b(xs))(xs);
const $d99ec1e84f6a18d9$export$523c0b569236b342 = $d99ec1e84f6a18d9$export$346677f925de839c(1);
const $d99ec1e84f6a18d9$export$e33d8f7c086e4f6a = (xs)=>xs.map((x)=>x * x).reduce((x, y)=>x + y, 0);
const $d99ec1e84f6a18d9$export$a213bbf7b9eeb22d = $954b786faa54682b$export$9aa05a5866350bcf((0, $87701c398fec8638$export$98e628dec113755e));
const $d99ec1e84f6a18d9$export$9b589fb896e0ad32 = $45e62f175e4efe27$export$9276dd97bf62cc8d((0, $87701c398fec8638$export$98e628dec113755e));
const $d99ec1e84f6a18d9$export$d2aa6c54a5925f01 = (0, $8724f1f29c7ffe96$export$1f447d93bf6229c9)($b921273116a71fbe$export$eadfa7aed248243e((0, $87701c398fec8638$export$98e628dec113755e)));
const $d99ec1e84f6a18d9$export$c1b3c08d1494dfd8 = (a)=>(b)=>[
            a[0] + b[0]
        ];
const $d99ec1e84f6a18d9$export$69bce51179ae0936 = (a)=>(b)=>[
            a[0] + b[0],
            a[1] + b[1]
        ];
const $d99ec1e84f6a18d9$export$6f1b619ec32f0879 = (a)=>(b)=>[
            a[0] + b[0],
            a[1] + b[1],
            a[2] + b[2]
        ];
const $d99ec1e84f6a18d9$export$c23cfeb816a8931e = (a)=>(b)=>[
            a[0] - b[0]
        ];
const $d99ec1e84f6a18d9$export$48a1a72d306481ef = (a)=>(b)=>[
            a[0] - b[0],
            a[1] - b[1]
        ];
const $d99ec1e84f6a18d9$export$822b7f4b95700b41 = (a)=>(b)=>[
            a[0] - b[0],
            a[1] - b[1],
            a[2] - b[2]
        ];
const $d99ec1e84f6a18d9$export$348a0786643311f = (x)=>(b)=>[
            x * b[0],
            x * b[1]
        ];
const $d99ec1e84f6a18d9$export$b4edfc09ac3c70aa = (f)=>(a)=>[
            f(a[0]),
            f(a[1]),
            f(a[2])
        ];
const $d99ec1e84f6a18d9$export$3dd9236ec152241 = (v1)=>[
        v1[0],
        0
    ];
const $d99ec1e84f6a18d9$export$2988c86c9fbad3d = (v1)=>[
        v1[0],
        0,
        0
    ];
const $d99ec1e84f6a18d9$export$5733eb2c17cb8d8c = (v2)=>[
        v2[0],
        0,
        v2[1]
    ];
const $d99ec1e84f6a18d9$export$9da38d06ceaaa3a0 = (v3)=>[
        v3[0],
        -v3[2]
    ];
const $d99ec1e84f6a18d9$export$3d6c154e5d232701 = (m)=>(v)=>[
            v[0] * m[0][0] + v[1] * m[0][1] + v[2] * m[0][2],
            v[0] * m[1][0] + v[1] * m[1][1] + v[2] * m[1][2],
            v[0] * m[2][0] + v[1] * m[2][1] + v[2] * m[2][2]
        ];
const $d99ec1e84f6a18d9$export$5ff1b69c67bdf722 = (a)=>(v)=>[
            v[0] * Math.cos(a) - v[1] * Math.sin(a),
            v[0] * Math.sin(a) + v[1] * Math.cos(a)
        ];
const $d99ec1e84f6a18d9$export$c5a8af68922f87d7 = (a)=>(v)=>[
            v[0] * $0afff5a8d5fc1877$export$50d414a77b60d802(a) - v[2] * $0afff5a8d5fc1877$export$5de3937cb4b592ed(a),
            v[1],
            v[0] * $0afff5a8d5fc1877$export$5de3937cb4b592ed(a) + v[2] * $0afff5a8d5fc1877$export$50d414a77b60d802(a)
        ];
const $d99ec1e84f6a18d9$export$fdba22b8ad836e3a = (a)=>(v)=>[
            v[0] * $0afff5a8d5fc1877$export$50d414a77b60d802(a) - v[1] * $0afff5a8d5fc1877$export$5de3937cb4b592ed(a),
            v[0] * $0afff5a8d5fc1877$export$5de3937cb4b592ed(a) + v[1] * $0afff5a8d5fc1877$export$50d414a77b60d802(a),
            v[2]
        ];
const $d99ec1e84f6a18d9$export$523fccffbb023eac = (a)=>(v)=>$d99ec1e84f6a18d9$export$fdba22b8ad836e3a(a)($d99ec1e84f6a18d9$export$5733eb2c17cb8d8c(v));
const $d99ec1e84f6a18d9$export$7ed3823ccd6026c4 = (v)=>[
        -v[1],
        v[0]
    ];
const $d99ec1e84f6a18d9$export$b5f64d0f15dfa393 = (v1)=>(v2)=>v1[0] * v2[1] - v1[1] * v2[0];
const $d99ec1e84f6a18d9$export$d86cdf75d7fb74e5 = (u)=>(v)=>$d99ec1e84f6a18d9$export$94132a0e348806d4(u)(v) / $d99ec1e84f6a18d9$export$e33d8f7c086e4f6a(v);
const $d99ec1e84f6a18d9$export$ab03b6763ed7026f = (u)=>(v)=>$d99ec1e84f6a18d9$export$dcdf75081b88279d($d99ec1e84f6a18d9$export$d86cdf75d7fb74e5(u)(v))(v);
const $d99ec1e84f6a18d9$export$96ec731ed4dcb222 = (a)=>(b)=>(0, $ff8824db188fc32d$export$e24e067557f99d49)((aa)=>(bb)=>Math.min(aa, bb))(a)(b);
const $d99ec1e84f6a18d9$export$8960430cfd85939f = (a)=>(b)=>(0, $ff8824db188fc32d$export$e24e067557f99d49)((aa)=>(bb)=>Math.max(aa, bb))(a)(b);
const $d99ec1e84f6a18d9$export$dbc627e74321aa3f = (a)=>(b)=>Math.acos(Math.min(1, Math.max(-1, $d99ec1e84f6a18d9$export$94132a0e348806d4($d99ec1e84f6a18d9$export$523c0b569236b342(a))($d99ec1e84f6a18d9$export$523c0b569236b342(b)))));
const $d99ec1e84f6a18d9$export$cf862fb5b27a736a = (vec)=>{
    const newV = [
        ...vec
    ];
    newV[0] = -vec[0];
    return newV;
};
const $d99ec1e84f6a18d9$export$77d8f16ce66da092 = (vec)=>{
    if (!vec[1]) return vec;
    const newV = [
        ...vec
    ];
    newV[1] = -vec[1];
    return newV;
};
const $d99ec1e84f6a18d9$export$630c4b95cb7b7170 = (vec)=>{
    if (!vec[2]) return vec;
    const newV = [
        ...vec
    ];
    newV[2] = -vec[2];
    return newV;
};



var $9I22g = parcelRequire("9I22g");
const $ec695bb278cff147$export$ffb5f4729a158638 = (x)=>x;
const $ec695bb278cff147$export$56c0d5a1e737357d = (codecT)=>new (0, $87701c398fec8638$export$92738401e1603719)(`P<${codecT.name}>`, (x)=>codecT.is(x), (input, context)=>$eVPL0.map($ec695bb278cff147$export$ad7cae49b56e2eb8)(codecT.validate(input, context)), (x)=>codecT.encode(x));
const $ec695bb278cff147$export$ad7cae49b56e2eb8 = $ec695bb278cff147$export$ffb5f4729a158638;
const $ec695bb278cff147$export$eb1a26e88fa939fd = (p)=>p;
const $ec695bb278cff147$export$e16d8520af44a096 = (p)=>(v)=>$d99ec1e84f6a18d9$export$e16d8520af44a096(p)(v);
const $ec695bb278cff147$export$f93b5905241a7cca = (p)=>(q)=>$d99ec1e84f6a18d9$export$f93b5905241a7cca(p)(q);
const $ec695bb278cff147$export$a61423b330c3444c = (...pts)=>$d99ec1e84f6a18d9$export$dcdf75081b88279d(1 / pts.length)(pts.reduce((acc, val)=>$d99ec1e84f6a18d9$export$e16d8520af44a096(acc)(val)));
const $ec695bb278cff147$export$e0f232dd469378a8 = (p)=>(q)=>$d99ec1e84f6a18d9$export$f93b5905241a7cca(p)(q);
const $ec695bb278cff147$export$3a89f8d6f6bf6c9f = (x)=>(p)=>(q)=>$d99ec1e84f6a18d9$export$3a89f8d6f6bf6c9f(x)(p)(q);
const $ec695bb278cff147$export$e8805feb671eaec0 = $ec695bb278cff147$export$56c0d5a1e737357d((0, $d99ec1e84f6a18d9$export$a213bbf7b9eeb22d));
const $ec695bb278cff147$export$d427e17c6d064ec6 = $ec695bb278cff147$export$56c0d5a1e737357d((0, $d99ec1e84f6a18d9$export$9b589fb896e0ad32));
const $ec695bb278cff147$export$e81d4063aa06b4a6 = $ec695bb278cff147$export$56c0d5a1e737357d((0, $d99ec1e84f6a18d9$export$d2aa6c54a5925f01));
const $ec695bb278cff147$export$fec56b2bbfce77de = (p, v)=>[
        p[0] + v[0],
        p[1] + v[1],
        p[2] + v[2]
    ];
const $ec695bb278cff147$export$9a06b01edbcd7427 = (p, q)=>[
        q[0] - p[0],
        q[1] - p[1],
        q[2] - p[2]
    ];
const $ec695bb278cff147$export$d838837eb5b184e3 = $ec695bb278cff147$export$fec56b2bbfce77de;
const $ec695bb278cff147$export$c37887aed78fe469 = [
    [
        Math.sqrt(0.5),
        -Math.sqrt(0.5),
        0
    ],
    [
        Math.sqrt(1 / 6),
        Math.sqrt(1 / 6),
        Math.sqrt(2 / 3)
    ],
    [
        Math.sqrt(1 / 3),
        Math.sqrt(1 / 3),
        -Math.sqrt(1 / 3)
    ]
];
const $ec695bb278cff147$export$871de8747c9eaa88 = (f)=>(p)=>f(p);
const $ec695bb278cff147$export$3d6c154e5d232701 = (m)=>$ec695bb278cff147$export$871de8747c9eaa88($d99ec1e84f6a18d9$export$3d6c154e5d232701(m));
const $ec695bb278cff147$export$ed3c46b298d70a83 = $ec695bb278cff147$export$3d6c154e5d232701($ec695bb278cff147$export$c37887aed78fe469);
const $ec695bb278cff147$export$9da38d06ceaaa3a0 = $ec695bb278cff147$export$871de8747c9eaa88($d99ec1e84f6a18d9$export$9da38d06ceaaa3a0);
const $ec695bb278cff147$export$5733eb2c17cb8d8c = $ec695bb278cff147$export$871de8747c9eaa88($d99ec1e84f6a18d9$export$5733eb2c17cb8d8c);
const $ec695bb278cff147$export$439a0dd13abe328d = (p)=>$ec695bb278cff147$export$9da38d06ceaaa3a0($ec695bb278cff147$export$ed3c46b298d70a83(p));
const $ec695bb278cff147$export$d71917a79103c107 = (a)=>(b)=>$d99ec1e84f6a18d9$export$e33d8f7c086e4f6a($ec695bb278cff147$export$f93b5905241a7cca(a)(b)) >= 0.000001;
const $ec695bb278cff147$export$bf67010aacbe66fa = (pts)=>pts.reduce(([minP, maxP], pnt)=>[
            $ec695bb278cff147$export$ffb5f4729a158638($d99ec1e84f6a18d9$export$96ec731ed4dcb222(minP)(pnt)),
            $ec695bb278cff147$export$ffb5f4729a158638($d99ec1e84f6a18d9$export$8960430cfd85939f(maxP)(pnt))
        ], [
        (0, $9I22g.head)(pts),
        (0, $9I22g.head)(pts)
    ]);







var $eVPL0 = parcelRequire("eVPL0");


var $3abDJ = parcelRequire("3abDJ");
const $f0e9ad8a586d486f$export$226b3eccf92c9ed9 = (isT)=>(x)=>typeof x === 'object' && x !== null && (0, $11ac65d824358a4b$export$dd642ef726dcde21)(x, 'length') && x.length === 2 && (0, $11ac65d824358a4b$export$dd642ef726dcde21)(x, '0') && isT(x[0]) && (0, $11ac65d824358a4b$export$dd642ef726dcde21)(x, '1') && isT(x[1]) && (0, $11ac65d824358a4b$export$dd642ef726dcde21)(x, '2') && isT(x[2]);
const $f0e9ad8a586d486f$export$66c1ae025e96b4bc = (xs)=>xs;
const $f0e9ad8a586d486f$export$9cd59f9826255e47 = (xs)=>[
        xs[0],
        xs[1],
        xs[2],
        xs[3]
    ];
const $f0e9ad8a586d486f$export$871de8747c9eaa88 = (f)=>(o)=>[
            f(o[0]),
            f(o[1]),
            f(o[2]),
            f(o[3])
        ];
const $f0e9ad8a586d486f$export$8901015135f2fb22 = (f)=>(xs, ys)=>[
            f(xs[0], ys[0]),
            f(xs[1], ys[1]),
            f(xs[2], ys[2]),
            f(xs[3], ys[3])
        ];
const $f0e9ad8a586d486f$export$48ec4a2b1cfc6557 = (x)=>[
        x,
        x,
        x,
        x
    ];
const $f0e9ad8a586d486f$export$ad7cae49b56e2eb8 = (w)=>(x)=>(y)=>(z)=>[
                    w,
                    x,
                    y,
                    z
                ];
var $f0e9ad8a586d486f$export$2e2bcd8739ae039 = $f0e9ad8a586d486f$export$ad7cae49b56e2eb8;
const $f0e9ad8a586d486f$export$ef0fa97514d9ab6e = (codecT)=>new (0, $87701c398fec8638$export$92738401e1603719)(`Four<${codecT.name}>`, $f0e9ad8a586d486f$export$226b3eccf92c9ed9(codecT.is), (input, context)=>(0, $3abDJ.pipe)((0, $87701c398fec8638$export$2f23118c22fb2630)(codecT).validate(input, context), $eVPL0.chain((xs)=>$f0e9ad8a586d486f$export$eab7a3fb0b7c5d96(xs) ? (0, $87701c398fec8638$export$fe7c49d056ea1d88)(xs) : (0, $87701c398fec8638$export$af2dba6db4e9e1f0)(xs, context, `Has ${xs.length} elements.`))), (x)=>[
            codecT.encode(x[0]),
            codecT.encode(x[1]),
            codecT.encode(x[2]),
            codecT.encode(x[3])
        ]);
const $f0e9ad8a586d486f$export$eab7a3fb0b7c5d96 = (x)=>x.length === 4;








const $dc04001260b223cb$export$13475bbd2a37a9b4 = (codecT)=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        $dc04001260b223cb$export$e49f7ffb825345a5(codecT),
        $dc04001260b223cb$export$23c7a12b0e0a6a7f(codecT)
    ]);
const $dc04001260b223cb$export$f0b4c4e183a702bc = (p)=>(seg)=>$dc04001260b223cb$export$4e59ee69b49e5f3(seg) ? $dc04001260b223cb$export$4957fa329f1abee4(p)(seg) : $dc04001260b223cb$export$38a987e52587c0e5(p)(seg);
const $dc04001260b223cb$export$4957fa329f1abee4 = (p)=>(seg)=>(0, $ec695bb278cff147$export$3a89f8d6f6bf6c9f)(p)(seg[1])(seg[0]);
const $dc04001260b223cb$export$38a987e52587c0e5 = (p)=>(seg)=>$dc04001260b223cb$export$fde8cef2e3203d58(p)(seg)[1][0];
const $dc04001260b223cb$export$b89fb645b0c50a76 = (p)=>(seg)=>$dc04001260b223cb$export$4e59ee69b49e5f3(seg) ? $dc04001260b223cb$export$75d8f38528aed967(p)(seg) : $dc04001260b223cb$export$fde8cef2e3203d58(p)(seg);
const $dc04001260b223cb$export$75d8f38528aed967 = (p)=>(seg)=>{
        const mid = (0, $ec695bb278cff147$export$3a89f8d6f6bf6c9f)(p)(seg[1])(seg[0]);
        return [
            [
                seg[0],
                mid
            ],
            [
                mid,
                seg[1]
            ]
        ];
    };
const $dc04001260b223cb$export$fde8cef2e3203d58 = (p)=>(seg)=>{
        const lp = (0, $ec695bb278cff147$export$3a89f8d6f6bf6c9f)(p);
        const a = lp(seg[1])(seg[0]);
        const o = lp(seg[2])(seg[1]);
        const d = lp(seg[3])(seg[2]);
        const b = lp(o)(a);
        const c = lp(d)(o);
        const r = lp(c)(b);
        return [
            [
                seg[0],
                a,
                b,
                r
            ],
            [
                r,
                c,
                d,
                seg[3]
            ]
        ];
    };
const $dc04001260b223cb$export$51186ad6e864892a = (f)=>(seg)=>$dc04001260b223cb$export$4e59ee69b49e5f3(seg) ? $dc04001260b223cb$export$efd5820fe5568a63(f)(seg) : $dc04001260b223cb$export$c5119673eec24940(f)(seg);
const $dc04001260b223cb$export$b2b14c8e7dc8913b = (seg)=>$dc04001260b223cb$export$4e59ee69b49e5f3(seg) ? seg[1] : seg[3];
const $dc04001260b223cb$export$4e59ee69b49e5f3 = (seg)=>seg.length === 2;
const $dc04001260b223cb$export$e49f7ffb825345a5 = (codecT)=>(0, $45e62f175e4efe27$export$9276dd97bf62cc8d)((0, $ec695bb278cff147$export$56c0d5a1e737357d)(codecT));
const $dc04001260b223cb$export$efd5820fe5568a63 = (f)=>(seg)=>[
            f(seg[0]),
            f(seg[1])
        ];
const $dc04001260b223cb$export$23c7a12b0e0a6a7f = (codecT)=>(0, $f0e9ad8a586d486f$export$ef0fa97514d9ab6e)((0, $ec695bb278cff147$export$56c0d5a1e737357d)(codecT));
const $dc04001260b223cb$export$c5119673eec24940 = (f)=>(seg)=>[
            f(seg[0]),
            f(seg[1]),
            f(seg[2]),
            f(seg[3])
        ];
const $dc04001260b223cb$export$dcc6bb13a3cbcdeb = (seg)=>seg.length === 1;
const $dc04001260b223cb$export$ced784817d9a4f97 = (v)=>[
        v
    ];
const $dc04001260b223cb$export$bdd5293f3cf7a909 = (c0, c1, v)=>[
        c0,
        c1,
        v
    ];
const $dc04001260b223cb$export$59f11a42dee7ad13 = (f)=>(seg)=>[
            f(seg[0])
        ];
const $dc04001260b223cb$export$124dafb1a1942d2d = (f)=>(seg)=>[
            f(seg[0]),
            f(seg[1]),
            f(seg[2])
        ];
const $dc04001260b223cb$export$ab03b6763ed7026f = (f)=>(seg)=>$dc04001260b223cb$export$dcc6bb13a3cbcdeb(seg) ? $dc04001260b223cb$export$59f11a42dee7ad13(f)(seg) : $dc04001260b223cb$export$124dafb1a1942d2d(f)(seg);
const $dc04001260b223cb$export$ea7460d1d5e99d88 = (p, seg)=>[
        p,
        (0, $ec695bb278cff147$export$fec56b2bbfce77de)(p, seg[0])
    ];
const $dc04001260b223cb$export$3eb356996b49c3cf = (p, seg)=>[
        p,
        (0, $ec695bb278cff147$export$fec56b2bbfce77de)(p, seg[0]),
        (0, $ec695bb278cff147$export$fec56b2bbfce77de)(p, seg[1]),
        (0, $ec695bb278cff147$export$fec56b2bbfce77de)(p, seg[2])
    ];
const $dc04001260b223cb$export$d838837eb5b184e3 = (p, seg)=>$dc04001260b223cb$export$dcc6bb13a3cbcdeb(seg) ? $dc04001260b223cb$export$ea7460d1d5e99d88(p, seg) : $dc04001260b223cb$export$3eb356996b49c3cf(p, seg);
const $dc04001260b223cb$export$f879ba6657ce48b2 = (p, segs)=>{
    const out = [
        $dc04001260b223cb$export$d838837eb5b184e3(p, segs[0])
    ];
    segs.slice(1).forEach((seg, i)=>{
        const s = out[i];
        if (s === undefined) return;
        out.push($dc04001260b223cb$export$d838837eb5b184e3(s[0], seg));
    });
    return out;
};
const $dc04001260b223cb$export$7ac27f071ff4989f = (seg)=>[
        (0, $ec695bb278cff147$export$9a06b01edbcd7427)(seg[1], seg[0])
    ];
const $dc04001260b223cb$export$6c160331ce9da079 = (seg)=>[
        (0, $ec695bb278cff147$export$9a06b01edbcd7427)(seg[1], seg[0]),
        (0, $ec695bb278cff147$export$9a06b01edbcd7427)(seg[2], seg[0]),
        (0, $ec695bb278cff147$export$9a06b01edbcd7427)(seg[3], seg[0])
    ];
const $dc04001260b223cb$export$c99b314de29d06c5 = (seg)=>$dc04001260b223cb$export$4e59ee69b49e5f3(seg) ? $dc04001260b223cb$export$7ac27f071ff4989f(seg) : $dc04001260b223cb$export$6c160331ce9da079(seg);



const $3ead2e6ff6058f21$export$b0e83c3ef8d2db1 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Id: $8af43a568842d8c3$export$d8deaab87a4e223a((0, $87701c398fec8638$export$22b082955e083ec3)),
    Class: $8af43a568842d8c3$export$d8deaab87a4e223a((0, $87701c398fec8638$export$22b082955e083ec3)),
    Info: (0, $87701c398fec8638$export$19282c40b967aec6),
    Segments: $8af43a568842d8c3$export$d8deaab87a4e223a($dc04001260b223cb$export$13475bbd2a37a9b4((0, $d99ec1e84f6a18d9$export$d2aa6c54a5925f01)))
});
const $3ead2e6ff6058f21$export$f0b4c4e183a702bc = (p)=>(c)=>{
        const scaledP = p * c.Segments.length;
        const i = Math.floor(scaledP);
        const subP = scaledP - i;
        const seg = c.Segments[i];
        if (seg === undefined) {
            if (i < 0) return $dc04001260b223cb$export$f0b4c4e183a702bc(scaledP)(c.Segments[0]);
            else return $dc04001260b223cb$export$f0b4c4e183a702bc(scaledP - c.Segments.length)($8af43a568842d8c3$export$4c7897fafd92b108(c.Segments));
        }
        return $dc04001260b223cb$export$f0b4c4e183a702bc(subP)(seg);
    };
const $3ead2e6ff6058f21$export$b89fb645b0c50a76 = (p)=>(segs)=>{
        const scaledP = p * segs.length;
        const i = Math.floor(scaledP);
        const subP = scaledP - i;
        const [bs, seg, fs] = $8af43a568842d8c3$export$f9380c9a627682d3(i)(segs);
        const [b, f] = $dc04001260b223cb$export$b89fb645b0c50a76(i < 0 ? scaledP : i >= segs.length ? scaledP - i : subP)(seg);
        return [
            $8af43a568842d8c3$export$c40cf5aab899f397(bs, b),
            [
                f,
                ...fs
            ]
        ];
    };






const $311cca378d9fa58e$export$24b3e11c74bbe5f5 = (props, def, name)=>new (0, $87701c398fec8638$export$92738401e1603719)(name ?? 'type with defaults', (u)=>{
        if (typeof u !== 'object' || u === null) return false;
        const hasProp = Object.prototype.hasOwnProperty.bind(u);
        return Object.entries(props).every(([k, v])=>hasProp(k) && v.is(u[k]));
    }, (u, context)=>{
        if (typeof u !== 'object') return (0, $87701c398fec8638$export$af2dba6db4e9e1f0)(u, context, 'Object Required');
        if (u === null) return (0, $87701c398fec8638$export$af2dba6db4e9e1f0)(u, context, 'Non-Null Required');
        const r = {};
        const hasProp = Object.prototype.hasOwnProperty.bind(u);
        for(const k in props)if (hasProp(k)) {
            const codec = props[k];
            if (!codec) return (0, $87701c398fec8638$export$af2dba6db4e9e1f0)(u, context, 'No Codec???');
            const valid = codec.validate(u[k], context);
            if (valid._tag === 'Left') return valid;
            r[k] = valid.right;
        } else r[k] = def[k];
        return (0, $87701c398fec8638$export$fe7c49d056ea1d88)(r);
    }, (x)=>{
        const r = {};
        for(const k in props){
            const codec = props[k];
            if (!codec) throw 'No Codec???';
            r[k] = codec.encode(x[k]);
        }
        return r;
    });


const $5c00e45590ca51c5$export$c3631f4566dc90f7 = (0, $87701c398fec8638$export$7e1278799275f68e)({
    RulerAcross: true,
    RulerAlong: true,
    ObjectAcross: true,
    ObjectAlong: true
});
const $5c00e45590ca51c5$export$5d24e00cfde59887 = (0, $87701c398fec8638$export$7e1278799275f68e)({
    Heavy: true,
    Solid: true,
    Dashed: true,
    Dotted: true
});
const $5c00e45590ca51c5$export$8afb76124cf08683 = {
    Visible: true,
    ShowBar: true,
    BarStyle: 'Dashed',
    ShowWhisker: true,
    ExtendWhisker: false,
    WhiskerStyle: 'Dotted',
    Layer: 0,
    ShowLabel: true,
    LabelLayer: 0.5,
    LabelOrient: 'RulerAlong',
    LabelPrefix: ''
};
const $5c00e45590ca51c5$export$61aed1e393f88e8e = (0, $311cca378d9fa58e$export$24b3e11c74bbe5f5)({
    Visible: (0, $87701c398fec8638$export$4a21f16c33752377),
    ShowBar: (0, $87701c398fec8638$export$4a21f16c33752377),
    BarStyle: $5c00e45590ca51c5$export$5d24e00cfde59887,
    ShowWhisker: (0, $87701c398fec8638$export$4a21f16c33752377),
    ExtendWhisker: (0, $87701c398fec8638$export$4a21f16c33752377),
    WhiskerStyle: $5c00e45590ca51c5$export$5d24e00cfde59887,
    Layer: (0, $87701c398fec8638$export$98e628dec113755e),
    ShowLabel: (0, $87701c398fec8638$export$4a21f16c33752377),
    LabelLayer: (0, $87701c398fec8638$export$98e628dec113755e),
    LabelOrient: $5c00e45590ca51c5$export$c3631f4566dc90f7,
    LabelPrefix: (0, $87701c398fec8638$export$22b082955e083ec3)
}, $5c00e45590ca51c5$export$8afb76124cf08683);
const $5c00e45590ca51c5$export$61dcc3651be14bfd = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Visible');
const $5c00e45590ca51c5$export$5878eaa9fd3bae63 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('BarStyle');
const $5c00e45590ca51c5$export$640e4747de4ee1f0 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('ExtendWhisker');
const $5c00e45590ca51c5$export$9ef531249e7db6a4 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('WhiskerStyle');
const $5c00e45590ca51c5$export$c78f2b5737b368ae = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Layer');
const $5c00e45590ca51c5$export$ca3dc64840c7f233 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('LabelLayer');
const $5c00e45590ca51c5$export$abc912d1738faea3 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('LabelOrient');






const $626d544ad2d93135$export$b759ae334551eee5 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Start: (0, $ec695bb278cff147$export$56c0d5a1e737357d)((0, $d99ec1e84f6a18d9$export$d2aa6c54a5925f01)),
    End: (0, $ec695bb278cff147$export$56c0d5a1e737357d)((0, $d99ec1e84f6a18d9$export$d2aa6c54a5925f01))
});
const $626d544ad2d93135$export$2bdfb8943b5847c9 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Start');
const $626d544ad2d93135$export$f33f6708ef035857 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('End');






const $ca3259999c4aeb4d$export$3081247862d57e3d = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Distance'),
    Left: (0, $ec695bb278cff147$export$56c0d5a1e737357d)((0, $d99ec1e84f6a18d9$export$d2aa6c54a5925f01)),
    Right: (0, $ec695bb278cff147$export$56c0d5a1e737357d)((0, $d99ec1e84f6a18d9$export$d2aa6c54a5925f01))
});
const $ca3259999c4aeb4d$export$f6ea1a71426d7411 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Angular'),
    Left: (0, $ec695bb278cff147$export$56c0d5a1e737357d)((0, $d99ec1e84f6a18d9$export$d2aa6c54a5925f01)),
    Middle: (0, $ec695bb278cff147$export$56c0d5a1e737357d)((0, $d99ec1e84f6a18d9$export$d2aa6c54a5925f01)),
    Right: (0, $ec695bb278cff147$export$56c0d5a1e737357d)((0, $d99ec1e84f6a18d9$export$d2aa6c54a5925f01))
});
const $ca3259999c4aeb4d$export$76df7375f104822f = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    $ca3259999c4aeb4d$export$3081247862d57e3d,
    $ca3259999c4aeb4d$export$f6ea1a71426d7411
]);
const $ca3259999c4aeb4d$export$8737083c298b9913 = (measure)=>measure.type === 'Distance' ? (0, $ec695bb278cff147$export$3a89f8d6f6bf6c9f)(0.5)(measure.Left)(measure.Right) : measure.Middle;
const $ca3259999c4aeb4d$export$be2ef8a3d71140ca = (scale)=>(ruler)=>{
        const dir = $ca3259999c4aeb4d$export$9fddb9d0dd7d8a54(scale)(ruler);
        const offset = $d99ec1e84f6a18d9$export$dcdf75081b88279d(ruler.Info.Layer)(dir);
        const label_offset = $d99ec1e84f6a18d9$export$dcdf75081b88279d(ruler.Info.Layer + ruler.Info.LabelLayer)(dir);
        const midpoint = $ca3259999c4aeb4d$export$8737083c298b9913(ruler.For);
        const label = (0, $ec695bb278cff147$export$e16d8520af44a096)(midpoint)(label_offset);
        const left = (0, $ec695bb278cff147$export$e16d8520af44a096)(ruler.For.Left)(offset);
        const right = (0, $ec695bb278cff147$export$e16d8520af44a096)(ruler.For.Right)(offset);
        return {
            dir: dir,
            offset: offset,
            left: left,
            right: right,
            label: label
        };
    };
const $ca3259999c4aeb4d$export$9fddb9d0dd7d8a54 = (len)=>(ruler)=>$d99ec1e84f6a18d9$export$346677f925de839c(len)((0, $ec695bb278cff147$export$f93b5905241a7cca)(ruler.Guide)(ruler.For.Left));
const $ca3259999c4aeb4d$export$72a4dbfaa588abb2 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Id: (0, $8af43a568842d8c3$export$d8deaab87a4e223a)((0, $87701c398fec8638$export$22b082955e083ec3)),
    Class: (0, $8af43a568842d8c3$export$d8deaab87a4e223a)((0, $87701c398fec8638$export$22b082955e083ec3)),
    Info: (0, $5c00e45590ca51c5$export$61aed1e393f88e8e),
    For: $ca3259999c4aeb4d$export$76df7375f104822f,
    Object: (0, $626d544ad2d93135$export$b759ae334551eee5),
    Guide: (0, $ec695bb278cff147$export$56c0d5a1e737357d)((0, $d99ec1e84f6a18d9$export$d2aa6c54a5925f01)),
    Unit: (0, $87701c398fec8638$export$22b082955e083ec3),
    Value: (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        (0, $87701c398fec8638$export$98e628dec113755e),
        (0, $87701c398fec8638$export$22b082955e083ec3)
    ])
});
const $ca3259999c4aeb4d$export$10cce82e20896ff1 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Info');






const $4ccbd5a55d027ff2$export$65cc8bc2326f8ef1 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Visible: (0, $87701c398fec8638$export$4a21f16c33752377)
});



const $4a4a37828a974efc$export$b04be29aa201d4f5 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Id: (0, $8af43a568842d8c3$export$d8deaab87a4e223a)((0, $87701c398fec8638$export$22b082955e083ec3)),
    Class: (0, $8af43a568842d8c3$export$d8deaab87a4e223a)((0, $87701c398fec8638$export$22b082955e083ec3)),
    Info: (0, $4ccbd5a55d027ff2$export$65cc8bc2326f8ef1),
    For: (0, $ec695bb278cff147$export$56c0d5a1e737357d)((0, $d99ec1e84f6a18d9$export$d2aa6c54a5925f01)),
    Guide: (0, $ec695bb278cff147$export$56c0d5a1e737357d)((0, $d99ec1e84f6a18d9$export$d2aa6c54a5925f01)),
    Text: (0, $87701c398fec8638$export$22b082955e083ec3)
});




const $7396d8de986b0ae3$export$5c065195b3c8d758 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MetaQty'),
    Qty: (0, $87701c398fec8638$export$98e628dec113755e)
});
const $7396d8de986b0ae3$export$afc9c2a21c3ba046 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MetaLength'),
    Length: (0, $87701c398fec8638$export$98e628dec113755e)
});
const $7396d8de986b0ae3$export$d70029c3ddc900a7 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MetaThickness'),
    Thickness: (0, $87701c398fec8638$export$98e628dec113755e)
});
const $7396d8de986b0ae3$export$1401e332eb6b9092 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MetaText'),
    Text: (0, $87701c398fec8638$export$22b082955e083ec3)
});
const $7396d8de986b0ae3$export$e0c5335f5e018f09 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MetaMaterial'),
    Material: (0, $87701c398fec8638$export$22b082955e083ec3),
    Thickness: (0, $87701c398fec8638$export$98e628dec113755e)
});
const $7396d8de986b0ae3$export$cb451664a802fb4a = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MetaArea'),
    Area: (0, $87701c398fec8638$export$98e628dec113755e)
});
const $7396d8de986b0ae3$export$42e4e2959638405c = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MetaWeight'),
    Weight: (0, $87701c398fec8638$export$98e628dec113755e)
});
const $7396d8de986b0ae3$export$7cf0d743c584af13 = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    $7396d8de986b0ae3$export$5c065195b3c8d758,
    $7396d8de986b0ae3$export$afc9c2a21c3ba046,
    $7396d8de986b0ae3$export$d70029c3ddc900a7,
    $7396d8de986b0ae3$export$1401e332eb6b9092,
    $7396d8de986b0ae3$export$e0c5335f5e018f09,
    $7396d8de986b0ae3$export$cb451664a802fb4a,
    $7396d8de986b0ae3$export$42e4e2959638405c
]);
const $7396d8de986b0ae3$export$ac8ec40bfe3872ab = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('RecordMetaValue'),
    Value: $7396d8de986b0ae3$export$7cf0d743c584af13
});
const $7396d8de986b0ae3$export$b1091108f3267752 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('RecordMetaValues'),
    Values: (0, $87701c398fec8638$export$2f23118c22fb2630)($7396d8de986b0ae3$export$7cf0d743c584af13)
});
const $7396d8de986b0ae3$export$67b6ea4d12a0ef1e = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    $7396d8de986b0ae3$export$ac8ec40bfe3872ab,
    $7396d8de986b0ae3$export$b1091108f3267752
]);
const $7396d8de986b0ae3$export$f98590fc2a4d625c = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Title: (0, $a968eea762bc3488$export$1f12680e68c5100d),
    Tag: (0, $87701c398fec8638$export$22b082955e083ec3),
    Value: $7396d8de986b0ae3$export$67b6ea4d12a0ef1e
});
const $7396d8de986b0ae3$export$b08a9033b36413fb = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Entries: (0, $87701c398fec8638$export$2f23118c22fb2630)((0, $87701c398fec8638$export$65e3907585753458)([
        (0, $87701c398fec8638$export$22b082955e083ec3),
        $7396d8de986b0ae3$export$f98590fc2a4d625c
    ]))
});


const $9b0caecbc3929477$export$7de691058ff51291 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Axes: (0, $f0e9ad8a586d486f$export$ef0fa97514d9ab6e)((0, $ec695bb278cff147$export$e81d4063aa06b4a6)),
    Curves: (0, $87701c398fec8638$export$2f23118c22fb2630)((0, $3ead2e6ff6058f21$export$b0e83c3ef8d2db1)),
    Rulers: (0, $87701c398fec8638$export$2f23118c22fb2630)((0, $ca3259999c4aeb4d$export$72a4dbfaa588abb2)),
    Labels: (0, $87701c398fec8638$export$2f23118c22fb2630)((0, $4a4a37828a974efc$export$b04be29aa201d4f5)),
    Meta: (0, $7396d8de986b0ae3$export$b08a9033b36413fb),
    Title: (0, $87701c398fec8638$export$22b082955e083ec3)
});
const $9b0caecbc3929477$export$83fbf29b47f8813 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Rulers');
const $9b0caecbc3929477$export$9b4037a0951a5881 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Curves');
const $9b0caecbc3929477$export$6e22c362a0406a2c = {
    Axes: [
        [
            1,
            0,
            0
        ],
        [
            0,
            1,
            0
        ],
        [
            0,
            0,
            1
        ],
        [
            0,
            0,
            0
        ]
    ],
    Curves: [],
    Rulers: [],
    Labels: [],
    Meta: {
        Entries: []
    },
    Title: ''
};
const $9b0caecbc3929477$export$9f048bf86ee2e9d2 = (piece)=>piece.Curves.map((curve)=>curve.Segments).flat(2);




const $94b6e9ffd299ce77$export$8afb76124cf08683 = {
    pan: [
        0,
        0
    ],
    zoom: 1
};



const $6dc4c4b5427dac73$export$820c702ddd5a7343 = (0, $87701c398fec8638$export$bc86dfbf7795668c)([
    (0, $87701c398fec8638$export$e45945969df8035a)({
        Kind: (0, $87701c398fec8638$export$22b082955e083ec3)
    }),
    (0, $87701c398fec8638$export$bf9fb029d174d554)({
        Pieces: $8af43a568842d8c3$export$d8deaab87a4e223a($9b0caecbc3929477$export$7de691058ff51291)
    })
]);
const $6dc4c4b5427dac73$export$1e284623f7aabd9b = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Pieces');
const $6dc4c4b5427dac73$export$6e22c362a0406a2c = {
    Pieces: [
        $9b0caecbc3929477$export$6e22c362a0406a2c
    ]
};
const $6dc4c4b5427dac73$export$9f048bf86ee2e9d2 = (figure)=>figure.Pieces.map($9b0caecbc3929477$export$9f048bf86ee2e9d2).flat(1);
const $6dc4c4b5427dac73$export$1d3f37926d47fbdc = [
    [
        0,
        0,
        0
    ],
    [
        0,
        0,
        0
    ]
];
const $6dc4c4b5427dac73$export$bf67010aacbe66fa = (figure)=>{
    const pts = $6dc4c4b5427dac73$export$9f048bf86ee2e9d2(figure);
    return $8af43a568842d8c3$export$abae9d370f12ca88(pts) ? $ec695bb278cff147$export$bf67010aacbe66fa(pts) : $6dc4c4b5427dac73$export$1d3f37926d47fbdc;
};
const $6dc4c4b5427dac73$export$36b2803fc594e30e = (piece)=>{
    const pts = $9b0caecbc3929477$export$9f048bf86ee2e9d2(piece);
    return $8af43a568842d8c3$export$abae9d370f12ca88(pts) ? $ec695bb278cff147$export$bf67010aacbe66fa(pts) : $6dc4c4b5427dac73$export$1d3f37926d47fbdc;
};
const $6dc4c4b5427dac73$export$1e044b7877db048c = (proj, fontsize, box)=>(figure)=>{
        const maxLayer = (0, $58f80d7b57eba59b$export$3988ae62b71be9a3)((0, $78df2dbbf84a78b3$export$a4627e546088548d)((0, $58f80d7b57eba59b$export$7ecc1a3b11b57dab), $9b0caecbc3929477$export$83fbf29b47f8813, (0, $58f80d7b57eba59b$export$7ecc1a3b11b57dab), $6dc4c4b5427dac73$export$1e284623f7aabd9b))(figure).map((ruler)=>ruler.Info.LabelLayer + ruler.Info.Layer).reduce((x, a)=>Math.max(x, a), 0);
        const padding = (0, $45e62f175e4efe27$export$48ec4a2b1cfc6557)(2 * fontsize * maxLayer);
        const innerBox = (0, $d99ec1e84f6a18d9$export$f93b5905241a7cca)(box)((0, $d99ec1e84f6a18d9$export$dcdf75081b88279d)(2)(padding));
        const pts = $6dc4c4b5427dac73$export$9f048bf86ee2e9d2(figure).map(proj);
        if (!$8af43a568842d8c3$export$abae9d370f12ca88(pts) || innerBox.some((a)=>a < 0)) return $94b6e9ffd299ce77$export$8afb76124cf08683;
        const bounds = $ec695bb278cff147$export$bf67010aacbe66fa(pts);
        const extent = $ec695bb278cff147$export$f93b5905241a7cca(bounds[1])(bounds[0]);
        const zoom = Math.min(innerBox[0] / extent[0], innerBox[1] / extent[1]);
        const pan = $ec695bb278cff147$export$e16d8520af44a096((0, $d99ec1e84f6a18d9$export$dcdf75081b88279d)(-1)(bounds[0]))((0, $d99ec1e84f6a18d9$export$dcdf75081b88279d)(1 / zoom)(padding));
        return {
            pan: pan,
            zoom: zoom
        };
    };





const $520c48df756a1a3e$export$3f58fdce283c1f4c = (0, $87701c398fec8638$export$e45945969df8035a)({
    USD: (0, $87701c398fec8638$export$22b082955e083ec3),
    Call: (0, $24396fcf7207086e$export$428ef1f8ddd66578)
});
const $520c48df756a1a3e$export$62d5467e2e4a5f20 = {};
const $520c48df756a1a3e$export$a3295358bff77e = (p)=>{
    const q = {};
    if (p.USD) q.USD = p.USD.toFixed(2);
    if (p.Call) q.Call = true;
    return q;
};
const $520c48df756a1a3e$export$dcdf75081b88279d = (n, p)=>$520c48df756a1a3e$export$a3295358bff77e({
        USD: p.USD ? n * parseFloat(p.USD) : undefined,
        Call: p.Call
    });
const $520c48df756a1a3e$export$e16d8520af44a096 = (a, b)=>$520c48df756a1a3e$export$a3295358bff77e({
        USD: a.USD ? b.USD ? parseFloat(a.USD) + parseFloat(b.USD) : parseFloat(a.USD) : b.USD ? parseFloat(b.USD) : undefined,
        Call: a.Call || b.Call
    });
const $520c48df756a1a3e$export$f93b5905241a7cca = (a, b)=>$520c48df756a1a3e$export$a3295358bff77e({
        USD: a.USD ? b.USD ? parseFloat(a.USD) - parseFloat(b.USD) : parseFloat(a.USD) : b.USD ? -parseFloat(b.USD) : undefined,
        Call: a.Call || b.Call
    });
const $520c48df756a1a3e$export$8a63f25cc62965f1 = (ps)=>ps.reduce($520c48df756a1a3e$export$e16d8520af44a096, {});
const $520c48df756a1a3e$export$ff876193aa9f1 = (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    $520c48df756a1a3e$export$3f58fdce283c1f4c,
    (0, $87701c398fec8638$export$1db45310990710a5)
]));
const $520c48df756a1a3e$export$bb4975b32c2ee1cf = (pm)=>Object.values(pm).filter((x)=>x);




const $4a28b13862156517$export$ef099b3749170d5e = (c)=>$4a28b13862156517$export$c437a2069937e6c8(c) ? $4a28b13862156517$export$a0113628dbfe2651(c) : $4a28b13862156517$export$341a893b8337cbe2(c);
const $4a28b13862156517$export$c437a2069937e6c8 = (x)=>x.hasOwnProperty('Items');
const $4a28b13862156517$export$a0113628dbfe2651 = (cg)=>{
    const Items = cg.Items.map($4a28b13862156517$export$ef099b3749170d5e);
    // assume this group is correct if all its items are unchanged
    if (Items.every((v, i)=>v === cg.Items[i])) return cg;
    const Price = (0, $520c48df756a1a3e$export$8a63f25cc62965f1)(Items.map((c)=>c.Extended));
    const ci = $4a28b13862156517$export$341a893b8337cbe2(Object.assign({}, cg, {
        Unit: $4a28b13862156517$export$6ad76399625e2d35,
        Price: Price
    }));
    return Object.assign({}, ci, {
        Items: Items
    });
};
const $4a28b13862156517$export$341a893b8337cbe2 = (item)=>{
    const Extended = (0, $520c48df756a1a3e$export$dcdf75081b88279d)(item.Count, item.Price);
    const Discount = (0, $520c48df756a1a3e$export$dcdf75081b88279d)(item.Count, (0, $520c48df756a1a3e$export$8a63f25cc62965f1)((0, $520c48df756a1a3e$export$bb4975b32c2ee1cf)(item.Discounts)));
    const SubTotal = (0, $520c48df756a1a3e$export$f93b5905241a7cca)(Extended, Discount);
    const Tax = (0, $520c48df756a1a3e$export$8a63f25cc62965f1)((0, $520c48df756a1a3e$export$bb4975b32c2ee1cf)(item.Taxes));
    const Total = (0, $520c48df756a1a3e$export$e16d8520af44a096)(SubTotal, Tax);
    // avoid allocating a new item if everything is correct.
    return item.Extended == Extended && item.Discount == Discount && item.SubTotal == SubTotal && item.Tax == Tax && item.Total == Total ? item : Object.assign({}, item, {
        Extended: Extended,
        Discount: Discount,
        Tax: Tax,
        SubTotal: SubTotal,
        Total: Total
    });
};
const $4a28b13862156517$export$6ad76399625e2d35 = {
    Count: 1,
    Unit: 'pc'
};
const $4a28b13862156517$export$1995c2131ced269b = (0, $87701c398fec8638$export$7e1278799275f68e)({
    pc: true,
    mm: true,
    "mm\xb2": true
});
const $4a28b13862156517$export$5aa02b087893052b = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Count: (0, $87701c398fec8638$export$98e628dec113755e),
    Unit: $4a28b13862156517$export$1995c2131ced269b
});
const $4a28b13862156517$export$bce1e544b9edc7a4 = (0, $87701c398fec8638$export$bc86dfbf7795668c)([
    (0, $87701c398fec8638$export$bf9fb029d174d554)({
        Name: (0, $87701c398fec8638$export$22b082955e083ec3),
        Count: (0, $87701c398fec8638$export$98e628dec113755e),
        Price: (0, $520c48df756a1a3e$export$3f58fdce283c1f4c),
        Unit: $4a28b13862156517$export$5aa02b087893052b,
        Discounts: (0, $520c48df756a1a3e$export$ff876193aa9f1),
        Taxes: (0, $520c48df756a1a3e$export$ff876193aa9f1),
        Extended: (0, $520c48df756a1a3e$export$3f58fdce283c1f4c),
        Discount: (0, $520c48df756a1a3e$export$3f58fdce283c1f4c),
        SubTotal: (0, $520c48df756a1a3e$export$3f58fdce283c1f4c),
        Tax: (0, $520c48df756a1a3e$export$3f58fdce283c1f4c),
        Total: (0, $520c48df756a1a3e$export$3f58fdce283c1f4c)
    }),
    (0, $87701c398fec8638$export$e45945969df8035a)({
        Unveil: (0, $87701c398fec8638$export$19282c40b967aec6)
    })
]);
const $4a28b13862156517$export$91b92057a2a9e47 = (0, $87701c398fec8638$export$74c5cab0f9a94551)('Charge', ()=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        $4a28b13862156517$export$bce1e544b9edc7a4,
        $4a28b13862156517$export$be28beddd6a0b
    ]));
const $4a28b13862156517$export$be28beddd6a0b = (0, $87701c398fec8638$export$bc86dfbf7795668c)([
    $4a28b13862156517$export$bce1e544b9edc7a4,
    (0, $87701c398fec8638$export$bf9fb029d174d554)({
        Items: (0, $87701c398fec8638$export$2f23118c22fb2630)($4a28b13862156517$export$91b92057a2a9e47)
    })
]);


const $cefda0850953082d$export$7de6cd8652177f82 = (quote)=>{
    const Extended = (0, $520c48df756a1a3e$export$8a63f25cc62965f1)(quote.Charges.map((charge)=>charge.Extended));
    // Need to confirm with the team. important!
    const Discount = (0, $520c48df756a1a3e$export$8a63f25cc62965f1)(quote.Charges.map((charge)=>charge.Discount));
    // const Discount = sum(prices(quote.Discounts));
    const SubTotal = (0, $520c48df756a1a3e$export$f93b5905241a7cca)(Extended, Discount);
    const Tax = (0, $520c48df756a1a3e$export$8a63f25cc62965f1)((0, $520c48df756a1a3e$export$bb4975b32c2ee1cf)(quote.Taxes));
    const Total = (0, $520c48df756a1a3e$export$e16d8520af44a096)(SubTotal, Tax);
    return Object.assign({}, quote, {
        Extended: Extended,
        Discount: Discount,
        Tax: Tax,
        SubTotal: SubTotal,
        Total: Total
    });
};
const $cefda0850953082d$export$82b8d343c504672 = (0, $87701c398fec8638$export$bc86dfbf7795668c)([
    (0, $87701c398fec8638$export$bf9fb029d174d554)({
        Name: (0, $87701c398fec8638$export$22b082955e083ec3),
        Charges: (0, $87701c398fec8638$export$2f23118c22fb2630)((0, $4a28b13862156517$export$91b92057a2a9e47)),
        Extended: (0, $520c48df756a1a3e$export$3f58fdce283c1f4c),
        Discount: (0, $520c48df756a1a3e$export$3f58fdce283c1f4c),
        Discounts: (0, $520c48df756a1a3e$export$ff876193aa9f1),
        SubTotal: (0, $520c48df756a1a3e$export$3f58fdce283c1f4c),
        Tax: (0, $520c48df756a1a3e$export$3f58fdce283c1f4c),
        Taxes: (0, $520c48df756a1a3e$export$ff876193aa9f1),
        Total: (0, $520c48df756a1a3e$export$3f58fdce283c1f4c)
    }),
    (0, $87701c398fec8638$export$e45945969df8035a)({
        Shipping: (0, $4a28b13862156517$export$91b92057a2a9e47)
    })
]);
const $cefda0850953082d$export$30a2c32520b13484 = {
    Name: '',
    Charges: [],
    Extended: (0, $520c48df756a1a3e$export$62d5467e2e4a5f20),
    Discount: (0, $520c48df756a1a3e$export$62d5467e2e4a5f20),
    Discounts: {},
    SubTotal: (0, $520c48df756a1a3e$export$62d5467e2e4a5f20),
    Tax: (0, $520c48df756a1a3e$export$62d5467e2e4a5f20),
    Taxes: {},
    Total: (0, $520c48df756a1a3e$export$62d5467e2e4a5f20)
};



const $10b175ffbc4c7dc7$export$d049cdf2d5d0bd3b = (0, $87701c398fec8638$export$7e1278799275f68e)({
    Retail: true,
    Design: true,
    Cutting: true,
    Product: true
});
const $10b175ffbc4c7dc7$export$59284d906bb8381b = [
    {
        key: 'Retail',
        names: {
            eng: 'Retail'
        }
    },
    {
        key: 'Design',
        names: {
            eng: 'Design'
        }
    },
    {
        key: 'Cutting',
        names: {
            eng: 'Cutting'
        }
    },
    {
        key: 'Product',
        names: {
            eng: 'Product'
        }
    }
];
const $10b175ffbc4c7dc7$export$c305f09562491877 = (0, $87701c398fec8638$export$7e1278799275f68e)({
    png: true,
    svg: true,
    dxf: true,
    pdf: true
});
const $10b175ffbc4c7dc7$export$21d66c43bd258d5 = [
    {
        key: 'svg',
        names: {
            eng: 'SVG'
        }
    },
    {
        key: 'png',
        names: {
            eng: 'PNG'
        }
    },
    {
        key: 'dxf',
        names: {
            eng: 'DXF'
        }
    },
    {
        key: 'pdf',
        names: {
            eng: 'PDF'
        }
    }
];
const $10b175ffbc4c7dc7$export$e416ea0257eed922 = [
    {
        key: 'figure',
        names: {
            eng: 'Edit'
        }
    }
].concat($10b175ffbc4c7dc7$export$21d66c43bd258d5);
const $10b175ffbc4c7dc7$export$9765818d669a1f97 = (0, $87701c398fec8638$export$e45945969df8035a)({
    Type: $10b175ffbc4c7dc7$export$d049cdf2d5d0bd3b,
    Size: (0, $d99ec1e84f6a18d9$export$9b589fb896e0ad32),
    Format: $10b175ffbc4c7dc7$export$c305f09562491877
});
const $10b175ffbc4c7dc7$export$599c70067f2ffd6e = (0, $87701c398fec8638$export$bc86dfbf7795668c)([
    (0, $87701c398fec8638$export$bf9fb029d174d554)({
        Template: (0, $6689c5083829c982$export$14416b8d99d47caa)
    }),
    (0, $87701c398fec8638$export$e45945969df8035a)({
        ApplyLimits: (0, $87701c398fec8638$export$22b082955e083ec3),
        GetBuilt: (0, $87701c398fec8638$export$4a21f16c33752377),
        GetDrawings: (0, $8af43a568842d8c3$export$d8deaab87a4e223a)($10b175ffbc4c7dc7$export$9765818d669a1f97),
        GetFigures: (0, $8af43a568842d8c3$export$d8deaab87a4e223a)($10b175ffbc4c7dc7$export$d049cdf2d5d0bd3b),
        GetLimits: (0, $87701c398fec8638$export$4a21f16c33752377),
        GetMass: (0, $87701c398fec8638$export$4a21f16c33752377),
        GetPrice: (0, $87701c398fec8638$export$4a21f16c33752377),
        GetValid: (0, $87701c398fec8638$export$4a21f16c33752377),
        GetQuote: (0, $87701c398fec8638$export$4a21f16c33752377)
    })
]);
const $10b175ffbc4c7dc7$export$e8821101629a00b = (0, $87701c398fec8638$export$bc86dfbf7795668c)([
    (0, $87701c398fec8638$export$bf9fb029d174d554)({
        Messages: (0, $87701c398fec8638$export$2f23118c22fb2630)((0, $8ea287ed6a1d6b5d$export$f69c19e57285b83a))
    }),
    (0, $87701c398fec8638$export$e45945969df8035a)({
        Built: (0, $87701c398fec8638$export$19282c40b967aec6),
        Drawings: (0, $8af43a568842d8c3$export$d8deaab87a4e223a)((0, $66b022cba2882e0a$export$6c98c30b3a286440)),
        Limits: (0, $87701c398fec8638$export$4a21f16c33752377),
        Figures: (0, $87701c398fec8638$export$e45945969df8035a)({
            Retail: (0, $6dc4c4b5427dac73$export$820c702ddd5a7343),
            Design: (0, $6dc4c4b5427dac73$export$820c702ddd5a7343),
            Cutting: (0, $6dc4c4b5427dac73$export$820c702ddd5a7343),
            Product: (0, $6dc4c4b5427dac73$export$820c702ddd5a7343)
        }),
        Mass: (0, $87701c398fec8638$export$2f23118c22fb2630)((0, $87701c398fec8638$export$98e628dec113755e)),
        Price: (0, $286b2f47b4833d97$export$4ccb4651fc0a59cb),
        Valid: (0, $87701c398fec8638$export$4a21f16c33752377),
        Quote: (0, $cefda0850953082d$export$82b8d343c504672)
    })
]);
const $10b175ffbc4c7dc7$export$3f8fe6489e95757d = (req)=>(buildReq)=>req.request($10b175ffbc4c7dc7$export$e8821101629a00b)('template/build', 'POST', buildReq);



/**
 * View Drawing.
 *
 * Front-end related drawings, checks for updated props and appends XML to the current react reference.
 *
 * @since 0.2.0
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


class $e67cb38579b6a15c$export$6c98c30b3a286440 extends $acw62.Component {
    constructor(ps){
        super(ps), this.shouldComponentUpdate = (newProps, _newState)=>!(0, $ca0affc99e9d76c6$export$e9bab7fafb253603)(this.props, newProps), this.componentDidMount = ()=>this.componentDidUpdate();
        this.ref = /*#__PURE__*/ $acw62.createRef();
    }
    componentDidUpdate() {
        const div = this.ref.current;
        if (div === null) return;
        if (this.props.Format === 'svg') {
            div.innerHTML = this.props.Data;
            const svg = div.children[0];
            if (svg === undefined) return;
            svg.removeAttribute('id');
            svg.removeAttribute('width');
            svg.removeAttribute('height');
        }
    }
    render() {
        switch(this.props.Format){
            case 'svg':
                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    ref: this.ref,
                    className: "drawing"
                });
            case 'png':
                return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    className: "drawing",
                    src: `data:image/png;base64,${this.props.Data}`
                });
        }
        return null;
    }
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");








var $55fb05426c12eeb7$exports = {};

$parcel$export($55fb05426c12eeb7$exports, "Curve", () => $55fb05426c12eeb7$export$b0e83c3ef8d2db1, (v) => $55fb05426c12eeb7$export$b0e83c3ef8d2db1 = v);
$parcel$export($55fb05426c12eeb7$exports, "Hitbox", () => $55fb05426c12eeb7$export$7ffe07e0fd862032, (v) => $55fb05426c12eeb7$export$7ffe07e0fd862032 = v);
$parcel$export($55fb05426c12eeb7$exports, "Ruler", () => $55fb05426c12eeb7$export$72a4dbfaa588abb2, (v) => $55fb05426c12eeb7$export$72a4dbfaa588abb2 = v);
$parcel$export($55fb05426c12eeb7$exports, "Ruler-angle", () => $55fb05426c12eeb7$export$3ff132563025f501, (v) => $55fb05426c12eeb7$export$3ff132563025f501 = v);
$parcel$export($55fb05426c12eeb7$exports, "Ruler-handle", () => $55fb05426c12eeb7$export$5ded6addfd0bcbd2, (v) => $55fb05426c12eeb7$export$5ded6addfd0bcbd2 = v);
$parcel$export($55fb05426c12eeb7$exports, "Ruler-line", () => $55fb05426c12eeb7$export$d991d13c4d46a157, (v) => $55fb05426c12eeb7$export$d991d13c4d46a157 = v);
$parcel$export($55fb05426c12eeb7$exports, "Ruler-whisker", () => $55fb05426c12eeb7$export$3e26d42fe9d6202d, (v) => $55fb05426c12eeb7$export$3e26d42fe9d6202d = v);
$parcel$export($55fb05426c12eeb7$exports, "Ruler-whisker-extended", () => $55fb05426c12eeb7$export$7144aec42d5d7a3d, (v) => $55fb05426c12eeb7$export$7144aec42d5d7a3d = v);
$parcel$export($55fb05426c12eeb7$exports, "RulerLabel-handle", () => $55fb05426c12eeb7$export$ac7b4089eb86866d, (v) => $55fb05426c12eeb7$export$ac7b4089eb86866d = v);
$parcel$export($55fb05426c12eeb7$exports, "active", () => $55fb05426c12eeb7$export$89da14300d534261, (v) => $55fb05426c12eeb7$export$89da14300d534261 = v);
var $55fb05426c12eeb7$export$b0e83c3ef8d2db1;
var $55fb05426c12eeb7$export$7ffe07e0fd862032;
var $55fb05426c12eeb7$export$72a4dbfaa588abb2;
var $55fb05426c12eeb7$export$3ff132563025f501;
var $55fb05426c12eeb7$export$5ded6addfd0bcbd2;
var $55fb05426c12eeb7$export$d991d13c4d46a157;
var $55fb05426c12eeb7$export$3e26d42fe9d6202d;
var $55fb05426c12eeb7$export$7144aec42d5d7a3d;
var $55fb05426c12eeb7$export$ac7b4089eb86866d;
var $55fb05426c12eeb7$export$89da14300d534261;
$55fb05426c12eeb7$export$b0e83c3ef8d2db1 = `mLRtFW_Curve`;
$55fb05426c12eeb7$export$7ffe07e0fd862032 = `mLRtFW_Hitbox`;
$55fb05426c12eeb7$export$72a4dbfaa588abb2 = `mLRtFW_Ruler`;
$55fb05426c12eeb7$export$3ff132563025f501 = `mLRtFW_Ruler-angle`;
$55fb05426c12eeb7$export$5ded6addfd0bcbd2 = `mLRtFW_Ruler-handle`;
$55fb05426c12eeb7$export$d991d13c4d46a157 = `mLRtFW_Ruler-line`;
$55fb05426c12eeb7$export$3e26d42fe9d6202d = `mLRtFW_Ruler-whisker`;
$55fb05426c12eeb7$export$7144aec42d5d7a3d = `mLRtFW_Ruler-whisker-extended`;
$55fb05426c12eeb7$export$ac7b4089eb86866d = `mLRtFW_RulerLabel-handle`;
$55fb05426c12eeb7$export$89da14300d534261 = `mLRtFW_active`;



var $acw62 = parcelRequire("acw62");
const $7ff8f69a51b0e2ac$export$1ab7ae714698c4b8 = (outer)=>{
    const inner = (0, $acw62.useRef)(outer ? outer.current : null);
    const ref = outer ?? inner;
    const [size, setSize] = (0, $acw62.useState)({
        w: 0,
        h: 0
    });
    (0, $acw62.useEffect)(()=>{
        if (!ref.current) return;
        const callback = (elem)=>setSize({
                w: elem.contentRect.width,
                h: elem.contentRect.height
            });
        const observer = new ResizeObserver((elems)=>elems.forEach(callback));
        observer.observe(ref.current);
        return ()=>observer.disconnect();
    }, [
        ref
    ]);
    return [
        ref,
        size
    ];
};
var $7ff8f69a51b0e2ac$export$2e2bcd8739ae039 = $7ff8f69a51b0e2ac$export$1ab7ae714698c4b8;


const $0b4a7130581cd32f$var$touchBlend = (pnts)=>{
    const cntr = $ec695bb278cff147$export$ffb5f4729a158638($d99ec1e84f6a18d9$export$348a0786643311f(1 / pnts.length)(pnts.reduce((a, b)=>$d99ec1e84f6a18d9$export$69bce51179ae0936(a)(b), [
        0,
        0
    ])));
    const offs = pnts.map($d99ec1e84f6a18d9$export$48a1a72d306481ef(cntr));
    const dist = offs.map($d99ec1e84f6a18d9$export$1991ecd29cc92c6b).reduce((a, b)=>a + b, 0);
    const angl = offs.map($0afff5a8d5fc1877$export$b8b770ee6a0d9760).reduce((a, b)=>a + b, 0) / offs.length;
    return {
        cntr: cntr,
        dist: dist,
        angl: angl
    };
};
const $0b4a7130581cd32f$var$touchSpots = (trgt, tchs)=>{
    const rect = trgt.getBoundingClientRect();
    return Array.from(tchs).filter((tch)=>tch).map((tch)=>[
            tch.clientX - rect.left,
            tch.clientY - rect.top
        ]);
};
const $0b4a7130581cd32f$export$61dc559f8a0b9bcf = (ref)=>{
    const iref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!ref) return;
        if (typeof ref === 'function') ref(iref.current);
        else ref.current = iref.current;
    });
    return iref;
};
const $0b4a7130581cd32f$var$mkDashing = (style)=>{
    switch(style){
        case 'Dashed':
            return '8';
        case 'Dotted':
            return '1 7';
        default:
            return undefined;
    }
};
const $0b4a7130581cd32f$var$mkWeight = (style)=>{
    switch(style){
        case 'Dotted':
            return '2px';
        case 'Heavy':
            return '2px';
        default:
            return '1px';
    }
};
const $0b4a7130581cd32f$export$56614ad18bbf7999 = ({ width: width, height: height, ...ps })=>{
    const [pan, setPan] = $acw62.useState([
        0,
        0
    ]);
    const [zoom, setZoom] = $acw62.useState(0.5);
    const [rotAngle, setRotAngle] = $acw62.useState(0);
    const toFigP = (0, $acw62.useCallback)((p)=>$d99ec1e84f6a18d9$export$48a1a72d306481ef($d99ec1e84f6a18d9$export$348a0786643311f(1 / zoom)(p))(pan), [
        pan,
        zoom
    ]);
    const proj = (0, $acw62.useCallback)((p)=>$ec695bb278cff147$export$9da38d06ceaaa3a0($ec695bb278cff147$export$871de8747c9eaa88($d99ec1e84f6a18d9$export$fdba22b8ad836e3a(rotAngle))(p)), [
        rotAngle
    ]);
    const doPan = (0, $acw62.useCallback)((dxy)=>setPan($d99ec1e84f6a18d9$export$69bce51179ae0936($d99ec1e84f6a18d9$export$348a0786643311f(1 / zoom)(dxy))), [
        zoom
    ]);
    const doZoom = (0, $acw62.useCallback)((dzf, pnt)=>{
        const fpt = toFigP(pnt);
        if (dzf < 0.1 || dzf > 10) return;
        setPan((p)=>$d99ec1e84f6a18d9$export$69bce51179ae0936(p)($d99ec1e84f6a18d9$export$348a0786643311f(1 / dzf - 1)($d99ec1e84f6a18d9$export$69bce51179ae0936(fpt)(p))));
        setZoom((z)=>z * dzf);
    }, [
        toFigP,
        setPan,
        setZoom
    ]);
    const onCenter = (0, $acw62.useCallback)((size)=>{
        const { pan: pan, zoom: zoom } = (0, $6dc4c4b5427dac73$export$1e044b7877db048c)(proj, 16, size)(ps.value);
        setPan(pan);
        setZoom(zoom);
    }, [
        proj,
        setPan,
        setZoom,
        ps.value
    ]);
    const doRotate = (0, $acw62.useCallback)((a, _p)=>setRotAngle((b)=>a + b), [
        setRotAngle
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0b4a7130581cd32f$export$d23d1f3707a268d2, {
        pref: "Figure",
        pan: pan,
        zoom: zoom,
        width: width ?? '100%',
        height: height ?? '100%',
        onPan: doPan,
        onZoom: doZoom,
        onRotate: doRotate,
        onCenter: onCenter,
        children: (hs)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0b4a7130581cd32f$export$ce7ec243d3bf6f60, {
                proj: proj,
                zoom: zoom,
                ...hs,
                ...ps
            })
    });
};
const $0b4a7130581cd32f$export$d7312ba6fbb3e550 = ({ ref: ref, ...ps })=>{
    const iref = $0b4a7130581cd32f$export$61dc559f8a0b9bcf(ref ?? null);
    (0, $acw62.useEffect)(()=>{
        const elm = iref.current;
        const def = (evt)=>{
            evt.preventDefault();
        };
        if (!elm) return;
        elm.addEventListener('wheel', def);
        elm.addEventListener('touchend', def);
        elm.addEventListener('touchmove', def);
        elm.addEventListener('touchstart', def);
        return ()=>{
            elm.removeEventListener('wheel', def);
            elm.removeEventListener('touchend', def);
            elm.removeEventListener('touchmove', def);
            elm.removeEventListener('touchstart', def);
        };
    }, [
        iref
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0b4a7130581cd32f$export$4016d599dec0169d, {
        ref: iref,
        ...ps
    });
};
const $0b4a7130581cd32f$export$d23d1f3707a268d2 = /*#__PURE__*/ $acw62.forwardRef((ps, ref)=>$0b4a7130581cd32f$export$d7312ba6fbb3e550({
        ref: ref,
        ...ps
    }));
const $0b4a7130581cd32f$export$c6536ba5e1866374 = ({ ref: ref, pan: pan, zoom: zoom, width: width, height: height, children: children, ...ps })=>{
    const fref = $0b4a7130581cd32f$export$61dc559f8a0b9bcf(ref ?? null);
    const [iref, size] = (0, $7ff8f69a51b0e2ac$export$2e2bcd8739ae039)(fref);
    const [btnMid, setBtnMid] = (0, $acw62.useState)(false);
    const [touch, setTouch] = (0, $acw62.useState)();
    const [activeType, setActiveType] = (0, $acw62.useState)();
    const [activeItem, setActiveItem] = (0, $acw62.useState)();
    const { onPan: doPan, onZoom: doZoom, onRotate: doRotate, onCenter: doCenter } = ps;
    const { onItemMove: doItemMove, onItemRelease: doItemRelease } = ps;
    // +[OPEN: MOUSE]
    const onWheel = (0, $acw62.useCallback)((evt)=>{
        const rect = evt.target.getBoundingClientRect();
        const spot = $ec695bb278cff147$export$ffb5f4729a158638($d99ec1e84f6a18d9$export$48a1a72d306481ef([
            evt.clientX,
            evt.clientY
        ])([
            rect.left,
            rect.top
        ]));
        if (evt.shiftKey || evt.metaKey) return;
        if (evt.ctrlKey) {
            doZoom?.(Math.exp(-evt.deltaY / 1000), spot);
            doRotate?.(evt.deltaX / 10, spot);
            return;
        }
        doPan?.($d99ec1e84f6a18d9$export$348a0786643311f(-0.5)([
            evt.altKey ? evt.deltaY : evt.deltaX,
            evt.altKey ? evt.deltaX : evt.deltaY
        ]));
    }, [
        doPan,
        doZoom,
        doRotate
    ]);
    const onMouseUp = (0, $acw62.useCallback)((evt)=>{
        if (evt.button === 1) setBtnMid(false);
        if (activeItem && activeType && iref && iref.current) {
            const rect = iref.current.getBoundingClientRect();
            const spot = [
                evt.clientX - rect.left,
                evt.clientY - rect.top
            ];
            doItemRelease?.(activeType, activeItem, spot);
        }
        setActiveType(undefined);
        setActiveItem(undefined);
    }, [
        iref,
        setBtnMid,
        activeItem,
        activeType,
        setActiveType,
        setActiveItem,
        doItemRelease
    ]);
    const onMouseMove = (0, $acw62.useCallback)((evt)=>{
        if (btnMid) {
            doPan?.([
                evt.movementX,
                evt.movementY
            ]);
            return;
        }
        if (!iref || !iref.current) return;
        const rect = iref.current.getBoundingClientRect();
        const spot = [
            evt.clientX - rect.left,
            evt.clientY - rect.top
        ];
        if (activeItem && activeType) doItemMove?.(activeType, activeItem, spot);
    }, [
        iref,
        doPan,
        btnMid,
        doItemMove,
        activeType,
        activeItem
    ]);
    const onMouseDown = (0, $acw62.useCallback)((evt)=>{
        if (evt.button === 1) setBtnMid(true);
        evt.preventDefault();
    }, [
        setBtnMid
    ]);
    const onItemMouseDown = (0, $acw62.useCallback)((typ, iid)=>(evt)=>{
            if (activeItem || evt.button !== 0) return;
            setActiveType(typ);
            setActiveItem(iid);
        }, [
        activeItem,
        setActiveType,
        setActiveItem
    ]);
    const onClick = (0, $acw62.useCallback)(()=>{
        iref?.current?.focus();
    }, [
        iref
    ]);
    // -[SHUT: MOUSE]
    // +[OPEN: TOUCH]
    const touchEnds = (0, $acw62.useCallback)((evt)=>{
        if (evt.touches.length <= 1) return;
        setTouch($0b4a7130581cd32f$var$touchBlend($0b4a7130581cd32f$var$touchSpots(evt.target, evt.touches)));
    }, [
        setTouch
    ]);
    const onTouchEnd = touchEnds;
    const onTouchMove = (0, $acw62.useCallback)((evt)=>{
        const ntch = $0b4a7130581cd32f$var$touchBlend($0b4a7130581cd32f$var$touchSpots(evt.target, evt.touches));
        if (!touch) {
            setTouch(ntch);
            return;
        }
        if (evt.touches.length <= 1) return;
        doPan?.($d99ec1e84f6a18d9$export$48a1a72d306481ef(ntch.cntr)(touch.cntr));
        doZoom?.(ntch.dist / touch.dist, touch.cntr);
        setTouch(ntch);
    }, [
        touch,
        doPan,
        doZoom,
        setTouch
    ]);
    const onTouchStart = touchEnds;
    // -[SHUT: TOUCH]
    // -[OPEN: KEYBOARD]
    const onKeyDown = (0, $acw62.useCallback)((evt)=>{
        if (evt.key === 'c') doCenter?.([
            size.w,
            size.h
        ]);
    }, [
        doCenter,
        size
    ]);
    // -[SHUT: KEYBOARD]
    const [ctrd, setCtrd] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (ctrd || size.w <= 0 || size.h <= 0) return;
        doCenter?.([
            size.w,
            size.h
        ]);
        setCtrd(true);
    }, [
        doCenter,
        ctrd,
        setCtrd,
        size.w,
        size.h
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        ref: iref,
        tabIndex: 0,
        width: width,
        height: height,
        onWheel: onWheel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart,
        onMouseUp: onMouseUp,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onKeyDown: onKeyDown,
        style: {
            '--font-size': `${16 / zoom}px`
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
            transform: `scale(${zoom}) translate(${pan[0]} ${pan[1]})`,
            children: children({
                aid: activeItem,
                onItemMouseDown: onItemMouseDown,
                ...ps
            })
        })
    });
};
const $0b4a7130581cd32f$export$4016d599dec0169d = /*#__PURE__*/ $acw62.forwardRef((ps, ref)=>$0b4a7130581cd32f$export$c6536ba5e1866374({
        ref: ref,
        ...ps
    }));
const $0b4a7130581cd32f$export$ce7ec243d3bf6f60 = ({ value: figure, ...ps })=>/*#__PURE__*/ (0, $ayMG0.jsx)("g", {
        className: "Figure",
        children: figure.Pieces.map((piece, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0b4a7130581cd32f$export$cf9ddce18584c8a9, {
                value: piece,
                ...ps
            }, i))
    });
const $0b4a7130581cd32f$export$cf9ddce18584c8a9 = ({ value: piece, ...ps })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
        className: "Piece",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                className: "Curves",
                children: piece.Curves.map((curve)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0b4a7130581cd32f$export$c3fb7563b25aecfb, {
                        value: curve,
                        ...ps
                    }, curve.Id.join('-')))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                className: "CBoxes",
                children: piece.Curves.map((curve)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0b4a7130581cd32f$export$2cf53053246277ec, {
                        value: curve,
                        ...ps
                    }, curve.Id.join('-')))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                className: "Rulers",
                children: [
                    piece.Rulers.map((ruler)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0b4a7130581cd32f$export$86ac7d96e657a22e, {
                            value: ruler,
                            ...ps
                        }, ruler.Id.join('-'))),
                    piece.Rulers.map((ruler)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0b4a7130581cd32f$export$e6bf87c07938f89c, {
                            value: ruler,
                            ...ps
                        }, ruler.Id.join('-')))
                ]
            })
        ]
    });
const $0b4a7130581cd32f$export$c3fb7563b25aecfb = ({ value: curve, proj: proj })=>{
    const curveId = curve.Id.join('-');
    const curveClass = curve.Class.join(' ');
    return /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        id: `curve-${curveId}`,
        className: `${$55fb05426c12eeb7$exports.Curve} ${$55fb05426c12eeb7$exports[curveClass] ?? ''}`,
        d: $0b4a7130581cd32f$export$a1e19885760323df(proj)(curve.Segments)
    }, curveId);
};
const $0b4a7130581cd32f$export$2cf53053246277ec = ({ value: curve, proj: proj, actionables: actionables })=>{
    if (actionables && !actionables.includes('EdgeBox')) return null;
    const curveId = curve.Id.join('-');
    const curveClass = curve.Class.join(' ');
    const [fst, rst] = (0, $3ead2e6ff6058f21$export$b89fb645b0c50a76)(1 / 3)(curve.Segments);
    const [mid, lst] = (0, $3ead2e6ff6058f21$export$b89fb645b0c50a76)(0.5)(rst);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                id: `hitbox-mid-${curveId}`,
                className: `${$55fb05426c12eeb7$exports.Hitbox} ${$55fb05426c12eeb7$exports.Mid} ${$55fb05426c12eeb7$exports[curveClass] ?? ''}`,
                d: $0b4a7130581cd32f$export$a1e19885760323df(proj)(mid)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                id: `hitbox-fst-${curveId}`,
                className: `${$55fb05426c12eeb7$exports.Hitbox} ${$55fb05426c12eeb7$exports.Fst} ${$55fb05426c12eeb7$exports[curveClass] ?? ''}`,
                d: $0b4a7130581cd32f$export$a1e19885760323df(proj)(fst)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                id: `hitbox-lst-${curveId}`,
                className: `${$55fb05426c12eeb7$exports.Hitbox} ${$55fb05426c12eeb7$exports.Lst} ${$55fb05426c12eeb7$exports[curveClass] ?? ''}`,
                d: $0b4a7130581cd32f$export$a1e19885760323df(proj)(lst)
            })
        ]
    });
};
const $0b4a7130581cd32f$export$e6bf87c07938f89c = ({ value: ruler, zoom: zoom, proj: proj })=>{
    const rlr = ruler.For;
    if (rlr.type !== 'Angular') return null;
    const sze = 10 / zoom;
    const left = $d99ec1e84f6a18d9$export$dcdf75081b88279d(sze)($d99ec1e84f6a18d9$export$523c0b569236b342($ec695bb278cff147$export$f93b5905241a7cca(proj(rlr.Left))(proj(rlr.Middle))));
    const rght = $d99ec1e84f6a18d9$export$dcdf75081b88279d(sze)($d99ec1e84f6a18d9$export$523c0b569236b342($ec695bb278cff147$export$f93b5905241a7cca(proj(rlr.Right))(proj(rlr.Middle))));
    const midl = proj(rlr.Middle);
    const mpt = $ec695bb278cff147$export$ffb5f4729a158638(midl);
    const lpt = $ec695bb278cff147$export$ffb5f4729a158638($d99ec1e84f6a18d9$export$e16d8520af44a096(midl)(left));
    const rpt = $ec695bb278cff147$export$ffb5f4729a158638($d99ec1e84f6a18d9$export$e16d8520af44a096(midl)(rght));
    const cpt = $ec695bb278cff147$export$ffb5f4729a158638($d99ec1e84f6a18d9$export$e16d8520af44a096($d99ec1e84f6a18d9$export$e16d8520af44a096(midl)(left))(rght));
    const angl = Math.acos($d99ec1e84f6a18d9$export$94132a0e348806d4(left)(rght) / ($d99ec1e84f6a18d9$export$1991ecd29cc92c6b(left) * $d99ec1e84f6a18d9$export$1991ecd29cc92c6b(rght))) / (2 * Math.PI) * 360;
    if (!(Math.abs(angl - 90) <= 0.00001)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
        points: `${mpt[0]},${mpt[1]} ${lpt[0]},${lpt[1]} ${cpt[0]},${cpt[1]} ${rpt[0]},${rpt[1]}`,
        className: $55fb05426c12eeb7$exports['Ruler-angle']
    });
};
const $0b4a7130581cd32f$export$86ac7d96e657a22e = ({ value: ruler, zoom: zoom, proj: proj, lengthConverter: lengthConverter, angleConverter: angleConverter, actionables: actionables, ...ps })=>{
    if (!ruler.Info.Visible) return null;
    const len = $d99ec1e84f6a18d9$export$1991ecd29cc92c6b($ec695bb278cff147$export$f93b5905241a7cca(ruler.For.Left)(ruler.For.Right));
    const actRlr = actionables && actionables.includes('Ruler');
    const actLbl = actionables && actionables.includes('RulerLabel');
    if (ruler.For.type === 'Angular' || len < 0.00001 || !ruler.Info.Visible) return null;
    const rulerId = ruler.Id.join('-');
    const rulerClass = ruler.Class.join(' ');
    const wsk = ruler.Info.ExtendWhisker;
    const val = ruler.Value === '+inf' ? 0 : Number(ruler.Value);
    const lbl = ruler.Unit === 'mm' ? lengthConverter.build(val) : ruler.Unit === 'deg' ? angleConverter.build(val) : ruler.Value.toString();
    const { dir: dir, label: label, left: left, right: right } = (0, $ca3259999c4aeb4d$export$be2ef8a3d71140ca)(32 / zoom)(ruler);
    const label_position = proj(label);
    const active = ps.aid === ruler.Id ? 'active' : '';
    const ruler_left = proj(left);
    const ruler_right = proj(right);
    const obj_left = proj(ruler.Object.Start);
    const obj_right = proj(ruler.Object.End);
    const wisker_offset = $d99ec1e84f6a18d9$export$dcdf75081b88279d(5 / 32)(dir);
    const wp1 = proj($ec695bb278cff147$export$e16d8520af44a096(left)(wisker_offset));
    const wps1 = proj($ec695bb278cff147$export$e0f232dd469378a8(left)(wisker_offset));
    const wp2 = proj($ec695bb278cff147$export$e16d8520af44a096(right)(wisker_offset));
    const wps2 = proj($ec695bb278cff147$export$e0f232dd469378a8(right)(wisker_offset));
    const vec = (()=>{
        switch(ruler.Info.LabelOrient){
            case 'ObjectAcross':
                return $d99ec1e84f6a18d9$export$7ed3823ccd6026c4($ec695bb278cff147$export$f93b5905241a7cca(obj_right)(obj_left));
            case 'ObjectAlong':
                return $ec695bb278cff147$export$f93b5905241a7cca(obj_right)(obj_left);
            case 'RulerAcross':
                return $d99ec1e84f6a18d9$export$7ed3823ccd6026c4($ec695bb278cff147$export$f93b5905241a7cca(ruler_right)(ruler_left));
            case 'RulerAlong':
                return $ec695bb278cff147$export$f93b5905241a7cca(ruler_right)(ruler_left);
        }
    })();
    const angle = Math.atan2(vec[1], vec[0]) * 180 / Math.PI;
    const rot = Math.abs(angle) > 90 ? angle + 180 : angle;
    const whiskerDashing = $0b4a7130581cd32f$var$mkDashing(ruler.Info.WhiskerStyle);
    const whiskerWeight = $0b4a7130581cd32f$var$mkWeight(ruler.Info.WhiskerStyle);
    const dashing = $0b4a7130581cd32f$var$mkDashing(ruler.Info.BarStyle);
    const weight = $0b4a7130581cd32f$var$mkWeight(ruler.Info.BarStyle);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
        id: `Ruler-${rulerId}`,
        className: `${$55fb05426c12eeb7$exports.Ruler} ${$55fb05426c12eeb7$exports[rulerClass] ?? ''}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: ruler_left[0],
                y1: ruler_left[1],
                x2: ruler_right[0],
                y2: ruler_right[1],
                strokeDasharray: dashing,
                strokeWidth: weight,
                className: $55fb05426c12eeb7$exports['Ruler-line']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: wps1[0],
                y1: wps1[1],
                x2: wp1[0],
                y2: wp1[1],
                className: $55fb05426c12eeb7$exports['Ruler-whisker']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: wps2[0],
                y1: wps2[1],
                x2: wp2[0],
                y2: wp2[1],
                className: $55fb05426c12eeb7$exports['Ruler-whisker']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                transform: `translate(${label_position[0]} ${label_position[1]}) rotate(${rot})`,
                children: lbl
            }),
            wsk ? /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: obj_left[0],
                y1: obj_left[1],
                x2: ruler_left[0],
                y2: ruler_left[1],
                strokeDasharray: whiskerDashing,
                strokeWidth: whiskerWeight,
                className: $55fb05426c12eeb7$exports['Ruler-whisker-extended']
            }) : null,
            wsk ? /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: obj_right[0],
                y1: obj_right[1],
                x2: ruler_right[0],
                y2: ruler_right[1],
                strokeDasharray: whiskerDashing,
                strokeWidth: whiskerWeight,
                className: $55fb05426c12eeb7$exports['Ruler-whisker-extended']
            }) : null,
            actRlr ? /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: ruler_left[0],
                y1: ruler_left[1],
                x2: ruler_right[0],
                y2: ruler_right[1],
                className: `${$55fb05426c12eeb7$exports['Ruler-handle']} ${$55fb05426c12eeb7$exports[active] ?? ''}`,
                onMouseDown: ps.onItemMouseDown('Ruler', ruler.Id)
            }) : null,
            actLbl ? /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: label_position[0],
                cy: label_position[1],
                r: 20 / zoom,
                className: `${$55fb05426c12eeb7$exports['RulerLabel-handle']} ${$55fb05426c12eeb7$exports[active] ?? ''}`,
                onMouseDown: ps.onItemMouseDown('RulerLabel', ruler.Id)
            }) : null
        ]
    });
};
const $0b4a7130581cd32f$export$4210f5ea57fbae57 = (segs)=>{
    const b = segs[0];
    const e = segs[segs.length - 1];
    if (b === undefined || e === undefined) return false;
    return $ec695bb278cff147$export$d71917a79103c107(b[0])((0, $dc04001260b223cb$export$b2b14c8e7dc8913b)(e));
};
const $0b4a7130581cd32f$export$a1e19885760323df = (proj)=>(segs)=>(0, $ff8824db188fc32d$export$16baaa20b202a186)($0b4a7130581cd32f$export$a4c51f2785ef622f(proj), $0b4a7130581cd32f$export$56dcfe961d71212b(proj))(segs).join(' ');
const $0b4a7130581cd32f$export$a4c51f2785ef622f = (proj)=>(seg)=>$0b4a7130581cd32f$export$5e03080bc36671a9((0, $dc04001260b223cb$export$51186ad6e864892a)(proj)(seg));
const $0b4a7130581cd32f$export$56dcfe961d71212b = (proj)=>(prev, curr)=>($ec695bb278cff147$export$d71917a79103c107((0, $dc04001260b223cb$export$b2b14c8e7dc8913b)(prev))(curr[0]) ? $0b4a7130581cd32f$export$ad79155a9d5789f6 : $0b4a7130581cd32f$export$5e03080bc36671a9)((0, $dc04001260b223cb$export$51186ad6e864892a)(proj)(curr));
const $0b4a7130581cd32f$export$5e03080bc36671a9 = (s)=>`M ${s[0][0]} ${s[0][1]} ${$0b4a7130581cd32f$export$ad79155a9d5789f6(s)}`;
const $0b4a7130581cd32f$export$ad79155a9d5789f6 = (s)=>(0, $dc04001260b223cb$export$4e59ee69b49e5f3)(s) ? `L ${s[1][0]} ${s[1][1]}` : `C ${s[1][0]} ${s[1][1]} ${s[2][0]} ${s[2][1]} ${s[3][0]} ${s[3][1]}`;
const $0b4a7130581cd32f$export$45a387e3e619f606 = ({ render: render, value: value, ...ps })=>{
    const [figures, setFigures] = $acw62.useState({});
    const [rendered, setRendered] = $acw62.useState(false);
    (0, $acw62.useEffect)(()=>{
        setRendered(false);
        render(value).then((figs)=>{
            setFigures(figs);
            setRendered(true);
        }).catch((e)=>{
            console.warn(e);
            setRendered('Error!');
        });
    }, [
        render,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            Object.entries(figures).map(([k, v])=>v ? /*#__PURE__*/ (0, $ayMG0.jsx)($0b4a7130581cd32f$export$ce7ec243d3bf6f60, {
                    value: v,
                    ...ps
                }, k) : null),
            rendered === true ? null : rendered === false ? /*#__PURE__*/ (0, $ayMG0.jsx)($0b4a7130581cd32f$export$9076cdaa054edd08, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)($0b4a7130581cd32f$export$6dec16e06d386d75, {
                message: rendered
            })
        ]
    });
};
const $0b4a7130581cd32f$export$9076cdaa054edd08 = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
const $0b4a7130581cd32f$export$6dec16e06d386d75 = ({ message: message })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("foreignObject", {
        width: "100%",
        height: "100%",
        children: [
            " ",
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    margin: '40%'
                },
                children: [
                    " ",
                    message,
                    " "
                ]
            }),
            " "
        ]
    });





var $9dcc8b56c3879240$export$cc1adf6fb659c762;
var $9dcc8b56c3879240$export$4862b4e1cbd4a552;
$9dcc8b56c3879240$export$cc1adf6fb659c762 = `_8Lf5ZG_controls`;
$9dcc8b56c3879240$export$4862b4e1cbd4a552 = `_8Lf5ZG_template-viewer`;


const $8fc20d6ff1f2aab1$var$getDrawings = (req, template, drawType, format)=>{
    const buildreq = {
        Template: template,
        GetFigures: format === 'figure' ? [
            drawType
        ] : undefined,
        GetDrawings: format === 'figure' ? undefined : [
            {
                Type: drawType,
                Size: [
                    500,
                    500
                ],
                Format: format
            }
        ]
    };
    return (0, $10b175ffbc4c7dc7$export$3f8fe6489e95757d)(req)(buildreq);
};
const $8fc20d6ff1f2aab1$export$85c5def18439af89 = (props)=>{
    const { req: req, template: template, initialFormat: initialFormat } = props;
    const [_loading, setLoading] = $acw62.useState(true);
    const [lastResp, setLastResp] = $acw62.useState({
        Messages: []
    });
    const [drawType, setDrawType] = $acw62.useState('Design');
    const [format, setFormat] = $acw62.useState(initialFormat || 'figure');
    $acw62.useEffect(()=>{
        setLoading(true);
        $8fc20d6ff1f2aab1$var$getDrawings(req, template, drawType, format).then((resp)=>{
            setLoading(false);
            setLastResp(resp);
        }).catch((err)=>{
            console.warn(err);
            setLastResp({
                Messages: [
                    {
                        level: 'error',
                        text: err.toString()
                    }
                ]
            });
            setLoading(false);
        });
    }, [
        req,
        template,
        drawType,
        format
    ]);
    const handleFormatSelection = $acw62.useCallback((f)=>{
        const fmt = f('svg');
        // Download dxf or pdf, don't try to show it.
        if (fmt === 'dxf' || fmt === 'pdf') $8fc20d6ff1f2aab1$var$getDrawings(req, template, drawType, fmt).then((resp)=>{
            const drawing = (resp.Drawings ?? [])[0];
            if (!drawing) return Promise.reject('No drawings.');
            return Promise.resolve({
                name: `template-${drawType}`,
                type: drawing.Format,
                getContent: ()=>drawing.Data,
                base64: true
            });
        }).then((0, $615738504270bac3$export$24422be91ad4011f)).catch(console.warn);
        else setFormat(f);
    }, [
        req,
        template,
        drawType,
        setFormat
    ]);
    const fig = lastResp.Figures?.[drawType];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `template-viewer ${$9dcc8b56c3879240$export$4862b4e1cbd4a552}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: $9dcc8b56c3879240$export$cc1adf6fb659c762,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$2e2bcd8739ae039), {
                        size: "small",
                        items: (0, $10b175ffbc4c7dc7$export$59284d906bb8381b),
                        value: drawType,
                        update: setDrawType
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$2e2bcd8739ae039), {
                        size: "small",
                        items: (0, $10b175ffbc4c7dc7$export$e416ea0257eed922),
                        value: format,
                        update: handleFormatSelection
                    })
                ]
            }),
            fig === undefined ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e67cb38579b6a15c$export$6c98c30b3a286440), {
                ...(lastResp.Drawings ?? [
                    (0, $66b022cba2882e0a$export$f156a189c8056443)
                ])[0]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0b4a7130581cd32f$export$56614ad18bbf7999), {
                value: fig,
                lengthConverter: (0, $4beeab19e80c1290$export$d871edfc009fc342),
                angleConverter: (0, $4beeab19e80c1290$export$6e98d19a58527322).exterior
            })
        ]
    });
};
const $8fc20d6ff1f2aab1$export$7370d7aaa0be7e8a = /*#__PURE__*/ $acw62.memo($8fc20d6ff1f2aab1$export$85c5def18439af89, (prevProps, nextProps)=>{
    return (0, $ca0affc99e9d76c6$export$e9bab7fafb253603)(prevProps, nextProps);
});



var $008ce9c6b88a8ccc$export$b5d042d2b680aed6;
var $008ce9c6b88a8ccc$export$41c562ebe57d11e2;
var $008ce9c6b88a8ccc$export$7dea6024c4894e8e;
var $008ce9c6b88a8ccc$export$4997ffc0176396a6;
$008ce9c6b88a8ccc$export$b5d042d2b680aed6 = `f_hQZW_editor`;
$008ce9c6b88a8ccc$export$41c562ebe57d11e2 = `f_hQZW_options`;
$008ce9c6b88a8ccc$export$7dea6024c4894e8e = `f_hQZW_viewer`;
$008ce9c6b88a8ccc$export$4997ffc0176396a6 = `f_hQZW_wrap`;



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @since 1.2.0
 */ 
var $kisy7 = parcelRequire("kisy7");

var $kLIh4 = parcelRequire("kLIh4");

var $5OFXS = parcelRequire("5OFXS");
function $996bbaeec61ffd0f$export$2cd1c249765cd0a4() {
    return new (0, $kisy7.Index)(function(i) {
        return new (0, $kisy7.Optional)(function(as) {
            return (0, $kLIh4.lookup)(i, as);
        }, function(a) {
            return function(as) {
                var oas = (0, $kLIh4.updateAt)(i, a)(as);
                if ((0, $5OFXS.isNone)(oas)) return as;
                else return oas.value;
            };
        });
    });
}


/**
 * Optics for Templates.
 *
 */ 
/**
 * Optics for TemplateMod.
 *
 */ 
var $kisy7 = parcelRequire("kisy7");



const $efdb506a8fb142bf$export$28a5c30e3a807f5b = (lang)=>(0, $kisy7.Lens).fromProp()(lang).compose((0, $1379b6c01f560d41$export$9364064a021bcaeb));
const $efdb506a8fb142bf$export$8d74d683613f4568 = (lang)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)(lang), (0, $58f80d7b57eba59b$export$36faa878fcded3d7)(''));
const $efdb506a8fb142bf$export$64b8d2e655f5ae0a = (key)=>(0, $kisy7.Optional).fromNullableProp()(key);




const $7aba2092ca2b63b7$export$3956c153c67322fc = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Names');
const $7aba2092ca2b63b7$export$4b9988f6b6a80316 = (lang)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($7aba2092ca2b63b7$export$3956c153c67322fc, (0, $efdb506a8fb142bf$export$8d74d683613f4568)(lang));
const $7aba2092ca2b63b7$export$e8b49a33e60fbb5b = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Opts');
const $7aba2092ca2b63b7$export$9de861551d3023af = (label)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($7aba2092ca2b63b7$export$e8b49a33e60fbb5b, (0, $58f80d7b57eba59b$export$79b2f7037acddd43)($7aba2092ca2b63b7$var$matchesLabel(label)));
const $7aba2092ca2b63b7$export$b13e15ea499ed6b7 = (label)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($7aba2092ca2b63b7$export$3e7d364af758ed31, (0, $58f80d7b57eba59b$export$79b2f7037acddd43)($7aba2092ca2b63b7$var$matchesLabel(label)));
const $7aba2092ca2b63b7$var$matchesLabel = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((label)=>(o)=>o.Label === label);
const $7aba2092ca2b63b7$export$3e7d364af758ed31 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Vars');
const $7aba2092ca2b63b7$export$e04252494b3c4e92 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Value');
const $7aba2092ca2b63b7$export$48ae47e7aac6f7fc = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Value');
const $7aba2092ca2b63b7$export$4de6889a096ee9cf = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Names');
const $7aba2092ca2b63b7$export$726ca57390740b07 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Groups');
const $7aba2092ca2b63b7$export$2bb609461ec3cd2c = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Fold');


parcelRequire("acw62");





const $111aab76558170aa$export$91db2342be6956eb = (ps)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        item: true,
        className: "option-editor",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
            sx: {
                my: 1,
                width: '100%'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$2e2bcd8739ae039), {
                id: `option-${ps.value.Label}-select`,
                value: ps.value.Value,
                label: ps.value.Names,
                size: "small",
                items: ps.value.Range.map((e)=>({
                        key: e.Label,
                        icon: e.Image,
                        names: e.Names
                    })),
                update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(ps.update, (0, $7aba2092ca2b63b7$export$e04252494b3c4e92))
            })
        })
    });
const $111aab76558170aa$export$a259f2e8c479f66 = (ps)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            " ",
            ps.value.map((opt, i)=>!ps.filterSelected(opt) ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($111aab76558170aa$export$91db2342be6956eb, {
                    value: opt,
                    update: (x)=>ps.update((0, $996bbaeec61ffd0f$export$2cd1c249765cd0a4)().index(i).modify(x))
                }, opt.Label)),
            " "
        ]
    });



var $ayMG0 = parcelRequire("ayMG0");



var $lWM6H = parcelRequire("lWM6H");

parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");




var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $1jJMI = parcelRequire("1jJMI");const $0acaed42692b8720$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $0acaed42692b8720$export$2e2bcd8739ae039 = $0acaed42692b8720$var$visuallyHidden;



function $6dec2bf07d6d333a$var$areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var $6dec2bf07d6d333a$export$2e2bcd8739ae039 = $6dec2bf07d6d333a$var$areArraysEqual;


'use client';
const $9e8acd9e5bad7cc4$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $9e8acd9e5bad7cc4$var$asc(a, b) {
    return a - b;
}
function $9e8acd9e5bad7cc4$var$findClosest(values, currentValue) {
    var _values$reduce;
    const { index: closestIndex } = (_values$reduce = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null)) != null ? _values$reduce : {};
    return closestIndex;
}
function $9e8acd9e5bad7cc4$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $9e8acd9e5bad7cc4$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $9e8acd9e5bad7cc4$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $9e8acd9e5bad7cc4$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $9e8acd9e5bad7cc4$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($9e8acd9e5bad7cc4$var$getDecimalPrecision(step)));
}
function $9e8acd9e5bad7cc4$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($9e8acd9e5bad7cc4$var$asc);
}
function $9e8acd9e5bad7cc4$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    var _sliderRef$current, _doc$activeElement;
    const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(sliderRef.current);
    if (!((_sliderRef$current = sliderRef.current) != null && _sliderRef$current.contains(doc.activeElement)) || Number(doc == null || (_doc$activeElement = doc.activeElement) == null ? void 0 : _doc$activeElement.getAttribute('data-index')) !== activeIndex) {
        var _sliderRef$current2;
        (_sliderRef$current2 = sliderRef.current) == null || _sliderRef$current2.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    }
    if (setActive) setActive(activeIndex);
}
function $9e8acd9e5bad7cc4$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $6dec2bf07d6d333a$export$2e2bcd8739ae039)(newValue, oldValue);
    return false;
}
const $9e8acd9e5bad7cc4$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $9e8acd9e5bad7cc4$export$544bf02140fa9a77 = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone;
function $9e8acd9e5bad7cc4$var$doesSupportTouchActionNone() {
    if ($9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone = true;
    }
    return $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone;
}
function $9e8acd9e5bad7cc4$export$56b2c08e277f365(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $9e8acd9e5bad7cc4$export$544bf02140fa9a77, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $acw62.useRef(undefined);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $acw62.useState(-1);
    const [open, setOpen] = $acw62.useState(-1);
    const [dragging, setDragging] = $acw62.useState(false);
    const moveCount = $acw62.useRef(0);
    const [valueDerived, setValueState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue != null ? defaultValue : min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($9e8acd9e5bad7cc4$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $1jJMI.default)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $15e2b45accdb3531$export$2e2bcd8739ae039)();
    const [focusedThumbIndex, setFocusedThumbIndex] = $acw62.useState(-1);
    const sliderRef = $acw62.useRef(null);
    const handleFocusRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(focusVisibleRef, sliderRef);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, handleFocusRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            var _otherHandlers$onFocu;
            const index = Number(event.currentTarget.getAttribute('data-index'));
            handleFocusVisible(event);
            if (isFocusVisibleRef.current === true) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers == null || (_otherHandlers$onFocu = otherHandlers.onFocus) == null || _otherHandlers$onFocu.call(otherHandlers, event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            var _otherHandlers$onBlur;
            handleBlurVisible(event);
            if (isFocusVisibleRef.current === false) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers == null || (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue > maxMarksValue) newValue = maxMarksValue;
            else if (newValue < marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $1jJMI.default)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $1jJMI.default)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $9e8acd9e5bad7cc4$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $9e8acd9e5bad7cc4$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            // The Shift + Up/Down keyboard shortcuts for moving the slider makes sense to be supported
            // only if the step is defined. If the step is null, this means tha the marks are used for specifying the valid values.
            if (step !== null) {
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                if ((event.key === 'ArrowLeft' || event.key === 'ArrowDown') && event.shiftKey || event.key === 'PageDown') newValue = Math.max(value - shiftStep, min);
                else if ((event.key === 'ArrowRight' || event.key === 'ArrowUp') && event.shiftKey || event.key === 'PageUp') newValue = Math.min(value + shiftStep, max);
                if (newValue !== null) {
                    changeValue(event, newValue);
                    event.preventDefault();
                }
            }
            otherHandlers == null || (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
        };
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) {
            var _document$activeEleme;
            // This is necessary because Firefox and Safari will keep focus
            // on a disabled element:
            // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
            // @ts-ignore
            (_document$activeEleme = document.activeElement) == null || _document$activeEleme.blur();
        }
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            var _otherHandlers$onChan;
            (_otherHandlers$onChan = otherHandlers.onChange) == null || _otherHandlers$onChan.call(otherHandlers, event);
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = $acw62.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.indexOf('vertical') === 0) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.indexOf('-reverse') !== -1) percent = 1 - percent;
        let newValue;
        newValue = $9e8acd9e5bad7cc4$var$percentToValue(percent, min, max);
        if (step) newValue = $9e8acd9e5bad7cc4$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $9e8acd9e5bad7cc4$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $1jJMI.default)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $9e8acd9e5bad7cc4$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $1jJMI.default)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $9e8acd9e5bad7cc4$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $9e8acd9e5bad7cc4$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $9e8acd9e5bad7cc4$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$9e8acd9e5bad7cc4$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $9e8acd9e5bad7cc4$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $acw62.useCallback(()=>{
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $acw62.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: $9e8acd9e5bad7cc4$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $acw62.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous;
            (_otherHandlers$onMous = otherHandlers.onMouseDown) == null || _otherHandlers$onMous.call(otherHandlers, event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $9e8acd9e5bad7cc4$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $9e8acd9e5bad7cc4$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = $9e8acd9e5bad7cc4$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $9e8acd9e5bad7cc4$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $8nd05.default)({}, externalHandlers, ownEventHandlers);
        return (0, $8nd05.default)({}, externalProps, {
            ref: handleRef
        }, mergedEventHandlers);
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous2;
            (_otherHandlers$onMous2 = otherHandlers.onMouseOver) == null || _otherHandlers$onMous2.call(otherHandlers, event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous3;
            (_otherHandlers$onMous3 = otherHandlers.onMouseLeave) == null || _otherHandlers$onMous3.call(otherHandlers, event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return (0, $8nd05.default)({}, externalProps, externalHandlers, ownEventHandlers);
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    const getHiddenInputProps = (externalProps = {})=>{
        var _parameters$step;
        const externalHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $8nd05.default)({}, externalHandlers, ownEventHandlers);
        return (0, $8nd05.default)({
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : (_parameters$step = parameters.step) != null ? _parameters$step : undefined,
            disabled: disabled
        }, externalProps, mergedEventHandlers, {
            style: (0, $8nd05.default)({}, (0, $0acaed42692b8720$export$2e2bcd8739ae039), {
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%'
            })
        });
    };
    return {
        active: active,
        axis: axis,
        axisProps: $9e8acd9e5bad7cc4$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $PJRTc = parcelRequire("PJRTc");

const $fef7b1c426e97238$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Slot);
};
var $fef7b1c426e97238$export$2e2bcd8739ae039 = $fef7b1c426e97238$var$shouldSpreadAdditionalProps;



var $jTnBY = parcelRequire("jTnBY");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $175610683d4083b7$export$9f59f2622d5cbc2a(slot) {
    return (0, $4Cod0.default)('MuiSlider', slot);
}
const $175610683d4083b7$var$sliderClasses = (0, $beCSm.default)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $175610683d4083b7$export$2e2bcd8739ae039 = $175610683d4083b7$var$sliderClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1d8e4e584d12bd05$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $9QePP.default)(open && (0, $175610683d4083b7$export$2e2bcd8739ae039).valueLabelOpen),
        circle: (0, $175610683d4083b7$export$2e2bcd8739ae039).valueLabelCircle,
        label: (0, $175610683d4083b7$export$2e2bcd8739ae039).valueLabelLabel
    };
    return utilityClasses;
};
function $1d8e4e584d12bd05$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $1d8e4e584d12bd05$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $acw62.cloneElement(children, {
        className: (0, $9QePP.default)(children.props.className)
    }, /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: (0, $9QePP.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e7d362f04a4204f3$var$_excluded = [
    "aria-label",
    "aria-valuetext",
    "aria-labelledby",
    "component",
    "components",
    "componentsProps",
    "color",
    "classes",
    "className",
    "disableSwap",
    "disabled",
    "getAriaLabel",
    "getAriaValueText",
    "marks",
    "max",
    "min",
    "name",
    "onChange",
    "onChangeCommitted",
    "orientation",
    "shiftStep",
    "size",
    "step",
    "scale",
    "slotProps",
    "slots",
    "tabIndex",
    "track",
    "value",
    "valueLabelDisplay",
    "valueLabelFormat"
];
function $e7d362f04a4204f3$var$Identity(x) {
    return x;
}
const $e7d362f04a4204f3$export$c1a21b3b4da66aa1 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars;
    return {
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).dragging}`]: {
            [`& .${(0, $175610683d4083b7$export$2e2bcd8739ae039).thumb}, & .${(0, $175610683d4083b7$export$2e2bcd8739ae039).track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    };
});
const $e7d362f04a4204f3$export$b02fde61a3559c2 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Rail',
    overridesResolver: (props, styles)=>styles.rail
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $e7d362f04a4204f3$export$105594979f116971 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>{
    var _theme$vars3;
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.keys(((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette).filter((key)=>{
                var _theme$vars4;
                return ((_theme$vars4 = theme.vars) != null ? _theme$vars4 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color,
                        track: 'inverted'
                    },
                    style: (0, $8nd05.default)({}, theme.vars ? {
                        backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                        borderColor: theme.vars.palette.Slider[`${color}Track`]
                    } : (0, $8nd05.default)({
                        backgroundColor: (0, $kSnzZ.lighten)(theme.palette[color].main, 0.62),
                        borderColor: (0, $kSnzZ.lighten)(theme.palette[color].main, 0.62)
                    }, theme.applyStyles('dark', {
                        backgroundColor: (0, $kSnzZ.darken)(theme.palette[color].main, 0.5)
                    }), theme.applyStyles('dark', {
                        borderColor: (0, $kSnzZ.darken)(theme.palette[color].main, 0.5)
                    })))
                }))
        ]
    };
});
const $e7d362f04a4204f3$export$2c1b491743890dec = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars5;
    return {
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.keys(((_theme$vars5 = theme.vars) != null ? _theme$vars5 : theme).palette).filter((key)=>{
                var _theme$vars6;
                return ((_theme$vars6 = theme.vars) != null ? _theme$vars6 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${(0, $175610683d4083b7$export$2e2bcd8739ae039).focusVisible}`]: (0, $8nd05.default)({}, theme.vars ? {
                            boxShadow: `0px 0px 0px 8px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                        } : {
                            boxShadow: `0px 0px 0px 8px ${(0, $kSnzZ.alpha)(theme.palette[color].main, 0.16)}`
                        }, {
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        }),
                        [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).active}`]: (0, $8nd05.default)({}, theme.vars ? {
                            boxShadow: `0px 0px 0px 14px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                        } : {
                            boxShadow: `0px 0px 0px 14px ${(0, $kSnzZ.alpha)(theme.palette[color].main, 0.16)}`
                        })
                    }
                }))
        ]
    };
});
const $e7d362f04a4204f3$export$6453176f504d54f0 = (0, $d8seH.default)((0, $1d8e4e584d12bd05$export$2e2bcd8739ae039), {
    name: 'MuiSlider',
    slot: 'ValueLabel',
    overridesResolver: (props, styles)=>styles.valueLabel
})(({ theme: theme })=>(0, $8nd05.default)({
        zIndex: 1,
        whiteSpace: 'nowrap'
    }, theme.typography.body2, {
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    }));
const $e7d362f04a4204f3$export$6f85f6a3c5da6f62 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    }));
const $e7d362f04a4204f3$export$e6cd369965e5aa95 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'markLabelActive',
    overridesResolver: (props, styles)=>styles.markLabel
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body2, {
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    }));
const $e7d362f04a4204f3$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $jTnBY.default)(color)}`,
            size && `size${(0, $jTnBY.default)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, $jTnBY.default)(size)}`,
            color && `thumbColor${(0, $jTnBY.default)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $175610683d4083b7$export$9f59f2622d5cbc2a), classes);
};
const $e7d362f04a4204f3$var$Forward = ({ children: children })=>children;
const $e7d362f04a4204f3$var$Slider = /*#__PURE__*/ $acw62.forwardRef(function Slider(inputProps, ref) {
    var _ref, _slots$root, _ref2, _slots$rail, _ref3, _slots$track, _ref4, _slots$thumb, _ref5, _slots$valueLabel, _ref6, _slots$mark, _ref7, _slots$markLabel, _ref8, _slots$input, _slotProps$root, _slotProps$rail, _slotProps$track, _slotProps$thumb, _slotProps$valueLabel, _slotProps$mark, _slotProps$markLabel, _slotProps$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = 'span', components: components = {}, componentsProps: componentsProps = {}, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, orientation: orientation = 'horizontal', shiftStep: shiftStep = 10, size: size = 'medium', step: step = 1, scale: scale = $e7d362f04a4204f3$var$Identity, slotProps: slotProps, slots: slots, track: track = 'normal', valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $e7d362f04a4204f3$var$Identity } = props, other = (0, $1En50.default)(props, $e7d362f04a4204f3$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    });
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $9e8acd9e5bad7cc4$export$56b2c08e277f365)((0, $8nd05.default)({}, ownerState, {
        rootRef: ref
    }));
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $e7d362f04a4204f3$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $e7d362f04a4204f3$export$c1a21b3b4da66aa1;
    const RailSlot = (_ref2 = (_slots$rail = slots == null ? void 0 : slots.rail) != null ? _slots$rail : components.Rail) != null ? _ref2 : $e7d362f04a4204f3$export$b02fde61a3559c2;
    const TrackSlot = (_ref3 = (_slots$track = slots == null ? void 0 : slots.track) != null ? _slots$track : components.Track) != null ? _ref3 : $e7d362f04a4204f3$export$105594979f116971;
    const ThumbSlot = (_ref4 = (_slots$thumb = slots == null ? void 0 : slots.thumb) != null ? _slots$thumb : components.Thumb) != null ? _ref4 : $e7d362f04a4204f3$export$2c1b491743890dec;
    const ValueLabelSlot = (_ref5 = (_slots$valueLabel = slots == null ? void 0 : slots.valueLabel) != null ? _slots$valueLabel : components.ValueLabel) != null ? _ref5 : $e7d362f04a4204f3$export$6453176f504d54f0;
    const MarkSlot = (_ref6 = (_slots$mark = slots == null ? void 0 : slots.mark) != null ? _slots$mark : components.Mark) != null ? _ref6 : $e7d362f04a4204f3$export$6f85f6a3c5da6f62;
    const MarkLabelSlot = (_ref7 = (_slots$markLabel = slots == null ? void 0 : slots.markLabel) != null ? _slots$markLabel : components.MarkLabel) != null ? _ref7 : $e7d362f04a4204f3$export$e6cd369965e5aa95;
    const InputSlot = (_ref8 = (_slots$input = slots == null ? void 0 : slots.input) != null ? _slots$input : components.Input) != null ? _ref8 : 'input';
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const railSlotProps = (_slotProps$rail = slotProps == null ? void 0 : slotProps.rail) != null ? _slotProps$rail : componentsProps.rail;
    const trackSlotProps = (_slotProps$track = slotProps == null ? void 0 : slotProps.track) != null ? _slotProps$track : componentsProps.track;
    const thumbSlotProps = (_slotProps$thumb = slotProps == null ? void 0 : slotProps.thumb) != null ? _slotProps$thumb : componentsProps.thumb;
    const valueLabelSlotProps = (_slotProps$valueLabel = slotProps == null ? void 0 : slotProps.valueLabel) != null ? _slotProps$valueLabel : componentsProps.valueLabel;
    const markSlotProps = (_slotProps$mark = slotProps == null ? void 0 : slotProps.mark) != null ? _slotProps$mark : componentsProps.mark;
    const markLabelSlotProps = (_slotProps$markLabel = slotProps == null ? void 0 : slotProps.markLabel) != null ? _slotProps$markLabel : componentsProps.markLabel;
    const inputSlotProps = (_slotProps$input = slotProps == null ? void 0 : slotProps.input) != null ? _slotProps$input : componentsProps.input;
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: (0, $8nd05.default)({}, (0, $fef7b1c426e97238$export$2e2bcd8739ae039)(RootSlot) && {
            as: component
        }),
        ownerState: (0, $8nd05.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: (0, $8nd05.default)({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap))
        },
        ownerState: (0, $8nd05.default)({}, ownerState, trackSlotProps == null ? void 0 : trackSlotProps.ownerState),
        className: classes.track
    });
    const thumbProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: (0, $8nd05.default)({}, ownerState, thumbSlotProps == null ? void 0 : thumbSlotProps.ownerState),
        className: classes.thumb
    });
    const valueLabelProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: (0, $8nd05.default)({}, ownerState, valueLabelSlotProps == null ? void 0 : valueLabelSlotProps.ownerState),
        className: classes.valueLabel
    });
    const markProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, (0, $8nd05.default)({}, rootProps, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(RailSlot, (0, $8nd05.default)({}, railProps)),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TrackSlot, (0, $8nd05.default)({}, trackProps)),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $9e8acd9e5bad7cc4$export$83ce4bc8280540e6)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.indexOf(mark.value) !== -1;
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)(MarkSlot, (0, $8nd05.default)({
                            "data-index": index
                        }, markProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(MarkSlot) && {
                            markActive: markActive
                        }, {
                            style: (0, $8nd05.default)({}, style, markProps.style),
                            className: (0, $9QePP.default)(markProps.className, markActive && classes.markActive)
                        })),
                        mark.label != null ? /*#__PURE__*/ (0, $ayMG0.jsx)(MarkLabelSlot, (0, $8nd05.default)({
                            "aria-hidden": true,
                            "data-index": index
                        }, markLabelProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(MarkLabelSlot) && {
                            markLabelActive: markActive
                        }, {
                            style: (0, $8nd05.default)({}, style, markLabelProps.style),
                            className: (0, $9QePP.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        })) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $9e8acd9e5bad7cc4$export$83ce4bc8280540e6)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $e7d362f04a4204f3$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $ayMG0.jsx)(ValueLabelComponent, (0, $8nd05.default)({}, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(ValueLabelComponent) && {
                    valueLabelFormat: valueLabelFormat,
                    valueLabelDisplay: valueLabelDisplay,
                    value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                    index: index,
                    open: open === index || active === index || valueLabelDisplay === 'on',
                    disabled: disabled
                }, valueLabelProps, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(ThumbSlot, (0, $8nd05.default)({
                        "data-index": index
                    }, thumbProps, {
                        className: (0, $9QePP.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: (0, $8nd05.default)({}, style, getThumbStyle(index), thumbProps.style),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, (0, $8nd05.default)({
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index]
                        }, inputSliderProps))
                    }))
                }), index);
            })
        ]
    }));
});
var $e7d362f04a4204f3$export$2e2bcd8739ae039 = $e7d362f04a4204f3$var$Slider;




const $7d26380e8a4c53cc$var$sliderValue = (_ev, newValue)=>typeof newValue === 'number' ? newValue : Math.min(...newValue);
const $7d26380e8a4c53cc$export$f5603a09670563b9 = (ps)=>{
    const range = ps.value.Range;
    switch(range.type){
        case 'Set':
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e7d362f04a4204f3$export$2e2bcd8739ae039), {
                value: ps.value.Value,
                step: null,
                marks: range.Set.map((x)=>({
                        value: x
                    })),
                onChange: (0, $lWM6H.flow)($7d26380e8a4c53cc$var$sliderValue, (0, $lWM6H.constant), ps.update)
            });
        case 'Range':
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e7d362f04a4204f3$export$2e2bcd8739ae039), {
                value: ps.value.Value,
                valueLabelFormat: (val)=>val.toString(),
                valueLabelDisplay: "auto",
                marks: [
                    range.Min,
                    range.Max
                ].map((x)=>({
                        value: x,
                        label: x.toString()
                    })),
                min: range.Min,
                max: range.Max,
                step: range.Step,
                onChange: (0, $lWM6H.flow)($7d26380e8a4c53cc$var$sliderValue, (0, $lWM6H.constant), ps.update)
            });
    }
};
const $7d26380e8a4c53cc$export$37f8f06e2ca92cb5 = (ps)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        item: true,
        className: "variable-editor",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$2e2bcd8739ae039), {
            unit: "inch",
            value: ps.value.Value,
            update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(ps.update, (0, $7aba2092ca2b63b7$export$48ae47e7aac6f7fc)),
            tlabel: ps.value.Names,
            min: ps.value.Range.type === 'Range' ? ps.value.Range.Min : undefined,
            max: ps.value.Range.type === 'Range' ? ps.value.Range.Max : undefined
        })
    });
const $7d26380e8a4c53cc$export$bf898595ac5d35d5 = (ps)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            " ",
            ps.variables.map((variable, i)=>!ps.filterSelected(variable) ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($7d26380e8a4c53cc$export$37f8f06e2ca92cb5, {
                    value: variable,
                    update: (x)=>ps.update((0, $996bbaeec61ffd0f$export$2cd1c249765cd0a4)().index(i).modify(x))
                }, variable.Label)),
            " "
        ]
    });






/**
 * Toggle the value of a boolean.
 */ const $e73bd36ca27436e9$export$e03c1c3201ee8bb7 = (x)=>!x;



const $6595f37001f528be$var$VarOptGroup = (props)=>{
    const { data: data, updateOpts: updateOpts, updateVars: updateVars, update: update } = props;
    const { Items: Items, Label: Label, Names: Names, Fold: Fold } = data;
    const isOption = (ps)=>ps.Type === 'Opts';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
        expanded: !Fold,
        style: {
            marginBottom: '12px'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                "aria-controls": "panel1d-content",
                onClick: (0, $d9f4ffa0bf773b73$export$49ac4be000c880a7)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $7aba2092ca2b63b7$export$2bb609461ec3cd2c)), (0, $e73bd36ca27436e9$export$e03c1c3201ee8bb7)),
                expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {
                    style: {
                        cursor: 'pointer'
                    }
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    children: Names.eng ?? Label
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 2,
                    className: "variable-editor",
                    children: Items.map((ps)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 6,
                            children: isOption(ps) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $111aab76558170aa$export$91db2342be6956eb), {
                                update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(updateOpts, (0, $58f80d7b57eba59b$export$b610b8812bbcded9)(ps.ArrIndex)),
                                value: ps
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d26380e8a4c53cc$export$37f8f06e2ca92cb5), {
                                update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(updateVars, (0, $58f80d7b57eba59b$export$b610b8812bbcded9)(ps.ArrIndex)),
                                value: ps
                            })
                        }, ps.Label))
                })
            })
        ]
    });
};
const $6595f37001f528be$var$VarOptLayout = (props)=>{
    const { update: update, value: value } = props;
    const { Opts: Opts, Vars: Vars, Groups: Groups } = value;
    const layoutData = (0, $acw62.useMemo)(()=>{
        const newVars = Vars.map((variable, ArrIndex)=>({
                ...variable,
                Type: 'Vars',
                ArrIndex: ArrIndex
            })).filter((variable)=>(0, $9e60ae4352b3f8e8$export$cae9ccc5485bbb97)(value)(variable));
        const newOpts = Opts.map((opt, ArrIndex)=>({
                ...opt,
                Type: 'Opts',
                ArrIndex: ArrIndex
            })).filter((opt)=>(0, $9e60ae4352b3f8e8$export$c1ee70c24c083802)(value)(opt));
        return Groups.map((group)=>{
            const newItems = group.Items.map((item)=>{
                if (item.type === 'Opt') {
                    const opt = newOpts.find((opt)=>opt.Label === item.Label);
                    if (opt) return {
                        ...opt,
                        Type: 'Opts'
                    };
                } else if (item.type === 'Var') {
                    const varb = newVars.find((varb)=>varb.Label === item.Label);
                    if (varb) return {
                        ...varb,
                        Type: 'Vars'
                    };
                }
                return null;
            }).filter((item)=>item !== null);
            return {
                ...group,
                Items: newItems
            };
        });
    }, [
        Groups,
        Opts,
        Vars,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        children: layoutData.map((elm, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($6595f37001f528be$var$VarOptGroup, {
                data: elm,
                update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $7aba2092ca2b63b7$export$726ca57390740b07), (0, $58f80d7b57eba59b$export$b610b8812bbcded9)(i)),
                updateOpts: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $7aba2092ca2b63b7$export$e8b49a33e60fbb5b)),
                updateVars: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $7aba2092ca2b63b7$export$3e7d364af758ed31))
            }, elm.Label))
    });
};
var $6595f37001f528be$export$2e2bcd8739ae039 = $6595f37001f528be$var$VarOptLayout;


const $9e60ae4352b3f8e8$var$isSelected = (opts)=>(optLabel)=>(entLabel)=>{
            const opt = opts.find((opt)=>opt.Label === optLabel);
            if (opt === undefined) return false;
            return opt.Value === entLabel;
        };
const $9e60ae4352b3f8e8$export$c1ee70c24c083802 = (tmpl)=>(opt)=>opt.Range.length > 1 && (0, $b0dad51325a37f96$export$8caee5e3bee8beba)($9e60ae4352b3f8e8$var$isSelected(tmpl.Opts))(opt.Depends);
const $9e60ae4352b3f8e8$export$cae9ccc5485bbb97 = (tmpl)=>(v)=>(0, $b0dad51325a37f96$export$8caee5e3bee8beba)($9e60ae4352b3f8e8$var$isSelected(tmpl.Opts))(v.Depends);
const $9e60ae4352b3f8e8$export$3c1e22b6b65f964a = (tmpl)=>{
    const sOpts = tmpl.Opts.filter((opt)=>$9e60ae4352b3f8e8$export$c1ee70c24c083802(tmpl)(opt)).map((o)=>[
            o.Label,
            o.Value
        ]);
    const sVars = tmpl.Vars.filter((opt)=>$9e60ae4352b3f8e8$export$cae9ccc5485bbb97(tmpl)(opt)).map((o)=>[
            o.Label,
            o.Value
        ]);
    return Object.assign({}, Object.fromEntries(sOpts), Object.fromEntries(sVars));
};
const $9e60ae4352b3f8e8$export$72b66677513e0cef = (props)=>{
    const { req: req, template: template, update: update } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: `scroll ${$008ce9c6b88a8ccc$export$4997ffc0176396a6}`,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: $008ce9c6b88a8ccc$export$b5d042d2b680aed6,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: $008ce9c6b88a8ccc$export$7dea6024c4894e8e,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8fc20d6ff1f2aab1$export$7370d7aaa0be7e8a), {
                        req: req,
                        template: template
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: $008ce9c6b88a8ccc$export$41c562ebe57d11e2,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6595f37001f528be$export$2e2bcd8739ae039), {
                        value: template,
                        update: update
                    })
                })
            ]
        })
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $6e2c64b122bb044a$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($6e2c64b122bb044a$exports, "__esModule", {
    value: true
});
$6e2c64b122bb044a$exports.default = void 0;

var $6e2c64b122bb044a$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $6e2c64b122bb044a$var$_default = $6e2c64b122bb044a$exports.default = (0, $6e2c64b122bb044a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92"
}), 'Share');





var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $f0f105dbd8c07c9e$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $f0f105dbd8c07c9e$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $acw62.useRef(false);
    const nodeRef = $acw62.useRef(null);
    const activatedRef = $acw62.useRef(false);
    const syntheticEventRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $acw62.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $acw62.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(children, childrenProps)
    });
}


const $26e52460a9367d20$export$7cfbf1907dc1f7ce = (ps)=>{
    const [copied, setCopied] = (0, $acw62.useState)('');
    const [clicked, setClicked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const copyToClipboard = (text)=>{
        navigator.clipboard.writeText(text);
        setCopied('Copied: ' + text);
        setClicked(true);
    };
    const handleTooltipClose = ()=>{
        setClicked(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0f105dbd8c07c9e$export$58385c17fee43f89), {
        onClickAway: handleTooltipClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
            title: copied,
            PopperProps: {
                disablePortal: true
            },
            onClose: handleTooltipClose,
            open: clicked,
            disableFocusListener: true,
            disableHoverListener: true,
            disableTouchListener: true,
            arrow: true,
            placement: "top",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                    title: clicked ? '' : 'Share URL',
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                        size: ps.size ?? 'large',
                        component: "span",
                        color: "info",
                        onClick: ()=>{
                            copyToClipboard(ps.url ?? window.location.href);
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6e2c64b122bb044a$exports))), {
                            fontSize: "inherit"
                        })
                    })
                })
            })
        })
    });
};





var $acw62 = parcelRequire("acw62");



const $959a02c4a2a54235$export$f2dd2e22e9fc297 = (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c);
const $959a02c4a2a54235$export$dd0a697e1782aedd = ()=>{
    const { search: search } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const current = $acw62.useMemo(()=>Object.fromEntries(new URLSearchParams(search).entries()), [
        search
    ]);
    const nav = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const update = $acw62.useMemo(()=>(f)=>nav($959a02c4a2a54235$export$da99e50c1f5e8cc8(f(current))), [
        nav,
        current
    ]);
    return [
        current,
        update
    ];
};
const $959a02c4a2a54235$export$da99e50c1f5e8cc8 = (qs)=>'?' + Object.entries(qs).filter((x)=>x[1] !== undefined).map(([k, v])=>encodeURIComponent(k) + (v === '' ? '' : '=' + encodeURIComponent(v))).join('&');
const $959a02c4a2a54235$export$2345a338db110003 = (key)=>{
    const [queries, updateQueries] = $959a02c4a2a54235$export$dd0a697e1782aedd();
    const current = queries[key];
    const update = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(updateQueries, $959a02c4a2a54235$export$f2dd2e22e9fc297(key));
    return [
        current,
        update
    ];
};






const $19c5105eb59307a3$var$TemplatePage = (props)=>{
    const { req: req } = props;
    const [template, updateTemplate] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const [limits, setLimits] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const [serverTemplates, setServerTemplates] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [queries, updateQueries] = (0, $959a02c4a2a54235$export$dd0a697e1782aedd)();
    const templateId = queries['id'];
    const updateTemplateId = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(updateQueries, (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('id'));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        (0, $d807307be9b2068b$export$8837f4fc672e936d)(req)().then(setServerTemplates).catch(console.warn);
    }, [
        req
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        updateTemplate(serverTemplates.find((t)=>t.Id === templateId));
    }, [
        serverTemplates,
        templateId
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `${$2daa5edab02aa632$export$ce69bd05624d0c48}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $efbb6eb46c8dd746$export$bfbece8a621a006f), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $437a2d9ce62cfb25$export$d0dbb306591aec74), {
                        codec: (0, $6689c5083829c982$export$14416b8d99d47caa),
                        name: "Template",
                        success: updateTemplate,
                        failure: (e)=>{
                            alert('Import failed, check console for details.');
                            console.warn(e);
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a29c4ff9777c8b77$export$f883e605db67eacf), {
                        name: "Template",
                        getContent: ()=>template,
                        onError: (e)=>{
                            alert('Export failed, check console for details.');
                            console.warn(e);
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$2e2bcd8739ae039), {
                        size: "small",
                        value: templateId ?? '',
                        update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(updateTemplateId, (0, $58f80d7b57eba59b$export$36faa878fcded3d7)('')),
                        items: (0, $ff8824db188fc32d$export$650746792cd2f81e)((0, $6689c5083829c982$export$34f8187f64e206fc))(serverTemplates)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                        size: "small",
                        value: limits ?? '',
                        label: "Limit Id",
                        variant: "outlined",
                        onChange: (ev)=>setLimits(ev.target.value == '' ? undefined : ev.target.value)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26e52460a9367d20$export$7cfbf1907dc1f7ce), {
                        size: "small"
                    })
                ]
            }),
            template ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9e60ae4352b3f8e8$export$72b66677513e0cef), {
                req: req,
                limits: limits,
                template: template,
                update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(updateTemplate, (0, $58f80d7b57eba59b$export$f8b8b9ce72e9ccbf))
            }) : null
        ]
    });
};
var $19c5105eb59307a3$export$2e2bcd8739ae039 = $19c5105eb59307a3$var$TemplatePage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/**
 * Building Raw Templates and getting information about them.
 *
 * @since 0.4.0
 */ 

const $d6e5c187599ae786$export$8837f4fc672e936d = (req)=>req.request((0, $87701c398fec8638$export$2f23118c22fb2630)((0, $6689c5083829c982$export$14416b8d99d47caa)))('template/list/raw', 'GET');
const $d6e5c187599ae786$export$d3fb956c8894134 = (req)=>(id)=>req.request((0, $6689c5083829c982$export$14416b8d99d47caa))(`template/list/raw/${id}`, 'GET');


/**
 * Building Templates and getting information about them.
 *
 * @since 0.4.0
 */ 

/**
 * ClientTemplateMod.
 *
 * @since 0.1.0
 */ 

/**
 * TemplatemMod.
 *
 */ 



const $3b87c0061540a0d6$export$9c2b743e92dc6556 = (0, $b0dad51325a37f96$export$fbbf45eff21470e3);
const $3b87c0061540a0d6$export$8b63f23087e3f850 = (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    (0, $87701c398fec8638$export$22b082955e083ec3),
    (0, $87701c398fec8638$export$1db45310990710a5)
]));
const $3b87c0061540a0d6$export$af248ec75d29d611 = (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        (0, $a968eea762bc3488$export$1f12680e68c5100d),
        (0, $87701c398fec8638$export$1db45310990710a5)
    ])),
    (0, $87701c398fec8638$export$1db45310990710a5)
]));
const $3b87c0061540a0d6$export$c73f84b8e85c3a26 = (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    (0, $87701c398fec8638$export$98e628dec113755e),
    (0, $87701c398fec8638$export$1db45310990710a5)
]));
const $3b87c0061540a0d6$export$6a741c5df95f09bf = (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    (0, $87701c398fec8638$export$22b082955e083ec3),
    (0, $87701c398fec8638$export$9d93593e0583cfae),
    (0, $87701c398fec8638$export$1db45310990710a5)
]));
const $3b87c0061540a0d6$export$2b672c515beef1fc = (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    (0, $a968eea762bc3488$export$1f12680e68c5100d),
    (0, $87701c398fec8638$export$1db45310990710a5)
]));
const $3b87c0061540a0d6$export$67d79864d6f80b36 = (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    (0, $a968eea762bc3488$export$1f12680e68c5100d),
    (0, $87701c398fec8638$export$1db45310990710a5)
]));
const $3b87c0061540a0d6$export$7dbd86a3f9d9b5b8 = (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    (0, $87701c398fec8638$export$98e628dec113755e),
    (0, $87701c398fec8638$export$1db45310990710a5)
]));
const $3b87c0061540a0d6$export$9d21bfc71a6f5176 = (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    (0, $87701c398fec8638$export$98e628dec113755e),
    (0, $87701c398fec8638$export$1db45310990710a5)
]));
const $3b87c0061540a0d6$export$e2c6322cb5c0e435 = (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    (0, $d92db2d2d4e06f06$export$9a58ef0d7ad3278c),
    (0, $87701c398fec8638$export$1db45310990710a5)
]));
const $3b87c0061540a0d6$export$e1223450ab6747ef = (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        (0, $87701c398fec8638$export$98e628dec113755e),
        (0, $87701c398fec8638$export$1db45310990710a5)
    ])),
    (0, $87701c398fec8638$export$1db45310990710a5)
]));
const $3b87c0061540a0d6$export$9f085383702ef11d = (0, $87701c398fec8638$export$e45945969df8035a)({
    Specialization: $3b87c0061540a0d6$export$9c2b743e92dc6556,
    SpaceCollateChange: $3b87c0061540a0d6$export$6a741c5df95f09bf,
    SpaceRestrict: (0, $87701c398fec8638$export$2f23118c22fb2630)((0, $87701c398fec8638$export$22b082955e083ec3)),
    OptionSelection: $3b87c0061540a0d6$export$8b63f23087e3f850,
    OptionNamesChange: $3b87c0061540a0d6$export$af248ec75d29d611,
    OptionRank: $3b87c0061540a0d6$export$e1223450ab6747ef,
    VariableCollateChange: $3b87c0061540a0d6$export$6a741c5df95f09bf,
    VariableSelection: $3b87c0061540a0d6$export$c73f84b8e85c3a26,
    VariableNames: $3b87c0061540a0d6$export$2b672c515beef1fc,
    SpaceNames: $3b87c0061540a0d6$export$67d79864d6f80b36,
    SpaceRank: $3b87c0061540a0d6$export$7dbd86a3f9d9b5b8,
    VariableRank: $3b87c0061540a0d6$export$9d21bfc71a6f5176,
    VariableRange: $3b87c0061540a0d6$export$e2c6322cb5c0e435
});


const $35ad564717de6617$export$ef9948ed0b4750df = {
    backsplash: {
        eng: 'Backsplash'
    },
    mirror: {
        eng: 'Mirror'
    },
    misc: {
        eng: 'Miscellaneous'
    },
    multimirror: {
        eng: 'Multiple Mirrors'
    },
    panel: {
        eng: 'Panel'
    },
    shelf: {
        eng: 'Shelf'
    },
    shower: {
        eng: 'Shower'
    },
    tabletop: {
        eng: 'Tabletop'
    }
};
const $35ad564717de6617$export$1107df4484a88f75 = Object.entries($35ad564717de6617$export$ef9948ed0b4750df).map(([key, names])=>({
        key: key,
        names: names
    }));
const $35ad564717de6617$export$9484bbecc3c49a2e = (0, $87701c398fec8638$export$7e1278799275f68e)($35ad564717de6617$export$ef9948ed0b4750df);
const $35ad564717de6617$export$46b83a6aabf254e3 = (x)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        _: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)(x),
        Id: (0, $87701c398fec8638$export$22b082955e083ec3)
    });
const $35ad564717de6617$export$40d515e766fe3b8a = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    ClientTemplateId: (0, $87701c398fec8638$export$22b082955e083ec3)
});
const $35ad564717de6617$export$53fe0590be79e915 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    ModId: (0, $87701c398fec8638$export$22b082955e083ec3)
});
const $35ad564717de6617$export$fe503af3b01854cb = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    $35ad564717de6617$export$40d515e766fe3b8a,
    $35ad564717de6617$export$53fe0590be79e915
]);
const $35ad564717de6617$export$d1c678fba33e7572 = (0, $87701c398fec8638$export$bc86dfbf7795668c)([
    (0, $87701c398fec8638$export$bf9fb029d174d554)({
        Id: (0, $87701c398fec8638$export$22b082955e083ec3),
        UserId: (0, $87701c398fec8638$export$22b082955e083ec3),
        Mode: $35ad564717de6617$export$9484bbecc3c49a2e,
        ModTemplate: (0, $3b87c0061540a0d6$export$9f085383702ef11d),
        NamesChange: (0, $a968eea762bc3488$export$1f12680e68c5100d)
    }),
    (0, $87701c398fec8638$export$e45945969df8035a)({
        ImageChange: (0, $87701c398fec8638$export$22b082955e083ec3)
    }),
    $35ad564717de6617$export$fe503af3b01854cb
]);


const $95ca87e0634ad264$export$d45a3e91f7dd14d0 = (req)=>req.request((0, $87701c398fec8638$export$2f23118c22fb2630)((0, $35ad564717de6617$export$d1c678fba33e7572)))('template/mod', 'GET');
const $95ca87e0634ad264$export$3fb70f395745212d = (req)=>(clientTemplateMod)=>req.request((0, $6689c5083829c982$export$14416b8d99d47caa))('template/mod', 'POST', clientTemplateMod);
const $95ca87e0634ad264$export$3b2bd3b309bebc94 = (req)=>(clientTemplateMod)=>req.request((0, $35ad564717de6617$export$d1c678fba33e7572))('template/mod', 'PUT', clientTemplateMod);





var $ayMG0 = parcelRequire("ayMG0");

var $lWM6H = parcelRequire("lWM6H");

var $5OFXS = parcelRequire("5OFXS");

var $fWUU5 = parcelRequire("fWUU5");
var $c5dd58add12ba066$exports = {};
"use strict";
var $c5dd58add12ba066$var$__createBinding = $c5dd58add12ba066$exports && $c5dd58add12ba066$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c5dd58add12ba066$var$__setModuleDefault = $c5dd58add12ba066$exports && $c5dd58add12ba066$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c5dd58add12ba066$var$__importStar = $c5dd58add12ba066$exports && $c5dd58add12ba066$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c5dd58add12ba066$var$__createBinding(result, mod, k);
    }
    $c5dd58add12ba066$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c5dd58add12ba066$exports, "__esModule", {
    value: true
});
$c5dd58add12ba066$exports.identity = $c5dd58add12ba066$exports.chain = $c5dd58add12ba066$exports.apS = $c5dd58add12ba066$exports.bind = $c5dd58add12ba066$exports.let = $c5dd58add12ba066$exports.bindTo = $c5dd58add12ba066$exports.Do = $c5dd58add12ba066$exports.ChainRec = $c5dd58add12ba066$exports.Comonad = $c5dd58add12ba066$exports.Alt = $c5dd58add12ba066$exports.Traversable = $c5dd58add12ba066$exports.Foldable = $c5dd58add12ba066$exports.chainFirst = $c5dd58add12ba066$exports.tap = $c5dd58add12ba066$exports.Monad = $c5dd58add12ba066$exports.Chain = $c5dd58add12ba066$exports.Applicative = $c5dd58add12ba066$exports.apSecond = $c5dd58add12ba066$exports.apFirst = $c5dd58add12ba066$exports.Apply = $c5dd58add12ba066$exports.Pointed = $c5dd58add12ba066$exports.flap = $c5dd58add12ba066$exports.Functor = $c5dd58add12ba066$exports.getEq = $c5dd58add12ba066$exports.getShow = $c5dd58add12ba066$exports.URI = $c5dd58add12ba066$exports.alt = $c5dd58add12ba066$exports.altW = $c5dd58add12ba066$exports.sequence = $c5dd58add12ba066$exports.traverse = $c5dd58add12ba066$exports.reduceRight = $c5dd58add12ba066$exports.foldMap = $c5dd58add12ba066$exports.reduce = $c5dd58add12ba066$exports.flatten = $c5dd58add12ba066$exports.duplicate = $c5dd58add12ba066$exports.extract = $c5dd58add12ba066$exports.extend = $c5dd58add12ba066$exports.flatMap = $c5dd58add12ba066$exports.of = $c5dd58add12ba066$exports.ap = $c5dd58add12ba066$exports.map = void 0;

var $4sfjE = parcelRequire("4sfjE");

var $ERVGH = parcelRequire("ERVGH");

var $ek0ul = parcelRequire("ek0ul");

var $3abDJ = parcelRequire("3abDJ");

var $emm1u = parcelRequire("emm1u");

var $c5dd58add12ba066$var$_ = $c5dd58add12ba066$var$__importStar((parcelRequire("704qB")));
var $c5dd58add12ba066$var$_map = function(fa, f) {
    return (0, $3abDJ.pipe)(fa, (0, $c5dd58add12ba066$exports.map)(f));
};
var $c5dd58add12ba066$var$_ap = function(fab, fa) {
    return (0, $3abDJ.pipe)(fab, (0, $c5dd58add12ba066$exports.ap)(fa));
};
/* istanbul ignore next */ var $c5dd58add12ba066$var$_reduce = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, $c5dd58add12ba066$exports.reduce)(b, f));
};
/* istanbul ignore next */ var $c5dd58add12ba066$var$_foldMap = function(M) {
    return function(fa, f) {
        return (0, $3abDJ.pipe)(fa, (0, $c5dd58add12ba066$exports.foldMap)(M)(f));
    };
};
/* istanbul ignore next */ var $c5dd58add12ba066$var$_reduceRight = function(fa, b, f) {
    return (0, $3abDJ.pipe)(fa, (0, $c5dd58add12ba066$exports.reduceRight)(b, f));
};
/* istanbul ignore next */ var $c5dd58add12ba066$var$_alt = function(fa, that) {
    return (0, $3abDJ.pipe)(fa, (0, $c5dd58add12ba066$exports.alt)(that));
};
/* istanbul ignore next */ var $c5dd58add12ba066$var$_extend = function(wa, f) {
    return (0, $3abDJ.pipe)(wa, (0, $c5dd58add12ba066$exports.extend)(f));
};
/* istanbul ignore next */ var $c5dd58add12ba066$var$_traverse = function(F) {
    var traverseF = (0, $c5dd58add12ba066$exports.traverse)(F);
    return function(ta, f) {
        return (0, $3abDJ.pipe)(ta, traverseF(f));
    };
};
var $c5dd58add12ba066$var$_chainRec = $ek0ul.tailRec;
/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
 * use the type constructor `F` to represent some computational context.
 *
 * @category mapping
 * @since 2.0.0
 */ var $c5dd58add12ba066$var$map = function(f) {
    return function(fa) {
        return f(fa);
    };
};
$c5dd58add12ba066$exports.map = $c5dd58add12ba066$var$map;
/**
 * @since 2.0.0
 */ var $c5dd58add12ba066$var$ap = function(fa) {
    return function(fab) {
        return fab(fa);
    };
};
$c5dd58add12ba066$exports.ap = $c5dd58add12ba066$var$ap;
/**
 * @category constructors
 * @since 2.0.0
 */ $c5dd58add12ba066$exports.of = $3abDJ.identity;
/**
 * @category sequencing
 * @since 2.14.0
 */ $c5dd58add12ba066$exports.flatMap = (0, $3abDJ.dual)(2, function(ma, f) {
    return f(ma);
});
/**
 * @since 2.0.0
 */ var $c5dd58add12ba066$var$extend = function(f) {
    return function(wa) {
        return f(wa);
    };
};
$c5dd58add12ba066$exports.extend = $c5dd58add12ba066$var$extend;
/**
 * @category Extract
 * @since 2.6.2
 */ $c5dd58add12ba066$exports.extract = $3abDJ.identity;
/**
 * @since 2.0.0
 */ $c5dd58add12ba066$exports.duplicate = (0, $c5dd58add12ba066$exports.extend)($3abDJ.identity);
/**
 * @category sequencing
 * @since 2.0.0
 */ $c5dd58add12ba066$exports.flatten = (0, $c5dd58add12ba066$exports.flatMap)($3abDJ.identity);
/**
 * @category folding
 * @since 2.0.0
 */ var $c5dd58add12ba066$var$reduce = function(b, f) {
    return function(fa) {
        return f(b, fa);
    };
};
$c5dd58add12ba066$exports.reduce = $c5dd58add12ba066$var$reduce;
/**
 * @category folding
 * @since 2.0.0
 */ var $c5dd58add12ba066$var$foldMap = function() {
    return function(f) {
        return function(fa) {
            return f(fa);
        };
    };
};
$c5dd58add12ba066$exports.foldMap = $c5dd58add12ba066$var$foldMap;
/**
 * @category folding
 * @since 2.0.0
 */ var $c5dd58add12ba066$var$reduceRight = function(b, f) {
    return function(fa) {
        return f(fa, b);
    };
};
$c5dd58add12ba066$exports.reduceRight = $c5dd58add12ba066$var$reduceRight;
/**
 * @category traversing
 * @since 2.6.3
 */ var $c5dd58add12ba066$var$traverse = function(F) {
    return function(f) {
        return function(ta) {
            return F.map(f(ta), $3abDJ.identity);
        };
    };
};
$c5dd58add12ba066$exports.traverse = $c5dd58add12ba066$var$traverse;
/**
 * @category traversing
 * @since 2.6.3
 */ var $c5dd58add12ba066$var$sequence = function(F) {
    return function(ta) {
        return F.map(ta, $3abDJ.identity);
    };
};
$c5dd58add12ba066$exports.sequence = $c5dd58add12ba066$var$sequence;
/**
 * Less strict version of [`alt`](#alt).
 *
 * The `W` suffix (short for **W**idening) means that the return types will be merged.
 *
 * @category error handling
 * @since 2.9.0
 */ var $c5dd58add12ba066$var$altW = function() {
    return $3abDJ.identity;
};
$c5dd58add12ba066$exports.altW = $c5dd58add12ba066$var$altW;
/**
 * Identifies an associative operation on a type constructor. It is similar to `Semigroup`, except that it applies to
 * types of kind `* -> *`.
 *
 * @category error handling
 * @since 2.0.0
 */ $c5dd58add12ba066$exports.alt = $c5dd58add12ba066$exports.altW;
/**
 * @category type lambdas
 * @since 2.0.0
 */ $c5dd58add12ba066$exports.URI = 'Identity';
/**
 * @category instances
 * @since 2.0.0
 */ $c5dd58add12ba066$exports.getShow = $3abDJ.identity;
/**
 * @category instances
 * @since 2.0.0
 */ $c5dd58add12ba066$exports.getEq = $3abDJ.identity;
/**
 * @category instances
 * @since 2.7.0
 */ $c5dd58add12ba066$exports.Functor = {
    URI: $c5dd58add12ba066$exports.URI,
    map: $c5dd58add12ba066$var$_map
};
/**
 * @category mapping
 * @since 2.10.0
 */ $c5dd58add12ba066$exports.flap = (0, $emm1u.flap)($c5dd58add12ba066$exports.Functor);
/**
 * @category instances
 * @since 2.10.0
 */ $c5dd58add12ba066$exports.Pointed = {
    URI: $c5dd58add12ba066$exports.URI,
    of: $c5dd58add12ba066$exports.of
};
/**
 * @category instances
 * @since 2.10.0
 */ $c5dd58add12ba066$exports.Apply = {
    URI: $c5dd58add12ba066$exports.URI,
    map: $c5dd58add12ba066$var$_map,
    ap: $c5dd58add12ba066$var$_ap
};
/**
 * Combine two effectful actions, keeping only the result of the first.
 *
 * @since 2.0.0
 */ $c5dd58add12ba066$exports.apFirst = (0, $4sfjE.apFirst)($c5dd58add12ba066$exports.Apply);
/**
 * Combine two effectful actions, keeping only the result of the second.
 *
 * @since 2.0.0
 */ $c5dd58add12ba066$exports.apSecond = (0, $4sfjE.apSecond)($c5dd58add12ba066$exports.Apply);
/**
 * @category instances
 * @since 2.7.0
 */ $c5dd58add12ba066$exports.Applicative = {
    URI: $c5dd58add12ba066$exports.URI,
    map: $c5dd58add12ba066$var$_map,
    ap: $c5dd58add12ba066$var$_ap,
    of: $c5dd58add12ba066$exports.of
};
/**
 * @category instances
 * @since 2.10.0
 */ $c5dd58add12ba066$exports.Chain = {
    URI: $c5dd58add12ba066$exports.URI,
    map: $c5dd58add12ba066$var$_map,
    ap: $c5dd58add12ba066$var$_ap,
    chain: $c5dd58add12ba066$exports.flatMap
};
/**
 * @category instances
 * @since 2.7.0
 */ $c5dd58add12ba066$exports.Monad = {
    URI: $c5dd58add12ba066$exports.URI,
    map: $c5dd58add12ba066$var$_map,
    ap: $c5dd58add12ba066$var$_ap,
    of: $c5dd58add12ba066$exports.of,
    chain: $c5dd58add12ba066$exports.flatMap
};
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation and
 * keeping only the result of the first.
 *
 * @category combinators
 * @since 2.16.7
 */ $c5dd58add12ba066$exports.tap = (0, $3abDJ.dual)(2, (0, $ERVGH.tap)($c5dd58add12ba066$exports.Chain));
/**
 * Alias of `tap`
 *
 * @category legacy
 * @since 2.0.0
 */ $c5dd58add12ba066$exports.chainFirst = $c5dd58add12ba066$exports.tap;
/**
 * @category instances
 * @since 2.7.0
 */ $c5dd58add12ba066$exports.Foldable = {
    URI: $c5dd58add12ba066$exports.URI,
    reduce: $c5dd58add12ba066$var$_reduce,
    foldMap: $c5dd58add12ba066$var$_foldMap,
    reduceRight: $c5dd58add12ba066$var$_reduceRight
};
/**
 * @category instances
 * @since 2.7.0
 */ $c5dd58add12ba066$exports.Traversable = {
    URI: $c5dd58add12ba066$exports.URI,
    map: $c5dd58add12ba066$var$_map,
    reduce: $c5dd58add12ba066$var$_reduce,
    foldMap: $c5dd58add12ba066$var$_foldMap,
    reduceRight: $c5dd58add12ba066$var$_reduceRight,
    traverse: $c5dd58add12ba066$var$_traverse,
    sequence: $c5dd58add12ba066$exports.sequence
};
/**
 * @category instances
 * @since 2.7.0
 */ $c5dd58add12ba066$exports.Alt = {
    URI: $c5dd58add12ba066$exports.URI,
    map: $c5dd58add12ba066$var$_map,
    alt: $c5dd58add12ba066$var$_alt
};
/**
 * @category instances
 * @since 2.7.0
 */ $c5dd58add12ba066$exports.Comonad = {
    URI: $c5dd58add12ba066$exports.URI,
    map: $c5dd58add12ba066$var$_map,
    extend: $c5dd58add12ba066$var$_extend,
    extract: $c5dd58add12ba066$exports.extract
};
/**
 * @category instances
 * @since 2.7.0
 */ $c5dd58add12ba066$exports.ChainRec = {
    URI: $c5dd58add12ba066$exports.URI,
    map: $c5dd58add12ba066$var$_map,
    ap: $c5dd58add12ba066$var$_ap,
    chain: $c5dd58add12ba066$exports.flatMap,
    chainRec: $c5dd58add12ba066$var$_chainRec
};
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * @category do notation
 * @since 2.9.0
 */ $c5dd58add12ba066$exports.Do = (0, $c5dd58add12ba066$exports.of)($c5dd58add12ba066$var$_.emptyRecord);
/**
 * @category do notation
 * @since 2.8.0
 */ $c5dd58add12ba066$exports.bindTo = (0, $emm1u.bindTo)($c5dd58add12ba066$exports.Functor);
var $c5dd58add12ba066$var$let_ = /*#__PURE__*/ (0, $emm1u.let)($c5dd58add12ba066$exports.Functor);
$c5dd58add12ba066$exports.let = $c5dd58add12ba066$var$let_;
/**
 * @category do notation
 * @since 2.8.0
 */ $c5dd58add12ba066$exports.bind = (0, $ERVGH.bind)($c5dd58add12ba066$exports.Chain);
/**
 * @category do notation
 * @since 2.8.0
 */ $c5dd58add12ba066$exports.apS = (0, $4sfjE.apS)($c5dd58add12ba066$exports.Apply);
// -------------------------------------------------------------------------------------
// legacy
// -------------------------------------------------------------------------------------
/**
 * Alias of `flatMap`.
 *
 * @category legacy
 * @since 2.0.0
 */ $c5dd58add12ba066$exports.chain = $c5dd58add12ba066$exports.flatMap;
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * This instance is deprecated, use small, specific instances instead.
 * For example if a function needs a `Functor` instance, pass `I.Functor` instead of `I.identity`
 * (where `I` is from `import I from 'fp-ts/Identity'`)
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ $c5dd58add12ba066$exports.identity = {
    URI: $c5dd58add12ba066$exports.URI,
    map: $c5dd58add12ba066$var$_map,
    ap: $c5dd58add12ba066$var$_ap,
    of: $c5dd58add12ba066$exports.of,
    chain: $c5dd58add12ba066$exports.flatMap,
    reduce: $c5dd58add12ba066$var$_reduce,
    foldMap: $c5dd58add12ba066$var$_foldMap,
    reduceRight: $c5dd58add12ba066$var$_reduceRight,
    traverse: $c5dd58add12ba066$var$_traverse,
    sequence: $c5dd58add12ba066$exports.sequence,
    alt: $c5dd58add12ba066$var$_alt,
    extract: $c5dd58add12ba066$exports.extract,
    extend: $c5dd58add12ba066$var$_extend,
    chainRec: $c5dd58add12ba066$var$_chainRec
};



/**
 * Optics for Range.
 *
 */ 
var $kisy7 = parcelRequire("kisy7");

var $hBXBN = parcelRequire("hBXBN");

/**
 * Option for Range of type `Range`
 *
 * @category Range
 */ const $6eb8181ce6d386db$var$getOptionRangeRange = (variableRange)=>variableRange.type === 'Range' ? $hBXBN.some(variableRange) : $hBXBN.none;
/**
 * Return RangeRange if the type is `Range`
 *
 * @category Range
 */ const $6eb8181ce6d386db$var$setRangeRange = (rangeRange)=>(range)=>rangeRange.type === 'Range' ? rangeRange : range;
const $6eb8181ce6d386db$export$41ee82b435e20826 = new (0, $kisy7.Optional)($6eb8181ce6d386db$var$getOptionRangeRange, $6eb8181ce6d386db$var$setRangeRange);
/**
 * Option for Range of type `Set`
 *
 * @category Range
 */ const $6eb8181ce6d386db$var$getOptionRangeSet = (variableRange)=>variableRange.type === 'Set' ? $hBXBN.some(variableRange) : $hBXBN.none;
/**
 * Return RangeSet if the type is `Range`
 *
 * @category Range
 */ const $6eb8181ce6d386db$var$setRangeSet = (rangeSet)=>(range)=>rangeSet.type === 'Set' ? rangeSet : range;
const $6eb8181ce6d386db$export$1d5b14212ce5e4ef = new (0, $kisy7.Optional)($6eb8181ce6d386db$var$getOptionRangeSet, $6eb8181ce6d386db$var$setRangeSet);
const $6eb8181ce6d386db$export$10959f32198b5037 = (0, $kisy7.Lens).fromProp()('Set');
const $6eb8181ce6d386db$export$57dff6df397369f6 = (0, $kisy7.Lens).fromProp()('Step');
const $6eb8181ce6d386db$export$9fe3358555274cc = $6eb8181ce6d386db$export$41ee82b435e20826.composeLens($6eb8181ce6d386db$export$57dff6df397369f6);
const $6eb8181ce6d386db$export$3096b23ac798df78 = (0, $kisy7.Lens).fromProp()('Max');
const $6eb8181ce6d386db$export$51f1ef0d27a29e7d = (0, $kisy7.Lens).fromProp()('Min');
const $6eb8181ce6d386db$export$c0342efd730e1b74 = $6eb8181ce6d386db$export$41ee82b435e20826.composeLens($6eb8181ce6d386db$export$51f1ef0d27a29e7d);
const $6eb8181ce6d386db$export$de339beb88c783ce = $6eb8181ce6d386db$export$41ee82b435e20826.composeLens($6eb8181ce6d386db$export$3096b23ac798df78);
const $6eb8181ce6d386db$export$31564b4caa3d7990 = (value)=>$6eb8181ce6d386db$export$10959f32198b5037.composeTraversal((0, $1379b6c01f560d41$export$b69442bcc2eaec57)).composePrism((0, $1379b6c01f560d41$export$d25223d48e034add)(value));


/**
 * Optics for TemplateMod.
 *
 */ 
var $kisy7 = parcelRequire("kisy7");



const $1225e12c9d6c4c58$export$2edb563f86f80eb8 = (0, $kisy7.Lens).fromProp()('Specialization').compose((0, $1379b6c01f560d41$export$bf4ccabcbd35b59a)({}));
const $1225e12c9d6c4c58$export$621174928988a03f = (0, $kisy7.Lens).fromProp()('SpaceCollateChange').compose((0, $1379b6c01f560d41$export$bf4ccabcbd35b59a)({}));
const $1225e12c9d6c4c58$export$dbc072c440865d2d = (0, $kisy7.Lens).fromProp()('SpaceRestrict').compose((0, $1379b6c01f560d41$export$bf4ccabcbd35b59a)([]));
const $1225e12c9d6c4c58$export$fbf2e5e3ac4af515 = (space)=>$1225e12c9d6c4c58$export$dbc072c440865d2d.compose((0, $1379b6c01f560d41$export$198cba5001cec8dc)(space));
const $1225e12c9d6c4c58$export$41e7dab67e01213a = (space)=>(0, $kisy7.Lens).fromProp()(space).compose((0, $1379b6c01f560d41$export$4fa4efdde929acb0)());
const $1225e12c9d6c4c58$export$e04252494b3c4e92 = (0, $kisy7.Lens).fromProp()('OptionSelection').compose((0, $1379b6c01f560d41$export$bf4ccabcbd35b59a)({}));
const $1225e12c9d6c4c58$export$2ea27ddc4d0fd3b9 = (0, $kisy7.Lens).fromProp()('VariableCollateChange').compose((0, $1379b6c01f560d41$export$bf4ccabcbd35b59a)({}));
const $1225e12c9d6c4c58$export$fcc183e3a0a9dba1 = (0, $kisy7.Lens).fromProp()('VariableSelection').compose((0, $1379b6c01f560d41$export$bf4ccabcbd35b59a)({}));
const $1225e12c9d6c4c58$export$adb9192872b64d41 = (0, $kisy7.Lens).fromProp()('VariableNames').compose((0, $1379b6c01f560d41$export$bf4ccabcbd35b59a)({}));
const $1225e12c9d6c4c58$export$b82e210f344079c3 = (label)=>(0, $kisy7.Lens).fromProp()(label).compose((0, $1379b6c01f560d41$export$bf4ccabcbd35b59a)({}));
const $1225e12c9d6c4c58$export$6a9c7a2c9e43e9b0 = (0, $kisy7.Lens).fromProp()('SpaceNames').compose((0, $1379b6c01f560d41$export$bf4ccabcbd35b59a)({}));
const $1225e12c9d6c4c58$export$48b50a06e9c49844 = (label)=>(0, $kisy7.Lens).fromProp()(label).compose((0, $1379b6c01f560d41$export$bf4ccabcbd35b59a)({}));
const $1225e12c9d6c4c58$export$41a17122cd4c9143 = (0, $kisy7.Lens).fromProp()('SpaceRank').compose((0, $1379b6c01f560d41$export$bf4ccabcbd35b59a)({}));
const $1225e12c9d6c4c58$export$fbc8bcd33b574fbc = (key)=>(0, $kisy7.Optional).fromNullableProp()(key);
const $1225e12c9d6c4c58$export$f7a5430f102c83b1 = (space)=>$1225e12c9d6c4c58$export$41a17122cd4c9143.composeOptional($1225e12c9d6c4c58$export$fbc8bcd33b574fbc(space));
const $1225e12c9d6c4c58$export$c6708ed01b2e51b = (0, $kisy7.Lens).fromProp()('VariableRank').compose((0, $1379b6c01f560d41$export$bf4ccabcbd35b59a)({}));
const $1225e12c9d6c4c58$export$f5697a7a1e1ec278 = (variable)=>$1225e12c9d6c4c58$export$c6708ed01b2e51b.composeOptional($1225e12c9d6c4c58$export$fbc8bcd33b574fbc(variable));
const $1225e12c9d6c4c58$export$c6cf3f466131890b = (key)=>(0, $kisy7.Optional).fromNullableProp()(key);
const $1225e12c9d6c4c58$export$d2b41c5654bbe59 = (0, $kisy7.Optional).fromNullableProp()('VariableRange');
const $1225e12c9d6c4c58$export$a96ef9e45d2262fc = (variableName)=>$1225e12c9d6c4c58$export$d2b41c5654bbe59.compose($1225e12c9d6c4c58$export$c6cf3f466131890b(variableName));
const $1225e12c9d6c4c58$export$3c1cc8cf2a54464c = (variableName)=>$1225e12c9d6c4c58$export$a96ef9e45d2262fc(variableName).compose((0, $6eb8181ce6d386db$export$de339beb88c783ce));
const $1225e12c9d6c4c58$export$16ea5f7f8474dfa1 = (variableName)=>$1225e12c9d6c4c58$export$a96ef9e45d2262fc(variableName).compose((0, $6eb8181ce6d386db$export$c0342efd730e1b74));
const $1225e12c9d6c4c58$export$4beaac73bc6e8898 = (variableName)=>$1225e12c9d6c4c58$export$a96ef9e45d2262fc(variableName).compose((0, $6eb8181ce6d386db$export$9fe3358555274cc));
const $1225e12c9d6c4c58$export$50b334fa64ff903e = (variableName)=>$1225e12c9d6c4c58$export$a96ef9e45d2262fc(variableName).compose((0, $6eb8181ce6d386db$export$1d5b14212ce5e4ef)).composeLens((0, $6eb8181ce6d386db$export$10959f32198b5037));
const $1225e12c9d6c4c58$export$f7465d1017373ca4 = (variableName)=>$1225e12c9d6c4c58$export$d2b41c5654bbe59.compose($1225e12c9d6c4c58$export$c6cf3f466131890b(variableName)).compose((0, $6eb8181ce6d386db$export$1d5b14212ce5e4ef));
const $1225e12c9d6c4c58$export$dbfbfcc2bbda8ca9 = (variableName)=>(numberToMatch)=>$1225e12c9d6c4c58$export$c6cf3f466131890b(variableName).compose((0, $6eb8181ce6d386db$export$1d5b14212ce5e4ef)).composeTraversal((0, $6eb8181ce6d386db$export$31564b4caa3d7990)(numberToMatch));
const $1225e12c9d6c4c58$export$e53aa3bb4f00c7c = (0, $kisy7.Optional).fromNullableProp()('OptionNamesChange');
const $1225e12c9d6c4c58$export$58a028effa4e9eeb = (spaceName)=>(0, $kisy7.Lens).fromNullableProp()(spaceName, {});
const $1225e12c9d6c4c58$export$649cb60a0d1c7b67 = (spaceName)=>(entryLabel)=>$1225e12c9d6c4c58$export$58a028effa4e9eeb(spaceName).composeOptional((0, $efdb506a8fb142bf$export$64b8d2e655f5ae0a)(entryLabel));
const $1225e12c9d6c4c58$export$ae9499e6d8493626 = (0, $kisy7.Optional).fromNullableProp()('OptionRank');
const $1225e12c9d6c4c58$export$17b13f62d18ead2a = (spaceName)=>(0, $kisy7.Lens).fromNullableProp()(spaceName, {});
const $1225e12c9d6c4c58$export$f5684c8de496e065 = (labelName)=>(0, $kisy7.Lens).fromNullableProp()(labelName, 0);
const $1225e12c9d6c4c58$export$d42602b96e31efda = (spaceName)=>(label)=>$1225e12c9d6c4c58$export$ae9499e6d8493626.composeLens($1225e12c9d6c4c58$export$17b13f62d18ead2a(spaceName)).composeLens($1225e12c9d6c4c58$export$f5684c8de496e065(label));


/**
 * Optics for TemplateMod.
 *
 */ 
var $kisy7 = parcelRequire("kisy7");



const $e0f84d2120016d65$export$d560c7e4a29451c2 = (0, $kisy7.Lens).fromProp()('Id');
const $e0f84d2120016d65$export$4d13b920b27d853 = new (0, $kisy7.Lens)((t)=>(0, $35ad564717de6617$export$40d515e766fe3b8a).is(t) ? {
        _: 'Template',
        Id: t.ClientTemplateId
    } : {
        _: 'Mod',
        Id: t.ModId
    }, (a)=>(t)=>Object.assign({}, $e0f84d2120016d65$export$c04b1435c5517e1b.get(t), (0, $35ad564717de6617$export$46b83a6aabf254e3)('Mod').is(a) ? {
            ModId: a.Id
        } : {
            ClientTemplateId: a.Id
        }));
const $e0f84d2120016d65$export$c04b1435c5517e1b = new (0, $kisy7.Lens)((t)=>{
    if ((0, $35ad564717de6617$export$40d515e766fe3b8a).is(t)) {
        const { ClientTemplateId: ClientTemplateId, ...rest } = t;
        return rest;
    }
    const { ModId: ModId, ...rest } = t;
    return rest;
}, (a)=>(t)=>Object.assign({}, t, a));
const $e0f84d2120016d65$export$6b3555415cf358b3 = (x)=>(0, $kisy7.Prism).fromPredicate((0, $35ad564717de6617$export$46b83a6aabf254e3)(x).is);
const $e0f84d2120016d65$export$3e58e8addd15b22d = ()=>(0, $kisy7.Lens).fromProp()('Id');
const $e0f84d2120016d65$export$d9aa71f96dda8d28 = (0, $kisy7.Lens).fromProp()('UserId');
const $e0f84d2120016d65$export$549ff81930776885 = (0, $kisy7.Lens).fromProp()('Mode');
const $e0f84d2120016d65$export$def385f8e5286427 = (0, $kisy7.Lens).fromProp()('ModTemplate');
const $e0f84d2120016d65$export$eda4bf923e42dab3 = (space)=>(entry)=>$e0f84d2120016d65$export$def385f8e5286427.compose((0, $1225e12c9d6c4c58$export$2edb563f86f80eb8)).compose((0, $1225e12c9d6c4c58$export$41e7dab67e01213a)(space)).compose((0, $1379b6c01f560d41$export$198cba5001cec8dc)(entry));
const $e0f84d2120016d65$export$2da07dd901925b4a = (space)=>$e0f84d2120016d65$export$def385f8e5286427.compose((0, $1225e12c9d6c4c58$export$e04252494b3c4e92)).compose((0, $kisy7.Lens).fromProp()(space));
const $e0f84d2120016d65$export$95b4c46a6af686a3 = (0, $kisy7.Lens).fromProp()('ImageChange').compose((0, $1379b6c01f560d41$export$9364064a021bcaeb));
const $e0f84d2120016d65$export$56d7bc3ecf329b60 = (0, $kisy7.Lens).fromProp()('NamesChange');
const $e0f84d2120016d65$export$90584b8dfa38485d = $e0f84d2120016d65$export$def385f8e5286427.composeOptional((0, $1225e12c9d6c4c58$export$d2b41c5654bbe59));



parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $86603163591f910a$export$baa0faa0c7ad8085(slot) {
    return (0, $4Cod0.default)('PrivateSwitchBase', slot);
}
const $86603163591f910a$var$switchBaseClasses = (0, $beCSm.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $86603163591f910a$export$2e2bcd8739ae039 = $86603163591f910a$var$switchBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f3bdb1b636c81735$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $f3bdb1b636c81735$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $jTnBY.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $86603163591f910a$export$baa0faa0c7ad8085), classes);
};
const $f3bdb1b636c81735$var$SwitchBaseRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $8nd05.default)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }));
const $f3bdb1b636c81735$var$SwitchBaseInput = (0, $d8seH.default)('input', {
    shouldForwardProp: (0, $8Uq77.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $f3bdb1b636c81735$var$SwitchBase = /*#__PURE__*/ $acw62.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $1En50.default)(props, $f3bdb1b636c81735$var$_excluded);
    const [checked, setCheckedState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, $8nd05.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $f3bdb1b636c81735$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f3bdb1b636c81735$var$SwitchBaseRoot, (0, $8nd05.default)({
        component: "span",
        className: (0, $9QePP.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($f3bdb1b636c81735$var$SwitchBaseInput, (0, $8nd05.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $f3bdb1b636c81735$export$2e2bcd8739ae039 = $f3bdb1b636c81735$var$SwitchBase;


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $122b08a8ae2faae5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $a8b10b2b5aaa8e54$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $1c8b21cdbf539e4f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');



var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e1cd6b997bc70d3$export$6c57c6e16b4063b(slot) {
    return (0, $4Cod0.default)('MuiCheckbox', slot);
}
const $6e1cd6b997bc70d3$var$checkboxClasses = (0, $beCSm.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $6e1cd6b997bc70d3$export$2e2bcd8739ae039 = $6e1cd6b997bc70d3$var$checkboxClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $12775c00f473d955$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $12775c00f473d955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $6e1cd6b997bc70d3$export$6c57c6e16b4063b), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $12775c00f473d955$var$CheckboxRoot = (0, $d8seH.default)((0, $f3bdb1b636c81735$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $6e1cd6b997bc70d3$export$2e2bcd8739ae039).checked}, &.${(0, $6e1cd6b997bc70d3$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $6e1cd6b997bc70d3$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $12775c00f473d955$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8b10b2b5aaa8e54$export$2e2bcd8739ae039), {});
const $12775c00f473d955$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $122b08a8ae2faae5$export$2e2bcd8739ae039), {});
const $12775c00f473d955$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1c8b21cdbf539e4f$export$2e2bcd8739ae039), {});
const $12775c00f473d955$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $12775c00f473d955$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $12775c00f473d955$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $12775c00f473d955$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', className: className } = props, other = (0, $1En50.default)(props, $12775c00f473d955$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $12775c00f473d955$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($12775c00f473d955$var$CheckboxRoot, (0, $8nd05.default)({
        type: "checkbox",
        inputProps: (0, $8nd05.default)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $acw62.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $12775c00f473d955$export$2e2bcd8739ae039 = $12775c00f473d955$var$Checkbox;




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $bOOlK = parcelRequire("bOOlK");

var $3z1Ay = parcelRequire("3z1Ay");



var $6o2lr = parcelRequire("6o2lr");

var $9dZwz = parcelRequire("9dZwz");
const $a0abf5ad226c4fb0$var$_excluded = [
    "ownerState"
], $a0abf5ad226c4fb0$var$_excluded2 = [
    "variants"
], $a0abf5ad226c4fb0$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $a0abf5ad226c4fb0$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $a0abf5ad226c4fb0$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $a0abf5ad226c4fb0$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const $a0abf5ad226c4fb0$export$35e57303dbd8a66 = (0, $6o2lr.default)();
const $a0abf5ad226c4fb0$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $a0abf5ad226c4fb0$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $a0abf5ad226c4fb0$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $a0abf5ad226c4fb0$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $a0abf5ad226c4fb0$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $1En50.default)(_ref, $a0abf5ad226c4fb0$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $8nd05.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$a0abf5ad226c4fb0$var$processStyleArg(resolvedStyle, (0, $8nd05.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $1En50.default)(resolvedStylesArg, $a0abf5ad226c4fb0$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $8nd05.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, $8nd05.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $a0abf5ad226c4fb0$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $a0abf5ad226c4fb0$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $a0abf5ad226c4fb0$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $a0abf5ad226c4fb0$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $9dZwz.default)((0, $8nd05.default)({}, props, {
            theme: $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $bOOlK.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $a0abf5ad226c4fb0$var$defaultOverridesResolver($a0abf5ad226c4fb0$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $1En50.default)(inputOptions, $a0abf5ad226c4fb0$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $a0abf5ad226c4fb0$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($a0abf5ad226c4fb0$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $bOOlK.default)(tag, (0, $8nd05.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $3z1Ay.isPlainObject)(stylesArg)) return (props)=>$a0abf5ad226c4fb0$var$processStyleArg(stylesArg, (0, $8nd05.default)({}, props, {
                    theme: $a0abf5ad226c4fb0$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $a0abf5ad226c4fb0$var$processStyleArg(slotStyle, (0, $8nd05.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $a0abf5ad226c4fb0$var$processStyleArg({
                    variants: themeVariants
                }, (0, $8nd05.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $0016d2a363b4c314$var$styled = (0, $a0abf5ad226c4fb0$export$2e2bcd8739ae039)();
var $0016d2a363b4c314$export$2e2bcd8739ae039 = $0016d2a363b4c314$var$styled;



var $4FZD0 = parcelRequire("4FZD0");
function $8ec30e4d54713c84$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $4FZD0.default)(theme.components[name].defaultProps, props);
}



'use client';
function $9f45a3834bb6880f$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $59c0686cf27fa016$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $8ec30e4d54713c84$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}



var $hcz0Q = parcelRequire("hcz0Q");

var $6o2lr = parcelRequire("6o2lr");

var $3OJTQ = parcelRequire("3OJTQ");

var $cKRCq = parcelRequire("cKRCq");

var $ayMG0 = parcelRequire("ayMG0");
const $d70594339ba23534$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $d70594339ba23534$var$defaultTheme = (0, $6o2lr.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $d70594339ba23534$var$defaultCreateStyledComponent = (0, $0016d2a363b4c314$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $d70594339ba23534$var$useThemePropsDefault(props) {
    return (0, $9f45a3834bb6880f$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $d70594339ba23534$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $d70594339ba23534$var$joinChildren(children, separator) {
    const childrenArray = $acw62.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $acw62.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $d70594339ba23534$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $d70594339ba23534$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $8nd05.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $3OJTQ.handleBreakpoints)({
        theme: theme
    }, (0, $3OJTQ.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $cKRCq.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $cKRCq.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$d70594339ba23534$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $cKRCq.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $3z1Ay.default)(styles, (0, $3OJTQ.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $3OJTQ.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $d70594339ba23534$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $d70594339ba23534$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $d70594339ba23534$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $8Indx.default)(slots, (slot)=>(0, $4Cod0.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($d70594339ba23534$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $hcz0Q.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $1En50.default)(props, $d70594339ba23534$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            children: divider ? $d70594339ba23534$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
'use client';
const $231d58234d437bc0$var$Stack = (0, $d70594339ba23534$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $d8seH.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $231d58234d437bc0$export$2e2bcd8739ae039 = $231d58234d437bc0$var$Stack;




var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5cff6b4166fff27c$export$717666c39ec07e12(slot) {
    return (0, $4Cod0.default)('MuiFormControlLabel', slot);
}
const $5cff6b4166fff27c$var$formControlLabelClasses = (0, $beCSm.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $5cff6b4166fff27c$export$2e2bcd8739ae039 = $5cff6b4166fff27c$var$formControlLabelClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1a034abd43bd8eee$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $1a034abd43bd8eee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $jTnBY.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5cff6b4166fff27c$export$717666c39ec07e12), classes);
};
const $1a034abd43bd8eee$export$1b479270917a5676 = (0, $d8seH.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $jTnBY.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, {
        [`& .${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $1a034abd43bd8eee$var$AsteriskComponent = (0, $d8seH.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $1a034abd43bd8eee$var$FormControlLabel = /*#__PURE__*/ $acw62.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = 'end', required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $1a034abd43bd8eee$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $1a034abd43bd8eee$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $9QePP.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$export$1b479270917a5676, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $1a034abd43bd8eee$export$2e2bcd8739ae039 = $1a034abd43bd8eee$var$FormControlLabel;




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");


var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $03c2199a765ab5af$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $e413843d0810bb75$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $6d9735fee3c00fe1$var$RadioButtonIconRoot = (0, $d8seH.default)('span', {
    shouldForwardProp: (0, $8Uq77.default)
})({
    position: 'relative',
    display: 'flex'
});
const $6d9735fee3c00fe1$var$RadioButtonIconBackground = (0, $d8seH.default)((0, $03c2199a765ab5af$export$2e2bcd8739ae039))({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $6d9735fee3c00fe1$var$RadioButtonIconDot = (0, $d8seH.default)((0, $e413843d0810bb75$export$2e2bcd8739ae039))(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $6d9735fee3c00fe1$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $8nd05.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6d9735fee3c00fe1$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $6d9735fee3c00fe1$export$2e2bcd8739ae039 = $6d9735fee3c00fe1$var$RadioButtonIcon;



var $jTnBY = parcelRequire("jTnBY");

var $3d47321b9fcbcb38$export$2e2bcd8739ae039 = (0, $cfb86ebe4ea00eb7$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $f9f6bb9b992d33b5$var$RadioGroupContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $f9f6bb9b992d33b5$export$2e2bcd8739ae039 = $f9f6bb9b992d33b5$var$RadioGroupContext;


'use client';
function $e9140607eee18105$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $f9f6bb9b992d33b5$export$2e2bcd8739ae039));
}



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d9d692e9561f6352$export$192f7b2363c77155(slot) {
    return (0, $4Cod0.default)('MuiRadio', slot);
}
const $d9d692e9561f6352$var$radioClasses = (0, $beCSm.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $d9d692e9561f6352$export$2e2bcd8739ae039 = $d9d692e9561f6352$var$radioClasses;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $cb3af4fea2cad44e$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $cb3af4fea2cad44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            size !== 'medium' && `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8nd05.default)({}, classes, (0, $8Indx.default)(slots, (0, $d9d692e9561f6352$export$192f7b2363c77155), classes));
};
const $cb3af4fea2cad44e$var$RadioRoot = (0, $d8seH.default)((0, $f3bdb1b636c81735$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $d9d692e9561f6352$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $d9d692e9561f6352$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $cb3af4fea2cad44e$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $cb3af4fea2cad44e$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d9735fee3c00fe1$export$2e2bcd8739ae039), {
    checked: true
});
const $cb3af4fea2cad44e$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d9735fee3c00fe1$export$2e2bcd8739ae039), {});
const $cb3af4fea2cad44e$var$Radio = /*#__PURE__*/ $acw62.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $cb3af4fea2cad44e$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $cb3af4fea2cad44e$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className } = props, other = (0, $1En50.default)(props, $cb3af4fea2cad44e$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $cb3af4fea2cad44e$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $e9140607eee18105$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $3d47321b9fcbcb38$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $cb3af4fea2cad44e$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cb3af4fea2cad44e$var$RadioRoot, (0, $8nd05.default)({
        type: "radio",
        icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $cb3af4fea2cad44e$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $acw62.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $cb3af4fea2cad44e$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other));
});
var $cb3af4fea2cad44e$export$2e2bcd8739ae039 = $cb3af4fea2cad44e$var$Radio;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $de580948e3d734b1$export$d72d4cbdc30b331f(slot) {
    return (0, $4Cod0.default)('MuiFormGroup', slot);
}
const $de580948e3d734b1$var$formGroupClasses = (0, $beCSm.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $de580948e3d734b1$export$2e2bcd8739ae039 = $de580948e3d734b1$var$formGroupClasses;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5042f159189dda87$var$_excluded = [
    "className",
    "row"
];
const $5042f159189dda87$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $de580948e3d734b1$export$d72d4cbdc30b331f), classes);
};
const $5042f159189dda87$var$FormGroupRoot = (0, $d8seH.default)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap'
    }, ownerState.row && {
        flexDirection: 'row'
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $5042f159189dda87$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false } = props, other = (0, $1En50.default)(props, $5042f159189dda87$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $5042f159189dda87$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5042f159189dda87$var$FormGroupRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $5042f159189dda87$export$2e2bcd8739ae039 = $5042f159189dda87$var$FormGroup;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c550ce5d3f5617f8$export$c4cff3a43f7cabb6(slot) {
    return (0, $4Cod0.default)('MuiRadioGroup', slot);
}
const $c550ce5d3f5617f8$var$radioGroupClasses = (0, $beCSm.default)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var $c550ce5d3f5617f8$export$2e2bcd8739ae039 = $c550ce5d3f5617f8$var$radioGroupClasses;







var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $659f9ff12b4e3755$var$_excluded = [
    "actions",
    "children",
    "className",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $659f9ff12b4e3755$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c550ce5d3f5617f8$export$c4cff3a43f7cabb6), classes);
};
const $659f9ff12b4e3755$var$RadioGroup = /*#__PURE__*/ $acw62.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $1En50.default)(props, $659f9ff12b4e3755$var$_excluded);
    const rootRef = $acw62.useRef(null);
    const classes = $659f9ff12b4e3755$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $acw62.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, rootRef);
    const name = (0, $4105219ee6538ed1$export$2e2bcd8739ae039)(nameProp);
    const contextValue = $acw62.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9f6bb9b992d33b5$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), (0, $8nd05.default)({
            role: "radiogroup",
            ref: handleRef,
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            children: children
        }))
    });
});
var $659f9ff12b4e3755$export$2e2bcd8739ae039 = $659f9ff12b4e3755$var$RadioGroup;












var $ayMG0 = parcelRequire("ayMG0");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $kSnzZ = parcelRequire("kSnzZ");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");






var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b23cfd2067550897$export$5682c366c0c669d9(slot) {
    return (0, $4Cod0.default)('MuiListItem', slot);
}
const $b23cfd2067550897$var$listItemClasses = (0, $beCSm.default)('MuiListItem', [
    'root',
    'container',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'padding',
    'button',
    'secondaryAction',
    'selected'
]);
var $b23cfd2067550897$export$2e2bcd8739ae039 = $b23cfd2067550897$var$listItemClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a1fd72c2634274a8$export$c09531d8563c67a5(slot) {
    return (0, $4Cod0.default)('MuiListItemButton', slot);
}
const $a1fd72c2634274a8$var$listItemButtonClasses = (0, $beCSm.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $a1fd72c2634274a8$export$2e2bcd8739ae039 = $a1fd72c2634274a8$var$listItemButtonClasses;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $558d665a4b71ad4c$export$ccdb26aeba48a86e(slot) {
    return (0, $4Cod0.default)('MuiListItemSecondaryAction', slot);
}
const $558d665a4b71ad4c$var$listItemSecondaryActionClasses = (0, $beCSm.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $558d665a4b71ad4c$export$2e2bcd8739ae039 = $558d665a4b71ad4c$var$listItemSecondaryActionClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9924235485c5a222$var$_excluded = [
    "className"
];
const $9924235485c5a222$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $558d665a4b71ad4c$export$ccdb26aeba48a86e), classes);
};
const $9924235485c5a222$var$ListItemSecondaryActionRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)'
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $9924235485c5a222$var$ListItemSecondaryAction = /*#__PURE__*/ $acw62.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $9924235485c5a222$var$_excluded);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $9924235485c5a222$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9924235485c5a222$var$ListItemSecondaryActionRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$9924235485c5a222$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $9924235485c5a222$export$2e2bcd8739ae039 = $9924235485c5a222$var$ListItemSecondaryAction;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f92832698674c928$var$_excluded = [
    "className"
], $f92832698674c928$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $f92832698674c928$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $f92832698674c928$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            disabled && 'disabled',
            button && 'button',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction',
            selected && 'selected'
        ],
        container: [
            'container'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $b23cfd2067550897$export$5682c366c0c669d9), classes);
};
const $f92832698674c928$export$aed538f7519abe89 = (0, $d8seH.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $f92832698674c928$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left'
    }, !ownerState.disablePadding && (0, $8nd05.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $a1fd72c2634274a8$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.button && {
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $f92832698674c928$var$ListItemContainer = (0, $d8seH.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $f92832698674c928$var$ListItem = /*#__PURE__*/ $acw62.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $1En50.default)(props.ContainerProps, $f92832698674c928$var$_excluded), other = (0, $1En50.default)(props, $f92832698674c928$var$_excluded2);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $acw62.useRef(null);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $acw62.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $90a633ad7a979daa$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $f92832698674c928$var$useUtilityClasses(ownerState);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $f92832698674c928$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $9QePP.default)((0, $b23cfd2067550897$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $4a35786d89db9dda$export$2e2bcd8739ae039);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f92832698674c928$var$ListItemContainer, (0, $8nd05.default)({
                as: ContainerComponent,
                className: (0, $9QePP.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $8nd05.default)({}, rootProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Root) && {
                        as: Component,
                        ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $8nd05.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Root) && {
            ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9924235485c5a222$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $f92832698674c928$export$2e2bcd8739ae039 = $f92832698674c928$var$ListItem;



var $3abDJ = parcelRequire("3abDJ");
parcelRequire("acw62");



var $5OFXS = parcelRequire("5OFXS");

var $kLIh4 = parcelRequire("kLIh4");

var $ayMG0 = parcelRequire("ayMG0");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $69235bd32d3d94eb$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11h-4v4h-2v-4H7v-2h4V7h2v4h4z"
}), 'AddCircle');



var $d8seH = parcelRequire("d8seH");

const $d740a3931eafa2ae$var$StyledChip = (0, $d8seH.default)((0, $47d4f79319086dc5$export$2e2bcd8739ae039))({
    cursor: 'pointer',
    '& .MuiChip-label': {
        display: 'flex'
    }
});
const $d740a3931eafa2ae$var$ChipAdd = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d740a3931eafa2ae$var$StyledChip, {
        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69235bd32d3d94eb$export$2e2bcd8739ae039), {}),
        variant: "outlined",
        clickable: true,
        ...props
    });
};
var $d740a3931eafa2ae$export$2e2bcd8739ae039 = $d740a3931eafa2ae$var$ChipAdd;



var $ayMG0 = parcelRequire("ayMG0");


var $3abDJ = parcelRequire("3abDJ");

var $acw62 = parcelRequire("acw62");





var $kLIh4 = parcelRequire("kLIh4");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $b8d976dd8c0b005c$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), 'Cancel');



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");




var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f3e589c60baacdec$export$4b135a4b3a6c4550(slot) {
    return (0, $4Cod0.default)('MuiInputAdornment', slot);
}
const $f3e589c60baacdec$var$inputAdornmentClasses = (0, $beCSm.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $f3e589c60baacdec$export$2e2bcd8739ae039 = $f3e589c60baacdec$var$inputAdornmentClasses;



var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d0c64ff513a9933f$var$_span;
const $d0c64ff513a9933f$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $d0c64ff513a9933f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $jTnBY.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $d0c64ff513a9933f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $jTnBY.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f3e589c60baacdec$export$4b135a4b3a6c4550), classes);
};
const $d0c64ff513a9933f$var$InputAdornmentRoot = (0, $d8seH.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $d0c64ff513a9933f$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $f3e589c60baacdec$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $f3e589c60baacdec$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const $d0c64ff513a9933f$var$InputAdornment = /*#__PURE__*/ $acw62.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $1En50.default)(props, $d0c64ff513a9933f$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $8nd05.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $d0c64ff513a9933f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d0c64ff513a9933f$var$InputAdornmentRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $d0c64ff513a9933f$var$_span || ($d0c64ff513a9933f$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $d0c64ff513a9933f$export$2e2bcd8739ae039 = $d0c64ff513a9933f$var$InputAdornment;



var $3abDJ = parcelRequire("3abDJ");





var $ayMG0 = parcelRequire("ayMG0");
var $ba571672f7b8a33c$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($ba571672f7b8a33c$exports, "__esModule", {
    value: true
});
$ba571672f7b8a33c$exports.default = void 0;

var $ba571672f7b8a33c$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ba571672f7b8a33c$var$_default = $ba571672f7b8a33c$exports.default = (0, $ba571672f7b8a33c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');



const $0b58908ec31949ea$var$CheckIconButton = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
        sx: {
            ml: '9px'
        },
        size: "small",
        color: "primary",
        "aria-label": "update value",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba571672f7b8a33c$exports))), {})
    });
var $0b58908ec31949ea$export$2e2bcd8739ae039 = $0b58908ec31949ea$var$CheckIconButton;


const $cc6fa3a65ee072cd$var$SetOptionTextField = ({ label: label, value: value, toggleVisibility: toggleVisibility, range: range, update: update })=>{
    const [temporaryValue, setTemporaryValue] = $acw62.useState(undefined);
    $acw62.useEffect(()=>{
        if (value) (0, $3abDJ.pipe)(value, setTemporaryValue);
    }, [
        value,
        setTemporaryValue
    ]);
    const handleMouseDownClose = (event)=>{
        event.preventDefault();
    };
    const modUpdate = (label, old, updated)=>(0, $e0f84d2120016d65$export$def385f8e5286427).modify((0, $1225e12c9d6c4c58$export$d2b41c5654bbe59).modify((0, $3abDJ.constant)((0, $3abDJ.pipe)((0, $3abDJ.pipe)((0, $1225e12c9d6c4c58$export$dbfbfcc2bbda8ca9), (0, $c5dd58add12ba066$exports.ap)(label), (0, $c5dd58add12ba066$exports.ap)(old)).set(updated), (0, $c5dd58add12ba066$exports.ap)({
            [label]: range
        })))));
    const submitUpdate = (val)=>(0, $3abDJ.pipe)(val, Number, (x)=>modUpdate(label, value, x), update);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                autoFocus: true,
                variant: "standard",
                value: temporaryValue,
                type: "number",
                onChange: (0, $3abDJ.flow)((0, $859db0da13774873$export$2b11a78b8ccd10d4), Number, setTemporaryValue),
                inputProps: {
                    step: 0.0025
                },
                InputProps: {
                    startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0c64ff513a9933f$export$2e2bcd8739ae039), {
                        position: "end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                            "aria-label": "cancel edit",
                            onClick: toggleVisibility,
                            onMouseDown: handleMouseDownClose,
                            edge: "start",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8d976dd8c0b005c$export$2e2bcd8739ae039), {})
                        })
                    })
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0b58908ec31949ea$export$2e2bcd8739ae039), {
                onClick: ()=>submitUpdate(temporaryValue),
                disabled: (0, $3abDJ.pipe)(temporaryValue, Number, isNaN)
            })
        ]
    });
};
var $cc6fa3a65ee072cd$export$2e2bcd8739ae039 = $cc6fa3a65ee072cd$var$SetOptionTextField;


const $2d5eda8de804db83$var$indexFilter = (filterIndex)=>(i, _)=>i !== filterIndex;
const $2d5eda8de804db83$var$filterByIndex = (i)=>(0, $kLIh4.filterWithIndex)($2d5eda8de804db83$var$indexFilter(i));
const $2d5eda8de804db83$var$refineAndReturnNonEmpty = (filteredArray)=>(arr)=>(0, $8af43a568842d8c3$export$abae9d370f12ca88)(filteredArray) ? filteredArray : arr;
const $2d5eda8de804db83$var$SetOption = ({ index: index, value: value, label: label, update: update, range: range })=>{
    const [editMode, setEditMode] = $acw62.useState(false);
    /*
	 * Assumes that a set value will never need to stay 0
	 * And that the user should edit it immediately
	 */ $acw62.useEffect(()=>{
        if (value === 0) setEditMode(true);
    }, [
        value,
        setEditMode
    ]);
    const handleClick = ()=>setEditMode((oldMode)=>!oldMode); // Toggles text field
    const handleDelete = (index)=>(label)=>(0, $e0f84d2120016d65$export$def385f8e5286427).modify((0, $1225e12c9d6c4c58$export$d2b41c5654bbe59).modify((0, $3abDJ.constant)({
                [label]: {
                    type: 'Set',
                    Set: $2d5eda8de804db83$var$refineAndReturnNonEmpty($2d5eda8de804db83$var$filterByIndex(index)((0, $6eb8181ce6d386db$export$10959f32198b5037).get(range)))((0, $6eb8181ce6d386db$export$10959f32198b5037).get(range))
                }
            })));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f92832698674c928$export$2e2bcd8739ae039), {
        sx: {
            p: 0.5,
            width: 'auto'
        },
        children: !editMode ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), {
            label: value,
            variant: "outlined",
            onClick: handleClick,
            onDelete: (0, $3abDJ.flow)(()=>handleDelete(index)(label), update)
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cc6fa3a65ee072cd$export$2e2bcd8739ae039), {
            range: range,
            toggleVisibility: handleClick,
            value: value,
            update: update,
            label: label
        })
    });
};
var $2d5eda8de804db83$export$2e2bcd8739ae039 = $2d5eda8de804db83$var$SetOption;




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $3abDJ = parcelRequire("3abDJ");



var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");

const $ab898f6be4b94968$var$StyledTextField = (0, $d8seH.default)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039))(({ theme: theme })=>({
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }));
/**
 *  TextField from MUI library but with default props and styling
 *  common to the TemplateMod page
 */ const $ab898f6be4b94968$var$ModTextField = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($ab898f6be4b94968$var$StyledTextField, {
        fullWidth: true,
        InputLabelProps: {
            shrink: true
        },
        size: "small",
        ...props
    });
var $ab898f6be4b94968$export$2e2bcd8739ae039 = $ab898f6be4b94968$var$ModTextField;



var $hBXBN = parcelRequire("hBXBN");


const $82e751e912506609$var$ModVariableRank = ({ variableLabel: variableLabel, currentRank: currentRank, ModTemplate: ModTemplate, update: update })=>{
    const handleVariableRankChange = (label)=>(rank)=>(0, $e0f84d2120016d65$export$def385f8e5286427).modify((0, $1225e12c9d6c4c58$export$c6708ed01b2e51b).modify((0, $3abDJ.constant)({
                ...(0, $1225e12c9d6c4c58$export$c6708ed01b2e51b).get(ModTemplate),
                [label]: rank ? Number(rank) : undefined
            })));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab898f6be4b94968$export$2e2bcd8739ae039), {
        value: (0, $3abDJ.pipe)((0, $1225e12c9d6c4c58$export$f5697a7a1e1ec278)(variableLabel).getOption(ModTemplate), $hBXBN.toNullable),
        label: `Display Rank: ${currentRank || 'None'}`,
        inputProps: {
            inputMode: 'numeric',
            pattern: '[0-9]*'
        },
        onChange: (0, $3abDJ.flow)((0, $859db0da13774873$export$2b11a78b8ccd10d4), (x)=>handleVariableRankChange(variableLabel)(x), update),
        helperText: (0, $3abDJ.pipe)((0, $859db0da13774873$export$6e7dd58ef09e0995), $c5dd58add12ba066$exports.ap($hBXBN.fromNullable(currentRank)), $c5dd58add12ba066$exports.ap((0, $1225e12c9d6c4c58$export$f5697a7a1e1ec278)(variableLabel).getOption(ModTemplate)), (0, $859db0da13774873$export$995b48be52afb12a))
    });
};
var $82e751e912506609$export$2e2bcd8739ae039 = $82e751e912506609$var$ModVariableRank;


const $f867f19cb2db67cf$export$c48349c7c3215056 = ({ variable: variable, range: range, templateMod: templateMod, update: update })=>{
    const handleAddSetItem = (label)=>(range)=>(0, $e0f84d2120016d65$export$def385f8e5286427).modify((0, $1225e12c9d6c4c58$export$d2b41c5654bbe59).modify((0, $3abDJ.constant)({
                [label]: {
                    type: 'Set',
                    Set: (0, $3abDJ.pipe)(range.Set, $kLIh4.copy, $kLIh4.append(0))
                }
            })));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        my: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $82e751e912506609$export$2e2bcd8739ae039), {
                variableLabel: variable.Label,
                currentRank: variable.Rank,
                ModTemplate: templateMod,
                update: update
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                color: "GrayText",
                variant: "caption",
                children: [
                    variable.Names.eng || variable.Label,
                    " Set Values"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
                pl: 0,
                mt: 0,
                flexWrap: "wrap",
                component: "ul",
                direction: "row",
                children: [
                    range.Set.map((setValue, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5eda8de804db83$export$2e2bcd8739ae039), {
                            index: i,
                            range: range,
                            label: variable.Label,
                            value: setValue,
                            update: update
                        }, variable.Label + setValue)),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f92832698674c928$export$2e2bcd8739ae039), {
                        sx: {
                            p: 0.5,
                            width: 'auto'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d740a3931eafa2ae$export$2e2bcd8739ae039), {
                            onClick: (0, $3abDJ.flow)(()=>handleAddSetItem(variable.Label)(range), update)
                        })
                    })
                ]
            }),
            (0, $3abDJ.pipe)((0, $1225e12c9d6c4c58$export$f7465d1017373ca4)(variable.Label).getOption(templateMod), $5OFXS.isSome) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                children: (0, $859db0da13774873$export$995b48be52afb12a)(true)
            })
        ]
    });
};
var $f867f19cb2db67cf$export$2e2bcd8739ae039 = $f867f19cb2db67cf$export$c48349c7c3215056;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");


var $hBXBN = parcelRequire("hBXBN");

var $3abDJ = parcelRequire("3abDJ");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $3abDJ = parcelRequire("3abDJ");




const $67aa88da4dc0a1e9$var$modSpaceName = (spaceName, entryLabel, newValue)=>(0, $1225e12c9d6c4c58$export$58a028effa4e9eeb)(spaceName).modify((prev)=>({
            ...prev,
            [entryLabel]: {
                eng: newValue
            }
        }));
const $67aa88da4dc0a1e9$var$handleClick = (spaceName, entryLabel, newValue)=>()=>(0, $e0f84d2120016d65$export$def385f8e5286427).composeOptional((0, $1225e12c9d6c4c58$export$e53aa3bb4f00c7c)).modify($67aa88da4dc0a1e9$var$modSpaceName(spaceName, entryLabel, newValue));
const $67aa88da4dc0a1e9$var$EntryNameTextField = ({ value: value, spaceName: spaceName, entryLabel: entryLabel, update: update, templateMod: templateMod, ...textFieldProps })=>{
    const [temporaryValue, setTemporaryValue] = $acw62.useState(value);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab898f6be4b94968$export$2e2bcd8739ae039), {
            size: "small",
            onChange: (0, $3abDJ.flow)((0, $859db0da13774873$export$2b11a78b8ccd10d4), setTemporaryValue),
            ...textFieldProps,
            value: temporaryValue,
            InputProps: {
                endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0c64ff513a9933f$export$2e2bcd8739ae039), {
                    position: "end",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0b58908ec31949ea$export$2e2bcd8739ae039), {
                        onClick: (0, $3abDJ.flow)($67aa88da4dc0a1e9$var$handleClick(spaceName, entryLabel, temporaryValue), update),
                        disabled: !temporaryValue
                    })
                })
            }
        })
    });
};
var $67aa88da4dc0a1e9$export$2e2bcd8739ae039 = $67aa88da4dc0a1e9$var$EntryNameTextField;



var $ayMG0 = parcelRequire("ayMG0");


var $3abDJ = parcelRequire("3abDJ");

var $acw62 = parcelRequire("acw62");





const $02e1121095974857$var$submitMod = (spaceName, entryLabel, newValue)=>(0, $e0f84d2120016d65$export$def385f8e5286427).composeOptional((0, $1225e12c9d6c4c58$export$ae9499e6d8493626)).composeLens((0, $1225e12c9d6c4c58$export$17b13f62d18ead2a)(spaceName)).composeLens((0, $1225e12c9d6c4c58$export$f5684c8de496e065)(entryLabel)).set(newValue);
const $02e1121095974857$var$handleClick = (spaceName, entryLabel, temporaryValue)=>()=>$02e1121095974857$var$submitMod(spaceName, entryLabel, temporaryValue);
const $02e1121095974857$var$EntryRankTextField = ({ value: value, update: update, spaceName: spaceName, entryLabel: entryLabel, templateMod: templateMod, ...textFieldProps })=>{
    const [temporaryValue, setTemporaryValue] = $acw62.useState(value);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab898f6be4b94968$export$2e2bcd8739ae039), {
        size: "small",
        inputProps: {
            inputMode: 'numeric',
            pattern: '[0-9]*'
        },
        onChange: (0, $3abDJ.flow)((0, $859db0da13774873$export$2b11a78b8ccd10d4), Number, setTemporaryValue),
        ...textFieldProps,
        value: temporaryValue,
        InputProps: {
            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0c64ff513a9933f$export$2e2bcd8739ae039), {
                position: "end",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0b58908ec31949ea$export$2e2bcd8739ae039), {
                    onClick: (0, $3abDJ.flow)($02e1121095974857$var$handleClick(spaceName, entryLabel, temporaryValue), update),
                    disabled: !temporaryValue
                })
            })
        }
    });
};
var $02e1121095974857$export$2e2bcd8739ae039 = $02e1121095974857$var$EntryRankTextField;



/**
 * Optics for Options.
 *
 */ 
var $kisy7 = parcelRequire("kisy7");

var $4ZBbi = parcelRequire("4ZBbi");
const $58f0bd7401930c3a$export$d1a363ffb2e01d31 = (0, $kisy7.Lens).fromProp()('Range');
const $58f0bd7401930c3a$export$ee5a1efba5905391 = (0, $kisy7.fromTraversable)((0, $4ZBbi.Traversable))();
const $58f0bd7401930c3a$export$f4655560c2931dea = (label)=>(0, $kisy7.Prism).fromPredicate((x)=>x.Label === label);
const $58f0bd7401930c3a$export$5e5c3cf1b9932d61 = (0, $kisy7.Lens).fromProp()('Names');
const $58f0bd7401930c3a$export$f5684c8de496e065 = (0, $kisy7.Optional).fromNullableProp()('Rank');
const $58f0bd7401930c3a$export$e8e46655a936d21f = (label)=>$58f0bd7401930c3a$export$d1a363ffb2e01d31.composeTraversal($58f0bd7401930c3a$export$ee5a1efba5905391).composePrism($58f0bd7401930c3a$export$f4655560c2931dea(label)).composeOptional($58f0bd7401930c3a$export$f5684c8de496e065);
const $58f0bd7401930c3a$export$ee9963854cbe5cd4 = (0, $kisy7.Lens).fromProp()('Names');


const $0415fa9e9f8c7ea5$var$SpaceEntry = ({ entry: entry, spaceName: spaceName, templateMod: templateMod, update: update })=>{
    const { value: editMode, toggle: toggleEditMode } = (0, $9e39118f6baea535$export$2e2bcd8739ae039)();
    const possibleModEntryName = (0, $1225e12c9d6c4c58$export$e53aa3bb4f00c7c).compose((0, $1225e12c9d6c4c58$export$649cb60a0d1c7b67)(spaceName)(entry.Label)).composeLens((0, $efdb506a8fb142bf$export$28a5c30e3a807f5b)('eng')).getOption(templateMod);
    /**
	 * Represents the `templateMod` entry name if defined, if not uses a default name
	 */ const relevantEntryName = (0, $3abDJ.pipe)(possibleModEntryName, $hBXBN.getOrElse((0, $3abDJ.constant)(entry.Names.eng || 'No English Translation')));
    const possibleModEntryRank = (0, $1225e12c9d6c4c58$export$d42602b96e31efda)(spaceName)(entry.Label).getOption(templateMod);
    /**
	 * Represents the `templateMod` entry rank if defined, if not uses a default rank
	 */ const relevantEntryRank = (0, $3abDJ.pipe)(possibleModEntryRank, $hBXBN.getOrElse((0, $3abDJ.constant)(entry.Rank || 0)));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f92832698674c928$export$2e2bcd8739ae039), {
        sx: {
            p: 0.5,
            width: 'auto',
            flexDirection: 'column'
        },
        children: !editMode ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), {
                    label: `(${relevantEntryRank || 'none'}) ${relevantEntryName}`,
                    onClick: toggleEditMode,
                    variant: "outlined"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                    children: (0, $859db0da13774873$export$995b48be52afb12a)((0, $859db0da13774873$export$e907cebc8d2b213b)($hBXBN.some((0, $58f0bd7401930c3a$export$5e5c3cf1b9932d61).compose((0, $efdb506a8fb142bf$export$28a5c30e3a807f5b)('eng')).get(entry)))(possibleModEntryName) || (0, $859db0da13774873$export$6e7dd58ef09e0995)($hBXBN.fromNullable(entry.Rank))(possibleModEntryRank))
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            display: "flex",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: 'flex',
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67aa88da4dc0a1e9$export$2e2bcd8739ae039), {
                            entryLabel: entry.Label,
                            spaceName: spaceName,
                            update: update,
                            templateMod: templateMod,
                            value: relevantEntryName,
                            label: entry.Names.eng
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02e1121095974857$export$2e2bcd8739ae039), {
                            value: relevantEntryRank,
                            label: `${relevantEntryName} Rank: ${entry.Rank || 'none'}`,
                            entryLabel: entry.Label,
                            spaceName: spaceName,
                            update: update,
                            templateMod: templateMod
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                    "aria-label": "cancel edit",
                    onClick: toggleEditMode,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8d976dd8c0b005c$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
};
var $0415fa9e9f8c7ea5$export$2e2bcd8739ae039 = $0415fa9e9f8c7ea5$var$SpaceEntry;







const $9a4125513576d694$var$findTemplate = (ps)=>{
    const base = (0, $e0f84d2120016d65$export$4d13b920b27d853).get(ps.mod);
    return (base._ === 'Template' ? ps.templates : ps.modTemplates).find((t)=>t.Id === base.Id);
};
const $9a4125513576d694$var$checkValue = (ev)=>({
        v: ev.target.value,
        c: ev.target.checked
    });
const $9a4125513576d694$var$sliderValue = (_ev, newValue)=>typeof newValue === 'number' ? newValue : Math.min(...newValue);
/**
 * Encodes a RangeRange with a default `Step` value
 * using NonEmpty<number> to fill in `Max` and `Min`
 *
 * @param arr NonEmpty<number>, ideally sorted with length > 1
 * @returns RangeRange
 */ const $9a4125513576d694$var$rangeRangeFromNonEmpty = (arr)=>(0, $d92db2d2d4e06f06$export$adb7e19bd67fc44b).encode({
        type: 'Range',
        Min: $fWUU5.head(arr),
        Max: $fWUU5.last(arr),
        Step: 0.025
    });
/**
 * Encode a RangeSet using the `Min` and `Max` values of
 * a RangeRange as only two entries of Set
 *
 * @param range RangeRange to convert to RangeSet
 */ const $9a4125513576d694$var$rangeSetFromRangeRange = (range)=>(0, $d92db2d2d4e06f06$export$34cb5241245008dd).encode({
        type: 'Set',
        Set: [
            (0, $6eb8181ce6d386db$export$51f1ef0d27a29e7d).get(range),
            (0, $6eb8181ce6d386db$export$3096b23ac798df78).get(range)
        ]
    });
/**
 * Sorts a NonEmpty<number> then encodes `RangeRange` object
 */ const $9a4125513576d694$var$unsortedNeaToRangeRange = (0, $lWM6H.flow)((0, $859db0da13774873$export$af7888a0bb3446c8), $9a4125513576d694$var$rangeRangeFromNonEmpty);
const $9a4125513576d694$export$c019608e5b5bb4cb = (ps)=>{
    const { ModTemplate: ModTemplate } = ps.mod;
    const template = $9a4125513576d694$var$findTemplate(ps);
    const handleSpaceNameChange = (label)=>(value)=>(0, $e0f84d2120016d65$export$def385f8e5286427).modify((0, $1225e12c9d6c4c58$export$6a9c7a2c9e43e9b0).modify((0, $lWM6H.constant)({
                ...(0, $1225e12c9d6c4c58$export$6a9c7a2c9e43e9b0).get(ModTemplate),
                [label]: {
                    'eng': value
                }
            })));
    const handleSpaceRankChange = (space)=>(rank)=>(0, $e0f84d2120016d65$export$def385f8e5286427).modify((0, $1225e12c9d6c4c58$export$41a17122cd4c9143).modify((0, $lWM6H.constant)({
                ...(0, $1225e12c9d6c4c58$export$41a17122cd4c9143).get(ModTemplate),
                [space]: rank ? Number(rank) : undefined
            })));
    return template === undefined ? null : template.Opts.map((space)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
            item: true,
            xs: 12,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
                elevation: 2,
                sx: {
                    p: 2,
                    m: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                            checked: (0, $e0f84d2120016d65$export$def385f8e5286427).compose((0, $1225e12c9d6c4c58$export$fbf2e5e3ac4af515)(space.Label)).get(ps.mod),
                            onChange: (ev)=>ps.update((0, $e0f84d2120016d65$export$def385f8e5286427).compose((0, $1225e12c9d6c4c58$export$fbf2e5e3ac4af515)(space.Label)).set(ev.target.checked))
                        }),
                        label: space.Names.eng ?? space.Label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab898f6be4b94968$export$2e2bcd8739ae039), {
                        value: (0, $1225e12c9d6c4c58$export$48b50a06e9c49844)(space.Label).compose((0, $efdb506a8fb142bf$export$28a5c30e3a807f5b)('eng')).get((0, $1225e12c9d6c4c58$export$6a9c7a2c9e43e9b0).get(ModTemplate)),
                        onChange: (0, $lWM6H.flow)((0, $859db0da13774873$export$2b11a78b8ccd10d4), (x)=>handleSpaceNameChange(space.Label)(x), ps.update),
                        helperText: (0, $lWM6H.pipe)((0, $859db0da13774873$export$e907cebc8d2b213b), $c5dd58add12ba066$exports.ap($5OFXS.some((0, $58f0bd7401930c3a$export$ee9963854cbe5cd4).compose((0, $efdb506a8fb142bf$export$28a5c30e3a807f5b)('eng')).get(space))), $c5dd58add12ba066$exports.ap((0, $1225e12c9d6c4c58$export$6a9c7a2c9e43e9b0).composeOptional((0, $efdb506a8fb142bf$export$64b8d2e655f5ae0a)(space.Label)).composeLens((0, $efdb506a8fb142bf$export$28a5c30e3a807f5b)('eng')).getOption(ModTemplate)), (0, $859db0da13774873$export$995b48be52afb12a)),
                        label: `Name: ${space.Names.eng || space.Label}`,
                        variant: "outlined"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab898f6be4b94968$export$2e2bcd8739ae039), {
                        value: (0, $lWM6H.pipe)((0, $1225e12c9d6c4c58$export$f7a5430f102c83b1)(space.Label).getOption(ModTemplate), $5OFXS.toNullable),
                        label: `Display Rank: ${space.Rank || 'none'}`,
                        inputProps: {
                            inputMode: 'numeric'
                        },
                        helperText: (0, $lWM6H.pipe)((0, $859db0da13774873$export$6e7dd58ef09e0995), $c5dd58add12ba066$exports.ap($5OFXS.fromNullable(space.Rank)), $c5dd58add12ba066$exports.ap((0, $1225e12c9d6c4c58$export$f7a5430f102c83b1)(space.Label).getOption(ModTemplate)), (0, $859db0da13774873$export$995b48be52afb12a)),
                        onChange: (0, $lWM6H.flow)((0, $859db0da13774873$export$2b11a78b8ccd10d4), (x)=>handleSpaceRankChange(space.Label)(x), ps.update)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        my: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                color: "GrayText",
                                variant: "caption",
                                children: "Entry Values"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
                                pl: 0,
                                mt: 0,
                                flexWrap: "wrap",
                                component: "ul",
                                direction: "row",
                                children: space.Range.map((entry)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $0415fa9e9f8c7ea5$export$2e2bcd8739ae039), {
                                        entry: entry,
                                        spaceName: space.Label,
                                        templateMod: ModTemplate,
                                        update: ps.update
                                    }, entry.Names.eng))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $574565f284cb845e$export$2e2bcd8739ae039), {
                        panelName: space.Label,
                        summary: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 1,
                            direction: "row",
                            children: space.Range.filter((opt)=>(0, $e0f84d2120016d65$export$eda4bf923e42dab3)(space.Label)(opt.Label).get(ps.mod)).map((opt, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: "auto",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        sx: {
                                            paddingRight: '1ex',
                                            color: (0, $e0f84d2120016d65$export$2da07dd901925b4a)(space.Label).get(ps.mod) === opt.Label ? 'text.primary' : 'text.secondary'
                                        },
                                        children: [
                                            " ",
                                            opt.Names.eng ?? opt.Label,
                                            " "
                                        ]
                                    }, opt.Label)
                                }, i))
                        }),
                        details: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $659f9ff12b4e3755$export$2e2bcd8739ae039), {
                            value: (0, $e0f84d2120016d65$export$2da07dd901925b4a)(space.Label).get(ps.mod) ?? '',
                            children: space.Range.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    container: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {
                                                value: opt.Label,
                                                onClick: ()=>ps.update((0, $e0f84d2120016d65$export$2da07dd901925b4a)(space.Label).modify((a)=>a === opt.Label ? undefined : opt.Label))
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                checked: (0, $e0f84d2120016d65$export$eda4bf923e42dab3)(space.Label)(opt.Label).get(ps.mod),
                                                value: opt.Label,
                                                onChange: (0, $lWM6H.flow)($9a4125513576d694$var$checkValue, (r)=>(0, $e0f84d2120016d65$export$eda4bf923e42dab3)(space.Label)(opt.Label).modify((0, $lWM6H.constant)(r.c)), ps.update)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: opt.Names.eng ?? opt.Label
                                            })
                                        ]
                                    })
                                }, opt.Label))
                        }, space.Label)
                    })
                ]
            })
        }, space.Label));
};
const $9a4125513576d694$export$8bb9d79ea938efc9 = (ps)=>{
    const { update: update } = ps;
    const { ModTemplate: ModTemplate } = ps.mod;
    const variableUpdate = (label)=>(val)=>(0, $e0f84d2120016d65$export$def385f8e5286427).modify((0, $1225e12c9d6c4c58$export$fcc183e3a0a9dba1).modify((0, $lWM6H.constant)({
                ...(0, $1225e12c9d6c4c58$export$fcc183e3a0a9dba1).get(ModTemplate),
                [label]: val
            })));
    const handleVariableNameChange = (label)=>(value)=>(0, $e0f84d2120016d65$export$def385f8e5286427).modify((0, $1225e12c9d6c4c58$export$adb9192872b64d41).modify((0, $lWM6H.constant)({
                ...(0, $1225e12c9d6c4c58$export$adb9192872b64d41).get(ModTemplate),
                [label]: {
                    'eng': value
                }
            })));
    const handleVariableRangeMaxChange = (variable)=>(value)=>(0, $e0f84d2120016d65$export$def385f8e5286427).modify((0, $1225e12c9d6c4c58$export$d2b41c5654bbe59).modify((0, $lWM6H.constant)({
                ...$5OFXS.toUndefined((0, $1225e12c9d6c4c58$export$d2b41c5654bbe59).getOption(ModTemplate)),
                [variable.Label]: {
                    type: 'Range',
                    Min: 0,
                    Step: 0,
                    ...$5OFXS.toUndefined((0, $6eb8181ce6d386db$export$41ee82b435e20826).getOption(variable.Range)),
                    ...$5OFXS.toUndefined((0, $1225e12c9d6c4c58$export$a96ef9e45d2262fc)(variable.Label).getOption(ModTemplate)),
                    Max: Number(value)
                }
            })));
    const handleVariableRangeMinChange = (variable)=>(value)=>(0, $e0f84d2120016d65$export$90584b8dfa38485d).modify((0, $lWM6H.constant)({
                ...$5OFXS.toUndefined((0, $1225e12c9d6c4c58$export$d2b41c5654bbe59).getOption(ModTemplate)),
                [variable.Label]: {
                    type: 'Range',
                    Max: 0,
                    Step: 0,
                    ...$5OFXS.toUndefined((0, $6eb8181ce6d386db$export$41ee82b435e20826).getOption(variable.Range)),
                    ...$5OFXS.toUndefined((0, $1225e12c9d6c4c58$export$a96ef9e45d2262fc)(variable.Label).getOption(ModTemplate)),
                    Min: Number(value)
                }
            }));
    const handleVariableRangeStepChange = (variable)=>(value)=>({
                ...$5OFXS.toUndefined((0, $1225e12c9d6c4c58$export$d2b41c5654bbe59).getOption(ModTemplate)),
                [variable.Label]: {
                    type: 'Range',
                    Max: 0,
                    Min: 0,
                    ...$5OFXS.toUndefined((0, $6eb8181ce6d386db$export$41ee82b435e20826).getOption(variable.Range)),
                    ...$5OFXS.toUndefined((0, $1225e12c9d6c4c58$export$a96ef9e45d2262fc)(variable.Label).getOption(ModTemplate)),
                    Step: Number(value)
                }
            });
    const convertToSet = (variableLabel)=>(range)=>(0, $e0f84d2120016d65$export$90584b8dfa38485d).modify((0, $lWM6H.constant)({
                ...$5OFXS.toUndefined((0, $1225e12c9d6c4c58$export$d2b41c5654bbe59).getOption(ModTemplate)),
                [variableLabel]: (0, $lWM6H.pipe)(range, $9a4125513576d694$var$rangeSetFromRangeRange)
            }));
    const convertToRange = (variableLabel)=>(nea)=>(0, $e0f84d2120016d65$export$90584b8dfa38485d).modify((0, $lWM6H.constant)({
                ...$5OFXS.toUndefined((0, $1225e12c9d6c4c58$export$d2b41c5654bbe59).getOption(ModTemplate)),
                [variableLabel]: (0, $lWM6H.pipe)(nea, $9a4125513576d694$var$unsortedNeaToRangeRange)
            }));
    const Range = (variable)=>{
        const range = variable.Range;
        const possibleModifiedRange = (0, $1225e12c9d6c4c58$export$a96ef9e45d2262fc)(variable.Label).getOption(ModTemplate);
        const relevantRange = (0, $lWM6H.pipe)(possibleModifiedRange, $5OFXS.getOrElse((0, $lWM6H.constant)(range)));
        switch(relevantRange.type){
            case 'Set':
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 11,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e7d362f04a4204f3$export$2e2bcd8739ae039), {
                            defaultValue: (ModTemplate.VariableSelection ?? {})[variable.Label],
                            step: null,
                            size: "small",
                            marks: relevantRange.Set.map((x)=>({
                                    value: x
                                })),
                            onChangeCommitted: (0, $lWM6H.flow)($9a4125513576d694$var$sliderValue, (x)=>variableUpdate(variable.Label)(x), ps.update)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f867f19cb2db67cf$export$2e2bcd8739ae039), {
                            variable: variable,
                            range: relevantRange,
                            templateMod: ModTemplate,
                            update: ps.update
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                            size: "small",
                            onClick: (0, $lWM6H.flow)(()=>convertToRange(variable.Label)(relevantRange.Set), ps.update),
                            variant: "text",
                            children: "Convert to Range"
                        })
                    ]
                });
            case 'Range':
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 11,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e7d362f04a4204f3$export$2e2bcd8739ae039), {
                            defaultValue: (ModTemplate.VariableSelection ?? {})[variable.Label],
                            valueLabelFormat: (val)=>val.toString(),
                            valueLabelDisplay: "auto",
                            marks: [
                                relevantRange.Min,
                                relevantRange.Max
                            ].map((x)=>({
                                    value: x,
                                    label: x.toString()
                                })),
                            min: relevantRange.Min,
                            max: relevantRange.Max,
                            step: relevantRange.Step,
                            onChangeCommitted: (0, $lWM6H.flow)($9a4125513576d694$var$sliderValue, (x)=>variableUpdate(variable.Label)(x), ps.update)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab898f6be4b94968$export$2e2bcd8739ae039), {
                            value: (0, $1225e12c9d6c4c58$export$b82e210f344079c3)(variable.Label).compose((0, $efdb506a8fb142bf$export$28a5c30e3a807f5b)('eng')).get((0, $1225e12c9d6c4c58$export$adb9192872b64d41).get(ModTemplate)),
                            onChange: (0, $lWM6H.flow)((0, $859db0da13774873$export$2b11a78b8ccd10d4), (x)=>handleVariableNameChange(variable.Label)(x), update),
                            label: `Name: ${variable.Names.eng || variable.Label}`,
                            variant: "outlined"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $82e751e912506609$export$2e2bcd8739ae039), {
                            variableLabel: variable.Label,
                            currentRank: variable.Rank,
                            ModTemplate: ModTemplate,
                            update: ps.update
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab898f6be4b94968$export$2e2bcd8739ae039), {
                                    value: (0, $lWM6H.pipe)((0, $1225e12c9d6c4c58$export$3c1cc8cf2a54464c)(variable.Label).getOption(ModTemplate), $5OFXS.toUndefined),
                                    label: `Max: ${(0, $lWM6H.pipe)((0, $6eb8181ce6d386db$export$de339beb88c783ce).getOption(variable.Range), $5OFXS.toNullable)}`,
                                    inputProps: {
                                        inputMode: 'numeric'
                                    },
                                    helperText: (0, $lWM6H.pipe)((0, $859db0da13774873$export$6e7dd58ef09e0995), $c5dd58add12ba066$exports.ap((0, $6eb8181ce6d386db$export$de339beb88c783ce).getOption(variable.Range)), $c5dd58add12ba066$exports.ap((0, $1225e12c9d6c4c58$export$3c1cc8cf2a54464c)(variable.Label).getOption(ModTemplate)), (0, $859db0da13774873$export$995b48be52afb12a)),
                                    onChange: (0, $lWM6H.flow)((0, $859db0da13774873$export$2b11a78b8ccd10d4), (x)=>handleVariableRangeMaxChange(variable)(x), ps.update)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab898f6be4b94968$export$2e2bcd8739ae039), {
                                    value: (0, $lWM6H.pipe)((0, $1225e12c9d6c4c58$export$16ea5f7f8474dfa1)(variable.Label).getOption(ModTemplate), $5OFXS.toUndefined),
                                    label: `Min: ${(0, $lWM6H.pipe)((0, $6eb8181ce6d386db$export$c0342efd730e1b74).getOption(variable.Range), $5OFXS.toNullable)}`,
                                    inputProps: {
                                        inputMode: 'numeric'
                                    },
                                    helperText: (0, $lWM6H.pipe)((0, $859db0da13774873$export$6e7dd58ef09e0995), $c5dd58add12ba066$exports.ap((0, $6eb8181ce6d386db$export$c0342efd730e1b74).getOption(variable.Range)), $c5dd58add12ba066$exports.ap((0, $1225e12c9d6c4c58$export$16ea5f7f8474dfa1)(variable.Label).getOption(ModTemplate)), (0, $859db0da13774873$export$995b48be52afb12a)),
                                    onChange: (0, $lWM6H.flow)((0, $859db0da13774873$export$2b11a78b8ccd10d4), (x)=>handleVariableRangeMinChange(variable)(x), ps.update)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab898f6be4b94968$export$2e2bcd8739ae039), {
                                    value: (0, $lWM6H.pipe)((0, $1225e12c9d6c4c58$export$4beaac73bc6e8898)(variable.Label).getOption(ModTemplate), $5OFXS.toUndefined),
                                    label: `Step: ${(0, $lWM6H.pipe)((0, $6eb8181ce6d386db$export$9fe3358555274cc).getOption(variable.Range), $5OFXS.toNullable)}`,
                                    type: "number",
                                    inputProps: {
                                        step: 0.0025,
                                        min: 0
                                    },
                                    helperText: (0, $lWM6H.pipe)((0, $859db0da13774873$export$6e7dd58ef09e0995), $c5dd58add12ba066$exports.ap((0, $6eb8181ce6d386db$export$9fe3358555274cc).getOption(variable.Range)), $c5dd58add12ba066$exports.ap((0, $1225e12c9d6c4c58$export$4beaac73bc6e8898)(variable.Label).getOption(ModTemplate)), (0, $859db0da13774873$export$995b48be52afb12a)),
                                    onChange: (0, $lWM6H.flow)((0, $859db0da13774873$export$2b11a78b8ccd10d4), (x)=>handleVariableRangeStepChange(variable)(x), (0, $e0f84d2120016d65$export$90584b8dfa38485d).set, ps.update)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                            size: "small",
                            onClick: (0, $lWM6H.flow)(()=>convertToSet(variable.Label)(relevantRange), ps.update),
                            variant: "text",
                            children: "Convert to Set"
                        })
                    ]
                });
        }
    };
    const Variable = (ps)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
            elevation: 2,
            sx: {
                p: 2,
                m: 1
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        children: ps.variable.Names.eng ?? ps.variable.Label
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    children: Range(ps.variable)
                })
            ]
        });
    const template = $9a4125513576d694$var$findTemplate(ps);
    return template === undefined ? null : template.Vars.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)(Variable, {
            variable: opt
        }, opt.Label));
};
const $9a4125513576d694$export$e34da8ad5841c398 = (modNames)=>modNames ? $5OFXS.some(modNames) : $5OFXS.none;
const $9a4125513576d694$export$125d0b248abd3e88 = (ps)=>{
    const { Id: Id, Mode: Mode, ImageChange: ImageChange } = ps.mod;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
        elevation: 2,
        sx: {
            p: 2,
            m: 1
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
            container: true,
            direction: "row",
            justifyContent: "space-evenly",
            spacing: 1,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    sm: 4,
                    md: 2,
                    lg: 12,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                        value: ps.mod.NamesChange.eng ?? '',
                        fullWidth: true,
                        label: "Template Name",
                        variant: "outlined",
                        onChange: (0, $lWM6H.flow)((0, $859db0da13774873$export$2b11a78b8ccd10d4), (0, $lWM6H.constant), (x)=>(0, $e0f84d2120016d65$export$56d7bc3ecf329b60).compose((0, $efdb506a8fb142bf$export$28a5c30e3a807f5b)('eng')).modify(x), ps.update)
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    sm: 4,
                    md: 2,
                    lg: 12,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                        value: Id,
                        fullWidth: true,
                        label: "Template Id",
                        variant: "outlined",
                        onChange: (0, $lWM6H.flow)((0, $859db0da13774873$export$2b11a78b8ccd10d4), (0, $lWM6H.constant), (x)=>(0, $e0f84d2120016d65$export$d560c7e4a29451c2).modify(x), ps.update)
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    sm: 4,
                    md: 2,
                    lg: 12,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$2e2bcd8739ae039), {
                            id: "BaseId",
                            value: (0, $e0f84d2120016d65$export$4d13b920b27d853).compose((0, $e0f84d2120016d65$export$3e58e8addd15b22d)()).get(ps.mod),
                            label: {
                                eng: 'Base Template'
                            },
                            items: [
                                ...ps.templates,
                                ...ps.modTemplates
                            ].map((t)=>({
                                    key: t.Id,
                                    names: t.Names
                                })),
                            update: (f)=>{
                                const Id = f('');
                                const _ = ps.templates.find((t)=>t.Id === Id) !== undefined ? 'Template' : 'Mod';
                                ps.update((0, $e0f84d2120016d65$export$4d13b920b27d853).set({
                                    _: _,
                                    Id: Id
                                }));
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    sm: 4,
                    md: 2,
                    lg: 12,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$2e2bcd8739ae039), {
                            id: "Mode",
                            value: Mode,
                            label: {
                                eng: 'Design Mode'
                            },
                            items: (0, $35ad564717de6617$export$1107df4484a88f75),
                            update: (f)=>ps.update((0, $e0f84d2120016d65$export$549ff81930776885).modify(f))
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    sm: 4,
                    md: 2,
                    lg: 12,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                        value: ImageChange ?? '',
                        fullWidth: true,
                        label: "Override Image URL",
                        variant: "outlined",
                        onChange: (0, $lWM6H.flow)((0, $859db0da13774873$export$2b11a78b8ccd10d4), (0, $lWM6H.constant), (x)=>(0, $e0f84d2120016d65$export$95b4c46a6af686a3).modify(x), ps.update)
                    })
                })
            ]
        })
    });
};
const $9a4125513576d694$export$aef17b2c703ec8ea = (ps)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        justifyContent: "space-evenly",
        container: true,
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                lg: 3,
                children: $9a4125513576d694$export$125d0b248abd3e88(ps)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                lg: 6,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "row",
                    spacing: 1,
                    children: $9a4125513576d694$export$c019608e5b5bb4cb(ps)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                lg: 3,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "column",
                    justifyContent: "center",
                    children: $9a4125513576d694$export$8bb9d79ea938efc9(ps)
                })
            })
        ]
    });
};









var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");






var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9c1b7b40cd19f5fe$export$81478e24460c57f2(slot) {
    return (0, $4Cod0.default)('MuiListItemIcon', slot);
}
const $9c1b7b40cd19f5fe$var$listItemIconClasses = (0, $beCSm.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $9c1b7b40cd19f5fe$export$2e2bcd8739ae039 = $9c1b7b40cd19f5fe$var$listItemIconClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c01aa6ddbe5e68bd$export$1061006a0db3aeb5(slot) {
    return (0, $4Cod0.default)('MuiListItemText', slot);
}
const $c01aa6ddbe5e68bd$var$listItemTextClasses = (0, $beCSm.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $c01aa6ddbe5e68bd$export$2e2bcd8739ae039 = $c01aa6ddbe5e68bd$var$listItemTextClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adff06ac3b11e066$export$515f8c67b5305377(slot) {
    return (0, $4Cod0.default)('MuiMenuItem', slot);
}
const $adff06ac3b11e066$var$menuItemClasses = (0, $beCSm.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $adff06ac3b11e066$export$2e2bcd8739ae039 = $adff06ac3b11e066$var$menuItemClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1ac984bce84b2164$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $1ac984bce84b2164$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $1ac984bce84b2164$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $adff06ac3b11e066$export$515f8c67b5305377), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $1ac984bce84b2164$var$MenuItemRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $1ac984bce84b2164$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $024a60f892d3fa61$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $024a60f892d3fa61$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $9c1b7b40cd19f5fe$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $8nd05.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $9c1b7b40cd19f5fe$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $1ac984bce84b2164$var$MenuItem = /*#__PURE__*/ $acw62.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $1En50.default)(props, $1ac984bce84b2164$var$_excluded);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $acw62.useRef(null);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $1ac984bce84b2164$var$useUtilityClasses(props);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1ac984bce84b2164$var$MenuItemRoot, (0, $8nd05.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $1ac984bce84b2164$export$2e2bcd8739ae039 = $1ac984bce84b2164$var$MenuItem;



var $kisy7 = parcelRequire("kisy7");
var $4afbe70870407d86$export$b47cf691ccbc6d39;
var $4afbe70870407d86$export$4862b4e1cbd4a552;
var $4afbe70870407d86$export$4997ffc0176396a6;
$4afbe70870407d86$export$b47cf691ccbc6d39 = `_9wxJ6a_template-mod`;
$4afbe70870407d86$export$4862b4e1cbd4a552 = `_9wxJ6a_template-viewer`;
$4afbe70870407d86$export$4997ffc0176396a6 = `_9wxJ6a_wrap`;


const $ad9376fa4dec09a7$var$updateClientTemplateMod = (page)=>(f)=>{
        page.setState((0, $kisy7.Optional).fromNullableProp()('mod').modify(f));
    };
const $ad9376fa4dec09a7$var$setClientTemplateMod = (page)=>(mod)=>{
        page.setState(()=>({
                mod: mod
            }));
    };
const $ad9376fa4dec09a7$var$setServerMod = (page)=>(id)=>{
        page.setState(()=>({
                mod: page.state.mods.find((t)=>t.Id === id)
            }));
    };
const $ad9376fa4dec09a7$var$fetchMods = (page)=>()=>{
        (0, $95ca87e0634ad264$export$d45a3e91f7dd14d0)(page.props.req).then((mods)=>page.setState({
                mods: mods
            })).catch(console.warn);
        (0, $d807307be9b2068b$export$8837f4fc672e936d)(page.props.req)().then((modTemplates)=>page.setState({
                modTemplates: modTemplates
            })).catch(console.warn);
    };
const $ad9376fa4dec09a7$var$fetchTemplates = (page)=>()=>{
        (0, $d6e5c187599ae786$export$8837f4fc672e936d)(page.props.req).then((templates)=>page.setState({
                templates: templates
            })).catch(console.warn);
    };
const $ad9376fa4dec09a7$var$runMod = (page)=>()=>{
        if (page.state.mod === undefined) return;
        (0, $95ca87e0634ad264$export$3fb70f395745212d)(page.props.req)(page.state.mod).then((template)=>{
            page.setState({
                template: template
            });
        }).catch(()=>{
            alert('Applying mod failed.');
        });
    };
const $ad9376fa4dec09a7$var$selectionValue = (ev)=>ev.target.value;
class $ad9376fa4dec09a7$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            mods: [],
            templates: [],
            modTemplates: []
        };
        $ad9376fa4dec09a7$var$fetchTemplates(this)();
        $ad9376fa4dec09a7$var$fetchMods(this)();
    }
    componentDidUpdate(_prevProps, prevState) {
        if (prevState.mod !== this.state.mod) $ad9376fa4dec09a7$var$runMod(this)();
    }
    render() {
        const { mod: mod, template: template, templates: templates, modTemplates: modTemplates } = this.state;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `screen ${$4afbe70870407d86$export$b47cf691ccbc6d39}`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $efbb6eb46c8dd746$export$bfbece8a621a006f), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $437a2d9ce62cfb25$export$d0dbb306591aec74), {
                            codec: (0, $35ad564717de6617$export$d1c678fba33e7572),
                            name: "ClientTemplateMod",
                            success: $ad9376fa4dec09a7$var$setClientTemplateMod(this),
                            failure: (e)=>{
                                alert('Import failed, check console for details.');
                                console.warn(e);
                            }
                        }),
                        mod === undefined ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a29c4ff9777c8b77$export$f883e605db67eacf), {
                            name: "ClientTemplateMod",
                            getContent: ()=>mod,
                            onError: (e)=>{
                                alert('Export failed, check console for details.');
                                console.warn(e);
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                            size: "small",
                            value: "_load-from-server",
                            onChange: (ev)=>$ad9376fa4dec09a7$var$setServerMod(this)($ad9376fa4dec09a7$var$selectionValue(ev)),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                    value: "_load-from-server",
                                    children: "Load"
                                }),
                                this.state.mods.map((m)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                        value: m.Id,
                                        children: m.NamesChange.eng ?? m.Id
                                    }, m.Id))
                            ]
                        }),
                        mod == undefined ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            onClick: ()=>(0, $95ca87e0634ad264$export$3b2bd3b309bebc94)(this.props.req)(mod).then($ad9376fa4dec09a7$var$fetchMods(this)).catch(console.warn),
                            children: "Save"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: 'scroll',
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: $4afbe70870407d86$export$4997ffc0176396a6,
                        children: [
                            template ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8fc20d6ff1f2aab1$export$7370d7aaa0be7e8a), {
                                req: this.props.req,
                                template: template
                            }) : null,
                            template && mod ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {
                                flexItem: true,
                                style: {
                                    margin: '1em'
                                }
                            }) : null,
                            mod ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9a4125513576d694$export$aef17b2c703ec8ea), {
                                templates: templates,
                                mod: mod,
                                modTemplates: modTemplates,
                                update: $ad9376fa4dec09a7$var$updateClientTemplateMod(this)
                            }) : null
                        ]
                    })
                })
            ]
        });
    }
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



/**
 * Options on Templates.
 *
 * @since 0.1.0
 */ 

/**
 * Partial Ordering Relations
 *
 * @since 0.1.0
 */ 
const $cd0a51a718cdd54e$export$633c786fccb90b8e = (0, $87701c398fec8638$export$7e1278799275f68e)({
    '?': true,
    '<': true,
    "\u2264": true,
    '=': true,
    "\u2265": true,
    '>': true
});
const $cd0a51a718cdd54e$export$fa0df8deb43d3c94 = [
    {
        key: '<',
        names: {}
    },
    {
        key: "\u2264",
        names: {}
    },
    {
        key: '=',
        names: {}
    },
    {
        key: "\u2265",
        names: {}
    },
    {
        key: '>',
        names: {}
    },
    {
        key: '?',
        names: {}
    }
];


const $1b6ba425eaad244a$export$d98813043ac451 = [
    {
        key: 'All',
        names: {
            eng: 'all'
        }
    },
    {
        key: 'Any',
        names: {
            eng: 'any'
        }
    },
    {
        key: 'If',
        names: {
            eng: 'if'
        }
    },
    {
        key: 'Opt',
        names: {
            eng: 'opt'
        }
    },
    {
        key: 'Var',
        names: {
            eng: 'var'
        }
    },
    {
        key: 'Var2',
        names: {
            eng: 'var2'
        }
    }
];
const $1b6ba425eaad244a$export$8406dcf8387ca1ba = (0, $87701c398fec8638$export$7e1278799275f68e)({
    All: true,
    Any: true,
    If: true,
    Opt: true,
    Var: true,
    Var2: true
});
const $1b6ba425eaad244a$export$65a93ea3c8c69dca = (0, $87701c398fec8638$export$74c5cab0f9a94551)('Limit', ()=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        $1b6ba425eaad244a$export$5dceb1ab650a1776,
        $1b6ba425eaad244a$export$b24b633b1364b94b,
        $1b6ba425eaad244a$export$1f9ff5f4a6c9361a,
        $1b6ba425eaad244a$export$a76800b3cc430f35,
        $1b6ba425eaad244a$export$bb57dda2d65d7bdf,
        $1b6ba425eaad244a$export$e31d33e578b5360d
    ]));
const $1b6ba425eaad244a$export$5dceb1ab650a1776 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('All'),
    Of: (0, $87701c398fec8638$export$2f23118c22fb2630)($1b6ba425eaad244a$export$65a93ea3c8c69dca)
});
const $1b6ba425eaad244a$export$6da7f911409897f = (x)=>x.type === 'All';
const $1b6ba425eaad244a$export$4905409b35bbfb5c = {
    type: 'All',
    Of: []
};
const $1b6ba425eaad244a$export$b24b633b1364b94b = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Any'),
    Of: (0, $87701c398fec8638$export$2f23118c22fb2630)($1b6ba425eaad244a$export$65a93ea3c8c69dca)
});
const $1b6ba425eaad244a$export$ebb65efc98a3b5f7 = (x)=>x.type === 'Any';
const $1b6ba425eaad244a$export$9c773c1699e584b2 = {
    type: 'Any',
    Of: []
};
const $1b6ba425eaad244a$export$1f9ff5f4a6c9361a = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('If'),
    If: $1b6ba425eaad244a$export$65a93ea3c8c69dca,
    Then: $1b6ba425eaad244a$export$65a93ea3c8c69dca
});
const $1b6ba425eaad244a$export$a7ec85523ec4e8e = (x)=>x.type === 'If';
const $1b6ba425eaad244a$export$7e8d01100f8fafb4 = {
    type: 'If',
    If: $1b6ba425eaad244a$export$4905409b35bbfb5c,
    Then: $1b6ba425eaad244a$export$4905409b35bbfb5c
};
const $1b6ba425eaad244a$export$a76800b3cc430f35 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Opt'),
    Space: (0, $87701c398fec8638$export$22b082955e083ec3),
    Member: (0, $87701c398fec8638$export$4a21f16c33752377),
    Option: (0, $87701c398fec8638$export$2f23118c22fb2630)((0, $87701c398fec8638$export$22b082955e083ec3))
});
const $1b6ba425eaad244a$export$7013e5bb3527c3e7 = (x)=>x.type === 'Opt';
const $1b6ba425eaad244a$export$cf7666cdd1c17998 = {
    type: 'Opt',
    Member: true,
    Space: '',
    Option: []
};
const $1b6ba425eaad244a$export$bb57dda2d65d7bdf = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Var'),
    Variable: (0, $87701c398fec8638$export$22b082955e083ec3),
    Relation: (0, $cd0a51a718cdd54e$export$633c786fccb90b8e),
    Threshold: (0, $87701c398fec8638$export$98e628dec113755e)
});
const $1b6ba425eaad244a$export$7926417cce752554 = (x)=>x.type === 'Var';
const $1b6ba425eaad244a$export$b05512a34af7db19 = {
    type: 'Var',
    Variable: '',
    Threshold: 0,
    Relation: "\u2264"
};
const $1b6ba425eaad244a$export$e31d33e578b5360d = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Var2'),
    Variables: (0, $87701c398fec8638$export$65e3907585753458)([
        (0, $87701c398fec8638$export$22b082955e083ec3),
        (0, $87701c398fec8638$export$22b082955e083ec3)
    ]),
    Relation: (0, $cd0a51a718cdd54e$export$633c786fccb90b8e),
    Thresholds: (0, $87701c398fec8638$export$65e3907585753458)([
        (0, $87701c398fec8638$export$98e628dec113755e),
        (0, $87701c398fec8638$export$98e628dec113755e)
    ])
});
const $1b6ba425eaad244a$export$911e39da4599971f = (x)=>x.type === 'Var2';
const $1b6ba425eaad244a$export$752ea8f2dba086ec = {
    type: 'Var2',
    Variables: [
        '',
        ''
    ],
    Thresholds: [
        0,
        0
    ],
    Relation: "\u2264"
};
const $1b6ba425eaad244a$export$6288b6b9c90bc00 = (0, $87701c398fec8638$export$e45945969df8035a)({
    Id: (0, $87701c398fec8638$export$22b082955e083ec3),
    Owner: (0, $87701c398fec8638$export$22b082955e083ec3),
    Names: (0, $a968eea762bc3488$export$1f12680e68c5100d),
    Limits: (0, $87701c398fec8638$export$2f23118c22fb2630)($1b6ba425eaad244a$export$65a93ea3c8c69dca)
});


/**
 * Optics for Template Limits
 *
 */ 



const $71f4979ed10b052c$export$81a605cad786aa22 = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('Id'), (0, $58f80d7b57eba59b$export$9364064a021bcaeb));
const $71f4979ed10b052c$export$cdbc606e8651e691 = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('Owner'), (0, $58f80d7b57eba59b$export$9364064a021bcaeb));
const $71f4979ed10b052c$export$ffd77c6ec214b4ae = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('Names'), (0, $58f80d7b57eba59b$export$36faa878fcded3d7)({}));
const $71f4979ed10b052c$export$4f0ff5895d116568 = (lang)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($71f4979ed10b052c$export$ffd77c6ec214b4ae, (0, $efdb506a8fb142bf$export$8d74d683613f4568)(lang));
const $71f4979ed10b052c$export$7fb3e0128786861d = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('Limits'), (0, $58f80d7b57eba59b$export$36faa878fcded3d7)([]));
const $71f4979ed10b052c$export$a6712f7c3cbafd4a = (n)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($71f4979ed10b052c$export$7fb3e0128786861d, (0, $58f80d7b57eba59b$export$b610b8812bbcded9)(n));
const $71f4979ed10b052c$export$a320a12b66655c4f = (0, $58f80d7b57eba59b$export$9c59b80dda569a6e)((0, $1b6ba425eaad244a$export$6da7f911409897f));
const $71f4979ed10b052c$export$cb7db3a1e1793509 = (0, $58f80d7b57eba59b$export$9c59b80dda569a6e)((0, $1b6ba425eaad244a$export$ebb65efc98a3b5f7));
const $71f4979ed10b052c$export$d238f08b94b3811 = (0, $58f80d7b57eba59b$export$9c59b80dda569a6e)((0, $1b6ba425eaad244a$export$a7ec85523ec4e8e));
const $71f4979ed10b052c$export$1737e38703f7edee = (0, $58f80d7b57eba59b$export$9c59b80dda569a6e)((0, $1b6ba425eaad244a$export$7013e5bb3527c3e7));
const $71f4979ed10b052c$export$52935ef7a1379bb1 = (0, $58f80d7b57eba59b$export$9c59b80dda569a6e)((0, $1b6ba425eaad244a$export$7926417cce752554));
const $71f4979ed10b052c$export$632ffd88b8af5e78 = (0, $58f80d7b57eba59b$export$9c59b80dda569a6e)((0, $1b6ba425eaad244a$export$911e39da4599971f));
const $71f4979ed10b052c$export$f632c79c8963a286 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Of');
const $71f4979ed10b052c$export$b26c150f612c10f7 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Of');
const $71f4979ed10b052c$export$be7183209e1cf849 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('If');
const $71f4979ed10b052c$export$134f56ec39d3c513 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Then');
const $71f4979ed10b052c$export$6e263237f4b92e56 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Member');
const $71f4979ed10b052c$export$e54be5f93095fbcf = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Space');
const $71f4979ed10b052c$export$a48d90838180b530 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Option');
const $71f4979ed10b052c$export$2461cc740a5e5704 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Variable');
const $71f4979ed10b052c$export$4f40008abfbb0634 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Relation');
const $71f4979ed10b052c$export$abf4f1327c084f77 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Threshold');
const $71f4979ed10b052c$export$a6f8acccb9c24678 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Variables');
const $71f4979ed10b052c$export$b194a0db8422663d = (i)=>(0, $78df2dbbf84a78b3$export$a4627e546088548d)((0, $58f80d7b57eba59b$export$b610b8812bbcded9)(i), (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Variables'));
const $71f4979ed10b052c$export$d16bb39b8c07447d = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Relation');
const $71f4979ed10b052c$export$d24406b32e7c181 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Thresholds');
const $71f4979ed10b052c$export$83a05411002828d5 = (i)=>(0, $78df2dbbf84a78b3$export$a4627e546088548d)((0, $58f80d7b57eba59b$export$b610b8812bbcded9)(i), (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Thresholds'));



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $38dec2a12fb5ddbe$export$a57493d0337fdf6b = /*#__PURE__*/ (0, $acw62.memo)(({ value: value, update: update, size: size })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
        size: size,
        checked: value,
        onChange: (ev)=>update(()=>ev.target.checked)
    }));
var $38dec2a12fb5ddbe$export$2e2bcd8739ae039 = $38dec2a12fb5ddbe$export$a57493d0337fdf6b;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");








const $fb08982e4a8dded8$export$30c9fe5d2bff22ce = ({ value: value, update: update, converter: converter, Edit: Edit, newItem: newItem, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        container: true,
        direction: "column",
        spacing: 1,
        children: [
            children,
            value.map((x, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        container: true,
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                item: true,
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(Edit, {
                                        converter: converter,
                                        value: x,
                                        update: (0, $859db0da13774873$export$2db37b7a33042541)((0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((0, $1379b6c01f560d41$export$b610b8812bbcded9))(i), update)
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                item: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    edge: "end",
                                    "aria-label": "delete",
                                    onClick: ()=>update((xs)=>[
                                                ...xs.slice(0, i),
                                                ...xs.slice(i + 1)
                                            ]),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($29a5410bebd3849f$exports))), {})
                                })
                            })
                        ]
                    })
                }, i)),
            newItem === undefined ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                    color: "primary",
                    edge: "end",
                    "aria-label": "add",
                    onClick: ()=>update((xs)=>[
                                ...xs,
                                newItem
                            ]),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($570fd50501d08ed5$exports))), {})
                })
            })
        ]
    });
var $fb08982e4a8dded8$export$2e2bcd8739ae039 = $fb08982e4a8dded8$export$30c9fe5d2bff22ce;




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $4f4dafdc4e72b545$export$3cc2f83517ffe657 = ({ value: value, update: update, size: size })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$2e2bcd8739ae039), {
        size: size,
        items: (0, $cd0a51a718cdd54e$export$fa0df8deb43d3c94),
        value: value,
        update: update
    });
var $4f4dafdc4e72b545$export$2e2bcd8739ae039 = $4f4dafdc4e72b545$export$3cc2f83517ffe657;








const $e7ac10e11806a1a5$export$d2365fcb913163d8 = /*#__PURE__*/ (0, $acw62.memo)(({ update: update, value: value, template: template })=>{
    const lang = (0, $c197ad7e0b56b287$export$c1fd9f444a3dc711)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        container: true,
        direction: "row",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                container: true,
                direction: "column",
                spacing: 1,
                xs: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df2af751bdad3651$export$c5db55acc87904b6), {
                            value: (0, $58f80d7b57eba59b$export$43f5536de9872e14)((0, $71f4979ed10b052c$export$4f0ff5895d116568)(lang))(value),
                            fullWidth: true,
                            label: "Limits Name",
                            variant: "outlined",
                            update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$4f0ff5895d116568)(lang))
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df2af751bdad3651$export$c5db55acc87904b6), {
                            value: (0, $58f80d7b57eba59b$export$43f5536de9872e14)((0, $71f4979ed10b052c$export$81a605cad786aa22))(value),
                            fullWidth: true,
                            label: "Limits Id",
                            variant: "outlined",
                            update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$81a605cad786aa22))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                xs: 10,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fb08982e4a8dded8$export$30c9fe5d2bff22ce), {
                    newItem: (0, $1b6ba425eaad244a$export$7e8d01100f8fafb4),
                    value: value.Limits ?? [],
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$7fb3e0128786861d)),
                    converter: (0, $4beeab19e80c1290$export$586f2408ab04b194).mm,
                    Edit: (0, $acw62.useMemo)(()=>(ps)=>/*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$export$c851acd06b461cd3, {
                                ...ps,
                                template: template
                            }), [
                        template
                    ])
                })
            })
        ]
    });
});
const $e7ac10e11806a1a5$export$c851acd06b461cd3 = ({ value: value, ...ps })=>value.type === 'If' ? /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$export$6f43bad17aea4a, {
        value: value,
        ...ps
    }) : value.type === 'All' ? /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$export$bbc49cb57aa4bb91, {
        value: value,
        ...ps
    }) : value.type === 'Any' ? /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$export$5a112267febbf7f, {
        value: value,
        ...ps
    }) : value.type === 'Opt' ? /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$export$5c5812349fe9e39d, {
        value: value,
        ...ps
    }) : value.type === 'Var' ? /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$export$36196f3d1fbcbac4, {
        value: value,
        ...ps
    }) : value.type === 'Var2' ? /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$export$4273bdd725efa589, {
        value: value,
        ...ps
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        children: "impossible"
    });
const $e7ac10e11806a1a5$export$bbc49cb57aa4bb91 = /*#__PURE__*/ (0, $acw62.memo)(({ value: value, update: update, template: template })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $fb08982e4a8dded8$export$30c9fe5d2bff22ce), {
        converter: (0, $4beeab19e80c1290$export$586f2408ab04b194).mm,
        newItem: (0, $1b6ba425eaad244a$export$cf7666cdd1c17998),
        value: value.Of,
        update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$a320a12b66655c4f), (0, $71f4979ed10b052c$export$f632c79c8963a286)),
        Edit: (ps)=>/*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$export$c851acd06b461cd3, {
                ...ps,
                template: template
            }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$var$LimitPicker, {
            value: value,
            update: update
        })
    }));
const $e7ac10e11806a1a5$export$5a112267febbf7f = /*#__PURE__*/ (0, $acw62.memo)(({ value: value, update: update, template: template })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $fb08982e4a8dded8$export$30c9fe5d2bff22ce), {
        converter: (0, $4beeab19e80c1290$export$586f2408ab04b194).mm,
        newItem: (0, $1b6ba425eaad244a$export$cf7666cdd1c17998),
        value: value.Of,
        update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$cb7db3a1e1793509), (0, $71f4979ed10b052c$export$b26c150f612c10f7)),
        Edit: (ps)=>/*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$export$c851acd06b461cd3, {
                ...ps,
                template: template
            }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$var$LimitPicker, {
            value: value,
            update: update
        })
    }));
const $e7ac10e11806a1a5$export$6f43bad17aea4a = /*#__PURE__*/ (0, $acw62.memo)(({ value: value, update: update, ...ps })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        item: true,
        container: true,
        direction: "row",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$var$LimitPicker, {
                value: value,
                update: update
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$export$c851acd06b461cd3, {
                    ...ps,
                    value: value.If,
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$d238f08b94b3811), (0, $71f4979ed10b052c$export$be7183209e1cf849))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$export$c851acd06b461cd3, {
                    ...ps,
                    value: value.Then,
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$d238f08b94b3811), (0, $71f4979ed10b052c$export$134f56ec39d3c513))
                })
            })
        ]
    }));
/** Change what space an option limit applies to, then clear the options selected in that option limit. */ const $e7ac10e11806a1a5$var$updateOptionSpaceAndClear = (f)=>(0, $78df2dbbf84a78b3$export$a4627e546088548d)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $71f4979ed10b052c$export$1737e38703f7edee), (0, $71f4979ed10b052c$export$e54be5f93095fbcf))(f), (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $71f4979ed10b052c$export$1737e38703f7edee), (0, $71f4979ed10b052c$export$a48d90838180b530)))([]));
const $e7ac10e11806a1a5$export$5c5812349fe9e39d = /*#__PURE__*/ (0, $acw62.memo)(({ value: value, update: update, template: template })=>{
    const spaces = template === undefined ? [] : template.Opts;
    const space = spaces.find((s)=>s.Label === value.Space);
    const entries = space === undefined ? [] : space.Range;
    const setSpace = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, $e7ac10e11806a1a5$var$updateOptionSpaceAndClear);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        item: true,
        container: true,
        direction: "row",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$var$LimitPicker, {
                value: value,
                update: update
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$e743e65751cd982a), {
                    size: "small",
                    items: spaces.map((space)=>({
                            key: space.Label,
                            names: space.Names
                        })),
                    value: value.Space,
                    update: setSpace
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $38dec2a12fb5ddbe$export$2e2bcd8739ae039), {
                    value: value.Member,
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$1737e38703f7edee), (0, $71f4979ed10b052c$export$6e263237f4b92e56))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$954be10a9d390636), {
                    size: "small",
                    items: entries.map((entry)=>({
                            key: entry.Label,
                            names: entry.Names
                        })),
                    value: value.Option,
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$1737e38703f7edee), (0, $71f4979ed10b052c$export$a48d90838180b530))
                })
            })
        ]
    });
});
const $e7ac10e11806a1a5$var$VarPicker = /*#__PURE__*/ (0, $acw62.memo)(({ value: value, update: update, template: template })=>{
    const vars = template === undefined ? [] : template.Vars;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$e743e65751cd982a), {
        size: "small",
        items: vars.map((v)=>({
                key: v.Label,
                names: {}
            })),
        value: value,
        update: update
    });
});
const $e7ac10e11806a1a5$export$36196f3d1fbcbac4 = /*#__PURE__*/ (0, $acw62.memo)(({ value: value, update: update, template: template })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        item: true,
        container: true,
        direction: "row",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$var$LimitPicker, {
                value: value,
                update: update
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$var$VarPicker, {
                    value: value.Variable,
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$52935ef7a1379bb1), (0, $71f4979ed10b052c$export$2461cc740a5e5704)),
                    template: template
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f4dafdc4e72b545$export$2e2bcd8739ae039), {
                    size: "small",
                    value: value.Relation,
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$52935ef7a1379bb1), (0, $71f4979ed10b052c$export$4f40008abfbb0634))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$2e2bcd8739ae039), {
                    size: "small",
                    unit: "inch",
                    value: value.Threshold,
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$52935ef7a1379bb1), (0, $71f4979ed10b052c$export$abf4f1327c084f77))
                })
            })
        ]
    }));
const $e7ac10e11806a1a5$export$4273bdd725efa589 = /*#__PURE__*/ (0, $acw62.memo)(({ value: value, update: update, template: template })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        item: true,
        container: true,
        direction: "row",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$var$LimitPicker, {
                value: value,
                update: update
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$var$VarPicker, {
                            value: value.Variables[0],
                            update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$632ffd88b8af5e78), (0, $71f4979ed10b052c$export$b194a0db8422663d)(0)),
                            template: template
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($e7ac10e11806a1a5$var$VarPicker, {
                            value: value.Variables[1],
                            update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$632ffd88b8af5e78), (0, $71f4979ed10b052c$export$b194a0db8422663d)(1)),
                            template: template
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f4dafdc4e72b545$export$2e2bcd8739ae039), {
                    size: "small",
                    value: value.Relation,
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$632ffd88b8af5e78), (0, $71f4979ed10b052c$export$d16bb39b8c07447d))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$2e2bcd8739ae039), {
                            size: "small",
                            unit: "inch",
                            value: value.Thresholds[0],
                            update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$632ffd88b8af5e78), (0, $71f4979ed10b052c$export$83a05411002828d5)(0))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$2e2bcd8739ae039), {
                            size: "small",
                            unit: "inch",
                            value: value.Thresholds[1],
                            update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $71f4979ed10b052c$export$632ffd88b8af5e78), (0, $71f4979ed10b052c$export$83a05411002828d5)(1))
                        })
                    ]
                })
            })
        ]
    }));
const $e7ac10e11806a1a5$var$pickType = (type)=>(lim)=>{
        if (type === lim.type) return lim;
        if (type === 'Any') {
            if (lim.type === 'All') return (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $71f4979ed10b052c$export$b26c150f612c10f7))(lim.Of)((0, $1b6ba425eaad244a$export$9c773c1699e584b2));
            return 0, $1b6ba425eaad244a$export$9c773c1699e584b2;
        }
        if (type === 'All') {
            if (lim.type === 'Any') return (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $71f4979ed10b052c$export$f632c79c8963a286))(lim.Of)((0, $1b6ba425eaad244a$export$4905409b35bbfb5c));
            return 0, $1b6ba425eaad244a$export$4905409b35bbfb5c;
        }
        if (type === 'If') return 0, $1b6ba425eaad244a$export$7e8d01100f8fafb4;
        if (type === 'Opt') return 0, $1b6ba425eaad244a$export$cf7666cdd1c17998;
        if (type === 'Var') return 0, $1b6ba425eaad244a$export$b05512a34af7db19;
        if (type === 'Var2') return 0, $1b6ba425eaad244a$export$752ea8f2dba086ec;
        return lim;
    };
const $e7ac10e11806a1a5$var$LimitPicker = ({ value: value, update: update })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        item: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$e743e65751cd982a), {
            size: "small",
            items: (0, $1b6ba425eaad244a$export$d98813043ac451),
            value: value.type,
            update: (f)=>update($e7ac10e11806a1a5$var$pickType(f(value.type)))
        })
    });














const $a849ae06d26d346b$var$editLimit_ = (id)=>(0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)(id ?? '');
const $a849ae06d26d346b$var$editLimit = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((lims, id)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($a849ae06d26d346b$var$editLimit_(id), (0, $58f80d7b57eba59b$export$36faa878fcded3d7)(lims.find((l)=>l.Id === id) ?? {})));
const $a849ae06d26d346b$export$dc36510d23ce6d08 = ({ req: req })=>{
    const [limits, setLimits] = (0, $acw62.useState)([]);
    const [edits, setEdits] = (0, $acw62.useState)({});
    const [saves, setSaves] = (0, $acw62.useState)(0);
    const [templates, setTemplates] = (0, $acw62.useState)([]);
    const [id, updateId] = (0, $959a02c4a2a54235$export$2345a338db110003)('id');
    const [template, updateTemplateId] = (0, $959a02c4a2a54235$export$2345a338db110003)('template');
    const updateTemplate = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(updateTemplateId, (0, $58f80d7b57eba59b$export$36faa878fcded3d7)('_'));
    // keep our list of limits up to date
    (0, $acw62.useEffect)(()=>{
        req.request((0, $87701c398fec8638$export$2f23118c22fb2630)((0, $1b6ba425eaad244a$export$6288b6b9c90bc00)))('template/limit/list', 'GET').then(setLimits).catch(console.warn);
    }, [
        req,
        saves
    ]);
    // fetch the template list (to base the options/vars on)
    (0, $acw62.useEffect)(()=>{
        (0, $d807307be9b2068b$export$8837f4fc672e936d)(req)().then(setTemplates).catch(console.warn);
    }, [
        req
    ]);
    const limit = (0, $58f80d7b57eba59b$export$43f5536de9872e14)($a849ae06d26d346b$var$editLimit(limits, id))(edits);
    const save = (0, $acw62.useCallback)(()=>{
        const lim = edits[id ?? ''];
        if (lim === undefined) return;
        const limId = lim.Id ?? '';
        if (limId === '') req.request((0, $87701c398fec8638$export$22b082955e083ec3))('template/limit', 'POST', lim).then((newId)=>{
            setEdits($a849ae06d26d346b$var$editLimit_(id)((0, $78df2dbbf84a78b3$export$c983f826f44ff86)(undefined)));
            setSaves((i)=>i + 1);
            updateId(()=>newId);
        }).catch(console.warn);
        else req.request((0, $87701c398fec8638$export$19282c40b967aec6))('template/limit', 'PUT', lim).then(()=>{
            setEdits($a849ae06d26d346b$var$editLimit_(id)((0, $78df2dbbf84a78b3$export$c983f826f44ff86)(undefined)));
            setSaves((i)=>i + 1);
            updateId(()=>limId);
        }).catch(console.warn);
    }, [
        id,
        edits,
        req,
        updateId
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "screen template-limits",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $efbb6eb46c8dd746$export$bfbece8a621a006f), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$2e2bcd8739ae039), {
                        label: {
                            eng: 'Template'
                        },
                        size: "small",
                        items: (0, $ff8824db188fc32d$export$650746792cd2f81e)((0, $6689c5083829c982$export$34f8187f64e206fc))(templates),
                        value: template ?? '_',
                        update: updateTemplate
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $437a2d9ce62cfb25$export$d0dbb306591aec74), {
                        codec: (0, $1b6ba425eaad244a$export$6288b6b9c90bc00),
                        name: "import-limits",
                        success: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(setEdits, $a849ae06d26d346b$var$editLimit(limits, id), (0, $78df2dbbf84a78b3$export$c983f826f44ff86))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a29c4ff9777c8b77$export$f883e605db67eacf), {
                        name: "export-limits",
                        getContent: ()=>limit
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                        size: "small",
                        value: id ?? '_',
                        onChange: (0, $acw62.useCallback)((ev)=>updateId(()=>ev.target.value), [
                            updateId
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                value: "_",
                                children: "Load"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                value: "",
                                children: "New"
                            }),
                            limits.map((m)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                    value: m.Id,
                                    children: (0, $58f80d7b57eba59b$export$43f5536de9872e14)((0, $71f4979ed10b052c$export$4f0ff5895d116568)('eng'))(m)
                                }, m.Id))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        size: "small",
                        variant: "outlined",
                        onClick: save,
                        children: "Save"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "scroll",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e7ac10e11806a1a5$export$d2365fcb913163d8), {
                    value: limit,
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(setEdits, $a849ae06d26d346b$var$editLimit(limits, id)),
                    template: templates.find((t)=>t.Id == template)
                })
            })
        ]
    });
};
var $a849ae06d26d346b$export$2e2bcd8739ae039 = $a849ae06d26d346b$export$dc36510d23ce6d08;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $b03affab22376d2b$export$729e9291cdb5b5ea = [
    'shower',
    'mirror',
    'panel',
    'misc'
];
const $b03affab22376d2b$export$3a6738f07b256f2f = {
    'shower': 'S',
    'mirror': 'M',
    'panel': 'P',
    'misc': 'MS'
};
const $b03affab22376d2b$export$fe0f87d711783637 = [
    'Retail',
    'DGM Website',
    'Davenport',
    'DullesCN'
];
const $b03affab22376d2b$export$34972741e49e1f02 = {
    'Retail': 'R',
    'DGM Website': 'DGM',
    'Davenport': 'DVP',
    'DullesCN': 'CN'
};
const $b03affab22376d2b$export$a903e0b288f88ac = {
    'Retail': '575364e710033c899f296ce7da8615bd',
    'DGM Website': '505419ae4311cb0a58eac51f87971f45',
    'Davenport': '0c465e583b398b05f52d9d0019dd756e',
    'DullesCN': 'c7c5367b8af883bfe8b6d6aca8e81349'
};
const $b03affab22376d2b$export$a3e595eabf5acc5c = (0, $87701c398fec8638$export$7e1278799275f68e)({
    shower: true,
    mirror: true,
    panel: true,
    misc: true
});
const $b03affab22376d2b$export$1399fdb3d5364162 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    description: (0, $87701c398fec8638$export$22b082955e083ec3),
    key: (0, $87701c398fec8638$export$22b082955e083ec3),
    name: (0, $87701c398fec8638$export$22b082955e083ec3),
    mode: $b03affab22376d2b$export$a3e595eabf5acc5c,
    value: (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        (0, $87701c398fec8638$export$22b082955e083ec3),
        (0, $87701c398fec8638$export$98e628dec113755e),
        (0, $87701c398fec8638$export$4a21f16c33752377)
    ])
});
const $b03affab22376d2b$export$7e7ccb034cced4c2 = (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), $b03affab22376d2b$export$1399fdb3d5364162); // union([ConfigEntry, undef])
const $b03affab22376d2b$export$ff038b2e7eee250e = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    ApiName: (0, $87701c398fec8638$export$22b082955e083ec3),
    ClassName: (0, $87701c398fec8638$export$22b082955e083ec3),
    Id: (0, $87701c398fec8638$export$22b082955e083ec3),
    Name: (0, $87701c398fec8638$export$22b082955e083ec3),
    SelectedVendor: (0, $87701c398fec8638$export$22b082955e083ec3),
    UserId: (0, $87701c398fec8638$export$22b082955e083ec3),
    Vendors: (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), $b03affab22376d2b$export$7e7ccb034cced4c2)
});
const $b03affab22376d2b$export$2a616981b6a5d4d2 = (o)=>{
    const selectedVendor = o.SelectedVendor;
    const selectedConfigEntries = Object.values(o.Vendors[selectedVendor] ?? {}).map((c)=>({
            ...c,
            mode: 'mode' in c ? c.mode : 'shower'
        }));
    return selectedConfigEntries.map((c)=>{
        const obj = {
            'Id': `${o.UserId}_${c.key}`,
            'OrgName': o.Name,
            'UserId': o.UserId,
            'SelectedVendor': selectedVendor,
            ...c
        };
        return obj;
    });
};
const $b03affab22376d2b$export$e295e35bd30452a1 = (allOrg)=>allOrg.map((o)=>$b03affab22376d2b$export$2a616981b6a5d4d2(o)).flat();



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $jTnBY = parcelRequire("jTnBY");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $e848e543ed3bf349$var$TableContext = /*#__PURE__*/ $acw62.createContext();
var $e848e543ed3bf349$export$2e2bcd8739ae039 = $e848e543ed3bf349$var$TableContext;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $09fe163f52c859c8$var$Tablelvl2Context = /*#__PURE__*/ $acw62.createContext();
var $09fe163f52c859c8$export$2e2bcd8739ae039 = $09fe163f52c859c8$var$Tablelvl2Context;



var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b(slot) {
    return (0, $4Cod0.default)('MuiTableCell', slot);
}
const $a8eb3ce62ab46dc7$var$tableCellClasses = (0, $beCSm.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $a8eb3ce62ab46dc7$export$2e2bcd8739ae039 = $a8eb3ce62ab46dc7$var$tableCellClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a71dfe9e22152ea2$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $a71dfe9e22152ea2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $jTnBY.default)(align)}`,
            padding !== 'normal' && `padding${(0, $jTnBY.default)(padding)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b), classes);
};
const $a71dfe9e22152ea2$var$TableCellRoot = (0, $d8seH.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $jTnBY.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body2, {
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $kSnzZ.lighten)((0, $kSnzZ.alpha)(theme.palette.divider, 1), 0.88) : (0, $kSnzZ.darken)((0, $kSnzZ.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16
    }, ownerState.variant === 'head' && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === 'body' && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === 'footer' && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === 'small' && {
        padding: '6px 16px',
        [`&.${(0, $a8eb3ce62ab46dc7$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: '0 12px 0 16px',
            '& > *': {
                padding: 0
            }
        }
    }, ownerState.padding === 'checkbox' && {
        width: 48,
        // prevent the checkbox column from growing
        padding: '0 0 0 4px'
    }, ownerState.padding === 'none' && {
        padding: 0
    }, ownerState.align === 'left' && {
        textAlign: 'left'
    }, ownerState.align === 'center' && {
        textAlign: 'center'
    }, ownerState.align === 'right' && {
        textAlign: 'right',
        flexDirection: 'row-reverse'
    }, ownerState.align === 'justify' && {
        textAlign: 'justify'
    }, ownerState.stickyHeader && {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $a71dfe9e22152ea2$var$TableCell = /*#__PURE__*/ $acw62.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $1En50.default)(props, $a71dfe9e22152ea2$var$_excluded);
    const table = $acw62.useContext((0, $e848e543ed3bf349$export$2e2bcd8739ae039));
    const tablelvl2 = $acw62.useContext((0, $09fe163f52c859c8$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $8nd05.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    });
    const classes = $a71dfe9e22152ea2$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a71dfe9e22152ea2$var$TableCellRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $a71dfe9e22152ea2$export$2e2bcd8739ae039 = $a71dfe9e22152ea2$var$TableCell;




/*:: export type {ScrollIndices} from './types';*/ var $b45a6abf916bff88$exports = {};
function $b45a6abf916bff88$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$b45a6abf916bff88$exports = $b45a6abf916bff88$var$_classCallCheck, $b45a6abf916bff88$exports.__esModule = true, $b45a6abf916bff88$exports["default"] = $b45a6abf916bff88$exports;


var $fe9438347a673ba6$exports = {};
var $010f4e0e13c82e16$exports = {};
var $2ef66ab8c52ac1c0$exports = {};
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
$2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports;


var $010f4e0e13c82e16$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $b77c8068776c2a21$exports = {};

var $b77c8068776c2a21$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$b77c8068776c2a21$exports = $b77c8068776c2a21$var$toPrimitive, $b77c8068776c2a21$exports.__esModule = true, $b77c8068776c2a21$exports["default"] = $b77c8068776c2a21$exports;


function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $b77c8068776c2a21$exports(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
$010f4e0e13c82e16$exports = $010f4e0e13c82e16$var$toPropertyKey, $010f4e0e13c82e16$exports.__esModule = true, $010f4e0e13c82e16$exports["default"] = $010f4e0e13c82e16$exports;


function $fe9438347a673ba6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $010f4e0e13c82e16$exports(o.key), o);
    }
}
function $fe9438347a673ba6$var$_createClass(e, r, t) {
    return r && $fe9438347a673ba6$var$_defineProperties(e.prototype, r), t && $fe9438347a673ba6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$fe9438347a673ba6$exports = $fe9438347a673ba6$var$_createClass, $fe9438347a673ba6$exports.__esModule = true, $fe9438347a673ba6$exports["default"] = $fe9438347a673ba6$exports;


var $ac4cd79166dac6e4$exports = {};

var $ac4cd79166dac6e4$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $4c93951af9bb8a88$exports = {};
function $4c93951af9bb8a88$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$4c93951af9bb8a88$exports = $4c93951af9bb8a88$var$_assertThisInitialized, $4c93951af9bb8a88$exports.__esModule = true, $4c93951af9bb8a88$exports["default"] = $4c93951af9bb8a88$exports;


function $ac4cd79166dac6e4$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $ac4cd79166dac6e4$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $4c93951af9bb8a88$exports(t);
}
$ac4cd79166dac6e4$exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, $ac4cd79166dac6e4$exports.__esModule = true, $ac4cd79166dac6e4$exports["default"] = $ac4cd79166dac6e4$exports;


var $93d4339c80153a6a$exports = {};
function $93d4339c80153a6a$var$_getPrototypeOf(t) {
    return $93d4339c80153a6a$exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $93d4339c80153a6a$exports.__esModule = true, $93d4339c80153a6a$exports["default"] = $93d4339c80153a6a$exports, $93d4339c80153a6a$var$_getPrototypeOf(t);
}
$93d4339c80153a6a$exports = $93d4339c80153a6a$var$_getPrototypeOf, $93d4339c80153a6a$exports.__esModule = true, $93d4339c80153a6a$exports["default"] = $93d4339c80153a6a$exports;


var $b050fc8434f4a0e1$exports = {};
var $7b4ac2338b8e8f97$exports = {};
function $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e) {
    return $7b4ac2338b8e8f97$exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $7b4ac2338b8e8f97$exports.__esModule = true, $7b4ac2338b8e8f97$exports["default"] = $7b4ac2338b8e8f97$exports, $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e);
}
$7b4ac2338b8e8f97$exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, $7b4ac2338b8e8f97$exports.__esModule = true, $7b4ac2338b8e8f97$exports["default"] = $7b4ac2338b8e8f97$exports;


function $b050fc8434f4a0e1$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $7b4ac2338b8e8f97$exports(t, e);
}
$b050fc8434f4a0e1$exports = $b050fc8434f4a0e1$var$_inherits, $b050fc8434f4a0e1$exports.__esModule = true, $b050fc8434f4a0e1$exports["default"] = $b050fc8434f4a0e1$exports;


var $bb7ca61ce45563c4$exports = {};

function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $010f4e0e13c82e16$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$bb7ca61ce45563c4$exports = $bb7ca61ce45563c4$var$_defineProperty, $bb7ca61ce45563c4$exports.__esModule = true, $bb7ca61ce45563c4$exports["default"] = $bb7ca61ce45563c4$exports;



var $acw62 = parcelRequire("acw62");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c8a186e1757974bb$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c8a186e1757974bb$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c8a186e1757974bb$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c8a186e1757974bb$var$componentWillMount.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c8a186e1757974bb$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $c8a186e1757974bb$var$componentWillMount;
        prototype.componentWillReceiveProps = $c8a186e1757974bb$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $c8a186e1757974bb$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}


function $e1efda5622819829$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e1efda5622819829$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e1efda5622819829$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e1efda5622819829$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e1efda5622819829$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $e1efda5622819829$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $e1efda5622819829$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e1efda5622819829$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */ /*:: type ChildrenParams = {
  onSectionRendered: (params: RenderedSection) => void,
  scrollToColumn: number,
  scrollToRow: number,
};*/ /*:: type Props = {
  children: (params: ChildrenParams) => React.Element<*>,
  className?: string,
  columnCount: number,
  disabled: boolean,
  isControlled: boolean,
  mode: 'cells' | 'edges',
  onScrollToChange?: (params: ScrollIndices) => void,
  rowCount: number,
  scrollToColumn: number,
  scrollToRow: number,
};*/ /*:: type State = ScrollIndices & {
  instanceProps: {
    prevScrollToColumn: number,
    prevScrollToRow: number,
  },
};*/ var $e1efda5622819829$var$ArrowKeyStepper = /*#__PURE__*/ function(_React$PureComponent) {
    function ArrowKeyStepper() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ArrowKeyStepper);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $e1efda5622819829$var$_callSuper(this, ArrowKeyStepper, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "state", {
            scrollToColumn: 0,
            scrollToRow: 0,
            instanceProps: {
                prevScrollToColumn: 0,
                prevScrollToRow: 0
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_columnStartIndex", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_columnStopIndex", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_rowStartIndex", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_rowStopIndex", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onKeyDown", function(event /*: KeyboardEvent*/ ) {
            var _this$props = _this.props, columnCount = _this$props.columnCount, disabled = _this$props.disabled, mode = _this$props.mode, rowCount = _this$props.rowCount;
            if (disabled) return;
            var _this$_getScrollState = _this._getScrollState(), scrollToColumnPrevious = _this$_getScrollState.scrollToColumn, scrollToRowPrevious = _this$_getScrollState.scrollToRow;
            var _this$_getScrollState2 = _this._getScrollState(), scrollToColumn = _this$_getScrollState2.scrollToColumn, scrollToRow = _this$_getScrollState2.scrollToRow;
            // The above cases all prevent default event event behavior.
            // This is to keep the grid from scrolling after the snap-to update.
            switch(event.key){
                case 'ArrowDown':
                    scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
                    break;
                case 'ArrowLeft':
                    scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
                    break;
                case 'ArrowRight':
                    scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
                    break;
                case 'ArrowUp':
                    scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
                    break;
            }
            if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
                event.preventDefault();
                _this._updateScrollState({
                    scrollToColumn: scrollToColumn,
                    scrollToRow: scrollToRow
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onSectionRendered", function(_ref /*:: */ ) {
            var columnStartIndex = _ref /*:: */ .columnStartIndex, columnStopIndex = _ref /*:: */ .columnStopIndex, rowStartIndex = _ref /*:: */ .rowStartIndex, rowStopIndex = _ref /*:: */ .rowStopIndex;
            _this._columnStartIndex = columnStartIndex;
            _this._columnStopIndex = columnStopIndex;
            _this._rowStartIndex = rowStartIndex;
            _this._rowStopIndex = rowStopIndex;
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(ArrowKeyStepper, _React$PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(ArrowKeyStepper, [
        {
            key: "setScrollIndexes",
            value: function setScrollIndexes(_ref2 /*:: */ ) {
                var scrollToColumn = _ref2 /*:: */ .scrollToColumn, scrollToRow = _ref2 /*:: */ .scrollToRow;
                this.setState({
                    scrollToRow: scrollToRow,
                    scrollToColumn: scrollToColumn
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, className = _this$props2.className, children = _this$props2.children;
                var _this$_getScrollState3 = this._getScrollState(), scrollToColumn = _this$_getScrollState3.scrollToColumn, scrollToRow = _this$_getScrollState3.scrollToRow;
                return /*#__PURE__*/ $acw62.createElement("div", {
                    className: className,
                    onKeyDown: this._onKeyDown
                }, children({
                    onSectionRendered: this._onSectionRendered,
                    scrollToColumn: scrollToColumn,
                    scrollToRow: scrollToRow
                }));
            }
        },
        {
            key: "_getScrollState",
            value: function _getScrollState() {
                return this.props.isControlled ? this.props : this.state;
            }
        },
        {
            key: "_updateScrollState",
            value: function _updateScrollState(_ref3 /*:: */ ) {
                var scrollToColumn = _ref3 /*:: */ .scrollToColumn, scrollToRow = _ref3 /*:: */ .scrollToRow;
                var _this$props3 = this.props, isControlled = _this$props3.isControlled, onScrollToChange = _this$props3.onScrollToChange;
                if (typeof onScrollToChange === 'function') onScrollToChange({
                    scrollToColumn: scrollToColumn,
                    scrollToRow: scrollToRow
                });
                if (!isControlled) this.setState({
                    scrollToColumn: scrollToColumn,
                    scrollToRow: scrollToRow
                });
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                if (nextProps.isControlled) return {};
                if (nextProps.scrollToColumn !== prevState.instanceProps.prevScrollToColumn || nextProps.scrollToRow !== prevState.instanceProps.prevScrollToRow) return $e1efda5622819829$var$_objectSpread($e1efda5622819829$var$_objectSpread({}, prevState), {}, {
                    scrollToColumn: nextProps.scrollToColumn,
                    scrollToRow: nextProps.scrollToRow,
                    instanceProps: {
                        prevScrollToColumn: nextProps.scrollToColumn,
                        prevScrollToRow: nextProps.scrollToRow
                    }
                });
                return {};
            }
        }
    ]);
}($acw62.PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))($e1efda5622819829$var$ArrowKeyStepper, "defaultProps", {
    disabled: false,
    isControlled: false,
    mode: 'edges',
    scrollToColumn: 0,
    scrollToRow: 0
});
(0, $c8a186e1757974bb$export$cea1c58a6db52bca)($e1efda5622819829$var$ArrowKeyStepper);
var $e1efda5622819829$export$2e2bcd8739ae039 = $e1efda5622819829$var$ArrowKeyStepper;











var $acw62 = parcelRequire("acw62");
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/ function $1b7c52d1527ca6fe$export$2e2bcd8739ae039(nonce, hostWindow) {
    // Check `document` and `window` in case of server-side rendering
    var _window;
    if (typeof hostWindow !== 'undefined') _window = hostWindow;
    else if (typeof window !== 'undefined') _window = window;
    else if (typeof self !== 'undefined') _window = self;
    else _window = $parcel$global;
    var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;
    if (!attachEvent) {
        var requestFrame = function() {
            var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function(fn) {
                return _window.setTimeout(fn, 20);
            };
            return function(fn) {
                return raf(fn);
            };
        }();
        var cancelFrame = function() {
            var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
            return function(id) {
                return cancel(id);
            };
        }();
        var resetTriggers = function resetTriggers(element) {
            var triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
            contract.scrollLeft = contract.scrollWidth;
            contract.scrollTop = contract.scrollHeight;
            expandChild.style.width = expand.offsetWidth + 1 + 'px';
            expandChild.style.height = expand.offsetHeight + 1 + 'px';
            expand.scrollLeft = expand.scrollWidth;
            expand.scrollTop = expand.scrollHeight;
        };
        var checkTriggers = function checkTriggers(element) {
            return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
        };
        var scrollListener = function scrollListener(e) {
            // Don't measure (which forces) reflow for scrolls that happen inside of children!
            if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) return;
            var element = this;
            resetTriggers(this);
            if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
            this.__resizeRAF__ = requestFrame(function() {
                if (checkTriggers(element)) {
                    element.__resizeLast__.width = element.offsetWidth;
                    element.__resizeLast__.height = element.offsetHeight;
                    element.__resizeListeners__.forEach(function(fn) {
                        fn.call(element, e);
                    });
                }
            });
        };
        /* Detect CSS Animations support to detect element display/re-attach */ var animation = false, keyframeprefix = '', animationstartevent = 'animationstart', domPrefixes = 'Webkit Moz O ms'.split(' '), startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '), pfx = '';
        var elm = _window.document.createElement('fakeelement');
        if (elm.style.animationName !== undefined) animation = true;
        if (animation === false) {
            for(var i = 0; i < domPrefixes.length; i++)if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
                pfx = domPrefixes[i];
                keyframeprefix = '-' + pfx.toLowerCase() + '-';
                animationstartevent = startEvents[i];
                animation = true;
                break;
            }
        }
        var animationName = 'resizeanim';
        var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
        var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
    }
    var createStyles = function createStyles(doc) {
        if (!doc.getElementById('detectElementResize')) {
            //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
            var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', head = doc.head || doc.getElementsByTagName('head')[0], style = doc.createElement('style');
            style.id = 'detectElementResize';
            style.type = 'text/css';
            if (nonce != null) style.setAttribute('nonce', nonce);
            if (style.styleSheet) style.styleSheet.cssText = css;
            else style.appendChild(doc.createTextNode(css));
            head.appendChild(style);
        }
    };
    var addResizeListener = function addResizeListener(element, fn) {
        if (attachEvent) element.attachEvent('onresize', fn);
        else {
            if (!element.__resizeTriggers__) {
                var doc = element.ownerDocument;
                var elementStyle = _window.getComputedStyle(element);
                if (elementStyle && elementStyle.position == 'static') element.style.position = 'relative';
                createStyles(doc);
                element.__resizeLast__ = {};
                element.__resizeListeners__ = [];
                (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
                var expandTrigger = doc.createElement('div');
                expandTrigger.className = 'expand-trigger';
                expandTrigger.appendChild(doc.createElement('div'));
                var contractTrigger = doc.createElement('div');
                contractTrigger.className = 'contract-trigger';
                element.__resizeTriggers__.appendChild(expandTrigger);
                element.__resizeTriggers__.appendChild(contractTrigger);
                element.appendChild(element.__resizeTriggers__);
                resetTriggers(element);
                element.addEventListener('scroll', scrollListener, true);
                /* Listen for a css animation to detect element display/re-attach */ if (animationstartevent) {
                    element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
                        if (e.animationName == animationName) resetTriggers(element);
                    };
                    element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                }
            }
            element.__resizeListeners__.push(fn);
        }
    };
    var removeResizeListener = function removeResizeListener(element, fn) {
        if (attachEvent) element.detachEvent('onresize', fn);
        else {
            element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
            if (!element.__resizeListeners__.length) {
                element.removeEventListener('scroll', scrollListener, true);
                if (element.__resizeTriggers__.__animationListener__) {
                    element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                    element.__resizeTriggers__.__animationListener__ = null;
                }
                try {
                    element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
                } catch (e) {
                // Preact compat; see developit/preact-compat/issues/228
                }
            }
        }
    };
    return {
        addResizeListener: addResizeListener,
        removeResizeListener: removeResizeListener
    };
}


function $0ae9562149794479$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0ae9562149794479$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0ae9562149794479$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0ae9562149794479$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0ae9562149794479$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $0ae9562149794479$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $0ae9562149794479$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0ae9562149794479$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
/*:: type Size = {
  height: number,
  width: number,
};*/ /*:: type Props = {
  /** Function responsible for rendering children.*-/
  children: Size => React.Element<*>,

  /** Optional custom CSS class name to attach to root AutoSizer element.  *-/
  className?: string,

  /** Default height to use for initial render; useful for SSR *-/
  defaultHeight?: number,

  /** Default width to use for initial render; useful for SSR *-/
  defaultWidth?: number,

  /** Disable dynamic :height property *-/
  disableHeight: boolean,

  /** Disable dynamic :width property *-/
  disableWidth: boolean,

  /** Nonce of the inlined stylesheet for Content Security Policy *-/
  nonce?: string,

  /** Callback to be invoked on-resize *-/
  onResize: Size => void,

  /** Optional inline style *-/
  style: ?Object,
};*/ /*:: type State = {
  height: number,
  width: number,
};*/ /*:: type ResizeHandler = (element: HTMLElement, onResize: () => void) => void;*/ /*:: type DetectElementResize = {
  addResizeListener: ResizeHandler,
  removeResizeListener: ResizeHandler,
};*/ var $0ae9562149794479$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function AutoSizer() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, AutoSizer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $0ae9562149794479$var$_callSuper(this, AutoSizer, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "state", {
            height: _this.props.defaultHeight || 0,
            width: _this.props.defaultWidth || 0
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_parentNode", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_autoSizer", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_window", void 0);
        // uses any instead of Window because Flow doesn't have window type
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_detectElementResize", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onResize", function() {
            var _this$props = _this.props, disableHeight = _this$props.disableHeight, disableWidth = _this$props.disableWidth, onResize = _this$props.onResize;
            if (_this._parentNode) {
                // Guard against AutoSizer component being removed from the DOM immediately after being added.
                // This can result in invalid style values which can result in NaN values if we don't handle them.
                // See issue #150 for more context.
                var height = _this._parentNode.offsetHeight || 0;
                var width = _this._parentNode.offsetWidth || 0;
                var win = _this._window || window;
                var style = win.getComputedStyle(_this._parentNode) || {};
                var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
                var paddingRight = parseInt(style.paddingRight, 10) || 0;
                var paddingTop = parseInt(style.paddingTop, 10) || 0;
                var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
                var newHeight = height - paddingTop - paddingBottom;
                var newWidth = width - paddingLeft - paddingRight;
                if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
                    _this.setState({
                        height: height - paddingTop - paddingBottom,
                        width: width - paddingLeft - paddingRight
                    });
                    onResize({
                        height: height,
                        width: width
                    });
                }
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_setRef", function(autoSizer /*: ?HTMLElement*/ ) {
            _this._autoSizer = autoSizer;
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(AutoSizer, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(AutoSizer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var nonce = this.props.nonce;
                if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
                    // Delay access of parentNode until mount.
                    // This handles edge-cases where the component has already been unmounted before its ref has been set,
                    // As well as libraries like react-lite which have a slightly different lifecycle.
                    this._parentNode = this._autoSizer.parentNode;
                    this._window = this._autoSizer.parentNode.ownerDocument.defaultView;
                    // Defer requiring resize handler in order to support server-side rendering.
                    // See issue #41
                    this._detectElementResize = (0, $1b7c52d1527ca6fe$export$2e2bcd8739ae039)(nonce, this._window);
                    this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
                    this._onResize();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this._detectElementResize && this._parentNode) this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, children = _this$props2.children, className = _this$props2.className, disableHeight = _this$props2.disableHeight, disableWidth = _this$props2.disableWidth, style = _this$props2.style;
                var _this$state = this.state, height = _this$state.height, width = _this$state.width;
                // Outer div should not force width/height since that may prevent containers from shrinking.
                // Inner component should overflow and use calculated width/height.
                // See issue #68 for more information.
                var outerStyle /*: Object*/  = {
                    overflow: 'visible'
                };
                var childParams /*: Object*/  = {};
                if (!disableHeight) {
                    outerStyle.height = 0;
                    childParams.height = height;
                }
                if (!disableWidth) {
                    outerStyle.width = 0;
                    childParams.width = width;
                }
                /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */ return /*#__PURE__*/ $acw62.createElement("div", {
                    className: className,
                    ref: this._setRef,
                    style: $0ae9562149794479$var$_objectSpread($0ae9562149794479$var$_objectSpread({}, outerStyle), style)
                }, children(childParams));
            }
        }
    ]);
}($acw62.Component);
(0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))($0ae9562149794479$export$2e2bcd8739ae039, "defaultProps", {
    onResize: function onResize() {},
    disableHeight: false,
    disableWidth: false,
    style: {}
});











var $acw62 = parcelRequire("acw62");
function $dd0db06e12b8535f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $dd0db06e12b8535f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $dd0db06e12b8535f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dd0db06e12b8535f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
/*:: type Children = (params: {measure: () => void}) => React.Element<*>;*/ /*:: type Cell = {
  columnIndex: number,
  rowIndex: number,
};*/ /*:: type Props = {
  cache: CellMeasureCache,
  children: Children | React.Element<*>,
  columnIndex?: number,
  index?: number,
  parent: {
    invalidateCellSizeAfterRender?: (cell: Cell) => void,
    recomputeGridSize?: (cell: Cell) => void,
  },
  rowIndex?: number,
};*/ /**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */ var $dd0db06e12b8535f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    function CellMeasurer() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, CellMeasurer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $dd0db06e12b8535f$var$_callSuper(this, CellMeasurer, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_child", /*#__PURE__*/ $acw62.createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_measure", function() {
            var _this$props = _this.props, cache = _this$props.cache, _this$props$columnInd = _this$props.columnIndex, columnIndex = _this$props$columnInd === void 0 ? 0 : _this$props$columnInd, parent = _this$props.parent, _this$props$rowIndex = _this$props.rowIndex, rowIndex = _this$props$rowIndex === void 0 ? _this.props.index || 0 : _this$props$rowIndex;
            var _this$_getCellMeasure = _this._getCellMeasurements(), height = _this$_getCellMeasure.height, width = _this$_getCellMeasure.width;
            if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
                cache.set(rowIndex, columnIndex, width, height);
                if (parent && typeof parent.recomputeGridSize === 'function') parent.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: rowIndex
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_registerChild", function(element) {
            if (element && !(element instanceof Element)) console.warn('CellMeasurer registerChild expects to be passed Element or null');
            _this._child.current = element;
            if (element) _this._maybeMeasureCell();
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(CellMeasurer, _React$PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(CellMeasurer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._maybeMeasureCell();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this._maybeMeasureCell();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var children = this.props.children;
                var resolvedChildren = typeof children === 'function' ? children({
                    measure: this._measure,
                    registerChild: this._registerChild
                }) : children;
                if (resolvedChildren === null) return resolvedChildren;
                return /*#__PURE__*/ (0, $acw62.cloneElement)(resolvedChildren, {
                    ref: function ref(node) {
                        if (typeof resolvedChildren.ref === 'function') resolvedChildren.ref(node);
                        else if (resolvedChildren.ref) resolvedChildren.ref.current = node;
                        _this2._child.current = node;
                    }
                });
            }
        },
        {
            key: "_getCellMeasurements",
            value: function _getCellMeasurements() {
                var cache = this.props.cache;
                var node = this._child.current;
                // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height
                if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
                    var styleWidth = node.style.width;
                    var styleHeight = node.style.height;
                    // If we are re-measuring a cell that has already been measured,
                    // It will have a hard-coded width/height from the previous measurement.
                    // The fact that we are measuring indicates this measurement is probably stale,
                    // So explicitly clear it out (eg set to "auto") so we can recalculate.
                    // See issue #593 for more info.
                    // Even if we are measuring initially- if we're inside of a MultiGrid component,
                    // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
                    // eg top/left Grid renders before bottom/right Grid
                    // Since the CellMeasurerCache is shared between them this taints derived cell size values.
                    if (!cache.hasFixedWidth()) node.style.width = 'auto';
                    if (!cache.hasFixedHeight()) node.style.height = 'auto';
                    var height = Math.ceil(node.offsetHeight);
                    var width = Math.ceil(node.offsetWidth);
                    // Reset after measuring to avoid breaking styles; see #660
                    if (styleWidth) node.style.width = styleWidth;
                    if (styleHeight) node.style.height = styleHeight;
                    return {
                        height: height,
                        width: width
                    };
                } else return {
                    height: 0,
                    width: 0
                };
            }
        },
        {
            key: "_maybeMeasureCell",
            value: function _maybeMeasureCell() {
                var _this$props2 = this.props, cache = _this$props2.cache, _this$props2$columnIn = _this$props2.columnIndex, columnIndex = _this$props2$columnIn === void 0 ? 0 : _this$props2$columnIn, parent = _this$props2.parent, _this$props2$rowIndex = _this$props2.rowIndex, rowIndex = _this$props2$rowIndex === void 0 ? this.props.index || 0 : _this$props2$rowIndex;
                if (!cache.has(rowIndex, columnIndex)) {
                    var _this$_getCellMeasure2 = this._getCellMeasurements(), height = _this$_getCellMeasure2.height, width = _this$_getCellMeasure2.width;
                    cache.set(rowIndex, columnIndex, width, height);
                    // If size has changed, let Grid know to re-render.
                    if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') parent.invalidateCellSizeAfterRender({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        }
    ]);
}($acw62.PureComponent); // Used for DEV mode warning check
(0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))($dd0db06e12b8535f$export$2e2bcd8739ae039, "__internalCellMeasurerFlag", false);





var $e11dc6f35d449d49$export$611c894df53833b0 = 30;
var $e11dc6f35d449d49$export$aa4eace044cdfdbf = 100;
// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.
/*:: type KeyMapper = (rowIndex: number, columnIndex: number) => any;*/ /*:: type CellMeasurerCacheParams = {
  defaultHeight?: number,
  defaultWidth?: number,
  fixedHeight?: boolean,
  fixedWidth?: boolean,
  minHeight?: number,
  minWidth?: number,
  keyMapper?: KeyMapper,
};*/ /*:: type Cache = {
  [key: any]: number,
};*/ /*:: type IndexParam = {
  index: number,
};*/ /**
 * Caches measurements for a given cell.
 */ var $e11dc6f35d449d49$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function CellMeasurerCache() {
        var _this = this;
        var params /*: CellMeasurerCacheParams*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, CellMeasurerCache);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_cellHeightCache", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_cellWidthCache", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_columnWidthCache", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_rowHeightCache", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_defaultHeight", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_defaultWidth", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_minHeight", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_minWidth", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_keyMapper", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_hasFixedHeight", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_hasFixedWidth", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_columnCount", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_rowCount", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "columnWidth", function(_ref /*:: */ ) {
            var index = _ref /*:: */ .index;
            var key = _this._keyMapper(0, index);
            return _this._columnWidthCache[key] !== undefined ? _this._columnWidthCache[key] : _this._defaultWidth;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "rowHeight", function(_ref2 /*:: */ ) {
            var index = _ref2 /*:: */ .index;
            var key = _this._keyMapper(index, 0);
            return _this._rowHeightCache[key] !== undefined ? _this._rowHeightCache[key] : _this._defaultHeight;
        });
        var defaultHeight = params.defaultHeight, defaultWidth = params.defaultWidth, fixedHeight = params.fixedHeight, fixedWidth = params.fixedWidth, keyMapper = params.keyMapper, minHeight = params.minHeight, minWidth = params.minWidth;
        this._hasFixedHeight = fixedHeight === true;
        this._hasFixedWidth = fixedWidth === true;
        this._minHeight = minHeight || 0;
        this._minWidth = minWidth || 0;
        this._keyMapper = keyMapper || $e11dc6f35d449d49$var$defaultKeyMapper;
        this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : $e11dc6f35d449d49$export$611c894df53833b0);
        this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : $e11dc6f35d449d49$export$aa4eace044cdfdbf);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(CellMeasurerCache, [
        {
            key: "clear",
            value: function clear(rowIndex /*: number*/ ) {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                delete this._cellHeightCache[key];
                delete this._cellWidthCache[key];
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: "clearAll",
            value: function clearAll() {
                this._cellHeightCache = {};
                this._cellWidthCache = {};
                this._columnWidthCache = {};
                this._rowHeightCache = {};
                this._rowCount = 0;
                this._columnCount = 0;
            }
        },
        {
            key: "defaultHeight",
            get: function get() /*: number*/ {
                return this._defaultHeight;
            }
        },
        {
            key: "defaultWidth",
            get: function get() /*: number*/ {
                return this._defaultWidth;
            }
        },
        {
            key: "hasFixedHeight",
            value: function hasFixedHeight() /*: boolean*/ {
                return this._hasFixedHeight;
            }
        },
        {
            key: "hasFixedWidth",
            value: function hasFixedWidth() /*: boolean*/ {
                return this._hasFixedWidth;
            }
        },
        {
            key: "getHeight",
            value: function getHeight(rowIndex /*: number*/ ) /*: number*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedHeight) return this._defaultHeight;
                else {
                    var _key = this._keyMapper(rowIndex, columnIndex);
                    return this._cellHeightCache[_key] !== undefined ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
                }
            }
        },
        {
            key: "getWidth",
            value: function getWidth(rowIndex /*: number*/ ) /*: number*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedWidth) return this._defaultWidth;
                else {
                    var _key2 = this._keyMapper(rowIndex, columnIndex);
                    return this._cellWidthCache[_key2] !== undefined ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
                }
            }
        },
        {
            key: "has",
            value: function has(rowIndex /*: number*/ ) /*: boolean*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                return this._cellHeightCache[key] !== undefined;
            }
        },
        {
            key: "set",
            value: function set(rowIndex /*: number*/ , columnIndex /*: number*/ , width /*: number*/ , height /*: number*/ ) /*: void*/ {
                var key = this._keyMapper(rowIndex, columnIndex);
                if (columnIndex >= this._columnCount) this._columnCount = columnIndex + 1;
                if (rowIndex >= this._rowCount) this._rowCount = rowIndex + 1;
                // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
                this._cellHeightCache[key] = height;
                this._cellWidthCache[key] = width;
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: "_updateCachedColumnAndRowSizes",
            value: function _updateCachedColumnAndRowSizes(rowIndex /*: number*/ , columnIndex /*: number*/ ) {
                // :columnWidth and :rowHeight are derived based on all cells in a column/row.
                // Pre-cache these derived values for faster lookup later.
                // Reads are expected to occur more frequently than writes in this case.
                // Only update non-fixed dimensions though to avoid doing unnecessary work.
                if (!this._hasFixedWidth) {
                    var columnWidth = 0;
                    for(var i = 0; i < this._rowCount; i++)columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
                    var columnKey = this._keyMapper(0, columnIndex);
                    this._columnWidthCache[columnKey] = columnWidth;
                }
                if (!this._hasFixedHeight) {
                    var rowHeight = 0;
                    for(var _i = 0; _i < this._columnCount; _i++)rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
                    var rowKey = this._keyMapper(rowIndex, 0);
                    this._rowHeightCache[rowKey] = rowHeight;
                }
            }
        }
    ]);
}();
function $e11dc6f35d449d49$var$defaultKeyMapper(rowIndex /*: number*/ , columnIndex /*: number*/ ) {
    return "".concat(rowIndex, "-").concat(columnIndex);
}


var $f7df01476f6daaab$export$2e2bcd8739ae039 = (0, $dd0db06e12b8535f$export$2e2bcd8739ae039);


var $dd8b9c1e17bbac03$exports = {};
function $dd8b9c1e17bbac03$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
$dd8b9c1e17bbac03$exports = $dd8b9c1e17bbac03$var$_objectDestructuringEmpty, $dd8b9c1e17bbac03$exports.__esModule = true, $dd8b9c1e17bbac03$exports["default"] = $dd8b9c1e17bbac03$exports;



var $3p9rK = parcelRequire("3p9rK");








var $acw62 = parcelRequire("acw62");






function $15e8569690cae660$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $15e8569690cae660$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $15e8569690cae660$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $15e8569690cae660$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15e8569690cae660$export$2e2bcd8739ae039 = $15e8569690cae660$export$4f5d2d50c9deca37;




var $acw62 = parcelRequire("acw62");

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */ function $eb7485db8fea8a79$export$2e2bcd8739ae039() {
    var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var cachedIndices = {};
    return function(_ref) {
        var callback = _ref.callback, indices = _ref.indices;
        var keys = Object.keys(indices);
        var allInitialized = !requireAllKeys || keys.every(function(key) {
            var value = indices[key];
            return Array.isArray(value) ? value.length > 0 : value >= 0;
        });
        var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function(key) {
            var cachedValue = cachedIndices[key];
            var value = indices[key];
            return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
        });
        cachedIndices = indices;
        if (allInitialized && indexChanged) callback(indices);
    };
}


var $55986f7b0f69fd17$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $2d215567a00cb0b5$var$size;
function $2d215567a00cb0b5$export$2e2bcd8739ae039(recalc) {
    if (!$2d215567a00cb0b5$var$size && $2d215567a00cb0b5$var$size !== 0 || recalc) {
        if (0, $55986f7b0f69fd17$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $2d215567a00cb0b5$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $2d215567a00cb0b5$var$size;
}


function $7d114388ef95f930$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d114388ef95f930$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d114388ef95f930$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d114388ef95f930$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7d114388ef95f930$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $7d114388ef95f930$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $7d114388ef95f930$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7d114388ef95f930$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// @TODO Merge Collection and CollectionView
/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */ var $7d114388ef95f930$var$IS_SCROLLING_TIMEOUT = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */ var $7d114388ef95f930$var$SCROLL_POSITION_CHANGE_REASONS = {
    OBSERVED: 'observed',
    REQUESTED: 'requested'
};
/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */ var $7d114388ef95f930$var$CollectionView = /*#__PURE__*/ function(_React$PureComponent) {
    function CollectionView() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, CollectionView);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $7d114388ef95f930$var$_callSuper(this, CollectionView, [].concat(args));
        // If this component is being rendered server-side, getScrollbarSize() will return undefined.
        // We handle this case in componentDidMount()
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "state", {
            isScrolling: false,
            scrollLeft: 0,
            scrollTop: 0
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_calculateSizeAndPositionDataOnNextUpdate", false);
        // Invokes callbacks only when their values have changed.
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onSectionRenderedMemoizer", (0, $eb7485db8fea8a79$export$2e2bcd8739ae039)());
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onScrollMemoizer", (0, $eb7485db8fea8a79$export$2e2bcd8739ae039)(false));
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_invokeOnSectionRenderedHelper", function() {
            var _this$props = _this.props, cellLayoutManager = _this$props.cellLayoutManager, onSectionRendered = _this$props.onSectionRendered;
            _this._onSectionRenderedMemoizer({
                callback: onSectionRendered,
                indices: {
                    indices: cellLayoutManager.getLastRenderedIndices()
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_setScrollingContainerRef", function(ref) {
            _this._scrollingContainer = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_updateScrollPositionForScrollToCell", function() {
            var _this$props2 = _this.props, cellLayoutManager = _this$props2.cellLayoutManager, height = _this$props2.height, scrollToAlignment = _this$props2.scrollToAlignment, scrollToCell = _this$props2.scrollToCell, width = _this$props2.width;
            var _this$state = _this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            if (scrollToCell >= 0) {
                var scrollPosition = cellLayoutManager.getScrollPositionForCell({
                    align: scrollToAlignment,
                    cellIndex: scrollToCell,
                    height: height,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    width: width
                });
                if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) _this._setScrollPosition(scrollPosition);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onScroll", function(event) {
            // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
            // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
            // See issue #404 for more information.
            if (event.target !== _this._scrollingContainer) return;
            // Prevent pointer events from interrupting a smooth scroll
            _this._enablePointerEventsAfterDelay();
            // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
            // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
            // This causes a series of rapid renders that is slow for long lists.
            // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
            var _this$props3 = _this.props, cellLayoutManager = _this$props3.cellLayoutManager, height = _this$props3.height, isScrollingChange = _this$props3.isScrollingChange, width = _this$props3.width;
            var scrollbarSize = _this._scrollbarSize;
            var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(), totalHeight = _cellLayoutManager$ge.height, totalWidth = _cellLayoutManager$ge.width;
            var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
            var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));
            // Certain devices (like Apple touchpad) rapid-fire duplicate events.
            // Don't force a re-render if this is the case.
            // The mouse may move faster then the animation frame does.
            // Use requestAnimationFrame to avoid over-updating.
            if (_this.state.scrollLeft !== scrollLeft || _this.state.scrollTop !== scrollTop) {
                // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
                // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
                // All things considered, this seems to be the best current work around that I'm aware of.
                // For more information see https://github.com/bvaughn/react-virtualized/pull/124
                var scrollPositionChangeReason = event.cancelable ? $7d114388ef95f930$var$SCROLL_POSITION_CHANGE_REASONS.OBSERVED : $7d114388ef95f930$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED;
                // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
                if (!_this.state.isScrolling) isScrollingChange(true);
                _this.setState({
                    isScrolling: true,
                    scrollLeft: scrollLeft,
                    scrollPositionChangeReason: scrollPositionChangeReason,
                    scrollTop: scrollTop
                });
            }
            _this._invokeOnScrollMemoizer({
                scrollLeft: scrollLeft,
                scrollTop: scrollTop,
                totalWidth: totalWidth,
                totalHeight: totalHeight
            });
        });
        _this._scrollbarSize = (0, $2d215567a00cb0b5$export$2e2bcd8739ae039)();
        if (_this._scrollbarSize === undefined) {
            _this._scrollbarSizeMeasured = false;
            _this._scrollbarSize = 0;
        } else _this._scrollbarSizeMeasured = true;
        return _this;
    }
    /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(CollectionView, _React$PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(CollectionView, [
        {
            key: "recomputeCellSizesAndPositions",
            value: function recomputeCellSizesAndPositions() {
                this._calculateSizeAndPositionDataOnNextUpdate = true;
                this.forceUpdate();
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props4 = this.props, cellLayoutManager = _this$props4.cellLayoutManager, scrollLeft = _this$props4.scrollLeft, scrollToCell = _this$props4.scrollToCell, scrollTop = _this$props4.scrollTop;
                // If this component was first rendered server-side, scrollbar size will be undefined.
                // In that event we need to remeasure.
                if (!this._scrollbarSizeMeasured) {
                    this._scrollbarSize = (0, $2d215567a00cb0b5$export$2e2bcd8739ae039)();
                    this._scrollbarSizeMeasured = true;
                    this.setState({});
                }
                if (scrollToCell >= 0) this._updateScrollPositionForScrollToCell();
                else if (scrollLeft >= 0 || scrollTop >= 0) this._setScrollPosition({
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
                // Update onSectionRendered callback.
                this._invokeOnSectionRenderedHelper();
                var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(), totalHeight = _cellLayoutManager$ge2.height, totalWidth = _cellLayoutManager$ge2.width;
                // Initialize onScroll callback.
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft || 0,
                    scrollTop: scrollTop || 0,
                    totalHeight: totalHeight,
                    totalWidth: totalWidth
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this$props5 = this.props, height = _this$props5.height, scrollToAlignment = _this$props5.scrollToAlignment, scrollToCell = _this$props5.scrollToCell, width = _this$props5.width;
                var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollPositionChangeReason = _this$state2.scrollPositionChangeReason, scrollTop = _this$state2.scrollTop;
                // Make sure requested changes to :scrollLeft or :scrollTop get applied.
                // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
                // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
                // So we only set these when we require an adjustment of the scroll position.
                // See issue #2 for more information.
                if (scrollPositionChangeReason === $7d114388ef95f930$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
                    if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) this._scrollingContainer.scrollLeft = scrollLeft;
                    if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) this._scrollingContainer.scrollTop = scrollTop;
                }
                // Update scroll offsets if the current :scrollToCell values requires it
                if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) this._updateScrollPositionForScrollToCell();
                // Update onRowsRendered callback if start/stop indices have changed
                this._invokeOnSectionRenderedHelper();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this._disablePointerEventsTimeoutId) clearTimeout(this._disablePointerEventsTimeoutId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, autoHeight = _this$props6.autoHeight, cellCount = _this$props6.cellCount, cellLayoutManager = _this$props6.cellLayoutManager, className = _this$props6.className, height = _this$props6.height, horizontalOverscanSize = _this$props6.horizontalOverscanSize, id = _this$props6.id, noContentRenderer = _this$props6.noContentRenderer, style = _this$props6.style, verticalOverscanSize = _this$props6.verticalOverscanSize, width = _this$props6.width;
                var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollLeft = _this$state3.scrollLeft, scrollTop = _this$state3.scrollTop;
                // Memoization reset
                if (this._lastRenderedCellCount !== cellCount || this._lastRenderedCellLayoutManager !== cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
                    this._lastRenderedCellCount = cellCount;
                    this._lastRenderedCellLayoutManager = cellLayoutManager;
                    this._calculateSizeAndPositionDataOnNextUpdate = false;
                    cellLayoutManager.calculateSizeAndPositionData();
                }
                var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(), totalHeight = _cellLayoutManager$ge3.height, totalWidth = _cellLayoutManager$ge3.width;
                // Safely expand the rendered area by the specified overscan amount
                var left = Math.max(0, scrollLeft - horizontalOverscanSize);
                var top = Math.max(0, scrollTop - verticalOverscanSize);
                var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
                var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);
                var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
                    height: bottom - top,
                    isScrolling: isScrolling,
                    width: right - left,
                    x: left,
                    y: top
                }) : [];
                var collectionStyle = {
                    boxSizing: 'border-box',
                    direction: 'ltr',
                    height: autoHeight ? 'auto' : height,
                    position: 'relative',
                    WebkitOverflowScrolling: 'touch',
                    width: width,
                    willChange: 'transform'
                };
                // Force browser to hide scrollbars when we know they aren't necessary.
                // Otherwise once scrollbars appear they may not disappear again.
                // For more info see issue #116
                var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
                var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;
                // Also explicitly init styles to 'auto' if scrollbars are required.
                // This works around an obscure edge case where external CSS styles have not yet been loaded,
                // But an initial scroll index of offset is set as an external prop.
                // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
                // This was originally reported via clauderic/react-infinite-calendar/issues/23
                collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
                collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
                return /*#__PURE__*/ $acw62.createElement("div", {
                    ref: this._setScrollingContainerRef,
                    "aria-label": this.props['aria-label'],
                    className: (0, $15e8569690cae660$export$2e2bcd8739ae039)('ReactVirtualized__Collection', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: "grid",
                    style: $7d114388ef95f930$var$_objectSpread($7d114388ef95f930$var$_objectSpread({}, collectionStyle), style),
                    tabIndex: 0
                }, cellCount > 0 && /*#__PURE__*/ $acw62.createElement("div", {
                    className: "ReactVirtualized__Collection__innerScrollContainer",
                    style: {
                        height: totalHeight,
                        maxHeight: totalHeight,
                        maxWidth: totalWidth,
                        overflow: 'hidden',
                        pointerEvents: isScrolling ? 'none' : '',
                        width: totalWidth
                    }
                }, childrenToDisplay), cellCount === 0 && noContentRenderer());
            }
        },
        {
            key: "_enablePointerEventsAfterDelay",
            value: function _enablePointerEventsAfterDelay() {
                var _this2 = this;
                if (this._disablePointerEventsTimeoutId) clearTimeout(this._disablePointerEventsTimeoutId);
                this._disablePointerEventsTimeoutId = setTimeout(function() {
                    var isScrollingChange = _this2.props.isScrollingChange;
                    isScrollingChange(false);
                    _this2._disablePointerEventsTimeoutId = null;
                    _this2.setState({
                        isScrolling: false
                    });
                }, $7d114388ef95f930$var$IS_SCROLLING_TIMEOUT);
            }
        },
        {
            key: "_invokeOnScrollMemoizer",
            value: function _invokeOnScrollMemoizer(_ref) {
                var _this3 = this;
                var scrollLeft = _ref.scrollLeft, scrollTop = _ref.scrollTop, totalHeight = _ref.totalHeight, totalWidth = _ref.totalWidth;
                this._onScrollMemoizer({
                    callback: function callback(_ref2) {
                        var scrollLeft = _ref2.scrollLeft, scrollTop = _ref2.scrollTop;
                        var _this3$props = _this3.props, height = _this3$props.height, onScroll = _this3$props.onScroll, width = _this3$props.width;
                        onScroll({
                            clientHeight: height,
                            clientWidth: width,
                            scrollHeight: totalHeight,
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop,
                            scrollWidth: totalWidth
                        });
                    },
                    indices: {
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    }
                });
            }
        },
        {
            key: "_setScrollPosition",
            value: function _setScrollPosition(_ref3) {
                var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
                var newState = {
                    scrollPositionChangeReason: $7d114388ef95f930$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                if (scrollLeft >= 0) newState.scrollLeft = scrollLeft;
                if (scrollTop >= 0) newState.scrollTop = scrollTop;
                if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) this.setState(newState);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.cellCount === 0 && (prevState.scrollLeft !== 0 || prevState.scrollTop !== 0)) return {
                    scrollLeft: 0,
                    scrollTop: 0,
                    scrollPositionChangeReason: $7d114388ef95f930$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) return {
                    scrollLeft: nextProps.scrollLeft != null ? nextProps.scrollLeft : prevState.scrollLeft,
                    scrollTop: nextProps.scrollTop != null ? nextProps.scrollTop : prevState.scrollTop,
                    scrollPositionChangeReason: $7d114388ef95f930$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                return null;
            }
        }
    ]);
}($acw62.PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))($7d114388ef95f930$var$CollectionView, "defaultProps", {
    'aria-label': 'grid',
    horizontalOverscanSize: 0,
    noContentRenderer: function noContentRenderer() {
        return null;
    },
    onScroll: function onScroll() {
        return null;
    },
    onSectionRendered: function onSectionRendered() {
        return null;
    },
    scrollToAlignment: 'auto',
    scrollToCell: -1,
    style: {},
    verticalOverscanSize: 0
});
$7d114388ef95f930$var$CollectionView.propTypes = {};
(0, $c8a186e1757974bb$export$cea1c58a6db52bca)($7d114388ef95f930$var$CollectionView);
var $7d114388ef95f930$export$2e2bcd8739ae039 = $7d114388ef95f930$var$CollectionView;






/*:: import type {Index, SizeAndPositionInfo} from './types';*/ /**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */ var $38467ff412f26fd6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Section(_ref /*:: */ ) {
        var height = _ref /*:: */ .height, width = _ref /*:: */ .width, x = _ref /*:: */ .x, y = _ref /*:: */ .y;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Section);
        this.height = height;
        this.width = width;
        this.x = x;
        this.y = y;
        this._indexMap = {};
        this._indices = [];
    }
    /** Add a cell to this section. */ return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Section, [
        {
            key: "addCellIndex",
            value: function addCellIndex(_ref2 /*:: */ ) {
                var index = _ref2 /*:: */ .index;
                if (!this._indexMap[index]) {
                    this._indexMap[index] = true;
                    this._indices.push(index);
                }
            }
        },
        {
            key: "getCellIndices",
            value: function getCellIndices() /*: Array<number>*/ {
                return this._indices;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.x, ",").concat(this.y, " ").concat(this.width, "x").concat(this.height);
            }
        }
    ]);
}();


/*:: import type {Index, SizeAndPositionInfo} from './types';*/ var $b2dcb6f04fa79efb$var$SECTION_SIZE = 100;
/*:: type RegisterCellParams = {
  cellMetadatum: SizeAndPositionInfo,
  index: number,
};*/ /**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */ var $b2dcb6f04fa79efb$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function SectionManager() {
        var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $b2dcb6f04fa79efb$var$SECTION_SIZE;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, SectionManager);
        this._sectionSize = sectionSize;
        this._cellMetadata = [];
        this._sections = {};
    }
    /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(SectionManager, [
        {
            key: "getCellIndices",
            value: function getCellIndices(_ref /*:: */ ) /*: Array<number>*/ {
                var height = _ref /*:: */ .height, width = _ref /*:: */ .width, x = _ref /*:: */ .x, y = _ref /*:: */ .y;
                var indices = {};
                this.getSections({
                    height: height,
                    width: width,
                    x: x,
                    y: y
                }).forEach(function(section) {
                    return section.getCellIndices().forEach(function(index) {
                        indices[index] = index;
                    });
                });
                // Object keys are strings; this function returns numbers
                return Object.keys(indices).map(function(index) {
                    return indices[index];
                });
            }
        },
        {
            key: "getCellMetadata",
            value: function getCellMetadata(_ref2 /*:: */ ) /*: SizeAndPositionInfo*/ {
                var index = _ref2 /*:: */ .index;
                return this._cellMetadata[index];
            }
        },
        {
            key: "getSections",
            value: function getSections(_ref3 /*:: */ ) /*: Array<Section>*/ {
                var height = _ref3 /*:: */ .height, width = _ref3 /*:: */ .width, x = _ref3 /*:: */ .x, y = _ref3 /*:: */ .y;
                var sectionXStart = Math.floor(x / this._sectionSize);
                var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
                var sectionYStart = Math.floor(y / this._sectionSize);
                var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);
                var sections = [];
                for(var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++)for(var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++){
                    var key = "".concat(sectionX, ".").concat(sectionY);
                    if (!this._sections[key]) this._sections[key] = new (0, $38467ff412f26fd6$export$2e2bcd8739ae039)({
                        height: this._sectionSize,
                        width: this._sectionSize,
                        x: sectionX * this._sectionSize,
                        y: sectionY * this._sectionSize
                    });
                    sections.push(this._sections[key]);
                }
                return sections;
            }
        },
        {
            key: "getTotalSectionCount",
            value: function getTotalSectionCount() {
                return Object.keys(this._sections).length;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var _this = this;
                return Object.keys(this._sections).map(function(index) {
                    return _this._sections[index].toString();
                });
            }
        },
        {
            key: "registerCell",
            value: function registerCell(_ref4 /*:: */ ) {
                var cellMetadatum = _ref4 /*:: */ .cellMetadatum, index = _ref4 /*:: */ .index;
                this._cellMetadata[index] = cellMetadatum;
                this.getSections(cellMetadatum).forEach(function(section) {
                    return section.addCellIndex({
                        index: index
                    });
                });
            }
        }
    ]);
}();


function $390131c5be3c47cd$export$2e2bcd8739ae039(_ref) {
    var cellCount = _ref.cellCount, cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter, sectionSize = _ref.sectionSize;
    var cellMetadata = [];
    var sectionManager = new (0, $b2dcb6f04fa79efb$export$2e2bcd8739ae039)(sectionSize);
    var height = 0;
    var width = 0;
    for(var index = 0; index < cellCount; index++){
        var cellMetadatum = cellSizeAndPositionGetter({
            index: index
        });
        if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) throw Error("Invalid metadata returned for cell ".concat(index, ":\n        x:").concat(cellMetadatum.x, ", y:").concat(cellMetadatum.y, ", width:").concat(cellMetadatum.width, ", height:").concat(cellMetadatum.height));
        height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
        width = Math.max(width, cellMetadatum.x + cellMetadatum.width);
        cellMetadata[index] = cellMetadatum;
        sectionManager.registerCell({
            cellMetadatum: cellMetadatum,
            index: index
        });
    }
    return {
        cellMetadata: cellMetadata,
        height: height,
        sectionManager: sectionManager,
        width: width
    };
}


/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */ function $f0fd48994814cc2b$export$2e2bcd8739ae039(_ref) {
    var _ref$align = _ref.align, align = _ref$align === void 0 ? 'auto' : _ref$align, cellOffset = _ref.cellOffset, cellSize = _ref.cellSize, containerSize = _ref.containerSize, currentOffset = _ref.currentOffset;
    var maxOffset = cellOffset;
    var minOffset = maxOffset - containerSize + cellSize;
    switch(align){
        case 'start':
            return maxOffset;
        case 'end':
            return minOffset;
        case 'center':
            return maxOffset - (containerSize - cellSize) / 2;
        default:
            return Math.max(minOffset, Math.min(maxOffset, currentOffset));
    }
}


function $4aab291370499c5f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $4aab291370499c5f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $4aab291370499c5f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4aab291370499c5f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
/*:: import type {ScrollPosition, SizeInfo} from './types';*/ /**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */ var $4aab291370499c5f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    function Collection(props, context) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Collection);
        _this = $4aab291370499c5f$var$_callSuper(this, Collection, [
            props,
            context
        ]);
        _this._cellMetadata = [];
        _this._lastRenderedCellIndices = [];
        // Cell cache during scroll (for performance)
        _this._cellCache = [];
        _this._isScrollingChange = _this._isScrollingChange.bind(_this);
        _this._setCollectionViewRef = _this._setCollectionViewRef.bind(_this);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(Collection, _React$PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Collection, [
        {
            key: "forceUpdate",
            value: function forceUpdate() {
                if (this._collectionView !== undefined) this._collectionView.forceUpdate();
            }
        },
        {
            key: "recomputeCellSizesAndPositions",
            value: function recomputeCellSizesAndPositions() {
                this._cellCache = [];
                this._collectionView.recomputeCellSizesAndPositions();
            }
        },
        {
            key: "render",
            value: function render() {
                var props = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, ((0, (/*@__PURE__*/$parcel$interopDefault($dd8b9c1e17bbac03$exports)))(this.props), this.props));
                return /*#__PURE__*/ $acw62.createElement((0, $7d114388ef95f930$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                    cellLayoutManager: this,
                    isScrollingChange: this._isScrollingChange,
                    ref: this._setCollectionViewRef
                }, props));
            }
        },
        {
            key: "calculateSizeAndPositionData",
            value: function calculateSizeAndPositionData() {
                var _this$props = this.props, cellCount = _this$props.cellCount, cellSizeAndPositionGetter = _this$props.cellSizeAndPositionGetter, sectionSize = _this$props.sectionSize;
                var data = (0, $390131c5be3c47cd$export$2e2bcd8739ae039)({
                    cellCount: cellCount,
                    cellSizeAndPositionGetter: cellSizeAndPositionGetter,
                    sectionSize: sectionSize
                });
                this._cellMetadata = data.cellMetadata;
                this._sectionManager = data.sectionManager;
                this._height = data.height;
                this._width = data.width;
            }
        },
        {
            key: "getLastRenderedIndices",
            value: function getLastRenderedIndices() {
                return this._lastRenderedCellIndices;
            }
        },
        {
            key: "getScrollPositionForCell",
            value: function getScrollPositionForCell(_ref) /*: ScrollPosition*/ {
                var align = _ref.align, cellIndex = _ref.cellIndex, height = _ref.height, scrollLeft = _ref.scrollLeft, scrollTop = _ref.scrollTop, width = _ref.width;
                var cellCount = this.props.cellCount;
                if (cellIndex >= 0 && cellIndex < cellCount) {
                    var cellMetadata = this._cellMetadata[cellIndex];
                    scrollLeft = (0, $f0fd48994814cc2b$export$2e2bcd8739ae039)({
                        align: align,
                        cellOffset: cellMetadata.x,
                        cellSize: cellMetadata.width,
                        containerSize: width,
                        currentOffset: scrollLeft,
                        targetIndex: cellIndex
                    });
                    scrollTop = (0, $f0fd48994814cc2b$export$2e2bcd8739ae039)({
                        align: align,
                        cellOffset: cellMetadata.y,
                        cellSize: cellMetadata.height,
                        containerSize: height,
                        currentOffset: scrollTop,
                        targetIndex: cellIndex
                    });
                }
                return {
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                };
            }
        },
        {
            key: "getTotalSize",
            value: function getTotalSize() /*: SizeInfo*/ {
                return {
                    height: this._height,
                    width: this._width
                };
            }
        },
        {
            key: "cellRenderers",
            value: function cellRenderers(_ref2) {
                var _this2 = this;
                var height = _ref2.height, isScrolling = _ref2.isScrolling, width = _ref2.width, x = _ref2.x, y = _ref2.y;
                var _this$props2 = this.props, cellGroupRenderer = _this$props2.cellGroupRenderer, cellRenderer = _this$props2.cellRenderer;
                // Store for later calls to getLastRenderedIndices()
                this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
                    height: height,
                    width: width,
                    x: x,
                    y: y
                });
                return cellGroupRenderer({
                    cellCache: this._cellCache,
                    cellRenderer: cellRenderer,
                    cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
                        var index = _ref3.index;
                        return _this2._sectionManager.getCellMetadata({
                            index: index
                        });
                    },
                    indices: this._lastRenderedCellIndices,
                    isScrolling: isScrolling
                });
            }
        },
        {
            key: "_isScrollingChange",
            value: function _isScrollingChange(isScrolling) {
                if (!isScrolling) this._cellCache = [];
            }
        },
        {
            key: "_setCollectionViewRef",
            value: function _setCollectionViewRef(ref) {
                this._collectionView = ref;
            }
        }
    ]);
}($acw62.PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))($4aab291370499c5f$export$2e2bcd8739ae039, "defaultProps", {
    'aria-label': 'grid',
    cellGroupRenderer: $4aab291370499c5f$var$defaultCellGroupRenderer
});
$4aab291370499c5f$export$2e2bcd8739ae039.propTypes = {};
function $4aab291370499c5f$var$defaultCellGroupRenderer(_ref4) {
    var cellCache = _ref4.cellCache, cellRenderer = _ref4.cellRenderer, cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter, indices = _ref4.indices, isScrolling = _ref4.isScrolling;
    return indices.map(function(index) {
        var cellMetadata = cellSizeAndPositionGetter({
            index: index
        });
        var cellRendererProps = {
            index: index,
            isScrolling: isScrolling,
            key: index,
            style: {
                height: cellMetadata.height,
                left: cellMetadata.x,
                position: 'absolute',
                top: cellMetadata.y,
                width: cellMetadata.width
            }
        };
        // Avoid re-creating cells while scrolling.
        // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
        // If a scroll is in progress- cache and reuse cells.
        // This cache will be thrown away once scrolling complets.
        if (isScrolling) {
            if (!(index in cellCache)) cellCache[index] = cellRenderer(cellRendererProps);
            return cellCache[index];
        } else return cellRenderer(cellRendererProps);
    }).filter(function(renderedCell) {
        return !!renderedCell;
    });
}


var $71f1443e37a27744$export$2e2bcd8739ae039 = (0, $4aab291370499c5f$export$2e2bcd8739ae039);









var $acw62 = parcelRequire("acw62");
function $01229c68a690a09c$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $01229c68a690a09c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $01229c68a690a09c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($01229c68a690a09c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */ var $01229c68a690a09c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    function ColumnSizer(props, context) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ColumnSizer);
        _this = $01229c68a690a09c$var$_callSuper(this, ColumnSizer, [
            props,
            context
        ]);
        _this._registerChild = _this._registerChild.bind(_this);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(ColumnSizer, _React$PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(ColumnSizer, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props = this.props, columnMaxWidth = _this$props.columnMaxWidth, columnMinWidth = _this$props.columnMinWidth, columnCount = _this$props.columnCount, width = _this$props.width;
                if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
                    if (this._registeredChild) this._registeredChild.recomputeGridSize();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, children = _this$props2.children, columnMaxWidth = _this$props2.columnMaxWidth, columnMinWidth = _this$props2.columnMinWidth, columnCount = _this$props2.columnCount, width = _this$props2.width;
                var safeColumnMinWidth = columnMinWidth || 1;
                var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;
                var columnWidth = width / columnCount;
                columnWidth = Math.max(safeColumnMinWidth, columnWidth);
                columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
                columnWidth = Math.floor(columnWidth);
                var adjustedWidth = Math.min(width, columnWidth * columnCount);
                return children({
                    adjustedWidth: adjustedWidth,
                    columnWidth: columnWidth,
                    getColumnWidth: function getColumnWidth() {
                        return columnWidth;
                    },
                    registerChild: this._registerChild
                });
            }
        },
        {
            key: "_registerChild",
            value: function _registerChild(child) {
                if (child && typeof child.recomputeGridSize !== 'function') throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
                this._registeredChild = child;
                if (this._registeredChild) this._registeredChild.recomputeGridSize();
            }
        }
    ]);
}($acw62.PureComponent);
$01229c68a690a09c$export$2e2bcd8739ae039.propTypes = {};


var $e24489a01d36406f$export$2e2bcd8739ae039 = (0, $01229c68a690a09c$export$2e2bcd8739ae039);


/*:: export type {
  NoContentRenderer,
  Alignment,
  CellPosition,
  CellSize,
  OverscanIndicesGetter,
  RenderedSection,
  CellRendererParams,
  Scroll,
} from './types';*/ 
var $3p9rK = parcelRequire("3p9rK");








var $acw62 = parcelRequire("acw62");

/**
 * Helper method that determines when to recalculate row or column metadata.
 */ /*:: type Params<T> = {
  // Number of rows or columns in the current axis
  cellCount: number,

  // Width or height of cells for the current axis
  cellSize: ?number,

  // Method to invoke if cell metadata should be recalculated
  computeMetadataCallback: (props: T) => void,

  // Parameters to pass to :computeMetadataCallback
  computeMetadataCallbackProps: T,

  // Newly updated number of rows or columns in the current axis
  nextCellsCount: number,

  // Newly updated width or height of cells for the current axis
  nextCellSize: ?number,

  // Newly updated scroll-to-index
  nextScrollToIndex: number,

  // Scroll-to-index
  scrollToIndex: number,

  // Callback to invoke if the scroll position should be recalculated
  updateScrollOffsetForScrollToIndex: () => void,
};*/ function $be0ed937fc97fa1d$export$2e2bcd8739ae039(_ref /*:: */ ) {
    var cellCount = _ref /*:: */ .cellCount, cellSize = _ref /*:: */ .cellSize, computeMetadataCallback = _ref /*:: */ .computeMetadataCallback, computeMetadataCallbackProps = _ref /*:: */ .computeMetadataCallbackProps, nextCellsCount = _ref /*:: */ .nextCellsCount, nextCellSize = _ref /*:: */ .nextCellSize, nextScrollToIndex = _ref /*:: */ .nextScrollToIndex, scrollToIndex = _ref /*:: */ .scrollToIndex, updateScrollOffsetForScrollToIndex = _ref /*:: */ .updateScrollOffsetForScrollToIndex;
    // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
    // In that event users should use the manual recompute methods to inform of changes.
    if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
        computeMetadataCallback(computeMetadataCallbackProps);
        // Updated cell metadata may have hidden the previous scrolled-to item.
        // In this case we should also update the scrollTop to ensure it stays visible.
        if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) updateScrollOffsetForScrollToIndex();
    }
}


var $c5fdcdd8d5286ae7$exports = {};

var $c05no = parcelRequire("c05no");
function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c05no(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$c5fdcdd8d5286ae7$exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, $c5fdcdd8d5286ae7$exports.__esModule = true, $c5fdcdd8d5286ae7$exports["default"] = $c5fdcdd8d5286ae7$exports;








/*:: import type {Alignment, CellSizeGetter, VisibleCellRange} from '../types';*/ /*:: type CellSizeAndPositionManagerParams = {
  cellCount: number,
  cellSizeGetter: CellSizeGetter,
  estimatedCellSize: number,
};*/ /*:: type ConfigureParams = {
  cellCount: number,
  estimatedCellSize: number,
  cellSizeGetter: CellSizeGetter,
};*/ /*:: type GetUpdatedOffsetForIndex = {
  align: Alignment,
  containerSize: number,
  currentOffset: number,
  targetIndex: number,
};*/ /*:: type GetVisibleCellRangeParams = {
  containerSize: number,
  offset: number,
};*/ /*:: type SizeAndPositionData = {
  offset: number,
  size: number,
};*/ /**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */ var $8a2b8845b352665f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function CellSizeAndPositionManager(_ref /*:: */ ) {
        var cellCount = _ref /*:: */ .cellCount, cellSizeGetter = _ref /*:: */ .cellSizeGetter, estimatedCellSize = _ref /*:: */ .estimatedCellSize;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, CellSizeAndPositionManager);
        // Cache of size and position data for cells, mapped by cell index.
        // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_cellSizeAndPositionData", {});
        // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_lastMeasuredIndex", -1);
        // Used in deferred mode to track which cells have been queued for measurement.
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_lastBatchedIndex", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_cellCount", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_cellSizeGetter", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_estimatedCellSize", void 0);
        this._cellSizeGetter = cellSizeGetter;
        this._cellCount = cellCount;
        this._estimatedCellSize = estimatedCellSize;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(CellSizeAndPositionManager, [
        {
            key: "areOffsetsAdjusted",
            value: function areOffsetsAdjusted() {
                return false;
            }
        },
        {
            key: "configure",
            value: function configure(_ref2 /*:: */ ) {
                var cellCount = _ref2 /*:: */ .cellCount, estimatedCellSize = _ref2 /*:: */ .estimatedCellSize, cellSizeGetter = _ref2 /*:: */ .cellSizeGetter;
                this._cellCount = cellCount;
                this._estimatedCellSize = estimatedCellSize;
                this._cellSizeGetter = cellSizeGetter;
            }
        },
        {
            key: "getCellCount",
            value: function getCellCount() /*: number*/ {
                return this._cellCount;
            }
        },
        {
            key: "getEstimatedCellSize",
            value: function getEstimatedCellSize() /*: number*/ {
                return this._estimatedCellSize;
            }
        },
        {
            key: "getLastMeasuredIndex",
            value: function getLastMeasuredIndex() /*: number*/ {
                return this._lastMeasuredIndex;
            }
        },
        {
            key: "getOffsetAdjustment",
            value: function getOffsetAdjustment() {
                return 0;
            }
        },
        {
            key: "getSizeAndPositionOfCell",
            value: function getSizeAndPositionOfCell(index /*: number*/ ) /*: SizeAndPositionData*/ {
                if (index < 0 || index >= this._cellCount) throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
                if (index > this._lastMeasuredIndex) {
                    var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                    var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                    for(var i = this._lastMeasuredIndex + 1; i <= index; i++){
                        var size = this._cellSizeGetter({
                            index: i
                        });
                        // undefined or NaN probably means a logic error in the size getter.
                        // null means we're using CellMeasurer and haven't yet measured a given index.
                        if (size === undefined || isNaN(size)) throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
                        else if (size === null) {
                            this._cellSizeAndPositionData[i] = {
                                offset: offset,
                                size: 0
                            };
                            this._lastBatchedIndex = index;
                        } else {
                            this._cellSizeAndPositionData[i] = {
                                offset: offset,
                                size: size
                            };
                            offset += size;
                            this._lastMeasuredIndex = index;
                        }
                    }
                }
                return this._cellSizeAndPositionData[index];
            }
        },
        {
            key: "getSizeAndPositionOfLastMeasuredCell",
            value: function getSizeAndPositionOfLastMeasuredCell() /*: SizeAndPositionData*/ {
                return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
                    offset: 0,
                    size: 0
                };
            }
        },
        {
            key: "getTotalSize",
            value: function getTotalSize() /*: number*/ {
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
                var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
                return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
            }
        },
        {
            key: "getUpdatedOffsetForIndex",
            value: function getUpdatedOffsetForIndex(_ref3 /*:: */ ) /*: number*/ {
                var _ref3$align = _ref3 /*:: */ .align, align = _ref3$align === void 0 ? 'auto' : _ref3$align, containerSize = _ref3 /*:: */ .containerSize, currentOffset = _ref3 /*:: */ .currentOffset, targetIndex = _ref3 /*:: */ .targetIndex;
                if (containerSize <= 0) return 0;
                var datum = this.getSizeAndPositionOfCell(targetIndex);
                var maxOffset = datum.offset;
                var minOffset = maxOffset - containerSize + datum.size;
                var idealOffset;
                switch(align){
                    case 'start':
                        idealOffset = maxOffset;
                        break;
                    case 'end':
                        idealOffset = minOffset;
                        break;
                    case 'center':
                        idealOffset = maxOffset - (containerSize - datum.size) / 2;
                        break;
                    default:
                        idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
                        break;
                }
                var totalSize = this.getTotalSize();
                return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
            }
        },
        {
            key: "getVisibleCellRange",
            value: function getVisibleCellRange(params /*: GetVisibleCellRangeParams*/ ) /*: VisibleCellRange*/ {
                var containerSize = params.containerSize, offset = params.offset;
                var totalSize = this.getTotalSize();
                if (totalSize === 0) return {};
                var maxOffset = offset + containerSize;
                var start = this._findNearestCell(offset);
                var datum = this.getSizeAndPositionOfCell(start);
                offset = datum.offset + datum.size;
                var stop = start;
                while(offset < maxOffset && stop < this._cellCount - 1){
                    stop++;
                    offset += this.getSizeAndPositionOfCell(stop).size;
                }
                return {
                    start: start,
                    stop: stop
                };
            }
        },
        {
            key: "resetCell",
            value: function resetCell(index /*: number*/ ) /*: void*/ {
                this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
            }
        },
        {
            key: "_binarySearch",
            value: function _binarySearch(high /*: number*/ , low /*: number*/ , offset /*: number*/ ) /*: number*/ {
                while(low <= high){
                    var middle = low + Math.floor((high - low) / 2);
                    var currentOffset = this.getSizeAndPositionOfCell(middle).offset;
                    if (currentOffset === offset) return middle;
                    else if (currentOffset < offset) low = middle + 1;
                    else if (currentOffset > offset) high = middle - 1;
                }
                if (low > 0) return low - 1;
                else return 0;
            }
        },
        {
            key: "_exponentialSearch",
            value: function _exponentialSearch(index /*: number*/ , offset /*: number*/ ) /*: number*/ {
                var interval = 1;
                while(index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset){
                    index += interval;
                    interval *= 2;
                }
                return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
            }
        },
        {
            key: "_findNearestCell",
            value: function _findNearestCell(offset /*: number*/ ) /*: number*/ {
                if (isNaN(offset)) throw Error("Invalid offset ".concat(offset, " specified"));
                // Our search algorithms find the nearest match at or below the specified offset.
                // So make sure the offset is at least 0 or no match will be found.
                offset = Math.max(0, offset);
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
                if (lastMeasuredCellSizeAndPosition.offset >= offset) // If we've already measured cells within this range just use a binary search as it's faster.
                return this._binarySearch(lastMeasuredIndex, 0, offset);
                else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
                // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
                // The overall complexity for this approach is O(log n).
                return this._exponentialSearch(lastMeasuredIndex, offset);
            }
        }
    ]);
}();


var $1fac82ade40b3f49$var$DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var $1fac82ade40b3f49$var$CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
var $1fac82ade40b3f49$var$isBrowser = function isBrowser() {
    return typeof window !== 'undefined';
};
var $1fac82ade40b3f49$var$isChrome = function isChrome() {
    return !!window.chrome;
};
var $1fac82ade40b3f49$export$d0dd9fc28a7917e7 = function getMaxElementSize() /*: number*/ {
    if ($1fac82ade40b3f49$var$isBrowser()) {
        if ($1fac82ade40b3f49$var$isChrome()) return $1fac82ade40b3f49$var$CHROME_MAX_ELEMENT_SIZE;
    }
    return $1fac82ade40b3f49$var$DEFAULT_MAX_ELEMENT_SIZE;
};


var $f12a24c056198f11$var$_excluded = [
    "maxScrollSize"
];
/*:: type ContainerSizeAndOffset = {
  containerSize: number,
  offset: number,
};*/ /*:: type Params = {
  maxScrollSize?: number,
  cellCount: number,
  cellSizeGetter: CellSizeGetter,
  estimatedCellSize: number,
};*/ /**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */ /**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */ var $f12a24c056198f11$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ScalingCellSizeAndPositionManager(_ref /*:: */ ) {
        var _ref$maxScrollSize = _ref /*:: */ .maxScrollSize, maxScrollSize = _ref$maxScrollSize === void 0 ? (0, $1fac82ade40b3f49$export$d0dd9fc28a7917e7)() : _ref$maxScrollSize, params = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_ref /*:: */ , $f12a24c056198f11$var$_excluded);
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ScalingCellSizeAndPositionManager);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_cellSizeAndPositionManager", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_maxScrollSize", void 0);
        // Favor composition over inheritance to simplify IE10 support
        this._cellSizeAndPositionManager = new (0, $8a2b8845b352665f$export$2e2bcd8739ae039)(params);
        this._maxScrollSize = maxScrollSize;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(ScalingCellSizeAndPositionManager, [
        {
            key: "areOffsetsAdjusted",
            value: function areOffsetsAdjusted() /*: boolean*/ {
                return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
            }
        },
        {
            key: "configure",
            value: function configure(params) {
                this._cellSizeAndPositionManager.configure(params);
            }
        },
        {
            key: "getCellCount",
            value: function getCellCount() /*: number*/ {
                return this._cellSizeAndPositionManager.getCellCount();
            }
        },
        {
            key: "getEstimatedCellSize",
            value: function getEstimatedCellSize() /*: number*/ {
                return this._cellSizeAndPositionManager.getEstimatedCellSize();
            }
        },
        {
            key: "getLastMeasuredIndex",
            value: function getLastMeasuredIndex() /*: number*/ {
                return this._cellSizeAndPositionManager.getLastMeasuredIndex();
            }
        },
        {
            key: "getOffsetAdjustment",
            value: function getOffsetAdjustment(_ref2 /*:: */ ) /*: number*/ {
                var containerSize = _ref2 /*:: */ .containerSize, offset = _ref2 /*:: */ .offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                var offsetPercentage = this._getOffsetPercentage({
                    containerSize: containerSize,
                    offset: offset,
                    totalSize: safeTotalSize
                });
                return Math.round(offsetPercentage * (safeTotalSize - totalSize));
            }
        },
        {
            key: "getSizeAndPositionOfCell",
            value: function getSizeAndPositionOfCell(index /*: number*/ ) {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
            }
        },
        {
            key: "getSizeAndPositionOfLastMeasuredCell",
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
            }
        },
        {
            key: "getTotalSize",
            value: function getTotalSize() /*: number*/ {
                return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
            }
        },
        {
            key: "getUpdatedOffsetForIndex",
            value: function getUpdatedOffsetForIndex(_ref3 /*:: */ ) {
                var _ref3$align = _ref3 /*:: */ .align, align = _ref3$align === void 0 ? 'auto' : _ref3$align, containerSize = _ref3 /*:: */ .containerSize, currentOffset = _ref3 /*:: */ .currentOffset, targetIndex = _ref3 /*:: */ .targetIndex;
                currentOffset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: currentOffset
                });
                var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
                    align: align,
                    containerSize: containerSize,
                    currentOffset: currentOffset,
                    targetIndex: targetIndex
                });
                return this._offsetToSafeOffset({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: "getVisibleCellRange",
            value: function getVisibleCellRange(_ref4 /*:: */ ) /*: VisibleCellRange*/ {
                var containerSize = _ref4 /*:: */ .containerSize, offset = _ref4 /*:: */ .offset;
                offset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: offset
                });
                return this._cellSizeAndPositionManager.getVisibleCellRange({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: "resetCell",
            value: function resetCell(index /*: number*/ ) /*: void*/ {
                this._cellSizeAndPositionManager.resetCell(index);
            }
        },
        {
            key: "_getOffsetPercentage",
            value: function _getOffsetPercentage(_ref5 /*:: */ ) {
                var containerSize = _ref5 /*:: */ .containerSize, offset = _ref5 /*:: */ .offset, totalSize = _ref5 /*:: */ .totalSize;
                return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
            }
        },
        {
            key: "_offsetToSafeOffset",
            value: function _offsetToSafeOffset(_ref6 /*:: */ ) /*: number*/ {
                var containerSize = _ref6 /*:: */ .containerSize, offset = _ref6 /*:: */ .offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: totalSize
                    });
                    return Math.round(offsetPercentage * (safeTotalSize - containerSize));
                }
            }
        },
        {
            key: "_safeOffsetToOffset",
            value: function _safeOffsetToOffset(_ref7 /*:: */ ) /*: number*/ {
                var containerSize = _ref7 /*:: */ .containerSize, offset = _ref7 /*:: */ .offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: safeTotalSize
                    });
                    return Math.round(offsetPercentage * (totalSize - containerSize));
                }
            }
        }
    ]);
}();



/*:: import type {OverscanIndicesGetterParams, OverscanIndices} from './types';*/ var $9f59d7fc962d6582$export$4a9c12fc9cd91d00 = -1;
var $9f59d7fc962d6582$export$f30397fa35598134 = 1;
var $9f59d7fc962d6582$export$bd8d94980b275a2d = 'horizontal';
var $9f59d7fc962d6582$export$11bc73ef6d36df46 = 'vertical';
function $9f59d7fc962d6582$export$2e2bcd8739ae039(_ref /*:: */ ) /*: OverscanIndices*/ {
    var cellCount = _ref /*:: */ .cellCount, overscanCellsCount = _ref /*:: */ .overscanCellsCount, scrollDirection = _ref /*:: */ .scrollDirection, startIndex = _ref /*:: */ .startIndex, stopIndex = _ref /*:: */ .stopIndex;
    if (scrollDirection === $9f59d7fc962d6582$export$f30397fa35598134) return {
        overscanStartIndex: Math.max(0, startIndex),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
}


/*:: import type {Alignment, CellSize} from '../types';*/ 
function $0aa19b9d9c4439cc$export$2e2bcd8739ae039(_ref /*:: */ ) {
    var cellSize = _ref /*:: */ .cellSize, cellSizeAndPositionManager = _ref /*:: */ .cellSizeAndPositionManager, previousCellsCount = _ref /*:: */ .previousCellsCount, previousCellSize = _ref /*:: */ .previousCellSize, previousScrollToAlignment = _ref /*:: */ .previousScrollToAlignment, previousScrollToIndex = _ref /*:: */ .previousScrollToIndex, previousSize = _ref /*:: */ .previousSize, scrollOffset = _ref /*:: */ .scrollOffset, scrollToAlignment = _ref /*:: */ .scrollToAlignment, scrollToIndex = _ref /*:: */ .scrollToIndex, size = _ref /*:: */ .size, sizeJustIncreasedFromZero = _ref /*:: */ .sizeJustIncreasedFromZero, updateScrollIndexCallback = _ref /*:: */ .updateScrollIndexCallback;
    var cellCount = cellSizeAndPositionManager.getCellCount();
    var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
    var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
    // If we have a new scroll target OR if height/row-height has changed,
    // We should ensure that the scroll target is visible.
    if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) updateScrollIndexCallback(scrollToIndex);
    else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    {
        if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) updateScrollIndexCallback(cellCount - 1);
    }
}


/*:: import type {CellRangeRendererParams} from './types';*/ 
var $acw62 = parcelRequire("acw62");
function $fc607241dfacb6e1$export$2e2bcd8739ae039(_ref /*:: */ ) {
    var cellCache = _ref /*:: */ .cellCache, cellRenderer = _ref /*:: */ .cellRenderer, columnSizeAndPositionManager = _ref /*:: */ .columnSizeAndPositionManager, columnStartIndex = _ref /*:: */ .columnStartIndex, columnStopIndex = _ref /*:: */ .columnStopIndex, deferredMeasurementCache = _ref /*:: */ .deferredMeasurementCache, horizontalOffsetAdjustment = _ref /*:: */ .horizontalOffsetAdjustment, isScrolling = _ref /*:: */ .isScrolling, isScrollingOptOut = _ref /*:: */ .isScrollingOptOut, parent = _ref /*:: */ .parent, rowSizeAndPositionManager = _ref /*:: */ .rowSizeAndPositionManager, rowStartIndex = _ref /*:: */ .rowStartIndex, rowStopIndex = _ref /*:: */ .rowStopIndex, styleCache = _ref /*:: */ .styleCache, verticalOffsetAdjustment = _ref /*:: */ .verticalOffsetAdjustment, visibleColumnIndices = _ref /*:: */ .visibleColumnIndices, visibleRowIndices = _ref /*:: */ .visibleRowIndices;
    var renderedCells = [];
    // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
    // User cannot scroll beyond these size limitations.
    // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
    // We should never cache styles for compressed offsets though as this can lead to bugs.
    // See issue #576 for more.
    var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
    var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
    for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++){
        var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
        for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++){
            var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
            var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
            var key = "".concat(rowIndex, "-").concat(columnIndex);
            var style = void 0;
            // Cache style objects so shallow-compare doesn't re-render unnecessarily.
            if (canCacheStyle && styleCache[key]) style = styleCache[key];
            else // In deferred mode, cells will be initially rendered before we know their size.
            // Don't interfere with CellMeasurer's measurements by setting an invalid size.
            if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) // Position not-yet-measured cells at top/left 0,0,
            // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
            // Positioning them further to the right/bottom influences their measured size.
            style = {
                height: 'auto',
                left: 0,
                position: 'absolute',
                top: 0,
                width: 'auto'
            };
            else {
                style = {
                    height: rowDatum.size,
                    left: columnDatum.offset + horizontalOffsetAdjustment,
                    position: 'absolute',
                    top: rowDatum.offset + verticalOffsetAdjustment,
                    width: columnDatum.size
                };
                styleCache[key] = style;
            }
            var cellRendererParams = {
                columnIndex: columnIndex,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent,
                rowIndex: rowIndex,
                style: style
            };
            var renderedCell = void 0;
            // Avoid re-creating cells while scrolling.
            // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
            // If a scroll is in progress- cache and reuse cells.
            // This cache will be thrown away once scrolling completes.
            // However if we are scaling scroll positions and sizes, we should also avoid caching.
            // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
            // For more info refer to issue #395
            //
            // If isScrollingOptOut is specified, we always cache cells.
            // For more info refer to issue #1028
            if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
                if (!cellCache[key]) cellCache[key] = cellRenderer(cellRendererParams);
                renderedCell = cellCache[key];
            // If the user is no longer scrolling, don't cache cells.
            // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
            } else renderedCell = cellRenderer(cellRendererParams);
            if (renderedCell == null || renderedCell === false) continue;
            if (!renderedCell.props.role) renderedCell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(renderedCell, {
                role: 'gridcell'
            });
            renderedCells.push(renderedCell);
        }
    }
    return renderedCells;
}
function $fc607241dfacb6e1$var$warnAboutMissingStyle(parent, renderedCell) {}




/*:: type Callback = (timestamp: number) => void;*/ /*:: type CancelAnimationFrame = (requestId: number) => void;*/ /*:: type RequestAnimationFrame = (callback: Callback) => number;*/ // Properly handle server-side rendering.
var $7e41c375438c5cf8$var$win;
if (typeof window !== 'undefined') $7e41c375438c5cf8$var$win = window;
else if (typeof self !== 'undefined') $7e41c375438c5cf8$var$win = self;
else $7e41c375438c5cf8$var$win = {};
// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var $7e41c375438c5cf8$var$request = $7e41c375438c5cf8$var$win.requestAnimationFrame || $7e41c375438c5cf8$var$win.webkitRequestAnimationFrame || $7e41c375438c5cf8$var$win.mozRequestAnimationFrame || $7e41c375438c5cf8$var$win.oRequestAnimationFrame || $7e41c375438c5cf8$var$win.msRequestAnimationFrame || function(callback /*: Callback*/ ) /*: RequestAnimationFrame*/ {
    return $7e41c375438c5cf8$var$win /*: any*/ .setTimeout(callback, 1000 / 60);
};
var $7e41c375438c5cf8$var$cancel = $7e41c375438c5cf8$var$win.cancelAnimationFrame || $7e41c375438c5cf8$var$win.webkitCancelAnimationFrame || $7e41c375438c5cf8$var$win.mozCancelAnimationFrame || $7e41c375438c5cf8$var$win.oCancelAnimationFrame || $7e41c375438c5cf8$var$win.msCancelAnimationFrame || function(id /*: number*/ ) {
    $7e41c375438c5cf8$var$win /*: any*/ .clearTimeout(id);
};
var $7e41c375438c5cf8$export$27f233d61a9e2fa4 /*: RequestAnimationFrame*/  = $7e41c375438c5cf8$var$request /*: any*/ ;
var $7e41c375438c5cf8$export$75aab3dbee8deceb /*: CancelAnimationFrame*/  = $7e41c375438c5cf8$var$cancel /*: any*/ ;


var $85d05b1a4e1d5c40$export$3b976196c7d0d7a6 = function cancelAnimationTimeout(frame /*: AnimationTimeoutId*/ ) {
    return (0, $7e41c375438c5cf8$export$75aab3dbee8deceb)(frame.id);
};
var $85d05b1a4e1d5c40$export$62c6fa81f9943047 = function requestAnimationTimeout(callback /*: Function*/ , delay /*: number*/ ) /*: AnimationTimeoutId*/ {
    var start;
    // wait for end of processing current event handler, because event handler may be long
    Promise.resolve().then(function() {
        start = Date.now();
    });
    var _timeout = function timeout() {
        if (Date.now() - start >= delay) callback.call();
        else frame.id = (0, $7e41c375438c5cf8$export$27f233d61a9e2fa4)(_timeout);
    };
    var frame /*: AnimationTimeoutId*/  = {
        id: (0, $7e41c375438c5cf8$export$27f233d61a9e2fa4)(_timeout)
    };
    return frame;
};


function $dddee09ada2ab319$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dddee09ada2ab319$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dddee09ada2ab319$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dddee09ada2ab319$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dddee09ada2ab319$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $dddee09ada2ab319$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $dddee09ada2ab319$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dddee09ada2ab319$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dddee09ada2ab319$export$c51e03d5b92ea76f = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */ var $dddee09ada2ab319$var$SCROLL_POSITION_CHANGE_REASONS = {
    OBSERVED: 'observed',
    REQUESTED: 'requested'
};
var $dddee09ada2ab319$var$renderNull /*: NoContentRenderer*/  = function renderNull() {
    return null;
};
/*:: type ScrollPosition = {
  scrollTop?: number,
  scrollLeft?: number,
};*/ /*:: type Props = {
  'aria-label': string,
  'aria-readonly'?: boolean,

  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   *-/
  autoContainerWidth: boolean,

  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   *-/
  autoHeight: boolean,

  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   *-/
  autoWidth: boolean,

  /** Responsible for rendering a cell given an row and column index.  *-/
  cellRenderer: CellRenderer,

  /** Responsible for rendering a group of cells given their index ranges.  *-/
  cellRangeRenderer: CellRangeRenderer,

  /** Optional custom CSS class name to attach to root Grid element.  *-/
  className?: string,

  /** Number of columns in grid.  *-/
  columnCount: number,

  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  *-/
  columnWidth: CellSize,

  /** Unfiltered props for the Grid container. *-/
  containerProps?: Object,

  /** ARIA role for the cell-container.  *-/
  containerRole: string,

  /** Optional inline style applied to inner cell-container *-/
  containerStyle: Object,

  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   *-/
  deferredMeasurementCache?: Object,

  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   *-/
  estimatedColumnSize: number,

  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   *-/
  estimatedRowSize: number,

  /** Exposed for testing purposes only.  *-/
  getScrollbarSize: () => number,

  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  *-/
  height: number,

  /** Optional custom id to attach to root Grid element.  *-/
  id?: string,

  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   *-/
  isScrolling?: boolean,

  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   *-/
  isScrollingOptOut: boolean,

  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  *-/
  noContentRenderer: NoContentRenderer,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   *-/
  onScroll: (params: Scroll) => void,

  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   *-/
  onScrollbarPresenceChange: (params: ScrollbarPresenceChange) => void,

  /** Callback invoked with information about the section of the Grid that was just rendered.  *-/
  onSectionRendered: (params: RenderedSection) => void,

  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   *-/
  overscanColumnCount: number,

  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   *-/
  overscanIndicesGetter: OverscanIndicesGetter,

  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   *-/
  overscanRowCount: number,

  /** ARIA role for the grid element.  *-/
  role: string,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   *-/
  rowHeight: CellSize,

  /** Number of rows in grid.  *-/
  rowCount: number,

  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. *-/
  scrollingResetTimeInterval: number,

  /** Horizontal offset. *-/
  scrollLeft?: number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   *-/
  scrollToAlignment: Alignment,

  /** Column index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToColumn: number,

  /** Vertical offset. *-/
  scrollTop?: number,

  /** Row index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToRow: number,

  /** Optional inline style *-/
  style: Object,

  /** Tab index for focus *-/
  tabIndex: ?number,

  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  *-/
  width: number,

  /** Reference to DOM node *-/
  elementRef?: React.Ref<React.ElementType>,
};*/ /*:: type InstanceProps = {
  prevColumnWidth: CellSize,
  prevRowHeight: CellSize,

  prevColumnCount: number,
  prevRowCount: number,
  prevIsScrolling: boolean,
  prevScrollToColumn: number,
  prevScrollToRow: number,

  columnSizeAndPositionManager: ScalingCellSizeAndPositionManager,
  rowSizeAndPositionManager: ScalingCellSizeAndPositionManager,

  scrollbarSize: number,
  scrollbarSizeMeasured: boolean,
};*/ /*:: type State = {
  instanceProps: InstanceProps,
  isScrolling: boolean,
  scrollDirectionHorizontal: -1 | 1,
  scrollDirectionVertical: -1 | 1,
  scrollLeft: number,
  scrollTop: number,
  scrollPositionChangeReason: 'observed' | 'requested' | null,
  needToResetStyleCache: boolean,
};*/ /**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */ var $dddee09ada2ab319$var$Grid = /*#__PURE__*/ function(_React$PureComponent) {
    function Grid(props /*: Props*/ ) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Grid);
        _this = $dddee09ada2ab319$var$_callSuper(this, Grid, [
            props
        ]);
        // Invokes onSectionRendered callback only when start/stop row or column indices change
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onGridRenderedMemoizer", (0, $eb7485db8fea8a79$export$2e2bcd8739ae039)());
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onScrollMemoizer", (0, $eb7485db8fea8a79$export$2e2bcd8739ae039)(false));
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_deferredInvalidateColumnIndex", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_deferredInvalidateRowIndex", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_recomputeScrollLeftFlag", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_recomputeScrollTopFlag", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_horizontalScrollBarSize", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_verticalScrollBarSize", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_scrollbarPresenceChanged", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_scrollingContainer", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_childrenToDisplay", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_columnStartIndex", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_columnStopIndex", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_rowStartIndex", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_rowStopIndex", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_renderedColumnStartIndex", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_renderedColumnStopIndex", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_renderedRowStartIndex", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_renderedRowStopIndex", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_initialScrollTop", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_initialScrollLeft", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_disablePointerEventsTimeoutId", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_styleCache", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_cellCache", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_debounceScrollEndedCallback", function() {
            _this._disablePointerEventsTimeoutId = null;
            // isScrolling is used to determine if we reset styleCache
            _this.setState({
                isScrolling: false,
                needToResetStyleCache: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_invokeOnGridRenderedHelper", function() {
            var onSectionRendered = _this.props.onSectionRendered;
            _this._onGridRenderedMemoizer({
                callback: onSectionRendered,
                indices: {
                    columnOverscanStartIndex: _this._columnStartIndex,
                    columnOverscanStopIndex: _this._columnStopIndex,
                    columnStartIndex: _this._renderedColumnStartIndex,
                    columnStopIndex: _this._renderedColumnStopIndex,
                    rowOverscanStartIndex: _this._rowStartIndex,
                    rowOverscanStopIndex: _this._rowStopIndex,
                    rowStartIndex: _this._renderedRowStartIndex,
                    rowStopIndex: _this._renderedRowStopIndex
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_setScrollingContainerRef", function(ref /*: Element*/ ) {
            _this._scrollingContainer = ref;
            if (typeof _this.props.elementRef === 'function') _this.props.elementRef(ref);
            else if ((0, (/*@__PURE__*/$parcel$interopDefault($2ef66ab8c52ac1c0$exports)))(_this.props.elementRef) === 'object') _this.props.elementRef.current = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onScroll", function(event /*: Event*/ ) {
            // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
            // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
            // See issue #404 for more information.
            if (event.target === _this._scrollingContainer) _this.handleScrollEvent(event.target /*: any*/ );
        });
        var columnSizeAndPositionManager = new (0, $f12a24c056198f11$export$2e2bcd8739ae039)({
            cellCount: props.columnCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.columnWidth)(params);
            },
            estimatedCellSize: Grid._getEstimatedColumnSize(props)
        });
        var rowSizeAndPositionManager = new (0, $f12a24c056198f11$export$2e2bcd8739ae039)({
            cellCount: props.rowCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.rowHeight)(params);
            },
            estimatedCellSize: Grid._getEstimatedRowSize(props)
        });
        _this.state = {
            instanceProps: {
                columnSizeAndPositionManager: columnSizeAndPositionManager,
                rowSizeAndPositionManager: rowSizeAndPositionManager,
                prevColumnWidth: props.columnWidth,
                prevRowHeight: props.rowHeight,
                prevColumnCount: props.columnCount,
                prevRowCount: props.rowCount,
                prevIsScrolling: props.isScrolling === true,
                prevScrollToColumn: props.scrollToColumn,
                prevScrollToRow: props.scrollToRow,
                scrollbarSize: 0,
                scrollbarSizeMeasured: false
            },
            isScrolling: false,
            scrollDirectionHorizontal: (0, $9f59d7fc962d6582$export$f30397fa35598134),
            scrollDirectionVertical: (0, $9f59d7fc962d6582$export$f30397fa35598134),
            scrollLeft: 0,
            scrollTop: 0,
            scrollPositionChangeReason: null,
            needToResetStyleCache: false
        };
        if (props.scrollToRow > 0) _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
        if (props.scrollToColumn > 0) _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
        return _this;
    }
    /**
   * Gets offsets for a given cell and alignment.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(Grid, _React$PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Grid, [
        {
            key: "getOffsetForCell",
            value: function getOffsetForCell() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$alignment = _ref.alignment, alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment, _ref$columnIndex = _ref.columnIndex, columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex, _ref$rowIndex = _ref.rowIndex, rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;
                var offsetProps = $dddee09ada2ab319$var$_objectSpread($dddee09ada2ab319$var$_objectSpread({}, this.props), {}, {
                    scrollToAlignment: alignment,
                    scrollToColumn: columnIndex,
                    scrollToRow: rowIndex
                });
                return {
                    scrollLeft: this._getCalculatedScrollLeft(offsetProps),
                    scrollTop: this._getCalculatedScrollTop(offsetProps)
                };
            }
        },
        {
            key: "getTotalRowsHeight",
            value: function getTotalRowsHeight() {
                return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: "getTotalColumnsWidth",
            value: function getTotalColumnsWidth() {
                return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: "handleScrollEvent",
            value: function handleScrollEvent(_ref2 /*:: */ ) {
                var _ref2$scrollLeft = _ref2 /*:: */ .scrollLeft, scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2 /*:: */ .scrollTop, scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;
                // On iOS, we can arrive at negative offsets by swiping past the start.
                // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
                if (scrollTopParam < 0) return;
                // Prevent pointer events from interrupting a smooth scroll
                this._debounceScrollEnded();
                var _this$props = this.props, autoHeight = _this$props.autoHeight, autoWidth = _this$props.autoWidth, height = _this$props.height, width = _this$props.width;
                var instanceProps = this.state.instanceProps;
                // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
                // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
                // This causes a series of rapid renders that is slow for long lists.
                // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
                var scrollbarSize = instanceProps.scrollbarSize;
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
                var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);
                // Certain devices (like Apple touchpad) rapid-fire duplicate events.
                // Don't force a re-render if this is the case.
                // The mouse may move faster then the animation frame does.
                // Use requestAnimationFrame to avoid over-updating.
                if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
                    // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
                    // Don't change direction for an axis unless scroll offset has changed.
                    var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? (0, $9f59d7fc962d6582$export$f30397fa35598134) : (0, $9f59d7fc962d6582$export$4a9c12fc9cd91d00) : this.state.scrollDirectionHorizontal;
                    var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? (0, $9f59d7fc962d6582$export$f30397fa35598134) : (0, $9f59d7fc962d6582$export$4a9c12fc9cd91d00) : this.state.scrollDirectionVertical;
                    var newState /*: $Shape<State>*/  = {
                        isScrolling: true,
                        scrollDirectionHorizontal: scrollDirectionHorizontal,
                        scrollDirectionVertical: scrollDirectionVertical,
                        scrollPositionChangeReason: $dddee09ada2ab319$var$SCROLL_POSITION_CHANGE_REASONS.OBSERVED
                    };
                    if (!autoHeight) newState.scrollTop = scrollTop;
                    if (!autoWidth) newState.scrollLeft = scrollLeft;
                    newState.needToResetStyleCache = false;
                    this.setState(newState);
                }
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    totalColumnsWidth: totalColumnsWidth,
                    totalRowsHeight: totalRowsHeight
                });
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref3 /*:: */ ) {
                var columnIndex = _ref3 /*:: */ .columnIndex, rowIndex = _ref3 /*:: */ .rowIndex;
                this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
                this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
            }
        },
        {
            key: "measureAllCells",
            value: function measureAllCells() {
                var _this$props2 = this.props, columnCount = _this$props2.columnCount, rowCount = _this$props2.rowCount;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
                instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$columnIndex = _ref4.columnIndex, columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex, _ref4$rowIndex = _ref4.rowIndex, rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;
                var _this$props3 = this.props, scrollToColumn = _this$props3.scrollToColumn, scrollToRow = _this$props3.scrollToRow;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
                instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);
                // Cell sizes may be determined by a function property.
                // In this case the cDU handler can't know if they changed.
                // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
                this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === (0, $9f59d7fc962d6582$export$f30397fa35598134) ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
                this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === (0, $9f59d7fc962d6582$export$f30397fa35598134) ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);
                // Clear cell cache in case we are scrolling;
                // Invalid row heights likely mean invalid cached content as well.
                this._styleCache = {};
                this._cellCache = {};
                this.forceUpdate();
            }
        },
        {
            key: "scrollToCell",
            value: function scrollToCell(_ref5 /*:: */ ) {
                var columnIndex = _ref5 /*:: */ .columnIndex, rowIndex = _ref5 /*:: */ .rowIndex;
                var columnCount = this.props.columnCount;
                var props = this.props;
                // Don't adjust scroll offset for single-column grids (eg List, Table).
                // This can cause a funky scroll offset because of the vertical scrollbar width.
                if (columnCount > 1 && columnIndex !== undefined) this._updateScrollLeftForScrollToColumn($dddee09ada2ab319$var$_objectSpread($dddee09ada2ab319$var$_objectSpread({}, props), {}, {
                    scrollToColumn: columnIndex
                }));
                if (rowIndex !== undefined) this._updateScrollTopForScrollToRow($dddee09ada2ab319$var$_objectSpread($dddee09ada2ab319$var$_objectSpread({}, props), {}, {
                    scrollToRow: rowIndex
                }));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props4 = this.props, getScrollbarSize = _this$props4.getScrollbarSize, height = _this$props4.height, scrollLeft = _this$props4.scrollLeft, scrollToColumn = _this$props4.scrollToColumn, scrollTop = _this$props4.scrollTop, scrollToRow = _this$props4.scrollToRow, width = _this$props4.width;
                var instanceProps = this.state.instanceProps;
                // Reset initial offsets to be ignored in browser
                this._initialScrollTop = 0;
                this._initialScrollLeft = 0;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // If this component was first rendered server-side, scrollbar size will be undefined.
                // In that event we need to remeasure.
                if (!instanceProps.scrollbarSizeMeasured) this.setState(function(prevState) {
                    var stateUpdate = $dddee09ada2ab319$var$_objectSpread($dddee09ada2ab319$var$_objectSpread({}, prevState), {}, {
                        needToResetStyleCache: false
                    });
                    stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
                    stateUpdate.instanceProps.scrollbarSizeMeasured = true;
                    return stateUpdate;
                });
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
                    var stateUpdate = Grid._getScrollToPositionStateUpdate({
                        prevState: this.state,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    });
                    if (stateUpdate) {
                        stateUpdate.needToResetStyleCache = false;
                        this.setState(stateUpdate);
                    }
                }
                // refs don't work in `react-test-renderer`
                if (this._scrollingContainer) {
                    // setting the ref's scrollLeft and scrollTop.
                    // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
                    if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) this._scrollingContainer.scrollLeft = this.state.scrollLeft;
                    if (this._scrollingContainer.scrollTop !== this.state.scrollTop) this._scrollingContainer.scrollTop = this.state.scrollTop;
                }
                // Don't update scroll offset if the size is 0; we don't render any cells in this case.
                // Setting a state may cause us to later thing we've updated the offce when we haven't.
                var sizeIsBiggerThanZero = height > 0 && width > 0;
                if (scrollToColumn >= 0 && sizeIsBiggerThanZero) this._updateScrollLeftForScrollToColumn();
                if (scrollToRow >= 0 && sizeIsBiggerThanZero) this._updateScrollTopForScrollToRow();
                // Update onRowsRendered callback
                this._invokeOnGridRenderedHelper();
                // Initialize onScroll callback
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft || 0,
                    scrollTop: scrollTop || 0,
                    totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
                    totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
                });
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps /*: Props*/ , prevState /*: State*/ ) {
                var _this2 = this;
                var _this$props5 = this.props, autoHeight = _this$props5.autoHeight, autoWidth = _this$props5.autoWidth, columnCount = _this$props5.columnCount, height = _this$props5.height, rowCount = _this$props5.rowCount, scrollToAlignment = _this$props5.scrollToAlignment, scrollToColumn = _this$props5.scrollToColumn, scrollToRow = _this$props5.scrollToRow, width = _this$props5.width;
                var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollPositionChangeReason = _this$state.scrollPositionChangeReason, scrollTop = _this$state.scrollTop, instanceProps = _this$state.instanceProps;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // Handle edge case where column or row count has only just increased over 0.
                // In this case we may have to restore a previously-specified scroll offset.
                // For more info see bvaughn/react-virtualized/issues/218
                var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
                // Make sure requested changes to :scrollLeft or :scrollTop get applied.
                // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
                // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
                // So we only set these when we require an adjustment of the scroll position.
                // See issue #2 for more information.
                if (scrollPositionChangeReason === $dddee09ada2ab319$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
                    // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
                    // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
                    if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollLeft = scrollLeft;
                    if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollTop = scrollTop;
                }
                // Special case where the previous size was 0:
                // In this case we don't show any windowed cells at all.
                // So we should always recalculate offset afterwards.
                var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;
                // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
                // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
                if (this._recomputeScrollLeftFlag) {
                    this._recomputeScrollLeftFlag = false;
                    this._updateScrollLeftForScrollToColumn(this.props);
                } else (0, $0aa19b9d9c4439cc$export$2e2bcd8739ae039)({
                    cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                    previousCellsCount: prevProps.columnCount,
                    previousCellSize: prevProps.columnWidth,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToColumn,
                    previousSize: prevProps.width,
                    scrollOffset: scrollLeft,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToColumn,
                    size: width,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollLeftForScrollToColumn(_this2.props);
                    }
                });
                if (this._recomputeScrollTopFlag) {
                    this._recomputeScrollTopFlag = false;
                    this._updateScrollTopForScrollToRow(this.props);
                } else (0, $0aa19b9d9c4439cc$export$2e2bcd8739ae039)({
                    cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                    previousCellsCount: prevProps.rowCount,
                    previousCellSize: prevProps.rowHeight,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToRow,
                    previousSize: prevProps.height,
                    scrollOffset: scrollTop,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToRow,
                    size: height,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollTopForScrollToRow(_this2.props);
                    }
                });
                // Update onRowsRendered callback if start/stop indices have changed
                this._invokeOnGridRenderedHelper();
                // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
                if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    this._invokeOnScrollMemoizer({
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        totalColumnsWidth: totalColumnsWidth,
                        totalRowsHeight: totalRowsHeight
                    });
                }
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this._disablePointerEventsTimeoutId) (0, $85d05b1a4e1d5c40$export$3b976196c7d0d7a6)(this._disablePointerEventsTimeoutId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, autoContainerWidth = _this$props6.autoContainerWidth, autoHeight = _this$props6.autoHeight, autoWidth = _this$props6.autoWidth, className = _this$props6.className, containerProps = _this$props6.containerProps, containerRole = _this$props6.containerRole, containerStyle = _this$props6.containerStyle, height = _this$props6.height, id = _this$props6.id, noContentRenderer = _this$props6.noContentRenderer, role = _this$props6.role, style = _this$props6.style, tabIndex = _this$props6.tabIndex, width = _this$props6.width;
                var _this$state2 = this.state, instanceProps = _this$state2.instanceProps, needToResetStyleCache = _this$state2.needToResetStyleCache;
                var isScrolling = this._isScrolling();
                var gridStyle /*: Object*/  = {
                    boxSizing: 'border-box',
                    direction: 'ltr',
                    height: autoHeight ? 'auto' : height,
                    position: 'relative',
                    width: autoWidth ? 'auto' : width,
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform'
                };
                if (needToResetStyleCache) this._styleCache = {};
                // calculate _styleCache here
                // if state.isScrolling (not from _isScrolling) then reset
                if (!this.state.isScrolling) this._resetStyleCache();
                // calculate children to render here
                this._calculateChildrenToRender(this.props, this.state);
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                // Force browser to hide scrollbars when we know they aren't necessary.
                // Otherwise once scrollbars appear they may not disappear again.
                // For more info see issue #116
                var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
                    this._horizontalScrollBarSize = horizontalScrollBarSize;
                    this._verticalScrollBarSize = verticalScrollBarSize;
                    this._scrollbarPresenceChanged = true;
                }
                // Also explicitly init styles to 'auto' if scrollbars are required.
                // This works around an obscure edge case where external CSS styles have not yet been loaded,
                // But an initial scroll index of offset is set as an external prop.
                // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
                // This was originally reported via clauderic/react-infinite-calendar/issues/23
                gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
                gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
                var childrenToDisplay = this._childrenToDisplay;
                var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
                return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                    ref: this._setScrollingContainerRef
                }, containerProps, {
                    "aria-label": this.props['aria-label'],
                    "aria-readonly": this.props['aria-readonly'],
                    className: (0, $15e8569690cae660$export$2e2bcd8739ae039)('ReactVirtualized__Grid', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: role,
                    style: $dddee09ada2ab319$var$_objectSpread($dddee09ada2ab319$var$_objectSpread({}, gridStyle), style),
                    tabIndex: tabIndex
                }), childrenToDisplay.length > 0 && /*#__PURE__*/ $acw62.createElement("div", {
                    className: "ReactVirtualized__Grid__innerScrollContainer",
                    role: containerRole,
                    style: $dddee09ada2ab319$var$_objectSpread({
                        width: autoContainerWidth ? 'auto' : totalColumnsWidth,
                        height: totalRowsHeight,
                        maxWidth: totalColumnsWidth,
                        maxHeight: totalRowsHeight,
                        overflow: 'hidden',
                        pointerEvents: isScrolling ? 'none' : '',
                        position: 'relative'
                    }, containerStyle)
                }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
            }
        },
        {
            key: "_calculateChildrenToRender",
            value: function _calculateChildrenToRender() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var cellRenderer = props.cellRenderer, cellRangeRenderer = props.cellRangeRenderer, columnCount = props.columnCount, deferredMeasurementCache = props.deferredMeasurementCache, height = props.height, overscanColumnCount = props.overscanColumnCount, overscanIndicesGetter = props.overscanIndicesGetter, overscanRowCount = props.overscanRowCount, rowCount = props.rowCount, width = props.width, isScrollingOptOut = props.isScrollingOptOut;
                var scrollDirectionHorizontal = state.scrollDirectionHorizontal, scrollDirectionVertical = state.scrollDirectionVertical, instanceProps = state.instanceProps;
                var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
                var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
                var isScrolling = this._isScrolling(props, state);
                this._childrenToDisplay = [];
                // Render only enough columns and rows to cover the visible area of the grid.
                if (height > 0 && width > 0) {
                    var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
                        containerSize: height,
                        offset: scrollTop
                    });
                    var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: height,
                        offset: scrollTop
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    this._renderedColumnStartIndex = visibleColumnIndices.start;
                    this._renderedColumnStopIndex = visibleColumnIndices.stop;
                    this._renderedRowStartIndex = visibleRowIndices.start;
                    this._renderedRowStopIndex = visibleRowIndices.stop;
                    var overscanColumnIndices = overscanIndicesGetter({
                        direction: 'horizontal',
                        cellCount: columnCount,
                        overscanCellsCount: overscanColumnCount,
                        scrollDirection: scrollDirectionHorizontal,
                        startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
                        stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
                    });
                    var overscanRowIndices = overscanIndicesGetter({
                        direction: 'vertical',
                        cellCount: rowCount,
                        overscanCellsCount: overscanRowCount,
                        scrollDirection: scrollDirectionVertical,
                        startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
                        stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    var columnStartIndex = overscanColumnIndices.overscanStartIndex;
                    var columnStopIndex = overscanColumnIndices.overscanStopIndex;
                    var rowStartIndex = overscanRowIndices.overscanStartIndex;
                    var rowStopIndex = overscanRowIndices.overscanStopIndex;
                    // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
                    if (deferredMeasurementCache) {
                        // If rows have a dynamic height, scan the rows we are about to render.
                        // If any have not yet been measured, then we need to render all columns initially,
                        // Because the height of the row is equal to the tallest cell within that row,
                        // (And so we can't know the height without measuring all column-cells first).
                        if (!deferredMeasurementCache.hasFixedHeight()) {
                            for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++)if (!deferredMeasurementCache.has(rowIndex, 0)) {
                                columnStartIndex = 0;
                                columnStopIndex = columnCount - 1;
                                break;
                            }
                        }
                        // If columns have a dynamic width, scan the columns we are about to render.
                        // If any have not yet been measured, then we need to render all rows initially,
                        // Because the width of the column is equal to the widest cell within that column,
                        // (And so we can't know the width without measuring all row-cells first).
                        if (!deferredMeasurementCache.hasFixedWidth()) {
                            for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++)if (!deferredMeasurementCache.has(0, columnIndex)) {
                                rowStartIndex = 0;
                                rowStopIndex = rowCount - 1;
                                break;
                            }
                        }
                    }
                    this._childrenToDisplay = cellRangeRenderer({
                        cellCache: this._cellCache,
                        cellRenderer: cellRenderer,
                        columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                        columnStartIndex: columnStartIndex,
                        columnStopIndex: columnStopIndex,
                        deferredMeasurementCache: deferredMeasurementCache,
                        horizontalOffsetAdjustment: horizontalOffsetAdjustment,
                        isScrolling: isScrolling,
                        isScrollingOptOut: isScrollingOptOut,
                        parent: this,
                        rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                        rowStartIndex: rowStartIndex,
                        rowStopIndex: rowStopIndex,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        styleCache: this._styleCache,
                        verticalOffsetAdjustment: verticalOffsetAdjustment,
                        visibleColumnIndices: visibleColumnIndices,
                        visibleRowIndices: visibleRowIndices
                    });
                    // update the indices
                    this._columnStartIndex = columnStartIndex;
                    this._columnStopIndex = columnStopIndex;
                    this._rowStartIndex = rowStartIndex;
                    this._rowStopIndex = rowStopIndex;
                }
            }
        },
        {
            key: "_debounceScrollEnded",
            value: function _debounceScrollEnded() {
                var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
                if (this._disablePointerEventsTimeoutId) (0, $85d05b1a4e1d5c40$export$3b976196c7d0d7a6)(this._disablePointerEventsTimeoutId);
                this._disablePointerEventsTimeoutId = (0, $85d05b1a4e1d5c40$export$62c6fa81f9943047)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
            }
        },
        {
            key: "_handleInvalidatedGridSize",
            value: /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */ function _handleInvalidatedGridSize() {
                if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
                    var columnIndex = this._deferredInvalidateColumnIndex;
                    var rowIndex = this._deferredInvalidateRowIndex;
                    this._deferredInvalidateColumnIndex = null;
                    this._deferredInvalidateRowIndex = null;
                    this.recomputeGridSize({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        },
        {
            key: "_invokeOnScrollMemoizer",
            value: function _invokeOnScrollMemoizer(_ref6 /*:: */ ) {
                var _this3 = this;
                var scrollLeft = _ref6 /*:: */ .scrollLeft, scrollTop = _ref6 /*:: */ .scrollTop, totalColumnsWidth = _ref6 /*:: */ .totalColumnsWidth, totalRowsHeight = _ref6 /*:: */ .totalRowsHeight;
                this._onScrollMemoizer({
                    callback: function callback(_ref7) {
                        var scrollLeft = _ref7.scrollLeft, scrollTop = _ref7.scrollTop;
                        var _this3$props = _this3.props, height = _this3$props.height, onScroll = _this3$props.onScroll, width = _this3$props.width;
                        onScroll({
                            clientHeight: height,
                            clientWidth: width,
                            scrollHeight: totalRowsHeight,
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop,
                            scrollWidth: totalColumnsWidth
                        });
                    },
                    indices: {
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    }
                });
            }
        },
        {
            key: "_isScrolling",
            value: function _isScrolling() /*: boolean*/ {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                // If isScrolling is defined in props, use it to override the value in state
                // This is a performance optimization for WindowScroller + Grid
                return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
            }
        },
        {
            key: "_maybeCallOnScrollbarPresenceChange",
            value: function _maybeCallOnScrollbarPresenceChange() {
                if (this._scrollbarPresenceChanged) {
                    var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
                    this._scrollbarPresenceChanged = false;
                    onScrollbarPresenceChange({
                        horizontal: this._horizontalScrollBarSize > 0,
                        size: this.state.instanceProps.scrollbarSize,
                        vertical: this._verticalScrollBarSize > 0
                    });
                }
            }
        },
        {
            key: "scrollToPosition",
            value: /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */ function scrollToPosition(_ref8 /*:: */ ) {
                var scrollLeft = _ref8 /*:: */ .scrollLeft, scrollTop = _ref8 /*:: */ .scrollTop;
                var stateUpdate = Grid._getScrollToPositionStateUpdate({
                    prevState: this.state,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: "_getCalculatedScrollLeft",
            value: function _getCalculatedScrollLeft() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollLeft(props, state);
            }
        },
        {
            key: "_updateScrollLeftForScrollToColumn",
            value: function _updateScrollLeftForScrollToColumn() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: "_getCalculatedScrollTop",
            value: function _getCalculatedScrollTop() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollTop(props, state);
            }
        },
        {
            key: "_resetStyleCache",
            value: function _resetStyleCache() {
                var styleCache = this._styleCache;
                var cellCache = this._cellCache;
                var isScrollingOptOut = this.props.isScrollingOptOut;
                // Reset cell and style caches once scrolling stops.
                // This makes Grid simpler to use (since cells commonly change).
                // And it keeps the caches from growing too large.
                // Performance is most sensitive when a user is scrolling.
                // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
                // This keeps the cellCache to a resonable size.
                this._cellCache = {};
                this._styleCache = {};
                // Copy over the visible cell styles so avoid unnecessary re-render.
                for(var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++)for(var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++){
                    var key = "".concat(rowIndex, "-").concat(columnIndex);
                    this._styleCache[key] = styleCache[key];
                    if (isScrollingOptOut) this._cellCache[key] = cellCache[key];
                }
            }
        },
        {
            key: "_updateScrollTopForScrollToRow",
            value: function _updateScrollTopForScrollToRow() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                var newState = {};
                if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
                    newState.scrollLeft = 0;
                    newState.scrollTop = 0;
                // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
                // scrollTo{Column,Row} should override scroll{Left,Top}
                } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) Object.assign(newState, Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: nextProps.scrollLeft,
                    scrollTop: nextProps.scrollTop
                }));
                var instanceProps = prevState.instanceProps;
                // Initially we should not clearStyleCache
                newState.needToResetStyleCache = false;
                if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) // Reset cache. set it to {} in render
                newState.needToResetStyleCache = true;
                instanceProps.columnSizeAndPositionManager.configure({
                    cellCount: nextProps.columnCount,
                    estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
                });
                instanceProps.rowSizeAndPositionManager.configure({
                    cellCount: nextProps.rowCount,
                    estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
                });
                if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
                    instanceProps.prevColumnCount = 0;
                    instanceProps.prevRowCount = 0;
                }
                // If scrolling is controlled outside this component, clear cache when scrolling stops
                if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) Object.assign(newState, {
                    isScrolling: false
                });
                var maybeStateA;
                var maybeStateB;
                (0, $be0ed937fc97fa1d$export$2e2bcd8739ae039)({
                    cellCount: instanceProps.prevColumnCount,
                    cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.columnSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.columnCount,
                    nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
                    nextScrollToIndex: nextProps.scrollToColumn,
                    scrollToIndex: instanceProps.prevScrollToColumn,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
                    }
                });
                (0, $be0ed937fc97fa1d$export$2e2bcd8739ae039)({
                    cellCount: instanceProps.prevRowCount,
                    cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.rowSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.rowCount,
                    nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
                    nextScrollToIndex: nextProps.scrollToRow,
                    scrollToIndex: instanceProps.prevScrollToRow,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
                    }
                });
                instanceProps.prevColumnCount = nextProps.columnCount;
                instanceProps.prevColumnWidth = nextProps.columnWidth;
                instanceProps.prevIsScrolling = nextProps.isScrolling === true;
                instanceProps.prevRowCount = nextProps.rowCount;
                instanceProps.prevRowHeight = nextProps.rowHeight;
                instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
                instanceProps.prevScrollToRow = nextProps.scrollToRow;
                // getting scrollBarSize (moved from componentWillMount)
                instanceProps.scrollbarSize = nextProps.getScrollbarSize();
                if (instanceProps.scrollbarSize === undefined) {
                    instanceProps.scrollbarSizeMeasured = false;
                    instanceProps.scrollbarSize = 0;
                } else instanceProps.scrollbarSizeMeasured = true;
                newState.instanceProps = instanceProps;
                return $dddee09ada2ab319$var$_objectSpread($dddee09ada2ab319$var$_objectSpread($dddee09ada2ab319$var$_objectSpread({}, newState), maybeStateA), maybeStateB);
            }
        },
        {
            key: "_getEstimatedColumnSize",
            value: function _getEstimatedColumnSize(props /*: Props*/ ) {
                return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
            }
        },
        {
            key: "_getEstimatedRowSize",
            value: function _getEstimatedRowSize(props /*: Props*/ ) {
                return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
            }
        },
        {
            key: "_getScrollToPositionStateUpdate",
            value: /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */ function _getScrollToPositionStateUpdate(_ref9 /*:: */ ) /*: $Shape<State>*/ {
                var prevState = _ref9 /*:: */ .prevState, scrollLeft = _ref9 /*:: */ .scrollLeft, scrollTop = _ref9 /*:: */ .scrollTop;
                var newState /*: Object*/  = {
                    scrollPositionChangeReason: $dddee09ada2ab319$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
                    newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? (0, $9f59d7fc962d6582$export$f30397fa35598134) : (0, $9f59d7fc962d6582$export$4a9c12fc9cd91d00);
                    newState.scrollLeft = scrollLeft;
                }
                if (typeof scrollTop === 'number' && scrollTop >= 0) {
                    newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? (0, $9f59d7fc962d6582$export$f30397fa35598134) : (0, $9f59d7fc962d6582$export$4a9c12fc9cd91d00);
                    newState.scrollTop = scrollTop;
                }
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) return newState;
                return {};
            }
        },
        {
            key: "_wrapSizeGetter",
            value: function _wrapSizeGetter(value /*: CellSize*/ ) /*: CellSizeGetter*/ {
                return typeof value === 'function' ? value : function() {
                    return value /*: any*/ ;
                };
            }
        },
        {
            key: "_getCalculatedScrollLeft",
            value: function _getCalculatedScrollLeft(nextProps /*: Props*/ , prevState /*: State*/ ) {
                var columnCount = nextProps.columnCount, height = nextProps.height, scrollToAlignment = nextProps.scrollToAlignment, scrollToColumn = nextProps.scrollToColumn, width = nextProps.width;
                var scrollLeft = prevState.scrollLeft, instanceProps = prevState.instanceProps;
                if (columnCount > 0) {
                    var finalColumn = columnCount - 1;
                    var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                    return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: width - scrollBarSize,
                        currentOffset: scrollLeft,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: "_getScrollLeftForScrollToColumnStateUpdate",
            value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                var scrollLeft = prevState.scrollLeft;
                var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
                if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: calculatedScrollLeft,
                    scrollTop: -1
                });
                return {};
            }
        },
        {
            key: "_getCalculatedScrollTop",
            value: function _getCalculatedScrollTop(nextProps /*: Props*/ , prevState /*: State*/ ) {
                var height = nextProps.height, rowCount = nextProps.rowCount, scrollToAlignment = nextProps.scrollToAlignment, scrollToRow = nextProps.scrollToRow, width = nextProps.width;
                var scrollTop = prevState.scrollTop, instanceProps = prevState.instanceProps;
                if (rowCount > 0) {
                    var finalRow = rowCount - 1;
                    var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                    return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: height - scrollBarSize,
                        currentOffset: scrollTop,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: "_getScrollTopForScrollToRowStateUpdate",
            value: function _getScrollTopForScrollToRowStateUpdate(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                var scrollTop = prevState.scrollTop;
                var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
                if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: -1,
                    scrollTop: calculatedScrollTop
                });
                return {};
            }
        }
    ]);
}($acw62.PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))($dddee09ada2ab319$var$Grid, "defaultProps", {
    'aria-label': 'grid',
    'aria-readonly': true,
    autoContainerWidth: false,
    autoHeight: false,
    autoWidth: false,
    cellRangeRenderer: (0, $fc607241dfacb6e1$export$2e2bcd8739ae039),
    containerRole: 'row',
    containerStyle: {},
    estimatedColumnSize: 100,
    estimatedRowSize: 30,
    getScrollbarSize: (0, $2d215567a00cb0b5$export$2e2bcd8739ae039),
    noContentRenderer: $dddee09ada2ab319$var$renderNull,
    onScroll: function onScroll() {},
    onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
    onSectionRendered: function onSectionRendered() {},
    overscanColumnCount: 0,
    overscanIndicesGetter: (0, $9f59d7fc962d6582$export$2e2bcd8739ae039),
    overscanRowCount: 10,
    role: 'grid',
    scrollingResetTimeInterval: $dddee09ada2ab319$export$c51e03d5b92ea76f,
    scrollToAlignment: 'auto',
    scrollToColumn: -1,
    scrollToRow: -1,
    style: {},
    tabIndex: 0,
    isScrollingOptOut: false
});
(0, $c8a186e1757974bb$export$cea1c58a6db52bca)($dddee09ada2ab319$var$Grid);
var $dddee09ada2ab319$export$2e2bcd8739ae039 = $dddee09ada2ab319$var$Grid;


/*:: import type {OverscanIndicesGetterParams, OverscanIndices} from './types';*/ var $872a5ffafec0d490$export$4a9c12fc9cd91d00 = -1;
var $872a5ffafec0d490$export$f30397fa35598134 = 1;
var $872a5ffafec0d490$export$bd8d94980b275a2d = 'horizontal';
var $872a5ffafec0d490$export$11bc73ef6d36df46 = 'vertical';
function $872a5ffafec0d490$export$2e2bcd8739ae039(_ref /*:: */ ) /*: OverscanIndices*/ {
    var cellCount = _ref /*:: */ .cellCount, overscanCellsCount = _ref /*:: */ .overscanCellsCount, scrollDirection = _ref /*:: */ .scrollDirection, startIndex = _ref /*:: */ .startIndex, stopIndex = _ref /*:: */ .stopIndex;
    // Make sure we render at least 1 cell extra before and after (except near boundaries)
    // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
    // For more info see issues #625
    overscanCellsCount = Math.max(1, overscanCellsCount);
    if (scrollDirection === $872a5ffafec0d490$export$f30397fa35598134) return {
        overscanStartIndex: Math.max(0, startIndex - 1),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
}






var $b95e04f2d4c66124$exports = {};
var $41f5c206613f56c9$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $41f5c206613f56c9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $1e0ecff44bad0ea1$exports(r);
}
$41f5c206613f56c9$exports = $41f5c206613f56c9$var$_arrayWithoutHoles, $41f5c206613f56c9$exports.__esModule = true, $41f5c206613f56c9$exports["default"] = $41f5c206613f56c9$exports;


var $cce79e023a3a67e7$exports = {};
function $cce79e023a3a67e7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$cce79e023a3a67e7$exports = $cce79e023a3a67e7$var$_iterableToArray, $cce79e023a3a67e7$exports.__esModule = true, $cce79e023a3a67e7$exports["default"] = $cce79e023a3a67e7$exports;


var $51f08ebed50a2438$exports = {};

function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1e0ecff44bad0ea1$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1e0ecff44bad0ea1$exports(r, a) : void 0;
    }
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $67c90abe6042aecd$exports = {};
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$67c90abe6042aecd$exports = $67c90abe6042aecd$var$_nonIterableSpread, $67c90abe6042aecd$exports.__esModule = true, $67c90abe6042aecd$exports["default"] = $67c90abe6042aecd$exports;


function $b95e04f2d4c66124$var$_toConsumableArray(r) {
    return $41f5c206613f56c9$exports(r) || $cce79e023a3a67e7$exports(r) || $51f08ebed50a2438$exports(r) || $67c90abe6042aecd$exports();
}
$b95e04f2d4c66124$exports = $b95e04f2d4c66124$var$_toConsumableArray, $b95e04f2d4c66124$exports.__esModule = true, $b95e04f2d4c66124$exports["default"] = $b95e04f2d4c66124$exports;









var $acw62 = parcelRequire("acw62");


function $962112ac788a4493$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $962112ac788a4493$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $962112ac788a4493$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($962112ac788a4493$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */ var $962112ac788a4493$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    function InfiniteLoader(props, context) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, InfiniteLoader);
        _this = $962112ac788a4493$var$_callSuper(this, InfiniteLoader, [
            props,
            context
        ]);
        _this._loadMoreRowsMemoizer = (0, $eb7485db8fea8a79$export$2e2bcd8739ae039)();
        _this._onRowsRendered = _this._onRowsRendered.bind(_this);
        _this._registerChild = _this._registerChild.bind(_this);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(InfiniteLoader, _React$PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(InfiniteLoader, [
        {
            key: "resetLoadMoreRowsCache",
            value: function resetLoadMoreRowsCache(autoReload) {
                this._loadMoreRowsMemoizer = (0, $eb7485db8fea8a79$export$2e2bcd8739ae039)();
                if (autoReload) this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    onRowsRendered: this._onRowsRendered,
                    registerChild: this._registerChild
                });
            }
        },
        {
            key: "_loadUnloadedRanges",
            value: function _loadUnloadedRanges(unloadedRanges) {
                var _this2 = this;
                var loadMoreRows = this.props.loadMoreRows;
                unloadedRanges.forEach(function(unloadedRange) {
                    var promise = loadMoreRows(unloadedRange);
                    if (promise) promise.then(function() {
                        // Refresh the visible rows if any of them have just been loaded.
                        // Otherwise they will remain in their unloaded visual state.
                        if ($962112ac788a4493$export$f5bcfb715736e8f2({
                            lastRenderedStartIndex: _this2._lastRenderedStartIndex,
                            lastRenderedStopIndex: _this2._lastRenderedStopIndex,
                            startIndex: unloadedRange.startIndex,
                            stopIndex: unloadedRange.stopIndex
                        })) {
                            if (_this2._registeredChild) $962112ac788a4493$export$2d6239c612aaa6dd(_this2._registeredChild, _this2._lastRenderedStartIndex);
                        }
                    });
                });
            }
        },
        {
            key: "_onRowsRendered",
            value: function _onRowsRendered(_ref) {
                var startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
                this._lastRenderedStartIndex = startIndex;
                this._lastRenderedStopIndex = stopIndex;
                this._doStuff(startIndex, stopIndex);
            }
        },
        {
            key: "_doStuff",
            value: function _doStuff(startIndex, stopIndex) {
                var _ref2, _this3 = this;
                var _this$props = this.props, isRowLoaded = _this$props.isRowLoaded, minimumBatchSize = _this$props.minimumBatchSize, rowCount = _this$props.rowCount, threshold = _this$props.threshold;
                var unloadedRanges = $962112ac788a4493$export$2e183c7e20fa8fbf({
                    isRowLoaded: isRowLoaded,
                    minimumBatchSize: minimumBatchSize,
                    rowCount: rowCount,
                    startIndex: Math.max(0, startIndex - threshold),
                    stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
                });
                // For memoize comparison
                var squashedUnloadedRanges = (_ref2 = []).concat.apply(_ref2, (0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(unloadedRanges.map(function(_ref3) {
                    var startIndex = _ref3.startIndex, stopIndex = _ref3.stopIndex;
                    return [
                        startIndex,
                        stopIndex
                    ];
                })));
                this._loadMoreRowsMemoizer({
                    callback: function callback() {
                        _this3._loadUnloadedRanges(unloadedRanges);
                    },
                    indices: {
                        squashedUnloadedRanges: squashedUnloadedRanges
                    }
                });
            }
        },
        {
            key: "_registerChild",
            value: function _registerChild(registeredChild) {
                this._registeredChild = registeredChild;
            }
        }
    ]);
}($acw62.PureComponent);
/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */ (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))($962112ac788a4493$export$2e2bcd8739ae039, "defaultProps", {
    minimumBatchSize: 10,
    rowCount: 0,
    threshold: 15
});
$962112ac788a4493$export$2e2bcd8739ae039.propTypes = {};
function $962112ac788a4493$export$f5bcfb715736e8f2(_ref4) {
    var lastRenderedStartIndex = _ref4.lastRenderedStartIndex, lastRenderedStopIndex = _ref4.lastRenderedStopIndex, startIndex = _ref4.startIndex, stopIndex = _ref4.stopIndex;
    return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}
function $962112ac788a4493$export$2e183c7e20fa8fbf(_ref5) {
    var isRowLoaded = _ref5.isRowLoaded, minimumBatchSize = _ref5.minimumBatchSize, rowCount = _ref5.rowCount, startIndex = _ref5.startIndex, stopIndex = _ref5.stopIndex;
    var unloadedRanges = [];
    var rangeStartIndex = null;
    var rangeStopIndex = null;
    for(var index = startIndex; index <= stopIndex; index++){
        var loaded = isRowLoaded({
            index: index
        });
        if (!loaded) {
            rangeStopIndex = index;
            if (rangeStartIndex === null) rangeStartIndex = index;
        } else if (rangeStopIndex !== null) {
            unloadedRanges.push({
                startIndex: rangeStartIndex,
                stopIndex: rangeStopIndex
            });
            rangeStartIndex = rangeStopIndex = null;
        }
    }
    // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
    // Scan forward to try filling our :minimumBatchSize.
    if (rangeStopIndex !== null) {
        var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);
        for(var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++){
            if (!isRowLoaded({
                index: _index
            })) rangeStopIndex = _index;
            else break;
        }
        unloadedRanges.push({
            startIndex: rangeStartIndex,
            stopIndex: rangeStopIndex
        });
    }
    // Check to see if our first range ended prematurely.
    // In this case we should scan backwards to try filling our :minimumBatchSize.
    if (unloadedRanges.length) {
        var firstUnloadedRange = unloadedRanges[0];
        while(firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0){
            var _index2 = firstUnloadedRange.startIndex - 1;
            if (!isRowLoaded({
                index: _index2
            })) firstUnloadedRange.startIndex = _index2;
            else break;
        }
    }
    return unloadedRanges;
}
function $962112ac788a4493$export$2d6239c612aaa6dd(component) {
    var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;
    if (recomputeSize) recomputeSize.call(component, currentIndex);
    else component.forceUpdate();
}


var $b8082a73518714ff$export$2e2bcd8739ae039 = (0, $962112ac788a4493$export$2e2bcd8739ae039);


/*:: export type {RowRendererParams} from './types';*/ 
var $3p9rK = parcelRequire("3p9rK");








var $acw62 = parcelRequire("acw62");

function $ec6045117d70e2ec$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $ec6045117d70e2ec$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $ec6045117d70e2ec$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ec6045117d70e2ec$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */ /*:: type Props = {
  'aria-label'?: string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   *-/
  autoHeight: boolean,

  /** Optional CSS class name *-/
  className?: string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   *-/
  estimatedRowSize: number,

  /** Height constraint for list (determines how many actual rows are rendered) *-/
  height: number,

  /** Optional renderer to be used in place of rows when rowCount is 0 *-/
  noRowsRenderer: NoContentRenderer,

  /** Callback invoked with information about the slice of rows that were just rendered.  *-/

  onRowsRendered: (params: RenderedRows) => void,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   *-/
  onScroll: (params: Scroll) => void,

  /** See Grid#overscanIndicesGetter *-/
  overscanIndicesGetter: OverscanIndicesGetter,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   *-/
  overscanRowCount: number,

  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  *-/
  rowHeight: CellSize,

  /** Responsible for rendering a row given an index; ({ index: number }): node *-/
  rowRenderer: RowRenderer,

  /** Number of rows in list. *-/
  rowCount: number,

  /** See Grid#scrollToAlignment *-/
  scrollToAlignment: Alignment,

  /** Row index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToIndex: number,

  /** Vertical offset. *-/
  scrollTop?: number,

  /** Optional inline style *-/
  style: Object,

  /** Tab index for focus *-/
  tabIndex?: number,

  /** Width of list *-/
  width: number,
};*/ var $ec6045117d70e2ec$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    function List() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, List);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $ec6045117d70e2ec$var$_callSuper(this, List, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "Grid", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_cellRenderer", function(_ref /*:: */ ) {
            var parent = _ref /*:: */ .parent, rowIndex = _ref /*:: */ .rowIndex, style = _ref /*:: */ .style, isScrolling = _ref /*:: */ .isScrolling, isVisible = _ref /*:: */ .isVisible, key = _ref /*:: */ .key;
            var rowRenderer = _this.props.rowRenderer;
            // TRICKY The style object is sometimes cached by Grid.
            // This prevents new style objects from bypassing shallowCompare().
            // However as of React 16, style props are auto-frozen (at least in dev mode)
            // Check to make sure we can still modify the style before proceeding.
            // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
            var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');
            if (widthDescriptor && widthDescriptor.writable) // By default, List cells should be 100% width.
            // This prevents them from flowing under a scrollbar (if present).
            style.width = '100%';
            return rowRenderer({
                index: rowIndex,
                style: style,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_setRef", function(ref /*: ?React.ElementRef<typeof Grid>*/ ) {
            _this.Grid = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onScroll", function(_ref2 /*:: */ ) {
            var clientHeight = _ref2 /*:: */ .clientHeight, scrollHeight = _ref2 /*:: */ .scrollHeight, scrollTop = _ref2 /*:: */ .scrollTop;
            var onScroll = _this.props.onScroll;
            onScroll({
                clientHeight: clientHeight,
                scrollHeight: scrollHeight,
                scrollTop: scrollTop
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onSectionRendered", function(_ref3 /*:: */ ) {
            var rowOverscanStartIndex = _ref3 /*:: */ .rowOverscanStartIndex, rowOverscanStopIndex = _ref3 /*:: */ .rowOverscanStopIndex, rowStartIndex = _ref3 /*:: */ .rowStartIndex, rowStopIndex = _ref3 /*:: */ .rowStopIndex;
            var onRowsRendered = _this.props.onRowsRendered;
            onRowsRendered({
                overscanStartIndex: rowOverscanStartIndex,
                overscanStopIndex: rowOverscanStopIndex,
                startIndex: rowStartIndex,
                stopIndex: rowStopIndex
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(List, _React$PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(List, [
        {
            key: "forceUpdateGrid",
            value: function forceUpdateGrid() {
                if (this.Grid) this.Grid.forceUpdate();
            }
        },
        {
            key: "getOffsetForRow",
            value: function getOffsetForRow(_ref4 /*:: */ ) {
                var alignment = _ref4 /*:: */ .alignment, index = _ref4 /*:: */ .index;
                if (this.Grid) {
                    var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
                        alignment: alignment,
                        rowIndex: index,
                        columnIndex: 0
                    }), scrollTop = _this$Grid$getOffsetF.scrollTop;
                    return scrollTop;
                }
                return 0;
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref5 /*:: */ ) {
                var columnIndex = _ref5 /*:: */ .columnIndex, rowIndex = _ref5 /*:: */ .rowIndex;
                if (this.Grid) this.Grid.invalidateCellSizeAfterRender({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "measureAllRows",
            value: function measureAllRows() {
                if (this.Grid) this.Grid.measureAllCells();
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref6$columnIndex = _ref6.columnIndex, columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex, _ref6$rowIndex = _ref6.rowIndex, rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "recomputeRowHeights",
            value: function recomputeRowHeights() {
                var index /*: number*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: index,
                    columnIndex: 0
                });
            }
        },
        {
            key: "scrollToPosition",
            value: function scrollToPosition() {
                var scrollTop /*: number*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToPosition({
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: "scrollToRow",
            value: function scrollToRow() {
                var index /*: number*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToCell({
                    columnIndex: 0,
                    rowIndex: index
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, className = _this$props.className, noRowsRenderer = _this$props.noRowsRenderer, scrollToIndex = _this$props.scrollToIndex, width = _this$props.width;
                var classNames = (0, $15e8569690cae660$export$2e2bcd8739ae039)('ReactVirtualized__List', className);
                return /*#__PURE__*/ $acw62.createElement((0, $dddee09ada2ab319$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, this.props, {
                    autoContainerWidth: true,
                    cellRenderer: this._cellRenderer,
                    className: classNames,
                    columnWidth: width,
                    columnCount: 1,
                    noContentRenderer: noRowsRenderer,
                    onScroll: this._onScroll,
                    onSectionRendered: this._onSectionRendered,
                    ref: this._setRef,
                    scrollToRow: scrollToIndex
                }));
            }
        }
    ]);
}($acw62.PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))($ec6045117d70e2ec$export$2e2bcd8739ae039, "defaultProps", {
    autoHeight: false,
    estimatedRowSize: 30,
    onScroll: function onScroll() {},
    noRowsRenderer: function noRowsRenderer() {
        return null;
    },
    onRowsRendered: function onRowsRendered() {},
    overscanIndicesGetter: (0, $872a5ffafec0d490$export$2e2bcd8739ae039),
    overscanRowCount: 10,
    scrollToAlignment: 'auto',
    scrollToIndex: -1,
    style: {}
});




/*:: import type {CellMeasurerCache, Positioner} from './Masonry';*/ /*:: type createCellPositionerParams = {
  cellMeasurerCache: CellMeasurerCache,
  columnCount: number,
  columnWidth: number,
  spacer?: number,
};*/ /*:: type resetParams = {
  columnCount: number,
  columnWidth: number,
  spacer?: number,
};*/ function $6adbcc2ddb9e86e2$export$2e2bcd8739ae039(_ref /*:: */ ) /*: Positioner*/ {
    var cellMeasurerCache = _ref /*:: */ .cellMeasurerCache, columnCount = _ref /*:: */ .columnCount, columnWidth = _ref /*:: */ .columnWidth, _ref$spacer = _ref /*:: */ .spacer, spacer = _ref$spacer === void 0 ? 0 : _ref$spacer;
    var columnHeights;
    initOrResetDerivedValues();
    function cellPositioner(index) {
        // Find the shortest column and use it.
        var columnIndex = 0;
        for(var i = 1; i < columnHeights.length; i++)if (columnHeights[i] < columnHeights[columnIndex]) columnIndex = i;
        var left = columnIndex * (columnWidth + spacer);
        var top = columnHeights[columnIndex] || 0;
        columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;
        return {
            left: left,
            top: top
        };
    }
    function initOrResetDerivedValues() /*: void*/ {
        // Track the height of each column.
        // Layout algorithm below always inserts into the shortest column.
        columnHeights = [];
        for(var i = 0; i < columnCount; i++)columnHeights[i] = 0;
    }
    function reset(params /*: resetParams*/ ) /*: void*/ {
        columnCount = params.columnCount;
        columnWidth = params.columnWidth;
        spacer = params.spacer;
        initOrResetDerivedValues();
    }
    cellPositioner.reset = reset;
    return cellPositioner;
}










var $acw62 = parcelRequire("acw62");

var $008fdf6f13d86ab1$exports = {};
var $bf2dbd940d8d1ee7$exports = {};
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$bf2dbd940d8d1ee7$exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, $bf2dbd940d8d1ee7$exports.__esModule = true, $bf2dbd940d8d1ee7$exports["default"] = $bf2dbd940d8d1ee7$exports;


var $efa3fde0b6100532$exports = {};
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$efa3fde0b6100532$exports = $efa3fde0b6100532$var$_iterableToArrayLimit, $efa3fde0b6100532$exports.__esModule = true, $efa3fde0b6100532$exports["default"] = $efa3fde0b6100532$exports;



var $9fdae42208ebda05$exports = {};
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9fdae42208ebda05$exports = $9fdae42208ebda05$var$_nonIterableRest, $9fdae42208ebda05$exports.__esModule = true, $9fdae42208ebda05$exports["default"] = $9fdae42208ebda05$exports;


function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $bf2dbd940d8d1ee7$exports(r) || $efa3fde0b6100532$exports(r, e) || $51f08ebed50a2438$exports(r, e) || $9fdae42208ebda05$exports();
}
$008fdf6f13d86ab1$exports = $008fdf6f13d86ab1$var$_slicedToArray, $008fdf6f13d86ab1$exports.__esModule = true, $008fdf6f13d86ab1$exports["default"] = $008fdf6f13d86ab1$exports;





/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/interval-tree-1d
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/ /**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/binary-search-bounds
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/ function $cb98b1d6de85d071$var$_GEA(a, l, h, y) {
    var i = h + 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (x >= y) {
            i = m;
            h = m - 1;
        } else l = m + 1;
    }
    return i;
}
function $cb98b1d6de85d071$var$_GEP(a, l, h, y, c) {
    var i = h + 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (c(x, y) >= 0) {
            i = m;
            h = m - 1;
        } else l = m + 1;
    }
    return i;
}
function $cb98b1d6de85d071$var$dispatchBsearchGE(a, y, c, l, h) {
    if (typeof c === 'function') return $cb98b1d6de85d071$var$_GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
    else return $cb98b1d6de85d071$var$_GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
}
function $cb98b1d6de85d071$var$_GTA(a, l, h, y) {
    var i = h + 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (x > y) {
            i = m;
            h = m - 1;
        } else l = m + 1;
    }
    return i;
}
function $cb98b1d6de85d071$var$_GTP(a, l, h, y, c) {
    var i = h + 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (c(x, y) > 0) {
            i = m;
            h = m - 1;
        } else l = m + 1;
    }
    return i;
}
function $cb98b1d6de85d071$var$dispatchBsearchGT(a, y, c, l, h) {
    if (typeof c === 'function') return $cb98b1d6de85d071$var$_GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
    else return $cb98b1d6de85d071$var$_GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
}
function $cb98b1d6de85d071$var$_LTA(a, l, h, y) {
    var i = l - 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (x < y) {
            i = m;
            l = m + 1;
        } else h = m - 1;
    }
    return i;
}
function $cb98b1d6de85d071$var$_LTP(a, l, h, y, c) {
    var i = l - 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (c(x, y) < 0) {
            i = m;
            l = m + 1;
        } else h = m - 1;
    }
    return i;
}
function $cb98b1d6de85d071$var$dispatchBsearchLT(a, y, c, l, h) {
    if (typeof c === 'function') return $cb98b1d6de85d071$var$_LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
    else return $cb98b1d6de85d071$var$_LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
}
function $cb98b1d6de85d071$var$_LEA(a, l, h, y) {
    var i = l - 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (x <= y) {
            i = m;
            l = m + 1;
        } else h = m - 1;
    }
    return i;
}
function $cb98b1d6de85d071$var$_LEP(a, l, h, y, c) {
    var i = l - 1;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (c(x, y) <= 0) {
            i = m;
            l = m + 1;
        } else h = m - 1;
    }
    return i;
}
function $cb98b1d6de85d071$var$dispatchBsearchLE(a, y, c, l, h) {
    if (typeof c === 'function') return $cb98b1d6de85d071$var$_LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
    else return $cb98b1d6de85d071$var$_LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
}
function $cb98b1d6de85d071$var$_EQA(a, l, h, y) {
    l;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        if (x === y) return m;
        else if (x <= y) l = m + 1;
        else h = m - 1;
    }
    return -1;
}
function $cb98b1d6de85d071$var$_EQP(a, l, h, y, c) {
    l;
    while(l <= h){
        var m = l + h >>> 1, x = a[m];
        var p = c(x, y);
        if (p === 0) return m;
        else if (p <= 0) l = m + 1;
        else h = m - 1;
    }
    return -1;
}
function $cb98b1d6de85d071$var$dispatchBsearchEQ(a, y, c, l, h) {
    if (typeof c === 'function') return $cb98b1d6de85d071$var$_EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
    else return $cb98b1d6de85d071$var$_EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
}
var $cb98b1d6de85d071$export$2e2bcd8739ae039 = {
    ge: $cb98b1d6de85d071$var$dispatchBsearchGE,
    gt: $cb98b1d6de85d071$var$dispatchBsearchGT,
    lt: $cb98b1d6de85d071$var$dispatchBsearchLT,
    le: $cb98b1d6de85d071$var$dispatchBsearchLE,
    eq: $cb98b1d6de85d071$var$dispatchBsearchEQ
};


var $9c2fe7e2a03fd1a3$var$NOT_FOUND = 0;
var $9c2fe7e2a03fd1a3$var$SUCCESS = 1;
var $9c2fe7e2a03fd1a3$var$EMPTY = 2;
function $9c2fe7e2a03fd1a3$var$IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
    this.mid = mid;
    this.left = left;
    this.right = right;
    this.leftPoints = leftPoints;
    this.rightPoints = rightPoints;
    this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
}
var $9c2fe7e2a03fd1a3$var$proto = $9c2fe7e2a03fd1a3$var$IntervalTreeNode.prototype;
function $9c2fe7e2a03fd1a3$var$copy(a, b) {
    a.mid = b.mid;
    a.left = b.left;
    a.right = b.right;
    a.leftPoints = b.leftPoints;
    a.rightPoints = b.rightPoints;
    a.count = b.count;
}
function $9c2fe7e2a03fd1a3$var$rebuild(node, intervals) {
    var ntree = $9c2fe7e2a03fd1a3$var$createIntervalTree(intervals);
    node.mid = ntree.mid;
    node.left = ntree.left;
    node.right = ntree.right;
    node.leftPoints = ntree.leftPoints;
    node.rightPoints = ntree.rightPoints;
    node.count = ntree.count;
}
function $9c2fe7e2a03fd1a3$var$rebuildWithInterval(node, interval) {
    var intervals = node.intervals([]);
    intervals.push(interval);
    $9c2fe7e2a03fd1a3$var$rebuild(node, intervals);
}
function $9c2fe7e2a03fd1a3$var$rebuildWithoutInterval(node, interval) {
    var intervals = node.intervals([]);
    var idx = intervals.indexOf(interval);
    if (idx < 0) return $9c2fe7e2a03fd1a3$var$NOT_FOUND;
    intervals.splice(idx, 1);
    $9c2fe7e2a03fd1a3$var$rebuild(node, intervals);
    return $9c2fe7e2a03fd1a3$var$SUCCESS;
}
$9c2fe7e2a03fd1a3$var$proto.intervals = function(result) {
    result.push.apply(result, this.leftPoints);
    if (this.left) this.left.intervals(result);
    if (this.right) this.right.intervals(result);
    return result;
};
$9c2fe7e2a03fd1a3$var$proto.insert = function(interval) {
    var weight = this.count - this.leftPoints.length;
    this.count += 1;
    if (interval[1] < this.mid) {
        if (this.left) {
            if (4 * (this.left.count + 1) > 3 * (weight + 1)) $9c2fe7e2a03fd1a3$var$rebuildWithInterval(this, interval);
            else this.left.insert(interval);
        } else this.left = $9c2fe7e2a03fd1a3$var$createIntervalTree([
            interval
        ]);
    } else if (interval[0] > this.mid) {
        if (this.right) {
            if (4 * (this.right.count + 1) > 3 * (weight + 1)) $9c2fe7e2a03fd1a3$var$rebuildWithInterval(this, interval);
            else this.right.insert(interval);
        } else this.right = $9c2fe7e2a03fd1a3$var$createIntervalTree([
            interval
        ]);
    } else {
        var l = (0, $cb98b1d6de85d071$export$2e2bcd8739ae039).ge(this.leftPoints, interval, $9c2fe7e2a03fd1a3$var$compareBegin);
        var r = (0, $cb98b1d6de85d071$export$2e2bcd8739ae039).ge(this.rightPoints, interval, $9c2fe7e2a03fd1a3$var$compareEnd);
        this.leftPoints.splice(l, 0, interval);
        this.rightPoints.splice(r, 0, interval);
    }
};
$9c2fe7e2a03fd1a3$var$proto.remove = function(interval) {
    var weight = this.count - this.leftPoints;
    if (interval[1] < this.mid) {
        if (!this.left) return $9c2fe7e2a03fd1a3$var$NOT_FOUND;
        var rw = this.right ? this.right.count : 0;
        if (4 * rw > 3 * (weight - 1)) return $9c2fe7e2a03fd1a3$var$rebuildWithoutInterval(this, interval);
        var r = this.left.remove(interval);
        if (r === $9c2fe7e2a03fd1a3$var$EMPTY) {
            this.left = null;
            this.count -= 1;
            return $9c2fe7e2a03fd1a3$var$SUCCESS;
        } else if (r === $9c2fe7e2a03fd1a3$var$SUCCESS) this.count -= 1;
        return r;
    } else if (interval[0] > this.mid) {
        if (!this.right) return $9c2fe7e2a03fd1a3$var$NOT_FOUND;
        var lw = this.left ? this.left.count : 0;
        if (4 * lw > 3 * (weight - 1)) return $9c2fe7e2a03fd1a3$var$rebuildWithoutInterval(this, interval);
        var r = this.right.remove(interval);
        if (r === $9c2fe7e2a03fd1a3$var$EMPTY) {
            this.right = null;
            this.count -= 1;
            return $9c2fe7e2a03fd1a3$var$SUCCESS;
        } else if (r === $9c2fe7e2a03fd1a3$var$SUCCESS) this.count -= 1;
        return r;
    } else {
        if (this.count === 1) {
            if (this.leftPoints[0] === interval) return $9c2fe7e2a03fd1a3$var$EMPTY;
            else return $9c2fe7e2a03fd1a3$var$NOT_FOUND;
        }
        if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
            if (this.left && this.right) {
                var p = this;
                var n = this.left;
                while(n.right){
                    p = n;
                    n = n.right;
                }
                if (p === this) n.right = this.right;
                else {
                    var l = this.left;
                    var r = this.right;
                    p.count -= n.count;
                    p.right = n.left;
                    n.left = l;
                    n.right = r;
                }
                $9c2fe7e2a03fd1a3$var$copy(this, n);
                this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
            } else if (this.left) $9c2fe7e2a03fd1a3$var$copy(this, this.left);
            else $9c2fe7e2a03fd1a3$var$copy(this, this.right);
            return $9c2fe7e2a03fd1a3$var$SUCCESS;
        }
        for(var l = (0, $cb98b1d6de85d071$export$2e2bcd8739ae039).ge(this.leftPoints, interval, $9c2fe7e2a03fd1a3$var$compareBegin); l < this.leftPoints.length; ++l){
            if (this.leftPoints[l][0] !== interval[0]) break;
            if (this.leftPoints[l] === interval) {
                this.count -= 1;
                this.leftPoints.splice(l, 1);
                for(var r = (0, $cb98b1d6de85d071$export$2e2bcd8739ae039).ge(this.rightPoints, interval, $9c2fe7e2a03fd1a3$var$compareEnd); r < this.rightPoints.length; ++r){
                    if (this.rightPoints[r][1] !== interval[1]) break;
                    else if (this.rightPoints[r] === interval) {
                        this.rightPoints.splice(r, 1);
                        return $9c2fe7e2a03fd1a3$var$SUCCESS;
                    }
                }
            }
        }
        return $9c2fe7e2a03fd1a3$var$NOT_FOUND;
    }
};
function $9c2fe7e2a03fd1a3$var$reportLeftRange(arr, hi, cb) {
    for(var i = 0; i < arr.length && arr[i][0] <= hi; ++i){
        var r = cb(arr[i]);
        if (r) return r;
    }
}
function $9c2fe7e2a03fd1a3$var$reportRightRange(arr, lo, cb) {
    for(var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i){
        var r = cb(arr[i]);
        if (r) return r;
    }
}
function $9c2fe7e2a03fd1a3$var$reportRange(arr, cb) {
    for(var i = 0; i < arr.length; ++i){
        var r = cb(arr[i]);
        if (r) return r;
    }
}
$9c2fe7e2a03fd1a3$var$proto.queryPoint = function(x, cb) {
    if (x < this.mid) {
        if (this.left) {
            var r = this.left.queryPoint(x, cb);
            if (r) return r;
        }
        return $9c2fe7e2a03fd1a3$var$reportLeftRange(this.leftPoints, x, cb);
    } else if (x > this.mid) {
        if (this.right) {
            var r = this.right.queryPoint(x, cb);
            if (r) return r;
        }
        return $9c2fe7e2a03fd1a3$var$reportRightRange(this.rightPoints, x, cb);
    } else return $9c2fe7e2a03fd1a3$var$reportRange(this.leftPoints, cb);
};
$9c2fe7e2a03fd1a3$var$proto.queryInterval = function(lo, hi, cb) {
    if (lo < this.mid && this.left) {
        var r = this.left.queryInterval(lo, hi, cb);
        if (r) return r;
    }
    if (hi > this.mid && this.right) {
        var r = this.right.queryInterval(lo, hi, cb);
        if (r) return r;
    }
    if (hi < this.mid) return $9c2fe7e2a03fd1a3$var$reportLeftRange(this.leftPoints, hi, cb);
    else if (lo > this.mid) return $9c2fe7e2a03fd1a3$var$reportRightRange(this.rightPoints, lo, cb);
    else return $9c2fe7e2a03fd1a3$var$reportRange(this.leftPoints, cb);
};
function $9c2fe7e2a03fd1a3$var$compareNumbers(a, b) {
    return a - b;
}
function $9c2fe7e2a03fd1a3$var$compareBegin(a, b) {
    var d = a[0] - b[0];
    if (d) return d;
    return a[1] - b[1];
}
function $9c2fe7e2a03fd1a3$var$compareEnd(a, b) {
    var d = a[1] - b[1];
    if (d) return d;
    return a[0] - b[0];
}
function $9c2fe7e2a03fd1a3$var$createIntervalTree(intervals) {
    if (intervals.length === 0) return null;
    var pts = [];
    for(var i = 0; i < intervals.length; ++i)pts.push(intervals[i][0], intervals[i][1]);
    pts.sort($9c2fe7e2a03fd1a3$var$compareNumbers);
    var mid = pts[pts.length >> 1];
    var leftIntervals = [];
    var rightIntervals = [];
    var centerIntervals = [];
    for(var i = 0; i < intervals.length; ++i){
        var s = intervals[i];
        if (s[1] < mid) leftIntervals.push(s);
        else if (mid < s[0]) rightIntervals.push(s);
        else centerIntervals.push(s);
    }
    //Split center intervals
    var leftPoints = centerIntervals;
    var rightPoints = centerIntervals.slice();
    leftPoints.sort($9c2fe7e2a03fd1a3$var$compareBegin);
    rightPoints.sort($9c2fe7e2a03fd1a3$var$compareEnd);
    return new $9c2fe7e2a03fd1a3$var$IntervalTreeNode(mid, $9c2fe7e2a03fd1a3$var$createIntervalTree(leftIntervals), $9c2fe7e2a03fd1a3$var$createIntervalTree(rightIntervals), leftPoints, rightPoints);
}
//User friendly wrapper that makes it possible to support empty trees
function $9c2fe7e2a03fd1a3$var$IntervalTree(root) {
    this.root = root;
}
var $9c2fe7e2a03fd1a3$var$tproto = $9c2fe7e2a03fd1a3$var$IntervalTree.prototype;
$9c2fe7e2a03fd1a3$var$tproto.insert = function(interval) {
    if (this.root) this.root.insert(interval);
    else this.root = new $9c2fe7e2a03fd1a3$var$IntervalTreeNode(interval[0], null, null, [
        interval
    ], [
        interval
    ]);
};
$9c2fe7e2a03fd1a3$var$tproto.remove = function(interval) {
    if (this.root) {
        var r = this.root.remove(interval);
        if (r === $9c2fe7e2a03fd1a3$var$EMPTY) this.root = null;
        return r !== $9c2fe7e2a03fd1a3$var$NOT_FOUND;
    }
    return false;
};
$9c2fe7e2a03fd1a3$var$tproto.queryPoint = function(p, cb) {
    if (this.root) return this.root.queryPoint(p, cb);
};
$9c2fe7e2a03fd1a3$var$tproto.queryInterval = function(lo, hi, cb) {
    if (lo <= hi && this.root) return this.root.queryInterval(lo, hi, cb);
};
Object.defineProperty($9c2fe7e2a03fd1a3$var$tproto, 'count', {
    get: function get() {
        if (this.root) return this.root.count;
        return 0;
    }
});
Object.defineProperty($9c2fe7e2a03fd1a3$var$tproto, 'intervals', {
    get: function get() {
        if (this.root) return this.root.intervals([]);
        return [];
    }
});
function $9c2fe7e2a03fd1a3$export$2e2bcd8739ae039(intervals) {
    if (!intervals || intervals.length === 0) return new $9c2fe7e2a03fd1a3$var$IntervalTree(null);
    return new $9c2fe7e2a03fd1a3$var$IntervalTree($9c2fe7e2a03fd1a3$var$createIntervalTree(intervals));
}


/*:: type RenderCallback = (index: number, left: number, top: number) => void;*/ // Position cache requirements:
//   O(log(n)) lookup of cells to render for a given viewport size
//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
var $223471badd1d0315$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PositionCache() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, PositionCache);
        // Tracks the height of each column
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_columnSizeMap", {});
        // Store tops and bottoms of each cell for fast intersection lookup.
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_intervalTree", (0, $9c2fe7e2a03fd1a3$export$2e2bcd8739ae039)());
        // Maps cell index to x coordinates for quick lookup.
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_leftMap", {});
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(PositionCache, [
        {
            key: "estimateTotalHeight",
            value: function estimateTotalHeight(cellCount /*: number*/ , columnCount /*: number*/ , defaultCellHeight /*: number*/ ) /*: number*/ {
                var unmeasuredCellCount = cellCount - this.count;
                return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
            }
        },
        {
            key: "range",
            value: function range(scrollTop /*: number*/ , clientHeight /*: number*/ , renderCallback /*: RenderCallback*/ ) /*: void*/ {
                var _this = this;
                this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function(_ref) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_ref, 3), top = _ref2[0], _ = _ref2[1], index = _ref2[2];
                    return renderCallback(index, _this._leftMap[index], top);
                });
            }
        },
        {
            key: "setPosition",
            value: function setPosition(index /*: number*/ , left /*: number*/ , top /*: number*/ , height /*: number*/ ) /*: void*/ {
                this._intervalTree.insert([
                    top,
                    top + height,
                    index
                ]);
                this._leftMap[index] = left;
                var columnSizeMap = this._columnSizeMap;
                var columnHeight = columnSizeMap[left];
                if (columnHeight === undefined) columnSizeMap[left] = top + height;
                else columnSizeMap[left] = Math.max(columnHeight, top + height);
            }
        },
        {
            key: "count",
            get: function get() /*: number*/ {
                return this._intervalTree.count;
            }
        },
        {
            key: "shortestColumnSize",
            get: function get() /*: number*/ {
                var columnSizeMap = this._columnSizeMap;
                var size = 0;
                for(var i in columnSizeMap){
                    var height = columnSizeMap[i /*: any*/ ];
                    size = size === 0 ? height : Math.min(size, height);
                }
                return size;
            }
        },
        {
            key: "tallestColumnSize",
            get: function get() /*: number*/ {
                var columnSizeMap = this._columnSizeMap;
                var size = 0;
                for(var i in columnSizeMap){
                    var height = columnSizeMap[i /*: any*/ ];
                    size = Math.max(size, height);
                }
                return size;
            }
        }
    ]);
}();



function $3e9f254466cab707$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3e9f254466cab707$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3e9f254466cab707$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3e9f254466cab707$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3e9f254466cab707$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $3e9f254466cab707$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $3e9f254466cab707$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3e9f254466cab707$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
/*:: import type {AnimationTimeoutId} from '../utils/requestAnimationTimeout';*/ /*:: type Props = {
  autoHeight: boolean,
  cellCount: number,
  cellMeasurerCache: CellMeasurerCache,
  cellPositioner: Positioner,
  cellRenderer: CellRenderer,
  className: ?string,
  height: number,
  id: ?string,
  keyMapper: KeyMapper,
  onCellsRendered: ?OnCellsRenderedCallback,
  onScroll: ?OnScrollCallback,
  overscanByPixels: number,
  role: string,
  scrollingResetTimeInterval: number,
  style: mixed,
  tabIndex: number,
  width: number,
  rowDirection: string,
  scrollTop?: number,
};*/ /*:: type State = {
  isScrolling: boolean,
  scrollTop: number,
};*/ var $3e9f254466cab707$var$emptyObject = {};
var $3e9f254466cab707$export$c51e03d5b92ea76f = 150;
/**
 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
 * Cell position is determined by an injected `cellPositioner` property.
 * Windowing is vertical; this component does not support horizontal scrolling.
 *
 * Rendering occurs in two phases:
 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
 * 2) Second pass uses the external `cellPositioner` to layout cells.
 *    At this time the positioner has access to cached size measurements for all cells.
 *    The positions it returns are cached by Masonry for fast access later.
 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
 *
 * Animation constraints:
 *   Simple animations are supported (eg translate/slide into place on initial reveal).
 *   More complex animations are not (eg flying from one position to another on resize).
 *
 * Layout constraints:
 *   This component supports multi-column layout.
 *   The height of each item may vary.
 *   The width of each item must not exceed the width of the column it is "in".
 *   The left position of all items within a column must align.
 *   (Items may not span multiple columns.)
 */ var $3e9f254466cab707$var$Masonry = /*#__PURE__*/ function(_React$PureComponent) {
    function Masonry() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Masonry);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $3e9f254466cab707$var$_callSuper(this, Masonry, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "state", {
            isScrolling: false,
            scrollTop: 0
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_debounceResetIsScrollingId", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_invalidateOnUpdateStartIndex", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_invalidateOnUpdateStopIndex", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_positionCache", new (0, $223471badd1d0315$export$2e2bcd8739ae039)());
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_startIndex", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_startIndexMemoized", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_stopIndex", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_stopIndexMemoized", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_debounceResetIsScrollingCallback", function() {
            _this.setState({
                isScrolling: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_setScrollingContainerRef", function(ref) {
            _this._scrollingContainer = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onScroll", function(event) {
            var height = _this.props.height;
            var eventScrollTop = event.currentTarget.scrollTop;
            // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
            // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
            // This causes a series of rapid renders that is slow for long lists.
            // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
            var scrollTop = Math.min(Math.max(0, _this._getEstimatedTotalHeight() - height), eventScrollTop);
            // On iOS, we can arrive at negative offsets by swiping past the start or end.
            // Avoid re-rendering in this case as it can cause problems; see #532 for more.
            if (eventScrollTop !== scrollTop) return;
            // Prevent pointer events from interrupting a smooth scroll
            _this._debounceResetIsScrolling();
            // Certain devices (like Apple touchpad) rapid-fire duplicate events.
            // Don't force a re-render if this is the case.
            // The mouse may move faster then the animation frame does.
            // Use requestAnimationFrame to avoid over-updating.
            if (_this.state.scrollTop !== scrollTop) _this.setState({
                isScrolling: true,
                scrollTop: scrollTop
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(Masonry, _React$PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Masonry, [
        {
            key: "clearCellPositions",
            value: function clearCellPositions() {
                this._positionCache = new (0, $223471badd1d0315$export$2e2bcd8739ae039)();
                this.forceUpdate();
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref) {
                var index = _ref.rowIndex;
                if (this._invalidateOnUpdateStartIndex === null) {
                    this._invalidateOnUpdateStartIndex = index;
                    this._invalidateOnUpdateStopIndex = index;
                } else {
                    this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
                    this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
                }
            }
        },
        {
            key: "recomputeCellPositions",
            value: function recomputeCellPositions() {
                var stopIndex = this._positionCache.count - 1;
                this._positionCache = new (0, $223471badd1d0315$export$2e2bcd8739ae039)();
                this._populatePositionCache(0, stopIndex);
                this.forceUpdate();
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._checkInvalidateOnUpdate();
                this._invokeOnScrollCallback();
                this._invokeOnCellsRenderedCallback();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps /*: Props*/ , prevState /*: State*/ ) {
                this._checkInvalidateOnUpdate();
                this._invokeOnScrollCallback();
                this._invokeOnCellsRenderedCallback();
                if (this.props.scrollTop !== prevProps.scrollTop) this._debounceResetIsScrolling();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this._debounceResetIsScrollingId) (0, $85d05b1a4e1d5c40$export$3b976196c7d0d7a6)(this._debounceResetIsScrollingId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, autoHeight = _this$props.autoHeight, cellCount = _this$props.cellCount, cellMeasurerCache = _this$props.cellMeasurerCache, cellRenderer = _this$props.cellRenderer, className = _this$props.className, height = _this$props.height, id = _this$props.id, keyMapper = _this$props.keyMapper, overscanByPixels = _this$props.overscanByPixels, role = _this$props.role, style = _this$props.style, tabIndex = _this$props.tabIndex, width = _this$props.width, rowDirection = _this$props.rowDirection;
                var _this$state = this.state, isScrolling = _this$state.isScrolling, scrollTop = _this$state.scrollTop;
                var children = [];
                var estimateTotalHeight = this._getEstimatedTotalHeight();
                var shortestColumnSize = this._positionCache.shortestColumnSize;
                var measuredCellCount = this._positionCache.count;
                var startIndex = 0;
                var stopIndex;
                this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function(index /*: number*/ , left /*: number*/ , top /*: number*/ ) {
                    if (typeof stopIndex === 'undefined') {
                        startIndex = index;
                        stopIndex = index;
                    } else {
                        startIndex = Math.min(startIndex, index);
                        stopIndex = Math.max(stopIndex, index);
                    }
                    children.push(cellRenderer({
                        index: index,
                        isScrolling: isScrolling,
                        key: keyMapper(index),
                        parent: _this2,
                        style: (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))({
                            height: cellMeasurerCache.getHeight(index)
                        }, rowDirection === 'ltr' ? 'left' : 'right', left), "position", 'absolute'), "top", top), "width", cellMeasurerCache.getWidth(index))
                    }));
                });
                // We need to measure additional cells for this layout
                if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
                    var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));
                    for(var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++){
                        stopIndex = _index;
                        children.push(cellRenderer({
                            index: _index,
                            isScrolling: isScrolling,
                            key: keyMapper(_index),
                            parent: this,
                            style: {
                                width: cellMeasurerCache.getWidth(_index)
                            }
                        }));
                    }
                }
                this._startIndex = startIndex;
                this._stopIndex = stopIndex;
                return /*#__PURE__*/ $acw62.createElement("div", {
                    ref: this._setScrollingContainerRef,
                    "aria-label": this.props['aria-label'],
                    className: (0, $15e8569690cae660$export$2e2bcd8739ae039)('ReactVirtualized__Masonry', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: role,
                    style: $3e9f254466cab707$var$_objectSpread({
                        boxSizing: 'border-box',
                        direction: 'ltr',
                        height: autoHeight ? 'auto' : height,
                        overflowX: 'hidden',
                        overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
                        position: 'relative',
                        width: width,
                        WebkitOverflowScrolling: 'touch',
                        willChange: 'transform'
                    }, style),
                    tabIndex: tabIndex
                }, /*#__PURE__*/ $acw62.createElement("div", {
                    className: "ReactVirtualized__Masonry__innerScrollContainer",
                    style: {
                        width: '100%',
                        height: estimateTotalHeight,
                        maxWidth: '100%',
                        maxHeight: estimateTotalHeight,
                        overflow: 'hidden',
                        pointerEvents: isScrolling ? 'none' : '',
                        position: 'relative'
                    }
                }, children));
            }
        },
        {
            key: "_checkInvalidateOnUpdate",
            value: function _checkInvalidateOnUpdate() {
                if (typeof this._invalidateOnUpdateStartIndex === 'number') {
                    var startIndex = this._invalidateOnUpdateStartIndex;
                    var stopIndex = this._invalidateOnUpdateStopIndex;
                    this._invalidateOnUpdateStartIndex = null;
                    this._invalidateOnUpdateStopIndex = null;
                    // Query external layout logic for position of newly-measured cells
                    this._populatePositionCache(startIndex, stopIndex);
                    this.forceUpdate();
                }
            }
        },
        {
            key: "_debounceResetIsScrolling",
            value: function _debounceResetIsScrolling() {
                var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
                if (this._debounceResetIsScrollingId) (0, $85d05b1a4e1d5c40$export$3b976196c7d0d7a6)(this._debounceResetIsScrollingId);
                this._debounceResetIsScrollingId = (0, $85d05b1a4e1d5c40$export$62c6fa81f9943047)(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
            }
        },
        {
            key: "_getEstimatedTotalHeight",
            value: function _getEstimatedTotalHeight() {
                var _this$props2 = this.props, cellCount = _this$props2.cellCount, cellMeasurerCache = _this$props2.cellMeasurerCache, width = _this$props2.width;
                var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));
                return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
            }
        },
        {
            key: "_invokeOnScrollCallback",
            value: function _invokeOnScrollCallback() {
                var _this$props3 = this.props, height = _this$props3.height, onScroll = _this$props3.onScroll;
                var scrollTop = this.state.scrollTop;
                if (this._onScrollMemoized !== scrollTop) {
                    onScroll({
                        clientHeight: height,
                        scrollHeight: this._getEstimatedTotalHeight(),
                        scrollTop: scrollTop
                    });
                    this._onScrollMemoized = scrollTop;
                }
            }
        },
        {
            key: "_invokeOnCellsRenderedCallback",
            value: function _invokeOnCellsRenderedCallback() {
                if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
                    var onCellsRendered = this.props.onCellsRendered;
                    onCellsRendered({
                        startIndex: this._startIndex,
                        stopIndex: this._stopIndex
                    });
                    this._startIndexMemoized = this._startIndex;
                    this._stopIndexMemoized = this._stopIndex;
                }
            }
        },
        {
            key: "_populatePositionCache",
            value: function _populatePositionCache(startIndex /*: number*/ , stopIndex /*: number*/ ) {
                var _this$props4 = this.props, cellMeasurerCache = _this$props4.cellMeasurerCache, cellPositioner = _this$props4.cellPositioner;
                for(var _index2 = startIndex; _index2 <= stopIndex; _index2++){
                    var _cellPositioner = cellPositioner(_index2), left = _cellPositioner.left, top = _cellPositioner.top;
                    this._positionCache.setPosition(_index2, left, top, cellMeasurerCache.getHeight(_index2));
                }
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                if (nextProps.scrollTop !== undefined && prevState.scrollTop !== nextProps.scrollTop) return {
                    isScrolling: true,
                    scrollTop: nextProps.scrollTop
                };
                return null;
            }
        }
    ]);
}($acw62.PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))($3e9f254466cab707$var$Masonry, "defaultProps", {
    autoHeight: false,
    keyMapper: $3e9f254466cab707$var$identity,
    onCellsRendered: $3e9f254466cab707$var$noop,
    onScroll: $3e9f254466cab707$var$noop,
    overscanByPixels: 20,
    role: 'grid',
    scrollingResetTimeInterval: $3e9f254466cab707$export$c51e03d5b92ea76f,
    style: $3e9f254466cab707$var$emptyObject,
    tabIndex: 0,
    rowDirection: 'ltr'
});
function $3e9f254466cab707$var$identity(value) {
    return value;
}
function $3e9f254466cab707$var$noop() {}
/*:: type KeyMapper = (index: number) => mixed;*/ /*:: export type CellMeasurerCache = {
  defaultHeight: number,
  defaultWidth: number,
  getHeight: (index: number) => number,
  getWidth: (index: number) => number,
};*/ /*:: type CellRenderer = (params: {|
  index: number,
  isScrolling: boolean,
  key: mixed,
  parent: mixed,
  style: mixed,
|}) => mixed;*/ /*:: type OnCellsRenderedCallback = (params: {|
  startIndex: number,
  stopIndex: number,
|}) => void;*/ /*:: type OnScrollCallback = (params: {|
  clientHeight: number,
  scrollHeight: number,
  scrollTop: number,
|}) => void;*/ /*:: type Position = {
  left: number,
  top: number,
};*/ (0, $c8a186e1757974bb$export$cea1c58a6db52bca)($3e9f254466cab707$var$Masonry);
var $3e9f254466cab707$export$2e2bcd8739ae039 /*:: export type Positioner = (index: number) => Position;*/  = $3e9f254466cab707$var$Masonry;


var $8f208c89a2c09c1b$export$2e2bcd8739ae039 = (0, $3e9f254466cab707$export$2e2bcd8739ae039);



var $3p9rK = parcelRequire("3p9rK");









var $acw62 = parcelRequire("acw62");





/*:: type CellMeasurerCacheDecoratorParams = {
  cellMeasurerCache: CellMeasurerCache,
  columnIndexOffset: number,
  rowIndexOffset: number,
};*/ /*:: type IndexParam = {
  index: number,
};*/ /**
 * Caches measurements for a given cell.
 */ var $2bd0d7c3b1ac5eff$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function CellMeasurerCacheDecorator() {
        var _this = this;
        var params /*: CellMeasurerCacheDecoratorParams*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, CellMeasurerCacheDecorator);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_cellMeasurerCache", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_columnIndexOffset", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "_rowIndexOffset", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "columnWidth", function(_ref /*:: */ ) {
            var index = _ref /*:: */ .index;
            _this._cellMeasurerCache.columnWidth({
                index: index + _this._columnIndexOffset
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "rowHeight", function(_ref2 /*:: */ ) {
            var index = _ref2 /*:: */ .index;
            _this._cellMeasurerCache.rowHeight({
                index: index + _this._rowIndexOffset
            });
        });
        var cellMeasurerCache = params.cellMeasurerCache, _params$columnIndexOf = params.columnIndexOffset, columnIndexOffset = _params$columnIndexOf === void 0 ? 0 : _params$columnIndexOf, _params$rowIndexOffse = params.rowIndexOffset, rowIndexOffset = _params$rowIndexOffse === void 0 ? 0 : _params$rowIndexOffse;
        this._cellMeasurerCache = cellMeasurerCache;
        this._columnIndexOffset = columnIndexOffset;
        this._rowIndexOffset = rowIndexOffset;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(CellMeasurerCacheDecorator, [
        {
            key: "clear",
            value: function clear(rowIndex /*: number*/ , columnIndex /*: number*/ ) /*: void*/ {
                this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
            }
        },
        {
            key: "clearAll",
            value: function clearAll() /*: void*/ {
                this._cellMeasurerCache.clearAll();
            }
        },
        {
            key: "defaultHeight",
            get: function get() /*: number*/ {
                return this._cellMeasurerCache.defaultHeight;
            }
        },
        {
            key: "defaultWidth",
            get: function get() /*: number*/ {
                return this._cellMeasurerCache.defaultWidth;
            }
        },
        {
            key: "hasFixedHeight",
            value: function hasFixedHeight() /*: boolean*/ {
                return this._cellMeasurerCache.hasFixedHeight();
            }
        },
        {
            key: "hasFixedWidth",
            value: function hasFixedWidth() /*: boolean*/ {
                return this._cellMeasurerCache.hasFixedWidth();
            }
        },
        {
            key: "getHeight",
            value: function getHeight(rowIndex /*: number*/ ) /*: ?number*/ {
                var columnIndex /*: ?number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
            }
        },
        {
            key: "getWidth",
            value: function getWidth(rowIndex /*: number*/ ) /*: ?number*/ {
                var columnIndex /*: ?number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
            }
        },
        {
            key: "has",
            value: function has(rowIndex /*: number*/ ) /*: boolean*/ {
                var columnIndex /*: ?number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
            }
        },
        {
            key: "set",
            value: function set(rowIndex /*: number*/ , columnIndex /*: number*/ , width /*: number*/ , height /*: number*/ ) /*: void*/ {
                this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width /*: number*/ , height /*: number*/ );
            }
        }
    ]);
}();



var $f191273bb207b1ad$var$_excluded = [
    "rowIndex"
], $f191273bb207b1ad$var$_excluded2 = [
    "columnIndex",
    "rowIndex"
], $f191273bb207b1ad$var$_excluded3 = [
    "columnIndex"
], $f191273bb207b1ad$var$_excluded4 = [
    "onScroll",
    "onSectionRendered",
    "onScrollbarPresenceChange",
    "scrollLeft",
    "scrollToColumn",
    "scrollTop",
    "scrollToRow"
];
function $f191273bb207b1ad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f191273bb207b1ad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f191273bb207b1ad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f191273bb207b1ad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f191273bb207b1ad$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $f191273bb207b1ad$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $f191273bb207b1ad$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f191273bb207b1ad$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f191273bb207b1ad$var$SCROLLBAR_SIZE_BUFFER = 20;
/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */ var $f191273bb207b1ad$var$MultiGrid = /*#__PURE__*/ function(_React$PureComponent) {
    function MultiGrid(props, context) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, MultiGrid);
        _this = $f191273bb207b1ad$var$_callSuper(this, MultiGrid, [
            props,
            context
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "state", {
            scrollLeft: 0,
            scrollTop: 0,
            scrollbarSize: 0,
            showHorizontalScrollbar: false,
            showVerticalScrollbar: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_deferredInvalidateColumnIndex", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_deferredInvalidateRowIndex", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_bottomLeftGridRef", function(ref) {
            _this._bottomLeftGrid = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_bottomRightGridRef", function(ref) {
            _this._bottomRightGrid = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_cellRendererBottomLeftGrid", function(_ref) {
            var rowIndex = _ref.rowIndex, rest = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_ref, $f191273bb207b1ad$var$_excluded);
            var _this$props = _this.props, cellRenderer = _this$props.cellRenderer, fixedRowCount = _this$props.fixedRowCount, rowCount = _this$props.rowCount;
            if (rowIndex === rowCount - fixedRowCount) return /*#__PURE__*/ $acw62.createElement("div", {
                key: rest.key,
                style: $f191273bb207b1ad$var$_objectSpread($f191273bb207b1ad$var$_objectSpread({}, rest.style), {}, {
                    height: $f191273bb207b1ad$var$SCROLLBAR_SIZE_BUFFER
                })
            });
            else return cellRenderer($f191273bb207b1ad$var$_objectSpread($f191273bb207b1ad$var$_objectSpread({}, rest), {}, {
                parent: _this,
                rowIndex: rowIndex + fixedRowCount
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_cellRendererBottomRightGrid", function(_ref2) {
            var columnIndex = _ref2.columnIndex, rowIndex = _ref2.rowIndex, rest = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_ref2, $f191273bb207b1ad$var$_excluded2);
            var _this$props2 = _this.props, cellRenderer = _this$props2.cellRenderer, fixedColumnCount = _this$props2.fixedColumnCount, fixedRowCount = _this$props2.fixedRowCount;
            return cellRenderer($f191273bb207b1ad$var$_objectSpread($f191273bb207b1ad$var$_objectSpread({}, rest), {}, {
                columnIndex: columnIndex + fixedColumnCount,
                parent: _this,
                rowIndex: rowIndex + fixedRowCount
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_cellRendererTopRightGrid", function(_ref3) {
            var columnIndex = _ref3.columnIndex, rest = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_ref3, $f191273bb207b1ad$var$_excluded3);
            var _this$props3 = _this.props, cellRenderer = _this$props3.cellRenderer, columnCount = _this$props3.columnCount, fixedColumnCount = _this$props3.fixedColumnCount;
            if (columnIndex === columnCount - fixedColumnCount) return /*#__PURE__*/ $acw62.createElement("div", {
                key: rest.key,
                style: $f191273bb207b1ad$var$_objectSpread($f191273bb207b1ad$var$_objectSpread({}, rest.style), {}, {
                    width: $f191273bb207b1ad$var$SCROLLBAR_SIZE_BUFFER
                })
            });
            else return cellRenderer($f191273bb207b1ad$var$_objectSpread($f191273bb207b1ad$var$_objectSpread({}, rest), {}, {
                columnIndex: columnIndex + fixedColumnCount,
                parent: _this
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_columnWidthRightGrid", function(_ref4) {
            var index = _ref4.index;
            var _this$props4 = _this.props, columnCount = _this$props4.columnCount, fixedColumnCount = _this$props4.fixedColumnCount, columnWidth = _this$props4.columnWidth;
            var _this$state = _this.state, scrollbarSize = _this$state.scrollbarSize, showHorizontalScrollbar = _this$state.showHorizontalScrollbar;
            // An extra cell is added to the count
            // This gives the smaller Grid extra room for offset,
            // In case the main (bottom right) Grid has a scrollbar
            // If no scrollbar, the extra space is overflow:hidden anyway
            if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) return scrollbarSize;
            return typeof columnWidth === 'function' ? columnWidth({
                index: index + fixedColumnCount
            }) : columnWidth;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onScroll", function(scrollInfo) {
            var scrollLeft = scrollInfo.scrollLeft, scrollTop = scrollInfo.scrollTop;
            _this.setState({
                scrollLeft: scrollLeft,
                scrollTop: scrollTop
            });
            var onScroll = _this.props.onScroll;
            if (onScroll) onScroll(scrollInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onScrollbarPresenceChange", function(_ref5) {
            var horizontal = _ref5.horizontal, size = _ref5.size, vertical = _ref5.vertical;
            var _this$state2 = _this.state, showHorizontalScrollbar = _this$state2.showHorizontalScrollbar, showVerticalScrollbar = _this$state2.showVerticalScrollbar;
            if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
                _this.setState({
                    scrollbarSize: size,
                    showHorizontalScrollbar: horizontal,
                    showVerticalScrollbar: vertical
                });
                var onScrollbarPresenceChange = _this.props.onScrollbarPresenceChange;
                if (typeof onScrollbarPresenceChange === 'function') onScrollbarPresenceChange({
                    horizontal: horizontal,
                    size: size,
                    vertical: vertical
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onScrollLeft", function(scrollInfo) {
            var scrollLeft = scrollInfo.scrollLeft;
            _this._onScroll({
                scrollLeft: scrollLeft,
                scrollTop: _this.state.scrollTop
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onScrollTop", function(scrollInfo) {
            var scrollTop = scrollInfo.scrollTop;
            _this._onScroll({
                scrollTop: scrollTop,
                scrollLeft: _this.state.scrollLeft
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_rowHeightBottomGrid", function(_ref6) {
            var index = _ref6.index;
            var _this$props5 = _this.props, fixedRowCount = _this$props5.fixedRowCount, rowCount = _this$props5.rowCount, rowHeight = _this$props5.rowHeight;
            var _this$state3 = _this.state, scrollbarSize = _this$state3.scrollbarSize, showVerticalScrollbar = _this$state3.showVerticalScrollbar;
            // An extra cell is added to the count
            // This gives the smaller Grid extra room for offset,
            // In case the main (bottom right) Grid has a scrollbar
            // If no scrollbar, the extra space is overflow:hidden anyway
            if (showVerticalScrollbar && index === rowCount - fixedRowCount) return scrollbarSize;
            return typeof rowHeight === 'function' ? rowHeight({
                index: index + fixedRowCount
            }) : rowHeight;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_topLeftGridRef", function(ref) {
            _this._topLeftGrid = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_topRightGridRef", function(ref) {
            _this._topRightGrid = ref;
        });
        var deferredMeasurementCache = props.deferredMeasurementCache, _fixedColumnCount = props.fixedColumnCount, _fixedRowCount = props.fixedRowCount;
        _this._maybeCalculateCachedStyles(true);
        if (deferredMeasurementCache) {
            _this._deferredMeasurementCacheBottomLeftGrid = _fixedRowCount > 0 ? new (0, $2bd0d7c3b1ac5eff$export$2e2bcd8739ae039)({
                cellMeasurerCache: deferredMeasurementCache,
                columnIndexOffset: 0,
                rowIndexOffset: _fixedRowCount
            }) : deferredMeasurementCache;
            _this._deferredMeasurementCacheBottomRightGrid = _fixedColumnCount > 0 || _fixedRowCount > 0 ? new (0, $2bd0d7c3b1ac5eff$export$2e2bcd8739ae039)({
                cellMeasurerCache: deferredMeasurementCache,
                columnIndexOffset: _fixedColumnCount,
                rowIndexOffset: _fixedRowCount
            }) : deferredMeasurementCache;
            _this._deferredMeasurementCacheTopRightGrid = _fixedColumnCount > 0 ? new (0, $2bd0d7c3b1ac5eff$export$2e2bcd8739ae039)({
                cellMeasurerCache: deferredMeasurementCache,
                columnIndexOffset: _fixedColumnCount,
                rowIndexOffset: 0
            }) : deferredMeasurementCache;
        }
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(MultiGrid, _React$PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(MultiGrid, [
        {
            key: "forceUpdateGrids",
            value: function forceUpdateGrids() {
                this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
                this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
                this._topLeftGrid && this._topLeftGrid.forceUpdate();
                this._topRightGrid && this._topRightGrid.forceUpdate();
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender() {
                var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$columnIndex = _ref7.columnIndex, columnIndex = _ref7$columnIndex === void 0 ? 0 : _ref7$columnIndex, _ref7$rowIndex = _ref7.rowIndex, rowIndex = _ref7$rowIndex === void 0 ? 0 : _ref7$rowIndex;
                this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
                this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
            }
        },
        {
            key: "measureAllCells",
            value: function measureAllCells() {
                this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
                this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
                this._topLeftGrid && this._topLeftGrid.measureAllCells();
                this._topRightGrid && this._topRightGrid.measureAllCells();
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref8$columnIndex = _ref8.columnIndex, columnIndex = _ref8$columnIndex === void 0 ? 0 : _ref8$columnIndex, _ref8$rowIndex = _ref8.rowIndex, rowIndex = _ref8$rowIndex === void 0 ? 0 : _ref8$rowIndex;
                var _this$props6 = this.props, fixedColumnCount = _this$props6.fixedColumnCount, fixedRowCount = _this$props6.fixedRowCount;
                var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
                var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);
                this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: adjustedRowIndex
                });
                this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
                    columnIndex: adjustedColumnIndex,
                    rowIndex: adjustedRowIndex
                });
                this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: rowIndex
                });
                this._topRightGrid && this._topRightGrid.recomputeGridSize({
                    columnIndex: adjustedColumnIndex,
                    rowIndex: rowIndex
                });
                this._leftGridWidth = null;
                this._topGridHeight = null;
                this._maybeCalculateCachedStyles(true);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props7 = this.props, scrollLeft = _this$props7.scrollLeft, scrollTop = _this$props7.scrollTop;
                if (scrollLeft > 0 || scrollTop > 0) {
                    var newState = {};
                    if (scrollLeft > 0) newState.scrollLeft = scrollLeft;
                    if (scrollTop > 0) newState.scrollTop = scrollTop;
                    this.setState(newState);
                }
                this._handleInvalidatedGridSize();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this._handleInvalidatedGridSize();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props8 = this.props, onScroll = _this$props8.onScroll, onSectionRendered = _this$props8.onSectionRendered, onScrollbarPresenceChange = _this$props8.onScrollbarPresenceChange, scrollLeftProp = _this$props8.scrollLeft, scrollToColumn = _this$props8.scrollToColumn, scrollTopProp = _this$props8.scrollTop, scrollToRow = _this$props8.scrollToRow, rest = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_this$props8, $f191273bb207b1ad$var$_excluded4);
                this._prepareForRender();
                // Don't render any of our Grids if there are no cells.
                // This mirrors what Grid does,
                // And prevents us from recording inaccurage measurements when used with CellMeasurer.
                if (this.props.width === 0 || this.props.height === 0) return null;
                // scrollTop and scrollLeft props are explicitly filtered out and ignored
                var _this$state4 = this.state, scrollLeft = _this$state4.scrollLeft, scrollTop = _this$state4.scrollTop;
                return /*#__PURE__*/ $acw62.createElement("div", {
                    style: this._containerOuterStyle
                }, /*#__PURE__*/ $acw62.createElement("div", {
                    style: this._containerTopStyle
                }, this._renderTopLeftGrid(rest), this._renderTopRightGrid($f191273bb207b1ad$var$_objectSpread($f191273bb207b1ad$var$_objectSpread({}, rest), {}, {
                    onScroll: onScroll,
                    scrollLeft: scrollLeft
                }))), /*#__PURE__*/ $acw62.createElement("div", {
                    style: this._containerBottomStyle
                }, this._renderBottomLeftGrid($f191273bb207b1ad$var$_objectSpread($f191273bb207b1ad$var$_objectSpread({}, rest), {}, {
                    onScroll: onScroll,
                    scrollTop: scrollTop
                })), this._renderBottomRightGrid($f191273bb207b1ad$var$_objectSpread($f191273bb207b1ad$var$_objectSpread({}, rest), {}, {
                    onScroll: onScroll,
                    onSectionRendered: onSectionRendered,
                    scrollLeft: scrollLeft,
                    scrollToColumn: scrollToColumn,
                    scrollToRow: scrollToRow,
                    scrollTop: scrollTop
                }))));
            }
        },
        {
            key: "_getBottomGridHeight",
            value: function _getBottomGridHeight(props) {
                var height = props.height;
                var topGridHeight = this._getTopGridHeight(props);
                return height - topGridHeight;
            }
        },
        {
            key: "_getLeftGridWidth",
            value: function _getLeftGridWidth(props) {
                var fixedColumnCount = props.fixedColumnCount, columnWidth = props.columnWidth;
                if (this._leftGridWidth == null) {
                    if (typeof columnWidth === 'function') {
                        var leftGridWidth = 0;
                        for(var index = 0; index < fixedColumnCount; index++)leftGridWidth += columnWidth({
                            index: index
                        });
                        this._leftGridWidth = leftGridWidth;
                    } else this._leftGridWidth = columnWidth * fixedColumnCount;
                }
                return this._leftGridWidth;
            }
        },
        {
            key: "_getRightGridWidth",
            value: function _getRightGridWidth(props) {
                var width = props.width;
                var leftGridWidth = this._getLeftGridWidth(props);
                return width - leftGridWidth;
            }
        },
        {
            key: "_getTopGridHeight",
            value: function _getTopGridHeight(props) {
                var fixedRowCount = props.fixedRowCount, rowHeight = props.rowHeight;
                if (this._topGridHeight == null) {
                    if (typeof rowHeight === 'function') {
                        var topGridHeight = 0;
                        for(var index = 0; index < fixedRowCount; index++)topGridHeight += rowHeight({
                            index: index
                        });
                        this._topGridHeight = topGridHeight;
                    } else this._topGridHeight = rowHeight * fixedRowCount;
                }
                return this._topGridHeight;
            }
        },
        {
            key: "_handleInvalidatedGridSize",
            value: function _handleInvalidatedGridSize() {
                if (typeof this._deferredInvalidateColumnIndex === 'number') {
                    var columnIndex = this._deferredInvalidateColumnIndex;
                    var rowIndex = this._deferredInvalidateRowIndex;
                    this._deferredInvalidateColumnIndex = null;
                    this._deferredInvalidateRowIndex = null;
                    this.recomputeGridSize({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                    this.forceUpdate();
                }
            }
        },
        {
            key: "_maybeCalculateCachedStyles",
            value: function _maybeCalculateCachedStyles(resetAll) {
                var _this$props9 = this.props, columnWidth = _this$props9.columnWidth, enableFixedColumnScroll = _this$props9.enableFixedColumnScroll, enableFixedRowScroll = _this$props9.enableFixedRowScroll, height = _this$props9.height, fixedColumnCount = _this$props9.fixedColumnCount, fixedRowCount = _this$props9.fixedRowCount, rowHeight = _this$props9.rowHeight, style = _this$props9.style, styleBottomLeftGrid = _this$props9.styleBottomLeftGrid, styleBottomRightGrid = _this$props9.styleBottomRightGrid, styleTopLeftGrid = _this$props9.styleTopLeftGrid, styleTopRightGrid = _this$props9.styleTopRightGrid, width = _this$props9.width;
                var sizeChange = resetAll || height !== this._lastRenderedHeight || width !== this._lastRenderedWidth;
                var leftSizeChange = resetAll || columnWidth !== this._lastRenderedColumnWidth || fixedColumnCount !== this._lastRenderedFixedColumnCount;
                var topSizeChange = resetAll || fixedRowCount !== this._lastRenderedFixedRowCount || rowHeight !== this._lastRenderedRowHeight;
                if (resetAll || sizeChange || style !== this._lastRenderedStyle) this._containerOuterStyle = $f191273bb207b1ad$var$_objectSpread({
                    height: height,
                    overflow: 'visible',
                    // Let :focus outline show through
                    width: width
                }, style);
                if (resetAll || sizeChange || topSizeChange) {
                    this._containerTopStyle = {
                        height: this._getTopGridHeight(this.props),
                        position: 'relative',
                        width: width
                    };
                    this._containerBottomStyle = {
                        height: height - this._getTopGridHeight(this.props),
                        overflow: 'visible',
                        // Let :focus outline show through
                        position: 'relative',
                        width: width
                    };
                }
                if (resetAll || styleBottomLeftGrid !== this._lastRenderedStyleBottomLeftGrid) this._bottomLeftGridStyle = $f191273bb207b1ad$var$_objectSpread({
                    left: 0,
                    overflowX: 'hidden',
                    overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
                    position: 'absolute'
                }, styleBottomLeftGrid);
                if (resetAll || leftSizeChange || styleBottomRightGrid !== this._lastRenderedStyleBottomRightGrid) this._bottomRightGridStyle = $f191273bb207b1ad$var$_objectSpread({
                    left: this._getLeftGridWidth(this.props),
                    position: 'absolute'
                }, styleBottomRightGrid);
                if (resetAll || styleTopLeftGrid !== this._lastRenderedStyleTopLeftGrid) this._topLeftGridStyle = $f191273bb207b1ad$var$_objectSpread({
                    left: 0,
                    overflowX: 'hidden',
                    overflowY: 'hidden',
                    position: 'absolute',
                    top: 0
                }, styleTopLeftGrid);
                if (resetAll || leftSizeChange || styleTopRightGrid !== this._lastRenderedStyleTopRightGrid) this._topRightGridStyle = $f191273bb207b1ad$var$_objectSpread({
                    left: this._getLeftGridWidth(this.props),
                    overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
                    overflowY: 'hidden',
                    position: 'absolute',
                    top: 0
                }, styleTopRightGrid);
                this._lastRenderedColumnWidth = columnWidth;
                this._lastRenderedFixedColumnCount = fixedColumnCount;
                this._lastRenderedFixedRowCount = fixedRowCount;
                this._lastRenderedHeight = height;
                this._lastRenderedRowHeight = rowHeight;
                this._lastRenderedStyle = style;
                this._lastRenderedStyleBottomLeftGrid = styleBottomLeftGrid;
                this._lastRenderedStyleBottomRightGrid = styleBottomRightGrid;
                this._lastRenderedStyleTopLeftGrid = styleTopLeftGrid;
                this._lastRenderedStyleTopRightGrid = styleTopRightGrid;
                this._lastRenderedWidth = width;
            }
        },
        {
            key: "_prepareForRender",
            value: function _prepareForRender() {
                if (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) this._leftGridWidth = null;
                if (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) this._topGridHeight = null;
                this._maybeCalculateCachedStyles();
                this._lastRenderedColumnWidth = this.props.columnWidth;
                this._lastRenderedFixedColumnCount = this.props.fixedColumnCount;
                this._lastRenderedFixedRowCount = this.props.fixedRowCount;
                this._lastRenderedRowHeight = this.props.rowHeight;
            }
        },
        {
            key: "_renderBottomLeftGrid",
            value: function _renderBottomLeftGrid(props) {
                var enableFixedColumnScroll = props.enableFixedColumnScroll, fixedColumnCount = props.fixedColumnCount, fixedRowCount = props.fixedRowCount, rowCount = props.rowCount, hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar;
                var showVerticalScrollbar = this.state.showVerticalScrollbar;
                if (!fixedColumnCount) return null;
                var additionalRowCount = showVerticalScrollbar ? 1 : 0, height = this._getBottomGridHeight(props), width = this._getLeftGridWidth(props), scrollbarSize = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0, gridWidth = hideBottomLeftGridScrollbar ? width + scrollbarSize : width;
                var bottomLeftGrid = /*#__PURE__*/ $acw62.createElement((0, $dddee09ada2ab319$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                    cellRenderer: this._cellRendererBottomLeftGrid,
                    className: this.props.classNameBottomLeftGrid,
                    columnCount: fixedColumnCount,
                    deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
                    height: height,
                    onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
                    ref: this._bottomLeftGridRef,
                    rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
                    rowHeight: this._rowHeightBottomGrid,
                    style: this._bottomLeftGridStyle,
                    tabIndex: null,
                    width: gridWidth
                }));
                if (hideBottomLeftGridScrollbar) return /*#__PURE__*/ $acw62.createElement("div", {
                    className: "BottomLeftGrid_ScrollWrapper",
                    style: $f191273bb207b1ad$var$_objectSpread($f191273bb207b1ad$var$_objectSpread({}, this._bottomLeftGridStyle), {}, {
                        height: height,
                        width: width,
                        overflowY: 'hidden'
                    })
                }, bottomLeftGrid);
                return bottomLeftGrid;
            }
        },
        {
            key: "_renderBottomRightGrid",
            value: function _renderBottomRightGrid(props) {
                var columnCount = props.columnCount, fixedColumnCount = props.fixedColumnCount, fixedRowCount = props.fixedRowCount, rowCount = props.rowCount, scrollToColumn = props.scrollToColumn, scrollToRow = props.scrollToRow;
                return /*#__PURE__*/ $acw62.createElement((0, $dddee09ada2ab319$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                    cellRenderer: this._cellRendererBottomRightGrid,
                    className: this.props.classNameBottomRightGrid,
                    columnCount: Math.max(0, columnCount - fixedColumnCount),
                    columnWidth: this._columnWidthRightGrid,
                    deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
                    height: this._getBottomGridHeight(props),
                    onScroll: this._onScroll,
                    onScrollbarPresenceChange: this._onScrollbarPresenceChange,
                    ref: this._bottomRightGridRef,
                    rowCount: Math.max(0, rowCount - fixedRowCount),
                    rowHeight: this._rowHeightBottomGrid,
                    scrollToColumn: scrollToColumn - fixedColumnCount,
                    scrollToRow: scrollToRow - fixedRowCount,
                    style: this._bottomRightGridStyle,
                    width: this._getRightGridWidth(props)
                }));
            }
        },
        {
            key: "_renderTopLeftGrid",
            value: function _renderTopLeftGrid(props) {
                var fixedColumnCount = props.fixedColumnCount, fixedRowCount = props.fixedRowCount;
                if (!fixedColumnCount || !fixedRowCount) return null;
                return /*#__PURE__*/ $acw62.createElement((0, $dddee09ada2ab319$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                    className: this.props.classNameTopLeftGrid,
                    columnCount: fixedColumnCount,
                    height: this._getTopGridHeight(props),
                    ref: this._topLeftGridRef,
                    rowCount: fixedRowCount,
                    style: this._topLeftGridStyle,
                    tabIndex: null,
                    width: this._getLeftGridWidth(props)
                }));
            }
        },
        {
            key: "_renderTopRightGrid",
            value: function _renderTopRightGrid(props) {
                var columnCount = props.columnCount, enableFixedRowScroll = props.enableFixedRowScroll, fixedColumnCount = props.fixedColumnCount, fixedRowCount = props.fixedRowCount, scrollLeft = props.scrollLeft, hideTopRightGridScrollbar = props.hideTopRightGridScrollbar;
                var _this$state5 = this.state, showHorizontalScrollbar = _this$state5.showHorizontalScrollbar, scrollbarSize = _this$state5.scrollbarSize;
                if (!fixedRowCount) return null;
                var additionalColumnCount = showHorizontalScrollbar ? 1 : 0, height = this._getTopGridHeight(props), width = this._getRightGridWidth(props), additionalHeight = showHorizontalScrollbar ? scrollbarSize : 0;
                var gridHeight = height, style = this._topRightGridStyle;
                if (hideTopRightGridScrollbar) {
                    gridHeight = height + additionalHeight;
                    style = $f191273bb207b1ad$var$_objectSpread($f191273bb207b1ad$var$_objectSpread({}, this._topRightGridStyle), {}, {
                        left: 0
                    });
                }
                var topRightGrid = /*#__PURE__*/ $acw62.createElement((0, $dddee09ada2ab319$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                    cellRenderer: this._cellRendererTopRightGrid,
                    className: this.props.classNameTopRightGrid,
                    columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
                    columnWidth: this._columnWidthRightGrid,
                    deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
                    height: gridHeight,
                    onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
                    ref: this._topRightGridRef,
                    rowCount: fixedRowCount,
                    scrollLeft: scrollLeft,
                    style: style,
                    tabIndex: null,
                    width: width
                }));
                if (hideTopRightGridScrollbar) return /*#__PURE__*/ $acw62.createElement("div", {
                    className: "TopRightGrid_ScrollWrapper",
                    style: $f191273bb207b1ad$var$_objectSpread($f191273bb207b1ad$var$_objectSpread({}, this._topRightGridStyle), {}, {
                        height: height,
                        width: width,
                        overflowX: 'hidden'
                    })
                }, topRightGrid);
                return topRightGrid;
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) return {
                    scrollLeft: nextProps.scrollLeft != null && nextProps.scrollLeft >= 0 ? nextProps.scrollLeft : prevState.scrollLeft,
                    scrollTop: nextProps.scrollTop != null && nextProps.scrollTop >= 0 ? nextProps.scrollTop : prevState.scrollTop
                };
                return null;
            }
        }
    ]);
}($acw62.PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))($f191273bb207b1ad$var$MultiGrid, "defaultProps", {
    classNameBottomLeftGrid: '',
    classNameBottomRightGrid: '',
    classNameTopLeftGrid: '',
    classNameTopRightGrid: '',
    enableFixedColumnScroll: false,
    enableFixedRowScroll: false,
    fixedColumnCount: 0,
    fixedRowCount: 0,
    scrollToColumn: -1,
    scrollToRow: -1,
    style: {},
    styleBottomLeftGrid: {},
    styleBottomRightGrid: {},
    styleTopLeftGrid: {},
    styleTopRightGrid: {},
    hideTopRightGridScrollbar: false,
    hideBottomLeftGridScrollbar: false
});
$f191273bb207b1ad$var$MultiGrid.propTypes = {};
(0, $c8a186e1757974bb$export$cea1c58a6db52bca)($f191273bb207b1ad$var$MultiGrid);
var $f191273bb207b1ad$export$2e2bcd8739ae039 = $f191273bb207b1ad$var$MultiGrid;


var $7912dd84c61f1726$export$2e2bcd8739ae039 = (0, $f191273bb207b1ad$export$2e2bcd8739ae039);









var $acw62 = parcelRequire("acw62");
function $2d0c811067011550$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $2d0c811067011550$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $2d0c811067011550$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2d0c811067011550$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */ var $2d0c811067011550$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    function ScrollSync(props, context) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ScrollSync);
        _this = $2d0c811067011550$var$_callSuper(this, ScrollSync, [
            props,
            context
        ]);
        _this.state = {
            clientHeight: 0,
            clientWidth: 0,
            scrollHeight: 0,
            scrollLeft: 0,
            scrollTop: 0,
            scrollWidth: 0
        };
        _this._onScroll = _this._onScroll.bind(_this);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(ScrollSync, _React$PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(ScrollSync, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                var _this$state = this.state, clientHeight = _this$state.clientHeight, clientWidth = _this$state.clientWidth, scrollHeight = _this$state.scrollHeight, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop, scrollWidth = _this$state.scrollWidth;
                return children({
                    clientHeight: clientHeight,
                    clientWidth: clientWidth,
                    onScroll: this._onScroll,
                    scrollHeight: scrollHeight,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollWidth: scrollWidth
                });
            }
        },
        {
            key: "_onScroll",
            value: function _onScroll(_ref) {
                var clientHeight = _ref.clientHeight, clientWidth = _ref.clientWidth, scrollHeight = _ref.scrollHeight, scrollLeft = _ref.scrollLeft, scrollTop = _ref.scrollTop, scrollWidth = _ref.scrollWidth;
                this.setState({
                    clientHeight: clientHeight,
                    clientWidth: clientWidth,
                    scrollHeight: scrollHeight,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollWidth: scrollWidth
                });
            }
        }
    ]);
}($acw62.PureComponent);
$2d0c811067011550$export$2e2bcd8739ae039.propTypes = {};


var $3aa53fffba03843f$export$2e2bcd8739ae039 = (0, $2d0c811067011550$export$2e2bcd8739ae039);


/*:: type SortDirection = 'ASC' | 'DESC';*/ /*:: type SortParams = {
  defaultSortDirection: SortDirection,
  event: MouseEvent,
  sortBy: string,
};*/ /*:: type SortDirectionMap = {[string]: SortDirection};*/ /*:: type MultiSortOptions = {
  defaultSortBy: ?Array<string>,
  defaultSortDirection: ?SortDirectionMap,
};*/ /*:: type MultiSortReturn = {
  /**
   * Sort property to be passed to the `Table` component.
   * This function updates `sortBy` and `sortDirection` values.
   *-/
  sort: (params: SortParams) => void,

  /**
   * Specifies the fields currently responsible for sorting data,
   * In order of importance.
   *-/
  sortBy: Array<string>,

  /**
   * Specifies the direction a specific field is being sorted in.
   *-/
  sortDirection: SortDirectionMap,
};*/ function $56f1b6bb70106de6$export$2e2bcd8739ae039(sortCallback /*: Function*/ ) /*: MultiSortReturn*/ {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, defaultSortBy = _ref.defaultSortBy, _ref$defaultSortDirec = _ref.defaultSortDirection, defaultSortDirection = _ref$defaultSortDirec === void 0 ? {} : _ref$defaultSortDirec;
    if (!sortCallback) throw Error("Required parameter \"sortCallback\" not specified");
    var sortBy = defaultSortBy || [];
    var sortDirection = {};
    sortBy.forEach(function(dataKey) {
        sortDirection[dataKey] = defaultSortDirection[dataKey] !== undefined ? defaultSortDirection[dataKey] : 'ASC';
    });
    function sort(_ref2 /*:: */ ) /*: void*/ {
        var defaultSortDirection = _ref2 /*:: */ .defaultSortDirection, event = _ref2 /*:: */ .event, dataKey = _ref2 /*:: */ .sortBy;
        if (event.shiftKey) {
            // Shift + click appends a column to existing criteria
            if (sortDirection[dataKey] !== undefined) sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
            else {
                sortDirection[dataKey] = defaultSortDirection;
                sortBy.push(dataKey);
            }
        } else if (event.ctrlKey || event.metaKey) {
            // Control + click removes column from sort (if pressent)
            var index = sortBy.indexOf(dataKey);
            if (index >= 0) {
                sortBy.splice(index, 1);
                delete sortDirection[dataKey];
            }
        } else {
            // Clear sortBy array of all non-selected keys
            sortBy.length = 0;
            sortBy.push(dataKey);
            // Clear sortDirection object of all non-selected keys
            var sortDirectionKeys = Object.keys(sortDirection);
            sortDirectionKeys.forEach(function(key) {
                if (key !== dataKey) delete sortDirection[key];
            });
            // If key is already selected, reverse sort direction.
            // Else, set sort direction to default direction.
            if (sortDirection[dataKey] !== undefined) sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
            else sortDirection[dataKey] = defaultSortDirection;
        }
        // Notify application code
        sortCallback({
            sortBy: sortBy,
            sortDirection: sortDirection
        });
    }
    return {
        sort: sort,
        sortBy: sortBy,
        sortDirection: sortDirection
    };
}


/*:: import type {CellDataGetterParams} from './types';*/ /**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */ function $c229ecefa5c3dbbe$export$2e2bcd8739ae039(_ref /*:: */ ) {
    var dataKey = _ref /*:: */ .dataKey, rowData = _ref /*:: */ .rowData;
    if (typeof rowData.get === 'function') return rowData.get(dataKey);
    else return rowData[dataKey];
}


/*:: import type {CellRendererParams} from './types';*/ /**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */ function $e29c867f03913bf5$export$2e2bcd8739ae039(_ref /*:: */ ) /*: string*/ {
    var cellData = _ref /*:: */ .cellData;
    if (cellData == null) return '';
    else return String(cellData);
}



var $acw62 = parcelRequire("acw62");
function $4074583ab64171e9$export$2e2bcd8739ae039(_ref /*:: */ ) {
    var className = _ref /*:: */ .className, columns = _ref /*:: */ .columns, style = _ref /*:: */ .style;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: className,
        role: "row",
        style: style
    }, columns);
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
var $7c4be1f06aae7753$var$SortDirection = {
    /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */ ASC: 'ASC',
    /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */ DESC: 'DESC'
};
var $7c4be1f06aae7753$export$2e2bcd8739ae039 = $7c4be1f06aae7753$var$SortDirection;


function $cb1d9e09cbcf7c66$export$2e2bcd8739ae039(_ref) {
    var sortDirection = _ref.sortDirection;
    var classNames = (0, $15e8569690cae660$export$2e2bcd8739ae039)('ReactVirtualized__Table__sortableHeaderIcon', {
        'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === (0, $7c4be1f06aae7753$export$2e2bcd8739ae039).ASC,
        'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === (0, $7c4be1f06aae7753$export$2e2bcd8739ae039).DESC
    });
    return /*#__PURE__*/ $acw62.createElement("svg", {
        className: classNames,
        width: 18,
        height: 18,
        viewBox: "0 0 24 24"
    }, sortDirection === (0, $7c4be1f06aae7753$export$2e2bcd8739ae039).ASC ? /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7 14l5-5 5 5z"
    }) : /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7 10l5 5 5-5z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }));
}
$cb1d9e09cbcf7c66$export$2e2bcd8739ae039.propTypes = {};


function $a7aea6ed7b1b2b3b$export$2e2bcd8739ae039(_ref /*:: */ ) {
    var dataKey = _ref /*:: */ .dataKey, label = _ref /*:: */ .label, sortBy = _ref /*:: */ .sortBy, sortDirection = _ref /*:: */ .sortDirection;
    var showSortIndicator = sortBy === dataKey;
    var children = [
        /*#__PURE__*/ $acw62.createElement("span", {
            className: "ReactVirtualized__Table__headerTruncatedText",
            key: "label",
            title: typeof label === 'string' ? label : null
        }, label)
    ];
    if (showSortIndicator) children.push(/*#__PURE__*/ $acw62.createElement((0, $cb1d9e09cbcf7c66$export$2e2bcd8739ae039), {
        key: "SortIndicator",
        sortDirection: sortDirection
    }));
    return children;
}



var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");
function $4495a9e1dfe02ed2$export$2e2bcd8739ae039(_ref /*:: */ ) {
    var className = _ref /*:: */ .className, columns = _ref /*:: */ .columns, index = _ref /*:: */ .index, key = _ref /*:: */ .key, onRowClick = _ref /*:: */ .onRowClick, onRowDoubleClick = _ref /*:: */ .onRowDoubleClick, onRowMouseOut = _ref /*:: */ .onRowMouseOut, onRowMouseOver = _ref /*:: */ .onRowMouseOver, onRowRightClick = _ref /*:: */ .onRowRightClick, rowData = _ref /*:: */ .rowData, style = _ref /*:: */ .style;
    var a11yProps = {
        'aria-rowindex': index + 1
    };
    if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
        a11yProps['aria-label'] = 'row';
        a11yProps.tabIndex = 0;
        if (onRowClick) a11yProps.onClick = function(event) {
            return onRowClick({
                event: event,
                index: index,
                rowData: rowData
            });
        };
        if (onRowDoubleClick) a11yProps.onDoubleClick = function(event) {
            return onRowDoubleClick({
                event: event,
                index: index,
                rowData: rowData
            });
        };
        if (onRowMouseOut) a11yProps.onMouseOut = function(event) {
            return onRowMouseOut({
                event: event,
                index: index,
                rowData: rowData
            });
        };
        if (onRowMouseOver) a11yProps.onMouseOver = function(event) {
            return onRowMouseOver({
                event: event,
                index: index,
                rowData: rowData
            });
        };
        if (onRowRightClick) a11yProps.onContextMenu = function(event) {
            return onRowRightClick({
                event: event,
                index: index,
                rowData: rowData
            });
        };
    }
    return /*#__PURE__*/ $acw62.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, a11yProps, {
        className: className,
        key: key,
        role: "row",
        style: style
    }), columns);
}










var $acw62 = parcelRequire("acw62");




function $0f0ab585f610fa40$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $0f0ab585f610fa40$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $0f0ab585f610fa40$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0f0ab585f610fa40$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
/**
 * Describes the header and cell contents of a table column.
 */ var $0f0ab585f610fa40$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function Column() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Column);
        return $0f0ab585f610fa40$var$_callSuper(this, Column, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(Column, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Column);
}($acw62.Component);
(0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))($0f0ab585f610fa40$export$2e2bcd8739ae039, "defaultProps", {
    cellDataGetter: (0, $c229ecefa5c3dbbe$export$2e2bcd8739ae039),
    cellRenderer: (0, $e29c867f03913bf5$export$2e2bcd8739ae039),
    defaultSortDirection: (0, $7c4be1f06aae7753$export$2e2bcd8739ae039).ASC,
    flexGrow: 0,
    flexShrink: 1,
    headerRenderer: (0, $a7aea6ed7b1b2b3b$export$2e2bcd8739ae039),
    style: {}
});
$0f0ab585f610fa40$export$2e2bcd8739ae039.propTypes = {};





var $3p9rK = parcelRequire("3p9rK");










var $acw62 = parcelRequire("acw62");




function $fb1899bd678280c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fb1899bd678280c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fb1899bd678280c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fb1899bd678280c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fb1899bd678280c7$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $fb1899bd678280c7$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $fb1899bd678280c7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fb1899bd678280c7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */ var $fb1899bd678280c7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    function Table(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Table);
        _this = $fb1899bd678280c7$var$_callSuper(this, Table, [
            props
        ]);
        _this.state = {
            scrollbarWidth: 0
        };
        _this._createColumn = _this._createColumn.bind(_this);
        _this._createRow = _this._createRow.bind(_this);
        _this._onScroll = _this._onScroll.bind(_this);
        _this._onSectionRendered = _this._onSectionRendered.bind(_this);
        _this._setRef = _this._setRef.bind(_this);
        _this._setGridElementRef = _this._setGridElementRef.bind(_this);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(Table, _React$PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Table, [
        {
            key: "forceUpdateGrid",
            value: function forceUpdateGrid() {
                if (this.Grid) this.Grid.forceUpdate();
            }
        },
        {
            key: "getOffsetForRow",
            value: function getOffsetForRow(_ref) {
                var alignment = _ref.alignment, index = _ref.index;
                if (this.Grid) {
                    var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
                        alignment: alignment,
                        rowIndex: index
                    }), scrollTop = _this$Grid$getOffsetF.scrollTop;
                    return scrollTop;
                }
                return 0;
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref2 /*:: */ ) {
                var columnIndex = _ref2 /*:: */ .columnIndex, rowIndex = _ref2 /*:: */ .rowIndex;
                if (this.Grid) this.Grid.invalidateCellSizeAfterRender({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "measureAllRows",
            value: function measureAllRows() {
                if (this.Grid) this.Grid.measureAllCells();
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$columnIndex = _ref3.columnIndex, columnIndex = _ref3$columnIndex === void 0 ? 0 : _ref3$columnIndex, _ref3$rowIndex = _ref3.rowIndex, rowIndex = _ref3$rowIndex === void 0 ? 0 : _ref3$rowIndex;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "recomputeRowHeights",
            value: function recomputeRowHeights() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: index
                });
            }
        },
        {
            key: "scrollToPosition",
            value: function scrollToPosition() {
                var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToPosition({
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: "scrollToRow",
            value: function scrollToRow() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToCell({
                    columnIndex: 0,
                    rowIndex: index
                });
            }
        },
        {
            key: "getScrollbarWidth",
            value: function getScrollbarWidth() {
                if (this.GridElement) {
                    var _Grid = this.GridElement;
                    var clientWidth = _Grid.clientWidth || 0;
                    var offsetWidth = _Grid.offsetWidth || 0;
                    return offsetWidth - clientWidth;
                }
                return 0;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._setScrollbarWidth();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this._setScrollbarWidth();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, children = _this$props.children, className = _this$props.className, disableHeader = _this$props.disableHeader, gridClassName = _this$props.gridClassName, gridStyle = _this$props.gridStyle, headerHeight = _this$props.headerHeight, headerRowRenderer = _this$props.headerRowRenderer, height = _this$props.height, id = _this$props.id, noRowsRenderer = _this$props.noRowsRenderer, rowClassName = _this$props.rowClassName, rowStyle = _this$props.rowStyle, scrollToIndex = _this$props.scrollToIndex, style = _this$props.style, width = _this$props.width;
                var scrollbarWidth = this.state.scrollbarWidth;
                var availableRowsHeight = disableHeader ? height : height - headerHeight;
                var rowClass = typeof rowClassName === 'function' ? rowClassName({
                    index: -1
                }) : rowClassName;
                var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
                    index: -1
                }) : rowStyle;
                // Precompute and cache column styles before rendering rows and columns to speed things up
                this._cachedColumnStyles = [];
                $acw62.Children.toArray(children).forEach(function(column, index) {
                    var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style || (0, $0f0ab585f610fa40$export$2e2bcd8739ae039).defaultProps.style);
                    _this2._cachedColumnStyles[index] = $fb1899bd678280c7$var$_objectSpread({
                        overflow: 'hidden'
                    }, flexStyles);
                });
                // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
                // This is done because Grid is a pure component and won't update unless its properties or state has changed.
                // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
                return /*#__PURE__*/ $acw62.createElement("div", {
                    "aria-label": this.props['aria-label'],
                    "aria-labelledby": this.props['aria-labelledby'],
                    "aria-colcount": $acw62.Children.toArray(children).length,
                    "aria-rowcount": this.props.rowCount,
                    className: (0, $15e8569690cae660$export$2e2bcd8739ae039)('ReactVirtualized__Table', className),
                    id: id,
                    role: "grid",
                    style: style
                }, !disableHeader && headerRowRenderer({
                    className: (0, $15e8569690cae660$export$2e2bcd8739ae039)('ReactVirtualized__Table__headerRow', rowClass),
                    columns: this._getHeaderColumns(),
                    style: $fb1899bd678280c7$var$_objectSpread({
                        height: headerHeight,
                        overflow: 'hidden',
                        paddingRight: scrollbarWidth,
                        width: width
                    }, rowStyleObject)
                }), /*#__PURE__*/ $acw62.createElement((0, $dddee09ada2ab319$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, this.props, {
                    elementRef: this._setGridElementRef,
                    "aria-readonly": null,
                    autoContainerWidth: true,
                    className: (0, $15e8569690cae660$export$2e2bcd8739ae039)('ReactVirtualized__Table__Grid', gridClassName),
                    cellRenderer: this._createRow,
                    columnWidth: width,
                    columnCount: 1,
                    height: availableRowsHeight,
                    id: undefined,
                    noContentRenderer: noRowsRenderer,
                    onScroll: this._onScroll,
                    onSectionRendered: this._onSectionRendered,
                    ref: this._setRef,
                    role: "rowgroup",
                    scrollbarWidth: scrollbarWidth,
                    scrollToRow: scrollToIndex,
                    style: $fb1899bd678280c7$var$_objectSpread($fb1899bd678280c7$var$_objectSpread({}, gridStyle), {}, {
                        overflowX: 'hidden'
                    })
                })));
            }
        },
        {
            key: "_createColumn",
            value: function _createColumn(_ref4) {
                var column = _ref4.column, columnIndex = _ref4.columnIndex, isScrolling = _ref4.isScrolling, parent = _ref4.parent, rowData = _ref4.rowData, rowIndex = _ref4.rowIndex;
                var onColumnClick = this.props.onColumnClick;
                var _column$props = column.props, cellDataGetter = _column$props.cellDataGetter, cellRenderer = _column$props.cellRenderer, className = _column$props.className, columnData = _column$props.columnData, dataKey = _column$props.dataKey, id = _column$props.id;
                var cellData = cellDataGetter({
                    columnData: columnData,
                    dataKey: dataKey,
                    rowData: rowData
                });
                var renderedCell = cellRenderer({
                    cellData: cellData,
                    columnData: columnData,
                    columnIndex: columnIndex,
                    dataKey: dataKey,
                    isScrolling: isScrolling,
                    parent: parent,
                    rowData: rowData,
                    rowIndex: rowIndex
                });
                var onClick = function onClick(event) {
                    onColumnClick && onColumnClick({
                        columnData: columnData,
                        dataKey: dataKey,
                        event: event
                    });
                };
                var style = this._cachedColumnStyles[columnIndex];
                var title = typeof renderedCell === 'string' ? renderedCell : null;
                // Avoid using object-spread syntax with multiple objects here,
                // Since it results in an extra method call to 'babel-runtime/helpers/extends'
                // See PR https://github.com/bvaughn/react-virtualized/pull/942
                return /*#__PURE__*/ $acw62.createElement("div", {
                    "aria-colindex": columnIndex + 1,
                    "aria-describedby": id,
                    className: (0, $15e8569690cae660$export$2e2bcd8739ae039)('ReactVirtualized__Table__rowColumn', className),
                    key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
                    onClick: onClick,
                    role: "gridcell",
                    style: style,
                    title: title
                }, renderedCell);
            }
        },
        {
            key: "_createHeader",
            value: function _createHeader(_ref5) {
                var column = _ref5.column, index = _ref5.index;
                var _this$props2 = this.props, headerClassName = _this$props2.headerClassName, headerStyle = _this$props2.headerStyle, onHeaderClick = _this$props2.onHeaderClick, sort = _this$props2.sort, sortBy = _this$props2.sortBy, sortDirection = _this$props2.sortDirection;
                var _column$props2 = column.props, columnData = _column$props2.columnData, dataKey = _column$props2.dataKey, defaultSortDirection = _column$props2.defaultSortDirection, disableSort = _column$props2.disableSort, headerRenderer = _column$props2.headerRenderer, id = _column$props2.id, label = _column$props2.label;
                var sortEnabled = !disableSort && sort;
                var classNames = (0, $15e8569690cae660$export$2e2bcd8739ae039)('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
                    ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
                });
                var style = this._getFlexStyleForColumn(column, $fb1899bd678280c7$var$_objectSpread($fb1899bd678280c7$var$_objectSpread({}, headerStyle), column.props.headerStyle));
                var renderedHeader = headerRenderer({
                    columnData: columnData,
                    dataKey: dataKey,
                    disableSort: disableSort,
                    label: label,
                    sortBy: sortBy,
                    sortDirection: sortDirection
                });
                var headerOnClick, headerOnKeyDown, headerTabIndex, headerAriaSort, headerAriaLabel;
                if (sortEnabled || onHeaderClick) {
                    // If this is a sortable header, clicking it should update the table data's sorting.
                    var isFirstTimeSort = sortBy !== dataKey;
                    // If this is the firstTime sort of this column, use the column default sort order.
                    // Otherwise, invert the direction of the sort.
                    var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === (0, $7c4be1f06aae7753$export$2e2bcd8739ae039).DESC ? (0, $7c4be1f06aae7753$export$2e2bcd8739ae039).ASC : (0, $7c4be1f06aae7753$export$2e2bcd8739ae039).DESC;
                    var onClick = function onClick(event) {
                        sortEnabled && sort({
                            defaultSortDirection: defaultSortDirection,
                            event: event,
                            sortBy: dataKey,
                            sortDirection: newSortDirection
                        });
                        onHeaderClick && onHeaderClick({
                            columnData: columnData,
                            dataKey: dataKey,
                            event: event
                        });
                    };
                    var onKeyDown = function onKeyDown(event) {
                        if (event.key === 'Enter' || event.key === ' ') onClick(event);
                    };
                    headerAriaLabel = column.props['aria-label'] || label || dataKey;
                    headerAriaSort = 'none';
                    headerTabIndex = 0;
                    headerOnClick = onClick;
                    headerOnKeyDown = onKeyDown;
                }
                if (sortBy === dataKey) headerAriaSort = sortDirection === (0, $7c4be1f06aae7753$export$2e2bcd8739ae039).ASC ? 'ascending' : 'descending';
                // Avoid using object-spread syntax with multiple objects here,
                // Since it results in an extra method call to 'babel-runtime/helpers/extends'
                // See PR https://github.com/bvaughn/react-virtualized/pull/942
                return /*#__PURE__*/ $acw62.createElement("div", {
                    "aria-label": headerAriaLabel,
                    "aria-sort": headerAriaSort,
                    className: classNames,
                    id: id,
                    key: 'Header-Col' + index,
                    onClick: headerOnClick,
                    onKeyDown: headerOnKeyDown,
                    role: "columnheader",
                    style: style,
                    tabIndex: headerTabIndex
                }, renderedHeader);
            }
        },
        {
            key: "_createRow",
            value: function _createRow(_ref6) {
                var _this3 = this;
                var index = _ref6.rowIndex, isScrolling = _ref6.isScrolling, key = _ref6.key, parent = _ref6.parent, style = _ref6.style;
                var _this$props3 = this.props, children = _this$props3.children, onRowClick = _this$props3.onRowClick, onRowDoubleClick = _this$props3.onRowDoubleClick, onRowRightClick = _this$props3.onRowRightClick, onRowMouseOver = _this$props3.onRowMouseOver, onRowMouseOut = _this$props3.onRowMouseOut, rowClassName = _this$props3.rowClassName, rowGetter = _this$props3.rowGetter, rowRenderer = _this$props3.rowRenderer, rowStyle = _this$props3.rowStyle;
                var scrollbarWidth = this.state.scrollbarWidth;
                var rowClass = typeof rowClassName === 'function' ? rowClassName({
                    index: index
                }) : rowClassName;
                var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
                    index: index
                }) : rowStyle;
                var rowData = rowGetter({
                    index: index
                });
                var columns = $acw62.Children.toArray(children).map(function(column, columnIndex) {
                    return _this3._createColumn({
                        column: column,
                        columnIndex: columnIndex,
                        isScrolling: isScrolling,
                        parent: parent,
                        rowData: rowData,
                        rowIndex: index,
                        scrollbarWidth: scrollbarWidth
                    });
                });
                var className = (0, $15e8569690cae660$export$2e2bcd8739ae039)('ReactVirtualized__Table__row', rowClass);
                var flattenedStyle = $fb1899bd678280c7$var$_objectSpread($fb1899bd678280c7$var$_objectSpread({}, style), {}, {
                    height: this._getRowHeight(index),
                    overflow: 'hidden',
                    paddingRight: scrollbarWidth
                }, rowStyleObject);
                return rowRenderer({
                    className: className,
                    columns: columns,
                    index: index,
                    isScrolling: isScrolling,
                    key: key,
                    onRowClick: onRowClick,
                    onRowDoubleClick: onRowDoubleClick,
                    onRowRightClick: onRowRightClick,
                    onRowMouseOver: onRowMouseOver,
                    onRowMouseOut: onRowMouseOut,
                    rowData: rowData,
                    style: flattenedStyle
                });
            }
        },
        {
            key: "_getFlexStyleForColumn",
            value: function _getFlexStyleForColumn(column) {
                var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var flexValue = "".concat(column.props.flexGrow, " ").concat(column.props.flexShrink, " ").concat(column.props.width, "px");
                var style = $fb1899bd678280c7$var$_objectSpread($fb1899bd678280c7$var$_objectSpread({}, customStyle), {}, {
                    flex: flexValue,
                    msFlex: flexValue,
                    WebkitFlex: flexValue
                });
                if (column.props.maxWidth) style.maxWidth = column.props.maxWidth;
                if (column.props.minWidth) style.minWidth = column.props.minWidth;
                return style;
            }
        },
        {
            key: "_getHeaderColumns",
            value: function _getHeaderColumns() {
                var _this4 = this;
                var _this$props4 = this.props, children = _this$props4.children, disableHeader = _this$props4.disableHeader;
                var items = disableHeader ? [] : $acw62.Children.toArray(children);
                return items.map(function(column, index) {
                    return _this4._createHeader({
                        column: column,
                        index: index
                    });
                });
            }
        },
        {
            key: "_getRowHeight",
            value: function _getRowHeight(rowIndex) {
                var rowHeight = this.props.rowHeight;
                return typeof rowHeight === 'function' ? rowHeight({
                    index: rowIndex
                }) : rowHeight;
            }
        },
        {
            key: "_onScroll",
            value: function _onScroll(_ref7) {
                var clientHeight = _ref7.clientHeight, scrollHeight = _ref7.scrollHeight, scrollTop = _ref7.scrollTop;
                var onScroll = this.props.onScroll;
                onScroll({
                    clientHeight: clientHeight,
                    scrollHeight: scrollHeight,
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: "_onSectionRendered",
            value: function _onSectionRendered(_ref8) {
                var rowOverscanStartIndex = _ref8.rowOverscanStartIndex, rowOverscanStopIndex = _ref8.rowOverscanStopIndex, rowStartIndex = _ref8.rowStartIndex, rowStopIndex = _ref8.rowStopIndex;
                var onRowsRendered = this.props.onRowsRendered;
                onRowsRendered({
                    overscanStartIndex: rowOverscanStartIndex,
                    overscanStopIndex: rowOverscanStopIndex,
                    startIndex: rowStartIndex,
                    stopIndex: rowStopIndex
                });
            }
        },
        {
            key: "_setRef",
            value: function _setRef(ref) {
                this.Grid = ref;
            }
        },
        {
            key: "_setGridElementRef",
            value: function _setGridElementRef(ref) {
                this.GridElement = ref;
            }
        },
        {
            key: "_setScrollbarWidth",
            value: function _setScrollbarWidth() {
                var scrollbarWidth = this.getScrollbarWidth();
                this.setState({
                    scrollbarWidth: scrollbarWidth
                });
            }
        }
    ]);
}($acw62.PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))($fb1899bd678280c7$export$2e2bcd8739ae039, "defaultProps", {
    disableHeader: false,
    estimatedRowSize: 30,
    headerHeight: 0,
    headerStyle: {},
    noRowsRenderer: function noRowsRenderer() {
        return null;
    },
    onRowsRendered: function onRowsRendered() {
        return null;
    },
    onScroll: function onScroll() {
        return null;
    },
    overscanIndicesGetter: (0, $872a5ffafec0d490$export$2e2bcd8739ae039),
    overscanRowCount: 10,
    rowRenderer: (0, $4495a9e1dfe02ed2$export$2e2bcd8739ae039),
    headerRowRenderer: (0, $4074583ab64171e9$export$2e2bcd8739ae039),
    rowStyle: {},
    scrollToAlignment: 'auto',
    scrollToIndex: -1,
    style: {}
});
$fb1899bd678280c7$export$2e2bcd8739ae039.propTypes = {};


var $ea275bc0ebeb876d$export$2e2bcd8739ae039 = (0, $fb1899bd678280c7$export$2e2bcd8739ae039);









var $acw62 = parcelRequire("acw62");

'no babel-plugin-flow-react-proptypes';
/*:: import type WindowScroller from '../WindowScroller.js';*/ var $b042c31398ad3df2$var$mountedInstances = [];
var $b042c31398ad3df2$var$originalBodyPointerEvents = null;
var $b042c31398ad3df2$var$disablePointerEventsTimeoutId = null;
function $b042c31398ad3df2$var$enablePointerEventsIfDisabled() {
    if ($b042c31398ad3df2$var$disablePointerEventsTimeoutId) {
        $b042c31398ad3df2$var$disablePointerEventsTimeoutId = null;
        if (document.body && $b042c31398ad3df2$var$originalBodyPointerEvents != null) document.body.style.pointerEvents = $b042c31398ad3df2$var$originalBodyPointerEvents;
        $b042c31398ad3df2$var$originalBodyPointerEvents = null;
    }
}
function $b042c31398ad3df2$var$enablePointerEventsAfterDelayCallback() {
    $b042c31398ad3df2$var$enablePointerEventsIfDisabled();
    $b042c31398ad3df2$var$mountedInstances.forEach(function(instance) {
        return instance.__resetIsScrolling();
    });
}
function $b042c31398ad3df2$var$enablePointerEventsAfterDelay() {
    if ($b042c31398ad3df2$var$disablePointerEventsTimeoutId) (0, $85d05b1a4e1d5c40$export$3b976196c7d0d7a6)($b042c31398ad3df2$var$disablePointerEventsTimeoutId);
    var maximumTimeout = 0;
    $b042c31398ad3df2$var$mountedInstances.forEach(function(instance) {
        maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
    });
    $b042c31398ad3df2$var$disablePointerEventsTimeoutId = (0, $85d05b1a4e1d5c40$export$62c6fa81f9943047)($b042c31398ad3df2$var$enablePointerEventsAfterDelayCallback, maximumTimeout);
}
function $b042c31398ad3df2$var$onScrollWindow(event /*: Event*/ ) {
    if (event.currentTarget === window && $b042c31398ad3df2$var$originalBodyPointerEvents == null && document.body) {
        $b042c31398ad3df2$var$originalBodyPointerEvents = document.body.style.pointerEvents;
        document.body.style.pointerEvents = 'none';
    }
    $b042c31398ad3df2$var$enablePointerEventsAfterDelay();
    $b042c31398ad3df2$var$mountedInstances.forEach(function(instance) {
        if (instance.props.scrollElement === event.currentTarget) instance.__handleWindowScrollEvent();
    });
}
function $b042c31398ad3df2$export$2ae59a3a1c144a62(component /*: WindowScroller*/ , element /*: Element*/ ) {
    if (!$b042c31398ad3df2$var$mountedInstances.some(function(instance) {
        return instance.props.scrollElement === element;
    })) element.addEventListener('scroll', $b042c31398ad3df2$var$onScrollWindow);
    $b042c31398ad3df2$var$mountedInstances.push(component);
}
function $b042c31398ad3df2$export$9eab03f1e587e004(component /*: WindowScroller*/ , element /*: Element*/ ) {
    $b042c31398ad3df2$var$mountedInstances = $b042c31398ad3df2$var$mountedInstances.filter(function(instance) {
        return instance !== component;
    });
    if (!$b042c31398ad3df2$var$mountedInstances.length) {
        element.removeEventListener('scroll', $b042c31398ad3df2$var$onScrollWindow);
        if ($b042c31398ad3df2$var$disablePointerEventsTimeoutId) {
            (0, $85d05b1a4e1d5c40$export$3b976196c7d0d7a6)($b042c31398ad3df2$var$disablePointerEventsTimeoutId);
            $b042c31398ad3df2$var$enablePointerEventsIfDisabled();
        }
    }
}


/**
 * Gets the dimensions of the element, accounting for API differences between
 * `window` and other DOM elements.
 */ /*:: type Dimensions = {
  height: number,
  width: number,
};*/ // TODO Move this into WindowScroller and import from there
/*:: type WindowScrollerProps = {
  serverHeight: number,
  serverWidth: number,
};*/ var $c47809fc274c4976$var$isWindow = function isWindow(element) {
    return element === window;
};
var $c47809fc274c4976$var$getBoundingBox = function getBoundingBox(element) {
    return element.getBoundingClientRect();
};
function $c47809fc274c4976$export$d1aa971bf69c7e87(scrollElement /*: ?Element*/ , props /*: WindowScrollerProps*/ ) /*: Dimensions*/ {
    if (!scrollElement) return {
        height: props.serverHeight,
        width: props.serverWidth
    };
    else if ($c47809fc274c4976$var$isWindow(scrollElement)) {
        var _window = window, innerHeight = _window.innerHeight, innerWidth = _window.innerWidth;
        return {
            height: typeof innerHeight === 'number' ? innerHeight : 0,
            width: typeof innerWidth === 'number' ? innerWidth : 0
        };
    } else return $c47809fc274c4976$var$getBoundingBox(scrollElement);
}
function $c47809fc274c4976$export$49c9ca06677d64ad(element /*: Element*/ , container /*: Element*/ ) {
    if ($c47809fc274c4976$var$isWindow(container) && document.documentElement) {
        var containerElement = document.documentElement;
        var elementRect = $c47809fc274c4976$var$getBoundingBox(element);
        var containerRect = $c47809fc274c4976$var$getBoundingBox(containerElement);
        return {
            top: elementRect.top - containerRect.top,
            left: elementRect.left - containerRect.left
        };
    } else {
        var scrollOffset = $c47809fc274c4976$export$760208e927c198fa(container);
        var _elementRect = $c47809fc274c4976$var$getBoundingBox(element);
        var _containerRect = $c47809fc274c4976$var$getBoundingBox(container);
        return {
            top: _elementRect.top + scrollOffset.top - _containerRect.top,
            left: _elementRect.left + scrollOffset.left - _containerRect.left
        };
    }
}
function $c47809fc274c4976$export$760208e927c198fa(element /*: Element*/ ) {
    if ($c47809fc274c4976$var$isWindow(element) && document.documentElement) return {
        top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
        left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
    };
    else return {
        top: element.scrollTop,
        left: element.scrollLeft
    };
}



function $0ea21529c10f2411$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0ea21529c10f2411$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0ea21529c10f2411$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0ea21529c10f2411$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0ea21529c10f2411$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $0ea21529c10f2411$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $0ea21529c10f2411$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0ea21529c10f2411$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $0ea21529c10f2411$export$4c2e2096c8dd4c46 = 150;
var $0ea21529c10f2411$var$getWindow = function getWindow() {
    return typeof window !== 'undefined' ? window : undefined;
};
var $0ea21529c10f2411$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    function WindowScroller() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, WindowScroller);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $0ea21529c10f2411$var$_callSuper(this, WindowScroller, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_window", $0ea21529c10f2411$var$getWindow());
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_isMounted", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_positionFromTop", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_positionFromLeft", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_detectElementResize", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_child", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_windowScrollerRef", /*#__PURE__*/ $acw62.createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "state", $0ea21529c10f2411$var$_objectSpread($0ea21529c10f2411$var$_objectSpread({}, (0, $c47809fc274c4976$export$d1aa971bf69c7e87)(_this.props.scrollElement, _this.props)), {}, {
            isScrolling: false,
            scrollLeft: 0,
            scrollTop: 0
        }));
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_registerChild", function(element) {
            if (element && !(element instanceof Element)) console.warn('WindowScroller registerChild expects to be passed Element or null');
            _this._child = element;
            _this.updatePosition();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onChildScroll", function(_ref) {
            var scrollTop = _ref.scrollTop;
            if (_this.state.scrollTop === scrollTop) return;
            var scrollElement = _this.props.scrollElement;
            if (scrollElement) {
                if (typeof scrollElement.scrollTo === 'function') scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
                else scrollElement.scrollTop = scrollTop + _this._positionFromTop;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_registerResizeListener", function(element) {
            if (element === window) window.addEventListener('resize', _this._onResize, false);
            else _this._detectElementResize.addResizeListener(element, _this._onResize);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_unregisterResizeListener", function(element) {
            if (element === window) window.removeEventListener('resize', _this._onResize, false);
            else if (element) _this._detectElementResize.removeResizeListener(element, _this._onResize);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "_onResize", function() {
            _this.updatePosition();
        });
        // Referenced by utils/onScroll
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "__handleWindowScrollEvent", function() {
            if (!_this._isMounted) return;
            var onScroll = _this.props.onScroll;
            var scrollElement = _this.props.scrollElement;
            if (scrollElement) {
                var scrollOffset = (0, $c47809fc274c4976$export$760208e927c198fa)(scrollElement);
                var scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
                var scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);
                _this.setState({
                    isScrolling: true,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
                onScroll({
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
            }
        });
        // Referenced by utils/onScroll
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "__resetIsScrolling", function() {
            _this.setState({
                isScrolling: false
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(WindowScroller, _React$PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(WindowScroller, [
        {
            key: "updatePosition",
            value: function updatePosition() {
                var scrollElement /*: ?Element*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
                var onResize = this.props.onResize;
                var _this$state = this.state, height = _this$state.height, width = _this$state.width;
                var thisNode = this._child || this._windowScrollerRef.current;
                if (thisNode instanceof Element && scrollElement) {
                    var offset = (0, $c47809fc274c4976$export$49c9ca06677d64ad)(thisNode, scrollElement);
                    this._positionFromTop = offset.top;
                    this._positionFromLeft = offset.left;
                }
                var dimensions = (0, $c47809fc274c4976$export$d1aa971bf69c7e87)(scrollElement, this.props);
                if (height !== dimensions.height || width !== dimensions.width) {
                    this.setState({
                        height: dimensions.height,
                        width: dimensions.width
                    });
                    onResize({
                        height: dimensions.height,
                        width: dimensions.width
                    });
                }
                if (this.props.updateScrollTopOnUpdatePosition === true) {
                    this.__handleWindowScrollEvent();
                    this.__resetIsScrolling();
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var scrollElement = this.props.scrollElement;
                this._detectElementResize = (0, $1b7c52d1527ca6fe$export$2e2bcd8739ae039)();
                this.updatePosition(scrollElement);
                if (scrollElement) {
                    (0, $b042c31398ad3df2$export$2ae59a3a1c144a62)(this, scrollElement);
                    this._registerResizeListener(scrollElement);
                }
                this._isMounted = true;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps /*: Props*/ , prevState /*: State*/ ) {
                var scrollElement = this.props.scrollElement;
                var prevScrollElement = prevProps.scrollElement;
                if (prevScrollElement !== scrollElement && prevScrollElement != null && scrollElement != null) {
                    this.updatePosition(scrollElement);
                    (0, $b042c31398ad3df2$export$9eab03f1e587e004)(this, prevScrollElement);
                    (0, $b042c31398ad3df2$export$2ae59a3a1c144a62)(this, scrollElement);
                    this._unregisterResizeListener(prevScrollElement);
                    this._registerResizeListener(scrollElement);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var scrollElement = this.props.scrollElement;
                if (scrollElement) {
                    (0, $b042c31398ad3df2$export$9eab03f1e587e004)(this, scrollElement);
                    this._unregisterResizeListener(scrollElement);
                }
                this._isMounted = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                var _this$state2 = this.state, isScrolling = _this$state2.isScrolling, scrollTop = _this$state2.scrollTop, scrollLeft = _this$state2.scrollLeft, height = _this$state2.height, width = _this$state2.width;
                return /*#__PURE__*/ $acw62.createElement('div', {
                    ref: this._windowScrollerRef
                }, children({
                    onChildScroll: this._onChildScroll,
                    registerChild: this._registerChild,
                    height: height,
                    isScrolling: isScrolling,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    width: width
                }));
            }
        }
    ]);
}($acw62.PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))($0ea21529c10f2411$export$2e2bcd8739ae039, "defaultProps", {
    onResize: function onResize() {},
    onScroll: function onScroll() {},
    scrollingResetTimeInterval: $0ea21529c10f2411$export$4c2e2096c8dd4c46,
    scrollElement: $0ea21529c10f2411$var$getWindow(),
    serverHeight: 0,
    serverWidth: 0
});


var $05b570cb31ad0510$export$2e2bcd8739ae039 = (0, $0ea21529c10f2411$export$2e2bcd8739ae039);




class $50ba126c278b488f$export$2e2bcd8739ae039 extends $acw62.PureComponent {
    constructor(props){
        super(props), this.getRowClassName = ({ index: index })=>{
            const { classes: classes, onRowClick: onRowClick } = this.props;
            return (0, $9QePP.default)(classes.tableRow, classes.flexContainer, {
                [classes.tableRowHover]: index !== -1 && onRowClick != null
            });
        }, this.cellRenderer = ({ cellData: cellData, columnData: columnData, dataKey: dataKey, rowData: rowData })=>{
            const { rowHeight: rowHeight, onRowClick: onRowClick, classes: classes, handleEditCell: handleEditCell } = this.props;
            const dataVal = cellData === 'false' ? false : cellData === 'true' ? true : columnData.displayValue ? columnData.displayValue(cellData) : cellData;
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                padding: "none",
                component: "div",
                className: (0, $9QePP.default)(classes.tableCell, classes.flexContainer, {
                    [classes.noClick]: onRowClick == null
                }),
                variant: "body",
                style: {
                    height: rowHeight
                },
                align: "left",
                sx: {
                    overflowY: 'auto',
                    pl: 2
                },
                children: typeof dataVal == 'boolean' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                    checked: dataVal,
                    disabled: !columnData.editable,
                    onChange: (e)=>handleEditCell ? handleEditCell(e.target.checked, rowData.Id, dataKey) : true
                }) : columnData.editable ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                    size: "small",
                    fullWidth: true,
                    variant: "standard",
                    multiline: columnData.multiline ?? false,
                    required: columnData.required ?? true,
                    InputProps: {
                        style: {
                            fontSize: 'inherit'
                        }
                    },
                    value: cellData,
                    onChange: (e)=>handleEditCell ? handleEditCell(e.target.value, rowData.Id, dataKey) : true
                }) : dataVal
            });
        }, this.headerRenderer = ({ label: label })=>{
            const { classes: classes } = this.props;
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                component: "div",
                className: (0, $9QePP.default)(classes.tableCell, classes.flexContainer, classes.noClick, classes.header),
                variant: "head",
                align: "center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: label
                })
            });
        };
        this.state = {
            rows: this.props.rows
        };
    }
    render() {
        const { columns: columns, rowHeight: rowHeight, headerHeight: headerHeight, classes: classes, tableClassName: tableClassName, ...tableProps } = this.props;
        const table = document.querySelector(`.${tableClassName}`);
        const tableWidth = table != null ? table.offsetWidth : window.innerWidth;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ae9562149794479$export$2e2bcd8739ae039), {
            children: ({ height: height, width: width })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $fb1899bd678280c7$export$2e2bcd8739ae039), {
                    height: height,
                    width: width,
                    rowHeight: rowHeight,
                    gridStyle: {
                        direction: 'inherit'
                    },
                    headerHeight: headerHeight,
                    ...tableProps,
                    rowClassName: this.getRowClassName,
                    children: columns.map(({ dataKey: dataKey, editable: editable, multiline: multiline, widthPercentage: widthPercentage, displayValue: displayValue, ...other }, index)=>{
                        const width = widthPercentage ? tableWidth * widthPercentage * 0.01 : 500;
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0f0ab585f610fa40$export$2e2bcd8739ae039), {
                            headerRenderer: (headerProps)=>this.headerRenderer({
                                    ...headerProps,
                                    columnIndex: index
                                }),
                            className: classes.flexContainer,
                            cellRenderer: this.cellRenderer,
                            dataKey: dataKey,
                            width: width,
                            columnData: {
                                editable: editable,
                                multiline: multiline,
                                displayValue: displayValue
                            },
                            ...other
                        }, dataKey);
                    })
                })
        });
    }
}


var $27a336f43d6db496$export$395a4017e5621e14;
$27a336f43d6db496$export$395a4017e5621e14 = `jWQ7dq_ConfigTable`;


const $d7e790f65d6f527d$var$configCompare = (a, b)=>{
    if (a.key < b.key) return -1;
    if (a.key > b.key) return 1;
    if (a.OrgName < b.OrgName) return -1;
    if (a.OrgName > b.OrgName) return 1;
    return 0;
};
const $d7e790f65d6f527d$var$configTableStyles = {
    headerHeight: 48,
    rowHeight: 65
};
const $d7e790f65d6f527d$var$configTableClasses = {
    flexContainer: 'ConfigTable-flexContainer',
    tableRow: 'ConfigTable-tableRow',
    tableRowHover: 'ConfigTable-tableRowHover',
    tableCell: 'ConfigTable-tableCell',
    noClick: 'ConfigTable-noClick',
    header: 'ConfigTable-header'
};
const $d7e790f65d6f527d$var$styles = ({ theme: theme })=>({
        '& .ReactVirtualized__Table__headerRow': {
            ...theme.direction === 'rtl' && {
                paddingLeft: '0 !important'
            },
            ...theme.direction !== 'rtl' && {
                paddingRight: undefined
            }
        },
        [`& .${$d7e790f65d6f527d$var$configTableClasses.flexContainer}`]: {
            display: 'flex',
            alignItems: 'center',
            boxSizing: 'border-box'
        },
        [`& .${$d7e790f65d6f527d$var$configTableClasses.tableRow}`]: {
            cursor: 'pointer'
        },
        [`& .${$d7e790f65d6f527d$var$configTableClasses.tableRowHover}`]: {
            '&:hover': {
                backgroundColor: theme.vars.palette.grey[200]
            }
        },
        [`& .${$d7e790f65d6f527d$var$configTableClasses.tableCell}`]: {
            flex: 1
        },
        [`& .${$d7e790f65d6f527d$var$configTableClasses.noClick}`]: {
            cursor: 'initial'
        },
        [`& .${$d7e790f65d6f527d$var$configTableClasses.header}`]: {
            'font-weight': '900 !important',
            height: $d7e790f65d6f527d$var$configTableStyles.headerHeight
        }
    });
const $d7e790f65d6f527d$var$VirtualizedTable = (0, $d8seH.default)((0, $50ba126c278b488f$export$2e2bcd8739ae039))($d7e790f65d6f527d$var$styles);
const $d7e790f65d6f527d$var$filteredEntry = (entry, filterText, filterMode)=>{
    return filterMode.indexOf(entry.mode) > -1 && entry.description.concat(entry.name, entry.key, entry.value.toString()).toLowerCase().indexOf(filterText.toLowerCase()) > -1;
};
class $d7e790f65d6f527d$export$2e2bcd8739ae039 extends $acw62.Component {
    constructor(props){
        super(props);
    }
    render() {
        const { editMode: editMode, allOrgSelectedConfigEntries: allOrgSelectedConfigEntries, filterText: filterText, filterMode: filterMode, filterOrganization: filterOrganization } = this.props;
        const configTableColumns = [
            {
                widthPercentage: 5,
                label: 'Org',
                dataKey: 'OrgName',
                editable: false,
                displayValue: (x)=>(0, $b03affab22376d2b$export$34972741e49e1f02)[x]
            },
            {
                widthPercentage: 3,
                label: 'Mode',
                dataKey: 'mode',
                editable: false,
                displayValue: (x)=>(0, $b03affab22376d2b$export$3a6738f07b256f2f)[x]
            },
            {
                widthPercentage: 30,
                label: 'Key',
                dataKey: 'key',
                editable: false
            },
            {
                widthPercentage: 30,
                label: 'Name',
                dataKey: 'name',
                editable: editMode
            },
            {
                widthPercentage: 25,
                label: 'Value',
                dataKey: 'value',
                editable: editMode,
                flexGrow: 1
            },
            {
                multiline: true,
                label: 'Description',
                dataKey: 'description',
                editable: editMode,
                widthPercentage: 17
            }
        ];
        const rows = allOrgSelectedConfigEntries.filter((o)=>filterOrganization.map((o)=>(0, $b03affab22376d2b$export$a903e0b288f88ac)[o]).includes(o.UserId) && $d7e790f65d6f527d$var$filteredEntry(o, filterText, filterMode)).sort($d7e790f65d6f527d$var$configCompare);
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `ConfigTable ${$27a336f43d6db496$export$395a4017e5621e14}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d7e790f65d6f527d$var$VirtualizedTable, {
                    classes: $d7e790f65d6f527d$var$configTableClasses,
                    rowCount: rows.length,
                    rowGetter: ({ index: index })=>rows[index],
                    columns: configTableColumns,
                    rows: rows,
                    ...$d7e790f65d6f527d$var$configTableStyles,
                    handleEditCell: this.props.onConfigEntryUpdate
                })
            })
        });
    }
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $20e4b243ccff587b$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($20e4b243ccff587b$exports, "__esModule", {
    value: true
});
$20e4b243ccff587b$exports.default = void 0;

var $20e4b243ccff587b$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $20e4b243ccff587b$var$_default = $20e4b243ccff587b$exports.default = (0, $20e4b243ccff587b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');



var $dd007b7321de4ab2$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($dd007b7321de4ab2$exports, "__esModule", {
    value: true
});
$dd007b7321de4ab2$exports.default = void 0;

var $dd007b7321de4ab2$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $dd007b7321de4ab2$var$_default = $dd007b7321de4ab2$exports.default = (0, $dd007b7321de4ab2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m12.126 8.125 1.937-1.937 3.747 3.747-1.937 1.938zM20.71 5.63l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75L20.71 7a1 1 0 0 0 0-1.37M2 5l6.63 6.63L3 17.25V21h3.75l5.63-5.62L18 21l2-2L4 3z"
}), 'EditOff');


var $8c6ad197f63b3f3e$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($8c6ad197f63b3f3e$exports, "__esModule", {
    value: true
});
$8c6ad197f63b3f3e$exports.default = void 0;

var $8c6ad197f63b3f3e$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8c6ad197f63b3f3e$var$_default = $8c6ad197f63b3f3e$exports.default = (0, $8c6ad197f63b3f3e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');


var $6eefe30025c8ad9a$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($6eefe30025c8ad9a$exports, "__esModule", {
    value: true
});
$6eefe30025c8ad9a$exports.default = void 0;

var $6eefe30025c8ad9a$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $6eefe30025c8ad9a$var$_default = $6eefe30025c8ad9a$exports.default = (0, $6eefe30025c8ad9a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m3-10H5V5h10z"
}), 'Save');









var $f36a60d9330db824$export$e1a8e267487c59d1;
var $f36a60d9330db824$export$d76128d007d19019;
var $f36a60d9330db824$export$4ea6092c933ebdb5;
$f36a60d9330db824$export$e1a8e267487c59d1 = `XQbIDq_edit`;
$f36a60d9330db824$export$d76128d007d19019 = `XQbIDq_search`;
$f36a60d9330db824$export$4ea6092c933ebdb5 = `XQbIDq_selections`;


const $52b2cdf95b128361$var$ConfigModeFilter = (ps)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
        component: "fieldset",
        className: "ConfigModeFilter",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
            "aria-label": "position",
            row: true,
            children: (0, $b03affab22376d2b$export$729e9291cdb5b5ea).map((mode)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                    value: mode,
                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                        checked: ps.selectedMode.includes(mode),
                        color: "success",
                        onChange: (e)=>{
                            ps.onFilterModeChange(e.target.value, e.target.checked);
                        }
                    }),
                    label: `${mode}(${(0, $b03affab22376d2b$export$3a6738f07b256f2f)[mode]})`,
                    labelPlacement: "start"
                }, mode);
            })
        })
    });
const $52b2cdf95b128361$var$OrganizationFilter = (ps)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
        component: "fieldset",
        className: "OrganizationFilter",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
            "aria-label": "position",
            row: true,
            children: (0, $b03affab22376d2b$export$fe0f87d711783637).map((org)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                    value: org,
                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                        checked: ps.selectedOrg.includes(org),
                        color: "success",
                        onChange: (e)=>{
                            ps.onFilterOrgChange(e.target.value, e.target.checked);
                        }
                    }),
                    label: `${org}(${(0, $b03affab22376d2b$export$34972741e49e1f02)[org]})`,
                    labelPlacement: "start"
                }, org);
            })
        })
    });
class $52b2cdf95b128361$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    render() {
        const { hasEdited: hasEdited, filterText: filterText, editMode: editMode, filterMode: filterMode, filterOrganization: filterOrganization, onEditModeChange: onEditModeChange, onFilterModeChange: onFilterModeChange, onFilterOrgChange: onFilterOrgChange, onFilterTextChange: onFilterTextChange, onSaveConfigs: onSaveConfigs } = this.props;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $efbb6eb46c8dd746$export$bfbece8a621a006f), {
            className: "SearchControl",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: $f36a60d9330db824$export$4ea6092c933ebdb5,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($52b2cdf95b128361$var$OrganizationFilter, {
                            selectedOrg: filterOrganization,
                            onFilterOrgChange: onFilterOrgChange
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($52b2cdf95b128361$var$ConfigModeFilter, {
                            selectedMode: filterMode,
                            onFilterModeChange: onFilterModeChange
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76910a07fd4ac4fe$export$2e2bcd8739ae039), {
                    id: "standard-error",
                    fullWidth: true,
                    placeholder: "Search build settings...",
                    value: filterText,
                    className: $f36a60d9330db824$export$d76128d007d19019,
                    onChange: (e)=>{
                        onFilterTextChange(e.target.value);
                    },
                    startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0c64ff513a9933f$export$2e2bcd8739ae039), {
                        position: "start",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($20e4b243ccff587b$exports))), {})
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                    title: editMode ? 'Cancel Edit' : 'Edit',
                    placement: "top",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                        checked: editMode,
                        onChange: (e)=>{
                            onEditModeChange(e.target.checked);
                        },
                        inputProps: {
                            'aria-label': 'controlled'
                        },
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8c6ad197f63b3f3e$exports))), {}),
                        checkedIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dd007b7321de4ab2$exports))), {}),
                        className: $f36a60d9330db824$export$e1a8e267487c59d1
                    })
                }),
                hasEdited ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                    title: 'Save',
                    placement: "top",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            onSaveConfigs();
                        },
                        size: "large",
                        component: "span",
                        color: "info",
                        style: {
                            padding: 'inherit'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6eefe30025c8ad9a$exports))), {
                            fontSize: "inherit"
                        })
                    })
                }) : null
            ]
        });
    }
}


/**
 * Getting information about Configs.
 *
 * @since 0.4.0
 */ 

const $a13bf4b12472563e$export$8837f4fc672e936d = (req)=>req.request((0, $87701c398fec8638$export$2f23118c22fb2630)((0, $b03affab22376d2b$export$ff038b2e7eee250e)))('glassd/org_config', 'GET');
const $a13bf4b12472563e$export$d3fb956c8894134 = (req)=>(id)=>req.request((0, $b03affab22376d2b$export$ff038b2e7eee250e))(`glassd/org_config/${id}`, 'GET');
const $a13bf4b12472563e$export$2eaf9172a83ee9e7 = (req)=>(orgConfig)=>req.request((0, $b03affab22376d2b$export$ff038b2e7eee250e))('glassd/org_config', 'PUT', orgConfig);



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


'use client';
/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */ function $2d16bff1157c299f$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $acw62.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $acw62.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $acw62.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $8nd05.default)({}, (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(parameters), (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(externalProps));
        return (0, $8nd05.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation'
        }, externalProps, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $2d16bff1157c299f$export$2e2bcd8739ae039 = $2d16bff1157c299f$var$useSnackbar;




var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4d2fdf4430378182$export$def81488db1a3216(slot) {
    return (0, $4Cod0.default)('MuiSnackbarContent', slot);
}
const $4d2fdf4430378182$var$snackbarContentClasses = (0, $beCSm.default)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $4d2fdf4430378182$export$2e2bcd8739ae039 = $4d2fdf4430378182$var$snackbarContentClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $dbe322effc7340b4$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $dbe322effc7340b4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4d2fdf4430378182$export$def81488db1a3216), classes);
};
const $dbe322effc7340b4$var$SnackbarContentRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiSnackbarContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    const backgroundColor = (0, $kSnzZ.emphasize)(theme.palette.background.default, emphasis);
    return (0, $8nd05.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    });
});
const $dbe322effc7340b4$var$SnackbarContentMessage = (0, $d8seH.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0'
});
const $dbe322effc7340b4$var$SnackbarContentAction = (0, $d8seH.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $dbe322effc7340b4$var$SnackbarContent = /*#__PURE__*/ $acw62.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert' } = props, other = (0, $1En50.default)(props, $dbe322effc7340b4$var$_excluded);
    const ownerState = props;
    const classes = $dbe322effc7340b4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($dbe322effc7340b4$var$SnackbarContentRoot, (0, $8nd05.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $dbe322effc7340b4$export$2e2bcd8739ae039 = $dbe322effc7340b4$var$SnackbarContent;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f3bdc4d25b715a88$export$6cb096457f5926f4(slot) {
    return (0, $4Cod0.default)('MuiSnackbar', slot);
}
const $f3bdc4d25b715a88$var$snackbarClasses = (0, $beCSm.default)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $f3bdc4d25b715a88$export$2e2bcd8739ae039 = $f3bdc4d25b715a88$var$snackbarClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ef601776ba11bb1e$var$_excluded = [
    "onEnter",
    "onExited"
], $ef601776ba11bb1e$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $ef601776ba11bb1e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $jTnBY.default)(anchorOrigin.vertical)}${(0, $jTnBY.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f3bdc4d25b715a88$export$6cb096457f5926f4), classes);
};
const $ef601776ba11bb1e$var$SnackbarRoot = (0, $d8seH.default)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $jTnBY.default)(ownerState.anchorOrigin.vertical)}${(0, $jTnBY.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)'
    };
    return (0, $8nd05.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.anchorOrigin.vertical === 'top' ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === 'left' && {
        justifyContent: 'flex-start'
    }, ownerState.anchorOrigin.horizontal === 'right' && {
        justifyContent: 'flex-end'
    }, {
        [theme.breakpoints.up('sm')]: (0, $8nd05.default)({}, ownerState.anchorOrigin.vertical === 'top' ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === 'center' && center, ownerState.anchorOrigin.horizontal === 'left' && {
            left: 24,
            right: 'auto'
        }, ownerState.anchorOrigin.horizontal === 'right' && {
            right: 24,
            left: 'auto'
        })
    });
});
const $ef601776ba11bb1e$var$Snackbar = /*#__PURE__*/ $acw62.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $ef601776ba11bb1e$var$_excluded), other = (0, $1En50.default)(props, $ef601776ba11bb1e$var$_excluded2);
    const ownerState = (0, $8nd05.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $ef601776ba11bb1e$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $2d16bff1157c299f$export$2e2bcd8739ae039)((0, $8nd05.default)({}, ownerState));
    const [exited, setExited] = $acw62.useState(true);
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: $ef601776ba11bb1e$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0f105dbd8c07c9e$export$58385c17fee43f89), (0, $8nd05.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ef601776ba11bb1e$var$SnackbarRoot, (0, $8nd05.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === 'top' ? 'down' : 'up',
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbe322effc7340b4$export$2e2bcd8739ae039), (0, $8nd05.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $ef601776ba11bb1e$export$2e2bcd8739ae039 = $ef601776ba11bb1e$var$Snackbar;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $jTnBY = parcelRequire("jTnBY");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $1da0e229d53b4459$export$69aecd24bc2cf7e3(slot) {
    return (0, $4Cod0.default)('MuiAlert', slot);
}
const $1da0e229d53b4459$var$alertClasses = (0, $beCSm.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $1da0e229d53b4459$export$2e2bcd8739ae039 = $1da0e229d53b4459$var$alertClasses;



parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $0eec239707c48bf2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $611e456547a52fc7$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $af7987087272cca1$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $76204164d2201318$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d7b9f0ef25189a24$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $d7b9f0ef25189a24$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color || severity)}`,
            `${variant}${(0, $jTnBY.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $1da0e229d53b4459$export$69aecd24bc2cf7e3), classes);
};
const $d7b9f0ef25189a24$var$AlertRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $kSnzZ.darken) : (0, $kSnzZ.lighten);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $kSnzZ.lighten) : (0, $kSnzZ.darken);
    return (0, $8nd05.default)({}, theme.typography.body2, {
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $1da0e229d53b4459$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $1da0e229d53b4459$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: (0, $8nd05.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const $d7b9f0ef25189a24$var$AlertIcon = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $d7b9f0ef25189a24$var$AlertMessage = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $d7b9f0ef25189a24$var$AlertAction = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $d7b9f0ef25189a24$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0eec239707c48bf2$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $611e456547a52fc7$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af7987087272cca1$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76204164d2201318$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $d7b9f0ef25189a24$var$Alert = /*#__PURE__*/ $acw62.forwardRef(function Alert(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $d7b9f0ef25189a24$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $d7b9f0ef25189a24$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    });
    const classes = $d7b9f0ef25189a24$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $8nd05.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, $8nd05.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('closeButton', {
        elementType: (0, $71c322247f7fbf93$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('closeIcon', {
        elementType: (0, $f7280bbf95507cba$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d7b9f0ef25189a24$var$AlertRoot, (0, $8nd05.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $d7b9f0ef25189a24$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseButtonSlot, (0, $8nd05.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseIconSlot, (0, $8nd05.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $d7b9f0ef25189a24$export$2e2bcd8739ae039 = $d7b9f0ef25189a24$var$Alert;


const $9f9722f5a293e2a2$var$Alert = /*#__PURE__*/ $acw62.forwardRef(function Alert(props, ref) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
        elevation: 6,
        ref: ref,
        variant: "filled",
        ...props
    });
});
const $9f9722f5a293e2a2$export$8d8dc7d5f743331b = (ps)=>{
    const { open: open, message: message, type: type, vertical: vertical, horizontal: horizontal, children: children, autoHideDuration: autoHideDuration = 6000, handleClose: handleClose } = ps;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef601776ba11bb1e$export$2e2bcd8739ae039), {
            anchorOrigin: {
                vertical: vertical,
                horizontal: horizontal
            },
            open: open,
            autoHideDuration: autoHideDuration,
            onClose: handleClose,
            children: children ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($9f9722f5a293e2a2$var$Alert, {
                onClose: handleClose,
                severity: type,
                sx: {
                    width: '100%'
                },
                children: message
            })
        })
    });
};


const $4d75faa715a9d2b9$var$saveConfigs = (page)=>{
    const toUpdateConfigs = [];
    page.state.editedUsers.forEach((userId)=>{
        const userConfig = page.state.allOrgConfigs.find((c)=>c.UserId == userId);
        if (userConfig) toUpdateConfigs.push(userConfig);
    });
    Promise.all(toUpdateConfigs.map((o)=>(0, $a13bf4b12472563e$export$2eaf9172a83ee9e7)(page.props.req)(o))).then((updatedConfigs)=>{
        page.setState({
            toastOpen: true,
            toastType: 'success',
            toastMessage: `Updated config for ${updatedConfigs.map((c)=>c.Name).join(', ')} sucessfully`,
            hasEdited: false,
            editedUsers: []
        });
    }).catch(()=>{
        page.setState({
            toastOpen: true,
            toastType: 'error',
            toastMessage: `Error updating config ${toUpdateConfigs.map((c)=>c.Name).join(', ')}`
        });
    });
};
class $4d75faa715a9d2b9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            filterText: '',
            editMode: false,
            filterMode: [
                'shower'
            ],
            filterOrganization: [
                'Retail'
            ],
            allOrgSelectedConfigEntries: [],
            hasEdited: false,
            editedUsers: [],
            allOrgConfigs: [],
            toastOpen: false,
            toastMessage: '',
            toastType: 'success'
        };
        (0, $a13bf4b12472563e$export$8837f4fc672e936d)(this.props.req).then((allOrgConfigs)=>{
            const allOrgSelectedConfigEntries = (0, $b03affab22376d2b$export$e295e35bd30452a1)(allOrgConfigs);
            if (allOrgConfigs && allOrgSelectedConfigEntries) this.setState({
                allOrgSelectedConfigEntries: allOrgSelectedConfigEntries,
                allOrgConfigs: allOrgConfigs
            });
        }).catch(console.warn);
    }
    render() {
        const handleConfigEntryUpdate = (value, rowId, dataKey)=>{
            const editedUsers = this.state.editedUsers;
            const updatedAllOrgConfigs = this.state.allOrgConfigs;
            const updatedConfigs = this.state.allOrgSelectedConfigEntries.map((row)=>{
                if (row.Id === rowId) {
                    const updatedEntry = {
                        ...row,
                        [dataKey]: value
                    };
                    const { UserId: UserId, description: description, key: key, name: name, mode: mode, SelectedVendor: SelectedVendor } = updatedEntry;
                    if (!editedUsers.includes(UserId)) editedUsers.push(UserId);
                    const updatedOrgConfig = this.state.allOrgConfigs.find((oc)=>oc.UserId == UserId);
                    if (updatedOrgConfig && updatedOrgConfig.Vendors && SelectedVendor in updatedOrgConfig.Vendors) {
                        if (updatedOrgConfig.Vendors[SelectedVendor] != undefined) {
                            (updatedOrgConfig.Vendors[SelectedVendor] ?? {})[key] = {
                                key: key,
                                name: name,
                                mode: mode,
                                description: description,
                                value: value
                            };
                            updatedAllOrgConfigs.filter((oc)=>oc.UserId != UserId).concat(updatedOrgConfig);
                        }
                    }
                    return updatedEntry;
                } else return {
                    ...row
                };
            });
            this.setState({
                allOrgConfigs: updatedAllOrgConfigs,
                allOrgSelectedConfigEntries: updatedConfigs,
                hasEdited: true,
                editedUsers: editedUsers
            });
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "screen",
            children: [
                this.state.toastOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9f9722f5a293e2a2$export$8d8dc7d5f743331b), {
                    open: this.state.toastOpen,
                    message: this.state.toastMessage,
                    type: this.state.toastType,
                    vertical: "top",
                    horizontal: "right",
                    handleClose: ()=>{
                        this.setState({
                            toastOpen: false,
                            toastMessage: '',
                            toastType: 'info'
                        });
                    }
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $52b2cdf95b128361$export$2e2bcd8739ae039), {
                    filterText: this.state.filterText,
                    filterMode: this.state.filterMode,
                    filterOrganization: this.state.filterOrganization,
                    editMode: this.state.editMode,
                    hasEdited: this.state.hasEdited,
                    onFilterTextChange: (t)=>{
                        this.setState({
                            filterText: t
                        });
                    },
                    onFilterModeChange: (m, checked)=>{
                        this.setState({
                            filterMode: checked ? this.state.filterMode.concat(m) : this.state.filterMode.filter((cm)=>cm != m)
                        });
                    },
                    onFilterOrgChange: (m, checked)=>{
                        this.setState({
                            filterOrganization: checked ? this.state.filterOrganization.concat(m) : this.state.filterOrganization.filter((cm)=>cm != m)
                        });
                    },
                    onEditModeChange: (em)=>{
                        this.setState({
                            editMode: em
                        });
                    },
                    onSaveConfigs: ()=>{
                        $4d75faa715a9d2b9$var$saveConfigs(this);
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7e790f65d6f527d$export$2e2bcd8739ae039), {
                    allOrgSelectedConfigEntries: this.state.allOrgSelectedConfigEntries,
                    filterText: this.state.filterText,
                    filterOrganization: this.state.filterOrganization,
                    editMode: this.state.editMode,
                    filterMode: this.state.filterMode,
                    onConfigEntryUpdate: handleConfigEntryUpdate
                })
            ]
        });
    }
}


/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kisy7 = parcelRequire("kisy7");








var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $7c38e60105924096$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.11 8.53 5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47M6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47m1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93"
}), 'RotateLeft');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $0e6e26bd337abb6b$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.55 5.55 11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03m3.89-2.42 1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48"
}), 'RotateRight');



var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");


const $a47d57d25e5ebc7f$var$StyledTextareaAutosize = (0, $d8seH.default)((0, $032c0e7078a9cb7d$export$2e2bcd8739ae039))(({ theme: theme })=>({
        border: `1px solid ${theme.vars.palette.app?.choreBorder}`,
        borderRadius: '6px',
        padding: '12px',
        backgroundColor: 'transparent',
        color: theme.vars.palette.text.primary,
        fontFamily: '"Poppins", sans-serif',
        fontSize: '16px',
        lineHeight: 1.5,
        '&:hover': {
            borderColor: theme.vars.palette.app?.border
        },
        '&:focus': {
            outline: `2px solid ${theme.vars.palette.app?.outline}`,
            borderColor: 'transparent'
        }
    }));
const $a47d57d25e5ebc7f$var$StyledLabel = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039))(({ theme: theme })=>({
        fontSize: '12px',
        lineHeight: '24px',
        color: theme.vars.palette.text.secondary
    }));
/**
 *  TextField from MUI library but with default props and styling
 *  common to the TemplateMod page
 */ const $a47d57d25e5ebc7f$var$QTextArea = ({ lang: lang, label: label, ...ps })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($a47d57d25e5ebc7f$var$StyledLabel, {
                children: label[lang]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a47d57d25e5ebc7f$var$StyledTextareaAutosize, {
                ...ps
            })
        ]
    });
var $a47d57d25e5ebc7f$export$2e2bcd8739ae039 = $a47d57d25e5ebc7f$var$QTextArea;


const $e07b188e89f06a27$var$testA = (0, $kisy7.Lens).fromProp()('a');
// const testB: Lens<TestState,string> = Lens.fromProp<TestState>()('b');
const $e07b188e89f06a27$var$testC = (0, $kisy7.Lens).fromProp()('c');
const $e07b188e89f06a27$var$testD = (0, $kisy7.Lens).fromProp()('d');
const $e07b188e89f06a27$var$modeTransList = [
    {
        key: 'Wall',
        names: {
            eng: 'Wall'
        },
        update: (f)=>console.log(f(''))
    },
    {
        key: 'Panel',
        names: {
            eng: 'Panel'
        },
        update: (f)=>console.log(f(''))
    },
    {
        key: 'Floor Plan',
        names: {
            eng: 'Floor Plan'
        },
        update: (f)=>console.log(f(''))
    }
];
const $e07b188e89f06a27$var$rotateTransList = [
    {
        key: 'Left',
        names: {},
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c38e60105924096$export$2e2bcd8739ae039), {}),
        update: (f)=>console.log(f(''))
    },
    {
        key: 'Right',
        names: {},
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0e6e26bd337abb6b$export$2e2bcd8739ae039), {}),
        update: (f)=>console.log(f(''))
    }
];
const $e07b188e89f06a27$export$479dc530b3dbf38d = ()=>{
    const [test, setTest] = (0, $acw62.useState)({
        a: 1,
        b: 'hello world',
        c: true,
        d: [
            1,
            2,
            3
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                container: true,
                direction: "row",
                justifyContent: "space-evenly",
                sx: {
                    m: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$24d6ae21130964e6), {
                            value: test.a,
                            update: (0, $859db0da13774873$export$2db37b7a33042541)($e07b188e89f06a27$var$testA, setTest)
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $38dec2a12fb5ddbe$export$2e2bcd8739ae039), {
                            value: test.c,
                            update: (0, $859db0da13774873$export$2db37b7a33042541)($e07b188e89f06a27$var$testC, setTest)
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fb08982e4a8dded8$export$30c9fe5d2bff22ce), {
                            converter: (0, $4beeab19e80c1290$export$586f2408ab04b194).mm,
                            value: test.d,
                            update: (0, $859db0da13774873$export$2db37b7a33042541)($e07b188e89f06a27$var$testD, setTest),
                            Edit: (0, $da9256d9077496fe$export$a902121087114074)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                container: true,
                direction: "row",
                justifyContent: "space-evenly",
                sx: {
                    m: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eec4876afb001649$export$2e2bcd8739ae039), {
                            lang: "eng",
                            size: "small",
                            items: $e07b188e89f06a27$var$modeTransList,
                            value: [
                                'Wall'
                            ],
                            update: (f)=>console.log('Q1', f(''))
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eec4876afb001649$export$2e2bcd8739ae039), {
                            lang: "eng",
                            size: "small",
                            items: $e07b188e89f06a27$var$modeTransList,
                            value: 'Wall',
                            update: (f)=>console.log('Q2:', f(''))
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eec4876afb001649$export$2e2bcd8739ae039), {
                            lang: "eng",
                            size: "small",
                            divider: true,
                            label: {
                                eng: 'Rotate'
                            },
                            items: $e07b188e89f06a27$var$rotateTransList,
                            update: (f)=>console.log('Q3', f('Left'))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                container: true,
                direction: "row",
                justifyContent: "space-evenly",
                sx: {
                    m: 1
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a47d57d25e5ebc7f$export$2e2bcd8739ae039), {
                        lang: "eng",
                        label: {
                            eng: 'Unit'
                        },
                        minRows: 3,
                        cols: 30
                    })
                })
            })
        ]
    });
};
var $e07b188e89f06a27$export$2e2bcd8739ae039 = $e07b188e89f06a27$export$479dc530b3dbf38d;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");


var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9901c9510940cf3a$export$b85c003f960b1f3a(slot) {
    return (0, $4Cod0.default)('MuiButtonGroup', slot);
}
const $9901c9510940cf3a$var$buttonGroupClasses = (0, $beCSm.default)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'vertical',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'groupedText',
    'groupedTextHorizontal',
    'groupedTextVertical',
    'groupedTextPrimary',
    'groupedTextSecondary',
    'groupedOutlined',
    'groupedOutlinedHorizontal',
    'groupedOutlinedVertical',
    'groupedOutlinedPrimary',
    'groupedOutlinedSecondary',
    'groupedContained',
    'groupedContainedHorizontal',
    'groupedContainedVertical',
    'groupedContainedPrimary',
    'groupedContainedSecondary',
    'lastButton',
    'middleButton'
]);
var $9901c9510940cf3a$export$2e2bcd8739ae039 = $9901c9510940cf3a$var$buttonGroupClasses;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1c026d95d0d4d482$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "disableRipple",
    "fullWidth",
    "orientation",
    "size",
    "variant"
];
const $1c026d95d0d4d482$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.variant)}${(0, $jTnBY.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.variant)}${(0, $jTnBY.default)(ownerState.color)}`]
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const $1c026d95d0d4d482$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation === 'vertical' && 'vertical',
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $jTnBY.default)(orientation)}`,
            `grouped${(0, $jTnBY.default)(variant)}`,
            `grouped${(0, $jTnBY.default)(variant)}${(0, $jTnBY.default)(orientation)}`,
            `grouped${(0, $jTnBY.default)(variant)}${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9901c9510940cf3a$export$b85c003f960b1f3a), classes);
};
const $1c026d95d0d4d482$var$ButtonGroupRoot = (0, $d8seH.default)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: $1c026d95d0d4d482$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === 'contained' && {
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.disableElevation && {
        boxShadow: 'none'
    }, ownerState.fullWidth && {
        width: '100%'
    }, ownerState.orientation === 'vertical' && {
        flexDirection: 'column'
    }, {
        [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: (0, $8nd05.default)({
            minWidth: 40,
            '&:hover': (0, $8nd05.default)({}, ownerState.variant === 'contained' && {
                boxShadow: 'none'
            })
        }, ownerState.variant === 'contained' && {
            boxShadow: 'none'
        }),
        [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).firstButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: (0, $8nd05.default)({}, ownerState.orientation === 'horizontal' && {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        }, ownerState.orientation === 'vertical' && {
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.variant === 'text' && ownerState.orientation === 'horizontal' && {
            borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
            [`&.${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'text' && ownerState.orientation === 'vertical' && {
            borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
            [`&.${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            borderColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, 0.5)
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
            borderRightColor: 'transparent'
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
            borderBottomColor: 'transparent'
        }, ownerState.variant === 'contained' && ownerState.orientation === 'horizontal' && {
            borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'contained' && ownerState.orientation === 'vertical' && {
            borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            borderColor: (theme.vars || theme).palette[ownerState.color].dark
        }, {
            '&:hover': (0, $8nd05.default)({}, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
                borderRightColor: 'currentColor'
            }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
                borderBottomColor: 'currentColor'
            })
        }),
        [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).lastButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: (0, $8nd05.default)({}, ownerState.orientation === 'horizontal' && {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.orientation === 'vertical' && {
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
            marginLeft: -1
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
            marginTop: -1
        })
    }));
const $1c026d95d0d4d482$var$ButtonGroup = /*#__PURE__*/ $acw62.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = 'horizontal', size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $1En50.default)(props, $1c026d95d0d4d482$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    });
    const classes = $1c026d95d0d4d482$var$useUtilityClasses(ownerState);
    const context = $acw62.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $9b0e6fd5d31b1b95$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1c026d95d0d4d482$var$ButtonGroupRoot, (0, $8nd05.default)({
        as: component,
        role: "group",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8639dcef822d5d4c$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25b1293270900846$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
var $1c026d95d0d4d482$export$2e2bcd8739ae039 = $1c026d95d0d4d482$var$ButtonGroup;











const $61648204ac198534$export$27a5bd065ad55220 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Cols: (0, $87701c398fec8638$export$2f23118c22fb2630)((0, $87701c398fec8638$export$22b082955e083ec3)),
    Rows: (0, $87701c398fec8638$export$2f23118c22fb2630)((0, $87701c398fec8638$export$22b082955e083ec3))
});
const $61648204ac198534$export$9ff8dbe85319c8ac = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('name');
const $61648204ac198534$export$5884f0d75c86f572 = ()=>(0, $58f80d7b57eba59b$export$94132a0e348806d4)('item');
const $61648204ac198534$export$c7bd411105e2dec3 = (item)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        name: (0, $87701c398fec8638$export$22b082955e083ec3),
        item: item
    });
const $61648204ac198534$export$d53d9be948a7219c = (path)=>path.map(({ name: name, item: item })=>`${name}_${$61648204ac198534$export$86b8243918667a3b(item)}`).join('-');
const $61648204ac198534$export$11e8f4826e9b563c = (path)=>path.map(({ name: name, item: item })=>`${name}[${$61648204ac198534$export$1562acadf72f4f6b(item)}]`).join('/');
const $61648204ac198534$var$hasSpace = (s)=>/\s/.test(s);
const $61648204ac198534$export$d84f44fa1bfbb5ce = (plan)=>{
    const props = plan.map(({ name: name })=>name);
    const propsUnique = props.length === new Set(props).size;
    const propsHaveSpace = plan.reduce((acc, { name: name })=>acc || $61648204ac198534$var$hasSpace(name), false);
    const propsValid = !!plan.length && !propsHaveSpace && plan.map(({ name: name, item: item })=>{
        const elems = item.map((0, $58f80d7b57eba59b$export$43f5536de9872e14)($61648204ac198534$export$e52eb0ff232b2a89));
        const elemsHaveSpace = elems.reduce((acc, elem)=>acc || $61648204ac198534$var$hasSpace(elem), false);
        const elemsUnique = elems.length === new Set(elems).size;
        return !elemsHaveSpace && name !== '' && !!item.length && elemsUnique && item.map($61648204ac198534$export$fd1e427916c6e56f).reduce((acc, res)=>acc && res, true);
    }).reduce((acc, res)=>acc && res, true);
    return propsUnique && propsValid;
};
const $61648204ac198534$export$fd1e427916c6e56f = (elem)=>typeof elem === 'string' ? elem !== '' : elem.lbl !== '' && elem.lst.length !== 0;
const $61648204ac198534$export$7c58e9b1273798cb = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MNum'),
    (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MLen'),
    (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MAng'),
    (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MAre')
]);
const $61648204ac198534$export$43d04ebc368cab80 = (val)=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        $61648204ac198534$export$a5873bebbcb2d054(val),
        $61648204ac198534$export$c61058862dac9244(val)
    ]);
const $61648204ac198534$export$a5873bebbcb2d054 = (val)=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        $61648204ac198534$export$e9d8d46fbf5f29f6('REQ', val),
        $61648204ac198534$export$e9d8d46fbf5f29f6('RLT', val),
        $61648204ac198534$export$e9d8d46fbf5f29f6('RGT', val),
        $61648204ac198534$export$e9d8d46fbf5f29f6('RLTE', val),
        $61648204ac198534$export$e9d8d46fbf5f29f6('RGTE', val)
    ]);
const $61648204ac198534$export$c61058862dac9244 = (val)=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        $61648204ac198534$export$ba90ca1dea769eb4('RBound', val),
        $61648204ac198534$export$ba90ca1dea769eb4('RBoundL', val),
        $61648204ac198534$export$ba90ca1dea769eb4('RBoundR', val),
        $61648204ac198534$export$ba90ca1dea769eb4('RBoundEx', val)
    ]);
const $61648204ac198534$export$3da30d0138b046bc = [
    'REQ',
    'RLT',
    'RGT',
    'RLTE',
    'RGTE'
];
const $61648204ac198534$export$d7634cb444fffa9a = [
    'RBound',
    'RBoundL',
    'RBoundR',
    'RBoundEx'
];
const $61648204ac198534$export$75cacde7d227d56 = $61648204ac198534$export$3da30d0138b046bc.concat($61648204ac198534$export$d7634cb444fffa9a);
const $61648204ac198534$export$b7f53471eaf052d9 = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    ...$61648204ac198534$export$75cacde7d227d56.map((n)=>(0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)(n))
]);
const $61648204ac198534$export$da707b495a770a7e = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    ...$61648204ac198534$export$3da30d0138b046bc.map((n)=>(0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)(n))
]);
const $61648204ac198534$export$4e6a2a8d2da4a8b9 = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    ...$61648204ac198534$export$d7634cb444fffa9a.map((n)=>(0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)(n))
]);
const $61648204ac198534$export$c3b681bafe82382 = ()=>(0, $58f80d7b57eba59b$export$94132a0e348806d4)('val');
const $61648204ac198534$export$e9d8d46fbf5f29f6 = (tag, val)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        tag: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)(tag),
        val: val
    });
const $61648204ac198534$export$bb2182dfba3e387a = ()=>(0, $58f80d7b57eba59b$export$94132a0e348806d4)('lo');
const $61648204ac198534$export$43bde67df112d15b = ()=>(0, $58f80d7b57eba59b$export$94132a0e348806d4)('hi');
const $61648204ac198534$export$b2397161918c09c8 = (t)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        lo: t,
        hi: t
    });
const $61648204ac198534$export$7956adc53e510229 = ()=>(0, $58f80d7b57eba59b$export$94132a0e348806d4)('val');
const $61648204ac198534$export$ba90ca1dea769eb4 = (tag, val)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        tag: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)(tag),
        val: $61648204ac198534$export$b2397161918c09c8(val)
    });
const $61648204ac198534$var$showRRange = (cod, range, showT)=>{
    const RS = $61648204ac198534$export$a5873bebbcb2d054(cod);
    if (RS.is(range)) {
        const val = showT(range.val);
        return `${range.tag}_${val}`;
    } else {
        const lo = showT(range.val.lo);
        const hi = showT(range.val.hi);
        return `${range.tag}_${lo}_${hi}`;
    }
};
const $61648204ac198534$export$8ef7c04771804ad0 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    'KSimpl1': (0, $87701c398fec8638$export$98e628dec113755e),
    'KSimpl2': (0, $87701c398fec8638$export$65e3907585753458)([
        (0, $87701c398fec8638$export$98e628dec113755e),
        (0, $87701c398fec8638$export$98e628dec113755e)
    ]),
    'KRange1': $61648204ac198534$export$43d04ebc368cab80((0, $87701c398fec8638$export$98e628dec113755e)),
    'KRange2': $61648204ac198534$export$43d04ebc368cab80((0, $87701c398fec8638$export$65e3907585753458)([
        (0, $87701c398fec8638$export$98e628dec113755e),
        (0, $87701c398fec8638$export$98e628dec113755e)
    ]))
});
const $61648204ac198534$export$4d447730fcec92b8 = (t)=>{
    switch(t){
        case 'KSimpl1':
            return 0, $87701c398fec8638$export$98e628dec113755e;
        case 'KSimpl2':
            return (0, $87701c398fec8638$export$65e3907585753458)([
                (0, $87701c398fec8638$export$98e628dec113755e),
                (0, $87701c398fec8638$export$98e628dec113755e)
            ]);
        case 'KRange1':
            return $61648204ac198534$export$43d04ebc368cab80((0, $87701c398fec8638$export$98e628dec113755e));
        default:
            return $61648204ac198534$export$43d04ebc368cab80((0, $87701c398fec8638$export$65e3907585753458)([
                (0, $87701c398fec8638$export$98e628dec113755e),
                (0, $87701c398fec8638$export$98e628dec113755e)
            ]));
    }
};
const $61648204ac198534$export$98008fe27340ca6f = (t)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        lbl: (0, $87701c398fec8638$export$22b082955e083ec3),
        mag: $61648204ac198534$export$7c58e9b1273798cb,
        knd: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)(t),
        lst: (0, $87701c398fec8638$export$2f23118c22fb2630)($61648204ac198534$export$4d447730fcec92b8(t))
    });
const $61648204ac198534$export$e52eb0ff232b2a89 = (f)=>(el)=>typeof el === 'string' ? f(el) : {
            ...el,
            lbl: f(el.lbl)
        };
const $61648204ac198534$export$32f9a2d836653613 = ()=>(0, $58f80d7b57eba59b$export$94132a0e348806d4)('mag');
const $61648204ac198534$export$3928c747f2969eb6 = ()=>(0, $58f80d7b57eba59b$export$94132a0e348806d4)('lst');
const $61648204ac198534$export$cc2832fafe367c5e = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    (0, $87701c398fec8638$export$22b082955e083ec3),
    $61648204ac198534$export$98008fe27340ca6f('KSimpl1'),
    $61648204ac198534$export$98008fe27340ca6f('KSimpl2'),
    $61648204ac198534$export$98008fe27340ca6f('KRange1'),
    $61648204ac198534$export$98008fe27340ca6f('KRange2')
]);
const $61648204ac198534$export$831bed58a23daa97 = (t)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        lbl: (0, $87701c398fec8638$export$22b082955e083ec3),
        knd: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)(t),
        val: $61648204ac198534$export$4d447730fcec92b8(t)
    });
const $61648204ac198534$export$37ef45a5100a74c8 = (m)=>(f)=>(0, $87701c398fec8638$export$22b082955e083ec3).is(f) ? m(f) : {
            ...f,
            lbl: m(f.lbl)
        };
const $61648204ac198534$export$2b84a6c9117bf0f5 = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    (0, $87701c398fec8638$export$22b082955e083ec3),
    $61648204ac198534$export$831bed58a23daa97('KSimpl1'),
    $61648204ac198534$export$831bed58a23daa97('KSimpl2'),
    $61648204ac198534$export$831bed58a23daa97('KRange1'),
    $61648204ac198534$export$831bed58a23daa97('KRange2')
]);
const $61648204ac198534$export$4b2950bdac9b6ee9 = (0, $87701c398fec8638$export$2f23118c22fb2630)($61648204ac198534$export$c7bd411105e2dec3($61648204ac198534$export$2b84a6c9117bf0f5));
const $61648204ac198534$export$814cc77def5a44df = (0, $87701c398fec8638$export$2f23118c22fb2630)($61648204ac198534$export$c7bd411105e2dec3((0, $87701c398fec8638$export$2f23118c22fb2630)($61648204ac198534$export$cc2832fafe367c5e)));
const $61648204ac198534$export$86b8243918667a3b = (frag)=>(0, $87701c398fec8638$export$22b082955e083ec3).is(frag) ? frag : `${frag.lbl}~${$61648204ac198534$export$c4ef64f5226904cb(frag.knd, frag.val)}`;
const $61648204ac198534$export$c4ef64f5226904cb = (_, val)=>{
    if ($61648204ac198534$export$4d447730fcec92b8('KSimpl1').is(val)) return $61648204ac198534$var$strNumbr(val);
    else if ($61648204ac198534$export$4d447730fcec92b8('KSimpl2').is(val)) return $61648204ac198534$var$showPair(val);
    else if ($61648204ac198534$export$4d447730fcec92b8('KRange1').is(val)) return $61648204ac198534$var$showRRange((0, $87701c398fec8638$export$98e628dec113755e), val, $61648204ac198534$var$strNumbr);
    else return $61648204ac198534$var$showRRange((0, $87701c398fec8638$export$65e3907585753458)([
        (0, $87701c398fec8638$export$98e628dec113755e),
        (0, $87701c398fec8638$export$98e628dec113755e)
    ]), val, $61648204ac198534$var$showPair);
};
const $61648204ac198534$var$showPair = ([fst, snd])=>`${$61648204ac198534$var$strNumbr(fst)}_${$61648204ac198534$var$strNumbr(snd)}`;
const $61648204ac198534$var$strNumbr = (n)=>Math.round(n) === n ? n + '.0' : n.toString();
const $61648204ac198534$export$1562acadf72f4f6b = (frag)=>{
    if ((0, $87701c398fec8638$export$22b082955e083ec3).is(frag)) return frag;
    else if ($61648204ac198534$export$831bed58a23daa97('KSimpl1').is(frag)) return `${frag.lbl}:${frag.val}`;
    else if ($61648204ac198534$export$831bed58a23daa97('KSimpl2').is(frag)) return `${frag.lbl}:${frag.val[0]}x${frag.val[1]}`;
    else if ($61648204ac198534$export$831bed58a23daa97('KRange1').is(frag)) return `${frag.lbl}:${$61648204ac198534$export$9ff489e82b5de642((0, $87701c398fec8638$export$98e628dec113755e), frag.val, (n)=>`${n}`)}`;
    else return `${frag.lbl}:${$61648204ac198534$export$9ff489e82b5de642((0, $87701c398fec8638$export$65e3907585753458)([
        (0, $87701c398fec8638$export$98e628dec113755e),
        (0, $87701c398fec8638$export$98e628dec113755e)
    ]), frag.val, (n)=>`${n[0]}x${n[1]}`)}`;
};
const $61648204ac198534$export$9ff489e82b5de642 = (cod, range, showT)=>{
    const RS = $61648204ac198534$export$a5873bebbcb2d054(cod);
    if (RS.is(range)) {
        const val = showT(range.val);
        switch(range.tag){
            case 'REQ':
                return `(= ${val})`;
            case 'RLT':
                return `(< ${val})`;
            case 'RGT':
                return `(> ${val})`;
            case 'RLTE':
                return `(\u{2264} ${val})`;
            case 'RGTE':
                return `(\u{2265} ${val})`;
        }
    } else {
        const lo = showT(range.val.lo);
        const hi = showT(range.val.hi);
        switch(range.tag){
            case 'RBound':
                return `[${lo} , ${hi}]`;
            case 'RBoundL':
                return `[${lo} , ${hi}\u{3009}`;
            case 'RBoundR':
                return `\u{3008}${lo} , ${hi}]`;
            case 'RBoundEx':
                return `\u{3008}${lo} , ${hi}\u{3009}`;
        }
    }
};


const $96bbda84cddc9285$export$d49461dfcce6c57b = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    kind: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Bool')
});
const $96bbda84cddc9285$export$95e99e299bd78ccf = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    kind: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Price')
});
const $96bbda84cddc9285$export$22789cc21136a310 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    kind: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Double')
});
const $96bbda84cddc9285$export$5db5918b76e12315 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('fst');
const $96bbda84cddc9285$export$626746f82a6b424a = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('snd');
const $96bbda84cddc9285$export$a84bdc57c5122798 = (0, $87701c398fec8638$export$74c5cab0f9a94551)('Kind', (self)=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        $96bbda84cddc9285$export$d49461dfcce6c57b,
        $96bbda84cddc9285$export$95e99e299bd78ccf,
        $96bbda84cddc9285$export$22789cc21136a310,
        (0, $87701c398fec8638$export$bf9fb029d174d554)({
            kind: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Tuple'),
            fst: self,
            snd: self
        })
    ]));
const $96bbda84cddc9285$export$2c141edbf364223f = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    kind: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Tuple'),
    fst: $96bbda84cddc9285$export$a84bdc57c5122798,
    snd: $96bbda84cddc9285$export$a84bdc57c5122798
});
const $96bbda84cddc9285$export$8ef7c04771804ad0 = (0, $87701c398fec8638$export$74c5cab0f9a94551)('KindT', (self)=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        (0, $87701c398fec8638$export$4a21f16c33752377),
        (0, $520c48df756a1a3e$export$3f58fdce283c1f4c),
        (0, $87701c398fec8638$export$98e628dec113755e),
        (0, $87701c398fec8638$export$65e3907585753458)([
            self,
            self
        ])
    ]));
const $96bbda84cddc9285$export$a1a1317e0e00857e = (tm)=>([fst, snd])=>[
            tm(fst),
            snd
        ];
const $96bbda84cddc9285$export$e31863d491ac5fa3 = (tm)=>([fst, snd])=>[
            fst,
            tm(snd)
        ];
const $96bbda84cddc9285$export$e0f247785fa80381 = (0, $87701c398fec8638$export$65e3907585753458)([
    $96bbda84cddc9285$export$8ef7c04771804ad0,
    $96bbda84cddc9285$export$8ef7c04771804ad0
]);
const $96bbda84cddc9285$export$182a4a1189c4a804 = (kind)=>{
    if ($96bbda84cddc9285$export$d49461dfcce6c57b.is(kind)) return false;
    else if ($96bbda84cddc9285$export$95e99e299bd78ccf.is(kind)) return {
        USD: '0'
    };
    else if ($96bbda84cddc9285$export$22789cc21136a310.is(kind)) return 0;
    else return [
        $96bbda84cddc9285$export$182a4a1189c4a804(kind.fst),
        $96bbda84cddc9285$export$182a4a1189c4a804(kind.snd)
    ];
};
const $96bbda84cddc9285$export$74b23887338b0190 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Grid: (0, $87701c398fec8638$export$22b082955e083ec3)
});
const $96bbda84cddc9285$export$56194e34a176ec43 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Elems');
const $96bbda84cddc9285$export$b2fa9b5bb9b9fe2c = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Id: (0, $87701c398fec8638$export$22b082955e083ec3),
    Zone: (0, $87701c398fec8638$export$22b082955e083ec3),
    Name: (0, $87701c398fec8638$export$22b082955e083ec3),
    Elems: (0, $87701c398fec8638$export$2f23118c22fb2630)($96bbda84cddc9285$export$74b23887338b0190)
});
const $96bbda84cddc9285$export$33cd80f3258e17d7 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Id');
const $96bbda84cddc9285$export$eb3887e98f2af0d8 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Name');
const $96bbda84cddc9285$export$e83c752e6d837e8c = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Plan');
const $96bbda84cddc9285$export$dfac6a454fcc5ba4 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Kind');
const $96bbda84cddc9285$export$ce0a655b3d1245c9 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Many');
const $96bbda84cddc9285$export$b4aa207d76251bd9 = (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('View');
const $96bbda84cddc9285$export$63a8e1e2f31d2a3 = (0, $87701c398fec8638$export$bc86dfbf7795668c)([
    (0, $87701c398fec8638$export$bf9fb029d174d554)({
        Id: (0, $87701c398fec8638$export$22b082955e083ec3),
        Name: (0, $87701c398fec8638$export$22b082955e083ec3),
        Plan: (0, $61648204ac198534$export$814cc77def5a44df),
        Kind: $96bbda84cddc9285$export$a84bdc57c5122798,
        Many: (0, $87701c398fec8638$export$4a21f16c33752377)
    }),
    (0, $87701c398fec8638$export$e45945969df8035a)({
        view: (0, $61648204ac198534$export$27a5bd065ad55220)
    })
]);
const $96bbda84cddc9285$export$31ab31c01c517be2 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Id: (0, $87701c398fec8638$export$22b082955e083ec3),
    Grid: (0, $87701c398fec8638$export$22b082955e083ec3),
    Path: (0, $61648204ac198534$export$4b2950bdac9b6ee9),
    Value: $96bbda84cddc9285$export$8ef7c04771804ad0
});
const $96bbda84cddc9285$export$a84a8011a7cb14e5 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Value');
const $96bbda84cddc9285$export$743680dfb6d971a9 = (gid, path)=>`grid-${gid}_path-${(0, $61648204ac198534$export$d53d9be948a7219c)(path)}`;
const $96bbda84cddc9285$export$b4e81cf3c71a88d0 = (knd, gid, path)=>({
        Id: $96bbda84cddc9285$export$743680dfb6d971a9(gid, path),
        Grid: gid,
        Path: path,
        Value: $96bbda84cddc9285$export$182a4a1189c4a804(knd)
    });


const $246cd4dea00cb67d$export$f59fd0025e3090ce = (req)=>req.request((0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $96bbda84cddc9285$export$b2fa9b5bb9b9fe2c)))('pricing/list/all', 'GET');
const $246cd4dea00cb67d$export$65c6a40128a7bab2 = (req)=>req.request((0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $96bbda84cddc9285$export$63a8e1e2f31d2a3)))('pricing/grid/all', 'GET');
const $246cd4dea00cb67d$export$5a6efa689e9084a4 = (req)=>(gid)=>req.request((0, $96bbda84cddc9285$export$63a8e1e2f31d2a3))(`pricing/grid/${gid}`, 'GET');
const $246cd4dea00cb67d$export$6f6f9ed9399dc743 = (req)=>(lid)=>req.request((0, $96bbda84cddc9285$export$b2fa9b5bb9b9fe2c))(`pricing/list/${lid}`, 'GET');
const $246cd4dea00cb67d$export$51dda5f0ca4b2617 = (req)=>(gid)=>req.request((0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $96bbda84cddc9285$export$31ab31c01c517be2)))(`pricing/item/all/${gid}`, 'GET');
const $246cd4dea00cb67d$export$abcfe34c125e2627 = (req)=>(iid)=>req.request((0, $96bbda84cddc9285$export$31ab31c01c517be2))(`pricing/item/${iid}`, 'GET');
const $246cd4dea00cb67d$export$b72a16247da44dc2 = (req)=>(itm)=>req.request((0, $96bbda84cddc9285$export$31ab31c01c517be2))('pricing/item/', 'POST', itm);
const $246cd4dea00cb67d$export$ebc68508096cea69 = (req)=>(grd)=>req.request((0, $96bbda84cddc9285$export$63a8e1e2f31d2a3))('pricing/grid/', 'POST', grd);
const $246cd4dea00cb67d$export$84866d7e17bbd365 = (req)=>(lst)=>req.request((0, $96bbda84cddc9285$export$b2fa9b5bb9b9fe2c))('pricing/list/', 'POST', lst);
const $246cd4dea00cb67d$export$6590f2463d751970 = (req)=>(gid)=>req.request((0, $96bbda84cddc9285$export$63a8e1e2f31d2a3))(`pricing/grid/${gid}`, 'DELETE');
const $246cd4dea00cb67d$export$536ddde8a6f56d5f = (req)=>(iid)=>req.request((0, $96bbda84cddc9285$export$31ab31c01c517be2))(`pricing/item/${iid}`, 'DELETE');



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3e2d01fd3f88b8c8$export$315cb19215f77ce0(slot) {
    return (0, $4Cod0.default)('MuiTable', slot);
}
const $3e2d01fd3f88b8c8$var$tableClasses = (0, $beCSm.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $3e2d01fd3f88b8c8$export$2e2bcd8739ae039 = $3e2d01fd3f88b8c8$var$tableClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $22fefd5f207422b3$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $22fefd5f207422b3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3e2d01fd3f88b8c8$export$315cb19215f77ce0), classes);
};
const $22fefd5f207422b3$var$TableRoot = (0, $d8seH.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': (0, $8nd05.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        })
    }, ownerState.stickyHeader && {
        borderCollapse: 'separate'
    }));
const $22fefd5f207422b3$var$defaultComponent = 'table';
const $22fefd5f207422b3$var$Table = /*#__PURE__*/ $acw62.forwardRef(function Table(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $22fefd5f207422b3$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false } = props, other = (0, $1En50.default)(props, $22fefd5f207422b3$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $22fefd5f207422b3$var$useUtilityClasses(ownerState);
    const table = $acw62.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e848e543ed3bf349$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($22fefd5f207422b3$var$TableRoot, (0, $8nd05.default)({
            as: component,
            role: component === $22fefd5f207422b3$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $22fefd5f207422b3$export$2e2bcd8739ae039 = $22fefd5f207422b3$var$Table;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9a6742b7048414d1$export$98bd2a9b566ec665(slot) {
    return (0, $4Cod0.default)('MuiTableBody', slot);
}
const $9a6742b7048414d1$var$tableBodyClasses = (0, $beCSm.default)('MuiTableBody', [
    'root'
]);
var $9a6742b7048414d1$export$2e2bcd8739ae039 = $9a6742b7048414d1$var$tableBodyClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $09d8a23708c3ccc9$var$_excluded = [
    "className",
    "component"
];
const $09d8a23708c3ccc9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9a6742b7048414d1$export$98bd2a9b566ec665), classes);
};
const $09d8a23708c3ccc9$var$TableBodyRoot = (0, $d8seH.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-row-group'
});
const $09d8a23708c3ccc9$var$tablelvl2 = {
    variant: 'body'
};
const $09d8a23708c3ccc9$var$defaultComponent = 'tbody';
const $09d8a23708c3ccc9$var$TableBody = /*#__PURE__*/ $acw62.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $09d8a23708c3ccc9$var$defaultComponent } = props, other = (0, $1En50.default)(props, $09d8a23708c3ccc9$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $09d8a23708c3ccc9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09fe163f52c859c8$export$2e2bcd8739ae039).Provider, {
        value: $09d8a23708c3ccc9$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($09d8a23708c3ccc9$var$TableBodyRoot, (0, $8nd05.default)({
            className: (0, $9QePP.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $09d8a23708c3ccc9$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $09d8a23708c3ccc9$export$2e2bcd8739ae039 = $09d8a23708c3ccc9$var$TableBody;




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fdf044e88b1c9ad4$export$eed427986a7abdf9(slot) {
    return (0, $4Cod0.default)('MuiTableContainer', slot);
}
const $fdf044e88b1c9ad4$var$tableContainerClasses = (0, $beCSm.default)('MuiTableContainer', [
    'root'
]);
var $fdf044e88b1c9ad4$export$2e2bcd8739ae039 = $fdf044e88b1c9ad4$var$tableContainerClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5d7964a6269b66c8$var$_excluded = [
    "className",
    "component"
];
const $5d7964a6269b66c8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fdf044e88b1c9ad4$export$eed427986a7abdf9), classes);
};
const $5d7964a6269b66c8$var$TableContainerRoot = (0, $d8seH.default)('div', {
    name: 'MuiTableContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    width: '100%',
    overflowX: 'auto'
});
const $5d7964a6269b66c8$var$TableContainer = /*#__PURE__*/ $acw62.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $1En50.default)(props, $5d7964a6269b66c8$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $5d7964a6269b66c8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5d7964a6269b66c8$var$TableContainerRoot, (0, $8nd05.default)({
        ref: ref,
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
var $5d7964a6269b66c8$export$2e2bcd8739ae039 = $5d7964a6269b66c8$var$TableContainer;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $cf1017f12785ebe4$export$2e731cea2d1c2392(slot) {
    return (0, $4Cod0.default)('MuiTableHead', slot);
}
const $cf1017f12785ebe4$var$tableHeadClasses = (0, $beCSm.default)('MuiTableHead', [
    'root'
]);
var $cf1017f12785ebe4$export$2e2bcd8739ae039 = $cf1017f12785ebe4$var$tableHeadClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c9c28a8e795911dc$var$_excluded = [
    "className",
    "component"
];
const $c9c28a8e795911dc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $cf1017f12785ebe4$export$2e731cea2d1c2392), classes);
};
const $c9c28a8e795911dc$var$TableHeadRoot = (0, $d8seH.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-header-group'
});
const $c9c28a8e795911dc$var$tablelvl2 = {
    variant: 'head'
};
const $c9c28a8e795911dc$var$defaultComponent = 'thead';
const $c9c28a8e795911dc$var$TableHead = /*#__PURE__*/ $acw62.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $c9c28a8e795911dc$var$defaultComponent } = props, other = (0, $1En50.default)(props, $c9c28a8e795911dc$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $c9c28a8e795911dc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09fe163f52c859c8$export$2e2bcd8739ae039).Provider, {
        value: $c9c28a8e795911dc$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c9c28a8e795911dc$var$TableHeadRoot, (0, $8nd05.default)({
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            role: component === $c9c28a8e795911dc$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $c9c28a8e795911dc$export$2e2bcd8739ae039 = $c9c28a8e795911dc$var$TableHead;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $321d86e199abda5b$export$ba0a6d6c28940107(slot) {
    return (0, $4Cod0.default)('MuiTableRow', slot);
}
const $321d86e199abda5b$var$tableRowClasses = (0, $beCSm.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $321d86e199abda5b$export$2e2bcd8739ae039 = $321d86e199abda5b$var$tableRowClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $22705465ad6920f8$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $22705465ad6920f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $321d86e199abda5b$export$ba0a6d6c28940107), classes);
};
const $22705465ad6920f8$var$TableRowRoot = (0, $d8seH.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $321d86e199abda5b$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $321d86e199abda5b$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $22705465ad6920f8$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $22705465ad6920f8$var$TableRow = /*#__PURE__*/ $acw62.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $22705465ad6920f8$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $1En50.default)(props, $22705465ad6920f8$var$_excluded);
    const tablelvl2 = $acw62.useContext((0, $09fe163f52c859c8$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    });
    const classes = $22705465ad6920f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($22705465ad6920f8$var$TableRowRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        role: component === $22705465ad6920f8$var$defaultComponent ? null : 'row',
        ownerState: ownerState
    }, other));
});
var $22705465ad6920f8$export$2e2bcd8739ae039 = $22705465ad6920f8$var$TableRow;






var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $938b1427b9e9a19f$export$5269a5bce2c2f987(slot) {
    return (0, $4Cod0.default)('MuiAlertTitle', slot);
}
const $938b1427b9e9a19f$var$alertTitleClasses = (0, $beCSm.default)('MuiAlertTitle', [
    'root'
]);
var $938b1427b9e9a19f$export$2e2bcd8739ae039 = $938b1427b9e9a19f$var$alertTitleClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $cbe9496169f0560d$var$_excluded = [
    "className"
];
const $cbe9496169f0560d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $938b1427b9e9a19f$export$5269a5bce2c2f987), classes);
};
const $cbe9496169f0560d$var$AlertTitleRoot = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: 'MuiAlertTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
});
const $cbe9496169f0560d$var$AlertTitle = /*#__PURE__*/ $acw62.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAlertTitle'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $cbe9496169f0560d$var$_excluded);
    const ownerState = props;
    const classes = $cbe9496169f0560d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cbe9496169f0560d$var$AlertTitleRoot, (0, $8nd05.default)({
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other));
});
var $cbe9496169f0560d$export$2e2bcd8739ae039 = $cbe9496169f0560d$var$AlertTitle;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e56e43dd06ac0faa$export$72aef224d6115253(slot) {
    return (0, $4Cod0.default)('MuiTab', slot);
}
const $e56e43dd06ac0faa$var$tabClasses = (0, $beCSm.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper'
]);
var $e56e43dd06ac0faa$export$2e2bcd8739ae039 = $e56e43dd06ac0faa$var$tabClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e6a3a0c577f6eee9$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $e6a3a0c577f6eee9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $jTnBY.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        iconWrapper: [
            'iconWrapper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e56e43dd06ac0faa$export$72aef224d6115253), classes);
};
const $e6a3a0c577f6eee9$var$TabRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $jTnBY.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).iconWrapper}`]: styles.iconWrapper
            }
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center'
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).iconWrapper}`]: (0, $8nd05.default)({}, ownerState.iconPosition === 'top' && {
            marginBottom: 6
        }, ownerState.iconPosition === 'bottom' && {
            marginTop: 6
        }, ownerState.iconPosition === 'start' && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === 'end' && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === 'inherit' && {
        color: 'inherit',
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === 'primary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === 'secondary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: 'none'
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $e6a3a0c577f6eee9$var$Tab = /*#__PURE__*/ $acw62.forwardRef(function Tab(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false } = props, other = (0, $1En50.default)(props, $e6a3a0c577f6eee9$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $e6a3a0c577f6eee9$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $acw62.isValidElement(iconProp) ? /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e6a3a0c577f6eee9$var$TabRoot, (0, $8nd05.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $e6a3a0c577f6eee9$export$2e2bcd8739ae039 = $e6a3a0c577f6eee9$var$Tab;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


// Source from https://github.com/alitaheri/normalize-scroll-left
let $5929c7187933e9a1$var$cachedType;
function $5929c7187933e9a1$export$a10970ffb6510128() {
    if ($5929c7187933e9a1$var$cachedType) return $5929c7187933e9a1$var$cachedType;
    const dummy = document.createElement('div');
    const container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    $5929c7187933e9a1$var$cachedType = 'reverse';
    if (dummy.scrollLeft > 0) $5929c7187933e9a1$var$cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $5929c7187933e9a1$var$cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return $5929c7187933e9a1$var$cachedType;
}
function $5929c7187933e9a1$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== 'rtl') return scrollLeft;
    const type = $5929c7187933e9a1$export$a10970ffb6510128();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $f2ff3c73ed46b37c$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $f2ff3c73ed46b37c$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $f2ff3c73ed46b37c$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f4c90fbbf54d23af$var$_excluded = [
    "onChange"
];
const $f4c90fbbf54d23af$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $f4c90fbbf54d23af$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $1En50.default)(props, $f4c90fbbf54d23af$var$_excluded);
    const scrollbarHeight = $acw62.useRef();
    const nodeRef = $acw62.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", (0, $8nd05.default)({
        style: $f4c90fbbf54d23af$var$styles
    }, other, {
        ref: nodeRef
    }));
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $b3ef3be5c947a70a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $02d495bb1a743bb2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');




var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $35c7816ebadb07c9$export$34861783d3c2eef8(slot) {
    return (0, $4Cod0.default)('MuiTabScrollButton', slot);
}
const $35c7816ebadb07c9$var$tabScrollButtonClasses = (0, $beCSm.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $35c7816ebadb07c9$export$2e2bcd8739ae039 = $35c7816ebadb07c9$var$tabScrollButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9e031514df70ea8e$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $9e031514df70ea8e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $35c7816ebadb07c9$export$34861783d3c2eef8), classes);
};
const $9e031514df70ea8e$var$TabScrollButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $35c7816ebadb07c9$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === 'vertical' && {
        width: '100%',
        height: 40,
        '& svg': {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $9e031514df70ea8e$var$TabScrollButton = /*#__PURE__*/ $acw62.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $1En50.default)(props, $9e031514df70ea8e$var$_excluded);
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const ownerState = (0, $8nd05.default)({
        isRtl: isRtl
    }, props);
    const classes = $9e031514df70ea8e$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $b3ef3be5c947a70a$export$2e2bcd8739ae039);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $02d495bb1a743bb2$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9e031514df70ea8e$var$TabScrollButtonRoot, (0, $8nd05.default)({
        component: "div",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === 'left' ? /*#__PURE__*/ (0, $ayMG0.jsx)(StartButtonIcon, (0, $8nd05.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $ayMG0.jsx)(EndButtonIcon, (0, $8nd05.default)({}, endButtonIconProps))
    }));
});
var $9e031514df70ea8e$export$2e2bcd8739ae039 = $9e031514df70ea8e$var$TabScrollButton;




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8a85ee70c626268d$export$cdd93bd054dec359(slot) {
    return (0, $4Cod0.default)('MuiTabs', slot);
}
const $8a85ee70c626268d$var$tabsClasses = (0, $beCSm.default)('MuiTabs', [
    'root',
    'vertical',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $8a85ee70c626268d$export$2e2bcd8739ae039 = $8a85ee70c626268d$var$tabsClasses;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7be483edbed3b474$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $7be483edbed3b474$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $7be483edbed3b474$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $7be483edbed3b474$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $7be483edbed3b474$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        flexContainer: [
            'flexContainer',
            vertical && 'flexContainerVertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8a85ee70c626268d$export$cdd93bd054dec359), classes);
};
const $7be483edbed3b474$var$TabsRoot = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $8a85ee70c626268d$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $8a85ee70c626268d$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $8a85ee70c626268d$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        }
    }));
const $7be483edbed3b474$var$TabsScroller = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'relative',
        display: 'inline-block',
        flex: '1 1 auto',
        whiteSpace: 'nowrap'
    }, ownerState.fixed && {
        overflowX: 'hidden',
        width: '100%'
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: 'none',
        // Firefox
        '&::-webkit-scrollbar': {
            display: 'none' // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: 'auto',
        overflowY: 'hidden'
    }, ownerState.scrollableY && {
        overflowY: 'auto',
        overflowX: 'hidden'
    }));
const $7be483edbed3b474$var$FlexContainer = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'FlexContainer',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.centered && {
        justifyContent: 'center'
    }));
const $7be483edbed3b474$var$TabsIndicator = (0, $d8seH.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === 'primary' && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === 'secondary' && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: '100%',
        width: 2,
        right: 0
    }));
const $7be483edbed3b474$var$TabsScrollbarSize = (0, $d8seH.default)((0, $f4c90fbbf54d23af$export$2e2bcd8739ae039))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $7be483edbed3b474$var$defaultIndicatorStyle = {};
let $7be483edbed3b474$var$warnedOnceTabPresent = false;
const $7be483edbed3b474$var$Tabs = /*#__PURE__*/ $acw62.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent = (0, $9e031514df70ea8e$export$2e2bcd8739ae039), scrollButtons: scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false } = props, other = (0, $1En50.default)(props, $7be483edbed3b474$var$_excluded);
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $7be483edbed3b474$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $acw62.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $acw62.useState($7be483edbed3b474$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $acw62.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $acw62.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $acw62.useState(false);
    const [scrollerStyle, setScrollerStyle] = $acw62.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $acw62.useRef(null);
    const tabListRef = $acw62.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $5929c7187933e9a1$export$3c615b88e5d7e4f6)(tabsNode, isRtl ? 'rtl' : 'ltr'),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $331f3746e6346411$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $f2ff3c73ed46b37c$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $5929c7187933e9a1$export$a10970ffb6510128)() === 'reverse' ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $acw62.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $9QePP.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonComponent, (0, $8nd05.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $9QePP.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonComponent, (0, $8nd05.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $9QePP.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $331f3746e6346411$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $331f3746e6346411$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $acw62.useEffect(()=>{
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $acw62.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $acw62.useEffect(()=>{
        setMounted(true);
    }, []);
    $acw62.useEffect(()=>{
        updateIndicatorState();
    });
    $acw62.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($7be483edbed3b474$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $acw62.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$TabsIndicator, (0, $8nd05.default)({}, TabIndicatorProps, {
        className: (0, $9QePP.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $8nd05.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $acw62.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $acw62.cloneElement(child, (0, $8nd05.default)({
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7be483edbed3b474$var$TabsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $ayMG0.jsxs)($7be483edbed3b474$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $7be483edbed3b474$export$2e2bcd8739ae039 = $7be483edbed3b474$var$Tabs;












var $621fb6a237b62b7c$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($621fb6a237b62b7c$exports, "__esModule", {
    value: true
});
$621fb6a237b62b7c$exports.default = void 0;

var $621fb6a237b62b7c$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $621fb6a237b62b7c$var$_default = $621fb6a237b62b7c$exports.default = (0, $621fb6a237b62b7c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1M8 13h8v-2H8zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5"
}), 'Link');


var $b86da8ab684d120a$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($b86da8ab684d120a$exports, "__esModule", {
    value: true
});
$b86da8ab684d120a$exports.default = void 0;

var $b86da8ab684d120a$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b86da8ab684d120a$var$_default = $b86da8ab684d120a$exports.default = (0, $b86da8ab684d120a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-.98 2.63-2.31 2.98l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5m-1 4h-2.19l2 2H16zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74 3.27 3z"
}), 'LinkOff');




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3a31c1516a2c01e5$export$5e57a444791c63be(slot) {
    return (0, $4Cod0.default)('MuiDialogActions', slot);
}
const $3a31c1516a2c01e5$var$dialogActionsClasses = (0, $beCSm.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $3a31c1516a2c01e5$export$2e2bcd8739ae039 = $3a31c1516a2c01e5$var$dialogActionsClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $207bc6ab7c60f4b2$var$_excluded = [
    "className",
    "disableSpacing"
];
const $207bc6ab7c60f4b2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3a31c1516a2c01e5$export$5e57a444791c63be), classes);
};
const $207bc6ab7c60f4b2$var$DialogActionsRoot = (0, $d8seH.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $207bc6ab7c60f4b2$var$DialogActions = /*#__PURE__*/ $acw62.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $1En50.default)(props, $207bc6ab7c60f4b2$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $207bc6ab7c60f4b2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($207bc6ab7c60f4b2$var$DialogActionsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $207bc6ab7c60f4b2$export$2e2bcd8739ae039 = $207bc6ab7c60f4b2$var$DialogActions;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c877f2cebcabf5cb$export$61b0ee1f05fb344e(slot) {
    return (0, $4Cod0.default)('MuiDialogContent', slot);
}
const $c877f2cebcabf5cb$var$dialogContentClasses = (0, $beCSm.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $c877f2cebcabf5cb$export$2e2bcd8739ae039 = $c877f2cebcabf5cb$var$dialogContentClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4fa8e9c420cdee0a$var$_excluded = [
    "className",
    "dividers"
];
const $4fa8e9c420cdee0a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c877f2cebcabf5cb$export$61b0ee1f05fb344e), classes);
};
const $4fa8e9c420cdee0a$var$DialogContentRoot = (0, $d8seH.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $f2e7257b2514744a$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $4fa8e9c420cdee0a$var$DialogContent = /*#__PURE__*/ $acw62.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $1En50.default)(props, $4fa8e9c420cdee0a$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        dividers: dividers
    });
    const classes = $4fa8e9c420cdee0a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4fa8e9c420cdee0a$var$DialogContentRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $4fa8e9c420cdee0a$export$2e2bcd8739ae039 = $4fa8e9c420cdee0a$var$DialogContent;






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");













var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $jTnBY = parcelRequire("jTnBY");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5f063e1b0f6d278b$export$39f6debbec19b3ba(slot) {
    return (0, $4Cod0.default)('MuiSwitch', slot);
}
const $5f063e1b0f6d278b$var$switchClasses = (0, $beCSm.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $5f063e1b0f6d278b$export$2e2bcd8739ae039 = $5f063e1b0f6d278b$var$switchClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $56ccc0421702a0be$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $56ccc0421702a0be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $jTnBY.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $5f063e1b0f6d278b$export$39f6debbec19b3ba), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $56ccc0421702a0be$var$SwitchRoot = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $56ccc0421702a0be$var$SwitchSwitchBase = (0, $d8seH.default)((0, $f3bdb1b636c81735$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked} + .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).disabled} + .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    }), ({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $kSnzZ.lighten)(theme.palette[color].main, 0.62) : (0, $kSnzZ.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked} + .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    }));
const $56ccc0421702a0be$var$SwitchTrack = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    }));
const $56ccc0421702a0be$var$SwitchThumb = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    }));
const $56ccc0421702a0be$var$Switch = /*#__PURE__*/ $acw62.forwardRef(function Switch(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx } = props, other = (0, $1En50.default)(props, $56ccc0421702a0be$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $56ccc0421702a0be$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($56ccc0421702a0be$var$SwitchRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchSwitchBase, (0, $8nd05.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $8nd05.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $56ccc0421702a0be$export$2e2bcd8739ae039 = $56ccc0421702a0be$var$Switch;







var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $eb92927349f9b82b$export$35e82fe41a9c438;
$eb92927349f9b82b$export$35e82fe41a9c438 = `_0QYY7G_kind-edit`;




const $6e0fce0974169c32$var$KindEdit = ({ value: value, update: update })=>{
    const opts = [
        'Bool',
        'Price',
        'Double',
        'Tuple'
    ];
    const selected = (0, $96bbda84cddc9285$export$d49461dfcce6c57b).is(value) ? 'Bool' : (0, $96bbda84cddc9285$export$95e99e299bd78ccf).is(value) ? 'Price' : (0, $96bbda84cddc9285$export$22789cc21136a310).is(value) ? 'Double' : 'Tuple';
    const handleChange = (evt)=>{
        switch(evt.target.value){
            case 'Bool':
                update(()=>({
                        kind: 'Bool'
                    }));
                break;
            case 'Price':
                update(()=>({
                        kind: 'Price'
                    }));
                break;
            case 'Double':
                update(()=>({
                        kind: 'Double'
                    }));
                break;
            default:
                update(()=>({
                        kind: 'Tuple',
                        fst: {
                            kind: 'Price'
                        },
                        snd: {
                            kind: 'Price'
                        }
                    }));
        }
    };
    const tuple = !(0, $96bbda84cddc9285$export$2c141edbf364223f).is(value) ? null : /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6e0fce0974169c32$var$KindEdit, {
                    value: value.fst,
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $96bbda84cddc9285$export$5db5918b76e12315))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6e0fce0974169c32$var$KindEdit, {
                    value: value.snd,
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $96bbda84cddc9285$export$626746f82a6b424a))
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        className: "kind-edit",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                        onChange: handleChange,
                        value: selected,
                        children: opts.map((lbl)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: lbl,
                                children: lbl
                            }, lbl))
                    })
                }),
                tuple
            ]
        })
    });
};
var $6e0fce0974169c32$export$2e2bcd8739ae039 = $6e0fce0974169c32$var$KindEdit;


/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");




function $5941f8069797d75c$var$quickSwap(list, x, y) {
    if (x < 0 || x >= list.length || y < 0 || y >= list.length) return [
        ...list
    ];
    const swappedList = [
        ...list
    ];
    const temp = swappedList[x];
    swappedList[x] = swappedList[y];
    swappedList[y] = temp;
    return swappedList;
}
function $5941f8069797d75c$var$swapNameElem(elem, x, y) {
    const newItem = {
        ...elem,
        item: $5941f8069797d75c$var$quickSwap(elem.item, x, y).filter((item)=>item !== undefined)
    };
    return newItem;
}
function $5941f8069797d75c$var$swapElemVal(elem, x, y) {
    const newItem = {
        ...elem,
        lst: $5941f8069797d75c$var$quickSwap(elem.lst, x, y)
    };
    return newItem;
}
// The main entry point for the plan builder
const $5941f8069797d75c$var$PlanEdit = ({ value: value, update: update })=>{
    const newItem = {
        name: 'NewItem',
        item: []
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("thead", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                            colSpan: 5,
                            children: "Planner"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "\u2191"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "\u2193"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "Value"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "Del"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "Add"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                children: value.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$ItemEdit, {
                        value: item,
                        update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $58f80d7b57eba59b$export$b610b8812bbcded9)(idx)),
                        remove: ()=>update(()=>value.filter((_el, ix)=>ix !== idx)),
                        swap: (ud)=>update(()=>$5941f8069797d75c$var$quickSwap(value, idx, idx + ud))
                    }, idx))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("tfoot", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        colSpan: 5,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            type: "button",
                            value: "Add",
                            onClick: ()=>update(()=>[
                                        ...value,
                                        newItem
                                    ])
                        })
                    })
                })
            })
        ]
    });
};
// The editor for `Name<Elem[]>`, or a plan property / item.
const $5941f8069797d75c$var$ItemEdit = ({ value: value, update: update, remove: remove, swap: swap })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            onClick: ()=>swap(-1),
                            type: "button",
                            value: "\u2191"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            onClick: ()=>swap(1),
                            type: "button",
                            value: "\u2193"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$TextEdit, {
                            value: value.name,
                            update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $61648204ac198534$export$9ff8dbe85319c8ac))
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            type: "button",
                            value: "Del",
                            onClick: remove
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            type: "button",
                            value: "Add",
                            onClick: ()=>update((0, $61648204ac198534$export$5884f0d75c86f572)()((a)=>[
                                        ...a,
                                        'NewItem'
                                    ]))
                        })
                    })
                ]
            }),
            value.item.map((elem, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$ElemEdit, {
                    value: elem,
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $61648204ac198534$export$5884f0d75c86f572)(), (0, $58f80d7b57eba59b$export$b610b8812bbcded9)(idx)),
                    remove: ()=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $61648204ac198534$export$5884f0d75c86f572)())((es)=>es.filter((_el, ix)=>ix !== idx)),
                    swap: (ud)=>update(()=>$5941f8069797d75c$var$swapNameElem(value, idx, idx + ud))
                }, idx))
        ]
    });
};
// Edior for a single Plan (item / property) element.
const $5941f8069797d75c$var$ElemEdit = ({ value: value, update: update, remove: remove, swap: swap })=>{
    // Is the Elem a label?
    const isLabel = typeof value == 'string';
    // Text for the Elem type toggler.
    const tgLabel = isLabel ? 'VAL' : 'LBL';
    // Actual label of the 'Elem'
    const elLabel = isLabel ? value : value.lbl;
    // Function that returns a value to be used when we switch from label to value and vice versa
    const flipper = ()=>isLabel ? {
            lbl: elLabel,
            mag: 'MNum',
            knd: 'KSimpl1',
            lst: []
        } : elLabel;
    // If we are working with ElemVal's, when we add new element this will create a default value of appropriate kind
    const defItem = ()=>{
        // this should not occur
        if (isLabel) return 0;
        switch(value.knd){
            case 'KSimpl1':
                return 0;
            case 'KSimpl2':
                return [
                    0,
                    0
                ];
            case 'KRange1':
                return {
                    tag: 'REQ',
                    val: 0
                };
            case 'KRange2':
                return {
                    tag: 'REQ',
                    val: [
                        0,
                        0
                    ]
                };
            default:
                return 0;
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            onClick: ()=>swap(-1),
                            type: "button",
                            value: "\u2191"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            onClick: ()=>swap(1),
                            type: "button",
                            value: "\u2193"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "button",
                                value: tgLabel,
                                onClick: ()=>update(flipper)
                            }),
                            isLabel ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$MagEdit, {
                                value: value.mag,
                                update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $61648204ac198534$export$32f9a2d836653613)())
                            }),
                            isLabel ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$KindEdit, {
                                value: value.knd,
                                update: update
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$TextEdit, {
                                value: elLabel,
                                update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $61648204ac198534$export$e52eb0ff232b2a89))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            type: "button",
                            value: "Del",
                            onClick: remove
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        children: isLabel ? null : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            type: "button",
                            value: "Add",
                            onClick: ()=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $61648204ac198534$export$3928c747f2969eb6)())((lst)=>[
                                        ...lst,
                                        defItem()
                                    ])
                        })
                    })
                ]
            }),
            isLabel ? null : value.lst.map((val, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$ValEdit, {
                    value: val,
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $61648204ac198534$export$3928c747f2969eb6)(), (0, $58f80d7b57eba59b$export$b610b8812bbcded9)(idx)),
                    remove: ()=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $61648204ac198534$export$3928c747f2969eb6)())((es)=>es.filter((_el, ix)=>ix !== idx)),
                    swap: (ud)=>update(()=>$5941f8069797d75c$var$swapElemVal(value, idx, idx + ud))
                }, idx))
        ]
    });
};
// Magnitude editor that will change the magnitude of some item element.
const $5941f8069797d75c$var$MagEdit = ({ value: value, update: update })=>{
    const MagOption = ({ name: name })=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
            selected: value === name,
            value: name,
            children: name
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
        onChange: (e)=>update(()=>e.target.value),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(MagOption, {
                name: "MNum"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(MagOption, {
                name: "MLen"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(MagOption, {
                name: "MAng"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(MagOption, {
                name: "MAre"
            })
        ]
    });
};
/*
 *	Kind editor will not only change the kind of the item element, but also the
 *	element itself,	because the element will have different type depending on the
 *	selected kind.
 */ const $5941f8069797d75c$var$KindEdit = ({ value: value, update: update })=>{
    const changeElemKind = (knd)=>(elm)=>typeof elm == 'string' ? elm : {
                ...elm,
                knd: knd,
                lst: []
            };
    const KindOption = ({ name: name })=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
            selected: (0, $58f80d7b57eba59b$export$43f5536de9872e14)((0, $61648204ac198534$export$e52eb0ff232b2a89))(value) === name,
            value: name,
            children: name
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
        onChange: (e)=>update(changeElemKind(e.target.value)),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(KindOption, {
                name: "KSimpl1"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(KindOption, {
                name: "KSimpl2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(KindOption, {
                name: "KRange1"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(KindOption, {
                name: "KRange2"
            })
        ]
    });
};
/*
 *	The value item editor wrapper. It will display appropriate editor for each
 *	kind of value item.
 */ const $5941f8069797d75c$var$ValEdit = ({ remove: remove, swap: swap, value: value, update: update })=>{
    const vitem = ()=>{
        if ((0, $61648204ac198534$export$4d447730fcec92b8)('KSimpl1').is(value)) return /*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$KSimpl1, {
            value: value,
            update: update
        });
        else if ((0, $61648204ac198534$export$4d447730fcec92b8)('KSimpl2').is(value)) return /*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$KSimpl2, {
            value: value,
            update: update
        });
        else if ((0, $61648204ac198534$export$4d447730fcec92b8)('KRange1').is(value)) return /*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$KRange1, {
            value: value,
            update: update
        });
        else return /*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$KRange2, {
            value: value,
            update: update
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    onClick: ()=>swap(-1),
                    type: "button",
                    value: "\u2191"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    onClick: ()=>swap(-1),
                    type: "button",
                    value: "\u2193"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                children: vitem()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    type: "button",
                    value: "Del",
                    onClick: remove
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {})
        ]
    });
};
const $5941f8069797d75c$var$KSimpl1 = ({ value: value, update: update })=>/*#__PURE__*/ (0, $ayMG0.jsx)("input", {
        type: "text",
        value: value,
        onChange: (e)=>update(()=>Number(e.target.value))
    });
const $5941f8069797d75c$var$KSimpl2 = ({ value: value, update: update })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            "(",
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "text",
                value: value[0],
                onChange: (e)=>update((p)=>[
                            Number(e.target.value),
                            p[1]
                        ])
            }),
            ",",
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "text",
                value: value[1],
                onChange: (e)=>update((p)=>[
                            p[0],
                            Number(e.target.value)
                        ])
            }),
            ")"
        ]
    });
const $5941f8069797d75c$var$KRange1 = ({ value: value, update: update })=>{
    const mkr = (r)=>{
        if ((0, $61648204ac198534$export$da707b495a770a7e).is(r)) return {
            tag: r,
            val: 0
        };
        else return {
            tag: r,
            val: {
                lo: 0,
                hi: 1
            }
        };
    };
    if ((0, $61648204ac198534$export$a5873bebbcb2d054)((0, $87701c398fec8638$export$98e628dec113755e)).is(value)) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$Ranger, {
                mkr: mkr,
                value: value,
                update: update
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "text",
                value: value.val,
                onChange: (e)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $61648204ac198534$export$c3b681bafe82382)())(()=>Number(e.target.value))
            })
        ]
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$Ranger, {
                mkr: mkr,
                value: value,
                update: update
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "text",
                value: value.val.lo,
                onChange: (e)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $61648204ac198534$export$7956adc53e510229)(), (0, $61648204ac198534$export$bb2182dfba3e387a)())(()=>Number(e.target.value))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "text",
                value: value.val.hi,
                onChange: (e)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $61648204ac198534$export$7956adc53e510229)(), (0, $61648204ac198534$export$43bde67df112d15b)())(()=>Number(e.target.value))
            })
        ]
    });
};
const $5941f8069797d75c$var$KRange2 = ({ value: value, update: update })=>{
    const mkr = (r)=>{
        if ((0, $61648204ac198534$export$da707b495a770a7e).is(r)) return {
            tag: r,
            val: [
                0,
                0
            ]
        };
        else return {
            tag: r,
            val: {
                lo: [
                    0,
                    0
                ],
                hi: [
                    1,
                    1
                ]
            }
        };
    };
    if ((0, $61648204ac198534$export$a5873bebbcb2d054)((0, $87701c398fec8638$export$65e3907585753458)([
        (0, $87701c398fec8638$export$98e628dec113755e),
        (0, $87701c398fec8638$export$98e628dec113755e)
    ])).is(value)) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$Ranger, {
                mkr: mkr,
                value: value,
                update: update
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$NumPairEdit, {
                value: value.val,
                update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $61648204ac198534$export$c3b681bafe82382)())
            })
        ]
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$Ranger, {
                mkr: mkr,
                value: value,
                update: update
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$NumPairEdit, {
                value: value.val.lo,
                update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $61648204ac198534$export$7956adc53e510229)(), (0, $61648204ac198534$export$bb2182dfba3e387a)())
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($5941f8069797d75c$var$NumPairEdit, {
                value: value.val.hi,
                update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $61648204ac198534$export$7956adc53e510229)(), (0, $61648204ac198534$export$43bde67df112d15b)())
            })
        ]
    });
};
var $5941f8069797d75c$export$2e2bcd8739ae039 = $5941f8069797d75c$var$PlanEdit;
/* UTILITY EDITORS */ const $5941f8069797d75c$var$Ranger = ({ mkr: mkr, value: value, update: update })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
        onChange: (e)=>update(()=>mkr(e.target.value)),
        children: (0, $61648204ac198534$export$75cacde7d227d56).map((tag)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                selected: tag === value.tag,
                value: tag,
                children: tag
            }))
    });
};
const $5941f8069797d75c$var$NumPairEdit = ({ value: value, update: update })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "text",
                value: value[0],
                onChange: (e)=>update((p)=>[
                            Number(e.target.value),
                            p[1]
                        ])
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "text",
                value: value[1],
                onChange: (e)=>update((p)=>[
                            p[0],
                            Number(e.target.value)
                        ])
            })
        ]
    });
const $5941f8069797d75c$var$TextEdit = ({ value: value, update: update })=>/*#__PURE__*/ (0, $ayMG0.jsx)("input", {
        type: "text",
        value: value,
        onChange: (ev)=>update(()=>ev.target.value)
    });




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $93dbcefb30038764$exports = {};

$parcel$export($93dbcefb30038764$exports, "call-checkbox", () => $93dbcefb30038764$export$99e2c05eac68e5c1, (v) => $93dbcefb30038764$export$99e2c05eac68e5c1 = v);
$parcel$export($93dbcefb30038764$exports, "cell-editor", () => $93dbcefb30038764$export$34724039d6073472, (v) => $93dbcefb30038764$export$34724039d6073472 = v);
$parcel$export($93dbcefb30038764$exports, "clicker", () => $93dbcefb30038764$export$c0ec68036f5a21f1, (v) => $93dbcefb30038764$export$c0ec68036f5a21f1 = v);
$parcel$export($93dbcefb30038764$exports, "price-grid", () => $93dbcefb30038764$export$9111db84ebe59d20, (v) => $93dbcefb30038764$export$9111db84ebe59d20 = v);
var $93dbcefb30038764$export$99e2c05eac68e5c1;
var $93dbcefb30038764$export$34724039d6073472;
var $93dbcefb30038764$export$c0ec68036f5a21f1;
var $93dbcefb30038764$export$9111db84ebe59d20;
$93dbcefb30038764$export$99e2c05eac68e5c1 = `jsNmpq_call-checkbox`;
$93dbcefb30038764$export$34724039d6073472 = `jsNmpq_cell-editor`;
$93dbcefb30038764$export$c0ec68036f5a21f1 = `jsNmpq_clicker`;
$93dbcefb30038764$export$9111db84ebe59d20 = `jsNmpq_price-grid`;













var $ayMG0 = parcelRequire("ayMG0");



const $1614aadb7e760801$export$7ba382867b739905 = ({ value: value, update: update, post: post })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                title: "Price in USD",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    type: "number",
                    value: Number(value.USD ?? '0'),
                    onChange: (e)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('USD'), (0, $58f80d7b57eba59b$export$36faa878fcded3d7)('0'))(()=>e.target.value.toString()),
                    onBlur: post
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "call-checkbox",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                    title: "Call",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "checkbox",
                        onChange: (e)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('Call'), (0, $58f80d7b57eba59b$export$36faa878fcded3d7)(false))(()=>e.target.checked),
                        checked: value.Call ?? false,
                        onBlur: post
                    })
                })
            })
        ]
    });
};




var $ayMG0 = parcelRequire("ayMG0");




var $8fe0a98016eeb6bb$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($8fe0a98016eeb6bb$exports, "__esModule", {
    value: true
});
$8fe0a98016eeb6bb$exports.default = void 0;

var $8fe0a98016eeb6bb$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8fe0a98016eeb6bb$var$_default = $8fe0a98016eeb6bb$exports.default = (0, $8fe0a98016eeb6bb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6.99 11 3 15l3.99 4v-3H14v-2H6.99zM21 9l-3.99-4v3H10v2h7.01v3z"
}), 'SwapHoriz');


const $63ab41fd568f4e27$export$36528da08d4fb317 = ({ value: value, update: update })=>{
    const swapCols = ()=>update(()=>({
                Cols: value.Rows,
                Rows: value.Cols
            }));
    const addToRows = (col)=>{
        const newRows = [
            ...value.Rows,
            col
        ];
        const newCols = value.Cols.filter((c)=>c !== col);
        update(()=>({
                Rows: newRows,
                Cols: newCols
            }));
    };
    const addToCols = (row)=>{
        const newRows = value.Rows.filter((r)=>r !== row);
        const newCols = [
            ...value.Cols,
            row
        ];
        update(()=>({
                Rows: newRows,
                Cols: newCols
            }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            flexGrow: 1
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1c026d95d0d4d482$export$2e2bcd8739ae039), {
                        size: "small",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                disabled: true,
                                children: "Rows:"
                            }, "rows"),
                            value.Rows.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                    onClick: ()=>addToCols(r),
                                    children: r
                                }, r))
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8fe0a98016eeb6bb$exports))), {
                        onClick: swapCols
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1c026d95d0d4d482$export$2e2bcd8739ae039), {
                        size: "small",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                disabled: true,
                                children: "Cols:"
                            }, "cols"),
                            value.Cols.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                    onClick: ()=>addToRows(c),
                                    children: c
                                }, c))
                        ]
                    })
                })
            ]
        })
    });
};
var $63ab41fd568f4e27$export$2e2bcd8739ae039 = $63ab41fd568f4e27$export$36528da08d4fb317;


// A little helper for generating arrays of numbers from 0 to Math.abs(n)
const $aee0d1fa0fb821a4$var$arr = (n)=>Array.from({
        length: Math.abs(n)
    }, (_, idx)=>idx);
// Count the number of values in an element.
const $aee0d1fa0fb821a4$var$elemCounter = (elem)=>(0, $87701c398fec8638$export$22b082955e083ec3).is(elem) ? 1 : elem.lst.length;
// Count the number of elements in a single Plan item
const $aee0d1fa0fb821a4$var$itemCounter = (item)=>item.item.reduce((acc, elm)=>acc + $aee0d1fa0fb821a4$var$elemCounter(elm), 0);
// Determine the appropriate grid size for a particular plan and view.
const $aee0d1fa0fb821a4$var$gridSize = (p, v)=>[
        p.filter((n)=>v.Cols.includes(n.name)).reduce((acc, itm)=>acc * $aee0d1fa0fb821a4$var$itemCounter(itm), 1),
        p.filter((n)=>v.Rows.includes(n.name)).reduce((acc, itm)=>acc * $aee0d1fa0fb821a4$var$itemCounter(itm), 1)
    ];
// Get the numerical path
const $aee0d1fa0fb821a4$var$pathArray = (plan, view, [col, row])=>{
    const cspans = $aee0d1fa0fb821a4$var$spans(plan, view.Cols).map(([name, [count, span]])=>[
            name,
            Math.floor(col / span) % count
        ]);
    const rspans = $aee0d1fa0fb821a4$var$spans(plan, view.Rows).map(([name, [count, span]])=>[
            name,
            Math.floor(row / span) % count
        ]);
    const tspans = cspans.concat(rspans);
    return plan.map((item)=>tspans.reduce((acc, [name, index])=>name === item.name ? acc + index : acc, 0));
};
// for each name it returns how many items it has and how many columns to span for each item
const $aee0d1fa0fb821a4$var$spans = (plan, names)=>{
    const counts = names.map((n)=>[
            n,
            plan.filter((itm)=>itm.name === n).reduce((acc, itm)=>acc + $aee0d1fa0fb821a4$var$itemCounter(itm), 0)
        ]);
    return counts.map(([name, count], index)=>{
        const rest = counts.slice(index + 1).reduce((acc, cnt)=>acc * cnt[1], 1);
        return [
            name,
            [
                count,
                rest
            ]
        ];
    });
};
// Creates fragments from a single Plan item
const $aee0d1fa0fb821a4$var$fragment = ({ name: name, item: item })=>item.map((elem)=>{
        if ((0, $87701c398fec8638$export$22b082955e083ec3).is(elem)) return [
            {
                name: name,
                item: elem
            }
        ];
        else return elem.lst.map((val)=>{
            return {
                name: name,
                item: {
                    lbl: elem.lbl,
                    knd: elem.knd,
                    val: val
                }
            };
        });
    }).reduce((res, arr)=>res.concat(arr));
const $aee0d1fa0fb821a4$var$arrayPath2Path = (parray, pfrags)=>$aee0d1fa0fb821a4$var$arr(Math.min(parray.length, pfrags.length)).map((i)=>pfrags[i][parray[i]]);
// Finds fragment from relIndex, then returns header label
const $aee0d1fa0fb821a4$var$makeHeader = (plan, name, idx)=>{
    const item = plan.find((item)=>item.name === name);
    const frags = item ? $aee0d1fa0fb821a4$var$fragment(item) : [];
    const frag = frags[idx];
    return frag ? (0, $61648204ac198534$export$1562acadf72f4f6b)(frag.item) : name + idx;
};
// Padds a table row with a certain amount of <th> elements
const $aee0d1fa0fb821a4$var$Paddington = ({ n: n })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: $aee0d1fa0fb821a4$var$arr(n).map((i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {}, `padding-${i}`))
    });
// Renders the horizontal header
const $aee0d1fa0fb821a4$var$HorizontalHeader = ({ plan: plan, view: view })=>{
    const hdrs = $aee0d1fa0fb821a4$var$spans(plan, view.Cols);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: hdrs.map(([name, [count, span]], idx)=>{
            const mult = hdrs.slice(0, idx).reduce((acc, hdr)=>acc * hdr[1][0], 1);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($aee0d1fa0fb821a4$var$Paddington, {
                        n: view.Rows.length
                    }),
                    $aee0d1fa0fb821a4$var$arr(mult).map((m)=>$aee0d1fa0fb821a4$var$arr(count).map((i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                colSpan: span,
                                className: $93dbcefb30038764$exports[`horiz-header-${idx}`],
                                children: $aee0d1fa0fb821a4$var$makeHeader(plan, name, i)
                            }, `${name}-col-${i}-${m}`))).reduce((res, itr)=>res.concat(itr), [])
                ]
            }, `${name}-row-${idx}`);
        })
    });
};
// Renders the vertical header
const $aee0d1fa0fb821a4$var$VerticalHeader = ({ colWs: colWs, row: row, plan: plan, view: view })=>{
    const hdrs = $aee0d1fa0fb821a4$var$spans(plan, view.Rows);
    const wdth = (i)=>colWs.slice(0, i).reduce((acc, w)=>acc + w, 0);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: hdrs.map(([name, [count, span]], idx)=>{
            const m = Math.floor(row / span);
            const i = m % count;
            return row % span === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                rowSpan: span,
                className: $93dbcefb30038764$exports[`vert-header-${span}-${idx}`],
                style: {
                    left: wdth(idx)
                },
                children: $aee0d1fa0fb821a4$var$makeHeader(plan, name, i)
            }, `${name}-row-${row}-${i}`) : null;
        })
    });
};
const $aee0d1fa0fb821a4$var$CellEdit = ({ kind: kind, value: value, update: update, post: post })=>{
    if ((0, $96bbda84cddc9285$export$d49461dfcce6c57b).is(kind) && (0, $87701c398fec8638$export$4a21f16c33752377).is(value)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
        title: "Toggle",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
            type: "checkbox",
            checked: value,
            onChange: (e)=>update(()=>e.target.checked),
            onBlur: post
        })
    });
    else if ((0, $96bbda84cddc9285$export$95e99e299bd78ccf).is(kind) && (0, $520c48df756a1a3e$export$3f58fdce283c1f4c).is(value)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1614aadb7e760801$export$7ba382867b739905), {
        value: value,
        update: update,
        post: post
    });
    else if ((0, $96bbda84cddc9285$export$22789cc21136a310).is(kind) && (0, $87701c398fec8638$export$98e628dec113755e).is(value)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
        title: "Numerical value",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
            type: "number",
            value: value,
            onChange: (e)=>update(()=>Number(e.target.value)),
            onBlur: post
        })
    });
    else if ((0, $96bbda84cddc9285$export$2c141edbf364223f).is(kind) && (0, $96bbda84cddc9285$export$e0f247785fa80381).is(value)) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($aee0d1fa0fb821a4$var$CellEdit, {
                kind: kind.fst,
                value: value[0],
                update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $96bbda84cddc9285$export$a1a1317e0e00857e)),
                post: post
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($aee0d1fa0fb821a4$var$CellEdit, {
                kind: kind.snd,
                value: value[1],
                update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $96bbda84cddc9285$export$e31863d491ac5fa3)),
                post: post
            })
        ]
    });
    else return null; // This should not happen (I think)
};
const $aee0d1fa0fb821a4$var$grid = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('grid');
const $aee0d1fa0fb821a4$var$imap = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('imap');
const $aee0d1fa0fb821a4$var$imapx = (pkey)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($aee0d1fa0fb821a4$var$imap, (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)(pkey));
const $aee0d1fa0fb821a4$var$Clicker = ({ action: action, clicks: clicks, content: content })=>{
    const clks = Math.abs(clicks);
    const [counter, setCounter] = $acw62.useState(clks);
    const handleClick = ()=>{
        if (counter <= 0) {
            action();
            return;
        }
        setCounter(counter - 1);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: $93dbcefb30038764$exports['clicker'],
        onClick: handleClick,
        children: [
            content,
            " ",
            counter < clks ? `(${counter})` : ''
        ]
    });
};
const $aee0d1fa0fb821a4$export$ad13e64a07ef64ee = ({ value: value, update: update, req: req })=>{
    const view = value.grid.View ?? {
        Cols: value.grid.Plan.map((prop)=>prop.name),
        Rows: []
    };
    const size = $aee0d1fa0fb821a4$var$gridSize(value.grid.Plan, view);
    const vp = `[cols]:${view.Cols.join('-')}-[rows]:${view.Rows.join('-')}`;
    const pfrags = value.grid.Plan.map($aee0d1fa0fb821a4$var$fragment);
    const arrP2P = (parr)=>$aee0d1fa0fb821a4$var$arrayPath2Path(parr, pfrags);
    const updateView = (viewUpdate)=>{
        const updatedGrid = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('View'), (0, $58f80d7b57eba59b$export$36faa878fcded3d7)(view))(viewUpdate)(value.grid);
        (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, $aee0d1fa0fb821a4$var$grid, (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('View'), (0, $58f80d7b57eba59b$export$36faa878fcded3d7)(view))(viewUpdate);
        (0, $246cd4dea00cb67d$export$ebc68508096cea69)(req)(updatedGrid);
    };
    const [colWs, setColWs] = $acw62.useState([]);
    $acw62.useLayoutEffect(()=>{
        const table = document.getElementById('price-grid');
        if (!table) return;
        const widths = Array.from(table.querySelectorAll('th')).slice(0, view.Rows.length).map((th)=>th.offsetWidth);
        setColWs(widths);
    }, [
        view.Rows.length
    ]);
    const priceGrid = /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
        id: "price-grid",
        className: $93dbcefb30038764$exports['price-grid'],
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($aee0d1fa0fb821a4$var$HorizontalHeader, {
                    plan: value.grid.Plan,
                    view: view
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                children: $aee0d1fa0fb821a4$var$arr(size[1]).map((row)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($aee0d1fa0fb821a4$var$VerticalHeader, {
                                colWs: colWs,
                                row: row,
                                plan: value.grid.Plan,
                                view: view
                            }),
                            $aee0d1fa0fb821a4$var$arr(size[0]).map((col)=>{
                                const path = arrP2P($aee0d1fa0fb821a4$var$pathArray(value.grid.Plan, view, [
                                    col,
                                    row
                                ]));
                                const pkey = (0, $61648204ac198534$export$d53d9be948a7219c)(path);
                                const kind = value.grid.Kind;
                                const ttem = value.imap[pkey];
                                // const item : PriceItem = ttem ??
                                const idel = ()=>{
                                    if (ttem) (0, $246cd4dea00cb67d$export$536ddde8a6f56d5f)(req)(ttem.Id).then(()=>{
                                        (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, $aee0d1fa0fb821a4$var$imap)((items)=>{
                                            const nitems = {
                                                ...items
                                            };
                                            delete nitems[pkey];
                                            return nitems;
                                        });
                                    }).catch(console.error);
                                };
                                const iadd = ()=>{
                                    const defItem = (0, $96bbda84cddc9285$export$b4e81cf3c71a88d0)(kind, value.grid.Id, path);
                                    (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, $aee0d1fa0fb821a4$var$imap)((items)=>({
                                            ...items,
                                            [pkey]: defItem
                                        }));
                                };
                                const handleDelete = (e)=>{
                                    if (e.shiftKey && e.altKey) idel();
                                };
                                const cedit = (item)=>{
                                    const post = ()=>(0, $246cd4dea00cb67d$export$b72a16247da44dc2)(req)(item);
                                    const updt = (f)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, $aee0d1fa0fb821a4$var$imapx(pkey), (0, $58f80d7b57eba59b$export$36faa878fcded3d7)(item), (0, $96bbda84cddc9285$export$a84a8011a7cb14e5))(f);
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)($aee0d1fa0fb821a4$var$CellEdit, {
                                        kind: kind,
                                        value: item.Value,
                                        update: updt,
                                        post: post
                                    });
                                };
                                return /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: $93dbcefb30038764$exports['cell-editor'],
                                        onClick: handleDelete,
                                        children: ttem ? cedit(ttem) : /*#__PURE__*/ (0, $ayMG0.jsx)($aee0d1fa0fb821a4$var$Clicker, {
                                            action: iadd,
                                            clicks: 5,
                                            content: "N/A"
                                        })
                                    })
                                }, `${vp}-${row}x${col}`);
                            })
                        ]
                    }, `${vp}_row-${row}`))
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        sx: {
            height: '100%'
        },
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                sx: {
                    flex: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            style: {
                                display: 'flex',
                                alignItems: 'center'
                            },
                            children: value.grid.Name
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {
                                orientation: "vertical"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $63ab41fd568f4e27$export$2e2bcd8739ae039), {
                                value: view,
                                update: updateView
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                sx: {
                    flex: 1
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        width: '100%',
                        height: '100%',
                        position: 'relative'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0,
                            position: 'absolute',
                            overflow: 'auto'
                        },
                        children: priceGrid
                    })
                })
            })
        ]
    });
};
var $aee0d1fa0fb821a4$export$2e2bcd8739ae039 = $aee0d1fa0fb821a4$export$ad13e64a07ef64ee;


const $d01a70bf6908749e$export$1ec53dc27fdc6e8b = ({ value: value, edit: edit })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5d7964a6269b66c8$export$2e2bcd8739ae039), {
            component: (0, $595185d0d7275c3b$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                    children: "Grid Name"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                    children: "Edit"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                        children: Object.entries(value).map(([gid, g])=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                        component: "th",
                                        scope: "row",
                                        children: g.Name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                            variant: "text",
                                            onClick: edit(gid),
                                            children: "Edit"
                                        })
                                    })
                                ]
                            }, gid))
                    })
                ]
            })
        })
    });
};
const $d01a70bf6908749e$export$6a21d487d8f1d96e = ({ req: req, grid: grid })=>{
    const [gridProps, setGridProps] = $acw62.useState({
        grid: grid,
        imap: {}
    });
    $acw62.useEffect(()=>{
        const loadPriceItems = async ()=>{
            console.log('Running the loadPriceItems', grid.Id);
            try {
                const items = await (0, $246cd4dea00cb67d$export$51dda5f0ca4b2617)(req)(grid.Id);
                const nitms = Object.values(items).reduce((rec, itm)=>{
                    rec[(0, $61648204ac198534$export$d53d9be948a7219c)(itm.Path)] = itm;
                    return rec;
                }, {});
                setGridProps({
                    grid: grid,
                    imap: nitms
                });
            } catch (err) {
                console.error(err);
            }
        };
        loadPriceItems();
    }, [
        req,
        grid
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aee0d1fa0fb821a4$export$ad13e64a07ef64ee), {
        req: req,
        value: gridProps,
        update: (f)=>setGridProps(f(gridProps))
    });
};
const $d01a70bf6908749e$export$eb52888eac007d02 = ({ req: req, aok: aok })=>{
    const [doin, setDoin] = $acw62.useState(false);
    const [errs, setErrs] = $acw62.useState([]);
    const [name, setName] = $acw62.useState('');
    const [plan, setPlan] = $acw62.useState([]);
    const [kind, setKind] = $acw62.useState({
        kind: 'Price'
    });
    const [many, setMany] = $acw62.useState(false);
    const alert = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
        severity: "error",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe9496169f0560d$export$2e2bcd8739ae039), {
                children: "Errors"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                children: errs.map((err)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: err
                    }, err))
            })
        ]
    });
    const handleCreate = ()=>{
        const hasSpace = (s)=>/\s/.test(s);
        const errors = [];
        const newGrid = {
            Id: '',
            Name: name,
            Plan: plan,
            Kind: kind,
            Many: many
        };
        setDoin(true);
        if (name === '' || hasSpace(name)) errors.push('Name is invalid.');
        if (!(0, $61648204ac198534$export$d84f44fa1bfbb5ce)(plan)) errors.push('Plan is invalid.');
        if (errors.length) {
            setErrs(errors);
            setDoin(false);
            return;
        }
        (0, $246cd4dea00cb67d$export$ebc68508096cea69)(req)(newGrid).then(()=>aok()).catch((err)=>{
            console.log(err);
            setErrs([
                'Unable to create new PriceGrid for some reason.'
            ]);
            setDoin(false);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
                    spacing: 2,
                    children: [
                        !errs.length ? null : alert,
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                            required: true,
                            label: "Grid Name",
                            variant: "outlined",
                            onChange: (e)=>setName(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
                            sx: {
                                padding: '1em'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5941f8069797d75c$export$2e2bcd8739ae039), {
                                value: plan,
                                update: (f)=>setPlan(f(plan))
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                            size: "large",
                            disabled: doin,
                            variant: "outlined",
                            onClick: handleCreate,
                            children: "Create"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                checked: many,
                                onChange: (e)=>setMany(e.target.checked)
                            }),
                            label: "Results in multiple values"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e0fce0974169c32$export$2e2bcd8739ae039), {
                            value: kind,
                            update: (f)=>setKind(f(kind))
                        })
                    ]
                })
            })
        ]
    });
};



const $09edfdb8261d3bb2$var$LinkGrid = ({ req: req, value: value, update: update })=>{
    const [status, setStatus] = $acw62.useState('Normal');
    const [open, setOpen] = $acw62.useState(false);
    const [grids, setGrids] = $acw62.useState([]);
    const [selected, setSelected] = $acw62.useState([]);
    const curGrids = value.Elems.map((elem)=>elem.Grid);
    $acw62.useEffect(()=>{
        (0, $246cd4dea00cb67d$export$65c6a40128a7bab2)(req).then((grids)=>setGrids(Object.values(grids))).catch(console.error);
    }, [
        req,
        value
    ]);
    const makePriceElem = (s)=>({
            Grid: s
        });
    const handleAdd = ()=>{
        const newElems = selected.map(makePriceElem);
        const newPList = (0, $96bbda84cddc9285$export$56194e34a176ec43)((old)=>old.concat(newElems))(value);
        setStatus('Sending');
        (0, $246cd4dea00cb67d$export$84866d7e17bbd365)(req)(newPList).then((list)=>{
            update(()=>list);
            setOpen(false);
            setStatus('Normal');
        }).catch((err)=>{
            console.error(err);
            setStatus('Error');
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                variant: "outlined",
                endIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($621fb6a237b62b7c$exports))), {}),
                onClick: ()=>setOpen(true),
                children: "Link grid"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4f13784bd714c44e$export$2e2bcd8739ae039), {
                open: open,
                onClose: ()=>setOpen(false),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6ac58aca374c76c$export$2e2bcd8739ae039), {
                        children: "Select price grids to add"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fa8e9c420cdee0a$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            component: "form",
                            sx: {
                                display: 'flex',
                                flexWrap: 'wrap'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                sx: {
                                    m: 1,
                                    width: 300
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                    multiple: true,
                                    value: selected,
                                    onChange: (e)=>{
                                        const val = e.target.value;
                                        setSelected(typeof val === 'string' ? val.split(',') : val);
                                    },
                                    input: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5d55d2dd82639e9$export$2e2bcd8739ae039), {}),
                                    renderValue: (selected)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            sx: {
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: 0.5
                                            },
                                            children: selected.map((value)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), {
                                                    label: value
                                                }, value);
                                            })
                                        }),
                                    children: grids.filter((grid)=>!curGrids.includes(grid.Id)).map((grid)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                            value: grid.Id,
                                            children: grid.Name
                                        }, grid.Id))
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $207bc6ab7c60f4b2$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                onClick: ()=>setOpen(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                color: status === 'Error' ? 'error' : 'primary',
                                disabled: status === 'Sending',
                                endIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6eefe30025c8ad9a$exports))), {}),
                                variant: "outlined",
                                onClick: handleAdd,
                                children: status === 'Sending' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "Saving..."
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "Add"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $09edfdb8261d3bb2$var$UnlinkGrid = ({ idx: idx, req: req, value: value, update: update })=>{
    const [status, setStatus] = $acw62.useState('Normal');
    const handleUnlink = ()=>{
        const newElems = [
            ...value.Elems
        ];
        newElems.splice(idx, 1);
        const newPList = (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $96bbda84cddc9285$export$56194e34a176ec43))(newElems)(value);
        setStatus('Sending');
        (0, $246cd4dea00cb67d$export$84866d7e17bbd365)(req)(newPList).then((list)=>{
            update(()=>list);
            setStatus('Normal');
        }).catch((err)=>{
            setStatus('Error');
            console.error(err);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
        color: status === 'Error' ? 'error' : 'primary',
        disabled: status === 'Sending',
        endIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b86da8ab684d120a$exports))), {}),
        variant: "outlined",
        onClick: handleUnlink,
        children: status === 'Sending' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: "Saving..."
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: "Unlink"
        })
    });
};
const $09edfdb8261d3bb2$export$e9467c75c0045dde = ({ req: req, value: value, update: update })=>{
    const [tab, setTab] = $acw62.useState(0);
    const [grids, setGrids] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        Promise.all(value.Elems.map((elem)=>(0, $246cd4dea00cb67d$export$5a6efa689e9084a4)(req)(elem.Grid))).then((grids)=>setGrids(grids));
    }, [
        req,
        value.Elems
    ]);
    const selectedGrid = grids[tab];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                sx: {
                    flex: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 4,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7be483edbed3b474$export$2e2bcd8739ae039), {
                                value: tab,
                                onChange: (_, t)=>setTab(t),
                                variant: "scrollable",
                                scrollButtons: true,
                                children: value.Elems.map((elem, ix)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                        label: grids[ix]?.Name ?? elem.Grid
                                    }, elem.Grid))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 8,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex',
                                height: '100%'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1c026d95d0d4d482$export$2e2bcd8739ae039), {
                                size: "large",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($09edfdb8261d3bb2$var$LinkGrid, {
                                        req: req,
                                        value: value,
                                        update: update
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($09edfdb8261d3bb2$var$UnlinkGrid, {
                                        idx: tab,
                                        req: req,
                                        value: value,
                                        update: update
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                sx: {
                    flex: 1,
                    marginTop: 0
                },
                direction: "column",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    sx: {
                        flex: 1
                    },
                    children: selectedGrid ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d01a70bf6908749e$export$6a21d487d8f1d96e), {
                        req: req,
                        grid: selectedGrid
                    }) : null
                })
            })
        ]
    });
};
var $09edfdb8261d3bb2$export$2e2bcd8739ae039 = $09edfdb8261d3bb2$export$e9467c75c0045dde;


const $4ac2d2c754ce35dc$export$9b685ca22fa2fffa = ({ value: value, edit: edit })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5d7964a6269b66c8$export$2e2bcd8739ae039), {
            component: (0, $595185d0d7275c3b$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                    children: "List Name"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                    children: "Edit"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                        children: Object.entries(value).map(([_, l])=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                        component: "th",
                                        scope: "row",
                                        children: l.Name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                            variant: "text",
                                            onClick: edit(l.Id),
                                            children: "Edit"
                                        })
                                    })
                                ]
                            }, l.Id))
                    })
                ]
            })
        })
    });
};
const $4ac2d2c754ce35dc$export$3897ffd7ac74d376 = ({ req: req, list: list })=>{
    const [priceList, setPriceList] = $acw62.useState(list);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09edfdb8261d3bb2$export$e9467c75c0045dde), {
        req: req,
        value: priceList,
        update: (f)=>setPriceList(f(priceList))
    });
};
const $4ac2d2c754ce35dc$export$cbe85c5163a39141 = ({ req: req, aok: aok })=>{
    const [zone, setZone] = $acw62.useState('');
    const [name, setName] = $acw62.useState('');
    const [errs, setErrs] = $acw62.useState([]);
    const alert = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
        severity: "error",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe9496169f0560d$export$2e2bcd8739ae039), {
                children: "Errors"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                children: errs.map((err)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: err
                    }, err))
            })
        ]
    });
    const handleCreate = ()=>{
        const errors = [];
        const hasSpace = (s)=>/\s/.test(s);
        const newPriceList = {
            Id: '',
            Zone: zone,
            Name: name,
            Elems: []
        };
        if (hasSpace(zone) || zone.length === 0) errors.push('Invalid zone: "' + zone + '"');
        if (hasSpace(name) || name.length === 0) errors.push('Invalid name: "' + name + '"');
        if (errors.length !== 0) {
            setErrs([
                ...errors
            ]);
            return;
        }
        (0, $246cd4dea00cb67d$export$84866d7e17bbd365)(req)(newPriceList).then(()=>{
            setErrs([]);
            aok();
        }).catch((err)=>{
            setErrs([
                'Unable to create new PriceList'
            ]);
            console.error(err);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
            item: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
                spacing: 2,
                children: [
                    !errs.length ? null : alert,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df2af751bdad3651$export$c5db55acc87904b6), {
                        value: zone,
                        update: (f)=>setZone(f(zone)),
                        label: "Zone"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df2af751bdad3651$export$c5db55acc87904b6), {
                        value: name,
                        update: (f)=>setName(f(name)),
                        label: "Name"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        onClick: handleCreate,
                        children: "Create"
                    })
                ]
            })
        })
    });
};



const $a641a45a95d00d23$var$links = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('links');
const $a641a45a95d00d23$var$lists = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('lists');
const $a641a45a95d00d23$var$grids = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('grids');
const $a641a45a95d00d23$var$Pricing = ({ req: req })=>{
    const [state, setState] = $acw62.useState({
        links: [
            'PriceList',
            'List',
            ''
        ],
        lists: {},
        grids: {}
    });
    const [mode, page, item] = state.links;
    const matchMaker = (mode, page)=>(tmode, tpage)=>mode === tmode && page === tpage;
    const match = matchMaker(mode, page);
    // Makes sure appropriate data is loaded and refreshed + it set's the view
    const loadr = (mode, page, item)=>()=>{
            const match = matchMaker(mode, page);
            const setLinks = (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)($a641a45a95d00d23$var$links)([
                mode,
                page,
                item ?? ''
            ]);
            const setGrids = (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)($a641a45a95d00d23$var$grids);
            switch(true){
                case match('PriceList', 'List'):
                    (0, $246cd4dea00cb67d$export$f59fd0025e3090ce)(req).then((lst)=>setState((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(setLinks, (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)($a641a45a95d00d23$var$lists)(lst))(state))).catch((e)=>console.error(e));
                    break;
                case match('PriceGrid', 'List'):
                    (0, $246cd4dea00cb67d$export$65c6a40128a7bab2)(req).then((lst)=>setState((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(setLinks, setGrids(lst))(state))).catch((e)=>console.error(e));
                    break;
                case match('PriceGrid', 'Edit'):
                    if (!item || item === '') break;
                    setState(setLinks);
                    break;
                case match('PriceList', 'Edit'):
                    if (!item || item === '') break;
                    setState(setLinks);
                    break;
                default:
                    setState(setLinks);
            }
        };
    const priceGrid = state.grids[item];
    const priceList = state.lists[item];
    // State initialization.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $acw62.useEffect(loadr(mode, page), []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        style: {
            height: '100%',
            padding: '0 1em',
            marginTop: 0,
            marginBottom: 0
        },
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                sx: {
                    flex: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1c026d95d0d4d482$export$2e2bcd8739ae039), {
                                variant: "contained",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                        onClick: loadr('PriceList', 'List'),
                                        variant: mode === 'PriceList' ? 'contained' : 'outlined',
                                        children: "Price Lists"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                        onClick: loadr('PriceGrid', 'List'),
                                        variant: mode === 'PriceGrid' ? 'contained' : 'outlined',
                                        children: "Price Grids"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                onClick: loadr(mode, 'Make'),
                                disabled: page === 'Make',
                                children: "New"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                sx: {
                    flex: 1
                },
                children: [
                    match('PriceList', 'List') ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4ac2d2c754ce35dc$export$9b685ca22fa2fffa), {
                        value: state.lists,
                        edit: (lid)=>loadr('PriceList', 'Edit', lid)
                    }) : null,
                    match('PriceGrid', 'List') ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d01a70bf6908749e$export$1ec53dc27fdc6e8b), {
                        value: state.grids,
                        edit: (gid)=>loadr('PriceGrid', 'Edit', gid)
                    }) : null,
                    match('PriceList', 'Edit') && item !== '' && priceList !== undefined ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4ac2d2c754ce35dc$export$3897ffd7ac74d376), {
                        req: req,
                        list: priceList
                    }) : null,
                    match('PriceGrid', 'Edit') && item !== '' && priceGrid !== undefined ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d01a70bf6908749e$export$6a21d487d8f1d96e), {
                        req: req,
                        grid: priceGrid
                    }) : null,
                    match('PriceList', 'Make') ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4ac2d2c754ce35dc$export$cbe85c5163a39141), {
                        req: req,
                        aok: loadr('PriceList', 'List')
                    }) : null,
                    match('PriceGrid', 'Make') ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d01a70bf6908749e$export$eb52888eac007d02), {
                        req: req,
                        aok: loadr('PriceGrid', 'List')
                    }) : null
                ]
            })
        ]
    });
};
var $a641a45a95d00d23$export$2e2bcd8739ae039 = $a641a45a95d00d23$var$Pricing;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $a388f687e0a39747$export$bab437785f90cbb4 = /*#__PURE__*/ function(BULK_DESIGN_VIEW_MODE) {
    BULK_DESIGN_VIEW_MODE[BULK_DESIGN_VIEW_MODE["DEFAULT"] = 0] = "DEFAULT";
    BULK_DESIGN_VIEW_MODE[BULK_DESIGN_VIEW_MODE["LIST_VIEW"] = 1] = "LIST_VIEW";
    BULK_DESIGN_VIEW_MODE[BULK_DESIGN_VIEW_MODE["DESIGN"] = 2] = "DESIGN";
    BULK_DESIGN_VIEW_MODE[BULK_DESIGN_VIEW_MODE["PRODUCTION_DOCUMENTS"] = 3] = "PRODUCTION_DOCUMENTS";
    BULK_DESIGN_VIEW_MODE[BULK_DESIGN_VIEW_MODE["ADDITIONAL_FIELD"] = 4] = "ADDITIONAL_FIELD";
    BULK_DESIGN_VIEW_MODE[BULK_DESIGN_VIEW_MODE["MORE_SPACE"] = 5] = "MORE_SPACE";
    return BULK_DESIGN_VIEW_MODE;
}({});
const $a388f687e0a39747$export$29523c2f5fc48e88 = 'SET_SERVER_TEMPLATES';
const $a388f687e0a39747$export$b2463983502340c6 = 'SHOW_ALERT';
const $a388f687e0a39747$export$90b7ee5b7e89afd4 = 'HIDE_ALERT';
const $a388f687e0a39747$export$dd3f6860d8bc5f06 = 'TOGGLE_VIEW_MODE';
const $a388f687e0a39747$export$bd0bf4d50261caa1 = 'SET_BULK_DESIGN_LOADING';
const $a388f687e0a39747$export$1129347c88918a1a = 'SHOW_DATA_PANEL';
const $a388f687e0a39747$export$2d10c83bffd81de3 = 'HIDE_DATA_PANEL';
const $a388f687e0a39747$export$f9f104ddd496ba3 = 'SET_DATA_PANEL_WIDTH';
const $a388f687e0a39747$var$DEFAULT_WIDTH = 300;
const $a388f687e0a39747$export$36d128238e6b60f5 = {
    mainViewMode: 0,
    serverTemplates: [],
    loading: false,
    alertProps: {
        open: false,
        title: '',
        type: 'success',
        description: '',
        autoDuration: 6000
    },
    dataPanelWidth: $a388f687e0a39747$var$DEFAULT_WIDTH,
    dispatch: ()=>({})
};
/**
 * Context
 */ const $a388f687e0a39747$export$afffaa0e40c01a5d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($a388f687e0a39747$export$36d128238e6b60f5);
const $a388f687e0a39747$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case $a388f687e0a39747$export$29523c2f5fc48e88:
            return {
                ...state,
                serverTemplates: action.data
            };
        case $a388f687e0a39747$export$b2463983502340c6:
            return {
                ...state,
                alertProps: {
                    ...state.alertProps,
                    ...action.data
                }
            };
        case $a388f687e0a39747$export$90b7ee5b7e89afd4:
            return {
                ...state,
                alertProps: {
                    open: false,
                    type: 'success',
                    title: '',
                    description: '',
                    autoDuration: 3000
                }
            };
        case $a388f687e0a39747$export$dd3f6860d8bc5f06:
            return {
                ...state,
                mainViewMode: action.data === state.mainViewMode ? 0 : action.data
            };
        case $a388f687e0a39747$export$bd0bf4d50261caa1:
            return {
                ...state,
                loading: action.data
            };
        case $a388f687e0a39747$export$1129347c88918a1a:
            return {
                ...state,
                dataPanelWidth: $a388f687e0a39747$var$DEFAULT_WIDTH
            };
        case $a388f687e0a39747$export$2d10c83bffd81de3:
            return {
                ...state,
                dataPanelWidth: 0
            };
        case $a388f687e0a39747$export$f9f104ddd496ba3:
            return {
                ...state,
                dataPanelWidth: action.data
            };
        default:
            return state;
    }
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


const $1bd72384e7261ec7$var$TreeViewColumn = ({ column: column })=>{
    const [sortOrder, setSortOrder] = (0, $acw62.useState)('asc');
    const handleChangeOrder = ()=>{
        setSortOrder((prev)=>prev === 'asc' ? 'desc' : 'asc');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: "tree-view-column",
        style: {
            width: column.width,
            minWidth: column.width,
            maxWidth: column.width
        },
        onClick: handleChangeOrder,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                className: "tree-view-column__title",
                children: column.label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))('tree-view-column__icon', {
                    desc: sortOrder === 'desc'
                })
            })
        ]
    });
};
var $1bd72384e7261ec7$export$2e2bcd8739ae039 = $1bd72384e7261ec7$var$TreeViewColumn;



var $ayMG0 = parcelRequire("ayMG0");

const $45dc03e7e5217533$var$getValueFromTemplate = (label, templateValues)=>{
    if (templateValues) {
        const searchLabel = templateValues.find((item)=>item.Label === label);
        if (searchLabel) switch(searchLabel.Type){
            case 'Opts':
                return searchLabel.Range.find((r)=>r.Label === searchLabel.Value)?.Names?.eng ?? '';
            case 'Vars':
                return searchLabel.Value;
        }
    }
    return '';
};
const $45dc03e7e5217533$export$53b3c91859018cd4 = [
    {
        id: 'measurements',
        width: '141px',
        label: 'Measurements',
        render: (_node, _quote, tValues)=>{
            const shape = $45dc03e7e5217533$var$getValueFromTemplate('Shape', tValues);
            if ([
                'Circle',
                'Half Circle'
            ].includes(shape)) {
                const diameter = $45dc03e7e5217533$var$getValueFromTemplate('diameter', tValues);
                if (diameter) return `${diameter}"`;
            } else if ([
                'Square',
                'Octagon',
                'Quarter Circle',
                'Equilateral Pentagon',
                'Right Pentagon',
                'Right Isosceles Triangle'
            ].includes(shape)) {
                const sideLength = $45dc03e7e5217533$var$getValueFromTemplate('side', tValues);
                if (sideLength) return `${sideLength}"`;
            } else if ([
                'Trapzoid',
                'Parallelogram'
            ].includes(shape)) {
                const width = $45dc03e7e5217533$var$getValueFromTemplate('width', tValues);
                const height = $45dc03e7e5217533$var$getValueFromTemplate('height', tValues);
                const skew = $45dc03e7e5217533$var$getValueFromTemplate('skew', tValues);
                return `${width}"x${height}", ${skew}"`;
            } else {
                const width = $45dc03e7e5217533$var$getValueFromTemplate('width', tValues);
                const height = $45dc03e7e5217533$var$getValueFromTemplate('height', tValues);
                if (width || height) return `${width}"x${height}"`;
            }
            return '-';
        }
    },
    {
        id: 'shape',
        width: '87px',
        label: 'Shape',
        render: (_node, _quote, tValues)=>$45dc03e7e5217533$var$getValueFromTemplate('Shape', tValues)
    },
    {
        id: 'edge-finish',
        width: '120px',
        label: 'Edge Finish',
        render: (_node, _quote, tValues)=>$45dc03e7e5217533$var$getValueFromTemplate('Edge', tValues)
    },
    {
        id: 'tempered',
        width: '115px',
        label: 'Tempered',
        render: (_node, _quote, tValues)=>{
            const tempered = $45dc03e7e5217533$var$getValueFromTemplate('TemperMark', tValues);
            return tempered;
        }
    },
    {
        id: 'thickness',
        width: '116px',
        label: 'Thickness',
        render: (_node, _quote, tValues)=>{
            const thickness = $45dc03e7e5217533$var$getValueFromTemplate('Thickness', tValues);
            return thickness;
        }
    },
    {
        id: 'corners',
        width: '98px',
        label: 'Corners',
        render: (node, _quote, tValues)=>{
            const formatCornerValue = (cornerIndex)=>{
                const cornerValue = tValues.find((item)=>item.Label === `Corner ${cornerIndex}`);
                const CornerLabels = [
                    'BL',
                    'BR',
                    'TR',
                    'TL'
                ];
                switch(cornerValue.Value){
                    case `none${cornerIndex}`:
                        return 'None';
                    case `eased${cornerIndex}`:
                        return `${CornerLabels[cornerIndex]}: E`;
                    case `clipped${cornerIndex}`:
                        return `${CornerLabels[cornerIndex]}: C${$45dc03e7e5217533$var$getValueFromTemplate(`corner${cornerIndex}-clip`, tValues)}"`;
                    case `rounded${cornerIndex}`:
                        return `${CornerLabels[cornerIndex]}: R${$45dc03e7e5217533$var$getValueFromTemplate(`corner${cornerIndex}-radius`, tValues)}"`;
                    default:
                        return '';
                }
            };
            const cornerInfo = [
                3,
                2,
                1,
                0
            ].map((index)=>{
                const cornerOpt = tValues.find((opt)=>opt.Label === `Corner ${index}`);
                const isValid = (0, $9e60ae4352b3f8e8$export$c1ee70c24c083802)(node.Item)(cornerOpt);
                if (isValid) return formatCornerValue(index);
                return null;
            }).filter((cor)=>!!cor);
            const isInvalidCornerInfo = cornerInfo.length === 0;
            if (isInvalidCornerInfo) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "tree-node-column__corner",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: "-"
                })
            });
            const isEveryCornerNone = cornerInfo.every((cor)=>cor === 'None');
            if (isEveryCornerNone) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "tree-node-column__corner",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: "None"
                })
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "tree-node-column__corner",
                children: cornerInfo.filter((cor)=>cor !== 'None').map((cor, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: cor
                    }, index))
            });
        }
    },
    {
        id: 'diameter',
        width: '104px',
        label: 'Diameter',
        render: (node, _quote, tValues)=>{
            const diameterOpt = tValues.find((opt)=>opt.Label === 'diameter');
            const isValid = (0, $9e60ae4352b3f8e8$export$cae9ccc5485bbb97)(node.Item)(diameterOpt);
            if (isValid) return $45dc03e7e5217533$var$getValueFromTemplate('diameter', tValues);
            return '';
        }
    },
    {
        id: 'sku',
        width: '70px',
        label: 'SKU',
        render: ()=>'-'
    },
    {
        id: 'price',
        width: '90px',
        label: 'Price',
        align: 'right',
        render: (_node, quote)=>`$ ${quote?.Total.USD}`
    }
];


function $d05af790682acfac$var$LeftBarHeader({ addTemplate: addTemplate, treeData: treeData }) {
    const { mainViewMode: mainViewMode } = (0, $acw62.useContext)((0, $a388f687e0a39747$export$afffaa0e40c01a5d));
    const gridTemplateColumns = (0, $acw62.useMemo)(()=>{
        if (mainViewMode === (0, $a388f687e0a39747$export$bab437785f90cbb4).LIST_VIEW) return `minmax(12px, 12px) 1fr repeat(${(0, $45dc03e7e5217533$export$53b3c91859018cd4).length}, auto) 176px`;
        return '12px 1fr auto';
    }, [
        mainViewMode
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: "tree-view__head",
        style: {
            gridTemplateColumns: gridTemplateColumns
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                className: "index"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                className: "tree-view__head-title",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        component: "span",
                        className: "title-icon",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: "/img/treeview/checklist.svg",
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        component: "span",
                        style: {
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        children: treeData.Name
                    })
                ]
            }),
            mainViewMode === (0, $a388f687e0a39747$export$bab437785f90cbb4).LIST_VIEW && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: (0, $45dc03e7e5217533$export$53b3c91859018cd4).map((column)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1bd72384e7261ec7$export$2e2bcd8739ae039), {
                        column: column
                    }, column.id))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                className: "tree-view__head-actions",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    className: "tree-view__head-btn",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        onClick: ()=>addTemplate(),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "#F7FAFC",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                id: "Icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    id: "Vector",
                                    d: "M9.16663 9.1665V4.1665H10.8333V9.1665H15.8333V10.8332H10.8333V15.8332H9.16663V10.8332H4.16663V9.1665H9.16663Z",
                                    fill: "#F7FAFC"
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
}
var $d05af790682acfac$export$2e2bcd8739ae039 = $d05af790682acfac$var$LeftBarHeader;


/**
 * Optics for pure manipulation of BulkDesign
 *
 * @since 0.1.0
 */ 
var $kisy7 = parcelRequire("kisy7");
/**
 * Optics for pure manipulation of Quote
 *
 * @since 0.1.0
 */ 
var $kisy7 = parcelRequire("kisy7");


const $f11497db38134253$export$26974116d1105203 = (0, $kisy7.Lens).fromProp()('Name');
const $f11497db38134253$export$10e160c2df1ec15e = (indices)=>new (0, $kisy7.Lens)((quote)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let currentNode = quote;
        for (const index of indices){
            if (currentNode && 'Charges' in currentNode && index >= 0 && index < currentNode.Charges.length) currentNode = currentNode.Charges[index];
            else if (currentNode && 'Items' in currentNode && index >= 0 && index < currentNode.Items.length) currentNode = currentNode.Items[index];
            else return undefined;
        }
        if ('Name' in currentNode && 'Count' in currentNode && 'Price' in currentNode) return currentNode;
        return undefined;
    }, ()=>(quote)=>quote);
const $f11497db38134253$export$cba3c508cfd477bb = (chargeItem, name)=>$f11497db38134253$export$26974116d1105203.set(name)(chargeItem);
const $f11497db38134253$export$c6a52f3075b036ea = (path, itemToAdd)=>{
    return (quote)=>{
        if (!quote) return undefined;
        let currentNode = quote;
        // Copy the path array so that it's not mutated
        const pathCopy = [
            ...path
        ];
        while(pathCopy.length > 0){
            const index = pathCopy.shift();
            if (currentNode && 'Charges' in currentNode && index !== undefined && index >= 0 && index < currentNode.Charges.length) {
                // If we reach the last index, add the new item just after it
                if (pathCopy.length === 0) currentNode.Charges.splice(index + 1, 0, {
                    ...itemToAdd
                });
                currentNode = currentNode.Charges[index];
            } else if (currentNode && 'Charges' in currentNode && index == 0 && currentNode.Charges.length == 0) // If we reach the last index, add the new item just after it
            {
                if (pathCopy.length === 0) currentNode.Charges.splice(index, 0, {
                    ...itemToAdd
                });
            } else if (currentNode && 'Items' in currentNode && index !== undefined && index >= 0 && index < currentNode.Items.length) {
                // If we reach the last index, add the new item just after it
                if (pathCopy.length === 0) currentNode.Items.splice(index + 1, 0, {
                    ...itemToAdd
                });
                currentNode = currentNode.Items[index];
            } else // Invalid path, return unchanged data
            return quote;
        }
        // Ensure currentNode is defined
        if (currentNode) {
            // Recalculate the price.
            quote.Charges = quote.Charges.map((charge)=>(0, $4a28b13862156517$export$ef099b3749170d5e)(charge));
            quote = (0, $cefda0850953082d$export$7de6cd8652177f82)(quote);
            return quote; // Return the modified data
        }
        // Invalid path, return unchanged data
        return quote;
    };
};
const $f11497db38134253$export$c3d74211dbe4930e = (path)=>{
    return (quote)=>{
        if (!quote) return undefined;
        let currentNode = quote;
        // Copy the path array so that it's not mutated
        const pathCopy = [
            ...path
        ];
        while(pathCopy.length > 0){
            const index = pathCopy.shift();
            if (currentNode && 'Charges' in currentNode && index !== undefined && index >= 0 && index < currentNode.Charges.length) {
                // If we reach the last index, remove the item.
                if (pathCopy.length === 0) currentNode.Charges.splice(index, 1);
                else currentNode = currentNode.Charges[index];
            } else if (currentNode && 'Items' in currentNode && index !== undefined && index >= 0 && index < currentNode.Items.length) {
                // If we reach the last index, remove the item.
                if (pathCopy.length === 0) currentNode.Items.splice(index, 1);
                else currentNode = currentNode.Items[index];
            } else // Invalid path, return unchanged data
            return quote;
        }
        // Ensure currentNode is defined
        if (currentNode) return quote; // Return the modified data
        // Invalid path, return unchanged data
        return quote;
    };
};
const $f11497db38134253$export$8f141d98755d06ac = (path, field, value)=>{
    return (quote)=>{
        if (!quote) return undefined;
        // Copy the path array so that it's not mutated
        const pathCopy = [
            ...path
        ];
        if (pathCopy.length === 0) return quote;
        let index = 0;
        let parent = undefined;
        index = pathCopy.shift();
        let currentNode = quote.Charges[index];
        while(pathCopy.length > 0){
            index = pathCopy.shift();
            if (currentNode && 'Items' in currentNode && index !== undefined && index >= 0 && index < currentNode.Items.length) {
                parent = currentNode.Items;
                currentNode = currentNode.Items[index];
            } else // Invalid path, return unchanged data
            return quote;
        }
        // Ensure currentNode is defined
        if (currentNode) {
            currentNode = {
                ...currentNode,
                [field]: value
            };
            if (parent && index >= 0) parent.splice(index, 1, currentNode);
            else if (index >= 0) quote.Charges.splice(index, 1, currentNode);
            // Recalculate the price if Count has been changed.
            if (field === 'Count') {
                quote.Charges = quote.Charges.map((charge)=>(0, $4a28b13862156517$export$ef099b3749170d5e)(charge));
                quote = (0, $cefda0850953082d$export$7de6cd8652177f82)(quote);
            }
            return quote; // Return the modified data
        }
        // Invalid path, return unchanged data
        return quote;
    };
};
const $f11497db38134253$export$beb8b05d1c8736e0 = (path, value)=>{
    return (quote)=>{
        if (!quote) return undefined;
        // Copy the path array so that it's not mutated
        const pathCopy = [
            ...path
        ];
        if (pathCopy.length === 0) return quote;
        let index = 0;
        let parent = undefined;
        index = pathCopy.shift();
        let currentNode = quote.Charges[index];
        while(pathCopy.length > 0){
            index = pathCopy.shift();
            if (currentNode && 'Items' in currentNode && index !== undefined && index >= 0 && index < currentNode.Items.length) {
                parent = currentNode.Items;
                currentNode = currentNode.Items[index];
            } else // Invalid path, return unchanged data
            return quote;
        }
        // Ensure currentNode is defined
        if (currentNode) {
            currentNode = {
                ...currentNode,
                Price: {
                    'USD': value.Charges.reduce((res, c)=>res + parseFloat(c.Price?.USD ?? '0'), 0).toFixed(2)
                },
                Discounts: value.Discounts,
                Taxes: value.Taxes,
                Extended: value.Extended,
                Discount: value.Discount,
                SubTotal: value.SubTotal,
                Tax: value.Tax,
                Total: value.Total
            };
            if (parent && index >= 0) parent.splice(index, 1, currentNode);
            else if (index >= 0) quote.Charges.splice(index, 1, currentNode);
            // Recalculate the price.
            quote.Charges = quote.Charges.map((charge)=>(0, $4a28b13862156517$export$ef099b3749170d5e)(charge));
            quote = (0, $cefda0850953082d$export$7de6cd8652177f82)(quote);
            return quote; // Return the modified data
        }
        // Invalid path, return unchanged data
        return quote;
    };
};


const $50fde2cab6970bb8$export$ec3e7f19a82f9ce5 = (0, $kisy7.Lens).fromProp()('Items');
const $50fde2cab6970bb8$export$69ccefa257f6efc7 = (0, $kisy7.Lens).fromProp()('Item');
const $50fde2cab6970bb8$export$37a2eaab5eadb46 = (indices)=>new (0, $kisy7.Lens)((s)=>{
        let currentNode = s;
        for (const index of indices){
            if (currentNode && 'Items' in currentNode && index >= 0 && index < currentNode.Items.length) currentNode = currentNode.Items[index];
            else return undefined;
        }
        return 'Item' in currentNode ? currentNode.Item : undefined;
    }, ()=>(s)=>s);
const $50fde2cab6970bb8$export$6ea27fa64ccd2a4d = (indices)=>{
    return new (0, $kisy7.Lens)((s)=>{
        let currentNode = s;
        for (const index of indices){
            if (currentNode && 'Items' in currentNode && index >= 0 && index < currentNode.Items.length) currentNode = currentNode.Items[index];
            else return [];
        }
        return 'Items' in currentNode ? currentNode.Items : [];
    }, ()=>(s)=>s);
};
const $50fde2cab6970bb8$export$4f4f3d7650ec6d20 = (indices)=>new (0, $kisy7.Lens)((s)=>{
        let currentNode = s;
        for (const index of indices){
            if (currentNode && 'Items' in currentNode && index >= 0 && index < currentNode.Items.length) currentNode = currentNode.Items[index];
            else return undefined;
        }
        if ('Item' in currentNode) return currentNode.Item;
        else if ('Items' in currentNode) return currentNode.Items;
        return undefined;
    }, ()=>(s)=>s);
const $50fde2cab6970bb8$export$558bb72b152ded6a = (indices)=>new (0, $kisy7.Lens)((s)=>{
        let currentNode = s;
        for (const index of indices){
            if (currentNode && 'Items' in currentNode && index >= 0 && index < currentNode.Items.length) currentNode = currentNode.Items[index];
            else return undefined;
        }
        return currentNode;
    }, ()=>(s)=>s);
const $50fde2cab6970bb8$export$9d63396748cc4f5 = (path, itemToAdd)=>{
    return (data)=>{
        if (!data) return undefined;
        let currentField = data;
        // Copy the path array so that it's not mutated
        const pathCopy = [
            ...path
        ];
        while(pathCopy.length > 0){
            const index = pathCopy.shift();
            if (currentField && 'Items' in currentField && index !== undefined && index >= 0 && index < currentField.Items.length) {
                // If we reach the last index, add the new item just after it
                if (pathCopy.length === 0) currentField.Items.splice(index + 1, 0, {
                    ...itemToAdd
                });
                currentField = currentField.Items[index];
            } else // Invalid path, return unchanged data
            return data;
        }
        // Ensure currentField is defined
        if (currentField) return data; // Return the modified data
        // Invalid path, return unchanged data
        return data;
    };
};
const $50fde2cab6970bb8$export$773ddc560f4a0181 = (path, itemToAdd)=>{
    return (data)=>{
        if (!data) return undefined;
        const clonedData = $50fde2cab6970bb8$var$deepClone(data); // Deep clone the entire tree to avoid modifying the original data
        let currentField = clonedData;
        // Copy the path array so that it's not mutated
        const pathCopy = [
            ...path
        ];
        while(pathCopy.length > 0){
            const index = pathCopy.shift();
            if (currentField && 'Items' in currentField && index !== undefined && index >= 0 && index < currentField.Items.length) {
                // If we reach the last index, add the new cloned item just after it
                if (pathCopy.length === 0) {
                    const newItem = $50fde2cab6970bb8$var$deepClone(itemToAdd); // Clone the item to ensure immutability
                    currentField.Items.splice(index + 1, 0, newItem);
                }
                currentField = currentField.Items[index];
            } else if (currentField && 'Items' in currentField && index == 0 && currentField.Items.length == 0) {
                if (pathCopy.length === 0) {
                    const newItem = $50fde2cab6970bb8$var$deepClone(itemToAdd); // Clone the item to ensure immutability
                    currentField.Items.splice(index, 0, newItem);
                }
            } else // Invalid path, return unchanged data
            return data;
        }
        // Ensure currentField is defined
        if (currentField) return clonedData; // Return the modified cloned data
        // Invalid path, return unchanged data
        return data;
    };
};
const $50fde2cab6970bb8$export$545f5afd8bd95e18 = (pathToMove, pathToReplace)=>{
    return (data)=>{
        if (!data) return undefined;
        const clonedData = JSON.parse(JSON.stringify(data));
        // Helper function to find the item based on the path
        const findItemAtPath = (path, node)=>{
            if (path.length === 1) {
                if ('Items' in node) return node.Items[path[0] ?? 0];
            } else {
                const [index, ...restPath] = path;
                if ('Items' in node && index !== undefined && index >= 0 && index < node.Items.length) {
                    const item = node.Items[index];
                    if (item && 'Items' in item) return findItemAtPath(restPath, item);
                }
            }
            return node;
        };
        const itemToMove = findItemAtPath(pathToMove, clonedData);
        const itemToMoveParent = findItemAtPath(pathToMove.slice(0, -1), clonedData);
        const itemToMoveReplaceParent = findItemAtPath(pathToReplace.slice(0, -1), clonedData);
        if (itemToMove && itemToMoveParent && itemToMoveReplaceParent && 'Items' in itemToMoveParent && 'Items' in itemToMoveReplaceParent) {
            const indexToMove = pathToMove[pathToMove.length - 1];
            const indexToReplace = pathToReplace[pathToReplace.length - 1];
            if (indexToMove !== undefined && indexToReplace !== undefined) {
                // Remove the item from its original position
                itemToMoveParent.Items.splice(indexToMove, 1);
                // Insert the item into the desired position
                itemToMoveReplaceParent.Items.splice(indexToReplace, 0, itemToMove);
                return clonedData;
            }
        }
        // Invalid paths, return unchanged data
        return data;
    };
};
const $50fde2cab6970bb8$export$67df6c63cb40f32c = (pathToMove, pathToReplace)=>{
    return (data)=>{
        if (!data) return undefined;
        const clonedData = JSON.parse(JSON.stringify(data));
        const findItemAtPath = (path, node)=>{
            if (path.length === 1) {
                const newPath = path[0] ?? 0;
                if ('Items' in node && newPath >= 0 && newPath < node.Items.length) return node.Items[newPath];
            } else {
                const [index, ...restPath] = path;
                if ('Items' in node && index !== undefined && index >= 0 && index < node.Items.length) {
                    const item = node.Items[index];
                    if (item && 'Items' in item) return findItemAtPath(restPath, item);
                }
            }
            return undefined;
        };
        const itemToMove = findItemAtPath(pathToMove, clonedData);
        const itemToReplace = findItemAtPath(pathToReplace, clonedData);
        if (itemToMove && itemToReplace) {
            const parentPathToMove = pathToMove.slice(0, -1);
            const parentPathToReplace = pathToReplace.slice(0, -1);
            const parentToMove = parentPathToMove.length === 0 ? clonedData : findItemAtPath(parentPathToMove, clonedData);
            const parentToReplace = parentPathToReplace.length === 0 ? clonedData : findItemAtPath(parentPathToReplace, clonedData);
            if (parentToMove && parentToReplace) {
                if ('Items' in parentToMove && 'Items' in parentToReplace) {
                    const indexToMove = pathToMove[pathToMove.length - 1];
                    const indexToReplace = pathToReplace[pathToReplace.length - 1];
                    if (indexToMove !== undefined && indexToReplace !== undefined) {
                        // Replace the item in the desired position
                        parentToReplace.Items[indexToReplace] = itemToMove;
                        return clonedData;
                    }
                }
            }
        }
        // Invalid paths, return unchanged data
        return data;
    };
};
const $50fde2cab6970bb8$export$e2ef7b144deda399 = (pathToMove, pathToReplace)=>{
    return (data)=>{
        if (!data) return undefined;
        const clonedData = JSON.parse(JSON.stringify(data));
        const findItemAtPath = (path, node)=>{
            if (path.length === 1) {
                const newPath = path[0] ?? 0;
                if ('Items' in node && newPath >= 0 && newPath < node.Items.length) return node.Items[newPath];
            } else {
                const [index, ...restPath] = path;
                if ('Items' in node && index !== undefined && index >= 0 && index < node.Items.length) {
                    const item = node.Items[index];
                    if (item && 'Items' in item) return findItemAtPath(restPath, item);
                }
            }
            return undefined;
        };
        const itemToMove = findItemAtPath(pathToMove, clonedData);
        const itemToReplace = findItemAtPath(pathToReplace, clonedData);
        if (itemToMove && itemToReplace) {
            const parentPathToMove = pathToMove.slice(0, -1);
            const parentPathToReplace = pathToReplace.slice(0, -1);
            const parentToMove = parentPathToMove.length === 0 ? clonedData : findItemAtPath(parentPathToMove, clonedData);
            const parentToReplace = parentPathToReplace.length === 0 ? clonedData : findItemAtPath(parentPathToReplace, clonedData);
            if (parentToMove && parentToReplace) {
                if ('Items' in parentToMove && 'Items' in parentToReplace) {
                    const indexToMove = pathToMove[pathToMove.length - 1];
                    const indexToReplace = pathToReplace[pathToReplace.length - 1];
                    if (indexToMove !== undefined && indexToReplace !== undefined) {
                        // Swap the items in the desired positions
                        parentToMove.Items[indexToMove] = itemToReplace;
                        parentToReplace.Items[indexToReplace] = itemToMove;
                        return clonedData;
                    }
                }
            }
        }
        // Invalid paths, return unchanged data
        return data;
    };
};
const $50fde2cab6970bb8$export$b29b09c0e78de6df = (indexToMove, indexToReplace)=>{
    return (data)=>{
        if (!data) return undefined;
        const clonedData = JSON.parse(JSON.stringify(data));
        if (indexToMove >= 0 && indexToMove < clonedData.length && indexToReplace >= 0 && indexToReplace < clonedData.length) {
            // Swap the items in the desired positions
            const temp = clonedData[indexToMove];
            clonedData[indexToMove] = clonedData[indexToReplace];
            clonedData[indexToReplace] = temp;
            return clonedData;
        }
        // Invalid indices, return unchanged data
        return data;
    };
};
const $50fde2cab6970bb8$export$63cb496dd00a537a = (path, newItems)=>{
    return (data)=>{
        if (!data) return undefined;
        // Deep clone the entire tree to avoid modifying the original data
        const clonedData = $50fde2cab6970bb8$var$deepClone(data);
        // Use a reference to traverse the cloned tree
        let currentField = clonedData;
        // Traverse the path to find the target object
        for (const index of path){
            if (currentField && 'Items' in currentField && index >= 0 && index < currentField.Items.length) currentField = currentField.Items[index];
            else // Invalid path, return unchanged data
            return data;
        }
        // Ensure currentField is defined and is a NamedTree or NamedLeaf
        if (currentField && ('Items' in currentField || 'Item' in currentField)) // Modify the cloned tree
        currentField.Items = newItems;
        // Return the modified cloned tree
        return clonedData;
    };
};
function $50fde2cab6970bb8$var$deepClone(obj) {
    if (obj === null || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) {
        const newArray = [];
        for(let i = 0; i < obj.length; i++)newArray[i] = $50fde2cab6970bb8$var$deepClone(obj[i]);
        return newArray;
    }
    if (typeof obj === 'object') {
        const newObj = {};
        for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = $50fde2cab6970bb8$var$deepClone(obj[key]);
        return newObj;
    }
    // If obj is neither null, nor an object, nor an array, return as is
    return obj;
}
function $50fde2cab6970bb8$export$9cb4719e2e525b7a(obj1, obj2) {
    if (obj1 === obj2) return true;
    if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) return false;
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        if (!keys2.includes(key) || !$50fde2cab6970bb8$export$9cb4719e2e525b7a(obj1[key], obj2[key])) return false;
    }
    return true;
}
const $50fde2cab6970bb8$export$e89563da860fe692 = (path, value)=>(data)=>{
        let currentField = data;
        let parent = undefined;
        for (const index of path){
            if (currentField && 'Items' in currentField && index >= 0 && index < currentField.Items.length) {
                parent = currentField;
                currentField = currentField.Items[index];
            } else // Invalid path, return unchanged data
            return data;
        }
        // Ensure currentField is defined
        if (currentField) {
            // Use type assertion to specify the expected type of currentField
            const updatedField = {
                ...currentField,
                Item: value
            };
            // If parent is a NamedTree, update the Items array with the updated child
            if (parent && 'Items' in parent) {
                parent.Items = parent.Items.map((item, index)=>index === path[path.length - 1] ? updatedField : item);
                return data; // Return the top-level parent object with the modified child
            }
            // If currentField is a NamedLeaf, return the updated NamedLeaf
            return updatedField;
        }
        // Invalid path, return unchanged data
        return data;
    };
const $50fde2cab6970bb8$export$934882c7e3a6622a = (path, field, value)=>(data)=>{
        let currentField = data;
        let parent = undefined;
        for (const index of path){
            if (currentField && 'Items' in currentField && index >= 0 && index < currentField.Items.length) {
                parent = currentField;
                currentField = currentField.Items[index];
            } else // Invalid path, return unchanged data
            return data;
        }
        // Ensure currentField is defined
        if (currentField) {
            // Use type assertion to specify the expected type of currentField
            const updatedField = {
                ...currentField,
                [field]: value
            };
            // If parent is a NamedTree, update the Items array with the updated child
            if (parent && 'Items' in parent) {
                parent.Items = parent.Items.map((item, index)=>index === path[path.length - 1] ? updatedField : item);
                return data; // Return the top-level parent object with the modified child
            }
            // If currentField is a NamedLeaf, return the updated NamedLeaf
            return updatedField;
        }
        // Invalid path, return unchanged data
        return data;
    };
const $50fde2cab6970bb8$export$cf952d891f5c44ba = (indices)=>new (0, $kisy7.Lens)((s)=>{
        let currentNode = s;
        for (const index of indices){
            if (currentNode && 'Items' in currentNode && index >= 0 && index < currentNode.Items.length) currentNode = currentNode.Items[index];
            else return undefined;
        }
        if ('Item' in currentNode) // Return the entire object for leaf nodes
        return currentNode;
        else if ('Items' in currentNode) // Return the entire array of objects for nodes with child items
        return currentNode.Items;
        return undefined;
    }, ()=>(s)=>s);
function $50fde2cab6970bb8$export$e06b4687124b7869(tree, currentPath = []) {
    if (tree.selected) // If the current tree is selected, add the current path to the result
    return [
        currentPath
    ];
    let selectedPaths = [];
    // Iterate through the items in the tree
    if (tree.Items) for(let i = 0; i < tree.Items.length; i++){
        const item = tree.Items[i];
        // Recursively search for selected paths in the child items
        const childPaths = $50fde2cab6970bb8$export$e06b4687124b7869(item, [
            ...currentPath,
            i
        ]);
        // Merge the selected paths found in the child items with the current selected paths
        selectedPaths = [
            ...selectedPaths,
            ...childPaths
        ];
    }
    return selectedPaths;
}
function $50fde2cab6970bb8$export$55419b43fbd08bb6(tree) {
    const items = [];
    function traverse(node) {
        if ('Item' in node) items.push(node.Item);
        if ('Items' in node) node.Items.forEach((childNode)=>traverse(childNode));
    }
    traverse(tree);
    return items;
}
function $50fde2cab6970bb8$export$4bb7ffec15540ced(tree) {
    const namedLeafs = [];
    function traverse(node) {
        if ('Item' in node) // Skip NamedLeaf's Item properties, we want the parent NamedLeaf object
        return;
        if ('Items' in node) node.Items.forEach((childNode)=>{
            if ('Item' in childNode) namedLeafs.push(childNode);
            traverse(childNode);
        });
    }
    traverse(tree);
    return namedLeafs;
}
function $50fde2cab6970bb8$export$1d6bfd37f1ddce96(tree, path = []) {
    const namedLeafs = [];
    function traverse(node, currentPath) {
        if ('Item' in node) // Skip NamedLeaf's Item properties, we want the parent NamedLeaf object
        return;
        if ('Items' in node) node.Items.forEach((childNode, index)=>{
            const newPath = [
                ...currentPath,
                index
            ];
            if ('Item' in childNode) namedLeafs.push({
                leaf: childNode,
                path: newPath
            });
            traverse(childNode, newPath);
        });
    }
    traverse(tree, path);
    return namedLeafs;
}
function $50fde2cab6970bb8$export$b11e2b7444dd349f(treeData, quoteData) {
    const namedLeafs = $50fde2cab6970bb8$export$1d6bfd37f1ddce96(treeData);
    return namedLeafs.map((namedLeafWithPath)=>{
        const chargeItem = (0, $f11497db38134253$export$10e160c2df1ec15e)(namedLeafWithPath.path).get(quoteData);
        return {
            namedLeafs: namedLeafWithPath,
            chargeItem: chargeItem
        };
    });
}
const $50fde2cab6970bb8$export$3172d964e040798f = (arr1, arr2)=>{
    if (arr1.length !== arr2.length) return false;
    for(let i = 0; i < arr1.length - 1; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
};
const $50fde2cab6970bb8$export$def75bf9f38fb39f = (path)=>{
    return (data)=>{
        if (!data) return undefined;
        const clonedData = $50fde2cab6970bb8$var$deepClone(data); // Deep clone the entire tree to avoid modifying the original data
        let currentField = clonedData;
        // Copy the path array so that it's not mutated
        const pathCopy = [
            ...path
        ];
        while(pathCopy.length > 0){
            const index = pathCopy.shift();
            if (currentField && 'Items' in currentField && index !== undefined && index >= 0 && index < currentField.Items.length) {
                // If we reach the last index, remove the item.
                if (pathCopy.length === 0) currentField.Items.splice(index, 1);
                else currentField = currentField.Items[index];
            } else // Invalid path, return unchanged data
            return data;
        }
        // Ensure currentField is defined
        if (currentField) return clonedData; // Return the modified cloned data
        // Invalid path, return unchanged data
        return data;
    };
};
const $50fde2cab6970bb8$export$796b1da0f028230a = (template, fields)=>{
    if (!template) return null;
    const templateValues = [
        ...template.Opts.map((variable)=>({
                ...variable,
                Type: 'Opts'
            })),
        ...template.Vars.map((variable)=>({
                ...variable,
                Type: 'Vars'
            }))
    ];
    const getValueFromTemplate = (label)=>{
        if (templateValues) {
            const searchLabel = templateValues.find((item)=>item.Label === label);
            if (searchLabel) switch(searchLabel.Type){
                case 'Opts':
                    return searchLabel.Range.find((r)=>r.Label === searchLabel.Value)?.Names?.eng ?? '';
                case 'Vars':
                    return searchLabel.Value;
            }
        }
        return '';
    };
    return fields.reduce((res, field)=>({
            ...res,
            [field]: getValueFromTemplate(field)
        }), {});
};
const $50fde2cab6970bb8$export$ad3707821486673c = (template, suffix)=>{
    if (!template) return '';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const values = $50fde2cab6970bb8$export$796b1da0f028230a(template, [
        'width',
        'height',
        'Material',
        'Shape',
        'diameter',
        'side',
        'skew'
    ]);
    let prefix = '';
    if ([
        'Circle',
        'Half Circle'
    ].includes(values.Shape)) prefix = values.diameter;
    else if ([
        'Square',
        'Octagon',
        'Quarter Circle',
        'Equilateral Pentagon',
        'Right Pentagon',
        'Right Isosceles Triangle'
    ].includes(values.Shape)) prefix = values.side;
    else if ([
        'Trapzoid',
        'Parallelogram'
    ].includes(values.Shape)) prefix = `${values.width}x${values.height}-${values.skew}"`;
    else prefix = `${values.width}x${values.height}`;
    return `${prefix} ${values.Shape} ${suffix || ''}`;
};




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");
const $217f3868aaf41db2$export$b676c0ee3a871594 = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: "6",
        height: "4",
        viewBox: "0 0 6 4",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M2.73434 1.53326L0.718282 3.54932L0.142383 2.97342L2.73434 0.381461L5.32629 2.97342L4.75039 3.54932L2.73434 1.53326Z",
            fill: "rgba(237, 242, 247, 1)"
        })
    });
const $217f3868aaf41db2$export$6208675820d4cc50 = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        fill: "#A0AEC0",
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 320 512",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
        })
    });
const $217f3868aaf41db2$export$85ac33870499f48b = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: "6",
        height: "4",
        viewBox: "0 0 6 4",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M2.73435 2.33002L4.75041 0.313965L5.32631 0.889864L2.73435 3.48182L0.142395 0.889864L0.718295 0.313965L2.73435 2.33002Z",
            fill: "rgba(237, 242, 247, 1)"
        })
    });
const $217f3868aaf41db2$export$17849064a33f75b9 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        fill: "#A0AEC0",
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 128 512",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"
        })
    });
const $217f3868aaf41db2$export$92ba62bde414cbb2 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        fill: "#A0AEC0",
        xmlns: "http://www.w3.org/2000/svg",
        height: "7px",
        viewBox: "0 0 384 512",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
        })
    });
const $217f3868aaf41db2$export$7e70fb1829f7392e = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        fill: "#A0AEC0",
        xmlns: "http://www.w3.org/2000/svg",
        width: "7px",
        viewBox: "0 0 320 512",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"
        })
    });
const $217f3868aaf41db2$export$d25fb2d4b25c628b = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            id: "Vector",
            d: "M10.6667 1.33333V10.6667H1.33339V1.33333H10.6667ZM10.6667 0H1.33339C0.600061 0 6.10352e-05 0.6 6.10352e-05 1.33333V10.6667C6.10352e-05 11.4 0.600061 12 1.33339 12H10.6667C11.4001 12 12.0001 11.4 12.0001 10.6667V1.33333C12.0001 0.6 11.4001 0 10.6667 0Z",
            fill: "#A0AEC0"
        })
    });
const $217f3868aaf41db2$export$f80e548fa2833b4f = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                id: "Checkbox",
                "clip-path": "url(#clip0_1511_4177)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    id: "Vector",
                    d: "M12.6667 2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4067 14 14 13.4 14 12.6667V3.33333C14 2.6 13.4067 2 12.6667 2ZM6.66667 11.3333L3.33333 8L4.27333 7.06L6.66667 9.44667L11.7267 4.38667L12.6667 5.33333L6.66667 11.3333Z",
                    fill: "#A0AEC0"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_1511_4177",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $217f3868aaf41db2$export$ea7a270f08684700 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M6.64221 2.76465L5.37616 1.49854H1.6C1.26863 1.49854 1 1.76716 1 2.09854V9.90134C1 10.2327 1.26863 10.5013 1.6 10.5013H12.2468C12.5782 10.5013 12.8468 10.2327 12.8468 9.90134V3.36465C12.8468 3.03328 12.5782 2.76465 12.2468 2.76465H6.64221Z",
            fill: "#A0AEC0",
            stroke: "#A0AEC0",
            "stroke-width": "1.4",
            "stroke-linecap": "round"
        })
    });
const $217f3868aaf41db2$export$6032e6db9bc400f5 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M6.64221 2.76465L5.37616 1.49854H1.6C1.26863 1.49854 1 1.76716 1 2.09854V9.90134C1 10.2327 1.26863 10.5013 1.6 10.5013H12.2468C12.5782 10.5013 12.8468 10.2327 12.8468 9.90134V3.36465C12.8468 3.03328 12.5782 2.76465 12.2468 2.76465H6.64221Z",
            stroke: "#A0AEC0",
            "stroke-width": "1.2",
            "stroke-linecap": "round"
        })
    });



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $2c5652d268761e1b$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m0 12H4V8h16z"
}), 'FolderOpen');


const $94c8d913b6827823$var$TreeNodeLabel = ({ node: node, path: path, editMode: editMode, showChildren: showChildren, editModeSelected: editModeSelected, setFieldBasedOnPath: setFieldBasedOnPath, onShowChildren: onShowChildren, onSelectChecbox: onSelectChecbox, onClick: onClick })=>{
    const [isNameEditing, setIsNameEditing] = (0, $acw62.useState)(false);
    const contentNameEditableRef = (0, $acw62.useRef)(null);
    const { Name: Name } = node;
    const offset = (0, $acw62.useMemo)(()=>{
        return `${10 + 22 * ((path || []).length - 1) + ('Item' in node ? 8 : 0)}px`;
    }, [
        path,
        node
    ]);
    const hasDivider = (path || []).length > 1 && 'Item' in node;
    const handleNameDoubleClick = ()=>{
        setIsNameEditing(true);
    };
    const handleNameBlur = ()=>{
        if (path) {
            setFieldBasedOnPath(path, 'Name', contentNameEditableRef.current?.innerText || '');
            setIsNameEditing(false);
        }
    };
    const handleEnterPressOnName = (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            if (path) {
                setFieldBasedOnPath(path, 'Name', e.currentTarget.textContent || '');
                setIsNameEditing(false);
            }
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (isNameEditing) contentNameEditableRef.current?.focus();
    }, [
        isNameEditing
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))('tree-label', {
            ['tree-label--divider']: hasDivider
        }),
        style: {
            '--tree-label-offset': offset
        },
        overflow: "hidden",
        children: [
            'Items' in node && !showChildren && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $217f3868aaf41db2$export$92ba62bde414cbb2), {
                onClick: ()=>!editMode && onShowChildren(),
                className: "mx-2"
            }),
            'Items' in node && showChildren && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $217f3868aaf41db2$export$7e70fb1829f7392e), {
                onClick: ()=>!editMode && onShowChildren(),
                className: "mx-2 tooltip-show"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $217f3868aaf41db2$export$d25fb2d4b25c628b), {
                onClick: ()=>onSelectChecbox(),
                className: `${editMode && !editModeSelected ? '' : 'd-none'} me-2`,
                style: {
                    marginLeft: '2px'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $217f3868aaf41db2$export$f80e548fa2833b4f), {
                onClick: ()=>onSelectChecbox(),
                className: `${editMode && editModeSelected ? '' : 'd-none'}`,
                style: {
                    marginRight: '2px'
                }
            }),
            'Items' in node && !showChildren && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $217f3868aaf41db2$export$ea7a270f08684700), {
                onClick: ()=>!editMode && onShowChildren(),
                className: "me-2"
            }),
            'Items' in node && showChildren && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2c5652d268761e1b$export$2e2bcd8739ae039), {
                onClick: ()=>!editMode && onShowChildren(),
                className: "me-2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                component: "span",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                onDoubleClick: handleNameDoubleClick,
                onClick: onClick,
                onBlur: handleNameBlur,
                onKeyDown: handleEnterPressOnName,
                contentEditable: isNameEditing,
                ref: contentNameEditableRef,
                dangerouslySetInnerHTML: {
                    __html: Name
                }
            })
        ]
    });
};
var $94c8d913b6827823$export$2e2bcd8739ae039 = $94c8d913b6827823$var$TreeNodeLabel;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

function $feb09b234a1ca5fe$export$16a9db7c67dd7eef({ className: className, prefix: prefix, suffix: suffix, onChange: onChange, children: children }) {
    const ref = (0, $acw62.useRef)(null);
    const addPrefix = (text)=>{
        if (!prefix) return text;
        if (text.includes(prefix)) return prefix + text.split('').filter((char)=>char !== prefix).join('');
        return `${prefix} ${text}`;
    };
    const addSuffix = (text)=>{
        if (!suffix) return text;
        if (text.includes(suffix)) return text.split('').filter((char)=>char !== suffix).join('') + suffix;
        return `${text}${suffix}`;
    };
    const handleKeyDown = (e)=>{
        const isNumberKey = /^[0-9]$/.test(e.key);
        if (e.key === 'Backspace' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') ;
        else if (e.key === 'Enter' && e.currentTarget.textContent) {
            e.preventDefault();
            e.currentTarget.textContent = addPrefix(e.currentTarget.textContent);
            e.currentTarget.textContent = addSuffix(e.currentTarget.textContent);
            onChange(e.currentTarget.textContent);
            if (ref.current) ref.current.blur();
        } else if (!isNumberKey) e.preventDefault();
    };
    const handleBlur = (e)=>{
        e.target.innerText = addPrefix(e.target.innerText);
        e.target.innerText = addSuffix(e.target.innerText);
        onChange(e.target.innerText);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        component: "span",
        className: className,
        contentEditable: true,
        onKeyDown: handleKeyDown,
        ref: ref,
        onBlur: handleBlur,
        suppressContentEditableWarning: true,
        children: children
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $83e175cb7e49d325$var$_excluded = [
    "className"
];
const $83e175cb7e49d325$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9c1b7b40cd19f5fe$export$81478e24460c57f2), classes);
};
const $83e175cb7e49d325$var$ListItemIconRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex'
    }, ownerState.alignItems === 'flex-start' && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $83e175cb7e49d325$var$ListItemIcon = /*#__PURE__*/ $acw62.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $83e175cb7e49d325$var$_excluded);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $83e175cb7e49d325$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($83e175cb7e49d325$var$ListItemIconRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $83e175cb7e49d325$export$2e2bcd8739ae039 = $83e175cb7e49d325$var$ListItemIcon;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0d696835f9b43a35$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $0d696835f9b43a35$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c01aa6ddbe5e68bd$export$1061006a0db3aeb5), classes);
};
const $0d696835f9b43a35$var$ListItemTextRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        flex: '1 1 auto',
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $0d696835f9b43a35$var$ListItemText = /*#__PURE__*/ $acw62.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $1En50.default)(props, $0d696835f9b43a35$var$_excluded);
    const { dense: dense } = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $0d696835f9b43a35$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        variant: dense ? 'body2' : 'body1',
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : 'span',
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0d696835f9b43a35$var$ListItemTextRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $0d696835f9b43a35$export$2e2bcd8739ae039 = $0d696835f9b43a35$var$ListItemText;



var $7e41c566302bd0e2$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($7e41c566302bd0e2$exports, "__esModule", {
    value: true
});
$7e41c566302bd0e2$exports.default = void 0;

var $7e41c566302bd0e2$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $7e41c566302bd0e2$var$_default = $7e41c566302bd0e2$exports.default = (0, $7e41c566302bd0e2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z"
}), 'DeleteOutline');



function $5e1c7f5c29eb95f1$export$ad2741d708ffd189({ id: id, onAction: onAction } = {
    id: 'simple-popover'
}) {
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const handleDelete = ()=>{
        if (onAction) onAction('delete');
        handleClose();
    };
    const open = Boolean(anchorEl);
    const popoverId = open ? id : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "tree-node-menu",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                className: "tree-icon",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $217f3868aaf41db2$export$17849064a33f75b9), {
                    onClick: handleClick
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $012baef8dc9ae9d0$export$2e2bcd8739ae039), {
                id: popoverId,
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                sx: {
                    '& .MuiPaper-root': {
                        overflow: 'visible',
                        marginLeft: '8px',
                        marginTop: '8px',
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            width: '12px',
                            height: '12px',
                            backgroundColor: '#2D3748',
                            borderTop: '1px solid #48BB78',
                            borderLeft: '1px solid #48BB78',
                            transform: 'rotate(45deg)',
                            top: '-6px',
                            right: '4px',
                            marginLeft: '-6px'
                        }
                    }
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    className: "tree-node-menu__content",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fbb3fa0cdc277971$export$2e2bcd8739ae039), {
                        sx: {
                            padding: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83e175cb7e49d325$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7e41c566302bd0e2$exports))), {
                                        fontSize: "small",
                                        sx: {
                                            color: '#cbd5e0'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                    sx: {
                                        '& .MuiTypography-root': {
                                            fontSize: '12px'
                                        }
                                    },
                                    onClick: handleDelete,
                                    children: "Delete"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $d8seH = parcelRequire("d8seH");
const $0ca3ac2f48b65f52$var$QButton = (0, $d8seH.default)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039))(()=>({
        height: '40px',
        background: '#2C7A7B',
        color: '#fff',
        padding: '8px',
        fontSize: '20px',
        fontWeight: '500',
        borderRadius: '6px',
        minWidth: 'auto',
        whiteSpace: 'nowrap'
    }));
var $0ca3ac2f48b65f52$export$2e2bcd8739ae039 = $0ca3ac2f48b65f52$var$QButton;






var $d8seH = parcelRequire("d8seH");

var $9c5eb05f9740712a$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($9c5eb05f9740712a$exports, "__esModule", {
    value: true
});
$9c5eb05f9740712a$exports.default = void 0;

var $9c5eb05f9740712a$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9c5eb05f9740712a$var$_default = $9c5eb05f9740712a$exports.default = (0, $9c5eb05f9740712a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');


const $24f0a8bb8c2e8fd2$var$StyledDialog = (0, $d8seH.default)((0, $4f13784bd714c44e$export$2e2bcd8739ae039))(()=>({
        '& .MuiPaper-root': {
            background: '#2D3748',
            borderRadius: '6px',
            border: '4px solid #48BB78'
        }
    }));
const $24f0a8bb8c2e8fd2$var$StyledDialogTitle = (0, $d8seH.default)((0, $a6ac58aca374c76c$export$2e2bcd8739ae039))(()=>({
        color: 'white',
        fontSize: '24px',
        fontWeight: '500',
        paddingRight: '64px'
    }));
const $24f0a8bb8c2e8fd2$var$StyledDialogActions = (0, $d8seH.default)((0, $207bc6ab7c60f4b2$export$2e2bcd8739ae039))(()=>({
        padding: '16px 24px'
    }));
const $24f0a8bb8c2e8fd2$export$de466dd8317b0b75 = ({ open: open, title: title, okLabel: okLabel, cancelLabel: cancelLabel, onClose: onClose, onOk: onOk })=>{
    const handleRedirect = (save)=>{
        if (onOk) onOk(save);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($24f0a8bb8c2e8fd2$var$StyledDialog, {
        open: open,
        className: "alert-dialog",
        onClose: onClose,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                size: "small",
                sx: {
                    minWidth: '24px',
                    width: '24px',
                    height: '24px',
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    padding: 0,
                    color: '#fff'
                },
                onClick: onClose,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9c5eb05f9740712a$exports))), {
                    sx: {
                        width: '24px',
                        height: '24px'
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($24f0a8bb8c2e8fd2$var$StyledDialogTitle, {
                id: "alert-dialog-title",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($24f0a8bb8c2e8fd2$var$StyledDialogActions, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ca3ac2f48b65f52$export$2e2bcd8739ae039), {
                        variant: "text",
                        autoFocus: true,
                        onClick: ()=>handleRedirect(true),
                        children: okLabel || 'Ok'
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ca3ac2f48b65f52$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        onClick: ()=>handleRedirect(false),
                        children: cancelLabel || 'Cancel'
                    })
                ]
            })
        ]
    });
};



function $0121dbde21e8aaba$export$2eba8ec3a333fdbb({ node: node, navigatedItem: navigatedItem, updateSelectedPath: updateSelectedPath, quoteData: quoteData, path: path, editMode: editMode, onSelect: onSelect, onDelete: onDelete, selectedItemsData: selectedItemsData, selectedPath: selectedPath, setFieldBasedOnPath: setFieldBasedOnPath, onDragStart: onDragStart, onDrop: onDrop, onDragOver: onDragOver, topParentData: topParentData, setTreeData: setTreeData, resetNavigatedItem: resetNavigatedItem }) {
    const { mainViewMode: mainViewMode } = (0, $acw62.useContext)((0, $a388f687e0a39747$export$afffaa0e40c01a5d));
    const [isNavigatedItem, setIsNavigatedItem] = (0, $acw62.useState)(path && navigatedItem && path.toString() === navigatedItem.toString());
    const isSelectedPath = selectedPath && selectedPath.toString() === path?.toString();
    const editModeSelected = selectedItemsData?.selected;
    const [showChildren, setShowChildren] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [dragEntered, setDragEntered] = (0, $acw62.useState)(false);
    const [openDelete, setOpenDelete] = (0, $acw62.useState)(false);
    const templateValues = (0, $acw62.useMemo)(()=>{
        const item = node.Item;
        if (item) return [
            ...(item.Opts || []).map((variable)=>({
                    ...variable,
                    Type: 'Opts'
                })),
            ...(item.Vars || []).map((variable)=>({
                    ...variable,
                    Type: 'Vars'
                }))
        ];
        return [];
    }, [
        node
    ]);
    const gridTemplateColumns = (0, $acw62.useMemo)(()=>{
        if (mainViewMode === (0, $a388f687e0a39747$export$bab437785f90cbb4).LIST_VIEW) return `minmax(12px, 12px) 1fr repeat(${(0, $45dc03e7e5217533$export$53b3c91859018cd4).length}, auto) 176px`;
        return '12px 1fr auto';
    }, [
        mainViewMode
    ]);
    const handleCountChange = (newCount)=>{
        const newValue = parseInt(newCount, 10);
        if (!isNaN(newValue)) {
            if (path) setFieldBasedOnPath(path, 'Count', newValue);
        }
    };
    const handleTooltipClick = ()=>{
        setShowChildren(!showChildren);
    };
    const handleCheckboxClick = ()=>{
        if (path) onSelect({
            path: path,
            selectStatus: !editModeSelected || false
        });
    };
    const onDragEnter = ()=>{
        setDragEntered(true);
    };
    const onDragLeave = ()=>{
        setDragEntered(false);
    };
    const handleMenuAction = (action)=>{
        if (action === 'delete') setOpenDelete(true);
    };
    const handleDelete = (yes)=>{
        if (path && yes) onDelete(path);
        setOpenDelete(false);
    };
    (0, $acw62.useEffect)(()=>{
        if (navigatedItem?.toString() === path?.toString()) setIsNavigatedItem(true);
        else setIsNavigatedItem(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        navigatedItem
    ]);
    /*
	 * 'Items' in node means data type is BulkDesign
	 * 'Item' in node means data type is BulkDesignLeaf
	 */ return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f92832698674c928$export$2e2bcd8739ae039), {
                draggable: true,
                onDragStart: (e)=>{
                    if (path) onDragStart(e, path);
                },
                onDrop: (e)=>{
                    setDragEntered(false);
                    if (path) onDrop(e, path);
                },
                onDragOver: onDragOver,
                onDragLeave: onDragLeave,
                onDragEnter: onDragEnter,
                "data-tree-path": JSON.stringify(path),
                "data-tree-is-navigated": isNavigatedItem,
                "data-tree-is-selected": isSelectedPath,
                className: "tree-list-item",
                onMouseEnter: ()=>{
                    resetNavigatedItem();
                    setIsNavigatedItem(true);
                },
                onMouseLeave: ()=>setIsNavigatedItem(false),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))('tree-node-container', {
                            ['tree-node-container--selected']: !editMode && isSelectedPath,
                            ['tree-node-container--selected-edit']: isNavigatedItem || !isNavigatedItem && editMode && editModeSelected,
                            ['tree-node-container--selected-hover']: !isNavigatedItem && !editMode && isSelectedPath,
                            ['tree-node-container--dragging']: dragEntered
                        }),
                        style: {
                            gridTemplateColumns: gridTemplateColumns
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                className: "tree-node-container__divider"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94c8d913b6827823$export$2e2bcd8739ae039), {
                                node: node,
                                path: path,
                                editMode: editMode,
                                showChildren: showChildren,
                                editModeSelected: editModeSelected,
                                setFieldBasedOnPath: setFieldBasedOnPath,
                                onShowChildren: handleTooltipClick,
                                onSelectChecbox: handleCheckboxClick,
                                onClick: ()=>path && updateSelectedPath(path)
                            }),
                            mainViewMode === (0, $a388f687e0a39747$export$bab437785f90cbb4).LIST_VIEW && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: (0, $45dc03e7e5217533$export$53b3c91859018cd4).map((column)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        className: "tree-node-column",
                                        style: {
                                            width: column.width,
                                            minWidth: column.width,
                                            maxWidth: column.width,
                                            justifyContent: column.align || 'center',
                                            textAlign: column.align || 'center'
                                        },
                                        children: column.render ? column.render(node, quoteData, templateValues) : column.label
                                    }, column.id))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))('label-right', {
                                    mini: mainViewMode !== (0, $a388f687e0a39747$export$bab437785f90cbb4).LIST_VIEW
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        component: "span",
                                        children: mainViewMode === (0, $a388f687e0a39747$export$bab437785f90cbb4).LIST_VIEW ? '' : `$ ${quoteData?.Total?.USD ?? 0}`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        className: "count-box",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $feb09b234a1ca5fe$export$16a9db7c67dd7eef), {
                                                className: "tag",
                                                suffix: "x",
                                                onChange: handleCountChange,
                                                children: [
                                                    node.Count,
                                                    "x"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                component: "span",
                                                className: "count-arrows-div",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                        component: "span",
                                                        className: "count-arrows-item",
                                                        onClick: ()=>{
                                                            handleCountChange((node.Count + 1).toString());
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $217f3868aaf41db2$export$b676c0ee3a871594), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                        component: "span",
                                                        className: "count-arrows-item",
                                                        onClick: ()=>{
                                                            node.Count > 1 && handleCountChange((node.Count - 1).toString());
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $217f3868aaf41db2$export$85ac33870499f48b), {})
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5e1c7f5c29eb95f1$export$ad2741d708ffd189), {
                                        id: `tree-node-menu-${path?.join('-')}`,
                                        onAction: handleMenuAction
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        style: {
                                            width: '16px'
                                        },
                                        onClick: ()=>path && updateSelectedPath(path),
                                        className: "tree-icon",
                                        children: 'Item' in node && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $217f3868aaf41db2$export$6208675820d4cc50), {})
                                    })
                                ]
                            })
                        ]
                    }),
                    'Items' in node && node.Items.length && showChildren ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $efa29d1bcd207503$export$7fbedc92909ed28e), {
                        navigatedItem: navigatedItem,
                        onDelete: onDelete,
                        setFieldBasedOnPath: setFieldBasedOnPath,
                        selectedPath: selectedPath,
                        selectedItemsData: selectedItemsData ? 'Items' in selectedItemsData ? selectedItemsData.Items : undefined : undefined,
                        onSelect: onSelect,
                        editMode: editMode,
                        path: path,
                        quoteData: quoteData ? 'Charges' in quoteData ? quoteData.Charges : 'Items' in quoteData ? quoteData.Items : undefined : undefined,
                        updateSelectedPath: updateSelectedPath,
                        treeData: node.Items,
                        onDragStart: onDragStart,
                        onDrop: onDrop,
                        onDragOver: onDragOver,
                        topParentData: topParentData,
                        setTreeData: setTreeData,
                        resetNavigatedItem: resetNavigatedItem
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $24f0a8bb8c2e8fd2$export$de466dd8317b0b75), {
                open: openDelete,
                title: "Are you sure you want to delete it?",
                okLabel: "Yes",
                cancelLabel: "No",
                onOk: handleDelete,
                onClose: ()=>setOpenDelete(false)
            })
        ]
    });
}




function $efa29d1bcd207503$export$7fbedc92909ed28e({ treeData: treeData, navigatedItem: navigatedItem, updateSelectedPath: updateSelectedPath, quoteData: quoteData, path: path, editMode: editMode, onSelect: onSelect, onDelete: onDelete, selectedItemsData: selectedItemsData, selectedPath: selectedPath, setFieldBasedOnPath: setFieldBasedOnPath, topParentData: topParentData, onDragOver: onDragOver, setTreeData: setTreeData, resetNavigatedItem: resetNavigatedItem }) {
    /*
	 * 'Charges' in item means data type is Quote
	 * 'Discount' in item means data type is Charge
	 * else data type is BulkDesign or BulkDesignLeaf
	 */ // Drag and Drop
    const [draggedIndex, setDraggedIndex] = (0, $acw62.useState)(undefined);
    const [draggedPath, setDraggedPath] = (0, $acw62.useState)(undefined);
    const onDragStart = (index, draggedPathToSet)=>{
        setDraggedPath(draggedPathToSet);
        setDraggedIndex(index);
    };
    const onDrop = (indexToReplace, index, pathToReplace)=>{
        if (index || index === 0) {
            const newTreeDataItems = (0, $50fde2cab6970bb8$export$b29b09c0e78de6df)(index, indexToReplace)(treeData);
            if (newTreeDataItems) {
                const newTreeData = (0, $50fde2cab6970bb8$export$63cb496dd00a537a)(pathToReplace || [], newTreeDataItems)(topParentData);
                if (newTreeData) {
                    if (!(0, $50fde2cab6970bb8$export$9cb4719e2e525b7a)(newTreeData, topParentData)) setTreeData(newTreeData);
                }
            }
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $640cd381f5e8b3ea$export$2e2bcd8739ae039), {
        className: "tree-list",
        children: treeData.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $0121dbde21e8aaba$export$2eba8ec3a333fdbb), {
                navigatedItem: navigatedItem,
                selectedPath: selectedPath,
                setFieldBasedOnPath: setFieldBasedOnPath,
                onSelect: onSelect,
                onDelete: onDelete,
                editMode: editMode,
                path: path ? [
                    ...path,
                    index
                ] : [
                    index
                ],
                selectedItemsData: selectedItemsData ? selectedItemsData[index] : undefined,
                quoteData: quoteData ? 'Charges' in quoteData ? quoteData : quoteData[index] : undefined,
                updateSelectedPath: updateSelectedPath,
                node: item,
                onDragStart: ()=>onDragStart(index, path || []),
                onDrop: ()=>onDrop(index, draggedIndex, draggedPath),
                onDragOver: onDragOver,
                topParentData: topParentData,
                setTreeData: setTreeData,
                resetNavigatedItem: resetNavigatedItem
            }, `${index}-${item.Name}-${item.Count}-${JSON.stringify(item.Item || {})}}`))
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $e0d91f22a9f86d1c$var$TemplateTreeViewFooter = ({ quote: quote })=>{
    const { mainViewMode: mainViewMode } = (0, $acw62.useContext)((0, $a388f687e0a39747$export$afffaa0e40c01a5d));
    const columns = [
        {
            id: 'price',
            width: '90px',
            label: 'Price',
            align: 'right',
            render: (quote)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    fontSize: '14px',
                    fontFamily: 'Inter',
                    children: [
                        "$ ",
                        quote?.Total.USD
                    ]
                })
        },
        {
            id: 'count',
            width: '168px',
            label: 'Price',
            align: 'center',
            render: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    fontSize: '14px',
                    fontFamily: 'Inter',
                    children: "0"
                })
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        justifyContent: 'space-between',
        className: "side-bar-bottom",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                fontSize: '14px',
                fontFamily: 'Inter',
                children: "Job / Project Total"
            }),
            mainViewMode === (0, $a388f687e0a39747$export$bab437785f90cbb4).LIST_VIEW ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: 'grid',
                    gridTemplateColumns: 'auto auto',
                    alignItems: 'center'
                },
                children: columns.map((column)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        style: {
                            display: 'flex',
                            padding: '0 0.25rem',
                            width: column.width,
                            minWidth: column.width,
                            maxWidth: column.width,
                            borderLeft: '1px solid #EDF2F7',
                            justifyContent: column.align || 'center',
                            alignItems: 'center',
                            boxSizing: 'border-box'
                        },
                        children: column.render ? column.render(quote) : column.label
                    }, column.id))
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                fontSize: '14px',
                fontFamily: 'Inter',
                children: [
                    "$ ",
                    quote.Total.USD
                ]
            })
        ]
    });
};
var $e0d91f22a9f86d1c$export$2e2bcd8739ae039 = $e0d91f22a9f86d1c$var$TemplateTreeViewFooter;



const $838f51ccfb30a43f$var$TemplateTreeView = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { treeData: treeData, setTreeData: setTreeData, updateSelectedPath: updateSelectedPath, quoteData: quoteData, addTemplate: addTemplate, selectedPath: selectedPath, setQuoteData: setQuoteData } = props;
    const { dispatch: dispatch } = (0, $acw62.useContext)((0, $a388f687e0a39747$export$afffaa0e40c01a5d));
    const [navigatedItem, setNavigatedItem] = (0, $acw62.useState)(undefined);
    const [editMode, setEditMode] = (0, $acw62.useState)(false);
    const [selectedItemsData, setSelectedItemsData] = (0, $acw62.useState)(convertToNewModelTree(treeData));
    (0, $acw62.useEffect)(()=>{
        setSelectedItemsData(convertToNewModelTree(treeData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $acw62.useEffect)(()=>{
        const handleKeyPress = (e)=>{
            switch(e.key){
                case 'ArrowUp':
                    handleArrowPress('up');
                    break;
                case 'ArrowDown':
                    handleArrowPress('down');
                    break;
                case 'Enter':
                    handleEnter();
                    break;
                case 'Escape':
                    handleEscape();
                    break;
                case 'Delete':
                    removeItem();
                    break;
                default:
                    break;
            }
        };
        document.addEventListener('keydown', handleKeyPress);
        return ()=>{
            document.removeEventListener('keydown', handleKeyPress);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedPath,
        editMode,
        selectedItemsData,
        navigatedItem
    ]);
    const setFieldBasedOnPath = (path, field, newValue)=>{
        const newTreeData = (0, $50fde2cab6970bb8$export$934882c7e3a6622a)(path, field, newValue)(treeData);
        console.log(newTreeData);
        setTreeData(newTreeData);
        const newQuoteData = (0, $f11497db38134253$export$8f141d98755d06ac)(path, field, newValue)(quoteData);
        setQuoteData(newQuoteData);
    };
    function convertToNewModelTree(data) {
        return {
            Name: data.Name,
            Count: data.Count,
            Items: data.Items.map((item)=>{
                if ('Items' in item) return convertToNewModelTree(item);
                else return {
                    Item: item.Item,
                    selected: false,
                    Name: item.Name,
                    Count: item.Count
                };
            }),
            selected: false
        };
    }
    const toggleEditMode = ()=>{
        setEditMode(!editMode);
    };
    const handleSelect = (data)=>{
        const updatedData = updateSelectedStatus(selectedItemsData, data.path, data.selectStatus);
        const updatedData2 = updateSelectionStatusRecursively(updatedData, selectedItemsData, undefined);
        setSelectedItemsData(updatedData2);
    };
    function updateSelectionStatusRecursively(node, selectedItemsData, selected) {
        if (isLeaf(node)) {
            if ('Item' in node) return {
                ...node,
                selected: selected !== undefined ? selected : node.selected
            };
            return node;
        }
        const anyChildSelected = node.Items.some((child)=>{
            return child.selected;
        });
        const allChildrenSelected = node.Items.every((child, index)=>{
            if ('Item' in child) return child.selected;
            else if ('Items' in child && selectedItemsData && 'Items' in selectedItemsData) return updateSelectionStatusRecursively(child, selectedItemsData.Items[index], undefined).selected;
            return false;
        });
        if (selectedItemsData && 'Items' in selectedItemsData) {
            if (allChildrenSelected) {
                const selectStatus = selectedItemsData.selected ? !node.selected ? false : true : node.selected ? true : true;
                return {
                    ...node,
                    selected: selectStatus,
                    Items: node.Items.map((item, index)=>updateSelectionStatusRecursively(item, selectedItemsData.Items[index], selectStatus))
                };
            } else if (anyChildSelected) {
                const selectStatus = !selectedItemsData.selected ? node.selected ? true : false : node.selected ? false : false;
                return {
                    ...node,
                    selected: selectStatus,
                    Items: node.Items.map((item, index)=>updateSelectionStatusRecursively(item, selectedItemsData.Items[index], selectStatus ? selectStatus : undefined))
                };
            } else return {
                ...node,
                selected: node.selected,
                Items: node.Items.map((item, index)=>updateSelectionStatusRecursively(item, selectedItemsData.Items[index], node.selected))
            };
        } else return {
            ...node,
            selected: node.selected,
            Items: node.Items.map((item)=>updateSelectionStatusRecursively(item, undefined, node.selected))
        };
    }
    function isLeaf(node) {
        return 'Item' in node;
    }
    function updateSelectedStatus(obj, path, selectStatus) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const navigateObject = (obj, path, selectStatus)=>{
            if (path.length === 0) return {
                ...obj,
                selected: selectStatus
            }; // Toggle selected property when path is empty
            const index = path[0];
            const restPath = path.slice(1);
            if ('Items' in obj && index !== undefined && index >= 0 && index < obj.Items.length) {
                const updatedItems = [
                    ...obj.Items
                ];
                updatedItems[index] = navigateObject(obj.Items[index], restPath, selectStatus);
                return {
                    ...obj,
                    Items: updatedItems
                };
            }
            return obj;
        };
        if (!obj || path.length === 0) return obj;
        return navigateObject(obj, path, selectStatus);
    }
    const handleEnter = ()=>{
        const treeItemElements = document.querySelectorAll('[data-tree-path]');
        const treeItemArray = Array.from(treeItemElements);
        const navigatedIndex = treeItemArray.findIndex((element)=>{
            return element.getAttribute('data-tree-is-navigated') === 'true';
        });
        const isAnyNavigated = navigatedIndex !== -1;
        if (isAnyNavigated) {
            const navigatedPath = treeItemArray[navigatedIndex]?.getAttribute('data-tree-path');
            if (navigatedPath && typeof navigatedPath === 'string') {
                const path = JSON.parse(navigatedPath);
                const isAlreadySelected = treeItemArray[navigatedIndex]?.getAttribute('data-tree-is-selected');
                if (editMode) handleSelect({
                    path: path,
                    selectStatus: !(isAlreadySelected ? isAlreadySelected === 'true' ? true : false : false)
                });
                else if ((0, $50fde2cab6970bb8$export$37a2eaab5eadb46)(path).get(treeData)) updateSelectedPath(isAlreadySelected ? undefined : path);
            }
        }
    };
    const handleEscape = ()=>{
        setNavigatedItem(undefined);
        updateSelectedPath(undefined);
    };
    const getMatchingListElement = (treeItemElements, navigatedSelectedIndex, resetNumber, type)=>{
        const listItem = treeItemElements[navigatedSelectedIndex];
        const listItemNew = treeItemElements[navigatedSelectedIndex + resetNumber];
        if (listItem && listItemNew) {
            const listItemPath = JSON.parse(listItem?.getAttribute('data-tree-path') || '');
            const listItemNewPath = JSON.parse(listItemNew?.getAttribute('data-tree-path') || '');
            if (listItemPath.length === listItemNewPath.length) return listItemNew;
            else return getMatchingListElement(treeItemElements, navigatedSelectedIndex, type === 'down' ? resetNumber + 1 : resetNumber - 1, type);
        } else return undefined;
    };
    const removeItem = ()=>{
        if (editMode) {
            // remove the checked items (multiple).
            const allSelectedPaths = (0, $50fde2cab6970bb8$export$e06b4687124b7869)({
                ...selectedItemsData,
                selected: false
            });
            let tData = treeData;
            let qData = quoteData;
            if (allSelectedPaths.length) for (const path of allSelectedPaths){
                const res = handleRemoveItem(path, tData, qData);
                tData = res.tree;
                qData = res.quote;
            }
        } else if (selectedPath) // remove the selected item.
        handleRemoveItem(selectedPath, treeData, quoteData);
    };
    const removeSelectedItem = (path)=>{
        if (path) handleRemoveItem(path, treeData, quoteData);
    };
    const handleRemoveItem = (path, tData, qData)=>{
        if (!path) return {
            tree: tData,
            quote: qData
        };
        const newTreeData = (0, $50fde2cab6970bb8$export$def75bf9f38fb39f)(path)(tData);
        setTreeData(newTreeData);
        const newQuoteData = (0, $f11497db38134253$export$c3d74211dbe4930e)(path)(qData);
        setQuoteData(newQuoteData);
        setSelectedItemsData(convertToNewModelTree(newTreeData));
        setNavigatedItem(undefined);
        updateSelectedPath(undefined);
        return {
            tree: newTreeData,
            quote: newQuoteData
        };
    };
    const handleArrowPress = (type)=>{
        const treeItemElements = document.querySelectorAll('[data-tree-path]');
        const treeItemArray = Array.from(treeItemElements);
        let resetNumber = 1;
        if (selectedPath && navigatedItem && selectedPath.toString() === navigatedItem.toString()) {
            const navigatedSelectedIndex = treeItemArray.findIndex((element)=>{
                return element.getAttribute('data-tree-path') === JSON.stringify(selectedPath);
            });
            if (navigatedSelectedIndex >= 0) {
                if (type === 'up') resetNumber = -1;
                const listElement = getMatchingListElement(treeItemElements, navigatedSelectedIndex, resetNumber, type);
                if (listElement) {
                    const path = JSON.parse(treeItemElements[navigatedSelectedIndex]?.getAttribute('data-tree-path') || '') || [];
                    const pathToRelpace = JSON.parse(listElement?.getAttribute('data-tree-path') || '') || [];
                    const isReplacable = (0, $50fde2cab6970bb8$export$3172d964e040798f)(path, pathToRelpace);
                    if (isReplacable) {
                        const ItemsToMutate = (0, $50fde2cab6970bb8$export$6ea27fa64ccd2a4d)(path.slice(0, -1)).get(treeData);
                        const newTreeDataItems = (0, $50fde2cab6970bb8$export$b29b09c0e78de6df)(path[path.length - 1] ?? 0, pathToRelpace[pathToRelpace.length - 1] ?? 0)(ItemsToMutate);
                        if (newTreeDataItems) {
                            const newTreeData = (0, $50fde2cab6970bb8$export$63cb496dd00a537a)(path.slice(0, -1), newTreeDataItems)(treeData);
                            setTreeData(newTreeData);
                            updateSelectedPath(pathToRelpace);
                            setNavigatedItem(pathToRelpace);
                        }
                    }
                }
            }
        } else {
            if (selectedPath) updateSelectedPath(undefined);
            let resetValue = [
                0
            ];
            if (type === 'up') {
                const lastValue = treeItemArray[treeItemArray.length - 1]?.getAttribute('data-tree-path');
                if (lastValue && lastValue.toString()) {
                    resetValue = JSON.parse(lastValue);
                    resetNumber = -1;
                }
            }
            const navigatedIndex = treeItemArray.findIndex((element)=>{
                return element.getAttribute('data-tree-is-navigated') === 'true';
            });
            const isAnyNavigated = navigatedIndex !== -1;
            if (isAnyNavigated) {
                const nextItem = treeItemArray[navigatedIndex + resetNumber]?.getAttribute('data-tree-path');
                if (nextItem && typeof nextItem === 'string') {
                    const newNextItem = JSON.parse(nextItem);
                    setNavigatedItem(newNextItem);
                } else setNavigatedItem(resetValue);
            } else if ((0, $50fde2cab6970bb8$export$4f4f3d7650ec6d20)(resetValue).get(treeData)) setNavigatedItem(resetValue);
        }
    };
    const duplicateItem = ()=>{
        if (editMode) {
            const allSelectedPaths = (0, $50fde2cab6970bb8$export$e06b4687124b7869)(selectedItemsData);
            if (allSelectedPaths.length) for (const path of allSelectedPaths)handleDuplication(path);
        } else if (selectedPath) handleDuplication(selectedPath);
    };
    const handleDuplication = (selectedPath)=>{
        let newItemToInsert = (0, $50fde2cab6970bb8$export$558bb72b152ded6a)(selectedPath).get(treeData);
        const newQuoteToInsert = (0, $f11497db38134253$export$10e160c2df1ec15e)(selectedPath).get(quoteData);
        if (newItemToInsert) {
            newItemToInsert = {
                ...newItemToInsert,
                Name: `${newItemToInsert.Name} (clone)`
            };
            const newTreeData = (0, $50fde2cab6970bb8$export$773ddc560f4a0181)(selectedPath, newItemToInsert)(treeData);
            setTreeData(newTreeData);
            setQuoteData((0, $f11497db38134253$export$c6a52f3075b036ea)(selectedPath, newQuoteToInsert)(quoteData));
            setSelectedItemsData(convertToNewModelTree(newTreeData));
            const newItemPath = [
                ...selectedPath.slice(0, selectedPath.length - 1),
                (selectedPath[selectedPath.length - 1] || 0) + 1
            ];
            updateSelectedPath(newItemPath, newTreeData);
        }
    };
    const onDragOver = (e)=>{
        e.preventDefault();
    };
    const resetNavigatedItem = ()=>{
        setNavigatedItem(undefined);
    };
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            handleDuplication: handleDuplication
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            className: "side-bar",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                className: "tree-view",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        className: "side-bar-content",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d05af790682acfac$export$2e2bcd8739ae039), {
                                duplicateItem: duplicateItem,
                                treeData: treeData,
                                addTemplate: addTemplate,
                                toggleEditMode: toggleEditMode
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                onDragOver: onDragOver,
                                className: "tree-view__container",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $efa29d1bcd207503$export$7fbedc92909ed28e), {
                                    navigatedItem: navigatedItem,
                                    setFieldBasedOnPath: setFieldBasedOnPath,
                                    onDelete: removeSelectedItem,
                                    selectedPath: selectedPath,
                                    selectedItemsData: selectedItemsData.Items,
                                    onSelect: handleSelect,
                                    editMode: editMode,
                                    path: undefined,
                                    quoteData: quoteData.Charges,
                                    updateSelectedPath: (path)=>{
                                        setNavigatedItem(undefined);
                                        updateSelectedPath(path);
                                        dispatch({
                                            type: (0, $a388f687e0a39747$export$1129347c88918a1a)
                                        });
                                    },
                                    treeData: treeData.Items,
                                    onDragStart: ()=>{},
                                    onDrop: ()=>{},
                                    onDragOver: onDragOver,
                                    topParentData: treeData,
                                    setTreeData: setTreeData,
                                    resetNavigatedItem: resetNavigatedItem
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0d91f22a9f86d1c$export$2e2bcd8739ae039), {
                        quote: quoteData
                    })
                ]
            })
        })
    });
});
var $838f51ccfb30a43f$export$2e2bcd8739ae039 = $838f51ccfb30a43f$var$TemplateTreeView;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jjlaj = parcelRequire("jjlaj");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b86eb8364bb4993c$export$29cad1383b3f235d(slot) {
    return (0, $4Cod0.default)('MuiCircularProgress', slot);
}
const $b86eb8364bb4993c$var$circularProgressClasses = (0, $beCSm.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $b86eb8364bb4993c$export$2e2bcd8739ae039 = $b86eb8364bb4993c$var$circularProgressClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $19b4ac261663afa8$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $19b4ac261663afa8$var$_ = (t)=>t, $19b4ac261663afa8$var$_t, $19b4ac261663afa8$var$_t2, $19b4ac261663afa8$var$_t3, $19b4ac261663afa8$var$_t4;
const $19b4ac261663afa8$var$SIZE = 44;
const $19b4ac261663afa8$var$circularRotateKeyframe = (0, $jjlaj.keyframes)($19b4ac261663afa8$var$_t || ($19b4ac261663afa8$var$_t = $19b4ac261663afa8$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $19b4ac261663afa8$var$circularDashKeyframe = (0, $jjlaj.keyframes)($19b4ac261663afa8$var$_t2 || ($19b4ac261663afa8$var$_t2 = $19b4ac261663afa8$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $19b4ac261663afa8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $jTnBY.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $jTnBY.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $b86eb8364bb4993c$export$29cad1383b3f235d), classes);
};
const $19b4ac261663afa8$var$CircularProgressRoot = (0, $d8seH.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $jjlaj.css)($19b4ac261663afa8$var$_t3 || ($19b4ac261663afa8$var$_t3 = $19b4ac261663afa8$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $19b4ac261663afa8$var$circularRotateKeyframe));
const $19b4ac261663afa8$var$CircularProgressSVG = (0, $d8seH.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $19b4ac261663afa8$var$CircularProgressCircle = (0, $d8seH.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $jjlaj.css)($19b4ac261663afa8$var$_t4 || ($19b4ac261663afa8$var$_t4 = $19b4ac261663afa8$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $19b4ac261663afa8$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $19b4ac261663afa8$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $1En50.default)(props, $19b4ac261663afa8$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $19b4ac261663afa8$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($19b4ac261663afa8$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        style: (0, $8nd05.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE} ${$19b4ac261663afa8$var$SIZE}`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $19b4ac261663afa8$var$SIZE,
                cy: $19b4ac261663afa8$var$SIZE,
                r: ($19b4ac261663afa8$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $19b4ac261663afa8$export$2e2bcd8739ae039 = $19b4ac261663afa8$var$CircularProgress;



var $721e36edb0f53275$exports = {};
$721e36edb0f53275$exports = JSON.parse("{\"Count\":1,\"Items\":[{\"Count\":1,\"Items\":[{\"Count\":2,\"Item\":{\"Panels\":[{\"Cutouts\":[{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[],\"Front\":[\"AcidEtch\",\"Sandblast\"],\"Ribbon\":{\"Back\":\"Aquatex\",\"Front\":\"Seedy\",\"Material\":\"Acrylic\",\"Thickness\":1.418955009041802,\"Tint\":\"Clear\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-0.8200582373883499},{\"Back\":[\"AluminiumCuPbFree\",\"ClearShield\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Material\":\"Polycarbonate\",\"Thickness\":1.8189895505678877,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.6112302862372659,-0.41220692642735274,0.03448904192832447,0.6747543945603404],\"Origin\":[0.6661124258339602,0.24623911101640228,-0.9275322805216435]},{\"Cutouts\":[],\"Edges\":[{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Bevel\",\"Width\":0},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}}],\"Material\":[{\"Back\":[],\"Front\":[\"Aluminium\",\"AluminiumCuPbFree\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Material\":\"NeoCeram\",\"Thickness\":1.6381948010542642,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":1.3326257012823022},{\"Back\":[\"AcidEtch\",\"AluminiumCuPbFree\"],\"Front\":[],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Aquatex\",\"Material\":\"Polycarbonate\",\"Thickness\":-1.1517660202575855,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":0.8605958017688391},{\"Back\":[],\"Front\":[],\"Ribbon\":{\"Back\":\"Aquatex\",\"Front\":\"Rain\",\"Material\":\"SodaLime\",\"Thickness\":0.27772317661201856,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.4954510074028536,-0.6791947856134701,-0.5408212142137636,-0.027113773535240495],\"Origin\":[-1.6025773834932173,-1.9008985206865774,2.115348113874294]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Offset\":0},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Offset\":0}]},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Hole\",\"Radius\":0}},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Ogee\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"ClearShield\",\"Sandblast\"],\"Front\":[\"SafetyBacking\",\"Sandblast\"],\"Ribbon\":{\"Back\":\"Aquatex\",\"Front\":\"Rain\",\"Material\":\"LowIron\",\"Thickness\":-1.5687998055098016,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":-1.4779881049748111},{\"Back\":[],\"Front\":[\"Aluminium\"],\"Ribbon\":{\"Front\":\"Rain\",\"Material\":\"Acrylic\",\"Thickness\":0.6591369144279845,\"Tint\":\"White\"}}],\"Orient\":[-0.22440925687225943,-0.7415425012800854,-0.5456598972206137,-0.31939079634595635],\"Origin\":[-1.8081631846365929,-0.8464520926283087,1.4524110503133627]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0},\"Offset\":0},\"Offset\":0},\"Offset\":0},\"Offset\":0}]}},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"Sandblast\"],\"Front\":[],\"Ribbon\":{\"Back\":\"Aquatex\",\"Front\":\"Rain\",\"Material\":\"SodaLime\",\"Thickness\":-0.2653760377263823,\"Tint\":\"Gray\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-1.524476793840279},{\"Back\":[],\"Front\":[\"ClearShield\",\"Sandblast\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Seedy\",\"Material\":\"Polycarbonate\",\"Thickness\":0.17722061577971818,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":0.39221915695269893},{\"Back\":[\"Aluminium\",\"AluminiumCuPbFree\"],\"Front\":[\"SafetyBacking\"],\"Ribbon\":{\"Material\":\"Polycarbonate\",\"Thickness\":-1.3227204839374087,\"Tint\":\"Gray\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.1821154162680912,0.25486833707917217,0.7078785612545722,-0.6330750732955408],\"Origin\":[1.1994490708900203,2.293111795876295,2.831209839143462]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Hole\",\"Radius\":0}},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0}}},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[],\"Front\":[\"SafetyBacking\",\"Sandblast\"],\"Ribbon\":{\"Back\":\"Polar\",\"Front\":\"Polar\",\"Material\":\"LowIron\",\"Thickness\":-1.247118761269748,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":1.5947161331807977},{\"Back\":[\"AcidEtch\"],\"Front\":[\"Aluminium\",\"SafetyBacking\"],\"Ribbon\":{\"Material\":\"SodaLime\",\"Thickness\":-1.2204606143964694,\"Tint\":\"Bronze\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-0.979031431846439},{\"Back\":[\"Aluminium\",\"ClearShield\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Front\":\"Rain\",\"Material\":\"LowIron\",\"Thickness\":-1.3167691697785586,\"Tint\":\"Clear\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.3816762922471443,0.316111179125983,-0.7545823826999073,0.4301190045638347],\"Origin\":[2.5134765210837844,2.1770086147194725,-2.8790006366470036]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Offset\":0},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[],\"Front\":[\"Aluminium\"],\"Ribbon\":{\"Back\":\"Rain\",\"Material\":\"Polycarbonate\",\"Thickness\":-0.3535123865350711,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.1756889029310814,0.3349673947920714,-0.6247746804620479,0.6830716305532177],\"Origin\":[1.5002992263715194,-0.5160519151980901,2.2681379162515314]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0}]},\"Offset\":0},\"Offset\":0}]}]}},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Hole\",\"Radius\":0}]},\"Offset\":0},\"Offset\":0}},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Miter\",\"Angle\":0},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"AluminiumCuPbFree\"],\"Front\":[\"Sandblast\"],\"Ribbon\":{\"Back\":\"Polar\",\"Material\":\"Acrylic\",\"Thickness\":0.6705428811963302,\"Tint\":\"Bronze\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-1.2103914285174462},{\"Back\":[\"AcidEtch\",\"SafetyBacking\"],\"Front\":[\"SafetyBacking\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Rain\",\"Material\":\"SodaLime\",\"Thickness\":0.8628434175641166,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":-1.6319240565653947},{\"Back\":[\"Aluminium\"],\"Front\":[\"Aluminium\",\"AluminiumCuPbFree\"],\"Ribbon\":{\"Back\":\"Aquatex\",\"Front\":\"Seedy\",\"Material\":\"LowIron\",\"Thickness\":-1.92122060211003,\"Tint\":\"Clear\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.6272651501127217,-0.3645238369376131,-0.48679722054815044,0.4865072145661772],\"Origin\":[0.8130842706409506,-2.5983981745306575,2.026431975510314]},{\"Cutouts\":[],\"Edges\":[{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Miter\",\"Angle\":0},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"ClearShield\",\"SafetyBacking\"],\"Front\":[\"ClearShield\",\"SafetyBacking\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Rain\",\"Material\":\"SodaLime\",\"Thickness\":0.8965143755262679,\"Tint\":\"Bronze\"}}],\"Orient\":[-0.953809611212371,-0.10607629387439312,0.05768080622839846,0.27507811623177364],\"Origin\":[-0.07844390872453079,1.9765215230918454,1.3201814785782566]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Bevel\",\"Width\":0},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"ClearShield\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Front\":\"Aquatex\",\"Material\":\"NeoCeram\",\"Thickness\":0.4411540459032128,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":0.23396410404049037},{\"Back\":[\"Sandblast\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Material\":\"NeoCeram\",\"Thickness\":0.1320083486700646,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.09463146671330266,-0.3932044767706316,-0.5881983293166462,0.7003269596012487],\"Origin\":[-2.2664447287675475,1.032595170605475,-0.6910163072458746]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Hole\",\"Radius\":0}},\"Offset\":0},\"Offset\":0}},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Ogee\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"Aluminium\"],\"Front\":[],\"Ribbon\":{\"Front\":\"Aquatex\",\"Material\":\"Polycarbonate\",\"Thickness\":-1.1915739138522612,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":0.6617856723623745},{\"Back\":[\"Aluminium\",\"AluminiumCuPbFree\"],\"Front\":[\"Sandblast\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Polar\",\"Material\":\"Polycarbonate\",\"Thickness\":1.0296676458492147,\"Tint\":\"Bronze\"}}],\"Orient\":[-0.3297085424810446,0.4384021176364985,0.5360266288210838,-0.6416940964833346],\"Origin\":[-2.6230269479858874,0.3459233957858804,-0.4082219589999499]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0}]},\"Offset\":0},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Miter\",\"Angle\":0},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Bevel\",\"Width\":0},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"ClearShield\",\"Sandblast\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Front\":\"Rain\",\"Material\":\"NeoCeram\",\"Thickness\":1.2808454383078758,\"Tint\":\"Clear\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":1.6915258034448333},{\"Back\":[],\"Front\":[\"AluminiumCuPbFree\"],\"Ribbon\":{\"Back\":\"Rain\",\"Front\":\"Seedy\",\"Material\":\"Acrylic\",\"Thickness\":1.715238026883328,\"Tint\":\"Gray\"}}],\"Orient\":[0.027934697982784258,-0.66912487789946,0.39071474643493437,-0.6315326890533288],\"Origin\":[-1.9217361593009736,-1.4091162480039663,-2.6817382948993345]},{\"Cutouts\":[],\"Edges\":[{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"Sandblast\"],\"Front\":[],\"Ribbon\":{\"Front\":\"Seedy\",\"Material\":\"Acrylic\",\"Thickness\":0.38492193518310036,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.14144027840910098,0.6941021501437881,0.4627669469284713,0.5329761773661444],\"Origin\":[0.011563600465945375,-1.8716127101598519,-1.0729566947409792]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Offset\":0}}},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0}]},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Ogee\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Bevel\",\"Width\":0},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Bevel\",\"Width\":0},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"AcidEtch\"],\"Front\":[\"Aluminium\",\"SafetyBacking\"],\"Ribbon\":{\"Front\":\"Aquatex\",\"Material\":\"SodaLime\",\"Thickness\":-0.23878580565703467,\"Tint\":\"Clear\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.567220631874454,0.6624905753446048,-0.37314916660197267,0.31642801996626785],\"Origin\":[-0.8796418498074845,-2.726342914708323,2.4742254337129803]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"Sandblast\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Front\":\"Rain\",\"Material\":\"SodaLime\",\"Thickness\":1.0563505748925484,\"Tint\":\"Clear\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-1.4020444426695304},{\"Back\":[\"Aluminium\"],\"Front\":[\"ClearShield\",\"SafetyBacking\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Polar\",\"Material\":\"SodaLime\",\"Thickness\":-1.514940188685774,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":-0.6069044427475834},{\"Back\":[\"Sandblast\"],\"Front\":[],\"Ribbon\":{\"Material\":\"SodaLime\",\"Thickness\":-0.20300549785316943,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.41035212263565757,0.5397124914531669,0.7349647151498134,0.012183164719358121],\"Origin\":[0.31842715627673396,2.2475661641855957,-0.24768120794883283]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"AcidEtch\",\"SafetyBacking\"],\"Front\":[\"ClearShield\",\"SafetyBacking\"],\"Ribbon\":{\"Back\":\"Polar\",\"Front\":\"Seedy\",\"Material\":\"SodaLime\",\"Thickness\":0.16365428785396458,\"Tint\":\"Bronze\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-0.005791918709553234},{\"Back\":[\"AluminiumCuPbFree\",\"SafetyBacking\"],\"Front\":[],\"Ribbon\":{\"Front\":\"Aquatex\",\"Material\":\"Acrylic\",\"Thickness\":1.5233542312509927,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.4096658319243915,-0.763288884333104,0.03422850248187503,-0.4983898020877533],\"Origin\":[-2.2604223597503172,-1.8444675928244112,1.5497449779971892]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Hole\",\"Radius\":0}},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Miter\",\"Angle\":0},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Miter\",\"Angle\":0},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"SafetyBacking\",\"Sandblast\"],\"Front\":[],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Rain\",\"Material\":\"Acrylic\",\"Thickness\":-1.3416620954332432,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.5755049346218226,-0.3136756255198712,-0.7244218148408411,0.2135759966928663],\"Origin\":[1.9588226628399754,2.2326260792147217,-2.4490335967721535]}]},\"Name\":\"South Wall Mirror\"},{\"Count\":1,\"Item\":{\"Panels\":[{\"Cutouts\":[{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[],\"Front\":[\"AcidEtch\",\"Sandblast\"],\"Ribbon\":{\"Back\":\"Aquatex\",\"Front\":\"Seedy\",\"Material\":\"Acrylic\",\"Thickness\":1.418955009041802,\"Tint\":\"Clear\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-0.8200582373883499},{\"Back\":[\"AluminiumCuPbFree\",\"ClearShield\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Material\":\"Polycarbonate\",\"Thickness\":1.8189895505678877,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.6112302862372659,-0.41220692642735274,0.03448904192832447,0.6747543945603404],\"Origin\":[0.6661124258339602,0.24623911101640228,-0.9275322805216435]},{\"Cutouts\":[],\"Edges\":[{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Bevel\",\"Width\":0},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}}],\"Material\":[{\"Back\":[],\"Front\":[\"Aluminium\",\"AluminiumCuPbFree\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Material\":\"NeoCeram\",\"Thickness\":1.6381948010542642,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":1.3326257012823022},{\"Back\":[\"AcidEtch\",\"AluminiumCuPbFree\"],\"Front\":[],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Aquatex\",\"Material\":\"Polycarbonate\",\"Thickness\":-1.1517660202575855,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":0.8605958017688391},{\"Back\":[],\"Front\":[],\"Ribbon\":{\"Back\":\"Aquatex\",\"Front\":\"Rain\",\"Material\":\"SodaLime\",\"Thickness\":0.27772317661201856,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.4954510074028536,-0.6791947856134701,-0.5408212142137636,-0.027113773535240495],\"Origin\":[-1.6025773834932173,-1.9008985206865774,2.115348113874294]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Offset\":0},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Offset\":0}]},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Hole\",\"Radius\":0}},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Ogee\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"ClearShield\",\"Sandblast\"],\"Front\":[\"SafetyBacking\",\"Sandblast\"],\"Ribbon\":{\"Back\":\"Aquatex\",\"Front\":\"Rain\",\"Material\":\"LowIron\",\"Thickness\":-1.5687998055098016,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":-1.4779881049748111},{\"Back\":[],\"Front\":[\"Aluminium\"],\"Ribbon\":{\"Front\":\"Rain\",\"Material\":\"Acrylic\",\"Thickness\":0.6591369144279845,\"Tint\":\"White\"}}],\"Orient\":[-0.22440925687225943,-0.7415425012800854,-0.5456598972206137,-0.31939079634595635],\"Origin\":[-1.8081631846365929,-0.8464520926283087,1.4524110503133627]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0},\"Offset\":0},\"Offset\":0},\"Offset\":0},\"Offset\":0}]}},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"Sandblast\"],\"Front\":[],\"Ribbon\":{\"Back\":\"Aquatex\",\"Front\":\"Rain\",\"Material\":\"SodaLime\",\"Thickness\":-0.2653760377263823,\"Tint\":\"Gray\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-1.524476793840279},{\"Back\":[],\"Front\":[\"ClearShield\",\"Sandblast\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Seedy\",\"Material\":\"Polycarbonate\",\"Thickness\":0.17722061577971818,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":0.39221915695269893},{\"Back\":[\"Aluminium\",\"AluminiumCuPbFree\"],\"Front\":[\"SafetyBacking\"],\"Ribbon\":{\"Material\":\"Polycarbonate\",\"Thickness\":-1.3227204839374087,\"Tint\":\"Gray\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.1821154162680912,0.25486833707917217,0.7078785612545722,-0.6330750732955408],\"Origin\":[1.1994490708900203,2.293111795876295,2.831209839143462]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Hole\",\"Radius\":0}},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0}}},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[],\"Front\":[\"SafetyBacking\",\"Sandblast\"],\"Ribbon\":{\"Back\":\"Polar\",\"Front\":\"Polar\",\"Material\":\"LowIron\",\"Thickness\":-1.247118761269748,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":1.5947161331807977},{\"Back\":[\"AcidEtch\"],\"Front\":[\"Aluminium\",\"SafetyBacking\"],\"Ribbon\":{\"Material\":\"SodaLime\",\"Thickness\":-1.2204606143964694,\"Tint\":\"Bronze\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-0.979031431846439},{\"Back\":[\"Aluminium\",\"ClearShield\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Front\":\"Rain\",\"Material\":\"LowIron\",\"Thickness\":-1.3167691697785586,\"Tint\":\"Clear\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.3816762922471443,0.316111179125983,-0.7545823826999073,0.4301190045638347],\"Origin\":[2.5134765210837844,2.1770086147194725,-2.8790006366470036]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Offset\":0},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[],\"Front\":[\"Aluminium\"],\"Ribbon\":{\"Back\":\"Rain\",\"Material\":\"Polycarbonate\",\"Thickness\":-0.3535123865350711,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.1756889029310814,0.3349673947920714,-0.6247746804620479,0.6830716305532177],\"Origin\":[1.5002992263715194,-0.5160519151980901,2.2681379162515314]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0}]},\"Offset\":0},\"Offset\":0}]}]}},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Hole\",\"Radius\":0}]},\"Offset\":0},\"Offset\":0}},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Miter\",\"Angle\":0},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"AluminiumCuPbFree\"],\"Front\":[\"Sandblast\"],\"Ribbon\":{\"Back\":\"Polar\",\"Material\":\"Acrylic\",\"Thickness\":0.6705428811963302,\"Tint\":\"Bronze\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-1.2103914285174462},{\"Back\":[\"AcidEtch\",\"SafetyBacking\"],\"Front\":[\"SafetyBacking\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Rain\",\"Material\":\"SodaLime\",\"Thickness\":0.8628434175641166,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":-1.6319240565653947},{\"Back\":[\"Aluminium\"],\"Front\":[\"Aluminium\",\"AluminiumCuPbFree\"],\"Ribbon\":{\"Back\":\"Aquatex\",\"Front\":\"Seedy\",\"Material\":\"LowIron\",\"Thickness\":-1.92122060211003,\"Tint\":\"Clear\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.6272651501127217,-0.3645238369376131,-0.48679722054815044,0.4865072145661772],\"Origin\":[0.8130842706409506,-2.5983981745306575,2.026431975510314]},{\"Cutouts\":[],\"Edges\":[{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Miter\",\"Angle\":0},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"ClearShield\",\"SafetyBacking\"],\"Front\":[\"ClearShield\",\"SafetyBacking\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Rain\",\"Material\":\"SodaLime\",\"Thickness\":0.8965143755262679,\"Tint\":\"Bronze\"}}],\"Orient\":[-0.953809611212371,-0.10607629387439312,0.05768080622839846,0.27507811623177364],\"Origin\":[-0.07844390872453079,1.9765215230918454,1.3201814785782566]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Bevel\",\"Width\":0},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"ClearShield\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Front\":\"Aquatex\",\"Material\":\"NeoCeram\",\"Thickness\":0.4411540459032128,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":0.23396410404049037},{\"Back\":[\"Sandblast\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Material\":\"NeoCeram\",\"Thickness\":0.1320083486700646,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.09463146671330266,-0.3932044767706316,-0.5881983293166462,0.7003269596012487],\"Origin\":[-2.2664447287675475,1.032595170605475,-0.6910163072458746]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Hole\",\"Radius\":0}},\"Offset\":0},\"Offset\":0}},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Ogee\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"Aluminium\"],\"Front\":[],\"Ribbon\":{\"Front\":\"Aquatex\",\"Material\":\"Polycarbonate\",\"Thickness\":-1.1915739138522612,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":0.6617856723623745},{\"Back\":[\"Aluminium\",\"AluminiumCuPbFree\"],\"Front\":[\"Sandblast\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Polar\",\"Material\":\"Polycarbonate\",\"Thickness\":1.0296676458492147,\"Tint\":\"Bronze\"}}],\"Orient\":[-0.3297085424810446,0.4384021176364985,0.5360266288210838,-0.6416940964833346],\"Origin\":[-2.6230269479858874,0.3459233957858804,-0.4082219589999499]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0}]},\"Offset\":0},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Miter\",\"Angle\":0},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Bevel\",\"Width\":0},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"ClearShield\",\"Sandblast\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Front\":\"Rain\",\"Material\":\"NeoCeram\",\"Thickness\":1.2808454383078758,\"Tint\":\"Clear\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":1.6915258034448333},{\"Back\":[],\"Front\":[\"AluminiumCuPbFree\"],\"Ribbon\":{\"Back\":\"Rain\",\"Front\":\"Seedy\",\"Material\":\"Acrylic\",\"Thickness\":1.715238026883328,\"Tint\":\"Gray\"}}],\"Orient\":[0.027934697982784258,-0.66912487789946,0.39071474643493437,-0.6315326890533288],\"Origin\":[-1.9217361593009736,-1.4091162480039663,-2.6817382948993345]},{\"Cutouts\":[],\"Edges\":[{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"Sandblast\"],\"Front\":[],\"Ribbon\":{\"Front\":\"Seedy\",\"Material\":\"Acrylic\",\"Thickness\":0.38492193518310036,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.14144027840910098,0.6941021501437881,0.4627669469284713,0.5329761773661444],\"Origin\":[0.011563600465945375,-1.8716127101598519,-1.0729566947409792]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Offset\":0}}},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0}]},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Ogee\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Bevel\",\"Width\":0},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Bevel\",\"Width\":0},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"AcidEtch\"],\"Front\":[\"Aluminium\",\"SafetyBacking\"],\"Ribbon\":{\"Front\":\"Aquatex\",\"Material\":\"SodaLime\",\"Thickness\":-0.23878580565703467,\"Tint\":\"Clear\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.567220631874454,0.6624905753446048,-0.37314916660197267,0.31642801996626785],\"Origin\":[-0.8796418498074845,-2.726342914708323,2.4742254337129803]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"Sandblast\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Front\":\"Rain\",\"Material\":\"SodaLime\",\"Thickness\":1.0563505748925484,\"Tint\":\"Clear\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-1.4020444426695304},{\"Back\":[\"Aluminium\"],\"Front\":[\"ClearShield\",\"SafetyBacking\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Polar\",\"Material\":\"SodaLime\",\"Thickness\":-1.514940188685774,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":-0.6069044427475834},{\"Back\":[\"Sandblast\"],\"Front\":[],\"Ribbon\":{\"Material\":\"SodaLime\",\"Thickness\":-0.20300549785316943,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.41035212263565757,0.5397124914531669,0.7349647151498134,0.012183164719358121],\"Origin\":[0.31842715627673396,2.2475661641855957,-0.24768120794883283]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"AcidEtch\",\"SafetyBacking\"],\"Front\":[\"ClearShield\",\"SafetyBacking\"],\"Ribbon\":{\"Back\":\"Polar\",\"Front\":\"Seedy\",\"Material\":\"SodaLime\",\"Thickness\":0.16365428785396458,\"Tint\":\"Bronze\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-0.005791918709553234},{\"Back\":[\"AluminiumCuPbFree\",\"SafetyBacking\"],\"Front\":[],\"Ribbon\":{\"Front\":\"Aquatex\",\"Material\":\"Acrylic\",\"Thickness\":1.5233542312509927,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.4096658319243915,-0.763288884333104,0.03422850248187503,-0.4983898020877533],\"Origin\":[-2.2604223597503172,-1.8444675928244112,1.5497449779971892]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Hole\",\"Radius\":0}},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Miter\",\"Angle\":0},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Miter\",\"Angle\":0},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"SafetyBacking\",\"Sandblast\"],\"Front\":[],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Rain\",\"Material\":\"Acrylic\",\"Thickness\":-1.3416620954332432,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.5755049346218226,-0.3136756255198712,-0.7244218148408411,0.2135759966928663],\"Origin\":[1.9588226628399754,2.2326260792147217,-2.4490335967721535]}]},\"Name\":\"Bathroom Mirror\"}],\"Name\":\"Master Bedroom\"},{\"Count\":4,\"Item\":{\"Panels\":[{\"Cutouts\":[{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[],\"Front\":[\"AcidEtch\",\"Sandblast\"],\"Ribbon\":{\"Back\":\"Aquatex\",\"Front\":\"Seedy\",\"Material\":\"Acrylic\",\"Thickness\":1.418955009041802,\"Tint\":\"Clear\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-0.8200582373883499},{\"Back\":[\"AluminiumCuPbFree\",\"ClearShield\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Material\":\"Polycarbonate\",\"Thickness\":1.8189895505678877,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.6112302862372659,-0.41220692642735274,0.03448904192832447,0.6747543945603404],\"Origin\":[0.6661124258339602,0.24623911101640228,-0.9275322805216435]},{\"Cutouts\":[],\"Edges\":[{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Bevel\",\"Width\":0},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}}],\"Material\":[{\"Back\":[],\"Front\":[\"Aluminium\",\"AluminiumCuPbFree\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Material\":\"NeoCeram\",\"Thickness\":1.6381948010542642,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":1.3326257012823022},{\"Back\":[\"AcidEtch\",\"AluminiumCuPbFree\"],\"Front\":[],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Aquatex\",\"Material\":\"Polycarbonate\",\"Thickness\":-1.1517660202575855,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":0.8605958017688391},{\"Back\":[],\"Front\":[],\"Ribbon\":{\"Back\":\"Aquatex\",\"Front\":\"Rain\",\"Material\":\"SodaLime\",\"Thickness\":0.27772317661201856,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.4954510074028536,-0.6791947856134701,-0.5408212142137636,-0.027113773535240495],\"Origin\":[-1.6025773834932173,-1.9008985206865774,2.115348113874294]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Offset\":0},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Offset\":0}]},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Hole\",\"Radius\":0}},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Ogee\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"ClearShield\",\"Sandblast\"],\"Front\":[\"SafetyBacking\",\"Sandblast\"],\"Ribbon\":{\"Back\":\"Aquatex\",\"Front\":\"Rain\",\"Material\":\"LowIron\",\"Thickness\":-1.5687998055098016,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":-1.4779881049748111},{\"Back\":[],\"Front\":[\"Aluminium\"],\"Ribbon\":{\"Front\":\"Rain\",\"Material\":\"Acrylic\",\"Thickness\":0.6591369144279845,\"Tint\":\"White\"}}],\"Orient\":[-0.22440925687225943,-0.7415425012800854,-0.5456598972206137,-0.31939079634595635],\"Origin\":[-1.8081631846365929,-0.8464520926283087,1.4524110503133627]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0},\"Offset\":0},\"Offset\":0},\"Offset\":0},\"Offset\":0}]}},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"Sandblast\"],\"Front\":[],\"Ribbon\":{\"Back\":\"Aquatex\",\"Front\":\"Rain\",\"Material\":\"SodaLime\",\"Thickness\":-0.2653760377263823,\"Tint\":\"Gray\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-1.524476793840279},{\"Back\":[],\"Front\":[\"ClearShield\",\"Sandblast\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Seedy\",\"Material\":\"Polycarbonate\",\"Thickness\":0.17722061577971818,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":0.39221915695269893},{\"Back\":[\"Aluminium\",\"AluminiumCuPbFree\"],\"Front\":[\"SafetyBacking\"],\"Ribbon\":{\"Material\":\"Polycarbonate\",\"Thickness\":-1.3227204839374087,\"Tint\":\"Gray\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.1821154162680912,0.25486833707917217,0.7078785612545722,-0.6330750732955408],\"Origin\":[1.1994490708900203,2.293111795876295,2.831209839143462]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Hole\",\"Radius\":0}},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0}}},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[],\"Front\":[\"SafetyBacking\",\"Sandblast\"],\"Ribbon\":{\"Back\":\"Polar\",\"Front\":\"Polar\",\"Material\":\"LowIron\",\"Thickness\":-1.247118761269748,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":1.5947161331807977},{\"Back\":[\"AcidEtch\"],\"Front\":[\"Aluminium\",\"SafetyBacking\"],\"Ribbon\":{\"Material\":\"SodaLime\",\"Thickness\":-1.2204606143964694,\"Tint\":\"Bronze\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-0.979031431846439},{\"Back\":[\"Aluminium\",\"ClearShield\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Front\":\"Rain\",\"Material\":\"LowIron\",\"Thickness\":-1.3167691697785586,\"Tint\":\"Clear\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.3816762922471443,0.316111179125983,-0.7545823826999073,0.4301190045638347],\"Origin\":[2.5134765210837844,2.1770086147194725,-2.8790006366470036]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Offset\":0},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[],\"Front\":[\"Aluminium\"],\"Ribbon\":{\"Back\":\"Rain\",\"Material\":\"Polycarbonate\",\"Thickness\":-0.3535123865350711,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.1756889029310814,0.3349673947920714,-0.6247746804620479,0.6830716305532177],\"Origin\":[1.5002992263715194,-0.5160519151980901,2.2681379162515314]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0}]},\"Offset\":0},\"Offset\":0}]}]}},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Hole\",\"Radius\":0}]},\"Offset\":0},\"Offset\":0}},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Miter\",\"Angle\":0},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"AluminiumCuPbFree\"],\"Front\":[\"Sandblast\"],\"Ribbon\":{\"Back\":\"Polar\",\"Material\":\"Acrylic\",\"Thickness\":0.6705428811963302,\"Tint\":\"Bronze\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-1.2103914285174462},{\"Back\":[\"AcidEtch\",\"SafetyBacking\"],\"Front\":[\"SafetyBacking\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Rain\",\"Material\":\"SodaLime\",\"Thickness\":0.8628434175641166,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":-1.6319240565653947},{\"Back\":[\"Aluminium\"],\"Front\":[\"Aluminium\",\"AluminiumCuPbFree\"],\"Ribbon\":{\"Back\":\"Aquatex\",\"Front\":\"Seedy\",\"Material\":\"LowIron\",\"Thickness\":-1.92122060211003,\"Tint\":\"Clear\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.6272651501127217,-0.3645238369376131,-0.48679722054815044,0.4865072145661772],\"Origin\":[0.8130842706409506,-2.5983981745306575,2.026431975510314]},{\"Cutouts\":[],\"Edges\":[{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Miter\",\"Angle\":0},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"ClearShield\",\"SafetyBacking\"],\"Front\":[\"ClearShield\",\"SafetyBacking\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Rain\",\"Material\":\"SodaLime\",\"Thickness\":0.8965143755262679,\"Tint\":\"Bronze\"}}],\"Orient\":[-0.953809611212371,-0.10607629387439312,0.05768080622839846,0.27507811623177364],\"Origin\":[-0.07844390872453079,1.9765215230918454,1.3201814785782566]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Bevel\",\"Width\":0},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"ClearShield\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Front\":\"Aquatex\",\"Material\":\"NeoCeram\",\"Thickness\":0.4411540459032128,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":0.23396410404049037},{\"Back\":[\"Sandblast\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Material\":\"NeoCeram\",\"Thickness\":0.1320083486700646,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.09463146671330266,-0.3932044767706316,-0.5881983293166462,0.7003269596012487],\"Origin\":[-2.2664447287675475,1.032595170605475,-0.6910163072458746]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Hole\",\"Radius\":0}},\"Offset\":0},\"Offset\":0}},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Ogee\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"Aluminium\"],\"Front\":[],\"Ribbon\":{\"Front\":\"Aquatex\",\"Material\":\"Polycarbonate\",\"Thickness\":-1.1915739138522612,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":0.6617856723623745},{\"Back\":[\"Aluminium\",\"AluminiumCuPbFree\"],\"Front\":[\"Sandblast\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Polar\",\"Material\":\"Polycarbonate\",\"Thickness\":1.0296676458492147,\"Tint\":\"Bronze\"}}],\"Orient\":[-0.3297085424810446,0.4384021176364985,0.5360266288210838,-0.6416940964833346],\"Origin\":[-2.6230269479858874,0.3459233957858804,-0.4082219589999499]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0}]},\"Offset\":0},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Miter\",\"Angle\":0},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Bevel\",\"Width\":0},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"ClearShield\",\"Sandblast\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Front\":\"Rain\",\"Material\":\"NeoCeram\",\"Thickness\":1.2808454383078758,\"Tint\":\"Clear\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":1.6915258034448333},{\"Back\":[],\"Front\":[\"AluminiumCuPbFree\"],\"Ribbon\":{\"Back\":\"Rain\",\"Front\":\"Seedy\",\"Material\":\"Acrylic\",\"Thickness\":1.715238026883328,\"Tint\":\"Gray\"}}],\"Orient\":[0.027934697982784258,-0.66912487789946,0.39071474643493437,-0.6315326890533288],\"Origin\":[-1.9217361593009736,-1.4091162480039663,-2.6817382948993345]},{\"Cutouts\":[],\"Edges\":[{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"Sandblast\"],\"Front\":[],\"Ribbon\":{\"Front\":\"Seedy\",\"Material\":\"Acrylic\",\"Thickness\":0.38492193518310036,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.14144027840910098,0.6941021501437881,0.4627669469284713,0.5329761773661444],\"Origin\":[0.011563600465945375,-1.8716127101598519,-1.0729566947409792]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Shift\",\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Offset\":0}}},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Overlap\",\"Cutouts\":[{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0}]},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Ogee\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Bevel\",\"Width\":0},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}},{\"Corner\":{\"type\":\"Round\",\"Radius\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Bevel\",\"Width\":0},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"AcidEtch\"],\"Front\":[\"Aluminium\",\"SafetyBacking\"],\"Ribbon\":{\"Front\":\"Aquatex\",\"Material\":\"SodaLime\",\"Thickness\":-0.23878580565703467,\"Tint\":\"Clear\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.567220631874454,0.6624905753446048,-0.37314916660197267,0.31642801996626785],\"Origin\":[-0.8796418498074845,-2.726342914708323,2.4742254337129803]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Hole\",\"Radius\":0},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"FlatPolish\"},\"Segment\":{\"type\":\"Linear\",\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"Sandblast\"],\"Front\":[\"AcidEtch\"],\"Ribbon\":{\"Front\":\"Rain\",\"Material\":\"SodaLime\",\"Thickness\":1.0563505748925484,\"Tint\":\"Clear\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-1.4020444426695304},{\"Back\":[\"Aluminium\"],\"Front\":[\"ClearShield\",\"SafetyBacking\"],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Polar\",\"Material\":\"SodaLime\",\"Thickness\":-1.514940188685774,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"},{\"Laminate\":\"Vinyl\",\"Thickness\":-0.6069044427475834},{\"Back\":[\"Sandblast\"],\"Front\":[],\"Ribbon\":{\"Material\":\"SodaLime\",\"Thickness\":-0.20300549785316943,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[-0.41035212263565757,0.5397124914531669,0.7349647151498134,0.012183164719358121],\"Origin\":[0.31842715627673396,2.2475661641855957,-0.24768120794883283]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0},\"Edging\":{\"type\":\"FlatPolish\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Seamed\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"AcidEtch\",\"SafetyBacking\"],\"Front\":[\"ClearShield\",\"SafetyBacking\"],\"Ribbon\":{\"Back\":\"Polar\",\"Front\":\"Seedy\",\"Material\":\"SodaLime\",\"Thickness\":0.16365428785396458,\"Tint\":\"Bronze\"}},{\"Laminate\":\"Vinyl\",\"Thickness\":-0.005791918709553234},{\"Back\":[\"AluminiumCuPbFree\",\"SafetyBacking\"],\"Front\":[],\"Ribbon\":{\"Front\":\"Aquatex\",\"Material\":\"Acrylic\",\"Thickness\":1.5233542312509927,\"Tint\":\"Bronze\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.4096658319243915,-0.763288884333104,0.03422850248187503,-0.4983898020877533],\"Origin\":[-2.2604223597503172,-1.8444675928244112,1.5497449779971892]},{\"Cutouts\":[{\"Cutout\":{\"type\":\"Rotate\",\"Angle\":0,\"Cutout\":{\"type\":\"Hole\",\"Radius\":0}},\"Edging\":{\"type\":\"Raw\"},\"Origin\":[0,0]},{\"Cutout\":{\"type\":\"Rect\",\"Height\":0,\"Radius\":0,\"Width\":0},\"Edging\":{\"type\":\"Seamed\"},\"Origin\":[0,0]}],\"Edges\":[{\"Corner\":{\"type\":\"Clip\",\"Length\":0},\"Cutouts\":[],\"Edging\":{\"type\":\"Miter\",\"Angle\":0},\"Segment\":{\"type\":\"Cubic\",\"P1\":[0,0],\"P2\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Raw\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Raw\"},\"Cutouts\":[],\"Edging\":{\"type\":\"Miter\",\"Angle\":0},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}},{\"Corner\":{\"type\":\"Eased\"},\"Cutouts\":[],\"Edging\":{\"type\":\"PencilPolish\"},\"Segment\":{\"type\":\"Conic\",\"F1\":[0,0],\"P1\":[0,0],\"To\":[0,0]}}],\"Material\":[{\"Back\":[\"SafetyBacking\",\"Sandblast\"],\"Front\":[],\"Ribbon\":{\"Back\":\"Seedy\",\"Front\":\"Rain\",\"Material\":\"Acrylic\",\"Thickness\":-1.3416620954332432,\"Tint\":\"White\"},\"Temper\":\"HeatTempered\"}],\"Orient\":[0.5755049346218226,-0.3136756255198712,-0.7244218148408411,0.2135759966928663],\"Origin\":[1.9588226628399754,2.2326260792147217,-2.4490335967721535]}]},\"Name\":\"Entryway Mirror\"}],\"Name\":\"44 Elm Blvd\"}");


var $ad5d0a10b685e478$exports = {};
$ad5d0a10b685e478$exports = JSON.parse("{\"Charges\":[{\"Count\":1,\"Discount\":{},\"Discounts\":{},\"Extended\":{\"USD\":\"700.00\"},\"Items\":[{\"Count\":2,\"Discount\":{},\"Discounts\":{},\"Extended\":{\"USD\":\"400.00\"},\"Name\":\"South Wall Mirror\",\"Price\":{\"USD\":\"200.00\"},\"SubTotal\":{\"USD\":\"400.00\"},\"Tax\":{},\"Taxes\":{},\"Total\":{\"USD\":\"400.00\"},\"Unit\":{\"Count\":1,\"Unit\":\"pc\"}},{\"Count\":1,\"Discount\":{},\"Discounts\":{},\"Extended\":{\"USD\":\"300.00\"},\"Name\":\"Bathroom Mirror\",\"Price\":{\"USD\":\"300.00\"},\"SubTotal\":{\"USD\":\"300.00\"},\"Tax\":{},\"Taxes\":{},\"Total\":{\"USD\":\"300.00\"},\"Unit\":{\"Count\":1,\"Unit\":\"pc\"}}],\"Name\":\"Master Bedroom\",\"Price\":{\"USD\":\"700.00\"},\"SubTotal\":{\"USD\":\"700.00\"},\"Tax\":{},\"Taxes\":{},\"Total\":{\"USD\":\"700.00\"},\"Unit\":{\"Count\":1,\"Unit\":\"pc\"}},{\"Count\":4,\"Discount\":{},\"Discounts\":{},\"Extended\":{\"USD\":\"400.00\"},\"Name\":\"Entryway Mirror\",\"Price\":{\"USD\":\"100.00\"},\"SubTotal\":{\"USD\":\"400.00\"},\"Tax\":{},\"Taxes\":{},\"Total\":{\"USD\":\"400.00\"},\"Unit\":{\"Count\":1,\"Unit\":\"pc\"}}],\"Discount\":{},\"Discounts\":{},\"Extended\":{\"USD\":\"1100.00\"},\"Name\":\"44 Elm Blvd\",\"Shipping\":{\"Count\":1,\"Discount\":{},\"Discounts\":{},\"Extended\":{},\"Items\":[],\"Name\":\"Default\",\"Price\":{},\"SubTotal\":{},\"Tax\":{},\"Taxes\":{},\"Total\":{},\"Unit\":{\"Count\":1,\"Unit\":\"pc\"}},\"SubTotal\":{\"USD\":\"1100.00\"},\"Tax\":{},\"Taxes\":{},\"Total\":{\"USD\":\"1100.00\"}}");









var $ayMG0 = parcelRequire("ayMG0");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $b6206966e4877619$var$ResizeHandle = ({ defaultValue: defaultValue = 330, minValue: minValue, maxValue: maxValue, position: position = 'right', onChange: onChange })=>{
    const [isResizing, setIsResizing] = (0, $acw62.useState)(false);
    const [initialPosition, setInitialPosition] = (0, $acw62.useState)(0);
    const resizeHandleRef = (0, $acw62.useRef)();
    const [leftSideBarWidth, setLeftSideBarWidth] = (0, $acw62.useState)(defaultValue);
    const handleDoubleClick = ()=>{
        setLeftSideBarWidth((prev)=>prev === 0 ? defaultValue : 0);
    };
    const handleMouseDown = (e)=>{
        e.preventDefault();
        setIsResizing(true);
    };
    const handleMouseUp = ()=>{
        setIsResizing(false);
    };
    const handleMouseMove = (0, $acw62.useCallback)((e)=>{
        if (isResizing) {
            const offset = e.pageX - initialPosition;
            const newWidth = defaultValue + offset * (position === 'left' ? -1 : 1);
            if (newWidth <= maxValue - 5 && newWidth > minValue) setLeftSideBarWidth(newWidth + 5);
        }
    }, [
        isResizing,
        maxValue,
        minValue,
        initialPosition,
        defaultValue,
        position
    ]);
    const handleResizeHandler = ()=>{
        const pageX = resizeHandleRef.current?.getBoundingClientRect().left || 0;
        setInitialPosition(pageX);
    };
    (0, $acw62.useEffect)(()=>{
        onChange(leftSideBarWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        leftSideBarWidth
    ]);
    (0, $acw62.useEffect)(()=>{
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
        return ()=>{
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [
        handleMouseMove
    ]);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener('resize', handleResizeHandler);
        return ()=>{
            window.removeEventListener('resize', handleResizeHandler);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const pageX = resizeHandleRef.current?.getBoundingClientRect().left || 0;
        setInitialPosition(pageX);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))('q-resize-handle', `q-resize-handle__${position}`),
        onDoubleClick: handleDoubleClick,
        onMouseDown: handleMouseDown,
        onMouseUp: handleMouseUp,
        ref: resizeHandleRef,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "q-resize-handle-div",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    className: "q-resize-handle-item",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: "/img/treeview/drag-handle-dotted.svg",
                        className: "d-none"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    className: "q-resize-handle-item q-resize-handle-item-middle",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: "/img/treeview/drag-handle-lines.png"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    className: "q-resize-handle-item q-resize-handle-item-last",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: "/img/treeview/drag-handle-dotted.svg"
                    })
                })
            ]
        })
    });
};
var $b6206966e4877619$export$2e2bcd8739ae039 = $b6206966e4877619$var$ResizeHandle;






var $ayMG0 = parcelRequire("ayMG0");



var $bb15634c27b561c5$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($bb15634c27b561c5$exports, "__esModule", {
    value: true
});
$bb15634c27b561c5$exports.default = void 0;

var $bb15634c27b561c5$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $bb15634c27b561c5$var$_default = $bb15634c27b561c5$exports.default = (0, $bb15634c27b561c5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), 'Error');










var $ayMG0 = parcelRequire("ayMG0");






const $211483590d92882f$var$isOption = (ps)=>ps.Type === 'Opts';
const $211483590d92882f$var$CornersPanel = ({ data: data, updateOpts: updateOpts, updateVars: updateVars })=>{
    const { Items: Items } = data;
    const renderCornerInput = (ps)=>$211483590d92882f$var$isOption(ps) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $111aab76558170aa$export$91db2342be6956eb), {
            update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(updateOpts, (0, $58f80d7b57eba59b$export$b610b8812bbcded9)(ps.ArrIndex)),
            value: ps
        }, ps.Label) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d26380e8a4c53cc$export$37f8f06e2ca92cb5), {
            update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(updateVars, (0, $58f80d7b57eba59b$export$b610b8812bbcded9)(ps.ArrIndex)),
            value: ps
        }, ps.Label);
    const renderCornerInputs = (cornerIndex)=>{
        const modeSelect = Items.find((item)=>item.Label === `Corner ${cornerIndex}`);
        const clipInput = Items.find((item)=>item.Label === `corner${cornerIndex}-clip`);
        const radiusInput = Items.find((item)=>item.Label === `corner${cornerIndex}-radius`);
        if (modeSelect) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            children: [
                renderCornerInput(modeSelect),
                clipInput && renderCornerInput(clipInput),
                radiusInput && renderCornerInput(radiusInput)
            ]
        });
        return null;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        container: true,
        spacing: 1,
        className: "corners-panel",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                className: "corners-panel__corner top-left",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    variant: "caption",
                    children: "Top-Left"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                className: "corners-panel__corner top-right",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    variant: "caption",
                    children: "Top-Right"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                className: "corners-panel__fields top-left",
                children: renderCornerInputs(3)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                className: "corners-panel__fields top-right",
                children: renderCornerInputs(2)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                className: "corners-panel__fields bottom-left",
                children: renderCornerInputs(0)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                className: "corners-panel__fields bottom-right",
                children: renderCornerInputs(1)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                className: "corners-panel__corner bottom-left",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    variant: "caption",
                    children: "Bottom-Left"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                className: "corners-panel__corner bottom-right",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    variant: "caption",
                    children: "Bottom-Right"
                })
            })
        ]
    });
};
var $211483590d92882f$export$2e2bcd8739ae039 = $211483590d92882f$var$CornersPanel;



const $16051580cfa7616f$var$DataGroup = (props)=>{
    const { data: data, updateOpts: updateOpts, updateVars: updateVars, update: update } = props;
    const { Items: Items, Label: Label, Names: Names, Fold: Fold } = data;
    const isOption = (ps)=>ps.Type === 'Opts';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
        expanded: !Fold,
        style: {
            margin: 0
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                "aria-controls": "panel1d-content",
                className: "q-datagroup__summary",
                onClick: (0, $d9f4ffa0bf773b73$export$49ac4be000c880a7)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $7aba2092ca2b63b7$export$2bb609461ec3cd2c)), (0, $e73bd36ca27436e9$export$e03c1c3201ee8bb7)),
                expandIcon: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($570fd50501d08ed5$exports))), {
                            className: "q-datagroup__summary-addicon",
                            sx: {
                                color: '#E2E8F0'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($29a5410bebd3849f$exports))), {
                            className: "q-datagroup__summary-removeicon",
                            sx: {
                                color: '#E2E8F0'
                            }
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            className: "q-datagroup__summar-title",
                            children: Names.eng ?? Label
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bb15634c27b561c5$exports))), {
                            sx: {
                                color: '#718096',
                                width: '20px',
                                height: '20px'
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                sx: {
                    padding: '20px 6px 8px',
                    backgroundColor: 'var(--gray-800, #1A202C)'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        rowGap: '20px'
                    },
                    children: Label === 'corner' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $211483590d92882f$export$2e2bcd8739ae039), {
                        data: data,
                        updateOpts: updateOpts,
                        updateVars: updateVars
                    }) : Items.map((ps)=>{
                        return isOption(ps) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $111aab76558170aa$export$91db2342be6956eb), {
                            update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(updateOpts, (0, $58f80d7b57eba59b$export$b610b8812bbcded9)(ps.ArrIndex)),
                            value: ps
                        }, ps.Label) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d26380e8a4c53cc$export$37f8f06e2ca92cb5), {
                            update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(updateVars, (0, $58f80d7b57eba59b$export$b610b8812bbcded9)(ps.ArrIndex)),
                            value: ps
                        }, ps.Label);
                    })
                })
            })
        ]
    });
};
var $16051580cfa7616f$export$2e2bcd8739ae039 = $16051580cfa7616f$var$DataGroup;







const $ebc59ff875b39f74$var$DEFAULT_WIDTH = 300;
const $ebc59ff875b39f74$var$MINIMUM_WIDTH = 300;
const $ebc59ff875b39f74$var$MAXIMUM_WIDTH = 500;
var $ebc59ff875b39f74$var$ActionStep = /*#__PURE__*/ function(ActionStep) {
    ActionStep["SAVE"] = "SAVE";
    ActionStep["CLONE"] = "CLONE";
    return ActionStep;
}($ebc59ff875b39f74$var$ActionStep || {});
const $ebc59ff875b39f74$var$TemplateDataPanel = (props)=>{
    const { update: update, value: value, selectedNode: selectedNode, setFieldBasedOnPath: setFieldBasedOnPath, handleDuplication: handleDuplication } = props;
    const { Opts: Opts, Vars: Vars, Groups: Groups } = value;
    const { serverTemplates: serverTemplates, dataPanelWidth: dataPanelWidth, dispatch: dispatch } = (0, $acw62.useContext)((0, $a388f687e0a39747$export$afffaa0e40c01a5d));
    const [amount, setAmount] = (0, $acw62.useState)(selectedNode?.Count ?? 0);
    const [actionStep, setActionStep] = (0, $acw62.useState)("SAVE");
    const handleSaveQuote = ()=>{
        // Firstly, Update amount.
        setFieldBasedOnPath('Count', amount);
        dispatch({
            type: (0, $a388f687e0a39747$export$b2463983502340c6),
            data: {
                open: true,
                type: 'success',
                title: 'Quote submitted',
                description: 'You can now continue',
                autoDuration: 3000
            }
        });
        setActionStep("CLONE");
    };
    const handleClose = ()=>{
        dispatch({
            type: (0, $a388f687e0a39747$export$2d10c83bffd81de3)
        });
    };
    const handleClone = ()=>{
        dispatch({
            type: (0, $a388f687e0a39747$export$2d10c83bffd81de3)
        });
        handleDuplication();
        dispatch({
            type: (0, $a388f687e0a39747$export$b2463983502340c6),
            data: {
                open: true,
                type: 'success',
                title: 'Item cloned',
                description: 'You are now editing the cloned item',
                autoDuration: 3000
            }
        });
        setTimeout(()=>{
            setActionStep("SAVE");
            dispatch({
                type: (0, $a388f687e0a39747$export$1129347c88918a1a)
            });
        }, 500);
    };
    const layoutData = (0, $acw62.useMemo)(()=>{
        const newVars = Vars.map((variable, ArrIndex)=>({
                ...variable,
                Type: 'Vars',
                ArrIndex: ArrIndex
            })).filter((variable)=>(0, $9e60ae4352b3f8e8$export$cae9ccc5485bbb97)(value)(variable));
        const newOpts = Opts.map((opt, ArrIndex)=>({
                ...opt,
                Type: 'Opts',
                ArrIndex: ArrIndex
            })).filter((opt)=>(0, $9e60ae4352b3f8e8$export$c1ee70c24c083802)(value)(opt)).map((opt)=>{
            // Todo: need to remove later.
            if (opt.Label === 'Shape') return {
                ...opt,
                Range: opt.Range.filter((r)=>![
                        'half-circle',
                        'square'
                    ].includes(r.Label))
            };
            return opt;
        });
        return Groups.map((group)=>{
            const newItems = group.Items.map((item)=>{
                if (item.type === 'Opt') {
                    const opt = newOpts.find((opt)=>opt.Label === item.Label);
                    if (opt) return {
                        ...opt,
                        Type: 'Opts'
                    };
                } else if (item.type === 'Var') {
                    const varb = newVars.find((varb)=>varb.Label === item.Label);
                    if (varb) return {
                        ...varb,
                        Type: 'Vars'
                    };
                }
                return null;
            }).filter((item)=>item !== null);
            return {
                ...group,
                Items: newItems
            };
        });
    }, [
        Groups,
        Opts,
        Vars,
        value
    ]).filter((layout)=>layout.Items.length > 0);
    const handleUpdate = (a)=>{
        update(a);
        setActionStep("SAVE");
    };
    (0, $acw62.useEffect)(()=>{
        setAmount(selectedNode?.Count || 0);
    }, [
        selectedNode
    ]);
    (0, $acw62.useEffect)(()=>{
        if (actionStep === "CLONE") setActionStep("SAVE");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        amount
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: "template-datapanel",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b6206966e4877619$export$2e2bcd8739ae039), {
                defaultValue: $ebc59ff875b39f74$var$DEFAULT_WIDTH,
                minValue: $ebc59ff875b39f74$var$MINIMUM_WIDTH,
                maxValue: $ebc59ff875b39f74$var$MAXIMUM_WIDTH,
                position: "left",
                onChange: (width)=>dispatch({
                        type: (0, $a388f687e0a39747$export$f9f104ddd496ba3),
                        data: width
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                className: "template-datapanel__content",
                style: {
                    width: `${dataPanelWidth}px`,
                    transition: 'width 0.3s ease-in-out'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        className: "template-datapanel__content-main",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                className: "template-datapanel__selector",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        className: "template-datapanel__selector-top",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                            className: "template-datapanel__selector-title",
                                            children: "Select glass"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        className: "template-datapanel__selector-content",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                            sx: {
                                                my: 1,
                                                width: '100%'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $250e0f5c3f8134c4$export$2e2bcd8739ae039), {
                                                value: value?.Id || '',
                                                label: {
                                                    eng: 'Template'
                                                },
                                                size: "small",
                                                items: (0, $ff8824db188fc32d$export$650746792cd2f81e)((0, $6689c5083829c982$export$34f8187f64e206fc))(serverTemplates),
                                                update: ()=>{}
                                            })
                                        })
                                    })
                                ]
                            }),
                            layoutData.map((elm, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $16051580cfa7616f$export$2e2bcd8739ae039), {
                                    data: elm,
                                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $7aba2092ca2b63b7$export$726ca57390740b07), (0, $58f80d7b57eba59b$export$b610b8812bbcded9)(i)),
                                    updateOpts: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(handleUpdate, (0, $7aba2092ca2b63b7$export$e8b49a33e60fbb5b)),
                                    updateVars: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(handleUpdate, (0, $7aba2092ca2b63b7$export$3e7d364af758ed31))
                                }, elm.Label))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        className: `template-datapanel__content-footer ${actionStep === "CLONE" ? 'gap-2' : 'gap-8'}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da9256d9077496fe$export$2e2bcd8739ae039), {
                                tlabel: {
                                    eng: 'Quantity'
                                },
                                min: 1,
                                update: setAmount,
                                value: amount
                            }),
                            actionStep === "SAVE" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ca3ac2f48b65f52$export$2e2bcd8739ae039), {
                                variant: "text",
                                onClick: handleSaveQuote,
                                children: "Save Quote"
                            }),
                            actionStep === "CLONE" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ca3ac2f48b65f52$export$2e2bcd8739ae039), {
                                        variant: "text",
                                        onClick: handleClose,
                                        style: {
                                            backgroundColor: '#822727'
                                        },
                                        children: "Close"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ca3ac2f48b65f52$export$2e2bcd8739ae039), {
                                        variant: "text",
                                        onClick: handleClone,
                                        style: {
                                            backgroundColor: '#1966D8'
                                        },
                                        children: "Clone"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $ebc59ff875b39f74$export$2e2bcd8739ae039 = $ebc59ff875b39f74$var$TemplateDataPanel;



const $5fb96737eae5d6d3$var$isSelected = (opts)=>(optLabel)=>(entLabel)=>{
            const opt = opts.find((opt)=>opt.Label === optLabel);
            if (opt === undefined) return false;
            return opt.Value === entLabel;
        };
const $5fb96737eae5d6d3$export$c1ee70c24c083802 = (tmpl)=>(opt)=>opt.Range.length > 1 && (0, $b0dad51325a37f96$export$8caee5e3bee8beba)($5fb96737eae5d6d3$var$isSelected(tmpl.Opts))(opt.Depends);
const $5fb96737eae5d6d3$export$cae9ccc5485bbb97 = (tmpl)=>(v)=>(0, $b0dad51325a37f96$export$8caee5e3bee8beba)($5fb96737eae5d6d3$var$isSelected(tmpl.Opts))(v.Depends);
const $5fb96737eae5d6d3$export$3c1e22b6b65f964a = (tmpl)=>{
    const sOpts = tmpl.Opts.filter((opt)=>$5fb96737eae5d6d3$export$c1ee70c24c083802(tmpl)(opt)).map((o)=>[
            o.Label,
            o.Value
        ]);
    const sVars = tmpl.Vars.filter((opt)=>$5fb96737eae5d6d3$export$cae9ccc5485bbb97(tmpl)(opt)).map((o)=>[
            o.Label,
            o.Value
        ]);
    return Object.assign({}, Object.fromEntries(sOpts), Object.fromEntries(sVars));
};
const $5fb96737eae5d6d3$export$64025381887b8f2d = (props)=>{
    const { req: req, template: template, update: update, selectedNode: selectedNode, setFieldBasedOnPath: setFieldBasedOnPath, handleDuplication: handleDuplication } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: "treeview-template",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8fc20d6ff1f2aab1$export$7370d7aaa0be7e8a), {
                req: req,
                template: template,
                initialFormat: "figure"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebc59ff875b39f74$export$2e2bcd8739ae039), {
                value: template,
                selectedNode: selectedNode,
                setFieldBasedOnPath: setFieldBasedOnPath,
                update: update,
                handleDuplication: handleDuplication
            })
        ]
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




const $909c4fde0e85a190$export$81c7a6a965a232ae = ({ title: title, description: description = '', autoDuration: autoDuration = 6000, style: style = {}, type: type, onClose: onClose = ()=>({}) })=>{
    (0, $acw62.useEffect)(()=>{
        let timerId = -1;
        if (autoDuration > 0) timerId = setTimeout(onClose, autoDuration);
        return ()=>{
            if (timerId) clearTimeout(timerId);
        };
    }, [
        autoDuration,
        onClose
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: "q-alert",
        sx: {
            borderRadius: '6px',
            border: `4px solid ${type === 'success' ? '#48BB78' : '#822727'}`,
            opacity: 0.9,
            background: '#2D3748E6',
            padding: '20px 57px 20px 20px',
            position: 'relative',
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                size: "small",
                sx: {
                    minWidth: '24px',
                    width: '24px',
                    height: '24px',
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    padding: 0,
                    color: '#fff'
                },
                onClick: onClose,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9c5eb05f9740712a$exports))), {
                    sx: {
                        width: '24px',
                        height: '24px'
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                pb: 2,
                variant: "h1",
                sx: {
                    fontSize: '24px',
                    fontWeight: 500,
                    lineHeight: '150%',
                    color: '#FFF',
                    paddingBottom: '0'
                },
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                pb: 2,
                variant: "h6",
                sx: {
                    fontSize: '24px',
                    fontWeight: 500,
                    lineHeight: '150%',
                    color: type === 'success' ? '#68D391' : '#D32F2F',
                    paddingBottom: '0'
                },
                children: description
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $d8seH = parcelRequire("d8seH");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





const $c6650fe4b700ca42$export$266a769812832828 = ({ title: title = '', isSelectable: isSelectable = false, isSelected: isSelected = false, isBorder: isBorder = false, padding: padding = 'lg', icon: icon, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))('bdh-menu', 'bdh-menu--primary', {
            ['bdh-menu--border']: isBorder,
            ['bdh-menu--selected']: isSelectable && isSelected
        }, `bdh-menu--${padding}`),
        ...props,
        children: [
            icon,
            title
        ]
    });
};
const $c6650fe4b700ca42$export$d9b273488cd8ce6f = ({ options: options, onClick: onClick, ...props })=>{
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [selectedMenus, setSelectedMenus] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const handleMenuClick = (opt)=>{
        setSelectedMenus((prev)=>[
                ...prev.filter((p)=>p !== opt.value),
                ...prev.includes(opt.value) ? [] : [
                    opt.value
                ]
            ]);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($c6650fe4b700ca42$export$266a769812832828, {
                id: "basic-button",
                "aria-controls": open ? 'basic-menu' : undefined,
                "aria-haspopup": "true",
                "aria-expanded": open ? 'true' : undefined,
                onClick: handleClick,
                ...props
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $364f3db28d8d2e79$export$2e2bcd8739ae039), {
                id: "basic-menu",
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                MenuListProps: {
                    'aria-labelledby': 'basic-button',
                    style: {
                        padding: 0
                    }
                },
                ...anchorEl ? {
                    PaperProps: {
                        style: {
                            width: `${anchorEl.clientWidth}px`
                        }
                    }
                } : {},
                transitionDuration: 0,
                children: options.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))('bdh-menu-item', 'bdh-menu-item--primary', {
                            ['bdh-menu-item--selected']: selectedMenus.includes(opt.value)
                        }),
                        onClick: ()=>handleMenuClick(opt),
                        children: opt.title
                    }, opt.value))
            })
        ]
    });
};





const $3cfc6ac812f49c9c$var$DiskIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        fill: "#F7FAFC",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
            id: "Icon",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                id: "Vector",
                d: "M17.9437 5.44359L14.5562 2.05609C14.4 1.89984 14.2083 1.78525 14 1.72275V1.6665H2.33329C1.96454 1.6665 1.66663 1.96442 1.66663 2.33317V17.6665C1.66663 18.0353 1.96454 18.3332 2.33329 18.3332H17.6666C18.0354 18.3332 18.3333 18.0353 18.3333 17.6665V6.38525C18.3333 6.03109 18.1937 5.69359 17.9437 5.44359ZM7.33329 3.1665H12.6666V5.33317H7.33329V3.1665ZM16.8333 16.8332H3.16663V3.1665H5.99996V5.99984C5.99996 6.36859 6.29788 6.6665 6.66663 6.6665H13.3333C13.702 6.6665 14 6.36859 14 5.99984V3.62067L16.8333 6.454V16.8332ZM9.99996 8.5415C8.34371 8.5415 6.99996 9.88525 6.99996 11.5415C6.99996 13.1978 8.34371 14.5415 9.99996 14.5415C11.6562 14.5415 13 13.1978 13 11.5415C13 9.88525 11.6562 8.5415 9.99996 8.5415ZM9.99996 13.2082C9.07913 13.2082 8.33329 12.4623 8.33329 11.5415C8.33329 10.6207 9.07913 9.87484 9.99996 9.87484C10.9208 9.87484 11.6666 10.6207 11.6666 11.5415C11.6666 12.4623 10.9208 13.2082 9.99996 13.2082Z",
                fill: "#F7FAFC"
            })
        })
    });
const $3cfc6ac812f49c9c$var$UserIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
            "clip-path": "url(#clip0_2631_2682)",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M11.9997 0C8.0296 0 4.79968 3.20853 4.79968 7.15232C4.79968 11.0961 8.0296 14.3046 11.9997 14.3046C15.9698 14.3046 19.1997 11.0961 19.1997 7.15232C19.1997 3.20853 15.9698 0 11.9997 0ZM11.9997 12.7152C8.91184 12.7152 6.39968 10.2197 6.39968 7.15232C6.39968 4.08493 8.91184 1.5894 11.9997 1.5894C15.0875 1.5894 17.5997 4.08493 17.5997 7.15232C17.5997 10.2197 15.0875 12.7152 11.9997 12.7152Z",
                    fill: "#A0AEC0"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M20.9582 15.8514C18.987 13.8632 16.3738 12.7682 13.6 12.7682H10.4C7.62624 12.7682 5.01301 13.8632 3.04181 15.8514C1.08027 17.8299 0 20.4415 0 23.2053C0 23.6442 0.358187 24 0.8 24H23.2C23.6418 24 24 23.6442 24 23.2053C24 20.4415 22.9197 17.8299 20.9582 15.8514ZM1.6352 22.4106C2.036 17.9028 5.81392 14.3577 10.4 14.3577H13.6C18.1861 14.3577 21.964 17.9028 22.3648 22.4106H1.6352Z",
                    fill: "#A0AEC0"
                })
            ]
        })
    });
const $3cfc6ac812f49c9c$var$ListIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M13.4438 1.6665H7.36543H3.33337V18.3332H17.5V1.6665H13.4438ZM12.4751 2.60879V4.34024H8.33409V2.60879H12.4751ZM7.38964 4.67004C7.4744 5.02339 7.80132 5.2943 8.18879 5.2943H12.6204C13.0079 5.2943 13.3348 5.02339 13.4196 4.67004H14.3882V15.3885H6.50574V4.67004H7.38964V4.67004ZM16.5314 17.4027H4.30204V2.60879H7.36543V3.73953H5.56129V16.3073H15.3448V3.73953H13.4438V2.60879H16.5314V17.4027Z",
                fill: "#F7FAFC"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M8.3098 8.59244C8.3098 8.59244 8.32191 8.59244 8.3098 8.59244C8.53986 8.59244 8.75781 8.49821 8.91521 8.34509L10.4772 6.75498L9.64171 5.96582L8.32191 7.30858L7.91023 6.87277L7.05054 7.63838L7.70438 8.33331C7.86179 8.49821 8.07974 8.59244 8.3098 8.59244Z",
                fill: "#F7FAFC"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M8.3098 11.6195C8.3098 11.6195 8.32191 11.6195 8.3098 11.6195C8.56407 11.6195 8.80624 11.5253 8.98786 11.3486L10.4893 9.8292L9.65382 9.04004L8.32191 10.3828L7.91022 9.94699L7.05054 10.7126L7.64384 11.3369C7.81336 11.5135 8.05552 11.6195 8.3098 11.6195Z",
                fill: "#F7FAFC"
            }),
            ' ',
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M8.3098 14.7296C8.3098 14.7296 8.32191 14.7296 8.3098 14.7296C8.53986 14.7296 8.75781 14.6354 8.91521 14.4823L10.4772 12.8922L9.64171 12.103L8.32191 13.434L7.91023 12.9982L7.05054 13.7638L7.70438 14.4587C7.86179 14.6354 8.07974 14.7296 8.3098 14.7296Z",
                fill: "#F7FAFC"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M13.6739 6.95508H11.4823V7.89737H13.6739V6.95508Z",
                fill: "#F7FAFC"
            }),
            ' ',
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M13.6739 9.80566H11.4823V10.7479H13.6739V9.80566Z",
                fill: "#F7FAFC"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M13.6739 12.7383H11.4823V13.6806H13.6739V12.7383Z",
                fill: "#F7FAFC"
            })
        ]
    });
const $3cfc6ac812f49c9c$var$BootstrapTooltip = (0, $d8seH.default)(({ className: className, ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
        ...props,
        classes: {
            popper: className
        }
    }))(()=>({
        [`& .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).tooltip}`]: {
            backgroundColor: '#2D3748',
            border: '1px solid #48BB78'
        }
    }));
const $3cfc6ac812f49c9c$export$6e3c1cdf13152e0e = ({ goBack: goBack })=>{
    const { mainViewMode: mainViewMode, dispatch: dispatch } = (0, $acw62.useContext)((0, $a388f687e0a39747$export$afffaa0e40c01a5d));
    const [open, setOpen] = (0, $acw62.useState)(false);
    const handleSwitchView = (mode)=>{
        dispatch({
            type: (0, $a388f687e0a39747$export$dd3f6860d8bc5f06),
            data: mode
        });
    };
    const handleRedirect = (save)=>{
        goBack(save);
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: "bulk-header",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                className: "bulk-header__first",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($3cfc6ac812f49c9c$var$BootstrapTooltip, {
                        title: "Continue to Dapp",
                        placement: "right",
                        slotProps: {
                            popper: {
                                modifiers: [
                                    {
                                        name: 'offset',
                                        options: {
                                            offset: [
                                                0,
                                                -14
                                            ]
                                        }
                                    }
                                ]
                            }
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6650fe4b700ca42$export$266a769812832828), {
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($3cfc6ac812f49c9c$var$DiskIcon, {}),
                                padding: "sm",
                                onClick: ()=>setOpen(true)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6650fe4b700ca42$export$266a769812832828), {
                        title: "List view",
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)($3cfc6ac812f49c9c$var$ListIcon, {}),
                        padding: "md",
                        isSelectable: true,
                        isSelected: mainViewMode === (0, $a388f687e0a39747$export$bab437785f90cbb4).LIST_VIEW,
                        onClick: ()=>handleSwitchView((0, $a388f687e0a39747$export$bab437785f90cbb4).LIST_VIEW)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c6650fe4b700ca42$export$266a769812832828), {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)($3cfc6ac812f49c9c$var$UserIcon, {}),
                    padding: "sm"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $24f0a8bb8c2e8fd2$export$de466dd8317b0b75), {
                open: open,
                title: "Returning to DAPP, would you like to save?",
                okLabel: "Save",
                cancelLabel: "Don't save",
                onOk: handleRedirect,
                onClose: ()=>setOpen(false)
            })
        ]
    });
};


/**
 * Building Templates and getting information about them.
 *
 * @since 0.4.0
 */ 
const $63744786ce2f1794$export$2a5a488e2ad719ed = (req)=>(Design, Tier, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Install, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Rules)=>req.request((0, $cefda0850953082d$export$82b8d343c504672))('price/design', 'POST', {
            Design: Design,
            Tier: Tier,
            Install: Install,
            Labor: {},
            Rules: Rules
        });


const $2cd2e90947afb30b$var$BulkDesignPage = /*#__PURE__*/ (0, $acw62.forwardRef)(({ req: req, onTreeDataChange: onTreeDataChange, onQuoteChange: onQuoteChange, onSaveChange: onSaveChange, onCancel: onCancel }, ref)=>{
    const [state, dispatch] = (0, $acw62.useReducer)((0, $a388f687e0a39747$export$1650419e431d3ba3), (0, $a388f687e0a39747$export$36d128238e6b60f5));
    const treeviewRef = (0, $acw62.useRef)(null);
    const [selectedPath, setSelectedPath] = (0, $acw62.useState)();
    const [selectedNode, setSelectedNode] = (0, $acw62.useState)();
    const [treeData, setTreeData] = (0, $acw62.useState)(JSON.parse(JSON.stringify($721e36edb0f53275$exports)));
    const [quoteData, setQuoteData] = (0, $acw62.useState)(JSON.parse(JSON.stringify($ad5d0a10b685e478$exports)));
    const [leftSideBarWidth, setLeftSideBarWidth] = (0, $acw62.useState)(330);
    const [limits, setLimits] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    setLimits;
    const [template, updateTemplate] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const [serverTemplates, setServerTemplates] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [defaultTemplatePrice, setDefaultTemplatePrice] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [settings, setSettings] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const handleWidth = 16;
    const treeViewWidth = (0, $acw62.useMemo)(()=>{
        if (state.mainViewMode === (0, $a388f687e0a39747$export$bab437785f90cbb4).LIST_VIEW) return '100vw';
        return `${leftSideBarWidth}px`;
    }, [
        leftSideBarWidth,
        state.mainViewMode
    ]);
    const alertProps = (0, $acw62.useMemo)(()=>state.alertProps, [
        state.alertProps
    ]);
    const getTemplatePrice = (0, $acw62.useCallback)(async (t)=>{
        if (settings) try {
            dispatch({
                type: (0, $a388f687e0a39747$export$bd0bf4d50261caa1),
                data: true
            });
            const price = await (0, $63744786ce2f1794$export$2a5a488e2ad719ed)(req)(t, settings.Tier, settings.Install, settings.Rules);
            handleCloseAlert();
            return price;
        } catch (err) {
            console.error(err);
            dispatch({
                type: (0, $a388f687e0a39747$export$b2463983502340c6),
                data: {
                    open: true,
                    type: 'error',
                    title: 'Error',
                    description: 'The template cannot be priced. Please adjust the options.',
                    autoDuration: 3000
                }
            });
            return 0, $cefda0850953082d$export$30a2c32520b13484;
        } finally{
            dispatch({
                type: (0, $a388f687e0a39747$export$bd0bf4d50261caa1),
                data: false
            });
        }
        return null;
    }, [
        req,
        settings
    ]);
    const updateTreeData = (data)=>{
        setTreeData({
            Name: data.Name,
            Count: data.Count,
            Items: data.Items
        });
        if (onTreeDataChange) onTreeDataChange(data);
    };
    const updateQuoteData = (quote)=>{
        setQuoteData(quote);
        if (onQuoteChange) onQuoteChange(quote);
    };
    (0, $acw62.useEffect)(()=>{
        (0, $d807307be9b2068b$export$8837f4fc672e936d)(req)().then((templates)=>{
            setServerTemplates(templates);
            dispatch({
                type: (0, $a388f687e0a39747$export$29523c2f5fc48e88),
                data: templates
            });
        }).catch(console.warn);
    }, [
        req
    ]);
    const handleSelectTemplate = (path, tData)=>{
        if (path && path.length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const selectedTemplate = (0, $50fde2cab6970bb8$export$4f4f3d7650ec6d20)(path).get(tData || treeData);
            if (selectedTemplate) {
                if (selectedTemplate.hasOwnProperty('Panels')) updateTemplate(undefined);
                else updateTemplate(selectedTemplate);
            } else updateTemplate(undefined);
        } else updateTemplate(undefined);
    };
    (0, $acw62.useEffect)(()=>{
        if (selectedPath && template) {
            const handleUpdateProcess = async ()=>{
                let newTreeData = treeData;
                let newQuoteData = quoteData;
                // Check if the current name is default one or not.
                let hasDefaultName = false;
                let suffix = '';
                const selectedItem = (0, $50fde2cab6970bb8$export$558bb72b152ded6a)(selectedPath).get(treeData);
                if (selectedItem) {
                    const defaultName = (0, $50fde2cab6970bb8$export$ad3707821486673c)(selectedItem.Item);
                    const itemNameNoClone = selectedItem.Name.split(' (clone)').join('');
                    suffix = selectedItem.Name.slice(itemNameNoClone.length);
                    hasDefaultName = defaultName === itemNameNoClone;
                }
                // In case of default name, update the name from new template.
                if (hasDefaultName) {
                    const newDefaultName = (0, $50fde2cab6970bb8$export$ad3707821486673c)(template, suffix);
                    if (newDefaultName !== selectedItem.Name) {
                        newTreeData = (0, $50fde2cab6970bb8$export$934882c7e3a6622a)(selectedPath, 'Name', newDefaultName)(treeData);
                        newQuoteData = (0, $f11497db38134253$export$8f141d98755d06ac)(selectedPath, 'Name', newDefaultName)(quoteData);
                        updateQuoteData(newQuoteData);
                    }
                }
                newTreeData = (0, $50fde2cab6970bb8$export$e89563da860fe692)(selectedPath, template)(newTreeData);
                updateTreeData(newTreeData);
                // Update quote.
                if (JSON.stringify(template) !== JSON.stringify(serverTemplates[0]) || !defaultTemplatePrice) {
                    const price = await getTemplatePrice(template);
                    if (price) {
                        newQuoteData = (0, $f11497db38134253$export$beb8b05d1c8736e0)(selectedPath, price)(quoteData);
                        updateQuoteData(newQuoteData);
                    }
                }
            };
            handleUpdateProcess();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedPath,
        template
    ]);
    (0, $acw62.useEffect)(()=>{
        if (selectedPath && selectedPath.length > 0) {
            const selected = (0, $50fde2cab6970bb8$export$558bb72b152ded6a)(selectedPath).get(treeData);
            setSelectedNode(selected);
        } else setSelectedNode(undefined);
    }, [
        selectedPath,
        treeData
    ]);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            updateQuote: (quote)=>{
                setQuoteData(JSON.parse(JSON.stringify(quote)));
            },
            updateTreeData: updateTreeData,
            updateSettings: setSettings
        }));
    if (!treeData) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: "Loading..."
    });
    const updateSelectedPath = (path, tData)=>{
        if (path) {
            if (selectedPath?.toString() === path.toString()) {
                setSelectedPath(undefined);
                handleSelectTemplate(undefined);
            } else {
                setSelectedPath(path);
                handleSelectTemplate(path, tData);
            }
        } else {
            setSelectedPath(undefined);
            handleSelectTemplate(undefined);
        }
    };
    const addTemplate = async ()=>{
        const newItemName = (0, $50fde2cab6970bb8$export$ad3707821486673c)(serverTemplates[0]);
        const newItemToInsert = {
            Name: newItemName,
            Count: 1,
            Item: serverTemplates[0]
        };
        const newQuoteToInsert = {
            Name: newItemName,
            Count: 1,
            Price: {
                USD: '0'
            },
            Unit: {
                Count: 1,
                Unit: 'pc'
            },
            Discounts: {},
            Taxes: {},
            Extended: {
                USD: '0'
            },
            Discount: {},
            SubTotal: {
                USD: '0'
            },
            Tax: {},
            Total: {
                USD: '0'
            }
        };
        // Get price.
        if (settings) {
            let price;
            if (defaultTemplatePrice) price = defaultTemplatePrice;
            else {
                price = await getTemplatePrice(serverTemplates[0]);
                setDefaultTemplatePrice(price);
            }
            if (price) {
                if (price.Charges) newQuoteToInsert.Price = {
                    USD: price.Charges.reduce((res, c)=>res + parseFloat(c.Price?.USD ?? '0'), 0).toFixed(2)
                };
                if (price.Charges[0]?.Unit) newQuoteToInsert.Unit = price.Charges[0].Unit;
                newQuoteToInsert.Discounts = price.Discounts;
                newQuoteToInsert.Taxes = price.Taxes;
                newQuoteToInsert.Extended = price.Extended;
                newQuoteToInsert.Discount = price.Discount;
                newQuoteToInsert.SubTotal = price.SubTotal;
                newQuoteToInsert.Tax = price.Tax;
                newQuoteToInsert.Total = price.Total;
            }
        }
        const pathToInsert = treeData.Items.length === 0 ? [
            0
        ] : selectedPath || [
            treeData.Items.length - 1
        ];
        // Need to be updated later.
        const newPath = treeData.Items.length === 0 ? pathToInsert : [
            (pathToInsert[0] || 0) + 1
        ];
        const newTreeData = (0, $50fde2cab6970bb8$export$773ddc560f4a0181)(pathToInsert, newItemToInsert)(treeData);
        updateTreeData(newTreeData);
        updateQuoteData((0, $f11497db38134253$export$c6a52f3075b036ea)(pathToInsert, newQuoteToInsert)(quoteData));
        updateSelectedPath(newPath, newTreeData);
    };
    const handleCloseAlert = ()=>{
        dispatch({
            type: (0, $a388f687e0a39747$export$90b7ee5b7e89afd4)
        });
    };
    const setFieldBasedOnPath = (field, newValue)=>{
        if (selectedPath) {
            const newTreeData = (0, $50fde2cab6970bb8$export$934882c7e3a6622a)(selectedPath, field, newValue)(treeData);
            console.log(newTreeData);
            setTreeData(newTreeData);
            const newQuoteData = (0, $f11497db38134253$export$8f141d98755d06ac)(selectedPath, field, newValue)(quoteData);
            setQuoteData(newQuoteData);
        }
    };
    const handleDuplication = ()=>{
        if (treeviewRef.current && selectedPath) treeviewRef.current.handleDuplication(selectedPath);
    };
    const handleGoBack = (save)=>{
        if (save) {
            if (onSaveChange) onSaveChange(treeData, quoteData);
        } else // Do something here.
        if (onCancel) onCancel();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a388f687e0a39747$export$afffaa0e40c01a5d).Provider, {
        value: {
            ...state,
            dispatch: dispatch
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3cfc6ac812f49c9c$export$6e3c1cdf13152e0e), {
                        goBack: handleGoBack
                    }),
                    (state.mainViewMode === (0, $a388f687e0a39747$export$bab437785f90cbb4).LIST_VIEW || state.mainViewMode === (0, $a388f687e0a39747$export$bab437785f90cbb4).DEFAULT) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        style: {
                            display: 'grid',
                            gridTemplateColumns: 'auto 1fr',
                            height: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "left-side-bar-draggable",
                                style: {
                                    width: treeViewWidth,
                                    paddingRight: state.mainViewMode !== (0, $a388f687e0a39747$export$bab437785f90cbb4).LIST_VIEW ? `${handleWidth}px` : 0
                                },
                                children: [
                                    state.mainViewMode !== (0, $a388f687e0a39747$export$bab437785f90cbb4).LIST_VIEW && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b6206966e4877619$export$2e2bcd8739ae039), {
                                        defaultValue: 330,
                                        minValue: 308,
                                        maxValue: 380,
                                        position: "right",
                                        onChange: setLeftSideBarWidth
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        className: "bar",
                                        style: {
                                            width: '100%'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $838f51ccfb30a43f$export$2e2bcd8739ae039), {
                                            ref: treeviewRef,
                                            setTreeData: updateTreeData,
                                            selectedPath: selectedPath,
                                            addTemplate: addTemplate,
                                            updateSelectedPath: updateSelectedPath,
                                            treeData: treeData,
                                            quoteData: quoteData,
                                            setQuoteData: updateQuoteData
                                        })
                                    })
                                ]
                            }),
                            state.mainViewMode !== (0, $a388f687e0a39747$export$bab437785f90cbb4).LIST_VIEW && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                className: "tree-view right-side-bar",
                                children: template && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5fb96737eae5d6d3$export$64025381887b8f2d), {
                                    req: req,
                                    limits: limits,
                                    template: template,
                                    selectedNode: selectedNode,
                                    setFieldBasedOnPath: setFieldBasedOnPath,
                                    handleDuplication: handleDuplication,
                                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(updateTemplate, (0, $58f80d7b57eba59b$export$f8b8b9ce72e9ccbf))
                                })
                            })
                        ]
                    })
                ]
            }),
            alertProps.open && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9f9722f5a293e2a2$export$8d8dc7d5f743331b), {
                open: true,
                type: "info",
                vertical: "bottom",
                horizontal: "right",
                autoHideDuration: 3000,
                handleClose: ()=>({}),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $909c4fde0e85a190$export$81c7a6a965a232ae), {
                    title: alertProps.title,
                    type: alertProps.type,
                    description: alertProps.description,
                    autoDuration: alertProps.autoDuration,
                    style: {
                        marginBottom: '60px',
                        marginRight: '-16px'
                    },
                    onClose: handleCloseAlert
                })
            }),
            state.loading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    position: 'fixed',
                    inset: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: '#0000006a'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {})
            })
        ]
    });
});
var $2cd2e90947afb30b$export$2e2bcd8739ae039 = $2cd2e90947afb30b$var$BulkDesignPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $eVPL0 = parcelRequire("eVPL0");
const $f64a1d08d63e25a2$export$414e41559af5a852 = (codec, onMessage, originFilter)=>{
    const onEvent = (0, $acw62.useCallback)((ev)=>{
        if (originFilter && !originFilter(ev.origin)) return;
        $eVPL0.fold(()=>undefined, (x)=>onMessage({
                ...ev,
                data: x
            }))(codec.decode(ev.data));
    }, [
        codec,
        onMessage,
        originFilter
    ]);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener('message', onEvent);
        return ()=>window.removeEventListener('message', onEvent);
    });
};





const $6a661e14ba33ee64$export$ade3ab6aaaec74c7 = (codecA)=>(0, $87701c398fec8638$export$74c5cab0f9a94551)('NamedTree', ()=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
            Name: (0, $87701c398fec8638$export$22b082955e083ec3),
            Count: (0, $87701c398fec8638$export$98e628dec113755e),
            Items: (0, $87701c398fec8638$export$2f23118c22fb2630)($6a661e14ba33ee64$export$9cada7ee0397d36a(codecA))
        }));
const $6a661e14ba33ee64$export$9cada7ee0397d36a = (codecA)=>(0, $87701c398fec8638$export$74c5cab0f9a94551)('NamedItem', ()=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
            $6a661e14ba33ee64$export$ade3ab6aaaec74c7(codecA),
            $6a661e14ba33ee64$export$462dac20a4c0dae4(codecA)
        ]));
const $6a661e14ba33ee64$export$55f79c9059b769da = (x)=>(0, $11ac65d824358a4b$export$dd642ef726dcde21)(x, 'Items');
const $6a661e14ba33ee64$export$e132ced8f644a612 = (x)=>(0, $11ac65d824358a4b$export$dd642ef726dcde21)(x, 'Item');
const $6a661e14ba33ee64$export$462dac20a4c0dae4 = (codecA)=>{
    return (0, $87701c398fec8638$export$bf9fb029d174d554)({
        Name: (0, $87701c398fec8638$export$22b082955e083ec3),
        Count: (0, $87701c398fec8638$export$98e628dec113755e),
        Item: codecA
    });
};
const $6a661e14ba33ee64$export$d2fb41866a01c4a2 = {
    Name: '',
    Count: 1,
    Items: []
};



/**
 * Requastor performing legacy "Glassd Web Service"-style authentication.
 *
 * @since 0.1.0
 */ // eslint-disable-next-line no-multi-assign
var $44edd02a6be448cd$export$5f828d93ff035aa8;
var $44edd02a6be448cd$export$cd94982b18c6332c;
var $44edd02a6be448cd$export$1d518568e4f529b0;
var $44edd02a6be448cd$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $44edd02a6be448cd$export$2fb37efbf6ae0c0e;
var $44edd02a6be448cd$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $44edd02a6be448cd$export$da39cf97e1eb7c91;
var $44edd02a6be448cd$export$52a9039d7177394f;
var $44edd02a6be448cd$export$f7201db400317331;
var $44edd02a6be448cd$export$448fa22aedc9dbca;
var $44edd02a6be448cd$export$b80c7ba289c8fa56;
var $44edd02a6be448cd$export$26e5786e8ac8e530;
var $44edd02a6be448cd$export$bdd223f16383713e;
var $44edd02a6be448cd$export$20533d26f07f1ee0;
var $44edd02a6be448cd$export$2f64596b8cbf08b4;
var $44edd02a6be448cd$export$2ce6d8d0e8b04e1a;
var $44edd02a6be448cd$export$12ada9414fbc594c;
var $44edd02a6be448cd$export$f5e7e39d57cd9700;
var $44edd02a6be448cd$export$36b6d6ef312eab39;
var $44edd02a6be448cd$export$58a258485f1e49f6;
var $44edd02a6be448cd$export$dedd8dc3dc62b370;
var $44edd02a6be448cd$export$971862a2fcb1bb40;
var $44edd02a6be448cd$export$c6ff6a88acbeaf40;
var $44edd02a6be448cd$export$fdc27893e98845cc;
var $44edd02a6be448cd$export$6671fb9a1323bed;
var $44edd02a6be448cd$export$d74daf141a551db;
var $44edd02a6be448cd$export$45df7cae684751af;
var $44edd02a6be448cd$export$1db683ad541682f6;
var $44edd02a6be448cd$export$6f65485f87568e37;
var $44edd02a6be448cd$export$91a8e56769aeb334;
var $44edd02a6be448cd$export$2d4117e99c2179e4;
var $44edd02a6be448cd$export$512823e338ddb1b7;
var $44edd02a6be448cd$export$9d0e0c0c4a8d30f3;
var $44edd02a6be448cd$export$b9d55ff329113abd;
var $44edd02a6be448cd$export$7efb24e2fddf99b9;
var $44edd02a6be448cd$export$bb1abf2ce84fc7e8;
var $44edd02a6be448cd$export$2f7171e78e524d5e;
var $44edd02a6be448cd$export$e1d879b482f37d98;
var $44edd02a6be448cd$export$1a988e7317c65621;
'use strict';

$44edd02a6be448cd$export$5f828d93ff035aa8 = $44edd02a6be448cd$export$cd94982b18c6332c = $44edd02a6be448cd$export$1d518568e4f529b0 = $44edd02a6be448cd$export$5285b6d41c912b41 = (parcelRequire("hkN9y"));

$44edd02a6be448cd$export$2fb37efbf6ae0c0e = $44edd02a6be448cd$export$ab85ecd77ce6a5cd = (parcelRequire("1R2J7"));

$44edd02a6be448cd$export$da39cf97e1eb7c91 = $44edd02a6be448cd$export$52a9039d7177394f = (parcelRequire("1iL1D"));
var $aaef572789dc684d$exports = {};
'use strict';

$aaef572789dc684d$exports = (parcelRequire("6swAi"));


var $44edd02a6be448cd$var$algoKeys = Object.keys($aaef572789dc684d$exports);
var $44edd02a6be448cd$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($44edd02a6be448cd$var$algoKeys);
$44edd02a6be448cd$export$f7201db400317331 = function() {
    return $44edd02a6be448cd$var$hashes;
};

var $lORrZ = parcelRequire("lORrZ");
$44edd02a6be448cd$export$448fa22aedc9dbca = $lORrZ.pbkdf2;
$44edd02a6be448cd$export$b80c7ba289c8fa56 = $lORrZ.pbkdf2Sync;
var $a97f913e2ff95e3b$export$bdd223f16383713e;
var $a97f913e2ff95e3b$export$26e5786e8ac8e530;
var $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
var $a97f913e2ff95e3b$export$20533d26f07f1ee0;
var $a97f913e2ff95e3b$export$12ada9414fbc594c;
var $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
var $a97f913e2ff95e3b$export$36b6d6ef312eab39;
var $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
var $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $a97f913e2ff95e3b$export$58a258485f1e49f6;
var $f85287bc79724838$exports = {};

var $26nOC = parcelRequire("26nOC");
var $675eb908dbde2e68$export$eab97d15b1788b8d;
var $675eb908dbde2e68$export$26e5786e8ac8e530;
var $675eb908dbde2e68$export$cc8859615686b300;
var $675eb908dbde2e68$export$8ad3f227af08fcc5;
var $675eb908dbde2e68$export$947646e34766044f;
'use strict';

$675eb908dbde2e68$export$eab97d15b1788b8d = (parcelRequire("dyok1"));

$675eb908dbde2e68$export$26e5786e8ac8e530 = (parcelRequire("enfpo"));

$675eb908dbde2e68$export$cc8859615686b300 = (parcelRequire("dB8Kv"));

$675eb908dbde2e68$export$8ad3f227af08fcc5 = (parcelRequire("eiYbc"));

$675eb908dbde2e68$export$947646e34766044f = (parcelRequire("5ye6K"));



var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $f85287bc79724838$require$Buffer = $1U9GM.Buffer;
var $f85287bc79724838$var$modes = {
    'des-ede3-cbc': $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$947646e34766044f),
    'des-ede3': $675eb908dbde2e68$export$947646e34766044f,
    'des-ede-cbc': $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$947646e34766044f),
    'des-ede': $675eb908dbde2e68$export$947646e34766044f,
    'des-cbc': $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$cc8859615686b300),
    'des-ecb': $675eb908dbde2e68$export$cc8859615686b300
};
$f85287bc79724838$var$modes.des = $f85287bc79724838$var$modes['des-cbc'];
$f85287bc79724838$var$modes.des3 = $f85287bc79724838$var$modes['des-ede3-cbc'];
$f85287bc79724838$exports = $f85287bc79724838$var$DES;
$dlqwk($f85287bc79724838$var$DES, $26nOC);
function $f85287bc79724838$var$DES(opts) {
    $26nOC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $f85287bc79724838$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$f85287bc79724838$require$Buffer.isBuffer(key)) key = $f85287bc79724838$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $f85287bc79724838$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$f85287bc79724838$require$Buffer.isBuffer(iv)) iv = $f85287bc79724838$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$f85287bc79724838$var$DES.prototype._update = function(data) {
    return $f85287bc79724838$require$Buffer.from(this._des.update(data));
};
$f85287bc79724838$var$DES.prototype._final = function() {
    return $f85287bc79724838$require$Buffer.from(this._des.final());
};



var $7Zu82 = parcelRequire("7Zu82");

var $5Su5u = parcelRequire("5Su5u");
var $0649907c0434f982$exports = {};

$parcel$export($0649907c0434f982$exports, "des-ecb", () => $0649907c0434f982$export$116f8a5cee447347, (v) => $0649907c0434f982$export$116f8a5cee447347 = v);
$parcel$export($0649907c0434f982$exports, "des-cbc", () => $0649907c0434f982$export$7483c4066bfb7ae9, (v) => $0649907c0434f982$export$7483c4066bfb7ae9 = v);
$parcel$export($0649907c0434f982$exports, "des", () => $0649907c0434f982$export$e7a565d2e588bb06, (v) => $0649907c0434f982$export$e7a565d2e588bb06 = v);
$parcel$export($0649907c0434f982$exports, "des-ede3-cbc", () => $0649907c0434f982$export$aaa2f54a426f3eb8, (v) => $0649907c0434f982$export$aaa2f54a426f3eb8 = v);
$parcel$export($0649907c0434f982$exports, "des3", () => $0649907c0434f982$export$eba20568dde4ada, (v) => $0649907c0434f982$export$eba20568dde4ada = v);
$parcel$export($0649907c0434f982$exports, "des-ede3", () => $0649907c0434f982$export$d3b5e5996938f5ae, (v) => $0649907c0434f982$export$d3b5e5996938f5ae = v);
$parcel$export($0649907c0434f982$exports, "des-ede-cbc", () => $0649907c0434f982$export$57c08356130bc99b, (v) => $0649907c0434f982$export$57c08356130bc99b = v);
$parcel$export($0649907c0434f982$exports, "des-ede", () => $0649907c0434f982$export$c7169791d5c1e65d, (v) => $0649907c0434f982$export$c7169791d5c1e65d = v);
var $0649907c0434f982$export$116f8a5cee447347;
var $0649907c0434f982$export$7483c4066bfb7ae9;
var $0649907c0434f982$export$e7a565d2e588bb06;
var $0649907c0434f982$export$aaa2f54a426f3eb8;
var $0649907c0434f982$export$eba20568dde4ada;
var $0649907c0434f982$export$d3b5e5996938f5ae;
var $0649907c0434f982$export$57c08356130bc99b;
var $0649907c0434f982$export$c7169791d5c1e65d;
$0649907c0434f982$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$0649907c0434f982$export$7483c4066bfb7ae9 = $0649907c0434f982$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$0649907c0434f982$export$aaa2f54a426f3eb8 = $0649907c0434f982$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$0649907c0434f982$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$0649907c0434f982$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$0649907c0434f982$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};



var $bSYjd = parcelRequire("bSYjd");
function $a97f913e2ff95e3b$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($0649907c0434f982$exports[suite]) {
        keyLen = $0649907c0434f982$exports[suite].key * 8;
        ivLen = $0649907c0434f982$exports[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($0649907c0434f982$exports[suite]) {
        keyLen = $0649907c0434f982$exports[suite].key * 8;
        ivLen = $0649907c0434f982$exports[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createCipheriv(suite, key, iv);
    if ($0649907c0434f982$exports[suite]) return new $f85287bc79724838$exports({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $a97f913e2ff95e3b$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createDecipheriv(suite, key, iv);
    if ($0649907c0434f982$exports[suite]) return new $f85287bc79724838$exports({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $a97f913e2ff95e3b$var$getCiphers() {
    return Object.keys($0649907c0434f982$exports).concat($7Zu82.getCiphers());
}
$a97f913e2ff95e3b$export$bdd223f16383713e = $a97f913e2ff95e3b$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$var$createCipher;
$a97f913e2ff95e3b$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$var$createCipheriv;
$a97f913e2ff95e3b$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$var$createDecipher;
$a97f913e2ff95e3b$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$var$createDecipheriv;
$a97f913e2ff95e3b$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$58a258485f1e49f6 = $a97f913e2ff95e3b$var$getCiphers;


$44edd02a6be448cd$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$export$26e5786e8ac8e530;
$44edd02a6be448cd$export$bdd223f16383713e = $a97f913e2ff95e3b$export$bdd223f16383713e;
$44edd02a6be448cd$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$export$20533d26f07f1ee0;
$44edd02a6be448cd$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
$44edd02a6be448cd$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
$44edd02a6be448cd$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$12ada9414fbc594c;
$44edd02a6be448cd$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
$44edd02a6be448cd$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$36b6d6ef312eab39;
$44edd02a6be448cd$export$58a258485f1e49f6 = $a97f913e2ff95e3b$export$58a258485f1e49f6;
$44edd02a6be448cd$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $4387b1fafb8a1868$export$971862a2fcb1bb40;
var $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
var $4387b1fafb8a1868$export$fdc27893e98845cc;
var $4387b1fafb8a1868$export$6671fb9a1323bed;
var $4387b1fafb8a1868$export$d74daf141a551db;

var $6ZWSX = parcelRequire("6ZWSX");
var $4387b1fafb8a1868$require$Buffer = $6ZWSX.Buffer;
var $7f34ba2fa9025258$exports = {};

var $hkN9y = parcelRequire("hkN9y");
$7f34ba2fa9025258$exports = $7f34ba2fa9025258$var$findPrime;
$7f34ba2fa9025258$var$findPrime.simpleSieve = $7f34ba2fa9025258$var$simpleSieve;
$7f34ba2fa9025258$var$findPrime.fermatTest = $7f34ba2fa9025258$var$fermatTest;

var $5vmVB = parcelRequire("5vmVB");
var $7f34ba2fa9025258$var$TWENTYFOUR = new $5vmVB(24);
var $bac5f004a90de4c6$exports = {};

var $7Zvov = parcelRequire("7Zvov");

var $7JHF0 = parcelRequire("7JHF0");
function $bac5f004a90de4c6$var$MillerRabin(rand) {
    this.rand = rand || new $7JHF0.Rand();
}
$bac5f004a90de4c6$exports = $bac5f004a90de4c6$var$MillerRabin;
$bac5f004a90de4c6$var$MillerRabin.create = function create(rand) {
    return new $bac5f004a90de4c6$var$MillerRabin(rand);
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7Zvov(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$bac5f004a90de4c6$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$bac5f004a90de4c6$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};


var $7f34ba2fa9025258$var$millerRabin = new $bac5f004a90de4c6$exports();
var $7f34ba2fa9025258$var$ONE = new $5vmVB(1);
var $7f34ba2fa9025258$var$TWO = new $5vmVB(2);
var $7f34ba2fa9025258$var$FIVE = new $5vmVB(5);
var $7f34ba2fa9025258$var$SIXTEEN = new $5vmVB(16);
var $7f34ba2fa9025258$var$EIGHT = new $5vmVB(8);
var $7f34ba2fa9025258$var$TEN = new $5vmVB(10);
var $7f34ba2fa9025258$var$THREE = new $5vmVB(3);
var $7f34ba2fa9025258$var$SEVEN = new $5vmVB(7);
var $7f34ba2fa9025258$var$ELEVEN = new $5vmVB(11);
var $7f34ba2fa9025258$var$FOUR = new $5vmVB(4);
var $7f34ba2fa9025258$var$TWELVE = new $5vmVB(12);
var $7f34ba2fa9025258$var$primes = null;
function $7f34ba2fa9025258$var$_getPrimes() {
    if ($7f34ba2fa9025258$var$primes !== null) return $7f34ba2fa9025258$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $7f34ba2fa9025258$var$primes = res;
    return res;
}
function $7f34ba2fa9025258$var$simpleSieve(p) {
    var primes = $7f34ba2fa9025258$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $7f34ba2fa9025258$var$fermatTest(p) {
    var red = $5vmVB.mont(p);
    return $7f34ba2fa9025258$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $7f34ba2fa9025258$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $5vmVB([
            0x8c,
            0x7b
        ]);
        else return new $5vmVB([
            0x8c,
            0x27
        ]);
    }
    gen = new $5vmVB(gen);
    var num, n2;
    while(true){
        num = new $5vmVB($hkN9y(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($7f34ba2fa9025258$var$ONE);
        if (!num.testn(1)) num.iadd($7f34ba2fa9025258$var$TWO);
        if (!gen.cmp($7f34ba2fa9025258$var$TWO)) while(num.mod($7f34ba2fa9025258$var$TWENTYFOUR).cmp($7f34ba2fa9025258$var$ELEVEN))num.iadd($7f34ba2fa9025258$var$FOUR);
        else if (!gen.cmp($7f34ba2fa9025258$var$FIVE)) while(num.mod($7f34ba2fa9025258$var$TEN).cmp($7f34ba2fa9025258$var$THREE))num.iadd($7f34ba2fa9025258$var$FOUR);
        n2 = num.shrn(1);
        if ($7f34ba2fa9025258$var$simpleSieve(n2) && $7f34ba2fa9025258$var$simpleSieve(num) && $7f34ba2fa9025258$var$fermatTest(n2) && $7f34ba2fa9025258$var$fermatTest(num) && $7f34ba2fa9025258$var$millerRabin.test(n2) && $7f34ba2fa9025258$var$millerRabin.test(num)) return num;
    }
}


var $f0f71b0d846b32d7$exports = {};
$f0f71b0d846b32d7$exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");


var $8911d62d5514749e$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $8911d62d5514749e$require$Buffer = $6ZWSX.Buffer;

var $5vmVB = parcelRequire("5vmVB");

var $8911d62d5514749e$var$millerRabin = new $bac5f004a90de4c6$exports();
var $8911d62d5514749e$var$TWENTYFOUR = new $5vmVB(24);
var $8911d62d5514749e$var$ELEVEN = new $5vmVB(11);
var $8911d62d5514749e$var$TEN = new $5vmVB(10);
var $8911d62d5514749e$var$THREE = new $5vmVB(3);
var $8911d62d5514749e$var$SEVEN = new $5vmVB(7);


var $hkN9y = parcelRequire("hkN9y");
$8911d62d5514749e$exports = $8911d62d5514749e$var$DH;
function $8911d62d5514749e$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$8911d62d5514749e$require$Buffer.isBuffer(pub)) pub = new $8911d62d5514749e$require$Buffer(pub, enc);
    this._pub = new $5vmVB(pub);
    return this;
}
function $8911d62d5514749e$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$8911d62d5514749e$require$Buffer.isBuffer(priv)) priv = new $8911d62d5514749e$require$Buffer(priv, enc);
    this._priv = new $5vmVB(priv);
    return this;
}
var $8911d62d5514749e$var$primeCache = {};
function $8911d62d5514749e$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $8911d62d5514749e$var$primeCache) return $8911d62d5514749e$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$7f34ba2fa9025258$exports.simpleSieve || !$7f34ba2fa9025258$exports.fermatTest(prime) || !$8911d62d5514749e$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $8911d62d5514749e$var$primeCache[hex] = error;
        return error;
    }
    if (!$8911d62d5514749e$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($8911d62d5514749e$var$TWENTYFOUR).cmp($8911d62d5514749e$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($8911d62d5514749e$var$TEN);
            if (rem.cmp($8911d62d5514749e$var$THREE) && rem.cmp($8911d62d5514749e$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $8911d62d5514749e$var$primeCache[hex] = error;
    return error;
}
function $8911d62d5514749e$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $5vmVB(prime);
    this._prime = $5vmVB.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $8911d62d5514749e$var$setPublicKey;
        this.setPrivateKey = $8911d62d5514749e$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($8911d62d5514749e$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $8911d62d5514749e$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$8911d62d5514749e$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $5vmVB($hkN9y(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$8911d62d5514749e$var$DH.prototype.computeSecret = function(other) {
    other = new $5vmVB(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $8911d62d5514749e$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $8911d62d5514749e$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $8911d62d5514749e$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$8911d62d5514749e$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._pub, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._priv, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrime = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this.__prime, enc);
};
$8911d62d5514749e$var$DH.prototype.getGenerator = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._gen, enc);
};
$8911d62d5514749e$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$8911d62d5514749e$require$Buffer.isBuffer(gen)) gen = new $8911d62d5514749e$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $5vmVB(gen);
    return this;
};
function $8911d62d5514749e$var$formatReturnValue(bn, enc) {
    var buf = new $8911d62d5514749e$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}


function $4387b1fafb8a1868$var$getDiffieHellman(mod) {
    var prime = new $4387b1fafb8a1868$require$Buffer($f0f71b0d846b32d7$exports[mod].prime, 'hex');
    var gen = new $4387b1fafb8a1868$require$Buffer($f0f71b0d846b32d7$exports[mod].gen, 'hex');
    return new $8911d62d5514749e$exports(prime, gen);
}
var $4387b1fafb8a1868$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $4387b1fafb8a1868$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($4387b1fafb8a1868$require$Buffer.isBuffer(enc) || $4387b1fafb8a1868$var$ENCODINGS[enc] === undefined) return $4387b1fafb8a1868$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $4387b1fafb8a1868$require$Buffer([
        2
    ]);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(generator)) generator = new $4387b1fafb8a1868$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $8911d62d5514749e$exports($7f34ba2fa9025258$exports(prime, generator), generator, true);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(prime)) prime = new $4387b1fafb8a1868$require$Buffer(prime, enc);
    return new $8911d62d5514749e$exports(prime, generator, true);
}
$4387b1fafb8a1868$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$fdc27893e98845cc = $4387b1fafb8a1868$var$getDiffieHellman;
$4387b1fafb8a1868$export$6671fb9a1323bed = $4387b1fafb8a1868$export$d74daf141a551db = $4387b1fafb8a1868$var$createDiffieHellman;


$44edd02a6be448cd$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$971862a2fcb1bb40;
$44edd02a6be448cd$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
$44edd02a6be448cd$export$fdc27893e98845cc = $4387b1fafb8a1868$export$fdc27893e98845cc;
$44edd02a6be448cd$export$6671fb9a1323bed = $4387b1fafb8a1868$export$6671fb9a1323bed;
$44edd02a6be448cd$export$d74daf141a551db = $4387b1fafb8a1868$export$d74daf141a551db;
var $3550302076d9e62e$exports = {};
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $3550302076d9e62e$require$Buffer = $1U9GM.Buffer;

var $1R2J7 = parcelRequire("1R2J7");

var $b6RFW = parcelRequire("b6RFW");

var $dlqwk = parcelRequire("dlqwk");
var $4d6db7c28d99f640$exports = {};
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $4d6db7c28d99f640$require$Buffer = $1U9GM.Buffer;

var $1iL1D = parcelRequire("1iL1D");

var $3Sg1O = parcelRequire("3Sg1O");

var $1zUcV = parcelRequire("1zUcV");
var $4d6db7c28d99f640$require$EC = $1zUcV.ec;

var $dEXSZ = parcelRequire("dEXSZ");

var $aNeDF = parcelRequire("aNeDF");
var $7fcf61ce5a538063$exports = {};
$7fcf61ce5a538063$exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");


var $4d6db7c28d99f640$var$RSA_PKCS1_PADDING = 1;
function $4d6db7c28d99f640$var$sign(hash, key, hashType, signType, tag) {
    var priv = $aNeDF(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $4d6db7c28d99f640$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $4d6db7c28d99f640$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $4d6db7c28d99f640$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $4d6db7c28d99f640$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $3Sg1O(pad, priv);
    return out;
}
function $4d6db7c28d99f640$var$ecSign(hash, priv) {
    var curveId = $7fcf61ce5a538063$exports[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $4d6db7c28d99f640$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $4d6db7c28d99f640$require$Buffer.from(out.toDER());
}
function $4d6db7c28d99f640$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $dEXSZ(0);
    var k;
    var H = $4d6db7c28d99f640$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $4d6db7c28d99f640$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $4d6db7c28d99f640$var$makeKey(q, kv, algo);
        r = $4d6db7c28d99f640$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $dEXSZ(0);
        }
    }
    return $4d6db7c28d99f640$var$toDER(r, s);
}
function $4d6db7c28d99f640$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $4d6db7c28d99f640$require$Buffer.from(res);
}
function $4d6db7c28d99f640$var$getKey(x, q, hash, algo) {
    x = $4d6db7c28d99f640$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - x.length);
        x = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $4d6db7c28d99f640$var$bits2octets(hash, q);
    var v = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $4d6db7c28d99f640$var$bits2int(obits, q) {
    var bits = new $dEXSZ(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $4d6db7c28d99f640$var$bits2octets(bits, q) {
    bits = $4d6db7c28d99f640$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $4d6db7c28d99f640$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - out.length);
        out = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $4d6db7c28d99f640$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $4d6db7c28d99f640$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
            t = $4d6db7c28d99f640$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $4d6db7c28d99f640$var$bits2int(t, q);
        kv.k = $1iL1D(algo, kv.k).update(kv.v).update($4d6db7c28d99f640$require$Buffer.from([
            0
        ])).digest();
        kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $4d6db7c28d99f640$var$makeR(g, k, p, q) {
    return g.toRed($dEXSZ.mont(p)).redPow(k).fromRed().mod(q);
}
$4d6db7c28d99f640$exports = $4d6db7c28d99f640$var$sign;
$4d6db7c28d99f640$exports.getKey = $4d6db7c28d99f640$var$getKey;
$4d6db7c28d99f640$exports.makeKey = $4d6db7c28d99f640$var$makeKey;


var $b885ed4272d45f84$exports = {};
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $b885ed4272d45f84$require$Buffer = $1U9GM.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $1zUcV = parcelRequire("1zUcV");
var $b885ed4272d45f84$require$EC = $1zUcV.ec;

var $aNeDF = parcelRequire("aNeDF");

function $b885ed4272d45f84$var$verify(sig, hash, key, signType, tag) {
    var pub = $aNeDF(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $b885ed4272d45f84$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $b885ed4272d45f84$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $b885ed4272d45f84$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $b885ed4272d45f84$require$Buffer.from(pad);
    var red = $dEXSZ.mont(pub.modulus);
    sig = new $dEXSZ(sig).toRed(red);
    sig = sig.redPow(new $dEXSZ(pub.publicExponent));
    sig = $b885ed4272d45f84$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $b885ed4272d45f84$var$ecVerify(sig, hash, pub) {
    var curveId = $7fcf61ce5a538063$exports[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $b885ed4272d45f84$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $b885ed4272d45f84$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $aNeDF.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $b885ed4272d45f84$var$checkValue(s, q);
    $b885ed4272d45f84$var$checkValue(r, q);
    var montp = $dEXSZ.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $dEXSZ(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $b885ed4272d45f84$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
$b885ed4272d45f84$exports = $b885ed4272d45f84$var$verify;



var $6swAi = parcelRequire("6swAi");
Object.keys($6swAi).forEach(function(key) {
    $6swAi[key].id = $3550302076d9e62e$require$Buffer.from($6swAi[key].id, 'hex');
    $6swAi[key.toLowerCase()] = $6swAi[key];
});
function $3550302076d9e62e$var$Sign(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Sign, $b6RFW.Writable);
$3550302076d9e62e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $4d6db7c28d99f640$exports(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $3550302076d9e62e$var$Verify(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Verify, $b6RFW.Writable);
$3550302076d9e62e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $3550302076d9e62e$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $b885ed4272d45f84$exports(sigBuffer, hash, key, this._signType, this._tag);
};
function $3550302076d9e62e$var$createSign(algorithm) {
    return new $3550302076d9e62e$var$Sign(algorithm);
}
function $3550302076d9e62e$var$createVerify(algorithm) {
    return new $3550302076d9e62e$var$Verify(algorithm);
}
$3550302076d9e62e$exports = {
    Sign: $3550302076d9e62e$var$createSign,
    Verify: $3550302076d9e62e$var$createVerify,
    createSign: $3550302076d9e62e$var$createSign,
    createVerify: $3550302076d9e62e$var$createVerify
};


$44edd02a6be448cd$export$45df7cae684751af = $3550302076d9e62e$exports.createSign;
$44edd02a6be448cd$export$1db683ad541682f6 = $3550302076d9e62e$exports.Sign;
$44edd02a6be448cd$export$6f65485f87568e37 = $3550302076d9e62e$exports.createVerify;
$44edd02a6be448cd$export$91a8e56769aeb334 = $3550302076d9e62e$exports.Verify;

$44edd02a6be448cd$export$2d4117e99c2179e4 = (parcelRequire("fd3gh"));
var $b7e0a6843ffae451$export$512823e338ddb1b7;
var $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
var $b7e0a6843ffae451$export$b9d55ff329113abd;

$b7e0a6843ffae451$export$512823e338ddb1b7 = (parcelRequire("98aLY"));

$b7e0a6843ffae451$export$7efb24e2fddf99b9 = (parcelRequire("jU8t7"));
$b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $b7e0a6843ffae451$export$512823e338ddb1b7(key, buf, true);
};
$b7e0a6843ffae451$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $b7e0a6843ffae451$export$7efb24e2fddf99b9(key, buf, true);
};


$44edd02a6be448cd$export$512823e338ddb1b7 = $b7e0a6843ffae451$export$512823e338ddb1b7;
$44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
$44edd02a6be448cd$export$b9d55ff329113abd = $b7e0a6843ffae451$export$b9d55ff329113abd;
$44edd02a6be448cd$export$7efb24e2fddf99b9 = $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
var $8c5943302864e9a5$export$2f7171e78e524d5e;

var $hPtJY = parcelRequire("hPtJY");
'use strict';
function $8c5943302864e9a5$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $1U9GM = parcelRequire("1U9GM");

var $hkN9y = parcelRequire("hkN9y");
var $8c5943302864e9a5$var$Buffer = $1U9GM.Buffer;
var $8c5943302864e9a5$var$kBufferMaxLength = $1U9GM.kMaxLength;
var $8c5943302864e9a5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $8c5943302864e9a5$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $8c5943302864e9a5$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $8c5943302864e9a5$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $8c5943302864e9a5$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $8c5943302864e9a5$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $8c5943302864e9a5$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $8c5943302864e9a5$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($8c5943302864e9a5$var$crypto && $8c5943302864e9a5$var$crypto.getRandomValues || false) {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$randomFill;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$randomFillSync;
} else {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$oldBrowser;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$oldBrowser;
}
function $8c5943302864e9a5$var$randomFill(buf, offset, size, cb) {
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size, cb);
}
function $8c5943302864e9a5$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $8c5943302864e9a5$var$crypto.getRandomValues(uint);
    if (cb) {
        $hPtJY.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $hkN9y(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $hkN9y(size);
    bytes.copy(buf, offset);
    return buf;
}
function $8c5943302864e9a5$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size);
}


$44edd02a6be448cd$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
$44edd02a6be448cd$export$2f7171e78e524d5e = $8c5943302864e9a5$export$2f7171e78e524d5e;
$44edd02a6be448cd$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$44edd02a6be448cd$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};



var $eVPL0 = parcelRequire("eVPL0");


const $38df349e245b274e$export$b56467c8644db4b4 = (endpoint, auth)=>{
    const authorization = (url, method, body)=>{
        const message = method + url.pathname + url.search + (0, $44edd02a6be448cd$export$2fb37efbf6ae0c0e)('md5').update(body).digest('hex');
        return 'GWS ' + auth.token + ':' + (0, $44edd02a6be448cd$export$da39cf97e1eb7c91)('sha1', auth.secret).update(message).digest('hex');
    };
    const requestRaw = (path, method, data)=>{
        const body = data === undefined || method === 'GET' ? undefined : JSON.stringify(data);
        const url = new URL(endpoint + '/' + path);
        return (0, $d61b813a8b093ee0$export$14cc81df70b6707e)(method, url.toString(), {
            Authorization: authorization(url, method, body || ''),
            'Content-Type': 'application/json;charset=utf-8'
        }, body).then((0, $128066113e324b22$export$50eef411b4a58360));
    };
    const request = (dec)=>(path, method, data)=>requestRaw(path, method, data).then((resp)=>(0, $eVPL0.match)((failures)=>Promise.reject({
                        error: 'JSON decode failure',
                        response: resp,
                        failures: failures
                    }), (good)=>Promise.resolve(good))(dec.decode(resp))).catch((e)=>Promise.reject({
                    error: 'Request error',
                    response: e
                }));
    return {
        requestRaw: requestRaw,
        request: request
    };
};


const $760befdd4fcb9e56$export$31d5215e225c155b = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Tier: (0, $87701c398fec8638$export$22b082955e083ec3),
    Install: (0, $87701c398fec8638$export$bf9fb029d174d554)({
        Delivery: (0, $87701c398fec8638$export$bf9fb029d174d554)({
            Kind: (0, $87701c398fec8638$export$22b082955e083ec3)
        }),
        Labor: (0, $87701c398fec8638$export$bf9fb029d174d554)({
            Provider: (0, $87701c398fec8638$export$22b082955e083ec3)
        }),
        Measure: (0, $87701c398fec8638$export$bf9fb029d174d554)({
            Provider: (0, $87701c398fec8638$export$22b082955e083ec3)
        }),
        Install: (0, $87701c398fec8638$export$bf9fb029d174d554)({
            Provider: (0, $87701c398fec8638$export$22b082955e083ec3)
        })
    }),
    Rules: (0, $87701c398fec8638$export$bf9fb029d174d554)({
        Org: (0, $87701c398fec8638$export$22b082955e083ec3)
    })
});
const $760befdd4fcb9e56$var$BulkDesignMessage = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('QUOTE'),
        (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('BULK_DESIGN'),
        (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('INIT_AUTH'),
        (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('SETTINGS')
    ]),
    data: (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        (0, $cefda0850953082d$export$82b8d343c504672),
        (0, $6a661e14ba33ee64$export$ade3ab6aaaec74c7)((0, $87701c398fec8638$export$19282c40b967aec6)),
        (0, $fb517bfb22ffdf52$export$b95309641e3cb54f),
        $760befdd4fcb9e56$export$31d5215e225c155b
    ])
});
const $760befdd4fcb9e56$var$EmbedBulkDesignPage = ({ config: config })=>{
    const [req, setReq] = (0, $acw62.useState)(undefined);
    const bulkDesignRef = (0, $acw62.useRef)(null);
    const handleMessage = (0, $acw62.useCallback)(({ data: data })=>{
        console.log('Bulk Design message ', data);
        if (data.type === 'INIT_AUTH') {
            const auth = data.data;
            if ((0, $fb517bfb22ffdf52$export$e6c26dc59f3b265a)(auth) && config) setReq((0, $38df349e245b274e$export$b56467c8644db4b4)(config.SilicaEndpoint, auth));
        } else if (data.type === 'QUOTE') {
            if (bulkDesignRef.current) bulkDesignRef.current.updateQuote(data.data);
        } else if (data.type === 'BULK_DESIGN') // Do something here.
        {
            if (bulkDesignRef.current) bulkDesignRef.current.updateTreeData(data.data);
        } else if (data.type === 'SETTINGS') // Do something here.
        {
            if (bulkDesignRef.current) bulkDesignRef.current.updateSettings(data.data);
        }
    }, [
        config
    ]);
    (0, $f64a1d08d63e25a2$export$414e41559af5a852)($760befdd4fcb9e56$var$BulkDesignMessage, handleMessage);
    const onQuoteChange = (0, $acw62.useCallback)((quote)=>{
        const payload = {
            type: 'Save-Quote',
            data: quote
        };
        if (window.top) window.top.postMessage(payload, '*');
        else if (window.parent) window.parent.postMessage(payload, '*');
    }, []);
    const onTreeDataChange = (0, $acw62.useCallback)((tree)=>{
        const payload = {
            type: 'Save-Bulk-Design',
            data: tree
        };
        if (window.top) window.top.postMessage(payload, '*');
        else if (window.parent) window.parent.postMessage(payload, '*');
    }, []);
    const onSaveChange = (0, $acw62.useCallback)((tree, quote)=>{
        const payload = {
            type: 'Save-CE',
            data: {
                tree: tree,
                quote: quote
            }
        };
        if (window.top) window.top.postMessage(payload, '*');
        else if (window.parent) window.parent.postMessage(payload, '*');
    }, []);
    const onCancel = (0, $acw62.useCallback)(()=>{
        // Do something here.
        const payload = {
            type: 'No-Save-CE'
        };
        if (window.top) window.top.postMessage(payload, '*');
        else if (window.parent) window.parent.postMessage(payload, '*');
    }, []);
    if (req) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "embed-bulk-design",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cd2e90947afb30b$export$2e2bcd8739ae039), {
            ref: bulkDesignRef,
            req: req,
            onQuoteChange: onQuoteChange,
            onTreeDataChange: onTreeDataChange,
            onSaveChange: onSaveChange,
            onCancel: onCancel
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: " Loading\u2026 "
    });
};
var $760befdd4fcb9e56$export$2e2bcd8739ae039 = $760befdd4fcb9e56$var$EmbedBulkDesignPage;



var $ayMG0 = parcelRequire("ayMG0");





















const $780b62615ddd415c$export$4b53a017d8039437 = (0, $87701c398fec8638$export$e45945969df8035a)({
    Visible: (0, $87701c398fec8638$export$4a21f16c33752377),
    ShowBar: (0, $87701c398fec8638$export$4a21f16c33752377),
    BarStyle: (0, $5c00e45590ca51c5$export$5d24e00cfde59887),
    ShowWhisker: (0, $87701c398fec8638$export$4a21f16c33752377),
    ExtendWhisker: (0, $87701c398fec8638$export$4a21f16c33752377),
    WhiskerStyle: (0, $5c00e45590ca51c5$export$5d24e00cfde59887),
    Layer: (0, $87701c398fec8638$export$98e628dec113755e),
    ShowLabel: (0, $87701c398fec8638$export$4a21f16c33752377),
    LabelLayer: (0, $87701c398fec8638$export$98e628dec113755e),
    LabelOrient: (0, $5c00e45590ca51c5$export$c3631f4566dc90f7),
    LabelPrefix: (0, $87701c398fec8638$export$22b082955e083ec3)
});
const $780b62615ddd415c$export$61dcc3651be14bfd = (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('Visible');
const $780b62615ddd415c$export$640e4747de4ee1f0 = (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('ExtendWhisker');
const $780b62615ddd415c$export$c78f2b5737b368ae = (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('Layer');
const $780b62615ddd415c$export$ca3dc64840c7f233 = (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('LabelLayer');
const $780b62615ddd415c$export$82dfdf46bc9d3607 = ()=>({});
const $780b62615ddd415c$export$fde5da16aaf01639 = (rim)=>(ri)=>({
            Visible: rim.Visible ?? ri.Visible,
            ShowBar: rim.ShowBar ?? ri.ShowBar,
            BarStyle: rim.BarStyle ?? ri.BarStyle,
            ShowWhisker: rim.ShowWhisker ?? ri.ShowWhisker,
            ExtendWhisker: rim.ExtendWhisker ?? ri.ExtendWhisker,
            WhiskerStyle: rim.WhiskerStyle ?? ri.WhiskerStyle,
            Layer: rim.Layer ?? ri.Layer,
            ShowLabel: rim.ShowLabel ?? ri.ShowLabel,
            LabelLayer: rim.LabelLayer ?? ri.LabelLayer,
            LabelOrient: rim.LabelOrient ?? ri.LabelOrient,
            LabelPrefix: rim.LabelPrefix ?? ri.LabelPrefix
        });



const $3e7de8e277eb6256$export$db5d9123c8a8b66b = (0, $87701c398fec8638$export$e45945969df8035a)({
    Info: (0, $780b62615ddd415c$export$4b53a017d8039437),
    Class: (0, $8af43a568842d8c3$export$d8deaab87a4e223a)((0, $87701c398fec8638$export$22b082955e083ec3)),
    Guide: (0, $ec695bb278cff147$export$56c0d5a1e737357d)((0, $d99ec1e84f6a18d9$export$d2aa6c54a5925f01)),
    Unit: (0, $87701c398fec8638$export$22b082955e083ec3),
    Value: (0, $87701c398fec8638$export$98e628dec113755e)
});
const $3e7de8e277eb6256$export$10cce82e20896ff1 = ()=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('Info'), (0, $58f80d7b57eba59b$export$36faa878fcded3d7)({}));
const $3e7de8e277eb6256$export$373bc6d48cf04761 = ()=>(0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('Class');
const $3e7de8e277eb6256$export$77608f7f5bafc39 = ()=>(0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('Unit');
const $3e7de8e277eb6256$export$67a367a7a8ad8f19 = ()=>(0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('Value');
const $3e7de8e277eb6256$export$ef1e5e37d1332d36 = ()=>({});
const $3e7de8e277eb6256$export$fa3762b2ac8671c4 = (mod)=>(val)=>({
            ...val,
            Info: mod.Info ? (0, $780b62615ddd415c$export$fde5da16aaf01639)(mod.Info)(val.Info) : val.Info,
            Class: mod.Class ?? val.Class,
            Guide: mod.Guide ?? val.Guide,
            Unit: mod.Unit ?? val.Unit,
            Value: mod.Value ?? val.Value
        });


const $3cad0932f8cf18b6$export$8972d2fce564e8d = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    Rulers: (0, $87701c398fec8638$export$e5185e241753e543)((0, $87701c398fec8638$export$22b082955e083ec3), (0, $3e7de8e277eb6256$export$db5d9123c8a8b66b))
});
const $3cad0932f8cf18b6$export$83fbf29b47f8813 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('Rulers');
const $3cad0932f8cf18b6$export$332e01febdc2accd = (rid)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($3cad0932f8cf18b6$export$83fbf29b47f8813, (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)(rid));
const $3cad0932f8cf18b6$export$27d363941855c5ab = (modA)=>(modB)=>{
        if (Object.getOwnPropertyNames(modB).length === 0) return modA;
        if (Object.getOwnPropertyNames(modA).length === 0) return modB;
        return $3cad0932f8cf18b6$export$83fbf29b47f8813((rs)=>({
                ...rs,
                ...modB.Rulers
            }))(modA);
    };
const $3cad0932f8cf18b6$export$52146bc489a12acd = {
    Rulers: {}
};
const $3cad0932f8cf18b6$export$113c6a12ae7bc40c = (mod)=>(val)=>({
            Kind: val.Kind,
            Pieces: val.Pieces.map(({ Rulers: Rulers, ...rest })=>({
                    ...rest,
                    Rulers: Rulers.map((ruler)=>{
                        const rmod = mod.Rulers[ruler.Id.join('-')];
                        return !rmod ? ruler : (0, $3e7de8e277eb6256$export$fa3762b2ac8671c4)(rmod)(ruler);
                    })
                }))
        });





const $6274183b067bff81$export$1b0303c6f4242240 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('pan');
const $6274183b067bff81$export$ee4c6ea405e707df = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('zoom');
const $6274183b067bff81$export$462a214a574addce = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('ctrd');
const $6274183b067bff81$export$63b920625b048d27 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('angle');
const $6274183b067bff81$export$6642aa73cf724e55 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('tweaks');
const $6274183b067bff81$export$1b1311167699cd73 = {
    pan: [
        0,
        0
    ],
    zoom: 1,
    ctrd: true,
    angle: 0,
    tweaks: (0, $3cad0932f8cf18b6$export$52146bc489a12acd)
};
const $6274183b067bff81$export$29cd7b75162a9425 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    editable: (0, $87701c398fec8638$export$4a21f16c33752377)
});
const $6274183b067bff81$export$4f9756682a863729 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('editable');
const $6274183b067bff81$export$7a38ef5dd3c31952 = {
    editable: false
};
const $6274183b067bff81$export$346677f925de839c = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('size');
const $6274183b067bff81$export$991dc94f816a1d48 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('figure');
const $6274183b067bff81$export$65273456778032a7 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('tweaks');
const $6274183b067bff81$export$89da14300d534261 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('active');
const $6274183b067bff81$export$e506a1d27d1eaa20 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('config');
const $6274183b067bff81$export$27f56930b0fd4e2 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('pieces');
const $6274183b067bff81$export$bf8821bf3a16b79 = (index)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($6274183b067bff81$export$27f56930b0fd4e2, (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)(index), (0, $58f80d7b57eba59b$export$36faa878fcded3d7)($6274183b067bff81$export$1b1311167699cd73));
const $6274183b067bff81$export$487c9f1cf8b996b0 = (active)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($6274183b067bff81$export$27f56930b0fd4e2, (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)(active), (0, $58f80d7b57eba59b$export$36faa878fcded3d7)($6274183b067bff81$export$1b1311167699cd73));
const $6274183b067bff81$export$1dd1015504849fc0 = (f)=>(s)=>{
        const opiece = (0, $58f80d7b57eba59b$export$43f5536de9872e14)($6274183b067bff81$export$487c9f1cf8b996b0(s.active))(s);
        const npiece = f(opiece);
        if (opiece === npiece) return s;
        return (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)($6274183b067bff81$export$487c9f1cf8b996b0(s.active))(npiece)(s);
    };
const $6274183b067bff81$export$2ec97e70e20fb49 = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($6274183b067bff81$export$1dd1015504849fc0, $6274183b067bff81$export$6642aa73cf724e55);
const $6274183b067bff81$export$92fbeba6bb0455fb = (state)=>Object.getOwnPropertyNames(state.pieces).map((prop)=>{
        const piece = state.pieces[prop];
        return !piece ? {
            Rulers: {}
        } : piece.tweaks;
    }).reduce((acc, curr)=>(0, $3cad0932f8cf18b6$export$27d363941855c5ab)(acc)(curr), state.tweaks);
const $6274183b067bff81$export$4c486572e961a974 = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($6274183b067bff81$export$1dd1015504849fc0, $6274183b067bff81$export$1b0303c6f4242240);
const $6274183b067bff81$export$e83f174dbf56adcc = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($6274183b067bff81$export$1dd1015504849fc0, $6274183b067bff81$export$ee4c6ea405e707df);
const $6274183b067bff81$export$633dd8fe5e013f07 = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($6274183b067bff81$export$1dd1015504849fc0, $6274183b067bff81$export$462a214a574addce);
const $6274183b067bff81$export$944b09d2ad10b378 = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($6274183b067bff81$export$1dd1015504849fc0, $6274183b067bff81$export$63b920625b048d27);
const $6274183b067bff81$export$6eb075c0109f040f = (rid)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($6274183b067bff81$export$2ec97e70e20fb49, (0, $3cad0932f8cf18b6$export$332e01febdc2accd)(rid.join('-')), (0, $58f80d7b57eba59b$export$36faa878fcded3d7)({}), (0, $3e7de8e277eb6256$export$10cce82e20896ff1)(), (0, $780b62615ddd415c$export$c78f2b5737b368ae));
const $6274183b067bff81$export$ac8a24a42be5bf71 = (rid)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($6274183b067bff81$export$2ec97e70e20fb49, (0, $3cad0932f8cf18b6$export$332e01febdc2accd)(rid.join('-')), (0, $58f80d7b57eba59b$export$36faa878fcded3d7)({}), (0, $3e7de8e277eb6256$export$10cce82e20896ff1)(), (0, $780b62615ddd415c$export$ca3dc64840c7f233));
const $6274183b067bff81$export$345bcac8b1ee40ea = (figure)=>({
        size: {
            w: 0,
            h: 0
        },
        figure: figure,
        tweaks: {
            Rulers: {}
        },
        pieces: {},
        active: '0',
        config: $6274183b067bff81$export$7a38ef5dd3c31952
    });
const $6274183b067bff81$export$17ce5513f83d414a = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((pan)=>(pnt)=>$ec695bb278cff147$export$e16d8520af44a096(pnt)($d99ec1e84f6a18d9$export$dcdf75081b88279d(-1)(pan)));
const $6274183b067bff81$export$9f00b5d34e5bfb8b = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((zoom)=>(pnt)=>$ec695bb278cff147$export$871de8747c9eaa88($d99ec1e84f6a18d9$export$348a0786643311f(1 / zoom))(pnt));
const $6274183b067bff81$export$2b99bb23a814f78e = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((pan)=>(0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((zoom)=>(pnt)=>$6274183b067bff81$export$17ce5513f83d414a(pan)($6274183b067bff81$export$9f00b5d34e5bfb8b(zoom)(pnt))));
const $6274183b067bff81$export$9dcec4428117750e = (0, $d9f4ffa0bf773b73$export$e8308fa57e490f0c)((a)=>(p)=>$ec695bb278cff147$export$9da38d06ceaaa3a0($ec695bb278cff147$export$871de8747c9eaa88($d99ec1e84f6a18d9$export$fdba22b8ad836e3a(a))(p)));
const $6274183b067bff81$export$f4348e32a399a3d5 = (state)=>state.figure.Pieces.map((piece, index)=>({
            name: piece.Title,
            page: String(index)
        }));




const $2c2d04dd32bcf067$export$3481c78889e8fbe8 = {
    tag: 'Center'
};
const $2c2d04dd32bcf067$export$4961127515ac14d9 = {
    tag: 'Center',
    all: true
};
const $2c2d04dd32bcf067$export$98079bf9b17d85bc = (state, { all: all })=>{
    const { w: w, h: h } = state.size;
    const project = (0, $6274183b067bff81$export$9dcec4428117750e)(0);
    if (w <= 0 || h <= 0) return state;
    return state.figure.Pieces.map((pce, idx)=>({
            pce: pce,
            idx: idx
        })).filter(({ idx: idx })=>{
        return all || String(idx) === state.active;
    }).map(({ pce: pce, idx: idx })=>{
        const piece = (0, $6274183b067bff81$export$bf8821bf3a16b79)(String(idx));
        const [min, max] = (0, $6dc4c4b5427dac73$export$36b2803fc594e30e)(pce).map(project);
        const [fgw, fgh] = $d99ec1e84f6a18d9$export$f93b5905241a7cca(max)(min);
        const margin = 50;
        const factor = Math.min((w - 2 * margin) / Math.abs(fgw), (h - 2 * margin) / Math.abs(fgh));
        const newZoom = factor;
        const sizeFig = [
            fgw,
            fgh
        ];
        const sizeSvg = [
            w,
            h
        ];
        const cptFig = $d99ec1e84f6a18d9$export$e16d8520af44a096(min)($d99ec1e84f6a18d9$export$dcdf75081b88279d(0.5)(sizeFig));
        const cptSvg = $d99ec1e84f6a18d9$export$dcdf75081b88279d(1 / newZoom)($d99ec1e84f6a18d9$export$dcdf75081b88279d(0.25)(sizeSvg));
        const newPan = $d99ec1e84f6a18d9$export$e16d8520af44a096(cptSvg)($d99ec1e84f6a18d9$export$f93b5905241a7cca(cptSvg)(cptFig));
        return (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(piece, (0, $6274183b067bff81$export$462a214a574addce)))(true), (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(piece, (0, $6274183b067bff81$export$1b0303c6f4242240)))(newPan), (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(piece, (0, $6274183b067bff81$export$ee4c6ea405e707df)))(newZoom), (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(piece, (0, $6274183b067bff81$export$63b920625b048d27)))(0));
    }).reduce((mod, cur)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(mod, cur), (s)=>s)(state);
};



const $f3625624ed8c0778$export$8d21e34596265fa2 = (con)=>({
        tag: 'Configure',
        con: con
    });
const $f3625624ed8c0778$export$c952d17c09a2c0ac = (state, con)=>(0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)($6274183b067bff81$export$e506a1d27d1eaa20)(con.con)(state);





const $54c5b04e33a5e872$export$9950874ef1c96274 = (rid)=>(fig)=>fig.Pieces.flatMap((pce)=>pce.Rulers.filter((rlr)=>rlr.Id === rid))[0];



const $ef72ad5d02c8e2ae$export$625f20b4af0c76ea = (rid, pnt)=>({
        tag: 'MoveRuler',
        rid: rid,
        pnt: pnt
    });
const $ef72ad5d02c8e2ae$export$bf99df96bfc2dd82 = (state, cmd)=>{
    const zoom = (0, $58f80d7b57eba59b$export$43f5536de9872e14)($6274183b067bff81$export$e83f174dbf56adcc)(state);
    const ruler = (0, $54c5b04e33a5e872$export$9950874ef1c96274)(cmd.rid)(state.figure);
    const project = $6274183b067bff81$export$9dcec4428117750e((0, $58f80d7b57eba59b$export$43f5536de9872e14)($6274183b067bff81$export$944b09d2ad10b378)(state));
    const normalize = $6274183b067bff81$export$2b99bb23a814f78e((0, $58f80d7b57eba59b$export$43f5536de9872e14)($6274183b067bff81$export$4c486572e961a974)(state))(zoom);
    if (!ruler) return state;
    const layer_offset = project($ec695bb278cff147$export$ffb5f4729a158638((0, $ca3259999c4aeb4d$export$9fddb9d0dd7d8a54)(32 / zoom)(ruler)));
    const left = project(ruler.For.Left);
    const target = normalize($ec695bb278cff147$export$ffb5f4729a158638(cmd.pnt));
    const layers = $d99ec1e84f6a18d9$export$d86cdf75d7fb74e5($d99ec1e84f6a18d9$export$f93b5905241a7cca(target)(left))(layer_offset);
    return (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)($6274183b067bff81$export$6eb075c0109f040f(cmd.rid))(layers)(state);
};







const $02881ae7c2d4f523$export$68e6008f32a07315 = (rid, pnt)=>({
        tag: 'MoveRulerLabel',
        rid: rid,
        pnt: pnt
    });
const $02881ae7c2d4f523$export$9862ffcc33b6cbfc = (state, cmd)=>{
    const zoom = (0, $58f80d7b57eba59b$export$43f5536de9872e14)($6274183b067bff81$export$e83f174dbf56adcc)(state);
    const ruler = (0, $54c5b04e33a5e872$export$9950874ef1c96274)(cmd.rid)(state.figure);
    const project = $6274183b067bff81$export$9dcec4428117750e((0, $58f80d7b57eba59b$export$43f5536de9872e14)($6274183b067bff81$export$944b09d2ad10b378)(state));
    const normalize = $6274183b067bff81$export$2b99bb23a814f78e((0, $58f80d7b57eba59b$export$43f5536de9872e14)($6274183b067bff81$export$4c486572e961a974)(state))(zoom);
    if (!ruler) return state;
    const dir_v = (0, $ca3259999c4aeb4d$export$9fddb9d0dd7d8a54)(32 / zoom)(ruler);
    const layer_offset = project($ec695bb278cff147$export$ffb5f4729a158638(dir_v));
    const left = project(ruler.For.Left);
    const target = normalize($ec695bb278cff147$export$ffb5f4729a158638(cmd.pnt));
    const layers = $d99ec1e84f6a18d9$export$d86cdf75d7fb74e5($d99ec1e84f6a18d9$export$f93b5905241a7cca(target)(left))(layer_offset);
    const ruler_layer = (0, $58f80d7b57eba59b$export$43f5536de9872e14)($6274183b067bff81$export$6eb075c0109f040f(cmd.rid))(state) ?? 0;
    return (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)($6274183b067bff81$export$ac8a24a42be5bf71(cmd.rid))(layers - ruler_layer)(state);
};






const $db1f7ae17fe4e255$export$4c486572e961a974 = (val, set)=>({
        tag: 'Pan',
        set: set ?? false,
        val: val
    });
const $db1f7ae17fe4e255$export$3cb97ef24de37629 = (state, cmd)=>{
    const delZoom = $6274183b067bff81$export$9f00b5d34e5bfb8b((0, $58f80d7b57eba59b$export$43f5536de9872e14)($6274183b067bff81$export$e83f174dbf56adcc)(state));
    return (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($6274183b067bff81$export$633dd8fe5e013f07((0, $78df2dbbf84a78b3$export$c983f826f44ff86)(false)), $6274183b067bff81$export$4c486572e961a974((pan)=>cmd.set ? cmd.val : $d99ec1e84f6a18d9$export$69bce51179ae0936(delZoom((0, $ec695bb278cff147$export$ffb5f4729a158638)(cmd.val)))(pan)))(state);
};



const $002dcb2e58e75863$export$bb628a54ab399bc9 = (val, pnt, set)=>({
        tag: 'Rotate',
        set: set ?? false,
        val: val,
        pnt: pnt
    });
const $002dcb2e58e75863$export$f80ce455de0815f5 = (state, cmd)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $6274183b067bff81$export$633dd8fe5e013f07)((0, $78df2dbbf84a78b3$export$c983f826f44ff86)(false)), (0, $6274183b067bff81$export$944b09d2ad10b378)((ang)=>cmd.set ? cmd.val : ang + cmd.val))(state);


const $95b6ced072457fd7$export$d646c0fa88385aa0 = (val)=>({
        tag: 'SetActive',
        val: val
    });
const $95b6ced072457fd7$export$86f99e10b2aae8aa = (state, cmd)=>(0, $6274183b067bff81$export$89da14300d534261)((_)=>cmd.val)(state);


const $137e5f09f7ca95a7$export$1c70a6cc12bc0366 = (val)=>({
        tag: 'SetSize',
        val: val
    });
const $137e5f09f7ca95a7$export$c61754ded8de59aa = (state, cmd)=>(0, $6274183b067bff81$export$346677f925de839c)((_)=>cmd.val)(state);

const $1876f312c3f68910$export$42fffed799c298bb = (val)=>({
        tag: 'SetState',
        val: val
    });
const $1876f312c3f68910$export$85b2b3a3cdc6cfaf = (cmd)=>{
    return cmd.val;
};



const $4741bf0fee8d5eea$export$e83f174dbf56adcc = (val, pnt, set)=>({
        tag: 'Zoom',
        set: set ?? false,
        val: val,
        pnt: pnt
    });
const $4741bf0fee8d5eea$export$ca20dcf6dc30f4b2 = (state, cmd)=>{
    if (Math.abs(cmd.val) < 0.1 || Math.abs(cmd.val) > 5) return state;
    return (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($6274183b067bff81$export$633dd8fe5e013f07((0, $78df2dbbf84a78b3$export$c983f826f44ff86)(false)), $6274183b067bff81$export$e83f174dbf56adcc((z)=>z * cmd.val))(state);
};



var $acw62 = parcelRequire("acw62");



const $5fe8acb3e2efeaa8$export$cd9835e9dc0ea669 = {
    tag: 'ResetTweaks'
};
const $5fe8acb3e2efeaa8$export$6540ecf455ae0821 = (state, _)=>(0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $6274183b067bff81$export$2ec97e70e20fb49))((0, $3cad0932f8cf18b6$export$52146bc489a12acd))(state);


const $fbdba84188affd35$export$1650419e431d3ba3 = (s, a)=>{
    if (a.tag == 'SetState') return (0, $1876f312c3f68910$export$85b2b3a3cdc6cfaf)(a);
    if (s == null) return s;
    switch(a.tag){
        case 'Pan':
            return (0, $db1f7ae17fe4e255$export$3cb97ef24de37629)(s, a);
        case 'Zoom':
            return (0, $4741bf0fee8d5eea$export$ca20dcf6dc30f4b2)(s, a);
        case 'Rotate':
            return (0, $002dcb2e58e75863$export$f80ce455de0815f5)(s, a);
        case 'Center':
            return (0, $2c2d04dd32bcf067$export$98079bf9b17d85bc)(s, a);
        case 'SetSize':
            return (0, $137e5f09f7ca95a7$export$c61754ded8de59aa)(s, a);
        case 'Configure':
            return (0, $f3625624ed8c0778$export$c952d17c09a2c0ac)(s, a);
        case 'SetActive':
            return (0, $95b6ced072457fd7$export$86f99e10b2aae8aa)(s, a);
        case 'MoveRuler':
            return (0, $ef72ad5d02c8e2ae$export$bf99df96bfc2dd82)(s, a);
        case 'ResetTweaks':
            return (0, $5fe8acb3e2efeaa8$export$6540ecf455ae0821)(s, a);
        case 'MoveRulerLabel':
            return (0, $02881ae7c2d4f523$export$9862ffcc33b6cbfc)(s, a);
    }
};
const $fbdba84188affd35$export$900e94db7bcea325 = (i)=>{
    const [state, emit] = (0, $acw62.useReducer)($fbdba84188affd35$export$1650419e431d3ba3, i, (x)=>x);
    return {
        emit: emit,
        state: state
    };
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");








const $43a0075edecf551b$export$bd5ddf6d08fd13c8 = (emit)=>(dxy)=>emit($db1f7ae17fe4e255$export$4c486572e961a974(dxy));
const $43a0075edecf551b$export$687f0df2a268f813 = (emit)=>(dzf, pnt)=>emit($4741bf0fee8d5eea$export$e83f174dbf56adcc(dzf, (0, $ec695bb278cff147$export$ffb5f4729a158638)(pnt)));
const $43a0075edecf551b$export$a24ddd6fa9cec915 = (emit)=>(ang, pnt)=>emit($002dcb2e58e75863$export$bb628a54ab399bc9(ang, pnt));
const $43a0075edecf551b$export$1679b117179a9a3 = (emit)=>()=>emit($2c2d04dd32bcf067$export$3481c78889e8fbe8);
const $43a0075edecf551b$export$33a6005babc0d984 = (emit)=>(typ, iid, pnt)=>{
        switch(typ){
            case 'Ruler':
                emit($ef72ad5d02c8e2ae$export$625f20b4af0c76ea(iid, pnt));
                return;
            case 'RulerLabel':
                emit($02881ae7c2d4f523$export$68e6008f32a07315(iid, pnt));
                return;
        }
    };
const $43a0075edecf551b$export$3b5c1f039e330a7d = (active)=>(0, $6dc4c4b5427dac73$export$1e284623f7aabd9b)((ps)=>{
        const index = parseInt(active);
        const piece = ps[index];
        return !piece ? [
            ps[0]
        ] : [
            piece
        ];
    });
const $43a0075edecf551b$export$2ca6212a619576d4 = ({ width: width, height: height, value: value, emit: emit, ...ps })=>{
    const [ref, size] = (0, $7ff8f69a51b0e2ac$export$2e2bcd8739ae039)();
    const pan = (0, $58f80d7b57eba59b$export$43f5536de9872e14)($6274183b067bff81$export$4c486572e961a974)(value);
    const zoom = (0, $58f80d7b57eba59b$export$43f5536de9872e14)($6274183b067bff81$export$e83f174dbf56adcc)(value);
    const ctrd = (0, $58f80d7b57eba59b$export$43f5536de9872e14)($6274183b067bff81$export$633dd8fe5e013f07)(value);
    const angle = (0, $58f80d7b57eba59b$export$43f5536de9872e14)($6274183b067bff81$export$944b09d2ad10b378)(value);
    const config = (0, $58f80d7b57eba59b$export$43f5536de9872e14)($6274183b067bff81$export$e506a1d27d1eaa20)(value);
    const figure = $43a0075edecf551b$export$3b5c1f039e330a7d(value.active)((0, $3cad0932f8cf18b6$export$113c6a12ae7bc40c)((0, $6274183b067bff81$export$92fbeba6bb0455fb)(value))(value.figure));
    const project = (0, $acw62.useCallback)((p)=>$6274183b067bff81$export$9dcec4428117750e(angle)(p), [
        angle
    ]);
    const doPan = (0, $acw62.useCallback)((dxy)=>$43a0075edecf551b$export$bd5ddf6d08fd13c8(emit)(dxy), [
        emit
    ]);
    const doZoom = (0, $acw62.useCallback)((dzf, pnt)=>$43a0075edecf551b$export$687f0df2a268f813(emit)(dzf, pnt), [
        emit
    ]);
    const doRotate = (0, $acw62.useCallback)((ang, pnt)=>$43a0075edecf551b$export$a24ddd6fa9cec915(emit)(ang, pnt), [
        emit
    ]);
    const doCenter = (0, $acw62.useCallback)(()=>$43a0075edecf551b$export$1679b117179a9a3(emit)(), [
        emit
    ]);
    const doItemMove = (0, $acw62.useCallback)((typ, iid, pnt)=>{
        if (config.editable) $43a0075edecf551b$export$33a6005babc0d984(emit)(typ, iid, pnt);
    }, [
        emit,
        config.editable
    ]);
    (0, $acw62.useEffect)(()=>emit($137e5f09f7ca95a7$export$1c70a6cc12bc0366(size)), [
        size,
        emit,
        value.figure
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!ctrd || size.w <= 0 || size.h <= 0) return;
        emit($2c2d04dd32bcf067$export$4961127515ac14d9);
    }, [
        emit,
        size,
        ctrd,
        value.figure
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0b4a7130581cd32f$export$d23d1f3707a268d2), {
        pref: "Figure",
        ref: ref,
        width: width,
        height: height,
        pan: pan,
        zoom: zoom,
        onPan: doPan,
        onZoom: doZoom,
        onCenter: doCenter,
        onRotate: doRotate,
        onItemMove: doItemMove,
        actionables: [
            'Ruler',
            'RulerLabel'
        ],
        children: (hs)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $0b4a7130581cd32f$export$ce7ec243d3bf6f60), {
                proj: project,
                zoom: zoom,
                value: figure,
                ...hs,
                ...ps
            })
    });
};






var $acw62 = parcelRequire("acw62");
const $50ea37e9e9f0a226$export$9babca38b2d995c1 = (emit)=>(e)=>{
        alert('Import failed, check the browser console for details.');
        console.warn(e);
        emit($1876f312c3f68910$export$42fffed799c298bb(null));
    };
const $50ea37e9e9f0a226$export$ad2664c38f706edf = (emit)=>(fig)=>{
        console.log('Imported a figure.');
        emit($1876f312c3f68910$export$42fffed799c298bb((0, $6274183b067bff81$export$345bcac8b1ee40ea)(fig)));
    };
const $50ea37e9e9f0a226$export$9a2e3904f7f47dcb = ()=>{
    const { emit: emit, state: state } = (0, $fbdba84188affd35$export$900e94db7bcea325)(null);
    const importFailure = (0, $acw62.useCallback)((e)=>$50ea37e9e9f0a226$export$9babca38b2d995c1(emit)(e), [
        emit
    ]);
    const importSuccess = (0, $acw62.useCallback)((fig)=>$50ea37e9e9f0a226$export$ad2664c38f706edf(emit)(fig), [
        emit
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "page figure",
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $efbb6eb46c8dd746$export$bfbece8a621a006f), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $437a2d9ce62cfb25$export$2e2bcd8739ae039), {
                    name: "Figure",
                    codec: (0, $6dc4c4b5427dac73$export$820c702ddd5a7343),
                    failure: importFailure,
                    success: importSuccess
                })
            }),
            !state ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $43a0075edecf551b$export$2ca6212a619576d4), {
                emit: emit,
                value: state,
                width: "100%",
                height: "100%",
                angleConverter: (0, $4beeab19e80c1290$export$6e98d19a58527322).exterior,
                lengthConverter: (0, $4beeab19e80c1290$export$d871edfc009fc342)
            })
        ]
    });
};
var $50ea37e9e9f0a226$export$2e2bcd8739ae039 = $50ea37e9e9f0a226$export$9a2e3904f7f47dcb;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");









const $a4972cdb81829546$export$e9f2180374ddf65c = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    tag: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MsgLoadFigure'),
    fig: (0, $6dc4c4b5427dac73$export$820c702ddd5a7343)
});
const $a4972cdb81829546$export$408679386f20bea3 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    tag: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MsgFocusFigure')
});
const $a4972cdb81829546$export$b173e562563f5d67 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    tag: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MsgDownloadFigure')
});
const $a4972cdb81829546$export$7ea1823939ff9bf7 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    tag: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MsgGetPages')
});
const $a4972cdb81829546$export$f673da8d4d77e06e = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    tag: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MsgSetActive'),
    act: (0, $87701c398fec8638$export$22b082955e083ec3)
});
const $a4972cdb81829546$export$f23fb2822868c746 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    tag: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MsgResetTweaks')
});
const $a4972cdb81829546$export$10b05091a68ea6bf = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    tag: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('MsgConfig'),
    con: (0, $6274183b067bff81$export$29cd7b75162a9425)
});
const $a4972cdb81829546$export$f69c19e57285b83a = (0, $87701c398fec8638$export$971dd5b0dfd021b6)([
    $a4972cdb81829546$export$e9f2180374ddf65c,
    $a4972cdb81829546$export$408679386f20bea3,
    $a4972cdb81829546$export$b173e562563f5d67,
    $a4972cdb81829546$export$7ea1823939ff9bf7,
    $a4972cdb81829546$export$f673da8d4d77e06e,
    $a4972cdb81829546$export$f23fb2822868c746,
    $a4972cdb81829546$export$10b05091a68ea6bf
]);
const $a4972cdb81829546$export$ce2b4637846f5c5d = (fig)=>({
        tag: 'ResFigure',
        fig: fig
    });
const $a4972cdb81829546$export$8f8c58f29d92693d = (pgs)=>({
        tag: 'ResPages',
        pgs: pgs
    });




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





var $693bce5de608e437$export$62d58b1c91e8e902;
var $693bce5de608e437$export$d12474c86de6e20;
var $693bce5de608e437$export$33df3bd35b4785c8;
var $693bce5de608e437$export$39f5674517ec0000;
$693bce5de608e437$export$62d58b1c91e8e902 = `D3nEEq_tab`;
$693bce5de608e437$export$d12474c86de6e20 = `D3nEEq_tab--active`;
$693bce5de608e437$export$33df3bd35b4785c8 = `D3nEEq_tab--modified`;
$693bce5de608e437$export$39f5674517ec0000 = `D3nEEq_tabs`;


const $a0bdcb5c7d8b9625$export$f7bb6c1ea06c8836 = (state)=>(index)=>{
        const piece = (0, $58f80d7b57eba59b$export$43f5536de9872e14)($6274183b067bff81$export$bf8821bf3a16b79(index))(state);
        return piece.tweaks !== (0, $3cad0932f8cf18b6$export$52146bc489a12acd);
    };
const $a0bdcb5c7d8b9625$export$5e797c436a3f6a49 = (state)=>(needle)=>{
        for(const prop in state.tweaks.Rulers)if (state.tweaks.Rulers.hasOwnProperty(prop) && prop.includes(needle)) return true;
        return false;
    };
const $a0bdcb5c7d8b9625$export$3e41faf802a29e71 = ({ value: piece, index: index, active: active, emitter: emitter, modified: modified })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: `${$693bce5de608e437$export$62d58b1c91e8e902} ${active === String(index) ? $693bce5de608e437$export$d12474c86de6e20 : ''} ${modified ? $693bce5de608e437$export$33df3bd35b4785c8 : ''}`,
        onClick: ()=>emitter((0, $95b6ced072457fd7$export$d646c0fa88385aa0)(String(index))),
        children: piece.Title
    });
const $a0bdcb5c7d8b9625$export$b2539bed5023c21c = ({ value: value, emitter: emitter })=>{
    const wasTweaked = (0, $acw62.useCallback)((index)=>$a0bdcb5c7d8b9625$export$f7bb6c1ea06c8836(value)(index), [
        value
    ]);
    const relevantPieces = value.figure.Pieces.filter((p)=>{
        const pieceType = p.Meta.Entries.find(([k, _])=>k === 'type')?.[1] ?? null;
        if (!pieceType || !(0, $7396d8de986b0ae3$export$ac8ec40bfe3872ab).is(pieceType.Value) || !(0, $7396d8de986b0ae3$export$1401e332eb6b9092).is(pieceType.Value.Value)) return true;
        if (pieceType.Value.Value.Text !== 'hardware') return true;
        return false;
    });
    if (relevantPieces.length <= 1) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    else return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: $693bce5de608e437$export$39f5674517ec0000,
        children: relevantPieces.map((piece, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($a0bdcb5c7d8b9625$export$3e41faf802a29e71, {
                value: piece,
                index: index,
                active: value.active,
                emitter: emitter,
                modified: wasTweaked(String(index))
            }, index))
    });
};


const $8727e44a96b3445b$export$ca65614d7992560c = (emit)=>(state)=>(msg)=>{
            switch(msg.tag){
                case 'MsgLoadFigure':
                    emit($1876f312c3f68910$export$42fffed799c298bb((0, $6274183b067bff81$export$345bcac8b1ee40ea)(msg.fig)));
                    return;
                case 'MsgFocusFigure':
                    emit($2c2d04dd32bcf067$export$3481c78889e8fbe8);
                    return;
                case 'MsgDownloadFigure':
                    if (!window.parent || !state) return;
                    window.parent.postMessage((0, $a4972cdb81829546$export$ce2b4637846f5c5d)((0, $3cad0932f8cf18b6$export$113c6a12ae7bc40c)((0, $6274183b067bff81$export$92fbeba6bb0455fb)(state))(state.figure)), '*');
                    return;
                case 'MsgGetPages':
                    if (!window.parent || !state) return;
                    window.parent.postMessage((0, $a4972cdb81829546$export$8f8c58f29d92693d)((0, $6274183b067bff81$export$f4348e32a399a3d5)(state)), '*');
                    return;
                case 'MsgSetActive':
                    emit($95b6ced072457fd7$export$d646c0fa88385aa0(msg.act));
                    return;
                case 'MsgResetTweaks':
                    emit($5fe8acb3e2efeaa8$export$cd9835e9dc0ea669);
                    return;
                case 'MsgConfig':
                    emit($f3625624ed8c0778$export$8d21e34596265fa2(msg.con));
                    return;
            }
        };
const $8727e44a96b3445b$export$a1a1436e53713b15 = (emit)=>(state)=>(event)=>(0, $128066113e324b22$export$2fbe0fdfc24beb3d)((0, $a4972cdb81829546$export$f69c19e57285b83a))(event.data).then($8727e44a96b3445b$export$ca65614d7992560c(emit)(state)).catch(console.error);
const $8727e44a96b3445b$export$4cf948624a22b919 = ()=>{
    const { emit: emit, state: state } = (0, $fbdba84188affd35$export$900e94db7bcea325)(null);
    (0, $acw62.useEffect)(()=>{
        const receive = $8727e44a96b3445b$export$a1a1436e53713b15(emit)(state);
        window.addEventListener('message', receive);
        return ()=>window.removeEventListener('message', receive);
    }, [
        emit,
        state
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "page figure",
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            !state ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "No state yet!"
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $43a0075edecf551b$export$2ca6212a619576d4), {
                emit: emit,
                value: state,
                width: "100%",
                height: "100%",
                angleConverter: (0, $4beeab19e80c1290$export$6e98d19a58527322).exterior,
                lengthConverter: (0, $4beeab19e80c1290$export$d871edfc009fc342)
            }),
            !state ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0bdcb5c7d8b9625$export$b2539bed5023c21c), {
                value: state,
                emitter: emit
            })
        ]
    });
};
var $8727e44a96b3445b$export$2e2bcd8739ae039 = $8727e44a96b3445b$export$4cf948624a22b919;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $eVPL0 = parcelRequire("eVPL0");



const $7813c8cbdcd8987c$export$d6ca7d181b310028 = (...args)=>args.filter((c)=>c !== undefined).map((c)=>c.trim()).filter((c)=>c !== '').join(' ');





var $lWM6H = parcelRequire("lWM6H");

var $eVPL0 = parcelRequire("eVPL0");

var $eVPL0 = parcelRequire("eVPL0");
const $769969b5d409bf93$export$46ba2b2dce92f7a = (cloud)=>(extent)=>{
        const first = cloud.get(extent.first);
        if (!first) return $eVPL0.left(extent.first);
        const final = cloud.get(extent.final);
        if (!final) return $eVPL0.left(extent.final);
        return $eVPL0.right({
            first: first,
            final: final
        });
    };



var $eVPL0 = parcelRequire("eVPL0");

const $7689a730aa677225$export$46ba2b2dce92f7a = (cloud)=>(angle)=>{
        const root = cloud.get(angle.root);
        if (!root) return $eVPL0.left(angle.root);
        return $eVPL0.map((extent)=>({
                root: root,
                ...extent
            }))($769969b5d409bf93$export$46ba2b2dce92f7a(cloud)(angle));
    };



const $aaf4782ffd20da64$export$46ba2b2dce92f7a = $769969b5d409bf93$export$46ba2b2dce92f7a;


const $81f3e195dd62fcba$export$46ba2b2dce92f7a = (cloud)=>(measure)=>$81f3e195dd62fcba$export$4ed21a0a126be250(measure) ? $7689a730aa677225$export$46ba2b2dce92f7a(cloud)(measure) : $aaf4782ffd20da64$export$46ba2b2dce92f7a(cloud)(measure);
const $81f3e195dd62fcba$export$4ed21a0a126be250 = (msr)=>msr.hasOwnProperty('root') && msr.hasOwnProperty('first') && msr.hasOwnProperty('final');
const $81f3e195dd62fcba$export$38db3d147cb3433 = (msr)=>!msr.hasOwnProperty('root') && msr.hasOwnProperty('first') && msr.hasOwnProperty('final');


const $e66d5d7469c9bfb9$export$46ba2b2dce92f7a = (cloud)=>({ subject: subject, measure: measure, towards: towards, ...rest })=>(0, $lWM6H.pipe)($eVPL0.Do, $eVPL0.bind('tow', ()=>{
            if (!towards) return $eVPL0.right(undefined);
            const tow = cloud.get(towards);
            return !tow ? $eVPL0.left(towards) : $eVPL0.right(tow);
        }), $eVPL0.bind('msr', ()=>$81f3e195dd62fcba$export$46ba2b2dce92f7a(cloud)(measure)), $eVPL0.bind('sub', ()=>!subject ? $eVPL0.right(undefined) : $769969b5d409bf93$export$46ba2b2dce92f7a(cloud)(subject)), $eVPL0.map(({ tow: tow, msr: measure, sub: sub })=>({
                measure: measure,
                ...towards ? {
                    towards: tow
                } : {},
                ...subject ? {
                    subject: sub
                } : {},
                ...rest
            })));
const $e66d5d7469c9bfb9$export$4ed21a0a126be250 = (rlr)=>$81f3e195dd62fcba$export$4ed21a0a126be250(rlr.measure);
const $e66d5d7469c9bfb9$export$38db3d147cb3433 = (rlr)=>$81f3e195dd62fcba$export$38db3d147cb3433(rlr.measure);



var $eVPL0 = parcelRequire("eVPL0");



const $d4bbeae8ea2583e1$export$65ab0ebced932b79 = (f)=>(c0)=>{
        const n0 = f(c0.c0);
        return c0.c0 === n0 ? c0 : {
            c0: n0
        };
    };
const $d4bbeae8ea2583e1$export$101619b11a34a0bd = (f)=>(c1)=>{
        const n1 = f(c1.c1);
        return c1.c1 === n1 ? c1 : {
            c1: n1
        };
    };
const $d4bbeae8ea2583e1$export$e211f1b16650c0ca = (n)=>Math.abs(n) <= 0.000001;
const $d4bbeae8ea2583e1$export$580d8d617aed3775 = ([x, y])=>`${x},${y}`;
const $d4bbeae8ea2583e1$export$cbfbec548517f2b6 = (p0, p1, p2)=>{
    const a = (0, $d99ec1e84f6a18d9$export$1991ecd29cc92c6b)((0, $d99ec1e84f6a18d9$export$f93b5905241a7cca)(p1)(p0));
    const b = (0, $d99ec1e84f6a18d9$export$1991ecd29cc92c6b)((0, $d99ec1e84f6a18d9$export$f93b5905241a7cca)(p2)(p1));
    const c = (0, $d99ec1e84f6a18d9$export$1991ecd29cc92c6b)((0, $d99ec1e84f6a18d9$export$f93b5905241a7cca)(p0)(p2));
    const s = (a + b + c) / 2;
    const A = Math.sqrt(s * (s - a) * (s - b) * (s - c));
    return $d4bbeae8ea2583e1$export$e211f1b16650c0ca(a) ? null : a * b * c / (4 * A);
};
const $d4bbeae8ea2583e1$export$9daea29673564e8f = ([x1, y1], [x2, y2], [x3, y3])=>{
    const cprod = (x2 - x1) * (y3 - y1) - (y2 - y1) * (x3 - x1);
    return $d4bbeae8ea2583e1$export$e211f1b16650c0ca(cprod) ? null : cprod > 0 ? 1 : 0;
};
const $d4bbeae8ea2583e1$export$f09585a853dddd32 = (r, a, b, c)=>(0, $d99ec1e84f6a18d9$export$1991ecd29cc92c6b)((0, $d99ec1e84f6a18d9$export$f93b5905241a7cca)(b)(a)) + (0, $d99ec1e84f6a18d9$export$1991ecd29cc92c6b)((0, $d99ec1e84f6a18d9$export$f93b5905241a7cca)(c)(b)) >= 2 * r * Math.sqrt(2);



var $eVPL0 = parcelRequire("eVPL0");

const $786e9122fc0a0938$export$66b01121c2b3ca6a = (ps, pe)=>`M ${(0, $d4bbeae8ea2583e1$export$580d8d617aed3775)(ps)} ${$786e9122fc0a0938$export$7c529efee34fe796(pe)}`;
const $786e9122fc0a0938$export$7c529efee34fe796 = (pe)=>`L ${(0, $d4bbeae8ea2583e1$export$580d8d617aed3775)(pe)}`;



var $eVPL0 = parcelRequire("eVPL0");


const $0fef7edab131e091$export$25d367e02170840 = (f)=>({ c0: c0, ...rest })=>({
            c0: f(c0),
            ...rest
        });
const $0fef7edab131e091$export$46ba2b2dce92f7a = (cloud)=>(radial)=>{
        const { c0: tc0, ...rest } = radial;
        const c0 = cloud.get(tc0);
        return c0 === undefined ? $eVPL0.left(tc0) : $eVPL0.right({
            c0: c0,
            ...rest
        });
    };
const $0fef7edab131e091$export$66b01121c2b3ca6a = (ps, r, pe)=>`M ${(0, $d4bbeae8ea2583e1$export$580d8d617aed3775)(ps)} ${$0fef7edab131e091$export$7c529efee34fe796(ps, r, pe)}`;
const $0fef7edab131e091$export$7c529efee34fe796 = (ps, r, pe)=>{
    const rad = (0, $d4bbeae8ea2583e1$export$cbfbec548517f2b6)(ps, r.c0, pe);
    const cws = (0, $d4bbeae8ea2583e1$export$9daea29673564e8f)(ps, r.c0, pe);
    const lrg = !rad ? null : (0, $d4bbeae8ea2583e1$export$f09585a853dddd32)(rad, ps, r.c0, pe) ? 1 : 0;
    if (rad === null || cws === null || lrg === null) return $786e9122fc0a0938$export$7c529efee34fe796(pe);
    return `A ${rad} ${rad} 0 ${lrg} ${cws} ${(0, $d4bbeae8ea2583e1$export$580d8d617aed3775)(pe)}`;
};



var $eVPL0 = parcelRequire("eVPL0");

const $4e16c0e4c6bbbe19$export$25d367e02170840 = (f)=>({ c0: c0, c1: c1, ...rest })=>({
            c0: f(c0),
            c1: f(c1),
            ...rest
        });
const $4e16c0e4c6bbbe19$export$46ba2b2dce92f7a = (cloud)=>(bezier)=>{
        const { c0: tc0, c1: tc1, ...rest } = bezier;
        const c0 = cloud.get(tc0);
        const c1 = cloud.get(tc1);
        if (c0 === undefined) return $eVPL0.left(tc0);
        if (c1 === undefined) return $eVPL0.left(tc1);
        return $eVPL0.right({
            c0: c0,
            c1: c1,
            ...rest
        });
    };
const $4e16c0e4c6bbbe19$export$66b01121c2b3ca6a = (ps, b, pe)=>`M ${(0, $d4bbeae8ea2583e1$export$580d8d617aed3775)(ps)} ${$4e16c0e4c6bbbe19$export$7c529efee34fe796(b, pe)}`;
const $4e16c0e4c6bbbe19$export$7c529efee34fe796 = (b, pe)=>`C ${(0, $d4bbeae8ea2583e1$export$580d8d617aed3775)(b.c0)} ${(0, $d4bbeae8ea2583e1$export$580d8d617aed3775)(b.c1)} ${(0, $d4bbeae8ea2583e1$export$580d8d617aed3775)(pe)}`;


const $03c1d17e9908deb0$export$cf74f7e3e455e0fa = (f)=>(chunk)=>{
        if ($03c1d17e9908deb0$export$b69c36657e42ff85(chunk)) {
            const bc0 = f(chunk.c0);
            const bc1 = f(chunk.c1);
            if (bc0 === chunk.c0 && bc1 === chunk.c1) return chunk;
            return {
                c0: bc0,
                c1: bc1
            };
        }
        if ($03c1d17e9908deb0$export$88937bcd61c5d498(chunk)) {
            const rc0 = f(chunk.c0);
            return rc0 === chunk.c0 ? chunk : {
                c0: rc0
            };
        }
        return chunk;
    };
const $03c1d17e9908deb0$export$25d367e02170840 = (f)=>(chunk)=>{
        if ($03c1d17e9908deb0$export$b69c36657e42ff85(chunk)) return $4e16c0e4c6bbbe19$export$25d367e02170840(f)(chunk);
        if ($03c1d17e9908deb0$export$88937bcd61c5d498(chunk)) return $0fef7edab131e091$export$25d367e02170840(f)(chunk);
        return chunk;
    };
const $03c1d17e9908deb0$export$46ba2b2dce92f7a = (cloud)=>(chunk)=>{
        if ($03c1d17e9908deb0$export$b69c36657e42ff85(chunk)) return $4e16c0e4c6bbbe19$export$46ba2b2dce92f7a(cloud)(chunk);
        if ($03c1d17e9908deb0$export$88937bcd61c5d498(chunk)) return $0fef7edab131e091$export$46ba2b2dce92f7a(cloud)(chunk);
        return $eVPL0.right(chunk);
    };
const $03c1d17e9908deb0$export$66b01121c2b3ca6a = (ps, chunk, pe)=>{
    if ($03c1d17e9908deb0$export$b69c36657e42ff85(chunk)) return $4e16c0e4c6bbbe19$export$66b01121c2b3ca6a(ps, chunk, pe);
    if ($03c1d17e9908deb0$export$88937bcd61c5d498(chunk)) return $0fef7edab131e091$export$66b01121c2b3ca6a(ps, chunk, pe);
    return $786e9122fc0a0938$export$66b01121c2b3ca6a(ps, pe);
};
const $03c1d17e9908deb0$export$803e4b91e12568c8 = (c)=>!(c.hasOwnProperty('c0') || c.hasOwnProperty('c1'));
const $03c1d17e9908deb0$export$88937bcd61c5d498 = (c)=>c.hasOwnProperty('c0') && !c.hasOwnProperty('c1');
const $03c1d17e9908deb0$export$b69c36657e42ff85 = (c)=>c.hasOwnProperty('c0') && c.hasOwnProperty('c1');





const $eb00536c18f59e28$export$25d367e02170840 = (f)=>(shape)=>shape.map(([curr, chnk])=>[
                f(curr),
                $03c1d17e9908deb0$export$25d367e02170840(f)(chnk)
            ]);
const $eb00536c18f59e28$export$46ba2b2dce92f7a = (cloud)=>(shape)=>$eVPL0.traverseArray(([node, chunk])=>{
            const point = cloud.get(node);
            const value = !point ? $eVPL0.left(node) : $eVPL0.map((piece)=>[
                    point,
                    piece
                ])($03c1d17e9908deb0$export$46ba2b2dce92f7a(cloud)(chunk));
            return value;
        })(shape);
const $eb00536c18f59e28$export$66b01121c2b3ca6a = (shape)=>shape.reduce((path, [curr, chnk], i)=>{
        const next = shape?.[i + 1]?.[0] ?? shape[0][0];
        if ($03c1d17e9908deb0$export$b69c36657e42ff85(chnk)) return path + ' ' + $4e16c0e4c6bbbe19$export$7c529efee34fe796(chnk, next);
        if ($03c1d17e9908deb0$export$88937bcd61c5d498(chnk)) return path + ' ' + $0fef7edab131e091$export$7c529efee34fe796(curr, chnk, next);
        return path + ' ' + $786e9122fc0a0938$export$7c529efee34fe796(next);
    }, `M ${(0, $d4bbeae8ea2583e1$export$580d8d617aed3775)(shape[0][0])}`) + ' Z';
const $eb00536c18f59e28$export$3533bc77bf6c916f = (f)=>(first, final)=>(shape)=>{
            const len = shape.length;
            let fstIx = null;
            let finIx = null;
            const looped = shape.concat(shape);
            const segments = [];
            for (const [ix, [n, c]] of looped.entries()){
                if (fstIx !== null && finIx !== null) break;
                const ns = [
                    n
                ].concat((0, $58f80d7b57eba59b$export$3988ae62b71be9a3)($03c1d17e9908deb0$export$cf74f7e3e455e0fa)(c));
                if (fstIx === null && ns.includes(first)) {
                    fstIx = ix;
                    $eb00536c18f59e28$export$ac8dfd3a7ad06e80(first)(ns).forEach(f(segments));
                }
                if (fstIx !== null && finIx === null && ns.includes(final)) {
                    finIx = ix;
                    if (final === n) segments.push([
                        n,
                        c
                    ]);
                    else $eb00536c18f59e28$export$e4efc4a06665497d(final)(ns).forEach((n)=>segments.push([
                            n,
                            {}
                        ]));
                }
            }
            if (fstIx !== null && finIx !== null) {
                const diff = finIx - fstIx;
                const left = len - diff;
                looped.slice(finIx + 1, finIx + left).forEach((c)=>segments.push(c));
                if ((0, $8af43a568842d8c3$export$abae9d370f12ca88)(segments)) return segments;
            }
            return shape;
        };
const $eb00536c18f59e28$export$13c2781d1a051e49 = (first, nodes, final)=>(shape)=>{
        const shp = $eb00536c18f59e28$export$3533bc77bf6c916f((segs)=>(n)=>{
                segs.push([
                    n,
                    {}
                ]);
                if (first !== n) return;
                segs.push(...nodes.map((n)=>[
                        n,
                        {}
                    ]));
            })(first, final)(shape);
        return shp;
    };
const $eb00536c18f59e28$export$d7362031d87dcd2a = (first, c0, c1, final)=>(shape)=>$eb00536c18f59e28$export$3533bc77bf6c916f((segs)=>(n)=>segs.push([
                    n,
                    n !== first ? {} : {
                        c0: c0,
                        c1: c1
                    }
                ]))(first, final)(shape);
const $eb00536c18f59e28$export$e3254935db333191 = (first, c0, final)=>(shape)=>$eb00536c18f59e28$export$3533bc77bf6c916f((segs)=>(n)=>segs.push([
                    n,
                    n !== first ? {} : {
                        c0: c0
                    }
                ]))(first, final)(shape);
const $eb00536c18f59e28$export$ac8dfd3a7ad06e80 = (el)=>(els)=>{
        const tks = [];
        for (const e of els){
            tks.push(e);
            if (e === el) break;
        }
        return tks;
    };
const $eb00536c18f59e28$export$e4efc4a06665497d = (el)=>(els)=>{
        const tks = [];
        let found = false;
        for (const e of els){
            if (!found && e === el) found = true;
            if (!found) continue;
            tks.push(e);
        }
        return tks;
    };
const $eb00536c18f59e28$export$f713a0a4e19c1799 = (shape)=>(n)=>{
        const nodes = [];
        shape.forEach(([n, c])=>{
            nodes.push(n);
            (0, $58f80d7b57eba59b$export$3988ae62b71be9a3)($03c1d17e9908deb0$export$cf74f7e3e455e0fa)(c).forEach((n)=>nodes.push(n));
        });
        if (!(0, $8af43a568842d8c3$export$abae9d370f12ca88)(nodes)) return null;
        const fst = nodes[0];
        const lst = nodes[nodes.length - 1] ?? fst;
        for (const [ix, node] of nodes.entries()){
            if (node !== n) continue;
            const prev = nodes[ix - 1] ?? lst;
            const next = nodes[ix + 1] ?? fst;
            return [
                prev,
                n,
                next
            ];
        }
        return null;
    };




var $eVPL0 = parcelRequire("eVPL0");


const $90eed4cce6dba2ac$export$98bada23690e67eb = ()=>(0, $58f80d7b57eba59b$export$94132a0e348806d4)('shape');
const $90eed4cce6dba2ac$export$46ba2b2dce92f7a = (cloud)=>({ shape: shape, ...rest })=>$eVPL0.map((shape)=>({
                shape: shape,
                ...rest
            }))($eb00536c18f59e28$export$46ba2b2dce92f7a(cloud)(shape));


const $c606faa825ef1d7d$export$891904c5d9d25883 = ()=>({
        point: {
            visual: {
                render: true
            },
            handle: {
                render: true
            }
        },
        chunk: {
            visual: {
                render: true
            },
            handle: {
                render: true
            }
        },
        frame: {
            visual: {
                render: true
            },
            handle: {
                render: true
            }
        },
        ruler: {
            whisk: {
                standard: {
                    render: true
                },
                extended: {
                    render: true
                }
            },
            label: {
                visual: {
                    render: true
                },
                handle: {
                    render: true
                }
            },
            visual: {
                render: true
            },
            handle: {
                render: true
            }
        }
    });


const $15a483b9f03099a6$export$fdfcf7462de85213 = (preset)=>(config)=>{
        const render = config?.render ?? preset.render;
        const labels = config?.labels ?? [];
        return {
            render: render,
            ...labels.length === 0 ? {} : {
                labels: labels
            }
        };
    };
const $15a483b9f03099a6$export$c52cff9fa99ec153 = (preset)=>(config)=>{
        return config?.extras ? config : preset;
    };
const $15a483b9f03099a6$export$1d2147785be8aae7 = (e)=>({
        handle: {
            extras: {
                tight: true,
                value: e
            }
        }
    });
const $15a483b9f03099a6$export$f9fc784f8b35ba50 = (preset)=>(config)=>{
        const visual = $15a483b9f03099a6$export$fdfcf7462de85213(preset.visual)(config?.visual);
        const visualH = $15a483b9f03099a6$export$fdfcf7462de85213(preset.handle)(config?.handle);
        const extrasH = $15a483b9f03099a6$export$c52cff9fa99ec153(preset.handle)(config?.handle);
        return {
            visual: visual,
            handle: {
                ...visualH,
                ...extrasH
            }
        };
    };
const $15a483b9f03099a6$export$868f336db37bf8e4 = (preset)=>(config)=>({
            standard: $15a483b9f03099a6$export$fdfcf7462de85213(preset.standard)(config?.standard),
            extended: $15a483b9f03099a6$export$fdfcf7462de85213(preset.extended)(config?.extended)
        });


var $0914b2a8bc1aa49c$exports = {};

$parcel$export($0914b2a8bc1aa49c$exports, "angle", () => $0914b2a8bc1aa49c$export$944b09d2ad10b378, (v) => $0914b2a8bc1aa49c$export$944b09d2ad10b378 = v);
$parcel$export($0914b2a8bc1aa49c$exports, "clickViews", () => $0914b2a8bc1aa49c$export$e35bc971ded0deb2, (v) => $0914b2a8bc1aa49c$export$e35bc971ded0deb2 = v);
$parcel$export($0914b2a8bc1aa49c$exports, "extended", () => $0914b2a8bc1aa49c$export$44d74886d11a5ca2, (v) => $0914b2a8bc1aa49c$export$44d74886d11a5ca2 = v);
$parcel$export($0914b2a8bc1aa49c$exports, "final", () => $0914b2a8bc1aa49c$export$ceb9104a85eb313f, (v) => $0914b2a8bc1aa49c$export$ceb9104a85eb313f = v);
$parcel$export($0914b2a8bc1aa49c$exports, "first", () => $0914b2a8bc1aa49c$export$43128fadae87b74a, (v) => $0914b2a8bc1aa49c$export$43128fadae87b74a = v);
$parcel$export($0914b2a8bc1aa49c$exports, "frags", () => $0914b2a8bc1aa49c$export$36e299e3b923000a, (v) => $0914b2a8bc1aa49c$export$36e299e3b923000a = v);
$parcel$export($0914b2a8bc1aa49c$exports, "frame", () => $0914b2a8bc1aa49c$export$2cef06c20297c17d, (v) => $0914b2a8bc1aa49c$export$2cef06c20297c17d = v);
$parcel$export($0914b2a8bc1aa49c$exports, "frameViews", () => $0914b2a8bc1aa49c$export$2a35ad12a49bdae3, (v) => $0914b2a8bc1aa49c$export$2a35ad12a49bdae3 = v);
$parcel$export($0914b2a8bc1aa49c$exports, "handle", () => $0914b2a8bc1aa49c$export$8f34ce051745d39e, (v) => $0914b2a8bc1aa49c$export$8f34ce051745d39e = v);
$parcel$export($0914b2a8bc1aa49c$exports, "length", () => $0914b2a8bc1aa49c$export$f24224f1c91d8156, (v) => $0914b2a8bc1aa49c$export$f24224f1c91d8156 = v);
$parcel$export($0914b2a8bc1aa49c$exports, "piece", () => $0914b2a8bc1aa49c$export$6ad76399625e2d35, (v) => $0914b2a8bc1aa49c$export$6ad76399625e2d35 = v);
$parcel$export($0914b2a8bc1aa49c$exports, "pieceViews", () => $0914b2a8bc1aa49c$export$e9e56fb1a0f43d56, (v) => $0914b2a8bc1aa49c$export$e9e56fb1a0f43d56 = v);
$parcel$export($0914b2a8bc1aa49c$exports, "point", () => $0914b2a8bc1aa49c$export$105684a3041cb6f3, (v) => $0914b2a8bc1aa49c$export$105684a3041cb6f3 = v);
$parcel$export($0914b2a8bc1aa49c$exports, "pointViews", () => $0914b2a8bc1aa49c$export$9a78c3d2ae28c831, (v) => $0914b2a8bc1aa49c$export$9a78c3d2ae28c831 = v);
$parcel$export($0914b2a8bc1aa49c$exports, "prefix", () => $0914b2a8bc1aa49c$export$82e9f45cca5ba907, (v) => $0914b2a8bc1aa49c$export$82e9f45cca5ba907 = v);
$parcel$export($0914b2a8bc1aa49c$exports, "reading", () => $0914b2a8bc1aa49c$export$1bc439096ffd97ac, (v) => $0914b2a8bc1aa49c$export$1bc439096ffd97ac = v);
$parcel$export($0914b2a8bc1aa49c$exports, "ruler", () => $0914b2a8bc1aa49c$export$f9adada2013e846e, (v) => $0914b2a8bc1aa49c$export$f9adada2013e846e = v);
$parcel$export($0914b2a8bc1aa49c$exports, "rulerViews", () => $0914b2a8bc1aa49c$export$53c75c3724e82ac8, (v) => $0914b2a8bc1aa49c$export$53c75c3724e82ac8 = v);
$parcel$export($0914b2a8bc1aa49c$exports, "selected", () => $0914b2a8bc1aa49c$export$d90250155de6d7e7, (v) => $0914b2a8bc1aa49c$export$d90250155de6d7e7 = v);
$parcel$export($0914b2a8bc1aa49c$exports, "sketch", () => $0914b2a8bc1aa49c$export$d038dabfbf61338f, (v) => $0914b2a8bc1aa49c$export$d038dabfbf61338f = v);
$parcel$export($0914b2a8bc1aa49c$exports, "standard", () => $0914b2a8bc1aa49c$export$b9b728df0601d25c, (v) => $0914b2a8bc1aa49c$export$b9b728df0601d25c = v);
$parcel$export($0914b2a8bc1aa49c$exports, "unit", () => $0914b2a8bc1aa49c$export$523c0b569236b342, (v) => $0914b2a8bc1aa49c$export$523c0b569236b342 = v);
$parcel$export($0914b2a8bc1aa49c$exports, "value", () => $0914b2a8bc1aa49c$export$2ab9a8f9f1186f14, (v) => $0914b2a8bc1aa49c$export$2ab9a8f9f1186f14 = v);
$parcel$export($0914b2a8bc1aa49c$exports, "visual", () => $0914b2a8bc1aa49c$export$496f218b657bbde0, (v) => $0914b2a8bc1aa49c$export$496f218b657bbde0 = v);
$parcel$export($0914b2a8bc1aa49c$exports, "whisker", () => $0914b2a8bc1aa49c$export$dca6466e528a1b77, (v) => $0914b2a8bc1aa49c$export$dca6466e528a1b77 = v);
var $0914b2a8bc1aa49c$export$944b09d2ad10b378;
var $0914b2a8bc1aa49c$export$e35bc971ded0deb2;
var $0914b2a8bc1aa49c$export$44d74886d11a5ca2;
var $0914b2a8bc1aa49c$export$ceb9104a85eb313f;
var $0914b2a8bc1aa49c$export$43128fadae87b74a;
var $0914b2a8bc1aa49c$export$36e299e3b923000a;
var $0914b2a8bc1aa49c$export$2cef06c20297c17d;
var $0914b2a8bc1aa49c$export$2a35ad12a49bdae3;
var $0914b2a8bc1aa49c$export$8f34ce051745d39e;
var $0914b2a8bc1aa49c$export$f24224f1c91d8156;
var $0914b2a8bc1aa49c$export$6ad76399625e2d35;
var $0914b2a8bc1aa49c$export$e9e56fb1a0f43d56;
var $0914b2a8bc1aa49c$export$105684a3041cb6f3;
var $0914b2a8bc1aa49c$export$9a78c3d2ae28c831;
var $0914b2a8bc1aa49c$export$82e9f45cca5ba907;
var $0914b2a8bc1aa49c$export$1bc439096ffd97ac;
var $0914b2a8bc1aa49c$export$f9adada2013e846e;
var $0914b2a8bc1aa49c$export$53c75c3724e82ac8;
var $0914b2a8bc1aa49c$export$d90250155de6d7e7;
var $0914b2a8bc1aa49c$export$d038dabfbf61338f;
var $0914b2a8bc1aa49c$export$b9b728df0601d25c;
var $0914b2a8bc1aa49c$export$523c0b569236b342;
var $0914b2a8bc1aa49c$export$2ab9a8f9f1186f14;
var $0914b2a8bc1aa49c$export$496f218b657bbde0;
var $0914b2a8bc1aa49c$export$dca6466e528a1b77;
$0914b2a8bc1aa49c$export$944b09d2ad10b378 = `_2dQHxG_angle`;
$0914b2a8bc1aa49c$export$e35bc971ded0deb2 = `_2dQHxG_clickViews`;
$0914b2a8bc1aa49c$export$44d74886d11a5ca2 = `_2dQHxG_extended`;
$0914b2a8bc1aa49c$export$ceb9104a85eb313f = `_2dQHxG_final`;
$0914b2a8bc1aa49c$export$43128fadae87b74a = `_2dQHxG_first`;
$0914b2a8bc1aa49c$export$36e299e3b923000a = `_2dQHxG_frags`;
$0914b2a8bc1aa49c$export$2cef06c20297c17d = `_2dQHxG_frame`;
$0914b2a8bc1aa49c$export$2a35ad12a49bdae3 = `_2dQHxG_frameViews`;
$0914b2a8bc1aa49c$export$8f34ce051745d39e = `_2dQHxG_handle`;
$0914b2a8bc1aa49c$export$f24224f1c91d8156 = `_2dQHxG_length`;
$0914b2a8bc1aa49c$export$6ad76399625e2d35 = `_2dQHxG_piece`;
$0914b2a8bc1aa49c$export$e9e56fb1a0f43d56 = `_2dQHxG_pieceViews`;
$0914b2a8bc1aa49c$export$105684a3041cb6f3 = `_2dQHxG_point`;
$0914b2a8bc1aa49c$export$9a78c3d2ae28c831 = `_2dQHxG_pointViews`;
$0914b2a8bc1aa49c$export$82e9f45cca5ba907 = `_2dQHxG_prefix`;
$0914b2a8bc1aa49c$export$1bc439096ffd97ac = `_2dQHxG_reading`;
$0914b2a8bc1aa49c$export$f9adada2013e846e = `_2dQHxG_ruler`;
$0914b2a8bc1aa49c$export$53c75c3724e82ac8 = `_2dQHxG_rulerViews`;
$0914b2a8bc1aa49c$export$d90250155de6d7e7 = `_2dQHxG_selected`;
$0914b2a8bc1aa49c$export$d038dabfbf61338f = `_2dQHxG_sketch`;
$0914b2a8bc1aa49c$export$b9b728df0601d25c = `_2dQHxG_standard`;
$0914b2a8bc1aa49c$export$523c0b569236b342 = `_2dQHxG_unit`;
$0914b2a8bc1aa49c$export$2ab9a8f9f1186f14 = `_2dQHxG_value`;
$0914b2a8bc1aa49c$export$496f218b657bbde0 = `_2dQHxG_visual`;
$0914b2a8bc1aa49c$export$dca6466e528a1b77 = `_2dQHxG_whisker`;


const $5213f89aeaa4967a$export$5ccc441fcd55fdc5 = (address)=>(message)=>({
            address: address,
            message: message
        });
const $5213f89aeaa4967a$export$bc395541cacf6365 = (msg)=>(mhs)=>{
        const rhs = {};
        for(const key in mhs){
            const mh = mhs[key];
            if (mh) rhs[key] = // eslint-disable-next-line  @typescript-eslint/no-explicit-any
            (event)=>mh(msg)(event);
        }
        return rhs;
    };
const $5213f89aeaa4967a$export$9f048bf86ee2e9d2 = ()=>(0, $58f80d7b57eba59b$export$94132a0e348806d4)('points');
const $5213f89aeaa4967a$export$3ce3cb072716a2c7 = ()=>(0, $58f80d7b57eba59b$export$94132a0e348806d4)('frames');
const $5213f89aeaa4967a$export$d41a4ef23103261f = ()=>(0, $58f80d7b57eba59b$export$94132a0e348806d4)('rulers');
const $5213f89aeaa4967a$export$105684a3041cb6f3 = ()=>(0, $58f80d7b57eba59b$export$94132a0e348806d4)('point');
const $5213f89aeaa4967a$export$fbe79e8ff00475af = ({ value: sketch, caster: caster, preset: preset, hndlrs: hndlrs, fntsze: fntsze, ...props })=>{
    const [ref, size] = (0, $7ff8f69a51b0e2ac$export$1ab7ae714698c4b8)();
    const center = (0, $acw62.useMemo)(()=>(p)=>{
            return [
                p[0] + size.w / 2,
                -p[1] + size.h / 2
            ];
        }, [
        size
    ]);
    const specks = (0, $acw62.useMemo)(()=>{
        const result = new Map();
        for (const [key, val] of sketch.points)result.set(key, caster(val.point));
        return result;
    }, [
        caster,
        sketch.points
    ]);
    const frames = (0, $acw62.useMemo)(()=>{
        const frames = new Map();
        for (const [key, val] of sketch.frames){
            const frame = $90eed4cce6dba2ac$export$46ba2b2dce92f7a(specks)(val);
            if ($eVPL0.isLeft(frame)) {
                console.warn(`Frame #${key}: Missing node ${frame.left}.`);
                continue;
            }
            frames.set(key, frame.right);
        }
        return frames;
    }, [
        specks,
        sketch.frames
    ]);
    const rulers = (0, $acw62.useMemo)(()=>{
        const rulers = new Map();
        for (const [key, val] of sketch.rulers){
            const ruler = $e66d5d7469c9bfb9$export$46ba2b2dce92f7a(specks)(val);
            if ($eVPL0.isLeft(ruler)) {
                console.warn(`Ruler #${key}: Missing node ${ruler.left}.`);
                continue;
            }
            rulers.set(key, ruler.right);
        }
        return rulers;
    }, [
        specks,
        sketch.rulers
    ]);
    const pointViews = (0, $acw62.useMemo)(()=>[
            ...sketch.points.entries()
        ].map(([key, val])=>/*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$eea1ac5c87d85c3f, {
                value: val,
                caster: (0, $78df2dbbf84a78b3$export$a4627e546088548d)(caster, center),
                preset: preset.point,
                address: key,
                hndlrs: hndlrs?.point
            }, key)), [
        caster,
        sketch.points,
        preset.point,
        hndlrs?.point,
        center
    ]);
    const frameViews = (0, $acw62.useMemo)(()=>[
            ...frames.entries()
        ].map(([key, val])=>/*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$5b00d53ac9d67306, {
                value: val,
                caster: center,
                preset: preset.frame,
                address: key,
                hndlrs: hndlrs?.frame
            }, key)), [
        frames,
        preset.frame,
        hndlrs?.frame,
        center
    ]);
    const pieceViews = (0, $acw62.useMemo)(()=>[
            ...frames.entries()
        ].map(([key, val])=>/*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$b3384d341345898f, {
                value: val.shape,
                caster: center,
                preset: preset.chunk,
                mode: "visual",
                address: key
            }, key)), [
        frames,
        preset.chunk,
        center
    ]);
    const clickViews = (0, $acw62.useMemo)(()=>[
            ...frames.entries()
        ].map(([key, val])=>/*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$b3384d341345898f, {
                value: val.shape,
                caster: center,
                preset: preset.chunk,
                mode: "handle",
                address: key,
                hndlrs: hndlrs?.chunk
            }, key)), [
        frames,
        preset.chunk,
        hndlrs?.chunk,
        center
    ]);
    const rulerViews = (0, $acw62.useMemo)(()=>[
            ...rulers.entries()
        ].map(([key, val])=>/*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$96557ff1a47679bc, {
                value: val,
                caster: center,
                preset: preset.ruler,
                address: key,
                hndlrs: hndlrs?.ruler,
                fntsze: fntsze
            }, key)), [
        rulers,
        preset.ruler,
        hndlrs?.ruler,
        fntsze,
        center
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ref: ref,
        className: $0914b2a8bc1aa49c$exports.sketch,
        style: {
            '--fntsze': fntsze
        },
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                className: $0914b2a8bc1aa49c$exports.frameViews,
                children: frameViews
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                className: $0914b2a8bc1aa49c$exports.pieceViews,
                children: pieceViews
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                className: $0914b2a8bc1aa49c$exports.clickViews,
                children: clickViews
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                className: $0914b2a8bc1aa49c$exports.rulerViews,
                children: rulerViews
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                className: $0914b2a8bc1aa49c$exports.pointViews,
                children: pointViews
            })
        ]
    });
};
const $5213f89aeaa4967a$export$eea1ac5c87d85c3f = ({ value: value, caster: caster, preset: preset, address: address, hndlrs: hndlrs })=>{
    const { visual: visual, handle: handle } = (0, $15a483b9f03099a6$export$f9fc784f8b35ba50)(preset)(value);
    const render = visual.render || handle.render;
    if (!render) return null;
    const [x, y] = caster(value.point);
    const viscls = (0, $7813c8cbdcd8987c$export$d6ca7d181b310028)($0914b2a8bc1aa49c$exports.visual, ...visual?.labels ?? []);
    const hdlcls = (0, $7813c8cbdcd8987c$export$d6ca7d181b310028)($0914b2a8bc1aa49c$exports.handle, ...handle?.labels ?? []);
    const message = $5213f89aeaa4967a$export$5ccc441fcd55fdc5(address)(handle?.extras?.value);
    const handlers = hndlrs ? $5213f89aeaa4967a$export$bc395541cacf6365(message)(hndlrs) : {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
        className: $0914b2a8bc1aa49c$exports.point,
        "data-point": address,
        children: [
            !visual.render ? null : /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: x,
                cy: y,
                className: viscls
            }),
            !handle.render ? null : /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: x,
                cy: y,
                className: hdlcls,
                ...handlers
            })
        ]
    });
};
const $5213f89aeaa4967a$export$5bc8585254931474 = ({ mode: mode, value: value, caster: caster, preset: preset, address: address, hndlrs: hndlrs })=>{
    const { visual: visual, handle: handle } = (0, $15a483b9f03099a6$export$f9fc784f8b35ba50)(preset)(value);
    const render = mode === 'visual' ? visual.render : handle.render;
    if (!render) return null;
    const path = $03c1d17e9908deb0$export$66b01121c2b3ca6a(caster((0, $ec695bb278cff147$export$ffb5f4729a158638)(value.first)), $03c1d17e9908deb0$export$25d367e02170840((v)=>caster((0, $ec695bb278cff147$export$ffb5f4729a158638)(v)))(value.chunk), caster((0, $ec695bb278cff147$export$ffb5f4729a158638)(value.final)));
    const labels = (0, $7813c8cbdcd8987c$export$d6ca7d181b310028)($0914b2a8bc1aa49c$exports.piece, $0914b2a8bc1aa49c$exports[mode], ...mode === 'visual' ? visual?.labels ?? [] : handle?.labels ?? []);
    const message = $5213f89aeaa4967a$export$5ccc441fcd55fdc5(address)(handle?.extras?.value);
    const handlers = mode === 'handle' && hndlrs ? $5213f89aeaa4967a$export$bc395541cacf6365(message)(hndlrs) : {};
    return /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: path,
        className: labels,
        ...handlers,
        "data-frame": address[0],
        "data-piece": address[1]
    });
};
const $5213f89aeaa4967a$export$b3384d341345898f = ({ value: value, address: address, ...props })=>{
    const start = value[0][0];
    const items = value.map(([first, shard], i)=>{
        const { visual: visual, handle: handle, ...chunk } = shard;
        const final = value?.[i + 1]?.[0] ?? start;
        const piece = {
            first: first,
            chunk: chunk,
            final: final,
            visual: visual,
            handle: handle
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$5bc8585254931474, {
            value: piece,
            address: [
                address,
                i
            ],
            ...props
        }, i);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
        className: $0914b2a8bc1aa49c$exports.frags,
        "data-frame": address,
        children: items
    });
};
const $5213f89aeaa4967a$export$5b00d53ac9d67306 = ({ value: value, caster: caster, preset: preset, hndlrs: hndlrs, address: address })=>{
    const { visual: visual, handle: handle } = (0, $15a483b9f03099a6$export$f9fc784f8b35ba50)(preset)(value);
    if (!visual.render && !handle.render) return null;
    const shape = $eb00536c18f59e28$export$25d367e02170840((v)=>caster((0, $ec695bb278cff147$export$ffb5f4729a158638)(v)))(value.shape);
    const apath = $eb00536c18f59e28$export$66b01121c2b3ca6a(shape);
    const viscls = (0, $7813c8cbdcd8987c$export$d6ca7d181b310028)($0914b2a8bc1aa49c$exports.visual, ...visual?.labels ?? []);
    const hdlcls = (0, $7813c8cbdcd8987c$export$d6ca7d181b310028)($0914b2a8bc1aa49c$exports.handle, ...handle?.labels ?? []);
    const message = $5213f89aeaa4967a$export$5ccc441fcd55fdc5(address)(handle?.extras?.value);
    const handlers = hndlrs ? $5213f89aeaa4967a$export$bc395541cacf6365(message)(hndlrs) : {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
        className: $0914b2a8bc1aa49c$exports.frame,
        "data-frame": address,
        children: [
            !visual.render ? null : /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: apath,
                className: viscls
            }),
            !handle.render ? null : /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: apath,
                className: hdlcls,
                ...handlers
            })
        ]
    });
};
const $5213f89aeaa4967a$export$a3eb262d36d12799 = ({ p1: p1, p2: p2, x1: x1, y1: y1, x2: x2, y2: y2, ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)("line", {
        x1: x1 ?? p1[0],
        y1: y1 ?? p1[1],
        x2: x2 ?? p2[0],
        y2: y2 ?? p2[1],
        ...props
    });
const $5213f89aeaa4967a$export$89a89e5cd1cc47d1 = ({ value: ruler, anchor: anchor, normal: normal, preset: preset, hndlrs: hndlrs, address: address, measure: measure, subject: subject, fntsze: fntsze })=>{
    const { unit: unit, value: value, prefix: prefix, orient: orient, spacing: spacing } = ruler;
    const { visual: visual, handle: handle } = (0, $15a483b9f03099a6$export$f9fc784f8b35ba50)(preset)(ruler);
    const dir = (0, $acw62.useMemo)(()=>{
        const msrDir = measure;
        const subDir = subject ?? measure;
        const allDir = {
            RulerAlong: msrDir,
            RulerAcross: $d99ec1e84f6a18d9$export$7ed3823ccd6026c4(msrDir),
            ObjectAlong: subDir,
            ObjectAcross: $d99ec1e84f6a18d9$export$7ed3823ccd6026c4(subDir)
        };
        return allDir[orient ?? 'RulerAlong'];
    }, [
        orient,
        subject,
        measure
    ]);
    if (!visual.render) return null;
    const ang = Math.atan2(dir[1], dir[0]) * 180 / Math.PI;
    const rot = Math.abs(ang) > 90 ? ang + 180 : ang;
    const pos = $ec695bb278cff147$export$e16d8520af44a096(anchor)($d99ec1e84f6a18d9$export$dcdf75081b88279d((spacing ?? 0) * fntsze)(normal));
    const message = $5213f89aeaa4967a$export$5ccc441fcd55fdc5(address)(handle?.extras?.value);
    const handlers = hndlrs ? $5213f89aeaa4967a$export$bc395541cacf6365(message)(hndlrs) : {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
        className: $0914b2a8bc1aa49c$exports.reading,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("text", {
                className: (0, $7813c8cbdcd8987c$export$d6ca7d181b310028)($0914b2a8bc1aa49c$exports.visual, ...visual?.labels ?? []),
                textAnchor: "middle",
                dominantBaseline: "middle",
                transform: `translate( ${pos[0]} , ${pos[1]} ) rotate( ${rot} )`,
                children: [
                    !prefix ? null : /*#__PURE__*/ (0, $ayMG0.jsx)("tspan", {
                        className: $0914b2a8bc1aa49c$exports.prefix,
                        children: prefix
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tspan", {
                        className: $0914b2a8bc1aa49c$exports.value,
                        children: value
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tspan", {
                        className: $0914b2a8bc1aa49c$exports.unit,
                        children: unit
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                className: (0, $7813c8cbdcd8987c$export$d6ca7d181b310028)($0914b2a8bc1aa49c$exports.handle, ...handle?.labels ?? []),
                cx: pos[0],
                cy: pos[1],
                ...handlers
            })
        ]
    });
};
const $5213f89aeaa4967a$export$96557ff1a47679bc = ({ value: value, ...rest })=>$e66d5d7469c9bfb9$export$4ed21a0a126be250(value) ? /*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$6e6d21499bbdf6d2, {
        value: value,
        ...rest
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$4a681ff0febe1309, {
        value: value,
        ...rest
    });
const $5213f89aeaa4967a$export$6e6d21499bbdf6d2 = ({ value: value, fntsze: fntsze, caster: caster, preset: preset, hndlrs: hndlrs, address: address })=>{
    const { measure: measure, reading: reading, towards: towards } = value;
    const { visual: visual, handle: handle } = (0, $15a483b9f03099a6$export$f9fc784f8b35ba50)(preset)(value);
    if (!visual.render) return null;
    const rad = 5 * fntsze;
    const len = 2 * fntsze;
    const first = caster((0, $ec695bb278cff147$export$ffb5f4729a158638)(measure.first));
    const root = caster((0, $ec695bb278cff147$export$ffb5f4729a158638)(measure.root));
    const final = caster((0, $ec695bb278cff147$export$ffb5f4729a158638)(measure.final));
    const msrDir = $d99ec1e84f6a18d9$export$523c0b569236b342($ec695bb278cff147$export$f93b5905241a7cca(final)(first));
    const hntPnt = towards ? caster(towards) : root;
    const hntDir = $d99ec1e84f6a18d9$export$f93b5905241a7cca(hntPnt)(first);
    const offDir = $d99ec1e84f6a18d9$export$b5f64d0f15dfa393(msrDir)(hntDir) <= 0 ? [
        msrDir[1],
        -msrDir[0]
    ] // Left perpendicular vector
     : [
        -msrDir[1],
        msrDir[0]
    ] // Right perpendicular vector
    ;
    const fstV = $ec695bb278cff147$export$f93b5905241a7cca(first)(root);
    const finV = $ec695bb278cff147$export$f93b5905241a7cca(final)(root);
    const twdFst = $d99ec1e84f6a18d9$export$523c0b569236b342(fstV);
    const twdFin = $d99ec1e84f6a18d9$export$523c0b569236b342(finV);
    const angle = reading?.value;
    const right = !!angle && Math.abs(90 - angle) <= 0.0001;
    const sze = Math.min(right ? len : rad, $d99ec1e84f6a18d9$export$1991ecd29cc92c6b(fstV), $d99ec1e84f6a18d9$export$1991ecd29cc92c6b(finV));
    const fst = $ec695bb278cff147$export$e16d8520af44a096(root)($d99ec1e84f6a18d9$export$dcdf75081b88279d(sze)(twdFst));
    const fin = $ec695bb278cff147$export$e16d8520af44a096(root)($d99ec1e84f6a18d9$export$dcdf75081b88279d(sze)(twdFin));
    const sqr = $ec695bb278cff147$export$e16d8520af44a096(root)($d99ec1e84f6a18d9$export$e16d8520af44a096($d99ec1e84f6a18d9$export$dcdf75081b88279d(sze)(twdFst))($d99ec1e84f6a18d9$export$dcdf75081b88279d(sze)(twdFin)));
    const ctr = root;
    const square = `M ${fst[0]} ${fst[1]} L ${ctr[0]} ${ctr[1]} L ${fin[0]} ${fin[1]} L ${sqr[0]} ${sqr[1]} Z`;
    const radial = `M ${fst[0]} ${fst[1]} L ${ctr[0]} ${ctr[1]} L ${fin[0]} ${fin[1]} A ${sze} ${sze} 0 0 0 ${fst[0]} ${fst[1]} Z`;
    const anchor = right || sze < fntsze * 3 ? root : $ec695bb278cff147$export$a61423b330c3444c(fin, fst);
    const message = $5213f89aeaa4967a$export$5ccc441fcd55fdc5(address)(handle?.extras?.value);
    const handlers = hndlrs ? $5213f89aeaa4967a$export$bc395541cacf6365(message)(hndlrs.ruler) : {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
        className: (0, $7813c8cbdcd8987c$export$d6ca7d181b310028)($0914b2a8bc1aa49c$exports.ruler, $0914b2a8bc1aa49c$exports.angle),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                className: $0914b2a8bc1aa49c$exports.handle,
                d: right ? square : radial,
                ...handlers
            }),
            !reading ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$89a89e5cd1cc47d1, {
                value: reading,
                anchor: anchor,
                normal: offDir,
                fntsze: fntsze,
                preset: preset.label,
                hndlrs: hndlrs?.label,
                address: address,
                measure: $ec695bb278cff147$export$f93b5905241a7cca(fin)(fst)
            })
        ]
    });
};
const $5213f89aeaa4967a$export$4a681ff0febe1309 = ({ value: value, preset: preset, caster: caster, fntsze: fntsze, hndlrs: hndlrs, address: address })=>{
    const { subject: subject, measure: measure, spacing: spacing, towards: towards, reading: reading, whisker: whisker, ...rhandle } = value;
    const { visual: visual, handle: handle } = (0, $15a483b9f03099a6$export$f9fc784f8b35ba50)(preset)(rhandle);
    if (!visual.render) return null;
    const fstPnt = caster((0, $ec695bb278cff147$export$ffb5f4729a158638)(measure.first));
    const finPnt = caster((0, $ec695bb278cff147$export$ffb5f4729a158638)(measure.final));
    const hntPnt = towards ? caster(towards) : undefined;
    const rlrDst = (spacing ?? 0) * fntsze;
    const msrDir = $d99ec1e84f6a18d9$export$523c0b569236b342($ec695bb278cff147$export$f93b5905241a7cca(finPnt)(fstPnt));
    const hntDir = hntPnt ? $d99ec1e84f6a18d9$export$f93b5905241a7cca(hntPnt)(fstPnt) : [
        -msrDir[1],
        msrDir[0]
    ] // Default right perpendicular vector
    ;
    const offDir = $d99ec1e84f6a18d9$export$b5f64d0f15dfa393(msrDir)(hntDir) <= 0 ? [
        msrDir[1],
        -msrDir[0]
    ] // Left perpendicular vector
     : [
        -msrDir[1],
        msrDir[0]
    ] // Right perpendicular vector
    ;
    const rlrOff = $d99ec1e84f6a18d9$export$dcdf75081b88279d(rlrDst)(offDir);
    const wskOff = $d99ec1e84f6a18d9$export$dcdf75081b88279d(fntsze / 2)(offDir);
    const rp1 = $ec695bb278cff147$export$e16d8520af44a096(fstPnt)(rlrOff);
    const rp2 = $ec695bb278cff147$export$e16d8520af44a096(finPnt)(rlrOff);
    const sp1 = subject?.first ? caster(subject.first) : fstPnt;
    const sp2 = subject?.final ? caster(subject.final) : finPnt;
    const { standard: standard, extended: extended } = (0, $15a483b9f03099a6$export$868f336db37bf8e4)(preset.whisk)(whisker);
    const std = [
        $0914b2a8bc1aa49c$exports.standard,
        $0914b2a8bc1aa49c$exports.whisker,
        ...standard?.labels ?? []
    ];
    const ext = [
        $0914b2a8bc1aa49c$exports.extended,
        $0914b2a8bc1aa49c$exports.whisker,
        ...extended?.labels ?? []
    ];
    const message = $5213f89aeaa4967a$export$5ccc441fcd55fdc5(address)(handle?.extras?.value);
    const handlers = hndlrs ? $5213f89aeaa4967a$export$bc395541cacf6365(message)(hndlrs.ruler) : {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
        className: (0, $7813c8cbdcd8987c$export$d6ca7d181b310028)($0914b2a8bc1aa49c$exports.ruler, $0914b2a8bc1aa49c$exports.length),
        children: [
            !extended.render ? null : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$a3eb262d36d12799, {
                        className: (0, $7813c8cbdcd8987c$export$d6ca7d181b310028)($0914b2a8bc1aa49c$exports.first, ...ext),
                        p1: rp1,
                        p2: sp1
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$a3eb262d36d12799, {
                        className: (0, $7813c8cbdcd8987c$export$d6ca7d181b310028)($0914b2a8bc1aa49c$exports.final, ...ext),
                        p1: rp2,
                        p2: sp2
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$a3eb262d36d12799, {
                className: (0, $7813c8cbdcd8987c$export$d6ca7d181b310028)($0914b2a8bc1aa49c$exports.visual, ...visual?.labels ?? []),
                p1: rp1,
                p2: rp2
            }),
            !standard.render ? null : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$a3eb262d36d12799, {
                        className: (0, $7813c8cbdcd8987c$export$d6ca7d181b310028)($0914b2a8bc1aa49c$exports.first, ...std),
                        p1: $ec695bb278cff147$export$e16d8520af44a096(rp1)(wskOff),
                        p2: $ec695bb278cff147$export$e0f232dd469378a8(rp1)(wskOff)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$a3eb262d36d12799, {
                        className: (0, $7813c8cbdcd8987c$export$d6ca7d181b310028)($0914b2a8bc1aa49c$exports.final, ...std),
                        p1: $ec695bb278cff147$export$e16d8520af44a096(rp2)(wskOff),
                        p2: $ec695bb278cff147$export$e0f232dd469378a8(rp2)(wskOff)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$a3eb262d36d12799, {
                className: (0, $7813c8cbdcd8987c$export$d6ca7d181b310028)($0914b2a8bc1aa49c$exports.handle, ...handle?.labels ?? []),
                p1: rp1,
                p2: rp2,
                ...handlers
            }),
            !reading ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$89a89e5cd1cc47d1, {
                value: reading,
                anchor: $ec695bb278cff147$export$a61423b330c3444c(rp1, rp2),
                normal: offDir,
                fntsze: fntsze,
                preset: preset.label,
                hndlrs: hndlrs?.label,
                address: address,
                measure: $ec695bb278cff147$export$f93b5905241a7cca(rp2)(rp1),
                subject: $ec695bb278cff147$export$f93b5905241a7cca(sp2)(sp1)
            })
        ]
    });
};
const $5213f89aeaa4967a$export$ba4690435b051db = ()=>{
    const sketch = {
        points: new Map([
            [
                0,
                {
                    point: [
                        0,
                        0
                    ]
                }
            ],
            [
                1,
                {
                    point: [
                        100,
                        0
                    ]
                }
            ],
            [
                2,
                {
                    point: [
                        100,
                        100
                    ]
                }
            ],
            [
                3,
                {
                    point: [
                        0,
                        100
                    ]
                }
            ]
        ]),
        frames: new Map([
            [
                0,
                {
                    shape: [
                        [
                            0,
                            {}
                        ],
                        [
                            1,
                            {
                                c0: 2
                            }
                        ],
                        [
                            3,
                            {}
                        ]
                    ]
                }
            ]
        ]),
        rulers: new Map([
            [
                0,
                {
                    measure: {
                        first: 0,
                        final: 2
                    },
                    spacing: 10,
                    reading: {
                        unit: 'mm',
                        value: 300,
                        spacing: 5
                    }
                }
            ],
            [
                1,
                {
                    measure: {
                        first: 3,
                        root: 0,
                        final: 1
                    },
                    spacing: 0,
                    reading: {
                        unit: 'deg',
                        value: 90,
                        spacing: 0
                    }
                }
            ]
        ])
    };
    const handlers = {
        point: {
            onClick: (msg)=>()=>{
                    if (!msg) console.log('No msg');
                    else console.log('Hello from point: ', msg.address);
                }
        },
        chunk: {
            onClick: (msg)=>()=>{
                    if (!msg) console.log('No msg');
                    else console.log('Hello from chunk: ', msg.address);
                }
        },
        frame: {
            onClick: (msg)=>()=>{
                    if (!msg) console.log('No msg');
                    else console.log('Hello from frame: ', msg.address);
                }
        },
        ruler: {
            ruler: {
                onClick: (msg)=>()=>{
                        if (!msg) console.log('No msg');
                        else console.log('Hello from ruler handle: ', msg.address);
                    }
            },
            label: {
                onClick: (msg)=>()=>{
                        if (!msg) console.log('No msg');
                        else console.log('Hello from ruler reading: ', msg.address);
                    }
            }
        }
    };
    const preset = (0, $acw62.useMemo)(()=>(0, $c606faa825ef1d7d$export$891904c5d9d25883)(), []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5213f89aeaa4967a$export$fbe79e8ff00475af, {
        fntsze: 10,
        value: sketch,
        caster: (x)=>x,
        preset: preset,
        hndlrs: handlers,
        width: "100%",
        height: "100%"
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");












const $bf23bd84be779cc0$export$640171019d58eb6d = (n)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('CW'),
        value: (0, $87701c398fec8638$export$65e3907585753458)([
            n,
            n,
            n
        ])
    }, `CW<${n.name}>`);
const $bf23bd84be779cc0$export$d1c0b2903c6906e7 = (f)=>(cw)=>{
        const { value: [a, b, c] } = cw;
        const na = f(a);
        const nb = f(b);
        const nc = f(c);
        if (na === a && nb === b && nc === c) return cw;
        return {
            type: 'CW',
            value: [
                na,
                nb,
                nc
            ]
        };
    };
const $bf23bd84be779cc0$export$ce920184faf97f5 = (n)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('CCW'),
        value: (0, $87701c398fec8638$export$65e3907585753458)([
            n,
            n,
            n
        ])
    }, `CCW<${n.name}>`);
const $bf23bd84be779cc0$export$817376aff4a7544a = (f)=>(ccw)=>{
        const { value: [a, b, c] } = ccw;
        const na = f(a);
        const nb = f(b);
        const nc = f(c);
        if (na === a && nb === b && nc === c) return ccw;
        return {
            type: 'CCW',
            value: [
                na,
                nb,
                nc
            ]
        };
    };
const $bf23bd84be779cc0$export$d15f4cd5286f9b1e = (n)=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        $bf23bd84be779cc0$export$640171019d58eb6d(n),
        $bf23bd84be779cc0$export$ce920184faf97f5(n)
    ], `Selector<${n.name}>`);
const $bf23bd84be779cc0$export$6cdc1cb9345ffadf = (n)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Angle'),
        value: (0, $87701c398fec8638$export$65e3907585753458)([
            n,
            n,
            n,
            (0, $87701c398fec8638$export$98e628dec113755e)
        ])
    }, `Angle<${n.name}>`);
const $bf23bd84be779cc0$export$dbc627e74321aa3f = (a, b, c, ang)=>({
        type: 'Angle',
        value: [
            a,
            b,
            c,
            ang
        ]
    });
const $bf23bd84be779cc0$export$6153027b6a813976 = (f)=>(ang)=>{
        const [a, b, c, v] = ang.value;
        const nv = f(v);
        return v === nv ? ang : {
            ...ang,
            value: [
                a,
                b,
                c,
                nv
            ]
        };
    };
const $bf23bd84be779cc0$export$5bb0c5624f56c99a = (f)=>(angle)=>{
        const { value: [a, b, c, v] } = angle;
        const na = f(a);
        const nb = f(b);
        const nc = f(c);
        if (na === a && nb === b && nc === c) return angle;
        return {
            type: 'Angle',
            value: [
                na,
                nb,
                nc,
                v
            ]
        };
    };
const $bf23bd84be779cc0$export$3081247862d57e3d = (n)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Distance'),
        value: (0, $87701c398fec8638$export$65e3907585753458)([
            n,
            n,
            (0, $87701c398fec8638$export$98e628dec113755e)
        ])
    }, `Distance<${n.name}>`);
const $bf23bd84be779cc0$export$3093ea205c856b02 = (a, b, dst)=>({
        type: 'Distance',
        value: [
            a,
            b,
            dst
        ]
    });
const $bf23bd84be779cc0$export$73e21c5121b301eb = (f)=>(dst)=>{
        const [a, b, v] = dst.value;
        const nv = f(v);
        return v === nv ? dst : {
            ...dst,
            value: [
                a,
                b,
                nv
            ]
        };
    };
const $bf23bd84be779cc0$export$8849f150b783b959 = (f)=>(distance)=>{
        const { value: [a, b, v] } = distance;
        const na = f(a);
        const nb = f(b);
        if (na === a && nb === b) return distance;
        return {
            type: 'Distance',
            value: [
                na,
                nb,
                v
            ]
        };
    };
const $bf23bd84be779cc0$export$aec1359a0a40a615 = (n)=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        $bf23bd84be779cc0$export$6cdc1cb9345ffadf(n),
        $bf23bd84be779cc0$export$3081247862d57e3d(n)
    ], `Constraint<${n.name}>`);
const $bf23bd84be779cc0$export$29cd7b75162a9425 = (n)=>(v)=>(0, $87701c398fec8638$export$e5185e241753e543)(n, (0, $ec695bb278cff147$export$56c0d5a1e737357d)(v), `Config<${n.name}, ${v.name}>`);
const $bf23bd84be779cc0$export$c6c3c87cd94a0d0e = (fstr, codec)=>new (0, $87701c398fec8638$export$92738401e1603719)(`Reckey<${codec.name}>`, codec.is, (input, context)=>{
        if ((0, $87701c398fec8638$export$22b082955e083ec3).is(input)) {
            const value = fstr(input);
            return value === null ? (0, $87701c398fec8638$export$af2dba6db4e9e1f0)(input, context) : (0, $87701c398fec8638$export$fe7c49d056ea1d88)(value);
        }
        return codec.validate(input, context);
    }, (x)=>x);
const $bf23bd84be779cc0$export$6bafb675e654df79 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('CacheMiss'),
    value: (0, $87701c398fec8638$export$98e628dec113755e)
}, 'CacheMiss');
const $bf23bd84be779cc0$export$f86ad16a25c10e1b = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('NoCluster'),
    value: (0, $87701c398fec8638$export$98e628dec113755e)
}, 'NoCluster');
const $bf23bd84be779cc0$export$b9e24f3487cb59b3 = (t)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('BadType'),
        value: (0, $87701c398fec8638$export$65e3907585753458)([
            t,
            (0, $87701c398fec8638$export$98e628dec113755e)
        ])
    }, `BadType<${t.name}>`);
const $bf23bd84be779cc0$export$2bd761e68dca34fb = (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Rigid');
const $bf23bd84be779cc0$export$c04a4665dc6c306a = (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Radial');
const $bf23bd84be779cc0$export$1e033a1cf24594e5 = (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Scalable');
const $bf23bd84be779cc0$export$51c022a791a45191 = $bf23bd84be779cc0$export$b9e24f3487cb59b3($bf23bd84be779cc0$export$2bd761e68dca34fb);
const $bf23bd84be779cc0$export$4a4c0a11f39f2a2f = $bf23bd84be779cc0$export$b9e24f3487cb59b3($bf23bd84be779cc0$export$c04a4665dc6c306a);
const $bf23bd84be779cc0$export$b05e73b0857bdbe7 = $bf23bd84be779cc0$export$b9e24f3487cb59b3($bf23bd84be779cc0$export$1e033a1cf24594e5);
const $bf23bd84be779cc0$export$a2f9d9fac9d12057 = (0, $87701c398fec8638$export$bf9fb029d174d554)({
    type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('Impossible'),
    value: (0, $87701c398fec8638$export$22b082955e083ec3)
}, 'Impossible');
const $bf23bd84be779cc0$export$26e841bcf1aeb894 = (n)=>(0, $87701c398fec8638$export$bf9fb029d174d554)({
        type: (0, $87701c398fec8638$export$c8ec6e1ec9fefcb0)('FetchError'),
        value: n
    }, 'FetchError');
const $bf23bd84be779cc0$export$c2334a830922c5c4 = (n)=>(0, $87701c398fec8638$export$971dd5b0dfd021b6)([
        $bf23bd84be779cc0$export$6bafb675e654df79,
        $bf23bd84be779cc0$export$f86ad16a25c10e1b,
        $bf23bd84be779cc0$export$51c022a791a45191,
        $bf23bd84be779cc0$export$4a4c0a11f39f2a2f,
        $bf23bd84be779cc0$export$b05e73b0857bdbe7,
        $bf23bd84be779cc0$export$a2f9d9fac9d12057,
        $bf23bd84be779cc0$export$26e841bcf1aeb894(n)
    ]);


const $b4bda917597b51a5$export$6f53315f92b3cf4b = (s)=>{
    const value = Number(s);
    return isNaN(value) ? null : value;
};
const $b4bda917597b51a5$export$c55ac50533417adc = (req)=>(cons)=>req.request((0, $87701c398fec8638$export$2f23118c22fb2630)((0, $bf23bd84be779cc0$export$29cd7b75162a9425)((0, $bf23bd84be779cc0$export$c6c3c87cd94a0d0e)($b4bda917597b51a5$export$6f53315f92b3cf4b, (0, $87701c398fec8638$export$98e628dec113755e)))((0, $d99ec1e84f6a18d9$export$9b589fb896e0ad32))))('geosol/simple/2D/', 'POST', cons);




const $b9dc988ac65b926a$export$9e770fa6ce19a9d6 = ([a, _])=>a;
const $b9dc988ac65b926a$export$6f71268a1666ab58 = ([_, b])=>b;
const $b9dc988ac65b926a$export$48cfd1e771a65c4f = ()=>(0, $58f80d7b57eba59b$export$94132a0e348806d4)('next');
const $b9dc988ac65b926a$export$4051a07651545597 = ()=>(0, $58f80d7b57eba59b$export$94132a0e348806d4)('data');
const $b9dc988ac65b926a$export$7061c75fc5af8b7e = (k)=>(f)=>(i)=>{
            const cv = i.data.get(k);
            if (!cv) return i;
            const nv = f(cv);
            if (!nv || nv === cv) return i;
            const data = new Map(i.data);
            data.set(k, nv);
            return {
                ...i,
                data: data
            };
        };
const $b9dc988ac65b926a$export$dd44f18ab656f3bb = (data)=>({
        next: data?.length ?? 0,
        data: new Map(data?.map((v, i)=>[
                i,
                v
            ]))
    });
const $b9dc988ac65b926a$export$4cbf152802aa238 = (...vals)=>(index)=>{
        let next = index.next;
        const data = new Map(index.data);
        for (const v of vals)data.set(next++, v);
        return {
            next: next,
            data: data
        };
    };
const $b9dc988ac65b926a$export$531574274d96d9f4 = (config)=>{
    const result = new Map();
    Object.keys(config).forEach((k)=>{
        const key = Number(k);
        if (isNaN(key)) {
            console.warn('Invalid \'Config\' key:', k);
            return;
        }
        const val = config[key];
        if (!val) {
            console.warn('Invalid \'Config\' val:', val);
            return;
        }
        result.set(key, val);
    });
    return result;
};
const $b9dc988ac65b926a$export$173bf19fd6f30397 = (config)=>{
    const data = $b9dc988ac65b926a$export$531574274d96d9f4(config);
    const next = data.size === 0 ? 0 : Math.max(...data.keys()) + 1;
    return {
        next: next,
        data: data
    };
};





const $5e197d6ee8aae64d$export$378ebb5d22b184dc = (a)=>a * Math.PI / 180;
const $5e197d6ee8aae64d$export$fc1400facf92c78 = (x, y)=>(l)=>({
            type: 'Len',
            dist: $bf23bd84be779cc0$export$3093ea205c856b02(x, y, l)
        });
const $5e197d6ee8aae64d$export$6c4a311cc157c764 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('dist');
const $5e197d6ee8aae64d$export$4b0df07277963c4b = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($5e197d6ee8aae64d$export$6c4a311cc157c764, $bf23bd84be779cc0$export$73e21c5121b301eb);
const $5e197d6ee8aae64d$export$89f6af3b05896e9 = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($5e197d6ee8aae64d$export$6c4a311cc157c764, $bf23bd84be779cc0$export$8849f150b783b959);
const $5e197d6ee8aae64d$export$b227ccbcf2260027 = (wise)=>wise === 'CW' ? 'CCW' : 'CW';
const $5e197d6ee8aae64d$export$dbc627e74321aa3f = (x, y, z)=>(a)=>(w)=>({
                type: 'Ang',
                wise: w,
                degs: a,
                angl: $bf23bd84be779cc0$export$dbc627e74321aa3f(x, y, z, $5e197d6ee8aae64d$export$378ebb5d22b184dc(a))
            });
const $5e197d6ee8aae64d$export$e101cee8f35760fb = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('wise');
const $5e197d6ee8aae64d$export$db5cdf2abe7c6936 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('degs');
const $5e197d6ee8aae64d$export$6e2928c7ea6a7bf3 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('angl');
const $5e197d6ee8aae64d$export$5bb0c5624f56c99a = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($5e197d6ee8aae64d$export$6e2928c7ea6a7bf3, $bf23bd84be779cc0$export$5bb0c5624f56c99a);
const $5e197d6ee8aae64d$export$6153027b6a813976 = (f)=>(ang)=>{
        const val = f(ang.degs);
        const res = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)($5e197d6ee8aae64d$export$db5cdf2abe7c6936)(val), (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($5e197d6ee8aae64d$export$6e2928c7ea6a7bf3, $bf23bd84be779cc0$export$6153027b6a813976))($5e197d6ee8aae64d$export$378ebb5d22b184dc(val)))(ang);
        return res === ang ? ang : res;
    };
const $5e197d6ee8aae64d$export$38a447969800c48d = ({ wise: wise, angl: { value: p } })=>({
        type: wise,
        value: [
            p[0],
            p[1],
            p[2]
        ]
    });
const $5e197d6ee8aae64d$export$187615b8520c1978 = (raw)=>raw.type === 'Len';
const $5e197d6ee8aae64d$export$2d1af5b4d0b7c63 = (raw)=>raw.type === 'Ang';
const $5e197d6ee8aae64d$export$ec8040a719e829b4 = (f)=>(raw)=>$5e197d6ee8aae64d$export$187615b8520c1978(raw) ? (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($5e197d6ee8aae64d$export$395f9f781e0ecd12, $5e197d6ee8aae64d$export$4b0df07277963c4b)(f)(raw) : (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($5e197d6ee8aae64d$export$cbf535030f215d89, $5e197d6ee8aae64d$export$6153027b6a813976)(f)(raw);
const $5e197d6ee8aae64d$export$395f9f781e0ecd12 = (0, $58f80d7b57eba59b$export$9c59b80dda569a6e)($5e197d6ee8aae64d$export$187615b8520c1978);
const $5e197d6ee8aae64d$export$cbf535030f215d89 = (0, $58f80d7b57eba59b$export$9c59b80dda569a6e)($5e197d6ee8aae64d$export$2d1af5b4d0b7c63);
const $5e197d6ee8aae64d$export$15ddcc5e53a3e282 = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($5e197d6ee8aae64d$export$cbf535030f215d89, $5e197d6ee8aae64d$export$e101cee8f35760fb);
const $5e197d6ee8aae64d$export$9f3779769916793c = (raw)=>$5e197d6ee8aae64d$export$187615b8520c1978(raw) ? Math.max(...(0, $58f80d7b57eba59b$export$3988ae62b71be9a3)($bf23bd84be779cc0$export$8849f150b783b959)(raw.dist)) : Math.max(...(0, $58f80d7b57eba59b$export$3988ae62b71be9a3)($bf23bd84be779cc0$export$5bb0c5624f56c99a)(raw.angl));
const $5e197d6ee8aae64d$export$94b0aa9bf6bbcceb = (raws)=>Math.max(...raws.map($5e197d6ee8aae64d$export$9f3779769916793c));
const $5e197d6ee8aae64d$export$e87bfa2a4c6bccb0 = (first, root, final)=>(radius)=>({
            type: 'Rnd',
            first: first,
            root: root,
            final: final,
            radius: radius
        });
const $5e197d6ee8aae64d$export$d0ee7ae8f1bb78a0 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('radius');
const $5e197d6ee8aae64d$export$e5df1f6a8a5a78fb = (f)=>(rnd)=>{
        const { root: root, first: first, final: final, radius: radius } = rnd;
        const rt = f(root);
        const fs = f(first);
        const fn = f(final);
        if (root === rt && first === fs && final === fn) return rnd;
        return {
            type: 'Rnd',
            root: rt,
            first: fs,
            final: fn,
            radius: radius
        };
    };
const $5e197d6ee8aae64d$export$ca49d7cd8ea40ba7 = (first, final, value, node, side)=>({
        type: 'Out',
        first: first,
        final: final,
        value: value,
        node: node,
        side: side
    });
const $5e197d6ee8aae64d$export$1ed76074fcc3565f = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('value');
const $5e197d6ee8aae64d$export$2585a69503f8755d = (f)=>(out)=>{
        const { first: first, final: final, ...rest } = out;
        const fs = f(first);
        const fn = f(final);
        if (first === fs && final === fn) return out;
        return {
            ...rest,
            first: fs,
            final: fn
        };
    };
const $5e197d6ee8aae64d$export$510e404e5fc11dff = (con)=>con.type === 'Len';
const $5e197d6ee8aae64d$export$dec9fdc8cb029188 = (con)=>con.type === 'Ang';
const $5e197d6ee8aae64d$export$d0b1979942e564a5 = (con)=>con.type === 'Rnd';
const $5e197d6ee8aae64d$export$43dc9c0bc0c109d8 = (con)=>con.type === 'Out';
const $5e197d6ee8aae64d$export$31f3e8a72eb0e9d3 = (f)=>(con)=>{
        switch(con.type){
            case 'Len':
                return $5e197d6ee8aae64d$export$89f6af3b05896e9(f)(con);
            case 'Ang':
                return $5e197d6ee8aae64d$export$5bb0c5624f56c99a(f)(con);
            case 'Rnd':
                return $5e197d6ee8aae64d$export$e5df1f6a8a5a78fb(f)(con);
            case 'Out':
                return $5e197d6ee8aae64d$export$2585a69503f8755d(f)(con);
        }
    };
const $5e197d6ee8aae64d$export$8c4816a110c965f9 = (f)=>(con)=>{
        switch(con.type){
            case 'Len':
                return (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($5e197d6ee8aae64d$export$40c466049faea864, $5e197d6ee8aae64d$export$4b0df07277963c4b)(f)(con);
            case 'Ang':
                return (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($5e197d6ee8aae64d$export$9955ce399a2d03d1, $5e197d6ee8aae64d$export$6153027b6a813976)(f)(con);
            case 'Rnd':
                return (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($5e197d6ee8aae64d$export$4076cf0a55ee62e9, $5e197d6ee8aae64d$export$d0ee7ae8f1bb78a0)(f)(con);
            case 'Out':
                return (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($5e197d6ee8aae64d$export$5062cbacc09a3513, $5e197d6ee8aae64d$export$1ed76074fcc3565f)(f)(con);
        }
    };
const $5e197d6ee8aae64d$export$40c466049faea864 = (0, $58f80d7b57eba59b$export$9c59b80dda569a6e)($5e197d6ee8aae64d$export$510e404e5fc11dff);
const $5e197d6ee8aae64d$export$9955ce399a2d03d1 = (0, $58f80d7b57eba59b$export$9c59b80dda569a6e)($5e197d6ee8aae64d$export$dec9fdc8cb029188);
const $5e197d6ee8aae64d$export$4076cf0a55ee62e9 = (0, $58f80d7b57eba59b$export$9c59b80dda569a6e)($5e197d6ee8aae64d$export$d0b1979942e564a5);
const $5e197d6ee8aae64d$export$5062cbacc09a3513 = (0, $58f80d7b57eba59b$export$9c59b80dda569a6e)($5e197d6ee8aae64d$export$43dc9c0bc0c109d8);
const $5e197d6ee8aae64d$export$912bfe39c298977d = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($5e197d6ee8aae64d$export$9955ce399a2d03d1, $5e197d6ee8aae64d$export$e101cee8f35760fb);
const $5e197d6ee8aae64d$export$1dd3390d835d3b3b = (idx)=>(con)=>Math.max(idx, Math.max(...(0, $58f80d7b57eba59b$export$3988ae62b71be9a3)($5e197d6ee8aae64d$export$31f3e8a72eb0e9d3)(con)) + 1);
const $5e197d6ee8aae64d$export$ecaf328d93852295 = (idx)=>(con)=>{
        const cix = $5e197d6ee8aae64d$export$1dd3390d835d3b3b(idx)(con);
        if ($5e197d6ee8aae64d$export$d0b1979942e564a5(con)) return cix + 6;
        if ($5e197d6ee8aae64d$export$43dc9c0bc0c109d8(con)) return cix + 1;
        return cix;
    };
const $5e197d6ee8aae64d$export$30770db3509a596b = (ix)=>(rnd)=>{
        const idx = $5e197d6ee8aae64d$export$1dd3390d835d3b3b(ix)(rnd);
        const { root: root, first: first, final: final, radius: radius } = rnd;
        return [
            $5e197d6ee8aae64d$export$fc1400facf92c78(idx + 0, root)(radius),
            $5e197d6ee8aae64d$export$dbc627e74321aa3f(idx + 0, root, final)(90)('CCW'),
            $5e197d6ee8aae64d$export$fc1400facf92c78(root, idx + 1)(radius),
            $5e197d6ee8aae64d$export$dbc627e74321aa3f(first, root, idx + 1)(90)('CCW'),
            $5e197d6ee8aae64d$export$dbc627e74321aa3f(idx + 2, idx + 0, root)(90)('CCW'),
            $5e197d6ee8aae64d$export$dbc627e74321aa3f(root, idx + 1, idx + 2)(90)('CCW'),
            $5e197d6ee8aae64d$export$fc1400facf92c78(idx + 2, idx + 3)(radius),
            $5e197d6ee8aae64d$export$dbc627e74321aa3f(idx + 2, idx + 3, root)(90)('CCW'),
            $5e197d6ee8aae64d$export$fc1400facf92c78(idx + 2, idx + 4)(radius),
            $5e197d6ee8aae64d$export$dbc627e74321aa3f(root, idx + 4, idx + 2)(90)('CCW'),
            $5e197d6ee8aae64d$export$fc1400facf92c78(idx + 2, idx + 5)(radius),
            $5e197d6ee8aae64d$export$dbc627e74321aa3f(idx + 2, idx + 5, root)(180)('CCW')
        ];
    };
const $5e197d6ee8aae64d$export$a02695d3303d27e4 = (ix)=>(out)=>{
        const idx = $5e197d6ee8aae64d$export$1dd3390d835d3b3b(ix)(out);
        const { first: first, final: final, value: value, side: side, node: node } = out;
        const off = node === 'First' ? first : final;
        const acon = node === 'Final' ? $5e197d6ee8aae64d$export$dbc627e74321aa3f(first, final, idx)(90)(side === 'Left' ? 'CCW' : 'CW') : $5e197d6ee8aae64d$export$dbc627e74321aa3f(final, first, idx)(90)(side === 'Left' ? 'CW' : 'CCW');
        return [
            $5e197d6ee8aae64d$export$fc1400facf92c78(off, idx)(value),
            acon
        ];
    };
const $5e197d6ee8aae64d$export$e2dd7a4768ac16a7 = (idx)=>(con)=>{
        switch(con.type){
            case 'Len':
                return [
                    con
                ];
            case 'Ang':
                return [
                    con
                ];
            case 'Rnd':
                return $5e197d6ee8aae64d$export$30770db3509a596b(idx)(con);
            case 'Out':
                return $5e197d6ee8aae64d$export$a02695d3303d27e4(idx)(con);
        }
    };
const $5e197d6ee8aae64d$export$3b216fd1a3f59116 = (idx)=>(cons)=>{
        let nidx = idx;
        const raws = [];
        for (const con of cons){
            const batch = $5e197d6ee8aae64d$export$e2dd7a4768ac16a7(nidx)(con);
            nidx = $5e197d6ee8aae64d$export$94b0aa9bf6bbcceb(batch) + 1;
            batch.forEach((x)=>raws.push(x));
        }
        return raws;
    };


const $bcf549f190757517$export$f53bacac58a98464 = [
    'house',
    'rectangle',
    'rounded_corner'
];
const $bcf549f190757517$export$48bc4889aeb285ae = {
    'house': {
        pnts: $b9dc988ac65b926a$export$dd44f18ab656f3bb(),
        cons: $b9dc988ac65b926a$export$dd44f18ab656f3bb([
            (0, $5e197d6ee8aae64d$export$fc1400facf92c78)(0, 1)(400),
            (0, $5e197d6ee8aae64d$export$fc1400facf92c78)(1, 2)(400),
            (0, $5e197d6ee8aae64d$export$fc1400facf92c78)(3, 0)(400),
            (0, $5e197d6ee8aae64d$export$dbc627e74321aa3f)(0, 1, 2)(90)('CCW'),
            (0, $5e197d6ee8aae64d$export$dbc627e74321aa3f)(3, 0, 1)(90)('CCW'),
            (0, $5e197d6ee8aae64d$export$fc1400facf92c78)(1, 4)(100),
            (0, $5e197d6ee8aae64d$export$dbc627e74321aa3f)(1, 4, 2)(180)('CCW'),
            (0, $5e197d6ee8aae64d$export$fc1400facf92c78)(5, 0)(100),
            (0, $5e197d6ee8aae64d$export$dbc627e74321aa3f)(3, 5, 0)(180)('CCW'),
            (0, $5e197d6ee8aae64d$export$fc1400facf92c78)(2, 6)(200),
            (0, $5e197d6ee8aae64d$export$dbc627e74321aa3f)(2, 6, 3)(180)('CCW'),
            (0, $5e197d6ee8aae64d$export$e87bfa2a4c6bccb0)(4, 6, 5)(50)
        ]),
        pics: [
            [
                [
                    0,
                    {}
                ],
                [
                    1,
                    {}
                ],
                [
                    4,
                    {}
                ],
                [
                    10,
                    {
                        c0: 12
                    }
                ],
                [
                    11,
                    {}
                ],
                [
                    5,
                    {}
                ]
            ]
        ]
    },
    'rectangle': {
        pnts: $b9dc988ac65b926a$export$dd44f18ab656f3bb(),
        cons: $b9dc988ac65b926a$export$dd44f18ab656f3bb([
            (0, $5e197d6ee8aae64d$export$fc1400facf92c78)(0, 1)(400),
            (0, $5e197d6ee8aae64d$export$fc1400facf92c78)(1, 2)(200),
            (0, $5e197d6ee8aae64d$export$fc1400facf92c78)(3, 0)(200),
            (0, $5e197d6ee8aae64d$export$dbc627e74321aa3f)(0, 1, 2)(90)('CCW'),
            (0, $5e197d6ee8aae64d$export$dbc627e74321aa3f)(3, 0, 1)(90)('CCW')
        ]),
        pics: [
            [
                [
                    0,
                    {}
                ],
                [
                    1,
                    {}
                ],
                [
                    2,
                    {}
                ],
                [
                    3,
                    {}
                ]
            ]
        ]
    },
    'rounded_corner': {
        pnts: $b9dc988ac65b926a$export$dd44f18ab656f3bb(),
        cons: $b9dc988ac65b926a$export$dd44f18ab656f3bb([
            (0, $5e197d6ee8aae64d$export$fc1400facf92c78)(0, 1)(400),
            (0, $5e197d6ee8aae64d$export$fc1400facf92c78)(1, 2)(200),
            (0, $5e197d6ee8aae64d$export$fc1400facf92c78)(3, 0)(200),
            (0, $5e197d6ee8aae64d$export$dbc627e74321aa3f)(0, 1, 2)(90)('CCW'),
            (0, $5e197d6ee8aae64d$export$dbc627e74321aa3f)(3, 0, 1)(90)('CCW'),
            (0, $5e197d6ee8aae64d$export$e87bfa2a4c6bccb0)(0, 1, 2)(50)
        ]),
        pics: [
            [
                [
                    7,
                    {
                        c0: 9
                    }
                ],
                [
                    8,
                    {}
                ],
                [
                    2,
                    {}
                ],
                [
                    3,
                    {
                        c0: 0
                    }
                ]
            ]
        ]
    }
};
var $bcf549f190757517$export$2e2bcd8739ae039 = $bcf549f190757517$export$48bc4889aeb285ae;









const $b709af327d5368f5$export$de53b258f2116f75 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('pnts');
const $b709af327d5368f5$export$8327ebbef2a0ba76 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('cons');
const $b709af327d5368f5$export$30265e9ecc990b5b = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('pics');
const $b709af327d5368f5$export$6c7d60e8e51b670d = (cid)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($b709af327d5368f5$export$8327ebbef2a0ba76, (0, $b9dc988ac65b926a$export$7061c75fc5af8b7e)(cid));
const $b709af327d5368f5$export$b3f70301b574f9e8 = (cid)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($b709af327d5368f5$export$6c7d60e8e51b670d(cid), (0, $58f80d7b57eba59b$export$4a65a988b6cd1e7e)((0, $5e197d6ee8aae64d$export$8c4816a110c965f9)));
const $b709af327d5368f5$export$8bafe30decf493f0 = (cid)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($b709af327d5368f5$export$6c7d60e8e51b670d(cid), (0, $58f80d7b57eba59b$export$4a65a988b6cd1e7e)((0, $5e197d6ee8aae64d$export$912bfe39c298977d)));
const $b709af327d5368f5$export$d279480762cc3301 = (cid)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($b709af327d5368f5$export$6c7d60e8e51b670d(cid), (0, $58f80d7b57eba59b$export$4a65a988b6cd1e7e)((0, $5e197d6ee8aae64d$export$40c466049faea864)), (0, $58f80d7b57eba59b$export$4a65a988b6cd1e7e)((0, $5e197d6ee8aae64d$export$4b0df07277963c4b)));
const $b709af327d5368f5$export$698e8be98fd709c5 = (cid)=>(0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)($b709af327d5368f5$export$6c7d60e8e51b670d(cid), (0, $58f80d7b57eba59b$export$4a65a988b6cd1e7e)((0, $5e197d6ee8aae64d$export$9955ce399a2d03d1)), (0, $58f80d7b57eba59b$export$4a65a988b6cd1e7e)((0, $5e197d6ee8aae64d$export$6153027b6a813976)));
const $b709af327d5368f5$export$c2e7248aaa27119b = (design)=>{
    const cons = (0, $5e197d6ee8aae64d$export$3b216fd1a3f59116)(0)([
        ...design.cons.data.values()
    ]);
    return {
        Selectors: cons.filter((0, $5e197d6ee8aae64d$export$2d1af5b4d0b7c63)).filter((c)=>c.degs !== 180).map((0, $5e197d6ee8aae64d$export$38a447969800c48d)),
        Constraints: cons.map((con)=>(0, $5e197d6ee8aae64d$export$2d1af5b4d0b7c63)(con) ? con.angl : con.dist)
    };
};
const $b709af327d5368f5$export$85012d2289c4838a = (basic)=>basic.map(([fst, chk], cid)=>{
        const fin = basic?.[cid + 1]?.[0] ?? basic[0][0];
        const handle = (0, $15a483b9f03099a6$export$1d2147785be8aae7)({
            cid: cid,
            fst: fst,
            fin: fin,
            chk: chk
        });
        return [
            fst,
            {
                ...chk,
                ...handle
            }
        ];
    });
const $b709af327d5368f5$export$6e85e3893c3640a3 = (basic, fid)=>{
    const shape = $b709af327d5368f5$export$85012d2289c4838a(basic);
    const handle = (0, $15a483b9f03099a6$export$1d2147785be8aae7)({
        fid: fid
    });
    return {
        shape: shape,
        ...handle
    };
};
const $b709af327d5368f5$export$34f5956919b10adc = (points)=>{
    const result = new Map();
    for (const [k, v] of points.data)result.set(k, {
        point: (0, $ec695bb278cff147$export$ffb5f4729a158638)(v)
    });
    return result;
};
const $b709af327d5368f5$export$e089874dda2f2071 = (basics)=>new Map(basics.map((b, i)=>[
            i,
            $b709af327d5368f5$export$6e85e3893c3640a3(b, i)
        ]));
const $b709af327d5368f5$export$4a50ae000fa67452 = (ang)=>(cid)=>{
        const { degs: degs, angl: { value: p } } = ang;
        const rhandle = (0, $15a483b9f03099a6$export$1d2147785be8aae7)({
            cid: cid,
            con: ang
        });
        const lhandle = (0, $15a483b9f03099a6$export$1d2147785be8aae7)({
            cid: cid,
            con: ang
        });
        const subject = {
            first: p[0],
            final: p[2]
        };
        const measure = {
            root: p[1],
            ...subject
        };
        const reading = {
            unit: "\xb0",
            value: degs,
            ...lhandle
        };
        const spacing = 5;
        return {
            subject: subject,
            measure: measure,
            reading: reading,
            spacing: spacing,
            ...rhandle
        };
    };
const $b709af327d5368f5$export$db598c0371160420 = (len)=>(cid)=>{
        const { dist: { value: p } } = len;
        const rhandle = (0, $15a483b9f03099a6$export$1d2147785be8aae7)({
            cid: cid,
            con: len
        });
        const lhandle = (0, $15a483b9f03099a6$export$1d2147785be8aae7)({
            cid: cid,
            con: len
        });
        const subject = {
            first: p[0],
            final: p[1]
        };
        const measure = subject;
        const reading = {
            unit: '"',
            value: p[2],
            ...lhandle
        };
        const spacing = 5;
        return {
            subject: subject,
            measure: measure,
            reading: reading,
            spacing: spacing,
            ...rhandle
        };
    };
const $b709af327d5368f5$export$db6aaf73ee203fb5 = (idx)=>(rnd)=>(cid)=>{
            const { radius: radius } = rnd;
            const rhandle = (0, $15a483b9f03099a6$export$1d2147785be8aae7)({
                cid: cid,
                con: rnd
            });
            const lhandle = (0, $15a483b9f03099a6$export$1d2147785be8aae7)({
                cid: cid,
                con: rnd
            });
            const subject = {
                first: idx + 2,
                final: idx + 5
            };
            const measure = subject;
            const reading = {
                unit: '"',
                value: radius,
                ...lhandle
            };
            const spacing = 0;
            return {
                subject: subject,
                measure: measure,
                reading: reading,
                spacing: spacing,
                ...rhandle
            };
        };
const $b709af327d5368f5$export$c0c6a59e626b8315 = (idx)=>(out)=>(cid)=>{
            const { value: value, first: first, final: final } = out;
            const source = out.node === 'First' ? first : final;
            const target = idx;
            const rhandle = (0, $15a483b9f03099a6$export$1d2147785be8aae7)({
                cid: cid,
                con: out
            });
            const lhandle = (0, $15a483b9f03099a6$export$1d2147785be8aae7)({
                cid: cid,
                con: out
            });
            const subject = {
                first: source,
                final: target
            };
            const measure = subject;
            const reading = {
                unit: '"',
                value: value,
                ...lhandle
            };
            const spacing = 5;
            return {
                subject: subject,
                measure: measure,
                reading: reading,
                spacing: spacing,
                ...rhandle
            };
        };
const $b709af327d5368f5$export$e5df5e7560a54b7f = (idx)=>(con)=>{
        switch(con.type){
            case 'Len':
                return $b709af327d5368f5$export$db598c0371160420(con);
            case 'Ang':
                return $b709af327d5368f5$export$4a50ae000fa67452(con);
            case 'Rnd':
                return $b709af327d5368f5$export$db6aaf73ee203fb5(idx)(con);
            case 'Out':
                return $b709af327d5368f5$export$c0c6a59e626b8315(idx)(con);
        }
    };
const $b709af327d5368f5$export$977233dede86815a = (ix)=>(consts)=>{
        let idx = ix;
        const result = new Map();
        for (const [k, c] of consts.data){
            result.set(k, $b709af327d5368f5$export$e5df5e7560a54b7f(idx)(c)(k));
            idx = (0, $5e197d6ee8aae64d$export$ecaf328d93852295)(idx)(c);
        }
        return result;
    };
const $b709af327d5368f5$export$2ba24979560a9591 = (design)=>{
    const points = $b709af327d5368f5$export$34f5956919b10adc(design.pnts);
    const frames = $b709af327d5368f5$export$e089874dda2f2071(design.pics);
    const rulers = $b709af327d5368f5$export$977233dede86815a(0)(design.cons);
    return {
        points: points,
        frames: frames,
        rulers: rulers
    };
};




const $95e9e4973720f4e5$export$e7329bbec379424f = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('stype');
const $95e9e4973720f4e5$export$2cef06c20297c17d = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('frame');
const $95e9e4973720f4e5$export$17a1664ed1fb5d6f = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('items');
const $95e9e4973720f4e5$export$99383ad763c1c561 = (stype, frame, ...items)=>({
        stype: stype,
        frame: frame,
        items: items
    });
const $95e9e4973720f4e5$export$9e3345a7f8ed9fcb = (a)=>(b)=>{
        if (a.stype !== b.stype || a.frame !== b.frame) return b;
        const nedges = [
            ...a.items.filter((e)=>!b.items.includes(e)),
            ...b.items.filter((e)=>!a.items.includes(e))
        ];
        return {
            stype: b.stype,
            frame: b.frame,
            items: nedges
        };
    };
const $95e9e4973720f4e5$export$232faf9add678146 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('prev');
const $95e9e4973720f4e5$export$8876b4fa1dca8c1f = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('curr');
const $95e9e4973720f4e5$export$3df11c9c20e7b288 = (0, $58f80d7b57eba59b$export$94132a0e348806d4)('done');
const $95e9e4973720f4e5$export$bce53fe721d95cb1 = (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('sels');
const $95e9e4973720f4e5$export$b1e5508a851be14d = (0, $58f80d7b57eba59b$export$b17a4b0e65bc778c)('menu');
const $95e9e4973720f4e5$export$f3a2a5c7ad654c3 = (design)=>({
        prev: [],
        curr: design,
        done: false
    });



const $7e3b1af46fff8b0c$export$999d6962397e4d2d = (points)=>({
        type: 'MsgSetPts',
        points: points
    });
const $7e3b1af46fff8b0c$export$914e7d4d3a81444c = (config)=>$7e3b1af46fff8b0c$export$999d6962397e4d2d((0, $b9dc988ac65b926a$export$173bf19fd6f30397)(config));
const $7e3b1af46fff8b0c$export$9d18de0472378f09 = (done)=>({
        type: 'MsgSetDone',
        done: done
    });
const $7e3b1af46fff8b0c$export$98efdf9b7eb12036 = (lenid, value)=>({
        type: 'MsgSetLen',
        lenid: lenid,
        value: value
    });
const $7e3b1af46fff8b0c$export$de65d0cf007063fa = (angid, value)=>({
        type: 'MsgSetAng',
        angid: angid,
        value: value
    });
const $7e3b1af46fff8b0c$export$b1cfaaa4653d855e = (valid, value)=>({
        type: 'MsgSetVal',
        valid: valid,
        value: value
    });
const $7e3b1af46fff8b0c$export$db3e87841a823c93 = {
    type: 'MsgUnDo'
};
const $7e3b1af46fff8b0c$export$28469d1c5cfc5b12 = (wiseid)=>({
        type: 'MsgTogWise',
        wiseid: wiseid
    });
const $7e3b1af46fff8b0c$export$d649b6842e09f2b = (side)=>side === 'Left';
const $7e3b1af46fff8b0c$export$a9d71693f0c1a85d = (side)=>side === 'Right';
const $7e3b1af46fff8b0c$export$e33ae691b63d89d5 = (frameid, chunkid, splitOn, length)=>({
        type: 'MsgSplitEdge',
        frameid: frameid,
        chunkid: chunkid,
        splitOn: splitOn,
        length: length
    });
const $7e3b1af46fff8b0c$export$6795d3f14a4dc17d = (frameid, chunkid, singular)=>({
        type: 'MsgSelectEdge',
        frameid: frameid,
        chunkid: chunkid,
        singular: singular
    });
const $7e3b1af46fff8b0c$export$2dcd94a2223fb79 = {
    type: 'MsgClearSelection'
};
const $7e3b1af46fff8b0c$export$10a63fcde820666 = (frameid, nodeid, singular)=>({
        type: 'MsgSelectNode',
        frameid: frameid,
        nodeid: nodeid,
        singular: singular
    });
const $7e3b1af46fff8b0c$export$db2f6ec3a61fb25c = (frameid, nodeid, radius)=>({
        type: 'MsgRoundCorner',
        frameid: frameid,
        nodeid: nodeid,
        radius: radius
    });
const $7e3b1af46fff8b0c$export$f5722fccec377315 = (menu)=>({
        type: 'MsgOpenPie',
        menu: menu
    });
const $7e3b1af46fff8b0c$export$10b5bf8daf4331e = {
    type: 'MsgClosePie'
};
const $7e3b1af46fff8b0c$export$17576e07b3e88340 = (frameid, first, final, value, side, node)=>({
        type: 'MsgOutage',
        frameid: frameid,
        first: first,
        final: final,
        value: value,
        side: side,
        node: node
    });


const $54bede46567a0f77$export$1650419e431d3ba3 = (state, msg)=>{
    const history = state.prev;
    const noHistory = history.length === 0;
    const settled = state.done || noHistory;
    switch(msg.type){
        case 'MsgSetPts':
            return (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $95e9e4973720f4e5$export$3df11c9c20e7b288))(true), (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $95e9e4973720f4e5$export$8876b4fa1dca8c1f), (0, $b709af327d5368f5$export$de53b258f2116f75)))(msg.points))(state);
        case 'MsgSetDone':
            return (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $95e9e4973720f4e5$export$3df11c9c20e7b288))(msg.done)(state);
        case 'MsgSetVal':
            {
                if (!settled) return state;
                const ncurr = (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $b709af327d5368f5$export$b3f70301b574f9e8)(msg.valid))(msg.value)(state.curr);
                if (ncurr === state.curr) return state;
                const newState = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $95e9e4973720f4e5$export$3df11c9c20e7b288))(false), (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $95e9e4973720f4e5$export$8876b4fa1dca8c1f))(ncurr), (0, $95e9e4973720f4e5$export$232faf9add678146)((ps)=>[
                        ...ps,
                        state.curr
                    ]))(state);
                return newState;
            }
        case 'MsgUnDo':
            {
                if (noHistory || !state.done) return state;
                const newState = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $95e9e4973720f4e5$export$8876b4fa1dca8c1f)((cd)=>state.prev?.[history.length - 1] ?? cd), (0, $95e9e4973720f4e5$export$232faf9add678146)((ps)=>ps.slice(0, -1)))(state);
                return newState;
            }
        case 'MsgTogWise':
            {
                if (!settled) return state;
                const ncurr = (0, $b709af327d5368f5$export$8bafe30decf493f0)(msg.wiseid)((0, $58f80d7b57eba59b$export$2b91d3689f613272)((0, $5e197d6ee8aae64d$export$b227ccbcf2260027)))(state.curr);
                if (ncurr === state.curr) return state;
                const newState = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $95e9e4973720f4e5$export$3df11c9c20e7b288))(false), (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $95e9e4973720f4e5$export$8876b4fa1dca8c1f))(ncurr), (0, $95e9e4973720f4e5$export$232faf9add678146)((ps)=>[
                        ...ps,
                        state.curr
                    ]))(state);
                return newState;
            }
        case 'MsgSplitEdge':
            {
                if (!settled) return state;
                const pict = state.curr.pics?.[msg.frameid];
                const edge = pict?.[msg.chunkid];
                const next = pict?.[msg.chunkid + 1] ?? pict?.[0];
                if (!pict || !edge || !next || (0, $03c1d17e9908deb0$export$b69c36657e42ff85)(edge[1]) || (0, $03c1d17e9908deb0$export$88937bcd61c5d498)(edge[1])) return state;
                const npic = (0, $eb00536c18f59e28$export$13c2781d1a051e49)(edge[0], [
                    state.curr.pnts.next
                ], next[0])(pict);
                const pprev = edge[0];
                const pcurr = state.curr.pnts.next;
                const pnext = pict[msg.chunkid + 1]?.[0] ?? pict[0][0];
                const conLen = (0, $7e3b1af46fff8b0c$export$d649b6842e09f2b)(msg.splitOn) ? (0, $5e197d6ee8aae64d$export$fc1400facf92c78)(pprev, pcurr)(msg.length) : (0, $5e197d6ee8aae64d$export$fc1400facf92c78)(pcurr, pnext)(msg.length);
                const conAng = (0, $5e197d6ee8aae64d$export$dbc627e74321aa3f)(pprev, pcurr, pnext)(180)('CCW');
                const ncons = (0, $b9dc988ac65b926a$export$4cbf152802aa238)(conLen, conAng)(state.curr.cons);
                const newState = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $95e9e4973720f4e5$export$3df11c9c20e7b288))(false), (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $95e9e4973720f4e5$export$8876b4fa1dca8c1f), (0, $b709af327d5368f5$export$30265e9ecc990b5b), (0, $58f80d7b57eba59b$export$b610b8812bbcded9)(msg.frameid)))(npic), (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $95e9e4973720f4e5$export$8876b4fa1dca8c1f), (0, $b709af327d5368f5$export$8327ebbef2a0ba76)))(ncons), (0, $95e9e4973720f4e5$export$232faf9add678146)((ps)=>[
                        ...ps,
                        state.curr
                    ]))(state);
                return newState;
            }
        case 'MsgOutage':
            {
                if (!settled) return state;
                const pict = state.curr.pics?.[msg.frameid];
                if (!pict) return state;
                const cix = state.curr.pnts.next;
                const tgtn = msg.node === 'First' ? msg.first : msg.final;
                const npic = $eb00536c18f59e28$export$25d367e02170840((n)=>n === tgtn ? cix : n)(pict);
                const con = $5e197d6ee8aae64d$export$ca49d7cd8ea40ba7(msg.first, msg.final, msg.value, msg.node, msg.side);
                const ncons = (0, $b9dc988ac65b926a$export$4cbf152802aa238)(con)(state.curr.cons);
                const newState = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $95e9e4973720f4e5$export$3df11c9c20e7b288))(false), (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $95e9e4973720f4e5$export$8876b4fa1dca8c1f), (0, $b709af327d5368f5$export$30265e9ecc990b5b), (0, $58f80d7b57eba59b$export$b610b8812bbcded9)(msg.frameid)))(npic), (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $95e9e4973720f4e5$export$8876b4fa1dca8c1f), (0, $b709af327d5368f5$export$8327ebbef2a0ba76)))(ncons), (0, $95e9e4973720f4e5$export$232faf9add678146)((ps)=>[
                        ...ps,
                        state.curr
                    ]))(state);
                return newState;
            }
        case 'MsgSelectEdge':
            {
                if (!settled) return state;
                const singl = (0, $95e9e4973720f4e5$export$99383ad763c1c561)('Edge', msg.frameid, msg.chunkid);
                if (!state?.sels) return {
                    ...state,
                    sels: singl
                };
                if (msg.singular) return {
                    ...state,
                    sels: singl
                };
                const nsels = (0, $95e9e4973720f4e5$export$9e3345a7f8ed9fcb)(state.sels)(singl);
                return {
                    ...state,
                    sels: nsels
                };
            }
        case 'MsgSelectNode':
            {
                if (!settled) return state;
                const singl = (0, $95e9e4973720f4e5$export$99383ad763c1c561)('Node', msg.frameid, msg.nodeid);
                if (!state?.sels) return {
                    ...state,
                    sels: singl
                };
                if (msg.singular) return {
                    ...state,
                    sels: singl
                };
                const nsels = (0, $95e9e4973720f4e5$export$9e3345a7f8ed9fcb)(state.sels)(singl);
                return {
                    ...state,
                    sels: nsels
                };
            }
        case 'MsgClearSelection':
            {
                if (!settled || !state?.sels) return state;
                const { sels: sels, ...rest } = state;
                return rest;
            }
        case 'MsgRoundCorner':
            {
                if (!settled) return state;
                const pic = state.curr.pics[msg.frameid];
                if (pic === undefined) return state;
                const nghb = (0, $eb00536c18f59e28$export$f713a0a4e19c1799)(pic)(msg.nodeid);
                if (nghb === null) return state;
                const con = (0, $5e197d6ee8aae64d$export$e87bfa2a4c6bccb0)(nghb[0], nghb[1], nghb[2])(msg.radius);
                const cix = state.curr.pnts.next;
                const abc = [
                    cix + 3,
                    cix + 5,
                    cix + 4
                ];
                const npic = (0, $eb00536c18f59e28$export$e3254935db333191)(abc[0], abc[1], abc[2])((0, $eb00536c18f59e28$export$13c2781d1a051e49)(nghb[0], abc, nghb[2])(pic));
                const ncons = (0, $b9dc988ac65b926a$export$4cbf152802aa238)(con)(state.curr.cons);
                const newState = (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $95e9e4973720f4e5$export$3df11c9c20e7b288))(false), (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $95e9e4973720f4e5$export$8876b4fa1dca8c1f), (0, $b709af327d5368f5$export$30265e9ecc990b5b), (0, $58f80d7b57eba59b$export$b610b8812bbcded9)(msg.frameid)))(npic), (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)((0, $95e9e4973720f4e5$export$8876b4fa1dca8c1f), (0, $b709af327d5368f5$export$8327ebbef2a0ba76)))(ncons), (0, $95e9e4973720f4e5$export$232faf9add678146)((ps)=>[
                        ...ps,
                        state.curr
                    ]))(state);
                return newState;
            }
        case 'MsgOpenPie':
            return (0, $58f80d7b57eba59b$export$adaa4cf7ef1b65be)((0, $95e9e4973720f4e5$export$b1e5508a851be14d))(msg.menu)(state);
        case 'MsgClosePie':
            {
                const { menu: _, ...rest } = state;
                return rest;
            }
    }
};
const $54bede46567a0f77$export$983832d820c96993 = ({ req: req })=>{
    const [state, dispatch] = (0, $acw62.useReducer)($54bede46567a0f77$export$1650419e431d3ba3, (0, $95e9e4973720f4e5$export$f3a2a5c7ad654c3)((0, $bcf549f190757517$export$2e2bcd8739ae039).rectangle));
    const design = (0, $acw62.useMemo)(()=>state.done ? state.curr : state.prev?.[state.prev.length - 1], [
        state
    ]);
    const sketch = (0, $acw62.useMemo)(()=>design ? (0, $b709af327d5368f5$export$2ba24979560a9591)(design) : undefined, [
        design
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!state.done) (0, $b4bda917597b51a5$export$c55ac50533417adc)(req)((0, $b709af327d5368f5$export$c2e7248aaa27119b)(state.curr)).then((cfgs)=>{
            if (cfgs?.[0]) dispatch($7e3b1af46fff8b0c$export$914e7d4d3a81444c(cfgs[0]));
            else {
                dispatch($7e3b1af46fff8b0c$export$9d18de0472378f09(true));
                dispatch($7e3b1af46fff8b0c$export$db3e87841a823c93);
            }
        }).catch(console.error);
    }, [
        req,
        state.done,
        state.curr
    ]);
    const rounder = (0, $acw62.useMemo)(()=>(fid, pid)=>{
            if ((fid === undefined || pid === undefined) && state?.sels?.stype !== 'Node') return;
            const frame = fid ?? state?.sels?.frame;
            const point = pid ?? state?.sels?.items?.[0];
            if (frame === undefined || point === undefined) return;
            const prompt = window.prompt('Radius:');
            if (prompt === null || prompt.trim() === '') return;
            const value = parseFloat(prompt.trim());
            dispatch($7e3b1af46fff8b0c$export$db2f6ec3a61fb25c(frame, point, value));
        }, [
        state?.sels,
        dispatch
    ]);
    const splitter = (0, $acw62.useMemo)(()=>(fid, eid)=>{
            if ((fid === undefined || eid === undefined) && state?.sels?.stype !== 'Edge') return;
            const frame = fid ?? state?.sels?.frame;
            const chunk = eid ?? state?.sels?.items?.[0];
            if (frame === undefined || chunk === undefined) return;
            const prompt = window.prompt('Distance:');
            if (prompt === null || prompt.trim() === '') return;
            const value = parseFloat(prompt.trim());
            if (isNaN(value)) return;
            const left = window.confirm('From the left? (if not, then from the right)');
            const side = left ? 'Left' : 'Right';
            dispatch($7e3b1af46fff8b0c$export$e33ae691b63d89d5(frame, chunk, side, value));
        }, [
        state?.sels,
        dispatch
    ]);
    const offsetter = (0, $acw62.useMemo)(()=>(node, side)=>(fid, msg)=>{
                if (fid === undefined || msg === undefined) return;
                const frame = fid ?? state?.sels?.frame;
                const chunk = msg?.cid ?? state?.sels?.items?.[0];
                if (frame === undefined || chunk === undefined) return;
                const prompt = window.prompt('Offset:');
                if (prompt === null || prompt.trim() === '') return;
                const value = parseFloat(prompt.trim());
                if (isNaN(value)) return;
                dispatch($7e3b1af46fff8b0c$export$17576e07b3e88340(frame, msg.fst, msg.fin, value, side, node));
            }, [
        state?.sels,
        dispatch
    ]);
    const pntHndlr = (0, $acw62.useMemo)(()=>(msg)=>(evt)=>{
                if (!msg || !evt) return;
                evt.stopPropagation();
                dispatch($7e3b1af46fff8b0c$export$10a63fcde820666(0, msg.address, !(evt.shiftKey ?? false)));
            }, [
        dispatch
    ]);
    const pmenuHndlr = (0, $acw62.useMemo)(()=>(msg)=>(evt)=>{
                if (!msg || !evt) return;
                evt.preventDefault();
                evt.stopPropagation();
                const x = evt.clientX;
                const y = evt.clientY;
                const fid = 0;
                const nid = msg.address;
                if (!x || !y) return;
                dispatch($7e3b1af46fff8b0c$export$f5722fccec377315($54bede46567a0f77$export$6053c582c35d0e0f(dispatch)(rounder)(x, y, fid, nid)));
            }, [
        dispatch,
        rounder
    ]);
    const emenuHndlr = (0, $acw62.useMemo)(()=>(msg)=>(evt)=>{
                if (!msg) return;
                evt?.preventDefault();
                evt?.stopPropagation();
                const x = evt?.clientX;
                const y = evt?.clientY;
                const fid = msg.address[0];
                // const nid : number = msg.address[1];
                if (!x || !y || msg?.message === undefined) return;
                dispatch($7e3b1af46fff8b0c$export$f5722fccec377315($54bede46567a0f77$export$56d7cb56ab0291d5(dispatch)(splitter)(offsetter)(x, y, fid, msg.message)));
            }, [
        dispatch,
        splitter,
        offsetter
    ]);
    const rlrHndlr = (0, $acw62.useMemo)(()=>(msg)=>(evt)=>{
                if (!msg || !msg.message || !evt) return;
                const shift = evt.shiftKey ?? false;
                if (shift) return dispatch($7e3b1af46fff8b0c$export$28469d1c5cfc5b12(msg.message.cid));
                const prompt = window.prompt('Value:');
                if (!prompt || prompt.trim() === '') return;
                const value = parseFloat(prompt.trim());
                if (Number.isNaN(value)) return;
                dispatch($7e3b1af46fff8b0c$export$b1cfaaa4653d855e(msg.message.cid, value));
            }, [
        dispatch
    ]);
    const selHndlr = (0, $acw62.useMemo)(()=>(msg)=>(evt)=>{
                if (!msg) return;
                evt?.stopPropagation();
                dispatch($7e3b1af46fff8b0c$export$6795d3f14a4dc17d(msg.address[0], msg.address[1], !(evt?.shiftKey ?? false)));
            }, [
        dispatch
    ]);
    const hndlrs = (0, $acw62.useMemo)(()=>({
            ruler: {
                ruler: {
                    onClick: rlrHndlr
                },
                label: {
                    onClick: rlrHndlr
                }
            },
            chunk: {
                onClick: selHndlr,
                onContextMenu: emenuHndlr
            },
            point: {
                onClick: pntHndlr,
                onContextMenu: pmenuHndlr
            }
        }), [
        rlrHndlr,
        selHndlr,
        pntHndlr,
        emenuHndlr,
        pmenuHndlr
    ]);
    const genClick = (0, $acw62.useMemo)(()=>()=>dispatch($7e3b1af46fff8b0c$export$2dcd94a2223fb79), [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        const keydown = (evt)=>{
            if (evt.key === 'z' && evt.ctrlKey) dispatch($7e3b1af46fff8b0c$export$db3e87841a823c93);
            if (evt.key === 's') splitter();
            if (evt.key === 'r') rounder();
        };
        document.addEventListener('keydown', keydown);
        return ()=>document.removeEventListener('keydown', keydown);
    }, [
        dispatch,
        splitter,
        rounder
    ]);
    const fixer = (0, $acw62.useMemo)(()=>$54bede46567a0f77$export$fcb36d4de4742728(0, 1, state.curr.pnts), [
        state.curr.pnts
    ]);
    const preset = (0, $acw62.useMemo)(()=>(0, $c606faa825ef1d7d$export$891904c5d9d25883)(), []);
    return !sketch ? null : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            width: '100%',
            height: '100%'
        },
        onClick: genClick,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5213f89aeaa4967a$export$fbe79e8ff00475af), {
                width: "100%",
                height: "100%",
                fntsze: 10,
                value: sketch,
                caster: fixer,
                preset: preset,
                hndlrs: hndlrs
            }),
            !state?.menu ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3a7a8634e41a2445$export$2e2bcd8739ae039), {
                ...state.menu
            })
        ]
    });
};
const $54bede46567a0f77$export$6053c582c35d0e0f = (dispatch)=>(rounder)=>(x, y, fid, nid)=>({
                x: x,
                y: y,
                onClose: ()=>{},
                entries: [
                    {
                        icon: 'R',
                        title: 'Round corner.',
                        onSelect: ()=>{
                            rounder(fid, nid);
                            dispatch($7e3b1af46fff8b0c$export$10b5bf8daf4331e);
                        }
                    }
                ]
            });
const $54bede46567a0f77$export$56d7cb56ab0291d5 = (dispatch)=>(splitter)=>(offsetter)=>(x, y, fid, meta)=>({
                    x: x,
                    y: y,
                    onClose: ()=>{},
                    entries: [
                        {
                            icon: 'S',
                            title: 'Split edge.',
                            onSelect: ()=>{
                                splitter(fid, meta.cid);
                                dispatch($7e3b1af46fff8b0c$export$10b5bf8daf4331e);
                            }
                        },
                        {
                            icon: 'TL',
                            title: 'Top Left Offset.',
                            onSelect: ()=>{
                                offsetter('Final', 'Left')(fid, meta);
                                dispatch($7e3b1af46fff8b0c$export$10b5bf8daf4331e);
                            }
                        },
                        {
                            icon: 'TR',
                            title: 'Top Right Offset.',
                            onSelect: ()=>{
                                offsetter('Final', 'Right')(fid, meta);
                                dispatch($7e3b1af46fff8b0c$export$10b5bf8daf4331e);
                            }
                        },
                        {
                            icon: 'BL',
                            title: 'Bottom Left Offset.',
                            onSelect: ()=>{
                                offsetter('First', 'Left')(fid, meta);
                                dispatch($7e3b1af46fff8b0c$export$10b5bf8daf4331e);
                            }
                        },
                        {
                            icon: 'BR',
                            title: 'Bottom Right Offset.',
                            onSelect: ()=>{
                                offsetter('First', 'Right')(fid, meta);
                                dispatch($7e3b1af46fff8b0c$export$10b5bf8daf4331e);
                            }
                        }
                    ]
                });
const $54bede46567a0f77$export$fcb36d4de4742728 = (z, o, pts)=>{
    const zp = pts.data.get(z);
    const op = pts.data.get(o);
    if (zp === undefined || op === undefined) return (p)=>p;
    const zo = $ec695bb278cff147$export$f93b5905241a7cca(op)(zp);
    const ro = (0, $d99ec1e84f6a18d9$export$5ff1b69c67bdf722)(-Math.atan2(zo[1], zo[0]));
    return (p)=>$ec695bb278cff147$export$ffb5f4729a158638(ro($ec695bb278cff147$export$e0f232dd469378a8(p)($ec695bb278cff147$export$eb1a26e88fa939fd(zp))));
};



const $e4ff4e09009595e9$var$palette = {
    background: {
        default: '#f7fafc',
        paper: '#f7fafc'
    },
    text: {
        disabled: 'rgba(0, 0, 0, 0.16)',
        primary: '#4a5568',
        secondary: '#4a5568'
    },
    action: {
        active: '#2d3748'
    },
    app: {
        primary: '#f7fafc',
        dark: '#e2e8f0',
        light: '#4a5568',
        active: '#cbd5e0',
        border: '#a0aec0',
        choreBorder: '#a0aec0',
        outline: '#90caf9'
    }
};
const $e4ff4e09009595e9$export$bca14c5b3b88a9c9 = (0, $9afe1ce524e8f62d$export$2e2bcd8739ae039)({
    cssVarPrefix: 'thm',
    colorSchemes: {
        dark: {
            palette: $e4ff4e09009595e9$var$palette
        },
        light: {
            palette: $e4ff4e09009595e9$var$palette
        }
    },
    typography: {
        fontFamily: 'inherit'
    },
    components: {
        MuiButton: {
            styleOverrides: {
                outlined: ({ theme: theme })=>({
                        border: `1px solid ${theme.vars.palette.app.choreBorder}`,
                        color: theme.vars.palette.text.primary,
                        '&:hover': {
                            borderColor: theme.vars.palette.app.border,
                            backgroundColor: 'inherit'
                        }
                    })
            }
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    padding: '8px 32px',
                    textTransform: 'capitalize',
                    fontSize: '16px'
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '6px'
                }
            }
        },
        MuiToolbar: {
            styleOverrides: {
                root: ({ theme: theme })=>({
                        color: theme.vars.palette.text.secondary
                    })
            }
        },
        MuiToggleButtonGroup: {
            styleOverrides: {
                grouped: ({ theme: theme })=>({
                        fontSize: '16px',
                        padding: '10px 16px',
                        border: `1px solid ${theme.vars.palette.app.choreBorder}`,
                        color: theme.vars.palette.app.light,
                        fontWeight: 400,
                        '&:hover': {
                            borderColor: theme.vars.palette.app.border,
                            zIndex: 1
                        }
                    })
            }
        }
    }
});
var $e4ff4e09009595e9$export$2e2bcd8739ae039 = $e4ff4e09009595e9$export$bca14c5b3b88a9c9;



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");
const $f6f632b2fdadc534$var$ScrollContent = ({ children: children })=>{
    const ref = (0, $acw62.useRef)(null);
    const [elHeight, setElHeight] = (0, $acw62.useState)(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (ref?.current) {
            const rect = ref?.current.getBoundingClientRect();
            const offsetTop = rect.top;
            const windowHeight = window.innerHeight;
            const calcHeight = windowHeight - offsetTop;
            setElHeight(calcHeight);
        }
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        ref: ref,
        sx: {
            overflowY: 'auto',
            overflowX: 'hidden'
        },
        height: elHeight,
        children: children
    });
};
var $f6f632b2fdadc534$export$2e2bcd8739ae039 = $f6f632b2fdadc534$var$ScrollContent;



var $ayMG0 = parcelRequire("ayMG0");

var $ffce09cc270464fd$export$89da14300d534261;
var $ffce09cc270464fd$export$a7b2fff67f3e0459;
var $ffce09cc270464fd$export$4ee3e000dcaf16dd;
var $ffce09cc270464fd$export$f22da7240b7add18;
var $ffce09cc270464fd$export$b9f05befa7a11399;
$ffce09cc270464fd$export$89da14300d534261 = `Lprr7q_active`;
$ffce09cc270464fd$export$a7b2fff67f3e0459 = `Lprr7q_headerbar`;
$ffce09cc270464fd$export$4ee3e000dcaf16dd = `Lprr7q_lside`;
$ffce09cc270464fd$export$f22da7240b7add18 = `Lprr7q_main`;
$ffce09cc270464fd$export$b9f05befa7a11399 = `Lprr7q_rside`;


const $2afd314fd2a5af89$var$state = ({ isActive: isActive })=>isActive ? $ffce09cc270464fd$export$89da14300d534261 : '';
const $2afd314fd2a5af89$export$c7c21e5b2657e253 = ({ req: req })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
        className: $ffce09cc270464fd$export$a7b2fff67f3e0459,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("nav", {
                className: $ffce09cc270464fd$export$f22da7240b7add18,
                children: [
                    !req ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/opening",
                        className: $2afd314fd2a5af89$var$state,
                        children: "Opening"
                    }),
                    !req ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/template",
                        className: $2afd314fd2a5af89$var$state,
                        children: "Template"
                    }),
                    !req ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/template-mod",
                        className: $2afd314fd2a5af89$var$state,
                        children: "Template Mod"
                    }),
                    !req ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/template-limits",
                        className: $2afd314fd2a5af89$var$state,
                        children: "Template Limits"
                    }),
                    !req ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/config-table",
                        className: $2afd314fd2a5af89$var$state,
                        children: "Configs"
                    }),
                    !req ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/login",
                        className: $2afd314fd2a5af89$var$state,
                        children: "Login"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/logout",
                        className: $2afd314fd2a5af89$var$state,
                        children: "Logout"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
                className: $ffce09cc270464fd$export$4ee3e000dcaf16dd
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
                className: $ffce09cc270464fd$export$b9f05befa7a11399
            })
        ]
    });



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");




const $b80e765470a054a0$export$62680b65e63e14ec = ()=>({
        language: 'eng',
        lengthUnit: 'inch',
        areaUnit: "ft\xb2"
    });
const $b80e765470a054a0$export$e134aa690da9cc14 = ({ value: value, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $c197ad7e0b56b287$export$195746d839abd8b5), {
        value: value.language,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $686182291220ef6d$export$2cb30ce74344c798), {
            value: value.lengthUnit,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $686182291220ef6d$export$e3bf5f6c648445ae), {
                value: value.areaUnit,
                children: children
            })
        })
    });
const $b80e765470a054a0$export$4fd58b444cfc565f = ({ value: value, update: update })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        container: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c197ad7e0b56b287$export$138a47b7521a65dc), {
                    value: value.language,
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $58f80d7b57eba59b$export$94132a0e348806d4)('language'))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $686182291220ef6d$export$f3d6fdaa595556c9), {
                    value: value.lengthUnit,
                    update: (0, $78df2dbbf84a78b3$export$1af3c925c49f37a2)(update, (0, $58f80d7b57eba59b$export$94132a0e348806d4)('lengthUnit'))
                })
            })
        ]
    });


const $9d936a2aecb96285$var$envs = [
    'qa',
    'dev',
    'live',
    'local'
];
const $9d936a2aecb96285$export$f0cb0fda19c18b37 = (value)=>$9d936a2aecb96285$var$envs.includes(value);
const $9d936a2aecb96285$export$44487a86467333c3 = (stage)=>(def)=>$9d936a2aecb96285$export$f0cb0fda19c18b37(stage) ? $9d936a2aecb96285$export$c884d9dcb329c3c[stage] : $9d936a2aecb96285$export$c884d9dcb329c3c[def];
const $9d936a2aecb96285$export$c884d9dcb329c3c = {
    'qa': {
        'SilicaEndpoint': 'https://silica-qa.commonedge.com',
        'Auth0': {
            'domain': 'https://commonedge.auth0.com',
            'clientId': 'TpSBsKIIsOdqsqZLUwK0AVsI0ijvu3ZT',
            'clientSecret': 'nrr03uxqV8nMCA7aOBdGY1pdLC0hPXgj5yhieKJJ9nV2pcu-Go_UtTkM7QBNiUfM',
            'audience': 'https://silica.commonedge.com/auth0/v0'
        }
    },
    'dev': {
        'SilicaEndpoint': 'https://silica-dev.commonedge.com',
        'Auth0': {
            'domain': 'https://commonedge.auth0.com',
            'clientId': 'TpSBsKIIsOdqsqZLUwK0AVsI0ijvu3ZT',
            'clientSecret': 'nrr03uxqV8nMCA7aOBdGY1pdLC0hPXgj5yhieKJJ9nV2pcu-Go_UtTkM7QBNiUfM',
            'audience': 'https://silica.commonedge.com/auth0/v0'
        }
    },
    'live': {
        'SilicaEndpoint': 'https://silica.commonedge.com',
        'Auth0': {
            'domain': 'https://commonedge.auth0.com',
            'clientId': 'TpSBsKIIsOdqsqZLUwK0AVsI0ijvu3ZT',
            'clientSecret': 'nrr03uxqV8nMCA7aOBdGY1pdLC0hPXgj5yhieKJJ9nV2pcu-Go_UtTkM7QBNiUfM',
            'audience': 'https://silica.commonedge.com/auth0/v0'
        }
    },
    'local': {
        'SilicaEndpoint': 'http://localhost:8088',
        'Auth0': {
            'domain': 'https://commonedge.auth0.com',
            'clientId': 'TpSBsKIIsOdqsqZLUwK0AVsI0ijvu3ZT',
            'clientSecret': 'nrr03uxqV8nMCA7aOBdGY1pdLC0hPXgj5yhieKJJ9nV2pcu-Go_UtTkM7QBNiUfM',
            'audience': 'https://silica.commonedge.com/auth0/v0'
        }
    }
};


const $cd93687958c8007e$var$App = ()=>{
    const [req, setReq] = (0, $acw62.useState)(undefined);
    const [settings, _updateSettings] = (0, $acw62.useState)((0, $b80e765470a054a0$export$62680b65e63e14ec)());
    const config = (0, $9d936a2aecb96285$export$44487a86467333c3)("dev")('local');
    const login = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $401fc7c7dcb14efc$export$2e2bcd8739ae039), {
        config: config,
        updateReq: setReq
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $837d879502e60b4b$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                        children: "Quartz"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("meta", {
                        name: "mobile-web-app-capable",
                        content: "yes"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b80e765470a054a0$export$e134aa690da9cc14), {
                value: settings,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aa64e0883cb2d190$export$99adf6d9ed169a14), {
                    defaultMode: "dark",
                    theme: (0, $e4ff4e09009595e9$export$2e2bcd8739ae039),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "embed/bulk-design"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "embed/tweaker/figure"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "*",
                                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2afd314fd2a5af89$export$c7c21e5b2657e253), {
                                        req: req
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                            id: "main",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "test",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e07b188e89f06a27$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "opening",
                                        element: !req ? login : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88b24329de9be42f$export$2e2bcd8739ae039), {
                                            req: req
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "template",
                                        element: !req ? login : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19c5105eb59307a3$export$2e2bcd8739ae039), {
                                            req: req
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "template-mod",
                                        element: !req ? login : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ad9376fa4dec09a7$export$2e2bcd8739ae039), {
                                            req: req
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "template-limits",
                                        element: !req ? login : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a849ae06d26d346b$export$2e2bcd8739ae039), {
                                            req: req
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "config-table",
                                        element: !req ? login : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4d75faa715a9d2b9$export$2e2bcd8739ae039), {
                                            req: req
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "figure",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50ea37e9e9f0a226$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "pricing",
                                        element: !req ? login : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a641a45a95d00d23$export$2e2bcd8739ae039), {
                                            req: req
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "bulk-design",
                                        element: !req ? login : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6f632b2fdadc534$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cd2e90947afb30b$export$2e2bcd8739ae039), {
                                                req: req
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "embed/bulk-design",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $760befdd4fcb9e56$export$2e2bcd8739ae039), {
                                            config: config
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "embed/tweaker/figure",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8727e44a96b3445b$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "login",
                                        element: !req ? login : null
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "logout",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df26a3ab557252de$export$2e2bcd8739ae039), {
                                            updateReq: setReq
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "sketch",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5213f89aeaa4967a$export$ba4690435b051db), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "gui",
                                        element: !req ? login : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54bede46567a0f77$export$983832d820c96993), {
                                            req: req
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $cd93687958c8007e$export$2e2bcd8739ae039 = $cd93687958c8007e$var$App;


var $70fc9a727fa662ae$export$2e2bcd8739ae039 = (0, $cd93687958c8007e$export$2e2bcd8739ae039);
if (typeof document !== 'undefined') {
    const target = document.getElementById('app');
    if (target === null) throw new Error('Cannot find the \'app\' DOM node.');
    (0, $7e96a608cb33bf79$export$882461b6382ed46c)(target).render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {})
    }));
}


//# sourceMappingURL=quartz.70db7722.js.map
